webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lang_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lang_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages_json__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__messages_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(127);





var lang = new __WEBPACK_IMPORTED_MODULE_0_lang_js___default.a({ locale: __WEBPACK_IMPORTED_MODULE_2__locale__["a" /* default */], messages: __WEBPACK_IMPORTED_MODULE_1__messages_json___default.a });
/* harmony default export */ __webpack_exports__["a"] = (lang);

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91edd3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(969);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91edd3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component_LineChart__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component_LineNonNumericYChart__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component_LineChartDataset__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Component_LineShapingChart__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_BarChart__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Component_BarChartDataset__ = __webpack_require__(1068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Component_LineChart__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Component_LineNonNumericYChart__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Component_LineChartDataset__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__Component_LineShapingChart__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Component_BarChart__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Component_BarChartDataset__["a"]; });









/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  MILLISECONDS: 1000,
  SECONDS: 60,
  MINUTES: 60,
  HOURS: 24,
  COUNT_DAY: 6,
  COUNT_MONTH: 4,

  SECONDS_PER_MINUTE: 60,

  MAX_LENGTH: 50,

  scatterplotYLabels: [{ id: 1, text: '00:00-00:29' }, { id: 2, text: '00:30-00:59' }, { id: 3, text: '01:00-01:29' }, { id: 4, text: '01:30-01:59' }, { id: 5, text: '02:00-02:29' }, { id: 6, text: '02:30-02:59' }, { id: 7, text: '03:00-03:29' }, { id: 8, text: '03:30-03:59' }, { id: 9, text: '04:00-04:29' }, { id: 10, text: '04:30-04:59' }, { id: 11, text: '05:00-05:29' }, { id: 12, text: '05:30-05:59' }, { id: 13, text: '06:00-06:29' }, { id: 14, text: '06:30-06:59' }, { id: 15, text: '07:00-07:29' }, { id: 16, text: '07:30-07:59' }, { id: 17, text: '08:00-08:29' }, { id: 18, text: '08:30-08:59' }, { id: 19, text: '09:00-09:29' }, { id: 20, text: '09:30-09:59' }, { id: 21, text: '10:00-10:29' }, { id: 22, text: '10:30-10:59' }, { id: 23, text: '11:00-11:29' }, { id: 24, text: '11:30-11:59' }, { id: 25, text: '12:00-12:29' }, { id: 26, text: '12:30-12:59' }, { id: 27, text: '13:00-13:29' }, { id: 28, text: '13:30-13:59' }, { id: 29, text: '14:00-14:29' }, { id: 30, text: '14:30-14:59' }, { id: 31, text: '15:00-15:29' }, { id: 32, text: '15:30-15:59' }, { id: 33, text: '16:00-16:29' }, { id: 34, text: '16:30-16:59' }, { id: 35, text: '17:00-17:29' }, { id: 36, text: '17:30-17:59' }, { id: 37, text: '18:00-18:29' }, { id: 38, text: '18:30-18:59' }, { id: 39, text: '19:00-19:29' }, { id: 40, text: '19:30-19:59' }, { id: 41, text: '20:00-20:29' }, { id: 42, text: '20:30-20:59' }, { id: 43, text: '21:00-21:29' }, { id: 44, text: '21:30-21:59' }, { id: 45, text: '22:00-22:29' }, { id: 46, text: '22:30-22:59' }, { id: 47, text: '23:00-23:29' }, { id: 48, text: '23:30-23:59' }]
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);

var UuidGenerator = /** @class */ (function () {
    function UuidGenerator() {
    }
    UuidGenerator.v4 = function () {
        return __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()();
    };
    return UuidGenerator;
}());
/* harmony default export */ __webpack_exports__["a"] = (UuidGenerator);


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableView_vue__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f166dee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableView_vue__ = __webpack_require__(1030);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f166dee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__storage_Storage__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Manager__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rbac_Manager__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_wolfy87_eventemitter__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_wolfy87_eventemitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_wolfy87_eventemitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Events__ = __webpack_require__(144);
















var Manager = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Manager, _EventEmitter);

  function Manager() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Manager.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Manager)).call(this));

    _this.$http = new __WEBPACK_IMPORTED_MODULE_8__api_Manager__["a" /* default */]();
    _this.$storage = new __WEBPACK_IMPORTED_MODULE_7__storage_Storage__["a" /* default */]();
    _this.$rbac = new __WEBPACK_IMPORTED_MODULE_9__rbac_Manager__["a" /* default */]();
    _this.initAuthorizationType();
    _this.initRBAC();
    _this.addStorageEventListeners();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'initAuthorizationType',
    value: function initAuthorizationType() {
      var storage = this.$storage;
      if (!storage.isTokenExpired() && storage.getToken()) {
        if (storage.getRefreshToken()) {
          this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* AUTHORIZED_AS_USER */]);
        } else {
          this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* AUTHORIZED_AS_APPLICATION */]);
        }
      } else {
        this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["i" /* UNAUTHORIZED */]);
      }
    }
  }, {
    key: 'initRBAC',
    value: function initRBAC() {
      if (!this.isGuest()) {
        this.$rbac.setUser(this.$storage.getUserInfo());
      }
    }
  }, {
    key: 'addStorageEventListeners',
    value: function addStorageEventListeners() {
      var _this2 = this;

      this.$storage.on(__WEBPACK_IMPORTED_MODULE_13__Events__["a" /* default */].USER_INFO_EXPIRED, function () {
        _this2.reinitUser();
      });
    }
  }, {
    key: 'setAuthorizationType',
    value: function setAuthorizationType() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch.apply(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */], ['auth/setAuthorizationType'].concat(args));
    }
  }, {
    key: 'getToken',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var storage, refreshToken;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storage = this.$storage;

                if (!storage.isTokenExpired()) {
                  _context.next = 20;
                  break;
                }

                storage.removeToken(true);
                this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["i" /* UNAUTHORIZED */]);
                this.$rbac.flush();
                _context.prev = 5;
                refreshToken = storage.getRefreshToken();

                if (!refreshToken) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return this.refresh(refreshToken);

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.next = 14;
                return this.authorizeAsApp();

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](5);
                _context.next = 20;
                return this.unauthorize();

              case 20:
                return _context.abrupt('return', storage.getToken());

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 16]]);
      }));

      function getToken() {
        return _ref.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: 'getTokenSync',
    value: function getTokenSync() {
      var storage = this.$storage;
      return storage.getToken();
    }
  }, {
    key: 'unauthorize',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.emit(__WEBPACK_IMPORTED_MODULE_13__Events__["a" /* default */].BEFORE_UNAUTHORIZE);
                result = this.$storage.removeToken();

                this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["i" /* UNAUTHORIZED */]);
                this.$rbac.flush();
                this.$storage.clear();
                this.emit(__WEBPACK_IMPORTED_MODULE_13__Events__["a" /* default */].AFTER_UNAUTHORIZE);
                _context2.next = 8;
                return this.authorizeAsApp();

              case 8:
                return _context2.abrupt('return', result);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unauthorize() {
        return _ref2.apply(this, arguments);
      }

      return unauthorize;
    }()
  }, {
    key: 'authorize',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(methodName) {
        var _$http,
            _len2,
            args,
            _key2,
            _ref4,
            response,
            _response$data,
            token,
            expiresIn,
            refreshToken,
            _args3 = arguments;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                for (_len2 = _args3.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  args[_key2 - 1] = _args3[_key2];
                }

                _context3.next = 4;
                return (_$http = this.$http)[methodName].apply(_$http, args);

              case 4:
                _ref4 = _context3.sent;
                response = _ref4.data;
                _response$data = response.data, token = _response$data.access_token, expiresIn = _response$data.expires_in, refreshToken = _response$data.refresh_token;

                expiresIn = new Date().getTime() + expiresIn * 1000;
                this.$storage.setToken(token, expiresIn, refreshToken);
                return _context3.abrupt('return', true);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                throw _context3.t0;

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 12]]);
      }));

      function authorize(_x) {
        return _ref3.apply(this, arguments);
      }

      return authorize;
    }()
  }, {
    key: 'authorizeAsApp',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.authorize('getAppToken');

              case 2:
                result = _context4.sent;

                this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* AUTHORIZED_AS_APPLICATION */]);
                return _context4.abrupt('return', result);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function authorizeAsApp() {
        return _ref5.apply(this, arguments);
      }

      return authorizeAsApp;
    }()
  }, {
    key: 'authorizeAsUser',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(methodName) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        var result, userInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.authorize.apply(this, [methodName].concat(args));

              case 2:
                result = _context5.sent;

                this.setAuthorizationType(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* AUTHORIZED_AS_USER */]);
                _context5.next = 6;
                return this.$rbac.initUser();

              case 6:
                userInfo = _context5.sent;

                this.$storage.setUserInfo(userInfo);
                return _context5.abrupt('return', result);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function authorizeAsUser(_x2) {
        return _ref6.apply(this, arguments);
      }

      return authorizeAsUser;
    }()
  }, {
    key: 'reinitUser',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var userInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$rbac.initUser();

              case 2:
                userInfo = _context6.sent;

                this.$storage.setUserInfo(userInfo);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function reinitUser() {
        return _ref7.apply(this, arguments);
      }

      return reinitUser;
    }()
  }, {
    key: 'login',
    value: function login(username, password) {
      return this.authorizeAsUser('getUserToken', { username: username, password: password });
    }
  }, {
    key: 'refresh',
    value: function refresh(token) {
      return this.authorizeAsUser('refresh', token);
    }
  }, {
    key: 'isAuthorized',
    value: function isAuthorized() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['auth/isAuthorized'];
    }
  }, {
    key: 'isGuest',
    value: function isGuest() {
      return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['auth/isGuest'];
    }
  }, {
    key: 'isBCBA',
    value: function isBCBA() {
      return this.$rbac.isBCBA();
    }
  }, {
    key: 'isCurator',
    value: function isCurator() {
      return this.$rbac.isCurator();
    }
  }, {
    key: 'isTherapist',
    value: function isTherapist() {
      return this.$rbac.isTherapist();
    }
  }, {
    key: 'isClient',
    value: function isClient() {
      return this.$rbac.isClient();
    }
  }, {
    key: 'can',
    value: function can() {
      var _$rbac;

      return (_$rbac = this.$rbac).can.apply(_$rbac, arguments);
    }
  }, {
    key: 'getUserInfo',
    value: function getUserInfo() {
      if (!this.isGuest()) {
        return this.$storage.getUserInfo();
      } else {
        return null;
      }
    }
  }, {
    key: 'isMensurationForbidden',
    value: function isMensurationForbidden() {
      return this.$rbac.isMensurationForbidden();
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_11_wolfy87_eventemitter___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_paginate__);




var pagination = {
  data: function data() {
    return {
      paginate: {
        perPage: 10,
        page: 1,
        forcePage: 0,
        lastPage: 0,
        pageRange: 3,
        marginPages: 2
      }
    };
  },

  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_2_vuejs_paginate___default.a
  },
  methods: {
    setPaginate: function setPaginate(data) {
      this.paginate.perPage = data.perPage;
      this.paginate.page = data.currentPage;
      this.paginate.lastPage = data.lastPage;
    },

    onPaginationBtnClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(pageNum) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.paginate.page = pageNum;
                this.paginate.forcePage = pageNum - 1;

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onPaginationBtnClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onPaginationBtnClick;
    }()
  }
};

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROTOCOL_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIRECTORY_TYPES; });
/* unused harmony export STATUS_NEW */
/* unused harmony export STATUS_ACTIVE */
/* unused harmony export STATUS_MAINTAINING */
/* unused harmony export STATUS_COMPLETED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSFER_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAPICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROTOCOL_TYPE; });
var PROTOCOL_STATUSES = {
  NEW: 1,
  ACTIVE: 2,
  MAINTAINING: 3,
  COMPLETED: 4,
  INDIVIDUALIZATION: 5
};

var DIRECTORY_TYPES = {
  TEACHING_METHOD: 1,
  HINT_TYPE: 2,
  REDUCTION_HINT_METHOD: 3,
  CRITERIA_END_SESSION: 4,
  CRITERIA_END_TEACHING: 5,
  CRITERIA_END_PROTOCOL: 6,
  APPLYING: 7
};

var STATUS_NEW = 1;
var STATUS_ACTIVE = 2;
var STATUS_MAINTAINING = 3;
var STATUS_COMPLETED = 4;

var TRANSFER_CONDITION = {
  ONE_TRIAL: 'one_trial',
  TRIAL_IN_A_ROW: 'trial_in_a_row',
  SESSION_IN_A_ROW: 'session_in_a_row',
  RATIO: 'ratio'
};

var DATAPICKER = "false";

var PROTOCOL_TYPE = {
  DTT: '1',
  SIMPLE: '2',
  MAND: '3',
  USD: '4',
  CHAIN: '5',
  SHAPING: '6',
  PECS: '7',
  PECSDESTINATION: '8',
  PECSWITHDISCRIMINATION: '9',
  PECSWITHITEMS: '10'

};

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionView_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b86f643_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionView_vue__ = __webpack_require__(1085);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b86f643_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopup_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfc92db8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopup_vue__ = __webpack_require__(1125);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfc92db8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardMenu_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a931b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardMenu_vue__ = __webpack_require__(1020);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a931b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showModal; });
var showModal = {
  data: function data() {
    return {
      isModalVisible: false
    };
  },

  methods: {
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    onModalCancel: function onModalCancel() {
      this.isModalVisible = false;
    },
    onShowModalBtnClick: function onShowModalBtnClick() {
      this.isModalVisible = true;
    }
  }
};

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typeProtocol; });

var typeProtocol = {
  computed: {
    isDTT: function isDTT() {
      return this.teachingMethod == 1;
    },

    isSimple: function isSimple() {
      return this.teachingMethod == 2;
    },

    isMand: function isMand() {
      return this.teachingMethod == 3;
    },

    isUSD: function isUSD() {
      return this.teachingMethod == 4;
    },

    isChain: function isChain() {
      return this.teachingMethod == 5;
    },

    isShaping: function isShaping() {
      return this.teachingMethod == 6;
    },
    isPecs: function isPecs() {
      return this.teachingMethod == 7;
    },
    isPecsWithoutDiscrimination: function isPecsWithoutDiscrimination() {
      return this.teachingMethod == 8;
    },
    isPecsWithDiscrimination: function isPecsWithDiscrimination() {
      return this.teachingMethod == 9;
    },
    isPecsWithItems: function isPecsWithItems() {
      return this.teachingMethod == 10;
    }
  }
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hints_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6facc14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hints_vue__ = __webpack_require__(1197);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6facc14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






var Manager = function () {
  function Manager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    this.baseUrl = "https://app.autismtech.online/api" + '/users/account';
    this.subscriptionsUrl = "https://app.autismtech.online/api" + '/subscriptions';
    this.clinicalCenterUrl = "https://app.autismtech.online/api" + '/users/centers';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'getAccountInfo',
    value: function getAccountInfo() {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.baseUrl);
    }
  }, {
    key: 'setAccountInfo',
    value: function setAccountInfo(user) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.baseUrl, user);
    }
  }, {
    key: 'changePassword',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(currentPassword, newPassword, newPasswordConfirmation) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.baseUrl + '/change-password', {
                  currentPassword: currentPassword,
                  newPassword: newPassword,
                  newPasswordConfirmation: newPasswordConfirmation
                });

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changePassword(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: 'getSubscriptions',
    value: function getSubscriptions(perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.subscriptionsUrl, {
        params: {
          perPage: perPage,
          page: page
        }

      });
    }
  }, {
    key: 'getClinicalCenter',
    value: function getClinicalCenter(perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.clinicalCenterUrl, {
        params: {
          perPage: perPage,
          page: page
        }

      });
    }
  }, {
    key: 'setClinicalCenter',
    value: function setClinicalCenter(clinic, id) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.clinicalCenterUrl + '/' + id, clinic);
    }
  }, {
    key: 'getSubscription',
    value: function getSubscription(id) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.subscriptionsUrl + '/' + id);
    }
  }, {
    key: 'setSubscription',
    value: function setSubscription(data) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.subscriptionsUrl, data);
    }
  }, {
    key: 'getTaskTypes',
    value: function getTaskTypes() {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.baseUrl + '/check-list-settings');
    }
  }, {
    key: 'getSkillDomain',
    value: function getSkillDomain(perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.baseUrl + '/skill-fields', {
        params: { perPage: perPage, page: page }
      });
    }
  }, {
    key: 'setSkillDomain',
    value: function setSkillDomain(name, id) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.baseUrl + '/skill-fields/' + id, {
        name: name
      });
    }
  }, {
    key: 'addSkillDomain',
    value: function addSkillDomain(name) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.baseUrl + '/skill-fields/', {
        name: name
      });
    }
  }, {
    key: 'deleteSkillDomain',
    value: function deleteSkillDomain(id) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(this.baseUrl + '/skill-fields/' + id);
    }
  }, {
    key: 'setTaskTypes',
    value: function setTaskTypes(data) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.baseUrl + '/check-list-settings', data);
    }
  }, {
    key: 'getSubscriptionComments',
    value: function getSubscriptionComments(id, perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.subscriptionsUrl + '/' + id + '/comment', {
        params: { perPage: perPage, page: page }
      });
    }
  }, {
    key: 'comment',
    value: function comment(id, data) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.subscriptionsUrl + '/' + id + '/comment', data);
    }
  }, {
    key: 'markCommentAsViewed',
    value: function markCommentAsViewed(id) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.subscriptionsUrl + '/' + id + '/comment/view');
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectWithPager_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fd83c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectWithPager_vue__ = __webpack_require__(1026);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectWithPager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fd83c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectWithPager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromptChart_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123359b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromptChart_vue__ = __webpack_require__(1132);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromptChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123359b3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromptChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managers_TherapistApiManager__ = __webpack_require__(901);



var BASE_URL = "https://app.autismtech.online/api" + '/users';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__managers_TherapistApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_axios___default.a, BASE_URL + '/therapists'));

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  AIM_TYPE_ABSENCE: 1,
  AIM_TYPE_PRESENCE: 2,
  BEHAVIOUR_TYPE_SHORT: 1,
  BEHAVIOUR_TYPE_LONG: 2,
  INTERVAL_DURATION_UNIT_MINUTES: 1,
  INTERVAL_DURATION_UNIT_SECONDS: 2,

  ENTITY_TYPE: 'interactive-session'

});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UndesirableBehaviorApiManager__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var BASE_URL = "https://app.autismtech.online/api";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__UndesirableBehaviorApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_axios___default.a, BASE_URL + '/undesirablebehaviors'));

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var Manager = function () {
  function Manager() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    this.baseUrl = "https://app.autismtech.online/api" + '/interactive-modules/dro';
    this.envUrl = "https://app.autismtech.online/api";
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'hasAccess',
    value: function hasAccess(assigneeId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/has-access', {
        params: { assigneeId: assigneeId }
      });
    }
  }, {
    key: 'getSettings',
    value: function getSettings(assigneeId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/settings', {
        params: { id: assigneeId }
      });
    }
  }, {
    key: 'getReports',
    value: function getReports(assigneeId, perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/sessions/', {
        params: { assigneeId: assigneeId, perPage: perPage, page: page }
      });
    }
  }, {
    key: 'getDashboardProtocol',
    value: function getDashboardProtocol(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.envUrl + '/protocols/assigned/mand/' + id + '/shortcuts');
    }
  }, {
    key: 'exportReports',
    value: function exportReports(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.baseUrl + '/sessions/export', {
        id: id
      }, { responseType: 'blob' });
    }
  }, {
    key: 'save',
    value: function save(data) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.baseUrl + '/sessions', data);
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Base API Manager.
 */
var BaseApiManager = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param {String} url
     */
    function BaseApiManager(axios, url) {
        this.url = url;
        this.axios = axios;
    }
    /**
     * Find entity by ID.
     *
     * @param {Number} id
     *
     * @returns {Promise<void>}
     */
    BaseApiManager.prototype.findById = function (_a) {
        var id = _a.id;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/" + id)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Paginate all entities.
     *
     * @param {Number} perPage
     * @param {Number} page
     * @param {String} sort
     * @param {String} search
     * @returns {Promise<any>}
     */
    BaseApiManager.prototype.paginateAll = function (perPage, page, sort, search) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("" + this.url, {
                            params: {
                                perPage: perPage,
                                page: page,
                                sort: sort,
                                search: search,
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search all entities.
     *
     * @param {String} search
     * @param {Number} perPage
     * @param {Number} page
     *
     * @returns {Promise<any>}
     */
    BaseApiManager.prototype.search = function (search, perPage, page) {
        if (search === void 0) { search = ''; }
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("" + this.url, {
                            params: {
                                search: search,
                                perPage: perPage,
                                page: page,
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete Curator by ID.
     *
     * @param {Number} id
     *
     * @returns {Promise<void>}
     */
    BaseApiManager.prototype.deleteById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.delete(this.url + "/" + id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BaseApiManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (BaseApiManager);


/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ef63d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1029);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8ef63d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8ef63d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest()) {
        next();
    } else {
        next({ name: 'login' });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(215);


var url = location.href;
var chunks = url.replace(location.origin + '/', '').split('/');
var locale = chunks[0];

if (!(locale && __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AVAILABLE_LANGUAGES */].includes(locale))) {
  location.href = location.origin + '/' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_LANGUAGE */];
}

/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppealsApiManager__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var BASE_URL = "https://app.autismtech.online/api";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__AppealsApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_axios___default.a, BASE_URL + '/appeals'));

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BidsList_vue__ = __webpack_require__(485);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3d9ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BidsList_vue__ = __webpack_require__(1040);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BidsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3d9ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BidsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartStage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dashboardParent_components_ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_values__);















var chartStage = {
  data: function data() {
    return {
      persentMax: true,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      trendLinePoint: null,
      chosenStimul: [],
      chartDatasetsForStimul: null,
      chartDatasetsForStimulDataset: null,
      chartDatasetsHintForStimulDataset: null,
      withoutData: false,
      changesLine: [],
      dataPoint: null,
      isModalVisible: false
    };
  },


  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_4__common_chart__["c" /* LineChart */], ChartPopup: __WEBPACK_IMPORTED_MODULE_6__modules_dashboardParent_components_ChartPopup__["a" /* default */]
  },

  methods: {
    mensurationChart: function mensurationChart(chartDatasetsForStimul) {

      var pointStyle = "rect";
      var dataForChart = [];
      var dataForHintChart = [];
      var changesLine = [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(chartDatasetsForStimul.chartData, function (chartData, indexChart) {

        if (indexChart == 1) {
          pointStyle = "circle";
        }
        if (indexChart == 2) {
          pointStyle = "rectRot";
        }
        if (indexChart == 3) {
          pointStyle = "triangle";
        }

        var chart = new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
          data: chartData.data.values ? chartData.data.values : chartData.data[1].values,
          label: chartData.description,
          pointStyle: pointStyle
        });

        if (chartData.data[2] && chartData.data[2].values) {

          var datasetPromptsChart = [];

          __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(chartData.data[2].hintResultsData, function (dataItem) {

            datasetPromptsChart.push(new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
              data: dataItem.data
            }));
          });

          dataForHintChart.push({
            chart: datasetPromptsChart,
            label: chartData.description,
            levels: chartData.data[2].levels
          });
        }

        dataForChart.push(chart);
      });

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(chartDatasetsForStimul.changes, function (change) {
        changesLine.push({
          x: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('protocol.changes') + '_' + change.id,
          index: change.id,
          isImportant: change.isImportant,
          comment: change.comment
        });
      });

      return {
        dataForChart: dataForChart,
        dataForHintChart: dataForHintChart,
        changesLine: changesLine,
        chartDatasetsForStimul: chartDatasetsForStimul
      };
    },
    chartShow: function chartShow() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var chosenTaskIds, url, params, response, chartDatasetsForStimul, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loaded = false;
                _this.changesLine = [];
                _this.trendLinePoint = null;
                _this.trendLineChecked = false;
                _this.levelLineChecked = false;
                _this.ScatterLineChecked = false;
                _this.chartDatasetsForStimul = null;
                _this.chartDatasetsForStimulDataset = null;
                _this.chartDatasetsHintForStimulDataset = null;

                chosenTaskIds = __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(_this.chosenStimul, 'id');

                if (!chosenTaskIds.length) {
                  _context.next = 18;
                  break;
                }

                url = _this.teachingMethod == 10 || _this.teachingMethod == 9 ? _this.apiChartUrl + _this.protocolId + '/mensuration/' : _this.apiChartUrl + _this.protocolId + '/mensuration/' + _this.stage.id;
                params = {
                  startDate: _this.rangeDateStartTimestamp,
                  endDate: _this.rangeDateEndTimestamp,
                  taskIds: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(chosenTaskIds)
                };
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
                  params: params
                });

              case 15:
                response = _context.sent;
                chartDatasetsForStimul = response.data.data;


                if (_this.teachingMethod == 9) {

                  if (chartDatasetsForStimul.length) {
                    _this.chartDatasetsForStimulDataset = [];
                    _this.chartDatasetsHintForStimulDataset = [];
                    _this.chartDatasetsForStimul = [];

                    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(chartDatasetsForStimul, function (chart) {

                      var result = _this.mensurationChart(chart);

                      _this.chartDatasetsForStimulDataset.push(result.dataForChart);
                      _this.chartDatasetsHintForStimulDataset.push(result.dataForHintChart);
                      _this.chartDatasetsForStimul.push(result.chartDatasetsForStimul);
                      _this.changesLine.push(result.changesLine);
                    });

                    _this.withoutData = false;
                  } else {
                    _this.withoutData = true;
                  }

                  /*let result = this.mensurationChart(this.chartDatasetsForStimul[0]);
                   this.chartDatasetsForStimulDataset = result.dataForChart;
                  this.chartDatasetsHintForStimulDataset = result.dataForHintChart;*/
                  //this.chartDatasetsForStimul[0] = result.chartDatasetsForStimul;

                } else {
                  if (chartDatasetsForStimul && chartDatasetsForStimul.chartData) {
                    result = _this.mensurationChart(chartDatasetsForStimul);


                    _this.chartDatasetsForStimulDataset = result.dataForChart;
                    _this.chartDatasetsHintForStimulDataset = result.dataForHintChart;
                    _this.chartDatasetsForStimul = result.chartDatasetsForStimul;
                    _this.changesLine = result.changesLine;

                    _this.withoutData = false;
                  } else {
                    _this.withoutData = true;
                  }
                }

              case 18:
                _this.loaded = true;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    popupShow: function popupShow(data, stageId) {
      if (this.chosenStimul.length == 1) {

        this.dataPoint = __WEBPACK_IMPORTED_MODULE_10_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.isModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    },
    checkedStimulus: function checkedStimulus(id) {

      var checked = false;
      if (id && this.chosenStimul.length) {
        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.chosenStimul, function (stimul) {
          if (stimul.stimulusId == id || stimul.id == id) {
            checked = true;
          }
        });
      }

      return checked;
    },
    choseStimulus: function choseStimulus(val, checked) {
      this.isChangeStimuli = true;
      if (checked) {
        this.chosenStimul.push(val);
      } else {
        var array = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.chosenStimul, function (item) {
          return item.name !== val.name;
        });
        this.chosenStimul = array;
      }
    },
    trendLine: function trendLine(item) {
      var SumOfPowX = 0,
          SumOfX = 0,
          n = item.length,
          SumOfXY = 0,
          SumOfY = 0;

      for (var i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += i + 1;
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      var det = SumOfPowX * n - Math.pow(SumOfX, 2);
      var a = (SumOfXY * n - SumOfX * SumOfY) / det;
      var b = (SumOfY - a * SumOfX) / n;

      var first = a + b;
      var last = a * n + b;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: first
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: last
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    levelLine: function levelLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(item, function (point) {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: y
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: y
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    scatterLine: function scatterLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      var min = __WEBPACK_IMPORTED_MODULE_11_lodash_minBy___default()(item, function (o) {
        return o.y;
      });
      var max = __WEBPACK_IMPORTED_MODULE_12_lodash_maxBy___default()(item, function (o) {
        return o.y;
      });

      var dataMin = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: min
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: min
      }];

      var dataMax = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: max
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: max
      }];

      var datasetMin = new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var datasetMax = new __WEBPACK_IMPORTED_MODULE_4__common_chart__["d" /* LineChartDataset */]({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var dataset = [datasetMin, datasetMax];

      return dataset;
    },
    fetchDatasetLineTrend: function fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
      var _this2 = this;

      var data = [],
          trendPointIndex = [],
          trendPoint = [],
          i = 0;
      var array = [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(item, function (point, index) {

        if (point.isImportant) {
          trendPoint.push(array);
          array = [];
          trendPointIndex.push(index);
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(array);
          }
        }
      });
      var dataset = [];

      if (trendLine) {
        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this2.trendLine(point));
          }
        });
      }
      if (levelLine) {
        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this2.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this2.scatterLine(point)[0]);
            dataset.push(_this2.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset;
    }
  },

  watch: {
    levelLineChecked: function levelLineChecked(newValue) {
      var _this3 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this3.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked: function trendLineChecked(newValue) {
      var _this4 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this4.isChangeStimuli = false;
      }, 500);
    },
    ScatterLineChecked: function ScatterLineChecked(newValue) {
      var _this5 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this5.isChangeStimuli = false;
      }, 500);
    }
  }

};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageMand_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d6ccb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageMand_vue__ = __webpack_require__(1143);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageMand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d6ccb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageMand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isMensurationForbidden()) {
    next();
  } else {
    next(from && from.name ? false : { 'name': 'default' });
  }
});

/***/ }),
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocompleteSearch_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4b5a45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocompleteSearch_vue__ = __webpack_require__(1193);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocompleteSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c4b5a45_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocompleteSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var Manager = function () {
  function Manager() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    this.baseUrl = "https://app.autismtech.online/api" + '/interactive-modules/random-rotation';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'hasAccess',
    value: function hasAccess(assigneeId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/has-access', {
        params: { assigneeId: assigneeId }
      });
    }
  }, {
    key: 'getSettings',
    value: function getSettings(assigneeId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/settings', {
        params: { id: assigneeId }
      });
    }
  }, {
    key: 'getReports',
    value: function getReports(assigneeId, perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/sessions/', {
        params: { assigneeId: assigneeId, perPage: perPage, page: page }
      });
    }
  }, {
    key: 'exportReports',
    value: function exportReports(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.baseUrl + '/sessions/export', {
        id: id
      }, { responseType: 'blob' });
    }
  }, {
    key: 'save',
    value: function save(data) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.baseUrl + '/sessions', data);
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_auth_interceptors_Authorization__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_auth_interceptors_AuthorizationResponse__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_auth_interceptors_Forbidden__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_interceptors_LanguageHeader__ = __webpack_require__(302);







__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = "https://app.autismtech.online/api";

Object(__WEBPACK_IMPORTED_MODULE_1__common_auth_interceptors_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_axios___default.a);
Object(__WEBPACK_IMPORTED_MODULE_2__common_auth_interceptors_AuthorizationResponse__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_axios___default.a);
Object(__WEBPACK_IMPORTED_MODULE_4__lang_interceptors_LanguageHeader__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_axios___default.a);
Object(__WEBPACK_IMPORTED_MODULE_3__common_auth_interceptors_Forbidden__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  BEFORE_UNAUTHORIZE: 'unauthorize',
  AFTER_UNAUTHORIZE: 'unauthorize',
  USER_INFO_EXPIRED: 'userinfoexpired'
});

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managers_CuratorApiManager__ = __webpack_require__(900);



var BASE_URL = "https://app.autismtech.online/api" + '/users';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__managers_CuratorApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_axios___default.a, BASE_URL + '/curators'));

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd56958_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__ = __webpack_require__(966);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd56958_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SUCCESSFUL_ANSWER: 1,
  HINT_ANSWER: 2,
  FAIL_ANSWER: 3,
  NO_ANSWER: 4
});

/***/ }),
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientBtn_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609ddd3f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientBtn_vue__ = __webpack_require__(1247);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609ddd3f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loader.97ed847.gif";

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RU_LANGUAGE; });
/* unused harmony export EN_LANGUAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PL_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UA_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_LANGUAGES; });
var RU_LANGUAGE = 'ru';
var EN_LANGUAGE = 'en';
var PL_LANGUAGE = 'pl';
var UA_LANGUAGE = 'uk';
var DEFAULT_LANGUAGE = RU_LANGUAGE;
var AVAILABLE_LANGUAGES = [RU_LANGUAGE, EN_LANGUAGE, UA_LANGUAGE, PL_LANGUAGE];

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_dist_logger__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_persistedState__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_auth_vuex__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mobile_index__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_user__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dro_vuex__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_randomRotation_vuex__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_bids_vuex__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_undesirableBehavior_index__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_appeals_index__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dashboardParent_vuex__ = __webpack_require__(945);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var plugins = [__WEBPACK_IMPORTED_MODULE_4__common_persistedState__["a" /* default */]];

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ auth: __WEBPACK_IMPORTED_MODULE_5__common_auth_vuex__["a" /* default */], dro: __WEBPACK_IMPORTED_MODULE_8__modules_dro_vuex__["a" /* default */], mobile: __WEBPACK_IMPORTED_MODULE_6__common_mobile_index__["a" /* default */], rotation: __WEBPACK_IMPORTED_MODULE_9__modules_randomRotation_vuex__["a" /* default */], behavior: __WEBPACK_IMPORTED_MODULE_11__modules_undesirableBehavior_index__["a" /* default */], appeals: __WEBPACK_IMPORTED_MODULE_12__modules_appeals_index__["a" /* default */], bids: __WEBPACK_IMPORTED_MODULE_10__modules_bids_vuex__["a" /* default */], protocol: __WEBPACK_IMPORTED_MODULE_13__modules_dashboardParent_vuex__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_7__modules_user__["a" /* default */]),
  strict: debug,
  plugins: debug ? plugins.concat([__WEBPACK_IMPORTED_MODULE_3_vuex_dist_logger___default()()]) : plugins
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managers_ClientApiManager__ = __webpack_require__(902);



var BASE_URL = "https://app.autismtech.online/api" + '/users';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__managers_ClientApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_axios___default.a, BASE_URL + '/clients'));

/***/ }),
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d085dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__ = __webpack_require__(993);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d085dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  MILLISECONDS: 1000,
  SECONDS: 60,
  MINUTES: 60,
  HOURS: 24,
  COUNT_DAY: 6,

  SECONDS_PER_MINUTE: 60,

  MAX_LENGTH: 50
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BidsApiManager__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var BASE_URL = "https://app.autismtech.online/api";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__BidsApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_axios___default.a, BASE_URL + '/bids'));

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadDTTData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEachRight__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEachRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEachRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__filters_filters__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue2_timepicker__);

































var loadDTTData = {
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/dtt/',
      apiCheckedUrl: '/protocols/assigned/',
      disabled: false,
      isLoaded: false,
      protocols: null,
      protocolsData: null,
      phaseSettings: [],
      activeStep: [],
      execution: '',
      stimulus: [],
      stimulList: [],
      attempts: {},
      currentSesssionDate: null,
      startSesssionDate: null,
      uiid: null,
      stimulusListEmpty: false,
      phases: null,
      lastSession: [],
      disabledSave: true,
      rangeDateStart: null, //new Date(),
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      timerId: null,
      showDatapicker: false,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      addStimulusItem: null,
      lastPhase: null,
      totalAtemptsCount: 0,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      showChangeDateSession: false,
      duration: null,
      stageInfo: this.stage,
      newTasks: []
    };
  },

  components: {
    Instruction: __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_6__modules_loader_components_Loader__["a" /* default */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_31_vue2_timepicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])('auth', ['isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).unix();
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).unix() + 3600;
    },
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    conditionTransfer: function conditionTransfer() {
      var condition = this.activeStep.transferCondition;

      if (condition) {
        if (condition.id == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL) {
          return __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.one_trial');
        } else if (condition.id == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
          return condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.trial_in_row');
        } else if (condition.id == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
          return condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.task_in_row');
        } else {
          return condition.ratio + " " + __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.condition_procent') + " " + condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.condition_trial') + " " + condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.condition_session');
        }
      }
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.minDate).unix();
        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);

        var previous = __WEBPACK_IMPORTED_MODULE_17_moment___default()(sessionDate).unix();
        return previous <= protocolDate;
      }

      return false;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response, entity;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.startSesssionDate = new Date();

              if (_this.stage) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this.apiUrl + _this.protocolId + '/show-stage/' + _this.stageId);

            case 6:
              response = _context.sent;

              _this.stageInfo = response.data.data;

            case 8:
              _context.next = 10;
              return _this.initProtocols();

            case 10:
              _this.uiid = __WEBPACK_IMPORTED_MODULE_21__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uiid,
                type: 'assigned-session'
              };


              _this.showDatapicker = __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["a" /* DATAPICKER */];

              _this.setEntity(entity);
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](0);

              console.dir(_context.t0);
              if (_context.t0.status == 403) {
                _this.$router.push({ name: 'client' });
              } else {
                _this.$router.push({ name: 'error' });
              }

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 16]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["b" /* mapActions */])('protocol', ['setProtocol', 'setProtocolVersion']), {
    visibleList: function visibleList(list) {
      var emptyList = true;
      if (list) {
        emptyList = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(list, function (item) {
          return !item.moveForward;
        }).length;
      }
      return emptyList;
    },
    changeNumber: function changeNumber(event) {
      if (!(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = this.client.timezone ? __WEBPACK_IMPORTED_MODULE_17_moment___default()().tz(this.client.timezone)._offset : 0;
      var dateTime = __WEBPACK_IMPORTED_MODULE_17_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_17_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    toLocaleDateTimeTimezone: function toLocaleDateTimeTimezone(date) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_17_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;

      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(dateWithTimezone).format('DD.MM.YYYY HH:mm');
    },


    addStimulus: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(item) {
        var unique, result, stimulList, uuid;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                unique = true;
                _context2.next = 3;
                return this.$validator.validate();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:

                if (item) {
                  stimulList = this.activeStep.globalTasks;


                  __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(stimulList, function (stimul) {
                    if (__WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(item.toLowerCase())) {
                      unique = false;
                    }
                  });

                  if (unique) {
                    uuid = __WEBPACK_IMPORTED_MODULE_21__common_uuid_UuidGenerator__["a" /* default */].v4();


                    this.phases[0].items.push({
                      attempt: 0,
                      sessionAnswers: {},
                      fieldIndex: this.activeStep.minFieldCount,
                      taskId: null,
                      description: item,
                      title: item,
                      answer: null,
                      active: true,
                      checked: true,
                      type: this.activeStep.taskType,
                      position: 0,
                      toNextLevel: false,
                      lastAnswers: [],
                      attepmtsCount: '1',
                      lastAnswersCount: [],
                      himselfList: [],
                      globalUuid: uuid,
                      fieldAnswers: [{
                        day: this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today(),
                        answers: [],
                        himself: this.activeStep.transferCondition.id !== __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO ? [] : 0,
                        total: 0
                      }]
                    });

                    this.activeStep.globalTasks.push({
                      description: item,
                      uuid: uuid
                    });

                    this.newTasks.push({
                      globalUuid: uuid,
                      description: item
                    });

                    this.addStimulusItem = null;
                    this.errors.clear();
                    this.disabledSave = false;
                  } else {
                    this.errors.add({
                      field: 'addStimulusItem',
                      msg: __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
                    });
                  }
                } else {
                  this.errors.add({
                    field: 'addStimulusItem',
                    msg: __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.stimulus_required')
                  });
                }

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addStimulus(_x) {
        return _ref.apply(this, arguments);
      }

      return addStimulus;
    }(),

    checkSessionVersion: function checkSessionVersion() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this2.apiCheckedUrl + _this2.protocolsData.id + '/is-version-equal/' + _this2.activeStep.majorVersion);
                return _context3.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    cancelSession: function cancelSession() {
      this.isModalVisible = false;
    },
    saveSession: function saveSession() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var stimulus, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                stimulus = [];

                _this3.isLoaded = false;
                __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(_this3.phases, function (phase) {
                  __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(phase.items, function (item) {
                    var attemptAnswers = [];

                    __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(item.sessionAnswers, function (fieldRezult, key) {
                      attemptAnswers.push({
                        field: key,
                        attemptAnswers: fieldRezult
                      });
                    });

                    stimulus.push({
                      globalUuid: item.globalUuid,
                      answers: attemptAnswers,
                      currentField: item.fieldIndex,
                      moveForward: item.moveForward,
                      description: item.description,
                      attempt: item.attempt
                    });
                  });
                });

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (_this3.isPreviousDateSession && _this3.previousTime.HH) {
                  clientTimeZoneOffset = _this3.client.timezone ? __WEBPACK_IMPORTED_MODULE_17_moment___default()().tz(_this3.client.timezone)._offset : 0;

                  sessionDate = new Date(Date.UTC(_this3.previousDate.getFullYear(), _this3.previousDate.getMonth(), _this3.previousDate.getDate(), _this3.previousTime.HH, _this3.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + _this3.previousDuration * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                isSaved = void 0;

                isSaved = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this3.apiUrl + _this3.protocolsData.id + '/sessions', {
                  'assignedSessions': [{
                    'uuid': _this3.uiid,
                    //'dayUuid': this.uiid,
                    'startedAt': _this3.isPreviousDateSession ? timeSessionDate : _this3.currentSesssionDate ? _this3.currentSesssionDate : Math.round(new Date().getTime() / 1000), //
                    'finishedAt': _this3.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000), //
                    'stimuli': stimulus,
                    'phaseId': _this3.activeStep.id,
                    'type': _this3.activeStep.taskType
                  }],
                  'index': _this3.activeStep.position,
                  'majorVersion': _this3.activeStep.majorVersion,
                  'uuid': _this3.activeStep.stageUuid,
                  'newTasks': _this3.newTasks
                }).then(function (response) {
                  _this3.setProtocol(null);
                  /*this.isLoaded = true;
                  this.initProtocols();
                  this.uiid = UuidGenerator.v4();
                  let entity = {
                    id: this.uiid,
                    type: 'assigned-session',
                  };
                  this.setEntity(entity);*/
                  _this3.$router.push({ name: 'choose-stage', params: { protocolsData: null, client: _this3.client } });
                }).catch(function (error) {
                  _this3.isLoaded = true;
                });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    saveStage: function saveStage() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var checkVersion;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                _this4.disabledSave = true;

                _context5.next = 3;
                return _this4.checkSessionVersion();

              case 3:
                checkVersion = _context5.sent;

                if (checkVersion.data.data.result) {
                  _this4.saveSession();
                } else {
                  _this4.isModalVisible = true;
                }

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    attemptChange: function attemptChange(answer, stimul, indexPhase, title, answerCount) {
      var _this5 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      var answerListCount = answerCount ? __WEBPACK_IMPORTED_MODULE_29_lodash_toInteger___default()(answerCount) : 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_28_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_28_lodash_fill___default()(new Array(answerListCount), answer);

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;

      if (this.totalAtemptsCount <= 3000) {

        this.maxTotalAtemptsCountError = false;

        var positive = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(this.activeStep.taskType.answers, function (item) {
          return item.himself;
        });
        var positiveAnswer = positive[0].id;

        var answerListHimself = [];

        var lastDate = stimul.fieldAnswers[0] ? stimul.fieldAnswers[0].day : this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();
        var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

        var newStimuli = stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex] : [];

        newStimuli = __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(newStimuli, answerListId);
        stimul.sessionAnswers[stimul.fieldIndex] = newStimuli;

        stimul.lastAnswers = __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(stimul.lastAnswers, answerList);
        stimul.lastAnswersId = __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(stimul.lastAnswersId, answerListId);
        stimul.newSessionAnswers = __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(stimul.newSessionAnswers, answerList);

        var listHimselfAnswers = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(stimul.fieldAnswers, function (item) {
          return item.day == lastDay;
        });

        if (this.activeStep.transferCondition.id !== __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO) {
          answerListHimself = __WEBPACK_IMPORTED_MODULE_28_lodash_fill___default()(new Array(answerListCount), answer == positiveAnswer);

          if (listHimselfAnswers.length) {
            if (!listHimselfAnswers.isMastered) {
              listHimselfAnswers[0].himself = __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(listHimselfAnswers[0].himself, answerListHimself);
              listHimselfAnswers[0].answers = listHimselfAnswers[0].answers && listHimselfAnswers[0].answers.length ? __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(listHimselfAnswers[0].answers, answerList) : answerList;
            }
          } else {

            listHimselfAnswers = {
              day: lastDay,
              himself: answerListHimself,
              answers: answerList
            };
            stimul.fieldAnswers.unshift(listHimselfAnswers);
          }
        } else {

          answerListHimself = answer == positiveAnswer ? __WEBPACK_IMPORTED_MODULE_28_lodash_fill___default()(new Array(answerListCount), answer == positiveAnswer) : [];

          if (listHimselfAnswers.length) {
            if (!listHimselfAnswers.isMastered) {
              listHimselfAnswers[0].himself += +answerListHimself.length;
              listHimselfAnswers[0].answers = listHimselfAnswers[0].answers && listHimselfAnswers[0].answers.length ? __WEBPACK_IMPORTED_MODULE_30_lodash_concat___default()(listHimselfAnswers[0].answers, answerList) : answerList;
              listHimselfAnswers[0].total += +answerListCount;
            }
          } else {
            listHimselfAnswers = {
              day: lastDay,
              himself: +answerListHimself.length,
              answers: answerList,
              total: +answerListCount
            };
            stimul.fieldAnswers.unshift(listHimselfAnswers);
          }
        }

        stimul.lastAnswersCount.push(answerListCount);

        var toNextLevel = stimul.toNextLevel;
        stimul.attempt = stimul.attempt + answerListCount;
        stimul.toNextLevel = this.nextLevel(stimul);

        if (!toNextLevel && stimul.toNextLevel) {
          this.phases[indexPhase].countToNextLevel++;
        }

        if (toNextLevel && !stimul.toNextLevel) {
          this.phases[indexPhase].countToNextLevel--;
        }
      }

      if (this.totalAtemptsCount > this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this5.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }
      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        stimul.answer = null;
        stimul.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id, index, stimul, toNext) {
      var _this6 = this;

      var activePhase = this.phases[index].items;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();
      var positive = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(this.activeStep.taskType.answers, function (item) {
        return item.himself;
      });
      var positiveAnswer = positive[0].id;
      var lastAnswersCount = stimul.lastAnswersCount[stimul.lastAnswersCount.length - 1];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(activePhase, function (item, key) {
        var isCurrentStimulus = stimul.id ? item.id == stimul.id : item.description == stimul.description;
        if (isCurrentStimulus) {
          item.attempt = item.attempt - lastAnswersCount;
          if (_this6.activeStep.transferCondition.id == 'ratio') {
            item.fieldAnswers[0].total = item.fieldAnswers[0].total - lastAnswersCount;
            if (item.sessionAnswers[item.fieldIndex][item.sessionAnswers[item.fieldIndex].length - 1] == positiveAnswer) {
              item.fieldAnswers[0].himself = item.fieldAnswers[0].himself - lastAnswersCount;
              item.positiveAnswersCount -= lastAnswersCount;
            }
            if (!item.fieldAnswers[0].total) {
              item.fieldAnswers.shift();
            }
          } else {

            var listHimselfAnswers = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(item.fieldAnswers, function (himselfItem) {
              return himselfItem.day == lastDay;
            });

            if (listHimselfAnswers.length) {
              listHimselfAnswers[0].himself = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(listHimselfAnswers[0].himself, lastAnswersCount);
              listHimselfAnswers[0].answers = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(listHimselfAnswers[0].answers, lastAnswersCount);
            }

            if (!listHimselfAnswers[0].answers.length) {
              item.fieldAnswers.shift();
            }
          }

          item.sessionAnswers[item.fieldIndex] = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(item.sessionAnswers[item.fieldIndex], lastAnswersCount);
          item.toNextLevel = _this6.nextLevel(item);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.lastAnswersId = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(item.lastAnswersId, lastAnswersCount);
          item.newSessionAnswers = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(item.newSessionAnswers, lastAnswersCount);

          item.lastAnswersCount.pop();

          if (toNext && !item.toNextLevel) {
            _this6.phases[index].countToNextLevel--;
          }
          if (!toNext && item.toNextLevel) {
            _this6.phases[index].countToNextLevel++;
          }
          _this6.totalAtemptsCount = _this6.totalAtemptsCount - lastAnswersCount;

          if (!activePhase.length) {
            _this6.disabledSave = true;
          }

          _this6.$set(activePhase, key, item);
        }
      });
    },

    goToNextLevel: function goToNextLevel(id, stimul, indexPhase) {
      var moveForward = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var items = this.phases[indexPhase].items;
      var index = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(items, function (answer) {
        if (id) {
          return stimul.id == answer.id;
        } else {
          return stimul.description == answer.description;
        }
      });
      if (!moveForward) {
        items.splice(index, 1);
      }

      stimul.toNextLevel = false;
      stimul.lastAnswers = [];
      stimul.lastAnswersId = [];
      stimul.newSessionAnswers = [];
      this.phases[indexPhase].countToNextLevel--;
      if (!moveForward) {
        this.phases[indexPhase + 1].items.push(stimul);
        this.phases[indexPhase + 1].items[this.phases[indexPhase + 1].items.length - 1].fieldAnswers = [{
          day: this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today(),
          himself: this.activeStep.transferCondition.id == 'ratio' ? 0 : [],
          answers: [],
          total: 0
        }];
      }
      if (stimul.fieldIndex < this.activeStep.maxFieldCount) {
        stimul.fieldIndex++;
      }
      stimul.attempt = 0;
      stimul.attepmtsCount = '1';
      stimul.lastAnswersCount = [];
      stimul.moveForward = moveForward;
      this.disabledSave = false;

      if (!moveForward) {
        this.phases[indexPhase + 1].visible = true;
      } else {
        stimul.moveToNextPhase = true;
        this.$set(this.phases[indexPhase].items, index, stimul);
      }
    },

    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_17_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_17_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_20__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    },


    initProtocols: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isLoaded = false;
                _context6.next = 3;
                return this.getProtocols();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function initProtocols() {
        return _ref2.apply(this, arguments);
      }

      return initProtocols;
    }(),

    nextLevel: function nextLevel(item) {
      var _this7 = this;

      var condition = this.activeStep.transferCondition.id;
      var toNextLevel = false;

      var fieldAnswers = item.fieldAnswers ? __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(item.fieldAnswers, function (answ) {
        return answ.answers && answ.answers.length || answ.total || answ.isMastered;
      }) : null;
      if (condition == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL) {

        var lastAnswers = fieldAnswers && fieldAnswers[0] ? fieldAnswers[0] : [];

        if (lastAnswers && lastAnswers.isMastered) {
          toNextLevel = true;
        } else {
          toNextLevel = lastAnswers.himself && lastAnswers.himself.length ? lastAnswers.himself[0] : false;
        }
      } else if (condition == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
        var _lastAnswers = fieldAnswers && fieldAnswers[0] ? fieldAnswers[0] : [];
        var trialCount = this.activeStep.transferCondition.trialCount;
        var summ = 0;

        if (_lastAnswers && _lastAnswers.isMastered) {
          toNextLevel = true;
        } else {
          if (_lastAnswers && _lastAnswers.himself && _lastAnswers.himself.length >= trialCount) {

            for (var i = 0; i < trialCount; i++) {
              if (_lastAnswers.himself[i]) {
                summ++;
              }
            }
            toNextLevel = summ == trialCount;
          }
        }
      } else if (condition == __WEBPACK_IMPORTED_MODULE_19__modules_protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
        var lastSessions = [];
        var dropCount = 0;

        if (fieldAnswers) {
          dropCount = fieldAnswers.length - this.activeStep.transferCondition.sessionCount > 0 ? fieldAnswers.length - this.activeStep.transferCondition.sessionCount : 0;
        }

        var _lastAnswers2 = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(fieldAnswers, dropCount);

        toNextLevel = false;

        if (_lastAnswers2 && _lastAnswers2.length) {

          __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(_lastAnswers2, function (answerList) {
            if (answerList.himself && !answerList.isMastered) {
              lastSessions.push(answerList.himself[0]);
            }
            if (answerList.isMastered) {
              lastSessions.push(answerList.isMastered);
            }
          });

          var positiveArray = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(lastSessions, function (o) {
            return o;
          });

          toNextLevel = positiveArray.length >= this.activeStep.transferCondition.sessionCount;
        } else {
          toNextLevel = false;
        }
      } else {
        var summLevel = [];
        var countSession = 0;
        var summTrial = 0;
        var countTrial = 0;
        var _trialCount = this.activeStep.transferCondition.trialCount;
        var sessionCount = this.activeStep.transferCondition.sessionCount;

        if (fieldAnswers && fieldAnswers.length >= sessionCount) {

          __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(fieldAnswers, function (answerList) {
            summTrial = 0;
            countSession++;

            countTrial = answerList.total;
            summTrial = answerList.himself;

            var trial = false;
            if (countTrial >= _trialCount) {
              trial = summTrial * 100 / countTrial >= _this7.activeStep.transferCondition.ratio;
            }

            if (answerList.isMastered) {
              trial = true;
            }

            summLevel.push(trial);
          });
        } else {
          return false;
        }
        if (countSession >= sessionCount) {

          var next = true;
          var _dropCount = 0;

          if (summLevel) {
            _dropCount = summLevel.length - sessionCount > 0 ? summLevel.length - sessionCount : 0;
          }

          var _lastAnswers3 = __WEBPACK_IMPORTED_MODULE_14_lodash_dropRight___default()(summLevel, _dropCount);

          __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(_lastAnswers3, function (answer) {
            if (!answer) {
              next = false;
            }
          });

          toNextLevel = next;
        } else {
          return false;
        }
      }

      return toNextLevel;
    },

    lastAnswerTitle: function lastAnswerTitle(answer) {

      var title = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(this.activeStep.taskType.answers, function (type) {
        return type.id == answer;
      });

      return title[0] ? title[0].title : answer;
    },

    getProtocols: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _this8 = this;

        var params, newDate, newDateUnix, response, phases, _loop, i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                params = {};


                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_17_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }

                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl + this.protocolId + '/stage/' + this.stageId + '/phase/' + this.phaseId, {
                  params: params
                });

              case 5:
                response = _context7.sent;

                this.protocolsData = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocolVuexData);
                this.protocols = this.protocolsData.protocol;

                if (this.protocolsData.status.id == 4) {
                  this.$router.push({ name: 'client-edit', params: { clientId: this.client.id } });
                }

                this.activeStep = response.data.data;
                this.stimulList = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.activeStep.stimuli);
                this.stimulList = __WEBPACK_IMPORTED_MODULE_27_lodash_orderBy___default()(this.stimulList, 'position');
                this.execution = this.protocols.execution || '';

                __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(this.stimulList, function (item) {

                  item.fieldIndex = item.fieldIndex ? item.fieldIndex : _this8.activeStep.minFieldCount;
                  if (item.fieldIndex < _this8.activeStep.minFieldCount && _this8.activeStep.withFields) {
                    item.fieldIndex = _this8.activeStep.minFieldCount;
                  }
                  item.sessionAnswers = {};
                  item.attempt = 0;
                  item.attepmtsCount = '1';
                  item.lastAnswersCount = [];
                  item.lastAnswersId = [];
                  item.type = _this8.activeStep.taskType;
                  item.moveForward = false;
                  item.newSessionAnswers = [];
                  item.toNextLevel = _this8.nextLevel(item);
                });

                phases = [];


                if (this.activeStep.withFields) {
                  _loop = function _loop(i) {
                    var listToNextLevel = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(_this8.stimulList, function (item) {
                      return item.fieldIndex == i + +_this8.activeStep.minFieldCount && item.toNextLevel;
                    });
                    phases[i] = {
                      visible: i ? false : true,
                      countToNextLevel: listToNextLevel ? listToNextLevel.length : 0,
                      items: __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(_this8.stimulList, function (item) {
                        return item.fieldIndex == i + +_this8.activeStep.minFieldCount;
                      })
                    };
                  };

                  for (i = 0; i <= this.activeStep.maxFieldCount - this.activeStep.minFieldCount; i++) {
                    _loop(i);
                  }
                } else {
                  phases[0] = {
                    visible: true,
                    countToNextLevel: 0,
                    items: this.stimulList
                  };
                }
                this.phases = phases;

                this.isLoaded = true;
                _context7.next = 23;
                break;

              case 20:
                _context7.prev = 20;
                _context7.t0 = _context7['catch'](0);

                console.dir(_context7.t0);
                //this.$router.push({name: 'client-edit', params: { clientId: this.client.id }});

              case 23:
                _context7.prev = 23;
                return _context7.finish(23);

              case 25:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 20, 23, 25]]);
      }));

      function getProtocols() {
        return _ref3.apply(this, arguments);
      }

      return getProtocols;
    }()

  }),
  watch: {
    previousDate: function previousDate(newValue, oldValue) {
      var _this9 = this;

      var oldDay = oldValue ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(oldValue).format('YYYY-MM-DD') : this.today();
      var newDay = __WEBPACK_IMPORTED_MODULE_17_moment___default()(newValue).format('YYYY-MM-DD');

      __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(this.stimulList, function (item) {

        var lastAnswersCount = item.attempt;
        var answIndex = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(_this9.activeStep.stimuli, function (field) {
          return field.globalUuid === item.globalUuid;
        });

        var fieldAnswIndex = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(item.fieldAnswers, function (field) {
          return field.day === oldDay;
        });
        var fieldAnswIndexNew = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(item.fieldAnswers, function (field) {
          return field.day === newDay;
        });
        var fieldAnswIndexBefore = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(_this9.activeStep.stimuli[answIndex].fieldAnswers, function (field) {
          return field.day === oldDay;
        });
        var answers = item.newSessionAnswers;

        var positive = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(_this9.activeStep.taskType.answers, function (item) {
          return item.himself;
        });
        var positiveAnswer = positive[0].title;
        var positiveAnswersCount = __WEBPACK_IMPORTED_MODULE_23_lodash_filter___default()(answers, function (answ) {
          return answ == positiveAnswer;
        }).length;
        var answersArray = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(answers, function (answ) {
          return answ == positiveAnswer;
        });

        var beforeItem = _this9.activeStep.stimuli[answIndex].fieldAnswers[fieldAnswIndexBefore];

        if (fieldAnswIndex >= 0) {

          if (oldDay == __WEBPACK_IMPORTED_MODULE_17_moment___default()(_this9.minDate).format('YYYY-MM-DD')) {

            item.fieldAnswers.unshift({
              day: newDay,
              answers: answers,
              total: answers.length,
              himself: _this9.activeStep.transferCondition.id == 'ratio' ? positiveAnswersCount : answersArray
            });
            item.lastAnswers = answers;
            item.fieldAnswers[fieldAnswIndex + 1].answers = [];
            item.fieldAnswers[fieldAnswIndex + 1].total = beforeItem ? beforeItem.total : 0;
            item.fieldAnswers[fieldAnswIndex + 1].himself = beforeItem ? beforeItem.himself : 0;
          } else {

            if (newDay == __WEBPACK_IMPORTED_MODULE_17_moment___default()(_this9.minDate).format('YYYY-MM-DD') && fieldAnswIndexNew >= 0) {

              item.fieldAnswers[fieldAnswIndexNew].answers = answers;
              item.lastAnswers = answIndex >= 0 ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this9.activeStep.stimuli[answIndex].lastAnswers), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(answers)) : answers;
              item.fieldAnswers[fieldAnswIndexNew].total = beforeItem ? beforeItem.total + answers.length : answers.length;
              item.fieldAnswers[fieldAnswIndexNew].himself = beforeItem ? beforeItem.himself + positiveAnswersCount : positiveAnswersCount;
              item.fieldAnswers.shift();
            } else {
              item.fieldAnswers[fieldAnswIndex].day = newDay;
            }
          }
        }
        item.toNextLevel = _this9.nextLevel(item);
      });
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue && this.previousDate) {
        var oldDay = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.previousDate).format('YYYY-MM-DD');
        var newDay = this.today();

        __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(this.stimulList, function (item) {

          var lastAnswersCount = item.attempt;

          if (lastAnswersCount > 0) {

            var fieldAnswIndex = __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(item.fieldAnswers, function (field) {
              return field.day === oldDay;
            });

            if (fieldAnswIndex >= 0) {
              item.fieldAnswers[fieldAnswIndex].day = newDay;
            }
          }
        });
      }
    }
  }
};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_translator__ = __webpack_require__(6);



var options = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
};

var filter = {
  toLocaleDate: function toLocaleDate(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    // return new Date(date.replace(/-/g, '/')).toLocaleDateString('ru')
  },
  toLocaleDateTime: function toLocaleDateTime(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
  },
  toFirstLetter: function toFirstLetter(text) {
    return text.charAt(0);
  },
  phaseNameByTypeId: function phaseNameByTypeId(phaseTypeId) {
    var name = '';
    switch (parseInt(phaseTypeId)) {
      case 0:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.all_phases');
        break;
      case 1:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.mastering');
        break;
      case 2:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.rotation');
        break;
      case 3:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.support');
        break;
      case 4:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.fluency');
        break;
      case 5:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.mastering');
        break;
    }
    return name;
  },

  intervalNameByTypeId: function intervalNameByTypeId(phaseTypeId) {
    var name = '';
    switch (parseInt(phaseTypeId)) {
      case 1:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.through_each_lesson');
        break;
      case 2:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.after_one_lesson');
        break;
      case 3:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.after_two_classes');
        break;
      case 4:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.after_three_classes');
        break;
      case 5:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.once_a_week');
        break;
      case 6:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks');
        break;
      case 7:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.once_a_month');
        break;
      default:
        name = __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('protocol.all_intervals');
        break;

    }
    return name;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (filter);

/***/ }),
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleView_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d359ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleView_vue__ = __webpack_require__(1167);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d359ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(565);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf63bcce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(1196);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf63bcce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Interface = function () {
  function Interface() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Interface);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Interface, [{
    key: 'get',
    value: function get() {
      throw new Error('You must implement this method');
    }
  }, {
    key: 'set',
    value: function set() {
      throw new Error('You must implement this method');
    }
  }, {
    key: 'remove',
    value: function remove() {
      throw new Error('You must implement this method');
    }
  }, {
    key: 'clear',
    value: function clear() {
      throw new Error('You must implement this method');
    }
  }]);

  return Interface;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interface);

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(127);





/* harmony default export */ __webpack_exports__["a"] = (function (axios) {
  var _this = this;

  axios.interceptors.request.use(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(config) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config.headers['Language'] = __WEBPACK_IMPORTED_MODULE_3__locale__["a" /* default */];
              return _context.abrupt('return', config);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
});;

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UNAUTHORIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHORIZED_AS_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTHORIZED_AS_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ROLE_BCBA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ROLE_INDEPENDENT_CURATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROLE_CURATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ROLE_THERAPIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROLE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUBSCRIPTION_MIN_DAYS_LEFT_FOR_WARNING; });
var UNAUTHORIZED = 1;
var AUTHORIZED_AS_APPLICATION = 2;
var AUTHORIZED_AS_USER = 3;

var ROLE_BCBA = 'bcba';
var ROLE_INDEPENDENT_CURATOR = 'independent_curator';
var ROLE_CURATOR = 'curator';
var ROLE_THERAPIST = 'therapist';
var ROLE_CLIENT = 'client';

var SUBSCRIPTION_MIN_DAYS_LEFT_FOR_WARNING = 7;

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_index__ = __webpack_require__(894);


var mobile = new __WEBPACK_IMPORTED_MODULE_0__vuex_index__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (mobile);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timer__ = __webpack_require__(914);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__Timer__["a" /* default */]());

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  START: 'start',
  STOP: 'stop',
  RESET: 'reset',
  TICK: 'tick',
  TO_TIME_CHANGED: 'to-time-changed',
  CURRENT_TIME_CHANGED: 'to-time-changed',
  TO_TIME_REACHED: 'to-time-reached'
});

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_register_components_SignupForm_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_login_components_LoginForm__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_passwordRecovery_components_SendResetTokenForm_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_passwordRecovery_components_ResetPasswordForm_vue__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_contactUs_components_ContactUsForm__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_error_components_ErrorModal__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dashboardParent_routes__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_protocols_routes__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_user_client_routes__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_profile_routes__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_user_therapist_routes__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_reports_routes__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_quiz_routes__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hooks_isGuest__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hooks_defaultIsGuest__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lang_locale__ = __webpack_require__(127);






















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [].concat([{
  path: '/',
  name: 'default',
  beforeEnter: __WEBPACK_IMPORTED_MODULE_17__hooks_defaultIsGuest__["a" /* default */]
}, {
  path: '/auth/register',
  name: 'signup',
  component: __WEBPACK_IMPORTED_MODULE_2__modules_register_components_SignupForm_vue__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_16__hooks_isGuest__["a" /* default */]
}, {
  path: '/auth/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_3__modules_login_components_LoginForm__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_16__hooks_isGuest__["a" /* default */]
}, {
  path: '/auth/password/reset',
  name: 'password-recovery-send-token',
  component: __WEBPACK_IMPORTED_MODULE_4__modules_passwordRecovery_components_SendResetTokenForm_vue__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_16__hooks_isGuest__["a" /* default */]
}, {
  path: '/auth/password/reset/:token',
  name: 'password-recovery-reset-password',
  component: __WEBPACK_IMPORTED_MODULE_5__modules_passwordRecovery_components_ResetPasswordForm_vue__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_16__hooks_isGuest__["a" /* default */],
  props: true
}, {
  path: '/contact-us',
  name: 'contact_us',
  component: __WEBPACK_IMPORTED_MODULE_6__modules_contactUs_components_ContactUsForm__["a" /* default */]
}, {
  path: '/error',
  name: 'error',
  component: __WEBPACK_IMPORTED_MODULE_7__modules_error_components_ErrorModal__["a" /* default */]
}, {
  path: '/404',
  name: '404',
  component: __WEBPACK_IMPORTED_MODULE_7__modules_error_components_ErrorModal__["a" /* default */]
}, {
  path: '*',
  redirect: '/404'
}], __WEBPACK_IMPORTED_MODULE_8__modules_dashboardParent_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__modules_user_client_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__modules_user_therapist_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__modules_reports_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modules_protocols_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__modules_profile_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__modules_quiz_routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  base: '/' + __WEBPACK_IMPORTED_MODULE_18__lang_locale__["a" /* default */] + '/'
}));

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fileUpload_components_Uploader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Uploader: __WEBPACK_IMPORTED_MODULE_6__fileUpload_components_Uploader__["a" /* default */] },
  data: function data() {
    return {
      user: {
        type: null,
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
        file: null
      },
      selected: '',
      disabled: false,
      types: [{ id: 1, value: 'bcba', label: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('registration.user_types.bcba') }, { id: 2, value: 'independent_curator', label: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('registration.user_types.independent_curator') }],
      submitted: false
    };
  },

  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('registration.header')
  },
  methods: {
    register: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, isSaved, response, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, message;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disabled = true;
                this.errors.remove('server');
                this.clearFileError();
                _context.next = 5;
                return this.$validator.validateAll();

              case 5:
                result = _context.sent;

                if (result) {
                  _context.next = 9;
                  break;
                }

                this.disabled = false;
                return _context.abrupt('return');

              case 9:
                _context.prev = 9;
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('/registration/register', this.user);

              case 12:
                isSaved = _context.sent;

                this.submitted = true;
                _context.next = 45;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);
                response = _context.t0.response;
                errors = response.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default()(errors)) {
                  _context.next = 44;
                  break;
                }

                if (!errors.message) {
                  _context.next = 25;
                  break;
                }

                this.errors.add('server', errors.message);
                _context.next = 44;
                break;

              case 25:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 28;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  message = errors[key].message;

                  this.errors.add(key, message);
                }
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context['catch'](28);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 36:
                _context.prev = 36;
                _context.prev = 37;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 39:
                _context.prev = 39;

                if (!_didIteratorError) {
                  _context.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context.finish(39);

              case 43:
                return _context.finish(36);

              case 44:
                this.disabled = false;

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 16], [28, 32, 36, 44], [37,, 39, 43]]);
      }));

      function register() {
        return _ref.apply(this, arguments);
      }

      return register;
    }(),
    onFileUploadAdd: function onFileUploadAdd() {
      this.disabled = true;
    },
    onFileUploadDone: function onFileUploadDone(_ref3) {
      var name = _ref3.name;

      this.disabled = false;
      this.user.file = name;
    },
    onFileUploadFail: function onFileUploadFail() {
      this.disabled = false;
      this.user.file = null;
    },
    onFileUploadProcessFail: function onFileUploadProcessFail() {
      this.disabled = false;
      this.user.file = null;
    },
    onFileUploadRemove: function onFileUploadRemove() {
      this.user.file = null;
    },
    addFileError: function addFileError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('validation.required', { attribute: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('validation.attributes.certificate') });

      this.clearFileError();
      this.errors.add('file', error);
    },
    clearFileError: function clearFileError() {
      this.errors.remove('file');
    },
    onChange: function onChange(obj) {
      this.selected = obj.value;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* Validator */].extend('unique_email', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('validation.unique_email', { attribute: attribute });
      },
      validate: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(email) {
          var valid, _ref5, response;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('/registration/validate-email', { email: email });

                case 4:
                  _ref5 = _context2.sent;
                  response = _ref5.data;

                  valid = response.data.valid;
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](1);

                  valid = false;

                case 12:
                  return _context2.abrupt('return', { valid: valid });

                case 13:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this, [[1, 9]]);
        }));

        return function validate(_x2) {
          return _ref4.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseUploader__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: { BaseUploader: __WEBPACK_IMPORTED_MODULE_5__BaseUploader__["a" /* default */] },
    props: {
        'afterSubmitForm': {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        options: {
            type: Object,
            default: function _default() {
                return {
                    'maxChunkSize': '1000000',
                    'maxNumberOfFiles': 1,
                    'maxFileSize': '100000000',
                    'acceptFileTypes': /(\.|\/)(gif|jpe?g|png|pdf)$/i,
                    'messages': {
                        'maxNumberOfFiles': __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('upload.max_number_of_files'),
                        'acceptFileTypes': __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('upload.accept_file_types'),
                        'maxFileSize': __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('upload.max_file_size'),
                        'minFileSize': __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('upload.min_file_size')
                    },
                    'accept': '.jpeg,.jpg,.png,.gif,.pdf'
                };
            }
        }
    },
    data: function data() {
        return {
            files: [],
            progress: 0
        };
    },

    computed: {
        disabled: function disabled() {
            return this.files.length >= this.options.maxNumberOfFiles;
        }
    },
    methods: {
        getTranslation: function getTranslation() {
            return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */], arguments);
        },
        checkProgress: function checkProgress() {
            if (__WEBPACK_IMPORTED_MODULE_2_lodash_every___default()(this.files, function (file) {
                return file.deleteUrl || file.error;
            })) {
                this.progress = 0;
            }
        },
        replaceFile: function replaceFile(file) {
            var cond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.files, cond || file);
            this.$set(this.files, index, file);
        },
        spliceFile: function spliceFile(file) {
            var index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.files, file);
            this.files.splice(index, 1);
        },
        onFileUploadAdd: function onFileUploadAdd(data) {
            var file = data.files[0];
            file.cancel = data.abort.bind(data);
            this.files.push(file);
            this.$emit('fileuploadadd', file);
        },
        onFileUploadProgressAll: function onFileUploadProgressAll(_ref) {
            var loaded = _ref.loaded,
                total = _ref.total;

            this.progress = parseInt(loaded / total * 100, 10);
        },
        onFileUploadDone: function onFileUploadDone(_ref2) {
            var result = _ref2.result;

            var file = result.files[0];
            this.replaceFile(file, { name: file.original_name, size: file.size });
            this.checkProgress();
            if (file.error) {
                this.$emit('fileuploadfail', file);
            } else {
                this.$emit('fileuploaddone', file);
            }
        },
        onFileUploadFail: function onFileUploadFail(_ref3) {
            var files = _ref3.files;

            var file = files[0];
            if (!file.error) {
                file.error = __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('upload.failed');
            }
            this.replaceFile(file);
            this.checkProgress();
            this.$emit('fileuploadfail', file);
        },
        onFileUploadProcessFail: function onFileUploadProcessFail(_ref4) {
            var files = _ref4.files;

            var file = files[0];
            this.replaceFile(file);
            this.checkProgress();
            this.$emit('fileuploadprocessfail', file);
        },
        cancel: function cancel(file) {
            if (file.cancel) {
                file.cancel();
            }
            this.spliceFile(file);
        },
        remove: function remove(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref5, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.delete(file.deleteUrl);

                            case 2:
                                _ref5 = _context.sent;
                                data = _ref5.data;

                                if (__WEBPACK_IMPORTED_MODULE_2_lodash_every___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_values___default()(data))) {
                                    _this.spliceFile(file);
                                    _this.$emit('fileuploadremove', file);
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    watch: {
        afterSubmitForm: function afterSubmitForm(newVal) {
            if (newVal) {
                this.files = [];
            }
        }
    }
});

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_file_upload_js_vendor_jquery_ui_widget__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_file_upload_js_vendor_jquery_ui_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blueimp_file_upload_js_vendor_jquery_ui_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_file_upload_js_jquery_iframe_transport__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_file_upload_js_jquery_iframe_transport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_blueimp_file_upload_js_jquery_iframe_transport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blueimp_file_upload_js_jquery_fileupload__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blueimp_file_upload_js_jquery_fileupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_blueimp_file_upload_js_jquery_fileupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blueimp_file_upload_js_jquery_fileupload_process__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blueimp_file_upload_js_jquery_fileupload_process___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_blueimp_file_upload_js_jquery_fileupload_process__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blueimp_file_upload_js_jquery_fileupload_validate__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blueimp_file_upload_js_jquery_fileupload_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_blueimp_file_upload_js_jquery_fileupload_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_auth_Manager__ = __webpack_require__(22);

//
//
//
//











var uploaderEvents = ['fileuploadadd', 'fileuploadsubmit', 'fileuploadsend', 'fileuploaddone', 'fileuploadfail', 'fileuploadalways', 'fileuploadprogress', 'fileuploadprogressall', 'fileuploadstart', 'fileuploadstop', 'fileuploadchange', 'fileuploadpaste', 'fileuploaddrop', 'fileuploaddragover', 'fileuploadchunksend', 'fileuploadchunkdone', 'fileuploadchunkfail', 'fileuploadchunkalways', 'fileuploadprocessstart', 'fileuploadprocess', 'fileuploadprocessdone', 'fileuploadprocessfail', 'fileuploadprocessalways', 'fileuploadprocessstop'];

var defaultOptions = {
  beforeSend: function beforeSend(xhr) {
    xhr.setRequestHeader('Authorization', 'Bearer ' + __WEBPACK_IMPORTED_MODULE_8__common_auth_Manager__["a" /* default */].getTokenSync());
  },
  dataType: 'json',
  url: "https://app.autismtech.online/api" + '/fileupload'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'options': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      var uploader = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).fileupload(__WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()(defaultOptions, this.options));

      var _loop = function _loop(event) {
        uploader.bind(event, function (e, data) {
          _this.$emit(event, data);
        });
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(uploaderEvents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var event = _step.value;

          _loop(event);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    destroy: function destroy() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).off().fileupload().fileupload('destroy');
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_loader_components_Loader__ = __webpack_require__(8);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_10__modules_loader_components_Loader__["a" /* default */] },
  data: function data() {
    return {
      user: {
        username: null,
        password: null
      },
      disabled: false,
      loaded: true
    };
  },

  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('login.labels.login')
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['isClient'])),
  methods: {
    login: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, isSaved, response, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, _ref3, message;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disabled = true;
                this.loaded = false;
                this.errors.clear();
                _context.next = 5;
                return this.$validator.validateAll();

              case 5:
                result = _context.sent;

                if (result) {
                  _context.next = 10;
                  break;
                }

                this.loaded = true;
                this.disabled = false;
                return _context.abrupt('return');

              case 10:
                _context.prev = 10;
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__common_auth_Manager__["a" /* default */].login(this.user.username, this.user.password);

              case 13:
                isSaved = _context.sent;

                this.isClient ? this.$router.push({ name: 'available-protocols' }) : this.$router.push({ name: 'client' });
                _context.next = 46;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](10);
                response = _context.t0.response;
                errors = response.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isObject___default()(errors)) {
                  _context.next = 45;
                  break;
                }

                if (!errors.message) {
                  _context.next = 26;
                  break;
                }

                this.errors.add('server', errors.message);
                _context.next = 45;
                break;

              case 26:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 29;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  _ref3 = errors[key].message ? errors[key] : errors[key][0], message = _ref3.message;

                  this.errors.add(key, message);
                }
                _context.next = 37;
                break;

              case 33:
                _context.prev = 33;
                _context.t1 = _context['catch'](29);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 37:
                _context.prev = 37;
                _context.prev = 38;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 40:
                _context.prev = 40;

                if (!_didIteratorError) {
                  _context.next = 43;
                  break;
                }

                throw _iteratorError;

              case 43:
                return _context.finish(40);

              case 44:
                return _context.finish(37);

              case 45:

                this.disabled = false;

              case 46:
                _context.prev = 46;

                this.loaded = true;
                return _context.finish(46);

              case 49:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 17, 46, 49], [29, 33, 37, 45], [38,, 40, 44]]);
      }));

      function login() {
        return _ref.apply(this, arguments);
      }

      return login;
    }()

  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'messages': {
      type: String,
      default: function _default() {
        return 'home.labels.loading_message';
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        username: null
      },
      disabled: false,
      submittedForBcba: false,
      submittedForUser: false,
      responseHashError: null
    };
  },

  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_2__lang_translator__["a" /* default */].get('login.labels.forgot')
  },
  methods: {
    send: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var result, isSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disabled = true;
                _context.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (result) {
                  _context.next = 7;
                  break;
                }

                this.disabled = false;
                return _context.abrupt('return');

              case 7:
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/auth/password/forgot', this.user).then(function (response) {
                  _this.responseHashError = null;
                  _this.user.username = null;
                  var userType = response.data.data.userType;
                  if (userType == 'bcba') {
                    _this.submittedForBcba = true;
                  }
                  if (userType == 'user') {
                    _this.submittedForUser = true;
                  }
                }).catch(function (error) {
                  _this.responseHashError = error.data.message;
                  _this.disabled = false;
                });

              case 9:
                isSaved = _context.sent;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send() {
        return _ref.apply(this, arguments);
      }

      return send;
    }()
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'token': {
      required: true,
      type: String
    }
  },
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('login.labels.forgot')
  },
  data: function data() {
    return {
      user: {
        username: null,
        password: null,
        password_confirmation: null
      },
      disabled: false,
      submitted: false,
      responseHashError: null
    };
  },

  methods: {
    register: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var result, isSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disabled = true;
                this.errors.remove('server');
                _context.next = 4;
                return this.$validator.validateAll();

              case 4:
                result = _context.sent;

                if (result) {
                  _context.next = 8;
                  break;
                }

                this.disabled = false;
                return _context.abrupt('return');

              case 8:
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/auth/password/reset', __WEBPACK_IMPORTED_MODULE_2_lodash_merge___default()(this.user, { token: this.token })).then(function (response) {
                  _this.responseHashError = null;
                  _this.submitted = true;
                }).catch(function (error) {
                  _this.responseHashError = error.data.errors.username ? error.data.errors.username.message : error.data.errors.message;
                  _this.disabled = false;
                });

              case 10:
                isSaved = _context.sent;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function register() {
        return _ref.apply(this, arguments);
      }

      return register;
    }()
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: null,
        email: null,
        message: null,
        captcha: null,
        captcha_key: null
      },
      image: null,
      loaded: false,
      disabled: false,
      submitted: false
    };
  },

  components: { Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */] },
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('contact_us.header')
  },
  methods: {
    send: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, isSaved, response, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, message;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.disabled = true;
                _context.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (result) {
                  _context.next = 7;
                  break;
                }

                this.disabled = false;
                return _context.abrupt('return');

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('/contact-us', this.form);

              case 10:
                isSaved = _context.sent;

                this.submitted = true;
                _context.next = 43;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](7);
                response = _context.t0.response;
                errors = response.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default()(errors)) {
                  _context.next = 42;
                  break;
                }

                if (!errors.message) {
                  _context.next = 23;
                  break;
                }

                this.errors.add('server', errors.message);
                _context.next = 42;
                break;

              case 23:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 26;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  message = errors[key].message;

                  this.errors.add(key, message);
                }
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t1 = _context['catch'](26);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 34:
                _context.prev = 34;
                _context.prev = 35;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 37:
                _context.prev = 37;

                if (!_didIteratorError) {
                  _context.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context.finish(37);

              case 41:
                return _context.finish(34);

              case 42:
                this.disabled = false;

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 14], [26, 30, 34, 42], [35,, 37, 41]]);
      }));

      function send() {
        return _ref.apply(this, arguments);
      }

      return send;
    }()
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/contact-us/captcha');

            case 2:
              response = _context2.sent;
              data = response.data.data;

              _this.image = data.img;
              _this.form.captcha_key = data.key;
              _this.loaded = true;

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isGuest']))
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardMenu__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DefaultLayout',

  components: {
    DashboardMenu: __WEBPACK_IMPORTED_MODULE_2__DashboardMenu__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isClient']))
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboardModal_components_requestHelpModal__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_components_AddModal_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appeals_components_AddModal_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboardModal_components_sendCommentModal__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboardModal_components_droModal__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dro_api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dro_components_CurrentIntervalFormMenu__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dro_components_ReportModal__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboardModal_components_protocolModal__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardMenu',
  props: {
    'clientData': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'hideDroModal': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'checkHasAccess': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'checkedHasAccess': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      isOpenMDCMenu: false,
      isModalVisible: false,
      isBehaviorModalVisible: false,
      isRequestModalVisible: false,
      isCommentModalVisible: false,
      isDroModalVisible: false,
      isModalReportVisible: false,
      isProtocolModalVisible: false,
      userClientId: null,
      isSettingsSet: false,
      hasAccess: true,
      modal: {
        data: {},
        clientId: ''
      },
      dashboardProtocolList: [],
      protocolId: null,
      currentProtocolId: null,
      apiClientUrl: '/users/clients/',
      client: null
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_11__common_mixins_showModal__["a" /* showModal */]],

  components: {
    requestHelpModal: __WEBPACK_IMPORTED_MODULE_3__dashboardModal_components_requestHelpModal__["a" /* default */],
    undesirableBehaviorModal: __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_components_AddModal_vue__["a" /* default */],
    writeAppealsModal: __WEBPACK_IMPORTED_MODULE_5__appeals_components_AddModal_vue__["a" /* default */],
    sendCommentModal: __WEBPACK_IMPORTED_MODULE_6__dashboardModal_components_sendCommentModal__["a" /* default */],
    droModal: __WEBPACK_IMPORTED_MODULE_7__dashboardModal_components_droModal__["a" /* default */],
    CurrentIntervalFormMenu: __WEBPACK_IMPORTED_MODULE_12__dro_components_CurrentIntervalFormMenu__["a" /* default */],
    ReportModal: __WEBPACK_IMPORTED_MODULE_13__dro_components_ReportModal__["a" /* default */],
    protocolModal: __WEBPACK_IMPORTED_MODULE_14__dashboardModal_components_protocolModal__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])('dro/session', ['assignee', 'isSessionStarted']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('dro/session', ['shouldSessionBeSaved', 'saveSessionData']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden', 'isPreviousDateSession']), {
    isCurrentIntervalShow: function isCurrentIntervalShow() {
      var id = this.clientId ? this.clientId : this.userClientId;

      var isIntervalEnable = this.assignee.id == id && this.isSessionStarted && !this.hideDroModal;
      this.setIntervalEnable(isIntervalEnable);
      return isIntervalEnable;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isTherapist'])),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('dro/session', ['setIsSessionStarted', 'setIntervalEnable']), {

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                this.loaded = true;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.info(_context.t0);
                this.loaded = true;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }(),

    checkAccess: function checkAccess() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var that, id, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this;

                if (!_this.isClient) {
                  _context2.next = 5;
                  break;
                }

                _this.hasAccess = false;
                _context2.next = 22;
                break;

              case 5:
                if (!_this.isTherapist) {
                  _context2.next = 22;
                  break;
                }

                _this.hasAccess = false;

                if (_this.checkedHasAccess) {
                  _context2.next = 21;
                  break;
                }

                _context2.prev = 8;
                id = _this.clientId ? _this.clientId : _this.userClientId;
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_8__dro_api_Manager__["a" /* default */].hasAccess(id);

              case 12:
                response = _context2.sent;

                if (response && response.data) {
                  if (response.data.data.hasAccess) {
                    _this.hasAccess = true;
                  }
                }
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](8);

                console.error(_context2.t0);

              case 19:
                _context2.next = 22;
                break;

              case 21:
                _this.hasAccess = _this.checkHasAccess;

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[8, 16]]);
      }))();
    },
    getProtocolsList: function getProtocolsList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var id, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this2.isClient) {
                  _context3.next = 12;
                  break;
                }

                _context3.prev = 1;
                id = _this2.clientId ? _this2.clientId : _this2.userClientId;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__dro_api_Manager__["a" /* default */].getDashboardProtocol(id);

              case 5:
                response = _context3.sent;

                if (response && response.data) {
                  _this2.dashboardProtocolList = response.data.data;
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](1);

                console.error(_context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[1, 9]]);
      }))();
    },
    dashboardProtocolClick: function dashboardProtocolClick(id) {
      this.modal.clientId = this.clientId || this.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
      this.isOpenMDCMenu = false;
      this.protocolId = id;
      this.isProtocolModalVisible = true;
    },
    onHelpModalBtnClick: function onHelpModalBtnClick() {
      this.modal.clientId = this.clientId || this.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
      this.isModalVisible = true;
      this.isOpenMDCMenu = false;
    },
    onBehaviorModalBtnClick: function onBehaviorModalBtnClick() {
      this.modal.clientId = this.clientId || this.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
      this.isBehaviorModalVisible = true;
      this.isOpenMDCMenu = false;
    },
    onRequestModalBtnClick: function onRequestModalBtnClick() {
      this.modal.clientId = this.clientId || this.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
      this.isRequestModalVisible = true;
      this.isOpenMDCMenu = false;
    },
    onCommentModalBtnClick: function onCommentModalBtnClick() {
      this.modal.clientId = this.clientId || this.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
      this.isCommentModalVisible = true;
      this.isOpenMDCMenu = false;
    },
    onDROModalBtnClick: function onDROModalBtnClick() {
      this.isOpenMDCMenu = false;
      this.modal.clientId = this.clientId ? this.clientId : this.route.params.clientId;
      if (this.isCurrentIntervalShow) {
        this.$router.push({ name: 'dro-session', params: {
            clientId: this.modal.clientId
          } });
      } else {
        this.isDroModalVisible = true;
      }
      this.isOpen = false;
    },
    hideMdcMenu: function hideMdcMenu() {
      this.isOpenMDCMenu = false;
    },
    onBehaviorModalClose: function onBehaviorModalClose() {
      this.isBehaviorModalVisible = false;
    },
    onRequestModalClose: function onRequestModalClose() {
      this.isRequestModalVisible = false;
    },
    onCommentModalClose: function onCommentModalClose() {
      this.isCommentModalVisible = false;
    },
    onBehaviorModalCancel: function onBehaviorModalCancel() {
      this.isBehaviorModalVisible = false;
    },
    onDroModalClose: function onDroModalClose() {
      this.isDroModalVisible = false;
      this.isSettingsSet = true;
    },
    onProtocolModalClose: function onProtocolModalClose() {
      this.isProtocolModalVisible = false;
    },
    onReportModalClose: function onReportModalClose() {
      this.isModalReportVisible = false;
    },
    onSaveSession: function onSaveSession() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var id, that, _ref2, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.processing = true;
                id = _this3.clientId ? _this3.clientId : _this3.userClientId;
                that = _this3;

                if (!_this3.shouldSessionBeSaved) {
                  _context4.next = 17;
                  break;
                }

                if (!that.saveSessionData.assigneeId) {
                  that.saveSessionData.assigneeId = id;
                }
                _context4.prev = 5;
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__dro_api_Manager__["a" /* default */].save(that.saveSessionData);

              case 8:
                _ref2 = _context4.sent;
                response = _ref2.data;

                if (response && response.data && response.data.id) {
                  _context4.next = 12;
                  break;
                }

                throw new Error('Session wasn\'t saved');

              case 12:
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](5);
                throw new Error('Unknown API error');

              case 17:
                _this3.isModalReportVisible = true;
                _this3.setIsSessionStarted(false);
                _this3.processing = false;

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[5, 14]]);
      }))();
    }
  }),
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this4.userClientId = _this4.clientId || _this4.route.params.clientId || __WEBPACK_IMPORTED_MODULE_9__common_auth_Manager__["a" /* default */].getUserInfo().id;
              _this4.currentProtocolId = _this4.route.params.protocolId;
              _this4.checkAccess();
              _this4.getProtocolsList();

              if (!_this4.clientData) {
                _this4.getClient(_this4.userClientId);
              } else {
                _this4.client = _this4.clientData;
              }

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.setIntervalEnable(false);
  },


  watch: {
    isOpenMDCMenu: function isOpenMDCMenu(newValue) {
      if (newValue) {
        this.getProtocolsList();
      }
    }
  }

});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'requestHelpModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onSendRequestButtonClick: function onSendRequestButtonClick() {
      this.validate();
    },
    sendRequest: function sendRequest(apiManager, clientId) {
      try {
        this.close();
      } catch (e) {
        console.error('Unknown API error occurred.');
      }
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    close: function close() {
      this.$emit('close');
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_undesirableBehavior__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_trim__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'undesirableBehaviorAddModal',
  props: {
    'clientData': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      typicalAncedent: [],
      typicalBehavior: [],
      typicalConsequenceInBehavior: [],
      typicalEffect: [],
      newTypicalAncedent: {
        text: '',
        id: null
      },
      newTypicalBehavior: {
        text: '',
        id: null
      },
      newTypicalConsequenceInBehavior: {
        text: '',
        id: null
      },
      newTypicalEffect: {
        text: '',
        id: null
      },
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },
    isAllValidated: function isAllValidated() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(this.typicalAncedent, ['selected', true]) >= 0 && __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(this.typicalBehavior, ['selected', true]) >= 0 && __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(this.typicalEffect, ['selected', true]) >= 0;
    },
    selectedBehaviorLenght: function selectedBehaviorLenght() {
      return __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(this.typicalBehavior, ['selected', true]).length;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])('behavior', ['typicalBehaviors']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])('appeals', ['entity']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration', 'isClient'])),
  created: function created() {
    if (this.clientId) {
      this.setTypesBehaviors(this.clientId);
    }
  },
  mounted: function mounted() {
    /*if (!this.uiid){
      this.uiid = UuidGenerator.v4()
      let entity = {
        id: this.uiid,
        type: 'assigned-session',
      };
       this.setEntity(entity);
    }*/

    if (!(this.$route.name === 'current-stage' || this.$route.name === 'mand-stage-current' || this.$route.name === 'chain-stage-current' || this.$route.name === 'shaping-stage-current' || this.$route.name === 'mastering-stage' || this.$route.name === 'rotation-stage' || this.$route.name === 'fluency-stage' || this.$route.name === 'maintain-stage' || this.$route.name === 'pecs-stage' || this.$route.name === 'pecs-stage-without-discrimination' || this.$route.name === 'mastering-stage-usd' || this.$route.name === 'pecs-with-discrimination-stage' || this.$route.name === 'pecs-with-items-stage' || this.$route.name === 'maintain-stage-usd')) {

      this.setEntity({});
    }
  },
  beforeDestroy: function beforeDestroy() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('behavior', ['setIsAdded', 'setTypesBehaviors']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {
    currentDate: function currentDate() {
      var clientTimeZoneOffset = this.clientData ? __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone)._offset : 0;
      var createdAt = Math.round(new Date().getTime() / 1000);
      if (this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm) {
        createdAt = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_13_moment___default()(new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm))).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].SECONDS_PER_MINUTE : Math.round(new Date().getTime() / 1000);
      }
      return createdAt;
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, tempTypicalAncedents, tempTypicalBehaviors, tempTypicalConsequenceInBehavior, tempTypicalEffects, createdAt, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;
                _this.errors.clear();

                _context.next = 4;
                return _this.$validator.validateAll();

              case 4:
                result = _context.sent;

                if (!(result && _this.isAllValidated)) {
                  _context.next = 28;
                  break;
                }

                tempTypicalAncedents = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this.typicalAncedent);
                tempTypicalBehaviors = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this.typicalBehavior);
                tempTypicalConsequenceInBehavior = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this.typicalConsequenceInBehavior);
                tempTypicalEffects = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this.typicalEffect);
                _context.prev = 10;

                _this.disabled = true;

                createdAt = _this.currentDate();
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_4__api_undesirableBehavior__["a" /* default */].create(_this.clientId, tempTypicalAncedents, tempTypicalBehaviors, tempTypicalEffects, tempTypicalConsequenceInBehavior, _this.entity, createdAt);

              case 15:
                response = _context.sent;

                _this.setIsAdded(true);
                _this.setTypesBehaviors(_this.clientId);
                _this.close();
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](10);

                console.dir(_context.t0);

              case 24:
                _context.prev = 24;
                return _context.finish(24);

              case 26:
                _context.next = 32;
                break;

              case 28:
                _this.disabled = false;
                if (__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(_this.typicalAncedent, ['selected', true]) < 0) {
                  _this.errors.add({
                    field: 'isEmptyErrorAncedent',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_ancedent')
                  });
                }
                if (__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(_this.typicalBehavior, ['selected', true]) < 0) {
                  _this.errors.add({
                    field: 'isEmptyErrorBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_behavior')
                  });
                }
                if (__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(_this.typicalEffect, ['selected', true]) < 0) {
                  _this.errors.add({
                    field: 'isEmptyErrorEffect',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_aftermath')
                  });
                }

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[10, 21, 24, 26]]);
      }))();
    },
    addAncedent: function addAncedent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, uniqueCounter, i, createdAt, newAncedent;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.typicalAncedent.length < __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;


                if (result && _this2.newTypicalAncedent.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.typicalAncedent).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(_this2.typicalAncedent[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(_this2.newTypicalAncedent.text.toLowerCase())) {
                      uniqueCounter++;
                      _this2.newTypicalAncedent.text = '';

                      _this2.$nextTick(function () {
                        if (_this2.isMobile) {
                          $('.mdc-dialog').animate({ scrollTop: $(".radio-btn.active").offset().top - 10 }, 500);
                        }
                      });
                    }
                  }

                  if (uniqueCounter === 0) {
                    createdAt = _this2.currentDate();
                    newAncedent = {
                      id: null,
                      index: __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      text: _this2.newTypicalAncedent.text,
                      selected: true,
                      createdAt: createdAt
                    };

                    _this2.typicalAncedent.push(newAncedent);
                    _this2.newTypicalAncedent.text = '';
                  }
                } else if (_this2.newTypicalAncedent.text == '') {
                  _this2.errors.add({
                    field: 'isEmptyErrorAncedent',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_ancedent')
                  });
                }
                _context2.next = 8;
                break;

              case 7:
                _this2.errors.add({
                  field: 'isMaxLengthAncedent',
                  msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.maxlength_ancedent')
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addBehavior: function addBehavior() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, uniqueCounter, i, createdAt, newBehavior;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.typicalBehavior.length < __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH && _this3.selectedBehaviorLenght === 0)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return _this3.$validator.validateAll();

              case 3:
                result = _context3.sent;


                if (result && _this3.newTypicalBehavior.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.typicalBehavior).length; i++) {
                    if (_this3.typicalBehavior[i].text.toLowerCase() === _this3.newTypicalBehavior.text.toLowerCase()) {
                      uniqueCounter++;
                      _this3.newTypicalBehavior.text = '';

                      _this3.$nextTick(function () {
                        if (_this3.isMobile) {
                          $('.mdc-dialog').animate({ scrollTop: $(".radio-btn.active").offset().top - 10 }, 500);
                        }
                      });
                    }
                  }

                  if (uniqueCounter === 0) {
                    createdAt = _this3.currentDate();
                    newBehavior = {
                      id: null,
                      index: __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      text: _this3.newTypicalBehavior.text,
                      selected: true,
                      createdAt: createdAt
                    };

                    _this3.typicalBehavior.push(newBehavior);
                    _this3.newTypicalBehavior.text = '';
                  }
                } else if (_this3.newTypicalBehavior.text == '') {
                  _this3.errors.add({
                    field: 'isEmptyErrorBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_behavior')
                  });
                }
                _context3.next = 8;
                break;

              case 7:
                if (_this3.typicalBehavior.length >= __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH) {
                  _this3.errors.add({
                    field: 'isMaxLengthBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.maxlength_behaviors')
                  });
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addEffect: function addEffect() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result, uniqueCounter, i, createdAt, newEffect;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.typicalEffect.length < __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 3;
                return _this4.$validator.validateAll();

              case 3:
                result = _context4.sent;


                if (result && _this4.newTypicalEffect.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.typicalEffect).length; i++) {
                    if (_this4.typicalEffect[i].text.toLowerCase() === _this4.newTypicalEffect.text.toLowerCase()) {
                      uniqueCounter++;
                      _this4.newTypicalEffect.text = '';

                      _this4.$nextTick(function () {
                        if (_this4.isMobile) {
                          $('.mdc-dialog').animate({ scrollTop: $(".radio-btn.active").offset().top - 10 }, 500);
                        }
                      });
                    }
                  }

                  if (uniqueCounter === 0) {
                    createdAt = _this4.currentDate();
                    newEffect = {
                      id: null,
                      index: __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      text: _this4.newTypicalEffect.text,
                      selected: true,
                      createdAt: createdAt
                    };

                    _this4.typicalEffect.push(newEffect);
                    _this4.newTypicalEffect.text = '';
                  }
                } else if (_this4.newTypicalEffect.text === '') {
                  _this4.errors.add({
                    field: 'isEmptyErrorEffect',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_aftermath')
                  });
                }
                _context4.next = 8;
                break;

              case 7:
                _this4.errors.add({
                  field: 'isMaxLengthEffect',
                  msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.maxlength_aftermath')
                });

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addConsequenceInBehavior: function addConsequenceInBehavior() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result, uniqueCounter, i, createdAt, newConsequenceInBehavior;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.typicalConsequenceInBehavior.length < __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 3;
                return _this5.$validator.validateAll();

              case 3:
                result = _context5.sent;


                if (result && _this5.newTypicalConsequenceInBehavior.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this5.typicalConsequenceInBehavior).length; i++) {
                    if (_this5.typicalConsequenceInBehavior[i].text.toLowerCase() === _this5.newTypicalConsequenceInBehavior.text.toLowerCase()) {
                      uniqueCounter++;
                      _this5.newTypicalConsequenceInBehavior.text = '';

                      _this5.$nextTick(function () {
                        if (_this5.isMobile) {
                          $('.mdc-dialog').animate({ scrollTop: $(".radio-btn.active").offset().top - 10 }, 500);
                        }
                      });
                    }
                  }

                  if (uniqueCounter === 0) {
                    createdAt = _this5.currentDate();
                    newConsequenceInBehavior = {
                      id: null,
                      index: __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      text: _this5.newTypicalConsequenceInBehavior.text,
                      selected: true,
                      createdAt: createdAt
                    };

                    _this5.typicalConsequenceInBehavior.push(newConsequenceInBehavior);
                    _this5.newTypicalConsequenceInBehavior.text = '';
                  }
                } else if (_this5.newTypicalConsequenceInBehavior.text === '') {
                  _this5.errors.add({
                    field: 'isEmptyErrorConsequenceInBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.need_choice_aftermath')
                  });
                }
                _context5.next = 8;
                break;

              case 7:
                _this5.errors.add({
                  field: 'isMaxLengthConsequenceInBehavior',
                  msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('behavior.maxlength_aftermath')
                });

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    setActiveAncedent: function setActiveAncedent(ancedent) {
      var ancedents = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalAncedent);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(ancedents, function (item) {
        if (item.index == ancedent.index) {
          item.selected = !item.selected;
        }
      });
      this.typicalAncedent = ancedents;
    },
    setActiveBehavior: function setActiveBehavior(behavior) {
      var behaviors = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehavior);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(behaviors, function (item) {
        if (item.index == behavior.index) {
          item.selected = !item.selected;
        } else {
          item.selected = false;
        }
      });
      this.typicalBehavior = behaviors;
    },
    setActiveEffect: function setActiveEffect(effect) {
      var effects = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalEffect);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(effects, function (item) {
        if (item.index == effect.index) {
          item.selected = !item.selected;
        }
      });
      this.typicalEffect = effects;
    },
    setActiveConsequenceInBehavior: function setActiveConsequenceInBehavior(consequenceInBehavior) {
      var consequenceInBehaviors = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalConsequenceInBehavior);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(consequenceInBehaviors, function (item) {
        if (item.index == consequenceInBehavior.index) {
          item.selected = !item.selected;
        }
      });
      this.typicalConsequenceInBehavior = consequenceInBehaviors;
    },
    reset: function reset() {
      var _this6 = this;

      this.typicalAncedent = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.antecedentTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalAncedent, function (item) {
        item.selected = false;
        if (item.createdAt) {

          var convertDate = _this6.currentDate();
          item.createdAt = convertDate;
        }
      });
      this.typicalBehavior = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.behaviorTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalBehavior, function (item) {
        item.selected = false;
        if (item.createdAt) {
          var convertDate = _this6.currentDate();
          item.createdAt = convertDate;
        }
      });
      this.typicalEffect = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.effectsTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalEffect, function (item) {
        item.selected = false;
        if (item.createdAt) {
          var convertDate = _this6.currentDate();
          item.createdAt = convertDate;
        }
      });

      this.typicalConsequenceInBehavior = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.consequenceInBehaviorTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalConsequenceInBehavior, function (item) {
        item.selected = false;
        if (item.createdAt) {
          var convertDate = _this6.currentDate();
          item.createdAt = convertDate;
        }
      });
      this.errors.clear();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    },
    cancel: function cancel() {
      this.reset();
      this.$emit('cancel');
    }
  }),
  watch: {
    typicalBehaviors: function typicalBehaviors() {
      var _this7 = this;

      this.typicalAncedent = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.antecedentTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalAncedent, function (item) {
        item.selected = false;
        item.index = item.id;
        if (item.createdAt) {
          var convertDate = _this7.currentDate();
          item.createdAt = convertDate;
        }
      });
      this.typicalBehavior = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.behaviorTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalBehavior, function (item) {
        item.selected = false;
        item.index = item.id;
        if (item.createdAt) {
          var convertDate = _this7.currentDate();
          item.createdAt = convertDate;
        }
      });
      this.typicalEffect = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.effectsTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalEffect, function (item) {
        item.selected = false;
        item.index = item.id;
        if (item.createdAt) {
          var convertDate = _this7.currentDate();
          item.createdAt = convertDate;
        }
      });

      this.typicalConsequenceInBehavior = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalBehaviors.consequenceInBehaviorTypes);
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.typicalConsequenceInBehavior, function (item) {
        item.selected = false;
        item.index = item.id;
        if (item.createdAt) {
          var convertDate = _this7.currentDate();
          item.createdAt = convertDate;
        }
      });
    },
    clientId: function clientId() {
      this.setTypesBehaviors(this.clientId);
    }
  }
});

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bab7fb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__ = __webpack_require__(994);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bab7fb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_appeals__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Constants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appealsAddModal',
  props: {
    'clientData': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      typicalAppealsTemp: [],
      newAppeal: {
        text: '',
        id: null
      },
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])('appeals', ['typicalAppeals', 'entity']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration'])),
  created: function created() {
    if (this.clientId) {
      this.setTypesAppeals(this.clientId);
    }
  },
  mounted: function mounted() {
    /*if (!this.uiid){
      this.uiid = UuidGenerator.v4()
      let entity = {
        id: this.uiid,
        type: 'assigned-session',
      };
       this.setEntity(entity);
    }*/

    if (!(this.$route.name === 'current-stage' || this.$route.name === 'mand-stage-current' || this.$route.name === 'chain-stage-current' || this.$route.name === 'shaping-stage-current' || this.$route.name === 'mastering-stage' || this.$route.name === 'rotation-stage' || this.$route.name === 'fluency-stage' || this.$route.name === 'maintain-stage' || this.$route.name === 'mastering-stage-usd' || this.$route.name === 'pecs-stage' || this.$route.name === 'pecs-stage-without-discrimination' || this.$route.name === 'pecs-with-discrimination-stage' || this.$route.name === 'pecs-with-items-stage' || this.$route.name === 'maintain-stage-usd')) {

      this.setEntity({});
    }
  },
  beforeDestroy: function beforeDestroy() {},


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('appeals', ['setIsAdded', 'setTypesAppeals', 'setEntity']), {
    currentDate: function currentDate() {
      var clientTimeZoneOffset = this.clientData ? __WEBPACK_IMPORTED_MODULE_14_moment___default()().tz(this.clientData.timezone)._offset : 0;
      var createdAt = Math.round(new Date().getTime() / 1000);
      if (this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm) {
        createdAt = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_14_moment___default()(new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm))).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__Constants__["a" /* default */].SECONDS_PER_MINUTE : Math.round(new Date().getTime() / 1000);
      }
      return createdAt;
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, tempTypicalAppeals, createdAt, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errors.clear();

                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!(result && __WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default()(_this.typicalAppealsTemp, ['selected', true]) >= 0)) {
                  _context.next = 25;
                  break;
                }

                tempTypicalAppeals = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this.typicalAppealsTemp);
                _context.prev = 6;

                _this.disabled = true;

                createdAt = _this.currentDate();
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5__api_appeals__["a" /* default */].create(_this.clientId, tempTypicalAppeals, _this.entity, createdAt);

              case 11:
                response = _context.sent;

                _this.setIsAdded(true);
                _this.setTypesAppeals(_this.clientId);
                _this.close();
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](6);

                console.dir(_context.t0);

              case 20:
                _context.prev = 20;

                _this.disabled = false;
                return _context.finish(20);

              case 23:
                _context.next = 26;
                break;

              case 25:
                if (__WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default()(_this.typicalAppealsTemp, ['selected', true]) < 0) {
                  _this.errors.add({
                    field: 'isEmptyError',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('appeals.need_choice_appeal')
                  });
                }

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 17, 20, 23]]);
      }))();
    },
    addAppeal: function addAppeal() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var createdAt, result, uniqueCounter, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, typicalTypicalAppeal, newAppeal;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                createdAt = _this2.currentDate();

                if (!(_this2.typicalAppealsTemp.length < __WEBPACK_IMPORTED_MODULE_10__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context2.next = 34;
                  break;
                }

                _context2.next = 4;
                return _this2.$validator.validateAll();

              case 4:
                result = _context2.sent;

                if (!(result && _this2.newAppeal.text !== '')) {
                  _context2.next = 31;
                  break;
                }

                _this2.disabled = true;
                uniqueCounter = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 11;


                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.typicalAppealsTemp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  typicalTypicalAppeal = _step.value;

                  if (__WEBPACK_IMPORTED_MODULE_9_lodash_trim___default()(typicalTypicalAppeal.text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_9_lodash_trim___default()(_this2.newAppeal.text.toLowerCase())) {
                    uniqueCounter++;
                    _this2.newAppeal.text = '';

                    _this2.$nextTick(function () {
                      if (_this2.isMobile) {
                        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.mdc-dialog').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_4_jquery___default()(".radio-btn.active").offset().top - 10 }, 500);
                      }
                    });
                  }
                }

                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 22:
                _context2.prev = 22;

                if (!_didIteratorError) {
                  _context2.next = 25;
                  break;
                }

                throw _iteratorError;

              case 25:
                return _context2.finish(22);

              case 26:
                return _context2.finish(19);

              case 27:
                if (uniqueCounter === 0) {
                  newAppeal = {
                    id: null,
                    index: Math.random(),
                    text: _this2.newAppeal.text,
                    selected: true,
                    createdAt: createdAt
                  };

                  _this2.typicalAppealsTemp.push(newAppeal);
                  _this2.newAppeal.text = '';
                }
                _this2.disabled = false;
                _context2.next = 32;
                break;

              case 31:
                if (_this2.newAppeal.text == '') {
                  _this2.errors.add({
                    field: 'isEmptyError',
                    msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('appeals.type_new_appeal')
                  });
                }

              case 32:
                _context2.next = 35;
                break;

              case 34:
                _this2.errors.add({
                  field: 'isMaxLengthAppeals',
                  msg: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('appeals.maxlength_appeals')
                });

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[11, 15, 19, 27], [20,, 22, 26]]);
      }))();
    },
    setActiveAppeal: function setActiveAppeal(appeal) {
      var attempts = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalAppealsTemp);

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(attempts, function (item) {
        if (item.index == appeal.index) {
          item.selected = !item.selected;
        }
      });

      this.typicalAppealsTemp = attempts;
    },
    reset: function reset() {
      var _this3 = this;

      this.typicalAppealsTemp = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalAppeals);
      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalAppealsTemp, function (item) {
        item.index = item.id;
        item.selected = false;
        var convertDate = _this3.currentDate();
        item.createdAt = convertDate;
      });
      this.errors.clear();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    },
    cancel: function cancel() {
      this.reset();
      this.$emit('cancel');
    }
  }),
  watch: {
    typicalAppeals: function typicalAppeals() {
      var _this4 = this;

      this.typicalAppealsTemp = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalAppeals);

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalAppealsTemp, function (item, index) {
        item.selected = false;
        item.index = item.id;
        var convertDate = _this4.currentDate();
        item.createdAt = convertDate;
      });
    },
    clientId: function clientId() {
      this.setTypesAppeals(this.clientId);
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sendCommentModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onSendRequestButtonClick: function onSendRequestButtonClick() {
      this.validate();
    },
    sendRequest: function sendRequest(apiManager, clientId) {
      try {
        this.close();
      } catch (e) {
        console.error('Unknown API error occurred.');
      }
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    close: function close() {
      this.$emit('close');
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loadDroInitData__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dro_components_SettingsForm__ = __webpack_require__(465);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'droModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loadDroInitData__["a" /* loadDroInitData */]],
  data: function data() {
    return {
      disabled: false,
      modalView: true
    };
  },

  components: {
    SettingsForm: __WEBPACK_IMPORTED_MODULE_4__dro_components_SettingsForm__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    close: function close() {
      this.$emit('close');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('dro/session', ['setSettings', 'setStartedAt'])),

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('dro/session', ['settings', 'assignee', 'isSessionStarted']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  })

});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadDroInitData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dro_api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dro_Constants__ = __webpack_require__(80);










var loadDroInitData = {
  data: function data() {
    return {
      loaded: false,
      sessionData: {},
      form: {},
      modalView: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('dro/session', ['setSettings', 'setAuditor', 'setAssignee', 'setUuid', 'clearSession', 'setIsSessionStarted', 'setShouldStartIntervalAutomatically', 'setStartedAt']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {
    onSessionSettingsSet: function onSessionSettingsSet(settings) {
      this.clearSession();
      this.setIsSessionStarted(true);
      this.setShouldStartIntervalAutomatically(true);
      var _sessionData = this.sessionData,
          auditor = _sessionData.auditor,
          assignee = _sessionData.assignee,
          uuid = _sessionData.uuid,
          entity = _sessionData.entity;

      this.setAuditor(auditor);
      this.setAssignee(assignee);
      this.setSettings(settings);
      this.setUuid(uuid);
      this.setEntity(entity);
      this.setStartedAt(Math.round(new Date().getTime() / 1000));
      this.sessionData = {};
    },
    loadInitialData: function loadInitialData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var clientId, response, _response$data$data, settings, auditor, assignee, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, uuid, entity;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                clientId = _this.clientId ? _this.clientId : _this.route.params.clientId;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__modules_dro_api_Manager__["a" /* default */].getSettings(clientId);

              case 4:
                response = _context.sent;
                _response$data$data = response.data.data, settings = _response$data$data.settings, auditor = _response$data$data.auditor, assignee = _response$data$data.assignee;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(settings)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;

                  if (settings[key]) {
                    settings[key] = settings[key].toString();
                  }
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                uuid = __WEBPACK_IMPORTED_MODULE_7__common_uuid_UuidGenerator__["a" /* default */].v4();
                entity = {
                  id: uuid,
                  type: __WEBPACK_IMPORTED_MODULE_8__modules_dro_Constants__["a" /* default */].ENTITY_TYPE
                };

                _this.sessionData = { auditor: auditor, assignee: assignee, uuid: uuid, entity: entity };
                _this.form = settings || {
                  aimTypeId: '1',
                  behaviourTypeId: '1',
                  intervalDurationValue: null,
                  intervalDurationUnitId: '1',
                  behaviourDescription: ''
                };
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t1 = _context['catch'](0);

                console.error(_context.t1);
                _this.$router.push({ name: 'default' });

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 31], [9, 13, 17, 25], [18,, 20, 24]]);
      }))();
    }
  }),
  computed: {
    isCurrentUserSession: function isCurrentUserSession() {
      var clientId = this.clientId ? this.clientId : this.route.params.clientId;
      return parseInt(clientId) === parseInt(this.assignee.id);
    },
    isCurrentUserStartedSessionBlock: function isCurrentUserStartedSessionBlock() {
      return this.isSessionStarted && this.isCurrentUserSession && !this.modalView;
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!_this2.isSessionStarted || !_this2.isCurrentUserSession)) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return _this2.loadInitialData();

            case 3:
              _this2.loaded = true;

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsForm_vue__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e58862_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsForm_vue__ = __webpack_require__(1003);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e58862_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'modalView': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'settings': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      disabled: false,
      form: {
        aimTypeId: '1',
        behaviourTypeId: '1',
        intervalDurationValue: null,
        intervalDurationUnitId: '1',
        behaviourDescription: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  created: function created() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.settings)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        if (value && this.form.hasOwnProperty(key)) {
          this.form[key] = value;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    startSession: function startSession() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (result) {
                  _context.next = 7;
                  break;
                }

                _this.disabled = false;
                return _context.abrupt('return');

              case 7:
                _this.$emit('session-settings-set', _this.form);
                _this.disabled = false;
                if (_this.modalView) {
                  _this.close();
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_currentIntervalForm__ = __webpack_require__(469);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_currentIntervalForm__["a" /* currentIntervalForm */]],
  data: function data() {
    return {
      scrollY: 0
    };
  },

  computed: {
    isIntervalCompleted: function isIntervalCompleted() {
      var interval = this.currentInterval;
      return interval.current == interval.duration;
    }
  },
  methods: {
    clickPrevent: function clickPrevent(e) {
      e.preventDefault();
    },
    handleIntervalScroll: function handleIntervalScroll() {
      if (window.scrollY < 60) {
        this.scrollY = window.scrollY;
      } else {
        this.scrollY = 60;
      }
    }
  },
  created: function created() {
    var _this = this;

    this.fillFormData();
    this.init();
    if (this.isMobile) {
      window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
        _this.handleIntervalScroll();
      }, 0.1));
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentIntervalForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dro_components_IntervalProgressBar__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dro_Constants__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);








var currentIntervalForm = {
  data: function data() {
    return {
      form: {
        intervalDurationValue: null,
        intervalDurationUnitId: null
      },
      isLoaded: false
    };
  },


  components: { IntervalProgressBar: __WEBPACK_IMPORTED_MODULE_4__modules_dro_components_IntervalProgressBar__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('dro/session', ['settings', 'currentInterval', 'intervals', 'shouldStartIntervalAutomatically', 'uuid']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('dro/session', ['intervalDuration', 'isIntervalStarted'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('dro/session', ['setIntervalDuration', 'setCurrentInterval', 'addInterval', 'setCurrentIntervalTime', 'setCurrentIntervalBehaviourHappenedAt', 'setFinishedAt', 'setCurrentInterval', 'setShouldStartIntervalAutomatically', 'onBehaviourHappened', 'startTimer', 'resetTimer']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    startSession: function startSession() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid, index, duration;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.setIntervalDuration({
                  value: _this.form.intervalDurationValue,
                  unitId: _this.form.intervalDurationUnitId
                });
                if (!_this.isIntervalStarted) {
                  index = _this.intervals.length + 1;
                  duration = _this.intervalDuration;

                  _this.setCurrentInterval({ index: index, duration: duration });
                }
                _this.startTimer();
                _this.isLoaded = true;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    finishSession: function finishSession() {
      this.resetTimer();
      this.setCurrentInterval();
      this.saveSession();
      this.setEntity({});
    },
    saveSession: function saveSession() {
      this.setFinishedAt(Math.round(new Date().getTime() / 1000));
      this.$emit('save-session');
    },
    fillFormData: function fillFormData() {
      this.form.intervalDurationValue = this.settings.intervalDurationValue;
      this.form.intervalDurationUnitId = this.settings.intervalDurationUnitId;
    },
    init: function init() {
      if (this.shouldStartIntervalAutomatically) {
        this.setShouldStartIntervalAutomatically(false);
        this.startSession();
      } else {
        this.isLoaded = true;
      }
      var entity = {
        id: this.uuid,
        type: __WEBPACK_IMPORTED_MODULE_5__modules_dro_Constants__["a" /* default */].ENTITY_TYPE
      };
      this.setEntity(entity);
      console.info(entity);
    }
  })
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('dro/session', ['currentInterval']), {
    current: function current() {
      return this.currentInterval.current;
    },
    max: function max() {
      return this.currentInterval.duration;
    },
    showCompleteMessage: function showCompleteMessage() {
      return this.current >= this.max;
    },
    progress: function progress() {
      return (this.current / this.max * 100).toFixed(2);
    }
  })
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMkg1QzUuNTUgMiA2IDEuNTUgNiAxQzYgMC40NSA1LjU1IDAgNSAwSDFDMC40NSAwIDAgMC40NSAwIDFDMCAxLjU1IDAuNDUgMiAxIDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5IDEpIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMC45OCAwQzAuNDcgMCAwLjA2IDAuMzkgMCAwLjg5TDEuOTggMi44NlYxQzEuOTggMC40NSAxLjUzIDAgMC45OCAwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDIgOCkiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00LjU3IDJDOC40NCAyIDExLjU3IDUuMTMgMTEuNTcgOUMxMS41NyAxMC4xMiAxMS4zIDExLjE4IDEwLjgzIDEyLjEyTDEyLjMgMTMuNTlDMTMuMSAxMi4yNSAxMy41NyAxMC42OCAxMy41NyA5QzEzLjU3IDYuODggMTIuODMgNC45MyAxMS42IDMuMzlMMTIuMzUgMi42NEMxMi43MyAyLjI2IDEyLjc0IDEuNjMgMTIuMzUgMS4yNEwxMi4zNCAxLjIzQzExLjk1IDAuODQgMTEuMzMgMC44NSAxMC45NCAxLjIzTDEwLjE5IDEuOThDOC42NCAwLjc0IDYuNjkgMCA0LjU3IDBDMi45MSAwIDEuMzUgMC40OCAwIDEuMjlMMS40NSAyLjc0QzIuMzkgMi4yNyAzLjQ1IDIgNC41NyAyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy40Mjk5MyA0KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE4LjAyMjUgMTYuNjEyNUwxLjcwMjUgMC4yOTI1QzEuMzEyNSAtMC4wOTc1IDAuNjgyNSAtMC4wOTc1IDAuMjkyNSAwLjI5MjVDLTAuMDk3NSAwLjY4MjUgLTAuMDk3NSAxLjMxMjUgMC4yOTI1IDEuNzAyNUwyLjM2MjUgMy43NzI1QzEuNDQyNSA1LjE1MjUgMC44ODI1IDYuNzYyNSAwLjgzMjUgOC40OTI1QzAuNzAyNSAxMy41NzI1IDQuNzcyNSAxNy43MzI1IDkuODMyNSAxNy43MzI1QzExLjY3MjUgMTcuNzMyNSAxMy4zODI1IDE3LjE4MjUgMTQuODEyNSAxNi4yMzI1TDE2LjYwMjUgMTguMDIyNUMxNi45OTI1IDE4LjQxMjUgMTcuNjIyNSAxOC40MTI1IDE4LjAxMjUgMTguMDIyNUMxOC40MTI1IDE3LjYzMjUgMTguNDEyNSAxNy4wMDI1IDE4LjAyMjUgMTYuNjEyNVpNOS44MzI1IDE1LjczMjVDNS45NjI1IDE1LjczMjUgMi44MzI1IDEyLjYwMjUgMi44MzI1IDguNzMyNUMyLjgzMjUgNy40NDI1IDMuMTgyNSA2LjI0MjUgMy43OTI1IDUuMjEyNUwxMy4zNjI1IDE0Ljc4MjVDMTIuMzIyNSAxNS4zODI1IDExLjEyMjUgMTUuNzMyNSA5LjgzMjUgMTUuNzMyNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMTY3NDggNC4yNjc1OCkiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportModal_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3c04f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportModal_vue__ = __webpack_require__(1012);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3c04f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      disabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('dro/session', ['auditor', 'assignee', 'intervals', 'settings', 'startedAt']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    date: function date() {
      var date = new Date();
      var day = date.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      return day + '.' + month + '.' + date.getFullYear();
    },
    behaviourDescription: function behaviourDescription() {
      return this.settings.behaviourDescription || __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('export.reports.dro.not_specified');
    },
    intervalCount: function intervalCount() {
      return this.intervals.length;
    },
    successfulIntervals: function successfulIntervals() {
      var isAimPresence = parseInt(this.settings.aimTypeId) === __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* default */].AIM_TYPE_PRESENCE;
      return this.intervals.filter(function (interval) {
        return isAimPresence ? interval.behaviourHappenedAt !== null : interval.behaviourHappenedAt === null;
      });
    },
    successfulIntervalCount: function successfulIntervalCount() {
      return this.successfulIntervals.length;
    },
    failedIntervalCount: function failedIntervalCount() {
      return this.intervalCount - this.successfulIntervalCount;
    },
    successRate: function successRate() {
      if (!this.intervalCount) {
        return 0;
      }
      return Math.round(this.successfulIntervalCount / this.intervalCount * 100);
    },
    failRate: function failRate() {
      if (!this.intervalCount) {
        return 0;
      }
      return 100 - this.successRate;
    },
    averageSuccessfulIntervalDuration: function averageSuccessfulIntervalDuration() {
      var totalDuration = this.successfulIntervals.map(function (interval) {
        return interval.behaviourHappenedAt !== null ? interval.behaviourHappenedAt : interval.duration;
      }).reduce(function (sum, duration) {
        return sum + duration;
      }, 0);
      return Math.round(totalDuration / this.successfulIntervalCount);
    }
  }),
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__undesirableBehavior_Constants__ = __webpack_require__(18);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'protocolMandModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientData': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      addMandReactionsItem: null,
      disabled: false,
      modalView: true,
      apiUrl: '/protocols/assigned/mand/',
      loaded: false,
      showMands: false,
      mands: [],
      timerId: null,
      totalAtemptsCount: 0,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      newMands: [],
      title: '',
      stagesList: [],
      currentStage: null,
      protocolData: null
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__["a" /* default */]
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },


    chooseStage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(stageId) {
        var _this = this;

        var response, protocol, mandList;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + stageId);

              case 3:
                response = _context.sent;
                protocol = response.data.data;


                this.title = __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('protocol.title_mand_reaction') + ': ' + this.protocol.shortcutMenuTitle + ' - ' + protocol.description;

                this.currentStage = protocol;
                mandList = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(protocol.globalTasks);


                this.mands = __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(protocol.mands, function (mand) {

                  var currentMand = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(mandList, function (item) {
                    return item.uuid == mand.globalUuid;
                  });

                  if (currentMand.length == 1) {

                    mand.attempt = 0;
                    mand.attepmtsCount = '1';
                    mand.description = currentMand[0].description;
                    var lastAnswers = mand.lastAnswers ? mand.lastAnswers : [];
                    _this.$set(mand, 'lastAnswers', lastAnswers);
                    var lastAnswersCount = mand.lastAnswersCount ? mand.lastAnswersCount : [];
                    _this.$set(mand, 'lastAnswersCount', lastAnswersCount);
                    _this.$set(mand, 'answers', []);
                    mand.recordedReactions = protocol.recordedReactions;
                    delete mand['uuid'];

                    return mand;
                  }
                });

                this.mands = __WEBPACK_IMPORTED_MODULE_9_lodash_sortBy___default()(this.mands, 'position');
                this.showMands = true;

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 16:
                _context.prev = 16;

                this.loaded = true;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13, 16, 19]]);
      }));

      function chooseStage(_x) {
        return _ref.apply(this, arguments);
      }

      return chooseStage;
    }(),

    getProtocols: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.apiUrl + this.protocolId + '/info');

              case 3:
                response = _context2.sent;

                this.protocolData = response.data.data;
                this.protocol = response.data.data.protocol;
                this.title = __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('protocol.title_mand_reaction') + ': ' + this.protocol.shortcutMenuTitle;
                this.stagesList = this.protocol.stages;

                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 13:
                _context2.prev = 13;

                this.loaded = true;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10, 13, 16]]);
      }));

      function getProtocols() {
        return _ref2.apply(this, arguments);
      }

      return getProtocols;
    }(),

    attemptChange: function attemptChange(answer, mand, title) {
      var _this2 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      this.totalAtemptsCount++;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(this.mands, function (item) {
          if (item.globalUuid == mand.globalUuid) {

            item.answers.push(answer);
            item.attempt++;
            item.lastAnswers.push(title);
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount--;
        setTimeout(function () {
          _this2.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        mand.answer = null;
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this3 = this;

      var mands = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.mands);

      __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(mands, function (item) {
        if (item.globalUuid == id) {
          item.answers.pop();
          item.lastAnswers.pop();
          item.attempt--;
          _this3.totalAtemptsCount--;
        }
      });

      setTimeout(function () {
        _this3.mands = mands;
      }, 200);
    },

    saveSession: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this4 = this;

        var isSaved, mandReactions, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                if (this.showMands) {
                  isSaved = void 0;

                  this.loaded = false;
                  this.errors.clear();

                  mandReactions = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.mands);


                  mandReactions = __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(mandReactions, function (mand) {

                    delete mand['recordedReactions'];
                    delete mand['lastAnswers'];
                    delete mand['lastAnswersCount'];
                    return mand;
                  });

                  sessionDate = void 0, timeSessionDate = void 0, timeSessionEndDate = void 0;


                  if (this.isPreviousDateSession) {
                    clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_16_moment___default()().tz(this.clientData.timezone)._offset;

                    sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                    timeSessionDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_17__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                    timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_17__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_17__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  }

                  isSaved = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {
                    'index': this.currentStage.position,
                    'uuid': this.currentStage.uuid,
                    'close': false,
                    'majorVersion': this.protocol.majorVersion,
                    'newMandReactions': this.newMands,
                    'assignedSessions': [{
                      'uuid': __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      'startedAt': this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000), //
                      'finishedAt': this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000),
                      'stimuli': mandReactions,
                      'type': this.currentStage.type
                    }]
                  }).then(function (response) {
                    _this4.close();
                  }).catch(function (error) {
                    if (error.response) {
                      _this4.disabled = false;
                    }
                  });
                } else {
                  this.$emit('close');
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function saveSession() {
        return _ref3.apply(this, arguments);
      }

      return saveSession;
    }(),

    addMands: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(item) {
        var unique, result, uuid;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                unique = true;
                _context4.next = 3;
                return this.$validator.validate();

              case 3:
                result = _context4.sent;

                if (result) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return');

              case 6:

                if (item) {

                  __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(this.currentStage.globalTasks, function (mand) {
                    if (__WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(mand.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(item.toLowerCase())) {
                      unique = false;
                    }
                  });

                  if (unique) {
                    uuid = __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4();


                    this.mands.push({
                      attempt: 0,
                      sessionAnswers: {},
                      globalUuid: uuid,
                      description: item,
                      title: item,
                      answer: null,
                      answers: [],
                      active: true,
                      checked: true,
                      recordedReactions: this.mands[0].recordedReactions,
                      position: 0,
                      lastAnswers: [],
                      attepmtsCount: '1',
                      lastAnswersCount: []
                    });

                    this.newMands.push({
                      globalUuid: uuid,
                      description: item
                    });

                    this.addMandReactionsItem = null;
                    this.errors.clear();
                    this.disabledSave = false;
                  } else {
                    this.errors.add({
                      field: 'addMandReactionsItem',
                      msg: __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('protocol.unique_mand')
                    });
                  }
                } else {
                  this.errors.add({
                    field: 'addMandReactionsItem',
                    msg: __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('protocol.mand_required')
                  });
                }

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addMands(_x2) {
        return _ref4.apply(this, arguments);
      }

      return addMands;
    }()

  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }

  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), {
    minDate: function minDate() {
      return this.protocolData.endDate ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolData && this.protocolData.endDate && this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').unix();
        var sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
        var previous = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix();
        return previous <= protocolDate;
      }

      return true;
    }
  }),

  created: function created() {
    this.currentSesssionDate = Math.round(new Date().getTime() / 1000);

    this.getProtocols();
  }
});

/***/ }),
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_client_components_AssignedProtocolList__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_bids_components_BidsList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_auth_Manager__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'availableProtocol',

  data: function data() {
    return {
      clientId: null,
      onlyList: true
    };
  },


  components: {
    AssignedProtocolList: __WEBPACK_IMPORTED_MODULE_2__user_client_components_AssignedProtocolList__["a" /* default */], BidsList: __WEBPACK_IMPORTED_MODULE_3__modules_bids_components_BidsList__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.clientId = __WEBPACK_IMPORTED_MODULE_4__common_auth_Manager__["a" /* default */].getUserInfo().id;

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedProtocolList_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e62d8544_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedProtocolList_vue__ = __webpack_require__(1032);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedProtocolList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e62d8544_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedProtocolList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProtocolModal__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_mixins_typeMethodProtocol__ = __webpack_require__(1031);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientInfo',
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'onlyList': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'reload': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      protocolUrl: '/protocols/users/',
      assignedUrl: '/protocols/assigned/',
      assignedProtocols: [],
      isLoaded: true,
      isModalVisible: false,
      isDeleteModalVisible: false,
      assignedProtocolId: null,
      isChange: false,
      options: {
        pageHeader: 'assignedProtocols',
        initialPage: null,
        filterable: false,
        sortable: [],
        skin: 'table table-sm',
        withSearch: true,
        columns: [{
          key: 'id',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocols')
        }, {
          key: 'protocols',
          changed: true,
          headings: ''
        }, {
          key: 'title',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocols')
        }, {
          key: 'status',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.status')
        }, {
          key: 'updatedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.change_date')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          console.info(resp);
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.type_the_procol_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          id: 'action-cell',
          title: 'wide-col',
          protocols: 'wide-col',
          status: 'nowrap',
          updatedAt: 'text-center nowrap',
          action: 'table-actions'
        },
        templates: {
          updatedAt: this.updatedAt
        },
        toMomentFormat: ['updatedAt'],
        perPage: 10,
        columnsDisplay: {
          id: 'min_tabletL',
          updatedAt: 'min_tablet',
          protocols: 'min_tabletL',
          title: 'max_tabletP'
        }
      },
      search: '',
      searchSkillField: '',
      sort: '-position',
      errorDeleteMessage: null
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */], __WEBPACK_IMPORTED_MODULE_9__common_mixins_showModal__["a" /* showModal */], __WEBPACK_IMPORTED_MODULE_15__common_mixins_typeMethodProtocol__["a" /* typeProtocol */]],

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */], newProtocolModal: __WEBPACK_IMPORTED_MODULE_8__ProtocolModal__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_12__common_table_components_TableView__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isEmptyProtocols: function isEmptyProtocols() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.assignedProtocols);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['isTherapist', 'isCurator', 'isClient', 'isBCBA', 'isMensurationForbidden', 'isPreviousDateSession'])),

  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentPage');
  },


  methods: {
    activeProtocolList: function activeProtocolList(stages) {
      var activeList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stages, function (stage) {
        return !stage.isClosed;
      });

      return activeList;
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    updatedAt: function updatedAt(h, row) {
      return this.toLocaleDate(row.updatedAt.date);
    },
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.getAssignedProtocols(_this.options.perPage, data.page, _this.clientId, data.query));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    isNew: function isNew(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].NEW;
    },

    isActive: function isActive(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].ACTIVE;
    },

    isIndividualize: function isIndividualize(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION;
    },

    isMaintaining: function isMaintaining(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].MAINTAINING;
    },

    isCompleted: function isCompleted(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].COMPLETED;
    },

    isDTT: function isDTT(protocol) {
      return protocol.protocol.teachingMethod.id === 1;
    },

    isSimple: function isSimple(protocol) {
      return protocol.protocol.teachingMethod.id === 2;
    },

    isMand: function isMand(protocol) {
      return protocol.protocol.teachingMethod.id === 3;
    },

    isUSD: function isUSD(protocol) {
      return protocol.protocol.teachingMethod.id === 4;
    },

    isChain: function isChain(protocol) {
      return protocol.protocol.teachingMethod.id === 5;
    },

    isShaping: function isShaping(protocol) {
      return protocol.protocol.teachingMethod.id === 6;
    },

    isPecs: function isPecs(protocol) {
      return protocol.protocol.teachingMethod.id === 7;
    },

    isOnIndividualization: function isOnIndividualization(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION;
    },

    onShowModalBtnClick: function onShowModalBtnClick() {
      this.isChange = false;
      this.isModalVisible = true;
    },


    getAssignedProtocols: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(perPage, page, clientId, search) {
        var params, response, assignedProtocols;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.isLoaded = false;
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'assignedProtocols');
                params = {
                  sort: this.sort,
                  searchSkillField: search ? search.searchSkillField : this.searchSkillField,
                  search: search ? search.search : this.search
                };
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.protocolUrl + clientId + '/' + perPage + '/' + page, {
                  params: params
                });

              case 7:
                response = _context2.sent;
                assignedProtocols = response.data.data.items;

                assignedProtocols.forEach(function (item) {
                  item.isOpen = false;
                });
                this.assignedProtocols = assignedProtocols;
                this.isLoaded = true;
                if (response) {
                  this.isChange = false;
                }

                return _context2.abrupt('return', response);

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);
                this.$router.push({ name: 'default' });

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 16]]);
      }));

      function getAssignedProtocols(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getAssignedProtocols;
    }(),

    exportProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/protocols/' + 'pdf/' + id, { responseType: 'blob' }).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocol') + '_' + id + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 3:
                response = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function exportProtocol(_x5) {
        return _ref2.apply(this, arguments);
      }

      return exportProtocol;
    }(),

    makeFirst: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.isChange = false;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/protocols/users/' + this.clientId + '/higher-position/' + id);

              case 4:
                response = _context4.sent;

                if (response) {
                  this.isChange = true;
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function makeFirst(_x6) {
        return _ref3.apply(this, arguments);
      }

      return makeFirst;
    }(),

    makeLast: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                this.isChange = false;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/protocols/users/' + this.clientId + '/lower-position/' + id);

              case 4:
                response = _context5.sent;

                if (response) {
                  this.isChange = true;
                }
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.dir(_context5.t0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function makeLast(_x7) {
        return _ref4.apply(this, arguments);
      }

      return makeLast;
    }(),
    allowMensuration: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                this.isChange = false;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/protocols/assigned/' + id + '/allow-mensuration');

              case 4:
                response = _context6.sent;

                if (response) {
                  this.isChange = true;
                }
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);

                console.dir(_context6.t0);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function allowMensuration(_x8) {
        return _ref5.apply(this, arguments);
      }

      return allowMensuration;
    }(),
    showDeletePopup: function showDeletePopup(id) {
      this.assignedProtocolId = id;
      this.isDeleteModalVisible = true;
      this.isChange = false;
    },


    onRemoveActiveProtocol: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(protocolId) {
        var isDeleted;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                this.isLoaded = false;

                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(this.assignedUrl + protocolId);

              case 4:
                isDeleted = _context7.sent;

                if (isDeleted) {
                  /*this.getAssignedProtocols(this.paginate.perPage, this.paginate.page,
                      this.clientId);*/
                  this.isLoaded = true;
                  this.isChange = true;
                }

                _context7.next = 13;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);

                console.dir(_context7.t0);
                this.isChange = false;
                if (_context7.t0 && _context7.t0.status == 422) {
                  this.isChange = true;
                  this.isLoaded = true;
                  this.errorDeleteMessage = _context7.t0.data.errors ? __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.unable_to_delete_protocol') : _context7.t0.data.message;
                }

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 8]]);
      }));

      function onRemoveActiveProtocol(_x9) {
        return _ref6.apply(this, arguments);
      }

      return onRemoveActiveProtocol;
    }(),
    onProtocolModalClose: function onProtocolModalClose() {
      this.isChange = false;
      this.onModalClose();
      var response = this.getAssignedProtocols(this.paginate.perPage, this.paginate.page, this.clientId);

      if (response) {
        this.isChange = true;
      }
    },

    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
      this.paginate.page = 1;
    },

    onSearchSkillField: function onSearchSkillField(searchSkillField) {
      this.searchSkillField = searchSkillField;
      this.paginate.page = 1;
    }
  },
  watch: {
    reload: function reload(newVal) {
      if (newVal) {
        this.isChange = false;
        var response = this.getAssignedProtocols(this.paginate.perPage, this.paginate.page, this.clientId);

        if (response) {
          this.isChange = true;
        }
      }
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProtocolModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/',
      assignList: [],
      selected: null,
      userId: null,
      search: '',
      disabled: true,
      lastId: null,
      perPage: 10,
      page: 1,
      loading: false,
      isLastPage: false,
      validated: {
        validate: 'required',
        on: 'none',
        name: 'title',
        as: "'protocol.header' | trans"
      },
      isLoaded: true
    };
  },
  created: function created() {
    this.getAssignList();
  },

  components: { Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], selectWithPager: __WEBPACK_IMPORTED_MODULE_6__common_selectWithPager_components_SelectWithPager__["a" /* default */] },
  methods: {
    onSetSelected: function onSetSelected(selected) {
      this.selected = selected;
      this.disabled = false;
    },

    onSendRequestButtonClick: function onSendRequestButtonClick() {
      this.isLoaded = false;
      this.disabled = true;
      this.validate();
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;


                if (result) {
                  _this.save();
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    nextPage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isLastPage) {
                  _context2.next = 9;
                  break;
                }

                this.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
                  search: this.search
                });

              case 4:
                response = _context2.sent;


                response.data.data.items.forEach(function (item) {
                  _this2.assignList.push(item);
                });

                this.loading = false;
                this.lastId = this.assignList[this.assignList.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function nextPage() {
        return _ref.apply(this, arguments);
      }

      return nextPage;
    }(),

    searchProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(search) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.page = 1;

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
                  params: {
                    search: search
                  }
                });

              case 4:
                response = _context3.sent;


                this.assignList = response.data.data.items;
                this.lastId = this.assignList.length > 0 ? this.assignList[this.assignList.length - 1].id : null;
                if (response.data.data.hasMorePages) {
                  this.page++;
                  this.isLastPage = false;
                } else {
                  this.isLastPage = true;
                }

                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));

      function searchProtocol(_x) {
        return _ref2.apply(this, arguments);
      }

      return searchProtocol;
    }(),

    getOptionTitle: function getOptionTitle(_ref3) {
      var option = _ref3.option;

      return option.title;
    },

    isLast: function isLast(_ref4) {
      var option = _ref4.option;

      return option.id == this.lastId;
    },

    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.disabled = true;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this3.apiUrl + 'assigned/', {
                  protocolId: _this3.selected.id,
                  clientId: _this3.clientId
                });

              case 3:
                isSaved = _context4.sent;

                if (isSaved) {
                  _this3.close();
                  _this3.disabled = false;
                } else {
                  _this3.disabled = false;
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },


    getAssignList: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
                  search: this.search
                });

              case 3:
                response = _context5.sent;


                this.assignList = response.data.data.items;
                this.lastId = this.assignList[this.assignList.length - 1].id;
                if (response.data.data.hasMorePages) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.dir(_context5.t0);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function getAssignList() {
        return _ref5.apply(this, arguments);
      }

      return getAssignList;
    }(),

    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.getAssignList();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    },
    cancel: function cancel() {
      this.reset();
      this.$emit('cancel');
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_once__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_once__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'SelectWithPager',
  props: {
    options: {},
    selected: null,
    disabled: false,
    label: '',
    loading: false,
    lastId: null,
    isLastPage: false,
    header: '',
    filterable: false,
    searchable: false,
    noOptions: '',
    validated: {
      type: [Object],
      default: function _default() {
        return {
          validate: 'required:false',
          on: '',
          name: '',
          as: ''
        };
      }
    },
    getOptionTitle: {
      type: Function,
      default: function _default(option) {
        return option.title;
      }
    },
    isLast: Function
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  data: function data() {
    return {
      closeOnSelect: true,
      clickOnNext: false,
      newSelected: null
    };
  },
  created: function created() {
    this.closeOnSelect = this.isMobile ? false : true;
  },


  methods: {
    onSetSelected: function onSetSelected(selected) {

      if (selected && this.isMobile) {
        if (this.clickOnNext) {
          this.closeOnSelect = false;
        } else {
          this.closeOnSelect = true;
        }
        this.newSelected = selected;
        this.clickOnNext = false;
      }

      this.$emit('set-selected', selected);
    },


    onChange: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (search) {
      this.$emit('set-search', search, this);
    }, 500),

    nextPage: function nextPage() {
      this.clickOnNext = true;
      this.closeOnSelect = this.isMobile ? false : true;
      if (!this.loading) {
        this.$emit('next-page');
      }
    },
    getTitle: function getTitle(option) {
      return this.getOptionTitle({
        option: option
      });
    },
    isLastItem: function isLastItem(option) {
      return this.isLast({
        option: option
      });
    }
  }

});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Search__ = __webpack_require__(104);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tableView',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    withChild: {
      type: Boolean,
      default: false
    },
    isLoaded: {
      type: Boolean,
      default: true
    },
    isList: {
      type: Boolean,
      default: false
    },
    listWithHeaderView: {
      type: Boolean,
      default: false
    },
    isChange: {
      type: Boolean,
      default: false
    },
    isTwoSearch: {
      type: Boolean,
      default: false
    },
    indexColumn: {
      type: [Number, String],
      default: 0
    }
  },
  components: { Search: __WEBPACK_IMPORTED_MODULE_7__Search__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_6__modules_loader_components_Loader__["a" /* default */] },
  data: function data() {
    return {
      slotColumns: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      tableColumns: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      listHide: false,
      search: '',
      searchSkillField: ''
    };
  },
  created: function created() {
    if (this.isList) {
      var columns = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.listRow, function (value, key) {
        columns.push(key);
      });
      this.tableColumns = __WEBPACK_IMPORTED_MODULE_5_lodash_keys___default()(this.options.listRow);
      var headings = {};
      __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.listRow, function (value, key) {
        headings[key] = value.headings;
      });

      this.options.headings = headings;
      this.listHide = __WEBPACK_IMPORTED_MODULE_5_lodash_keys___default()(headings).length == 1;
    } else {
      var columnsChanged = __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.options.columns, { changed: true });
      this.slotColumns = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(columnsChanged, 'key');
      var _columns = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(this.options.columns, 'key');
      this.tableColumns = _columns;
      var _headings = {};
      __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.columns, function (value, key) {
        _headings[value.key] = value.headings;
      });

      this.options.headings = _headings;
    }
  },
  mounted: function mounted() {

    if (localStorage.currentPage) {

      if (localStorage.getItem("currentPageHeader") === this.options.pageHeader) {
        this.options.initialPage = localStorage.getItem("currentPage");
      }
    }

    this.options.initialPage = this.options.initialPage ? this.options.initialPage : 1;
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentPage');
  },


  methods: {
    onSearchEnter: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(search) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                if (this.isTwoSearch) {
                  this.search = search;
                  this.$refs.protocolTable.query = {
                    search: this.search,
                    searchSkillField: this.searchSkillField
                  };
                } else {
                  this.$refs.protocolTable.query = search;
                }

                this.$refs.protocolTable.refresh();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSearchEnter(_x) {
        return _ref.apply(this, arguments);
      }

      return onSearchEnter;
    }(),
    onSearchSkillField: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(search) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.searchSkillField = search;
                this.$refs.protocolTable.query = {
                  search: this.search,
                  searchSkillField: this.searchSkillField
                };
                this.$refs.protocolTable.refresh();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSearchSkillField(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onSearchSkillField;
    }(),
    onRefreshEnter: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(search) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$refs.protocolTable.refresh();

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onRefreshEnter(_x3) {
        return _ref3.apply(this, arguments);
      }

      return onRefreshEnter;
    }()
  },

  watch: {
    isList: function isList(newValue, oldValue) {

      if (newValue) {
        var columns = [];
        __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.listRow, function (value, key) {
          columns.push(key);
        });
        this.tableColumns = __WEBPACK_IMPORTED_MODULE_5_lodash_keys___default()(this.options.listRow);
        var headings = {};
        __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.listRow, function (value, key) {
          headings[key] = value.headings;
        });

        this.options.headings = headings;
        this.listHide = __WEBPACK_IMPORTED_MODULE_5_lodash_keys___default()(headings).length == 1;
      } else {
        var columnsChanged = __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.options.columns, { changed: true });
        this.slotColumns = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(columnsChanged, 'key');
        var _columns2 = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(this.options.columns, 'key');
        this.tableColumns = _columns2;
        var _headings2 = {};
        __WEBPACK_IMPORTED_MODULE_4_lodash_forIn___default()(this.options.columns, function (value, key) {
          _headings2[value.key] = value.headings;
        });

        this.options.headings = _headings2;
      }
    },
    isChange: function isChange(newValue, oldValue) {

      if (newValue) {
        this.$refs.protocolTable.refresh();
      }
    }
  }

});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  props: {
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'list-search'
    }
  },
  methods: {
    'onEnter': function onEnter(event) {

      if (event && event.which == 13) {
        var input = this.$refs['input_search'];
        input.blur();
      }

      if (event && event.type == 'blur') {
        var value = event.target.value;
        this.$emit('enter', value);
      }
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bids__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewModal__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddModal__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'userId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      isChange: false,
      bids: [],
      disabled: false,
      isLoaded: true,
      isModalVisible: false,
      isViewModalVisible: false,
      isAddModalVisible: false,
      isOpen: false,
      shortTextLength: 200,
      currentPageNumber: 1,
      modal: {
        data: {},
        clientId: ''
      },
      api: null,
      state: {
        created: false
      },
      options: {
        pageHeader: 'bids',
        initialPage: null,
        filterable: false,
        sortable: [],
        debounce: 1000,
        skin: 'table table-sm',
        columns: [{
          key: 'icon',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.bids')
        }, {
          key: 'description',
          changed: true,
          headings: ''
        }, {
          key: 'client',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.client')
        }, {
          key: 'initiator',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.initiator')
        }, {
          key: 'status',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.status')
        }, {
          key: 'therapist',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.therapist')
        }, {
          key: 'change_date',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.create_date')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        listRow: {
          icon: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.bids'),
            hasTemplate: false
          }
        },
        texts: {
          noResults: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        perPage: 10
      }
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */]],

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], bidsModal: __WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */], bidsViewModal: __WEBPACK_IMPORTED_MODULE_5__ViewModal__["a" /* default */], bidsAddModal: __WEBPACK_IMPORTED_MODULE_6__AddModal__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isEmptyBids: function isEmptyBids() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.bids);
    }

  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isTherapist', 'isMensurationForbidden']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])('bids/list', ['isSaved']), {
    isTherapistOnClientProfile: function isTherapistOnClientProfile() {
      return this.isTherapist && 'client-edit' === this.route.name;
    },
    addBidBlockShouldBeVisible: function addBidBlockShouldBeVisible() {
      return this.userId && (this.isClient || this.isTherapistOnClientProfile) && !this.isMensurationForbidden;
    }
  }),

  filters: {
    shortText: function shortText(text, length) {
      if (text.length < length) {
        return text;
      } else {
        return text.substr(0, length) + '...';
      }
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.state.created = false;
              //await this.onFetchBids();
              if (_this.isClient) {
                _this.options.columns = [{
                  key: 'icon',
                  changed: true,
                  headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.bids')
                }, {
                  key: 'description',
                  changed: true,
                  headings: ''
                }, {
                  key: 'initiator',
                  changed: true,
                  headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.initiator')
                }, {
                  key: 'status',
                  changed: true,
                  headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.status')
                }, {
                  key: 'change_date',
                  changed: true,
                  headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.create_date')
                }, {
                  key: 'action',
                  changed: true,
                  headings: ''
                }];
              }
              _this.state.created = true;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('bids/list', ['setIsSaved']), {
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.fetchBids(_this2.userId, _this2.options.perPage, data.page, _this2.sort, data.query));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onFetchBids: function onFetchBids() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.fetchBids(_this3.userId, _this3.options.perPage, _this3.paginate.page);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    fetchBids: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId, perPage, page, refresh) {
        var response, bids;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.isLoaded = false;
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'bids');

                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__api_bids__["a" /* default */].list(clientId, perPage, page);

              case 6:
                response = _context4.sent;
                bids = response.data.data.items;


                bids.forEach(function (item) {
                  item.isOpen = false;
                });

                this.bids = bids;

                if (!refresh) {
                  this.currentPageNumber = page;
                  this.setPaginate(response.data.data);
                } else {
                  this.onPaginationClick(this.currentPageNumber);
                }
                this.isChange = false;
                return _context4.abrupt('return', response);

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);
                this.isLoaded = true;
                this.$router.push({ name: 'default' });

              case 20:
                _context4.prev = 20;

                this.isLoaded = true;
                this.setIsSaved(false);
                return _context4.finish(20);

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 15, 20, 24]]);
      }));

      function fetchBids(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return fetchBids;
    }(),

    onModalCancel: function onModalCancel() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isViewModalVisible = false;
      this.isAddModalVisible = false;
    },
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isViewModalVisible = false;
      this.isAddModalVisible = false;
      this.isChange = true;
      this.$emit('list-reload');
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.modal.data = { item: item };
      this.isModalVisible = true;
    },
    onViewBtnClick: function onViewBtnClick(item) {
      this.modal.data = { item: item };
      this.isViewModalVisible = true;
    },
    onAddBtnClick: function onAddBtnClick() {
      this.isChange = true;
      this.modal.clientId = this.userId;
      this.isAddModalVisible = true;
    },
    onPaginationClick: function onPaginationClick(pageNum) {
      this.fetchBids(this.userId, this.paginate.perPage, pageNum);
      this.onPaginationBtnClick(pageNum);
    }
  }),
  watch: {
    isLoaded: function isLoaded(newVal) {
      this.$emit('loading', newVal === false, this.state.created);
    },
    isSaved: function isSaved() {
      if (this.isSaved) {
        this.onFetchBids();
      }
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bids__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);





var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BidsModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      bid: [],
      entities: [],
      protocol: '',
      comment: '',
      approval: false,
      perPage: 10,
      page: 1,
      search: "",
      loading: false,
      isLastPage: false,
      validated: {
        validate: this.approval ? '' : 'required',
        on: 'none',
        name: 'protocol',
        as: "'bids.appoint_protocol' | trans"
      }
    };
  },


  components: {
    selectWithPager: __WEBPACK_IMPORTED_MODULE_9__common_selectWithPager_components_SelectWithPager__["a" /* default */]
  },

  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('bids/list', ['setIsSaved']), {
    onSearchProcol: function onSearchProcol(search) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.page = 1;
                _context.next = 3;
                return _this.searchProcol(__WEBPACK_IMPORTED_MODULE_4__api_bids__["a" /* default */], search, _this);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    searchProcol: __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(apiManager, search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return apiManager.searchId(vm.bid.id, search, vm.perPage, vm.page);

              case 3:
                response = _context2.sent;

                if (response.data.data.items.length) {
                  vm.entities = response.data.data.items;
                  vm.search = search;
                  vm.lastId = vm.entities[vm.entities.length - 1].id;

                  if (response.data.data.hasMorePages) {
                    vm.page++;
                    vm.isLastPage = false;
                  } else {
                    vm.isLastPage = true;
                  }
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }(), 150),

    onChangeProcol: function onChangeProcol(val) {
      this.protocol = val;
    },


    getOptionTitle: function getOptionTitle(_ref2) {
      var option = _ref2.option;

      return option.name;
    },
    isLast: function isLast(_ref3) {
      var option = _ref3.option;

      return option.id == this.lastId;
    },

    nextPage: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.isLastPage) {
                  _context3.next = 9;
                  break;
                }

                this.loading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_bids__["a" /* default */].searchId(this.bid.id, this.search, this.perPage, this.page);

              case 4:
                response = _context3.sent;


                response.data.data.items.forEach(function (item) {
                  _this3.entities.push(item);
                });

                this.loading = false;
                this.lastId = this.entities[this.entities.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function nextPage() {
        return _ref4.apply(this, arguments);
      }

      return nextPage;
    }(),

    onAppointProtocolButtonClick: function onAppointProtocolButtonClick() {
      this.validate();
    },
    onApprovalButtonClick: function onApprovalButtonClick() {
      var _this4 = this;

      this.approval = true;
      this.$nextTick(function () {
        _this4.validate();
      });
    },


    appointProtocol: __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(apiManager, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return apiManager.assign(vm.bid.id, vm.protocol.id, vm.protocol.type, vm.comment, vm.bid.description);

              case 3:
                response = _context4.sent;


                vm.close();
                vm.$parent.onPaginationClick(1);
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.error('Unknown API error occurred.');

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[0, 8]]);
      }));

      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }(), 100),

    approvalBid: __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(apiManager, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return apiManager.update(vm.bid.id, vm.bid.description, vm.comment);

              case 3:
                response = _context5.sent;


                vm.close();
                vm.$parent.onPaginationClick(1);
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.error('Unknown API error occurred.');

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2, [[0, 8]]);
      }));

      return function (_x6, _x7) {
        return _ref6.apply(this, arguments);
      };
    }(), 100),

    isNewBid: function isNewBid() {
      return this.bid.status.id == 1;
    },
    validate: function validate() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this5.$validator.validateAll();

              case 2:
                result = _context6.sent;


                if (result) {
                  if (_this5.approval) {
                    _this5.approvalBid(__WEBPACK_IMPORTED_MODULE_4__api_bids__["a" /* default */], _this5);
                  } else {
                    _this5.appointProtocol(__WEBPACK_IMPORTED_MODULE_4__api_bids__["a" /* default */], _this5);
                  }
                }

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.errors.clear();
    },
    close: function close() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this6.isTherapist && _this6.isNewBid())) {
                  _context7.next = 17;
                  break;
                }

                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_bids__["a" /* default */].viewed(_this6.bid.id);

              case 4:
                response = _context7.sent;
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](1);

                console.error('Unknown API error occurred.');

              case 10:
                _context7.prev = 10;

                _this6.reset();
                _this6.setIsSaved(true);
                _this6.$emit('close');
                return _context7.finish(10);

              case 15:
                _context7.next = 20;
                break;

              case 17:
                _this6.reset();
                _this6.setIsSaved(true);
                _this6.$emit('close');

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6, [[1, 7, 10, 15]]);
      }))();
    },
    cancel: function cancel() {
      this.reset();
      this.$emit('cancel');
    }
  }),

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    isEdit: function isEdit() {
      return !__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(this.data);
    },

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['isTherapist', 'isCurator'])),

  watch: {
    visible: function visible() {
      if (this.isEdit) {
        if (this.data.item && __WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default()(this.data)) {
          try {
            this.bid = this.data.item;
            this.onSearchProcol(" ");
          } catch (e) {
            console.error('Unknown API error occurred.');
          }
        }
      }
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BidsViewModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      bid: []
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  computed: {
    isEdit: function isEdit() {
      return !__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(this.data);
    },

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  watch: {
    visible: function visible() {
      if (this.isEdit) {
        if (this.data.item && this.data.item.comments && __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(this.data)) {
          try {
            this.bid = this.data.item;
          } catch (e) {
            console.error('Unknown API error occurred.');
          }
        }
      }
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bids__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BidsAddModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      description: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('bids/list', ['setIsSaved']), {
    onSendRequestButtonClick: function onSendRequestButtonClick() {
      this.validate();
    },
    sendRequest: function sendRequest(apiManager, clientId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return apiManager.create(clientId, _this.description);

              case 3:
                response = _context.sent;


                _this.close();
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
                _context.prev = 10;

                _this.setIsSaved(true);
                _this.$emit('close');
                return _context.finish(10);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7, 10, 14]]);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                result = _context2.sent;


                if (result) {
                  _this2.sendRequest(__WEBPACK_IMPORTED_MODULE_3__api_bids__["a" /* default */], _this2.clientId);
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    cancel: function cancel() {
      this.description = '';
      this.$emit('cancel');
    },
    close: function close() {
      this.description = '';
      this.$emit('close');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isTherapist']))
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_filter__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DashboardMenu: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */] },
  name: 'AvailableProtocolLayout',
  props: {
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'teachingMethod': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/',
      apiClientUrl: '/users/clients/',
      client: null,
      isAssignedProtocolFinished: false,
      assignedProtocolId: null,
      hideDroModal: false,
      statusId: null,
      teachingMethodId: this.teachingMethod,
      loaded: false,
      protocol: null,
      hasAccess: false,
      checkHasAccess: true,
      unavailableRoutes: {
        simple: ['protocol-item', 'stage-list', 'current-stage', 'results'],
        chain: ['protocol-item', 'chain-stage-current', 'stage-list', 'results'],
        usd: ['protocol-item', 'choose-usd', 'stage-list', 'mastering-stage-usd', 'maintain-stage-usd', 'results'],
        mand: ['protocol-item', 'stage-list', 'mand-stage-current', 'results'],
        dtt: ['protocol-item', 'stage-list', 'choose-stage', 'mastering-stage', 'rotation-stage', 'fluency-stage', 'maintain-stage', 'results'],
        nonDtt: ['protocol-item', 'stage-list', 'current-stage', 'results'],
        shaping: ['protocol-item', 'stage-list', 'shaping-stage-current', 'results'],
        pecs: ['protocol-item', 'stage-list', 'pecs-stage', 'results'],
        pecsDiscrimination: ['protocol-item', 'stage-list', 'pecs-stage-without-discrimination', 'results'],
        pecsWithDiscrimination: ['protocol-item', 'stage-list', 'pecs-with-discrimination-stage', 'results'],
        pecsWithItems: ['protocol-item', 'pecs-with-items-stage', 'results']
      }
    };
  },
  created: function created() {
    this.detectProtocol();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['getUserInfo', 'isBCBA', 'isTherapist', 'isCurator', 'isClient', 'isMensurationForbidden']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    activeProtocolList: function activeProtocolList() {
      var activeList = __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default()(this.protocol.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return activeList;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol', 'setProtocolVersion']), {

    isCompleted: function isCompleted() {
      return this.statusId === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].COMPLETED;
    },
    isOnIndividualization: function isOnIndividualization() {
      return this.statusId === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION;
    },
    isDtt: function isDtt() {
      return this.teachingMethodId === 1;
    },
    isSimple: function isSimple() {
      return this.teachingMethodId === 2;
    },
    isMand: function isMand() {
      return this.teachingMethodId === 3;
    },
    isUSD: function isUSD() {
      return this.teachingMethodId === 4;
    },
    isChain: function isChain() {
      return this.teachingMethodId === 5;
    },
    isShaping: function isShaping() {
      return this.teachingMethodId === 6;
    },
    isPecs: function isPecs() {
      return this.teachingMethodId === 7;
    },
    isPecsWithoutDiscrimination: function isPecsWithoutDiscrimination() {
      return this.teachingMethodId === 8;
    },
    isPecsWithDiscrimination: function isPecsWithDiscrimination() {
      return this.teachingMethodId === 9;
    },
    isPecsWithItems: function isPecsWithItems() {
      return this.teachingMethodId === 10;
    },
    isRouteMatchToTeachingMethod: function isRouteMatchToTeachingMethod() {
      var unavailableRoutes = this.unavailableRoutes.nonDtt;

      if (this.isDtt()) {
        unavailableRoutes = this.unavailableRoutes.dtt;
      }

      if (this.isMand()) {
        unavailableRoutes = this.unavailableRoutes.mand;
      }

      if (this.isUSD()) {
        unavailableRoutes = this.unavailableRoutes.usd;
      }

      if (this.isChain()) {
        unavailableRoutes = this.unavailableRoutes.chain;
      }

      if (this.isShaping()) {
        unavailableRoutes = this.unavailableRoutes.shaping;
      }
      if (this.isPecs()) {
        unavailableRoutes = this.unavailableRoutes.pecs;
      }

      if (this.isPecsWithoutDiscrimination()) {
        unavailableRoutes = this.unavailableRoutes.pecsDiscrimination;
      }

      if (this.isPecsWithDiscrimination()) {
        unavailableRoutes = this.unavailableRoutes.pecsWithDiscrimination;
      }

      if (this.isPecsWithItems()) {
        unavailableRoutes = this.unavailableRoutes.pecsWithItems;
      }

      return !!unavailableRoutes.includes(this.route.name);
    },
    backToProtocolPage: function backToProtocolPage() {
      this.$router.push({ name: 'protocol-item', params: { clientId: this.clientId || this.assignedProtocolId } });
    },
    detectProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.teachingMethodId) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/teaching-method');

              case 3:
                response = _context.sent;

                this.teachingMethodId = response.data.data.id;

              case 5:
                if (this.isDtt()) {
                  this.apiUrl = '/protocols/assigned/dtt/';
                }

                if (this.isMand()) {
                  this.apiUrl = '/protocols/assigned/mand/';
                }

                if (this.isUSD()) {
                  this.apiUrl = '/protocols/assigned/vcd/';
                }

                if (this.isChain()) {
                  this.apiUrl = '/protocols/assigned/chain/';
                }

                if (this.isShaping()) {
                  this.apiUrl = '/protocols/assigned/shaping/';
                }

                if (this.isSimple()) {
                  this.apiUrl = '/protocols/assigned/simple/';
                }

                if (this.isPecs()) {
                  this.apiUrl = '/protocols/assigned/pecs-sentence-structure/';
                }

                if (this.isPecsWithoutDiscrimination()) {
                  this.apiUrl = '/protocols/assigned/pecs-without-discrimination/';
                }

                if (this.isPecsWithDiscrimination()) {
                  this.apiUrl = '/protocols/assigned/pecs-with-discrimination/';
                }

                if (this.isPecsWithItems()) {
                  this.apiUrl = '/protocols/assigned/pecs-features-with-items/';
                }

                if (!this.isRouteMatchToTeachingMethod()) {
                  this.backToProtocolPage();
                }
                this.fetchProtocol();

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function detectProtocol() {
        return _ref.apply(this, arguments);
      }

      return detectProtocol;
    }(),
    fetchProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                response = void 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/info');

              case 3:
                response = _context2.sent;


                this.protocol = response.data.data;
                this.setProtocol(response.data.data);

                this.assignedProtocolId = this.protocol.assigneeId;
                this.statusId = this.protocol.status.id;
                if (this.protocol) {
                  this.getClient(this.clientId || this.assignedProtocolId);
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchProtocol() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocol;
    }(),
    getClient: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context3.sent;

                this.client = response.data.data;
                this.loaded = true;
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.info(_context3.t0);
                this.loaded = true;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function getClient(_x) {
        return _ref3.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    }
  }),
  watch: {
    protocolVuexData: function protocolVuexData(value) {
      if (!value) {
        this.detectProtocol();
      }
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppealsLayout_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0748c485_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppealsLayout_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppealsLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0748c485_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppealsLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appeals_components_AppealsList__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__ = __webpack_require__(28);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appealsLayout',

  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_6__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      }
    }
  },

  data: function data() {
    return {
      isOpen: false,
      client: null,
      clientApiUrl: '/users/clients/'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['getUserInfo', 'isBCBA', 'isTherapist', 'isCurator', 'isClient', 'user']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])(['route']), {
    isEmptyClient: function isEmptyClient() {
      return isEmpty(this.client);
    },
    clientTimezone: function clientTimezone() {
      if (!this.isClient) {
        return this.client.timezone;
      } else {
        return this.user.timezone;
      }
    }
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__["a" /* pagination */]],

  components: {
    AppealsList: __WEBPACK_IMPORTED_MODULE_4__appeals_components_AppealsList__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__["a" /* default */]
  },

  created: function created() {
    if (!this.isClient) {
      this.getClient(this.clientId);
    }
  },


  methods: {
    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.clientApiUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.client.id } });
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_appeals__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddModal__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editTypicalAppealsModal_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Constants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_timezone__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_auth_Manager__ = __webpack_require__(22);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_19__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      }
    },
    'clientTimezone': {
      type: [String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: 'appeals/statistics/',
      isModalVisible: false,
      isEditModalVisible: false,
      rangeDateStart: new Date(),
      rangeDateEnd: new Date(),
      measurements: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__["a" /* pagination */], __WEBPACK_IMPORTED_MODULE_7__common_mixins_showModal__["a" /* showModal */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], appealsAddModal: __WEBPACK_IMPORTED_MODULE_4__AddModal__["a" /* default */], editTypicalAppealsModal: __WEBPACK_IMPORTED_MODULE_5__editTypicalAppealsModal_vue__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_13__common_chart__["a" /* BarChart */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])('appeals', ['appeals', 'isLoaded', 'paginateData', 'isAdded']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden']), {
    isEmptyAppeals: function isEmptyAppeals() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.appeals);
    },
    lineChartDataset: function lineChartDataset() {
      return this.fetchDatasetForChart();
    },
    barChartDataset: function barChartDataset() {
      return this.fetchBarDatasetForChart();
    },
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_12__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_12__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }),
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_18_vee_validate__["a" /* Validator */].extend('check-period', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('report.description_max_period', { attribute: attribute });
      },
      validate: function validate() {
        var date = new Date(_this.rangeDateStart.getFullYear(), _this.rangeDateStart.getMonth() + 4, _this.rangeDateStart.getDate(), _this.rangeDateEnd.getHours(), _this.rangeDateEnd.getMinutes(), _this.rangeDateEnd.getSeconds(), _this.rangeDateEnd.getMilliseconds());
        return _this.rangeDateEnd.getTime() <= date.getTime();
      }
    });
    var initialPage = 1;

    if (!!localStorage.currentPage && localStorage.currentPage != 1) {

      if (localStorage.getItem("currentPageHeader") === 'appeals') {
        initialPage = localStorage.getItem("currentPage");
      }
      var rangeDateStart = localStorage.getItem("rangeDateStart");
      var rangeDateEnd = localStorage.getItem("rangeDateEnd");
      if (rangeDateStart) {
        this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_16_moment___default()(rangeDateStart)._d;
      }
      if (rangeDateEnd) {
        this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_16_moment___default()(rangeDateEnd)._d;
      }
      this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : __WEBPACK_IMPORTED_MODULE_19__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      this.paginate.page = initialPage;
      this.onSendRequest();
    } else {

      if (this.clientTimezone) {
        this.setDate();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('rangeDateStart');
    localStorage.removeItem('rangeDateEnd');
    localStorage.removeItem('clientId');
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('appeals', ['setAppeals', 'setTypesAppeals', 'setCurrentPage', 'setIsAdded']), {
    setDate: function setDate() {
      var clientDateStart = __WEBPACK_IMPORTED_MODULE_16_moment___default()().tz(this.clientTimezone).subtract(__WEBPACK_IMPORTED_MODULE_12__Constants__["a" /* default */].COUNT_DAY, 'days').add(-__WEBPACK_IMPORTED_MODULE_16_moment___default()().utcOffset(), 'm');
      var clientDateEnd = __WEBPACK_IMPORTED_MODULE_16_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_16_moment___default()().utcOffset(), 'm');

      this.rangeDateStart = clientDateStart._d;
      this.rangeDateEnd = clientDateEnd._d;

      this.onSendRequest();
    },
    onPaginationClick: function onPaginationClick(pageNum) {
      localStorage.setItem('currentPage', pageNum);
      localStorage.setItem('currentPageHeader', 'appeals');
      localStorage.setItem('rangeDateStart', this.rangeDateStart);
      localStorage.setItem('rangeDateEnd', this.rangeDateEnd);
      localStorage.setItem('clientId', this.clientId);

      this.setCurrentPage(pageNum);
      this.getPageAppeals(this.clientId, this.paginate.perPage, pageNum, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);
    },
    onSendRequest: function onSendRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                result = _context.sent;

                if (result) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this2.getPageAppeals(_this2.clientId, _this2.paginate.perPage, _this2.paginate.page, _this2.rangeDateStartTimestamp, _this2.rangeDateEndTimestamp);
                _this2.fetchMeasurement(_this2.clientId);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },


    getPageAppeals: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId, perPage, page, startDate, endDate) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setAppeals({ clientId: clientId, perPage: perPage, page: page, startDate: startDate, endDate: endDate });

              case 2:
                this.onPaginationBtnClick(page);
                this.setIsAdded(false);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPageAppeals(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return getPageAppeals;
    }(),
    onModalCancel: function onModalCancel() {
      this.isModalVisible = false;
      this.isEditModalVisible = false;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isEditModalVisible = false;
    },
    onEditBtnClick: function onEditBtnClick() {
      this.isEditModalVisible = true;
    },

    fetchMeasurement: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_appeals__["a" /* default */].getCountAppeals(this.clientId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 3:
                response = _context3.sent;


                this.measurements = response.data.data;

                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function fetchMeasurement() {
        return _ref2.apply(this, arguments);
      }

      return fetchMeasurement;
    }(),
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
    },
    toLocaleDateYear: function toLocaleDateYear(date) {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    fetchDatasetForChart: function fetchDatasetForChart() {
      var data = [];
      var i = 0;
      var label = __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('appeals.avarage_appeals_perhour');
      __WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: i,
          y: item.perHourCount
        });
        i++;
      });

      return new __WEBPACK_IMPORTED_MODULE_13__common_chart__["d" /* LineChartDataset */]({
        data: data, label: label
      });
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart() {
      var _this3 = this;

      var data = [];
      var i = 0;
      var label = __WEBPACK_IMPORTED_MODULE_15__lang_translator__["a" /* default */].get('appeals.total_appeals_perday');
      var labels = [];
      __WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: i,
          y: item.totalCount
        });
        i++;
        labels.push(_this3.toLocaleDate(item.dateRange.end));
      });

      return new __WEBPACK_IMPORTED_MODULE_13__common_chart__["b" /* BarChartDataset */]({ data: data, label: label, labels: labels });
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    },
    isAdded: function isAdded() {
      if (this.isAdded) {
        this.onSendRequest();
      }
    },
    rangeDateStart: function rangeDateStart(oldValue, newValue) {
      /*let rangeDays = Constants.MILLISECONDS * Constants.SECONDS *
          Constants.MINUTES * Constants.HOURS * Constants.COUNT_DAY;
      if (!oldValue) {
        this.rangeDateStart = newValue
      }
      let myDate = cloneDeep(this.rangeDateStart);
      let newDate = new Date(myDate.getTime() + rangeDays);
       if (newDate.getTime() / Constants.MILLISECONDS > moment.tz(new Date(), this.clientTimezone).utcOffset(0, true).unix()) {
        this.rangeDateEnd = moment().tz(this.clientTimezone).add(-(moment().utcOffset()), 'm')._d;
      }
      else {
        this.rangeDateEnd = newDate;
      }*/
    },
    clientTimezone: function clientTimezone() {
      if (this.clientTimezone) {
        this.setDate();
      }
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_appeals__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Constants__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editTypicalModal',
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      typicalAppealsTemp: [],
      removedAppealsTemp: [],
      newTypicalAppeal: {
        text: '',
        id: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])('appeals', ['typicalAppeals'])),
  created: function created() {
    this.setTypesAppeals(this.clientId);
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('appeals', ['setTypesAppeals']), {
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;

                if (!result) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__api_appeals__["a" /* default */].saveTypes(_this.clientId, _this.typicalAppealsTemp);

              case 7:
                response = _context.sent;

                _this.setTypesAppeals(_this.clientId);
                _this.close();
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](4);

                console.dir(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 12]]);
      }))();
    },
    addAppeal: function addAppeal() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, appeal, uniqueCounter, i, _i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.typicalAppealsTemp.length < __WEBPACK_IMPORTED_MODULE_7__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;
                appeal = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(_this2.newTypicalAppeal);


                if (result && appeal.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.typicalAppealsTemp).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_6_lodash_trim___default()(_this2.typicalAppealsTemp[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_6_lodash_trim___default()(appeal.text.toLowerCase())) {
                      uniqueCounter++;
                    }
                  }
                  for (_i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.removedAppealsTemp).length; _i++) {
                    if (__WEBPACK_IMPORTED_MODULE_6_lodash_trim___default()(_this2.removedAppealsTemp[_i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_6_lodash_trim___default()(appeal.text.toLowerCase())) {
                      appeal = _this2.removedAppealsTemp[_i];
                    }
                  }

                  if (uniqueCounter === 0) {
                    appeal.createdAt = Math.round(new Date().getTime() / 1000);
                    _this2.typicalAppealsTemp.push(__WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(appeal));
                    _this2.reset();
                  } else {
                    _this2.errors.add({
                      field: 'isNotUnique',
                      msg: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('appeals.unique_appeals')
                    });
                  }
                } else if (appeal.text === '') {
                  _this2.errors.add({
                    field: 'isEmptyError',
                    msg: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('appeals.type_new_appeal')
                  });
                }
                _context2.next = 9;
                break;

              case 8:
                _this2.errors.add({
                  field: 'isMaxLengthAppeals',
                  msg: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('appeals.maxlength_appeals')
                });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeAppeal: function removeAppeal(index, appeal) {
      this.removedAppealsTemp.push(appeal);
      this.typicalAppealsTemp.splice(index, 1);
    },
    reset: function reset() {
      this.newTypicalAppeal.text = '';
      this.removedAppealsTemp = [];
      this.errors.clear();
    },
    saveAppeals: function saveAppeals() {
      this.reset();
      this.typicalAppealsTemp = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalAppeals);
      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.typicalAppealsTemp, function (item) {
        var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
        item.createdAt = convertDate;
      });
    },
    close: function close() {
      this.saveAppeals();
      this.$emit('close');
    },
    cancel: function cancel() {
      this.saveAppeals();
      this.$emit('cancel');
    }
  }),
  watch: {
    typicalAppeals: function typicalAppeals() {
      this.typicalAppealsTemp = __WEBPACK_IMPORTED_MODULE_5_lodash_cloneDeep___default()(this.typicalAppeals);
      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.typicalAppealsTemp, function (item) {
        var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
        item.createdAt = convertDate;
      });
    }
  }
});

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorLayout_vue__ = __webpack_require__(499);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688f1b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorLayout_vue__ = __webpack_require__(1078);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688f1b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_components_UndesirableBehaviorList__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'undesirableBehaviorLayout',

  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_6__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      }
    }
  },

  data: function data() {
    return {
      isOpen: false,
      client: null,
      clientApiUrl: '/users/clients/'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */]],

  components: {
    UndesirableBehaviorList: __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_components_UndesirableBehaviorList__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['getUserInfo', 'isBCBA', 'isTherapist', 'isCurator', 'isClient', 'user']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])('behavior', ['currentPage', 'isAdded']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])(['route']), {
    isEmptyClient: function isEmptyClient() {
      return isEmpty(this.client);
    },
    clientTimezone: function clientTimezone() {
      if (!this.isClient) {
        return this.client.timezone;
      } else {
        return this.user.timezone;
      }
    }
  }),

  created: function created() {
    if (!this.isClient) {
      this.getClient(this.clientId);
    }
  },


  methods: {
    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.clientApiUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.client.id } });
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddModal__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UndesirableBehaviorChart__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editTypicalBehaviorsModal_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment_timezone__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reports_api_Manager__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_auth_Manager__ = __webpack_require__(22);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_25__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      }
    },
    'clientTimezone': {
      type: [String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      activeBehaviorId: null,
      isModalVisible: false,
      isEditModalVisible: false,
      rangeDateStart: null,
      rangeDateEnd: null,
      measurements: null,
      antecedentTypes: null,
      consequenceInBehavior: null,
      behaviorTypes: null,
      effectsTypes: null,
      antecedentLegend: null,
      behaviorLegend: null,
      effectsLegend: null,
      rangeDateFinish: this.getMaxDateFinish(new Date()),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      minDateStart: this.getMinDateStart(new Date()),
      protocolList: [],
      protocol: {
        protocolId: 'time',
        title: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.hours_24')
      },
      disabledSelect: false,
      ancedentId: null,
      loading: false,
      lastAncedentId: null,
      ancedents: [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.all_ancedent') }],
      isLastAncedentPage: false,
      pageBehaviors: 1,
      pageAncedents: 1,
      behaviorId: null,
      lastBehaviorsId: null,
      behaviorsList: [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('report.all') }],
      isLastBehaviorsPage: false,
      changedShow: false,
      afterSetDate: false
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */], __WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__["a" /* showModal */]],

  components: {
    UndesirableBehaviorChart: __WEBPACK_IMPORTED_MODULE_5__UndesirableBehaviorChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_20__common_chart__["c" /* LineChart */],
    Loader: __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__["a" /* default */],
    undesirableBehaviorAddModal: __WEBPACK_IMPORTED_MODULE_4__AddModal__["a" /* default */],
    editTypicalBehaviorsModal: __WEBPACK_IMPORTED_MODULE_6__editTypicalBehaviorsModal_vue__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_20__common_chart__["a" /* BarChart */],
    selectWithPager: __WEBPACK_IMPORTED_MODULE_22__common_selectWithPager_components_SelectWithPager__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])('behavior', ['behaviors', 'isLoaded', 'isAdded', 'paginateData']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])(['route']), {
    isEmptyBehavior: function isEmptyBehavior() {
      return __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.behaviors);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden', 'isClient']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])('behavior', ['typicalBehaviors']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_14__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_14__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    lineChartDataset: function lineChartDataset() {
      return [this.fetchLineDatasetForChart()];
    },
    barChartAncedentDataset: function barChartAncedentDataset() {
      return this.fetchBarDatasetForChart(this.antecedentTypes, __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.ancedent'));
    },
    barChartBehaviorDataset: function barChartBehaviorDataset() {
      return this.fetchBarDatasetForChart(this.behaviorTypes, __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.unwanted_behavior'));
    },
    barChartEffectsDataset: function barChartEffectsDataset() {
      return this.fetchBarDatasetForChart(this.effectsTypes, __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.aftermath'));
    },
    barChartConsequenceInBehaviorDataset: function barChartConsequenceInBehaviorDataset() {
      return this.fetchBarDatasetForChart(this.consequenceInBehavior, __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.aftermath'));
    }
  }),

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_21_vee_validate__["a" /* Validator */].extend('check-period', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('report.description_max_period', { attribute: attribute });
      },
      validate: function validate() {
        var date = new Date(_this.rangeDateStart.getFullYear(), _this.rangeDateStart.getMonth() + 4, _this.rangeDateStart.getDate(), _this.rangeDateEnd.getHours(), _this.rangeDateEnd.getMinutes(), _this.rangeDateEnd.getSeconds(), _this.rangeDateEnd.getMilliseconds());
        return _this.rangeDateEnd.getTime() <= date.getTime();
      }
    });
    var initialPage = 1;
    if (!!localStorage.currentPage && localStorage.currentPage != 1) {
      if (localStorage.getItem("currentPageHeader") === 'behaviorsList') {
        initialPage = localStorage.getItem("currentPage");
      }
      var rangeDateStart = localStorage.getItem("rangeDateStart");
      var rangeDateEnd = localStorage.getItem("rangeDateEnd");
      if (rangeDateStart) {
        this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_15_moment___default()(rangeDateStart)._d;
      }
      if (rangeDateEnd) {
        this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_15_moment___default()(rangeDateEnd)._d;
      }
      this.ancedentId = localStorage.getItem('ancedentId');
      this.behaviorId = localStorage.getItem('behaviorId');
      this.onSearchProtocol();
      var protocolId = localStorage.getItem('protocol');
      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_filter___default()(this.protocolList, function (item) {
        return item.id == protocolId;
      })[0];
      this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : __WEBPACK_IMPORTED_MODULE_25__common_auth_Manager__["a" /* default */].getUserInfo().id || this.route.params.clientId;
      this.applyFilter(initialPage);
    } else {
      if (this.clientTimezone) {
        this.setDate();
      }

      this.applyFilter();
    }
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('rangeDateStart');
    localStorage.removeItem('rangeDateEnd');
    localStorage.removeItem('clientId');
    localStorage.removeItem('ancedentId');
    localStorage.removeItem('behaviorId');
    localStorage.removeItem('protocolID');
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('behavior', ['setBehaviors', 'setGroupedBehaviors', 'setCurrentPage', 'setIsAdded', 'setTypesBehaviors']), {
    onSetAncedentSelected: function onSetAncedentSelected(selected) {
      this.ancedentId = selected;
    },
    onSetBehaviorsSelected: function onSetBehaviorsSelected(selected) {
      this.behaviorId = selected;
    },


    isLast: function isLast(_ref) {
      var option = _ref.option;

      return option.id == this.lastId;
    },

    isLastAncedent: function isLastAncedent(_ref2) {
      var option = _ref2.option;

      return option.id == this.lastAncedentId;
    },

    isLastBehavior: function isLastBehavior(_ref3) {
      var option = _ref3.option;

      return option.id == this.lastBehaviorsId;
    },

    getMaxDateFinish: function getMaxDateFinish(date) {
      var clientDateEnd = __WEBPACK_IMPORTED_MODULE_15_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_15_moment___default()().utcOffset(), 'm');
      var minDateEnd = clientDateEnd._d;
      return minDateEnd;
    },

    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
    },

    fetchLineDatasetForChart: function fetchLineDatasetForChart() {
      var _this2 = this;

      var data = [],
          i = 0;
      __WEBPACK_IMPORTED_MODULE_18_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: _this2.toLocaleDate(item.dateRange.end),
          y: item.perHourCount
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_20__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      if (color == '#255255') return '#333333';
      return color;
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart(listTypes, name) {
      var _this3 = this;

      var data = [],
          i = 0,
          label = name,
          backgroundColor = void 0,
          datasets = [],
          legends = [];

      var types = __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default()(listTypes, 'count', 'desc');

      __WEBPACK_IMPORTED_MODULE_18_lodash_forEach___default()(types, function (item) {
        data = [{
          x: ++i,
          y: item.count
        }];
        label = item.title;
        backgroundColor = _this3.getRandomColor();
        legends.push({
          label: label,
          background: backgroundColor
        });

        datasets.push(new __WEBPACK_IMPORTED_MODULE_20__common_chart__["b" /* BarChartDataset */]({
          data: data, label: label, labels: legends, backgroundColor: backgroundColor, borderColor: backgroundColor
        }));
      });

      return datasets;
    },
    setDate: function setDate() {
      var clientDateStart = __WEBPACK_IMPORTED_MODULE_15_moment___default()().tz(this.clientTimezone).subtract(__WEBPACK_IMPORTED_MODULE_14__Constants__["a" /* default */].COUNT_DAY, 'day').add(-__WEBPACK_IMPORTED_MODULE_15_moment___default()().utcOffset(), 'm');
      var clientDateEnd = __WEBPACK_IMPORTED_MODULE_15_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_15_moment___default()().utcOffset(), 'm');

      this.rangeDateStart = clientDateStart._d;
      this.rangeDateEnd = clientDateEnd._d;

      this.onSearchProtocol();
      this.nextAncedentPage();
      this.nextBehaviorsPage();

      this.onSendRequest();
    },
    openDescription: function openDescription(id) {
      if (this.activeBehaviorId !== id) {
        this.activeBehaviorId = id;
      } else {
        this.activeBehaviorId = null;
      }
    },
    onPaginationClick: function onPaginationClick(pageNum) {
      localStorage.setItem('currentPage', pageNum);
      localStorage.setItem('currentPageHeader', 'behaviorsList');
      localStorage.setItem('rangeDateStart', this.rangeDateStart);
      localStorage.setItem('rangeDateEnd', this.rangeDateEnd);
      localStorage.setItem('clientId', this.clientId);
      localStorage.setItem('ancedentId', this.ancedentId);
      localStorage.setItem('behaviorId', this.behaviorId);
      localStorage.setItem('protocolID', this.protocol ? this.protocol.id : null);

      this.setCurrentPage(pageNum);
      this.getPageBehaviors(this.clientId, this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null, this.ancedentId ? this.ancedentId.id : null, this.behaviorId ? this.behaviorId.id : null, this.paginate.perPage, pageNum, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);
    },
    onSendRequest: function onSendRequest() {
      var _this4 = this;

      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.$validator.validateAll();

              case 2:
                result = _context.sent;

                if (result) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                _this4.paginate.page = pageNum;
                _this4.getPageBehaviors(_this4.clientId, _this4.protocol ? _this4.protocol.id === 'time' ? null : _this4.protocol.id : null, _this4.ancedentId ? _this4.ancedentId.id : null, _this4.behaviorId ? _this4.behaviorId.id : null, _this4.paginate.perPage, _this4.paginate.page, _this4.rangeDateStartTimestamp, _this4.rangeDateEndTimestamp);

                _this4.setIsAdded(false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    applyFilter: function applyFilter() {
      var _this5 = this;

      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.$validator.validateAll();

              case 2:
                result = _context2.sent;

                if (result) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:

                _this5.changedShow = true;
                _this5.paginate.page = pageNum;

                _this5.getPageBehaviors(_this5.clientId, _this5.protocol ? _this5.protocol.protocolId === 'time' ? null : _this5.protocol.id : null, _this5.ancedentId && _this5.ancedentId.id !== 'all' ? _this5.ancedentId.id : null, _this5.behaviorId && _this5.behaviorId.id !== 'all' ? _this5.behaviorId.id : null, _this5.paginate.perPage, _this5.paginate.page, _this5.rangeDateStartTimestamp, _this5.rangeDateEndTimestamp).then(function () {
                  _this5.afterSetDate = true;
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    changedView: function changedView() {
      this.changedShow = false;
    },
    getDateTimestamp: function getDateTimestamp(date) {
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(date).unix() + Math.abs(date.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_14__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },


    getPageBehaviors: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clientId, protocolId, antecedentId, behaviorId, perPage, page, startDate, endDate) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setBehaviors({ clientId: clientId, protocolId: protocolId, antecedentId: antecedentId, behaviorId: behaviorId, perPage: perPage, page: page, startDate: startDate, endDate: endDate });

              case 2:

                this.onPaginationBtnClick(page);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPageBehaviors(_x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
        return _ref4.apply(this, arguments);
      }

      return getPageBehaviors;
    }(),

    onModalCancel: function onModalCancel() {
      this.isModalVisible = false;
      this.isEditModalVisible = false;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isEditModalVisible = false;
      this.applyFilter();
    },
    onEditBtnClick: function onEditBtnClick() {
      this.isEditModalVisible = true;
    },


    onSearchProtocol: __WEBPACK_IMPORTED_MODULE_24_lodash_debounce___default()(function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(search) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_23__reports_api_Manager__["a" /* default */].getProtocols(this.clientId, 500, 1, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp, null, search, true);

              case 2:
                response = _context4.sent;


                this.protocolList = response.data.data.items;

                this.protocolList.unshift({
                  protocolId: 'all',
                  title: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.all_protocol'),
                  id: 'all'
                });
                this.protocolList.unshift({
                  protocolId: 'time',
                  title: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.hours_24'),
                  id: null
                });

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function (_x11) {
        return _ref5.apply(this, arguments);
      };
    }(), 500),

    nextAncedentPage: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this6 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.isLastAncedentPage) {
                  _context5.next = 9;
                  break;
                }

                this.loading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__["a" /* default */].getAncedents(this.clientId, this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null, null, this.perPage, this.pageAncedents, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 4:
                response = _context5.sent;


                response.data.data.items.forEach(function (item) {
                  _this6.ancedents.push(item);
                });

                if (response) {
                  this.loading = false;
                }
                this.lastAncedentId = this.ancedents[this.ancedents.length - 1].id;
                if (response.data.data.hasMorePages) {
                  this.pageAncedents++;
                } else {
                  this.isLastAncedentPage = true;
                }

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function nextAncedentPage() {
        return _ref6.apply(this, arguments);
      }

      return nextAncedentPage;
    }(),

    nextBehaviorsPage: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _this7 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.isLastBehaviorsPage) {
                  _context6.next = 9;
                  break;
                }

                this.loading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__["a" /* default */].getBehaviors(this.clientId, this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null, null, this.perPage, this.pageBehaviors, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 4:
                response = _context6.sent;


                response.data.data.items.forEach(function (item) {
                  _this7.behaviorsList.push(item);
                });

                if (response) {
                  this.loading = false;
                }
                this.lastBehaviorsId = this.behaviorsList[this.behaviorsList.length - 1].id;

                if (response.data.data.hasMorePages) {
                  this.pageBehaviors++;
                } else {
                  this.isLastBehaviorsPage = true;
                }

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function nextBehaviorsPage() {
        return _ref7.apply(this, arguments);
      }

      return nextBehaviorsPage;
    }(),

    getOptionAncedentTitle: function getOptionAncedentTitle(_ref8) {
      var option = _ref8.option;

      return option.text;
    },

    getOptionBehaviorsTitle: function getOptionBehaviorsTitle(_ref9) {
      var option = _ref9.option;

      return option.text;
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    },
    isAdded: function isAdded() {
      if (this.isAdded) {
        this.onSendRequest();
      }
    },
    protocol: function protocol() {
      this.ancedentId = null;
      this.behaviorId = null;
      this.isLastAncedentPage = false;
      this.isLastBehaviorsPage = false;
      this.ancedents = [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.all_ancedent') }];
      this.pageBehaviors = 1;
      this.pageAncedents = 1;
      this.behaviorId = null;
      this.lastBehaviorsId = null;
      this.behaviorsList = [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('report.all') }];
      this.nextAncedentPage();
      this.nextBehaviorsPage();
    },
    rangeDateStart: function rangeDateStart(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateStart = oldValue;
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_15_moment___default()(newValue).format('DD.MM.YYYY') === __WEBPACK_IMPORTED_MODULE_15_moment___default()(oldValue).format('DD.MM.YYYY')) {
        return;
      }

      if (!!oldValue) {
        this.protocol = {
          protocolId: 'time',
          title: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.hours_24')
        };
        this.onSearchProtocol();
      }
    },
    rangeDateEnd: function rangeDateEnd(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateEnd = oldValue;
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_15_moment___default()(newValue).format('DD.MM.YYYY') === __WEBPACK_IMPORTED_MODULE_15_moment___default()(oldValue).format('DD.MM.YYYY')) {
        return;
      }

      if (!!oldValue) {

        this.protocol = {
          protocolId: 'time',
          title: __WEBPACK_IMPORTED_MODULE_17__lang_translator__["a" /* default */].get('behavior.hours_24')
        };
        this.onSearchProtocol();
      }
    },
    clientTimezone: function clientTimezone() {
      if (this.clientTimezone) {
        this.setDate();
      }
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorChart_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8065f54c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorChart_vue__ = __webpack_require__(1076);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8065f54c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddModal__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editTypicalBehaviorsModal_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_chart__ = __webpack_require__(17);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    clientId: null,
    rangeDateStart: null,
    rangeDateEnd: null,
    protocolId: null,
    ancedentId: null,
    behaviorId: null,
    isApplyChanges: false
  },
  data: function data() {
    return {
      activeBehaviorId: null,
      isModalVisible: false,
      isEditModalVisible: false,
      measurements: [],
      antecedentTypes: null,
      consequenceInBehavior: null,
      behaviorTypes: null,
      effectsTypes: null,
      antecedentLegend: null,
      behaviorLegend: null,
      effectsLegend: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      protocolList: [],
      protocol: null,
      disabledSelect: false,
      loading: false,
      lastAncedentId: null,
      ancedents: [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.ancedent') }],
      isLastAncedentPage: false,
      pageBehaviors: 1,
      pageAncedents: 1,
      lastBehaviorsId: null,
      behaviorsList: [{ id: "all", text: __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.all_option') }],
      isLastBehaviorsPage: false,
      scatterplotData: [],
      scatterplotXLabels: [],
      scatterplotYLabels: []
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__["a" /* pagination */], __WEBPACK_IMPORTED_MODULE_7__common_mixins_showModal__["a" /* showModal */]],

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_19__common_chart__["c" /* LineChart */],
    Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */],
    undesirableBehaviorAddModal: __WEBPACK_IMPORTED_MODULE_4__AddModal__["a" /* default */],
    editTypicalBehaviorsModal: __WEBPACK_IMPORTED_MODULE_5__editTypicalBehaviorsModal_vue__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_19__common_chart__["a" /* BarChart */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])('behavior', ['behaviors', 'isLoaded', 'isAdded', 'paginateData']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])(['route']), {
    isEmptyBehavior: function isEmptyBehavior() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.behaviors);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden', 'isClient']), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapState */])('behavior', ['typicalBehaviors']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_13__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_13__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    lineChartDataset: function lineChartDataset() {
      return [this.fetchLineDatasetForChart()];
    },
    barChartAncedentDataset: function barChartAncedentDataset() {
      return this.fetchBarDatasetForChart(this.antecedentTypes, __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.ancedent'));
    },
    barChartBehaviorDataset: function barChartBehaviorDataset() {
      return this.fetchBarDatasetForChart(this.behaviorTypes, __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.unwanted_behavior'));
    },
    barChartEffectsDataset: function barChartEffectsDataset() {
      return this.fetchBarDatasetForChart(this.effectsTypes, __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.aftermath'));
    },
    barChartConsequenceInBehaviorDataset: function barChartConsequenceInBehaviorDataset() {
      return this.fetchBarDatasetForChart(this.consequenceInBehavior, __WEBPACK_IMPORTED_MODULE_16__lang_translator__["a" /* default */].get('behavior.aftermath'));
    }
  }),

  methods: {
    onSetAncedentSelected: function onSetAncedentSelected(selected) {
      this.ancedentId = selected;
    },
    onSetBehaviorsSelected: function onSetBehaviorsSelected(selected) {
      this.behaviorId = selected;
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
    },

    fetchLineDatasetForChart: function fetchLineDatasetForChart() {
      var _this = this;

      var data = [],
          i = 0;
      __WEBPACK_IMPORTED_MODULE_17_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: _this.toLocaleDate(item.dateRange.end),
          y: item.perHourCount
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_19__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      if (color == '#255255') return '#333333';
      return color;
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart(listTypes, name) {
      var _this2 = this;

      var data = [],
          i = 0,
          label = name,
          backgroundColor = void 0,
          datasets = [],
          legends = [];

      var types = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(listTypes, 'count', 'desc');

      __WEBPACK_IMPORTED_MODULE_17_lodash_forEach___default()(types, function (item) {
        data = [{
          x: ++i,
          y: item.count
        }];
        label = item.title;
        backgroundColor = _this2.getRandomColor();
        legends.push({
          label: label,
          background: backgroundColor
        });

        datasets.push(new __WEBPACK_IMPORTED_MODULE_19__common_chart__["b" /* BarChartDataset */]({
          data: data, label: label, labels: legends, backgroundColor: backgroundColor, borderColor: backgroundColor
        }));
      });

      return datasets;
    },
    getDateTimestamp: function getDateTimestamp(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).unix() + Math.abs(date.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_13__Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },


    fetchMeasurement: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.getCountBehavior();

              case 3:
                _context.next = 5;
                return this.getCountTypes();

              case 5:
                _context.next = 7;
                return this.getScatterplotData();

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 12:
                _context.prev = 12;

                this.$emit('changedView');
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 12, 15]]);
      }));

      function fetchMeasurement() {
        return _ref.apply(this, arguments);
      }

      return fetchMeasurement;
    }(),

    getCountBehavior: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__["a" /* default */].getCountBehavior(this.clientId, this.protocolId, this.ancedentId, this.behaviorId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 2:
                response = _context2.sent;

                this.measurements = response.data.data;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCountBehavior() {
        return _ref2.apply(this, arguments);
      }

      return getCountBehavior;
    }(),

    getCountTypes: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var responseTypes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__["a" /* default */].getCountTypes(this.clientId, this.protocolId, this.ancedentId, this.behaviorId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 2:
                responseTypes = _context3.sent;

                this.antecedentTypes = responseTypes.data.data.antecedent;
                this.behaviorTypes = responseTypes.data.data.behavior;
                this.effectsTypes = responseTypes.data.data.effects;
                this.consequenceInBehavior = responseTypes.data.data.consequenceInBehavior;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCountTypes() {
        return _ref3.apply(this, arguments);
      }

      return getCountTypes;
    }(),

    getScatterplotData: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__api_undesirableBehavior__["a" /* default */].getScatterplotData(this.clientId, this.protocolId, this.ancedentId, this.behaviorId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 2:
                response = _context4.sent;

                this.scatterplotData = response.data.data.statistic;
                this.scatterplotXLabels = response.data.data.dates;
                this.scatterplotYLabels = __WEBPACK_IMPORTED_MODULE_13__Constants__["a" /* default */].scatterplotYLabels;

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getScatterplotData() {
        return _ref4.apply(this, arguments);
      }

      return getScatterplotData;
    }(),

    currentScatterplotValue: function currentScatterplotValue(data, value) {

      var current = __WEBPACK_IMPORTED_MODULE_12_lodash_filter___default()(value, function (item) {
        return item.date === data;
      });

      return current.length ? current[0].totalCount : null;
    },


    getOptionAncedentTitle: function getOptionAncedentTitle(_ref5) {
      var option = _ref5.option;

      return option.text;
    },

    getOptionBehaviorsTitle: function getOptionBehaviorsTitle(_ref6) {
      var option = _ref6.option;

      return option.text;
    }

  },
  watch: {
    isApplyChanges: function isApplyChanges(newValue) {
      if (newValue) {
        this.fetchMeasurement();
      }
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTypicalBehaviorsModal_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1354d9ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTypicalBehaviorsModal_vue__ = __webpack_require__(1075);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTypicalBehaviorsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1354d9ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTypicalBehaviorsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_undesirableBehavior__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);






var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editTypicalBehaviorsModal',
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      typicalAncedent: [],
      removedTypicalAncedent: [],
      typicalBehavior: [],
      typicalConsequenceInBehavior: [],
      removedTypicalConsequenceInBehavior: [],
      removedTypicalBehavior: [],
      typicalEffects: [],
      removedTypicalEffect: [],
      newTypicalAncedent: {
        text: '',
        id: null
      },
      newTypicalBehavior: {
        text: '',
        id: null
      },
      newTypicalEffect: {
        text: '',
        id: null
      },
      newTypicalConsequenceInBehavior: {
        text: '',
        id: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden', 'isClient']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])('behavior', ['typicalBehaviors'])),
  created: function created() {
    if (this.clientId) {
      this.setTypesBehaviors(this.clientId);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('behavior', ['setTypesBehaviors']), (_extends2 = {
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;

                if (!result) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__api_undesirableBehavior__["a" /* default */].saveTypes(_this.clientId, _this.typicalAncedent, _this.typicalBehavior, _this.typicalEffects, _this.typicalConsequenceInBehavior);

              case 7:
                response = _context.sent;

                _this.setTypesBehaviors(_this.clientId);
                _this.close();
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](4);

                console.dir(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 12]]);
      }))();
    },
    addAncedent: function addAncedent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ancedent, result, uniqueCounter, i, _i;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ancedent = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this2.newTypicalAncedent);

                if (!(_this2.typicalAncedent.length < __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 4;
                return _this2.$validator.validateAll();

              case 4:
                result = _context2.sent;


                if (result && ancedent.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.typicalAncedent).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this2.typicalAncedent[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(ancedent.text.toLowerCase())) {
                      uniqueCounter++;
                    }
                  }

                  for (_i = 0; _i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.removedTypicalAncedent).length; _i++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this2.removedTypicalAncedent[_i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(ancedent.text.toLowerCase())) {
                      ancedent = _this2.removedTypicalAncedent[_i];
                    }
                  }

                  if (uniqueCounter === 0) {
                    ancedent.createdAt = Math.round(new Date().getTime() / 1000);
                    _this2.typicalAncedent.push(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(ancedent));
                    _this2.newTypicalAncedent.text = '';
                  } else {
                    _this2.errors.add({
                      field: 'isNotUniqueAncedent',
                      msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unique_ancedent')
                    });
                  }
                } else if (ancedent.text === '') {
                  _this2.errors.add({
                    field: 'isEmptyErrorAncedent',
                    msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.need_choice_ancedent')
                  });
                }
                _context2.next = 10;
                break;

              case 8:
                console.info("isMaxLengthAncedent");
                _this2.errors.add({
                  field: 'isMaxLengthAncedent',
                  msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.maxlength_ancedent')
                });

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    addBehavior: function addBehavior() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var behavior, result, uniqueCounter, i, _i2;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                behavior = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this3.newTypicalBehavior);

                if (!(_this3.typicalBehavior.length < __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 4;
                return _this3.$validator.validateAll();

              case 4:
                result = _context3.sent;


                if (result && behavior.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.typicalBehavior).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this3.typicalBehavior[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(behavior.text.toLowerCase())) {
                      uniqueCounter++;
                    }
                  }

                  for (_i2 = 0; _i2 < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.removedTypicalBehavior).length; _i2++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this3.removedTypicalBehavior[_i2].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(behavior.text.toLowerCase())) {
                      behavior = _this3.removedTypicalBehavior[_i2];
                    }
                  }

                  if (uniqueCounter === 0) {
                    behavior.createdAt = Math.round(new Date().getTime() / 1000);
                    _this3.typicalBehavior.push(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(behavior));
                    _this3.newTypicalBehavior.text = '';
                  } else {
                    _this3.errors.add({
                      field: 'isNotUniqueBehavior',
                      msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unique_behaviors')
                    });
                  }
                } else if (behavior.text === '') {
                  _this3.errors.add({
                    field: 'isEmptyErrorBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.need_choice_behavior')
                  });
                }
                _context3.next = 9;
                break;

              case 8:
                _this3.errors.add({
                  field: 'isMaxLengthBehavior',
                  msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.maxlength_behaviors')
                });

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addConsequenceInBehavior: function addConsequenceInBehavior() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var consequenceInBehavior, result, uniqueCounter, i, _i3;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                consequenceInBehavior = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this4.newTypicalConsequenceInBehavior);

                if (!(_this4.typicalConsequenceInBehavior.length < __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return _this4.$validator.validateAll();

              case 4:
                result = _context4.sent;


                if (result && behavior.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.typicalConsequenceInBehavior).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this4.typicalConsequenceInBehavior[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(consequenceInBehavior.text.toLowerCase())) {
                      uniqueCounter++;
                    }
                  }

                  for (_i3 = 0; _i3 < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.removedTypicalConsequenceInBehavior).length; _i3++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this4.removedTypicalConsequenceInBehavior[_i3].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(consequenceInBehavior.text.toLowerCase())) {
                      consequenceInBehavior = _this4.removedTypicalConsequenceInBehavior[_i3];
                    }
                  }

                  if (uniqueCounter === 0) {
                    consequenceInBehavior.createdAt = Math.round(new Date().getTime() / 1000);
                    _this4.typicalConsequenceInBehavior.push(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(consequenceInBehavior));
                    _this4.newTypicalConsequenceInBehavior.text = '';
                  } else {
                    _this4.errors.add({
                      field: 'isNotUniqueBehavior',
                      msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unique_behaviors')
                    });
                  }
                } else if (consequenceInBehavior.text === '') {
                  _this4.errors.add({
                    field: 'isEmptyErrorBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.need_choice_behavior')
                  });
                }
                _context4.next = 9;
                break;

              case 8:
                _this4.errors.add({
                  field: 'isMaxLengthBehavior',
                  msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.maxlength_behaviors')
                });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addEffect: function addEffect() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var effect, result, uniqueCounter, i, _i4;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                effect = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this5.newTypicalEffect);

                if (!(_this5.typicalEffects.length < __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* default */].MAX_LENGTH)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 4;
                return _this5.$validator.validateAll();

              case 4:
                result = _context5.sent;


                if (result && effect.text !== '') {
                  uniqueCounter = 0;


                  for (i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.typicalEffects).length; i++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this5.typicalEffects[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(effect.text.toLowerCase())) {
                      uniqueCounter++;
                    }
                  }

                  for (_i4 = 0; _i4 < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.removedTypicalEffect).length; _i4++) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this5.removedTypicalEffect[_i4].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(effect.text.toLowerCase())) {
                      effect = _this5.removedTypicalEffect[_i4];
                    }
                  }

                  if (uniqueCounter === 0) {
                    effect.createdAt = Math.round(new Date().getTime() / 1000);
                    _this5.typicalEffects.push(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(effect));
                    _this5.newTypicalEffect.text = '';
                  } else {
                    _this5.errors.add({
                      field: 'isNotUniqueEffect',
                      msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unique_aftermath')
                    });
                  }
                } else if (effect.text === '') {
                  _this5.errors.add({
                    field: 'isEmptyErrorEffect',
                    msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.need_choice_aftermath')
                  });
                }
                _context5.next = 9;
                break;

              case 8:
                _this5.errors.add({
                  field: 'isMaxLengthEffect',
                  msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.maxlength_aftermath')
                });

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'addConsequenceInBehavior', function addConsequenceInBehavior() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var consequenceInBehavior, result, uniqueCounter, i, _i5;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              consequenceInBehavior = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(_this6.newTypicalConsequenceInBehavior);

              if (!(_this6.typicalConsequenceInBehavior.length < __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* default */].MAX_LENGTH)) {
                _context6.next = 8;
                break;
              }

              _context6.next = 4;
              return _this6.$validator.validateAll();

            case 4:
              result = _context6.sent;


              if (result && consequenceInBehavior.text !== '') {
                uniqueCounter = 0;


                for (i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this6.typicalConsequenceInBehavior).length; i++) {
                  if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this6.typicalConsequenceInBehavior[i].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(consequenceInBehavior.text.toLowerCase())) {
                    uniqueCounter++;
                  }
                }

                for (_i5 = 0; _i5 < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this6.removedTypicalConsequenceInBehavior).length; _i5++) {
                  if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(_this6.removedTypicalConsequenceInBehavior[_i5].text.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(consequenceInBehavior.text.toLowerCase())) {
                    consequenceInBehavior = _this6.removedTypicalConsequenceInBehavior[_i5];
                  }
                }

                if (uniqueCounter === 0) {
                  consequenceInBehavior.createdAt = Math.round(new Date().getTime() / 1000);
                  _this6.typicalConsequenceInBehavior.push(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(consequenceInBehavior));
                  _this6.newTypicalConsequenceInBehavior.text = '';
                } else {
                  _this6.errors.add({
                    field: 'isNotUniqueConsequenceInBehavior',
                    msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unique_aftermath')
                  });
                }
              } else if (consequenceInBehavior.text === '') {
                _this6.errors.add({
                  field: 'isEmptyErrorConsequenceInBehavior',
                  msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.need_choice_aftermath')
                });
              }
              _context6.next = 9;
              break;

            case 8:
              _this6.errors.add({
                field: 'isMaxLengthConsequenceInBehavior',
                msg: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.maxlength_aftermath')
              });

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'removeAncedent', function removeAncedent(index, item) {
    this.removedTypicalAncedent.push(item);
    this.typicalAncedent.splice(index, 1);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'removeBehavior', function removeBehavior(index, item) {
    this.removedTypicalBehavior.push(item);
    this.typicalBehavior.splice(index, 1);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'removeEffect', function removeEffect(index, item) {
    this.removedTypicalEffect.push(item);
    this.typicalEffects.splice(index, 1);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'removeConsequenceInBehavior', function removeConsequenceInBehavior(index, item) {
    this.removedTypicalConsequenceInBehavior.push(item);
    this.typicalConsequenceInBehavior.splice(index, 1);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'reset', function reset() {
    this.newTypicalAncedent.text = '';
    this.newTypicalBehavior.text = '';
    this.newTypicalEffect.text = '';
    this.newTypicalConsequenceInBehavior.text = '';
    this.removedTypicalAncedent = [];
    this.removedTypicalBehavior = [];
    this.removedTypicalEffect = [];
    this.removedTypicalConsequenceInBehavior = [];
    this.errors.clear();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'close', function close() {
    this.reset();
    this.$emit('close');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'cancel', function cancel() {
    this.reset();
    this.$emit('cancel');
  }), _extends2)),
  watch: {
    typicalBehaviors: function typicalBehaviors() {
      this.typicalAncedent = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalBehaviors.antecedentTypes);
      this.typicalBehavior = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalBehaviors.behaviorTypes);
      this.typicalEffects = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalBehaviors.effectsTypes);
      this.typicalConsequenceInBehavior = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.typicalBehaviors.consequenceInBehaviorTypes);

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalAncedent, function (item) {
        if (item.createdAt) {
          var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
          item.createdAt = convertDate;
        }
      });

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalBehavior, function (item) {
        if (item.createdAt) {
          var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
          item.createdAt = convertDate;
        }
      });

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalEffects, function (item) {
        if (item.createdAt) {
          var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
          item.createdAt = convertDate;
        }
      });

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.typicalConsequenceInBehavior, function (item) {
        if (item.createdAt) {
          var convertDate = Math.round(new Date(item.createdAt.date).getTime() / 1000);
          item.createdAt = convertDate;
        }
      });
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var Manager = function () {
  function Manager() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    this.baseUrl = "https://app.autismtech.online/api" + '/protocols/statistics';
    this.baseUrlUsers = "https://app.autismtech.online/api" + '/users';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'getClinicalCenters',
    value: function getClinicalCenters(perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/clinicalCenters', {
        params: { perPage: perPage, page: page }
      });
    }
  }, {
    key: 'getClinicalCenter',
    value: function getClinicalCenter(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrlUsers + '/centers/show/' + id);
    }
  }, {
    key: 'getClients',
    value: function getClients(clinicalCenterId, perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/clients/', {
        params: {
          clinicalCenterId: clinicalCenterId ? clinicalCenterId : null,
          perPage: perPage,
          page: page
        }
      });
    }
  }, {
    key: 'getClient',
    value: function getClient(clientId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrlUsers + '/clients/' + clientId);
    }
  }, {
    key: 'getSkillField',
    value: function getSkillField(clientId, perPage, page, startDate, endDate, search) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/skill-fields/', {
        params: {
          clientId: clientId,
          perPage: perPage,
          page: page,
          startDate: startDate,
          endDate: endDate,
          search: search
        }
      });
    }
  }, {
    key: 'getProtocols',
    value: function getProtocols(clientId, perPage, page, startDate, endDate, skillFieldId, search, withUndesirableBehavior) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/protocols/' + clientId, {
        params: {
          perPage: perPage,
          page: page,
          startDate: startDate,
          endDate: endDate,
          skillFieldId: skillFieldId,
          withUndesirableBehavior: withUndesirableBehavior,
          search: search
        }
      });
    }
  }, {
    key: 'getStatistics',
    value: function getStatistics(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId, levelLineChecked, trendLineChecked, ScatterLineChecked, graphMoYesPercentChecked, graphTotalPercentChecked, graphPromptLevelsChecked, graphImprovedSPOUChecked, graphMoYesChecked, graphProbeFullChecked, graphMoGoalChecked, graphMandReactChecked, graphGoalChecked, graphCumulativeImproveChecked, graphImprovePromptChecked, graphImproveChecked, graphCumulitiveChecked, showAbsolute, showRelative, showGraphUndesirableBehaviors, undesirableBehaviorGraphType, undesirableBehaviorBehaviorId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/' + clientId, {
        params: {
          perPage: perPage,
          page: page,
          startDate: startDate,
          endDate: endDate,
          skillFieldId: skillFieldId,
          protocolId: protocolId,
          levelLineChecked: levelLineChecked,
          trendLineChecked: trendLineChecked,
          ScatterLineChecked: ScatterLineChecked,
          graphMoYesPercentChecked: graphMoYesPercentChecked,
          graphTotalPercentChecked: graphTotalPercentChecked,
          graphPromptLevelsChecked: graphPromptLevelsChecked,
          graphImprovedSPOUChecked: graphImprovedSPOUChecked,
          graphMoYesChecked: graphMoYesChecked,
          graphProbeFullChecked: graphProbeFullChecked,
          graphMoGoalChecked: graphMoGoalChecked,
          graphMandReactChecked: graphMandReactChecked,
          graphGoalChecked: graphGoalChecked,
          graphCumulativeImproveChecked: graphCumulativeImproveChecked,
          graphImprovePromptChecked: graphImprovePromptChecked,
          graphImproveChecked: graphImproveChecked,
          graphCumulitiveChecked: graphCumulitiveChecked,
          showAbsolute: showAbsolute,
          showRelative: showRelative,
          showGraphUndesirableBehaviors: showGraphUndesirableBehaviors,
          undesirableBehaviorGraphType: undesirableBehaviorGraphType,
          undesirableBehaviorBehaviorId: undesirableBehaviorBehaviorId
        }
      });
    }
  }, {
    key: 'getEfficiency',
    value: function getEfficiency(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/efficiency/' + clientId, {
        params: {
          perPage: perPage,
          page: page,
          startDate: startDate,
          endDate: endDate,
          skillFieldId: skillFieldId,
          protocolId: protocolId
        }
      });
    }
  }, {
    key: 'getEfficiency',
    value: function getEfficiency(clientId, perPage, page, startDate, endDate, skillFieldId, protocolId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/efficiency/' + clientId, {
        params: {
          perPage: perPage,
          page: page,
          startDate: startDate,
          endDate: endDate,
          skillFieldId: skillFieldId,
          protocolId: protocolId
        }
      });
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Manager());

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_toggleView_components_ToggleView__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'protocolData'],

  data: function data() {
    return {
      apiUrl: '/protocols/assigned/',
      statusId: null,
      teachingMethodId: null,
      assignedProtocol: {
        id: null,
        assigneeId: null,
        assignorId: null,
        status: {},
        passedStages: [],
        activeStage: {},
        beginDate: null,
        endDate: null
      },
      protocol: {
        id: null,
        title: null,
        skillField: null,
        goal: null,
        execution: null,
        dataFields: [],
        published: null,
        createdAt: null,
        updatedAt: null,
        deletedAt: null,
        stages: []
      },
      dataFields: ['code1', 'code2', 'features', 'instruction', 'provideHint', 'reductionHint', 'rightReaction', 'errorCorrection', 'templateTitle', 'taskType', 'skillField', 'goal', 'execution']

    };
  },


  components: { ToogleView: __WEBPACK_IMPORTED_MODULE_4__common_toggleView_components_ToggleView__["a" /* default */] },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isMensurationForbidden']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])(['route']), {
    activeProtocolList: function activeProtocolList() {

      var activeList = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocolData.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return activeList;
    }
  }),

  methods: {

    isCompleted: function isCompleted() {
      return this.statusId === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].COMPLETED;
    },
    isOnIndividualization: function isOnIndividualization() {
      return this.statusId === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION;
    },
    isDtt: function isDtt() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].DTT;
    },

    isMand: function isMand() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].MAND;
    },

    isUSD: function isUSD() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].USD;
    },

    isChain: function isChain() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].CHAIN;
    },
    isShaping: function isShaping() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].SHAPING;
    },

    isSimple: function isSimple() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].SIMPLE;
    },

    isPecs: function isPecs() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].PECS;
    },

    isPecsWithoutDiscrimination: function isPecsWithoutDiscrimination() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].PECSDESTINATION;
    },

    isPecsWithItems: function isPecsWithItems() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].PECSWITHITEMS;
    },

    isPecsWithDiscrimination: function isPecsWithDiscrimination() {
      return this.teachingMethodId.toString() === __WEBPACK_IMPORTED_MODULE_6__protocols_constants_js__["d" /* PROTOCOL_TYPE */].PECSWITHDISCRIMINATION;
    },

    fetchProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (this.protocolData) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + id + '/info');

              case 4:
                response = _context.sent;


                this.protocol = response.data.data.protocol;
                this.assignedProtocol = response.data.data;
                this.statusId = response.data.data.status.id;
                _context.next = 13;
                break;

              case 10:
                this.protocol = this.protocolData.protocol;
                this.assignedProtocol = this.protocolData;
                this.statusId = this.protocolData.status.id;

              case 13:

                this.teachingMethodId = this.protocol.teachingMethod.id;
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);
                this.isClient ? this.$router.push({ name: 'available-protocols' }) : this.$router.push({ name: 'client' });

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function fetchProtocol(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchProtocol;
    }(),

    otherFields: function otherFields(key) {
      return !this.dataFields.includes(key);
    },

    loadProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isNew = false;
                _context2.next = 3;
                return this.fetchProtocol(this.protocolId);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadProtocol() {
        return _ref2.apply(this, arguments);
      }

      return loadProtocol;
    }()

  },
  created: function created() {
    this.loadProtocol();
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShowAll: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  methods: {

    toggleShow: function toggleShow() {
      this.isShowAll = !this.isShowAll;
    }

  }

});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNull__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_forEach__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'client', 'stageId'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['getUserInfo', 'isBCBA', 'isTherapist', 'isCurator', 'isClient', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    minDate: function minDate() {
      return this.endDate ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = this.isChangedDate ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.minDate).add(-1, 'minutes').unix() : __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.minDate).unix();
        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_21_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    activeStageCount: function activeStageCount() {
      var activeList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.protocolVuexData.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return this.protocolVuexData && this.protocolVuexData.protocol.stages ? activeList.length : 0;
    }
  }),

  data: function data() {
    return {
      apiUrl: '/protocols/assigned/simple/',
      apiProtocolUrl: '/protocols/assigned/',
      close: true,
      disabled: false,
      btnDisabled: false,
      isLoaded: false,
      protocols: null,
      attemptsCount: 0,
      showSessionView: true,
      activeStep: [],
      execution: '',
      stimulus: [],
      stimulList: [],
      stimulListTimeout: [],
      stimulusList: [],
      attempts: {},
      activeAttempt: [],
      isVirtualStage: false,
      currentSesssionDate: null,
      addStimulusItem: null,
      checked: true,
      isActive: false,
      isModalVisible: false,
      title: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      continueSession: false,
      uiid: null,
      stimulusListEmpty: false,
      chooseStimuli: true,
      disabledSpo: true,
      timerId: null,
      isModalSessionVisible: false,
      totalAtemptsCount: 0,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 59],
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      rangeDateStart: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      duration: null,
      maxDateStart: this.getMaxDateStart(new Date()),
      showChangeDateSession: false,
      showSpoSession: false,
      showSpoStartedDay: null,
      showSpoDuration: null,
      newTasks: [],
      type: null,
      closeLastSession: false,
      disabledSave: true,
      endDate: null,
      majorVersion: null,
      isChangedDate: false
    };
  },


  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__["TabContent"],
    WizardButton: __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__["WizardButton"],
    Instruction: __WEBPACK_IMPORTED_MODULE_6__common_instruction_components_InstructionView__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__["a" /* default */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_20_vue2_timepicker___default.a
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.initProtocols();

            case 2:
              _this2.endDate = _this2.protocols.endDate;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {

    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_21_moment___default()().tz(this.client.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_21_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_21_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    addStimulus: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(item) {
        var that, unique, uuid, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = this;
                unique = true;
                uuid = __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4();
                _context3.next = 5;
                return this.$validator.validate();

              case 5:
                result = _context3.sent;

                if (result) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt('return');

              case 8:

                if (item) {

                  __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(this.activeStep.globalTasks, function (stimul) {
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_8_lodash_trim___default()(item.toLowerCase())) {
                      unique = false;
                    }
                  });

                  if (unique) {

                    this.$set(this.stimulusList, this.stimulusList.length, {
                      attempt: 0,
                      id: null,
                      globalUuid: uuid,
                      description: item,
                      answer: null,
                      attemptAnswers: [],
                      percent: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.task_types.answers.no_data'),
                      attepmtsCount: '1',
                      lastAnswers: [],
                      answers: [],
                      lastAnswersCount: []
                    });

                    this.stimulusListEmpty = false;

                    this.newTasks.push({
                      globalUuid: uuid,
                      description: item
                    });

                    this.addStimulusItem = null;
                    this.disabledSave = false;
                    this.errors.clear();
                  } else {
                    this.errors.add({
                      field: 'addStimulusItem',
                      msg: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
                    });
                  }
                } else {
                  this.errors.add({
                    field: 'addStimulusItem',
                    msg: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.stimulus_required')
                  });
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addStimulus(_x) {
        return _ref.apply(this, arguments);
      }

      return addStimulus;
    }(),

    attemptChange: function attemptChange(answer, globalUuid, title, answerCount) {
      var _this3 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
        this.stimulusList = this.stimulListTimeout;
      }

      this.stimulListTimeout = __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default()(this.stimulusList);

      var answerListCount = __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger___default()(answerCount);
      var answerList = __WEBPACK_IMPORTED_MODULE_18_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_18_lodash_fill___default()(new Array(answerListCount), answer);

      __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(this.stimulListTimeout, function (item) {
        if (item.globalUuid == globalUuid) {
          _this3.totalAtemptsCount = _this3.totalAtemptsCount + answerListCount;

          if (_this3.totalAtemptsCount <= _this3.maxTotalAtemptsCount) {
            _this3.disabledSave = false;
            _this3.maxTotalAtemptsCountError = false;

            item.attemptAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default()(item.attemptAnswers, answerListId);
            item.attempt = item.attempt + answerListCount;
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default()(item.lastAnswers, answerList);
            item.answersName = __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default()(item.answersName, answerList);
            item.lastAnswersCount.push(answerCount);
            item.answers = __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default()(item.answers, answerListId);
          }

          if (_this3.totalAtemptsCount > _this3.maxTotalAtemptsCount) {
            _this3.disabledSave = true;
            _this3.maxTotalAtemptsCountError = true;
            _this3.totalAtemptsCount = _this3.totalAtemptsCount - answerListCount;
          }

          item.answer = null;
          item.attepmtsCount = 1;
        }
      });

      this.disabledSpo = false;

      this.timerId = setTimeout(function () {
        _this3.stimulusList = _this3.stimulListTimeout;
      }, 300);
    },

    backToPreviousAttempt: function backToPreviousAttempt(globalUuid) {
      var _this4 = this;

      var stimuls = this.stimulusList;
      var answer = 0;

      __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(stimuls, function (item, key) {
        if (item.globalUuid == globalUuid) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.attemptAnswers = __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight___default()(item.attemptAnswers, lastAnswersCount);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.answersName = __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight___default()(item.answersName, lastAnswersCount);
          item.answers = __WEBPACK_IMPORTED_MODULE_16_lodash_dropRight___default()(item.answers, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this4.totalAtemptsCount = _this4.totalAtemptsCount - lastAnswersCount;
          item.lastAnswersCount.pop();
        }
        if (item.attempt > 0) {
          answer++;
        }

        _this4.$set(stimuls, key, item);
      });

      if (!this.totalAtemptsCount) {
        this.disabledSave = true;
      }

      if (answer == 0) {
        this.disabledSpo = true;
      }
    },

    showSession: function showSession() {
      var _this5 = this;

      this.uiid = __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4();
      var entity = {
        id: this.uiid,
        type: 'assigned-session'
      };

      this.setEntity(entity);

      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default()(this.attempts)) {
        delete this.attempts;
        this.attempts = {};
      }

      this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
      this.attemptsCount = this.isVirtualStage && this.activeStep.type.id == 5 || this.activeStep.type.id != 5 ? 3000 : 1;

      this.stimulusList = {};

      var virtualTasks = this.isVirtualStage ? this.activeStep.virtualStage.globalTasks : [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default()(this.stimulList, function (item, key) {

        if (_this5.isVirtualStage) {

          var currentTask = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(virtualTasks, function (itemVirtual) {
            return itemVirtual.uuid === item.globalUuid;
          });

          if (currentTask.length) {
            _this5.stimulusList[key] = {
              globalUuid: item.globalUuid,
              description: item.description,
              answer: null,
              position: item.position,
              lastAnswers: item.lastAnswers,
              answers: [],
              attepmtsCount: '1',
              lastAnswersCount: [],
              answersName: [],
              attempt: 0
            };
          }
        } else {

          _this5.$set(_this5.stimulusList, key, {
            globalUuid: item.globalUuid,
            description: item.description,
            answer: null,
            position: item.position,
            lastAnswers: _this5.isVirtualStage && _this5.activeStep.type.id == 5 || _this5.activeStep.type.id != 5 ? item.lastAnswers : [],
            answers: [],
            attepmtsCount: '1',
            lastAnswersCount: [],
            answersName: [],
            attempt: 0
          });
        }
      });

      this.stimulusList = __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy___default()(this.stimulusList, 'position');
      this.stimulListTimeout = this.stimulusList;

      if (!this.stimulList.length) {
        this.stimulusListEmpty = true;
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.protocols.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.confirm_close_all');
      }
      this.isModalVisible = true;
    },

    saveSessionStage: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(close) {
        var _this6 = this;

        var that, isSaved, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, startDate, finishedAt, _clientTimeZoneOffset, sessionSpoDate, duration, stimuli;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();
                this.disabledSave = true;

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousDate && this.previousTime.HH && this.previousTime.mm) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_21_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                startDate = this.isPreviousDateSession && this.previousDate && this.previousTime.HH && this.previousTime.mm ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession && this.previousDate && this.previousTime.HH && this.previousTime.mm ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);


                if (this.showSpoStartedDay) {
                  _clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_21_moment___default()().tz(this.client.timezone)._offset;
                  sessionSpoDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  duration = this.previousDuration ? this.previousDuration : this.showSpoDuration;


                  startDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(sessionSpoDate).unix() - Math.abs(_clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  finishedAt = __WEBPACK_IMPORTED_MODULE_21_moment___default()(sessionSpoDate).unix() - Math.abs(_clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + duration * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                stimuli = __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default()(this.stimulusList);


                stimuli = __WEBPACK_IMPORTED_MODULE_24_lodash_map___default()(stimuli, function (stimul) {
                  delete stimul['lastAnswers'];
                  delete stimul['answersName'];
                  delete stimul['lastAnswersCount'];
                  return stimul;
                });

                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {
                  'index': this.activeStep.position,
                  'uuid': this.activeStep.uuid,
                  'close': close,
                  'majorVersion': this.protocols.protocol.majorVersion,
                  'newTasks': this.newTasks,
                  'assignedSessions': [{
                    'uuid': this.uiid ? this.uiid : __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    'startedAt': startDate,
                    'finishedAt': finishedAt,
                    'stimuli': stimuli,
                    'type': this.type
                  }]

                }).then(function (response) {

                  if (!close) {

                    _this6.setProtocol(null);
                    if (!_this6.isVirtualStage && _this6.activeStep.type.id == 5) {
                      _this6.protocols.protocol.majorVersion = response.data.data ? response.data.data.protocol.majorVersion : 1;
                      if (_this6.isPreviousDateSession) {
                        _this6.isChangedDate = true;
                        var minute = _this6.previousDuration ? +_this6.previousDuration + +_this6.previousTime.mm : _this6.previousTime.mm;
                        var dateSession = new Date(_this6.previousDate.getFullYear(), _this6.previousDate.getMonth(), _this6.previousDate.getDate(), _this6.previousTime.HH, minute);

                        _this6.endDate = {
                          date: dateSession
                        };
                      } else {
                        _this6.endDate = {
                          date: new Date()
                        };
                      }

                      _this6.initProtocols();
                    } else {
                      var stageActiveList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(_this6.protocols.protocol.stages, ['isClosed', false]);
                      if (stageActiveList.length == 1) {
                        _this6.$router.push({ name: 'client-edit', params: { clientId: _this6.protocols.assigneeId } });
                      } else {
                        _this6.$router.push({ name: 'stage-list', params: { clientId: _this6.protocols.assigneeId, protocolData: null } });
                      }
                    }
                  } else {
                    _this6.showSessionView = false;
                    _this6.stimulList = {};
                    _this6.stimulListTimeout = {};
                    var _stageActiveList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(_this6.protocols.protocol.stages, ['isClosed', false]);
                    _this6.setProtocol(null);
                    if (_stageActiveList.length == 1) {
                      _this6.$router.push({ name: 'results', params: { clientId: _this6.protocols.assigneeId, protocolId: _this6.protocolId } });
                    } else {
                      _this6.$router.push({ name: 'stage-list', params: { clientId: _this6.protocols.assigneeId, protocolData: null } });
                    }
                    _this6.uiid = null;
                    _this6.addStimulusItem = null;
                    _this6.stimulusListEmpty = false;
                    if (response) {
                      _this6.showChangeDateSession = false;
                    }
                  }
                }).catch(function (error) {
                  console.info(error);
                  if (error.response) {
                    _this6.disabled = false;
                    _this6.isLoaded = true;
                    _this6.responseHashError = error.response.data.errors.hash.message;
                  } else {
                    //this.$router.push({name: 'stage-list', params: { clientId: this.protocols.assigneeId, protocolData: null}});
                  }
                });

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function saveSessionStage(_x2) {
        return _ref2.apply(this, arguments);
      }

      return saveSessionStage;
    }(),

    checkSessionVersion: function checkSessionVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this7.apiProtocolUrl + _this7.protocolId + '/is-version-equal/' + _this7.protocols.protocol.majorVersion);
                return _context5.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    cancelSession: function cancelSession() {
      this.isModalVisible = false;
    },


    hideSession: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(close) {
        var spo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var checkVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.disabledSave = true;
                this.showSpoSession = spo;
                if (this.showSpoSession && this.isPreviousDateSession && this.previousDate && this.previousTime.HH && this.previousTime.mm) {
                  this.showSpoStartedDay = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  this.showSpoDuration = this.previousDuration;
                  this.duration = null;
                }
                _context6.next = 5;
                return this.checkSessionVersion();

              case 5:
                checkVersion = _context6.sent;

                if (checkVersion.data.data.result) {
                  this.closeLastSession = !spo;
                  this.saveSessionStage(close);
                } else {
                  //this.isModalSessionVisible = true;
                }

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function hideSession(_x3) {
        return _ref3.apply(this, arguments);
      }

      return hideSession;
    }(),

    initProtocols: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isLoaded = false;
                this.showSessionView = true;
                _context7.next = 4;
                return this.getProtocols();

              case 4:

                this.isLoaded = true;

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function initProtocols() {
        return _ref4.apply(this, arguments);
      }

      return initProtocols;
    }(),

    getProtocol: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var params, sessionDate, clientTimeZoneOffset, newDate, newDateUnix, timeSessionDate, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = {};
                sessionDate = new Date();
                clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_21_moment___default()().tz(this.client.timezone)._offset;


                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.utc(this.previousDate).unix;

                  params = {
                    date: newDateUnix
                  };
                }

                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId, {
                  params: params
                });

              case 6:
                response = _context8.sent;
                return _context8.abrupt('return', response);

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getProtocol() {
        return _ref5.apply(this, arguments);
      }

      return getProtocol;
    }(),

    getProtocols: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.getProtocol();

              case 3:
                response = _context9.sent;


                this.protocols = __WEBPACK_IMPORTED_MODULE_11_lodash_cloneDeep___default()(this.protocolVuexData);

                this.close = false;
                this.activeStep = response.data.data;

                this.isVirtualStage = !__WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default()(this.activeStep.virtualStage);

                this.stimulList = this.activeStep.tasks;
                this.type = this.isVirtualStage ? this.activeStep.virtualStage.type : this.activeStep.type;

                this.stimulList = __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy___default()(this.stimulList, 'position');
                this.execution = this.protocols.protocol.execution || '';
                this.btnDisabled = this.activeStep.daySessionClosed;
                this.chooseStimuli = this.activeStep.chooseStimuli;

                this.showSession();

                if (this.btnDisabled) {
                  this.showSessionView = false;
                }

                _context9.next = 22;
                break;

              case 18:
                _context9.prev = 18;
                _context9.t0 = _context9['catch'](0);

                console.dir(_context9.t0);
                if (_context9.t0.status == 403) {
                  this.$router.push({ name: 'client' });
                } else {
                  this.$router.push({ name: 'error' });
                }

              case 22:
                _context9.prev = 22;
                return _context9.finish(22);

              case 24:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 18, 22, 24]]);
      }));

      function getProtocols() {
        return _ref6.apply(this, arguments);
      }

      return getProtocols;
    }(),

    reInitProtocols: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this8 = this;

        var response, activeStep;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.isLoaded = false;
                _context10.next = 3;
                return this.getProtocol();

              case 3:
                response = _context10.sent;
                activeStep = response.data.data;


                __WEBPACK_IMPORTED_MODULE_25_lodash_forEach___default()(this.stimulusList, function (stimul, index) {
                  var answ = __WEBPACK_IMPORTED_MODULE_19_lodash_concat___default()(activeStep.tasks[index].lastAnswers, stimul.answersName);
                  _this8.$set(stimul, 'lastAnswers', answ);
                });

                this.isLoaded = true;

              case 7:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function reInitProtocols() {
        return _ref7.apply(this, arguments);
      }

      return reInitProtocols;
    }()

  }),
  watch: {
    previousDate: function previousDate(newValue) {
      if (this.activeStep.type.id == 5) {
        this.initProtocols();
      } else {
        this.reInitProtocols();
      }
    },
    previousTime: function previousTime(newValue) {
      if (this.endDate && __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.previousDate).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.endDate.date).format('YYYY-MM-DD') && this.activeStep.type.id == 5) {
        this.initProtocols();
      }
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        this.showSpoSession = false;
        this.showSpoStartedDay = null;
        if (this.activeStep.type.id == 5) {
          this.initProtocols();
        } else {
          this.reInitProtocols();
        }
      }

      if (newValue && this.previousDate) {
        if (this.activeStep.type.id == 5) {
          this.initProtocols();
        } else {
          this.reInitProtocols();
        }
      }
    }
  }

});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'text': {
      required: true,
      type: String
    },
    'header': {
      required: true,
      type: String
    },
    'shortTextLength': {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      isExpanded: false
    };
  },

  computed: {
    isCanExpanded: function isCanExpanded() {
      return this.text && this.text.length > this.shortTextLength;
    },

    shortText: function shortText() {
      if (this.isCanExpanded) {
        return this.text.substr(0, this.shortTextLength) + '...';
      } else {
        return this.text;
      }
    }
  },
  methods: {
    toggle: function toggle() {
      this.isExpanded = !this.isExpanded;
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_drop__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a },
  name: 'MandReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      addMandReactionsItem: null,
      apiUrl: '/protocols/assigned/mand/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      fluencyCount: null,
      supportCount: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isModalVisible: false,
      isConflictModalVisible: false,
      protocolsData: this.protocolData,
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      mands: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      newMands: [],
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      uuid: null,
      endDate: null,
      majorVersion: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    minDate: function minDate() {
      return this.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    activeStageCount: function activeStageCount() {
      var activeList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocolsData.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return this.protocolsData && this.protocolsData.protocol.stages ? activeList.length : 0;
    }
  }),
  created: function created() {
    this.fetchProtocolData();
    this.endDate = this.protocolsData && this.protocolsData.endDate ? this.protocolsData.endDate : null;
    this.majorVersion = this.protocolsData.protocol.majorVersion;
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);

              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };


              _this.setEntity(entity);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchProtocolData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);

              case 3:
                response = _context2.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.assignedProtocolId = this.protocolData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initMands();
                  this.initProtocolData();
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function fetchProtocolData() {
        return _ref.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {

      this.protocol = this.protocolData.protocol;
      this.execution = this.protocol.execution;

      this.isLoaded = true;
    },

    initMands: function initMands() {
      var _this2 = this;

      var mandList = this.currentStage.globalTasks;
      this.mands = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.currentStage.mands, function (mand) {

        var currentMand = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(mandList, function (item) {
          return item.uuid == mand.globalUuid;
        });

        if (currentMand.length == 1) {

          mand.attempt = 0;
          mand.attepmtsCount = '1';
          mand.description = currentMand[0].description;
          var lastAnswers = mand.lastAnswers ? mand.lastAnswers : [];
          _this2.$set(mand, 'lastAnswers', lastAnswers);
          var lastAnswersCount = mand.lastAnswersCount ? mand.lastAnswersCount : [];
          _this2.$set(mand, 'lastAnswersCount', lastAnswersCount);
          _this2.$set(mand, 'answers', []);
          mand.recordedReactions = _this2.currentStage.recordedReactions;
          delete mand['uuid'];

          return mand;
        }
      });

      this.mands = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(this.mands, 'position');
    },
    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context3.sent;

                this.client = response.data.data;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 10:
                _context3.prev = 10;

                this.loaded = true;
                return _context3.finish(10);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.confirm_close_all');
      }
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isConflictModalVisible = false;
    },


    attemptChange: function attemptChange(answer, mand, title, answerCount) {
      var _this3 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = answerCount ? __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(answerCount) : 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), answer);

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.mands, function (item) {
          if (item.globalUuid == mand.globalUuid) {
            item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, answerListId);
            //item.attemptAnswers.push(answer);
            item.attempt = item.attempt + answerListCount;
            //item.lastAnswers.push(title);
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, answerList);
            item.lastAnswersCount.push(answerCount);
            item.lastAnswersTotal += answerListCount;
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this3.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        mand.answer = null;
        mand.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.mands, function (item, key) {
        if (item.globalUuid == id) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.answers, lastAnswersCount);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this4.totalAtemptsCount = _this4.totalAtemptsCount - lastAnswersCount;
          item.lastAnswersCount.pop();
          item.lastAnswersTotal -= lastAnswersCount;

          if (!_this4.totalAtemptsCount) {
            _this4.disabledSave = true;
          }
        }
      });
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this5.apiCheckedUrl + _this5.protocolData.id + '/is-version-equal/' + _this5.majorVersion);
                return _context4.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    saveStage: function saveStage(close) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                _this6.disabledSave = true;

                _context5.next = 3;
                return _this6.checkSessionVersion();

              case 3:
                checkVersion = _context5.sent;

                if (!_this6.showChangeDateSession) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return _this6.$validator.validate('duration');

              case 7:
                _context5.t0 = _context5.sent;
                _context5.next = 11;
                break;

              case 10:
                _context5.t0 = true;

              case 11:
                result = _context5.t0;


                if (result && checkVersion.data.data.result) {
                  _this6.saveSession(close);
                } else {
                  _this6.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },


    saveSession: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(close) {
        var _this7 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, mandReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                mandReactions = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.mands);


                mandReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(mandReactions, function (mand) {

                  delete mand['recordedReactions'];
                  delete mand['lastAnswers'];
                  delete mand['lastAnswersCount'];
                  delete mand['lastAnswersTotal'];
                  return mand;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.majorVersion,
                  'newMandReactions': this.newMands,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': mandReactions,
                    'type': that.currentStage.type
                  }]

                }).then(function (response) {
                  if (_this7.isClient) {
                    _this7.$router.push({ name: 'available-protocols' });
                  }

                  _this7.setProtocol(null);
                  if (close) {
                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'results', params: { clientId: _this7.clientId || _this7.assignedProtocolId, protocolId: _this7.protocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: that.clientId, protocolData: null } });
                    }
                  } else {

                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'client-edit', params: { clientId: _this7.clientId || _this7.assignedProtocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: that.clientId, protocolData: null } });
                    }

                    /*if(this.isPreviousDateSession){
                       let minute = this.previousDuration ? +this.previousDuration + +this.previousTime.mm : this.previousTime.mm;
                      let dateSession = new Date(this.previousDate.getFullYear(),
                          this.previousDate.getMonth(),
                          this.previousDate.getDate(),
                          this.previousTime.HH,
                          minute);
                       this.endDate = {
                        date: dateSession
                      };
                    } else{
                      this.endDate = {
                        date: new Date()
                      };
                    }
                     this.majorVersion = response.data.data.protocol.majorVersion;
                     this.uuid = UuidGenerator.v4();
                    let entity = {
                      id: this.uuid,
                      type: 'assigned-session',
                    };
                     forIn(this.mands, (item, index) => {
                       this.$set(this.mands[index], 'attempt', 0);
                      this.$set(this.mands[index], 'lastAnswersTotal', 0);
                      this.$set(this.mands[index], 'answers', []);
                     });
                     this.setEntity(entity);
                    this.setAlertVisible();
                    this.isLoaded = true;*/
                  }
                }).catch(function (error) {
                  if (error.response) {
                    _this7.disabled = false;
                    _this7.isLoaded = true;
                  }
                });

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveSession(_x2) {
        return _ref3.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                _this8.saveSession(true);

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },


    addMands: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(item) {
        var unique, result, uuid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                unique = true;
                _context8.next = 3;
                return this.$validator.validate();

              case 3:
                result = _context8.sent;

                if (result) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt('return');

              case 6:

                if (item) {

                  __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.currentStage.globalTasks, function (mand) {
                    if (__WEBPACK_IMPORTED_MODULE_20_lodash_trim___default()(mand.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_20_lodash_trim___default()(item.toLowerCase())) {
                      unique = false;
                    }
                  });

                  if (unique) {
                    uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();


                    this.currentStage.globalTasks.push({
                      uuid: uuid,
                      description: item
                    });

                    this.mands.push({
                      attempt: 0,
                      sessionAnswers: {},
                      globalUuid: uuid,
                      description: item,
                      title: item,
                      answer: null,
                      answers: [],
                      active: true,
                      checked: true,
                      recordedReactions: this.currentStage.recordedReactions,
                      position: 0,
                      lastAnswers: [],
                      attepmtsCount: '1',
                      lastAnswersCount: []
                    });

                    this.newMands.push({
                      globalUuid: uuid,
                      description: item
                    });

                    this.addMandReactionsItem = null;
                    this.errors.clear();
                    this.disabledSave = false;
                  } else {
                    this.errors.add({
                      field: 'addMandReactionsItem',
                      msg: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.unique_mand')
                    });
                  }
                } else {
                  this.errors.add({
                    field: 'addMandReactionsItem',
                    msg: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.mand_required')
                  });
                }

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function addMands(_x3) {
        return _ref4.apply(this, arguments);
      }

      return addMands;
    }()

  }),
  watch: {
    previousDate: function previousDate(newValue) {

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.mands, function (item, index) {

        var answCount = item.lastAnswers.length - item.lastAnswersTotal;

        item.lastAnswers = __WEBPACK_IMPORTED_MODULE_22_lodash_drop___default()(item.lastAnswers, answCount);
      });
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.mands, function (item, index) {

          var answCount = item.lastAnswers.length - item.lastAnswersTotal;

          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_22_lodash_drop___default()(item.lastAnswers, answCount);
        });
      }
    }
  }

});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_20__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/chain/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isModalVisible: false,
      isConflictModalVisible: false,
      protocolsData: this.protocolData,
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.confirm_close_env'),
      uuid: null,
      endDate: null,
      majorVersion: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    minDate: function minDate() {
      return this.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    activeStageCount: function activeStageCount() {
      var activeList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocolsData.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return this.protocolsData && this.protocolsData.protocol.stages ? activeList.length : 0;
    }
  }),
  created: function created() {
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };

              _this.endDate = _this.protocolsData && _this.protocolsData.endDate ? _this.protocolsData.endDate : null;
              _this.majorVersion = _this.protocolsData.protocol.majorVersion;

              _this.setEntity(entity);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchProtocolData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);

              case 3:
                response = _context2.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.assignedProtocolId = this.protocolData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function fetchProtocolData() {
        return _ref.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this2 = this;

      this.protocol = this.protocolData.protocol;
      this.execution = this.protocol.execution;

      this.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.currentStage.stimuli, function (task) {

        task.attempt = 0;
        task.attepmtsCount = '1';
        var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
        _this2.$set(task, 'lastAnswers', lastAnswers);
        var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
        _this2.$set(task, 'lastAnswersCount', lastAnswersCount);
        _this2.$set(task, 'lastAnswersTotal', 0);
        _this2.$set(task, 'answers', []);
        _this2.$set(task, 'type', _this2.currentStage.type);

        return task;
      });

      this.tasks = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(this.tasks, 'position');
      this.isLoaded = true;
    },

    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context3.sent;

                this.client = response.data.data;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 10:
                _context3.prev = 10;

                this.loaded = true;
                return _context3.finish(10);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.confirm_close_all');
      }
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isConflictModalVisible = false;
    },


    attemptChange: function attemptChange(answer, task, title, answerCount) {
      var _this3 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = answerCount ? __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(answerCount) : 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), answer);

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
          if (item.globalUuid == task.globalUuid) {
            item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, answerListId);
            item.attempt = item.attempt + answerListCount;
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, answerList);
            item.lastAnswersCount.push(answerCount);
            item.lastAnswersTotal += answerListCount;
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this3.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        task.answer = null;
        task.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, key) {
        if (item.globalUuid == id) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.answers, lastAnswersCount);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this4.totalAtemptsCount = _this4.totalAtemptsCount - lastAnswersCount;
          item.lastAnswersCount.pop();
          item.lastAnswersTotal -= lastAnswersCount;

          if (!_this4.totalAtemptsCount) {
            _this4.disabledSave = true;
          }
        }
      });
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this5.apiCheckedUrl + _this5.protocolData.id + '/is-version-equal/' + _this5.majorVersion);
                return _context4.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    saveStage: function saveStage(close) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                _this6.disabledSave = true;

                _context5.next = 3;
                return _this6.checkSessionVersion();

              case 3:
                checkVersion = _context5.sent;

                if (!_this6.showChangeDateSession) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return _this6.$validator.validate('duration');

              case 7:
                _context5.t0 = _context5.sent;
                _context5.next = 11;
                break;

              case 10:
                _context5.t0 = true;

              case 11:
                result = _context5.t0;


                if (result && checkVersion.data.data.result) {
                  _this6.saveSession(close);
                } else {
                  _this6.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },


    saveSession: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(close) {
        var _this7 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.tasks);


                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersCount'];
                  delete task['lastAnswersTotal'];
                  delete task['type'];
                  delete task['attepmtsCount'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.majorVersion,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': that.currentStage.type
                  }]

                }).then(function (response) {
                  if (_this7.isClient) {
                    _this7.$router.push({ name: 'available-protocols' });
                  }
                  if (close) {
                    _this7.setProtocol(null);
                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'results', params: { clientId: _this7.clientId || _this7.assignedProtocolId, protocolId: _this7.protocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: that.clientId, protocolData: null } });
                    }
                  } else {

                    _this7.setProtocol(null);
                    /*this.uuid = UuidGenerator.v4();
                    let entity = {
                      id: this.uuid,
                      type: 'assigned-session',
                    };
                    if(this.isPreviousDateSession){
                       let minute = this.previousDuration ? +this.previousDuration + +this.previousTime.mm : this.previousTime.mm;
                      let dateSession = new Date(this.previousDate.getFullYear(),
                          this.previousDate.getMonth(),
                          this.previousDate.getDate(),
                          this.previousTime.HH,
                          minute);
                       this.endDate = {
                        date: dateSession
                      };
                     } else{
                      this.endDate = {
                        date: new Date()
                      };
                    }
                     forIn(this.tasks, (item, index) => {
                       this.$set(this.tasks[index], 'attempt', 0);
                      this.$set(this.tasks[index], 'lastAnswersTotal', 0);
                      this.$set(this.tasks[index], 'answers', []);
                     });
                     this.majorVersion = response.data.data.majorVersion;
                    this.setEntity(entity);*/
                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'client-edit', params: { clientId: _this7.clientId || _this7.assignedProtocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: that.clientId, protocolData: null } });
                    }

                    //this.$router.push({name: 'stage-list', params: { clientId: that.clientId, protocolData: null, teachingMethod: 5}});
                  }
                }).catch(function (error) {
                  if (error.response) {
                    _this7.disabled = false;
                    _this7.isLoaded = true;
                  }
                });

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveSession(_x2) {
        return _ref3.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                _this8.saveSession(true);

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    }
  }),
  watch: {
    previousDate: function previousDate(newValue) {

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {

        var answCount = item.lastAnswers.length - item.lastAnswersTotal;
        item.lastAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_drop___default()(item.lastAnswers, answCount);
      });
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {

          var answCount = item.lastAnswers.length - item.lastAnswersTotal;
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_drop___default()(item.lastAnswers, answCount);
        });
      }
    }
  }

});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_22__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/shaping/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isModalVisible: false,
      isConflictModalVisible: false,
      protocolsData: null,
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.confirm_close_env'),
      uuid: null,
      selectedIndex: null,
      isChangeCurrent: false,
      newCurrentId: null,
      changed: false,
      isOpenPrev: false,
      isOpenDisabled: false,
      majorVersion: null,
      endDate: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    prevTasks: function prevTasks() {
      var prevTasks = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.tasks, function (task) {
        return !task.selected && !task.disabled;
      });
      return prevTasks;
    },
    selectedTasks: function selectedTasks() {
      var selectedTasks = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.tasks, function (task) {
        return task.selected;
      });
      return selectedTasks[0];
    },
    selectedIndexTask: function selectedIndexTask() {
      var selectedIndexTask = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.tasks, function (task) {
        return task.selected;
      });
      return selectedIndexTask;
    },
    nextTasks: function nextTasks() {
      var nextTasks = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.tasks, function (task) {
        return task.disabled;
      });
      return nextTasks;
    },
    activeStageCount: function activeStageCount() {
      var activeList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocolsData.protocol.stages, function (stage) {
        return !stage.isClosed;
      });

      return this.protocolsData && this.protocolsData.protocol.stages ? activeList.length : 0;
    }
  }),
  created: function created() {
    this.protocolsData = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolVuexData);
    this.majorVersion = this.protocolsData.protocol.majorVersion;
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };


              _this.setEntity(entity);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    toggleViewPrev: function toggleViewPrev() {
      this.isOpenPrev = !this.isOpenPrev;
    },
    toggleViewDisabled: function toggleViewDisabled() {
      this.isOpenDisabled = !this.isOpenDisabled;
    },
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchProtocolData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, newDate, newDateUnix, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};


                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId, {
                  params: params
                });

              case 5:
                response = _context2.sent;

                if (response) {
                  this.currentStage = response.data.data;

                  this.assignedProtocolId = this.protocolsData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.info(_context2.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchProtocolData() {
        return _ref.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this2 = this;

      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolsData.protocol);
      this.execution = this.protocol.execution;
      var currentTaskPosition = 0;

      var targetIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.currentStage.stimuli, function (item) {
        return item.globalUuid === _this2.currentStage.targetStimulus.globalUuid;
      })[0].position;

      this.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.currentStage.stimuli, function (task, index) {
        _this2.$set(task, 'lastSessions', []);
        if (task.globalUuid === _this2.currentStage.targetStimulus.globalUuid) {
          _this2.$set(task, 'selected', true);
          _this2.$set(task, 'lastSessions', _this2.currentStage.targetStimulus.lastSessions);
          _this2.$set(task, 'mastered', _this2.currentStage.targetStimulus.isMastered);
        }

        task.attempt = 0;
        task.attepmtsCount = '1';
        var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
        _this2.$set(task, 'lastAnswers', lastAnswers);
        var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
        _this2.$set(task, 'lastAnswersCount', lastAnswersCount);
        _this2.$set(task, 'answers', []);
        _this2.$set(task, 'type', _this2.currentStage.type);
        _this2.$set(task, 'toNextLevel', _this2.nextLevel(task));

        if (task.position > targetIndex) {
          _this2.$set(task, 'disabled', true);
        }

        return task;
      });

      this.tasks = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(this.tasks, 'position');

      var currentIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.tasks, function (item) {
        return item.globalUuid === _this2.currentStage.targetStimulus.globalUuid;
      });

      this.isLoaded = true;
    },

    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context3.sent;

                this.client = response.data.data;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 10:
                _context3.prev = 10;

                this.loaded = true;
                return _context3.finish(10);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_24__lang_translator__["a" /* default */].get('protocol.confirm_close_all_env');
      }
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isConflictModalVisible = false;
      this.isChangeCurrent = false;
    },
    changeCurrentTask: function changeCurrentTask() {
      this.isChangeCurrent = false;
      this.currentStage.targetStimulus.globalUuid = this.newCurrentId;
      this.isLoaded = false;
      this.saveStage(false, true);
    },
    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    },


    attemptChange: function attemptChange(answer, task, title, answerCount) {
      var _this3 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = answerCount ? __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger___default()(answerCount) : 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_16_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_16_lodash_fill___default()(new Array(answerListCount), answer);
      var lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      this.changed = true;

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {

        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {
          if (item.globalUuid == task.globalUuid) {
            item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_concat___default()(item.answers, answerListId);
            item.attempt = item.attempt + answerListCount;
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_concat___default()(item.lastAnswers, answerList);
            item.lastAnswersCount.push(answerCount);
            if (lastDate === lastDay) {
              item.lastSessions[task.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_concat___default()(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
            } else {
              item.lastSessions.push({
                date: lastDay,
                attempts: answerListId,
                mastered: false
              });
            }
            item.mastered = false;

            _this3.$set(_this3.tasks[index], 'toNextLevel', _this3.nextLevel(item));
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this3.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        task.answer = null;
        task.attepmtsCount = '1';
      }, 300);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, key) {
        if (item.globalUuid == id) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.answers = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.answers, lastAnswersCount);

          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this4.totalAtemptsCount = _this4.totalAtemptsCount - lastAnswersCount;
          item.lastAnswersCount.pop();
          item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

          if (!item.lastSessions[item.lastSessions.length - 1].attempts.length) {
            item.lastSessions.pop();
          }

          item.toNextLevel = _this4.nextLevel(item);

          if (!_this4.totalAtemptsCount) {
            _this4.disabledSave = true;
          }
        }
      });
    },

    selectAsCurrent: function selectAsCurrent(id) {

      this.isChangeCurrent = true;
      this.newCurrentId = id;
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this5.apiCheckedUrl + _this5.protocolsData.id + '/is-version-equal/' + _this5.majorVersion);
                return _context4.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    saveStage: function saveStage(close) {
      var _this6 = this;

      var changeCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                _this6.disabledSave = true;

                _context5.next = 3;
                return _this6.checkSessionVersion();

              case 3:
                checkVersion = _context5.sent;

                if (!_this6.showChangeDateSession) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return _this6.$validator.validate('duration');

              case 7:
                _context5.t0 = _context5.sent;
                _context5.next = 11;
                break;

              case 10:
                _context5.t0 = true;

              case 11:
                result = _context5.t0;


                if (result && checkVersion.data.data.result) {
                  _this6.saveSession(close, changeCurrent);
                } else {
                  _this6.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },


    saveSession: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(close) {
        var _this7 = this;

        var changeCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.tasks);


                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersCount'];
                  delete task['type'];
                  delete task['attepmtsCount'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.majorVersion,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': that.currentStage.type,
                    'targetStimulus': {
                      "globalUuid": this.currentStage.targetStimulus.globalUuid,
                      "isMastered": this.currentStage.targetStimulus.globalUuid == this.tasks[this.tasks.length - 1].globalUuid && !!this.tasks[this.tasks.length - 1].mastered
                    }
                  }]

                }).then(function (response) {

                  if (_this7.isClient) {
                    _this7.$router.push({ name: 'available-protocols' });
                  }

                  _this7.setProtocol(null);

                  if (close) {

                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'results', params: { clientId: _this7.clientId || _this7.assignedProtocolId, protocolId: _this7.protocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: _this7.clientId, protocolData: null } });
                    }
                  }

                  if (changeCurrent) {
                    _this7.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
                    var entity = {
                      id: _this7.uuid,
                      type: 'assigned-session'
                    };

                    _this7.setEntity(entity);
                    _this7.majorVersion = response.data.data.majorVersion;

                    if (_this7.isPreviousDateSession && _this7.previousTime.HH) {
                      var minute = _this7.previousDuration ? +_this7.previousDuration + +_this7.previousTime.mm : _this7.previousTime.mm;
                      var dateSession = new Date(_this7.previousDate.getFullYear(), _this7.previousDate.getMonth(), _this7.previousDate.getDate(), _this7.previousTime.HH, minute);

                      _this7.protocolsData.endDate = {
                        date: dateSession
                      };
                    }
                    _this7.fetchProtocolData();
                  } else {

                    if (stageActiveList.length == 1) {
                      _this7.$router.push({ name: 'client-edit', params: { clientId: _this7.clientId || _this7.assignedProtocolId } });
                    } else {
                      _this7.$router.push({ name: 'stage-list', params: { clientId: _this7.clientId, protocolData: null } });
                    }
                  }
                }).catch(function (error) {
                  console.info(error);
                  if (error.response) {
                    _this7.disabled = false;
                    _this7.isLoaded = true;
                  }
                });

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveSession(_x3) {
        return _ref3.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                _this8.saveSession(true);

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },


    goToNextLevel: function goToNextLevel(uuid, task, index) {

      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      if (index == this.tasks.length - 1) {

        this.$set(this.tasks[index], 'mastered', true);
      } else {
        task.selected = false;
        this.$set(this.tasks[index + 1], 'disabled', false);
        this.$set(this.tasks[index + 1], 'selected', true);
        this.$set(this.tasks[index + 1], 'lastSessions', [{
          date: lastDay,
          attempts: [],
          mastered: false
        }]);
        this.$set(this.tasks[index + 1], 'mastered', false);
        this.$set(this.currentStage.targetStimulus, 'globalUuid', this.tasks[index + 1].globalUuid);
      }
      this.disabledSave = false;
      this.changed = true;
    },

    nextLevel: function nextLevel(item) {
      var _this9 = this;

      var positive = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.currentStage.type.answers, function (item) {
        return item.himself;
      });
      var positiveAnswer = positive[0].id;
      var toNextLevel = false;

      var trialCount = this.currentStage.masteringCondition.trialCount;
      var sessionCount = this.currentStage.masteringCondition.sessionCount;

      if (item.lastSessions.length >= sessionCount) {

        var sortedSession = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(item.lastSessions, function (date) {
          return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date.date, 'YYYY-MM-DD').unix();
        });

        var lastSessions = __WEBPACK_IMPORTED_MODULE_20_lodash_drop___default()(sortedSession, item.lastSessions.length - sessionCount);
        var mastered = false;
        var countMastered = 0;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(lastSessions, function (answerList, index) {

          var lastSessionAtempts = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(answerList.attempts, answerList.attempts.length - trialCount);
          var lastSessionAtemptsCount = lastSessionAtempts.length;

          if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {

            if (answerList.isMastered) {

              countMastered++;
            } else {

              var positiveAnswerCount = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(lastSessionAtempts, function (item) {
                return item == positiveAnswer;
              }).length;
              var trial = positiveAnswerCount * 100 / lastSessionAtemptsCount >= _this9.currentStage.masteringCondition.ratio;
              if (trial) {
                countMastered++;
              } else {
                mastered = false;
              }
            }
          } else {
            return false;
          }
        });

        if (countMastered >= lastSessions.length) {
          mastered = true;
        }

        toNextLevel = mastered;
      } else {
        return false;
      }

      return toNextLevel;
    }

  }),
  watch: {
    previousDate: function previousDate(newValue) {
      if (!this.changed && this.protocolsData.endDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
        this.fetchProtocolData();
      }
    },
    previousTime: function previousTime(newValue) {
      /*if (this.protocolsData.endDate && moment(this.previousDate).format('YYYY-MM-DD') == moment(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
        this.fetchProtocolData();
      }*/
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        if (!this.changed && this.protocolsData.endDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date).format('YYYY-MM-DD')) {
          this.fetchProtocolData();
        }
      }
    }
  }

});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__protocols_constants_js__ = __webpack_require__(30);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_7__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */] },
  name: 'ReactionStageList',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/',
      apiClientUrl: '/users/clients/',
      protocol: null,
      supportCount: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      protocolsData: this.protocolVuexData,
      isLoaded: false,
      execution: '',
      stagesList: [],
      title: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('protocol.confirm_close')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData'])),
  created: function created() {
    if (this.isClient) {
      this.$router.push({ name: 'protocol-item', params: { clientId: this.clientId, protocolData: this.protocolVuexData } });
    } else {
      this.fetchProtocol();
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {

    detectProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/teaching-method');

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data.data.id);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function detectProtocol() {
        return _ref.apply(this, arguments);
      }

      return detectProtocol;
    }(),

    fetchProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoaded = false;
                if (!this.protocolVuexData) {
                  this.fetchProtocolData();
                } else {
                  this.protocolsData = this.protocolVuexData;
                  this.assignedProtocolId = this.protocolVuexData.assigneeId;
                  this.client = this.clientData;
                  this.initProtocolData();
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchProtocol() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocol;
    }(),

    fetchProtocolData: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var teachingMethodId, urlMap, apiUrl, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.detectProtocol();

              case 3:
                teachingMethodId = _context3.sent;
                urlMap = {
                  1: 'dtt',
                  2: 'simple',
                  3: 'mand',
                  4: 'vcd',
                  5: 'chain',
                  6: 'shaping',
                  9: 'pecs-with-discrimination'
                };
                apiUrl = this.apiUrl + urlMap[teachingMethodId] + '/' + this.protocolId + '/info';
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(apiUrl);

              case 8:
                response = _context3.sent;

                this.protocolsData = response.data.data;
                this.setProtocol(this.protocolsData);
                this.assignedProtocolId = this.protocolsData.assigneeId;

                if (this.client) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 15;
                return this.getClient(this.clientId);

              case 15:
                if (response) {
                  this.initProtocolData();
                }
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18]]);
      }));

      function fetchProtocolData() {
        return _ref3.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      this.protocol = this.protocolsData.protocol;
      var status = this.protocolsData && this.protocolsData.status && this.protocolsData.status.id ? this.protocolsData.status.id : null;
      this.stagesList = this.protocol.stages;
      var stageActiveList = this.protocol.stages.length ? __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]) : [];
      if ((!stageActiveList.length || status === __WEBPACK_IMPORTED_MODULE_9__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION) && this.protocol.teachingMethod.id !== 9) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      }

      this.isLoaded = true;
    },

    getClient: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context4.sent;

                this.client = response.data.data;
                return _context4.abrupt('return', response);

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 11:
                _context4.prev = 11;

                this.loaded = true;
                return _context4.finish(11);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8, 11, 14]]);
      }));

      function getClient(_x) {
        return _ref4.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    }
  })

});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loadDTTData__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'protocolData', 'phaseId', 'stageId'],
  data: function data() {
    return {
      addStimulusItem: null,
      lastPhase: null,
      isModalVisible: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_loadDTTData__["a" /* loadDTTData */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isTherapist'])),

  methods: {}

});

/***/ }),
/* 515 */,
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_maintainStage__ = __webpack_require__(517);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/dtt/'
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_maintainStage__["a" /* maintainStage */]]

});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return maintainStage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__);





















var maintainStage = {
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage', 'teachingMethod'],
  data: function data() {
    return {
      apiUrlDetect: '/protocols/',
      apiCheckedUrl: '/protocols/assigned/',
      disabled: false,
      disabledSave: true,
      isLoaded: false,
      protocols: null,
      protocolsData: null,
      phaseSettings: [],
      activeStep: [],
      execution: '',
      stimulus: [],
      stimulList: [],
      attempts: {},
      currentSesssionDate: null,
      uiid: null,
      stimulusListEmpty: false,
      addStimulusItem: null,
      todayStimulList: null,
      allStimulList: null,
      visible: true,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      intervalTypes: [{ typeId: '1', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.through_each_lesson') }, { typeId: '2', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_one_lesson') }, { typeId: '3', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_two_classes') }, { typeId: '4', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_three_classes') }, { typeId: '5', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_a_week') }, { typeId: '6', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks') }, { typeId: '7', name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_a_month') }],
      duration: null,
      showDatapicker: false,
      isModalVisible: false,
      showChangeDateSession: false,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      stageInfo: this.stage,
      protocolData: null,
      teachingMethodId: this.teachingMethod
    };
  },

  components: {
    Instruction: __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_4__modules_loader_components_Loader__["a" /* default */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_17_vue2_timepicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolData && this.protocolData.endDate ? __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    previousDateTimestamp: function previousDateTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.previousDate).unix() - 3600;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.previousDate).unix() + 3600;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolData && this.protocolData.endDate && this.isPreviousDateSession && this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').unix();
        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_14_moment___default()(sessionDate).unix();
        return previous <= protocolDate;
      }

      return false;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.todayStimulList = null;
              _this.allStimulList = null;
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _context.next = 5;
              return _this.initProtocols();

            case 5:
              _this.uiid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uiid,
                type: 'assigned-session'
              };

              if (_this.stage) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.apiUrl + _this.protocolId + '/show-stage/' + _this.stageId);

            case 10:
              response = _context.sent;

              _this.stageInfo = response.data.data;

            case 12:
              if (_this.teachingMethod) {
                _context.next = 16;
                break;
              }

              _context.next = 15;
              return _this.detectProtocol();

            case 15:
              _this.teachingMethodId = _context.sent;

            case 16:

              _this.showDatapicker = __WEBPACK_IMPORTED_MODULE_15__modules_protocols_constants_js__["a" /* DATAPICKER */];

              _this.setEntity(entity);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('protocol', ['setProtocol', 'setProtocolVersion']), {

    detectProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiCheckedUrl + this.protocolId + '/teaching-method');

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response.data.data.id);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function detectProtocol() {
        return _ref.apply(this, arguments);
      }

      return detectProtocol;
    }(),

    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    cancelSession: function cancelSession() {
      this.isModalVisible = false;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = this.client.timezone ? __WEBPACK_IMPORTED_MODULE_14_moment___default()().tz(this.client.timezone)._offset : 0;
      var dateTime = __WEBPACK_IMPORTED_MODULE_14_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_14_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_16__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this2.apiCheckedUrl + _this2.protocolId + '/is-version-equal/' + _this2.activeStep.majorVersion);
                return _context3.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    saveSession: function saveSession() {
      var _this3 = this;

      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var stimulus, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, isSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                stimulus = [];

                _this3.isLoaded = false;
                __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(_this3.todayStimulList, function (item) {

                  if (item.attemptAnswers.length || item.moveToPrevPhase) {
                    stimulus.push({
                      globalUuid: item.globalUuid,
                      answerId: item.attemptAnswers[0],
                      description: item.description,
                      moveBack: item.moveToPrevPhase,
                      intervalType: item.intervalType
                    });
                  }
                });

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (_this3.isPreviousDateSession) {
                  clientTimeZoneOffset = _this3.client.timezone ? __WEBPACK_IMPORTED_MODULE_14_moment___default()().tz(_this3.client.timezone)._offset : 0;

                  sessionDate = new Date(Date.UTC(_this3.previousDate.getFullYear(), _this3.previousDate.getMonth(), _this3.previousDate.getDate(), _this3.previousTime.HH, _this3.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_16__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_16__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + _this3.previousDuration * __WEBPACK_IMPORTED_MODULE_16__modules_undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                isSaved = void 0;

                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this3.apiUrl + _this3.protocolId + '/sessions', {
                  'assignedSessions': [{
                    'uuid': _this3.uiid,
                    //'dayUuid': UuidGenerator.v4(),
                    'startedAt': _this3.isPreviousDateSession ? timeSessionDate : _this3.currentSesssionDate ? _this3.currentSesssionDate : Math.round(new Date().getTime() / 1000), //
                    'finishedAt': _this3.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000), //
                    'stimuli': stimulus,
                    'phaseId': _this3.activeStep.id,
                    'type': _this3.activeStep.taskType
                  }],
                  'uuid': _this3.stageInfo.uuid,
                  'close': close,
                  'index': _this3.stageInfo.position,
                  'majorVersion': _this3.activeStep.majorVersion
                }).then(function (response) {
                  if (close) {
                    _this3.$router.push({ name: 'client-edit', params: { clientId: _this3.protocols.assigneeId } });
                  } else {
                    _this3.setProtocol(null);
                    if (_this3.teachingMethodId == 1) {
                      _this3.$router.push({ name: 'choose-stage' });
                    } else {
                      _this3.$router.push({ name: 'choose-usd' });
                    }
                  }
                  _this3.isLoaded = true;
                }).catch(function (error) {
                  console.info(error);
                });

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    saveStage: function saveStage() {
      var _this4 = this;

      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var checkVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.checkSessionVersion();

              case 2:
                checkVersion = _context5.sent;

                if (checkVersion.data.data.result) {
                  _this4.saveSession(close);
                } else {
                  _this4.isModalVisible = true;
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },


    initProtocols: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var entity;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isLoaded = false;
                this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
                this.uuid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4();
                entity = {
                  id: this.uuid,
                  type: 'assigned-session'
                };


                this.setEntity(entity);
                _context6.next = 7;
                return this.getProtocols();

              case 7:
                this.isLoaded = true;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function initProtocols() {
        return _ref2.apply(this, arguments);
      }

      return initProtocols;
    }(),

    getInterval: function getInterval(id) {
      var interval = null;
      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.intervalTypes, function (item) {
        if (item.typeId == id) {
          interval = item;
        }
      });
      if (interval) {
        return interval.name;
      }
    },


    attemptChange: function attemptChange(answer, stimul) {
      stimul.toRotation = this.rotationBack(stimul, answer);
      stimul.disabled = true;
      stimul.attemptAnswers.push(answer);
      this.disabledSave = false;

      setTimeout(function () {
        stimul.answer = null;
      }, 800);
    },

    goToPrevPhase: function goToPrevPhase(id) {
      var _this5 = this;

      var stimuls = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.todayStimulList);

      __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(stimuls, function (item) {
        if (item.globalUuid == id) {
          item.moveToPrevPhase = true;
        }
      });

      setTimeout(function () {
        _this5.todayStimulList = stimuls;
        _this5.disabledSave = false;
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this6 = this;

      var stimuls = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.todayStimulList);

      __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(stimuls, function (item) {
        if (item.globalUuid == id) {
          item.attemptAnswers.pop();
          item.disabled = false;
          item.answer = null;
          item.toRotation = _this6.rotationBack(item);
        }
      });

      setTimeout(function () {
        _this6.todayStimulList = stimuls;
      }, 200);
    },

    rotationBack: function rotationBack(stimul) {
      var answer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var negative = __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default()(stimul.type.answers, function (item) {
        return !item.himself;
      });
      var negativeAnswer = negative[0].id;

      if (stimul.answers) {
        if (stimul.answers[0] == negativeAnswer && stimul.answers[1] == negativeAnswer || stimul.answers[0] == negativeAnswer && answer == negativeAnswer) {
          return true;
        } else {
          return false;
        }
      }
    },

    getProtocols: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _this7 = this;

        var params, newDate, newDateUnix, timeSessionDate, response, stimuliList, taskType;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                params = {};


                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_14_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_14_moment___default.a.utc(this.previousDate).unix;

                  params = {
                    date: newDateUnix
                  };
                }

                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/stage/' + this.stageId + '/phase/3/', { params: params });

              case 5:
                response = _context7.sent;


                if (response) {
                  this.protocolData = this.protocolVuexData;
                  this.protocols = this.protocolData.protocol;
                  this.activeStep = response.data.data;
                  this.stimulList = this.activeStep.tasks;
                  this.execution = this.protocols.execution;

                  stimuliList = this.activeStep.stimuli;
                  taskType = this.activeStep.taskType;


                  __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(stimuliList, function (item) {

                    item.title = item.description;
                    item.type = taskType;
                    item.attemptAnswers = [];
                    item.disabled = false;
                    item.moveToPrevPhase = false;
                    item.toRotation = _this7.rotationBack(item);
                  });

                  this.todayStimulList = __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default()(stimuliList, 'showToday');
                  this.todayStimulList = __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default()(this.todayStimulList, 'position');
                  this.allStimulList = __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default()(stimuliList, ['showToday', false]);
                }

                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](0);

                console.dir(_context7.t0);

              case 12:
                _context7.prev = 12;

                this.isLoaded = true;
                return _context7.finish(12);

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9, 12, 15]]);
      }));

      function getProtocols() {
        return _ref3.apply(this, arguments);
      }

      return getProtocols;
    }()

  }),
  watch: {
    previousDate: function previousDate(newValue) {
      this.getProtocols();
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      this.getProtocols();
    }
  }

};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loadDTTData__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'protocolData', 'stageId'],
  data: function data() {
    return {
      addStimulusItem: null,
      lastPhase: null,
      isModalVisible: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loadDTTData__["a" /* loadDTTData */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isCurator', 'isBCBA', 'isTherapist']), {
    isDisabled: function isDisabled() {
      var taskLength = 0;
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.phases, function (phase) {
        taskLength += phase.items.length;
      });
      return taskLength < 2;
    }
  }),

  methods: {}

});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loadDTTData__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'protocolData', 'phaseId', 'stageId'],
  data: function data() {
    return {
      addStimulusItem: null,
      lastPhase: null,
      isModalVisible: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loadDTTData__["a" /* loadDTTData */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isCurator', 'isBCBA', 'isTherapist']), {
    isDisabled: function isDisabled() {
      var taskLength = 0;
      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.phases, function (phase) {
        taskLength += phase.items.length;
      });
      return taskLength < 2;
    }
  }),

  methods: {}

});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StageHeader__ = __webpack_require__(521);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], StageHeader: __WEBPACK_IMPORTED_MODULE_13__StageHeader__["a" /* default */] },
  name: 'ChoseStage',
  props: {
    'name': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },

    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/dtt/',
      apiClientUrl: '/users/clients/',
      protocol: null,
      mastering: null,
      rotation: null,
      fluency: null,
      support: null,
      rotationCount: null,
      fluencyCount: null,
      supportCount: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      phasesCount: null,
      isModalVisible: false,
      isLoaded: false,
      title: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      stage: null
    };
  },
  created: function created() {
    this.fetchProtocolData();
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    stageCount: function stageCount() {
      var activeList = this.protocolVuexData && this.protocolVuexData.protocol.stages ? __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocolVuexData.protocol.stages, function (stage) {
        return !stage.isClosed;
      }).length : 0;

      return activeList;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol', 'setProtocolVersion']), {

    fetchProtocolData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, phases;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.isLoaded = false;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);

              case 4:
                response = _context.sent;

                this.stage = response.data.data;
                this.assignedProtocolId = response.data.data.assigneeId;
                this.client = this.clientData;
                if (response) {
                  phases = this.stage.phases;

                  this.mastering = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(phases, function (item) {
                    return item.typeId == 1;
                  })[0];
                  this.rotation = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(phases, function (item) {
                    return item.typeId == 2;
                  })[0];
                  this.rotationCount = this.rotation ? this.rotation.taskCount : null;
                  this.fluency = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(phases, function (item) {
                    return item.typeId == 4;
                  })[0];
                  this.fluencyCount = this.fluency ? this.fluency.taskCount : null;
                  this.support = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(phases, function (item) {
                    return item.typeId == 3;
                  })[0];
                  this.supportCount = this.support ? this.support.taskCount : null;
                  this.phasesCount = phases ? phases.length : 0;

                  this.isLoaded = true;
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);
                if (_context.t0.status == 403) {
                  this.$router.push({ name: 'client' });
                } else {
                  this.$router.push({ name: 'error' });
                }

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function fetchProtocolData() {
        return _ref.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context2.sent;

                this.client = response.data.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 10:
                _context2.prev = 10;

                this.loaded = true;
                return _context2.finish(10);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'stage-list', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocolVuexData.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.confirm_close_all');
      }
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    closeStage: function closeStage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isSaved, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isSaved = void 0;

                _this.isLoaded = false;

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (_this.isPreviousDateSession && _this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_11_moment___default()().tz(_this.clientData.timezone)._offset;

                  sessionDate = new Date(Date.UTC(_this.previousDate.getFullYear(), _this.previousDate.getMonth(), _this.previousDate.getDate(), _this.previousTime.HH, _this.previousTime.mm));

                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(sessionDate).unix() + _this.previousDuration * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.apiUrl + _this.protocolId + '/sessions', {
                  'assignedSessions': [{
                    'uuid': __WEBPACK_IMPORTED_MODULE_8__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    'startedAt': _this.isPreviousDateSession ? timeSessionDate : Math.round(new Date().getTime() / 1000), //
                    'finishedAt': _this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000) //
                  }],
                  'uuid': _this.stage.uuid,
                  'majorVersion': _this.protocolVuexData.protocol.majorVersion,
                  'close': true
                }).then(function (response) {
                  var stageActiveList = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this.protocolVuexData.protocol.stages, ['isClosed', false]);
                  _this.setProtocol(null);
                  if (stageActiveList.length <= 1) {
                    _this.$router.push({ name: 'results', params: { clientId: _this.clientId || _this.assignedProtocolId, protocolId: _this.protocolId } });
                  } else {
                    _this.$router.push({ name: 'stage-list', params: { clientId: _this.clientId || _this.assignedProtocolId, protocolId: _this.protocolId } });
                  }
                  //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
                }).catch(function (error) {
                  console.info(error);
                  _this.isLoaded = true;
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }))();
    }
  })

});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StageHeader_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7cdeda_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StageHeader_vue__ = __webpack_require__(1114);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StageHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7cdeda_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StageHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StageHeader',
  props: {
    'stage': null,
    'stageCount': null
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolVuexData.endDate ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.protocolVuexData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolVuexData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.minDate).unix();
        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);

        var previous = __WEBPACK_IMPORTED_MODULE_2_moment___default()(sessionDate).unix();
        return previous <= protocolDate;
      }

      return false;
    }
  }),
  methods: {
    closeSession: function closeSession() {
      this.$emit('close-session');
    }
  },
  watch: {
    previousDate: function previousDate(newValue) {
      this.$emit('fetch-protocol');
    },
    previousTime: function previousTime(newValue) {
      if (this.showDatePrevious) {
        this.$emit('fetch-protocol');
      }
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        this.$emit('fetch-protocol');
      }
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StageHeader__ = __webpack_require__(521);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChooseUSDStage',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], StageHeader: __WEBPACK_IMPORTED_MODULE_13__StageHeader__["a" /* default */] },
  props: {
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/vcd/',
      apiClientUrl: '/users/clients/',
      stage: null,
      mastering: null,
      support: null,
      rotationCount: null,
      supportCount: null,
      masteringCount: null,
      client: {},
      loaded: false,
      phasesCount: null,
      isModalVisible: false,
      protocolsData: null,
      isLoaded: false,
      title: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.confirm_close')
    };
  },
  created: function created() {
    this.fetchProtocol();
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    assignedProtocolId: function assignedProtocolId() {
      return this.protocolVuexData ? this.protocolVuexData.assigneeId : null;
    },
    stageCount: function stageCount() {
      return this.protocolVuexData && this.protocolVuexData.protocol.stages ? this.protocolVuexData.protocol.stages.length : 0;
    },
    activeStageCount: function activeStageCount() {
      var activeList = this.protocolVuexData ? __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocolVuexData.protocol.stages, function (stage) {
        return !stage.isClosed;
      }) : [];

      return this.protocolVuexData && this.protocolVuexData.protocol.stages ? activeList.length : 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {

    fetchProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;


                this.isLoaded = false;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);

              case 4:
                response = _context.sent;

                if (response) {
                  this.protocolsData = this.protocolVuexData;
                  this.stage = response.data.data;
                  //this.getClient(this.clientId || this.assignedProtocolId);
                  this.isLoaded = true;
                  this.mastering = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.stage.phases, function (item) {
                    return item.typeId == 5;
                  })[0];
                  this.masteringCount = this.mastering ? this.mastering.taskCount : null;
                  this.support = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.stage.phases, function (item) {
                    return item.typeId == 3;
                  })[0];
                  this.supportCount = this.support ? this.support.taskCount : null;
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function fetchProtocol() {
        return _ref.apply(this, arguments);
      }

      return fetchProtocol;
    }(),

    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context2.sent;

                this.client = response.data.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 10:
                _context2.prev = 10;

                this.loaded = true;
                return _context2.finish(10);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },

    closeSession: function closeSession() {
      var stageActiveList = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocolsData.protocol.stages, ['isClosed', false]);
      if (stageActiveList.length == 1) {
        this.title = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.confirm_close_all');
      }
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    closeStage: function closeStage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isSaved, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isSaved = void 0;

                _this.isLoaded = false;

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (_this.isPreviousDateSession && _this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_11_moment___default()().tz(_this.clientData.timezone) ? __WEBPACK_IMPORTED_MODULE_11_moment___default()().tz(_this.clientData.timezone)._offset : 0;

                  sessionDate = new Date(Date.UTC(_this.previousDate.getFullYear(), _this.previousDate.getMonth(), _this.previousDate.getDate(), _this.previousTime.HH, _this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(sessionDate).unix() + _this.previousDuration * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_12__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.apiUrl + _this.protocolId + '/sessions', {
                  'assignedSessions': [{
                    'uuid': __WEBPACK_IMPORTED_MODULE_8__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    'startedAt': _this.isPreviousDateSession ? timeSessionDate : Math.round(new Date().getTime() / 1000), //
                    'finishedAt': _this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000) //
                  }],
                  'uuid': _this.stage.uuid,
                  'index': _this.stage.position,
                  'close': true
                }).then(function (response) {

                  var stageActiveList = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this.protocolsData.protocol.stages, ['isClosed', false]);
                  _this.setProtocol(null);
                  if (stageActiveList.length <= 1) {
                    _this.$router.push({ name: 'results', params: { clientId: _this.clientId || _this.assignedProtocolId, protocolId: _this.protocolId } });
                  } else {
                    _this.$router.push({ name: 'stage-list', params: { clientId: _this.clientId || _this.assignedProtocolId, protocolId: _this.protocolId } });
                  }
                }).catch(function (error) {
                  console.info(error);
                  _this.isLoaded = true;
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }))();
    }
  })
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_protocol_api_protocol__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_ceil__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_ceil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_ceil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_unionBy__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_unionBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CurrentStageChain__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__CurrentStageShaping__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__CurrentSimple__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CurrentMand__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CurrentStageDTT__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CurrentPecs__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__undesirableBehavior_components_UndesirableBehaviorChart__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chart_component_CumulutiveChart__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__common_mixins_typeProtocol__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__LastSessionResults__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__LastSessionPecsResults__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__LastSessionPecsWithDiscrimination__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__CurrentPecsWithDescrimination__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__CurrentPecsCategory__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__LastSessionCategoryResults__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__common_toggleViewList_components_ToggleView__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__CurrentPecsWithItems__ = __webpack_require__(1168);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















































var MODE_SESSIONS = 'session';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'protocolData', 'clientData'],
  components: {
    CumulutiveChart: __WEBPACK_IMPORTED_MODULE_41__chart_component_CumulutiveChart__["a" /* default */], LastSessionResults: __WEBPACK_IMPORTED_MODULE_43__LastSessionResults__["a" /* default */], LastSessionPecsWithDiscrimination: __WEBPACK_IMPORTED_MODULE_45__LastSessionPecsWithDiscrimination__["a" /* default */], CurrentPecsWithDescrimination: __WEBPACK_IMPORTED_MODULE_46__CurrentPecsWithDescrimination__["a" /* default */], CurrentPecsCategory: __WEBPACK_IMPORTED_MODULE_47__CurrentPecsCategory__["a" /* default */], LastSessionCategoryResults: __WEBPACK_IMPORTED_MODULE_48__LastSessionCategoryResults__["a" /* default */], CurrentPecsWithItems: __WEBPACK_IMPORTED_MODULE_50__CurrentPecsWithItems__["a" /* default */],
    ChartPopup: __WEBPACK_IMPORTED_MODULE_39__ChartPopup__["a" /* default */], CurrentStageChain: __WEBPACK_IMPORTED_MODULE_32__CurrentStageChain__["a" /* default */], CurrentStageShaping: __WEBPACK_IMPORTED_MODULE_33__CurrentStageShaping__["a" /* default */], CurrentStageDTT: __WEBPACK_IMPORTED_MODULE_36__CurrentStageDTT__["a" /* default */], CurrentSimple: __WEBPACK_IMPORTED_MODULE_34__CurrentSimple__["a" /* default */], CurrentMand: __WEBPACK_IMPORTED_MODULE_35__CurrentMand__["a" /* default */], CurrentPecs: __WEBPACK_IMPORTED_MODULE_37__CurrentPecs__["a" /* default */], ToogleView: __WEBPACK_IMPORTED_MODULE_49__common_toggleViewList_components_ToggleView__["a" /* default */],
    Paginate: __WEBPACK_IMPORTED_MODULE_20_vuejs_paginate___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], LineShapingChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["f" /* LineShapingChart */], Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_19__common_table_components_TableView__["a" /* default */], UndesirableBehaviorChart: __WEBPACK_IMPORTED_MODULE_40__undesirableBehavior_components_UndesirableBehaviorChart__["a" /* default */], LastSessionPecsResults: __WEBPACK_IMPORTED_MODULE_44__LastSessionPecsResults__["a" /* default */] },

  data: function data() {
    return {
      sessionDay: null,
      isLoaded: true,
      isChange: false,
      isChangeStimul: false,
      isChangeStatic: false,
      protocolUrl: '/protocols/',
      apiUrl: '/protocols/assigned/',
      measurements: [],
      protocol: {},
      mode: 'session',
      cumulutiveKind: null,
      persentMax: true,
      scaleLabel: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.total_percent'),
      selectedPhase: null,
      selectedStage: null,
      field: null,
      interval: null,
      intervalList: [{ id: 1, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.through_each_lesson') }, { id: 2, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_one_lesson') }, { id: 3, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_two_classes') }, { id: 4, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.after_three_classes') }, { id: 5, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_a_week') }, { id: 6, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks') }, { id: 7, name: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.once_a_month') }],
      rangeDateStart: new Date(),
      rangeDateEnd: new Date(),
      minDateStart: this.getMinDateStart(new Date()),
      maxDateStart: this.getMaxDateStart(new Date()),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showReport: false,
      showSimpleReport: false,
      paginate: {
        perPage: 5,
        page: 1,
        forcePage: 0,
        lastPage: null,
        pageRange: 3,
        marginPages: 2,
        chunk: 20
      },
      optionsStatisticList: {
        perPage: 10,
        pagination: {
          chunk: 20
        },
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.name_mand_reaction')
        }, {
          key: 'stage',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.stage')
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.name_mand_reaction'),
            hasTemplate: false
          },
          stage: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.stage'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestStimulListFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          answerTitle: 'text-center',
          mandLevel: 'text-center',
          motivationCondition: 'text-center',
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      },
      optionsPecsList: {
        perPage: 10,
        pagination: {
          chunk: 20
        },
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'position',
          changed: true,
          headings: ''
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.countSamples')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt,
          position: this.position
        },
        listRow: {
          position: {
            headings: '',
            hasTemplate: true
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }

        },
        requestFunction: this.requestStimulListFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      },
      mandList: [],
      stimulRezults: [],
      stimulRezultsImproved: [],
      isApplyFilter: false,
      listChartDate: [],
      listChartDateImproved: [],
      listMandChartDate: [],
      verticalLineMandPoint: [],
      hintRezults: [],
      hintRezultsLevels: null,
      trendLinePoint: null,
      trendLinePointImproved: null,
      verticalLinePoint: null,
      verticalLinePointImproved: null,
      phases: [],
      stimulusList: [],
      stimulusListEmpty: false,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      levelLineCheckedImproved: false,
      trendLineCheckedImproved: false,
      ScatterLineCheckedImproved: false,
      chosenStimul: [],
      phasesList: [],
      stagesList: [],
      allFields: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.all_field'),
      isChangeStimuli: false,
      teachingMethod: null,
      graphReaction: null,
      graphReactionPointArray: [],
      graphReactionDays: null,
      graphReactionxLabels: null,
      taskTypesMand: [],
      lastSession: [],
      stimulusId: null,
      selectedId: null,
      measurementMandDay: null,
      measurementDay: null,
      cumulutiveData: null,
      isModalVisible: false,
      isChainModalVisible: false,
      isPromptModalVisible: false,
      dataPoint: null,
      hoveredIndex: null,
      chartDatasetsForStages: null,
      trendLineArrayPoint: [],
      version: null,
      type: null,
      selectedStageId: null,
      measurementsBehavior: null,
      changedShow: false,
      xLabelsShaping: null,
      yLabelsShaping: null,
      measurementsShaping: null,
      lastSessionChart: null,
      xLastSessionChart: null,
      yLastSessionChart: null,
      horizontalLinePointShaping: null,
      chartDatasetsForStimul: null,
      changed: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_42__common_mixins_typeProtocol__["a" /* typeProtocol */]],
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['isBCBA', 'isCurator', 'isClient', 'user']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {

    isEmptyMeasurements: function isEmptyMeasurements() {
      if (!__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.measurements)) {
        if (!__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.measurements[0])) {
          return false;
        }
      }
      return true;
    },

    isEmptyMeasurementsList: function isEmptyMeasurementsList() {
      var counter = 0;
      for (var i = 0; i < this.measurements.length; i++) {
        if (__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.measurements[i])) {
          counter++;
        }
      }

      if (counter === this.measurements.length) {
        return true;
      }
    },

    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      var startDate = new Date(this.rangeDateStart.getFullYear(), this.rangeDateStart.getMonth(), this.rangeDateStart.getDate(), 0, 0, 0, 0);
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(startDate).unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      var endDate = new Date(this.rangeDateEnd.getFullYear(), this.rangeDateEnd.getMonth(), this.rangeDateEnd.getDate(), 23, 59, 59, 59);
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(endDate).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    lineChartDatasetBehavior: function lineChartDatasetBehavior() {
      return [this.fetchLineDatasetForChartBehavior()];
    },
    barChartAncedentDataset: function barChartAncedentDataset() {
      return this.fetchBarDatasetForChartBehavior(this.antecedentTypes, __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('behavior.ancedent'));
    },
    barChartBehaviorDataset: function barChartBehaviorDataset() {
      return this.fetchBarDatasetForChartBehavior(this.behaviorTypes, __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('behavior.unwanted_behavior'));
    },
    barChartEffectsDataset: function barChartEffectsDataset() {
      return this.fetchBarDatasetForChartBehavior(this.effectsTypes, __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('behavior.aftermath'));
    }
  }),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var dt, date, teachingMethod;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_30_vee_validate__["a" /* Validator */].extend('check-period', {
                getMessage: function getMessage(attribute) {
                  return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('rotation.unique_stimulus', { attribute: attribute });
                },
                validate: function validate() {
                  var date = new Date(_this.rangeDateStart.getFullYear(), _this.rangeDateStart.getMonth() + 4, _this.rangeDateStart.getDate(), _this.rangeDateEnd.getHours(), _this.rangeDateEnd.getMinutes(), _this.rangeDateEnd.getSeconds(), _this.rangeDateEnd.getMilliseconds());
                  return _this.rangeDateEnd.getTime() <= date.getTime();
                }
              });

              if (_this.clientData) {
                if (_this.clientData.timezone) {
                  _this.setDate();
                } else {
                  dt = new Date();
                  date = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() - 7);

                  _this.rangeDateStart = date;
                }
              }

              _context.next = 4;
              return _this.detectProtocol();

            case 4:
              teachingMethod = _context.sent;


              if (!_this.mode) {
                _this.mode = MODE_SESSIONS;
              }

              _this.fetchMeasurementLastSession();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    getData: function getData(data) {
      return [{
        absoluteData: data.absoluteData,
        relativeData: data.relativeData,
        stageInfo: this.cumulutiveData[0].stageInfo,
        categoryInfo: data.categoryInfo
      }];
    },
    changedView: function changedView() {
      this.changedShow = false;
    },
    fetchBarDatasetForChartBehavior: function fetchBarDatasetForChartBehavior(listTypes, name) {
      var _this2 = this;

      var data = [],
          i = 0,
          label = name,
          backgroundColor = void 0,
          datasets = [],
          legends = [];

      var types = __WEBPACK_IMPORTED_MODULE_24_lodash_orderBy___default()(listTypes, 'count', 'desc');

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(types, function (item) {
        data = [{
          x: ++i,
          y: item.count
        }];
        label = item.title;
        backgroundColor = _this2.getRandomColor();
        legends.push({
          label: label,
          background: backgroundColor
        });

        datasets.push(new BarChartDataset({
          data: data, label: label, labels: legends, backgroundColor: backgroundColor, borderColor: backgroundColor
        }));
      });

      return datasets;
    },
    fetchLineDatasetForChartBehavior: function fetchLineDatasetForChartBehavior() {
      var _this3 = this;

      var data = [],
          i = 0;

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.measurementsBehavior, function (item) {
        data.push({
          x: _this3.toLocaleDate(item.dateRange.end),
          y: item.perHourCount
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    },
    popupShow: function popupShow(data, stageId, hoveredIndex) {

      if (this.chosenStimul.length == 1) {

        var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone)._offset;

        var dateX = data.x;
        var date = __WEBPACK_IMPORTED_MODULE_38_lodash_split___default()(data.x, ')');

        if (date.length > 1) {
          dateX = date[date.length - 1];
        }

        this.dataPoint = this.teachingMethod == 4 ? __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix() : __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(dateX, 'DD.MM.YYYY').unix() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;

        this.hoveredIndex = hoveredIndex;
        this.selectedStageId = stageId;
        this.isModalVisible = true;
      }
    },
    popupPromptShow: function popupPromptShow(data) {
      if (this.chosenStimul.length == 1) {
        var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone)._offset;
        this.dataPoint = __WEBPACK_IMPORTED_MODULE_13_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
        this.isPromptModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;

      this.isChainModalVisible = false;
    },
    onPromptClose: function onPromptClose() {
      this.isPromptModalVisible = false;
    },


    toLocaleDateTime: function toLocaleDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
    },

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    mandDate: function mandDate(h, row) {
      return row.mandDate ? this.toLocaleDate(row.mandDate.date) : '';
    },
    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    mandLevel: function mandLevel(h, row) {
      var level = '';
      if (row.mandLevel == 'spontaneous_level') {
        level = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.spontaneous_level');
      }

      if (row.mandLevel == 'with_subject') {
        level = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.with_subject');
      }

      return level;
    },
    motivationCondition: function motivationCondition(h, row) {
      var condition = '';
      if (row.motivationCondition) {
        condition = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('admin.yes');
      } else {
        condition = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('admin.no');
      }

      return condition;
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    day: function day(h, row) {
      return row.day ? this.toLocaleDate(row.day.date) : '';
    },
    position: function position(h, row) {
      return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.step') + row.position;
    },
    secondDuration: function secondDuration(h, row) {
      var minDuration = __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(row.secondDuration / 60);
      var secDuration = row.secondDuration - minDuration * 60;

      return minDuration + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.min') + ' ' + secDuration + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.sec');
    },


    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get(key);
    },
    clientDateTime: function clientDateTime(date) {
      if (date) {
        var timezone = this.isClient ? __WEBPACK_IMPORTED_MODULE_31__common_auth_Manager__["a" /* default */].getUserInfo().timezone : this.clientData.timezone;
        if (!timezone) {
          return this.toLocaleDate(__WEBPACK_IMPORTED_MODULE_13_moment___default()(date));
        }

        var clientDateEnd = this.toLocaleDate(__WEBPACK_IMPORTED_MODULE_13_moment___default()(date).tz(timezone).add(-__WEBPACK_IMPORTED_MODULE_13_moment___default()(date).utcOffset(), 'm')._d);
        return clientDateEnd;
      }
    },
    onChangeSelectedPhase: function onChangeSelectedPhase(val) {
      this.selectedPhase = val;
      this.field = null;
      this.fieldList = [];

      if (val.id) {
        if (val.minFieldCount) {
          this.field = null;
          this.fieldList = [];
          for (var i = val.minFieldCount; i <= val.maxFieldCount; i++) {
            this.fieldList.push(i);
          }

          this.fieldList.unshift(this.allFields);
        } else {
          this.intervalList = val.intervals;

          this.intervalList.unshift({
            type: {
              id: null
            }
          });
        }
      }
    },
    checkedStimulus: function checkedStimulus(id) {
      var checked = false;
      if (id && this.chosenStimul.length) {
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chosenStimul, function (stimul) {
          if (stimul.stimulusId == id || stimul.id == id) {
            checked = true;
          }
        });
      }

      return checked;
    },
    choseSimpleStimulus: function choseSimpleStimulus(val, checked) {
      this.isChangeStimuli = true;
      this.showSimpleReport = false;
      if (checked) {
        this.chosenStimul.push(val);
      } else {
        var array = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.chosenStimul, function (item) {
          return item.name !== val.name;
        });
        this.chosenStimul = array;
      }
    },
    chartSimpleShow: function chartSimpleShow() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                _this4.showSimpleReport = true;

                _this4.loaded = true;

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchDataSetForSession: function fetchDataSetForSession() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this5.chosenStimul.length) {
                  _context4.next = 2;
                  break;
                }

                return _context4.delegateYield( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var graphReactionPointArray, graphReactionChangesArray, graphReactionChangesListArray, graphReactionDays, graphReactionDaysWithId, dataForStimulusList, chartDatasets, stages, countStimul, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, _ref2, indexStimul, stimul, id, url, response;

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this5.isChangeStimul = false;
                          _this5.graphReaction = [];
                          graphReactionPointArray = [];
                          graphReactionChangesArray = [];
                          graphReactionChangesListArray = [];
                          graphReactionDays = [];

                          _this5.graphReactionDays = [];
                          graphReactionDaysWithId = [];

                          _this5.isChangeStimuli = true;
                          _this5.isApplyFilter = true;
                          dataForStimulusList = [];
                          chartDatasets = [];
                          stages = [];
                          countStimul = _this5.chosenStimul.length;
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _iteratorError = undefined;
                          _context3.prev = 17;
                          _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(_this5.chosenStimul));

                        case 19:
                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context3.next = 35;
                            break;
                          }

                          _ref = _step.value;
                          _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                          indexStimul = _ref2[0];
                          stimul = _ref2[1];
                          id = stimul.id;
                          url = _this5.apiUrl + 'vcd/' + _this5.protocolId + '/mensuration/' + id;
                          _context3.next = 28;
                          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
                            params: {
                              startDate: _this5.rangeDateStartTimestamp,
                              endDate: _this5.rangeDateEndTimestamp,
                              stageId: _this5.selectedStage ? _this5.selectedStage.id : null
                            }
                          });

                        case 28:
                          response = _context3.sent;


                          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(response.data.data.chartData[0].data, function (stagesData) {
                            var stage = [stagesData.stageInfo];
                            stages = __WEBPACK_IMPORTED_MODULE_28_lodash_unionBy___default()(stages, stage, 'id');
                          });

                          chartDatasets.push({
                            stimul: stimul.name,
                            data: response.data.data.chartData[0].data
                          });
                          graphReactionChangesListArray = __WEBPACK_IMPORTED_MODULE_28_lodash_unionBy___default()(graphReactionChangesListArray, response.data.data.changes, 'id');

                        case 32:
                          _iteratorNormalCompletion = true;
                          _context3.next = 19;
                          break;

                        case 35:
                          _context3.next = 41;
                          break;

                        case 37:
                          _context3.prev = 37;
                          _context3.t0 = _context3['catch'](17);
                          _didIteratorError = true;
                          _iteratorError = _context3.t0;

                        case 41:
                          _context3.prev = 41;
                          _context3.prev = 42;

                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }

                        case 44:
                          _context3.prev = 44;

                          if (!_didIteratorError) {
                            _context3.next = 47;
                            break;
                          }

                          throw _iteratorError;

                        case 47:
                          return _context3.finish(44);

                        case 48:
                          return _context3.finish(41);

                        case 49:

                          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stages, function (stage) {

                            __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(chartDatasets, function (stimulData, indexChart) {

                              var currentStageChart = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stimulData.data, function (data) {
                                return data.stageInfo.id === stage.id;
                              });

                              var pointStyle = "rect";

                              if (indexChart == 1) {
                                pointStyle = "circle";
                              }
                              if (indexChart == 2) {
                                pointStyle = "rectRot";
                              }
                              if (indexChart == 3) {
                                pointStyle = "triangle";
                              }

                              var chart = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                                data: currentStageChart.length ? currentStageChart[0].values : [],
                                label: stimulData.stimul,
                                pointStyle: pointStyle
                              });

                              if (!stage.dataForChart) {
                                stage.dataForChart = [];
                                stage.graphReactionDays = [];
                                stage.graphReactionxLabels = [];
                                stage.graphReactionPointArray = [];
                                stage.values = [];
                              }

                              stage.dataForChart.push(chart);

                              if (currentStageChart.length) {
                                stage.graphReactionDays = __WEBPACK_IMPORTED_MODULE_27_lodash_uniqBy___default()(__WEBPACK_IMPORTED_MODULE_28_lodash_unionBy___default()(stage.graphReactionDays, currentStageChart[0].dayVersions, 'day'));
                                stage.graphReactionxLabels = currentStageChart[0].xLabels;
                                stage.values = currentStageChart[0].values;
                              }
                            });

                            stage.graphReactionDays = __WEBPACK_IMPORTED_MODULE_29_lodash_sortBy___default()(stage.graphReactionDays, ['id', function (date) {
                              return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date.day, 'DD.MM.YYYY').unix();
                            }, function (date) {
                              return date.day.length;
                            }]);

                            stage.xLabels = [];

                            __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stage.graphReactionDays, function (day, index) {

                              if (index > 0 && day.id !== stage.graphReactionDays[index - 1].id) {

                                var lastId = day.id;
                                var firstId = stage.graphReactionDays[index - 1].id;

                                var changes = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(graphReactionChangesListArray, function (change) {
                                  return change.id > firstId && change.id <= lastId;
                                });

                                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(changes, function (change) {

                                  var indexChange = __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default()(graphReactionChangesListArray, function (item) {
                                    return item.id == change.id;
                                  });

                                  stage.xLabels.push({
                                    id: change.id,
                                    day: 'Изменения ' + (indexChange + 1)

                                  });

                                  stage.graphReactionPointArray.push({
                                    x: 'Изменения ' + (indexChange + 1),
                                    isImportant: change.isImportant,
                                    comment: change.comment
                                  });
                                });
                              }

                              stage.xLabels.push(day);
                            });

                            stage.graphReactionDays = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(stage.xLabels, 'day');
                          });

                          _this5.chartDatasetsForStages = stages;

                          _this5.isApplyFilter = false;
                          _this5.isLoaded = true;
                          _this5.isChangeStimul = false;

                          if (_this5.chosenStimul.length === 1 && (_this5.trendLineChecked || _this5.levelLineChecked || _this5.ScatterLineChecked)) {
                            __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(_this5.chartDatasetsForStages, function (dataSet, key) {
                              _this5.trendLineArrayPoint[key] = _this5.fetchDatasetLineTrend(dataSet.values, _this5.trendLineChecked, _this5.levelLineChecked, _this5.ScatterLineChecked);
                            });
                          } else {
                            __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(_this5.chartDatasetsForStages, function (dataSet, key) {
                              _this5.trendLineArrayPoint[key] = null;
                            });
                          }

                          /*if (this.chosenStimul.length === 1 && (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked)) {
                            this.trendLinePoint = this.fetchDatasetLineTrend(dataset, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
                          } else {
                            this.trendLinePoint = null;
                          }*/

                        case 55:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5, [[17, 37, 41, 49], [42,, 44, 48]]);
                })(), 't0', 2);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    choseStimulus: function choseStimulus(val, checked) {
      var _this6 = this;

      this.isChangeStimuli = true;
      if (checked) {
        this.chosenStimul.push(val);
      } else {
        var array = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.chosenStimul, function (item) {
          return _this6.teachingMethod != 4 ? item.stimulusName !== val.stimulusName : item.name !== val.name;
        });
        this.chosenStimul = array;
      }

      if (this.chosenStimul.length == 1 && this.teachingMethod != 4) {
        this.fetchDatasetForStimulus();
      }

      if (this.chosenStimul.length > 1 && this.teachingMethod != 4) {
        this.fetchDatasetForStimulusList();
      }

      if (this.teachingMethod == 4) {
        this.fetchDataSetForSession();
      }

      if (!this.chosenStimul.length) {
        this.isChangeStimuli = false;
      }
    },


    fetchTaskTypes: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.protocolUrl + 'task-types/');

              case 3:
                response = _context5.sent;


                this.taskTypesMand = response.data.data.filter(function (item) {
                  return item.id == 6;
                })[0].answers;

                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

                console.dir(_context5.t0);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function fetchTaskTypes() {
        return _ref3.apply(this, arguments);
      }

      return fetchTaskTypes;
    }(),

    fetchDatasetForStimulus: function fetchDatasetForStimulus() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var stimul, params, response, stimulus, hints, improved, data, dataImproved, dataHint, listChartDate, listChartDateImproved, dataList, dataListImproved, stimDataset, hintRezults;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                stimul = _this7.chosenStimul[_this7.chosenStimul.length - 1];
                params = {
                  stageId: _this7.selectedStage ? _this7.selectedStage.id : null,
                  startDate: _this7.rangeDateStartTimestamp,
                  endDate: _this7.rangeDateEndTimestamp
                };
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('' + _this7.apiUrl + _this7.protocolId + '/measurement/stimulus/' + stimul.stimulusId, { params: params });

              case 4:
                response = _context6.sent;
                stimulus = response.data.data.himself;
                hints = response.data.data.promptLevels;
                improved = response.data.data.improvedAnswerStat;
                data = [];
                dataImproved = [];
                dataHint = {};


                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulus, function (item, index) {
                  var changes = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                  var repeatDate = null;
                  var repeatDateNumber = 0;

                  var countDay = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stimulus, function (day) {
                    return item.day == day.day;
                  });

                  var firstDay = __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default()(stimulus, function (day) {
                    return item.day == day.day;
                  });

                  if (countDay.length > 1) {

                    if (stimulus[index - 1]) {
                      if (item.day == stimulus[index - 1].day) {
                        repeatDate = index;
                        repeatDateNumber = index - firstDay + 1;
                        changes = item.isChanged ? '(' + repeatDateNumber + ') ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') : '(' + repeatDateNumber + ') ';
                      }
                    }

                    if (stimulus[index + 1]) {
                      if (item.day == stimulus[index + 1].day) {
                        repeatDate = index;
                        repeatDateNumber = index - firstDay + 1;
                        changes = item.isChanged ? '(' + repeatDateNumber + ') ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') : '(' + repeatDateNumber + ') ';
                      }
                    }
                  }

                  data.push({
                    x: item.isChanged || repeatDate ? changes + _this7.toLocaleDate(item.day) : _this7.toLocaleDate(item.day),
                    y: item.isChanged ? changes + _this7.toLocaleDate(item.day) : __WEBPACK_IMPORTED_MODULE_25_lodash_ceil___default()(item.himself * 100),
                    comment: item.isChanged ? item.comment : '',
                    isChanged: item.isChanged,
                    isImportant: item.isImportant,
                    left: index < stimulus.length / 2,
                    right: index > stimulus.length / 2
                  });
                });

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(improved, function (item, index) {
                  var changes = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                  var repeatDate = null;
                  var repeatDateNumber = 0;

                  var countDay = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stimulus, function (day) {
                    return item.day == day.day;
                  });

                  var firstDay = __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default()(stimulus, function (day) {
                    return item.day == day.day;
                  });

                  if (countDay.length > 1) {

                    if (stimulus[index - 1]) {
                      if (item.day == stimulus[index - 1].day) {
                        repeatDate = index;
                        repeatDateNumber = index - firstDay + 1;
                        changes = item.isChanged ? '(' + repeatDateNumber + ') ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') : '(' + repeatDateNumber + ') ';
                      }
                    }

                    if (stimulus[index + 1]) {
                      if (item.day == stimulus[index + 1].day) {
                        repeatDate = index;
                        repeatDateNumber = index - firstDay + 1;
                        changes = item.isChanged ? '(' + repeatDateNumber + ') ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') : '(' + repeatDateNumber + ') ';
                      }
                    }
                  }

                  dataImproved.push({
                    x: item.isChanged || repeatDate ? changes + _this7.toLocaleDate(item.day) : _this7.toLocaleDate(item.day),
                    y: item.isChanged ? changes + _this7.toLocaleDate(item.day) : __WEBPACK_IMPORTED_MODULE_25_lodash_ceil___default()(item.improved * 100),
                    comment: item.isChanged ? item.comment : '',
                    isChanged: item.isChanged,
                    isImportant: item.isImportant,
                    left: index < stimulus.length / 2,
                    right: index > stimulus.length / 2
                  });
                });

                _this7.hintRezultsLevels = hints.levels;

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(_this7.hintRezultsLevels, function (item, index) {
                  dataHint[index] = [];
                  __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(hints.prompts, function (promptItem) {

                    var prompt = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(promptItem.prompts, function (o) {
                      return item.level === o.level;
                    });

                    if (prompt.length) {
                      dataHint[index].push({
                        x: _this7.toLocaleDate(promptItem.day.date),
                        y: item.description
                      });
                    } else {
                      dataHint[index].push({
                        x: _this7.toLocaleDate(promptItem.day.date),
                        y: null
                      });
                    }
                  });
                });

                _this7.verticalLinePoint = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
                  return point.isChanged;
                });

                _this7.verticalLinePointImproved = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(dataImproved, function (point) {
                  return point.isChanged;
                });

                if (_this7.trendLineChecked || _this7.levelLineChecked || _this7.ScatterLineChecked) {
                  _this7.trendLinePoint = _this7.fetchDatasetLineTrend(data, _this7.trendLineChecked, _this7.levelLineChecked, _this7.ScatterLineChecked);
                } else {
                  _this7.trendLinePoint = null;
                }

                if (_this7.trendLineCheckedImproved || _this7.levelLineCheckedImproved || _this7.ScatterLineCheckedImproved) {
                  _this7.trendLinePointImproved = _this7.fetchDatasetLineTrend(dataImproved, _this7.trendLineCheckedImproved, _this7.levelLineCheckedImproved, _this7.ScatterLineCheckedImproved);
                } else {
                  _this7.trendLinePointImproved = null;
                }

                listChartDate = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(data, function (item) {
                  return item.x;
                });


                if (data.length) {
                  if (data[data.length - 1]) {
                    listChartDate.push('');
                  }
                  if (data[0]) {
                    listChartDate.unshift('');
                  }
                }

                _this7.listChartDate = listChartDate;

                listChartDateImproved = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(dataImproved, function (item) {
                  return item.x;
                });


                if (data.length) {
                  if (data[data.length - 1]) {
                    listChartDateImproved.push('');
                  }
                  if (data[0]) {
                    listChartDateImproved.unshift('');
                  }
                }

                _this7.listChartDateImproved = listChartDateImproved;

                dataList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
                  return !point.isChanged || point.isChanged && point.isImportant;
                });
                dataListImproved = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(dataImproved, function (point) {
                  return !point.isChanged || point.isChanged && point.isImportant;
                });
                stimDataset = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                  data: dataList
                });


                _this7.stimulRezults = [stimDataset];

                _this7.stimulRezultsImproved = [new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                  data: dataListImproved
                })];

                _this7.hintRezultsLevels = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(hints.levels, 'description');
                _this7.hintRezultsLevels.push('');
                _this7.hintRezultsLevels.unshift(' ');

                hintRezults = [];


                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(dataHint, function (dataItem) {
                  hintRezults.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                    data: dataItem
                  }));
                });

                _this7.hintRezults = hintRezults;
                _this7.isChangeStimuli = false;

                return _context6.abrupt('return', _this7.stimulRezults);

              case 38:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    findMaxCountDate: function findMaxCountDate(list, date) {
      var max = 0;
      var countDay = 0;

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(list, function (item, index) {
        countDay = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item, function (day) {
          return date == day.day && !day.isChanged;
        }).length;

        if (countDay > max) {
          max = countDay;
        }
      });

      return max;
    },
    fetchDatasetForStimulusList: function fetchDatasetForStimulusList() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var dataForStimulusList, dataForStimulusListImproved, listChartDate, listChartDateImproved, i, stimulusList, stimulusListImproved, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, stimul, params, response, himself, improved;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dataForStimulusList = [];
                dataForStimulusListImproved = [];
                listChartDate = [];
                listChartDateImproved = [];
                i = 0;
                stimulusList = [];
                stimulusListImproved = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context7.prev = 10;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this8.chosenStimul);

              case 12:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context7.next = 25;
                  break;
                }

                stimul = _step2.value;
                params = {
                  stageId: _this8.selectedStage ? _this8.selectedStage.id : null,
                  startDate: _this8.rangeDateStartTimestamp,
                  endDate: _this8.rangeDateEndTimestamp
                };
                _context7.next = 17;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('' + _this8.apiUrl + _this8.protocolId + '/measurement/stimulus/' + stimul.stimulusId, { params: params });

              case 17:
                response = _context7.sent;
                himself = {
                  himself: response.data.data.himself,
                  stimulusName: stimul.stimulusName
                };
                improved = {
                  improved: response.data.data.improvedAnswerStat,
                  stimulusName: stimul.stimulusName
                };

                stimulusList.push(himself);
                stimulusListImproved.push(improved);

              case 22:
                _iteratorNormalCompletion2 = true;
                _context7.next = 12;
                break;

              case 25:
                _context7.next = 31;
                break;

              case 27:
                _context7.prev = 27;
                _context7.t0 = _context7['catch'](10);
                _didIteratorError2 = true;
                _iteratorError2 = _context7.t0;

              case 31:
                _context7.prev = 31;
                _context7.prev = 32;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 34:
                _context7.prev = 34;

                if (!_didIteratorError2) {
                  _context7.next = 37;
                  break;
                }

                throw _iteratorError2;

              case 37:
                return _context7.finish(34);

              case 38:
                return _context7.finish(31);

              case 39:

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulusList, function (stimulus, i) {

                  __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulus.himself, function (item, index) {
                    var countDayChanged = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stimulus.himself, function (day) {
                      return item.day == day.day && day.isChanged;
                    });

                    if (countDayChanged.length > 1) {
                      var dayChangedList = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(countDayChanged, function (day, index) {
                        var changeIndex = parseInt(index) + 1;
                        day.label = '(' + changeIndex + ') ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                        day.labelIndex = changeIndex;
                        return day;
                      });
                    }

                    if (countDayChanged.length == 1) {
                      countDayChanged[0].label = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                      countDayChanged[0].labelIndex = index;
                    }
                  });
                });

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulusListImproved, function (stimulus, i) {

                  __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulus.improved, function (item, index) {
                    var countDayChanged = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(stimulus.improved, function (day) {
                      return item.day == day.day && day.isChanged;
                    });

                    if (countDayChanged.length > 1) {
                      var dayChangedList = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(countDayChanged, function (day, index) {
                        var changeIndex = parseInt(index) + 1;
                        day.label = '(' + changeIndex + ')' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                        day.labelIndex = changeIndex;
                        return day;
                      });
                    }

                    if (countDayChanged.length == 1) {
                      countDayChanged[0].label = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
                      countDayChanged[0].labelIndex = index;
                    }
                  });
                });

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulusList, function (stimulus, i) {
                  var pointStyle = "rect";

                  if (i == 1) {
                    pointStyle = "circle";
                  }
                  if (i == 2) {
                    pointStyle = "rectRot";
                  }
                  if (i == 3) {
                    pointStyle = "triangle";
                  }

                  var data = [];

                  __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulus.himself, function (item, index) {

                    if (stimulus.himself[index - 1] && stimulus.himself[index - 1].label) {

                      if (stimulus.himself[index - 1].label && stimulus.himself[index - 1].day == item.day && !item.isChanged) {
                        item.label = '(' + stimulus.himself[index - 1].labelIndex + ') ';
                        item.labelIndex = stimulus.himself[index - 1].labelIndex;
                      }
                    }

                    listChartDate.push({
                      day: item.day,
                      label: item.label ? item.label + _this8.toLocaleDate(item.day) : _this8.toLocaleDate(item.day),
                      labelIndex: item.label ? item.labelIndex : index
                    });

                    data.push({
                      x: item.label ? item.label + _this8.toLocaleDate(item.day) : _this8.toLocaleDate(item.day),
                      y: item.isChanged ? item.label + _this8.toLocaleDate(item.day) : __WEBPACK_IMPORTED_MODULE_25_lodash_ceil___default()(item.himself * 100),
                      comment: item.isChanged ? item.comment : '',
                      isChanged: item.isChanged,
                      isImportant: item.isImportant,
                      left: index < stimulus.himself.length / 2,
                      right: index > stimulus.himself.length / 2
                    });

                    _this8.verticalLinePoint = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
                      return point.isChanged;
                    });

                    _this8.trendLinePoint = null;
                  });

                  var dataList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
                    return !point.isChanged || point.isChanged && point.isImportant;
                  });

                  var stimDataset = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                    label: stimulus.stimulusName,
                    data: dataList,
                    pointStyle: pointStyle
                  });

                  dataForStimulusList.push(stimDataset);
                });

                __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulusListImproved, function (stimulus, i) {
                  var pointStyle = "rect";

                  if (i == 1) {
                    pointStyle = "circle";
                  }
                  if (i == 2) {
                    pointStyle = "rectRot";
                  }
                  if (i == 3) {
                    pointStyle = "triangle";
                  }

                  var dataImproved = [];

                  __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(stimulus.improved, function (item, index) {

                    if (stimulus.improved[index - 1] && stimulus.improved[index - 1].label) {

                      if (stimulus.improved[index - 1].label && stimulus.improved[index - 1].day == item.day && !item.isChanged) {
                        item.label = '(' + stimulus.improved[index - 1].labelIndex + ') ';
                        item.labelIndex = stimulus.improved[index - 1].labelIndex;
                      }
                    }

                    listChartDateImproved.push({
                      day: item.day,
                      label: item.label ? item.label + _this8.toLocaleDate(item.day) : _this8.toLocaleDate(item.day),
                      labelIndex: item.label ? item.labelIndex : index
                    });

                    dataImproved.push({
                      x: item.label ? item.label + _this8.toLocaleDate(item.day) : _this8.toLocaleDate(item.day),
                      y: item.isChanged ? item.label + _this8.toLocaleDate(item.day) : __WEBPACK_IMPORTED_MODULE_25_lodash_ceil___default()(item.improved * 100),
                      comment: item.isChanged ? item.comment : '',
                      isChanged: item.isChanged,
                      isImportant: item.isImportant,
                      left: index < stimulus.improved.length / 2,
                      right: index > stimulus.improved.length / 2
                    });

                    _this8.verticalLinePointImproved = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(dataImproved, function (point) {
                      return point.isChanged;
                    });

                    _this8.trendLinePointImproved = null;
                  });

                  var dataList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(dataImproved, function (point) {
                    return !point.isChanged || point.isChanged && point.isImportant;
                  });

                  var stimDatasetImproved = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
                    label: stimulus.stimulusName,
                    data: dataList,
                    pointStyle: pointStyle
                  });

                  dataForStimulusListImproved.push(stimDatasetImproved);
                });

                _this8.hintRezults = [];
                listChartDate = __WEBPACK_IMPORTED_MODULE_27_lodash_uniqBy___default()(listChartDate, 'label');
                listChartDate = __WEBPACK_IMPORTED_MODULE_29_lodash_sortBy___default()(listChartDate, 'labelIndex');

                listChartDate = __WEBPACK_IMPORTED_MODULE_29_lodash_sortBy___default()(listChartDate, function (date) {
                  return new __WEBPACK_IMPORTED_MODULE_13_moment___default.a(date.day).unix();
                });

                _this8.listChartDate = __WEBPACK_IMPORTED_MODULE_21_lodash_map___default()(listChartDate, function (date) {
                  return date.label;
                });

                if (_this8.listChartDate.length) {
                  if (_this8.listChartDate[_this8.listChartDate.length - 1]) {
                    _this8.listChartDate.push('');
                  }
                  if (_this8.listChartDate[0]) {
                    _this8.listChartDate.unshift(' ');
                  }
                }

                _this8.stimulRezults = dataForStimulusList;
                _this8.stimulRezultsImproved = dataForStimulusListImproved;
                _this8.isChangeStimuli = false;
                return _context7.abrupt('return', dataForStimulusList);

              case 53:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[10, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    onChangeSelectedStage: function onChangeSelectedStage(val) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.selectedStage = val;

                /*if (this.isDTTProtocol) {
                   this.selectedPhase = null;
                  this.phasesList = [];
                  this.field = null;
                  this.interval = null;
                   if (val.id) {
                     let stageId = val.id;
                     let url = `${this.apiUrl}${this.protocolId}/measurement/${stageId}/phases`;
                    let response = await axios.get(url);
                     this.phasesList = orderBy(response.data.data, 'position', 'asc');
                     this.phasesList.unshift({
                      id: null,
                      typeId: 0,
                      title: lang.get('protocol.all_phases')
                    })
                   }
                 }*/

                // add get info about selected stage

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    requestStimulListFunction: function requestStimulListFunction(data) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this10.isChangeStatic = false;
                return _context9.abrupt('return', _this10.onSendReactionListRequest(_this10.optionsStatisticList.perPage, data.page));

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },


    applyFilter: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this11 = this;

        var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var result, apiUrl, url, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:

                if (change) {
                  this.isLoaded = false;
                  this.selectedId = null;
                  this.showReport = false;
                  this.changedShow = true;
                }

                _context10.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context10.sent;

                if (result) {
                  _context10.next = 10;
                  break;
                }

                this.disabled = false;
                this.loaded = false;
                this.isLoaded = true;
                this.showReport = false;
                return _context10.abrupt('return');

              case 10:
                if (!change) {
                  _context10.next = 50;
                  break;
                }

                this.isApplyFilter = true;

                if (!(this.teachingMethod != 1 && this.teachingMethod != 6)) {
                  _context10.next = 44;
                  break;
                }

                if (!(change || !this.cumulutiveData)) {
                  _context10.next = 43;
                  break;
                }

                this.showReport = false;
                this.fetchTaskTypes();
                this.isChangeStatic = true;

                apiUrl = this.apiUrl;
                _context10.t0 = this.teachingMethod;
                _context10.next = _context10.t0 === 2 ? 21 : _context10.t0 === 3 ? 23 : _context10.t0 === 4 ? 25 : _context10.t0 === 5 ? 27 : _context10.t0 === 7 ? 29 : _context10.t0 === 8 ? 31 : _context10.t0 === 9 ? 33 : _context10.t0 === 10 ? 35 : 37;
                break;

              case 21:
                apiUrl = this.apiUrl + 'simple/';
                return _context10.abrupt('break', 37);

              case 23:
                apiUrl = this.apiUrl + 'mand/';
                return _context10.abrupt('break', 37);

              case 25:
                apiUrl = this.apiUrl + 'vcd/';
                return _context10.abrupt('break', 37);

              case 27:
                apiUrl = this.apiUrl + 'chain/';
                return _context10.abrupt('break', 37);

              case 29:
                apiUrl = this.apiUrl + 'pecs-sentence-structure/';
                return _context10.abrupt('break', 37);

              case 31:
                apiUrl = this.apiUrl + 'pecs-without-discrimination/';
                return _context10.abrupt('break', 37);

              case 33:
                apiUrl = this.apiUrl + 'pecs-with-discrimination/';
                return _context10.abrupt('break', 37);

              case 35:
                apiUrl = this.apiUrl + 'pecs-features-with-items/';
                return _context10.abrupt('break', 37);

              case 37:
                url = apiUrl + this.protocolId + '/mastered-cumulative-stat';
                _context10.next = 40;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url);

              case 40:
                response = _context10.sent;

                this.cumulutiveData = response.data.data;
                this.isChangeStatic = false;

              case 43:
                if (!this.selectedId) {
                  this.isApplyFilter = false;
                }

              case 44:

                if (this.teachingMethod == 1) {
                  this.fetchDatasetForCumulutiveChartDTT();
                }

                if (this.teachingMethod == 6) {
                  this.isApplyFilter = false;
                }

                this.isChange = true;
                this.chosenStimul = [];
                this.isLoaded = true;
                setTimeout(function () {
                  _this11.showReport = true;
                }, 100);

              case 50:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function applyFilter() {
        return _ref4.apply(this, arguments);
      }

      return applyFilter;
    }(),

    fetchDatasetForCumulutiveChartDTT: function fetchDatasetForCumulutiveChartDTT() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                url = _this12.apiUrl + 'dtt/' + _this12.protocolId + '/mastered-cumulative-stat';
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url);

              case 3:
                response = _context11.sent;

                _this12.cumulutiveData = response.data.data;
                _this12.isApplyFilter = false;

              case 6:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },


    onSendReactionListRequest: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.mandList = [];

                url = this.apiUrl;
                _context12.t0 = this.teachingMethod;
                _context12.next = _context12.t0 === 1 ? 5 : _context12.t0 === 2 ? 7 : _context12.t0 === 4 ? 9 : _context12.t0 === 3 ? 11 : _context12.t0 === 7 ? 13 : 15;
                break;

              case 5:
                url = this.apiUrl + 'dtt/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                return _context12.abrupt('break', 15);

              case 7:
                url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
                return _context12.abrupt('break', 15);

              case 9:
                url = this.apiUrl + 'vcd/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                return _context12.abrupt('break', 15);

              case 11:
                url = this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/';
                return _context12.abrupt('break', 15);

              case 13:
                url = this.apiUrl + 'pecs-sentence-structure/' + this.protocolId + '/stage-introduced-mastered-history/';
                return _context12.abrupt('break', 15);

              case 15:

                //let url = this.teachingMethod == 3 ? this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/' : this.apiUrl + 'vcd/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                //let url = this.apiUrl + 'mand/' + this.protocolId + '/stimuli-reactions-statistics/'
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.selectedStage ? this.selectedStage.id : null,
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp
                };
                _context12.next = 18;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: params });

              case 18:
                response = _context12.sent;

                this.mandList = response.data.data.items;
                return _context12.abrupt('return', response);

              case 21:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function onSendReactionListRequest(_x2, _x3) {
        return _ref5.apply(this, arguments);
      }

      return onSendReactionListRequest;
    }(),

    onSendMandLastSessionRequest: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                url = this.apiUrl + 'mand/' + this.protocolId + '/last-sessions';
                params = {
                  perPage: perPage,
                  page: page
                };
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: params });

              case 4:
                response = _context13.sent;

                this.isApplyFilter = false;
                return _context13.abrupt('return', response);

              case 7:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function onSendMandLastSessionRequest(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return onSendMandLastSessionRequest;
    }(),

    answerTitle: function answerTitle(answer, mandLast) {
      var title = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(mandLast.answers, function (item) {
        return item.id == answer;
      });

      return title.length ? title[0]['title'] : '';
    },

    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },
    getMaxDateStart: function getMaxDateStart(date) {

      if (this.clientData && this.clientData.timezone) {
        var clientDateEnd = __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone).add(-__WEBPACK_IMPORTED_MODULE_13_moment___default()().utcOffset(), 'm');

        return clientDateEnd._d;
      } else {
        return new Date();
      }
    },

    setDate: function setDate() {
      var clientDateStart = __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone).subtract(__WEBPACK_IMPORTED_MODULE_22__undesirableBehavior_Constants__["a" /* default */].COUNT_DAY, 'days').add(-__WEBPACK_IMPORTED_MODULE_13_moment___default()().utcOffset(), 'm');
      var clientDateEnd = __WEBPACK_IMPORTED_MODULE_13_moment___default()().tz(this.clientData.timezone).add(-__WEBPACK_IMPORTED_MODULE_13_moment___default()().utcOffset(), 'm');

      this.rangeDateStart = clientDateStart._d;
      this.rangeDateEnd = clientDateEnd._d;
    },


    detectProtocol: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var protocolId, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                protocolId = this.protocolId ? this.protocolId : this.protocolData.id;
                _context14.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.apiUrl + protocolId + '/teaching-method');

              case 3:
                response = _context14.sent;

                this.teachingMethod = response.data.data.id;
                return _context14.abrupt('return', this.teachingMethod);

              case 6:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function detectProtocol() {
        return _ref7.apply(this, arguments);
      }

      return detectProtocol;
    }(),

    fetchMeasurementLastSession: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                this.isLoaded = false;
                if (!this.mode) {
                  this.mode = MODE_SESSIONS;
                }

                url = void 0;
                _context15.t0 = this.teachingMethod;
                _context15.next = _context15.t0 === 1 ? 7 : _context15.t0 === 2 ? 9 : _context15.t0 === 3 ? 11 : _context15.t0 === 4 ? 13 : _context15.t0 === 5 ? 15 : _context15.t0 === 6 ? 17 : _context15.t0 === 7 ? 19 : _context15.t0 === 8 ? 21 : _context15.t0 === 9 ? 23 : _context15.t0 === 10 ? 25 : 27;
                break;

              case 7:
                url = this.apiUrl + 'dtt/';
                return _context15.abrupt('break', 27);

              case 9:
                url = this.apiUrl + 'simple/';
                return _context15.abrupt('break', 27);

              case 11:
                url = this.apiUrl + 'mand/';
                return _context15.abrupt('break', 27);

              case 13:
                url = this.apiUrl + 'vcd/';
                return _context15.abrupt('break', 27);

              case 15:
                url = this.apiUrl + 'chain/';
                return _context15.abrupt('break', 27);

              case 17:
                url = this.apiUrl + 'shaping/';
                return _context15.abrupt('break', 27);

              case 19:
                url = this.apiUrl + 'pecs-sentence-structure/';
                return _context15.abrupt('break', 27);

              case 21:
                url = this.apiUrl + 'pecs-without-discrimination/';
                return _context15.abrupt('break', 27);

              case 23:
                url = this.apiUrl + 'pecs-with-discrimination/';
                return _context15.abrupt('break', 27);

              case 25:
                url = this.apiUrl + 'pecs-features-with-items/';
                return _context15.abrupt('break', 27);

              case 27:
                response = null;

                if (!(this.teachingMethod === 9)) {
                  _context15.next = 32;
                  break;
                }

                this.isLoaded = true;
                _context15.next = 37;
                break;

              case 32:
                _context15.next = 34;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url + this.protocolId + '/last-sessions');

              case 34:
                response = _context15.sent;

                this.lastSession = this.teachingMethod == 6 ? response.data.data.resultMensuration : response.data.data;
                this.measurementDay = this.lastSession.day;

              case 37:

                this.stagesList = [{
                  id: null,
                  title: __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.all_stage')
                }];

                this.stagesList = this.protocolData.protocol.stages;

                if (this.teachingMethod == 6) {
                  this.lastSessionChart = response.data.data.charts;
                }

                this.isLoaded = true;

                /*if (response){
                  this.isLoaded = true;
                }*/
                _context15.next = 47;
                break;

              case 43:
                _context15.prev = 43;
                _context15.t1 = _context15['catch'](0);

                console.dir(_context15.t1);
                if (_context15.t1.status === 403) {
                  //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
                }

              case 47:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 43]]);
      }));

      function fetchMeasurementLastSession() {
        return _ref8.apply(this, arguments);
      }

      return fetchMeasurementLastSession;
    }(),

    fetchShapingMeasurement: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var url, chartTypes, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                this.isLoaded = false;

                url = this.apiUrl + 'shaping/' + this.protocolId + '/mensuration/';
                chartTypes = [];
                _context16.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp,
                    stageId: this.selectedStage ? this.selectedStage.id : null
                  }
                });

              case 6:
                response = _context16.sent;


                this.measurementsShaping = response.data.data.data;
                this.xLabelsShaping = response.data.data.xLabels;
                this.yLabelsShaping = response.data.data.yLabels;

                _context16.next = 15;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16['catch'](0);

                console.dir(_context16.t0);

              case 15:
                _context16.prev = 15;

                this.isLoaded = true;
                this.isChange = true;
                this.showReport = true;
                this.isApplyFilter = false;
                return _context16.finish(15);

              case 21:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 12, 15, 21]]);
      }));

      function fetchShapingMeasurement() {
        return _ref9.apply(this, arguments);
      }

      return fetchShapingMeasurement;
    }(),

    fetchDatasetForShapingChart: function fetchDatasetForShapingChart(data) {
      var dataChart = [];

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(data, function (chart) {
        dataChart.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
          data: chart,
          pointBorderWidth: 2
        }));

        var value = __WEBPACK_IMPORTED_MODULE_38_lodash_split___default()(chart[0].y, '_');

        dataChart.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
          data: [{
            x: chart[0].x,
            y: value[0] + '_0'
          }, {
            x: chart[chart.length - 1].x,
            y: value[0] + '_0'
          }],
          pointRadius: 0,
          pointBackgroundColor: 'transparent',
          pointBorderColor: 'transparent',
          borderWidth: 2,
          borderDash: [12, 10]
        }));
      });

      return dataChart;
    },
    fetchDatasetForChart: function fetchDatasetForChart(item) {
      var _this13 = this;

      var data = [],
          i = 0;

      if (item.info.taskType && item.info.taskType.id === 1 && !item.phaseTypeId) {
        item.scaleLabel = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.mastered_stimuli');
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(item.mastering, function (day) {
          data.push({
            x: day.isChanged ? __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') + day.day : _this13.toLocaleDate(day.day),
            y: day.isChanged ? __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') + day.day : day.percent,
            comment: day.isChanged ? day.comment : '',
            isChanged: day.isChanged,
            isImportant: day.isImportant

          });
        });
      } else {

        item.scaleLabel = item.info.type !== 'dtt_protocol_mastering_results' ? __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.average_percent') : __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.mastering_percent');

        if (item.dayMensuration) {
          if (item.dayMensuration[0]) {
            if (item.dayMensuration[0].isChanged) {
              data.push({
                x: '',
                y: -6
              });
            }
          }
        }
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(item.dayMensuration, function (day, index) {
          var changes = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
          var next = '';
          if (index > 1) {
            if (day.isChanged && item.dayMensuration[index - 1].isChanged) {
              var count = 0;
              var countArr = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.dayMensuration, function (x) {
                return x.day == day.day && x.isImportant;
              });

              __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(countArr, function (x, index) {
                if (x.comment == day.comment) {
                  count = index + 1;
                }
              });
              count = ' / ' + index;
            }
          }

          data.push({
            x: day.isImportant ? changes + _this13.toLocaleDate(day.day) + next : _this13.toLocaleDate(day.day),
            y: day.isChanged ? changes + day.day : day.percent,
            comment: day.isChanged ? day.comment : '',
            isChanged: day.isChanged,
            isImportant: day.isImportant,
            left: index <= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2),
            right: index >= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2)
          });

          if (day.isChanged && index == item.dayMensuration.length - 1) {
            data.push({
              x: ' ',
              y: -6
            });
          }
        });

        var array = [];

        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(data, function (point, index) {
          if (point.isChanged && !point.isImportant && data[index - 1] && data[index + 1]) {

            if (!(data[index - 1].x == point.x || data[index + 1].x == point.x)) {

              point.y = (data[index - 1].y + data[index + 1].y) / 2;
              point.left = index <= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2);
              point.right = index >= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2);
              point.enabled = false;
              array.push(point);
            }
          } else {

            array.push(point);
          }
        });

        item.verticalLinePoint = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
          return point.isChanged;
        });

        data = array;
      }

      return new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    },
    chooseStimul: function chooseStimul(stim, item, key, count) {
      if (count) {
        item.choosenStimul = stim;
        this.$set(this.measurements, key, item);
      }
    },
    fetchDatasetStimulusForChart: function fetchDatasetStimulusForChart(item) {
      var _this14 = this;

      var data = [],
          i = 0;

      item.scaleLabel = item.info.type !== 'dtt_protocol_mastering_results' ? __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.average_percent') : __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.mastering_percent');

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(item.dayMensuration, function (day, index) {
        var percent = null;
        var stimul = [];
        var addPoint = true;
        var changesLine = [];
        var changes = __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from');
        if (item.choosenStimul && day.stimuli) {
          stimul = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(day.stimuli, function (st) {
            return st.description == item.choosenStimul.description;
          });
          percent = stimul[0] ? stimul[0].analytics.himself.percent : null;
          if (stimul[0] && !day.isChanged) {
            addPoint = !(percent == 0 && stimul[0].analytics.attempts == 0);
          }
        }
        if (index > 1) {
          if (day.isChanged && item.dayMensuration[index - 1].isChanged) {
            var count = 0;
            var countArr = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.dayMensuration, function (x) {
              return x.day == day.day && x.isImportant;
            });

            __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(countArr, function (x, index) {
              if (x.comment == day.comment) {
                count = index + 1;
              }
            });
            changes = count + ' ' + __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('report.changes_from') + ' ';
          }
        }

        if (addPoint && (stimul.length || day.isChanged)) {

          data.push({
            x: day.isImportant ? changes + _this14.toLocaleDate(day.day) : _this14.toLocaleDate(day.day),
            y: day.isChanged ? changes + day.day : percent,
            comment: day.isChanged ? day.comment : '',
            isChanged: day.isChanged,
            isImportant: day.isImportant,
            left: index <= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2),
            right: index >= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2)
          });
        }
      });

      if (item.trendLine || item.levelLine || item.ScatterLine) {
        item.trendLinePoint = this.fetchDatasetLineTrend(data, item.trendLine, item.levelLine, item.ScatterLine);
      } else {
        item.trendLinePoint = null;
      }

      var array = [];

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(data, function (point, index) {
        if (point.isChanged && !point.isImportant && data[index - 1] && data[index + 1]) {

          if (!(data[index - 1].x == point.x || data[index + 1].x == point.x)) {

            point.y = (data[index - 1].y + data[index + 1].y) / 2;
            point.left = index <= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2);
            point.right = index >= __WEBPACK_IMPORTED_MODULE_18_lodash_toInteger___default()(item.dayMensuration.length / 2);
            array.push(point);
          }

          if (data[index - 1].x == point.x) {
            point.left = true;
            point.right = false;
          }

          if (data[index + 1].x == point.x) {
            point.left = false;
            point.right = true;
          }
        } else {
          array.push(point);
        }
      });

      item.verticalLinePoint = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(data, function (point) {
        return point.isChanged;
      });

      data = array;

      if (data[0]) {
        if (data[0].isChanged) {
          data.unshift({
            x: ' ',
            y: -6
          });
        }
      }

      if (data[data.length - 1]) {
        if (data[data.length - 1].isChanged) {
          data.push({
            x: ' ',
            y: -6
          });
        }
      }

      /* return new LineChartDataset({
       data,
       });*/
    },
    trendLine: function trendLine(item) {
      var SumOfPowX = 0,
          SumOfX = 0,
          n = item.length,
          SumOfXY = 0,
          SumOfY = 0;

      for (var i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += i + 1;
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      var det = SumOfPowX * n - Math.pow(SumOfX, 2);
      var a = (SumOfXY * n - SumOfX * SumOfY) / det;
      var b = (SumOfY - a * SumOfX) / n;

      var first = a + b;
      var last = a * n + b;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: first
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: last
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    levelLine: function levelLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(item, function (point) {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: y
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: y
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    scatterLine: function scatterLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      var min = __WEBPACK_IMPORTED_MODULE_16_lodash_minBy___default()(item, function (o) {
        return o.y;
      });
      var max = __WEBPACK_IMPORTED_MODULE_17_lodash_maxBy___default()(item, function (o) {
        return o.y;
      });

      var dataMin = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: min
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: min
      }];

      var dataMax = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: max
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: max
      }];

      var datasetMin = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var datasetMax = new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var dataset = [datasetMin, datasetMax];

      return dataset;
    },
    fetchDatasetLineTrend: function fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
      var _this15 = this;

      var data = [],
          trendPointIndex = [],
          trendPoint = [],
          i = 0;
      var array = [];

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(item, function (point, index) {

        if (point.isImportant) {
          trendPoint.push(array);
          array = [];
          trendPointIndex.push(index);
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(array);
          }
        }
      });
      var dataset = [];

      if (trendLine) {
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this15.trendLine(point));
          }
        });
      }
      if (levelLine) {
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this15.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this15.scatterLine(point)[0]);
            dataset.push(_this15.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset;
    },
    goToGraph: function goToGraph(graphId) {
      var _this16 = this;

      var graph = 'mandGraphWrapp' + graphId;
      setTimeout(function () {
        if (_this16.$refs[graph]) {
          _this16.$refs[graph][0].scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  },
  watch: {
    levelLineChecked: function levelLineChecked(newValue) {
      var _this17 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this17.trendLineArrayPoint[key] = _this17.fetchDatasetLineTrend(dataSet.values, _this17.trendLineChecked, _this17.levelLineChecked, _this17.ScatterLineChecked);
          });
        }
      } else {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = null;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this17.trendLineArrayPoint[key] = null;
          });
        }
      }
      setTimeout(function () {
        _this17.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked: function trendLineChecked(newValue) {
      var _this18 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this18.trendLineArrayPoint[key] = _this18.fetchDatasetLineTrend(dataSet.values, _this18.trendLineChecked, _this18.levelLineChecked, _this18.ScatterLineChecked);
          });
        }
      } else {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = null;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this18.trendLineArrayPoint[key] = null;
          });
        }
      }
      setTimeout(function () {
        _this18.isChangeStimuli = false;
      }, 500);
    },
    ScatterLineChecked: function ScatterLineChecked(newValue) {
      var _this19 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.stimulRezults[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this19.trendLineArrayPoint[key] = _this19.fetchDatasetLineTrend(dataSet.values, _this19.trendLineChecked, _this19.levelLineChecked, _this19.ScatterLineChecked);
          });
        }
      } else {
        if (this.teachingMethod != 4) {
          this.trendLinePoint = null;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.chartDatasetsForStages, function (dataSet, key) {
            _this19.trendLineArrayPoint[key] = null;
          });
        }
      }
      setTimeout(function () {
        _this19.isChangeStimuli = false;
      }, 500);
    },
    levelLineCheckedImproved: function levelLineCheckedImproved(newValue) {
      var _this20 = this;

      this.isChangeStimuli = true;
      if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
        this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
      } else {
        this.trendLinePointImproved = null;
      }
      setTimeout(function () {
        _this20.isChangeStimuli = false;
      }, 500);
    },
    trendLineCheckedImproved: function trendLineCheckedImproved(newValue) {
      var _this21 = this;

      this.isChangeStimuli = true;
      if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
        this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
      } else {
        this.trendLinePointImproved = null;
      }
      setTimeout(function () {
        _this21.isChangeStimuli = false;
      }, 500);
    },
    ScatterLineCheckedImproved: function ScatterLineCheckedImproved(newValue) {
      var _this22 = this;

      this.isChangeStimuli = true;
      if (this.trendLineCheckedImproved || this.levelLineCheckedImproved || this.ScatterLineCheckedImproved) {
        this.trendLinePointImproved = this.fetchDatasetLineTrend(this.stimulRezultsImproved[0].data, this.trendLineCheckedImproved, this.levelLineCheckedImproved, this.ScatterLineCheckedImproved);
      } else {
        this.trendLinePointImproved = null;
      }
      setTimeout(function () {
        _this22.isChangeStimuli = false;
      }, 500);
    },
    mode: function mode(newValue) {
      if (newValue == 'detail') {
        this.applyFilter(this.changed);
        this.changed = false;
      }
    },
    rangeDateStart: function rangeDateStart(newValue, oldValue) {
      this.showSimpleReport = false;
      if (!newValue) {
        this.rangeDateStart = oldValue;
      }
    },
    rangeDateEnd: function rangeDateEnd(newValue, oldValue) {
      this.showSimpleReport = false;
      if (!newValue) {
        this.rangeDateEnd = oldValue;
      } else {
        this.minDateStart = this.getMinDateStart(newValue);
      }
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__managers_ProtocolApiManager__ = __webpack_require__(1121);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__managers_ProtocolApiManager__["a" /* default */]("https://app.autismtech.online/api" + '/protocols'));

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_chartStage__ = __webpack_require__(130);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp'],
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_11__common_chart__["c" /* LineChart */], Loader: __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_13__ChartPopup__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_chartStage__["a" /* chartStage */]],

  data: function data() {
    return {
      isChange: false,
      isChangeStimuli: false,
      list: [],
      options: {
        pageHeader: 'chainList',
        initialPage: null,
        perPage: 10,
        pagination: {
          chunk: 20
        },
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.name_step')
        }, {
          key: 'stage',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.environment')
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.name_step'),
            hasTemplate: false
          },
          stage: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.environment'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          answerTitle: 'text-center',
          mandLevel: 'text-center',
          motivationCondition: 'text-center',
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      },
      apiUrl: '/protocols/assigned/',
      loaded: true,
      selectedStageId: null,
      apiChartUrl: '/protocols/assigned/chain/'

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'chainList');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'chain/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage.id
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;

                this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  }

});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_max__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'isVCD': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isChain': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isSimple': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isDtt': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecs': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithoutDiscrimination': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithDiscrimination': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithItems': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isStageChain': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'version': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'stimulName': {
      type: String,
      default: function _default() {
        return '';
      }
    },
    'chartType': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'dataPoint': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stimulId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'graphTitle': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'categoryInfo': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      verticalLinePoint: [],
      apiUrl: '/protocols/assigned/',
      dataSet: null,
      valueMax: null
    };
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },

    title: function title() {

      var title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_stimul_daily');

      if (this.isChain) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_steps_daily') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_step_daily') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_percent_daily');
      }

      if (this.isPecs || this.isPecsWithoutDiscrimination) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_steps_daily_pecs') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_daily_pecs') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_perc_daily_pecs');
      }

      if (this.isPecsWithDiscrimination || this.isPecsWithItems) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_for_category_daily_pecs') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.chart_properties_per_day') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.chart_properties_percent_per_day');
      }

      return title;
    },

    scaleY: function scaleY() {

      var title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.reaction_count');

      if (this.isChain) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.reaction_count') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.step_count') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.chart_percent_axes');
      }

      if (this.isPecs || this.isPecsWithoutDiscrimination) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.number_step_pecs_detail') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.number_step_pecs') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.percent_step_pecs');
      }

      if (this.isPecsWithDiscrimination || this.isPecsWithItems) {
        title = !!this.isStageChain ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.number_step_pecs_detail') : this.chartType === 1 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.number_properties_pecs') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.percent_properties_pecs');
      }

      return title;
    }
  },
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["a" /* BarChart */] },
  mounted: function mounted() {
    this.showChart();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date * 1000).format('DD.MM.YYYY');
    },

    showChart: function showChart() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this.isVCD ? _this.apiUrl + 'vcd/' : _this.apiUrl;
                url = void 0, params = void 0;


                if (_this.isPecs) {
                  apiUrl = _this.apiUrl + 'pecs-sentence-structure/';
                }

                if (_this.isPecsWithoutDiscrimination) {
                  apiUrl = _this.apiUrl + 'pecs-without-discrimination/';
                }

                if (_this.isPecsWithDiscrimination) {
                  apiUrl = _this.apiUrl + 'pecs-with-discrimination/';
                }

                if (_this.isChain) {
                  apiUrl = _this.apiUrl + 'chain/';
                }

                if (_this.isSimple) {
                  apiUrl = _this.apiUrl + 'simple/';
                }

                if (_this.isDtt) {
                  apiUrl = _this.apiUrl + 'dtt/';
                }

                if (_this.isPecsWithItems) {
                  apiUrl = _this.apiUrl + 'pecs-features-with-items/';
                }

                if ((_this.isPecs || _this.isChain || _this.isPecsWithoutDiscrimination) && !_this.isStageChain && !_this.isSimple && !_this.isPecsWithItems) {

                  url = apiUrl + _this.protocolId + '/detailed-mastered-cumulative-stat/' + _this.stageId;
                  params = {
                    date: _this.dataPoint,
                    type: _this.chartType,
                    version: _this.version
                  };
                } else if (_this.isPecsWithItems) {

                  url = apiUrl + _this.protocolId + '/detailed-mastered-cumulative-stat/category/' + _this.categoryInfo.id;
                  params = {
                    date: _this.dataPoint,
                    type: _this.chartType,
                    version: _this.version
                  };
                } else if (_this.isPecsWithDiscrimination) {

                  if (_this.isStageChain) {

                    url = apiUrl + _this.protocolId + '/detailed-session-mensuration/' + _this.stageId + '/task/' + _this.stimulId;
                    params = {
                      date: _this.dataPoint,
                      type: _this.chartType,
                      version: _this.version
                    };
                  } else {

                    url = apiUrl + _this.protocolId + '/detailed-mastered-cumulative-stat/' + _this.stageId + '/category/' + _this.categoryInfo.id;
                    params = {
                      date: _this.dataPoint,
                      type: _this.chartType,
                      version: _this.version
                    };
                  }
                } else {

                  url = apiUrl + _this.protocolId + '/detailed-session-mensuration/' + _this.stimulId;
                  params = {
                    stageId: _this.stageId,
                    date: _this.dataPoint,
                    type: _this.chartType
                  };
                }

                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params
                });

              case 12:
                response = _context.sent;

                _this.dataSet = response.data.data;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRandomColor: function getRandomColor(i) {

      var letter = i * 48 < 248 ? i * 40 : i * 24;
      var color = 'rgb(' + letter + ',' + letter + ',' + letter + ')';

      return color;
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart() {
      var _this2 = this;

      var data = [];
      var datasets = [];
      var i = 0;
      var label = '';
      var labels = [];
      var backgroundColor = null;

      if (!this.isChain && !this.isPecs && !this.isPecsWithoutDiscrimination && !this.isPecsWithDiscrimination && !this.isPecsWithItems || this.isStageChain) {

        if (this.dataSet.data.length) {

          var arrayCount = [];

          __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(this.dataSet.data, function (item, index) {

            data = item.answers;
            label = item.info.label;
            labels = _this2.dataSet.labels;
            backgroundColor = _this2.getRandomColor(index);
            datasets.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["b" /* BarChartDataset */]({
              data: data, label: label, labels: labels, backgroundColor: backgroundColor
            }));

            var max = __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(data, 'y');
            arrayCount.push(max.y);
          });

          this.valueMax = __WEBPACK_IMPORTED_MODULE_7_lodash_max___default()(arrayCount) * 1.1;
          this.verticalLinePoint = this.dataSet.changes;
        } else {
          data = [];
          labels = [];
          backgroundColor = this.getRandomColor(1);
          datasets.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["b" /* BarChartDataset */]({
            data: data, label: label, labels: labels, backgroundColor: backgroundColor
          }));
        }
      } else {

        if (this.chartType !== 1) {
          this.valueMax = 110;
        }

        if (this.dataSet.length) {
          __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(this.dataSet, function (item, index) {
            data.push({
              x: item.index,
              y: item.count
            });

            labels.push(item.index);
          });

          label = '';
          backgroundColor = this.getRandomColor(1);
          datasets.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["b" /* BarChartDataset */]({
            data: data, label: label, labels: labels, backgroundColor: backgroundColor
          }));

          if (this.chartType === 1) {
            var _max = __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(this.dataSet, 'maxCount');
            this.valueMax = _max ? _max.maxCount * 1.1 : null;
          }
        } else {
          data = [];
          labels = [];
          backgroundColor = this.getRandomColor(1);
          datasets.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["b" /* BarChartDataset */]({
            data: data, label: label, labels: labels, backgroundColor: backgroundColor
          }));
        }
      }

      return datasets;
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChartPopupShaping__ = __webpack_require__(1128);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'isApplyFilter'],
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineShapingChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["f" /* LineShapingChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_12__ChartPopupShaping__["a" /* default */]
  },

  data: function data() {
    return {
      isChange: false,
      list: [],
      persentMax: true,
      apiUrl: '/protocols/assigned/',
      measurementsShaping: null,
      changesLine: [],
      withoutData: false,
      loaded: true,
      isShapingModalVisible: false,
      dataPoint: null,
      selectedStageId: null,
      yLabelsShaping: null,
      xLabelsShaping: null,
      changes: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.chartShow();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    popupShow: function popupShow(data, stageId) {
      this.dataPoint = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
      this.selectedStageId = stageId;
      this.isShapingModalVisible = true;
    },
    onClose: function onClose() {
      this.isShapingModalVisible = false;
    },
    fetchDatasetForShapingChart: function fetchDatasetForShapingChart(data) {
      var dataChart = [];

      __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(data, function (chart) {
        dataChart.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
          data: chart,
          pointBorderWidth: 2
        }));

        var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(chart[0].y, '_');

        dataChart.push(new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
          data: [{
            x: chart[0].x,
            y: value[0] + '_0'
          }, {
            x: chart[chart.length - 1].x,
            y: value[0] + '_0'
          }],
          pointRadius: 0,
          pointBackgroundColor: 'transparent',
          pointBorderColor: 'transparent',
          borderWidth: 2,
          borderDash: [12, 10]
        }));
      });

      return dataChart;
    },
    chartShow: function chartShow() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataForChart, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loaded = false;
                _this3.changesLine = [];
                dataForChart = [];
                url = _this3.apiUrl + 'shaping/' + _this3.protocolId + '/mensuration/' + _this3.stage.id;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
                  params: {
                    startDate: _this3.rangeDateStartTimestamp,
                    endDate: _this3.rangeDateEndTimestamp
                  }
                });

              case 6:
                response = _context3.sent;

                _this3.measurementsShaping = response.data.data.data;
                _this3.yLabelsShaping = response.data.data.yLabels;
                _this3.xLabelsShaping = response.data.data.xLabels;
                if (_this3.xLabelsShaping) {
                  _this3.xLabelsShaping.push("  ");
                }
                _this3.changes = response.data.data.changes;

                _this3.loaded = true;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'chain/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage.id
                };
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context4.sent;

                this.list = response.data.data.items;
                return _context4.abrupt('return', response);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },
  watch: {
    isApplyFilter: function isApplyFilter() {
      this.chartShow();
    }
  }

});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_chart__ = __webpack_require__(17);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {

    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'stimulName': {
      type: String,
      default: function _default() {
        return '';
      }
    },
    'dataPoint': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      verticalLinePoint: [],
      apiUrl: '/protocols/assigned/',
      dataSet: null,
      valueMax: null
    };
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_8__common_chart__["d" /* LineChartDataset */], LineShapingChart: __WEBPACK_IMPORTED_MODULE_8__common_chart__["f" /* LineShapingChart */] },
  mounted: function mounted() {
    this.showChart();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date * 1000).format('DD.MM.YYYY');
    },

    showChart: function showChart() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this.isVCD ? _this.apiUrl + 'vcd/' : _this.apiUrl;
                url = void 0, params = void 0;


                url = _this.apiUrl + 'shaping/' + _this.protocolId + '/detailed-session-mensuration/' + _this.stageId;
                params = {
                  date: _this.dataPoint
                };

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params
                });

              case 6:
                response = _context.sent;

                _this.dataSet = response.data.data;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchDatasetForShapingChart: function fetchDatasetForShapingChart(data) {
      var dataChart = [];

      __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(data, function (chart) {
        dataChart.push(new __WEBPACK_IMPORTED_MODULE_8__common_chart__["d" /* LineChartDataset */]({
          data: chart,
          pointBorderWidth: 2
        }));

        var value = __WEBPACK_IMPORTED_MODULE_6_lodash_split___default()(chart[0].y, '_');

        dataChart.push(new __WEBPACK_IMPORTED_MODULE_8__common_chart__["d" /* LineChartDataset */]({
          data: [{
            x: chart[0].x,
            y: value[0] + '_0'
          }, {
            x: chart[chart.length - 1].x,
            y: value[0] + '_0'
          }],
          pointRadius: 0,
          pointBackgroundColor: 'transparent',
          pointBorderColor: 'transparent',
          borderWidth: 2,
          borderDash: [12, 10]
        }));
      });

      return dataChart;
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CurrentStageSimple__ = __webpack_require__(1133);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedStage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'stagesList', 'showReport'],
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_12__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__["a" /* default */], CurrentStageSimple: __WEBPACK_IMPORTED_MODULE_14__CurrentStageSimple__["a" /* default */]
  },

  data: function data() {
    return {
      isChangeStatic: false,
      showSimpleReport: true,
      apiUrl: '/protocols/assigned/',
      chosenStimul: [],
      optionsStatisticList: {
        initialPage: null,
        perPage: 10,
        pagination: {
          chunk: 20
        },
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.name_mand_reaction')
        }, {
          key: 'stage',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.stage')
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.name_mand_reaction'),
            hasTemplate: false
          },
          stage: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.stage'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestStimulListFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          answerTitle: 'text-center',
          mandLevel: 'text-center',
          motivationCondition: 'text-center',
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    //this.chartShow();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    requestStimulListFunction: function requestStimulListFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChangeStatic = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'pecsWithDescrimination');
                return _context2.abrupt('return', _this2.onSendReactionListRequest(_this2.optionsStatisticList.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendReactionListRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.selectedStage ? this.selectedStage.id : null,
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;

                this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendReactionListRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendReactionListRequest;
    }(),

    checkedStimulus: function checkedStimulus(id) {
      var checked = false;
      if (id && this.chosenStimul.length) {
        __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(this.chosenStimul, function (stimul) {
          if (stimul.stimulusId == id || stimul.id == id) {
            checked = true;
          }
        });
      }

      return checked;
    },
    choseSimpleStimulus: function choseSimpleStimulus(val, checked) {
      this.isChangeStimuli = true;
      this.showSimpleReport = false;
      if (checked) {
        this.chosenStimul.push(val);
      } else {
        var array = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.chosenStimul, function (item) {
          return item.name !== val.name;
        });
        this.chosenStimul = array;
      }
    },
    chartSimpleShow: function chartSimpleShow() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                _this3.showSimpleReport = true;

                _this3.loaded = true;

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    }
  },

  watch: {
    showReport: function showReport(newValue) {

      if (!newValue) {
        this.chosenStimul = [];
        this.isChangeStatic = true;
      }
    }
  }

});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['promtChartValues', 'promtChartLevels', 'stageId', 'chosenStimul', 'protocolId', 'description', 'index', 'isSimple', 'isDtt'],
  components: {
    LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_0__common_chart__["e" /* LineNonNumericYChart */], ChartPopup: __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_ChartPopup__["a" /* default */]
  },
  data: function data() {
    return {
      selectedStageId: null,
      dataPoint: null,
      type: null,
      isModalVisible: false

    };
  },

  computed: {},
  created: function created() {
    this.promtChartLevels.push("");
    this.promtChartLevels.unshift(" ");
  },

  methods: {
    fetchDatasetForPromptsChart: function fetchDatasetForPromptsChart(dataset) {
      var _this = this;

      var datasetPromptsChart = [];

      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(dataset, function (dataItem) {

        var dateChart = !!_this.isSimple ? __WEBPACK_IMPORTED_MODULE_1_lodash_values___default()(dataItem.data) : __WEBPACK_IMPORTED_MODULE_1_lodash_values___default()(dataItem);

        if (dateChart.length) {
          datasetPromptsChart.push(new __WEBPACK_IMPORTED_MODULE_0__common_chart__["d" /* LineChartDataset */]({
            data: dateChart
          }));
        }
      });

      return datasetPromptsChart;
    },
    popupPromptShow: function popupPromptShow(data, stageId) {

      if (this.chosenStimul.length === 1) {
        this.dataPoint = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.isModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_mixins_trendLine__ = __webpack_require__(533);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'isApplyFilter', 'chosenStimul'],
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_10__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_10__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_10__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_13__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_15__chart_component_PromptChart__["a" /* default */]
  },

  data: function data() {
    return {
      isChange: false,
      list: [],
      persentMax: true,
      apiUrl: '/protocols/assigned/',
      measurements: null,
      changesLine: [],
      withoutData: false,
      loaded: true,
      isModalVisible: false,
      dataPoint: null,
      selectedStageId: null,
      yLabels: null,
      xLabels: null,
      changes: null,
      hintRezultsLevels: [],
      type: 1,
      dataset: null,
      datasetImproved: null,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      trendLinePoint: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_16__common_mixins_trendLine__["a" /* trendLine */]],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    //this.chartShow();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    popupShow: function popupShow(data, stageId) {

      if (this.chosenStimul.length === 1) {
        this.dataPoint = __WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.type = 1;
        this.isModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    },
    fetchDatasetForStageChart: function fetchDatasetForStageChart(datasetChart) {

      var chartData = [];
      var chartDataImproved = [];
      var pointStyle = "rect";

      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(datasetChart, function (chart, indexChart) {

        if (indexChart == 1) {
          pointStyle = "circle";
        }
        if (indexChart == 2) {
          pointStyle = "rectRot";
        }
        if (indexChart == 3) {
          pointStyle = "triangle";
        }

        var dataset = new __WEBPACK_IMPORTED_MODULE_10__common_chart__["d" /* LineChartDataset */]({
          data: chart.independentChartData.values,
          label: chart.description,
          pointStyle: pointStyle
        });

        var datasetImproved = new __WEBPACK_IMPORTED_MODULE_10__common_chart__["d" /* LineChartDataset */]({
          data: chart.improvedChartData.values,
          label: chart.description,
          pointStyle: pointStyle
        });

        chartData.push(dataset);
        chartDataImproved.push(datasetImproved);
      });

      this.dataset = chartData;
      this.datasetImproved = chartDataImproved;

      return chartData;
    },
    fetchDatasetForStageChartChanges: function fetchDatasetForStageChartChanges(datasetChartChanges) {

      var changes = [];

      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(datasetChartChanges, function (change) {
        changes.push({
          x: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.changes') + '_' + change.id,
          index: change.id,
          isImportant: change.isImportant,
          comment: change.comment
        });
      });

      return changes;
    },
    chartShow: function chartShow() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataForChart, chosenTaskIds, url, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loaded = false;
                _this3.changesLine = [];
                _this3.trendLinePoint = null;
                dataForChart = [];
                chosenTaskIds = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(_this3.chosenStimul, 'id');
                url = _this3.apiUrl + 'simple/' + _this3.protocolId + '/mensuration/' + _this3.stage.id;
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: {
                    startDate: _this3.rangeDateStartTimestamp,
                    endDate: _this3.rangeDateEndTimestamp,
                    globalTaskIds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(chosenTaskIds)
                  }
                });

              case 8:
                response = _context3.sent;


                if (response) {
                  _this3.measurements = response.data.data;
                  _this3.changes = _this3.fetchDatasetForStageChartChanges(_this3.measurements.changes);
                  _this3.yLabels = response.data.data.yLabels;
                  _this3.xLabels = response.data.data.labels;
                  _this3.hintRezultsLevels = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(_this3.measurements.levels, function (hint) {
                    return hint.description;
                  });
                  _this3.fetchDatasetForStageChart(_this3.measurements.tasksChart);
                }

                _this3.loaded = true;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-introduced-mastered-history/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage.id
                };
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: params });

              case 5:
                response = _context4.sent;

                this.list = response.data.data.items;
                return _context4.abrupt('return', response);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },
  watch: {
    isApplyFilter: function isApplyFilter(apply) {
      if (apply) {
        this.chartShow();
      }
    }
  }

});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trendLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);





var trendLine = {
  methods: {
    trendLine: function trendLine(item) {
      var SumOfPowX = 0,
          SumOfX = 0,
          n = item.length,
          SumOfXY = 0,
          SumOfY = 0;

      for (var i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += i + 1;
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      var det = SumOfPowX * n - Math.pow(SumOfX, 2);
      var a = (SumOfXY * n - SumOfX * SumOfY) / det;
      var b = (SumOfY - a * SumOfX) / n;

      var first = a + b;
      var last = a * n + b;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: first
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: last
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_1__chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    levelLine: function levelLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(item, function (point) {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: y
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: y
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_1__chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    scatterLine: function scatterLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      var min = __WEBPACK_IMPORTED_MODULE_2_lodash_minBy___default()(item, function (o) {
        return o.y;
      });
      var max = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(item, function (o) {
        return o.y;
      });

      var dataMin = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: min
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: min
      }];

      var dataMax = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: max
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: max
      }];

      var datasetMin = new __WEBPACK_IMPORTED_MODULE_1__chart__["d" /* LineChartDataset */]({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var datasetMax = new __WEBPACK_IMPORTED_MODULE_1__chart__["d" /* LineChartDataset */]({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var dataset = [datasetMin, datasetMax];

      return dataset;
    },
    fetchDatasetLineTrend: function fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
      var _this = this;

      var data = [],
          trendPointIndex = [],
          trendPoint = [],
          i = 0;
      var array = [];

      __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(item, function (point, index) {

        if (point.isImportant) {
          trendPoint.push(array);
          array = [];
          trendPointIndex.push(index);
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(array);
          }
        }
      });
      var dataset = [];

      if (trendLine) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.trendLine(point));
          }
        });
      }
      if (levelLine) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.scatterLine(point)[0]);
            dataset.push(_this.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset;
    }
  },

  watch: {
    levelLineChecked: function levelLineChecked(newValue) {
      var _this2 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this2.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked: function trendLineChecked(newValue) {
      var _this3 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this3.isChangeStimuli = false;
      }, 500);
    },
    ScatterLineChecked: function ScatterLineChecked(newValue) {
      var _this4 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.dataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this4.isChangeStimuli = false;
      }, 500);
    }
  }

};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CurrentStageMand__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedStage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'stagesList', 'showReport', 'taskTypesMand', 'clientData'],
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_10__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_10__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_10__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_12__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_13__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_14__chart_component_PromptChart__["a" /* default */], CurrentStageMand: __WEBPACK_IMPORTED_MODULE_15__CurrentStageMand__["a" /* default */]
  },

  data: function data() {
    return {
      isChangeStatic: false,
      showSimpleReport: true,
      apiUrl: '/protocols/assigned/',
      selectedId: null,
      chosenStimul: [],
      showMandType: true,
      showMandType1: false,
      showMandType2: false,
      showMandType3: false,
      showMandType4: false,
      showMandType5: false,
      showMandType7: false,
      showMandType8: false,
      showMandType9: false,
      showMandType10: false,
      list: [],
      graphReaction: null,
      graphReactionPointArray: [],
      graphReactionDays: null,
      graphReactionxLabels: null,
      chartSelectedType: [],
      optionsStatisticList: {
        initialPage: null,
        perPage: 10,
        pagination: {
          chunk: 20
        },
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.name_mand_reaction')
        }, {
          key: 'stage',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.stage')
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.name_mand_reaction'),
            hasTemplate: false
          },
          stage: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.stage'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestStimulListFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          answerTitle: 'text-center',
          mandLevel: 'text-center',
          motivationCondition: 'text-center',
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      },
      optionsStimulReactionList: {
        pageHeader: 'mandList',
        initialPage: 1,
        perPage: 10,
        chunk: 20,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'day',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.date')
        }, {
          key: 'secondDuration',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.duration')
        }, {
          key: 'withPrompts',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.with_prompts')
        }, {
          key: 'himself',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.himself')
        }, {
          key: 'spontaneous',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.spontaneous')
        }, {
          key: 'withPromptsHour',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.with_prompts_per_hour')
        }, {
          key: 'himselfPerHour',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.himself_per_hour')
        }, {
          key: 'spontaneousPerHour',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.spontaneous_per_hour')
        }],
        listRow: {
          day: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.date'),
            hasTemplate: false
          },
          secondDuration: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.duration'),
            hasTemplate: true
          },
          withPrompts: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.with_prompts'),
            hasTemplate: false
          },
          himself: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.himself'),
            hasTemplate: false
          },
          spontaneous: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.spontaneous'),
            hasTemplate: false
          },
          withPromptsHour: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.with_prompts_per_hour'),
            hasTemplate: false
          },
          himselfPerHour: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.himself_per_hour'),
            hasTemplate: false
          },
          spontaneousPerHour: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.spontaneous_per_hour'),
            hasTemplate: false
          }

        },
        requestFunction: this.requestStimulReactionListFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        templates: {
          day: this.day,
          secondDuration: this.secondDuration
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          secondDuration: 'text-center',
          himself: 'text-center',
          himselfPerHour: 'text-center',
          spontaneous: 'text-center',
          spontaneousPerHour: 'text-center',
          withPrompts: 'text-center',
          withPromptsHour: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.checked ? "table-info" : "";
        }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {

    titleMandReaction: function titleMandReaction() {
      var _this = this;

      var mandName = __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(this.list, function (mand) {
        return mand.id == _this.selectedId;
      });
      return mandName.length ? mandName[0].name : '';
    },

    isEmptyMand: function isEmptyMand() {
      if (this.graphReaction) {
        if (!this.graphReaction.chartData[0].data.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },

    showMand: function showMand() {
      var showList = {
        '1': this.showMandType1,
        '2': this.showMandType2,
        '3': this.showMandType3,
        '4': this.showMandType4,
        '5': this.showMandType5,
        '8': this.showMandType8,
        '9': this.showMandType9,
        '10': this.showMandType10
      };

      var array = [];

      __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(showList, function (item, key) {
        if (item) {
          array.push(key);
        }
      });

      return array;
    }
  }),

  created: function created() {
    //this.chartShow();

    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    day: function day(h, row) {
      return row.day ? this.toLocaleDate(row.day.date) : '';
    },
    secondDuration: function secondDuration(h, row) {
      var minDuration = __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(row.secondDuration / 60);
      var secDuration = row.secondDuration - minDuration * 60;

      return minDuration + __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.min') + ' ' + secDuration + __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.sec');
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    requestStimulListFunction: function requestStimulListFunction(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'mandList');
                _this3.isChangeStatic = false;
                return _context2.abrupt('return', _this3.onSendReactionListRequest(_this3.optionsStatisticList.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    onSendReactionListRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.selectedStage ? this.selectedStage.id : null,
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;

                this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendReactionListRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendReactionListRequest;
    }(),

    requestStimulReactionListFunction: function requestStimulReactionListFunction(data) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isChangeStimul = false;
                return _context4.abrupt('return', _this4.onSendMandReactionListRequest(_this4.optionsStimulReactionList.perPage, data.page));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },


    onSendMandReactionListRequest: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = this.apiUrl + 'mand/' + this.protocolId + '/stimulus-general-reactions-statistics/' + this.selectedId;
                params = {
                  perPage: perPage,
                  page: page,
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp,
                  stageId: this.selectedStage ? this.selectedStage.id : null
                };
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: params });

              case 4:
                response = _context5.sent;
                return _context5.abrupt('return', response);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onSendMandReactionListRequest(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return onSendMandReactionListRequest;
    }(),

    checkedStimulus: function checkedStimulus(id) {
      var checked = false;
      if (id && this.chosenStimul.length) {
        __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.chosenStimul, function (stimul) {
          if (stimul.stimulusId == id || stimul.id == id) {
            checked = true;
          }
        });
      }

      return checked;
    },
    graphReactionShow: function graphReactionShow() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url, chartTypes, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.graphReaction = null;
                _this5.isApplyFilter = true;
                _this5.isChangeStimul = true;
                url = _this5.apiUrl + 'mand/' + _this5.protocolId + '/mensuration/' + _this5.selectedId;
                chartTypes = _this5.showMand;
                _context6.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: {
                    chartTypes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(chartTypes),
                    startDate: _this5.rangeDateStartTimestamp,
                    endDate: _this5.rangeDateEndTimestamp,
                    stageId: _this5.selectedStage ? _this5.selectedStage.id : null
                  }
                });

              case 7:
                response = _context6.sent;


                _this5.graphReaction = response.data.data;
                _this5.chartSelectedType = chartTypes;
                if (response) {
                  _this5.isApplyFilter = false;
                  _this5.isLoaded = true;
                }

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    choseSessionStimulus: function choseSessionStimulus(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url, chartTypes, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this6.selectedId = null;
                _this6.chartSelectedType = [];
                _this6.showMandType = false;
                _this6.showMandType1 = false;
                _this6.showMandType2 = false;
                _this6.showMandType3 = false;
                _this6.showMandType4 = false;
                _this6.showMandType5 = false;
                _this6.showMandType8 = false;
                _this6.showMandType9 = false;
                _this6.showMandType10 = false;
                _this6.isChangeStimul = false;
                _this6.graphReaction = null;
                _this6.isChangeStimuli = true;

                _this6.isApplyFilter = true;
                url = _this6.apiUrl + 'mand/' + _this6.protocolId + '/mensuration/' + id;
                chartTypes = [];
                _context7.next = 19;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: {
                    chartTypes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(chartTypes),
                    startDate: _this6.rangeDateStartTimestamp,
                    endDate: _this6.rangeDateEndTimestamp,
                    stageId: _this6.selectedStage ? _this6.selectedStage.id : null
                  }
                });

              case 19:
                response = _context7.sent;

                _this6.graphReaction = response.data.data;
                if (response) {
                  _this6.selectedId = id;
                  _this6.isApplyFilter = false;
                  _this6.isLoaded = true;
                  _this6.isChangeStimul = true;
                }

              case 22:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    inListOfSelectedType: function inListOfSelectedType(type) {
      var selectType = __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(this.chartSelectedType, function (chartType) {
        return chartType === type;
      });

      console.info(this.chartSelectedType);

      return selectType.length;
    },
    graphReactionTitle: function graphReactionTitle(type) {

      var first = this.taskTypesMand[0].title;
      var second = this.taskTypesMand[1].title;
      var third = this.taskTypesMand[4].title;
      var improve = this.taskTypesMand[2].title;

      switch (type) {
        case 1:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_mo_yes_percent');
          break;
        case 2:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_mo_yes');
          break;
        case 3:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_probe', {
            'first': first,
            'second': second,
            'third': third
          });
          break;
        case 4:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_mo_goal');
          break;
        case 5:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_mand_react', {
            'first': first,
            'second': second,
            'third': third
          });
          break;
        case 6:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_prompt_levels');
          break;
        case 7:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_goal', {
            'first': first,
            'second': second,
            'third': third
          });
          break;
        case 8:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_cumulative_improve', {
            'first': first,
            'second': second,
            'third': third
          });
          break;
        case 9:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_improve_prompt', {
            'improve': improve
          });
          break;
        case 10:

          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_improve', {
            'improve': improve
          });
          break;
        case 11:
          return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('report.graph_relation_prompt', {
            'plus': '+',
            'second': second
          });
          break;

      }
    },
    chartSimpleShow: function chartSimpleShow() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:

                _this7.showSimpleReport = true;

                _this7.loaded = true;

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    goToGraph: function goToGraph(graphId) {
      var _this8 = this;

      var graph = 'mandGraphWrapp' + graphId;
      setTimeout(function () {
        if (_this8.$refs[graph]) {
          _this8.$refs[graph][0].scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  },

  watch: {
    showReport: function showReport(newValue) {

      if (!newValue) {
        this.chosenStimul = [];
        this.isChangeStatic = true;
      }
    }
  }

});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findKey__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_findKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_repeat__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_round__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MandPopup__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__undesirableBehavior_Constants__ = __webpack_require__(18);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['mandDataset', 'mandType', 'mandChanges', 'mandLevels', 'mandAnswers', 'mandTitle', 'protocolId', 'mandId', 'clientData'],
  components: {
    mandPopup: __WEBPACK_IMPORTED_MODULE_20__MandPopup__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_3__common_chart__["c" /* LineChart */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_3__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */] },

  data: function data() {
    return {
      listMandChartDate: [],
      hintRezultsLevels: [],
      verticalLineMandPoint: [],
      mandGraphReaction: null,
      levelMandLineChecked: false,
      trendMandLineChecked: false,
      scatterMandLineChecked: false,
      trendMandLinePoint: false,
      datasetForMandChart: [],
      trendLinePoint: [],
      isChangeStimuli: false,
      isModalVisible: false,
      dataPoint: null,
      stageInfo: null
    };
  },


  computed: {},

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.hintRezultsLevels = __WEBPACK_IMPORTED_MODULE_13_lodash_map___default()(_this.mandLevels, function (hint) {
                return hint.description;
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    mandGraphReactionTitle: function mandGraphReactionTitle(type) {

      var typeTitle = __WEBPACK_IMPORTED_MODULE_10_lodash_toInteger___default()(type);
      switch (typeTitle) {
        case 1:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_mo_yes_percent');
          break;
        case 2:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_mo_yes');
          break;
        case 3:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_probe', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 4:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_mo_goal');
          break;
        case 5:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_mand_react', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 6:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_prompt_levels');
          break;
        case 7:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_goal', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 8:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_cumulative_improve', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 9:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_improve_prompt', {
            'improve': this.mandAnswers[2].title
          });
          break;
        case 10:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_improve', {
            'improve': this.mandAnswers[2].title
          });
          break;
        case 11:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.graph_relation_prompt', {
            'plus': '+',
            'second': this.mandAnswers[1].title
          });
          break;

      }
    },
    popupShow: function popupShow(data, stageInfo) {

      if (this.mandType != 5 && this.mandType != 8 && this.mandType != 10 && this.mandType != 11) {

        this.dataPoint = __WEBPACK_IMPORTED_MODULE_18_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.stageInfo = stageInfo;
        this.isModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    },
    scaleLabelTitle: function scaleLabelTitle(type) {

      var typeTitle = __WEBPACK_IMPORTED_MODULE_10_lodash_toInteger___default()(type);
      switch (typeTitle) {
        case 1:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_mo_yes_percent');
          break;
        case 2:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_mo_yes');
          break;
        case 3:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_probe', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 4:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_mo_goal');
          break;
        case 5:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_mand_react', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 6:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_prompt_levels');
          break;
        case 7:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_goal', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 8:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_cumulative_improve', {
            'first': this.mandAnswers[0].title,
            'second': this.mandAnswers[1].title,
            'third': this.mandAnswers[4].title
          });
          break;
        case 9:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_improve_prompt', {
            'improve': this.mandAnswers[2].title
          });
          break;
        case 10:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_improve', {
            'improve': this.mandAnswers[2].title
          });
          break;
        case 11:
          return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('report.label_relation_prompt', {
            'plus': '+',
            'second': this.mandAnswers[1].title
          });
          break;

      }
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_18_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
    },

    trendLine: function trendLine(item) {
      var SumOfPowX = 0,
          SumOfX = 0,
          n = item.length,
          SumOfXY = 0,
          SumOfY = 0;

      for (var i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += i + 1;
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      var det = SumOfPowX * n - Math.pow(SumOfX, 2);
      var a = (SumOfXY * n - SumOfX * SumOfY) / det;
      var b = (SumOfY - a * SumOfX) / n;

      var first = a + b;
      var last = a * n + b;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: first
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: last
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    levelLine: function levelLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(item, function (point) {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: y
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: y
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    scatterLine: function scatterLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      var min = __WEBPACK_IMPORTED_MODULE_8_lodash_minBy___default()(item, function (o) {
        return o.y;
      });
      var max = __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy___default()(item, function (o) {
        return o.y;
      });

      var dataMin = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: min
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: min
      }];

      var dataMax = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: max
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: max
      }];

      var datasetMin = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var datasetMax = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var dataset = [datasetMin, datasetMax];

      return dataset;
    },
    fetchDatasetForMandChart: function fetchDatasetForMandChart(mandDataset) {
      var _this2 = this;

      var datasetForMand = mandDataset.values;
      var datasetForMandHint = __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default()(mandDataset.hintResultsData);
      var datasetForMandType = __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default()(this.mandType);

      var data = [],
          i = 0,
          datasetMandChart = [],
          promptList = {};

      if (datasetForMandType != 7 && datasetForMandType != 8 && datasetForMandType != 6) {

        var chart = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
          data: datasetForMand,
          label: datasetForMandType
        });

        if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked) {
          __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
            _this2.trendLinePoint[key] = _this2.fetchDatasetLineTrend(dataSet.values, _this2.trendMandLineChecked, _this2.levelMandLineChecked, _this2.scatterMandLineChecked);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
            _this2.trendLinePoint[key] = null;
          });
        }

        datasetMandChart = [chart];
      }

      if (datasetForMandType == 7 || datasetForMandType == 8) {
        var spontaneous = [],
            himself = [],
            prompts = [];

        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(datasetForMand, function (day, index) {

          spontaneous.push(day.spontaneous);
          himself.push(day.himself);
          prompts.push(day.prompts);
        });

        var datasetSpontaneous = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
          data: spontaneous,
          label: this.mandAnswers[0].title,
          pointStyle: 'rect'
        });
        var datasetHimselfs = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
          data: himself,
          label: this.mandAnswers[1].title,
          pointStyle: 'circle'
        });
        var datasetPrompts = new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
          data: prompts,
          label: this.mandAnswers[4].title,
          pointStyle: 'rectRot'
        });

        datasetMandChart = [datasetSpontaneous, datasetHimselfs, datasetPrompts];
      }

      if (datasetForMandType == 6) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(datasetForMandHint, function (dataItem) {

          var dateChart = __WEBPACK_IMPORTED_MODULE_19_lodash_values___default()(dataItem.data);

          if (dateChart.length) {
            datasetMandChart.push(new __WEBPACK_IMPORTED_MODULE_3__common_chart__["d" /* LineChartDataset */]({
              data: dateChart
            }));
          }
        });
      }

      this.datasetForMandChart = datasetMandChart;

      return datasetMandChart;
    },
    fetchDatasetLineTrend: function fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
      var _this3 = this;

      var data = [],
          trendPointIndex = [],
          trendPoint = [],
          i = 0;
      var array = [];

      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(item, function (point, index) {

        if (point.isImportant) {
          trendPoint.push(array);
          array = [];
          trendPointIndex.push(index);
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(array);
          }
        }
      });

      var dataset = [];

      if (trendLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this3.trendLine(point));
          }
        });
      }
      if (levelLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this3.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this3.scatterLine(point)[0]);
            dataset.push(_this3.scatterLine(point)[1]);
          }
        });
      }

      return dataset;
    }
  },
  watch: {
    levelMandLineChecked: function levelMandLineChecked(newValue) {
      var _this4 = this;

      this.isChangeStimuli = true;
      if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this4.trendLinePoint[key] = _this4.fetchDatasetLineTrend(dataSet.values, _this4.trendMandLineChecked, _this4.levelMandLineChecked, _this4.scatterMandLineChecked);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this4.trendLinePoint[key] = null;
        });
      }
      setTimeout(function () {
        _this4.isChangeStimuli = false;
      }, 500);
    },
    trendMandLineChecked: function trendMandLineChecked(newValue) {
      var _this5 = this;

      this.isChangeStimuli = true;
      if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this5.trendLinePoint[key] = _this5.fetchDatasetLineTrend(dataSet.values, _this5.trendMandLineChecked, _this5.levelMandLineChecked, _this5.scatterMandLineChecked);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this5.trendLinePoint[key] = null;
        });
      }
      setTimeout(function () {
        _this5.isChangeStimuli = false;
      }, 500);
    },
    scatterMandLineChecked: function scatterMandLineChecked(newValue) {
      var _this6 = this;

      this.isChangeStimuli = true;
      if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this6.trendLinePoint[key] = _this6.fetchDatasetLineTrend(dataSet.values, _this6.trendMandLineChecked, _this6.levelMandLineChecked, _this6.scatterMandLineChecked);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.mandDataset, function (dataSet, key) {
          _this6.trendLinePoint[key] = null;
        });
      }
      setTimeout(function () {
        _this6.isChangeStimuli = false;
      }, 500);
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_chart__ = __webpack_require__(17);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'stimulName': {
      type: String,
      default: function _default() {
        return '';
      }
    },
    'mandType': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'dataPoint': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'mandId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'typeTitle': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'graphTitle': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'mandAnswers': null
  },
  data: function data() {
    return {
      verticalLinePoint: [],
      apiUrl: '/protocols/assigned/mand/',
      mandDataSet: null
    };
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_7__common_chart__["a" /* BarChart */] },
  mounted: function mounted() {
    this.showMandChart();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date * 1000).format('DD.MM.YYYY');
    },

    showMandChart: function showMandChart() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _this.apiUrl + _this.protocolId + '/detailed-session-mensuration/' + _this.mandId;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: {
                    date: _this.dataPoint,
                    stageId: _this.stageId,
                    type: _this.mandType
                  }
                });

              case 3:
                response = _context.sent;

                _this.mandDataSet = response.data.data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRandomColor: function getRandomColor(i) {

      var letter = i * 48 < 248 ? i * 40 : i * 24;
      var color = 'rgb(' + letter + ',' + letter + ',' + letter + ')';

      return color;
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart() {
      var _this2 = this;

      var data = [];
      var datasets = [];
      var i = 0;
      var label = '';
      var labels = [];
      var backgroundColor = null;

      if (this.mandDataSet.data.length) {
        __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(this.mandDataSet.data, function (item, index) {

          data = item.answers;
          label = item.info.label;
          labels = _this2.mandDataSet.labels;
          backgroundColor = _this2.getRandomColor(index);
          datasets.push(new __WEBPACK_IMPORTED_MODULE_7__common_chart__["b" /* BarChartDataset */]({
            data: data, label: label, labels: labels, backgroundColor: backgroundColor
          }));
        });

        this.verticalLinePoint = this.mandDataSet.changes;
      } else {
        data = [];
        label = '';
        labels = [];
        backgroundColor = this.getRandomColor(1);
        datasets.push(new __WEBPACK_IMPORTED_MODULE_7__common_chart__["b" /* BarChartDataset */]({
          data: data, label: label, labels: labels, backgroundColor: backgroundColor
        }));
      }

      console.info(datasets);

      return datasets;
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_mixins_trendLine__ = __webpack_require__(533);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp'],
  components: {
    PromptChart: __WEBPACK_IMPORTED_MODULE_18__chart_component_PromptChart__["a" /* default */],
    TableView: __WEBPACK_IMPORTED_MODULE_6__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_12__common_chart__["c" /* LineChart */], Loader: __WEBPACK_IMPORTED_MODULE_15__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_16__ChartPopup__["a" /* default */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_12__common_chart__["e" /* LineNonNumericYChart */]
  },

  data: function data() {
    return {
      isChange: false,
      isChangeStimuli: false,
      list: [],
      persentMax: true,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      trendLinePoint: null,
      options: {
        pageHeader: 'dttList',
        initialPage: null,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        columns: [{
          key: 'stimulusName',
          changed: false,
          headings: ''
        }, {
          key: 'value',
          changed: true,
          headings: ''
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.introduced')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.mastered')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt,
          value: this.value
        },
        listRow: {
          stimulusName: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.stimulus_name'),
            hasTemplate: false
          },
          value: {
            headings: "",
            hasTemplate: true
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.introduced'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.mastered'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          answerTitle: 'text-center',
          mandLevel: 'text-center',
          motivationCondition: 'text-center',
          countSamples: 'text-center'
        },
        rowClassCallback: function rowClassCallback(row) {
          return row.stimulusName && !row.checked ? "" : !row.stimulusName ? 'child-row' : "table-info";
        }
      },
      apiUrl: '/protocols/assigned/',
      chosenStimul: [],
      chartDatasetsForStimul: null,
      dataset: null,
      changesLine: [],
      withoutData: false,
      loaded: true,
      isDTTModalVisible: false,
      dataPoint: null,
      selectedStageId: null,
      promptsChartList: [],
      type: null
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_19__common_mixins_trendLine__["a" /* trendLine */]],

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    stimulList: function stimulList() {

      return this.dataset ? __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(this.dataset, 'label').join(", ") : null;
    }
  }),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    value: function value(h, row) {

      var value = '';

      if (row.type == 'phase' && row.value == 1) {
        value = __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.phase_mastering');
      }

      if (row.type == 'phase' && row.value == 2) {
        value = __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.phase_rotation');
      }
      if (row.type == 'phase' && row.value == 3) {
        value = __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.phase_support');
      }
      if (row.type == 'phase' && row.value == 4) {
        value = __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.phase_support');
      }

      if (row.type == 'field') {
        value = __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.field') + row.value;
      }
      if (row.type != 'phase' && row.type != 'field' && row.type != 'interval') {
        value = row.value;
      }
      if (row.type == 'interval') {
        value = row.value | intervalNameByTypeId;
      }

      return value;
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'dttList');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    popupShow: function popupShow(data, stageId) {

      if (this.chosenStimul.length == 1) {

        this.dataPoint = __WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.type = 1;
        this.isDTTModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isDTTModalVisible = false;
    },
    chartShow: function chartShow() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataForChart, dataPromptsChart, chosenTaskIds, url, response, pointStyle;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.chosenStimul.length) {
                  _context3.next = 18;
                  break;
                }

                _this3.loaded = false;
                _this3.changesLine = [];
                _this3.trendLinePoint = null;
                _this3.trendLineChecked = false;
                _this3.levelLineChecked = false;
                _this3.ScatterLineChecked = false;
                _this3.promptsChartList = [];
                dataForChart = [];
                dataPromptsChart = [];
                chosenTaskIds = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(_this3.chosenStimul, 'globalTaskId');
                url = _this3.apiUrl + 'dtt/' + _this3.protocolId + '/mensuration/' + _this3.stage.id;
                _context3.next = 14;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: {
                    startDate: _this3.rangeDateStartTimestamp,
                    endDate: _this3.rangeDateEndTimestamp,
                    taskIds: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(chosenTaskIds)
                  }
                });

              case 14:
                response = _context3.sent;

                _this3.chartDatasetsForStimul = response.data.data;

                if (_this3.chartDatasetsForStimul && _this3.chartDatasetsForStimul.chartData) {
                  pointStyle = "rect";


                  __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(_this3.chartDatasetsForStimul.chartData, function (chartData, indexChart) {

                    var data = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(chartData.data, function (chart) {
                      return chart.type === 1;
                    })[0];

                    var dataPropmts = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(chartData.data, function (chart) {
                      return chart.type === 2;
                    })[0];

                    if (indexChart == 1) {
                      pointStyle = "circle";
                    }
                    if (indexChart == 2) {
                      pointStyle = "rectRot";
                    }
                    if (indexChart == 3) {
                      pointStyle = "triangle";
                    }

                    var chart = new __WEBPACK_IMPORTED_MODULE_12__common_chart__["d" /* LineChartDataset */]({
                      data: data.values,
                      label: chartData.description,
                      pointStyle: pointStyle
                    });
                    dataForChart.push(chart);

                    _this3.promptsChartList.push(dataPropmts);
                  });

                  __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(_this3.chartDatasetsForStimul.changes, function (change) {
                    _this3.changesLine.push({
                      x: __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get('protocol.changes') + '_' + change.id,
                      index: change.id,
                      isImportant: change.isImportant,
                      comment: change.comment
                    });
                  });

                  _this3.dataset = dataForChart;
                  _this3.withoutData = false;
                } else {
                  _this3.withoutData = true;
                }
                _this3.loaded = true;

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.list = [];

                url = this.apiUrl + 'dtt/' + this.protocolId + '/stage/' + this.stage.id + '/stimuli-introduced-mastered-history/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage.id
                };
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: params });

              case 5:
                response = _context4.sent;

                this.list = response.data.data.items;
                return _context4.abrupt('return', response);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }(),

    checkedStimulus: function checkedStimulus(id) {
      var checked = false;
      if (id && this.chosenStimul.length) {
        __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(this.chosenStimul, function (stimul) {
          if (stimul.globalTaskId == id) {
            checked = true;
          }
        });
      }

      return checked;
    },
    choseStimulus: function choseStimulus(val, checked) {
      this.isChangeStimuli = true;
      if (checked) {
        this.chosenStimul.push(val);
        console.info(this.chosenStimul);
      } else {
        var array = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.chosenStimul, function (item) {
          return item.globalTaskId !== val.globalTaskId;
        });
        this.chosenStimul = array;
      }
    }
  }

});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_startsWith__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_startsWith__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'apiChartUrl': {
      type: [Number, String],
      default: function _default() {
        return '/protocols/assigned/pecs-sentence-structure/';
      }
    },
    'stage': {
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateStartTimestamp': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateEndTimestamp': {
      default: function _default() {
        return null;
      }
    },

    'teachingMethod': {
      default: function _default() {
        return null;
      }
    }

  },
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_12__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__["a" /* default */], CurrentStageMand: __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__["a" /* chartStage */], __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__["a" /* typeProtocol */]],

  data: function data() {
    return {
      message: '',
      isChange: false,
      options: {
        pageHeader: 'pecsList',
        initialPage: 1,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        chosenStimul: [],
        columns: [{
          key: 'name',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence_title')
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt,
          name: this.name
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence_title'),
            hasTemplate: true
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        }
      },
      apiUrl: '/protocols/assigned/'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    labelsActiveLength: function labelsActiveLength() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.chartDatasetsForStimul.labels, function (label) {
        return !__WEBPACK_IMPORTED_MODULE_18_lodash_startsWith___default()(label, __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.changes'));
      }).length;
    }
  }),

  created: function created() {

    //this.chartShow();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    setLegend: function setLegend(html) {
      this.message = html;
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    name: function name(h, row) {
      return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get(row.name);
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'pecsList');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiChartUrl + this.protocolId + '/stage/' + this.stage.id + '/stimuli-introduced-mastered-history/';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage.id
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;

                this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },

  watch: {
    showReport: function showReport(newValue) {}
  }

});

/***/ }),
/* 539 */,
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_typeProtocol__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_ChartPopup__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['teachingMethod', 'cumulutiveData', 'selectedStage', 'protocolId', 'categoryInfo', 'stageInfo'],
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_0__common_chart__["c" /* LineChart */], ChartPopup: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_ChartPopup__["a" /* default */]
  },
  data: function data() {
    return {
      cumulutiveKind: null,
      isModalVisible: false,
      dataPoint: null,
      type: null,
      version: null,
      selectedStageId: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_mixins_typeProtocol__["a" /* typeProtocol */]],
  methods: {
    fetchDatasetForCumulutiveChart: function fetchDatasetForCumulutiveChart(datasetChart) {
      var dataset = new __WEBPACK_IMPORTED_MODULE_0__common_chart__["d" /* LineChartDataset */]({
        data: datasetChart
      });
      return [dataset];
    },
    chartDate: function chartDate(chartDateList) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_values___default()(chartDateList);
    },
    popupAbsoluteDataShow: function popupAbsoluteDataShow(data, stageId) {

      this.dataPoint = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
      this.version = data.version;
      this.type = 1;
      this.selectedStageId = stageId;
      this.isModalVisible = true;
    },
    popupRelativeDataShow: function popupRelativeDataShow(data, stageId) {

      this.dataPoint = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
      this.version = data.version;
      this.type = 2;
      this.selectedStageId = stageId;
      this.isModalVisible = true;
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['session', 'rowStimuli'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  methods: {
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_2__lang_translator__["a" /* default */].get(key);
    },
    answerTitle: function answerTitle(answer, last) {
      var title = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(last.answers, function (item) {
        return item.id == answer;
      });

      return title.length ? title[0]['title'] : '';
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_mixins_typeProtocol__ = __webpack_require__(65);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['session', 'teachingMethod', 'isRowData'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_mixins_typeProtocol__["a" /* typeProtocol */]],
  methods: {
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_2__lang_translator__["a" /* default */].get(key);
    },
    answerTitle: function answerTitle(answer, last) {
      var title = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(last.answers, function (item) {
        return item.id == answer;
      });

      return title.length ? title[0]['title'] : '';
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_mixins_typeProtocol__ = __webpack_require__(65);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['session', 'teachingMethod'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_mixins_typeProtocol__["a" /* typeProtocol */]],
  methods: {
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_2__lang_translator__["a" /* default */].get(key);
    },
    answerTitle: function answerTitle(answer, last) {
      var title = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(last.answers, function (item) {
        return item.id == answer;
      });

      return title.length ? title[0]['title'] : '';
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__ = __webpack_require__(65);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'apiChartUrl': {
      type: [Number, String],
      default: function _default() {
        return '/protocols/assigned/pecs-with-discrimination/';
      }
    },
    'stage': {
      default: function _default() {
        return null;
      }
    },
    'stagesList': {
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateStartTimestamp': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateEndTimestamp': {
      default: function _default() {
        return null;
      }
    },

    'teachingMethod': {
      default: function _default() {
        return null;
      }
    }

  },
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_12__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__["a" /* default */], CurrentStageMand: __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__["a" /* chartStage */], __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__["a" /* typeProtocol */]],

  data: function data() {
    return {
      message: '',
      isChange: false,
      options: {
        pageHeader: 'pecsWithDescrimination',
        initialPage: 1,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        chosenStimul: [],
        columns: [{
          key: 'categoryTitle',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.categoryTitle')
        }, {
          key: 'stageId',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.levelTitle')
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          categoryTitle: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.categoryTitle'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        }
      },
      apiUrl: '/protocols/assigned/'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    //this.chartShow();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    stageName: function stageName(id) {
      var title = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.stagesList, function (item) {
        return item.id == id;
      });
      return title.length ? title[0].description : this.stagesList[this.stagesList.length - 1].description;
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt) : '';
    },
    name: function name(h, row) {
      return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get(row.name);
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'pecsWithDescrimination');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var _this3 = this;

        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiChartUrl + this.protocolId + '/category-introduced-mastered-history';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage ? this.stage.id : null
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;


                __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(response.data.data.items, function (item) {

                  __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(item.rowData, function (rowData, index) {

                    _this3.list.push({
                      categoryTitle: index === 0 ? item.categoryTitle : '',
                      startedAt: rowData.startedAt,
                      masteredAt: rowData.masteredAt,
                      countSamples: rowData.countSamples,
                      stageId: rowData.stageId
                    });
                  });
                });

                response.data.data.items = this.list;

                //this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },

  watch: {
    showReport: function showReport(newValue) {}
  }

});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CurrentStageMand__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_chartStage__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_mixins_typeProtocol__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chart_component_ChartForStimul__ = __webpack_require__(1160);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'apiChartUrl': {
      type: [Number, String],
      default: function _default() {
        return '/protocols/assigned/pecs-with-discrimination/';
      }
    },
    'stage': {
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateStartTimestamp': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateEndTimestamp': {
      default: function _default() {
        return null;
      }
    },

    'teachingMethod': {
      default: function _default() {
        return null;
      }
    },

    'category': {
      default: function _default() {
        return null;
      }
    }

  },
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], ChartPopup: __WEBPACK_IMPORTED_MODULE_11__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_12__chart_component_PromptChart__["a" /* default */], CurrentStageMand: __WEBPACK_IMPORTED_MODULE_13__CurrentStageMand__["a" /* default */], ChartForStimul: __WEBPACK_IMPORTED_MODULE_17__chart_component_ChartForStimul__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_chartStage__["a" /* chartStage */], __WEBPACK_IMPORTED_MODULE_16__common_mixins_typeProtocol__["a" /* typeProtocol */]],

  data: function data() {
    return {
      message: '',
      isChange: false,
      options: {
        pageHeader: 'pecsCategory',
        initialPage: 1,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        chosenStimul: [],
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.propertyTitle')
        }, {
          key: 'stage',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.levelTitle')
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.propertyTitle'),
            hasTemplate: false
          },
          stage: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.levelTitle'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        }
      },
      optionsItems: {
        initialPage: 1,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        chosenStimul: [],
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.propertyTitle')
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }, {
          key: 'action',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.choose_stimul_chart')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.propertyTitle'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        }
      },
      apiUrl: '/protocols/assigned/'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {

    //this.chartShow();


    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
    },
    name: function name(h, row) {
      return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get(row.name);
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'pecsCategory');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];
                url = this.apiChartUrl + this.protocolId + '/category/' + this.category.id + '/stimuli-introduced-mastered-history';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage ? this.stage.id : null
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;
                return _context3.abrupt('return', response);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },

  watch: {
    showReport: function showReport(newValue) {}
  }

});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboardParent_components_ChartPopupTable__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_minBy__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_startsWith__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_mixins_typeProtocol__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lang_translator__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['chartData', 'chartDatasetsForStimul', 'changesLine', 'category', 'loaded', 'chosenStimul', 'protocolId', 'stage', 'teachingMethod'],
  components: {
    LineChartDataset: __WEBPACK_IMPORTED_MODULE_1__common_chart__["d" /* LineChartDataset */], LineChart: __WEBPACK_IMPORTED_MODULE_1__common_chart__["c" /* LineChart */], ChartPopup: __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_ChartPopup__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */], ChartPopupTable: __WEBPACK_IMPORTED_MODULE_3__dashboardParent_components_ChartPopupTable__["a" /* default */]
  },
  data: function data() {
    return {
      message: '',
      selectedStageId: null,
      dataPoint: null,
      type: null,
      isModalVisible: false,
      persentMax: true,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      trendLinePoint: null,
      categoryInfo: null

    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__common_mixins_typeProtocol__["a" /* typeProtocol */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    labelsActiveLength: function labelsActiveLength() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.chartDatasetsForStimul.labels, function (label) {
        return !__WEBPACK_IMPORTED_MODULE_11_lodash_startsWith___default()(label, __WEBPACK_IMPORTED_MODULE_13__lang_translator__["a" /* default */].get('protocol.changes'));
      }).length;
    },
    stageId: function stageId() {
      return this.stage ? this.stage.id : null;
    }
  }),
  created: function created() {},

  methods: {
    setLegend: function setLegend(html) {
      this.message = html;
    },
    popupShow: function popupShow(data, stageId, datasetIndex, categoryInfo) {

      if (this.chartDatasetsForStimul.chartData.length === 1) {

        this.dataPoint = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.categoryInfo = categoryInfo;
        this.isModalVisible = true;
      }
    },
    onClose: function onClose() {
      this.isModalVisible = false;
    },
    trendLine: function trendLine(item) {
      var SumOfPowX = 0,
          SumOfX = 0,
          n = item.length,
          SumOfXY = 0,
          SumOfY = 0;

      for (var i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += i + 1;
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      var det = SumOfPowX * n - Math.pow(SumOfX, 2);
      var a = (SumOfXY * n - SumOfX * SumOfY) / det;
      var b = (SumOfY - a * SumOfX) / n;

      var first = a + b;
      var last = a * n + b;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: first
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: last
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_1__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    levelLine: function levelLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(item, function (point) {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      var data = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: y
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: y
      }];

      var dataset = new __WEBPACK_IMPORTED_MODULE_1__common_chart__["d" /* LineChartDataset */]({
        data: data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset;
    },
    scatterLine: function scatterLine(item) {
      var n = item.length,
          SumOfY = 0,
          y = 0;

      var min = __WEBPACK_IMPORTED_MODULE_8_lodash_minBy___default()(item, function (o) {
        return o.y;
      });
      var max = __WEBPACK_IMPORTED_MODULE_9_lodash_maxBy___default()(item, function (o) {
        return o.y;
      });

      var dataMin = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: min
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: min
      }];

      var dataMax = [{
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[0].x,
        y: max
      }, {
        comment: "",
        isChanged: false,
        isImportant: false,
        x: item[n - 1].x,
        y: max
      }];

      var datasetMin = new __WEBPACK_IMPORTED_MODULE_1__common_chart__["d" /* LineChartDataset */]({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var datasetMax = new __WEBPACK_IMPORTED_MODULE_1__common_chart__["d" /* LineChartDataset */]({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      var dataset = [datasetMin, datasetMax];

      return dataset;
    },
    fetchDatasetLineTrend: function fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
      var _this = this;

      var data = [],
          trendPointIndex = [],
          trendPoint = [],
          i = 0;
      var array = [];

      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(item, function (point, index) {

        if (point.isImportant) {
          trendPoint.push(array);
          array = [];
          trendPointIndex.push(index);
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(array);
          }
        }
      });
      var dataset = [];

      if (trendLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.trendLine(point));
          }
        });
      }
      if (levelLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(trendPoint, function (point) {
          if (point.length > 2) {
            dataset.push(_this.scatterLine(point)[0]);
            dataset.push(_this.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset;
    }
  },
  watch: {
    levelLineChecked: function levelLineChecked(newValue) {
      var _this2 = this;

      this.isChangeStimuli = true;
      console.info(this.chartData);

      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this2.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked: function trendLineChecked(newValue) {
      var _this3 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this3.isChangeStimuli = false;
      }, 500);
    },
    ScatterLineChecked: function ScatterLineChecked(newValue) {
      var _this4 = this;

      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(function () {
        _this4.isChangeStimuli = false;
      }, 500);
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_max__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'isVCD': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isChain': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isSimple': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isDtt': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecs': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithoutDiscrimination': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithDiscrimination': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isPecsWithItems': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isStageChain': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'version': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'stimulName': {
      type: String,
      default: function _default() {
        return '';
      }
    },
    'chartType': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'dataPoint': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stimulId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'graphTitle': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'categoryInfo': {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      verticalLinePoint: [],
      apiUrl: '/protocols/assigned/',
      dataSet: null,
      valueMax: null
    };
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },

    title: function title() {

      var title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.categoryTitle') + ': ' + this.categoryInfo.title;

      return title;
    },

    scaleY: function scaleY() {

      var title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.reaction_count');

      return title;
    }
  },
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["a" /* BarChart */] },
  mounted: function mounted() {
    this.showTable();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date * 1000).format('DD.MM.YYYY');
    },

    showTable: function showTable() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = void 0;
                url = void 0, params = void 0;


                if (_this.isPecsWithItems) {
                  apiUrl = _this.apiUrl + 'pecs-features-with-items/';

                  url = apiUrl + _this.protocolId + '/detailed-session-mensuration/' + _this.stimulId;
                  params = {
                    date: _this.dataPoint,
                    type: _this.chartType,
                    version: _this.version
                  };
                }

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params
                });

              case 5:
                response = _context.sent;

                _this.dataSet = response.data.data;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/pecs-with-discrimination/',
      lastSession: null
    };
  },


  props: {
    'stage': {
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      default: function _default() {
        return null;
      }
    }

  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetchMeasurementLastSession();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get(key);
    },

    fetchMeasurementLastSession: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl + this.protocolId + '/last-sessions/stage/' + this.stage.id);

              case 3:
                response = _context2.sent;

                this.lastSession = response.data.data;

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);
                if (_context2.t0.status === 403) {
                  //this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function fetchMeasurementLastSession() {
        return _ref.apply(this, arguments);
      }

      return fetchMeasurementLastSession;
    }()
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    'title': null,
    'nameTitle': null
  },

  data: function data() {
    return {
      isShowAll: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  methods: {

    toggleShow: function toggleShow() {
      this.isShowAll = !this.isShowAll;
    }

  }

});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChartPopup__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__ = __webpack_require__(65);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'apiChartUrl': {
      type: [Number, String],
      default: function _default() {
        return '/protocols/assigned/pecs-features-with-items/';
      }
    },
    'stage': {
      default: function _default() {
        return null;
      }
    },
    'stagesList': {
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateStartTimestamp': {
      default: function _default() {
        return null;
      }
    },
    'rangeDateEndTimestamp': {
      default: function _default() {
        return null;
      }
    },

    'teachingMethod': {
      default: function _default() {
        return null;
      }
    }

  },
  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_5__common_table_components_TableView__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["c" /* LineChart */], LineChartDataset: __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */], LineNonNumericYChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["e" /* LineNonNumericYChart */], Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], ChartPopup: __WEBPACK_IMPORTED_MODULE_12__ChartPopup__["a" /* default */], PromptChart: __WEBPACK_IMPORTED_MODULE_13__chart_component_PromptChart__["a" /* default */], CurrentStageMand: __WEBPACK_IMPORTED_MODULE_14__CurrentStageMand__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_chartStage__["a" /* chartStage */], __WEBPACK_IMPORTED_MODULE_17__common_mixins_typeProtocol__["a" /* typeProtocol */]],

  data: function data() {
    return {
      message: '',
      isChange: false,
      options: {
        pageHeader: 'pecsWithItems',
        initialPage: 1,
        perPage: 25,
        filterable: false,
        debounce: 1000,
        sortable: [],
        withSearch: false,
        skin: 'table table-sm',
        chosenStimul: [],
        columns: [{
          key: 'categoryTitle',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.categoryTitle')
        }, {
          key: 'stageId',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.levelTitle')
        }, {
          key: 'startedAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at')
        }, {
          key: 'masteredAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering')
        }, {
          key: 'countSamples',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples')
        }],
        templates: {
          masteredAt: this.masteredAt,
          startedAt: this.startedAt
        },
        listRow: {
          categoryTitle: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.categoryTitle'),
            hasTemplate: false
          },
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.started_at'),
            hasTemplate: true
          },
          masteredAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.date_mastering'),
            hasTemplate: true
          },
          countSamples: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.countSamples'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table'),
          count: "Страница {page} из {pages}"
        },
        columnsClasses: {
          countSamples: 'text-center'
        }
      },
      apiUrl: '/protocols/assigned/'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  created: function created() {
    //this.chartShow();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    stageName: function stageName(id) {
      var title = __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default()(this.stagesList, function (item) {
        return item.id == id;
      })[0].description;
      return title;
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return row.startedAt ? this.toLocaleDate(row.startedAt) : '';
    },
    masteredAt: function masteredAt(h, row) {
      return row.masteredAt ? this.toLocaleDate(row.masteredAt) : '';
    },
    name: function name(h, row) {
      return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get(row.name);
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isChange = false;
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'pecsWithItems');
                return _context2.abrupt('return', _this2.onSendRequest(_this2.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onSendRequest: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(perPage, page) {
        var _this3 = this;

        var url, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.list = [];

                url = this.apiChartUrl + this.protocolId + '/stimuli-introduced-mastered-history';
                params = {
                  perPage: perPage,
                  page: page,
                  stageId: this.stage ? this.stage.id : null
                };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 5:
                response = _context3.sent;


                __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(response.data.data.items, function (item) {

                  __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(item.rowData, function (rowData, index) {

                    _this3.list.push({
                      categoryTitle: index === 0 ? item.categoryTitle : '',
                      startedAt: rowData.startedAt,
                      masteredAt: rowData.masteredAt,
                      countSamples: rowData.countSamples,
                      stageId: rowData.stageId
                    });
                  });
                });

                response.data.data.items = this.list;

                //this.list = response.data.data.items;
                return _context3.abrupt('return', response);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSendRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSendRequest;
    }()

  },

  watch: {
    showReport: function showReport(newValue) {}
  }

});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dro_api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_3__dashboardParent_components_DashboardMenu__["a" /* default */] },
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    },
    'sessionId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      loaded: false,
      hideDroModal: true,
      apiUrl: '/users/clients/',
      conflictedUrl: '/protocols/assigned/',
      client: {},
      conflicts: [],
      isLoaded: true,
      hasPager: false,
      options: {
        pageHeader: 'conflicts',
        initialPage: null,
        filterable: false,
        sortable: [],
        skin: 'table table-sm table-with-head',
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('report.stimul')
        }, {
          key: 'title',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.response')
        }, {
          key: 'phaseTypeId',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.phase')
        }, {
          key: 'fieldIndex',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.field')
        }, {
          key: 'intervalTypeId',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.interval')
        }],
        templates: {
          title: this.title,
          fieldIndex: this.fieldName,
          phaseTypeId: this.phaseNameByTypeId,
          intervalTypeId: this.intervalNameByTypeId
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.items,
            count: resp.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          name: 'wrapp-all w40',
          title: 'text-center',
          phaseTypeId: 'text-center',
          fieldIndex: 'text-center',
          intervalTypeId: 'text-center'
        },
        perPage: 20
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__common_mixins_pagination__["a" /* pagination */]],
  created: function created() {
    this.baseUrl = "https://app.autismtech.online/api" + '/interactive-modules/dro';
    this.getClient(this.clientId);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isEmptyconflicts: function isEmptyconflicts() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default()(this.conflicts);
    }
  }),
  methods: {
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.clientId } });
    },

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }(),
    toLocaleDateTime: function toLocaleDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
    },

    title: function title(h, row) {
      return __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get(row.title);
    },


    phaseNameByTypeId: function phaseNameByTypeId(h, row) {
      var name = '';
      switch (parseInt(row.phaseTypeId)) {
        case 0:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.all_phases');
          break;
        case 1:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.mastering');
          break;
        case 2:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.rotation');
          break;
        case 3:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.support');
          break;
        case 4:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.fluency');
          break;
        default:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.no_data');

      }
      return name;
    },

    intervalNameByTypeId: function intervalNameByTypeId(h, row) {
      var name = '';
      switch (parseInt(row.intervalTypeId)) {
        case 1:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.through_each_lesson');
          break;
        case 2:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.after_one_lesson');
          break;
        case 3:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.after_two_classes');
          break;
        case 4:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.after_three_classes');
          break;
        case 5:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.once_a_week');
          break;
        case 6:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks');
          break;
        case 7:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.once_a_month');
          break;
        default:
          name = __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.no_data');
          break;

      }
      return name;
    },

    fieldName: function fieldName(h, row) {
      return row.fieldIndex ? __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.field') + ' ' + row.fieldIndex : __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('protocol.no_data');
    },
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var assigneeId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                assigneeId = _this.route.params.clientId;

                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'conflicts');
                return _context2.abrupt('return', _this.fetchConflicts(assigneeId, _this.sessionId, _this.options.perPage, data.page));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getConflicts: function getConflicts(assigneeId, sessionId, perPage, page) {
      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.conflictedUrl + assigneeId + '/inconsistent/stimuli/' + sessionId + ('/' + perPage + '/' + page));
    },


    fetchConflicts: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(assigneeId, sessionId, perPage, page) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.isLoaded = false;
                _context3.next = 4;
                return this.getConflicts(assigneeId, sessionId, perPage, page);

              case 4:
                response = _context3.sent;


                this.hasPager = response.data.data.lastPage > 1;

                this.conflicts = response.data.data.items;
                this.setPaginate(response.data.data);
                this.isLoaded = true;

                return _context3.abrupt('return', response.data.data);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);
                this.isLoaded = true;

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 12]]);
      }));

      function fetchConflicts(_x2, _x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return fetchConflicts;
    }(),

    onPaginationClick: function onPaginationClick(pageNum) {
      var assigneeId = this.route.params.clientId;
      this.fetchConflicts(assigneeId, this.paginate.perPage, pageNum);
      this.onPaginationBtnClick(pageNum);
    }
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEachRight__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEachRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEachRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_values__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__filters_filters__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__randomRotation_Constants_js__ = __webpack_require__(172);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






























/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/vcd/',
      apiCheckedUrl: '/protocols/assigned/',
      isLoaded: false,
      protocols: null,
      isConflictModalVisible: false,
      changedGroup: [],
      sessionView: false,
      saveChangesPopup: false,
      setSessions: [],
      blocksLength: 9,
      blocksStimulusLength: 3,
      selectedGroup: null,
      currentSessionIndex: 0,
      selectedLevelUiid: null,
      answerList: [],
      chooseNextSessionModal: false,
      selectedIndexGroup: null,
      selectedIndex: null,
      tempSessions: null,
      shortDescripton: null,
      majorVersion: null,
      protocolData: null,
      stageInfo: this.stage,
      timerId: null,
      selectedRow: null,
      uuid: null
    };
  },


  components: {
    Instruction: __WEBPACK_IMPORTED_MODULE_4__common_instruction_components_InstructionView__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.previousDate).unix();
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.previousDate).unix() + 3600;
    },
    minDate: function minDate() {
      return this.protocolData.endDate ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    himselfAnswer: function himselfAnswer() {
      var active = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.protocols.taskType.answers, 'himself');
      return active.length ? active[0].id : null;
    },
    promptAnswer: function promptAnswer() {
      var active = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.protocols.taskType.answers, 'isPrompt');
      return active.length ? active[0].id : null;
    },
    otherAnswer: function otherAnswer() {
      var active = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.protocols.taskType.answers, function (item) {
        return !item.himself && !item.isPrompt;
      });
      return active.length ? active[0] : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolData.endDate && this.isPreviousDateSession && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.minDate).unix();
        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);

        var previous = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix();
        return previous <= protocolDate;
      }

      return false;
    },
    currentAnswersLenght: function currentAnswersLenght() {
      var answerLength = 0;

      if (this.sessionView) {

        var sessinAnswer = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.tempSessions.blocks, function (block) {
          return block.answer;
        });

        answerLength = sessinAnswer.length;
      }

      return answerLength;
    },
    answersLenght: function answersLenght() {
      var answerLength = 0;

      if (this.sessionView) {

        var sessinAnswer = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.tempSessions.blocks, function (block) {
          return block.answer;
        });

        answerLength = this.selectedGroup.lastSession ? sessinAnswer.length + this.selectedGroup.lastSession.blocks.length : sessinAnswer.length;
      }

      return answerLength;
    }
  }),

  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.stage) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.apiUrl + _this.protocolId + '/show-stage/' + _this.stageId);

            case 3:
              response = _context.sent;

              _this.stageInfo = response.data.data;

            case 5:

              _this.protocolData = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(_this.protocolVuexData);

              _this.fetchProtocol();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    //this.setProtocol(null)
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('appeals', ['setEntity']), Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    currentAnswer: function currentAnswer(stimul, index) {
      var current = [];
      if (this.selectedGroup.lastSession) {
        current = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.selectedGroup.lastSession.blocks, function (block) {
          return block.index == index;
        });
      }

      return current.length && !current[0].isPrompt ? current[0].selectedStimulusUuid === stimul.stimulus.globalUuid : false;
    },
    currentAnswerPrompt: function currentAnswerPrompt(index) {
      var current = [];
      if (this.selectedGroup.lastSession) {
        current = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.selectedGroup.lastSession.blocks, function (block) {
          return block.index == index;
        });
      }

      return current.length ? current[0].isPrompt : false;
    },
    currentAnswerError: function currentAnswerError(index) {
      var current = [];
      if (this.selectedGroup.lastSession) {
        current = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.selectedGroup.lastSession.blocks, function (block) {
          return block.index == index;
        });
      }

      return current.length ? !current[0].isHimself : false;
    },
    disabledRow: function disabledRow(index) {
      var current = [];
      var previous = [];
      var answPrev = false;
      var answNext = false;

      if (this.selectedGroup.lastSession) {
        current = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.selectedGroup.lastSession.blocks, function (block) {
          return block.index == index;
        });

        if (index > 0) {
          previous = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.selectedGroup.lastSession.blocks, function (block) {
            return block.index == index - 1;
          });
        }
      }

      if (index > 0) {

        answPrev = previous.length || this.tempSessions.blocks[index - 1].answer;
      }

      if (index < this.tempSessions.blocks.length - 1) {

        answNext = this.tempSessions.blocks[index + 1].answer;
      }

      return !!current.length || !(answPrev || index == 0) && !answNext;
    },
    disableC: function disableC(stimul) {
      if (!this.selectedIndex) {
        return stimul.correct;
      }

      return false;
    },


    fetchProtocol: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(nextSession) {
        var entity, params, newDate, newDateUnix, timeSessionDate, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.currentSesssionDate = Math.round(new Date().getTime() / 1000);

                this.uuid = __WEBPACK_IMPORTED_MODULE_20__common_uuid_UuidGenerator__["a" /* default */].v4();
                entity = {
                  id: this.uuid,
                  type: 'assigned-session'
                };


                this.setEntity(entity);

                this.isLoaded = false;

                this.changedGroup = [];

                params = {};


                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_16_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_16_moment___default.a.utc(this.previousDate).unix;

                  params = {
                    date: newDateUnix
                  };
                }

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/stage/' + this.stageId + '/phase/5', {
                  params: params
                });

              case 10:
                response = _context2.sent;

                this.protocols = response.data.data;
                if (response) {
                  if (nextSession) {
                    this.showSession();
                  }
                  this.isLoaded = true;
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchProtocol(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchProtocol;
    }(),

    goToNextLevel: function goToNextLevel(index, groupIndex) {

      var levels = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels);
      var group = this.protocols.levels[index].groups[groupIndex];
      var nextLevelGroup = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels[index + 1].groups);

      nextLevelGroup.push({
        uuid: group.uuid,
        index: group.index,
        id: group.id,
        moveForward: true,
        stimuli: group.stimuli,
        levelUuid: this.protocols.levels[index].uuid,
        sessions: [],
        lastSessionIndex: null,
        lastSession: null
      });

      this.changedGroup.push({
        uuid: group.uuid,
        index: group.index,
        id: group.id,
        moveForward: true,
        stimuli: group.stimuli,
        levelUuid: this.protocols.levels[index].uuid,
        sessions: []
      });
      levels[index].groups.splice(groupIndex, 1);
      levels[index + 1].groups = nextLevelGroup;
      this.$set(this.protocols, 'levels', levels);
    },
    goToPrevLevel: function goToPrevLevel(index, groupIndex) {

      var levels = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels);
      var group = this.protocols.levels[index].groups[groupIndex];
      var prevLevelGroup = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels[index - 1].groups);
      prevLevelGroup.push({
        uuid: group.uuid,
        index: group.index,
        id: group.id,
        moveBack: true,
        lastSessionIndex: null,
        lastSession: null,
        stimuli: group.stimuli,
        levelUuid: this.protocols.levels[index].uuid,
        sessions: []
      });

      this.changedGroup.push({
        uuid: group.uuid,
        index: group.index,
        id: group.id,
        moveBack: true,
        stimuli: group.stimuli,
        levelUuid: this.protocols.levels[index].uuid,
        sessions: []
      });
      levels[index].groups.splice(groupIndex, 1);
      levels[index - 1].groups = prevLevelGroup;
      this.$set(this.protocols, 'levels', levels);
    },
    goToMaintain: function goToMaintain(index, groupIndex) {
      var levels = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels);
      var group = this.protocols.levels[index].groups[groupIndex];
      this.changedGroup.push({
        uuid: group.uuid,
        index: group.index,
        id: group.id,
        moveForward: true,
        stimuli: this.protocols.levels[index].groups[groupIndex].stimuli,
        levelUuid: this.protocols.levels[index].uuid,
        sessions: []
      });
      levels[index].groups.splice(groupIndex, 1);
      this.$set(this.protocols, 'levels', levels);
    },
    checkSessionVersion: function checkSessionVersion() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var version, sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                version = _this2.majorVersion ? _this2.majorVersion : _this2.protocols.majorVersion;
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this2.apiCheckedUrl + _this2.protocolData.id + '/is-version-equal/' + version);
                return _context3.abrupt('return', sessionVersion);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    saveStage: function saveStage() {
      var _this3 = this;

      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var nextSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var checkVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.isLoaded = false;

                _context4.next = 3;
                return _this3.checkSessionVersion();

              case 3:
                checkVersion = _context4.sent;


                if (checkVersion.data.data.result) {
                  _this3.saveSession(close, false, nextSession);
                } else {
                  _this3.isLoaded = true;
                  _this3.isConflictModalVisible = true;
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },


    saveSession: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(close) {
        var _this4 = this;

        var afterSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var nextSession = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isSaved, sessionDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, startedAt, finishedAt, session, answerList, answerLength;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_16_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_16_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);


                this.mastering = this.stageInfo ? __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(this.stageInfo.phases, function (item) {
                  return item.typeId == 5;
                })[0] : null;
                session = [];
                answerList = [];

                if (this.sessionView) {
                  __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.tempSessions.blocks, function (block, index) {
                    if (block.answer) {
                      var target = !block.errorAnsw ? __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(block.stimuli, 'correct') : __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(block.stimuli, ['correct', false]);
                      answerList.push({
                        "targetStimulusDescription": target[0].stimulus.description,
                        "targetStimulusUuid": target[0].stimulus.globalUuid,
                        "selectedStimulusUuid": block.answer != _this4.promptAnswer && !block.errorAnsw ? block.answerStimul.stimulus.globalUuid : target[0].stimulus.globalUuid,
                        "index": index,
                        "isPrompt": block.answer == _this4.promptAnswer,
                        "isHimself": block.answer == _this4.himselfAnswer,
                        "answerId": block.answer
                      });
                    }
                  });

                  answerLength = this.selectedGroup.lastSession ? answerList.length + this.selectedGroup.lastSession.blocks.length : answerList.length;


                  session = [{
                    "uuid": this.selectedGroup.uuid,
                    "moveForward": false,
                    "moveBack": false,
                    "levelUuid": this.selectedLevelUiid,
                    "sessions": [{
                      "uuid": this.selectedGroup.lastSession ? this.selectedGroup.lastSession.uuid : __WEBPACK_IMPORTED_MODULE_20__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      "startedAt": startedAt,
                      "finishedAt": answerLength === 9 ? finishedAt : null,
                      "index": this.currentSessionIndex,
                      "blocks": answerList
                    }]
                  }];
                }

                this.disabled = false;

                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {
                  'uuid': this.stageInfo.uuid,
                  'close': close,
                  'majorVersion': this.majorVersion ? this.majorVersion : this.protocolData.protocol.majorVersion,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'phaseId': this.mastering.id,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': [],
                    'type': this.protocols.taskType,
                    'groups': this.sessionView ? session : this.changedGroup
                  }]

                }).then(function (response) {

                  _this4.changedGroup = [];
                  _this4.majorVersion = response.data.data.majorVersion;
                  _this4.setProtocol(null);

                  if (close) {
                    var stageActiveList = __WEBPACK_IMPORTED_MODULE_22_lodash_filter___default()(_this4.protocolsData.protocol.stages, ['isClosed', false]);
                    _this4.setProtocol(null);
                    if (stageActiveList.length <= 1) {
                      _this4.$router.push({ name: 'results', params: { clientId: _this4.clientId || _this4.assignedProtocolId, protocolId: _this4.protocolId } });
                    } else {
                      _this4.$router.push({ name: 'stage-list', params: { clientId: _this4.clientId || _this4.assignedProtocolId, protocolId: _this4.protocolId } });
                    }
                  } else {
                    if (sessionDate) {
                      _this4.protocolData.endDate = {
                        date: new Date(_this4.previousDate.getFullYear(), _this4.previousDate.getMonth(), _this4.previousDate.getDate(), _this4.previousTime.HH, __WEBPACK_IMPORTED_MODULE_28_lodash_toInteger___default()(_this4.previousTime.mm) + __WEBPACK_IMPORTED_MODULE_28_lodash_toInteger___default()(_this4.previousDuration))
                      };
                    }

                    if (!nextSession) {
                      _this4.sessionView = false;
                    } else {
                      _this4.currentSessionIndex++;
                    }

                    if (afterSave) {
                      _this4.fetchProtocol(afterSave);
                    } else {
                      _this4.fetchProtocol(nextSession);
                    }
                  }

                  //this.$router.push({name: 'choose-usd', params: { client: this.client, protocolId: this.protocolId}});
                }).catch(function (error) {
                  if (error.response) {
                    _this4.disabled = false;
                    _this4.isLoaded = true;
                  }
                });

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveSession(_x4) {
        return _ref2.apply(this, arguments);
      }

      return saveSession;
    }(),

    goToGroup: function goToGroup(index, indexGroup) {
      this.selectedIndex = index;
      this.selectedIndexGroup = indexGroup;
      this.selectedGroup = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(this.protocols.levels[index].groups[indexGroup]);
      this.currentSessionIndex = __WEBPACK_IMPORTED_MODULE_28_lodash_toInteger___default()(this.selectedGroup.lastSessionIndex);
      this.selectedLevelUiid = this.protocols.levels[index].uuid;
      if (this.changedGroup.length) {
        this.saveChangesPopup = true;
      } else {
        if (this.selectedGroup.lastSession) {
          this.chooseNextSessionModal = true;
        } else {
          if (this.selectedGroup.lastSessionIndex !== null) {
            this.currentSessionIndex++;
          }
          this.showSession();
        }
      }
    },
    showSession: function showSession() {
      this.buildSet(this.selectedIndex, this.selectedIndexGroup);
      this.sessionView = true;
    },
    closePopup: function closePopup(next) {
      this.chooseNextSessionModal = false;
      if (next) {
        this.currentSessionIndex++;
      }
      this.buildSet(this.selectedIndex, this.selectedIndexGroup, next);
      this.sessionView = true;
    },
    closeChangesPopup: function closeChangesPopup(change) {
      if (change) {
        this.saveSession(false, true);
      }

      this.saveChangesPopup = false;
    },
    buildSet: function buildSet(index, indexGroup, next) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var group, stimulus, descriptionLenght, tempStimulus, tempAnotherStimulus, session, i, stimuli, uuid, block, j;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.setSessions = [];
                _this5.selectedGroup = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(_this5.protocols.levels[index].groups[indexGroup]);
                if (next) {
                  _this5.selectedGroup.lastSession = null;
                }
                group = _this5.selectedGroup;
                stimulus = group.stimuli;
                descriptionLenght = 0;


                __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(stimulus, function (item) {
                  descriptionLenght = item.description.length > descriptionLenght ? item.description.length : descriptionLenght;
                });

                //create temp stimulus block for creating another
                tempStimulus = [stimulus[0], stimulus[1], stimulus[2]];
                tempAnotherStimulus = ['A', 'B', 'C'];


                if (descriptionLenght > 8) {
                  _this5.shortDescripton = tempAnotherStimulus;
                }

                //temp blocks for session
                session = {
                  index: 1,
                  blocks: []
                };

                //for each blocks row

                for (i = 0; i < _this5.blocksLength; i++) {
                  //temp block for each blocks row
                  stimuli = [];
                  uuid = __WEBPACK_IMPORTED_MODULE_20__common_uuid_UuidGenerator__["a" /* default */].v4();
                  block = {
                    uuid: i + '' + uuid,
                    index: i + 1,
                    resultId: __WEBPACK_IMPORTED_MODULE_30__randomRotation_Constants_js__["a" /* default */].NO_ANSWER,
                    stimuli: []
                  };

                  //for each stimulus create object and add to blocks

                  for (j = 0; j < _this5.blocksStimulusLength; j++) {
                    stimuli[j] = {
                      name: descriptionLenght <= 8 ? tempStimulus[j].description : tempAnotherStimulus[j],
                      stimulus: tempStimulus[j],
                      position: j + 1,
                      correct: false
                    };
                  }

                  if (descriptionLenght > 8) {
                    tempAnotherStimulus.unshift(tempAnotherStimulus.pop());
                  }

                  tempStimulus.unshift(tempStimulus.pop());

                  block.stimuli = stimuli;
                  session.blocks[i] = block;
                }

                //add all blocks to each session
                _this5.tempSessions = session;

                _this5.setActiveStimulus(index, indexGroup);

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    setActiveStimulus: function setActiveStimulus(index, indexGroup) {
      //array with index of active items in row
      var firstStimulusByBlocks = [];
      var activeItems = [];
      var group = this.selectedGroup;

      //for each stimulus column
      for (var j = 0; j < this.blocksLength; j++) {
        var self = this;
        var itemIndex = void 0;

        if (j === 0) {
          //random number for checking active element in column
          var activeIndex = this.currentSessionIndex % 3;
          //set active
          self.tempSessions.blocks[j].stimuli[activeIndex].correct = true;

          //add to activeItems
          activeItems = activeItems.concat(activeIndex);
          itemIndex = activeIndex;
        } else if (j % 3 == 0) {
          var newIndex = firstStimulusByBlocks[firstStimulusByBlocks.length - 1];

          switch (newIndex) {
            case 0:
              this.tempSessions.blocks[j].stimuli[1].correct = true;
              activeItems = activeItems.concat(1);
              itemIndex = 1;
              break;
            case 1:
              this.tempSessions.blocks[j].stimuli[2].correct = true;
              activeItems = activeItems.concat(2);
              itemIndex = 2;
              break;
            case 2:
              this.tempSessions.blocks[j].stimuli[0].correct = true;
              activeItems = activeItems.concat(0);
              itemIndex = 0;
              break;
          }
        } else {
          switch (activeItems[j - 1]) {
            case 0:
              this.tempSessions.blocks[j].stimuli[2].correct = true;
              activeItems = activeItems.concat(2);
              itemIndex = 2;
              break;
            case 1:
              this.tempSessions.blocks[j].stimuli[0].correct = true;
              activeItems = activeItems.concat(0);
              itemIndex = 0;
              break;
            case 2:
              this.tempSessions.blocks[j].stimuli[1].correct = true;
              activeItems = activeItems.concat(1);
              itemIndex = 1;
              break;
          }
        }

        if (j % 3 == 0) {
          firstStimulusByBlocks = firstStimulusByBlocks.concat(itemIndex);
        }
      }
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isConflictModalVisible = false;
    },
    attemptChange: function attemptChange(stimul, index, answer) {
      var _this6 = this;

      var errorAnsw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      //this.selectedRow = index;
      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.tempSessions.blocks, function (block) {
        _this6.$set(block, 'isChanged', false);
      });
      this.$set(this.tempSessions.blocks[index], 'answerStimul', stimul);
      this.$set(this.tempSessions.blocks[index], 'answer', answer);
      this.$set(this.tempSessions.blocks[index], 'errorAnsw', errorAnsw);
      this.$set(this.tempSessions.blocks[index], 'isChanged', true);

      this.timerId = setTimeout(function () {
        _this6.$set(_this6.tempSessions.blocks[index], 'isChanged', false);
      }, 500);
    }
  }),
  watch: {
    previousDate: function previousDate(newValue) {
      this.fetchProtocol();
    },
    previousTime: function previousTime(newValue) {
      if (this.protocolData.endDate && __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.previousDate).format('YYYY-MM-DD') == __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.protocolData.endDate.date).format('YYYY-MM-DD')) {
        this.fetchProtocol();
      }
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        this.fetchProtocol();
      }
    }
  }

});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_maintainStage__ = __webpack_require__(517);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/vcd/'
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_maintainStage__["a" /* maintainStage */]]
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CurrentStageLayout',

  props: {
    'protocolData': {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/pecs-sentence-structure/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isConflictModalVisible: false,
      protocolsData: __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolData),
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      uuid: null,
      isOpenDisabled: false,
      currentStage: null,
      isModalVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    conditionTransfer: function conditionTransfer() {
      var condition = this.currentStage.masteringCondition;

      if (condition) {
        return condition.ratio + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_procent') + " " + condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_trial') + " " + condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_session');
      }
    }
  }),
  created: function created() {
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };


              _this.setEntity(entity);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['setPreviousDate']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {

    closeSession: function closeSession() {
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    saveCurrentStep: function saveCurrentStep() {
      var _this2 = this;

      var max = __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default()(this.tasks, 'attempt').attempt;

      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
        var lastDate = item.lastSessions.length ? item.lastSessions[item.lastSessions.length - 1].date : null;

        if (item.attempt < max) {

          item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, 44);
          item.attempt += 1;
          item.lastAnswersTotal++;
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.task_types.answers.titles.no_data'));
          item.lastAnswersId = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, 44);
          item.lastAnswersCount.push(1);
          item.disabled = true;

          if (lastDate === lastDay) {
            item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[item.lastSessions.length - 1].attempts, 44);
          } else {
            item.isMastered = false;
            item.lastSessions.push({
              date: lastDay,
              attempts: [44],
              isMastered: false
            });
          }

          _this2.$set(item, 'toNextLevel', _this2.nextLevel(item));
        }
        _this2.$set(item, 'disabledBack', true);

        item.disabled = false;
      });
    },
    toggleViewDisabled: function toggleViewDisabled(position) {

      var stage = this.protocol.stages[position];
      stage.isOpenDisabled = !stage.isOpenDisabled;
      this.$set(this.protocol.stages, position, stage);
    },
    goToPrevLevel: function goToPrevLevel(uuid, task) {

      var index = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.tasks, function (task) {

        return uuid.globalUuid == uuid;
      });

      this.$set(this.tasks[index], 'newStageUuid', this.protocol.stages[this.currentStage.position + -1].uuid);
    },
    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, newDate, newDateUnix, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};

                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/', { params: params });

              case 5:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.info(_context2.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),

    fetchProtocolData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchData();

              case 2:
                response = _context3.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.assignedProtocolId = this.protocolsData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchProtocolData() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this3 = this;

      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolsData.protocol);
      this.execution = this.protocol.execution;

      this.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.currentStage.tasks, function (task) {

        task.attempt = 0;
        task.attepmtsCount = '1';
        var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
        _this3.$set(task, 'lastAnswers', lastAnswers);
        _this3.$set(task, 'lastAnswersId', []);
        var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
        _this3.$set(task, 'lastAnswersCount', lastAnswersCount);
        _this3.$set(task, 'answers', []);
        _this3.$set(task, 'type', _this3.currentStage.type);
        _this3.$set(task, 'toNextLevel', _this3.nextLevel(task));
        _this3.$set(task, 'disabled', false);
        _this3.$set(task, 'disabledBack', true);
        _this3.$set(task, 'lastAnswersTotal', 0);

        return task;
      });

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.protocol.stages, function (item) {
        item.isOpenDisabled = false;
      });

      this.isLoaded = true;
    },

    nextLevel: function nextLevel(item) {
      var _this4 = this;

      var positive = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.currentStage.type.answers, function (item) {
        return item.himself;
      });
      var positiveAnswer = positive[0].id;
      var toNextLevel = false;
      var trialCount = this.currentStage.masteringCondition.trialCount;
      var sessionCount = this.currentStage.masteringCondition.sessionCount;

      if (item.lastSessions && item.lastSessions.length >= sessionCount || item.isMastered) {

        if (item.isMastered) {
          return true;
        }

        var sortedSession = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(item.lastSessions, function (date) {
          return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date.date, 'YYYY-MM-DD').unix();
        });

        var lastSessions = __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(sortedSession, item.lastSessions.length - sessionCount);
        var mastered = false;
        var countMastered = 0;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(lastSessions, function (answerList, index) {
          var trialLength = answerList.attempts && answerList.attempts.length > trialCount ? answerList.attempts.length - trialCount : 0;
          var lastSessionAtempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(answerList.attempts, trialLength);
          var lastSessionAtemptsCount = lastSessionAtempts.length;

          if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {

            if (answerList.isMastered) {

              countMastered++;
            } else {

              var positiveAnswerCount = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(lastSessionAtempts, function (item) {
                return item == positiveAnswer;
              }).length;
              var trial = positiveAnswerCount * 100 / lastSessionAtemptsCount >= _this4.currentStage.masteringCondition.ratio;

              if (trial) {
                countMastered++;
              } else {
                mastered = false;
              }
            }
          } else {
            return false;
          }
        });

        if (countMastered >= sessionCount) {
          mastered = true;
        }

        toNextLevel = mastered;
      } else {
        return false;
      }

      return toNextLevel;
    },

    getClient: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context4.sent;

                this.client = response.data.data;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 10:
                _context4.prev = 10;

                this.loaded = true;
                return _context4.finish(10);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref3.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },
    onModalClose: function onModalClose() {
      this.isConflictModalVisible = false;
    },


    attemptChange: function attemptChange(answer, task, title, answerCount) {
      var _this5 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), answer);
      var lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
          if (item.globalUuid == task.globalUuid) {

            item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, answerListId);
            item.attempt = item.attempt + answerListCount;
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, answerList);
            item.lastAnswersId = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswersId, answerListId);
            item.lastAnswersCount.push(answerCount);

            if (lastDate === lastDay) {
              item.lastSessions[task.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
            } else {
              item.isMastered = false;
              item.lastSessions.push({
                date: lastDay,
                attempts: answerListId,
                mastered: false
              });
            }

            item.lastAnswersTotal += +answerListCount;

            item.toNextLevel = _this5.nextLevel(item);
            item.disabled = true;
            _this5.$set(item, 'disabledBack', false);
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this5.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        task.answer = null;
        task.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, key) {
        if (item.globalUuid == id) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.answers, lastAnswersCount);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.lastAnswersId = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswersId, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this6.totalAtemptsCount = _this6.totalAtemptsCount - lastAnswersCount;

          item.lastAnswersCount.pop();
          item.disabled = false;
          _this6.$set(item, 'disabledBack', true);

          item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

          if (!item.lastSessions[item.lastSessions.length - 1].attempts.length && !item.lastSessions[item.lastSessions.length - 1].isMastered) {
            item.lastSessions.pop();
          }

          item.lastAnswersTotal -= lastAnswersCount;

          _this6.$set(_this6.tasks[key], 'toNextLevel', _this6.nextLevel(item));

          if (!_this6.totalAtemptsCount) {
            _this6.disabledSave = true;
          }
        }
      });
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this7.apiCheckedUrl + _this7.protocolsData.id + '/is-version-equal/' + _this7.protocolsData.protocol.majorVersion);
                return _context5.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    saveStage: function saveStage(close, stageId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.isLoaded = false;

                _context6.next = 3;
                return _this8.checkSessionVersion();

              case 3:
                checkVersion = _context6.sent;

                if (!_this8.showChangeDateSession) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 7;
                return _this8.$validator.validate('duration');

              case 7:
                _context6.t0 = _context6.sent;
                _context6.next = 11;
                break;

              case 10:
                _context6.t0 = true;

              case 11:
                result = _context6.t0;


                if (result && checkVersion.data.data.result) {
                  _this8.saveSession(close, stageId);
                } else {
                  _this8.isLoaded = true;
                  _this8.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },


    saveSession: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(close, stageId) {
        var _this9 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                this.saveCurrentStep();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.tasks);


                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersId'];
                  delete task['lastAnswersCount'];
                  delete task['type'];
                  delete task['attepmtsCount'];
                  delete task['lastAnswersTotal'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.protocol.majorVersion,
                  'newStageUuid': stageId,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': that.currentStage.type
                  }]

                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                    var entity;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (_this9.isClient) {
                              _this9.$router.push({ name: 'available-protocols' });
                            }
                            _this9.setProtocol(null);

                            if (!close) {
                              _context7.next = 6;
                              break;
                            }

                            _this9.$router.push({ name: 'results', params: { clientId: _this9.clientId || _this9.assignedProtocolId, protocolId: _this9.protocolId } });
                            _context7.next = 16;
                            break;

                          case 6:
                            if (stageId) {
                              _context7.next = 10;
                              break;
                            }

                            _this9.$router.push({ name: 'client-edit', params: { clientId: _this9.clientId || _this9.assignedProtocolId } });
                            _context7.next = 16;
                            break;

                          case 10:
                            _this9.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
                            entity = {
                              id: _this9.uuid,
                              type: 'assigned-session'
                            };


                            if (_this9.isPreviousDateSession && _this9.previousTime.HH) {
                              _this9.protocolsData.endDate = {
                                date: new Date(_this9.previousDate.getFullYear(), _this9.previousDate.getMonth(), _this9.previousDate.getDate(), _this9.previousTime.HH, __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(_this9.previousTime.mm) + __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(_this9.previousDuration))
                              };

                              __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this9.tasks, function (item, index) {

                                _this9.$set(_this9.tasks[index], 'attempt', 0);
                                _this9.$set(_this9.tasks[index], 'lastAnswersTotal', 0);
                                _this9.$set(_this9.tasks[index], 'answers', []);
                              });
                            }
                            _this9.setEntity(entity);
                            _context7.next = 16;
                            return _this9.fetchProtocolData();

                          case 16:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this9);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()

                //this.setAlertVisible();
                ).catch(function (error) {
                  console.info(error);
                  if (error.response) {
                    _this9.disabled = false;
                    _this9.isLoaded = true;
                  }
                });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function saveSession(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                _this10.saveSession(true);

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }),
  watch: {
    previousDate: function previousDate(newValue, oldValue) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var oldDay, newDay, endDate, taskForDate, taskForDateTasks;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                oldDay = oldValue ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(oldValue).format('YYYY-MM-DD') : _this11.today();
                newDay = __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD');
                endDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this11.protocolsData.endDate.date).format('YYYY-MM-DD');
                taskForDate = null;
                taskForDateTasks = null;

                if (!(newDay == endDate)) {
                  _context10.next = 12;
                  break;
                }

                _this11.loaded = false;
                _context10.next = 9;
                return _this11.fetchData();

              case 9:
                taskForDate = _context10.sent;

                taskForDateTasks = taskForDate.data.data.tasks;
                _this11.loaded = true;

              case 12:

                __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this11.tasks, function (item, index) {

                  var answCount = item.lastAnswersTotal;

                  var fieldAnswIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(item.lastSessions, function (field) {
                    return field.date === oldDay;
                  });
                  var fieldAnswNewIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(item.lastSessions, function (field) {
                    return field.date === newDay;
                  });
                  item.lastAnswers = answCount && item.lastAnswers.length ? __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(item.lastAnswers, item.lastAnswers.length - answCount) : [];
                  var currentItem = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(taskForDateTasks, function (task) {
                    return task.globalUuid === item.globalUuid;
                  });

                  var currentItemAtepmts = currentItem && currentItem.length ? currentItem[0].lastSessions[currentItem[0].lastSessions.length - 1].attempts : [];

                  if (fieldAnswIndex >= 0) {

                    item.lastSessions[fieldAnswIndex].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastSessions[fieldAnswIndex].attempts, answCount);

                    if (!item.lastSessions[fieldAnswIndex].attempts.length && !item.lastSessions[fieldAnswIndex].isMastered) {
                      item.lastSessions.pop();
                    }

                    if (fieldAnswNewIndex < 0 && answCount) {
                      item.lastSessions.push({
                        date: __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD'),
                        attempts: item.lastAnswersId,
                        isMastered: false
                      });
                    }
                  }

                  if (fieldAnswNewIndex >= 0) {
                    item.lastSessions[fieldAnswNewIndex].attempts = taskForDateTasks ? __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(currentItemAtepmts, item.lastAnswersId) : __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[fieldAnswNewIndex].attempts, item.lastAnswersId);
                  }

                  item.isMastered = false;
                  item.toNextLevel = _this11.nextLevel(item);
                });

              case 13:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      var _this12 = this;

      if (!newValue) {

        this.currentDate = this.previousDate;

        this.setPreviousDate(null);

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {

          item.isMastered = false;
          item.toNextLevel = _this12.nextLevel(item);
        });
      } else {
        this.setPreviousDate(this.currentDate);
      }
    }
  }

});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/pecs-without-discrimination/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isConflictModalVisible: false,
      protocolsData: __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolData),
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      uuid: null,
      isOpenDisabled: false,
      currentStage: null,
      isModalVisible: false,
      currentDate: new Date()
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    conditionTransfer: function conditionTransfer() {
      var condition = this.currentStage.masteringCondition;

      if (condition) {
        return condition.ratio + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_procent') + " " + condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_trial') + " " + condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_session');
      }
    }
  }),
  created: function created() {
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };


              _this.currentDate = _this.previousDate ? _this.previousDate : new Date();

              _this.setEntity(entity);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['setPreviousDate']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {

    closeSession: function closeSession() {
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    saveCurrentStep: function saveCurrentStep() {
      var _this2 = this;

      var max = __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default()(this.tasks, 'attempt').attempt;

      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
        var lastDate = item.lastSessions.length ? item.lastSessions[item.lastSessions.length - 1].date : null;

        if (item.attempt < max) {

          item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, 44);
          item.lastAnswersTotal++;
          item.attempt += 1;
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.task_types.answers.titles.no_data'));
          item.lastAnswersCount.push(1);
          item.disabled = true;

          if (lastDate === lastDay) {
            item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[item.lastSessions.length - 1].attempts, 44);
          } else {
            item.isMastered = false;
            item.lastSessions.push({
              date: lastDay,
              attempts: [44],
              mastered: false
            });
          }

          _this2.$set(item, 'toNextLevel', _this2.nextLevel(item));
        }
        _this2.$set(item, 'disabledBack', true);

        item.disabled = false;
      });
    },
    toggleViewDisabled: function toggleViewDisabled(position) {

      var stage = this.protocol.stages[position];
      stage.isOpenDisabled = !stage.isOpenDisabled;
      this.$set(this.protocol.stages, position, stage);
    },
    goToPrevLevel: function goToPrevLevel(uuid, task) {

      var index = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.tasks, function (task) {

        return uuid.globalUuid == uuid;
      });

      this.$set(this.tasks[index], 'newStageUuid', this.protocol.stages[this.currentStage.position + -1].uuid);
    },
    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, newDate, newDateUnix, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};

                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/', { params: params });

              case 5:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.info(_context2.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),

    fetchProtocolData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchData();

              case 2:
                response = _context3.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.assignedProtocolId = this.protocolsData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchProtocolData() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this3 = this;

      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolsData.protocol);
      this.execution = this.protocol.execution;

      this.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.currentStage.tasks, function (task) {

        task.attempt = 0;
        task.attepmtsCount = '1';
        var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
        _this3.$set(task, 'lastAnswers', lastAnswers);
        var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
        _this3.$set(task, 'lastAnswersCount', lastAnswersCount);
        _this3.$set(task, 'lastAnswersTotal', 0);
        _this3.$set(task, 'answers', []);
        _this3.$set(task, 'type', _this3.currentStage.type);
        _this3.$set(task, 'toNextLevel', _this3.nextLevel(task));
        _this3.$set(task, 'disabled', false);
        _this3.$set(task, 'disabledBack', true);

        return task;
      });

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.protocol.stages, function (item) {
        item.isOpenDisabled = false;
      });

      this.isLoaded = true;
    },

    nextLevel: function nextLevel(item) {
      var _this4 = this;

      var positive = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.currentStage.type.answers, function (item) {
        return item.himself;
      });
      var positiveAnswer = positive[0].id;
      var toNextLevel = false;
      var trialCount = this.currentStage.masteringCondition.trialCount;
      var sessionCount = this.currentStage.masteringCondition.sessionCount;

      if (item.lastSessions && item.lastSessions.length >= sessionCount || item.isMastered) {

        if (item.isMastered) {
          return true;
        }

        var sortedSession = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(item.lastSessions, function (date) {
          return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date.date, 'YYYY-MM-DD').unix();
        });

        var lastSessions = __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(sortedSession, item.lastSessions.length - sessionCount);
        var mastered = false;
        var countMastered = 0;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(lastSessions, function (answerList, index) {
          var trialLength = answerList.attempts && answerList.attempts.length > trialCount ? answerList.attempts.length - trialCount : 0;
          var lastSessionAtempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(answerList.attempts, trialLength);
          var lastSessionAtemptsCount = lastSessionAtempts.length;

          if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {

            if (answerList.isMastered) {

              countMastered++;
            } else {

              var positiveAnswerCount = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(lastSessionAtempts, function (item) {
                return item == positiveAnswer;
              }).length;
              var trial = positiveAnswerCount * 100 / lastSessionAtemptsCount >= _this4.currentStage.masteringCondition.ratio;

              if (trial) {
                countMastered++;
              } else {
                mastered = false;
              }
            }
          } else {
            return false;
          }
        });

        if (countMastered >= sessionCount) {
          mastered = true;
        }

        toNextLevel = mastered;
      } else {
        return false;
      }

      return toNextLevel;
    },

    getClient: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context4.sent;

                this.client = response.data.data;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 10:
                _context4.prev = 10;

                this.loaded = true;
                return _context4.finish(10);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref3.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },
    onModalClose: function onModalClose() {
      this.isConflictModalVisible = false;
    },


    attemptChange: function attemptChange(answer, task, title, answerCount) {
      var _this5 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), answer);
      var lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
          if (item.globalUuid == task.globalUuid) {

            item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, answerListId);
            item.attempt = item.attempt + answerListCount;
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, answerList);
            item.lastAnswersCount.push(answerCount);

            if (lastDate === lastDay) {
              item.lastSessions[task.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
            } else {
              item.isMastered = false;
              item.lastSessions.push({
                date: lastDay,
                attempts: answerListId,
                mastered: false
              });
            }

            item.lastAnswersTotal += answerListCount;

            item.toNextLevel = _this5.nextLevel(item);
            item.disabled = true;
            _this5.$set(item, 'disabledBack', false);
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this5.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        task.answer = null;
        task.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, key) {
        if (item.globalUuid == id) {
          var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

          item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.answers, lastAnswersCount);
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
          item.attempt = item.attempt - lastAnswersCount;
          _this6.totalAtemptsCount = _this6.totalAtemptsCount - lastAnswersCount;

          item.lastAnswersCount.pop();
          item.disabled = false;
          _this6.$set(item, 'disabledBack', true);

          item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

          if (!item.lastSessions[item.lastSessions.length - 1].attempts.length && !item.lastSessions[item.lastSessions.length - 1].isMastered) {
            item.lastSessions.pop();
          }

          item.lastAnswersTotal -= lastAnswersCount;

          _this6.$set(_this6.tasks[key], 'toNextLevel', _this6.nextLevel(item));

          if (!_this6.totalAtemptsCount) {
            _this6.disabledSave = true;
          }
        }
      });
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this7.apiCheckedUrl + _this7.protocolsData.id + '/is-version-equal/' + _this7.protocolsData.protocol.majorVersion);
                return _context5.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    saveStage: function saveStage(close, stageId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.isLoaded = false;

                _context6.next = 3;
                return _this8.checkSessionVersion();

              case 3:
                checkVersion = _context6.sent;

                if (!_this8.showChangeDateSession) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 7;
                return _this8.$validator.validate('duration');

              case 7:
                _context6.t0 = _context6.sent;
                _context6.next = 11;
                break;

              case 10:
                _context6.t0 = true;

              case 11:
                result = _context6.t0;


                if (result && checkVersion.data.data.result) {
                  _this8.saveSession(close, stageId);
                } else {
                  _this8.isLoaded = true;
                  _this8.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },


    saveSession: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(close, stageId) {
        var _this9 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                this.saveCurrentStep();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.tasks);


                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersCount'];
                  delete task['type'];
                  delete task['attepmtsCount'];
                  delete task['lastAnswersTotal'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.protocol.majorVersion,
                  'newStageUuid': stageId,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': that.currentStage.type
                  }]

                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                    var entity;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (_this9.isClient) {
                              _this9.$router.push({ name: 'available-protocols' });
                            }
                            _this9.setProtocol(null);

                            if (!close) {
                              _context7.next = 6;
                              break;
                            }

                            _this9.$router.push({ name: 'results', params: { clientId: _this9.clientId || _this9.assignedProtocolId, protocolId: _this9.protocolId } });
                            _context7.next = 16;
                            break;

                          case 6:
                            if (stageId) {
                              _context7.next = 10;
                              break;
                            }

                            _this9.$router.push({ name: 'client-edit', params: { clientId: _this9.clientId || _this9.assignedProtocolId } });
                            _context7.next = 16;
                            break;

                          case 10:
                            _this9.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
                            entity = {
                              id: _this9.uuid,
                              type: 'assigned-session'
                            };


                            if (_this9.isPreviousDateSession && _this9.previousTime.HH) {
                              _this9.protocolsData.endDate = {
                                date: new Date(_this9.previousDate.getFullYear(), _this9.previousDate.getMonth(), _this9.previousDate.getDate(), _this9.previousTime.HH, __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(_this9.previousTime.mm) + __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default()(_this9.previousDuration))
                              };

                              __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this9.tasks, function (item, index) {

                                _this9.$set(_this9.tasks[index], 'attempt', 0);
                                _this9.$set(_this9.tasks[index], 'lastAnswersTotal', 0);
                                _this9.$set(_this9.tasks[index], 'answers', []);
                              });
                            }
                            _this9.setEntity(entity);
                            _context7.next = 16;
                            return _this9.fetchProtocolData();

                          case 16:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this9);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.info(error);
                  if (error.response) {
                    _this9.disabled = false;
                    _this9.isLoaded = true;
                  }
                });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function saveSession(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                _this10.saveSession(true);

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }),
  watch: {
    previousDate: function previousDate(newValue, oldValue) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var oldDay, newDay, endDate, taskForDate, taskForDateTasks;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                oldDay = oldValue ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(oldValue).format('YYYY-MM-DD') : _this11.today();
                newDay = __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD');
                endDate = _this11.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this11.protocolsData.endDate.date).format('YYYY-MM-DD') : null;
                taskForDate = null;
                taskForDateTasks = null;

                if (!(newDay == endDate && endDate)) {
                  _context10.next = 12;
                  break;
                }

                _this11.loaded = false;
                _context10.next = 9;
                return _this11.fetchData();

              case 9:
                taskForDate = _context10.sent;

                taskForDateTasks = taskForDate.data.data.tasks;
                _this11.loaded = true;

              case 12:

                __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this11.tasks, function (item, index) {

                  var answCount = item.lastAnswersTotal;

                  var fieldAnswIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(item.lastSessions, function (field) {
                    return field.date === oldDay;
                  });
                  var fieldAnswNewIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(item.lastSessions, function (field) {
                    return field.date === newDay;
                  });
                  item.lastAnswers = answCount && item.lastAnswers.length ? __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(item.lastAnswers, item.lastAnswers.length - answCount) : [];
                  var currentItem = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(taskForDateTasks, function (task) {
                    return task.globalUuid === item.globalUuid;
                  });

                  var currentItemAtepmts = currentItem && currentItem.length ? currentItem[0].lastSessions[currentItem[0].lastSessions.length - 1].attempts : [];

                  if (fieldAnswIndex >= 0) {

                    item.lastSessions[fieldAnswIndex].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastSessions[fieldAnswIndex].attempts, answCount);

                    if (!item.lastSessions[fieldAnswIndex].attempts.length && !item.lastSessions[fieldAnswIndex].isMastered) {
                      item.lastSessions.pop();
                    }

                    if (fieldAnswNewIndex < 0 && answCount) {
                      item.lastSessions.push({
                        date: __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD'),
                        attempts: item.lastAnswersId,
                        isMastered: false
                      });
                    }
                  }

                  if (fieldAnswNewIndex >= 0) {
                    item.lastSessions[fieldAnswNewIndex].attempts = taskForDateTasks ? __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(currentItemAtepmts, item.lastAnswersId) : __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[fieldAnswNewIndex].attempts, item.lastAnswersId);
                  }

                  item.isMastered = false;
                  item.toNextLevel = _this11.nextLevel(item);
                });

              case 13:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    previousTime: function previousTime(newValue) {},
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      var _this12 = this;

      if (!newValue) {
        this.currentDate = this.previousDate;
        this.setPreviousDate(null);

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {

          item.isMastered = false;
          item.toNextLevel = _this12.nextLevel(item);
        });
      } else {
        this.setPreviousDate(this.currentDate);
      }
    }
  }

});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_toggleViewList_components_ToggleView__ = __webpack_require__(239);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_19__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a, ToogleView: __WEBPACK_IMPORTED_MODULE_25__common_toggleViewList_components_ToggleView__["a" /* default */] },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/pecs-with-discrimination/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isConflictModalVisible: false,
      protocolsData: __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolData),
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      uuid: null,
      isOpenDisabled: false,
      currentStage: null,
      isModalVisible: false,
      currentDate: new Date(),
      isOpen: false,
      currentCategoryUuid: null,
      categories: null,
      nameTitle: __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.categoryTitle') + ': '
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    conditionTransfer: function conditionTransfer() {
      var condition = this.currentStage.masteringCondition;

      if (condition) {
        return condition.ratio + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_procent') + " " + condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_trial') + " " + condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.condition_session');
      }
    },
    disabledSelected: function disabledSelected() {
      var _this = this;

      var count = 0;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories, function (category) {

        count += _this.activeTaskLength(category.tasks).length;
      });

      return count == 0;
    }
  }),
  created: function created() {
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this2.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this2.uuid,
                type: 'assigned-session'
              };


              _this2.currentDate = _this2.previousDate ? _this2.previousDate : new Date();

              _this2.setEntity(entity);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['setPreviousDate']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {
    activeTaskLength: function activeTaskLength(taskList) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(taskList, function (task) {
        return task.active;
      });
    },
    selectTaskList: function selectTaskList() {
      this.$set(this.currentStage, 'selectedTasks', true);
    },
    toggleView: function toggleView(uuid) {
      this.currentCategoryUuid = uuid;
    },


    closeSession: function closeSession() {
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    saveCurrentStep: function saveCurrentStep() {
      var _this3 = this;

      var max = __WEBPACK_IMPORTED_MODULE_24_lodash_maxBy___default()(this.tasks, 'attempt').attempt;

      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item) {
        var lastDate = item.lastSessions.length ? item.lastSessions[item.lastSessions.length - 1].date : null;

        if (item.attempt < max) {

          item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, 44);
          item.lastAnswersTotal++;
          item.attempt += 1;
          item.lastAnswers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, __WEBPACK_IMPORTED_MODULE_21__lang_translator__["a" /* default */].get('protocol.task_types.answers.titles.no_data'));
          item.lastAnswersCount.push(1);
          item.disabled = true;

          if (lastDate === lastDay) {
            item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[item.lastSessions.length - 1].attempts, 44);
          } else {
            item.isMastered = false;
            item.lastSessions.push({
              date: lastDay,
              attempts: [44],
              mastered: false
            });
          }

          _this3.$set(item, 'toNextLevel', _this3.nextLevel(item));
        }

        item.disabled = false;
      });
    },
    toggleViewDisabled: function toggleViewDisabled(position) {

      var stage = this.protocol.stages[position];
      stage.isOpenDisabled = !stage.isOpenDisabled;
      this.$set(this.protocol.stages, position, stage);
    },
    goToPrevLevel: function goToPrevLevel(uuid, task) {

      var index = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.tasks, function (task) {

        return uuid.globalUuid == uuid;
      });

      this.$set(this.tasks[index], 'newStageUuid', this.protocol.stages[this.currentStage.position + -1].uuid);
    },
    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, newDate, newDateUnix, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};

                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId, { params: params });

              case 5:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.info(_context2.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),

    fetchProtocolData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchData();

              case 2:
                response = _context3.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.$set(this.currentStage, 'selectedTasks', false);
                  this.assignedProtocolId = this.protocolsData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchProtocolData() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this4 = this;

      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolsData.protocol);
      this.execution = this.protocol.execution;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.currentStage.categories, function (category) {

        category.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(category.tasks, function (task, index) {

          var lastSessions = task.lastSessions ? task.lastSessions : [];
          _this4.$set(task, 'lastSessions', lastSessions);
          task.attempt = 0;
          task.attepmtsCount = '1';
          var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
          _this4.$set(task, 'lastAnswers', lastAnswers);
          var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
          _this4.$set(task, 'lastAnswersCount', lastAnswersCount);
          _this4.$set(task, 'answers', []);
          _this4.$set(task, 'type', _this4.currentStage.type);
          _this4.$set(task, 'toNextLevel', _this4.nextLevel(task));

          return task;
        });
      });

      this.categories = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.currentStage.categories);

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.protocol.stages, function (item) {
        item.isOpenDisabled = false;
      });

      this.isLoaded = true;
    },

    getClient: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context4.sent;

                this.client = response.data.data;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 10:
                _context4.prev = 10;

                this.loaded = true;
                return _context4.finish(10);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref3.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },
    onModalClose: function onModalClose() {
      this.isConflictModalVisible = false;
    },
    changeActiveCategory: function changeActiveCategory(category) {
      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(category.tasks, function (item, index) {

        item.active = category.active;
      });
    },


    attemptChange: function attemptChange(categoryUuid, answer, task, title, answerCount) {
      var _this5 = this;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var answerListCount = 1;
      var answerList = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), title);
      var answerListId = __WEBPACK_IMPORTED_MODULE_15_lodash_fill___default()(new Array(answerListCount), answer);
      var lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.categories, function (category) {
          return category.uuid === categoryUuid;
        });
        var currentTaskIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.categories[currentCategoryIndex].tasks, function (taskCurrent) {
          return taskCurrent.globalUuid == task.globalUuid;
        });

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories[currentCategoryIndex].tasks, function (item, index) {
          if (item.globalUuid == task.globalUuid) {

            item.answers = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.answers, answerListId);
            item.attempt = item.attempt + answerListCount;
            _this5.$set(_this5.categories[currentCategoryIndex].tasks[index], 'lastAnswers', __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastAnswers, answerList));
            item.lastAnswersCount.push(answerCount);

            if (lastDate === lastDay) {
              item.lastSessions[task.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_17_lodash_concat___default()(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
            } else {
              item.isMastered = false;
              item.lastSessions.push({
                date: lastDay,
                attempts: answerListId,
                mastered: false
              });
            }

            item.lastAnswersTotal += answerListCount;

            item.toNextLevel = _this5.nextLevel(item);
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
        setTimeout(function () {
          _this5.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      this.disabledSave = false;

      this.timerId = setTimeout(function () {
        task.answer = null;
        //task.attepmtsCount = '1';
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(id, categoryUuid) {
      var _this6 = this;

      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(this.categories, function (category) {
        return category.uuid === categoryUuid;
      });

      if (currentCategoryIndex >= 0) {
        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories[currentCategoryIndex].tasks, function (item, key) {

          if (item.globalUuid == id) {
            var lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

            item.answers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.answers, lastAnswersCount);
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
            item.attempt = item.attempt - lastAnswersCount;
            _this6.totalAtemptsCount = _this6.totalAtemptsCount - lastAnswersCount;

            item.lastAnswersCount.pop();
            item.disabled = false;
            _this6.$set(item, 'disabledBack', true);

            item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

            if (!item.lastSessions[item.lastSessions.length - 1].attempts.length && !item.lastSessions[item.lastSessions.length - 1].isMastered) {
              item.lastSessions.pop();
            }

            item.lastAnswersTotal -= lastAnswersCount;

            _this6.$set(_this6.categories[currentCategoryIndex].tasks[key], 'toNextLevel', _this6.nextLevel(item));

            if (!_this6.totalAtemptsCount) {
              _this6.disabledSave = true;
            }
          }
        });
      }
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this7.apiCheckedUrl + _this7.protocolsData.id + '/is-version-equal/' + _this7.protocolsData.protocol.majorVersion);
                return _context5.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    saveStage: function saveStage(close, stageId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.isLoaded = false;

                _context6.next = 3;
                return _this8.checkSessionVersion();

              case 3:
                checkVersion = _context6.sent;

                if (!_this8.showChangeDateSession) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 7;
                return _this8.$validator.validate('duration');

              case 7:
                _context6.t0 = _context6.sent;
                _context6.next = 11;
                break;

              case 10:
                _context6.t0 = true;

              case 11:
                result = _context6.t0;


                if (result && checkVersion.data.data.result) {
                  _this8.saveSession(close, stageId);
                } else {
                  _this8.isLoaded = true;
                  _this8.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },


    saveSession: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(close, stageId) {
        var _this9 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = [];


                __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories, function (category) {
                  __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(category.tasks, function (task) {
                    taskReactions.push(task);
                  });
                });

                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersCount'];
                  delete task['type'];
                  delete task['attepmtsCount'];
                  delete task['lastAnswersTotal'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.protocol.majorVersion,
                  'newStageUuid': stageId,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': that.currentStage.type
                  }]

                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (_this9.isClient) {
                              _this9.$router.push({ name: 'available-protocols' });
                            }
                            _this9.setProtocol(null);
                            if (close) {
                              _this9.$router.push({ name: 'results', params: { clientId: _this9.clientId || _this9.assignedProtocolId, protocolId: _this9.protocolId } });
                            } else {

                              if (stageActiveList.length == 1) {
                                _this9.$router.push({ name: 'client-edit', params: { clientId: _this9.clientId || _this9.assignedProtocolId } });
                              } else {
                                _this9.$router.push({ name: 'stage-list', params: { clientId: _this9.clientId, protocolData: null } });
                              }
                            }

                          case 3:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this9);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.info(error);
                  _this9.$router.push({ name: 'client-edit', params: { clientId: _this9.clientId || _this9.assignedProtocolId } });
                });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function saveSession(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                _this10.saveSession(true);

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },


    nextLevel: function nextLevel(item) {
      var _this11 = this;

      var positive = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.currentStage.type.answers, function (item) {
        return item.himself;
      });
      var positiveAnswer = positive[0].id;
      var toNextLevel = false;

      var trialCount = this.currentStage.masteringCondition.trialCount;
      var sessionCount = this.currentStage.masteringCondition.sessionCount;

      if (item.isMastered) {
        return true;
      }

      if (item.lastSessions.length >= sessionCount) {

        var sortedSession = __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default()(item.lastSessions, function (date) {
          return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date.date, 'YYYY-MM-DD').unix();
        });

        var lastSessions = __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(sortedSession, item.lastSessions.length - sessionCount);
        var mastered = false;
        var countMastered = 0;

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(lastSessions, function (answerList, index) {

          var lastSessionAtempts = __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(answerList.attempts, answerList.attempts.length - trialCount);
          var lastSessionAtemptsCount = lastSessionAtempts.length;

          if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {

            if (answerList.isMastered) {

              countMastered++;
            } else {

              var positiveAnswerCount = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(lastSessionAtempts, function (item) {
                return item == positiveAnswer;
              }).length;
              var trial = positiveAnswerCount * 100 / lastSessionAtemptsCount >= _this11.currentStage.masteringCondition.ratio;
              if (trial) {
                countMastered++;
              } else {
                mastered = false;
              }
            }
          } else {
            return false;
          }
        });

        if (countMastered >= sessionCount) {
          mastered = true;
        }

        toNextLevel = mastered;
      } else {
        return false;
      }

      return toNextLevel;
    }

  }),
  watch: {
    previousDate: function previousDate(newValue, oldValue) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var oldDay, newDay, endDate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:

                if (oldValue) {
                  oldDay = oldValue ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(oldValue).format('YYYY-MM-DD') : _this12.today();
                  newDay = __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD');
                  endDate = _this12.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this12.protocolsData.endDate.date).format('YYYY-MM-DD') : null;


                  if (oldDay !== _this12.today()) {

                    __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this12.categories, function (category, categoryIndex) {

                      category.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(category.tasks, function (task, index) {

                        if (oldDay == endDate) {

                          var lastSessionAnswersCount = task.lastAnswers.length > task.answers.length ? task.lastAnswers.length - task.answers.length : 0;
                          var lastAnswers = lastSessionAnswersCount > 0 ? __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(task.lastAnswers, lastSessionAnswersCount) : task.lastAnswers;

                          _this12.$set(task, 'lastAnswers', lastAnswers);

                          var oldLastSessionIndex = __WEBPACK_IMPORTED_MODULE_22_lodash_findIndex___default()(task.lastSessions, function (lastSession) {
                            return lastSession.date === oldDay;
                          });

                          if (oldLastSessionIndex >= 0) {

                            var attemptsCount = task.lastSessions[oldLastSessionIndex].attempts ? task.lastSessions[oldLastSessionIndex].attempts.length - lastSessionAnswersCount : 0;
                            var attempts = attemptsCount > 0 ? __WEBPACK_IMPORTED_MODULE_23_lodash_drop___default()(task.lastSessions[oldLastSessionIndex].attempts, attemptsCount) : [];
                            var newAttempts = attemptsCount > 0 ? __WEBPACK_IMPORTED_MODULE_18_lodash_dropRight___default()(task.lastSessions[oldLastSessionIndex].attempts, lastSessionAnswersCount) : [];

                            task.lastSessions[oldLastSessionIndex].attempts = attempts;
                            task.lastSessions.push({
                              date: newDay,
                              attempts: newAttempts,
                              mastered: false
                            });
                            task.isMastered = false;
                          }
                        } else {

                          task.lastSessions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(task.lastSessions, function (lastSession) {

                            if (lastSession.date === oldDay) {
                              lastSession.date = newDay;
                            }

                            return lastSession;
                          });
                        }

                        //task.isMastered = false;
                        task.toNextLevel = _this12.nextLevel(task);

                        return task;
                      });
                    });
                  }
                }

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {
        this.currentDate = this.previousDate;
        this.setPreviousDate(null);
      } else {

        this.setPreviousDate(this.currentDate);
      }
    }
  }

});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fill__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_concat__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_drop__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__common_toggleViewList_components_ToggleView__ = __webpack_require__(239);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Instruction: __WEBPACK_IMPORTED_MODULE_20__common_instruction_components_InstructionView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_7__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_timepicker___default.a, ToogleView: __WEBPACK_IMPORTED_MODULE_26__common_toggleViewList_components_ToggleView__["a" /* default */] },
  name: 'ChainReactionStage',
  props: {
    'name': null,
    'protocolData': null,
    'clientData': null,
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'stageId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/protocols/assigned/pecs-features-with-items/',
      apiClientUrl: '/users/clients/',
      apiCheckedUrl: '/protocols/assigned/',
      protocol: null,
      client: {},
      assignedProtocolId: null,
      loaded: false,
      isConflictModalVisible: false,
      protocolsData: __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolData),
      isLoaded: false,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showChangeDateSession: false,
      maxTotalAtemptsCountError: false,
      maxTotalAtemptsCount: 3000,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      tasks: [],
      timerId: null,
      totalAtemptsCount: 0,
      execution: '',
      disabledSave: true,
      currentSesssionDate: null,
      title: __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.confirm_close'),
      uuid: null,
      isOpenDisabled: false,
      currentStage: null,
      isModalVisible: false,
      currentDate: new Date(),
      isOpen: false,
      currentCategoryUuid: null,
      categories: null,
      iterationIndex: 0,
      selectItem: false,
      selectProperty: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isClient', 'isBCBA', 'isCurator', 'isPreviousDateSession', 'previousDate', 'previousTime', 'previousDuration']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('protocol', ['protocolVuexData']), {
    minDate: function minDate() {
      return this.protocolsData && this.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },
    showDatePrevious: function showDatePrevious() {
      if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm) {

        var protocolDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.minDate).unix();

        var sessionDate = new Date(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm);
        var previous = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix();

        return previous <= protocolDate;
      }

      return false;
    },
    conditionTransfer: function conditionTransfer() {
      var condition = this.currentStage.masteringCondition;

      if (condition) {
        return condition.ratio + " " + __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.condition_procent') + " " + condition.sessionCount + " " + __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.condition_trial') + " " + condition.trialCount + " " + __WEBPACK_IMPORTED_MODULE_22__lang_translator__["a" /* default */].get('protocol.condition_session');
      }
    },
    selectTaskAndItem: function selectTaskAndItem() {
      var itemsCount = 0;
      var propCount = 0;

      __WEBPACK_IMPORTED_MODULE_15_lodash_forEach___default()(this.categories, function (category) {
        if (category.typeId == 2) {
          itemsCount += __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(category.tasks, function (task) {
            return task.active;
          }).length;
        } else {
          propCount += __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(category.tasks, function (task) {
            return task.active;
          }).length;
        }
      });

      return itemsCount >= 1 && propCount >= 1;
    },
    itemsCategory: function itemsCategory() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.categories, function (category) {
        return category.typeId == 2;
      })[0];
    },
    propsCategory: function propsCategory() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.categories, function (category) {
        return category.typeId != 2;
      });
    }
  }),
  created: function created() {
    this.fetchProtocolData();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var entity;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.currentSesssionDate = Math.round(new Date().getTime() / 1000);
              _this.uuid = __WEBPACK_IMPORTED_MODULE_6__common_uuid_UuidGenerator__["a" /* default */].v4();
              entity = {
                id: _this.uuid,
                type: 'assigned-session'
              };


              _this.currentDate = _this.previousDate ? _this.previousDate : new Date();

              _this.setEntity(entity);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['setPreviousDate']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {
    activeTaskLength: function activeTaskLength(taskList) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(taskList, function (task) {
        return task.active;
      });
    },
    selectTaskList: function selectTaskList() {
      this.$set(this.currentStage, 'selectedTasks', true);
    },
    toggleView: function toggleView(uuid) {
      this.currentCategoryUuid = uuid;
    },


    closeSession: function closeSession() {
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    saveCurrentStep: function saveCurrentStep() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories, function (category, categoryIndex) {

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(category.tasks, function (item, itemIndex) {

          _this2.$set(_this2.categories[categoryIndex].tasks[itemIndex], 'disabled', false);
        });
      });

      this.iterationIndex++;
      this.selectItem = false;
      this.selectProperty = false;
    },
    toggleViewDisabled: function toggleViewDisabled(position) {

      var stage = this.protocol.stages[position];
      stage.isOpenDisabled = !stage.isOpenDisabled;
      this.$set(this.protocol.stages, position, stage);
    },
    goToPrevLevel: function goToPrevLevel(uuid, task) {

      var index = __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex___default()(this.tasks, function (task) {

        return uuid.globalUuid == uuid;
      });

      this.$set(this.tasks[index], 'newStageUuid', this.protocol.stages[this.currentStage.position + -1].uuid);
    },
    today: function today() {
      var dateTime = new Date();
      var dateWithTimezone = null;
      if (this.client.timezone) {
        dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;
      }

      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateWithTimezone).format('YYYY-MM-DD');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('protocol', ['setProtocol']), {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    emptyLength: function emptyLength(length) {
      return 5 - length > 0 ? 5 - length : 0;
    },


    getMaxDateStart: function getMaxDateStart(date) {
      var clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientData.timezone)._offset;
      var dateTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      var dateWithTimezone = __WEBPACK_IMPORTED_MODULE_9_moment___default()(dateTime.getTime() + Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000).toDate();

      return dateWithTimezone;
    },

    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, newDate, newDateUnix, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};

                if (this.isPreviousDateSession && this.previousDate) {
                  newDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD');
                  newDateUnix = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(newDate, 'YYYY-MM-DD').unix();


                  params = {
                    date: newDateUnix
                  };
                }
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.protocolId + '/show-stage/', { params: params });

              case 5:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.info(_context2.t0);
                this.$router.push({ name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId } });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),

    fetchProtocolData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchData();

              case 2:
                response = _context3.sent;

                if (response) {
                  this.currentStage = response.data.data;
                  this.$set(this.currentStage, 'selectedTasks', false);
                  this.assignedProtocolId = this.protocolsData.assigneeId;
                  this.getClient(this.clientId || this.assignedProtocolId);
                  this.initProtocolData();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchProtocolData() {
        return _ref2.apply(this, arguments);
      }

      return fetchProtocolData;
    }(),

    initProtocolData: function initProtocolData() {
      var _this3 = this;

      this.protocol = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.protocolsData.protocol);
      this.execution = this.protocol.execution;

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.currentStage.categories, function (category) {

        category.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(category.tasks, function (task, index) {

          _this3.$set(task, 'lastSessions', []);
          task.attempt = 0;
          task.attepmtsCount = '1';
          task.active = false;
          var lastAnswers = task.lastAnswers ? task.lastAnswers : [];
          _this3.$set(task, 'lastAnswers', lastAnswers);
          var lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
          _this3.$set(task, 'lastAnswersCount', lastAnswersCount);
          _this3.$set(task, 'answers', []);
          _this3.$set(task, 'disabled', false);
          _this3.$set(task, 'typeAnswers', [{
            'id': 1,
            'answer': '+',
            'title': task.description,
            'color': category.typeId == 2 ? '#6A97FC' : '#76cc4e'
          }, {
            'id': 2,
            'answer': '-',
            'title': '-',
            'color': '#dddddd'
          }]);

          return task;
        });
      });

      this.categories = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(this.currentStage.categories);

      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.protocol.stages, function (item) {
        item.isOpenDisabled = false;
      });

      this.isLoaded = true;
    },

    getClient: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context4.sent;

                this.client = response.data.data;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.dir(_context4.t0);

              case 10:
                _context4.prev = 10;

                this.loaded = true;
                return _context4.finish(10);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 10, 13]]);
      }));

      function getClient(_x) {
        return _ref3.apply(this, arguments);
      }

      return getClient;
    }(),
    backToPreviousPage: function backToPreviousPage() {
      if (this.clientId || this.assignedProtocolId) {
        this.$router.push({ name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId } });
      } else {
        this.$router.push({ name: 'protocols' });
      }
    },
    onModalClose: function onModalClose() {
      this.isConflictModalVisible = false;
    },
    changeActiveCategory: function changeActiveCategory(category) {
      __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(category.tasks, function (item, index) {

        item.active = category.active;
      });
    },


    attemptChange: function attemptChange(category, answer, task) {
      var _this4 = this;

      var categoryUuid = category.uuid;

      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      var lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
      var lastDay = this.isPreviousDateSession ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.previousDate).format('YYYY-MM-DD') : this.today();

      this.totalAtemptsCount++;
      if (this.totalAtemptsCount <= this.maxTotalAtemptsCount) {
        this.maxTotalAtemptsCountError = false;

        var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex___default()(this.categories, function (category) {
          return category.uuid === categoryUuid;
        });

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories[currentCategoryIndex].tasks, function (item, index) {

          item.disabled = true;

          if (item.globalUuid == task.globalUuid) {

            item.answers.push({
              id: answer.id,
              iterationIndex: _this4.iterationIndex
            });
            item.attempt++;
            item.lastAnswers.push(answer.answer);
            _this4.$set(_this4.categories[currentCategoryIndex].tasks[index], 'lastAnswers', item.lastAnswers);
            item.disabled = true;

            if (lastDate === lastDay) {
              item.lastSessions[task.lastSessions.length - 1].attempts.push(answer.id);
            } else {
              item.isMastered = false;
              item.lastSessions.push({
                date: lastDay,
                attempts: [answer.id],
                mastered: false
              });
            }

            item.lastAnswersTotal++;
          }
        });
      } else {
        this.maxTotalAtemptsCountError = true;
        this.totalAtemptsCount = this.totalAtemptsCount - 1;
        setTimeout(function () {
          _this4.$refs.maxTotalAtemptsCountError.scrollIntoView();
        }, 100);
      }

      if (category.typeId == 2) {
        this.selectItem = true;
      } else {
        this.selectProperty = true;
      }

      this.timerId = setTimeout(function () {
        task.answer = null;
      }, 200);
    },

    backToPreviousAttempt: function backToPreviousAttempt(categoryUuid) {
      var _this5 = this;

      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex___default()(this.categories, function (category) {
        return category.uuid === categoryUuid;
      });

      if (currentCategoryIndex >= 0) {
        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories[currentCategoryIndex].tasks, function (item, key) {

          if (item.answers.length && item.answers[item.answers.length - 1].iterationIndex === _this5.iterationIndex) {
            var lastAnswersCount = 1;

            item.answers = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.answers, lastAnswersCount);
            item.lastAnswers = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.lastAnswers, lastAnswersCount);
            item.attempt = item.attempt - lastAnswersCount;
            _this5.totalAtemptsCount = _this5.totalAtemptsCount - lastAnswersCount;

            item.lastAnswersCount.pop();
            _this5.$set(item, 'disabledBack', true);

            item.lastSessions[item.lastSessions.length - 1].attempts = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

            if (!item.lastSessions[item.lastSessions.length - 1].attempts.length && !item.lastSessions[item.lastSessions.length - 1].isMastered) {
              item.lastSessions.pop();
            }

            item.lastAnswersTotal -= lastAnswersCount;

            item.disabled = false;

            if (!_this5.totalAtemptsCount) {
              _this5.disabledSave = true;
            }
          }

          item.disabled = false;
          _this5.categories[currentCategoryIndex].active = false;
        });

        if (this.categories[currentCategoryIndex].typeId == 2) {
          this.selectItem = false;
        } else {

          var activeProps = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.propsCategory, function (category) {
            return category.active;
          });
          this.selectProperty = activeProps.length;
        }
      }
    },

    checkSessionVersion: function checkSessionVersion() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var sessionVersion;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sessionVersion = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this6.apiCheckedUrl + _this6.protocolsData.id + '/is-version-equal/' + _this6.protocolsData.protocol.majorVersion);
                return _context5.abrupt('return', sessionVersion);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    saveStage: function saveStage(close, stageId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var checkVersion, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.isLoaded = false;

                _context6.next = 3;
                return _this7.checkSessionVersion();

              case 3:
                checkVersion = _context6.sent;

                if (!_this7.showChangeDateSession) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 7;
                return _this7.$validator.validate('duration');

              case 7:
                _context6.t0 = _context6.sent;
                _context6.next = 11;
                break;

              case 10:
                _context6.t0 = true;

              case 11:
                result = _context6.t0;


                if (result && checkVersion.data.data.result) {
                  _this7.saveSession(close, stageId);
                } else {
                  _this7.isLoaded = true;
                  _this7.isConflictModalVisible = true;
                }

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },


    saveSession: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(close, stageId) {
        var _this8 = this;

        var that, isSaved, sessionDate, sessionEndDate, timeSessionDate, timeSessionEndDate, clientTimeZoneOffset, taskReactions, startedAt, finishedAt, stageActiveList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                that = this;
                isSaved = void 0;

                this.isLoaded = false;
                this.errors.clear();

                sessionDate = null;
                sessionEndDate = null;
                timeSessionDate = null;
                timeSessionEndDate = null;


                if (this.isPreviousDateSession && this.previousTime.HH) {
                  clientTimeZoneOffset = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.client.timezone)._offset;

                  sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(), this.previousDate.getMonth(), this.previousDate.getDate(), this.previousTime.HH, this.previousTime.mm));
                  timeSessionDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                  timeSessionEndDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(sessionDate).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE + this.previousDuration * __WEBPACK_IMPORTED_MODULE_10__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
                }

                taskReactions = [];


                __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.categories, function (category) {
                  __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(category.tasks, function (task) {
                    taskReactions.push(task);
                  });
                });

                taskReactions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(taskReactions, function (task) {

                  delete task['lastAnswers'];
                  delete task['lastAnswersCount'];
                  delete task['typeAnswers'];
                  delete task['attepmtsCount'];
                  delete task['lastAnswersTotal'];
                  return task;
                });

                startedAt = this.isPreviousDateSession ? timeSessionDate : this.currentSesssionDate ? this.currentSesssionDate : Math.round(new Date().getTime() / 1000);
                finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round(new Date().getTime() / 1000);
                stageActiveList = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.protocol.stages, ['isClosed', false]);


                isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl + this.protocolId + '/sessions', {

                  'index': that.currentStage.position,
                  'uuid': that.currentStage.uuid,
                  'close': close,
                  'majorVersion': this.protocol.majorVersion,
                  'newStageUuid': stageId,
                  'assignedSessions': [{
                    'uuid': this.uuid,
                    'iterationCount': this.iterationIndex + 1,
                    'startedAt': startedAt,
                    'finishedAt': finishedAt,
                    'stimuli': taskReactions,
                    'type': this.currentStage.type
                  }]

                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (_this8.isClient) {
                              _this8.$router.push({ name: 'available-protocols' });
                            }
                            _this8.setProtocol(null);
                            if (close) {
                              _this8.$router.push({ name: 'results', params: { clientId: _this8.clientId || _this8.assignedProtocolId, protocolId: _this8.protocolId } });
                            } else {

                              if (stageActiveList.length == 1) {
                                _this8.$router.push({ name: 'client-edit', params: { clientId: _this8.clientId || _this8.assignedProtocolId } });
                              } else {
                                _this8.$router.push({ name: 'stage-list', params: { clientId: _this8.clientId, protocolData: null } });
                              }
                            }

                          case 3:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this8);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.info(error);
                  _this8.$router.push({ name: 'client-edit', params: { clientId: _this8.clientId || _this8.assignedProtocolId } });
                });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function saveSession(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return saveSession;
    }(),

    closeStage: function closeStage() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                _this9.saveSession(true);

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    }
  }),
  watch: {
    previousDate: function previousDate(newValue, oldValue) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var oldDay, newDay, endDate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                oldDay = oldValue ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(oldValue).format('YYYY-MM-DD') : _this10.today();
                newDay = __WEBPACK_IMPORTED_MODULE_9_moment___default()(newValue).format('YYYY-MM-DD');
                endDate = _this10.protocolsData.endDate ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this10.protocolsData.endDate.date).format('YYYY-MM-DD') : null;


                __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this10.categories, function (category, categoryIndex) {

                  category.tasks = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(category.tasks, function (task, index) {

                    if (oldDay == endDate) {

                      var lastSessionAnswersCount = task.lastAnswers.length > task.answers.length ? task.lastAnswers.length - task.answers.length : 0;
                      var lastAnswers = lastSessionAnswersCount > 0 ? __WEBPACK_IMPORTED_MODULE_24_lodash_drop___default()(task.lastAnswers, lastSessionAnswersCount) : task.lastAnswers;

                      _this10.$set(task, 'lastAnswers', lastAnswers);

                      var oldLastSessionIndex = __WEBPACK_IMPORTED_MODULE_23_lodash_findIndex___default()(task.lastSessions, function (lastSession) {

                        return lastSession.date === oldDay;
                      });

                      if (oldLastSessionIndex >= 0) {

                        var attemptsCount = task.lastSessions[oldLastSessionIndex].attempts ? task.lastSessions[oldLastSessionIndex].attempts.length - lastSessionAnswersCount : 0;
                        var attempts = attemptsCount > 0 ? __WEBPACK_IMPORTED_MODULE_24_lodash_drop___default()(task.lastSessions[oldLastSessionIndex].attempts, attemptsCount) : [];
                        var newAttempts = attemptsCount > 0 ? __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(task.lastSessions[oldLastSessionIndex].attempts, lastSessionAnswersCount) : [];

                        task.lastSessions[oldLastSessionIndex].attempts = attempts;

                        task.lastSessions.push({
                          date: newDay,
                          attempts: newAttempts,
                          mastered: false
                        });
                      }
                    } else {

                      task.lastSessions = __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(task.lastSessions, function (lastSession) {

                        if (lastSession.date === oldDay) {
                          lastSession.date = newDay;
                        }

                        return lastSession;
                      });
                    }

                    task.isMastered = false;

                    return task;
                  });
                });

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    previousTime: function previousTime(newValue) {},
    isPreviousDateSession: function isPreviousDateSession(newValue) {
      if (!newValue) {

        this.currentDate = this.previousDate;
        this.setPreviousDate(null);

        __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(this.tasks, function (item, index) {

          item.isMastered = false;
        });
      } else {
        this.setPreviousDate(this.currentDate);
      }
    }
  }

});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Manager__ = __webpack_require__(82);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var clientId, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            clientId = to && to.params && to.params.clientId ? parseInt(to.params.clientId) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].hasAccess(clientId);

          case 4:
            response = _context.sent;
            result = response.data.data;

            if (!(result && result.hasAccess)) {
              _context.next = 10;
              break;
            }

            next();
            _context.next = 11;
            break;

          case 10:
            throw new Error('Forbidden');

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](0);

            next({ name: 'default' });

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 13]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isChange: false,
      apiUrl: '/protocols/',
      protocols: [],
      paginate: {
        perPage: 5,
        page: 1,
        forcePage: 0,
        lastPage: null,
        pageRange: 3,
        marginPages: 2
      },
      disabled: false,
      isLoaded: true,
      isModalVisible: false,
      protocolId: null,
      options: {
        pageHeader: 'protocols',
        initialPage: null,
        filterable: false,
        sortable: [],
        debounce: 1000,
        skin: 'table table-sm',
        withSearch: true,
        columns: [{
          key: 'id',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocols')
        }, {
          key: 'title',
          changed: true,
          headings: ''
        }, {
          key: 'published',
          changed: true,
          headings: ''
        }, {
          key: 'createdAt',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.create_date')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        listRow: {
          goal: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocol_goal'),
            hasTemplate: false
          },
          createdAt: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.create_date'),
            hasTemplate: false
          }
        },
        headings: { goal: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocols') },
        dateColumns: ['created_at'],
        texts: {
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.type_the_procol_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          id: 'icons-field',
          action: 'table-actions',
          title: 'wide-col',
          published: 'nowrap',
          createdAt: 'nowrap'
        },
        search: '',
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        }
      }

    };
  },


  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_7_vuejs_paginate___default.a, Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_9__common_table_components_TableView__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA', 'isMensurationForbidden']), {
    isEmptyProtocols: function isEmptyProtocols() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(this.protocols);
    }
  }),

  created: function created() {
    if (this.isMobile) {
      //this.fetchProtocols(this.paginate.perPage, this.paginate.page);
    }
  },


  methods: {
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.fetchProtocols(data.limit, data.page, data.query));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    fetchProtocols: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(perPage, page, search) {
        var params, url, response, protocols;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.isLoaded = false;
                //search = search ? search : this.search;
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'protocols');
                params = {
                  sort: this.sort,
                  search: search ? search.search : this.search,
                  searchSkillField: search ? search.searchSkillField : this.searchSkillField
                };
                url = this.apiUrl + perPage + '/' + page;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params });

              case 8:
                response = _context2.sent;
                protocols = response.data.data.items;

                protocols.forEach(function (item) {
                  item.isOpen = false;
                });
                this.protocols = protocols;
                this.setPaginate(response.data.data);
                this.isLoaded = true;
                this.isChange = false;
                return _context2.abrupt('return', response);

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);
                if (_context2.t0.status == 403) {
                  this.$router.push({ name: 'client' });
                }

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 18]]);
      }));

      function fetchProtocols(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return fetchProtocols;
    }(),

    showDeletePopup: function showDeletePopup(id) {
      this.protocolId = id;
      this.isModalVisible = true;
    },
    duplicateProtocol: function duplicateProtocol(protocolId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this2.isLoaded = false;

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.apiUrl + protocolId + '/copy');

              case 4:
                response = _context3.sent;

                _this2.isChange = true;
                return _context3.abrupt('return', response.data.data);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 10]]);
      }))();
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },


    setPaginate: function setPaginate(data) {
      this.paginate.perPage = data.perPage;
      this.paginate.page = data.currentPage;
      this.paginate.lastPage = data.lastPage;
    },

    detectProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(protocolId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + protocolId + '/teaching-method');

              case 2:
                response = _context4.sent;
                return _context4.abrupt('return', response.data.data.id);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function detectProtocol(_x4) {
        return _ref2.apply(this, arguments);
      }

      return detectProtocol;
    }(),

    deleteProtocol: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        var index, teachingMethodId, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                this.isLoaded = false;
                index = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.protocols, function (protocol) {
                  return protocol.id === id;
                });
                _context5.next = 5;
                return this.detectProtocol(id);

              case 5:
                teachingMethodId = _context5.sent;
                url = teachingMethodId == 3 ? this.apiUrl + 'mand/' : this.apiUrl;

                if (!(index !== -1)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 10;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + id);

              case 10:
                response = _context5.sent;

                this.protocols.splice(index, 1);
                this.isChange = true;
                this.paginate.forcePage = this.paginate.page - 1;
                if (this.protocols.length === 0 && this.paginate.page - 1 > 0) {
                  this.paginate.page = this.paginate.page - 1;
                  this.fetchProtocols(this.paginate.perPage, this.paginate.page);
                }

              case 15:
                this.isLoaded = true;
                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5['catch'](0);

                console.dir(_context5.t0);

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 18]]);
      }));

      function deleteProtocol(_x5) {
        return _ref3.apply(this, arguments);
      }

      return deleteProtocol;
    }(),

    exportProtocol: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'pdf/' + id, { responseType: 'blob' }).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocol') + '_' + id + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 3:
                response = _context6.sent;
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);

                console.dir(_context6.t0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));

      function exportProtocol(_x6) {
        return _ref4.apply(this, arguments);
      }

      return exportProtocol;
    }(),

    onPaginationClick: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(pageNum) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.fetchProtocols(this.paginate.perPage, pageNum);
                this.paginate.page = pageNum;
                this.paginate.forcePage = pageNum - 1;

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onPaginationClick(_x7) {
        return _ref5.apply(this, arguments);
      }

      return onPaginationClick;
    }(),
    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
      this.paginate.page = 1;
    },
    onSearchSkillField: function onSearchSkillField(searchSkillField) {
      this.searchSkillField = searchSkillField;
      this.paginate.page = 1;
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_hash__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_autocompleteSearch_components_autocompleteSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_parseInt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_differenceBy__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_differenceBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_differenceBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tasks__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TasksDTT__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__TasksMand__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__TasksUSD__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TasksChain__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TasksShaping__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ConfirmChangeModal__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__profile_api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ChangeFixingModal__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_lodash_isEqual__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Protocollnfo__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ProtocolCriteration__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__TasksPecs__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__CriteriaPecs__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__CriteriaPecsItems__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__TasksPecs3__ = __webpack_require__(1234);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














































/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientProtocol': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'isActiveProtocol': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },

  data: function data() {
    return {
      apiUrl: '/protocols/',
      apiClientUrl: '/users/clients/',
      applyings: [],
      skillFields: [],
      client: {},
      isOpen: false,
      isTaskDeleteOpen: false,
      isMandDeleteOpen: false,
      taskDeleteTitle: null,
      taskDeleteUuid: null,
      mandDeleteTitle: null,
      selectedTeachingMethodID: null,
      disabledTeachingMethod: false,
      dragging: false,
      draggingGlobalTasks: false,
      focusStage: false,
      protocol: {
        id: null,
        title: '',
        applying: '',
        skillField: '',
        teachingMethodDescription: '',
        goal: '',
        execution: '',
        criteriaEndSession: '',
        criteriaEndTeaching: '',
        criteriaEndProtocol: '',
        synthesisStrategy: '',
        materials: '',
        teachingFormat: '',
        risingPrompt: '',
        dataFields: [],
        published: false,
        shortcutMenuTitle: '',
        isShortcutEnabled: false,
        stages: [{
          id: null,
          position: 0,
          title: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + 0,
          titleDescription: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + 0,
          description: '',
          attemptCount: '10',
          tasks: [],
          mands: [],
          phases: [{
            typeId: 1,
            transferCondition: {
              id: null
            },
            minFieldCount: '2',
            maxFieldCount: '8',
            taskType: null
          }, {
            typeId: 2,
            transferCondition: {
              id: null
            },
            minFieldCount: '2',
            maxFieldCount: '8',
            taskType: null
          }, {
            typeId: 3,
            intervals: []
          }]
        }],
        isNew: true,
        teachingMethodId: null,
        intervals: [],
        globalTasks: [],
        globalMandReactions: [],
        isOnIndividualization: false
      },
      hintListRotation: null,
      validateStimuls: true,
      validateCheckList: true,
      errorStages: true,
      errorStagesCount: true,
      selectedInterval: null,
      columns: ['name', 'count', 'action'],
      dataFields: ['baseLevel', 'code1', 'code2', 'errorCorrection', 'features', 'hintType', 'instruction', 'provideHint', 'reductionHint', 'reductionHintMethod', 'rightReaction', 'teachingMethod'],
      templates: [],
      directories: [],
      taskTypes: [],
      taskTypesMand: [],
      taskNotDttTypes: [],
      disabled: false,
      isNew: true,
      isEditing: false,
      listTasks: false,
      listTasksDTT: false,
      listTasksMand: false,
      listTasksUSD: false,
      listTasksChain: false,
      listTasksShaping: false,
      listTasksPecs: false,
      listTasksPecsWithDiscrimination: false,
      taskTypeTitle: '',
      selectedTaskTypeTitle: '',
      selectedStagesTitle: '',
      canPublish: false,
      isLoaded: true,
      visible: true,
      showDeleteButton: true,
      isChanged: false,
      isChangedTask: true,
      isChangedMand: true,
      teachingMethod: null,
      selectedTeachingMethod: null,
      transferConditionValue: {
        first: '',
        second: '',
        third: '',
        fourth: ''
      },
      masteringTransferCondition: null,
      rotationTransferCondition: null,
      fluencyTransferCondition: null,
      intervalId: null,
      taskIntervalId: null,
      mandIntervalId: null,
      changedSavePopup: false,
      disabledNotImportantChanges: false,
      update: false,
      published: false,
      mandDeleteUiid: null,
      isModalAcceptPopup: false,
      selectedTaskUuid: null,
      globalTask: null,
      stagesTask: null,
      categories: null,
      allTaskTypes: null,
      isModalCantDelete: false,
      hashProtocol: null,
      countRemovedCategory: 0,
      isAllTasksEnabled: false
    };
  },


  components: {
    CriteriaPecs: __WEBPACK_IMPORTED_MODULE_49__CriteriaPecs__["a" /* default */], CriteriaPecsItems: __WEBPACK_IMPORTED_MODULE_50__CriteriaPecsItems__["a" /* default */], TasksPecs3: __WEBPACK_IMPORTED_MODULE_51__TasksPecs3__["a" /* default */], Tasks: __WEBPACK_IMPORTED_MODULE_22__Tasks__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_30__loader_components_Loader__["a" /* default */], autocompleteSearch: __WEBPACK_IMPORTED_MODULE_13__common_autocompleteSearch_components_autocompleteSearch__["a" /* default */], Hints: __WEBPACK_IMPORTED_MODULE_29__Hints__["a" /* default */], TasksDTT: __WEBPACK_IMPORTED_MODULE_23__TasksDTT__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_38_vuedraggable___default.a, ChangeFixingModal: __WEBPACK_IMPORTED_MODULE_41__ChangeFixingModal__["a" /* default */], TasksMand: __WEBPACK_IMPORTED_MODULE_24__TasksMand__["a" /* default */], ConfirmChangeModal: __WEBPACK_IMPORTED_MODULE_28__ConfirmChangeModal__["a" /* default */], TasksUsd: __WEBPACK_IMPORTED_MODULE_25__TasksUSD__["a" /* default */], TasksChain: __WEBPACK_IMPORTED_MODULE_26__TasksChain__["a" /* default */], TasksShaping: __WEBPACK_IMPORTED_MODULE_27__TasksShaping__["a" /* default */], ProtocolInfo: __WEBPACK_IMPORTED_MODULE_46__Protocollnfo__["a" /* default */], ProtocolCriteration: __WEBPACK_IMPORTED_MODULE_47__ProtocolCriteration__["a" /* default */], TasksPecs: __WEBPACK_IMPORTED_MODULE_48__TasksPecs__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_39_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA']), Object(__WEBPACK_IMPORTED_MODULE_39_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {

    isDTT: function isDTT() {
      return this.selectedTeachingMethodID == 1;
    },

    isSimple: function isSimple() {
      return this.selectedTeachingMethodID == 2;
    },

    isMand: function isMand() {
      return this.selectedTeachingMethodID == 3;
    },

    isUSD: function isUSD() {
      return this.selectedTeachingMethodID == 4;
    },

    isChain: function isChain() {
      return this.selectedTeachingMethodID == 5;
    },

    isShaping: function isShaping() {
      return this.selectedTeachingMethodID == 6;
    },
    isPecs: function isPecs() {
      return this.selectedTeachingMethodID == 7;
    },
    isPecsWithoutDiscrimination: function isPecsWithoutDiscrimination() {
      return this.selectedTeachingMethodID == 8;
    },
    isPecsWithDiscrimination: function isPecsWithDiscrimination() {
      return this.selectedTeachingMethodID == 9;
    },
    isPecsWithItems: function isPecsWithItems() {
      return this.selectedTeachingMethodID == 10;
    },
    activeStages: function activeStages() {
      return __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(this.protocol.stages, function (stage) {
        return stage.isActive;
      });
    }
  }),

  provide: function provide() {
    return { parentValidator: this.$validator };
  },


  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      this.intervalId = window.setInterval(function () {
        var hashProtocol = __WEBPACK_IMPORTED_MODULE_9_object_hash___default.a.MD5(_this.protocol);

        if (!!_this.hashProtocol && hashProtocol !== _this.hashProtocol) {
          _this.setIsChanged(false);
          _this.autoSave();
        }

        if (!_this.hashProtocol) {
          _this.hashProtocol = hashProtocol;
        }
      }, 15000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  created: function created() {
    var _this2 = this;

    this.isLoaded = false;
    this.fetchTaskTypes();
    this.fetchDirectories();
    this.fetchHint();

    this.transferConditionValue.first = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
    this.transferConditionValue.second = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW;
    this.transferConditionValue.third = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW;
    this.transferConditionValue.fourth = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO;
    __WEBPACK_IMPORTED_MODULE_37_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return _this2.protocol.teachingMethodId != 3 ? __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('validation.unique_task', { attribute: attribute }) : __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.unique_mand', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  if (_this2.protocol.teachingMethodId != 3) {
                    __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this2.protocol.globalTasks, function (item) {
                      if (__WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(item.description) === __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(task)) {
                        unique++;
                      }
                    });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this2.protocol.globalMandReactions, function (item) {
                      if (__WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(item.description) === __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(task)) {
                        unique++;
                      }
                    });
                  }

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });

    __WEBPACK_IMPORTED_MODULE_37_vee_validate__["a" /* Validator */].extend('unique_stage', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('validation.unique_stage', { attribute: attribute });
      },
      validate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(stage) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this2.protocol.stages, function (item) {
                    if (__WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(item.description) === __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(stage)) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function validate(_x2) {
          return _ref2.apply(this, arguments);
        };
      }()
    });
  },


  methods: {
    validatorTaskAdd: function validatorTaskAdd() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_37_vee_validate__["a" /* Validator */].extend('unique_task', {
        getMessage: function getMessage(attribute) {
          return _this3.protocol.teachingMethodId != 3 ? __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('validation.unique_task', { attribute: attribute }) : __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.unique_mand', { attribute: attribute });
        },
        validate: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(task) {
            var valid, unique;
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    valid = void 0;
                    unique = 0;


                    if (_this3.protocol.teachingMethodId != 3) {
                      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this3.protocol.globalTasks, function (item) {
                        if (__WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(item.description) === __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(task)) {
                          unique++;
                        }
                      });
                    } else {
                      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this3.protocol.globalMandReactions, function (item) {
                        if (__WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(item.description) === __WEBPACK_IMPORTED_MODULE_33_lodash_trim___default()(task)) {
                          unique++;
                        }
                      });
                    }

                    if (unique > 1) {
                      valid = false;
                    } else {
                      valid = true;
                    }

                    return _context3.abrupt('return', { valid: valid });

                  case 5:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this3);
          }));

          return function validate(_x3) {
            return _ref3.apply(this, arguments);
          };
        }()
      });
    },
    onMoveStages: function onMoveStages(_ref4) {
      var relatedContext = _ref4.relatedContext,
          draggedContext = _ref4.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.isClosed) && !draggedElement.isClosed;
    },


    setIsChanged: function setIsChanged() {
      var isChanged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.isChanged = isChanged;
    },
    autoSave: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var protocol, urlSave, response, _protocol, dataFields, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref6, _ref7, key, value;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.protocol.assigneeId) {
                  _context4.next = 73;
                  break;
                }

                this.protocol.teachingMethodId = this.teachingMethod.id;
                this.protocol.isNew = this.isNew;
                if (this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
                  this.reindexStages();
                }
                if (this.protocol.teachingMethodId != 3 && this.protocol.teachingMethodId != 7 && this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
                  this.reindexTasks();
                }

                if (this.protocol.teachingMethodId == 3) {
                  this.reindexMands();
                }

                if (this.protocol.teachingMethodId == 7 || this.protocol.teachingMethodId == 8) {
                  this.masteredStimuliList();
                }

                if (this.protocol.teachingMethodId == 9 || this.protocol.teachingMethodId == 10) {
                  this.criteriaPecsDescriptionChanged();
                }

                this.hintListActivate();

                protocol = __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.protocol);


                protocol.teachingMethod = this.teachingMethod;

                urlSave = this.apiUrl + 'draft/';
                _context4.t0 = this.teachingMethod.id;
                _context4.next = _context4.t0 === 1 ? 15 : _context4.t0 === 2 ? 17 : _context4.t0 === 3 ? 19 : _context4.t0 === 4 ? 21 : _context4.t0 === 5 ? 23 : _context4.t0 === 6 ? 25 : _context4.t0 === 7 ? 27 : _context4.t0 === 8 ? 29 : _context4.t0 === 9 ? 31 : _context4.t0 === 10 ? 33 : 35;
                break;

              case 15:
                urlSave = this.apiUrl + 'draft/dtt/';
                return _context4.abrupt('break', 35);

              case 17:
                urlSave = this.apiUrl + 'draft/simple/';
                return _context4.abrupt('break', 35);

              case 19:
                urlSave = this.apiUrl + 'draft/mand/';
                return _context4.abrupt('break', 35);

              case 21:
                urlSave = this.apiUrl + 'draft/vcd/';
                return _context4.abrupt('break', 35);

              case 23:
                urlSave = this.apiUrl + 'draft/chain/';
                return _context4.abrupt('break', 35);

              case 25:
                urlSave = this.apiUrl + 'draft/shaping/';
                return _context4.abrupt('break', 35);

              case 27:
                urlSave = this.apiUrl + 'draft/pecs-sentence-structure/';
                return _context4.abrupt('break', 35);

              case 29:
                urlSave = this.apiUrl + 'draft/pecs-without-discrimination/';
                return _context4.abrupt('break', 35);

              case 31:
                urlSave = this.apiUrl + 'draft/pecs-with-discrimination/';
                return _context4.abrupt('break', 35);

              case 33:
                urlSave = this.apiUrl + 'draft/pecs-features-with-items/';
                return _context4.abrupt('break', 35);

              case 35:

                if (this.protocol.teachingMethodId == 3) {

                  protocol.globalMandReactions = __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy___default()(this.protocol.globalMandReactions, 'description');

                  if (protocol.globalMandReactions.length != this.protocol.globalMandReactions.length) {
                    __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(protocol.stages, function (stage, index) {
                      protocol.stages[index].mands = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.mands, function (mand) {
                        var globalMand = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(protocol.globalMandReactions, function (global) {
                          return global.uuid == mand.globalUuid;
                        });

                        if (globalMand.length) {
                          return mand;
                        }
                      });
                    });
                  }
                }

                if (this.protocol.teachingMethodId != 3 && this.protocol.teachingMethodId != 7 && this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {

                  protocol.globalTasks = __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy___default()(this.protocol.globalTasks, 'description');
                  __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(protocol.stages, function (stage, index) {
                    protocol.stages[index].tasks = __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy___default()(stage.tasks, 'description');
                  });
                }

                protocol.stages = __WEBPACK_IMPORTED_MODULE_31_lodash_uniqBy___default()(protocol.stages, 'description');

                response = null;

                if (!this.protocol.id) {
                  _context4.next = 45;
                  break;
                }

                _context4.next = 42;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(urlSave + this.protocol.id, protocol);

              case 42:
                response = _context4.sent;
                _context4.next = 48;
                break;

              case 45:
                _context4.next = 47;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(urlSave, protocol);

              case 47:
                response = _context4.sent;

              case 48:
                if (!response) {
                  _context4.next = 73;
                  break;
                }

                _protocol = response.data.data;
                dataFields = _protocol ? _protocol.dataFields : null;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 54;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(dataFields)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _ref6 = _step.value;
                  _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
                  key = _ref7[0];
                  value = _ref7[1];

                  if (['Отсутствует', 'No'].includes(value)) {
                    dataFields[key] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.absent');
                  } else if (!value) {
                    dataFields[key] = '';
                  }
                }
                _context4.next = 62;
                break;

              case 58:
                _context4.prev = 58;
                _context4.t1 = _context4['catch'](54);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 62:
                _context4.prev = 62;
                _context4.prev = 63;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 65:
                _context4.prev = 65;

                if (!_didIteratorError) {
                  _context4.next = 68;
                  break;
                }

                throw _iteratorError;

              case 68:
                return _context4.finish(65);

              case 69:
                return _context4.finish(62);

              case 70:
                this.protocol.id = _protocol.id;
                this.protocol.bcbaId = _protocol.bcbaId;
                this.hashProtocol = __WEBPACK_IMPORTED_MODULE_9_object_hash___default.a.MD5(this.protocol);

              case 73:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[54, 58, 62, 70], [63,, 65, 69]]);
      }));

      function autoSave() {
        return _ref5.apply(this, arguments);
      }

      return autoSave;
    }(),

    validate: function validate() {
      this.errors.clear();
      this.intervalError = false;
      if (this.$refs.searchSkillField) {
        this.$refs.searchSkillField.validate();
      }
    },


    validateForm: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var that, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = this;

                this.validate();
                _context5.next = 4;
                return this.$validator.validateAll();

              case 4:
                result = _context5.sent;


                if (!result) {
                  that.handleValidationErrorAdvanced();
                }

                return _context5.abrupt('return', that.errors.items.length == 0);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function validateForm() {
        return _ref8.apply(this, arguments);
      }

      return validateForm;
    }(),

    validateStimul: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _this4 = this;

        var validateCheckList;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.validateStimuls = true;
                validateCheckList = true;

                __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.stages, function (item) {
                  item.notValid = false;
                  if (item.tasks.length == 1 && item.tasks[0].description == "" || !item.tasks.length) {
                    _this4.validateStimuls = false;
                  }
                  if (!item.type) {
                    validateCheckList = false;
                    item.notValid = true;
                  }
                });
                return _context6.abrupt('return', this.validateStimuls && validateCheckList);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function validateStimul() {
        return _ref9.apply(this, arguments);
      }

      return validateStimul;
    }(),

    validateMand: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.validateMands = true;
                this.validateCheckList = true;
                /*forEach(this.protocol.stages, (item) => {
                  if ((item.tasks.length == 1 && item.tasks[0].description == "") || !item.tasks.length){
                    this.validateMands =  false;
                  }
                });*/
                return _context7.abrupt('return', this.validateMands);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function validateMand() {
        return _ref10.apply(this, arguments);
      }

      return validateMand;
    }(),

    validateStages: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _this5 = this;

        var validateStages;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.errorStages = true;
                validateStages = true;

                __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (item) {

                  if (_this5.protocol.teachingMethodId == 6 || _this5.isShaping) {
                    item.notValid = false;

                    if (!item.type) {
                      validateStages = false;
                      item.notValid = true;
                    }
                  } else if (_this5.protocol.teachingMethodId == 2 || _this5.isSimple) {
                    item.notValid = false;

                    if (!item.type || !item.targetStimulus.globalUuid) {
                      validateStages = false;
                      item.notValid = true;
                    }
                  } else {
                    __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(item.phases, function (phase) {
                      item.notValid = false;

                      if (phase.active && phase.typeId !== 5) {

                        if (phase.typeId == 3) {
                          if (!phase.intervals.length) {
                            validateStages = false;
                            item.notValid = true;
                          }
                        } else {
                          if (!phase.transferCondition.id) {
                            validateStages = false;
                            item.notValid = true;
                          }
                        }
                      }
                    });
                  }
                });

                return _context8.abrupt('return', validateStages);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function validateStages() {
        return _ref11.apply(this, arguments);
      }

      return validateStages;
    }(),

    getClient: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context9.sent;

                this.client = response.data.data;
                _context9.next = 10;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9['catch'](0);

                console.dir(_context9.t0);

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function getClient(_x5) {
        return _ref12.apply(this, arguments);
      }

      return getClient;
    }(),

    onChangeCriteriaEndSession: function onChangeCriteriaEndSession(search) {
      this.setIsChanged(true);
      this.searchAutocomplete(__WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["b" /* DIRECTORY_TYPES */].CRITERIA_END_SESSION, search, this);
    },
    onChangeCriteriaEndTeaching: function onChangeCriteriaEndTeaching(search) {
      this.setIsChanged(true);
      this.searchAutocomplete(__WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["b" /* DIRECTORY_TYPES */].CRITERIA_END_TEACHING, search, this);
    },
    onChangeCriteriaEndProtocol: function onChangeCriteriaEndProtocol(search) {
      this.setIsChanged(true);
      this.searchAutocomplete(__WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["b" /* DIRECTORY_TYPES */].CRITERIA_END_PROTOCOL, search, this);
    },
    setCriteriaEndSession: function setCriteriaEndSession(text) {
      this.protocol.criteriaEndSession = text;
      this.autocomplete = [];
    },
    setCriteriaEndTeaching: function setCriteriaEndTeaching(text) {
      this.protocol.criteriaEndTeaching = text;
      this.autocomplete = [];
    },
    setCriteriaEndProtocol: function setCriteriaEndProtocol(text) {
      this.protocol.criteriaEndProtocol = text;
      this.autocomplete = [];
    },


    fetchTaskTypes: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, taskTypes;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.apiUrl + 'task-types/');

              case 3:
                response = _context10.sent;


                this.allTaskTypes = response.data.data;

                this.taskTypesMand = this.allTaskTypes.filter(function (item) {
                  return item.id == 6;
                });

                taskTypes = this.allTaskTypes.filter(function (item) {
                  return item.id !== 2 && item.id !== 6;
                });


                this.taskTypes = taskTypes;

                this.taskNotDttTypes = this.allTaskTypes.filter(function (item) {
                  return item.id !== 2 && item.id !== 1 && item.id !== 6;
                });

                _context10.next = 14;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10['catch'](0);

                console.dir(_context10.t0);

              case 14:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 11]]);
      }));

      function fetchTaskTypes() {
        return _ref13.apply(this, arguments);
      }

      return fetchTaskTypes;
    }(),

    fetchDirectories: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.apiUrl + 'directories/');

              case 3:
                response = _context11.sent;


                this.directories = response.data.data;

                if (this.protocolId && response) {
                  this.loadProtocol();
                } else {
                  this.loadFromTemplate();
                }

                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11['catch'](0);

                console.dir(_context11.t0);

              case 11:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function fetchDirectories() {
        return _ref14.apply(this, arguments);
      }

      return fetchDirectories;
    }(),

    fetchHint: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_40__profile_api_Manager__["a" /* default */].getTaskTypes();

              case 3:
                response = _context12.sent;

                this.hintListRotation = response.data.data.taskPrompts.prompts;
                __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.hintListRotation, function (item) {
                  item.active = false;
                });

                _context12.next = 11;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12['catch'](0);

                console.dir(_context12.t0);

              case 11:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 8]]);
      }));

      function fetchHint() {
        return _ref15.apply(this, arguments);
      }

      return fetchHint;
    }(),

    fetchTemplates: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.apiUrl + 'templates/');

              case 3:
                response = _context13.sent;

                this.templates = response.data.data;
                _context13.next = 10;
                break;

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13['catch'](0);

                console.dir(_context13.t0);

              case 10:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 7]]);
      }));

      function fetchTemplates() {
        return _ref16.apply(this, arguments);
      }

      return fetchTemplates;
    }(),

    detectProtocol: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.apiUrl + this.protocolId + '/teaching-method');

              case 3:
                response = _context14.sent;
                return _context14.abrupt('return', response.data.data.id);

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14['catch'](0);

                console.info(_context14.t0);
                if (_context14.t0.data.code == 404 || _context14.t0.status !== 200) {
                  this.$router.push({ name: 'error' });
                }

              case 11:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 7]]);
      }));

      function detectProtocol() {
        return _ref17.apply(this, arguments);
      }

      return detectProtocol;
    }(),

    getListOfTasks: function getListOfTasks() {
      var _this6 = this;

      var step = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()(this.protocol.globalTasks, function (item) {

        return {
          description: item.description,
          title: item.title,
          globalTaskId: item.id,
          globalUuid: item.uuid,
          position: item.position,
          stageId: _this6.protocol.stages[0].id,
          stageUuid: _this6.protocol.stages[0].uuid
        };
      });

      this.$set(this.protocol.stages[0], 'tasks', step);
    },

    fetchProtocol: function () {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15(id) {
        var _this7 = this;

        var teachingMethodId, apiUrl, response, protocol, dataFields, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref19, _ref20, key, value, index;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.detectProtocol();

              case 2:
                teachingMethodId = _context15.sent;

                if (!teachingMethodId) {
                  _context15.next = 81;
                  break;
                }

                _context15.prev = 4;
                apiUrl = this.apiUrl;
                _context15.t0 = teachingMethodId;
                _context15.next = _context15.t0 === 1 ? 9 : _context15.t0 === 2 ? 11 : _context15.t0 === 3 ? 13 : _context15.t0 === 4 ? 15 : _context15.t0 === 5 ? 17 : _context15.t0 === 6 ? 19 : _context15.t0 === 7 ? 21 : _context15.t0 === 8 ? 23 : _context15.t0 === 9 ? 25 : _context15.t0 === 10 ? 27 : 29;
                break;

              case 9:
                apiUrl = this.apiUrl + 'dtt/';
                return _context15.abrupt('break', 29);

              case 11:
                apiUrl = this.apiUrl + 'simple/';
                return _context15.abrupt('break', 29);

              case 13:
                apiUrl = this.apiUrl + 'mand/';
                return _context15.abrupt('break', 29);

              case 15:
                apiUrl = this.apiUrl + 'vcd/';
                return _context15.abrupt('break', 29);

              case 17:
                apiUrl = this.apiUrl + 'chain/';
                return _context15.abrupt('break', 29);

              case 19:
                apiUrl = this.apiUrl + 'shaping/';
                return _context15.abrupt('break', 29);

              case 21:
                apiUrl = this.apiUrl + 'pecs-sentence-structure/';
                return _context15.abrupt('break', 29);

              case 23:
                apiUrl = this.apiUrl + 'pecs-without-discrimination/';
                return _context15.abrupt('break', 29);

              case 25:
                apiUrl = this.apiUrl + 'pecs-with-discrimination/';
                return _context15.abrupt('break', 29);

              case 27:
                apiUrl = this.apiUrl + 'pecs-features-with-items/';
                return _context15.abrupt('break', 29);

              case 29:
                _context15.next = 31;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(apiUrl + id);

              case 31:
                response = _context15.sent;
                protocol = response.data.data;
                dataFields = protocol.dataFields;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context15.prev = 37;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(dataFields)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _ref19 = _step2.value;
                  _ref20 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref19, 2);
                  key = _ref20[0];
                  value = _ref20[1];

                  if (['Отсутствует', 'No'].includes(value)) {
                    dataFields[key] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.absent');
                  } else if (!value) {
                    dataFields[key] = '';
                  }
                }

                _context15.next = 45;
                break;

              case 41:
                _context15.prev = 41;
                _context15.t1 = _context15['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context15.t1;

              case 45:
                _context15.prev = 45;
                _context15.prev = 46;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 48:
                _context15.prev = 48;

                if (!_didIteratorError2) {
                  _context15.next = 51;
                  break;
                }

                throw _iteratorError2;

              case 51:
                return _context15.finish(48);

              case 52:
                return _context15.finish(45);

              case 53:
                index = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.directories, protocol.teachingMethod);


                this.teachingMethod = this.directories[index];
                protocol.dataFields = dataFields;
                this.protocol = protocol;

                this.protocol.skillField = protocol.skillField.name;

                if (this.teachingMethod.id != 3 && this.teachingMethod.id != 7 && this.teachingMethod.id != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
                  this.orderTasks();
                }

                if (this.teachingMethod.id == 3) {
                  this.orderMands();
                }

                if (this.teachingMethod.id != 3 && this.teachingMethod.id != 7 && this.teachingMethod.id != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
                  this.reindexTasks();
                }

                if (this.protocol.teachingMethodId == 3) {
                  this.reindexMands();
                }

                if (this.protocol.teachingMethodId == 8 || this.teachingMethod.id == 8) {
                  this.getListOfTasks();
                }

                if (this.protocol.assigneeId) {
                  this.disabledTeachingMethod = true;

                  if (!(this.isMand || this.protocol.teachingMethod.id == 3)) {
                    this.globalTask = __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.protocol.globalTasks);
                  }

                  if (this.isMand || this.protocol.teachingMethod.id == 3) {
                    this.globalTask = __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.protocol.globalMandReactions);
                  }

                  if (this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 || this.isPecsWithItems || this.protocol.teachingMethod.id == 10) {
                    this.categories = __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.protocol.categories);
                  }
                }

                if ((this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 2) && !protocol.globalTasks.length) {
                  this.addTask();
                }

                if (this.teachingMethod.id == 3 && !protocol.globalMandReactions) {
                  this.addMand();
                }

                if (this.protocol.assigneeId && this.protocol.stages.length) {

                  if (this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8) {
                    this.isAllTasksEnabled = this.protocol.isAllTasksEnabled;
                  }

                  __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.stages, function (item) {

                    if (_this7.isUSD || _this7.protocol.teachingMethod.id == 4 || _this7.isChain || _this7.protocol.teachingMethod.id == 5) {
                      item.activeCount = item.stimuli.length;
                    }

                    if (_this7.isDTT || _this7.protocol.teachingMethod.id == 1) {
                      item.activeCount = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(item.tasks, 'active').length;
                    }

                    if (_this7.isMand || _this7.protocol.teachingMethod.id == 3) {
                      item.activeCount = item.mands ? item.mands.length : 0;
                    }

                    if (_this7.isChain || _this7.protocol.teachingMethod.id == 5) {
                      item.masteredCount = item.masteredStimuli ? item.masteredStimuli.length : 0;
                    }

                    if (_this7.isSimple || _this7.protocol.teachingMethod.id == 2 || _this7.isPecsWithDiscrimination || _this7.protocol.teachingMethod.id == 9 || _this7.isPecsWithItems || _this7.protocol.teachingMethod.id == 10 || _this7.isPecs || _this7.protocol.teachingMethod.id == 7 || _this7.isPecsWithoutDiscrimination || _this7.protocol.teachingMethod.id == 8) {
                      item.masteredCount = item.masteredTasks ? item.masteredTasks.length : 0;
                    }

                    if (_this7.isShaping || _this7.protocol.teachingMethod.id == 6) {
                      item.targetStimulusUuid = item.targetStimulus ? item.targetStimulus.globalUuid : null;
                    }

                    if (_this7.isMand || _this7.protocol.teachingMethod.id == 3) {
                      item.masteredCount = item.masteredMands ? item.masteredMands.length : 0;
                    }

                    if (_this7.isDTT || _this7.protocol.teachingMethod.id == 1 || _this7.isMand || _this7.protocol.teachingMethod.id == 3 || _this7.isUSD || _this7.protocol.teachingMethod.id == 4) {
                      item.fixed = item.hasAssignedStage ? item.hasAssignedStage : false;
                    } else {

                      if (_this7.protocol.status) {
                        if (_this7.protocol.status.id == 1) {
                          item.fixed = false;
                        } else {
                          item.fixed = !item.isNew;
                        }
                      }
                    }
                  });
                }

                if (this.clientId || this.protocol.assigneeId) {
                  this.getClient(this.clientId || this.protocol.assigneeId);
                }
                if (this.protocol.status) {
                  if (this.protocol.status.id != 1) {
                    this.showDeleteButton = false;
                  }
                }

                if (this.protocol.stages.length && this.protocol.stages[0].hasAssignedStage) {
                  this.showDeleteButton = false;
                }

                this.hashProtocol = __WEBPACK_IMPORTED_MODULE_9_object_hash___default.a.MD5(this.protocol);

                setTimeout(function () {
                  _this7.isEditing = true;
                }, 100);

                _context15.next = 78;
                break;

              case 74:
                _context15.prev = 74;
                _context15.t2 = _context15['catch'](4);

                console.dir(_context15.t2);
                if (_context15.t2.status == 403) {
                  this.$router.push({ name: 'client' });
                }

              case 78:
                _context15.prev = 78;

                this.isLoaded = true;
                return _context15.finish(78);

              case 81:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[4, 74, 78, 81], [37, 41, 45, 53], [46,, 48, 52]]);
      }));

      function fetchProtocol(_x6) {
        return _ref18.apply(this, arguments);
      }

      return fetchProtocol;
    }(),

    setProtocolFromTemplate: function setProtocolFromTemplate(template) {
      this.protocol.templateId = template.id;
      var dataFields = template.dataFields;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(dataFields)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref21 = _step3.value;

          var _ref22 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref21, 2);

          var key = _ref22[0];
          var value = _ref22[1];

          if (['Отсутствует'].includes(value)) {
            dataFields[key] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.absent');
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.protocol.dataFields = dataFields;
      this.protocol.stages = [];
    },

    otherFields: function otherFields(key) {
      return !this.dataFields.includes(key);
    },

    stageHaveEmptyTitle: function stageHaveEmptyTitle() {
      var isEmptyTitle = false;
      this.protocol.stages.forEach(function (item, index) {
        if (__WEBPACK_IMPORTED_MODULE_15_lodash_isUndefined___default()(item['description']) || item['description'].length < 1) {
          isEmptyTitle = true;
        }
      });

      return isEmptyTitle;
    },

    stageFocus: function stageFocus() {
      var _this8 = this;

      this.$nextTick(function () {
        var index = _this8.protocol.stages.length - 1;
        var focusStage = 'stage_' + index;
        var input = _this8.$refs[focusStage][0];
        input.focus();
      });
    },

    reindexStages: function reindexStages() {
      this.protocol.stages.forEach(function (item, index) {
        var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
        item['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
        item['title'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position;
        item['titleDescription'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position + ': ' + item['description'];
      });
    },

    reindexTasks: function reindexTasks() {
      var _this9 = this;

      if (this.protocol.globalTasks && this.protocol.globalTasks.length) {
        this.protocol.globalTasks.forEach(function (item, index) {
          var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
          item['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
          item['title'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position;
        });
      }

      if (this.protocol.stages && this.protocol.stages.length) {
        this.protocol.stages.forEach(function (item) {
          if (_this9.isShaping || _this9.isChain) {
            item.stimuli.forEach(function (task, index) {
              var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
              task['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
              task['title'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position;
            });
          } else {

            item.tasks.forEach(function (task, index) {
              var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
              task['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
              task['title'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position;
            });
          }
        });
      }
    },

    hintListActivate: function hintListActivate() {
      this.protocol.stages.forEach(function (item, index) {

        if (item.taskPrompts) {
          if (item.taskPrompts[2].active || item.taskPrompts[3].active || item.taskPrompts[4].active || item.taskPrompts[5].active) {
            item.taskPrompts[1].active = false;
          }
        }
      });
    },

    reindexMands: function reindexMands() {
      if (this.protocol.globalMandReactions && this.protocol.globalMandReactions.length) {
        this.protocol.globalMandReactions.forEach(function (item, index) {
          var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
          item['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
          //item['title'] =  lang.get('protocol.stimulus') + ' ' +  parseInt(index);
        });
      }

      if (this.protocol.stages && this.protocol.stages.length) {
        this.protocol.stages.forEach(function (item) {
          item.mands.forEach(function (task, index) {
            var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index) + 1;
            task['position'] = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
            task['title'] = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(index);
          });
        });
      }
    },

    masteredStimuliList: function masteredStimuliList() {
      var _this10 = this;

      this.protocol.stages.forEach(function (item, index) {

        var masteredStimuli = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(item.tasks, function (item) {

          if (_this10.selectedTeachingMethod && _this10.selectedTeachingMethod.id == 8 || _this10.teachingMethod && _this10.teachingMethod.id == 8) {
            return !_this10.protocol.isAllTasksEnabled && (item.position == 3 || item.position == 4) && item.mastered || _this10.protocol.isAllTasksEnabled && item.mastered;
          } else {
            return item.mastered;
          }
        });

        _this10.$set(_this10.protocol.stages[index], 'masteredStimuli', masteredStimuli);
        _this10.$set(_this10.protocol.stages[index], 'masteredTasks', masteredStimuli);
      });
    },

    criteriaPecsDescriptionChanged: function criteriaPecsDescriptionChanged() {
      var _this11 = this;

      this.protocol.stages.forEach(function (item, index) {

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(item.tasks, function (task) {

          var currentCategory = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(_this11.protocol.categories, function (category) {
            return task.categoryUuid === category.uuid;
          })[0];
          var currentTask = currentCategory ? __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(currentCategory.tasks, function (taskCategory) {
            return taskCategory.uuid === task.globalUuid;
          })[0] : null;

          task.description = currentTask ? currentTask.description : task.description;
        });

        var masteredStimuli = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(item.tasks, function (item) {
          return item.mastered;
        });

        _this11.$set(_this11.protocol.stages[index], 'masteredStimuli', masteredStimuli);
        _this11.$set(_this11.protocol.stages[index], 'masteredTasks', masteredStimuli);
      });
    },

    orderTasks: function orderTasks() {
      __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default()(this.protocol.globalTasks, 'position');
      this.protocol.stages.forEach(function (item) {
        item.tasks = __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default()(item.tasks, 'position');
      });
    },

    orderMands: function orderMands() {
      __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default()(this.protocol.globalMandReactions, 'position');
      this.protocol.stages.forEach(function (item) {
        item.mands = __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default()(item.mands, 'position');
      });
    },

    addStage: function addStage() {
      var newProtocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setIsChanged(true);
      if (!this.stageHaveEmptyTitle()) {
        this.protocol.stages.push(this.newStage());
      }

      if (this.teachingMethod.id == 3 && !this.protocol.globalMandReactions) {
        this.$set(this.protocol, 'globalMandReactions', []);
        //this.protocol.globalMandReactions = [];
        this.addMand();
      }

      if ((this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 5 || this.teachingMethod.id == 2) && (!this.protocol.globalTasks || !this.protocol.globalTasks.length)) {
        this.$set(this.protocol, 'globalTasks', []);
        //this.protocol.globalTasks = [];
        this.addTask();
      }

      if (!newProtocol) this.stageFocus();
      this.changeCanPublish();
      return true;
    },

    duplicateStage: function duplicateStage(stage) {
      this.setIsChanged(true);
      this.changeCanPublish();
      var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.stages.length) + 1;
      var newStage = __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(stage);
      newStage.id = null;
      newStage.position = position;

      newStage.isNew = true;
      newStage.isClosed = false;
      newStage.hasAssignedStage = false;
      newStage.changed = true;
      newStage.uuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
      newStage.description = stage.description + ' - ' + position + ' (' + __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.copy') + ')';
      newStage.title = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position;
      newStage.titleDescription = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position;

      if (this.teachingMethod.id != 3 && this.teachingMethod.id != 4) {

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(newStage.tasks, function (task) {
          task.id = null;
          task.phaseId = null;
          task.stageId = null;
          task.isNew = true;
          task.uuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
        });
      }

      if (this.teachingMethod.id == 1) {

        newStage.changed = newStage.isNew ? newStage.changed : true;

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(newStage.phases, function (phase) {
          phase.id = null;
          phase.stageId = null;
          phase.phaseId = null;
        });

        var intervals = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(newStage.phases, function (item) {
          return item.typeId == 3;
        })[0].intervals;

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(intervals, function (interval) {
          interval.id = null;
          interval.phaseId = null;
          if (!interval.typeId) {
            interval.typeId = 1;
          }
        });
      }

      if (this.teachingMethod.id == 4) {

        var _intervals = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(newStage.phases, function (item) {
          return item.typeId == 3;
        })[0].intervals;

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(_intervals, function (interval) {
          interval.id = null;
          interval.phaseId = null;
          if (!interval.typeId) {
            interval.typeId = 1;
          }
        });

        var levels = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(newStage.phases, function (item) {
          return item.typeId == 5;
        })[0].levels;

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(levels, function (level) {
          var levelUiid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
          var tasks = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(newStage.stimuli, function (item) {
            return item.levelUuid == level.uuid;
          });

          __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(tasks, function (task) {
            task.id = null;
            task.levelUuid = levelUiid;
          });

          level.uuid = levelUiid;

          __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(level.groups, function (group) {
            var groupUiid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
            var tasks = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(newStage.stimuli, function (item) {
              return item.levelGroupUuid == group.uuid;
            });

            __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(tasks, function (task) {
              task.id = null;
              task.levelGroupUuid = groupUiid;
            });

            group.uuid = groupUiid;
          });
        });

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(newStage.stimuli, function (task) {
          task.id = null;
          //task.levelUuid = UuidGenerator.v4();
          //task.levelGroupUuid = UuidGenerator.v4();
        });
      }

      this.protocol.stages.push(newStage);
    },

    newStage: function newStage() {
      this.setIsChanged(true);
      var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.stages.length) + 1;
      var globalTasks = [];
      var globalMandReactions = [];
      var uuidStage = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4().toString();

      if (this.teachingMethod.id != 3) {
        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.globalTasks, function (item) {
          globalTasks.push({
            globalTaskId: item.id,
            id: null,
            isNew: true,
            changed: false,
            position: item.position,
            active: true,
            phaseType: 1,
            description: item.description,
            fieldIndex: 1,
            title: item.title,
            uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
            globalUuid: item.uuid
          });
        });
      }

      var recordedReactionsList = [];

      if (this.teachingMethod.id == 3) {
        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.globalMandReactions, function (item) {
          globalMandReactions.push({
            position: item.position,
            description: item.description,
            globalUuid: item.uuid,
            isNew: true
          });
        });

        var recordedReactions = this.taskTypesMand[0].answers;

        recordedReactionsList = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()(recordedReactions, function (reactions) {
          return reactions.id;
        });
      }

      return {
        id: null,
        uuid: uuidStage,
        position: __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.stages.length),
        title: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position,
        titleDescription: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stage') + ' ' + position,
        description: '',
        attemptCount: '10',
        tasks: globalTasks,
        stimuli: globalTasks,
        type: null,
        mands: globalMandReactions,
        isNew: true,
        isPromptEnabled: false,
        taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
        recordedReactions: recordedReactionsList,
        masteringCondition: this.teachingMethod.id == 3 || this.isMand || this.teachingMethod.id == 5 || this.isChain || this.teachingMethod.id == 6 || this.isShaping ? {
          ratio: 100,
          trialCount: 3,
          sessionCount: 1,
          answerDirectory: { id: 1 }
        } : null,
        phases: this.teachingMethod.id == 1 ? [{
          typeId: 1,
          transferCondition: {
            id: null
          },
          minFieldCount: '2',
          maxFieldCount: '8',
          taskType: null,
          active: true,
          withFields: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation)
        }, {
          typeId: 2,
          transferCondition: {
            id: null
          },
          minFieldCount: '2',
          maxFieldCount: '8',
          taskType: null,
          active: true,
          withFields: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation)
        }, {
          typeId: 4,
          transferCondition: {
            id: null
          },
          minFieldCount: '2',
          maxFieldCount: '8',
          taskType: null,
          active: true,
          withFields: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation)
        }, {
          typeId: 3,
          intervals: [],
          active: true
        }] : this.teachingMethod.id == 4 ? [{
          typeId: 5,
          masteringConditions: {
            nextLevel: {
              ratio: 90,
              blockCount: 9
            },
            previousLevel: {
              ratio: 90,
              blockCount: 9
            },
            nextPhase: {
              ratio: 90,
              blockCount: 9
            }

          },
          minFieldCount: '2',
          maxFieldCount: '8',
          taskType: null,
          active: true,
          withFields: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
          levels: [{
            "uuid": __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
            "description": __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.delay_none'),
            "index": 1
          }, {
            "uuid": __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
            "description": __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.delay', { sec: 2 }),
            "index": 2
          }, {
            "uuid": __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
            "description": __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.delay', { sec: 4 }),
            "index": 3
          }]
        }, {
          typeId: 3,
          intervals: [],
          active: true
        }] : ''
      };
    },

    removeStage: function removeStage(index) {
      this.setIsChanged(true);
      try {
        if (index !== -1) {
          this.protocol.stages.splice(index, 1);
          this.reindexStages();
        }

        this.changeCanPublish();
      } catch (error) {
        console.dir(error);
        return false;
      }

      return true;
    },

    editProtocol: function () {
      var _ref23 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var published = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.saveProtocol(true, published);

              case 1:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function editProtocol() {
        return _ref23.apply(this, arguments);
      }

      return editProtocol;
    }(),

    createProtocol: function () {
      var _ref24 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var published = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.saveProtocol(false, published);

              case 1:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function createProtocol() {
        return _ref24.apply(this, arguments);
      }

      return createProtocol;
    }(),
    saveAndAllowMensuration: function () {
      var _ref25 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.protocol.isMensurationAllowed = true;
                this.saveProtocol(true, true);

              case 2:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function saveAndAllowMensuration() {
        return _ref25.apply(this, arguments);
      }

      return saveAndAllowMensuration;
    }(),
    isEmptyLastStage: function isEmptyLastStage() {
      var lastIndex = this.protocol.stages.length - 1;
      if (lastIndex > 0) {
        return this.protocol.stages[lastIndex].description.length < 1 && this.protocol.stages[lastIndex].tasks.length < 1;
      }
      return false;
    },

    stageLastIndex: function stageLastIndex() {
      return this.protocol.stages.length - 1;
    },

    handleValidationErrorAdvanced: function handleValidationErrorAdvanced() {
      var firstField = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errors.collect())[0];
      if (this.$refs['' + firstField]) {
        if (this.$refs['' + firstField].$el) {
          this.$refs['' + firstField].$el.scrollIntoView();
        } else if (this.$refs['' + firstField][0]) {
          this.$refs['' + firstField][0].$el.scrollIntoView();
        } else {
          this.$refs['' + firstField].scrollIntoView();
        }
      }
    },
    setTransferCondition: function setTransferCondition(condition, conditionValue) {

      if (condition.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
        condition['trialCount'] = conditionValue.trialCount;
      } else if (condition.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
        condition['sessionCount'] = conditionValue.sessionCount;
      } else if (condition.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO) {
        condition['ratio'] = conditionValue.ratio;
        condition['trialCount'] = conditionValue.conditionTrial;
        condition['sessionCount'] = conditionValue.conditionSession;
      }
    },
    getTransferCondition: function getTransferCondition(condition, conditionValue) {

      if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
        condition.trialCount = conditionValue.trialCount;
      } else if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
        condition.sessionCount = conditionValue.sessionCount;
      } else if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO) {
        condition.ratio = conditionValue.ratio;
        condition.conditionTrial = conditionValue.trialCount;
        condition.conditionSession = conditionValue.sessionCount;
      }
    },
    changedTeachingMethod: function changedTeachingMethod() {
      this.teachingMethod = this.selectedTeachingMethod;
      this.protocol.teachingMethodId = this.selectedTeachingMethod.id;
      this.protocol.teachingMethod = this.selectedTeachingMethod;
      this.protocol.dataFields.teachingMethod = this.selectedTeachingMethod.name;
      this.$set(this.protocol, 'stages', []);

      if (this.teachingMethod.id != 3) {
        this.$set(this.protocol, 'globalTasks', []);
      } else {
        this.$set(this.protocol, 'globalMandReactions', []);
      }

      if (this.selectedTeachingMethod.id == 7 || this.teachingMethod.id == 7 || this.selectedTeachingMethod.id == 8 || this.teachingMethod.id == 8) {
        this.addPecsStages();
      } else {
        this.$set(this.protocol, 'teachingMethodDescription', "");
        this.$set(this.protocol, 'skillField', "");
        this.protocol.stages.push(this.newStage());
        this.addPecsStages();
      }

      if (this.selectedTeachingMethod.id == 9 || this.teachingMethod.id == 9 || this.selectedTeachingMethod.id == 10 || this.teachingMethod.id == 10) {
        this.addPecsWithDiscriminationStages();
      }

      if (this.selectedTeachingMethod.id == 1) {
        this.selectedTeachingMethodID = this.selectedTeachingMethod.id;
        this.rotationTransferCondition = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
        this.fluencyTransferCondition = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
        this.masteringTransferCondition = __WEBPACK_IMPORTED_MODULE_12__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
        this.addTask();
      } else {
        this.selectedTeachingMethodID = this.selectedTeachingMethod.id;
      }

      if (this.selectedTeachingMethod.id == 3) {
        this.addMand();
      }

      if (this.selectedTeachingMethod.id == 4 || this.selectedTeachingMethod.id == 6 || this.selectedTeachingMethod.id == 2 || this.selectedTeachingMethod.id == 5) {
        this.addTask();
      }
    },
    accept: function accept() {
      this.toggleConfirmChangeModal();
      this.changedTeachingMethod();
    },
    toggleConfirmChangeModal: function toggleConfirmChangeModal() {
      this.isOpen = !this.isOpen;
      this.isEditing = true;
    },
    cancel: function cancel() {
      var _this12 = this;

      var method = this.directories[__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.directories, this.protocol.teachingMethod)];
      this.isEditing = false;
      this.teachingMethod = method;
      this.selectedTeachingMethodID = this.teachingMethod.id;
      this.protocol.dataFields.teachingMethod = this.teachingMethod.name;

      setTimeout(function () {
        _this12.toggleConfirmChangeModal();
      }, 100);
    },


    validateAllStage: function () {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var validateStimulList, validateStages, validateCountStages, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                validateStimulList = true;
                validateStages = true;
                validateCountStages = true;
                _context19.next = 5;
                return this.validateForm();

              case 5:
                result = _context19.sent;

                if (!(this.teachingMethod.id == 1 || this.isDTT || this.teachingMethod.id == 4 || this.isUSD || this.teachingMethod.id == 6 || this.isShaping)) {
                  _context19.next = 11;
                  break;
                }

                _context19.next = 9;
                return this.validateStages();

              case 9:
                validateStages = _context19.sent;

                this.errorStages = validateStages;

              case 11:
                if (!(this.teachingMethod.id == 2 || this.isSimple)) {
                  _context19.next = 16;
                  break;
                }

                _context19.next = 14;
                return this.validateStimul();

              case 14:
                validateStages = _context19.sent;

                this.errorStages = validateStages;

              case 16:
                if (!(this.teachingMethod.id == 3 || this.isMand)) {
                  _context19.next = 21;
                  break;
                }

                _context19.next = 19;
                return this.validateMand();

              case 19:
                validateStimulList = _context19.sent;

                this.reindexMands();

              case 21:

                this.errorStagesCount = this.protocol.stages.length;

                return _context19.abrupt('return', result && validateStimulList && validateStages && this.errorStagesCount);

              case 23:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function validateAllStage() {
        return _ref26.apply(this, arguments);
      }

      return validateAllStage;
    }(),

    postProtocol: function () {
      var _ref27 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var _this13 = this;

        var validateError, isSaved, url;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.disabled = true;
                this.isLoaded = false;
                if (this.teachingMethod.id != 9 && this.teachingMethod.id != 8 && this.teachingMethod.id != 10) {
                  this.reindexStages();
                }
                this.setPublished(this.published);

                _context20.next = 6;
                return this.validateAllStage();

              case 6:
                validateError = _context20.sent;

                if (!validateError) {
                  _context20.next = 56;
                  break;
                }

                this.setIsChanged(false);

                isSaved = false;


                if (this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 5) {
                  this.protocol.isNew = this.isNew;
                  this.reindexTasks();
                }

                if (this.teachingMethod.id == 7) {
                  this.changePecsStages();
                  this.masteredStimuliList();
                }

                if (this.teachingMethod.id == 8) {
                  this.masteredStimuliList();
                }

                if (this.teachingMethod.id == 9 || this.teachingMethod.id == 10) {
                  this.criteriaPecsDescriptionChanged();
                }

                this.hintListActivate();

                _context20.prev = 15;
                url = void 0;
                _context20.t0 = this.teachingMethod.id;
                _context20.next = _context20.t0 === 1 ? 20 : _context20.t0 === 2 ? 22 : _context20.t0 === 3 ? 24 : _context20.t0 === 4 ? 26 : _context20.t0 === 5 ? 28 : _context20.t0 === 6 ? 30 : _context20.t0 === 7 ? 32 : _context20.t0 === 8 ? 34 : _context20.t0 === 9 ? 36 : _context20.t0 === 10 ? 38 : 40;
                break;

              case 20:
                url = this.apiUrl + 'dtt/';
                return _context20.abrupt('break', 40);

              case 22:
                url = this.apiUrl + 'simple/';
                return _context20.abrupt('break', 40);

              case 24:
                url = this.apiUrl + 'mand/';
                return _context20.abrupt('break', 40);

              case 26:
                url = this.apiUrl + 'vcd/';
                return _context20.abrupt('break', 40);

              case 28:
                url = this.apiUrl + 'chain/';
                return _context20.abrupt('break', 40);

              case 30:
                url = this.apiUrl + 'shaping/';
                return _context20.abrupt('break', 40);

              case 32:
                url = this.apiUrl + 'pecs-sentence-structure/';
                return _context20.abrupt('break', 40);

              case 34:
                url = this.apiUrl + 'pecs-without-discrimination/';
                return _context20.abrupt('break', 40);

              case 36:
                url = this.apiUrl + 'pecs-with-discrimination/';
                return _context20.abrupt('break', 40);

              case 38:
                url = this.apiUrl + 'pecs-features-with-items/';
                return _context20.abrupt('break', 40);

              case 40:
                if (!(this.update || this.protocol.id)) {
                  _context20.next = 47;
                  break;
                }

                this.protocol.id = this.protocolId ? this.protocolId : this.protocol.id;

                _context20.next = 44;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url + this.protocol.id, this.protocol);

              case 44:
                isSaved = _context20.sent;
                _context20.next = 50;
                break;

              case 47:
                _context20.next = 49;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, this.protocol);

              case 49:
                isSaved = _context20.sent;

              case 50:

                if (isSaved) {
                  if (this.protocol.assigneeId) {
                    this.$router.push({
                      name: 'client-edit',
                      params: { clientId: this.protocol.assigneeId }
                    });
                  } else {
                    this.$router.push({ name: 'protocols' });
                  }
                }
                _context20.next = 56;
                break;

              case 53:
                _context20.prev = 53;
                _context20.t1 = _context20['catch'](15);

                console.dir(_context20.t1);

              case 56:
                this.disabled = false;
                this.isLoaded = true;
                if (!this.errorStages || !this.errorStagesCount) {
                  setTimeout(function () {
                    _this13.$refs.stages.scrollIntoView();
                  }, 100);
                }

              case 59:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this, [[15, 53]]);
      }));

      function postProtocol() {
        return _ref27.apply(this, arguments);
      }

      return postProtocol;
    }(),

    onChangeRemovedCategoryCount: function onChangeRemovedCategoryCount() {
      this.countRemovedCategory++;
    },

    saveProtocol: function () {
      var _ref28 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var _this14 = this;

        var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var published = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var validateError, newTask;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                /*if (this.isEmptyLastStage()) {
                  this.removeStage(this.stageLastIndex());
                }*/

                this.update = update;
                this.published = published;

                if (this.teachingMethod.id == 9 || this.teachingMethod.id == 10) {
                  this.criteriaPecsDescriptionChanged();
                }

                if (this.teachingMethod.id == 8 || this.teachingMethod.id == 7) {
                  this.masteredStimuliList();
                }

                if (!(this.protocol.assigneeId && !this.protocol.isOnIndividualization)) {
                  _context21.next = 11;
                  break;
                }

                _context21.next = 7;
                return this.validateAllStage();

              case 7:
                validateError = _context21.sent;

                if (validateError) {
                  newTask = void 0;


                  if (this.isDTT || this.protocol.teachingMethod.id == 1 || this.isUSD || this.protocol.teachingMethod.id == 4 || this.isChain || this.protocol.teachingMethod.id == 5 || this.isSimple || this.protocol.teachingMethod.id == 2 || this.isShaping || this.protocol.teachingMethod.id == 6) {
                    newTask = this.protocol.globalTasks;
                  }

                  if (this.isMand || this.protocol.teachingMethod.id == 3) {
                    newTask = this.protocol.globalMandReactions;
                  }

                  if (this.isDTT || this.protocol.teachingMethod.id == 1 || this.isUSD || this.protocol.teachingMethod.id == 4 || this.isChain || this.protocol.teachingMethod.id == 5 || this.isSimple || this.protocol.teachingMethod.id == 2 || this.isShaping || this.protocol.teachingMethod.id == 6 || this.isMand || this.protocol.teachingMethod.id == 3) {

                    if (!__WEBPACK_IMPORTED_MODULE_45_lodash_isEqual___default()(newTask, this.globalTask)) {
                      this.disabledNotImportantChanges = true;
                    }
                  }

                  if (this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 || this.isPecsWithItems || this.protocol.teachingMethod.id == 10) {

                    if (this.countRemovedCategory) {
                      this.disabledNotImportantChanges = true;
                    }

                    __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.categories, function (category) {

                      var currentCategory = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(_this14.categories, function (item) {
                        return item.uuid === category.uuid;
                      })[0];

                      if (currentCategory) {

                        if (_this14.isPecsWithDiscrimination || _this14.protocol.teachingMethod.id == 9) {
                          if (category.currentStage.uuid !== currentCategory.currentStage.uuid) {
                            _this14.disabledNotImportantChanges = true;
                          }
                        }

                        var notNewTasks = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(category.tasks, function (task) {
                          return !task.isNew;
                        });

                        if (+notNewTasks.length < +currentCategory.tasks.length) {
                          _this14.disabledNotImportantChanges = true;
                        }
                      }
                    });
                  }

                  if (this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8) {

                    if (this.isAllTasksEnabled !== this.protocol.isAllTasksEnabled) {
                      this.disabledNotImportantChanges = true;
                    }
                  }

                  __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.stages, function (item) {

                    if (_this14.isUSD || _this14.protocol.teachingMethod.id == 4 || _this14.isChain || _this14.protocol.teachingMethod.id == 5) {

                      if (item.activeCount !== item.stimuli.length) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isDTT || _this14.protocol.teachingMethod.id == 1) {
                      var tesksCount = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(item.tasks, 'active').length;
                      if (item.activeCount !== tesksCount) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isMand || _this14.protocol.teachingMethod.id == 3) {
                      if (item.activeCount !== item.mands.length) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isChain || _this14.protocol.teachingMethod.id == 5) {
                      if (item.masteredCount && item.masteredStimuli && item.masteredCount !== item.masteredStimuli.length) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isMand || _this14.protocol.teachingMethod.id == 3) {
                      if (item.masteredCount && item.masteredCount !== item.masteredMands.length) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isSimple || _this14.protocol.teachingMethod.id == 2 || _this14.isPecsWithItems || _this14.protocol.teachingMethod.id == 10 || _this14.isPecsWithDiscrimination || _this14.protocol.teachingMethod.id == 9 || _this14.isPecs || _this14.protocol.teachingMethod.id == 7 || _this14.isPecsWithoutDiscrimination || _this14.protocol.teachingMethod.id == 8) {

                      if (item.masteredTasks && item.masteredCount !== item.masteredTasks.length) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isShaping || _this14.protocol.teachingMethod.id == 6) {
                      if (item.targetStimulus.globalUuid !== item.targetStimulusUuid) {
                        _this14.disabledNotImportantChanges = true;
                      }
                    }

                    if (_this14.isPecsWithItems || _this14.protocol.teachingMethod.id == 10) {

                      item.type = _this14.allTaskTypes.filter(function (item) {
                        return item.id == 1;
                      })[0];
                    }
                  });

                  this.disabledTeachingMethod = true;
                  this.changedSavePopup = true;
                }

                _context21.next = 12;
                break;

              case 11:
                this.postProtocol();

              case 12:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function saveProtocol() {
        return _ref28.apply(this, arguments);
      }

      return saveProtocol;
    }(),

    selectChangeValue: function selectChangeValue(field) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.protocol.dataFields[field]) === 'object') {
        this.protocol.dataFields[field] = this.protocol.dataFields[field].name;
        this.protocol.dataFields['teahingMethodId'] = this.protocol.dataFields[field].id;
        this.setIsChanged(true);
      }
    },

    setPublished: function setPublished() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.protocol.published = value;
    },

    showTasks: function () {
      var _ref29 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22(task) {
        var input;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:

                if (this.$refs['task_0']) {

                  if (this.$refs['task_0'][0]) {
                    input = this.$refs['task_0'][0];

                    input.blur();
                  }
                }

                this.$nextTick(function () {
                  var _this15 = this;

                  this.taskIntervalId = window.setInterval(function () {
                    if (_this15.isChangedTask) {
                      _this15.showStagesTask(task);
                      clearInterval(_this15.taskIntervalId);
                    }
                  }, 100);
                });

              case 2:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function showTasks(_x13) {
        return _ref29.apply(this, arguments);
      }

      return showTasks;
    }(),

    showMands: function () {
      var _ref30 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23(mand) {
        var input;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:

                if (this.$refs['task_0']) {

                  if (this.$refs['task_0'][0]) {
                    input = this.$refs['task_0'][0];

                    input.blur();
                  }
                }

                this.$nextTick(function () {
                  var _this16 = this;

                  this.mandIntervalId = window.setInterval(function () {
                    if (_this16.isChangedMand) {
                      _this16.showStagesMand(mand);
                      clearInterval(_this16.mandIntervalId);
                    }
                  }, 100);
                });

              case 2:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function showMands(_x14) {
        return _ref30.apply(this, arguments);
      }

      return showMands;
    }(),

    showStagesTask: function () {
      var _ref31 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24(task) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!this.isPecsWithoutDiscrimination && !this.isPecsWithDiscrimination) {
                  this.reindexStages();
                }
                this.validate();
                _context24.next = 4;
                return this.validateForm();

              case 4:
                result = _context24.sent;

                if (result) {
                  _context24.next = 7;
                  break;
                }

                return _context24.abrupt('return');

              case 7:

                this.selectedStagesTitle = task.title;

                if (this.isDTT) {

                  this.listTasksDTT = true;
                }
                if (this.isSimple) {

                  this.listTasks = true;
                }
                if (this.isUSD) {

                  this.listTasksUSD = true;
                }
                if (this.isChain) {

                  this.listTasksChain = true;
                }
                if (!this.isMand) {

                  if (task.tasks.length && this.listTasksDTT) {

                    this.selectedTaskTypeTitle = this.getTaskTypeTitle(task.tasks[0].typeId);
                  }
                  if (task.tasks.length && this.listTasks && task.tasks[0].typeId !== 1 && task.tasks[0].typeId !== 2) {

                    this.selectedTaskTypeTitle = this.getTaskTypeTitle(task.tasks[0].typeId);
                  }
                }

                if (this.isShaping) {
                  this.listTasksShaping = true;
                }

                if (this.isPecsWithDiscrimination) {
                  this.listTasksPecsWithDiscrimination = true;
                }

                this.$nextTick(function () {
                  __WEBPACK_IMPORTED_MODULE_8_jquery___default()('html,body').animate({ scrollTop: 0 }, 500);
                });

              case 16:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function showStagesTask(_x15) {
        return _ref31.apply(this, arguments);
      }

      return showStagesTask;
    }(),

    showStagesMand: function () {
      var _ref32 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25(mand) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                this.reindexStages();
                this.validate();
                _context25.next = 4;
                return this.validateForm();

              case 4:
                result = _context25.sent;

                if (result) {
                  _context25.next = 7;
                  break;
                }

                return _context25.abrupt('return');

              case 7:

                this.selectedStagesTitle = mand.title;
                this.listTasksMand = true;

                this.$nextTick(function () {
                  __WEBPACK_IMPORTED_MODULE_8_jquery___default()('html,body').animate({ scrollTop: 0 }, 500);
                });

              case 10:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function showStagesMand(_x16) {
        return _ref32.apply(this, arguments);
      }

      return showStagesMand;
    }(),

    hideTasks: function hideTasks() {
      var _this17 = this;

      if (this.isDTT) {
        this.listTasksDTT = false;
      } else if (this.isUSD) {
        this.listTasksUSD = false;
      } else if (this.isChain) {
        this.listTasksChain = false;
      } else if (this.isShaping) {
        this.listTasksShaping = false;
      }if (this.isPecsWithDiscrimination) {
        this.listTasksPecsWithDiscrimination = false;
      } else {
        this.listTasks = false;
      }

      this.disabled = false;
      this.errors.clear();
      this.validateStimuls = true;
      this.validateCheckList = true;
      this.changeCanPublish();
      this.validatorTaskAdd();

      setTimeout(function () {
        if (_this17.$refs['stage_0']) {
          _this17.$refs['stage_0'][0].$el.scrollIntoView();
        }
      }, 200);
    },

    hideMands: function hideMands() {
      var _this18 = this;

      this.listTasksMand = false;
      this.disabled = false;
      this.errors.clear();
      this.changeCanPublish();

      setTimeout(function () {
        _this18.$refs['stage_0'][0].$el.scrollIntoView();
      }, 200);
    },

    loadProtocol: function () {
      var _ref33 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this.isNew = false;
                _context26.next = 3;
                return this.fetchProtocol(this.protocolId);

              case 3:
                this.isLoaded = true;
                this.changeCanPublish();
                this.setIsChanged(false);

              case 6:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function loadProtocol() {
        return _ref33.apply(this, arguments);
      }

      return loadProtocol;
    }(),

    loadFromTemplate: function () {
      var _ref34 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee27() {
        var _this19 = this;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.isNew = true;

                this.selectedTeachingMethodID = this.directories[0].id;
                this.teachingMethod = this.directories[0];
                this.protocol.teachingMethod = this.directories[0];
                this.protocol.teachingMethodId = this.directories[0].id;

                _context27.next = 7;
                return this.fetchTemplates();

              case 7:
                this.setProtocolFromTemplate(this.templates[0]);
                this.addStage(true);
                this.changeCanPublish();
                this.setIsChanged(false);
                setTimeout(function () {
                  _this19.isEditing = true;
                }, 100);
                this.isLoaded = true;
                /*if ((this.protocol.teachingMethodId = 1) || (this.teachingMethod.id = 1)) {
                  //this.addTask();
                }*/

              case 13:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function loadFromTemplate() {
        return _ref34.apply(this, arguments);
      }

      return loadFromTemplate;
    }(),

    getTaskTypeTitle: function getTaskTypeTitle(taskTypeId) {
      var taskTypeTitle = '';
      var taskType = this.taskTypes.filter(function (taskType) {
        return taskType.id === taskTypeId;
      });

      if (Array.isArray(taskType) && !__WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty___default()(taskType)) {
        taskTypeTitle = taskType.shift().title;
      }

      return taskTypeTitle;
    },

    toLocaleDateTimeTimezone: function toLocaleDateTimeTimezone(date) {
      var dateTime = new Date(date);
      var dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_35__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;

      return __WEBPACK_IMPORTED_MODULE_34_moment___default()(dateWithTimezone).format('DD.MM.YYYY HH:mm');
    },


    changeCanPublish: function changeCanPublish() {
      var _this20 = this;

      var publish = true;
      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (value, key) {
        if (!_this20.isMand && !_this20.isShaping && !_this20.isChain) {
          if (value.tasks.length === 0) {
            publish = false;
          }
        }

        if (_this20.isShaping || _this20.isChain) {
          if (value.stimuli.length === 0) {
            publish = false;
          }
        }

        if (_this20.isMand) {
          if (!_this20.protocol.globalMandReactions) {
            _this20.$set(_this20.protocol, 'globalMandReactions', []);
            //this.protocol.globalMandReactions = [];
          }
          if (_this20.protocol.globalMandReactions.length === 0) {
            publish = false;
          }
        }
      });

      this.canPublish = publish;
    },

    addTask: function addTask() {
      var _this21 = this;

      this.setIsChanged(false);
      this.currentStageIndex = 0;
      this.protocol.stages[0].isNew = true;
      var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.globalTasks.length) + 1;
      var uuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();

      if (!this.protocol.globalTasks.length) {
        this.$set(this.protocol, 'globalTasks', []);
      }

      this.$set(this.protocol.globalTasks, position - 1, {
        'id': null,
        'typeId': 1,
        'position': position,
        'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
        'description': '',
        'isNew': true,
        'active': true,
        'uuid': uuid
      });

      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (value) {
        if (!value.isClosed) {

          if (_this21.isUSD || _this21.isChain || _this21.isShaping) {

            var stimPositon = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(value.stimuli.length) + 1;
            _this21.$set(value.stimuli, stimPositon - 1, {
              'id': null,
              'globalTaskId': null,
              'position': stimPositon,
              'phaseType': 1,
              'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + stimPositon,
              'description': '',
              'isNew': true,
              'active': true,
              'uuid': __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
              'globalUuid': uuid,
              'target': false
            });

            if (_this21.isShaping && _this21.protocol.globalTasks.length === 1) {
              if (!value.targetStimulus) {
                value.targetStimulus = {};
                _this21.$set(value.targetStimulus, 'globalUuid', uuid);
              }
            }
          } else {

            var tasksPositon = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(value.tasks.length) + 1;

            _this21.$set(value.tasks, tasksPositon - 1, {
              'id': null,
              'globalTaskId': null,
              'typeId': _this21.isDTT ? __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(value.phases, function (item) {
                return item.active;
              })[0].typeId : null,
              'position': tasksPositon,
              'fieldIndex': _this21.isDTT ? __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(value.phases, function (item) {
                return item.active;
              })[0].minFieldCount : null,
              'phaseType': 1,
              'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + tasksPositon,
              'description': '',
              'isNew': true,
              'active': true,
              'uuid': __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
              'globalUuid': uuid
            });
          }
        }
      });

      if (position != 1) {

        var focusTask = 'task_' + (position - 1);
        setTimeout(function () {
          var input = _this21.$refs[focusTask][0];
          input.focus();
        }, 100);
      }
    },

    addMand: function addMand() {
      var _this22 = this;

      this.setIsChanged(false);
      this.currentStageIndex = 0;
      this.protocol.stages[0].isNew = true;
      if (!this.protocol.globalMandReactions) {
        this.$set(this.protocol, 'globalMandReactions', []);
        //this.protocol.globalMandReactions = [];
      }
      var position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.globalMandReactions.length) + 1;
      var uuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();

      /*this.protocol.globalMandReactions.push({
        'id': null,
        'position': position,
        'title': lang.get('protocol.mands') + ' ' + position,
        'description': '',
        'uuid': uuid
      });*/

      this.$set(this.protocol.globalMandReactions, position - 1, {
        'id': null,
        'position': position,
        'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.mands') + ' ' + uuid,
        'description': '',
        'uuid': uuid,
        'isNew': true
      });

      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (value) {
        if (!value.isClosed) {
          value.mands.push({
            'position': position,
            'globalUuid': uuid,
            'isNew': true
          });
        }
      });

      if (position != 1) {

        var focusMand = 'task_' + (position - 1);
        setTimeout(function () {
          var input = _this22.$refs[focusMand][0];
          input.focus();
        }, 100);
      }
    },

    setStageMandDescription: function () {
      var _ref35 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee28() {
        var _this23 = this;

        var position, validation, task_input, focusTask;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.globalMandReactions.length) + 1;
                validation = true;

                if (!(position != 1)) {
                  _context28.next = 10;
                  break;
                }

                task_input = 'task_' + (position - 2);
                _context28.next = 6;
                return this.$validator.validateAll();

              case 6:
                validation = _context28.sent;
                _context28.next = 9;
                return this.$validator.validate(task_input);

              case 9:
                validation = _context28.sent;

              case 10:

                if (validation) {
                  this.setIsChanged(true);
                  this.changeCanPublish();
                } else {
                  focusTask = 'task_' + (position - 2);

                  setTimeout(function () {
                    var input = _this23.$refs[focusTask][0];
                    input.focus();
                  }, 100);
                }

              case 11:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function setStageMandDescription() {
        return _ref35.apply(this, arguments);
      }

      return setStageMandDescription;
    }(),

    setStageTaskDescription: function () {
      var _ref36 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee29(task) {
        var _this24 = this;

        var position, validation, task_input, stagesLenght, focusTask;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.globalTasks.length) + 1;
                validation = true;

                if (!(position != 1)) {
                  _context29.next = 7;
                  break;
                }

                task_input = 'task_' + (position - 2);
                _context29.next = 6;
                return this.$validator.validate(task_input);

              case 6:
                validation = _context29.sent;

              case 7:
                this.isChangedTask = false;
                stagesLenght = this.protocol.stages.length;


                __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (stage, index) {

                  var taskName = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.tasks, function (value) {
                    return value.globalUuid == task.uuid;
                  });
                  if (taskName.length) {
                    taskName[0].description = task.description;

                    if (validation) {
                      taskName[0].duplicate = false;
                    } else {
                      taskName[0].duplicate = true;
                    }
                  }

                  if (stagesLenght - 1 == index) {
                    _this24.isChangedTask = true;
                  }
                });

                if (validation) {

                  this.protocol.globalTasks[position - 2].duplicate = false;
                  this.setIsChanged(true);
                  this.changeCanPublish();
                } else {
                  this.protocol.globalTasks[position - 2].duplicate = true;

                  focusTask = 'task_' + (position - 2);

                  setTimeout(function () {
                    var input = _this24.$refs[focusTask][0];
                    input.focus();
                  }, 100);
                }

              case 11:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function setStageTaskDescription(_x17) {
        return _ref36.apply(this, arguments);
      }

      return setStageTaskDescription;
    }(),

    setStageDescription: function () {
      var _ref37 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee30(stage) {
        var position, validation, task_input;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                position = __WEBPACK_IMPORTED_MODULE_17_lodash_parseInt___default()(this.protocol.stages.length);
                validation = true;

                if (!position) {
                  _context30.next = 7;
                  break;
                }

                task_input = 'stage_' + (position - 1);
                _context30.next = 6;
                return this.$validator.validate(task_input);

              case 6:
                validation = _context30.sent;

              case 7:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function setStageDescription(_x18) {
        return _ref37.apply(this, arguments);
      }

      return setStageDescription;
    }(),

    focusStageTaskDescription: function focusStageTaskDescription(task) {
      this.setIsChanged(false);
    },

    removeTaskModal: function removeTaskModal(taskUuid) {
      var _this25 = this;

      if (this.teachingMethod.id == 4 || this.teachingMethod.id == 6) {

        var taskCount = 0;
        var stimulCanDelete = true;

        __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(this.protocol.stages, function (stage) {

          var currentTask = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.stimuli, function (stimul) {
            return stimul.globalUuid === taskUuid;
          })[0];

          if (currentTask && currentTask.levelUuid && _this25.teachingMethod.id == 4 || _this25.teachingMethod.id == 6 && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid) {
            taskCount++;
          }

          if (_this25.teachingMethod.id == 6 && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid && stage.stimuli.length === 1) {
            stimulCanDelete = false;
          }
        });

        if (!stimulCanDelete) {
          this.isModalCantDelete = true;
          return;
        }

        if (taskCount) {
          this.isModalAcceptPopup = true;
          this.selectedTaskUuid = taskUuid;
        } else {
          this.removeTask(taskUuid);
        }
      } else {
        if ((this.isBCBA || this.isCurator) && !this.showDeleteButton) {
          this.taskDeleteUuid = taskUuid;
          this.isTaskDeleteOpen = true;
        } else {
          this.removeTask(taskUuid);
        }
      }
    },

    changeStimul: function changeStimul() {
      var _this26 = this;

      __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (stage, index) {

        var currentTask = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.stimuli, function (stimul) {
          return stimul.globalUuid === _this26.selectedTaskUuid;
        })[0];

        if (!_this26.isShaping && currentTask && currentTask.levelUuid) {

          var mastering = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.phases, function (item) {
            return item.typeId == 5;
          })[0];
          var level = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(mastering.levels, function (level) {
            return level.uuid == currentTask.levelUuid;
          })[0];
          var groupIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(level.groups, function (group) {
            return group.uuid == currentTask.levelGroupUuid;
          });

          var deleteTaskIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(stage.stimuli, function (deteted) {
            return deteted.globalUuid == _this26.selectedTaskUuid;
          });

          stage.stimuli.splice(deleteTaskIndex, 1);

          var listSetTasks = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(stage.stimuli, function (task) {
            return currentTask.levelGroupUuid === task.levelGroupUuid;
          });

          __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(listSetTasks, function (task) {
            delete task['levelUuid'];
            delete task['levelGroupUuid'];
          });

          level.groups.splice(groupIndex, 1);
        }

        if (_this26.isShaping && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid) {

          var sortedTasks = __WEBPACK_IMPORTED_MODULE_44_lodash_sortBy___default()(stage.stimuli, 'position');

          var taskIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(sortedTasks, function (stimul) {
            return stimul.globalUuid === _this26.selectedTaskUuid;
          });

          if (taskIndex > 0) {

            _this26.$set(stage.targetStimulus, 'globalUuid', sortedTasks[taskIndex - 1].globalUuid);
          } else {
            _this26.$set(stage.targetStimulus, 'globalUuid', sortedTasks[taskIndex + 1].globalUuid);
          }
        }
      });
      this.removeTask(this.selectedTaskUuid);
      this.isModalAcceptPopup = false;
    },
    closeStimul: function closeStimul() {
      this.isModalAcceptPopup = false;
      this.isModalCantDelete = false;
    },


    removeMandModal: function removeMandModal(uuid) {

      if ((this.isBCBA || this.isCurator) && !this.showDeleteButton) {
        this.mandDeleteUiid = uuid;
        this.isMandDeleteOpen = true;
      } else {
        this.removeMand(uuid);
      }
    },

    acceptDelete: function acceptDelete() {
      this.removeTask(this.taskDeleteUuid);
      this.isTaskDeleteOpen = false;
    },

    cancelDelete: function cancelDelete() {
      this.isTaskDeleteOpen = false;
    },

    acceptDeleteMand: function acceptDeleteMand() {
      this.removeMand(this.mandDeleteUiid);
      this.isMandDeleteOpen = false;
    },

    cancelDeleteMand: function cancelDeleteMand() {
      this.isMandDeleteOpen = false;
    },

    acceptSave: function acceptSave(fixingChange, comment, fixingChangeDate) {
      if (fixingChange != '1') {
        this.protocol.changeFixing = {
          isChangesImportant: fixingChange == '3',
          comment: comment,
          date: fixingChangeDate
        };
      }
      this.changedSavePopup = false;
      this.postProtocol();
    },

    cancelSave: function cancelSave() {
      this.disabledNotImportantChanges = false;
      this.changedSavePopup = false;
    },

    removeTask: function removeTask(taskUuid) {
      var _this27 = this;

      var errorsList = this.errors.items.filter(function (items) {
        return items.rule != 'unique_task';
      });

      this.errors.items = errorsList;

      var currentTask = __WEBPACK_IMPORTED_MODULE_32_lodash_filter___default()(this.protocol.globalTasks, function (task) {
        return task.uuid === taskUuid;
      });

      var taskIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.protocol.globalTasks, function (task) {
        return task.uuid === taskUuid;
      });

      if (taskIndex !== -1) {
        this.protocol.globalTasks.splice(taskIndex, 1);

        __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (value) {
          var taskStageIndex = void 0;
          if (_this27.isShaping || _this27.isChain) {
            taskStageIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(value.stimuli, function (task) {
              return task.globalUuid === taskUuid;
            });

            value.stimuli.splice(taskStageIndex, 1);
          } else {

            taskStageIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(value.tasks, function (task) {
              return task.globalUuid === taskUuid;
            });

            value.tasks.splice(taskStageIndex, 1);
          }
        });

        if (this.protocol.teachingMethodId != 3 && this.protocol.teachingMethodId != 7 && this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
          this.reindexTasks();
        }

        if (this.protocol.teachingMethodId == 3) {
          this.reindexMands();
        }
        this.changeCanPublish();
      }

      this.setIsChanged(true);
      return true;
    },

    removeMand: function removeMand(uuid) {

      var errorsList = this.errors.items.filter(function (items) {
        return items.rule != 'unique_mand';
      });

      this.errors.items = errorsList;

      var mandIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(this.protocol.globalMandReactions, function (mand) {
        return mand.uuid === uuid;
      });

      if (mandIndex !== -1) {
        this.protocol.globalMandReactions.splice(mandIndex, 1);

        __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(this.protocol.stages, function (value) {
          var mandStageIndex = __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(value.mands, function (mand) {
            return mand.globalUuid === uuid;
          });
          value.mands.splice(mandStageIndex, 1);
        });

        this.reindexMands();
        this.changeCanPublish();
      }

      this.setIsChanged(true);
      return true;
    },

    changePecsStages: function changePecsStages() {
      this.$set(this.protocol.stages[1], 'masteringCondition', this.protocol.stages[0].masteringCondition);
      this.$set(this.protocol.stages[2], 'masteringCondition', this.protocol.stages[0].masteringCondition);
      this.$set(this.protocol.stages[1], 'isPromptEnabled', this.protocol.stages[0].isPromptEnabled);
      this.$set(this.protocol.stages[2], 'isPromptEnabled', this.protocol.stages[0].isPromptEnabled);
      this.$set(this.protocol.stages[1], 'taskPrompts', this.protocol.stages[0].taskPrompts);
      this.$set(this.protocol.stages[2], 'taskPrompts', this.protocol.stages[0].taskPrompts);
    },
    addPecsStages: function addPecsStages() {

      if (this.teachingMethod.id == 7) {

        this.$set(this.protocol, 'teachingMethodDescription', "NET");
        this.$set(this.protocol, 'skillField', "Манд");

        var globalTasks = [{
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.get_album'),
          title: 'protocol.pecs.target_sequence.get_album',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 0
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.get_i_want_card'),
          title: 'protocol.pecs.target_sequence.get_i_want_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 1
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.put_i_want_card'),
          title: 'protocol.pecs.target_sequence.put_i_want_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 2
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.get_reinforcement_item_card'),
          title: 'protocol.pecs.target_sequence.get_reinforcement_item_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 3
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.put_reinforcement_item_card'),
          title: 'protocol.pecs.target_sequence.put_reinforcement_item_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 4
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.get_template'),
          title: 'protocol.pecs.target_sequence.get_template',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 5
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.give_template'),
          title: 'protocol.pecs.target_sequence.give_template',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 6
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.target_sequence.read_sentence'),
          title: 'protocol.pecs.target_sequence.read_sentence',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 7
        }];

        var taskTypes = this.allTaskTypes.filter(function (item) {
          return item.id == 4;
        })[0];

        var stageUuid1 = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();

        var firstStep = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()([globalTasks[3], globalTasks[4], globalTasks[5], globalTasks[6]], function (item) {

          return {
            description: item.description,
            title: item.title,
            globalTaskId: null,
            globalUuid: item.uuid,
            position: item.position,
            stageId: null,
            stageUuid: stageUuid1
          };
        });

        var stageUuid2 = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
        var secondStep = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()([globalTasks[0], globalTasks[1], globalTasks[2], globalTasks[3], globalTasks[4], globalTasks[5], globalTasks[6]], function (item) {

          return {
            description: item.description,
            title: item.title,
            globalTaskId: null,
            globalUuid: item.uuid,
            position: item.position,
            stageId: null,
            stageUuid: stageUuid2
          };
        });

        var stageUuid3 = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();
        var thirdStep = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()([].concat(globalTasks), function (item) {

          return {
            description: item.description,
            title: item.title,
            globalTaskId: null,
            globalUuid: item.uuid,
            position: item.position,
            stageId: null,
            stageUuid: stageUuid3
          };
        });

        this.$set(this.protocol, 'stages', [{
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 0,
          title: 'protocol.pecs.step_one',
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.step_one'),
          tasks: firstStep,
          type: taskTypes,
          isNew: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
          masteringCondition: {
            ratio: 100,
            trialCount: 3,
            sessionCount: 1,
            answerDirectory: { id: 1 }
          }
        }, {
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 1,
          title: 'protocol.pecs.step_two',
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.step_two'),
          tasks: secondStep,
          type: taskTypes,
          isNew: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
          masteringCondition: {
            ratio: 100,
            trialCount: 3,
            sessionCount: 1,
            answerDirectory: { id: 1 }
          }
        }, {
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 2,
          title: 'protocol.pecs.step_three',
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.step_three'),
          tasks: thirdStep,
          type: taskTypes,
          isNew: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
          masteringCondition: {
            ratio: 100,
            trialCount: 3,
            sessionCount: 1,
            answerDirectory: { id: 1 }
          }
        }]);

        this.$set(this.protocol, 'globalTasks', globalTasks);
      }

      if (this.teachingMethod.id == 8) {

        this.$set(this.protocol, 'teachingMethodDescription', "");
        this.$set(this.protocol, 'skillField', "");

        var _globalTasks = [{
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.get_album'),
          title: 'protocol.pecs.without_discrimination_target_sequence.get_album',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 0,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.get_i_want_card'),
          title: 'protocol.pecs.without_discrimination_target_sequence.get_i_want_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 1,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.put_i_want_card'),
          title: 'protocol.pecs.without_discrimination_target_sequence.put_i_want_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 2,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.get_target_property_item_card'),
          title: 'protocol.pecs.without_discrimination_target_sequence.get_target_property_item_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 3,
          enabled: false
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.put_target_property_item_card'),
          title: 'protocol.pecs.without_discrimination_target_sequence.put_target_property_item_card',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 4,
          enabled: false
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.get_card_desired_item'),
          title: 'protocol.pecs.without_discrimination_target_sequence.get_card_desired_item',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 5,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.put_card_desired_item'),
          title: 'protocol.pecs.without_discrimination_target_sequence.put_card_desired_item',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 6,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.get_template'),
          title: 'protocol.pecs.without_discrimination_target_sequence.get_template',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 7,
          enabled: true
        }, {
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.without_discrimination_target_sequence.give_template'),
          title: 'protocol.pecs.without_discrimination_target_sequence.give_template',
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 8,
          enabled: true
        }];

        var _taskTypes = this.allTaskTypes.filter(function (item) {
          return item.id == 4;
        })[0];

        var _stageUuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4();

        var _firstStep = __WEBPACK_IMPORTED_MODULE_43_lodash_map___default()(_globalTasks, function (item) {

          return {
            description: item.description,
            title: item.title,
            globalTaskId: null,
            globalUuid: item.uuid,
            position: item.position,
            stageId: null,
            stageUuid: _stageUuid
          };
        });

        this.$set(this.protocol, 'stages', [{
          id: null,
          uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
          position: 0,
          title: 'protocol.pecs.step_one',
          description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.pecs.step_one'),
          tasks: _firstStep,
          type: _taskTypes,
          isNew: true,
          isAllTasksEnabled: true,
          isPromptEnabled: false,
          taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(this.hintListRotation),
          masteringCondition: {
            ratio: 100,
            trialCount: 3,
            sessionCount: 1,
            answerDirectory: { id: 1 }
          }
        }]);

        this.$set(this.protocol, 'globalTasks', _globalTasks);
        this.$set(this.protocol, 'isAllTasksEnabled', true);
      }
    },
    getDefaultPecsCategories: function getDefaultPecsCategories() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee31() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                _context31.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(_this28.apiUrl + 'default-categories/');

              case 3:
                response = _context31.sent;
                return _context31.abrupt('return', response.data.data);

              case 7:
                _context31.prev = 7;
                _context31.t0 = _context31['catch'](0);

                console.dir(_context31.t0);

              case 10:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, _this28, [[0, 7]]);
      }))();
    },
    addPecsWithDiscriminationStages: function addPecsWithDiscriminationStages() {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee32() {
        var defaultPecsCategories, taskTypes, categoryUuid, taskUuid, indexTask;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return _this29.getDefaultPecsCategories();

              case 2:
                defaultPecsCategories = _context32.sent;


                _this29.$set(_this29.protocol, 'categories', []);

                taskTypes = _this29.allTaskTypes.filter(function (item) {
                  return item.id == 1;
                })[0];


                _this29.$set(_this29.protocol, 'masteringCondition', {
                  ratio: 100,
                  trialCount: 3,
                  sessionCount: 1,
                  answerDirectory: { id: 1 }
                });

                if (_this29.isPecsWithItems) {

                  _this29.$set(_this29.protocol, 'stages', [{
                    id: null,
                    uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    position: 0,
                    title: "count_properties1",
                    description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.count_properties1'),
                    tasks: [],
                    type: taskTypes,
                    isNew: true,
                    isPromptEnabled: false,
                    taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(_this29.hintListRotation),
                    isActive: true
                  }]);
                } else {
                  _this29.$set(_this29.protocol, 'stages', [{
                    id: null,
                    uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    position: 0,
                    title: "count_properties1",
                    description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.count_properties1'),
                    tasks: [],
                    type: taskTypes,
                    isNew: true,
                    isPromptEnabled: false,
                    taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(_this29.hintListRotation),
                    isActive: true
                  }, {
                    id: null,
                    uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    position: 1,
                    title: "count_properties2",
                    description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.count_properties2'),
                    tasks: [],
                    type: taskTypes,
                    isNew: true,
                    isPromptEnabled: false,
                    taskPrompts: __WEBPACK_IMPORTED_MODULE_36_lodash_cloneDeep___default()(_this29.hintListRotation),
                    isActive: true
                  }, {
                    id: null,
                    uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    position: 2,
                    title: "count_properties3",
                    description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.count_properties3'),
                    tasks: [],
                    type: taskTypes,
                    isNew: true,
                    isActive: true
                  }, {
                    id: null,
                    uuid: __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    position: 3,
                    title: "count_properties4",
                    description: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.count_properties4'),
                    tasks: [],
                    type: taskTypes,
                    isNew: true,
                    isActive: true
                  }]);
                }

                __WEBPACK_IMPORTED_MODULE_19_lodash_forEach___default()(defaultPecsCategories, function (category) {

                  var categoryUuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4().toString();
                  var taskUuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4().toString();

                  _this29.protocol.categories.push({
                    'id': null,
                    'uuid': categoryUuid,
                    'currentStage': {
                      id: _this29.protocol.stages[0].id,
                      uuid: _this29.protocol.stages[0].uuid,
                      description: _this29.protocol.stages[0].description,
                      title: 'count_properties1',
                      hasAssignedStage: false,
                      isClosed: false
                    },
                    'tasks': [{
                      'description': "",
                      'id': null,
                      'position': 0,
                      'protocolCategoryId': null,
                      'protocolCategoryUuid': categoryUuid,
                      'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.property') + ' 1',
                      'uuid': taskUuid,
                      'isNew': true,
                      'active': true
                    }],
                    'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get(category.name),
                    'masteringPercent': 0,
                    'active': true,
                    'typeId': 1
                  });

                  __WEBPACK_IMPORTED_MODULE_18_lodash_forIn___default()(_this29.protocol.stages, function (value, index) {

                    var indexTask = _this29.protocol.stages[index].tasks.length;

                    _this29.protocol.stages[index].tasks.push({
                      'id': null,
                      'globalTaskId': null,
                      'position': indexTask,
                      'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.property') + ' ' + indexTask,
                      'description': '',
                      'isNew': true,
                      'active': true,
                      'uuid': __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                      'globalUuid': taskUuid,
                      'categoryUuid': categoryUuid
                    });
                  });
                });

                if (_this29.isPecsWithItems) {
                  categoryUuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4().toString();
                  taskUuid = __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4().toString();
                  indexTask = _this29.protocol.stages[0].tasks.length;


                  _this29.protocol.categories.push({
                    'id': null,
                    'uuid': categoryUuid,
                    'currentStage': {
                      id: _this29.protocol.stages[0].id,
                      uuid: _this29.protocol.stages[0].uuid,
                      description: _this29.protocol.stages[0].description,
                      title: 'count_properties1',
                      hasAssignedStage: false,
                      isClosed: false
                    },
                    'tasks': [{
                      'description': "",
                      'id': null,
                      'position': indexTask,
                      'protocolCategoryId': null,
                      'protocolCategoryUuid': categoryUuid,
                      'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.property') + indexTask,
                      'uuid': taskUuid,
                      'isNew': true,
                      'active': true
                    }],
                    'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.items'),
                    'masteringPercent': 0,
                    'active': true,
                    'typeId': 2
                  });

                  _this29.protocol.stages[0].tasks.push({
                    'id': null,
                    'globalTaskId': null,
                    'position': 1,
                    'title': __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('protocol.property') + ' ' + 1,
                    'description': '',
                    'isNew': true,
                    'active': true,
                    'uuid': __WEBPACK_IMPORTED_MODULE_42__common_uuid_UuidGenerator__["a" /* default */].v4(),
                    'globalUuid': taskUuid,
                    'categoryUuid': categoryUuid
                  });
                }

              case 9:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, _this29);
      }))();
    }
  },
  watch: {
    teachingMethod: function teachingMethod(newValue, oldValue) {

      if (!this.protocol.teachingMethodId) {
        this.$set(this.protocol, 'teachingMethodId', null);
      }

      if (newValue.id == 7 && !this.protocol.stages.length) {
        this.addPecsStages();
      }

      if (this.isEditing) {

        if (!!this.protocol.stages[0].description) {
          this.toggleConfirmChangeModal();
          this.selectedTeachingMethod = newValue;
          this.selectedTeachingMethodID = oldValue.id;
          this.protocol.dataFields.teachingMethod = newValue.name;
        } else {
          if (this.isNew && newValue.id != 7 && newValue.id != 8 && newValue.id != 9 && newValue.id != 10) {
            this.selectedTeachingMethodID = newValue.id;
            this.protocol.stages = [];
            if (newValue.id != 3) {
              this.$set(this.protocol, 'globalTasks', []);
            } else {
              this.$set(this.protocol, 'globalMandReactions', []);
            }
            this.protocol.stages.push(this.newStage());
            if (newValue.id != 3) {
              this.addTask();
            }
            if (newValue.id == 3) {
              delete this.protocol['globalTasks'];
              this.addMand();
            }
            this.protocol.teachingMethodId = newValue.id;
            this.protocol.dataFields.teachingMethod = newValue.name;
            this.$set(this.protocol, 'teachingMethodDescription', "");
            this.$set(this.protocol, 'skillField', "");
          }

          if (this.isNew && newValue && (newValue.id == 7 || newValue.id == 8)) {
            this.selectedTeachingMethod = newValue;
            this.selectedTeachingMethodID = newValue.id;
            this.protocol.teachingMethodId = newValue.id;
            this.protocol.teachingMethod = newValue;
            this.protocol.dataFields.teachingMethod = newValue.name;

            this.addPecsStages();
          }

          if (this.isNew && newValue && (newValue.id == 9 || newValue.id == 10)) {

            this.selectedTeachingMethod = newValue;
            this.selectedTeachingMethodID = newValue.id;
            this.protocol.teachingMethodId = newValue.id;
            this.protocol.teachingMethod = newValue;
            this.protocol.dataFields.teachingMethod = newValue.name;

            this.addPecsWithDiscriminationStages();
          }
        }
      } else {
        this.protocol.teachingMethodId = newValue.id;
        this.selectedTeachingMethodID = newValue.id;
        this.protocol.dataFields.teachingMethod = newValue.name;
        this.fetchTaskTypes();
      }

      //this.validatorTaskAdd();

    },
    draggingGlobalTasks: function draggingGlobalTasks(val) {
      if (!val) {
        if (this.protocol.teachingMethodId != 3) {
          this.reindexTasks();
        }

        if (this.protocol.teachingMethodId == 3) {
          this.reindexMands();
        }
      }
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'field': {
      required: true,
      type: String,
      default: function _default() {
        return 'text';
      }
    },
    'label': {
      required: true,
      type: String,
      default: function _default() {
        return '';
      }
    },
    'id': {
      type: String,
      default: function _default() {
        return 'text';
      }
    },
    'validateLable': {
      required: true,
      type: String,
      default: function _default() {
        return '';
      }
    },
    'validateRule': {
      required: true,
      type: String,
      default: function _default() {
        return '';
      }
    },
    'visible': {
      required: true,
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'disabled': {
      required: false,
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    suggestions: {
      type: Array,
      required: true,
      default: function _default() {
        return null;
      }
    },
    value: {
      type: [String, Number]
    },
    rowsCount: {
      required: false,
      type: [String, Number],
      default: function _default() {
        return 1;
      }
    },
    multiline: {
      required: false,
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      open: false,
      current: -1
    };
  },


  inject: ["parentValidator"],

  created: function created() {
    this.$validator = this.parentValidator;
  },


  computed: {
    openSuggestion: function openSuggestion() {
      return this.suggestions.length > 0 && this.open === true;
    },

    inputText: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    blockCarret: function blockCarret(event) {
      if (event.keyCode == '38' || event.keyCode == '40') {
        event.preventDefault();
      }
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.errors.clear();
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validateAll();

              case 2:
                result = _context.sent;

                if (result) {
                  document.removeEventListener('keydown', _this.blockCarret);
                  _this.$emit('save', _this.inputText);
                } else {
                  _this.$emit('validate', _this.errors);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    enter: function enter() {
      if (this.current > -1 && this.current < this.suggestions.length) {
        this.suggestionClick(this.current, this.suggestions[this.current][this.field]);
      }
      //this.open = false;
      //this.validate();
    },
    right: function right() {
      if (this.current !== -1) {
        this.inputText = this.suggestions[this.current][this.field];
        this.change();
      }
    },
    up: function up() {
      if (this.current > -1) {
        this.current--;
      } else {
        this.current = this.suggestions.length - 1;
      }

      this.fixScrolling();
    },
    down: function down() {
      if (this.current < this.suggestions.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }

      this.fixScrolling();
    },
    fixScrolling: function fixScrolling() {
      if (this.current >= 0) {
        var liHeight = this.$refs.options[this.current].clientHeight;
        this.$refs.scrollContainer.scrollTop = liHeight * this.current;
      }
    },
    hideDropdown: function hideDropdown() {
      var self = this;

      setTimeout(function () {
        self.open = false;
      }, 200);
    },
    isActive: function isActive(index) {
      return index === this.current;
    },

    change: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      if (this.inputText.length > 0) {
        this.$emit('inputChange', this.inputText);

        if (this.open == false) {
          this.open = true;
          this.current = -1;
        }
      }
    }, 100),
    suggestionClick: function suggestionClick(index, text) {
      this.current = index;
      this.inputText = text;
      this.$emit('inputChange', this.inputText);
      this.open = false;
    }
  },
  watch: {
    visible: function visible() {
      if (this.visible) {
        document.addEventListener('keydown', this.blockCarret);
      } else {
        document.removeEventListener('keydown', this.blockCarret);
      }
    }
  }
});

/***/ }),
/* 563 */,
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_parseInt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfirmModal__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_trim__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ConfirmModal: __WEBPACK_IMPORTED_MODULE_13__ConfirmModal__["a" /* default */], Hints: __WEBPACK_IMPORTED_MODULE_15__protocols_components_Hints__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default.a },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedTaskTypeTitle', 'selectedStagesTitle', 'changeFromClient'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: [],
      selected: {},
      taskType: {},
      tempCurrentStageAttemptCount: null,
      coldSampleIds: [1, 5],
      baseColdSample: 5,
      spoTaskTypes: [],
      disabledChange: false,
      stimulList: [],
      isModalVisible: false,
      isStimulVisible: false,
      intervalId: null,
      dragging: false,
      disabledTaskType: false,
      addTaskReactionItem: null,
      msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.enable_recording')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA']), {
    isEmptySelectedStage: function isEmptySelectedStage() {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default()(this.selectedStage);
    },
    taskTypesNew: function taskTypesNew() {
      var _this = this;

      return this.taskTypes.filter(function (item) {
        return item.title !== _this.taskType.title;
      });
    },
    spoTaskTypesNew: function spoTaskTypesNew() {
      var _this2 = this;

      return this.spoTaskTypes.filter(function (item) {
        return item.title !== _this2.spoTaskTypes.title;
      });
    },


    isBaseColdSample: {
      get: function get() {
        return this.baseColdSample === this.taskType.id;
      }
    }
  }),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this3 = this;

      this.intervalId = window.setInterval(function () {
        _this3.protocolChanged();
      }, 25000);
    });
  },

  methods: {
    masteredTask: function masteredTask(task) {
      if (task.mastered) {
        var taskCurrent = __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default()(this.tasks, function (item) {
          return item.globalUuid == task.globalUuid;
        })[0];

        taskCurrent.position = this.tasks.length + 1;

        this.tasks = __WEBPACK_IMPORTED_MODULE_18_lodash_sortBy___default()(this.tasks, 'position');

        this.reindexTasks();
      }
    },


    reindexTasks: function reindexTasks() {
      this.tasks.forEach(function (item, index) {
        var position = __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default()(index) + 1;
        item['position'] = __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default()(index);
      });
    },

    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeTaskType: function changeTaskType(taskType) {
      if (taskType) {
        if (this.currentStage.type !== taskType) {
          this.protocolChanged();
        }
        this.currentStage.type = taskType;
        this.taskType = taskType;

        this.currentStageIndex = this.getCurrentStageIndex(this.currentStageTitle);

        if (this.isBaseColdSample) {
          this.setStageGenerate();
        } else {
          this.deleteStageGenerate();
        }

        var tasks = this.tasks;
        var taskCount = tasks.length;
        if (taskCount > 0) {
          for (var i = 0; i < taskCount; i++) {
            this.tasks[i]['typeId'] = this.taskType.id;
          }
        }
      } else {
        this.currentStage.type = {};
        this.taskType = {};
      }
    },

    changeSpoTaskType: function changeSpoTaskType(taskType) {
      if (taskType) {
        this.protocolChanged();
        this.currentStage.generate.type = taskType;
      }
    },

    addTask: function addTask(addTaskReactionItem) {
      if (!addTaskReactionItem) {
        return;
      }

      var unique = true;

      var taskReactionsList = this.protocol.globalTasks;

      __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(taskReactionsList, function (stimul) {
        if (__WEBPACK_IMPORTED_MODULE_22_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_22_lodash_trim___default()(addTaskReactionItem.toLowerCase())) {
          unique = false;
        }
      });
      if (unique) {

        var position = __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default()(this.tasks.length) + 1;
        var uuid = __WEBPACK_IMPORTED_MODULE_16__common_uuid_UuidGenerator__["a" /* default */].v4();

        this.tasks.push({
          'position': position,
          'globalUuid': uuid,
          'description': addTaskReactionItem,
          'mastered': false,
          'active': true,
          'target': false
        });

        this.protocol.globalTasks.push({
          'position': position,
          'mastered': false,
          'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.tasks') + ' ' + position,
          'description': addTaskReactionItem,
          'active': false,
          'uuid': uuid
        });

        this.addTaskReactionItem = null;
        this.changeCanPublish();
      } else {
        this.errors.add({
          field: 'addTaskReactionItem',
          msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
        });
      }
    },

    editProtocol: function editProtocol() {
      this.$emit('editProtocol');
    },
    createProtocol: function createProtocol() {
      this.$emit('createProtocol');
    },
    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    reindexStages: function reindexStages() {
      this.tasks.forEach(function (item, index) {
        var position = __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default()(index);
        item['position'] = __WEBPACK_IMPORTED_MODULE_6_lodash_parseInt___default()(index);
      });
    },

    hintsUpdate: function hintsUpdate() {
      if (this.currentStage.taskPrompts[2].active || this.currentStage.taskPrompts[3].active || this.currentStage.taskPrompts[4].active || this.currentStage.taskPrompts[5].active) {
        this.currentStage.taskPrompts[1].active = false;
      }
    },

    hideTasks: function hideTasks() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.disabled = true;
                _context.next = 3;
                return _this4.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!(!result || !_this4.taskType.title)) {
                  _context.next = 7;
                  break;
                }

                _this4.disabled = false;
                return _context.abrupt('return');

              case 7:

                _this4.hintsUpdate();

                _this4.$set(_this4.protocol.stages, _this4.currentStageIndex, _this4.currentStage);

                _this4.reindexTasks();

                _this4.$set(_this4.protocol.stages[_this4.currentStageIndex], 'tasks', __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default()(_this4.tasks, function (item) {
                  return item.active;
                }));

                _this4.protocol.stages[_this4.currentStageIndex].masteredTasks = __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default()(_this4.tasks, function (item) {
                  return item.mastered;
                });
                _this4.protocol.stages[_this4.currentStageIndex].type = _this4.taskType;

                _this4.reindexStages();
                _this4.$emit('hideTasks');

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },


    setStageGenerate: function setStageGenerate() {
      if (!this.currentStage.hasOwnProperty('generate')) {
        this.currentStage['generate'] = {
          type: this.getSpoType(4),
          attempts: this.currentStage.attemptCount,
          answer: '-'
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(this.currentStage.generate.type)) {
        this.currentStage.generate.type = this.getSpoType(4);
      }

      if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(this.currentStage.generate.attempts)) {
        this.currentStage.attemptCount = this.currentStage.generate.attempts;
      }
    },

    deleteStageGenerate: function deleteStageGenerate() {
      if (this.currentStage.hasOwnProperty('generate')) {
        delete this.currentStage.generate;
      }
    },

    getSpoType: function getSpoType(id) {
      var types = this.spoTaskTypes.filter(function (taskType) {
        return taskType.id === id;
      });

      return types.shift();
    }

  },

  created: function created() {
    var _this5 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }

    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.taskTypes, function (type) {
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(_this5.coldSampleIds, type.id)) {
        _this5.spoTaskTypes.push(type);
      }
    });

    this.selected = this.protocol.stages[this.currentStageIndex];
    this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
    this.currentStage = __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    if (this.currentStage.type) {
      if (this.currentStage.type.id === 1 || this.currentStage.type.id === 2) {
        this.disabledTaskType = true;
      }

      this.taskType = this.currentStage.type;
    }
    if (!this.taskTypes) {
      var index = 0;
      if (this.selectedTaskTypeTitle) {
        index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.taskTypes, function (task) {
          return task.title === _this5.selectedTaskTypeTitle;
        });
      }
      this.taskType = this.taskTypes[index];
    }

    var taskList = __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(this.protocol.globalTasks);

    this.tasks = __WEBPACK_IMPORTED_MODULE_19_lodash_map___default()(taskList, function (task) {
      var currentTask = __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default()(_this5.currentStage.tasks, function (item) {
        return item.globalUuid == task.uuid;
      });

      task.active = currentTask.length == 1;
      task.position = currentTask.length ? currentTask[0].position : taskList.length;
      task.globalUuid = task.uuid;
      task.canBeMarkedAsMastered = currentTask.length ? currentTask[0].canBeMarkedAsMastered : false;
      task.mastered = __WEBPACK_IMPORTED_MODULE_20_lodash_filter___default()(_this5.currentStage.masteredTasks, function (item) {
        return item.globalUuid == task.uuid;
      }).length == 1;
      delete task['uuid'];

      return task;
    });

    this.tasks = __WEBPACK_IMPORTED_MODULE_18_lodash_sortBy___default()(this.tasks, 'position');

    this.setStageGenerate();

    __WEBPACK_IMPORTED_MODULE_11_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('validation.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(_this5.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this5);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmDeleteModal',
  props: {
    visible: {
      required: true,
      types: [Boolean]
    },
    item: {
      required: true,
      types: [Object]
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  methods: {
    accept: function accept() {
      this.$emit('accept', this.item);
    },
    cancel: function cancel() {
      this.$emit('cancel', this.item);
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HintList',

  props: {
    hintList: [Object, Array],
    hintVisible: false
  },

  computed: {
    sortedHintList: function sortedHintList() {
      var promts = this.hintList;

      promts[2].subLevel = true;
      promts[3].subLevel = true;
      promts[4].subLevel = true;
      promts[5].subLevel = true;

      if (this.hintList[2].active || this.hintList[3].active || this.hintList[4].active || this.hintList[5].active) {
        promts[1].active = true;
      }

      return promts;
    }
  }

});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isString__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfirmModal__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TaskDTTModal__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TaskDttPhaseModal__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isInteger__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_isInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_parseInt__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_parseInt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_parseInt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ConfirmModal: __WEBPACK_IMPORTED_MODULE_13__ConfirmModal__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_22_vuedraggable___default.a, TaskDTTModal: __WEBPACK_IMPORTED_MODULE_14__TaskDTTModal__["a" /* default */], TaskDttPhaseModal: __WEBPACK_IMPORTED_MODULE_15__TaskDttPhaseModal__["a" /* default */], Hints: __WEBPACK_IMPORTED_MODULE_23__protocols_components_Hints__["a" /* default */] },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedTaskTypeTitle', 'selectedStagesTitle', 'changeFromClient', 'showDeleteButton', 'transferConditionValue'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: [],
      addStimulusItem: null,
      selected: {},
      taskType: {},
      taskTypesList: [],
      tempCurrentStageAttemptCount: null,
      coldSampleIds: [1, 5],
      baseColdSample: 5,
      spoTaskTypes: [],
      disabledChange: false,
      errorPhaseCount: false,
      stimulList: [],
      isModalVisible: false,
      modal: null,
      stimul: null,
      isStimulVisible: false,
      dragging: false,
      masteringConditionTransfer: {
        trialCount: '2',
        sessionCount: '2',
        ratio: '80',
        conditionTrial: '3',
        conditionSession: '3'
      },
      rotationConditionTransfer: {
        trialCount: '2',
        sessionCount: '2',
        ratio: '80',
        conditionTrial: '3',
        conditionSession: '3'
      },
      fluencyConditionTransfer: {
        trialCount: '2',
        sessionCount: '2',
        ratio: '80',
        conditionTrial: '3',
        conditionSession: '3'
      },
      masteringTransferCondition: null,
      rotationTransferCondition: null,
      fluencyTransferCondition: null,
      masteringMinFieldCount: null,
      rotationMinFieldCount: null,
      fluencyMinFieldCount: null,
      masteringMaxFieldCount: null,
      rotationMaxFieldCount: null,
      fluencyMaxFieldCount: null,
      masteringTaskType: null,
      rotationTaskType: null,
      mastering: null,
      masteringActive: true,
      rotationActive: true,
      intervalsActive: true,
      fluencyActive: true,
      supportActive: true,
      rotation: null,
      intervalsList: null,
      fluency: null,
      interval_count: null,
      modalView: false,
      phaseName: null,
      afterLoad: false,
      intervals: [{ typeId: 1, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.through_each_lesson'), count: '3', checked: false }, { typeId: 2, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_one_lesson'), count: '3', checked: false }, { typeId: 3, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_two_classes'), count: '3', checked: false }, { typeId: 4, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_three_classes'), count: '3', checked: false }, { typeId: 5, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_a_week'), count: '3', checked: false }, { typeId: 6, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks'), count: '3', checked: false }, { typeId: 7, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_a_month'), count: '3', checked: false }],
      intervalError: false,
      options: {
        filterable: false,
        sortable: [],
        skin: 'table table-sm',
        headings: {
          name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.interval_name'),
          count: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.interval_count'),
          action: ''
        },
        texts: {
          noResults: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          count: 'table-count',
          action: 'table-actions'
        }
      },
      currentPhaseType: null,
      phaseType: null,
      modalViewField: false,
      minValue: null,
      maxValue: null,
      oldMinValue: null,
      oldMaxValue: null,
      hintListMastering: null,
      hintListRotation: null,
      masteringVisible: false,
      rotationVisible: false,
      oldValueMax: null,
      oldValueMin: null,
      changedValue: false,
      intervalId: null,
      msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.enable_recording'),
      stimulListToChange: null,
      isModalChangePhaseVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isEmptySelectedStage: function isEmptySelectedStage() {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default()(this.selectedStage);
    },
    isEditing: function isEditing() {
      var active = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.active;
      });
      return !(active.length == 1 && (active[0].typeId == 3 && active[0].intervals.length == 1 || active[0].typeId != 3 && !active[0].withFields) || active.length == 0);
    },
    taskTypesNew: function taskTypesNew() {
      var _this = this;

      return this.taskTypes.filter(function (item) {
        return item.title !== _this.taskType.title;
      });
    },
    spoTaskTypesNew: function spoTaskTypesNew() {
      var _this2 = this;

      return this.spoTaskTypes.filter(function (item) {
        return item.title !== _this2.spoTaskTypes.title;
      });
    },
    protocolStages: function protocolStages() {
      var _this3 = this;

      return this.protocol.stages.filter(function (item) {
        return item.title !== _this3.currentStage.title;
      });
    },


    currentStageAttemptCount: {
      get: function get() {
        if (this.tempCurrentStageAttemptCount) {
          if (__WEBPACK_IMPORTED_MODULE_6_lodash_isString___default()(this.tempCurrentStageAttemptCount)) {
            return this.tempCurrentStageAttemptCount;
          } else {
            return this.tempCurrentStageAttemptCount.toString();
          }
        }
      },
      set: function set(newValue) {
        if (this.tempCurrentStageAttemptCount !== newValue) {
          this.tempCurrentStageAttemptCount = newValue;
          if (this.isBaseColdSample) {
            this.currentStage.attemptCount = newValue;
            this.currentStage.generate.attempts = newValue;
          } else {
            this.currentStage.attemptCount = newValue;
          }
        }
      }
    },
    isBaseColdSample: {
      get: function get() {
        return this.baseColdSample === this.taskType.id;
      }
    },

    stimulListToChangeAndActive: function stimulListToChangeAndActive() {
      return __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
        return task.changed && task.active;
      }).length;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_28_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this4 = this;

      this.intervalId = window.setInterval(function () {
        _this4.hideTasks();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    acivatedTask: function acivatedTask(task) {
      if (task.active) {
        var taskCurrent = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (item) {
          return item.globalUuid == task.globalUuid;
        })[0];

        this.$set(taskCurrent, 'phaseType', __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.active;
        })[0].typeId);
        this.$set(taskCurrent, 'fieldIndex', taskCurrent.phaseType != 3 ? __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.active;
        })[0].minFieldCount : null);
        this.$set(taskCurrent, 'intervalType', taskCurrent.phaseType == 3 ? __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.intervals, function (interval) {
          return interval.checked;
        })[0] : null);
      }
    },
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    changeMaxMinValue: function changeMaxMinValue(typeId) {
      var oldMax = null;
      var oldMin = null;
      if (typeId == 1) {
        oldMax = this.masteringMaxFieldCount;
        oldMin = this.masteringMinFieldCount;
      }

      if (typeId == 2) {
        oldMax = this.rotationMaxFieldCount;
        oldMin = this.rotationMinFieldCount;
      }

      if (typeId == 4) {
        oldMax = this.fluencyMaxFieldCount;
        oldMin = this.fluencyMinFieldCount;
      }
      this.oldValueMax = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(oldMax);
      this.oldValueMin = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(oldMin);
      this.changedValue = true;
    },
    changeNumberMax: function changeNumberMax(event, typeId) {
      if (!(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      } else {
        if (!this.changedValue) {
          this.changeMaxMinValue(typeId);
        }
      }
    },
    changeMaxFieldCount: function changeMaxFieldCount(max, typeId) {

      if (this.afterLoad && max > 0) {

        var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == typeId;
        })[0];

        var minValue = null;

        if (!this.oldValueMin) {
          this.changeMaxMinValue(typeId);
        }

        if (this.oldValueMin && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(this.oldValueMin) > __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(max)) {
          if (typeId == 1) {
            this.masteringMinFieldCount = max;
          }
          if (typeId == 2) {
            this.rotationMinFieldCount = max;
          }
          if (typeId == 4) {
            this.fluencyMinFieldCount = max;
          }
          minValue = max;
        } else {
          if (typeId == 1) {
            minValue = this.masteringMinFieldCount;
          }
          if (typeId == 2) {
            minValue = this.rotationMinFieldCount;
          }
          if (typeId == 4) {
            minValue = this.fluencyMinFieldCount;
          }
        }

        var newTask = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
          return task.phaseType == typeId && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(task.fieldIndex) > __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(max);
        });

        var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
          return task.phaseType == typeId && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(task.fieldIndex) > __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(max);
        }).length;

        if (taskCount) {
          this.modalViewField = true;
          this.maxValue = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(max);
          this.minValue = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(minValue);
          this.currentPhaseType = typeId;
        } else {
          phase.minFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(minValue);
          phase.maxFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(max);
        }
      }
      this.changedValue = false;
    },
    changeMinFieldCount: function changeMinFieldCount(min, typeId) {

      if (this.afterLoad && min > 0) {

        var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == typeId;
        })[0];

        var maxValue = null;

        if (!this.oldValueMax) {
          this.changeMaxMinValue(typeId);
        }

        if (__WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(this.oldValueMax) < __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(min)) {
          if (typeId == 1) {
            this.masteringMaxFieldCount = min;
          }
          if (typeId == 2) {
            this.rotationMaxFieldCount = min;
          }
          if (typeId == 4) {
            this.fluencyMaxFieldCount = min;
          }
          maxValue = min;
        } else {
          if (typeId == 1) {
            maxValue = this.masteringMaxFieldCount;
          }
          if (typeId == 2) {
            maxValue = this.rotationMaxFieldCount;
          }
          if (typeId == 4) {
            maxValue = this.fluencyMaxFieldCount;
          }
        }

        var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
          return task.phaseType == typeId && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(task.fieldIndex) < __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(min);
        }).length;

        if (taskCount) {
          this.modalViewField = true;
          this.minValue = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(min);
          this.maxValue = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(maxValue);
          this.currentPhaseType = typeId;
        } else {
          phase.minFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(min);
          phase.maxFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(maxValue);
        }
      }
      this.changedValue = false;
    },
    currentIntervalType: function currentIntervalType(typeId) {
      var currentInterval = null;
      if (typeId) {
        currentInterval = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.intervals, function (interval) {
          return interval.typeId == typeId;
        })[0];
      } else {
        currentInterval = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.intervals, function (interval) {
          return interval.checked;
        })[0];
      }
      var currentIntervalName = currentInterval ? currentInterval.name : null;
      return currentIntervalName;
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.stimul = item;
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
      this.isModalChangePhaseVisible = false;
    },
    onModalSave: function onModalSave(phaseTask, field, interval) {
      var _this5 = this;

      var currentTask = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
        return task.description === _this5.stimul.description;
      })[0];

      currentTask.phaseType = phaseTask;
      currentTask.phaseId = phaseTask.id;
      currentTask.fieldIndex = phaseTask != 3 ? field : null;
      currentTask.intervalType = phaseTask == 3 && interval ? __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(interval.typeId) : null;

      this.isModalVisible = false;
    },
    onModalSaveChanges: function onModalSaveChanges(phaseTask, field, interval) {

      __WEBPACK_IMPORTED_MODULE_27_lodash_map___default()(this.stimulListToChange, function (task) {

        task.phaseType = phaseTask;
        task.phaseId = phaseTask.id;
        task.fieldIndex = phaseTask != 3 ? field : null;
        task.intervalType = phaseTask == 3 && interval ? __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(interval.typeId) : null;

        task.changed = false;
        return task;
      });

      this.isModalChangePhaseVisible = false;
    },
    onEditSomeBtnClick: function onEditSomeBtnClick() {
      this.stimulListToChange = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
        return task.changed && task.active;
      });

      if (this.stimulListToChange.length) {
        this.isModalChangePhaseVisible = true;
      }
    },
    onModalSavePhase: function onModalSavePhase() {
      var _this6 = this;

      var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == _this6.currentPhaseType;
      })[0];
      phase.active = false;
    },
    onModalClosePhase: function onModalClosePhase() {
      var _this7 = this;

      var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == _this7.currentPhaseType;
      })[0];
      phase.active = true;
      if (this.currentPhaseType == 1) {
        this.masteringActive = true;
      }
      if (this.currentPhaseType == 2) {
        this.rotationActive = true;
      }

      if (this.currentPhaseType == 3) {
        this.intervalsActive = true;
      }
      if (this.currentPhaseType == 4) {
        this.fluencyActive = true;
      }
      this.modalView = false;
    },
    onModalSaveField: function onModalSaveField() {
      var _this8 = this;

      var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == _this8.currentPhaseType;
      })[0];
      phase.minFieldCount = this.minValue;
      phase.maxFieldCount = this.maxValue;

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.tasks, function (task) {
        if (task.phaseType == _this8.currentPhaseType && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(task.fieldIndex) < __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this8.minValue)) {
          task.fieldIndex = _this8.minValue;
        }

        if (task.phaseType == _this8.currentPhaseType && __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(task.fieldIndex) > __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this8.maxValue)) {
          task.fieldIndex = _this8.maxValue;
        }
      });
      this.modalViewField = false;
      this.oldValueMax = null;
      this.oldValueMin = null;
    },
    onModalCloseField: function onModalCloseField() {
      var _this9 = this;

      var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == _this9.currentPhaseType;
      })[0];
      phase.active = true;
      if (this.currentPhaseType == 1) {
        this.masteringMinFieldCount = this.oldValueMin;
        this.masteringMaxFieldCount = this.oldValueMax;
      }
      if (this.currentPhaseType == 2) {
        this.rotationMinFieldCount = this.oldValueMin;
        this.rotationMaxFieldCount = this.oldValueMax;
      }
      if (this.currentPhaseType == 4) {
        this.fluencyMinFieldCount = this.oldValueMin;
        this.fluencyMaxFieldCount = this.oldValueMax;
      }
      this.modalViewField = false;
      this.oldValueMax = null;
      this.oldValueMin = null;
    },


    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeStages: function changeStages(data) {
      var _this10 = this;

      var canChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var current, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                current = _this10.currentStage;
                _context.next = 3;
                return _this10.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result && !canChange) {
                  _this10.changeStages(current, true);
                }
                if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default()(data.tasks) && Array.isArray(data.tasks)) {
                  _this10.tasks = data.tasks;
                }
                _this10.currentStage = data;
                _this10.currentStageTitle = data.title;
                _this10.currentStageIndex = _this10.getCurrentStageIndex(data.title);
                _this10.currentStage.type = data.type;
                if (_this10.changeFromClient) {
                  _this10.disabledChange = data.isNew ? false : true;
                }
                _this10.tempCurrentStageAttemptCount = _this10.currentStage.attemptCount;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },


    addTask: function addTask(addStimulusItem) {
      var _this11 = this;

      if (!addStimulusItem) {
        return;
      }

      var unique = true;

      var stimulList = this.protocol.globalTasks;

      __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(stimulList, function (stimul) {
        if (__WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(addStimulusItem.toLowerCase())) {
          unique = false;
        }
      });

      if (unique) {
        this.currentStage.isNew = true;

        var position = __WEBPACK_IMPORTED_MODULE_19_lodash_parseInt___default()(this.tasks.length) + 1;
        var uuid = __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4();

        this.tasks.unshift({
          'id': null,
          'stageId': null,
          'typeId': 1,
          'globalTaskId': null,
          'fieldIndex': __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
            return item.active;
          })[0].minFieldCount,
          'phaseType': __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
            return item.active;
          })[0].typeId,
          'position': position,
          'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
          'description': addStimulusItem,
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': uuid
        });

        this.protocol.globalTasks.push({
          'id': null,
          'stageId': null,
          'typeId': 1,
          'fieldIndex': 1,
          'phaseType': 1,
          'position': position,
          'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
          'description': addStimulusItem,
          'isNew': true,
          'active': false,
          'uuid': uuid
        });

        __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(this.protocol.stages, function (value, index) {
          if (_this11.currentStageIndex != index && !value.isClosed) {
            value.tasks.push({
              'id': null,
              'stageId': null,
              'typeId': 1,
              'phaseType': __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(value.phases, function (item) {
                return item.active;
              })[0].typeId,
              'globalTaskId': null,
              'fieldIndex': __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(value.phases, function (item) {
                return item.active;
              })[0].minFieldCount,
              'position': position,
              'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
              'description': addStimulusItem,
              'isNew': true,
              'active': false,
              'uuid': __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4(),
              'globalUuid': uuid
            });
          }
        });

        this.addStimulusItem = null;
        this.changeCanPublish();
      } else {
        this.errors.add({
          field: 'addStimulusItem',
          msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
        });
      }
    },

    editProtocol: function editProtocol() {
      this.$emit('editProtocol');
    },
    createProtocol: function createProtocol() {
      this.$emit('createProtocol');
    },
    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    reindexStages: function reindexStages() {
      this.tasks.forEach(function (item, index) {
        var position = __WEBPACK_IMPORTED_MODULE_19_lodash_parseInt___default()(index);
        item['position'] = __WEBPACK_IMPORTED_MODULE_19_lodash_parseInt___default()(index);
      });
    },

    validatePhases: function validatePhases() {
      var _this12 = this;

      var countActivePhase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.active;
      }).length;
      if (!this.masteringActive & !this.rotationActive & !this.intervalsActive & !this.fluencyActive) {
        this.errorPhaseCount = true;
        setTimeout(function () {
          _this12.$refs.errorPhase.scrollIntoView();
        }, 100);
      } else {
        this.errorPhaseCount = false;
      }
      return countActivePhase;
    },

    hideTasks: function hideTasks() {
      var _this13 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, valid, protocol, intervals, intervalLenght, mastering, rotation, fluency;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this13.intervalError = false;
                _this13.disabled = true;
                _context2.next = 4;
                return _this13.$validator.validateAll();

              case 4:
                result = _context2.sent;
                valid = _this13.validatePhases();
                protocol = _this13.protocol;

                protocol.stages[_this13.currentStageIndex] = _this13.currentStage;

                if (!(!result || !valid)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                intervals = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(protocol.stages[_this13.currentStageIndex].phases, function (item) {
                  return item.typeId == 3;
                })[0];
                intervalLenght = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(_this13.intervals, function (val) {
                  return val.checked;
                });

                if (!(!intervalLenght.length && _this13.intervalsActive)) {
                  _context2.next = 16;
                  break;
                }

                _this13.intervalError = true;
                _this13.disabled = false;
                return _context2.abrupt('return');

              case 16:

                intervals.intervals = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(_this13.intervals, function (val) {
                  return val.checked;
                });

                mastering = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(protocol.stages[_this13.currentStageIndex].phases, function (item) {
                  return item.typeId == 1;
                })[0];
                rotation = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(protocol.stages[_this13.currentStageIndex].phases, function (item) {
                  return item.typeId == 2;
                })[0];
                fluency = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(protocol.stages[_this13.currentStageIndex].phases, function (item) {
                  return item.typeId == 4;
                })[0];


                mastering.taskType = _this13.masteringTaskType;
                rotation.taskType = _this13.rotationTaskType;
                fluency.taskType = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(_this13.taskTypes, function (item) {
                  return item.id == 1;
                })[0];

                mastering.transferCondition.id = _this13.masteringTransferCondition;
                rotation.transferCondition.id = _this13.rotationTransferCondition;
                fluency.transferCondition.id = _this13.fluencyTransferCondition;
                _this13.setTransferCondition(mastering.transferCondition, _this13.masteringConditionTransfer);
                _this13.setTransferCondition(rotation.transferCondition, _this13.rotationConditionTransfer);
                _this13.setTransferCondition(fluency.transferCondition, _this13.fluencyConditionTransfer);

                if (hide && _this13.hintListMastering[2].active || _this13.hintListMastering[3].active || _this13.hintListMastering[4].active || _this13.hintListMastering[5].active) {
                  _this13.hintListMastering[1].active = false;
                }

                if (hide && _this13.hintListRotation[2].active || _this13.hintListRotation[3].active || _this13.hintListRotation[4].active || _this13.hintListRotation[5].active) {
                  _this13.hintListRotation[1].active = false;
                }

                mastering.taskPrompts = _this13.hintListMastering;
                rotation.taskPrompts = _this13.hintListRotation;

                mastering.isPromptEnabled = _this13.masteringVisible;
                rotation.isPromptEnabled = _this13.rotationVisible;

                mastering.minFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.masteringMinFieldCount);
                rotation.minFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.rotationMinFieldCount);
                fluency.minFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.fluencyMinFieldCount);

                mastering.maxFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.masteringMaxFieldCount);
                rotation.maxFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.rotationMaxFieldCount);
                fluency.maxFieldCount = __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(_this13.fluencyMaxFieldCount);

                mastering.active = _this13.masteringActive;
                rotation.active = _this13.rotationActive;
                fluency.active = _this13.fluencyActive;
                intervals.active = _this13.intervalsActive;

                protocol.stages[_this13.currentStageIndex].changed = true;

                protocol.stages[_this13.currentStageIndex].tasks = _this13.tasks;

                _this13.disabled = false;
                _this13.reindexStages();

                setTimeout(function () {
                  _this13.protocol = protocol;
                  if (hide) {
                    _this13.afterLoad = false;
                    _this13.$emit('hideTasks');
                  }
                  _this13.protocolChanged();
                }, 100);

              case 50:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this13);
      }))();
    },


    setStageGenerate: function setStageGenerate() {
      if (!this.currentStage.hasOwnProperty('generate')) {
        this.currentStage['generate'] = {
          type: this.getSpoType(4),
          attempts: this.currentStage.attemptCount,
          answer: '-'
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(this.currentStage.generate.type)) {
        this.currentStage.generate.type = this.getSpoType(4);
      }

      if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNull___default()(this.currentStage.generate.attempts)) {
        this.currentStage.attemptCount = this.currentStage.generate.attempts;
      }
    },

    deleteStageGenerate: function deleteStageGenerate() {
      if (this.currentStage.hasOwnProperty('generate')) {
        delete this.currentStage.generate;
      }
    },

    getSpoType: function getSpoType(id) {
      var types = this.spoTaskTypes.filter(function (taskType) {
        return taskType.id === id;
      });

      return types.shift();
    },

    setTransferCondition: function setTransferCondition(condition, conditionValue) {

      if (condition.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
        condition['trialCount'] = conditionValue.trialCount;
      } else if (condition.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
        condition['sessionCount'] = conditionValue.sessionCount;
      } else if (condition.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO) {
        condition['ratio'] = conditionValue.ratio;
        condition['trialCount'] = conditionValue.conditionTrial;
        condition['sessionCount'] = conditionValue.conditionSession;
      }
    },
    getTransferCondition: function getTransferCondition(condition, conditionValue) {

      if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].TRIAL_IN_A_ROW) {
        condition.trialCount = conditionValue.trialCount;
      } else if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].SESSION_IN_A_ROW) {
        condition.sessionCount = conditionValue.sessionCount;
      } else if (conditionValue.id == __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].RATIO) {
        condition.ratio = conditionValue.ratio;
        condition.conditionTrial = conditionValue.trialCount;
        condition.conditionSession = conditionValue.sessionCount;
      }
    }
  },

  created: function created() {
    var _this14 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }

    this.taskTypesList = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.taskTypes, function (o) {
      return o.id == 1 || o.id == 4;
    });

    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.taskTypesList, function (type) {
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(_this14.coldSampleIds, type.id)) {
        _this14.spoTaskTypes.push(type);
      }
    });

    this.currentStage = __WEBPACK_IMPORTED_MODULE_16_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);
    this.currentStage.phases = __WEBPACK_IMPORTED_MODULE_20_lodash_sortBy___default()(this.currentStage.phases, 'position');

    this.currentStageTitle = this.currentStage.title;
    if (this.currentStage.generate) {}
    this.taskType = this.currentStage.type;

    if (!this.taskTypesList) {
      var index = 0;
      if (this.selectedTaskTypeTitle) {
        index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.taskTypesList, function (task) {
          return task.title === _this14.selectedTaskTypeTitle;
        });
      }
      this.taskType = this.taskTypesList[index];
    }

    this.tasks = this.currentStage.tasks;

    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.tasks, function (task) {

      var phase = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(_this14.currentStage.phases, function (item) {
        return item.typeId == task.typeId;
      })[0];

      if (phase && task.fieldIndex < phase.minFieldCount) {
        task.fieldIndex = phase.withFields ? phase.minFieldCount : 1;
      }

      //task.fieldIndex = phase.withFields ? phase.minFieldCount : 1
    });

    var intervals = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 3;
    })[0].intervals;

    if (intervals.length) {

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(intervals, function (item) {
        var index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(_this14.intervals, {
          typeId: item.type ? item.type.id : item.typeId
        });

        _this14.intervals[index].id = item.id;
        _this14.intervals[index].phaseId = item.phaseId;
        _this14.intervals[index].count = item.count.toString();
        _this14.intervals[index].checked = true;
      });
    } else {
      this.intervals[0].checked = true;
    }

    this.mastering = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 1;
    })[0];
    this.mastering.title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_mastering');
    this.rotation = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 2;
    })[0];
    this.rotation.title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_rotation');
    this.fluency = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 4;
    })[0];
    this.fluency.title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_fluency');
    this.intervalsList = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 3;
    })[0];
    this.intervalsList.title = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_support');

    this.fluency.executionSecondsLimit = this.fluency.executionSecondsLimit ? this.fluency.executionSecondsLimit.toString() : '3';

    var masteringCondition = this.mastering ? this.mastering.transferCondition : null;
    var rotationCondition = this.rotation ? this.rotation.transferCondition : null;
    var fluencyCondition = this.fluency ? this.fluency.transferCondition : null;

    this.masteringTransferCondition = masteringCondition.id ? masteringCondition.id : __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
    this.rotationTransferCondition = rotationCondition.id ? rotationCondition.id : __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;
    this.fluencyTransferCondition = fluencyCondition.id ? fluencyCondition.id : __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL;

    if (masteringCondition.id != __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL) this.getTransferCondition(this.masteringConditionTransfer, masteringCondition);
    if (rotationCondition.id != __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL) this.getTransferCondition(this.rotationConditionTransfer, rotationCondition);
    if (fluencyCondition.id != __WEBPACK_IMPORTED_MODULE_21__protocols_constants_js__["e" /* TRANSFER_CONDITION */].ONE_TRIAL) this.getTransferCondition(this.fluencyConditionTransfer, fluencyCondition);

    this.masteringTaskType = this.mastering.taskType;
    this.rotationTaskType = this.rotation.taskType;

    this.masteringActive = this.mastering.active;
    this.rotationActive = this.rotation.active;
    this.intervalsActive = this.intervalsList.active;
    this.fluencyActive = this.fluency.active;

    this.masteringMinFieldCount = this.mastering.minFieldCount;
    this.rotationMinFieldCount = this.rotation.minFieldCount;
    this.fluencyMinFieldCount = this.fluency.minFieldCount;

    this.masteringMaxFieldCount = this.mastering.maxFieldCount;
    this.rotationMaxFieldCount = this.rotation.maxFieldCount;
    this.fluencyMaxFieldCount = this.fluency.maxFieldCount;

    this.hintListMastering = this.mastering.taskPrompts;
    this.hintListRotation = this.rotation.taskPrompts;

    this.masteringVisible = this.mastering.isPromptEnabled;
    this.rotationVisible = this.rotation.isPromptEnabled;

    this.changeStages(this.currentStage);
    this.setStageGenerate();

    setTimeout(function () {
      _this14.afterLoad = true;
    }, 100);

    __WEBPACK_IMPORTED_MODULE_11_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('validation.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_12_lodash_forIn___default()(_this14.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context3.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this14);
        }));

        return function validate(_x3) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  },


  watch: {
    masteringTransferCondition: function masteringTransferCondition(newValue, oldValue) {
      if (oldValue) {
        var mastering = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 1;
        })[0];
        mastering.transferCondition.id = newValue;
        this.setTransferCondition(mastering.transferCondition, this.masteringConditionTransfer);
      }
    },
    rotationTransferCondition: function rotationTransferCondition(newValue, oldValue) {
      if (oldValue) {
        var rotation = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 2;
        })[0];
        rotation.transferCondition.id = newValue;
        this.setTransferCondition(rotation.transferCondition, this.rotationConditionTransfer);
      }
    },
    fluencyTransferCondition: function fluencyTransferCondition(newValue, oldValue) {
      if (oldValue) {
        var fluency = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 4;
        })[0];
        fluency.transferCondition.id = newValue;
        this.setTransferCondition(fluency.transferCondition, this.fluencyConditionTransfer);
      }
    },
    masteringActive: function masteringActive(newValue) {

      if (this.afterLoad) {

        var mastering = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 1;
        })[0];

        if (!newValue) {
          var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
            return task.phaseType == 1;
          }).length;

          if (taskCount) {
            this.modalView = true;
            this.phaseName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.mastering');
            this.currentPhaseType = 1;
          } else {
            mastering.active = newValue;
          }
        } else {
          mastering.active = newValue;
          this.errorPhaseCount = false;
        }
      }
    },
    rotationActive: function rotationActive(newValue) {
      if (this.afterLoad) {
        var rotation = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 2;
        })[0];

        if (!newValue) {
          var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
            return task.phaseType == 2;
          }).length;

          if (taskCount) {
            this.modalView = true;
            this.phaseName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.rotation');
            this.currentPhaseType = 2;
          } else {
            rotation.active = newValue;
          }
        } else {
          rotation.active = newValue;
          this.errorPhaseCount = false;
        }
      }
    },
    fluencyActive: function fluencyActive(newValue) {
      if (this.afterLoad) {
        var fluency = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 4;
        })[0];

        if (!newValue) {
          var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
            return task.phaseType == 4;
          }).length;

          if (taskCount) {
            this.modalView = true;
            this.phaseName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.fluency');
            this.currentPhaseType = 4;
          } else {
            fluency.active = newValue;
          }
        } else {
          fluency.active = newValue;
          this.errorPhaseCount = false;
        }
      }
    },
    intervalsActive: function intervalsActive(newValue) {
      if (this.afterLoad) {
        var intervals = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.currentStage.phases, function (item) {
          return item.typeId == 3;
        })[0];

        if (!newValue) {
          var taskCount = __WEBPACK_IMPORTED_MODULE_17_lodash_filter___default()(this.tasks, function (task) {
            return task.phaseType == 3;
          }).length;

          if (taskCount) {
            this.modalView = true;
            this.phaseName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.support');
            this.currentPhaseType = 3;
          } else {
            intervals.active = newValue;
          }
        } else {
          intervals.active = newValue;
          this.errorPhaseCount = false;
        }
      }
    }
  }

});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDTTModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: [Object, Array],
      default: function _default() {
        return null;
      }
    },
    'stimul': {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    'intervals': {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */]
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },

  data: function data() {
    return {
      isLoaded: true,
      disabled: false,
      phases: [],
      phaseTask: null,
      field: null,
      fieldList: null,
      interval: null,
      intervalList: null,
      currentPhase: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var currentPhase, phase;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.data) {

                _this.phases = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.active;
                });
                currentPhase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.typeId == _this.stimul.phaseType;
                })[0];

                if (currentPhase.active) {
                  _this.phaseTask = currentPhase;
                  _this.field = _this.stimul.fieldIndex ? _this.stimul.fieldIndex.toString() : '1';
                } else {
                  //this.phaseTask = this.phases[0];
                  _this.currentPhase = currentPhase.title;
                  _this.disabled = true;
                }

                phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.typeId == 3;
                })[0];


                __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(phase.intervals, function (item) {
                  var index = __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default()(_this.intervals, {
                    typeId: item.type ? item.type.id : item.typeId
                  });

                  _this.intervals[index].id = item.id;
                  _this.intervals[index].phaseId = item.phaseId;
                  _this.intervals[index].count = item.count.toString();
                });

                _this.intervalList = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.intervals, function (item) {
                  return item.checked;
                });
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, phaseTypeId, interval, field, label;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context2.abrupt('return');

              case 7:
                phaseTypeId = _this2.phaseTask ? _this2.phaseTask.typeId : null;
                interval = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this2.intervalList, function (item) {
                  return item.typeId == _this2.interval;
                })[0];
                field = _this2.field;
                label = _this2.fieldList ? _this2.fieldList[0] : null;

                field = _this2.field ? _this2.field : label;

                _this2.$emit('save', phaseTypeId, field, interval);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('close');
    }
  },
  watch: {
    phaseTask: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(val) {
        var _this3 = this;

        var phase, fieldList, min, max, i, firstInterval, field, label;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (val) {
                  phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(this.data, function (item) {
                    return item.typeId == val.typeId;
                  })[0];

                  this.disabled = false;
                  fieldList = null;

                  if (phase.minFieldCount && phase.withFields) {
                    fieldList = [];
                    min = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.minFieldCount);
                    max = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.maxFieldCount);

                    for (i = min; i <= max; i++) {
                      fieldList.push(i);
                    }
                  }
                  if (phase.intervals) {
                    firstInterval = this.intervalList[0] ? this.intervalList[0].typeId.toString() : null;

                    this.interval = this.stimul && this.stimul.intervalType ? this.stimul.intervalType.toString() : firstInterval;
                  }

                  this.fieldList = fieldList;
                  field = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(fieldList, function (val) {
                    return val == _this3.stimul.fieldIndex;
                  });
                  label = this.fieldList ? this.fieldList[0].toString() : null;

                  this.field = this.stimul.fieldIndex && field.length > 0 ? this.stimul.fieldIndex.toString() : label;
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function phaseTask(_x) {
        return _ref.apply(this, arguments);
      }

      return phaseTask;
    }()
  }

});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDTTModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: [Object, Array],
      default: function _default() {
        return null;
      }
    },
    'stimulList': {
      type: [Array],
      default: function _default() {
        return {};
      }
    },
    'intervals': {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */]
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },

  data: function data() {
    return {
      isLoaded: true,
      disabled: false,
      phases: [],
      phaseTask: null,
      field: null,
      fieldList: null,
      interval: null,
      intervalList: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var phase;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.data) {

                _this.phases = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.active;
                });
                _this.phaseTask = _this.phases[0];
                _this.field = _this.fieldList ? _this.fieldList[0] : null;

                phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.typeId == 3;
                })[0];


                __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(phase.intervals, function (item) {
                  var index = __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default()(_this.intervals, {
                    typeId: item.type ? item.type.id : item.typeId
                  });

                  _this.intervals[index].id = item.id;
                  _this.intervals[index].phaseId = item.phaseId;
                  _this.intervals[index].count = item.count.toString();
                });

                _this.intervalList = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.intervals, function (item) {
                  return item.checked;
                });
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, phaseTypeId, interval, field, label;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context2.abrupt('return');

              case 7:
                phaseTypeId = _this2.phaseTask ? _this2.phaseTask.typeId : null;
                interval = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this2.intervalList, function (item) {
                  return item.typeId == _this2.interval;
                })[0];
                field = _this2.field;
                label = _this2.fieldList ? _this2.fieldList[0] : null;

                field = _this2.field ? _this2.field : label;

                _this2.$emit('save', phaseTypeId, field, interval);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('close');
    }
  },
  watch: {
    phaseTask: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(val) {
        var phase, fieldList, min, max, i, firstInterval;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (val) {
                  phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(this.data, function (item) {
                    return item.typeId == val.typeId;
                  })[0];

                  this.disabled = false;
                  fieldList = null;

                  if (phase.minFieldCount && phase.withFields) {
                    fieldList = [];
                    min = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.minFieldCount);
                    max = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.maxFieldCount);

                    for (i = min; i <= max; i++) {
                      fieldList.push(i);
                    }
                  }
                  if (phase.intervals) {
                    firstInterval = this.intervalList[0] ? this.intervalList[0].typeId.toString() : null;

                    this.interval = this.stimul && this.stimul.intervalType ? this.stimul.intervalType.toString() : firstInterval;
                  }

                  this.fieldList = fieldList;
                  this.field = this.fieldList ? this.fieldList[0].toString() : null;
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function phaseTask(_x) {
        return _ref.apply(this, arguments);
      }

      return phaseTask;
    }()
  }

});

/***/ }),
/* 570 */,
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { draggable: __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default.a, Hints: __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__["a" /* default */] },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedStagesTitle', 'changeFromClient'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      mands: [],
      mandList: [],
      modal: null,
      mand: null,
      selected: {},
      disabledChange: false,
      stimulList: [],
      isModalVisible: false,
      isStimulVisible: false,
      intervalId: null,
      addMandReactionItem: null,
      recordedReactionsList: [],
      isPromptEnableList: 0,
      errorRecordedReactionsList: false,
      masteringConditions: {
        stageId: null,
        ratio: '100',
        trialCount: '3',
        sessionCount: '1',
        answerDirectory: { id: 1 }
      },
      masteringCondition: null,
      masteringConditionAnswer: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA'])),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      this.intervalId = window.setInterval(function () {
        _this.hideMands();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },


    fetchMasteringCondition: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var response, current;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'mand/stage-mastering-condition-answer-directories/');

              case 3:
                response = _context.sent;

                this.masteringCondition = response.data.data;
                current = this.masteringCondition[0];


                if (this.currentStage.masteringCondition && this.currentStage.masteringCondition.answerDirectory.id) {
                  current = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.masteringCondition, function (item) {
                    return item.id == _this2.currentStage.masteringCondition.answerDirectory.id;
                  })[0];
                }

                this.masteringConditionAnswer = current;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function fetchMasteringCondition() {
        return _ref.apply(this, arguments);
      }

      return fetchMasteringCondition;
    }(),

    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    labelMand: function labelMand(title, description) {
      return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get(title) + ' (' + description + ')';
    },

    masteredMand: function masteredMand(mand) {
      if (mand.mastered) {
        var mandCurrent = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.mands, function (item) {
          return item.globalUuid == mand.globalUuid;
        })[0];

        mandCurrent.position = this.mands.length + 1;

        this.mands = __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default()(this.mands, 'position');

        this.reindexMands();
      }
    },


    reindexMands: function reindexMands() {
      this.mands.forEach(function (item, index) {
        var position = parseInt(index) + 1;
        item['position'] = parseInt(index);
      });
    },

    changeRecordedReactions: function changeRecordedReactions() {
      var list = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.recordedReactionsList, function (item) {
        return item.isPrompt && item.checked;
      });

      this.isPromptEnableList = list.length;
    },


    addMand: function addMand(addMandReactionItem) {
      if (!addMandReactionItem) {
        return;
      }

      var unique = true;

      var mandReactionsList = this.protocol.globalMandReactions;

      __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(mandReactionsList, function (stimul) {
        if (__WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(addMandReactionItem.toLowerCase())) {
          unique = false;
        }
      });

      if (unique) {
        this.currentStage.isNew = true;

        var position = parseInt(this.mands.length) + 1;
        var uuid = __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4();

        this.mands.unshift({
          'position': position,
          'globalUuid': uuid,
          'description': addMandReactionItem,
          'mastered': false,
          'active': true
        });

        this.protocol.globalMandReactions.push({
          'position': position,
          'mastered': false,
          'title': __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.mands') + ' ' + position,
          'description': addMandReactionItem,
          'active': false,
          'uuid': uuid
        });

        this.addMandReactionItem = null;
        this.changeCanPublish();
      } else {
        this.errors.add({
          field: 'addMandReactionItem',
          msg: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
        });
      }
    },

    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },


    hintsUpdate: function hintsUpdate() {
      if (this.currentStage.taskPrompts[2].active || this.currentStage.taskPrompts[3].active || this.currentStage.taskPrompts[4].active || this.currentStage.taskPrompts[5].active) {
        this.currentStage.taskPrompts[1].active = false;
      }
    },

    hideMands: function hideMands() {
      var _this3 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, recordedReactionsList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$validator.validateAll();

              case 2:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 18;
                  break;
                }

                _this3.reindexMands();
                _this3.hintsUpdate();

                _this3.currentStage.mands = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this3.mands, function (item) {
                  return item.active;
                });

                _this3.currentStage.masteringCondition.answerDirectory = {
                  id: _this3.masteringConditionAnswer.id
                };

                _this3.currentStage.masteredMands = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this3.mands, function (item) {
                  return item.mastered;
                });

                recordedReactionsList = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this3.recordedReactionsList, function (item) {
                  return item.checked;
                });


                _this3.currentStage.recordedReactions = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(recordedReactionsList, function (reactions) {
                  return reactions.id;
                });

                if (recordedReactionsList.length) {
                  _context2.next = 16;
                  break;
                }

                _this3.errorRecordedReactionsList = true;
                return _context2.abrupt('return');

              case 16:
                _this3.errorRecordedReactionsList = false;

              case 17:

                setTimeout(function () {
                  _this3.protocol.stages[_this3.currentStageIndex] = _this3.currentStage;
                  if (hide) {
                    _this3.afterLoad = false;
                    _this3.$emit('hideMands');
                  }
                  _this3.protocolChanged();
                }, 100);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },

  created: function created() {
    var _this4 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }
    this.selected = this.protocol.stages[this.currentStageIndex];
    this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
    this.currentStage = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    var mandList = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.globalMandReactions);

    this.mands = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(mandList, function (mand) {

      var currentMand = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.currentStage.mands, function (item) {
        return item.globalUuid == mand.uuid;
      });

      mand.active = currentMand.length == 1;
      mand.position = currentMand.length ? currentMand[0].position : mand.position;
      mand.globalUuid = mand.uuid;
      mand.canBeMarkedAsMastered = currentMand.length ? currentMand[0].canBeMarkedAsMastered : false;

      mand.mastered = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.currentStage.masteredMands, function (item) {
        return item.globalUuid == mand.uuid;
      }).length == 1;

      delete mand['uuid'];

      return mand;
    });

    this.mands = __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default()(this.mands, 'position');

    this.recordedReactionsList = this.taskTypes[0].answers;

    this.recordedReactionsList = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(this.recordedReactionsList, function (reactions) {

      var currentReaction = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(_this4.currentStage.recordedReactions, function (id) {
        return id == reactions.id;
      });

      if (currentReaction >= 0) {
        reactions.checked = true;
      }

      return reactions;
    });

    this.changeRecordedReactions();
    this.fetchMasteringCondition();

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('unique_mand', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.unique_mand', { attribute: attribute });
      },
      validate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(mand) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(_this4.mands, function (item) {
                    if (item.description === mand) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context3.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }));

        return function validate(_x2) {
          return _ref2.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isString__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_join__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNull__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ConfirmModal__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isInteger__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_isInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_parseInt__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_parseInt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_parseInt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AddHintModal__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TaskUSDModal__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





























/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ConfirmModal: __WEBPACK_IMPORTED_MODULE_14__ConfirmModal__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_21_vuedraggable___default.a, AddHintModal: __WEBPACK_IMPORTED_MODULE_22__AddHintModal__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_28__loader_components_Loader__["a" /* default */], TaskUsdModal: __WEBPACK_IMPORTED_MODULE_23__TaskUSDModal__["a" /* default */] },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedTaskTypeTitle', 'selectedStagesTitle', 'changeFromClient', 'showDeleteButton', 'transferConditionValue'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: null,
      intervalError: false,
      addStimulusItem: null,
      selected: {},
      taskType: {},
      taskTypesList: [],
      tempCurrentStageAttemptCount: null,
      coldSampleIds: [1, 5],
      baseColdSample: 5,
      spoTaskTypes: [],
      disabledChange: false,
      errorPhaseCount: false,
      stimulList: [],
      isModalVisible: false,
      modal: null,
      stimul: null,
      isStimulVisible: false,
      dragging: false,
      modalView: false,
      afterLoad: false,
      hintLevel: null,
      hintLevelList: [],
      isModalHintVisible: false,
      selectedGroup: null,
      masteredLevels: null,
      mastering: null,
      isLoaded: false,
      isModalAcceptPopup: false,
      deletedSetItem: '',
      isModalDisablePopup: false,
      activeTask: null,
      intervals: [{ typeId: 1, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.through_each_lesson'), count: '3', checked: false, stimuli: [] }, { typeId: 2, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_one_lesson'), count: '3', checked: false, stimuli: [] }, { typeId: 3, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_two_classes'), count: '3', checked: false, stimuli: [] }, { typeId: 4, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.after_three_classes'), count: '3', checked: false, stimuli: [] }, { typeId: 5, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_a_week'), count: '3', checked: false, stimuli: [] }, { typeId: 6, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_every_two_weeks'), count: '3', checked: false, stimuli: [] }, { typeId: 7, name: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.once_a_month'), count: '3', checked: false, stimuli: [] }],
      phases: [],
      condition_list: [9, 18, 27],
      acceptDeleteSetPopup: false,
      selectedIndex: null,
      selectedGroupIndex: null,
      msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.enable_recording')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_29_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA']), {

    isEmptySelectedStage: function isEmptySelectedStage() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.selectedStage);
    },
    taskTypesNew: function taskTypesNew() {
      var _this = this;

      return this.taskTypes.filter(function (item) {
        return item.title !== _this.taskType.title;
      });
    },
    spoTaskTypesNew: function spoTaskTypesNew() {
      var _this2 = this;

      return this.spoTaskTypes.filter(function (item) {
        return item.title !== _this2.spoTaskTypes.title;
      });
    },
    protocolStages: function protocolStages() {
      var _this3 = this;

      return this.protocol.stages.filter(function (item) {
        return item.title !== _this3.currentStage.title;
      });
    },
    activeStimulList: function activeStimulList() {
      return this.tasks.filter(function (item) {
        return !item.levelUuid && item.phaseTypeId !== 3 && item.active;
      });
    }
  }),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this4 = this;

      this.intervalId = window.setInterval(function () {
        _this4.hideTasks();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    acceptDeleteSet: function acceptDeleteSet(index, groupIndex) {
      this.selectedIndex = index;
      this.selectedGroupIndex = groupIndex;
      this.acceptDeleteSetPopup = true;
    },
    closeAcceptDeleteSetPopup: function closeAcceptDeleteSetPopup() {
      this.deleteGroup(this.selectedIndex, this.selectedGroupIndex);
      this.cancelAcceptDeleteSetPopup();
    },
    cancelAcceptDeleteSetPopup: function cancelAcceptDeleteSetPopup() {
      this.acceptDeleteSetPopup = false;
    },
    levelTitle: function levelTitle(index) {
      return __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.level') + ' ' + (index + 1) + ':';
    },
    onModalSave: function onModalSave(phaseTask, interval) {
      var _this5 = this;

      var support = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == 3;
      })[0];
      var mastering = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.currentStage.phases, function (item) {
        return item.typeId == 5;
      })[0];
      var intervalCurrent = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(support.intervals, function (item) {
        return _this5.stimul.intervalTypeId ? item.typeId === _this5.stimul.intervalTypeId : item.typeId === 1;
      })[0];

      if (this.stimul.phaseTypeId && this.stimul.phaseTypeId !== phaseTask) {

        if (this.stimul.phaseTypeId === 5 && this.stimul.levelUuid) {
          this.deleteSet(this.stimul);
        }
      }

      if (intervalCurrent && intervalCurrent.stimuli) {

        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(support.intervals, function (interval) {

          var stimulIndex = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(interval.stimuli, function (item) {
            return item.globalUuid == _this5.stimul.globalUuid;
          });

          if (stimulIndex >= 0 && interval.stimuli.length) {
            interval.stimuli.splice(stimulIndex, 1);
          }
        });
      }

      var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (task) {
        return task.globalUuid === _this5.stimul.globalUuid;
      })[0];

      this.$set(currentTask, 'phaseTypeId', phaseTask);
      if (interval) {
        this.$set(currentTask, 'intervalTypeId', __WEBPACK_IMPORTED_MODULE_26_lodash_toInteger___default()(interval.typeId));
      }

      if (phaseTask == 3) {
        var newInterval = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(support.intervals, function (item) {
          return item.typeId === interval.typeId;
        })[0];

        newInterval.stimuli.push(currentTask);
      }

      if (phaseTask == 5) {

        if (mastering && !mastering.stimuli) {
          this.$set(mastering, 'stimuli', []);
        }

        mastering.stimuli.push(currentTask);
      }
      this.isModalVisible = false;
    },
    onModalCancel: function onModalCancel() {
      this.isModalHintVisible = false;
    },
    onModalUSDClose: function onModalUSDClose() {
      this.isModalVisible = false;
    },
    changeStimul: function changeStimul() {
      this.isModalAcceptPopup = false;
      this.isModalVisible = true;
    },
    deleteSet: function deleteSet(stimul) {
      var _this6 = this;

      var level = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.mastering.levels, function (level) {
        return level.uuid == stimul.levelUuid;
      })[0];

      var groupIndex = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(level.groups, function (group) {
        return group.uuid == stimul.levelGroupUuid;
      });

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(level.groups[groupIndex].stimuli, function (item) {

        var deleteTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this6.tasks, function (deteted) {
          return deteted.globalUuid == item.globalUuid;
        })[0];

        delete deleteTask['levelUuid'];
      });

      var listSetTasks = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (task) {
        return stimul.levelGroupUuid === task.levelGroupUuid;
      });

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(listSetTasks, function (task) {
        delete task['levelUuid'];
        delete task['levelGroupUuid'];
      });

      level.groups.splice(groupIndex, 1);
    },
    disableStimul: function disableStimul() {
      this.deleteSet(this.activeTask);
      this.isModalDisablePopup = false;
    },
    closeStimul: function closeStimul() {
      this.isModalAcceptPopup = false;
    },
    closeDisableStimul: function closeDisableStimul() {
      var _this7 = this;

      var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (task) {
        return task.globalUuid === _this7.activeTask.globalUuid;
      })[0];
      currentTask.active = true;
      this.isModalDisablePopup = false;
    },
    onModalClose: function onModalClose(selectedStimulList) {
      var _this8 = this;

      var uuid = __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4();

      __WEBPACK_IMPORTED_MODULE_27_lodash_map___default()(this.tasks, function (task) {

        var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(selectedStimulList, function (item) {
          return item.globalUuid == task.globalUuid;
        });

        if (currentTask.length) {
          _this8.$set(task, 'levelUuid', _this8.mastering.levels[_this8.selectedGroup].uuid);
          _this8.$set(task, 'levelGroupUuid', uuid);
          _this8.$set(task, 'phaseTypeId', 5);
        }

        return task;
      });

      if (!this.mastering.levels[this.selectedGroup].groups) {
        this.mastering.levels[this.selectedGroup].groups = [];
      }

      this.mastering.levels[this.selectedGroup].groups.push({
        uuid: uuid,
        description: "набор " + this.mastering.levels[this.selectedGroup].groups.length,
        index: this.mastering.levels[this.selectedGroup].groups.length,
        stimuli: selectedStimulList
      });

      this.isModalHintVisible = false;
    },
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.stimul = item;
      if (item.levelGroupUuid) {
        this.listDeletedSetItem(item.levelGroupUuid);
        this.isModalAcceptPopup = true;
      } else {
        this.isModalVisible = true;
      }
    },
    listDeletedSetItem: function listDeletedSetItem(levelGroupUuid) {
      var list = __WEBPACK_IMPORTED_MODULE_8_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_27_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (item) {
        return item.levelGroupUuid == levelGroupUuid;
      }), 'description'), ', ');
      this.deletedSetItem = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.delete_set') + '\r\n' + __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.set') + ': ' + list;
    },


    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    addTask: function addTask(addStimulusItem) {
      if (!addStimulusItem) {
        return;
      }

      var unique = true;

      var stimulList = this.protocol.globalTasks;

      __WEBPACK_IMPORTED_MODULE_13_lodash_forIn___default()(stimulList, function (stimul) {
        if (__WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_25_lodash_trim___default()(addStimulusItem.toLowerCase())) {
          unique = false;
        }
      });

      if (unique) {
        this.currentStage.isNew = true;

        var position = __WEBPACK_IMPORTED_MODULE_18_lodash_parseInt___default()(this.tasks.length) + 1;
        var uuid = __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4();

        this.tasks.unshift({
          'id': null,
          'stageId': null,
          'typeId': 1,
          'globalTaskId': null,
          'position': position,
          'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
          'description': addStimulusItem,
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': uuid
        });

        this.protocol.globalTasks.push({
          'id': null,
          'stageId': null,
          'fieldIndex': 1,
          'position': position,
          'title': __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.stimulus') + ' ' + position,
          'description': addStimulusItem,
          'isNew': true,
          'active': false,
          'uuid': uuid
        });

        this.addStimulusItem = null;
        this.changeCanPublish();
      } else {
        this.errors.add({
          field: 'addStimulusItem',
          msg: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
        });
      }
    },

    addLevel: function addLevel() {
      this.mastering.levels.push({
        uuid: __WEBPACK_IMPORTED_MODULE_24__common_uuid_UuidGenerator__["a" /* default */].v4(),
        description: '',
        index: this.mastering.levels.length + 1,
        groups: []
      });
    },
    removeLevel: function removeLevel(index) {
      this.mastering.levels.splice(index, 1);
    },
    addGroup: function addGroup(index) {
      this.selectedGroup = index;
      this.isModalHintVisible = true;
    },
    deleteGroup: function deleteGroup(index, groupIndex) {
      var _this9 = this;

      this.isLoaded = false;

      var group = this.mastering.levels[index].groups[groupIndex];

      __WEBPACK_IMPORTED_MODULE_27_lodash_map___default()(this.tasks, function (task, index) {

        var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(group.stimuli, function (item) {
          return item.globalUuid == task.globalUuid;
        });

        if (currentTask.length) {
          delete task['levelUuid'];
          delete task['levelGroupUuid'];
        }

        _this9.$set(_this9.tasks, index, task);

        return task;
      });

      this.mastering.levels[index].groups.splice(groupIndex, 1);
      this.isLoaded = true;
    },
    editProtocol: function editProtocol() {
      this.$emit('editProtocol');
    },
    createProtocol: function createProtocol() {
      this.$emit('createProtocol');
    },
    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    reindexStages: function reindexStages() {
      this.tasks.forEach(function (item, index) {
        var position = __WEBPACK_IMPORTED_MODULE_18_lodash_parseInt___default()(index);
        item['position'] = __WEBPACK_IMPORTED_MODULE_18_lodash_parseInt___default()(index);
      });
    },

    hideTasks: function hideTasks() {
      var _this10 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, protocol, intervals, intervalLenght;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this10.intervalError = false;
                _this10.disabled = true;
                _context.next = 4;
                return _this10.$validator.validateAll();

              case 4:
                result = _context.sent;
                protocol = _this10.protocol;

                protocol.stages[_this10.currentStageIndex] = _this10.currentStage;

                if (result) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                intervals = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(protocol.stages[_this10.currentStageIndex].phases, function (item) {
                  return item.typeId == 3;
                })[0];
                intervalLenght = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this10.intervals, function (val) {
                  return val.checked;
                });

                if (intervalLenght.length) {
                  _context.next = 15;
                  break;
                }

                _this10.intervalError = true;
                _this10.disabled = false;
                return _context.abrupt('return');

              case 15:

                intervals.intervals = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this10.intervals, function (val) {
                  return val.checked;
                });

                protocol.stages[_this10.currentStageIndex].changed = true;
                protocol.stages[_this10.currentStageIndex].stimuli = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this10.tasks, 'active');

                _this10.disabled = false;
                _this10.reindexStages();

                setTimeout(function () {
                  _this10.protocol = protocol;
                  if (hide) {
                    _this10.afterLoad = false;
                    _this10.$emit('hideTasks');
                  }
                  _this10.protocolChanged();
                }, 100);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },


    setStageGenerate: function setStageGenerate() {
      if (!this.currentStage.hasOwnProperty('generate')) {
        this.currentStage['generate'] = {
          type: this.getSpoType(4),
          attempts: this.currentStage.attemptCount,
          answer: '-'
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default()(this.currentStage.generate.type)) {
        this.currentStage.generate.type = this.getSpoType(4);
      }

      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNull___default()(this.currentStage.generate.attempts)) {
        this.currentStage.attemptCount = this.currentStage.generate.attempts;
      }
    },

    deleteStageGenerate: function deleteStageGenerate() {
      if (this.currentStage.hasOwnProperty('generate')) {
        delete this.currentStage.generate;
      }
    },

    getSpoType: function getSpoType(id) {
      var types = this.spoTaskTypes.filter(function (taskType) {
        return taskType.id === id;
      });

      return types.shift();
    },

    stimulDescrition: function stimulDescrition(globalUuid) {
      var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.protocol.globalTasks, function (item) {
        return item.uuid == globalUuid;
      });

      return currentTask.length ? currentTask[0].description : '';
    },
    currentIntervalType: function currentIntervalType(typeId) {
      var currentInterval = null;
      if (typeId) {
        currentInterval = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.intervals, function (interval) {
          return interval.typeId == typeId;
        })[0];
      } else {
        currentInterval = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.intervals, function (interval) {
          return interval.checked;
        })[0];
      }
      var currentIntervalName = currentInterval ? currentInterval.name : null;
      return currentIntervalName;
    },
    changeActive: function changeActive(task) {
      if (!task.active && task.levelGroupUuid) {
        this.listDeletedSetItem(task.levelGroupUuid);
        this.isModalDisablePopup = true;
        this.activeTask = task;
      }
    }
  },

  created: function created() {
    var _this11 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }

    this.taskTypesList = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.taskTypes, function (o) {
      return o.id == 1 || o.id == 4;
    });

    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.taskTypesList, function (type) {
      if (!__WEBPACK_IMPORTED_MODULE_11_lodash_includes___default()(_this11.coldSampleIds, type.id)) {
        _this11.spoTaskTypes.push(type);
      }
    });

    this.currentStage = __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    this.currentStageTitle = this.currentStage.title;
    this.taskType = this.currentStage.type;
    this.mastering = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.currentStage.phases, function (phase) {
      return phase.typeId == 5;
    })[0];

    this.support = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.currentStage.phases, function (phase) {
      return phase.typeId == 3;
    })[0];

    if (!this.taskTypesList) {
      var index = 0;
      if (this.selectedTaskTypeTitle) {
        index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(this.taskTypesList, function (task) {
          return task.title === _this11.selectedTaskTypeTitle;
        });
      }
      this.taskType = this.taskTypesList[index];
    }

    var taskList = __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default()(this.protocol.globalTasks);

    this.tasks = __WEBPACK_IMPORTED_MODULE_27_lodash_map___default()(taskList, function (task) {

      var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this11.currentStage.stimuli, function (item) {
        return item.globalUuid == task.uuid;
      });

      task.active = currentTask.length == 1;
      task.position = currentTask.length ? currentTask[0].position : task.position;
      task.globalUuid = task.uuid;
      if (task.active) {
        task.levelUuid = currentTask[0].levelUuid;
        task.levelGroupUuid = currentTask[0].levelGroupUuid;
        task.phaseTypeId = currentTask[0].phaseTypeId;
        task.intervalTypeId = currentTask[0].intervalTypeId;
      }

      delete task['uuid'];

      return task;
    });

    this.tasks = __WEBPACK_IMPORTED_MODULE_19_lodash_sortBy___default()(this.tasks, 'position');

    __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.currentStage.phases, function (phase) {
      var title = phase.typeId === 3 ? __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_support') : __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('protocol.phase_mastering');
      _this11.$set(phase, 'title', title);
    });

    var support = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.currentStage.phases, function (item) {
      return item.typeId == 3;
    });

    var intervals = support.length ? support[0].intervals : [];

    if (intervals.length) {

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(intervals, function (item) {
        var index = __WEBPACK_IMPORTED_MODULE_4_lodash_findIndex___default()(_this11.intervals, {
          typeId: item.type ? item.type.id : item.typeId
        });

        _this11.intervals[index].id = item.id;
        _this11.intervals[index].count = item.count.toString();
        _this11.intervals[index].checked = true;
        _this11.intervals[index].stimuli = item.stimuli;
      });
    } else {
      this.intervals[0].checked = true;
    }

    this.setStageGenerate();

    setTimeout(function () {
      _this11.afterLoad = true;
      _this11.isLoaded = true;
    }, 100);

    __WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('validation.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_13_lodash_forIn___default()(_this11.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this11);
        }));

        return function validate(_x2) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  },


  watch: {}

});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'addHintModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'stimulList': {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      stimulusList: [],
      errorsStimulLenght: false

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }

  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  mounted: function mounted() {
    this.stimulusList = __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(this.stimulList);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    close: function close(selectedStimul) {
      this.$emit('close');
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var selectedStimulus, selectedStimul;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this.errors.clear();
                if (!_this.stimulusList.length) {
                  _this.$emit('cancel');
                }

                selectedStimulus = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this.stimulusList, 'selected');
                selectedStimul = __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(selectedStimulus, function (task, index) {
                  return {
                    globalUuid: task.globalUuid,
                    index: index
                  };
                });


                if (selectedStimul.length == 3) {
                  _this.$emit('close', selectedStimul);
                } else {
                  _this.errorsStimulLenght = true;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    setActiveStimul: function setActiveStimul(stimul) {
      var list = __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(this.stimulusList);
      __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(list, function (item) {
        if (stimul.globalUuid === item.globalUuid) {
          item.selected = !item.selected;
        }
      });
      this.stimulusList = list;
    }
  },
  watch: {}
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDTTModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: [Object, Array],
      default: function _default() {
        return null;
      }
    },
    'stimul': {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    'intervals': {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */]
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },

  data: function data() {
    return {
      isLoaded: true,
      disabled: false,
      phases: [],
      phaseTask: null,
      field: null,
      fieldList: null,
      interval: null,
      intervalList: null,
      currentPhase: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var currentPhase, phase;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.data) {

                _this.phases = _this.data;
                currentPhase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.typeId === _this.stimul.phaseTypeId;
                })[0];


                _this.phaseTask = currentPhase;

                phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.data, function (item) {
                  return item.typeId === 3;
                })[0];


                __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(phase.intervals, function (item) {
                  var index = __WEBPACK_IMPORTED_MODULE_7_lodash_findIndex___default()(_this.intervals, {
                    typeId: item.type ? item.type.id : item.typeId
                  });

                  _this.intervals[index].id = item.id;
                  _this.intervals[index].phaseId = item.phaseId;
                  _this.intervals[index].count = item.count.toString();
                });

                _this.intervalList = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this.intervals, function (item) {
                  return item.checked;
                });
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, phaseTypeId, interval;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context2.abrupt('return');

              case 7:
                phaseTypeId = _this2.phaseTask ? _this2.phaseTask.typeId : null;
                interval = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(_this2.intervalList, function (item) {
                  return item.typeId == _this2.interval;
                })[0];


                _this2.$emit('save', phaseTypeId, interval);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('close');
    }
  },
  watch: {
    phaseTask: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(val) {
        var _this3 = this;

        var phase, fieldList, min, max, i, firstInterval, field, label;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (val) {
                  phase = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(this.data, function (item) {
                    return item.typeId == val.typeId;
                  })[0];

                  this.disabled = false;
                  fieldList = null;

                  if (phase.minFieldCount && phase.withFields) {
                    fieldList = [];
                    min = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.minFieldCount);
                    max = __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default()(phase.maxFieldCount);

                    for (i = min; i <= max; i++) {
                      fieldList.push(i);
                    }
                  }
                  if (phase.intervals) {
                    firstInterval = this.intervalList[0] ? this.intervalList[0].typeId.toString() : null;

                    this.interval = this.stimul.intervalTypeId ? this.stimul.intervalTypeId.toString() : firstInterval;
                  }

                  this.fieldList = fieldList;
                  field = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(fieldList, function (val) {
                    return val == _this3.stimul.fieldIndex;
                  });
                  label = this.fieldList ? this.fieldList[0].toString() : null;

                  this.field = this.stimul.fieldIndex && field.length > 0 ? this.stimul.fieldIndex.toString() : label;
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function phaseTask(_x) {
        return _ref.apply(this, arguments);
      }

      return phaseTask;
    }()
  }

});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { draggable: __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default.a },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedStagesTitle', 'changeFromClient'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: [],
      taskList: [],
      modal: null,
      task: null,
      selected: {},
      disabledChange: false,
      stimulList: [],
      isModalVisible: false,
      isStimulVisible: false,
      intervalId: null,
      addTaskItem: null,
      recordedReactionsList: [],
      errorRecordedReactionsList: false,
      masteringConditions: {
        trialCount: '3',
        sessionCount: '1'
      },
      masteringCondition: null,
      masteringConditionAnswer: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA'])),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      this.intervalId = window.setInterval(function () {
        _this.hideTasks();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    labelTask: function labelTask(title, description) {
      return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get(title) + ' (' + description + ')';
    },

    masteredTask: function masteredTask(task) {
      if (task.mastered) {
        var taskCurrent = __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(this.tasks, function (item) {
          return item.globalUuid == task.globalUuid;
        })[0];

        taskCurrent.position = this.tasks.length + 1;

        this.tasks = __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default()(this.tasks, 'position');

        this.reindextasks();
      }
    },


    reindextasks: function reindextasks() {
      this.tasks.forEach(function (item, index) {
        var position = parseInt(index) + 1;
        item['position'] = parseInt(index);
      });
    },

    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    hideTasks: function hideTasks() {
      var _this2 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$validator.validateAll();

              case 2:
                result = _context.sent;


                if (result) {
                  _this2.reindextasks();

                  _this2.currentStage.stimuli = __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(_this2.tasks, function (item) {
                    return item.active;
                  });

                  _this2.currentStage.masteredStimuli = __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(_this2.tasks, function (item) {
                    return item.mastered;
                  });

                  setTimeout(function () {
                    _this2.protocol.stages[_this2.currentStageIndex] = _this2.currentStage;
                    if (hide) {
                      _this2.afterLoad = false;
                      _this2.$emit('hideTasks');
                    }
                    _this2.protocolChanged();
                  }, 100);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  created: function created() {
    var _this3 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }
    this.selected = this.protocol.stages[this.currentStageIndex];
    this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
    this.currentStage = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    var taskList = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.globalTasks);

    this.tasks = __WEBPACK_IMPORTED_MODULE_14_lodash_map___default()(taskList, function (task) {

      var currentTask = __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(_this3.currentStage.stimuli, function (item) {
        return item.globalUuid == task.uuid;
      });

      task.active = currentTask.length == 1;
      task.position = currentTask.length ? currentTask[0].position : task.position;
      task.globalUuid = task.uuid;
      task.canBeMarkedAsMastered = currentTask.length ? currentTask[0].canBeMarkedAsMastered : false;

      task.mastered = __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(_this3.currentStage.masteredStimuli, function (item) {
        return item.globalUuid == task.uuid;
      }).length == 1;

      delete task['uuid'];

      return task;
    });

    this.tasks = __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default()(this.tasks, 'position');

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(_this3.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function validate(_x2) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { draggable: __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default.a, Hints: __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__["a" /* default */] },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedStagesTitle', 'changeFromClient'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: [],
      taskList: [],
      modal: null,
      task: null,
      selected: {},
      disabledChange: false,
      stimulList: [],
      isModalVisible: false,
      isStimulVisible: false,
      intervalId: null,
      addTaskReactionItem: null,
      isPromptEnableList: 0,
      errorRecordedReactionsList: false,
      masteringConditions: {
        stageId: null,
        ratio: '100',
        trialCount: '3',
        sessionCount: '1',
        answerDirectory: { id: 1 }
      },
      masteringCondition: null,
      masteringConditionAnswer: null,
      taskType: {},
      taskTypesList: [],
      errorStimuli: false,
      newCurrentTask: null,
      currentTargetId: null,
      onChange: false,
      errorTarget: false,
      msg: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.enable_recording')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA']), {
    targetPosition: function targetPosition() {
      var _this = this;

      var position = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (item) {
        return item.globalUuid == _this.currentTargetId;
      });

      return position.length ? position[0].position : false;
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    this.taskTypesList = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.taskTypes, function (o) {
      return o.id == 1 || o.id == 4;
    });

    if (!this.taskTypesList) {
      var index = 0;
      if (this.selectedTaskTypeTitle) {
        index = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.taskTypesList, function (task) {
          return task.title === _this2.selectedTaskTypeTitle;
        });
      }
      this.taskType = this.taskTypesList[index];
    }

    this.$nextTick(function () {
      var _this3 = this;

      this.intervalId = window.setInterval(function () {
        _this3.hideTasks();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },


    labelTask: function labelTask(title, description) {
      return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get(title) + ' (' + description + ')';
    },

    onMoveTasks: function onMoveTasks(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;

      return (!relatedElement || !relatedElement.mastered) && !draggedElement.mastered && relatedElement.globalUuid !== this.currentStage.targetStimulus.globalUuid;
    },
    changeVisibleTask: function changeVisibleTask(task) {
      if (!task.active) {
        var taskCurrent = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.tasks, function (item) {
          return item.globalUuid == task.globalUuid;
        })[0];

        taskCurrent.position = this.tasks.length + 1;

        this.tasks = __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default()(this.tasks, 'position');

        this.reindextasks();
      }
    },


    reindextasks: function reindextasks() {
      this.tasks.forEach(function (item, index) {
        var position = parseInt(index) + 1;
        item['position'] = parseInt(index);
      });
    },

    masteredTask: function masteredTask(task) {
      var _this4 = this;

      console.info("masteredTask");

      if (!this.currentStage.targetStimulus.length) {
        this.currentStage.targetStimulus = {};
      }
      this.$set(this.currentStage.targetStimulus, 'globalUuid', task.globalUuid);

      __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(this.tasks, function (item) {
        if (item.position < task.position || _this4.currentTargetId === _this4.currentStage.targetStimulus.globalUuid) {
          item.mastered = true;
        } else {
          item.mastered = false;
        }
      });
      this.currentTargetId = task.globalUuid;
    },
    targetTask: function targetTask(task) {

      if (task.position < this.targetPosition) {
        this.isModalVisible = true;
        this.newCurrentTask = task;
      } else {
        if ((this.onChange || !this.targetPosition) && this.currentStage.masteredStimuli.length) {
          this.masteredTask(task);
        }
      }
      this.onChange = true;
    },
    onAcceptChangeStimulus: function onAcceptChangeStimulus() {

      this.masteredTask(this.newCurrentTask);
      this.isModalVisible = false;
    },
    onCancelChangeStimulus: function onCancelChangeStimulus() {
      this.$set(this.currentStage.targetStimulus, 'globalUuid', this.currentTargetId);
      this.isModalVisible = false;
    },


    reindexTasks: function reindexTasks() {
      this.tasks.forEach(function (item, index) {
        var position = parseInt(index) + 1;
        item['position'] = parseInt(index);
      });
    },

    addTask: function addTask(addTaskReactionItem) {
      if (!addTaskReactionItem) {
        return;
      }

      var unique = true;

      var taskReactionsList = this.protocol.globalTasks;

      __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(taskReactionsList, function (stimul) {
        if (__WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(stimul.description.toLowerCase()) === __WEBPACK_IMPORTED_MODULE_14_lodash_trim___default()(addTaskReactionItem.toLowerCase())) {
          unique = false;
        }
      });

      if (unique) {
        this.currentStage.isNew = true;

        var position = parseInt(this.tasks.length) + 1;
        var uuid = __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4();

        this.tasks.push({
          'position': position,
          'globalUuid': uuid,
          'description': addTaskReactionItem,
          'mastered': false,
          'active': true,
          'target': false
        });

        this.protocol.globalTasks.push({
          'position': position,
          'mastered': false,
          'title': __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.tasks') + ' ' + position,
          'description': addTaskReactionItem,
          'active': false,
          'uuid': uuid
        });

        this.addTaskReactionItem = null;
        this.changeCanPublish();
      } else {
        this.errors.add({
          field: 'addTaskReactionItem',
          msg: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('rotation.unique_stimulus')
        });
      }
    },

    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    hideTasks: function hideTasks() {
      var _this5 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, stimuli;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.$validator.validateAll();

              case 2:
                result = _context.sent;
                stimuli = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this5.tasks, function (item) {
                  return item.active;
                });


                if (result && stimuli.length && _this5.currentStage.targetStimulus.globalUuid) {

                  _this5.errorTarget = false;
                  _this5.errorStimuli = false;

                  _this5.reindexTasks();

                  _this5.currentStage.stimuli = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this5.tasks, function (item) {
                    return item.active;
                  });

                  _this5.currentStage.masteredTasks = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this5.tasks, function (item) {
                    return item.mastered;
                  });

                  _this5.currentStage.type = _this5.taskType;

                  setTimeout(function () {
                    _this5.$set(_this5.protocol.stages, _this5.currentStageIndex, _this5.currentStage);
                    if (hide) {
                      _this5.afterLoad = false;
                      _this5.$emit('hideTasks');
                    }
                    _this5.protocolChanged();
                  }, 100);
                }

                if (!stimuli.length) {
                  _this5.errorStimuli = true;
                }

                if (!_this5.currentStage.targetStimulus.globalUuid) {
                  _this5.errorTarget = true;
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },

  created: function created() {
    var _this6 = this;

    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }
    this.selected = this.protocol.stages[this.currentStageIndex];
    this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
    this.currentStage = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    var taskList = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.globalTasks);

    this.tasks = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(taskList, function (task) {

      var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this6.currentStage.stimuli, function (item) {
        return item.globalUuid == task.uuid;
      });

      task.active = currentTask.length == 1;
      task.position = currentTask.length ? currentTask[0].position : taskList.length;
      task.globalUuid = task.uuid;
      task.canBeMarkedAsMastered = currentTask.length ? currentTask[0].canBeMarkedAsMastered : false;
      task.mastered = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this6.currentStage.masteredStimuli, function (item) {
        return item.globalUuid == task.uuid;
      }).length == 1;
      delete task['uuid'];

      return task;
    });

    this.taskType = this.currentStage.type;

    this.tasks = __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default()(this.tasks, 'position');

    if (!this.currentStage.targetStimulus) {
      this.currentStage.targetStimulus = {
        globalUuid: this.tasks[0].globalUuid
      };
    }

    this.currentTargetId = this.currentStage.targetStimulus.globalUuid;

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(_this6.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this6);
        }));

        return function validate(_x2) {
          return _ref2.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteTherapistModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  methods: {
    accept: function accept() {
      this.$emit('accept');
    },
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_Constants__ = __webpack_require__(18);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChangeFixingModal',
  data: function data() {
    return {
      comment: '',
      fixingChange: '3',
      rangeDateStart: null,
      rangeTimeStart: {
        HH: '',
        mm: ''
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: new Date(),
      minDateStart: null,
      errorTime: false
    };
  },

  props: {
    visible: {
      required: true,
      types: [Boolean]
    },
    client: null,
    protocol: null,
    disabledNotImportantChanges: false
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  components: { VueTimepicker: __WEBPACK_IMPORTED_MODULE_2_vue2_timepicker___default.a },
  created: function created() {
    if (this.protocol.endDate) {
      this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.protocol.endDate.date, 'YYYY-MM-DD HH:mm').toDate(); //new Date(this.toLocaleDate(this.protocol.endDate.date));

      this.minDateStart = this.rangeDateStart;
      var hours = this.rangeDateStart.getHours();
      this.rangeTimeStart.HH = hours > 9 ? hours.toString() : '0' + hours;
      var min = this.rangeDateStart.getMinutes() + 1;
      if (min < 60) {
        this.rangeTimeStart.mm = min > 9 ? min.toString() : '0' + min;
      } else {
        this.rangeTimeStart.mm = '00';
        this.rangeTimeStart.HH = hours > 9 ? (hours + 1).toString() : '0' + (hours + 1);
      }
    }
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY.MM.DD HH:mm');
    },

    accept: function accept() {
      var clientTimeZoneOffset = this.client.timezone ? __WEBPACK_IMPORTED_MODULE_3_moment___default()().tz(this.client.timezone)._offset : 0;

      var fixingChangeDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date(Date.UTC(this.rangeDateStart.getFullYear(), this.rangeDateStart.getMonth(), this.rangeDateStart.getDate(), this.rangeTimeStart.HH, this.rangeTimeStart.mm))).unix() - Math.abs(clientTimeZoneOffset) * __WEBPACK_IMPORTED_MODULE_4__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;

      this.$emit('accept', this.fixingChange, this.comment, fixingChangeDate);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    validate: function validate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errors.clear();

                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!(!_this.rangeTimeStart.HH || !_this.rangeTimeStart.mm)) {
                  _context.next = 7;
                  break;
                }

                _this.errorTime = true;
                return _context.abrupt('return');

              case 7:

                if (result) {
                  _this.accept();
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    rangeDateStart: function rangeDateStart(newDate) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(newDate).format('DD.MM.YYYY') === __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.minDateStart).format('DD.MM.YYYY')) {
        var hours = this.minDateStart.getHours();
        var min = this.minDateStart.getMinutes() + 1;
        this.hourRange = [hours, 23];
        if (this.rangeTimeStart.HH < hours) {
          this.minuteRange = [min, 60];
          this.rangeTimeStart.HH = null;
          this.rangeTimeStart.mm = null;
        }
      } else {
        this.hourRange = [0, 23];
        this.minuteRange = [0, 60];
      }
    },
    rangeTimeStart: function rangeTimeStart(newTime) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.rangeDateStart).format('DD.MM.YYYY') === __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.minDateStart).format('DD.MM.YYYY') && newTime.HH) {
        var hours = this.minDateStart.getHours();
        var min = this.minDateStart.getMinutes() + 1;
        if (newTime.HH == hours) {
          this.minuteRange = [min, 60];
          if (this.rangeTimeStart.mm < min) {
            this.rangeTimeStart.mm = null;
          }
        } else {
          this.minuteRange = [0, 60];
        }
      }
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_autocompleteSearch_components_autocompleteSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'protocol': {
      type: Object
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'selectedTeachingMethodID': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    return {
      apiUrl: '/protocols/',
      teachingMethodDescriptionValidated: null,
      skillFieldValidated: false,
      autocomplete: []
    };
  },


  components: {
    autocompleteSearch: __WEBPACK_IMPORTED_MODULE_6__common_autocompleteSearch_components_autocompleteSearch__["a" /* default */]
  },

  inject: ["parentValidator"],

  created: function created() {
    this.$validator = this.parentValidator;
  },


  computed: {

    isDTT: function isDTT() {
      return this.selectedTeachingMethodID == 1;
    },

    isSimple: function isSimple() {
      return this.selectedTeachingMethodID == 2;
    },

    isMand: function isMand() {
      return this.selectedTeachingMethodID == 3;
    },

    isUSD: function isUSD() {
      return this.selectedTeachingMethodID == 4;
    },

    isChain: function isChain() {
      return this.selectedTeachingMethodID == 5;
    },

    isShaping: function isShaping() {
      return this.selectedTeachingMethodID == 6;
    },
    isPecs: function isPecs() {
      return this.selectedTeachingMethodID == 7;
    },
    isPecsWithoutDiscrimination: function isPecsWithoutDiscrimination() {
      return this.selectedTeachingMethodID == 8;
    },
    isAllValidated: function isAllValidated() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default()(this.protocol.skillField);
    }
  },

  methods: {
    setIsChanged: function setIsChanged(change) {
      this.$emit('setIsChanged', change);
    },
    setTeachingMethodNewValue: function setTeachingMethodNewValue(value) {
      this.protocol.teachingMethodDescription = value;
    },
    setTeachingMethodNewValidated: function setTeachingMethodNewValidated(text) {
      this.protocol.teachingMethodDescription = text;
      this.teachingMethodDescriptionValidated = true;
      this.autocomplete = [];
    },
    validatedTeachingMethodNew: function validatedTeachingMethodNew(error) {
      this.errors.items.push(error.items[0]);
    },
    onChangeTeachingMethodNew: function onChangeTeachingMethodNew(search) {
      this.setIsChanged(true);
      this.searchAutocompleteTeachingMethod(__WEBPACK_IMPORTED_MODULE_4__protocols_constants_js__["b" /* DIRECTORY_TYPES */].TEACHING_METHOD, search, this);
    },


    searchAutocomplete: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(vm.apiUrl + 'skill-fields/search/' + '?search=' + search);

              case 3:
                response = _context.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(response.data.data, 'name');
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 250),

    searchAutocompleteTeachingMethod: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(typeId, search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(vm.apiUrl + 'directories/search/' + typeId + '?search=' + search);

              case 3:
                response = _context2.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(response.data.data, 'title');
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 7]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }(), 250),

    onChangeSkillField: function onChangeSkillField(search) {
      this.searchAutocomplete(search, this);
    },
    setSkillFieldValue: function setSkillFieldValue(value) {
      this.protocol.skillField = value;
    },
    setSkillFieldValidated: function setSkillFieldValidated(text) {
      this.protocol.skillField = text;
      this.skillFieldValidated = true;
      this.autocomplete = [];
    },
    validatedSkillField: function validatedSkillField(error) {
      this.errors.items.push(error.items[0]);
    }
  }

});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_autocompleteSearch_components_autocompleteSearch__ = __webpack_require__(134);



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'protocol': {
      type: Object
    },
    'visible': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'selectedTeachingMethodID': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    return {
      apiUrl: '/protocols/',
      teachingMethodDescriptionValidated: null,
      skillFieldValidated: false,
      autocomplete: []
    };
  },


  components: {
    autocompleteSearch: __WEBPACK_IMPORTED_MODULE_6__common_autocompleteSearch_components_autocompleteSearch__["a" /* default */]
  },

  inject: ["parentValidator"],

  created: function created() {
    this.$validator = this.parentValidator;
  },


  computed: {

    isDTT: function isDTT() {
      return this.selectedTeachingMethodID == 1;
    },

    isSimple: function isSimple() {
      return this.selectedTeachingMethodID == 2;
    },

    isMand: function isMand() {
      return this.selectedTeachingMethodID == 3;
    },

    isUSD: function isUSD() {
      return this.selectedTeachingMethodID == 4;
    },

    isChain: function isChain() {
      return this.selectedTeachingMethodID == 5;
    },

    isShaping: function isShaping() {
      return this.selectedTeachingMethodID == 6;
    }
  },

  methods: {
    setIsChanged: function setIsChanged(change) {
      this.$emit('setIsChanged', change);
    },
    setTeachingMethodNewValue: function setTeachingMethodNewValue(value) {
      this.protocol.teachingMethodDescription = value;
    },
    setTeachingMethodNewValidated: function setTeachingMethodNewValidated(text) {
      this.protocol.teachingMethodDescription = text;
      this.teachingMethodDescriptionValidated = true;
      this.autocomplete = [];
    },
    validatedTeachingMethodNew: function validatedTeachingMethodNew(error) {
      this.errors.items.push(error.items[0]);
    },
    onChangeTeachingMethodNew: function onChangeTeachingMethodNew(search) {
      this.setIsChanged(true);
      this.searchAutocompleteTeachingMethod(__WEBPACK_IMPORTED_MODULE_4__protocols_constants_js__["b" /* DIRECTORY_TYPES */].TEACHING_METHOD, search, this);
    },


    searchAutocomplete: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(vm.apiUrl + 'skill-fields/search/' + '?search=' + search);

              case 3:
                response = _context.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(response.data.data, 'name');
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 250),

    searchAutocompleteTeachingMethod: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(typeId, search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(vm.apiUrl + 'directories/search/' + typeId + '?search=' + search);

              case 3:
                response = _context2.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(response.data.data, 'title');
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 7]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }(), 250),

    onChangeSkillField: function onChangeSkillField(search) {
      this.searchAutocomplete(search, this);
    },
    setSkillFieldValue: function setSkillFieldValue(value) {
      this.protocol.skillField = value;
    },
    setSkillFieldValidated: function setSkillFieldValidated(text) {
      this.protocol.skillField = text;
      this.skillFieldValidated = true;
      this.autocomplete = [];
    },
    validatedSkillField: function validatedSkillField(error) {
      this.errors.items.push(error.items[0]);
    }
  }

});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'protocol': {
      type: Object
    },
    teachingMethod: {
      type: Object
    }

  },

  components: { Hints: __WEBPACK_IMPORTED_MODULE_2__protocols_components_Hints__["a" /* default */] },

  data: function data() {
    return {
      isAllTasksEnabled: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA'])),

  inject: ["parentValidator"],

  created: function created() {

    this.$validator = this.parentValidator;

    __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.protocol.stages, function (stage) {

      stage.tasks = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(stage.tasks, function (task) {

        task.mastered = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(stage.masteredTasks, function (item) {
          return item.globalUuid == task.globalUuid;
        }).length == 1;

        return task;
      });
    });

    this.isAllTasksEnabled = !this.protocol.isAllTasksEnabled;
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    }
  },

  watch: {
    isAllTasksEnabled: function isAllTasksEnabled(newValue) {

      this.protocol.isAllTasksEnabled = !newValue;
    }
  }

});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_remove__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_toInteger__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'protocol': {
      type: Object
    },
    teachingMethod: {
      type: Object
    }

  },

  components: { Hints: __WEBPACK_IMPORTED_MODULE_4__protocols_components_Hints__["a" /* default */] },

  data: function data() {
    return {
      isAllTasksEnabled: false,
      isModalAcceptPopup: false,
      currentCategoryUuid: null,
      currentTaskUuid: null,
      isModalAcceptPopupCategory: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA']), {
    levels: function levels() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.protocol.stages, function (stage, index) {
        return {
          id: stage.id,
          uuid: stage.uuid,
          title: 'count_properties' + (__WEBPACK_IMPORTED_MODULE_14_lodash_toInteger___default()(index) + 1)
        };
      });
    }
  }),

  inject: ["parentValidator"],

  created: function created() {
    var _this = this;

    this.$validator = this.parentValidator;

    this.$validator.extend('unique_category', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('validation.unique_categories', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(category) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(_this.protocol.categories, function (item) {
                    if (__WEBPACK_IMPORTED_MODULE_13_lodash_trim___default()(item.title) === __WEBPACK_IMPORTED_MODULE_13_lodash_trim___default()(category)) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });

    this.$validator.extend('unique_properties', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('validation.unique_properties', { attribute: attribute });
      },
      validate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(property) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(_this.protocol.categories, function (item) {
                    __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(item.tasks, function (task) {
                      if (__WEBPACK_IMPORTED_MODULE_13_lodash_trim___default()(task.description) === __WEBPACK_IMPORTED_MODULE_13_lodash_trim___default()(property)) {
                        unique++;
                      }
                    });
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function validate(_x2) {
          return _ref2.apply(this, arguments);
        };
      }()
    });

    if (!this.protocol.categories) {
      this.$set(this.protocol, 'categories', []);
      this.addCategory();
    }

    __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.categories, function (category) {
      if (!category.tasks.length) {
        _this.addProperty(category.uuid, category.id);
      }
    });
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },


    removePropertyPopup: function removePropertyPopup(categoryUuid, taskUuid) {

      if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
        this.currentCategoryUuid = categoryUuid;
        this.currentTaskUuid = taskUuid;
        this.isModalAcceptPopup = true;
      } else {
        this.removeProperty(categoryUuid, taskUuid);
      }
    },

    cancel: function cancel() {
      this.isModalAcceptPopup = false;
      this.isModalAcceptPopupCategory = false;
    },

    removeProperty: function removeProperty(categoryUuid, taskUuid) {

      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var taskIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories[currentCategoryIndex].tasks, function (task) {
        return task.uuid === taskUuid;
      });

      if (taskIndex !== -1) {
        this.protocol.categories[currentCategoryIndex].tasks.splice(taskIndex, 1);

        __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value) {
          var taskStageIndex = void 0;

          taskStageIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(value.tasks, function (task) {
            return task.globalUuid === taskUuid;
          });

          value.tasks.splice(taskStageIndex, 1);
        });
      }
    },

    removeCategoryPopup: function removeCategoryPopup(categoryUuid) {

      if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
        this.currentCategoryUuid = categoryUuid;
        this.isModalAcceptPopupCategory = true;
      } else {
        this.removeCategory(categoryUuid);
      }
    },

    removeCategory: function removeCategory(categoryUuid) {
      var _this2 = this;

      this.$emit('removed');
      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var currentTasks = this.protocol.categories[currentCategoryIndex].tasks;

      if (currentCategoryIndex !== -1) {

        this.protocol.categories.splice(currentCategoryIndex, 1);

        __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value, indexStages) {

          __WEBPACK_IMPORTED_MODULE_9_lodash_remove___default()(_this2.protocol.stages[indexStages].tasks, function (task) {
            return task.categoryUuid == categoryUuid;
          });
        });
      }
    },

    categoriesTask: function categoriesTask(uuid) {
      var tasks = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.protocol.globalTasks, function (task) {
        return task.protocolCategoryUuid == uuid;
      });
      return tasks;
    },


    addProperty: function addProperty(categoryUuid, categoryId) {
      var _this3 = this;

      var uuid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4();
      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var position = this.protocol.categories[currentCategoryIndex].tasks.length;

      this.protocol.categories[currentCategoryIndex].tasks.push({
        'description': "",
        'id': null,
        'position': position,
        'protocolCategoryId': categoryId,
        'protocolCategoryUuid': categoryUuid,
        'title': __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.property') + ' ' + position,
        'uuid': uuid,
        'isNew': true,
        'active': true
      });

      __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value, index) {

        var propertyPositon = parseInt(value.tasks.length) + 1;

        _this3.$set(_this3.protocol.stages[index].tasks, propertyPositon - 1, {
          'id': null,
          'globalTaskId': null,
          'position': propertyPositon,
          'title': __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.property') + ' ' + propertyPositon,
          'description': '',
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': uuid,
          'categoryUuid': categoryUuid,
          'categoryId': categoryId
        });
      });
    },

    addCategory: function addCategory() {

      var uuid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4().toString();

      this.protocol.categories.push({
        'id': null,
        'uuid': uuid,
        'currentStage': {
          id: this.protocol.stages[0].id,
          uuid: this.protocol.stages[0].uuid,
          description: this.protocol.stages[0].description,
          hasAssignedStage: false,
          isClosed: false,
          title: 'count_properties1'
        },
        'tasks': [],
        'title': '',
        'masteringPercent': 0,
        'active': true
      });

      this.addProperty(uuid, null);
    }
  }

});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_remove__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_translator__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'protocol': {
      type: Object
    },
    teachingMethod: {
      type: Object
    }

  },

  components: { Hints: __WEBPACK_IMPORTED_MODULE_4__protocols_components_Hints__["a" /* default */] },

  data: function data() {
    return {
      isAllTasksEnabled: false,
      isModalAcceptPopup: false,
      currentCategoryUuid: null,
      currentTaskUuid: null,
      isModalAcceptPopupCategory: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA'])),

  inject: ["parentValidator"],

  created: function created() {
    var _this = this;

    this.$validator = this.parentValidator;

    this.$validator.extend('unique_category', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('validation.unique_categories', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(category) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(_this.protocol.categories, function (item) {
                    if (__WEBPACK_IMPORTED_MODULE_10_lodash_trim___default()(item.title) === __WEBPACK_IMPORTED_MODULE_10_lodash_trim___default()(category)) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });

    this.$validator.extend('unique_properties', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('validation.unique_properties', { attribute: attribute });
      },
      validate: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(property) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(_this.protocol.categories, function (item) {
                    __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(item.tasks, function (task) {
                      if (__WEBPACK_IMPORTED_MODULE_10_lodash_trim___default()(task.description) === __WEBPACK_IMPORTED_MODULE_10_lodash_trim___default()(property)) {
                        unique++;
                      }
                    });
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function validate(_x2) {
          return _ref2.apply(this, arguments);
        };
      }()
    });

    if (!this.protocol.categories) {
      this.$set(this.protocol, 'categories', []);
      this.addCategory();
    } else {

      this.protocol.categories = __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.protocol.categories, function (category, index) {

        var tasksList = __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(category.tasks, function (task) {

          var currentTaskIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(_this.protocol.stages[0].tasks, function (item) {
            return item.globalUuid == task.uuid;
          });

          var currentMasteredTask = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this.protocol.stages[0].masteredTasks, function (item) {
            return item.globalUuid == task.uuid;
          });

          task.active = currentTaskIndex >= 0;
          task.mastered = currentMasteredTask.length == 1;
          if (currentTaskIndex >= 0) {

            _this.$set(_this.protocol.stages[0].tasks[currentTaskIndex], 'mastered', currentMasteredTask.length == 1);
          }

          return task;
        });

        _this.$set(_this.protocol.categories[index], 'tasks', tasksList);
        _this.$set(_this.protocol.categories[index], 'active', !!__WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(category.tasks, function (task) {
          return task.active;
        }).length);

        if (!tasksList.length) {
          _this.$set(_this.protocol.categories[index], 'active', true);
          _this.addProperty(category.uuid, category.id);
        }

        return category;
      });
    }
  },


  methods: {

    removePropertyPopup: function removePropertyPopup(categoryUuid, taskUuid) {
      if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
        this.currentCategoryUuid = categoryUuid;
        this.currentTaskUuid = taskUuid;
        this.isModalAcceptPopup = true;
      } else {
        this.removeProperty(categoryUuid, taskUuid);
      }
    },

    cancel: function cancel() {
      this.isModalAcceptPopup = false;
      this.isModalAcceptPopupCategory = false;
    },

    removeCategoryPopup: function removeCategoryPopup(categoryUuid) {
      if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
        this.currentCategoryUuid = categoryUuid;
        this.isModalAcceptPopupCategory = true;
      } else {
        this.removeCategory(categoryUuid);
      }
    },

    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    changeActiveCategory: function changeActiveCategory(category) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(category.tasks, function (item) {
        item.active = category.active;

        _this2.changeActiveTask(category, item);
      });
    },
    changeActiveTask: function changeActiveTask(category, currentTask) {

      if (currentTask.active) {

        var task = {
          'id': null,
          'globalTaskId': currentTask.id,
          'position': this.protocol.stages[0].tasks.length,
          'title': __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.property') + ' ' + this.protocol.stages[0].tasks.length,
          'description': currentTask.description,
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': currentTask.uuid,
          'categoryUuid': currentTask.categoryUuid,
          'categoryId': currentTask.categoryId
        };

        this.protocol.stages[0].tasks.push(task);
      } else {
        var taskIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.stages[0].tasks, function (task) {
          return task.globalUuid === currentTask.uuid;
        });

        if (taskIndex !== -1) {
          this.protocol.stages[0].tasks.splice(taskIndex, 1);
        }
      }
    },
    masteredTask: function masteredTask(task) {

      var taskCurrentIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.stages[0].tasks, function (item) {
        return item.globalUuid == task.uuid;
      });

      if (taskCurrentIndex >= 0) {
        console.info("mastered");

        this.$set(this.protocol.stages[0].tasks[taskCurrentIndex], 'mastered', task.mastered);
      }
    },


    removeProperty: function removeProperty(categoryUuid, taskUuid) {

      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var taskIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories[currentCategoryIndex].tasks, function (task) {
        return task.uuid === taskUuid;
      });

      if (taskIndex !== -1) {
        this.protocol.categories[currentCategoryIndex].tasks.splice(taskIndex, 1);

        __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value) {
          var taskStageIndex = void 0;

          taskStageIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(value.tasks, function (task) {
            return task.globalUuid === taskUuid;
          });

          value.tasks.splice(taskStageIndex, 1);
        });
      }
    },

    removeCategory: function removeCategory(categoryUuid) {
      var _this3 = this;

      this.$emit('removed');

      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var currentTasks = this.protocol.categories[currentCategoryIndex].tasks;

      if (currentCategoryIndex !== -1) {

        this.protocol.categories.splice(currentCategoryIndex, 1);

        __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value, indexStages) {

          __WEBPACK_IMPORTED_MODULE_9_lodash_remove___default()(_this3.protocol.stages[indexStages].tasks, function (task) {
            return task.categoryUuid == categoryUuid;
          });
        });
      }
    },

    addProperty: function addProperty(categoryUuid, categoryId) {
      var _this4 = this;

      var uuid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4();
      var currentCategoryIndex = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.protocol.categories, function (category) {
        return category.uuid == categoryUuid;
      });

      var position = this.protocol.categories[currentCategoryIndex].tasks.length;

      this.protocol.categories[currentCategoryIndex].tasks.push({
        'description': "",
        'id': null,
        'position': position,
        'protocolCategoryId': categoryId,
        'protocolCategoryUuid': categoryUuid,
        'title': __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.property') + ' ' + position,
        'uuid': uuid,
        'isNew': true,
        'active': true
      });

      __WEBPACK_IMPORTED_MODULE_6_lodash_forIn___default()(this.protocol.stages, function (value) {

        var propertyPositon = parseInt(value.tasks.length) + 1;

        _this4.$set(value.tasks, propertyPositon - 1, {
          'id': null,
          'globalTaskId': null,
          'position': propertyPositon,
          'title': __WEBPACK_IMPORTED_MODULE_12__lang_translator__["a" /* default */].get('protocol.property') + ' ' + propertyPositon,
          'description': '',
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': uuid,
          'categoryUuid': categoryUuid,
          'categoryId': categoryId
        });
      });
    },

    addCategory: function addCategory() {

      var uuid = __WEBPACK_IMPORTED_MODULE_11__common_uuid_UuidGenerator__["a" /* default */].v4().toString();

      this.protocol.categories.push({
        'id': null,
        'uuid': uuid,
        'currentStage': {
          id: this.protocol.stages[0].id,
          uuid: this.protocol.stages[0].uuid,
          description: this.protocol.stages[0].description,
          hasAssignedStage: false,
          isClosed: false
        },
        'tasks': [],
        'title': '',
        'masteringPercent': 0,
        'active': true,
        'typeId': 1
      });

      this.addProperty(uuid, null);
    }
  }

});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_find__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_remove__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_remove__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  components: { draggable: __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default.a, Hints: __WEBPACK_IMPORTED_MODULE_11__protocols_components_Hints__["a" /* default */] },
  props: ['protocol', 'isNew', 'taskTypes', 'selectedStagesTitle', 'changeFromClient'],
  data: function data() {
    return {
      apiUrl: '/protocols/',
      disabled: false,
      currentStageIndex: 0,
      currentStageTitle: '',
      currentStage: {},
      selectedStage: {},
      tasks: [],
      taskList: [],
      modal: null,
      task: null,
      categories: [],
      selected: {},
      disabledChange: false

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA'])),

  mounted: function mounted() {
    this.$nextTick(function () {
      var _this = this;

      this.intervalId = window.setInterval(function () {
        _this.hidePecsWithDiscrimination();
      }, 5000);
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  methods: {
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    protocolChanged: function protocolChanged() {
      this.$emit('protocolChanged');
    },
    masteredTask: function masteredTask(task) {

      var taskCurrentIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.currentStage.tasks, function (item) {
        return item.globalUuid == task.uuid;
      });

      if (taskCurrentIndex >= 0) {

        this.$set(this.currentStage.tasks[taskCurrentIndex], 'mastered', task.mastered);
      }
    },
    changeActiveCategory: function changeActiveCategory(category) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(category.tasks, function (item) {
        item.active = category.active;
        _this2.changeActiveTask(category, item);
      });
    },
    changeActiveTask: function changeActiveTask(category, currentTask) {

      if (currentTask.active) {

        var task = {
          'id': null,
          'globalTaskId': currentTask.id,
          'position': this.currentStage.tasks.length,
          'title': __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.property') + ' ' + this.currentStage.tasks.length,
          'description': currentTask.description,
          'isNew': true,
          'active': true,
          'uuid': __WEBPACK_IMPORTED_MODULE_12__common_uuid_UuidGenerator__["a" /* default */].v4(),
          'globalUuid': currentTask.uuid
        };

        this.currentStage.tasks.push(task);
      } else {

        __WEBPACK_IMPORTED_MODULE_19_lodash_remove___default()(this.currentStage.tasks, function (task) {
          return task.globalUuid === currentTask.uuid;
        });
      }
    },


    getCurrentStageIndex: function getCurrentStageIndex(title) {
      this.currentStageIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(this.protocol.stages, function (stage) {
        return stage.title === title;
      });

      return this.currentStageIndex;
    },

    changeCanPublish: function changeCanPublish() {
      this.$emit('changeCanPublish');
    },
    hidePecsWithDiscrimination: function hidePecsWithDiscrimination() {
      var _this3 = this;

      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$validator.validateAll();

              case 2:
                result = _context.sent;


                if (result) {

                  _this3.currentStage.masteredTasks = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this3.currentStage.tasks, function (item) {
                    return item.mastered;
                  });

                  __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(_this3.protocol.categories, function (category) {

                    if (category.currentStage.uuid === _this3.currentStage.uuid) {

                      var masteredTaskCount = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this3.currentStage.tasks, function (task) {
                        return task.mastered && task.categoryUuid == category.uuid;
                      }).length;

                      category.masteringPercent = masteredTaskCount ? Math.round(masteredTaskCount * 100 / category.tasks.length) : 0;
                    }
                  });

                  setTimeout(function () {
                    _this3.protocol.stages[_this3.currentStageIndex] = _this3.currentStage;
                    if (hide) {
                      _this3.afterLoad = false;
                      _this3.$emit('hidePecsWithDiscrimination');
                    }
                    _this3.protocolChanged();
                  }, 100);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },

  created: function created() {
    var _this4 = this;

    console.info("jdsklfj");
    if (this.selectedStagesTitle) {
      this.currentStageIndex = this.getCurrentStageIndex(this.selectedStagesTitle);
    }
    this.selected = this.protocol.stages[this.currentStageIndex];
    this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
    this.currentStage = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(this.protocol.stages[this.currentStageIndex]);

    var categoriesList = __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(this.protocol.categories, function (category) {

      var currentCategories = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.protocol.stages, function (stage) {
        return category.currentStage.uuid === stage.uuid;
      });

      return currentCategories[0].position >= _this4.currentStage.position;
    }));

    this.currentStage.tasks = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(this.currentStage.tasks, function (task, index) {

      var currentMasteredTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.currentStage.masteredTasks, function (item) {
        return item.globalUuid == task.globalUuid;
      });

      task.mastered = currentMasteredTask.length == 1;

      return task;
    });

    this.categories = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(categoriesList, function (category) {

      var tasksList = __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(category.tasks, function (task) {

        var currentTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.currentStage.tasks, function (item) {
          return item.globalUuid == task.uuid;
        });

        var currentMasteredTask = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this4.currentStage.masteredTasks, function (item) {
          return item.globalUuid == task.uuid;
        });

        task.active = currentTask.length == 1 || task.active;
        task.mastered = currentMasteredTask.length == 1 || task.mastered;

        return task;
      });

      category.tasks = tasksList;
      category.active = !!__WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(category.tasks, function (task) {
        return task.active;
      }).length;

      return category;
    });

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('unique_task', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.unique_task', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(task) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_9_lodash_forIn___default()(_this4.tasks, function (item) {
                    if (item.description === task) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context2.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4);
        }));

        return function validate(_x2) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardBCBA',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isTherapist']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']))
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ClientBtn__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_table_Search__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_table_components_TableView__ = __webpack_require__(21);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Clients',
  data: function data() {
    return {
      apiUrl: '/users/therapists/' + __WEBPACK_IMPORTED_MODULE_11__common_auth_Manager__["a" /* default */].getUserInfo().id + '/clients/hash/',
      therapistId: __WEBPACK_IMPORTED_MODULE_11__common_auth_Manager__["a" /* default */].getUserInfo().id || null,
      isModalVisible: false,
      isOpen: false,
      responseHashError: null,
      paginate: {
        perPage: 10,
        page: 0,
        forcePage: 0,
        pageRange: 3,
        marginPages: 2
      },
      user: {
        code: null
      },
      modal: {
        data: {}
      },
      isChange: false,
      options: {
        pageHeader: 'clients',
        filterable: false,
        initialPage: null,
        sortable: [],
        withSearch: true,
        debounce: 1500,
        placeholder: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
        skin: 'table table-sm',
        columns: [{
          key: 'client',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.clients')
        }, {
          key: 'hash',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.number')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.items,
            count: resp.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.type_the_client_code_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          client: 'wide-col',
          action: 'table-actions'
        }
      },
      search: '',
      sort: '-id'
    };
  },


  components: {
    Search: __WEBPACK_IMPORTED_MODULE_12__common_table_Search__["a" /* default */], Paginate: __WEBPACK_IMPORTED_MODULE_6_vuejs_paginate___default.a, clientModal: __WEBPACK_IMPORTED_MODULE_7__Modal__["a" /* default */], clientBtn: __WEBPACK_IMPORTED_MODULE_8__ClientBtn__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_13__common_table_components_TableView__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('client/repository', ['items', 'page', 'pageCount', 'total', 'hasMorePages', 'isLoaded', 'isChanged']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['canCreateClient', 'canUpdateClient', 'canDeleteClient', 'isTherapist', 'isMensurationForbidden']), {
    isEmptyList: function isEmptyList() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.items);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.getClients(data.page, _this.sort, data.query));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('client/repository', ['getItems', 'deleteItemById']), {
    getTranslation: function getTranslation() {
      return __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */], arguments);
    },
    getClients: function getClients(page, sort, search, perPage) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'clients');
                _context2.next = 4;
                return _this2.getItems({
                  perPage: _this2.paginate.perPage,
                  page: page,
                  sort: sort ? sort : _this2.sort,
                  search: search ? search : _this2.search
                });

              case 4:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isChange = true;
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.isChange = false;
      this.modal.data = { item: item };
      this.isModalVisible = true;
    },
    onAddCuratorModalBtnClick: function onAddCuratorModalBtnClick() {
      this.isChange = false;
      this.modal.data = {};
      this.isModalVisible = true;
    },

    onDeleteBtnClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isChange = false;
                _context3.next = 3;
                return this.deleteItemById({ id: id });

              case 3:
                _context3.next = 5;
                return this.getClients(this.page);

              case 5:
                response = _context3.sent;


                if (response) {
                  this.isChange = true;
                }

                this.setPaginateState(this.page);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onDeleteBtnClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onDeleteBtnClick;
    }(),
    addHashBtnClick: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this3 = this;

        var result, isSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.disabled = true;
                this.isChange = false;
                _context4.next = 4;
                return this.$validator.validateAll();

              case 4:
                result = _context4.sent;


                if (result === true) {
                  isSaved = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.apiUrl, { 'hash': this.user.code }).then(function (response) {
                    _this3.responseHashError = null;
                    _this3.user.code = null;
                    //this.getClients()
                    _this3.isChange = true;
                  }).catch(function (error) {
                    if (error.data) {
                      _this3.disabled = false;
                      _this3.responseHashError = error.data.errors.hash.message;
                    }
                  });
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addHashBtnClick() {
        return _ref2.apply(this, arguments);
      }

      return addHashBtnClick;
    }(),
    onPaginationClick: function onPaginationClick(page) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.getClients(page);

              case 2:
                _this4.setPaginateState(page);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    setPaginateState: function setPaginateState(page) {
      this.paginate.page = page;
      this.paginate.forcePage = page - 1;
    },

    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
    }
  }),
  watch: {
    pageCount: function pageCount(newValue, oldValue) {
      // spike :
      if (newValue > 1 && oldValue === 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    page: function page(newValue, oldValue) {
      // spike :
      if (newValue === 1 && oldValue > 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    isChanged: function isChanged(newValue, oldValue) {
      if (newValue) {
        this.isChange = newValue;
      }
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_client__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_clinicalCenter__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Constants__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);






var _this6 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_17__loader_components_Loader__["a" /* default */]
  },

  data: function data() {
    return {
      user: {
        username: null,
        displayName: null,
        clinicalCenter: null,
        clinicalCenterId: null,
        code: null,
        therapists: [],
        therapistIds: [],
        timezone: null,
        password: null,
        passwordConfirmation: null
      },
      oldUser: {},
      userTimezone: null,
      therapists: [],
      clinicalCenters: [],
      timezonesList: [],
      isLoaded: true,
      searchText: null,
      searchTimezoneText: null,
      disabled: false,
      userName: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('user.username'),
      passwordLabel: __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('validation.attributes.password')
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* Validator */].extend('unique_username', {
                getMessage: function getMessage(attribute) {
                  return __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('validation.unique', { attribute: attribute });
                },
                validate: function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(username) {
                    var valid, userId, _ref2, response;

                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            valid = void 0;
                            userId = void 0;

                            if (!_this.isEdit) {
                              _context.next = 8;
                              break;
                            }

                            if (!(username === _this.oldUser.username)) {
                              _context.next = 7;
                              break;
                            }

                            return _context.abrupt('return', true);

                          case 7:
                            userId = _this.user.id;

                          case 8:
                            _context.prev = 8;
                            _context.next = 11;
                            return __WEBPACK_IMPORTED_MODULE_18_axios___default.a.post('/registration/validate-username', { username: username, userId: userId });

                          case 11:
                            _ref2 = _context.sent;
                            response = _ref2.data;

                            valid = response.data.valid;
                            _context.next = 19;
                            break;

                          case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](8);

                            valid = false;

                          case 19:
                            return _context.abrupt('return', { valid: valid });

                          case 20:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[8, 16]]);
                  }));

                  return function validate(_x) {
                    return _ref.apply(this, arguments);
                  };
                }()
              });

              if (_this.timezones) {
                _context2.next = 6;
                break;
              }

              _this.isLoaded = false;
              _context2.next = 5;
              return _this.loadTimezones();

            case 5:
              _this.isLoaded = true;

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('client/repository', ['timezones', 'validationError', 'isChanged']), {
    isEdit: function isEdit() {
      return !__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.data);
    },

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },
    timezonesListNew: function timezonesListNew() {
      var _this2 = this;

      return this.timezonesList.filter(function (item) {
        if (_this2.searchTimezoneText && _this2.searchTimezoneText.length > __WEBPACK_IMPORTED_MODULE_16__Constants__["a" /* default */].MIN_CHARACTERS_LENGTH) {
          if (item.label.replace(/^.{Constants.FIRST_TIMES_CHARACTERS_LENGTH}/, '').toLowerCase().indexOf(_this2.searchTimezoneText.toLowerCase()) > -1) {
            return item;
          }
        } else {
          return item;
        }
      });
    },
    clinicalCentersNew: function clinicalCentersNew() {
      var _this3 = this;

      return this.clinicalCenters.filter(function (item) {
        if (_this3.user.clinicalCenter) {
          return item.name !== _this3.user.clinicalCenter.name;
        } else {
          return item.name;
        }
      });
    },
    therapistsNew: function therapistsNew() {
      var _this4 = this;

      if (this.user.therapists) {

        return this.therapists.filter(function (item) {
          var counter = 0;

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this4.user.therapists), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _therapist = _step.value;

              if (item.id === _therapist.id) {
                counter++;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (counter === 0) {
            return true;
          }
        });
      } else {
        return this.therapists;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('client/repository', ['editItem', 'addItem', 'loadTimezones']), {
    onSearchTherapist: function onSearchTherapist(search, loading) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading(true);
                _context3.next = 3;
                return _this5.searchTherapists(__WEBPACK_IMPORTED_MODULE_7__api_therapist__["a" /* default */], search, _this5);

              case 3:
                _this5.searchText = search;
                loading(false);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    onSearchTimezone: function onSearchTimezone(search) {
      this.searchTimezoneText = search;
    },

    searchTherapists: __WEBPACK_IMPORTED_MODULE_14_lodash_debounce___default()(function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(apiManager, search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return apiManager.search(search, 500, 1);

              case 3:
                response = _context4.sent;

                vm.therapists = response.data.data.items;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 7]]);
      }));

      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }(), 350),
    onChangeTherapist: function onChangeTherapist(val) {
      this.user.therapists = val;
      this.user.therapistIds = this.user.therapists ? __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(this.user.therapists, function (therapist) {
        return therapist.id;
      }) : [];
    },
    searchClinicalCenter: function searchClinicalCenter(search, perPage, page) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__api_clinicalCenter__["a" /* default */].search(search, perPage, page);

              case 2:
                response = _context5.sent;

                _this7.clinicalCenters = response.data.data.items;

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    onChangeClinicalCenter: function onChangeClinicalCenter(val) {
      this.user.clinicalCenter = val;
      this.user.clinicalCenterId = this.user.clinicalCenter ? this.user.clinicalCenter.id : null;
    },
    save: function save() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result, method, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.disabled = true;
                _context6.next = 3;
                return _this8.$validator.validateAll();

              case 3:
                result = _context6.sent;

                if (result) {
                  _context6.next = 7;
                  break;
                }

                _this8.disabled = false;
                return _context6.abrupt('return');

              case 7:

                try {
                  _this8.user.timezone = _this8.userTimezone.id;

                  method = _this8.isEdit ? _this8.editItem : _this8.addItem;
                  response = method(_this8.$data.user);
                } catch (e) {

                  console.info("e");
                  console.info(e);
                } finally {
                  _this8.disabled = false;
                }

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.searchText = null;
      this.errors.clear();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    }
  }),
  watch: {
    visible: function visible(newValue, oldValue) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var index, response, _index;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this9.searchClinicalCenter('', __WEBPACK_IMPORTED_MODULE_16__Constants__["a" /* default */].PER_PAGE, __WEBPACK_IMPORTED_MODULE_16__Constants__["a" /* default */].PAGE);
                _this9.$refs.therapistsSelect.onEscape();
                _this9.searchText = null;
                if (!_this9.timezonesList.length) {
                  for (index in _this9.timezones) {
                    _this9.timezonesList.push({ id: index, label: _this9.timezones[index] });
                  }
                }

                if (!_this9.isEdit) {
                  _context7.next = 25;
                  break;
                }

                if (!(_this9.data.item && __WEBPACK_IMPORTED_MODULE_12_lodash_isObject___default()(_this9.data.item))) {
                  _context7.next = 25;
                  break;
                }

                _context7.prev = 6;

                _this9.isLoaded = false;
                _context7.next = 10;
                return __WEBPACK_IMPORTED_MODULE_8__api_client__["a" /* default */].findById({ id: _this9.data.item.id });

              case 10:
                response = _context7.sent;

                _this9.user = response.data.data;
                _this9.oldUser = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(_this9.user);
                _this9.therapists = _this9.user.therapists ? _this9.user.therapists : [];
                _this9.clinicalCenters.push(_this9.user.clinicalCenter);

                for (_index in _this9.timezones) {
                  if (_this9.user.timezone == _index) {
                    _this9.userTimezone = _this9.timezones[_index];
                  }
                }
                _context7.next = 22;
                break;

              case 18:
                _context7.prev = 18;
                _context7.t0 = _context7['catch'](6);

                console.error('Unknown API error occurred.');
                _this9.isLoaded = true;

              case 22:
                _context7.prev = 22;

                _this9.isLoaded = true;
                return _context7.finish(22);

              case 25:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[6, 18, 22, 25]]);
      }))();
    },
    validationError: function validationError(newValue) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (newValue) {
                  _this10.errors.add({
                    field: 'isValidationError',
                    msg: newValue.message
                  });
                } else {
                  _this10.errors.clear();
                }

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    isChanged: function isChanged(newValue) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (newValue) {
                  _this11.close();
                }

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientRow',
  props: {
    item: Object,
    showEdit: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    showDelete: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      isOpen: false,
      isModalVisible: false
    };
  },

  methods: {
    close: function close() {
      this.isOpen = false;
    },
    showDeletePopup: function showDeletePopup() {
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    editItem: function editItem() {
      this.close();
      this.$emit('editItem', this.item);
    },
    deleteItem: function deleteItem() {
      this.close();
      this.$emit('deleteItem', this.item.id);
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__client_components_ClientBtn__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_table_Search__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__ = __webpack_require__(21);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Curators',
  data: function data() {
    return {
      isModalVisible: false,
      paginate: {
        perPage: 10,
        page: 0,
        forcePage: 0,
        pageRange: 3,
        marginPages: 2
      },
      isChange: false,
      modal: {
        data: {}
      },
      options: {
        pageHeader: 'curators',
        filterable: false,
        initialPage: null,
        sortable: [],
        withSearch: true,
        placeholder: '',
        debounce: 1500,
        skin: 'table table-sm',
        columns: [{
          key: 'curators',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.curators')
        }, {
          key: 'therapistsCount',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.therapists') + '/ ' + __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.clients')
        }, {
          key: 'bidsOnWorkCount',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.request_for_work_overdue')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.items,
            count: resp.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.type_the_curator_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          curators: 'mw120',
          therapistsCount: 'text-center',
          bidsOnWorkCount: 'text-center',
          action: 'table-actions'
        },
        perPage: 10
      },
      search: '',
      sort: '-id'
    };
  },

  components: {
    Search: __WEBPACK_IMPORTED_MODULE_10__common_table_Search__["a" /* default */], Paginate: __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate___default.a, curatorModal: __WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* default */], clientBtn: __WEBPACK_IMPORTED_MODULE_7__client_components_ClientBtn__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('curator/repository', ['items', 'page', 'pageCount', 'total', 'hasMorePages', 'isLoaded', 'isChanged']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['canCreateCurator', 'canUpdateCurator', 'canDeleteCurator', 'isMensurationForbidden']), {
    isEmptyList: function isEmptyList() {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default()(this.items);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('curator/repository', ['getItems', 'deleteItemById']), {
    getTranslation: function getTranslation() {
      return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */], arguments);
    },
    getCurators: function getCurators(page, sort, search) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'curators');
                _context.next = 4;
                return _this.getItems({
                  perPage: _this.options.perPage,
                  page: page,
                  sort: sort ? sort : _this.sort,
                  search: search ? search : _this.search
                });

              case 4:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.getCurators(data.page, _this2.sort, data.query));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onAddCuratorModalBtnClick: function onAddCuratorModalBtnClick() {
      this.modal.data = {};
      this.isModalVisible = true;
      this.isChange = false;
    },
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isChange = true;
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.modal.data = { item: item };
      this.isModalVisible = true;
      this.isChange = false;
    },

    onDeleteBtnClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isChange = false;
                _context3.next = 3;
                return this.deleteItemById({ id: id });

              case 3:
                _context3.next = 5;
                return this.getCurators(this.page);

              case 5:
                response = _context3.sent;


                if (response) {
                  this.isChange = true;
                }

                this.setPaginateState(this.page);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onDeleteBtnClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onDeleteBtnClick;
    }(),
    onPaginationClick: function onPaginationClick(page) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.getCurators(page);

              case 2:
                _this3.setPaginateState(page);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    setPaginateState: function setPaginateState(page) {
      this.paginate.page = page;
      this.paginate.forcePage = page - 1;
    },

    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
    }
  }),
  watch: {
    pageCount: function pageCount(newValue, oldValue) {
      // spike :
      if (newValue > 1 && oldValue === 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    page: function page(newValue, oldValue) {
      // spike :
      if (newValue === 1 && oldValue > 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    isChanged: function isChanged(newValue, oldValue) {
      if (newValue) {
        this.isChange = newValue;
      }
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_curator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CuratorModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      user: {
        username: null,
        displayName: null,
        password: null,
        passwordConfirmation: null
      },
      oldUser: {},
      isLoaded: true,
      disabled: false,
      userName: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('user.username'),
      passwordLabel: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('validation.attributes.password')
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* Validator */].extend('unique_username', {
                getMessage: function getMessage(attribute) {
                  return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('validation.unique', { attribute: attribute });
                },
                validate: function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(username) {
                    var valid, userId, _ref2, response;

                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            valid = void 0;
                            userId = void 0;

                            if (!_this.isEdit) {
                              _context.next = 8;
                              break;
                            }

                            if (!(username === _this.oldUser.username)) {
                              _context.next = 7;
                              break;
                            }

                            return _context.abrupt('return', true);

                          case 7:
                            userId = _this.user.id;

                          case 8:
                            _context.prev = 8;
                            _context.next = 11;
                            return __WEBPACK_IMPORTED_MODULE_12_axios___default.a.post('/registration/validate-username', { username: username, userId: userId });

                          case 11:
                            _ref2 = _context.sent;
                            response = _ref2.data;

                            valid = response.data.valid;
                            _context.next = 19;
                            break;

                          case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](8);

                            valid = false;

                          case 19:
                            return _context.abrupt('return', { valid: valid });

                          case 20:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[8, 16]]);
                  }));

                  return function validate(_x) {
                    return _ref.apply(this, arguments);
                  };
                }()
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('curator/repository', ['editItem', 'addItem']), {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, method;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.disabled = true;
                _context3.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context3.sent;

                if (result) {
                  _context3.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context3.abrupt('return');

              case 7:

                try {
                  method = _this2.isEdit ? _this2.editItem : _this2.addItem;


                  method(_this2.user);

                  //this.close();
                } catch (e) {} finally {
                  _this2.disabled = false;
                  _this2.isloading = true;
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    reset: function reset() {
      console.log(this.$data);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.errors.clear();
    },
    close: function close() {
      this.$emit('close');
      this.reset();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    isEdit: function isEdit() {
      return !__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default()(this.data);
    },

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('curator/repository', ['validationError', 'isChanged'])),
  watch: {
    visible: function visible(newValue, oldValue) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this3.isEdit) {
                  _context4.next = 17;
                  break;
                }

                if (!(_this3.data.item && __WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default()(_this3.data.item))) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 2;

                _this3.isLoaded = false;
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__api_curator__["a" /* default */].findById({ id: _this3.data.item.id });

              case 6:
                response = _context4.sent;

                _this3.user = response.data.data;
                _this3.oldUser = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(_this3.data.item);
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](2);

                console.error('Unknown API error occurred.');

              case 14:
                _context4.prev = 14;

                _this3.isLoaded = true;
                return _context4.finish(14);

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[2, 11, 14, 17]]);
      }))();
    },
    validationError: function validationError(newValue) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (newValue) {
                  _this4.errors.add({
                    field: 'isValidationError',
                    msg: newValue.message
                  });
                } else {
                  _this4.errors.clear();
                }

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    isChanged: function isChanged(newValue) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (newValue) {
                  _this5.close();
                }

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientInfo__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignedProtocolList__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConflictProtocolList__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModulesList__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_bids_components_BidsList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientProfile',
  props: ['clientId'],
  data: function data() {
    return {
      client: {},
      protocols: [],
      disabled: false,
      onlyList: false,
      reloadBids: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA', 'isPreviousDateSession'])),
  mixins: [__WEBPACK_IMPORTED_MODULE_6__common_mixins_showModal__["a" /* showModal */]],

  components: {
    ClientInfo: __WEBPACK_IMPORTED_MODULE_1__ClientInfo__["a" /* default */], AssignedProtocolList: __WEBPACK_IMPORTED_MODULE_2__AssignedProtocolList__["a" /* default */], BidsList: __WEBPACK_IMPORTED_MODULE_5__modules_bids_components_BidsList__["a" /* default */], ModulesList: __WEBPACK_IMPORTED_MODULE_4__ModulesList__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_7__dashboardParent_components_DashboardMenu__["a" /* default */], ConflictProtocolList: __WEBPACK_IMPORTED_MODULE_3__ConflictProtocolList__["a" /* default */]
  },
  methods: {
    reloadList: function reloadList() {
      var _this = this;

      this.reloadBids = true;
      setTimeout(function () {
        _this.reloadBids = false;
      }, 500);
    }
  },
  mounted: function mounted() {
    var anchor = this.$router.currentRoute.hash;
    this.$nextTick(function () {
      if (anchor && document.querySelector(anchor)) {
        location.href = anchor;
      }
    });
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientInfo',
  props: ['clientId'],
  data: function data() {
    return {
      apiUrl: '/users/',
      client: {},
      hasAssignedQuiz: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getClient(_this.clientId);

              if (_this.isTherapist) {
                _this.getAssignedQuiz();
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isCurator', 'isBCBA', 'isTherapist', 'isPreviousDateSession'])),
  methods: {

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + 'clients/' + clientId);

              case 3:
                response = _context2.sent;

                this.client = response.data.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }(),
    getAssignedQuiz: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + this.clientId + '/quiz/has-assigned-quiz');

              case 3:
                response = _context3.sent;

                this.hasAssignedQuiz = !!response.data.data.hasAssignedQuiz;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getAssignedQuiz() {
        return _ref2.apply(this, arguments);
      }

      return getAssignedQuiz;
    }()
  }

});

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientInfo',
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'onlyList': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'reload': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      protocolUrl: '/protocols/users/',
      conflictedUrl: '/protocols/assigned/',
      conflictedProtocols: [],
      isLoaded: true,
      isDeleteModalVisible: false,
      assignedSessionId: null,
      isChange: false,
      options: {
        initialPage: null,
        filterable: false,
        sortable: [],
        skin: 'table table-sm',
        withSearch: true,
        columns: [{
          key: 'id',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.protocols')
        }, {
          key: 'protocols',
          changed: true,
          headings: ''
        }, {
          key: 'createdAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.save_session_date')
        }, {
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.start_session_date')
        }, {
          key: 'stimuliCount',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.trial_count')
        }, {
          key: 'stageIndex',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('protocol.stage_count')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.type_the_procol_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          id: 'action-cell',
          stageIndex: 'text-center',
          stimuliCount: 'text-center',
          startedAt: 'text-center nowrap',
          createdAt: 'text-center nowrap',
          action: 'table-actions'
        },
        templates: {
          startedAt: this.startedAt,
          createdAt: this.createdAt
        },
        toMomentFormat: ['updatedAt', 'createdAt'],
        perPage: 10,
        columnsDisplay: {
          id: 'min_tabletL',
          startedAt: 'min_tabletL',
          createdAt: 'min_tabletL'
        }
      },
      search: ''
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */], __WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__["a" /* showModal */]],

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isEmptyProtocols: function isEmptyProtocols() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.conflictedProtocols);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['isTherapist', 'isCurator', 'isClient', 'isBCBA', 'isMensurationForbidden'])),

  mounted: function mounted() {

    if (localStorage.currentConflictPage) {
      this.options.initialPage = localStorage.getItem("currentConflictPage");
    }
    this.options.initialPage = this.options.initialPage ? this.options.initialPage : 1;

    console.info(this.options.initialPage);
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentConflictPage');
  },


  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startedAt: function startedAt(h, row) {
      return this.toLocaleDate(row.startedAt.date);
    },
    createdAt: function createdAt(h, row) {
      return this.toLocaleDate(row.createdAt.date);
    },
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.getConflictedProtocols(_this.options.perPage, data.page, _this.clientId, data.query));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    isNew: function isNew(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_10__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].NEW;
    },

    isActive: function isActive(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_10__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].ACTIVE;
    },

    isMaintaining: function isMaintaining(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_10__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].MAINTAINING;
    },

    isCompleted: function isCompleted(protocol) {
      return protocol.status.id === __WEBPACK_IMPORTED_MODULE_10__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].COMPLETED;
    },

    isDTT: function isDTT(protocol) {
      return protocol.protocol.teachingMethod.id === 1;
    },

    getConflictedProtocols: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(perPage, page, clientId, search) {
        var params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.isLoaded = false;
                localStorage.setItem('currentConflictPage', page);
                search = search ? search : this.search;
                params = {
                  sort: this.sort
                };

                if (search) {
                  params.search = search;
                }
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.conflictedUrl + clientId + '/inconsistent/sessions/' + perPage + '/' + page, {
                  params: params
                });

              case 8:
                response = _context2.sent;


                this.conflictedProtocols = response.data.data.items;
                this.isLoaded = true;
                if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.conflictedProtocols)) {
                  this.setPaginate(response.data.data);
                }

                return _context2.abrupt('return', response);

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 15]]);
      }));

      function getConflictedProtocols(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getConflictedProtocols;
    }(),

    showDeletePopup: function showDeletePopup(id) {
      this.assignedSessionId = id;
      this.isDeleteModalVisible = true;
      this.isChange = false;
    },


    onRemoveActiveProtocol: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(sessionId) {
        var isDeleted;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.isLoaded = false;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(this.conflictedUrl + this.clientId + '/inconsistent/sessions/' + sessionId);

              case 4:
                isDeleted = _context3.sent;

                if (isDeleted) {
                  this.getConflictedProtocols(this.paginate.perPage, this.paginate.page, this.clientId);
                  this.isLoaded = true;
                  this.isChange = true;
                }

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function onRemoveActiveProtocol(_x5) {
        return _ref2.apply(this, arguments);
      }

      return onRemoveActiveProtocol;
    }(),

    onPaginationClick: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(pageNum) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.getConflictedProtocols(this.paginate.perPage, pageNum, this.clientId);
                this.onPaginationBtnClick(pageNum);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPaginationClick(_x6) {
        return _ref3.apply(this, arguments);
      }

      return onPaginationClick;
    }(),

    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
      this.paginate.page = 1;
    }
  },
  watch: {
    reload: function reload(newVal) {
      if (newVal) {
        this.isChange = false;
        var response = this.getConflictedProtocols(this.paginate.perPage, this.paginate.page, this.clientId);

        if (response) {
          this.isChange = true;
        }
      }
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dro_components_ModuleItem_vue__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__randomRotation_components_ModuleItem_vue__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return this.route.params.clientId || null;
      }
    }
  },

  data: function data() {
    return {
      isLoadedDro: false,
      isLoadedRotation: false,
      hasAccessDro: false,
      hasAccessRotation: false
    };
  },


  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */], DroModuleItem: __WEBPACK_IMPORTED_MODULE_1__dro_components_ModuleItem_vue__["a" /* default */], RotationModuleItem: __WEBPACK_IMPORTED_MODULE_2__randomRotation_components_ModuleItem_vue__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route'])),

  methods: {
    setHasAccessDro: function setHasAccessDro() {
      this.hasAccessDro = true;
    },
    setHasAccessRotation: function setHasAccessRotation() {
      this.hasAccessRotation = true;
    },
    setLoadedDro: function setLoadedDro() {
      this.isLoadedDro = true;
    },
    setLoadedRotation: function setLoadedRotation() {
      this.isLoadedRotation = true;
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return this.route.params.clientId || null;
      }
    }
  },

  data: function data() {
    return {
      hasAccess: false
    };
  },


  components: {},

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('dro/session', ['isSessionStarted'])),

  created: function created() {
    this.checkAccess();
  },


  methods: {
    checkAccess: function checkAccess() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].hasAccess(_this.clientId);

              case 3:
                response = _context.sent;

                if (!(response && response.data)) {
                  _context.next = 9;
                  break;
                }

                if (response.data.data.hasAccess) {
                  _this.hasAccess = true;
                  _this.$emit('hasAccess');
                }

                _this.$emit('isLoaded');
                _context.next = 11;
                break;

              case 9:
                _this.$emit('isLoaded');
                throw new Error('Unknown API error');

              case 11:
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.$emit('isLoaded');
                console.error(_context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    openDetail: function openDetail() {
      if (this.isSessionStarted) {
        this.$router.push({ name: 'dro-session', params: this.route.params });
      } else {
        this.$router.push({ name: 'dro', params: this.route.params });
      }
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Manager__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    return {
      hasAccess: false
    };
  },


  components: {},

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])(['route'])),

  created: function created() {
    this.checkAccess();
  },


  methods: {
    checkAccess: function checkAccess() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].hasAccess(_this.clientId);

              case 3:
                response = _context.sent;

                if (!(response && response.data)) {
                  _context.next = 9;
                  break;
                }

                if (response.data.data.hasAccess) {
                  _this.hasAccess = true;
                  _this.$emit('hasAccess');
                }

                _this.$emit('isLoaded');
                _context.next = 11;
                break;

              case 9:
                _this.$emit('isLoaded');
                throw new Error('Unknown API error');

              case 11:
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.$emit('isLoaded');
                console.error(_context.t0);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    openDetail: function openDetail() {
      this.$router.push({ name: 'rotation', params: this.route.params });
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDashboardLayout_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efdc453_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDashboardLayout_vue__ = __webpack_require__(1268);
function injectStyle (ssrContext) {
  __webpack_require__(1267)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efdc453_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardUserBCBA',
  components: {
    DashboardMenu: __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_DashboardMenu__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['canViewCurators', 'canViewTherapists', 'canViewClients', 'isTherapist', 'isClient', 'isPreviousDateSession']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']))
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_bids_components_BidsList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CuratorInfo__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_AttachedTherapistList__ = __webpack_require__(1272);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CuratorProfile',
  props: ['id'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__common_mixins_showModal__["a" /* showModal */]],

  components: {
    CuratorInfo: __WEBPACK_IMPORTED_MODULE_2__CuratorInfo__["a" /* default */], BidsList: __WEBPACK_IMPORTED_MODULE_0__modules_bids_components_BidsList__["a" /* default */], TherapistList: __WEBPACK_IMPORTED_MODULE_3__list_AttachedTherapistList__["a" /* default */]
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      required: true,
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      apiUrl: '/users/curators/',
      curator: {}
    };
  },
  created: function created() {
    this.getCurator(this.id);
  },

  methods: {
    getCurator: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(curatorId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.apiUrl + curatorId);

              case 3:
                response = _context.sent;

                this.curator = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getCurator(_x) {
        return _ref.apply(this, arguments);
      }

      return getCurator;
    }()
  }

});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TherapistItem__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Manager__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modals_DeleteTherapistModal__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_AddTherapistModal__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_Search__ = __webpack_require__(104);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    curatorId: {
      type: [Number, String],
      default: function _default() {
        return this.$route.params.id || null;
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_mixins_pagination__["a" /* pagination */]],
  data: function data() {
    return {
      isLoaded: false,
      items: [],
      api: null,
      deleteModal: {
        id: null,
        isOpen: false
      },
      isAddTherapistModalOpen: false,
      search: ''
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.api = new __WEBPACK_IMPORTED_MODULE_8__api_Manager__["a" /* default */](_this.curatorId);
              _context.next = 3;
              return _this.getItems();

            case 3:
              _this.isLoaded = true;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.api = null;
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */], Item: __WEBPACK_IMPORTED_MODULE_7__TherapistItem__["a" /* default */], DeleteTherapistModal: __WEBPACK_IMPORTED_MODULE_9__modals_DeleteTherapistModal__["a" /* default */], AddTherapistModal: __WEBPACK_IMPORTED_MODULE_10__modals_AddTherapistModal__["a" /* default */], Search: __WEBPACK_IMPORTED_MODULE_11__common_table_Search__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['canCreateCurator', 'canUpdateCurator', 'canDeleteCurator', 'isMensurationForbidden']), {
    isEmptyList: function isEmptyList() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(this.items);
    },
    lastPage: function lastPage() {
      return this.paginate.lastPage;
    },
    page: function page() {
      return this.paginate.page;
    }
  }),
  methods: {
    getItems: function getItems() {
      var _this2 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, _response$data$data, items, perPage, lastPage, currentPage;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.api.getTherapists(_this2.paginate.perPage, reset ? 1 : _this2.paginate.page, _this2.search);

              case 3:
                response = _context2.sent;
                _response$data$data = response.data.data, items = _response$data$data.items, perPage = _response$data$data.perPage, lastPage = _response$data$data.lastPage, currentPage = _response$data$data.currentPage;

                _this2.items = items;
                _this2.setPaginate({ perPage: perPage, lastPage: lastPage, currentPage: currentPage });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    onPaginationClick: function onPaginationClick(pageNum) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoaded = false;
                _this3.onPaginationBtnClick(pageNum);
                _context3.next = 4;
                return _this3.getItems();

              case 4:
                _this3.isLoaded = true;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onDeleteTherapist: function onDeleteTherapist(id) {
      this.deleteModal.id = id;
      this.toggleDeleteModal();
    },
    toggleDeleteModal: function toggleDeleteModal() {
      this.deleteModal.isOpen = !this.deleteModal.isOpen;
    },
    deleteTherapist: function deleteTherapist() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoaded = false;
                _context4.prev = 1;
                _context4.next = 4;
                return _this4.api.deleteTherapist(_this4.deleteModal.id);

              case 4:
                _context4.next = 6;
                return _this4.getItems(true);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](1);

                console.error(_context4.t0);

              case 11:
                _this4.toggleDeleteModal();
                _this4.deleteModal.id = null;
                _this4.isLoaded = true;

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 8]]);
      }))();
    },
    toggleAddTherapistModal: function toggleAddTherapistModal() {
      this.isAddTherapistModalOpen = !this.isAddTherapistModalOpen;
    },
    onAddTherapist: function onAddTherapist() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isLoaded = false;
                _this5.toggleAddTherapistModal();
                _context5.next = 4;
                return _this5.getItems(true);

              case 4:
                _this5.isLoaded = true;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    onSearchEnter: function onSearchEnter(search) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.isLoaded = false;
                _this6.search = search;
                _context6.next = 4;
                return _this6.getItems(true);

              case 4:
                _this6.isLoaded = true;

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  },
  watch: {
    lastPage: function lastPage(newValue, oldValue) {
      // spike :
      if (newValue > 1 && oldValue === 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    page: function page(newValue, oldValue) {
      // spike :
      if (newValue === 1 && oldValue > 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: Object
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden'])),
  methods: {
    close: function close() {
      this.isOpen = false;
    },
    deleteItem: function deleteItem() {
      this.close();
      this.$emit('deleteItem', this.item.id);
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var Manager = function () {
  function Manager(curatorId) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    this.baseUrl = "https://app.autismtech.online/api" + ('/users/curators/' + curatorId);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'getTherapists',
    value: function getTherapists() {
      var perPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/therapists', {
        params: {
          perPage: perPage,
          page: page,
          search: search
        }
      });
    }
  }, {
    key: 'deleteTherapist',
    value: function deleteTherapist(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(this.baseUrl + '/therapists/' + id);
    }
  }, {
    key: 'addTherapist',
    value: function addTherapist(id) {
      var therapistIds = [id];
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.baseUrl + '/therapists', {
        therapistIds: therapistIds
      });
    }
  }, {
    key: 'getNotOwnTherapists',
    value: function getNotOwnTherapists() {
      var perPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.baseUrl + '/therapists', {
        params: {
          perPage: perPage,
          page: page,
          isOwn: 0
        }
      });
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeleteTherapistModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  methods: {
    confirm: function confirm() {
      this.$emit('confirm');
    },
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Manager__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddTherapistModal',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */], selectWithPager: __WEBPACK_IMPORTED_MODULE_4__common_selectWithPager_components_SelectWithPager__["a" /* default */] },
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    curatorId: {
      type: [Number, String],
      default: function _default() {
        return this.$route.params.id || null;
      }
    }
  },
  data: function data() {
    return {
      therapists: [],
      api: null,
      therapistId: null,
      isLoaded: false,
      disabled: true,
      isLastPage: false,
      loading: false,
      perPage: 5,
      page: 1,
      lastId: null
    };
  },
  created: function created() {
    this.api = new __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */](this.curatorId);
  },
  beforeDestroy: function beforeDestroy() {
    this.api = null;
  },

  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },
    isListEmpty: function isListEmpty() {
      return !this.therapists.length;
    },
    isAcceptDisabled: function isAcceptDisabled() {
      return this.disabled || this.isListEmpty;
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    accept: function accept() {
      this.$emit('accept');
    },
    save: function save(_ref) {
      var _this = this;

      var accept = _ref.accept;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (result) {
                  _context.next = 7;
                  break;
                }

                _this.disabled = false;
                return _context.abrupt('return');

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return _this.api.addTherapist(_this.therapistId.id);

              case 10:
                accept();
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                console.error(_context.t0);
                _this.disabled = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 13]]);
      }))();
    },


    nextPage: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isLastPage) {
                  _context2.next = 9;
                  break;
                }

                this.loading = true;
                _context2.next = 4;
                return this.api.getNotOwnTherapists(this.perPage, this.page);

              case 4:
                response = _context2.sent;


                response.data.data.items.forEach(function (item) {
                  _this2.therapists.push(item);
                });

                this.loading = false;
                this.lastId = this.therapists[this.therapists.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function nextPage() {
        return _ref2.apply(this, arguments);
      }

      return nextPage;
    }(),

    onSetSelected: function onSetSelected(selected) {
      this.therapistId = selected;
    },

    getOptionTitle: function getOptionTitle(_ref3) {
      var option = _ref3.option;

      return option.displayName;
    },

    isLast: function isLast(_ref4) {
      var option = _ref4.option;

      return option.id == this.lastId;
    }

  },
  watch: {
    visible: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(val) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isLoaded = false;
                this.disabled = true;

                if (!val) {
                  _context3.next = 17;
                  break;
                }

                _context3.prev = 3;
                _context3.next = 6;
                return this.api.getNotOwnTherapists(this.perPage, this.page);

              case 6:
                response = _context3.sent;

                this.therapists = response.data.data.items;
                this.lastId = this.therapists[this.therapists.length - 1].id;

                if (response.data.data.hasMorePages) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](3);

                console.error(_context3.t0);

              case 15:
                _context3.next = 18;
                break;

              case 17:
                this.therapists = [];

              case 18:
                this.isLoaded = true;
                this.disabled = false;

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 12]]);
      }));

      function visible(_x) {
        return _ref5.apply(this, arguments);
      }

      return visible;
    }()
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsForm__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SettingsTable__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CurrentIntervalForm__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportModal__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IntervalList__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loadDroInitData__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      processing: false,
      isModalVisible: false,
      hideDroModal: true,
      apiUrl: '/users/clients/',
      client: {}
    };
  },

  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_10__common_mixins_showModal__["a" /* showModal */], __WEBPACK_IMPORTED_MODULE_14__mixins_loadDroInitData__["a" /* loadDroInitData */]],
  components: {
    IntervalList: __WEBPACK_IMPORTED_MODULE_9__IntervalList__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */],
    SettingsForm: __WEBPACK_IMPORTED_MODULE_4__SettingsForm__["a" /* default */],
    SettingsTable: __WEBPACK_IMPORTED_MODULE_5__SettingsTable__["a" /* default */],
    Instruction: __WEBPACK_IMPORTED_MODULE_6__common_instruction_components_InstructionView__["a" /* default */],
    CurrentIntervalForm: __WEBPACK_IMPORTED_MODULE_7__CurrentIntervalForm__["a" /* default */],
    ReportModal: __WEBPACK_IMPORTED_MODULE_8__ReportModal__["a" /* default */],
    DashboardMenu: __WEBPACK_IMPORTED_MODULE_13__dashboardParent_components_DashboardMenu__["a" /* default */]
  },

  created: function created() {
    this.getClient(this.clientId);
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["d" /* mapState */])('dro/session', ['settings', 'intervals', 'assignee', 'isSessionStarted', 'uuid']), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["d" /* mapState */])(['route']), {
    isIntervalsNotEmpty: function isIntervalsNotEmpty() {
      return !!this.intervals.length;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('dro/session', ['shouldSessionBeSaved', 'saveSessionData'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('dro/session', ['clearSession']), {
    onSaveSession: function onSaveSession() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.processing = true;

                if (!_this.shouldSessionBeSaved) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__api_Manager__["a" /* default */].save(_this.saveSessionData);

              case 5:
                _ref = _context.sent;
                response = _ref.data;

                if (response && response.data && response.data.id) {
                  _context.next = 9;
                  break;
                }

                throw new Error('Session wasn\'t saved');

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);
                throw new Error('Unknown API error');

              case 14:
                _this.onShowModalBtnClick();
                _this.processing = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 11]]);
      }))();
    },
    onClose: function onClose() {
      this.loaded = false;
      this.onModalClose();
      this.clearSession();
      this.$router.push({ name: 'dro', params: this.route.params });
    },
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.clientId } });
    },

    getClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(this.apiUrl + clientId);

              case 3:
                response = _context2.sent;

                this.client = response.data.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return getClient;
    }()

  })
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('dro/session', ['settings']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('dro/session', ['intervalDuration']))
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_currentIntervalForm__ = __webpack_require__(469);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_currentIntervalForm__["a" /* currentIntervalForm */]],

  created: function created() {
    this.fillFormData();
    this.init();
  },

  methods: {
    clickPrevent: function clickPrevent(e) {
      e.preventDefault();
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('dro/session', ['intervals']))
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DroReport__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DroReport: __WEBPACK_IMPORTED_MODULE_3__DroReport__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__["a" /* default */] },
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    }
  },
  data: function data() {
    return {
      loaded: false,
      hideDroModal: true,
      apiUrl: '/users/clients/',
      client: {}
    };
  },
  created: function created() {
    this.getClient(this.clientId);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden'])),
  methods: {
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.clientId } });
    },

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.apiUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }()
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Manager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reports: [],
      isLoaded: true,
      sort: '-id',
      hasPager: false,
      options: {
        pageHeader: 'droReports',
        filterable: false,
        initialPage: null,
        sortable: [],
        skin: 'table table-sm table-with-head',
        columns: [{
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.started_at')
        }, {
          key: 'auditor',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.auditor')
        }, {
          key: 'behaviourDescription',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.behaviour_description')
        }, {
          key: 'intervalCount',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.interval_count')
        }, {
          key: 'successRate',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.success_rate')
        }, {
          key: 'failRate',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.fail_rate')
        }, {
          key: 'averageSuccessfulIntervalDuration',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.average_successful_interval_duration')
        }, {
          key: 'exportReport',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.download_report')
        }],
        listRow: {
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.started_at'),
            hasTemplate: true
          },
          auditor: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.auditor'),
            hasTemplate: true
          },
          behaviourDescription: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.behaviour_description'),
            hasTemplate: false
          },
          intervalCount: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.interval_count'),
            hasTemplate: false
          },
          successRate: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.success_rate'),
            hasTemplate: false
          },
          failRate: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.fail_rate'),
            hasTemplate: false
          },
          averageSuccessfulIntervalDuration: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.average_successful_interval_duration'),
            hasTemplate: false
          },
          exportReport: {
            headings: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('dro.report.download_report'),
            hasTemplate: false
          }
        },
        templates: {
          startedAt: this.startedAt,
          auditor: this.auditor
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.items,
            count: resp.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          startedAt: 'text-center',
          auditor: 'text-center',
          behaviourDescription: 'text-center',
          intervalCount: 'text-center',
          successRate: 'text-center',
          failRate: 'text-center',
          averageSuccessfulIntervalDuration: 'text-center',
          exportReport: 'text-center'
        },
        perPage: 10
      }
    };
  },

  components: { Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_9__common_table_components_TableView__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isEmptyReports: function isEmptyReports() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.reports);
    }
  }),
  created: function created() {
    //let assigneeId = this.route.params.clientId;
    //this.fetchReports(assigneeId, this.paginate.perPage, this.paginate.page);
  },

  methods: {

    toLocaleDateTime: function toLocaleDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
    },

    startedAt: function startedAt(h, row) {
      return this.toLocaleDateTime(row.startedAt.date);
    },
    auditor: function auditor(h, row) {
      return row.auditor.name;
    },
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var assigneeId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assigneeId = _this.route.params.clientId;
                return _context.abrupt('return', _this.fetchReports(assigneeId, _this.options.perPage, data.page));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    fetchReports: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(assigneeId, perPage, page) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.isLoaded = false;
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'droReports');
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].getReports(assigneeId, perPage, page);

              case 6:
                response = _context2.sent;


                this.hasPager = response.data.data.lastPage > 1;

                this.reports = response.data.data.items.map(function (item) {
                  if (!item.behaviourDescription) {
                    item.behaviourDescription = __WEBPACK_IMPORTED_MODULE_8__lang_translator__["a" /* default */].get('export.reports.dro.not_specified');
                  }
                  return item;
                });
                this.setPaginate(response.data.data);
                this.isLoaded = true;

                return _context2.abrupt('return', response.data.data);

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);
                this.isLoaded = true;

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14]]);
      }));

      function fetchReports(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }(),
    exportReport: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].exportReports(id).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', 'report_' + id + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 3:
                response = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function exportReport(_x4) {
        return _ref2.apply(this, arguments);
      }

      return exportReport;
    }(),
    onPaginationClick: function onPaginationClick(pageNum) {
      var assigneeId = this.route.params.clientId;
      this.fetchReports(assigneeId, this.paginate.perPage, pageNum);
      this.onPaginationBtnClick(pageNum);
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsForm__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReportModal__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SessionsList__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Manager__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dro_Constants__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__ = __webpack_require__(19);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loaded: false,
      isSettingsSet: false,
      isModalVisible: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_mixins_showModal__["a" /* showModal */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */],
    SessionsList: __WEBPACK_IMPORTED_MODULE_7__SessionsList__["a" /* default */],
    SettingsForm: __WEBPACK_IMPORTED_MODULE_4__SettingsForm__["a" /* default */],
    Instruction: __WEBPACK_IMPORTED_MODULE_5__common_instruction_components_InstructionView__["a" /* default */],
    ReportModal: __WEBPACK_IMPORTED_MODULE_6__ReportModal__["a" /* default */],
    DashboardMenu: __WEBPACK_IMPORTED_MODULE_11__dashboardParent_components_DashboardMenu__["a" /* default */]
  },
  created: function created() {
    this.loadInitialData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])('rotation/session', ['stimuli', 'sessions', 'uuid']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('rotation/session', ['setAuditor', 'setAssignee', 'setSettings', 'clearSession', 'setUuid']), Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('appeals', ['setEntity']), {
    onSessionSettingsSet: function onSessionSettingsSet() {
      this.isSettingsSet = true;
      this.loaded = true;
    },
    loadInitialData: function loadInitialData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, _response$data$data, stimuli, auditor, assignee, entity;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getSettings(_this.route.params.clientId);

              case 3:
                response = _context.sent;
                _response$data$data = response.data.data, stimuli = _response$data$data.stimuli, auditor = _response$data$data.auditor, assignee = _response$data$data.assignee;

                _this.clearSession();
                _this.setSettings(stimuli);
                _this.setAuditor(auditor);
                _this.setAssignee(assignee);
                _this.setUuid(__WEBPACK_IMPORTED_MODULE_13__common_uuid_UuidGenerator__["a" /* default */].v4());
                entity = {
                  id: _this.uuid,
                  type: __WEBPACK_IMPORTED_MODULE_12__dro_Constants__["a" /* default */].ENTITY_TYPE
                };

                _this.setEntity(entity);
                _this.loaded = true;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.$router.push({ name: 'default' });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    },
    onClose: function onClose() {
      this.onModalClose();
      this.clearSession();
      this.$router.push({ name: 'rotation', params: this.route.params });
    }
  })
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      disabled: false,
      tableWasBuild: false,
      loaded: false,
      form: {},
      tempSessions: [],
      blocksLength: 9,
      blocksStimulusLength: 3,
      sessionsLength: 3
    };
  },

  components: { Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])('rotation/session', ['stimuli', 'sessions']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  created: function created() {
    var _this = this;

    this.form = __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default()(this.stimuli) ? ['', '', ''] : this.stimuli;

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* Validator */].extend('check-unique', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('rotation.unique_stimulus', { attribute: attribute });
      },
      validate: function validate() {
        var uniqueCounter = 0;

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.form).length; i++) {
          for (var j = 0; j < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.form).length; j++) {
            if (_this.form[i] == _this.form[j]) {
              uniqueCounter++;
            }
          }
        }

        return uniqueCounter === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.form).length;
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('rotation/session', ['setSettings', 'setSessions', 'setStartedAt', 'setIsSaved']), {
    buildTable: function buildTable() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, tempStimulus, k, session, i, stimuli, block, j;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.disabled = true;
                _this2.loaded = true;
                _this2.setSessions([]);

                _context.next = 5;
                return _this2.$validator.validateAll();

              case 5:
                result = _context.sent;

                if (result) {
                  _context.next = 10;
                  break;
                }

                _this2.disabled = false;
                _this2.loaded = false;
                return _context.abrupt('return');

              case 10:
                _this2.setSettings(_this2.form);
                _this2.setStartedAt(Math.round(new Date().getTime() / 1000));

                //create temp stimulus block for creating another
                tempStimulus = [_this2.form[0], _this2.form[1], _this2.form[2]];

                //for each sessions

                for (k = 0; k < _this2.sessionsLength; k++) {
                  //temp blocks for session
                  session = {
                    index: k + 1,
                    blocks: []
                  };

                  //for each blocks row

                  for (i = 0; i < _this2.blocksLength; i++) {
                    //temp block for each blocks row
                    stimuli = [];
                    block = {
                      index: i + 1,
                      resultId: __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].NO_ANSWER,
                      stimuli: []
                    };

                    //for each stimulus create object and add to blocks

                    for (j = 0; j < _this2.blocksStimulusLength; j++) {
                      stimuli[j] = {
                        name: tempStimulus[j],
                        position: j + 1,
                        correct: false
                      };
                    }

                    //shift stimulus by 1 in tempBlock
                    tempStimulus.unshift(tempStimulus.pop());

                    block.stimuli = stimuli;
                    session.blocks[i] = block;
                  }

                  //add all blocks to each session
                  _this2.tempSessions[k] = session;
                }

                //next go to setting active
                _this2.setActiveStimulus();

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setActiveStimulus: function setActiveStimulus() {
      //for each sessions
      for (var k = 0; k < this.sessionsLength; k++) {
        //array with index of active items in row
        var firstStimulusByBlocks = [];
        var activeItems = [];

        //for each stimulus column
        for (var j = 0; j < this.blocksLength; j++) {
          var self = this;
          var itemIndex = void 0;

          if (j === 0) {
            //random number for checking active element in column
            var activeIndex = Math.floor(Math.random() * self.blocksStimulusLength);
            //set active
            self.tempSessions[k].blocks[j].stimuli[activeIndex].correct = true;

            //add to activeItems
            activeItems = activeItems.concat(activeIndex);
            itemIndex = activeIndex;
          } else if (j % 3 == 0) {
            var newIndex = firstStimulusByBlocks[firstStimulusByBlocks.length - 1];

            switch (newIndex) {
              case 0:
                this.tempSessions[k].blocks[j].stimuli[1].correct = true;
                activeItems = activeItems.concat(1);
                itemIndex = 1;
                break;
              case 1:
                this.tempSessions[k].blocks[j].stimuli[2].correct = true;
                activeItems = activeItems.concat(2);
                itemIndex = 2;
                break;
              case 2:
                this.tempSessions[k].blocks[j].stimuli[0].correct = true;
                activeItems = activeItems.concat(0);
                itemIndex = 0;
                break;
            }
          } else {
            switch (activeItems[j - 1]) {
              case 0:
                this.tempSessions[k].blocks[j].stimuli[2].correct = true;
                activeItems = activeItems.concat(2);
                itemIndex = 2;
                break;
              case 1:
                this.tempSessions[k].blocks[j].stimuli[0].correct = true;
                activeItems = activeItems.concat(0);
                itemIndex = 0;
                break;
              case 2:
                this.tempSessions[k].blocks[j].stimuli[1].correct = true;
                activeItems = activeItems.concat(1);
                itemIndex = 1;
                break;
            }
          }

          if (j % 3 == 0) {
            firstStimulusByBlocks = firstStimulusByBlocks.concat(itemIndex);
          }
        }
      }

      this.tableWasBuild = true;
      this.disabled = false;
      this.loaded = false;
      this.setSessions(this.tempSessions);
      this.setIsSaved(true);
      this.$emit('session-settings-set');

      if (this.isMobile) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('html, body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#rotation-setting__button").offset().top - 10 }, 500);
      }
    },
    destroyTable: function destroyTable() {
      this.tableWasBuild = false;
      this.disabled = false;
      this.setSessions([]);
      this.setIsSaved(false);
      this.$emit('session-settings-set');

      if (this.isMobile) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('html, body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#rotation-settings").offset().top - 25 }, 500);
      }
    }
  })
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Manager__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(172);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      disabled: false,
      allApproachesCount: 0,
      approachesCheckedCount: 0,
      failAnswerCount: 0,
      successfulCount: 0,
      hintCount: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('rotation/session', ['auditor', 'assignee', 'settings', 'sessions', 'stimuli', 'startedAt', 'finishedAt', 'uuid']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    date: function date() {
      var date = new Date();
      var day = date.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      return day + '.' + month + '.' + date.getFullYear();
    },
    hintRate: function hintRate() {
      return Math.round(this.hintCount / this.allApproachesCount * 100) || 0;
    },
    successfulAnswerRate: function successfulAnswerRate() {
      return Math.round(this.successfulCount / this.allApproachesCount * 100) || 0;
    },
    failAnswerRate: function failAnswerRate() {
      return Math.round(this.failAnswerCount / this.allApproachesCount * 100) || 0;
    },
    noAnswerRate: function noAnswerRate() {
      return Math.round(100 - this.approachesCheckedCount / this.allApproachesCount * 100) || 0;
    }
  }),
  created: function created() {
    this.countAll();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('rotation/session', ['setFinishedAt', 'setIsSaved']), {
    countAll: function countAll() {
      this.allApproachesCount = 0;
      this.approachesCheckedCount = 0;
      this.failAnswerCount = 0;
      this.successfulCount = 0;
      this.hintCount = 0;

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.sessions).length; i++) {
        for (var j = 0; j < this.sessions[i].blocks.length; j++) {
          if (this.sessions[i].blocks[j].resultId === __WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* default */].SUCCESSFUL_ANSWER) {
            this.successfulCount++;
            this.approachesCheckedCount++;
          } else if (this.sessions[i].blocks[j].resultId === __WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* default */].FAIL_ANSWER) {
            this.failAnswerCount++;
            this.approachesCheckedCount++;
          } else if (this.sessions[i].blocks[j].resultId === __WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* default */].HINT_ANSWER) {
            this.hintCount++;
            this.approachesCheckedCount++;
          }
          this.allApproachesCount++;
        }
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    close: function close() {
      this.$emit('close');
    },
    save: function save(_ref) {
      var _this = this;

      var accept = _ref.accept;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, _ref2, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.setFinishedAt(Math.round(new Date().getTime() / 1000));
                _this.disabled = true;
                data = {
                  assigneeId: _this.route.params.clientId,
                  uuid: _this.uuid,
                  startedAt: _this.startedAt,
                  finishedAt: _this.finishedAt,
                  stimuli: _this.stimuli,
                  sessions: _this.sessions,
                  report: {
                    totalCount: _this.allApproachesCount,
                    rightCount: _this.successfulCount,
                    wrongCount: _this.failAnswerCount,
                    suggestedCount: _this.hintCount,
                    uncompletedCount: _this.allApproachesCount - _this.approachesCheckedCount
                  }
                };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api_Manager__["a" /* default */].save(data);

              case 6:
                _ref2 = _context.sent;
                response = _ref2.data;

                if (!(response && response.data && response.data.id)) {
                  _context.next = 13;
                  break;
                }

                if (accept) {
                  accept();
                }
                _this.close();
                _context.next = 14;
                break;

              case 13:
                throw new Error('Unknown API error');

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 19:
                _context.prev = 19;

                _this.disabled = false;
                return _context.finish(19);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16, 19, 22]]);
      }))();
    }
  }),
  watch: {
    sessions: function sessions() {
      this.countAll();
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(172);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tempChosenResult: [],
      indexCurrentBlock: 0,
      indexCurrentSession: 0,
      shortTextLength: 150
    };
  },
  created: function created() {
    this.initChosenResults();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])('rotation/session', ['sessions', 'isSaved']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isEmptySessions: function isEmptySessions() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(this.sessions);
    },
    isEmptyTempChosenResult: function isEmptyTempChosenResult() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(this.tempChosenResult);
    },
    tempSessions: function tempSessions() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(this.sessions);
    },
    visibleBlock: function visibleBlock() {
      return this.sessions[this.indexCurrentSession].blocks[this.indexCurrentBlock];
    },
    sessionsLength: function sessionsLength() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sessions).length;
    },
    blocksLength: function blocksLength() {
      return this.sessions[this.indexCurrentSession].blocks.length;
    },
    isPrevButtonDisabled: function isPrevButtonDisabled() {
      return this.indexCurrentBlock === 0 && this.indexCurrentSession === 0;
    },
    isNextButtonDisabled: function isNextButtonDisabled() {
      return this.indexCurrentBlock === this.blocksLength - 1 && this.indexCurrentSession === this.sessionsLength - 1;
    },
    successfulAnswer: function successfulAnswer() {
      return __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].SUCCESSFUL_ANSWER;
    },
    failAnswer: function failAnswer() {
      return __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].FAIL_ANSWER;
    },
    hintAnswer: function hintAnswer() {
      return __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].HINT_ANSWER;
    }
  }),
  filters: {
    shortText: function shortText(text, length) {
      if (text.length < length) {
        return text;
      } else {
        return text.substr(0, length) + '...';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('rotation/session', ['setSessions']), {
    initChosenResults: function initChosenResults() {
      this.tempChosenResult = [];
      for (var k = 0; k < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sessions).length; k++) {

        //set chosenResult as array for each session
        this.$set(this.tempChosenResult, k, []);

        for (var i = 0; i < this.sessions[k].blocks.length; i++) {
          this.$set(this.tempChosenResult[k], i, {
            value: null,
            isChecked: false
          });
        }
      }
    },
    setChecked: function setChecked(sessionIndex, blockIndex) {
      this.tempChosenResult[sessionIndex][blockIndex].isChecked = true;
    },
    refreshResults: function refreshResults() {
      this.tempChosenResult = [];
      this.indexCurrentBlock = 0;
      this.indexCurrentSession = 0;
      this.initChosenResults();
    },
    changeBlock: function changeBlock(direction) {
      if (direction === 'next') {
        if (this.indexCurrentBlock === this.blocksLength - 1) {
          this.indexCurrentSession++;
          this.indexCurrentBlock = 0;
        } else {
          this.indexCurrentBlock++;
        }
      } else {
        if (this.indexCurrentBlock === 0) {
          this.indexCurrentSession--;
          this.indexCurrentBlock = this.blocksLength - 1;
        } else {
          this.indexCurrentBlock--;
        }
      }
    },
    showReport: function showReport() {
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tempSessions).length; i++) {
        for (var j = 0; j < this.tempSessions[i].blocks.length; j++) {
          if (this.tempChosenResult[i][j].value === __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].SUCCESSFUL_ANSWER) {
            this.tempSessions[i].blocks[j].resultId = __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].SUCCESSFUL_ANSWER;
          } else if (this.tempChosenResult[i][j].value === __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].FAIL_ANSWER) {
            this.tempSessions[i].blocks[j].resultId = __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].FAIL_ANSWER;
          } else if (this.tempChosenResult[i][j].value === __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].HINT_ANSWER) {
            this.tempSessions[i].blocks[j].resultId = __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* default */].HINT_ANSWER;
          }
        }
      }

      this.setSessions(this.tempSessions);
      this.$emit('show-report');
    }
  }),
  watch: {
    isSaved: function isSaved() {
      this.refreshResults();
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RotationReport__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RotationReport: __WEBPACK_IMPORTED_MODULE_3__RotationReport__["a" /* default */], DashboardMenu: __WEBPACK_IMPORTED_MODULE_5__dashboardParent_components_DashboardMenu__["a" /* default */] },
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    }
  },
  data: function data() {
    return {
      loaded: false,
      apiUrl: '/users/clients/',
      client: {}
    };
  },
  created: function created() {
    this.getClient(this.clientId);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['isMensurationForbidden'])),
  methods: {
    backToPreviousPage: function backToPreviousPage() {
      this.$router.push({ name: 'client-edit', params: { clientId: this.clientId } });
    },

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.apiUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }()
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_Manager__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__ = __webpack_require__(28);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reports: [],
      isLoaded: true
    };
  },

  components: { Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_pagination__["a" /* pagination */]],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isEmptyReports: function isEmptyReports() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(this.reports);
    }
  }),
  created: function created() {
    var assigneeId = this.route.params.clientId;
    this.fetchReports(assigneeId, this.paginate.perPage, this.paginate.page);
  },

  methods: {
    fetchReports: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(assigneeId, perPage, page) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.isLoaded = false;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].getReports(assigneeId, perPage, page);

              case 4:
                response = _context.sent;


                this.reports = response.data.data.items;
                this.setPaginate(response.data.data);
                this.isLoaded = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);
                this.isLoaded = true;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function fetchReports(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }(),
    exportReport: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_Manager__["a" /* default */].exportReports(id).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', 'report_' + id + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 3:
                response = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function exportReport(_x4) {
        return _ref2.apply(this, arguments);
      }

      return exportReport;
    }(),
    onPaginationClick: function onPaginationClick(pageNum) {
      var assigneeId = this.route.params.clientId;
      this.fetchReports(assigneeId, this.paginate.perPage, pageNum);
      this.onPaginationBtnClick(pageNum);
    }
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      client: {},
      isChange: false,
      disabled: false,
      onlyList: false,
      reloadBids: false,
      isLoaded: true,
      rangeDateStart: this.getDateStart(new Date()),
      rangeDateEnd: new Date(),
      price: "999 рублей",
      client_count: null,
      minDateStart: this.getMinDateStart(new Date()),
      regions: [],
      regionId: null,
      loading: false,
      lastId: null,
      isLastPage: false,
      comment: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      options: {
        filterable: false,
        debounce: 1000,
        sortable: [],
        skin: 'table table-sm',
        columns: [{
          key: 'startedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('subscription.start_date')
        }, {
          key: 'finishedAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('subscription.end_date')
        }, {
          key: 'clientCount',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.client_count')
        }, {
          key: 'cost',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.price')
        }, {
          key: 'status',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.status')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        listRow: {
          startedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('subscription.start_date'),
            hasTemplate: false
          },
          finishedAt: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('subscription.end_date'),
            hasTemplate: false
          },
          clientCount: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.client_count'),
            hasTemplate: false
          },
          cost: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.price'),
            hasTemplate: false
          },
          status: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.status'),
            hasTemplate: false
          }
        },
        templates: {
          startedAt: this.startDateFormat,
          finishedAt: this.finishedDateFormat
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          clientCount: 'text-center',
          cost: 'text-center',
          action: 'text-right actions-cell'
        },
        perPage: 10
      }
    };
  },

  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    startDateFormat: function startDateFormat(h, row) {
      return this.toLocaleDate(row.startedAt.date);
    },
    finishedDateFormat: function finishedDateFormat(h, row) {
      return this.toLocaleDate(row.finishedAt.date);
    },


    nextPage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isLastPage) {
                  _context.next = 9;
                  break;
                }

                this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.apiUrl, {
                  params: {
                    perPage: this.perPage,
                    page: this.page
                  }
                });

              case 4:
                response = _context.sent;


                response.data.data.items.forEach(function (item) {
                  _this.therapists.push(item);
                });

                this.loading = false;
                this.lastId = this.therapists[this.therapists.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function nextPage() {
        return _ref.apply(this, arguments);
      }

      return nextPage;
    }(),

    onSetSelected: function onSetSelected(selected) {
      this.therapistId = selected;
    },

    getOptionTitle: function getOptionTitle(_ref2) {
      var option = _ref2.option;

      return option.name;
    },
    isLast: function isLast(_ref3) {
      var option = _ref3.option;

      return option.id == this.lastId;
    },

    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__api_Manager__["a" /* default */].getSubscriptions(data.limit, data.page);

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    getDateStart: function getDateStart(date) {
      var minDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 1);
      return minDateStart;
    },

    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.rangeDateStart).startOf('day').unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.rangeDateEnd).endOf("day").unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },


    sendRequest: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.errors.clear();
                _context3.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 23;
                  break;
                }

                _context3.prev = 5;

                this.isLoaded = false;
                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__api_Manager__["a" /* default */].setSubscription({
                  "startedAt": this.rangeDateStartTimestamp(),
                  "finishedAt": this.rangeDateEndTimestamp(),
                  "clientCount": this.client_count,
                  "comment": this.comment
                });

              case 9:
                response = _context3.sent;
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](5);

                console.error('Unknown API error occurred.');

              case 15:
                _context3.prev = 15;

                this.isChange = true;
                this.isLoaded = true;
                this.comment = null;
                this.rangeDateStart = this.getDateStart(new Date());
                this.rangeDateEnd = new Date();
                this.client_count = null;
                return _context3.finish(15);

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 12, 15, 23]]);
      }));

      function sendRequest() {
        return _ref4.apply(this, arguments);
      }

      return sendRequest;
    }()
  }

});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ClinicalModal__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClinicalCenter',
  data: function data() {
    return {
      apiUrl: '/users/centers',
      isModalVisible: false,
      client: {},
      isChange: false,
      disabled: false,
      onlyList: false,
      reloadBids: false,
      isLoaded: true,
      rangeDateStart: this.getDateStart(new Date()),
      rangeDateEnd: new Date(),
      price: "999 рублей",
      client_count: null,
      minDateStart: this.getMinDateStart(new Date()),
      regions: [],
      regionId: null,
      loading: false,
      lastId: null,
      isLastPage: false,
      comment: null,
      baseUrl: "https://app.autismtech.online/api",
      modal: {
        data: {}
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      options: {
        pageHeader: 'clinicalCenter',
        filterable: false,
        initialPage: null,
        debounce: 1000,
        sortable: [],
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.name')
        }, {
          key: 'phone',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.phone')
        }, {
          key: 'address',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.address')
        }, {
          key: 'socialNetwork',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.other_contact')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        listRow: {
          name: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.name'),
            hasTemplate: false
          },
          phone: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.phone'),
            hasTemplate: false
          },
          address: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.address'),
            hasTemplate: false
          },
          socialNetwork: {
            headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.other_contact'),
            hasTemplate: false
          }
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          clientCount: 'text-center',
          cost: 'text-center',
          phone: 'nowrap',
          action: 'text-right actions-cell'
        },
        perPage: 10
      }
    };
  },

  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__["a" /* default */], clinicalModal: __WEBPACK_IMPORTED_MODULE_11__ClinicalModal__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  created: function created() {
    console.info(process);
  },


  methods: {
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isChange = true;
    },
    onModalBtnClick: function onModalBtnClick(item) {
      this.modal.data = item;
      this.isModalVisible = true;
      this.isChange = false;
    },


    onSetSelected: function onSetSelected(selected) {
      this.therapistId = selected;
    },

    getOptionTitle: function getOptionTitle(_ref) {
      var option = _ref.option;

      return option.name;
    },
    isLast: function isLast(_ref2) {
      var option = _ref2.option;

      return option.id == this.lastId;
    },

    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'clinicalCenter');
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__api_Manager__["a" /* default */].getClinicalCenter(data.limit, data.page);

              case 4:
                response = _context.sent;

                console.info(process);
                return _context.abrupt('return', response);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    getDateStart: function getDateStart(date) {
      var minDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 1);
      return minDateStart;
    },

    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.rangeDateStart).startOf('day').unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.rangeDateEnd).endOf("day").unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(87)))

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fileUpload_components_Uploader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_Manager__ = __webpack_require__(67);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClinicalModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      clinicName: {
        name: null,
        phone: null,
        address: null,
        other_contact: null,
        logo: null,
        legalName: null
      },
      logoUrl: null,
      oldClinicName: {},
      isLoaded: true,
      disabled: false,
      clinicalName: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('profile.name_clinic_center'),
      options: {
        formData: {
          type: 'image'
        },
        singleFileUploads: false,
        maxNumberOfFiles: 1
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.clinicName = _this.data;
              _this.logoUrl = _this.clinicName.logo;

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], Uploader: __WEBPACK_IMPORTED_MODULE_11__fileUpload_components_Uploader__["a" /* default */]
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context2.abrupt('return');

              case 7:
                _context2.prev = 7;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12__api_Manager__["a" /* default */].setClinicalCenter(_this2.clinicName, _this2.data.id);

              case 10:
                isSaved = _context2.sent;


                if (isSaved) {
                  _this2.close();
                }

                _context2.next = 16;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](7);

              case 16:
                _context2.prev = 16;

                _this2.disabled = false;
                _this2.isloading = true;
                return _context2.finish(16);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 14, 16, 20]]);
      }))();
    },
    reset: function reset() {
      console.log(this.$data);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.errors.clear();
    },
    close: function close() {
      this.$emit('close');
      this.reset();
    },
    onFileUploadAdd: function onFileUploadAdd() {
      this.disabled = true;
    },
    onFileUploadDone: function onFileUploadDone(_ref) {
      var name = _ref.name,
          url = _ref.url;

      this.clearFileError();
      this.disabled = false;
      this.clinicName.logo = name;
      this.logoUrl = url;
    },
    onFileUploadFail: function onFileUploadFail() {
      console.info("onFileUploadFail");
      this.disabled = false;
      this.addFileError();
      this.clinicName.logo = null;
    },
    onFileUploadProcessFail: function onFileUploadProcessFail() {
      this.disabled = false;
      this.clinicName.logo = null;
    },
    onFileUploadRemove: function onFileUploadRemove() {
      this.clinicName.logo = null;
    },
    addFileError: function addFileError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('validation.required', { attribute: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('validation.attributes.file') });

      this.clearFileError();
      this.errors.add('file', error);
    },
    clearFileError: function clearFileError() {
      this.errors.remove('file');
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }

});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  props: {
    id: {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      isChange: false,
      subscription: {},
      isLoaded: true,
      comment: null,
      commentListOptions: {
        filterable: false,
        sortable: [],
        debounce: 1000,
        skin: 'table table-sm table-heading-hide',
        listRow: {
          user: {
            headings: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.user'),
            hasTemplate: true
          },
          create_date: {
            headings: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('subscription.create_date'),
            hasTemplate: true
          },
          text: {
            headings: '',
            hasTemplate: false
          }
        },
        templates: {
          user: this.userTemplates,
          create_date: this.createDate
        },
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_5__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        perPage: 10
      }
    };
  },
  created: function created() {
    this.getSubscriptionInfo();
    this.markCommentAsViewed();
  },

  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__["a" /* default */]
  },
  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    userTemplates: function userTemplates(h, row) {
      return row.user.name;
    },
    createDate: function createDate(h, row) {
      return this.toLocaleDate(row.create_date);
    },
    requestFunction: function requestFunction(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].getSubscriptionComments(_this.id, data.limit, data.page);

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSubscriptionInfo: function getSubscriptionInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].getSubscription(_this2.id);

              case 3:
                response = _context2.sent;

                _this2.subscription = response.data.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                if (_context2.t0.status == 403) {
                  _this2.$router.push({ name: 'error' });
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    markCommentAsViewed: function markCommentAsViewed() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].markCommentAsViewed(_this3.id);

              case 3:
                response = _context3.sent;
                _context3.next = 8;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    leaveComment: function leaveComment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$validator.validateAll();

              case 2:
                result = _context4.sent;

                if (result) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _context4.prev = 5;

                _this4.isChange = false;
                _this4.isLoaded = false;
                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].comment(_this4.id, { id: _this4.id, text: _this4.comment });

              case 10:
                response = _context4.sent;
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](5);

                console.error('Unknown API error occurred.');

              case 16:
                _context4.prev = 16;

                _this4.comment = null;
                _this4.isChange = true;
                _this4.isLoaded = true;
                return _context4.finish(16);

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[5, 13, 16, 21]]);
      }))();
    }
  }

});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskTypes',
  props: {},
  data: function data() {
    return {
      isLoaded: true,
      taskTypes: null,
      hintListRotation: null
    };
  },
  created: function created() {
    this.getTaskTypesInfo();
  },

  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_4__loader_components_Loader__["a" /* default */]
  },
  methods: {
    getTaskTypesInfo: function getTaskTypesInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].getTaskTypes();

              case 2:
                response = _context.sent;

                _this.taskTypes = response.data.data.taskAnswers;
                _this.hintListRotation = response.data.data.taskPrompts;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setTaskTypesInfo: function setTaskTypesInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoaded = false;

                _context2.next = 4;
                return _this2.$validator.validateAll();

              case 4:
                result = _context2.sent;

                if (result) {
                  _context2.next = 8;
                  break;
                }

                _this2.isLoaded = true;
                return _context2.abrupt('return');

              case 8:
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].setTaskTypes({
                  "items": {
                    "taskAnswers": _this2.taskTypes,
                    "taskPrompts": {
                      "prompts": _this2.hintListRotation.prompts
                    }
                  }
                });

              case 10:
                response = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                console.error('Unknown API error occurred.');

              case 16:
                _context2.prev = 16;

                _this2.isLoaded = true;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 13, 16, 19]]);
      }))();
    }
  }

});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fileUpload_components_Uploader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      user: {
        username: null,
        displayName: null,
        email: null
      },
      password: null,
      password_confirmation: null,
      current_password: null,
      disabled: false,
      afterSubmitForm: false,
      password_changed: false,
      responseHashError: null,
      baseUrl: "https://app.autismtech.online/api",
      loaded: true
    };
  },

  components: { Uploader: __WEBPACK_IMPORTED_MODULE_5__fileUpload_components_Uploader__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */] },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__api_Manager__["a" /* default */].getAccountInfo();

            case 2:
              response = _context.sent;

              _this.user = response.data.data;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    saveProfile: function saveProfile() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var validateResult, isSaved, result, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, _ref, message;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$validator.validateAll('form-profile');

              case 2:
                validateResult = _context2.sent;

                if (validateResult) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:

                _this2.loaded = false;
                _this2.errors.clear();

                _context2.prev = 7;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6__api_Manager__["a" /* default */].setAccountInfo(_this2.user);

              case 10:
                isSaved = _context2.sent;

                if (!isSaved) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_6__api_Manager__["a" /* default */].getAccountInfo();

              case 14:
                result = _context2.sent;

                _this2.user = result.data.data;
                if (result) {
                  _this2.disabled = false;
                  _this2.loaded = true;
                  _this2.afterSubmitForm = true;
                }

              case 17:
                _context2.next = 43;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](7);
                errors = _context2.t0.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default()(errors)) {
                  _context2.next = 42;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 26;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  _ref = errors[key].message ? errors[key] : errors[key][0], message = _ref.message;

                  _this2.errors.add(key, message);
                }
                _context2.next = 34;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t1 = _context2['catch'](26);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 34:
                _context2.prev = 34;
                _context2.prev = 35;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 37:
                _context2.prev = 37;

                if (!_didIteratorError) {
                  _context2.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context2.finish(37);

              case 41:
                return _context2.finish(34);

              case 42:
                _this2.loaded = true;

              case 43:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 19], [26, 30, 34, 42], [35,, 37, 41]]);
      }))();
    },
    savePassword: function savePassword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result, isSaved, errors, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key, _ref2, message;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.password_changed = false;
                _this3.errors.clear();

                _context3.next = 4;
                return _this3.$validator.validateAll('form-pass');

              case 4:
                result = _context3.sent;

                if (result) {
                  _context3.next = 8;
                  break;
                }

                _this3.disabled = false;
                return _context3.abrupt('return');

              case 8:
                _context3.prev = 8;
                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_6__api_Manager__["a" /* default */].changePassword(_this3.current_password, _this3.password, _this3.password_confirmation);

              case 11:
                isSaved = _context3.sent;


                if (isSaved) {
                  _this3.password_changed = true;
                  _this3.password = null;
                  _this3.password_confirmation = null;
                  _this3.current_password = null;
                }

                _context3.next = 38;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](8);
                errors = _context3.t0.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default()(errors)) {
                  _context3.next = 38;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 22;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  key = _step2.value;
                  _ref2 = errors[key].message ? errors[key] : errors[key][0], message = _ref2.message;

                  _this3.errors.add(key, message);
                }
                _context3.next = 30;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t1 = _context3['catch'](22);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t1;

              case 30:
                _context3.prev = 30;
                _context3.prev = 31;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 33:
                _context3.prev = 33;

                if (!_didIteratorError2) {
                  _context3.next = 36;
                  break;
                }

                throw _iteratorError2;

              case 36:
                return _context3.finish(33);

              case 37:
                return _context3.finish(30);

              case 38:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[8, 15], [22, 26, 30, 38], [31,, 33, 37]]);
      }))();
    }
  }

});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Manager__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SkillModal__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_client_components_ClientBtn__ = __webpack_require__(174);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClinicalCenter',
  data: function data() {
    return {
      apiUrl: '/users/centers',
      isModalVisible: false,
      client: {},
      isChange: false,
      disabled: false,
      isLoaded: true,
      loading: false,
      lastId: null,
      isLastPage: false,
      baseUrl: "https://app.autismtech.online/api",
      modal: {
        data: {}
      },
      options: {
        pageHeader: 'skillDomain',
        filterable: false,
        initialPage: null,
        debounce: 1000,
        sortable: [],
        skin: 'table table-sm',
        columns: [{
          key: 'name',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('profile.name')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],

        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filter: '',
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          action: 'text-right actions-cell',
          id: 'actions-cell'
        },
        perPage: 20
      }
    };
  },

  components: {
    TableView: __WEBPACK_IMPORTED_MODULE_3__common_table_components_TableView__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], skillModal: __WEBPACK_IMPORTED_MODULE_9__SkillModal__["a" /* default */], clientBtn: __WEBPACK_IMPORTED_MODULE_11__user_client_components_ClientBtn__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),

  methods: {
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isChange = true;
    },
    onModalBtnClick: function onModalBtnClick(item) {
      this.modal.data = item;
      this.isModalVisible = true;
      this.isChange = false;
    },
    onAddModalBtnClick: function onAddModalBtnClick() {
      this.modal.data = {
        name: ''
      };
      this.isModalVisible = true;
      this.isChange = false;
    },
    onDeleteBtnClick: function onDeleteBtnClick(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isChange = false;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__api_Manager__["a" /* default */].deleteSkillDomain(id);

              case 3:
                response = _context.sent;


                if (response) {
                  _this.isChange = true;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    isLast: function isLast(_ref) {
      var option = _ref.option;

      return option.id == this.lastId;
    },

    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage.setItem('currentPage', data.page);
                localStorage.setItem('currentPageHeader', 'skillDomain');
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__api_Manager__["a" /* default */].getSkillDomain(data.limit, data.page);

              case 4:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }

});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fileUpload_components_Uploader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_Manager__ = __webpack_require__(67);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClinicalModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      name: null,
      isLoaded: true,
      disabled: false

    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.name = _this.data.name;

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_11__loader_components_Loader__["a" /* default */], Uploader: __WEBPACK_IMPORTED_MODULE_13__fileUpload_components_Uploader__["a" /* default */]
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, isSaved, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, _ref, message;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.disabled = false;
                return _context2.abrupt('return');

              case 7:
                _context2.prev = 7;
                isSaved = void 0;

                if (!_this2.data.id) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_14__api_Manager__["a" /* default */].setSkillDomain(_this2.name, _this2.data.id);

              case 12:
                isSaved = _context2.sent;
                _context2.next = 18;
                break;

              case 15:
                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_14__api_Manager__["a" /* default */].addSkillDomain(_this2.name);

              case 17:
                isSaved = _context2.sent;

              case 18:
                if (isSaved) {
                  _this2.close();
                }

                _context2.next = 48;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](7);
                errors = _context2.t0.data.errors;

                if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isObject___default()(errors)) {
                  _context2.next = 48;
                  break;
                }

                if (!errors.message) {
                  _context2.next = 29;
                  break;
                }

                _this2.errors.add('server', errors.message);
                _context2.next = 48;
                break;

              case 29:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 32;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  key = _step.value;
                  _ref = errors[key].message ? errors[key] : errors[key][0], message = _ref.message;

                  _this2.errors.add(key, message);
                }
                _context2.next = 40;
                break;

              case 36:
                _context2.prev = 36;
                _context2.t1 = _context2['catch'](32);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 40:
                _context2.prev = 40;
                _context2.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context2.prev = 43;

                if (!_didIteratorError) {
                  _context2.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context2.finish(43);

              case 47:
                return _context2.finish(40);

              case 48:
                _context2.prev = 48;

                _this2.disabled = false;
                _this2.isloading = true;
                return _context2.finish(48);

              case 52:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 21, 48, 52], [32, 36, 40, 48], [41,, 43, 47]]);
      }))();
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.errors.clear();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  }

});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileLayout',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']))
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__client_components_ClientBtn__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_table_Search__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__ = __webpack_require__(21);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Therapists',
  data: function data() {
    return {
      isModalVisible: false,
      paginate: {
        perPage: 5,
        page: 0,
        forcePage: 0,
        pageRange: 3,
        marginPages: 2
      },
      isChange: false,
      modal: {
        data: {}
      },
      options: {
        pageHeader: 'therapists',
        initialPage: null,
        filterable: false,
        withSearch: true,
        debounce: 1500,
        sortable: [],
        skin: 'table table-sm',
        columns: [{
          key: 'therapists',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.therapists')
        }, {
          key: 'clientsCount',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.clients')
        }, {
          key: 'bidsOnWorkCount',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.request_for_work')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.items,
            count: resp.total
          };
        },
        texts: {
          filter: "",
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('user.type_the_therapist_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        columnsClasses: {
          clientsCount: 'text-center',
          bidsOnWorkCount: 'text-center',
          action: 'table-actions'
        },
        perPage: 10
      },
      search: '',
      sort: '-id'
    };
  },

  components: {
    Search: __WEBPACK_IMPORTED_MODULE_10__common_table_Search__["a" /* default */], Paginate: __WEBPACK_IMPORTED_MODULE_5_vuejs_paginate___default.a, therapistModal: __WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* default */], clientBtn: __WEBPACK_IMPORTED_MODULE_7__client_components_ClientBtn__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_8__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_11__common_table_components_TableView__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('therapist/repository', ['items', 'page', 'pageCount', 'total', 'hasMorePages', 'isLoaded', 'isChanged']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['canCreateTherapist', 'canUpdateTherapist', 'canDeleteTherapist', 'isMensurationForbidden']), {
    isEmptyList: function isEmptyList() {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default()(this.items);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('therapist/repository', ['getItems', 'deleteItemById']), {
    getTranslation: function getTranslation() {
      return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */], arguments);
    },
    getTherapists: function getTherapists(page, sort, search) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'therapists');
                _context.next = 4;
                return _this.getItems({
                  perPage: _this.options.perPage,
                  page: page,
                  sort: sort ? sort : _this.sort,
                  search: search ? search : _this.search
                });

              case 4:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    requestFunction: function requestFunction(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.getTherapists(data.page, _this2.sort, data.query));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onAddCuratorModalBtnClick: function onAddCuratorModalBtnClick() {
      this.modal.data = {};
      this.isModalVisible = true;
      this.isChange = false;
    },
    onModalClose: function onModalClose() {
      this.modal.data = {};
      this.isModalVisible = false;
      this.isChange = true;
    },
    onEditBtnClick: function onEditBtnClick(item) {
      this.modal.data = { item: item };
      this.isModalVisible = true;
      this.isChange = false;
    },

    onDeleteBtnClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isChange = false;
                _context3.next = 3;
                return this.deleteItemById({ id: id });

              case 3:
                _context3.next = 5;
                return this.getTherapists(this.page);

              case 5:
                response = _context3.sent;


                if (response) {
                  this.isChange = true;
                }

                this.setPaginateState(this.page);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onDeleteBtnClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onDeleteBtnClick;
    }(),
    onPaginationClick: function onPaginationClick(page) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.getTherapists(page);

              case 2:
                _this3.setPaginateState(page);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    setPaginateState: function setPaginateState(page) {
      this.paginate.page = page;
      this.paginate.forcePage = page - 1;
    },

    onSearchEnter: function onSearchEnter(search) {
      this.search = search;
    }
  }),
  watch: {
    pageCount: function pageCount(newValue, oldValue) {
      // spike :
      if (newValue > 1 && oldValue === 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    page: function page(newValue, oldValue) {
      // spike :
      if (newValue === 1 && oldValue > 1) {
        this.paginate.page = 0;
        this.paginate.forcePage = 0;
      }
    },
    isChanged: function isChanged(newValue, oldValue) {
      if (newValue) {
        this.isChange = newValue;
      }
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_curator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);





var _this3 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TherapistModal',
  props: {
    'visible': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'data': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      user: {
        username: null,
        displayName: null,
        curators: [],
        curatorIds: [],
        password: null,
        passwordConfirmation: null
      },
      oldUser: {},
      curators: [],
      isLoaded: true,
      selected: null,
      searchText: null,
      resetChange: true,
      disabled: false,
      userName: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('validation.attributes.username'),
      passwordLabel: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('validation.attributes.password')
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_14__loader_components_Loader__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* Validator */].extend('unique_username', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('validation.unique', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(username) {
          var valid, userId, _ref2, response;

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = void 0;
                  userId = void 0;

                  if (!_this.isEdit) {
                    _context.next = 8;
                    break;
                  }

                  if (!(username === _this.oldUser.username)) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt('return', true);

                case 7:
                  userId = _this.user.id;

                case 8:
                  _context.prev = 8;
                  _context.next = 11;
                  return __WEBPACK_IMPORTED_MODULE_15_axios___default.a.post('/registration/validate-username', { username: username, userId: userId });

                case 11:
                  _ref2 = _context.sent;
                  response = _ref2.data;

                  valid = response.data.valid;
                  _context.next = 19;
                  break;

                case 16:
                  _context.prev = 16;
                  _context.t0 = _context['catch'](8);

                  valid = false;

                case 19:
                  return _context.abrupt('return', { valid: valid });

                case 20:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[8, 16]]);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('therapist/repository', ['editItem', 'addItem']), {
    onSearch: function onSearch(search) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.searchCurators(__WEBPACK_IMPORTED_MODULE_12__api_curator__["a" /* default */], search, _this2);

              case 2:
                _this2.searchText = search;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    searchCurators: __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(apiManager, search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return apiManager.search(search, 500, 1);

              case 3:
                response = _context3.sent;

                vm.curators = response.data.data.items;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }));

      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }(), 350),
    onChange: function onChange() {
      if (this.user.curators) {
        this.user.curatorIds = this.user.curators ? __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(this.user.curators, function (curator) {
          return curator.id;
        }) : [];
      }
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result, method;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.disabled = true;
                _context4.next = 3;
                return _this4.$validator.validateAll();

              case 3:
                result = _context4.sent;

                if (result) {
                  _context4.next = 7;
                  break;
                }

                _this4.disabled = false;
                return _context4.abrupt('return');

              case 7:

                try {
                  method = _this4.isEdit ? _this4.editItem : _this4.addItem;


                  method(_this4.user);

                  //this.close();
                } catch (e) {} finally {
                  _this4.disabled = false;
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.searchText = null;
      this.errors.clear();
    },
    close: function close() {
      this.reset();
      this.$emit('close');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('therapist/repository', ['validationError', 'isChanged']), {
    isEdit: function isEdit() {
      return !__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default()(this.data);
    },

    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },

    curatorsNew: function curatorsNew() {
      var _this5 = this;

      if (this.curators) {
        return this.curators.filter(function (item) {
          var counter = 0;

          if (_this5.user.curators) {
            for (var i = 0; i < _this5.user.curators.length; i++) {
              if (item.id === _this5.user.curators[i].id) {
                counter++;
              }
            }
          }

          if (counter === 0) {
            return true;
          }
        });
      } else {
        return [];
      }
    }
  }),
  watch: {
    visible: function visible(newValue, oldValue) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$refs.curatorsSelect.onEscape();
                _this6.searchText = null;

                if (!_this6.isEdit) {
                  _context5.next = 21;
                  break;
                }

                if (!(_this6.data.item && __WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default()(_this6.data.item))) {
                  _context5.next = 21;
                  break;
                }

                _context5.prev = 4;

                _this6.isLoaded = false;
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_13__api_therapist__["a" /* default */].findById({ id: _this6.data.item.id });

              case 8:
                response = _context5.sent;

                _this6.user = response.data.data;
                if (!_this6.user.curators) {
                  _this6.user.curators = [];
                }
                _this6.oldUser = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(_this6.user);
                _this6.curators = _this6.user.curators;
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](4);

                console.error('Unknown API error occurred.');

              case 18:
                _context5.prev = 18;

                _this6.isLoaded = true;
                return _context5.finish(18);

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[4, 15, 18, 21]]);
      }))();
    },
    validationError: function validationError(newValue) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (newValue) {
                  _this7.errors.add({
                    field: 'isValidationError',
                    msg: newValue.message
                  });
                } else {
                  _this7.errors.clear();
                }

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    isChanged: function isChanged(newValue) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (newValue) {
                  _this8.close();
                }

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Clients__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bids_components_BidsList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Measurements__ = __webpack_require__(1346);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  props: {
    therapistId: {
      required: true,
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      model: {},
      state: {
        loadingCount: 0
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchData();

            case 2:
              _this.model = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: { Measurements: __WEBPACK_IMPORTED_MODULE_6__Measurements__["a" /* default */], BidsList: __WEBPACK_IMPORTED_MODULE_5__bids_components_BidsList__["a" /* default */], Clients: __WEBPACK_IMPORTED_MODULE_4__Clients__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_3__loader_components_Loader__["a" /* default */] },
  computed: {
    loading: {
      get: function get() {
        return this.state.loadingCount > 0;
      },
      set: function set(newVal) {
        if (newVal === false) {
          this.state.loadingCount--;
          return;
        }

        this.state.loadingCount++;
      }
    }
  },
  methods: {
    setLoading: function setLoading(state) {
      this.loading = state;
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.setLoading(true);
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__api_therapist__["a" /* default */].findById({ id: this.therapistId });

              case 4:
                response = _context2.sent;
                return _context2.abrupt('return', response.data.data);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 11:
                _context2.prev = 11;

                this.setLoading(false);
                return _context2.finish(11);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8, 11, 14]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),
    onLoading: function onLoading(val, created) {
      if (created === false) {
        this.loading = val;
      }
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConfirmDeleteModal__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AttachClientModal__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_table_Search__ = __webpack_require__(104);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Search: __WEBPACK_IMPORTED_MODULE_9__common_table_Search__["a" /* default */], AttachClientModal: __WEBPACK_IMPORTED_MODULE_8__AttachClientModal__["a" /* default */], ConfirmDeleteModal: __WEBPACK_IMPORTED_MODULE_7__ConfirmDeleteModal__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__common_mixins_pagination__["a" /* pagination */]],

  name: 'Clients',
  props: {
    therapistId: {
      required: true,
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      items: [],
      search: null,
      sort: '-id',
      state: {
        created: false,
        loadingCount: 0
      },
      modals: {
        confirmDelete: {
          client: null,
          isVisible: false
        },
        attachClient: {
          isVisible: false
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.state.created = false;
              _context.next = 3;
              return _this.fetchData();

            case 3:
              _this.state.created = true;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['canUpdateTherapist', 'canUpdateClient', 'isMensurationForbidden']), {
    loading: {
      get: function get() {
        return this.state.loadingCount > 0;
      },
      set: function set(newVal) {
        if (newVal === false) {
          this.state.loadingCount--;
          return;
        }
        this.state.loadingCount++;
      }
    }
  }),
  methods: {
    setLoading: function setLoading(state) {
      this.loading = state;
      this.$emit('loading', state, this.state.created);
    },
    toggleConfirmDeleteModal: function toggleConfirmDeleteModal() {
      this.modals.confirmDelete.isVisible = !this.modals.confirmDelete.isVisible;
    },
    toggleAttachClientModal: function toggleAttachClientModal() {
      this.modals.attachClient.isVisible = !this.modals.attachClient.isVisible;
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, _response$data$data, items, perPage, lastPage, currentPage;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.setLoading(true);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_therapist__["a" /* default */].paginateAllClientsByTherapistId({
                  therapistId: this.therapistId,
                  perPage: this.paginate.perPage,
                  page: this.paginate.page,
                  sort: this.sort,
                  search: this.search
                });

              case 4:
                response = _context2.sent;
                _response$data$data = response.data.data, items = _response$data$data.items, perPage = _response$data$data.perPage, lastPage = _response$data$data.lastPage, currentPage = _response$data$data.currentPage;

                this.items = items;
                this.setPaginate({ perPage: perPage, lastPage: lastPage, currentPage: currentPage });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 13:
                _context2.prev = 13;

                this.setLoading(false);
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10, 13, 16]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),
    deleteClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(client) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.setLoading(true);

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_therapist__["a" /* default */].deleteClient(this.therapistId, client.id);

              case 4:
                _context3.next = 6;
                return this.fetchData();

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 11:
                _context3.prev = 11;

                this.setLoading(false);
                return _context3.finish(11);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8, 11, 14]]);
      }));

      function deleteClient(_x) {
        return _ref2.apply(this, arguments);
      }

      return deleteClient;
    }(),
    addClients: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(clientIds) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.setLoading(true);

                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_therapist__["a" /* default */].addClients({ therapistId: this.therapistId, clientIds: clientIds });

              case 4:
                _context4.next = 6;
                return this.fetchData();

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 11:
                _context4.prev = 11;

                this.setLoading(false);
                return _context4.finish(11);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8, 11, 14]]);
      }));

      function addClients(_x2) {
        return _ref3.apply(this, arguments);
      }

      return addClients;
    }(),
    onDeleteItemIconClick: function onDeleteItemIconClick(item) {
      this.toggleConfirmDeleteModal();
      this.modals.confirmDelete.client = item;
    },
    onPaginationClick: function onPaginationClick(pageNum) {
      this.onPaginationBtnClick(pageNum);
      this.fetchData();
    },
    onAcceptDeleteClient: function onAcceptDeleteClient(item) {
      this.toggleConfirmDeleteModal();

      if (this.items.length - 1 === 0 && this.paginate.page - 1 !== 0) {
        this.paginate.page -= 1;
        this.paginate.forcePage -= 1;
      }

      this.deleteClient(item);
      this.modals.confirmDelete.client = null;
    },
    onCancelDeleteClient: function onCancelDeleteClient(item) {
      this.toggleConfirmDeleteModal();
      this.modals.confirmDelete.client = null;
    },
    onAttachClientButtonClick: function onAttachClientButtonClick() {
      this.toggleAttachClientModal();
    },
    onAcceptAttachClient: function onAcceptAttachClient(itemId) {
      this.toggleAttachClientModal();
      this.addClients([itemId]);
    },
    onCancelAttachClient: function onCancelAttachClient() {
      this.toggleAttachClientModal();
    },
    onSearchEnter: function onSearchEnter(text) {
      this.search = text;
      this.fetchData();
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmDeleteModal',
  props: {
    visible: {
      required: true,
      types: [Boolean]
    },
    item: {
      required: true,
      types: [Object]
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    }
  },
  methods: {
    accept: function accept() {
      this.$emit('accept', this.item);
    },
    cancel: function cancel() {
      this.$emit('cancel', this.item);
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AttachClientModal',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */], selectWithPager: __WEBPACK_IMPORTED_MODULE_4__common_selectWithPager_components_SelectWithPager__["a" /* default */] },
  data: function data() {
    return {
      items: [],
      item: null,
      lastClientId: null,
      isLastPageClient: false,
      perPage: 10,
      page: 1,
      state: {
        disabled: false,
        loadingCount: 0
      }
    };
  },

  props: {
    visible: {
      required: true,
      type: [Boolean]
    },
    therapistId: {
      required: true,
      type: [Number, String]
    }
  },
  computed: {
    isOpen: {
      get: function get() {
        return this.visible;
      },
      set: function set() {}
    },
    loading: {
      get: function get() {
        return this.state.loadingCount > 0;
      },
      set: function set(newVal) {
        if (newVal === false) {
          this.state.loadingCount--;
          return;
        }
        this.state.loadingCount++;
      }
    },
    itemsNew: function itemsNew() {
      var _this = this;

      return this.items.filter(function (item) {
        if (_this.item) {
          return item.id !== _this.item.id;
        } else {
          return true;
        }
      });
    },

    isItemsExists: function isItemsExists() {
      return this.items.length > 0;
    },
    isAcceptDisabled: function isAcceptDisabled() {
      return this.state.disabled || !this.isItemsExists;
    }
  },
  methods: {
    setLoading: function setLoading(state) {
      this.loading = state;
      this.$emit('loading', state, this.state.created);
    },
    accept: function accept() {
      this.$emit('accept', this.item.id);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setLoading(true);

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_therapist__["a" /* default */].paginateAllClientsByTherapistId({
                  therapistId: this.therapistId,
                  perPage: this.perPage,
                  page: this.page,
                  isOwn: 0
                });

              case 3:
                response = _context.sent;


                this.items = response.data.data.items;

                if (this.items.length) {
                  this.disabledClient = false;
                  this.lastClientId = this.items[this.items.length - 1].id;
                  if (response.data.data.lastPage != this.page) {
                    this.page++;
                  } else {
                    this.isLastPageClient = true;
                  }
                }
                this.setLoading(false);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),

    getOptionClientTitle: function getOptionClientTitle(_ref2) {
      var option = _ref2.option;

      return option.code;
    },

    onChangeClinicId: function onChangeClinicId(selected) {
      this.item = selected;
    },

    nextClientPage: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isLastPageClient) {
                  _context2.next = 9;
                  break;
                }

                this.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__api_therapist__["a" /* default */].paginateAllClientsByTherapistId({
                  therapistId: this.therapistId,
                  perPage: this.perPage,
                  page: this.page,
                  isOwn: 0
                });

              case 4:
                response = _context2.sent;

                response.data.data.items.forEach(function (item) {
                  _this2.items.push(item);
                });
                this.lastClientId = this.items[this.items.length - 1].id;
                if (this.page == response.data.data.lastPage) {
                  this.isLastPageClient = true;
                } else {
                  this.page++;
                }

                if (response) {
                  this.loading = false;
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function nextClientPage() {
        return _ref3.apply(this, arguments);
      }

      return nextClientPage;
    }(),

    isLastClient: function isLastClient(_ref4) {
      var option = _ref4.option;

      return option.id == this.lastClientId;
    }
  },
  watch: {
    visible: function visible(newVal, oldVal) {
      if (newVal === true) {
        this.fetchData();
      } else {
        this.item = null;
      }
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_protocol_api_protocol__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_mixins_pagination__["a" /* pagination */]],

  name: 'Measurements',
  props: {
    userId: {
      required: true,
      type: [Number, String]
    }
  },
  data: function data() {
    return {
      items: [],
      state: {
        created: false,
        loadingCount: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    loading: {
      get: function get() {
        return this.state.loadingCount > 0;
      },
      set: function set(newVal) {
        if (newVal === false) {
          this.state.loadingCount--;
          return;
        }
        this.state.loadingCount++;
      }
    },
    lastPage: function lastPage() {
      return this.paginate.lastPage;
    },
    page: function page() {
      return this.paginate.page;
    },
    isEmptyMeasurements: function isEmptyMeasurements() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_isEmpty___default()(this.items);
    }
  }),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.state.created = false;
              _context.next = 3;
              return _this.fetchData();

            case 3:
              _this.state.created = true;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setLoading: function setLoading(state) {
      this.loading = state;
      this.$emit('loading', state, this.state.created);
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, _response$data$data, items, perPage, lastPage, currentPage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.setLoading(true);

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__common_protocol_api_protocol__["a" /* default */].paginateLastSessions({
                  userId: this.userId,
                  perPage: this.paginate.perPage,
                  page: this.paginate.page
                });

              case 4:
                response = _context2.sent;
                _response$data$data = response.data.data, items = _response$data$data.items, perPage = _response$data$data.perPage, lastPage = _response$data$data.lastPage, currentPage = _response$data$data.currentPage;

                this.items = items;
                this.setPaginate({ perPage: perPage, lastPage: lastPage, currentPage: currentPage });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 13:
                _context2.prev = 13;

                this.setLoading(false);
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10, 13, 16]]);
      }));

      function fetchData() {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }(),
    onPaginationClick: function onPaginationClick(pageNum) {
      this.onPaginationBtnClick(pageNum);
      this.fetchData();
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboardParent_components_DashboardMenu__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardReport',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isBCBA', 'isCurator']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']))
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reports_components_PdfReportCurator__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CuratorList',
  props: {
    'isEdit': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'id': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'startDate': {
      type: [Object]
    },
    'endDate': {
      type: [Object]
    }
  },
  data: function data() {
    return {
      apiUrl: '/users/curators/',
      apiStaticUrl: '/users/statistics/curators',
      apiSaveUrl: '/statistics/reports/curators/',
      curators: [],
      curator: '',
      curatorId: null,
      perPage: 10,
      page: 1,
      pdfProcess: false,
      rangeDateStart: new Date(),
      rangeDateEnd: new Date(),
      minDateStart: this.getMinDateStart(new Date()),
      maxDateStart: this.getMaxDateStart(new Date()),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showTable: false,
      curatorsStatistics: null,
      paginateData: null,
      afterSend: false,
      isSaveDisable: false,
      isLoading: false,
      loading: false,
      lastId: null,
      isLastPage: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__["a" /* pagination */]],
  components: {
    PdfReportCurator: __WEBPACK_IMPORTED_MODULE_11__reports_components_PdfReportCurator__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__["a" /* default */],
    selectWithPager: __WEBPACK_IMPORTED_MODULE_12__common_selectWithPager_components_SelectWithPager__["a" /* default */]
  },
  created: function created() {

    if (this.isEdit) {
      this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.startDate.date)._d;
      this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.endDate.date)._d;
      this.isSaveDisable = true;
    } else {
      var dt = new Date();
      var date = new Date(dt.getFullYear(), dt.getMonth() - 1, dt.getDate());
      this.rangeDateStart = date;
    }

    this.getCurators();
  },

  methods: {
    saveReport: function saveReport() {
      console.log(12313);
      window.open(this.url);
      console.info(2123123);
    },

    nextPage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isLastPage) {
                  _context.next = 9;
                  break;
                }

                this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl, {
                  params: {
                    perPage: this.perPage,
                    page: this.page
                  }
                });

              case 4:
                response = _context.sent;


                response.data.data.items.forEach(function (item) {
                  _this.curators.push(item);
                });

                this.loading = false;
                this.lastId = this.curators[this.curators.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function nextPage() {
        return _ref.apply(this, arguments);
      }

      return nextPage;
    }(),

    onSetSelected: function onSetSelected(selected) {
      this.curatorId = selected;
    },

    getCurators: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl, {
                  params: {
                    perPage: this.perPage,
                    page: this.page
                  }
                });

              case 3:
                response = _context2.sent;

                this.curators = response.data.data.items;
                this.lastId = this.curators[this.curators.length - 1].id;

                if (response.data.data.hasMorePages) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

                if (this.isEdit) {
                  if (this.id) {
                    this.getCurator(this.id);
                  } else {
                    this.onSendRequest();
                    this.afterSend = true;
                  }
                }
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function getCurators() {
        return _ref2.apply(this, arguments);
      }

      return getCurators;
    }(),
    getCurator: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl + id);

              case 2:
                response = _context3.sent;

                this.curatorId = response.data.data;

                if (response) {
                  this.onSendRequest();
                  this.afterSend = true;
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCurator(_x) {
        return _ref3.apply(this, arguments);
      }

      return getCurator;
    }(),
    onPaginationClick: function onPaginationClick(pageNum) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this2.onPaginationBtnClick(pageNum);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this2.apiStaticUrl + '/' + _this2.paginate.perPage + '/' + pageNum, {
                  params: {
                    startDate: _this2.rangeDateStartTimestamp,
                    endDate: _this2.rangeDateEndTimestamp
                  }
                });

              case 3:
                response = _context4.sent;

                _this2.curatorsStatistics = response.data.data.items;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },

    getCuratorStatistics: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                response = void 0;

                this.curatorsStatistics = [];
                _context5.prev = 2;

                if (!id) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiStaticUrl + '/' + id, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp
                  }
                });

              case 6:
                response = _context5.sent;

                if (response.data.data instanceof Object && !(response.data.data instanceof Array)) {
                  this.curatorsStatistics.push(response.data.data);
                }
                _context5.next = 14;
                break;

              case 10:
                _context5.next = 12;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiStaticUrl + '/' + 500 + '/' + this.paginate.page, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp
                  }
                });

              case 12:
                response = _context5.sent;

                this.curatorsStatistics = response.data.data.items;

              case 14:

                this.paginateData = response.data.data;
                this.isLoading = false;

                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5['catch'](2);

                console.dir(_context5.t0);

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 18]]);
      }));

      function getCuratorStatistics(_x2) {
        return _ref4.apply(this, arguments);
      }

      return getCuratorStatistics;
    }(),
    findCuratorById: function findCuratorById(id) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default()(this.curators, function (item) {
        if (item.id == id) {
          that.curator = item.displayName;
        }
      });
    },
    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },
    getMaxDateStart: function getMaxDateStart(date) {
      var minDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2);
      return minDateStart;
    },
    onSendRequest: function onSendRequest() {
      this.isLoading = true;
      if (this.afterSend) {
        this.isSaveDisable = false;
      }
      var curatorId = this.curatorId ? this.curatorId.id : null;
      this.curator = curatorId ? this.curatorId.displayName : null;
      this.getCuratorStatistics(curatorId);
      this.showTable = true;
    },
    saveRequest: function saveRequest() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var title, isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                title = _this3.curatorId ? __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.info_curator') + ' ' + _this3.curator : __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.info_curators');

                _this3.pdfProcess = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this3.apiSaveUrl, {
                  "title": title,
                  "startDate": _this3.rangeDateStartTimestamp,
                  "endDate": _this3.rangeDateEndTimestamp,
                  "curatorId": _this3.curatorId ? _this3.curatorId.id : null
                });

              case 4:
                isSaved = _context6.sent;


                if (isSaved) {
                  _this3.$router.push({ name: 'archive-reports' });
                  _this3.pdfProcess = false;
                }

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3);
      }))();
    },
    generatePdf: function generatePdf() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var uri, response, hash, url, link, node;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this4.pdfProcess = true;
                uri = _this4.curatorId ? '/users/curators/export/' + _this4.curatorId.id : '/users/curators/export';
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(uri, {
                  "startDate": _this4.rangeDateStartTimestamp,
                  "endDate": _this4.rangeDateEndTimestamp
                });

              case 4:
                response = _context7.sent;
                hash = response.data.data.hash;
                url = "https://app.autismtech.online/api" + ('/users/reports/download?hash=' + hash);
                link = document.createElement("a");

                link.href = url;
                node = document.body.appendChild(link);

                link.click();
                setTimeout(function () {
                  node.remove();
                  _this4.pdfProcess = false;
                });

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this4);
      }))();
    },

    getOptionTitle: function getOptionTitle(_ref5) {
      var option = _ref5.option;

      return option.displayName;
    },
    isLast: function isLast(_ref6) {
      var option = _ref6.option;

      return option.id == this.lastId;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isBCBA']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    },
    rangeDateStart: function rangeDateStart(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateStart = oldValue;
      }
    },
    rangeDateEnd: function rangeDateEnd(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateEnd = oldValue;
        this.minDateStart = this.getMinDateStart(oldValue);
      } else {
        this.minDateStart = this.getMinDateStart(newValue);
      }
    }
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'curator': {
      type: [String],
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {
    generate: function generate() {
      var _this = this;

      var pdfName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.info_curators');
      if (this.curator) {
        pdfName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.info_curator') + '_' + this.curator;
      }

      //Filters
      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
        var filtersImg = canvas.toDataURL('image/png');

        //Client Table
        __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-client-table'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
          var clientsImg = canvas.toDataURL('image/png');

          __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true }).then(function (canvas) {
            __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
            var docDefinition = {
              pageSize: 'A4',
              pageOrientation: 'portrait',
              pageMargins: [20, 30, 20, 20],
              content: [{
                image: filtersImg,
                width: 550
              }, {
                image: clientsImg,
                width: 570,
                margin: [-10, 20, 0, 0]
              }],
              footer: {
                columns: [{
                  text: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.generated_by'),
                  fontSize: 8,
                  bold: true,
                  alignment: 'right',
                  margin: [0, 0, 20, 0]
                }]
              }
            };
            __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(pdfName + '.pdf');
            _this.$emit('generated', true);
          });
        });
      });
    },
    pix2mm: function pix2mm(val, dpi) {
      return val / 0.0393701 / dpi;
    }
  }
});

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reports_components_PdfReportTherapist__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_toInteger__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TherapistList',
  props: {
    'isEdit': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'id': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'startDate': {
      type: [Object]
    },
    'endDate': {
      type: [Object]
    }
  },
  data: function data() {
    return {
      apiUrl: '/users/therapists/',
      apiStaticUrl: '/users/statistics/therapists',
      apiSaveUrl: '/statistics/reports/therapists/',
      therapists: [],
      therapist: '',
      therapistId: null,
      perPage: 10,
      page: 1,
      rangeDateStart: new Date(),
      rangeDateEnd: new Date(),
      pdfProcess: false,
      minDateStart: this.getMinDateStart(new Date()),
      maxDateStart: this.getMaxDateStart(new Date()),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showTable: false,
      therapistStatistics: null,
      paginateData: null,
      clientStatistics: null,
      paginateClientData: null,
      paginateClient: {
        perPage: 10,
        page: 1,
        forcePage: 0,
        lastPage: 0,
        pageRange: 3,
        marginPages: 2
      },
      afterSend: false,
      isSaveDisable: false,
      isLoading: false,
      loading: false,
      lastId: null,
      isLastPage: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_mixins_pagination__["a" /* pagination */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_10__loader_components_Loader__["a" /* default */],
    PdfReportTherapist: __WEBPACK_IMPORTED_MODULE_11__reports_components_PdfReportTherapist__["a" /* default */],
    selectWithPager: __WEBPACK_IMPORTED_MODULE_12__common_selectWithPager_components_SelectWithPager__["a" /* default */]
  },
  created: function created() {
    if (this.isEdit) {
      this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.startDate.date)._d;
      this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.endDate.date)._d;
      this.isSaveDisable = true;
    } else {
      var dt = new Date();
      var date = new Date(dt.getFullYear(), dt.getMonth() - 1, dt.getDate());
      this.rangeDateStart = date;
    }
    this.getTherapists();
  },

  methods: {
    timeDuration: function timeDuration(time) {
      var min = time * 60;
      var minDuration = __WEBPACK_IMPORTED_MODULE_13_lodash_toInteger___default()(min);
      var secDuration = __WEBPACK_IMPORTED_MODULE_13_lodash_toInteger___default()(min * 60 - minDuration * 60);
      var timeDuration = time ? minDuration + __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.min') + ' ' + secDuration + __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.sec') : 0 + __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.min');

      return timeDuration;
    },


    nextPage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isLastPage) {
                  _context.next = 9;
                  break;
                }

                this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl, {
                  params: {
                    perPage: this.perPage,
                    page: this.page
                  }
                });

              case 4:
                response = _context.sent;


                response.data.data.items.forEach(function (item) {
                  _this.therapists.push(item);
                });

                this.loading = false;
                this.lastId = this.therapists[this.therapists.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function nextPage() {
        return _ref.apply(this, arguments);
      }

      return nextPage;
    }(),

    onSetSelected: function onSetSelected(selected) {
      this.therapistId = selected;
    },

    getTherapists: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl, {
                  params: {
                    perPage: this.perPage,
                    page: this.page
                  }
                });

              case 3:
                response = _context2.sent;

                this.therapists = response.data.data.items;
                this.lastId = this.therapists[this.therapists.length - 1].id;

                if (response.data.data.hasMorePages) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

                if (this.isEdit) {
                  if (this.id) {
                    this.getTherapist(this.id);
                  } else {
                    this.onSendRequest();
                    this.afterSend = true;
                  }
                }
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function getTherapists() {
        return _ref2.apply(this, arguments);
      }

      return getTherapists;
    }(),
    getTherapist: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var that, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = this;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiUrl + id);

              case 3:
                response = _context3.sent;

                this.therapistId = response.data.data;

                if (response) {
                  this.onSendRequest();
                  this.afterSend = true;
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTherapist(_x) {
        return _ref3.apply(this, arguments);
      }

      return getTherapist;
    }(),
    onPaginationClick: function onPaginationClick(pageNum) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this2.onPaginationBtnClick(pageNum);
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this2.apiStaticUrl + '/' + _this2.paginate.perPage + '/' + pageNum, {
                  params: {
                    startDate: _this2.rangeDateStartTimestamp,
                    endDate: _this2.rangeDateEndTimestamp
                  }
                });

              case 3:
                response = _context4.sent;

                _this2.therapistStatistics = response.data.data.items;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    onPaginationClientClick: function onPaginationClientClick(pageNum) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var therapistId, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this3.paginateClient.page = pageNum;
                _this3.paginateClient.forcePage = pageNum - 1;
                therapistId = _this3.therapistId ? _this3.therapistId.id : null;
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this3.apiStaticUrl + '/' + therapistId + '/clients/' + _this3.paginateClient.perPage + '/' + _this3.paginateClient.page, {
                  params: {
                    startDate: _this3.rangeDateStartTimestamp,
                    endDate: _this3.rangeDateEndTimestamp
                  }
                });

              case 5:
                response = _context5.sent;

                _this3.clientStatistics = response.data.data.items;

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },

    getTherapistStatistics: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                response = void 0;

                this.therapistStatistics = [];
                _context6.prev = 2;

                if (!id) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiStaticUrl + '/' + id, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp
                  }
                });

              case 6:
                response = _context6.sent;

                if (response.data.data instanceof Object && !(response.data.data instanceof Array)) {
                  this.therapistStatistics.push(response.data.data);
                }
                _context6.next = 14;
                break;

              case 10:
                _context6.next = 12;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiStaticUrl + '/' + 500 + '/' + this.paginate.page, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp
                  }
                });

              case 12:
                response = _context6.sent;

                this.therapistStatistics = response.data.data.items;

              case 14:

                this.paginateData = response.data.data;
                this.isLoading = false;

                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6['catch'](2);

                console.dir(_context6.t0);

              case 21:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 18]]);
      }));

      function getTherapistStatistics(_x2) {
        return _ref4.apply(this, arguments);
      }

      return getTherapistStatistics;
    }(),
    getClientStatistics: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                response = void 0;
                _context7.prev = 1;

                if (!id) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiStaticUrl + '/' + id + '/clients/' + this.paginateClient.perPage + '/' + this.paginateClient.page, {
                  params: {
                    startDate: this.rangeDateStartTimestamp,
                    endDate: this.rangeDateEndTimestamp
                  }
                });

              case 5:
                response = _context7.sent;

                this.clientStatistics = response.data.data.items;
                this.paginateClientData = response.data.data;

              case 8:
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](1);

                console.dir(_context7.t0);

              case 13:
                _context7.prev = 13;
                return _context7.finish(13);

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 10, 13, 15]]);
      }));

      function getClientStatistics(_x3) {
        return _ref5.apply(this, arguments);
      }

      return getClientStatistics;
    }(),
    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },
    getMaxDateStart: function getMaxDateStart(date) {
      var minDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2);
      return minDateStart;
    },
    findTherapistById: function findTherapistById(id) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default()(this.therapists, function (item) {
        if (item.id == id) {
          that.therapist = item.displayName;
        }
      });
    },
    onSendRequest: function onSendRequest() {
      this.isLoading = true;
      if (this.afterSend) {
        this.isSaveDisable = false;
      }
      var therapistId = this.therapistId ? this.therapistId.id : null;
      this.therapist = therapistId ? this.therapistId.displayName : '';
      this.getTherapistStatistics(therapistId);
      this.getClientStatistics(therapistId);
      this.showTable = true;
    },

    setClientPaginate: function setClientPaginate(data) {
      this.paginateClient.perPage = data.perPage;
      this.paginateClient.page = data.currentPage;
      this.paginateClient.lastPage = data.lastPage;
    },
    saveRequest: function saveRequest() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var title, isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                title = _this4.therapistId ? __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.info_therapist') + ' ' + _this4.therapist : __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.info_therapists');

                _this4.pdfProcess = true;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this4.apiSaveUrl, {
                  "title": title,
                  "startDate": _this4.rangeDateStartTimestamp,
                  "endDate": _this4.rangeDateEndTimestamp,
                  "therapistId": _this4.therapistId ? _this4.therapistId.id : null
                });

              case 4:
                isSaved = _context8.sent;


                if (isSaved) {
                  _this4.$router.push({ name: 'archive-reports' });
                  _this4.pdfProcess = false;
                }

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this4);
      }))();
    },
    generatePdf: function generatePdf() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var uri, response, hash, url, link, node;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this5.pdfProcess = true;
                uri = _this5.therapistId ? '/users/therapists/export/' + _this5.therapistId.id : '/users/therapists/export';
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(uri, {
                  "startDate": _this5.rangeDateStartTimestamp,
                  "endDate": _this5.rangeDateEndTimestamp
                });

              case 4:
                response = _context9.sent;
                hash = response.data.data.hash;
                url = "https://app.autismtech.online/api" + ('/users/reports/download?hash=' + hash);
                link = document.createElement("a");

                link.href = url;
                node = document.body.appendChild(link);

                link.click();
                setTimeout(function () {
                  node.remove();
                  _this5.pdfProcess = false;
                });

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this5);
      }))();
    },

    getOptionTitle: function getOptionTitle(_ref6) {
      var option = _ref6.option;

      return option.displayName;
    },
    isLast: function isLast(_ref7) {
      var option = _ref7.option;

      return option.id == this.lastId;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isBCBA']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_6__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    },
    paginateClientData: function paginateClientData() {
      this.setClientPaginate(this.paginateClientData);
    },
    rangeDateStart: function rangeDateStart(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateStart = oldValue;
      }
    },
    rangeDateEnd: function rangeDateEnd(newValue, oldValue) {
      if (!newValue) {
        this.rangeDateEnd = oldValue;
        this.minDateStart = this.getMinDateStart(oldValue);
      } else {
        this.minDateStart = this.getMinDateStart(newValue);
      }
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_translator__ = __webpack_require__(6);
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'therapist': {
      type: [String],
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {
    generate: function generate() {
      var _this = this;

      var pdfName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.info_therapists');
      if (this.therapist) {
        pdfName = __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.info_therapist') + '_' + this.therapist;
      }

      //Filters
      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
        var filtersImg = canvas.toDataURL('image/png');

        //Client Table
        __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-client-table'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
          var clientsImg = canvas.toDataURL('image/png');

          __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true }).then(function (canvas) {
            __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
            var docDefinition = {
              pageSize: 'A4',
              pageOrientation: 'portrait',
              pageMargins: [20, 30, 20, 20],
              content: [{
                image: filtersImg,
                width: 550
              }, {
                image: clientsImg,
                width: 570,
                margin: [-10, 20, 0, 0]
              }],
              footer: {
                columns: [{
                  text: __WEBPACK_IMPORTED_MODULE_3__lang_translator__["a" /* default */].get('report.generated_by'),
                  fontSize: 8,
                  bold: true,
                  alignment: 'right',
                  margin: [0, 0, 20, 0]
                }]
              }
            };
            __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(pdfName + '.pdf');
            _this.$emit('generated', true);
          });
        });
      });
    },
    pix2mm: function pix2mm(val, dpi) {
      return val / 0.0393701 / dpi;
    }
  }

});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataUB__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataAppeals__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataEfficiency__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_slick__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_Manager__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_parseInt__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_parseInt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_parseInt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reports_components_PdfReportClient__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_selectWithPager_components_SelectWithPager__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__undesirableBehavior_api_undesirableBehavior__ = __webpack_require__(81);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientsList',
  props: {
    'isEdit': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'id': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'skillFieldId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'skillFieldName': {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    'protocolTitle': {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    'clinicId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'protocolId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'startDate': {
      type: [Object]
    },
    'endDate': {
      type: [Object]
    },
    'csvShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'pdfShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'levelLineShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'trendLineShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'scatterLineShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphMoYesPercentShow': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'graphTotalPercentShow': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'graphPromptLevelsShow': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'graphImprovedSPOUShow': {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    'graphMoYesShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphProbeFullShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphMoGoalShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphMandReactShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphGoalShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphCumulativeImproveShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphImprovePromptShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphImproveShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphCumulitiveShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphAboluteShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphRelativeShow': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'graphUndesirableBehaviors': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'behaviorGraphType': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'behaviorUBId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      apiUrl: '/users/clients/',
      clients: [],
      clientId: null,
      client: '',
      apiSaveUrl: '/statistics/reports/clients/',
      perPage: 10,
      page: 1,
      pageClient: 1,
      pdfProcess: false,
      rangeDateStart: new Date(),
      rangeDateEnd: new Date(),
      minDateStart: this.getMinDateStart(new Date()),
      rangeDateFinish: this.getMaxDateFinish(new Date()),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      showTable: false,
      changeData: null,
      clinics: [{ id: null, name: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('report.all_centre') }],
      disabledClient: false,
      disabledSelect: true,
      skillField: null,
      allSkillField: null,
      skillFieldList: [],
      allSkillFieldList: [],
      protocolList: [],
      protocol: null,
      statisticsList: [],
      totalStatisticsList: [],
      paginateData: null,
      efficiencyList: null,
      currentSkillFieldIndex: null,
      processing: false,
      processingFilter: false,
      fromAchive: false,
      isSaveDisable: false,
      loading: false,
      lastId: null,
      lastClinicId: null,
      isLastPage: false,
      isLastPageClient: false,
      scaleLabel: {
        display: true,
        labelString: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('protocol.average_percent')
      },
      slickOptions: {
        adaptiveHeight: true
      },
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      graphMoYesPercentChecked: true,
      graphTotalPercentChecked: true,
      graphPromptLevelsChecked: true,
      graphImprovedSPOUChecked: true,
      graphMoYesChecked: false,
      graphProbeFullChecked: false,
      graphMoGoalChecked: false,
      graphMandReactChecked: false,
      graphGoalChecked: false,
      graphCumulativeImproveChecked: false,
      graphImprovePromptChecked: false,
      graphImproveChecked: false,
      graphCumulitiveChecked: false,
      pdfReport: false,
      csvReport: false,
      chartType: 'absolute',
      showGraphUndesirableBehaviors: false,
      undesirableBehaviorGraphType: '1',
      undesirableBehaviorBehaviorId: null,
      behaviorId: { id: null, text: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.all_ub') },
      lastBehaviorsId: null,
      behaviorsList: [{ id: null, text: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.all_ub') }],
      isLastBehaviorsPage: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__common_mixins_pagination__["a" /* pagination */]],
  components: {
    DataAppeals: __WEBPACK_IMPORTED_MODULE_7__DataAppeals__["a" /* default */],
    DataUB: __WEBPACK_IMPORTED_MODULE_6__DataUB__["a" /* default */],
    Slick: __WEBPACK_IMPORTED_MODULE_9_vue_slick__["a" /* default */],
    DataEfficiency: __WEBPACK_IMPORTED_MODULE_8__DataEfficiency__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_17__loader_components_Loader__["a" /* default */],
    PdfReportClient: __WEBPACK_IMPORTED_MODULE_19__reports_components_PdfReportClient__["a" /* default */],
    selectWithPager: __WEBPACK_IMPORTED_MODULE_20__common_selectWithPager_components_SelectWithPager__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_22__common_chart__["c" /* LineChart */]
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var that, response, dt, date;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              __WEBPACK_IMPORTED_MODULE_23_vee_validate__["a" /* Validator */].extend('check-period', {
                getMessage: function getMessage(attribute) {
                  return __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('rotation.unique_stimulus', { attribute: attribute });
                },
                validate: function validate() {
                  var date = new Date(_this.rangeDateStart.getFullYear(), _this.rangeDateStart.getMonth() + 4, _this.rangeDateStart.getDate(), _this.rangeDateEnd.getHours(), _this.rangeDateEnd.getMinutes(), _this.rangeDateEnd.getSeconds(), _this.rangeDateEnd.getMilliseconds());
                  return _this.rangeDateEnd.getTime() <= date.getTime();
                }
              });

              _this.processingFilter = true;

              that = _this;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClinicalCenters(_this.perPage, _this.page);

            case 5:
              response = _context.sent;

              response.data.data.items.forEach(function (item) {
                that.clinics.push(item);
              });

              _this.lastId = _this.clinics[_this.clinics.length - 1].id;
              if (response.data.data.hasMorePages) {
                _this.page++;
              } else {
                _this.isLastPage = true;
              }

              if (_this.isEdit) {
                _this.rangeDateStart = __WEBPACK_IMPORTED_MODULE_12_moment___default()(_this.startDate.date)._d;
                _this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_12_moment___default()(_this.endDate.date)._d;
                _this.pdfReport = _this.pdfShow;
                _this.csvReport = _this.csvShow;
                _this.levelLineChecked = _this.levelLineShow;
                _this.trendLineChecked = _this.trendLineShow;
                _this.ScatterLineChecked = _this.scatterLineShow;
                _this.graphMoYesPercentChecked = _this.graphMoYesPercentShow;
                _this.graphTotalPercentChecked = _this.graphTotalPercentShow;
                _this.graphPromptLevelsChecked = _this.graphPromptLevelsShow;
                _this.graphImprovedSPOUChecked = _this.graphImprovedSPOUShow;
                _this.graphMoYesChecked = _this.graphMoYesShow;
                _this.graphProbeFullChecked = _this.graphProbeFullShow;
                _this.graphMoGoalChecked = _this.graphMoGoalShow;
                _this.graphMandReactChecked = _this.graphMandReactShow;
                _this.graphGoalChecked = _this.graphGoalShow;
                _this.graphCumulativeImproveChecked = _this.graphCumulativeImproveShow;
                _this.graphImprovePromptChecked = _this.graphImprovePromptShow;
                _this.graphImproveChecked = _this.graphImproveShow;
                _this.graphCumulitiveChecked = _this.graphCumulitiveShow;

                _this.chartType = _this.graphAboluteShow ? 'absolute' : 'relative';
                _this.fromAchive = true;
              } else {
                dt = new Date();
                date = new Date(dt.getFullYear(), dt.getMonth() - 1, dt.getDate());

                _this.rangeDateStart = date;
              }

              if (response) {
                if (_this.isEdit) {
                  if (_this.clinicId) {
                    _this.getCurrentClinicalCenter(_this.clinicId);
                  } else {
                    _this.clinicalCenterId = _this.clinics[0];
                    _this.processingFilter = false;
                  }
                } else {
                  _this.processingFilter = false;
                  _this.clinicalCenterId = _this.clinics[0];
                }

                //this.onChangeClinicalCenter(this.clinicalCenterId)
              }

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    timeDuration: function timeDuration(time) {
      var min = time * 60;
      var minDuration = __WEBPACK_IMPORTED_MODULE_24_lodash_toInteger___default()(min);
      var secDuration = __WEBPACK_IMPORTED_MODULE_24_lodash_toInteger___default()(min * 60 - minDuration * 60);
      var timeDuration = time ? minDuration + __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.min') + ' ' + secDuration + __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.sec') : 0 + __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.min');

      return timeDuration;
    },


    isNew: function isNew(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].NEW;
    },

    isActive: function isActive(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].ACTIVE;
    },

    isMaintaining: function isMaintaining(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].MAINTAINING;
    },

    isCompleted: function isCompleted(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].COMPLETED;
    },

    isIndividualize: function isIndividualize(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__protocols_constants_js__["c" /* PROTOCOL_STATUSES */].INDIVIDUALIZATION;
    },

    getOptionTitle: function getOptionTitle(_ref) {
      var option = _ref.option;

      return option.name;
    },
    getOptionClientTitle: function getOptionClientTitle(_ref2) {
      var option = _ref2.option;

      return option.code;
    },
    isLast: function isLast(_ref3) {
      var option = _ref3.option;

      return option.id == this.lastId;
    },
    isLastBehavior: function isLastBehavior(_ref4) {
      var option = _ref4.option;

      return option.id == this.lastBehaviorsId;
    },

    onSetBehaviorsSelected: function onSetBehaviorsSelected(selected) {
      this.behaviorId = selected;
    },


    isLastClient: function isLastClient(_ref5) {
      var option = _ref5.option;

      return option.id == this.lastClinicId;
    },

    onChangeClinicalCenter: function onChangeClinicalCenter(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabledClient = true;
                _this2.lastClinicId = null;
                _this2.isLastPageClient = false;
                _this2.pageClient = 1;

                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClients(val.id, _this2.perPage, _this2.pageClient);

              case 6:
                response = _context2.sent;

                _this2.clients = response.data.data.items;

                if (_this2.clients.length) {
                  _this2.disabledClient = false;
                  _this2.lastClinicId = _this2.clients[_this2.clients.length - 1].id;
                  if (response.data.data.lastPage != _this2.pageClient) {
                    _this2.pageClient++;
                  } else {
                    _this2.isLastPageClient = true;
                  }
                  _this2.clinicalCenterId = val;
                  if (_this2.id && _this2.clients && _this2.fromAchive) {

                    _this2.getCurrentClient(_this2.id);
                  } else {
                    _this2.showTable = false;
                    _this2.clientId = null;
                  }
                  if (response) {
                    _this2.loading = false;
                  }
                } else {
                  _this2.disabledClient = true;
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    onChangeClinicId: function onChangeClinicId(selected) {
      this.clientId = selected;
    },

    nextClinicalPage: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.isLastPage) {
                  _context3.next = 9;
                  break;
                }

                this.loading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClinicalCenters(this.perPage, this.page);

              case 4:
                response = _context3.sent;

                response.data.data.items.forEach(function (item) {
                  _this3.clinics.push(item);
                });

                if (response) {
                  this.loading = false;
                }
                this.lastId = this.clinics[this.clinics.length - 1].id;
                if (response.data.data.lastPage != this.page) {
                  this.page++;
                } else {
                  this.isLastPage = true;
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function nextClinicalPage() {
        return _ref6.apply(this, arguments);
      }

      return nextClinicalPage;
    }(),

    nextClientPage: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this4 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.isLastPageClient) {
                  _context4.next = 9;
                  break;
                }

                this.loading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClients(this.clinicalCenterId.id, this.perPage, this.pageClient);

              case 4:
                response = _context4.sent;

                response.data.data.items.forEach(function (item) {
                  _this4.clients.push(item);
                });
                this.lastClinicId = this.clients[this.clients.length - 1].id;
                if (this.pageClient == response.data.data.lastPage) {
                  this.isLastPageClient = true;
                } else {
                  this.pageClient++;
                }

                if (response) {
                  this.loading = false;
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function nextClientPage() {
        return _ref7.apply(this, arguments);
      }

      return nextClientPage;
    }(),

    getCurrentSkillFieldIndex: function getCurrentSkillFieldIndex(id) {
      this.currentSkillFieldIndex = __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default()(this.efficiencyList, function (skillField) {
        return skillField.skillFieldId === id;
      });
    },

    getCurrentSlideIndex: function getCurrentSlideIndex(id) {
      this.currentSlideIndex = __WEBPACK_IMPORTED_MODULE_15_lodash_findIndex___default()(this.allSkillFieldList, function (skillField) {
        return skillField.id === id;
      });
    },

    getCurrentClient: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClient(id);

              case 2:
                response = _context5.sent;

                this.clientId = {
                  id: response.data.data.id,
                  code: response.data.data.code
                };

                if (this.isEdit && this.clientId) {
                  this.showGraphUndesirableBehaviors = this.graphUndesirableBehaviors;
                  this.undesirableBehaviorGraphType = this.behaviorGraphType ? this.behaviorGraphType.toString() : null;
                }

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCurrentClient(_x) {
        return _ref8.apply(this, arguments);
      }

      return getCurrentClient;
    }(),

    getCurrentClinicalCenter: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getClinicalCenter(id);

              case 2:
                response = _context6.sent;

                if (response) {
                  this.clinicalCenterId = response.data.data;
                  this.processingFilter = false;
                }

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCurrentClinicalCenter(_x2) {
        return _ref9.apply(this, arguments);
      }

      return getCurrentClinicalCenter;
    }(),

    getComments: function getComments() {
      var comments = [];
      __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default()(this.efficiencyList, function (item) {
        if (item.comment) {
          comments.push({
            'skillFieldId': item.skillFieldId,
            'protocolId': item.protocolId,
            'text': item.comment
          });
        }
      });
      return comments;
    },

    onPaginationClick: function onPaginationClick(pageNum) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this5.onPaginationBtnClick(pageNum);
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getStatistics(_this5.clientId.id, 500, pageNum, _this5.rangeDateStartTimestamp, _this5.rangeDateEndTimestamp, _this5.skillField ? _this5.skillField.id : null, _this5.protocol ? _this5.protocol.protocolId : null);

              case 3:
                response = _context7.sent;

                _this5.statisticsList = response.data.data.items;
                _this5.totalStatisticsList = response.data.data.itemsTotal;

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    clientTimezone: function clientTimezone() {
      return this.user.timezone;
    },

    findClientById: function findClientById(client) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_5_lodash_forIn___default()(this.clients, function (item) {
        if (item.id == id) {
          that.client = item.code;
        }
      });
    },
    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },
    getMaxDateFinish: function getMaxDateFinish(date) {
      var minDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2);
      return minDateStart;
    },
    onSendRequest: function onSendRequest() {
      var _this6 = this;

      var fromArchive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var result, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this6.$validator.validateAll();

              case 2:
                result = _context8.sent;

                if (result) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt('return');

              case 5:
                _this6.isSaveDisable = fromArchive;
                _this6.showTable = false;
                _this6.processing = true;
                _this6.client = _this6.clientId ? _this6.clientId.code : '';
                //this.findClientById(this.clientId)
                _this6.changeData = _this6.clientId.id + _this6.rangeDateStart + _this6.rangeDateEnd;

                _context8.next = 12;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getStatistics(_this6.clientId.id, 500, 1, _this6.rangeDateStartTimestamp, _this6.rangeDateEndTimestamp, _this6.skillField ? _this6.skillField.id : null, _this6.protocol ? _this6.protocol.protocolId : null, _this6.levelLineChecked, _this6.trendLineChecked, _this6.ScatterLineChecked, _this6.graphMoYesPercentChecked, _this6.graphTotalPercentChecked, _this6.graphPromptLevelsChecked, _this6.graphImprovedSPOUChecked, _this6.graphMoYesChecked, _this6.graphProbeFullChecked, _this6.graphMoGoalChecked, _this6.graphMandReactChecked, _this6.graphGoalChecked, _this6.graphCumulativeImproveChecked, _this6.graphImprovePromptChecked, _this6.graphImproveChecked, _this6.graphCumulitiveChecked, _this6.chartType === 'absolute', _this6.chartType === 'relative', _this6.showGraphUndesirableBehaviors, _this6.showGraphUndesirableBehaviors ? _this6.undesirableBehaviorGraphType : null, _this6.showGraphUndesirableBehaviors && _this6.undesirableBehaviorGraphType === '2' && _this6.behaviorId ? _this6.behaviorId.id : null);

              case 12:
                response = _context8.sent;

                _this6.statisticsList = response.data.data.items;
                _this6.totalStatisticsList = response.data.data.itemsTotal;
                _this6.paginateData = response.data.data;

                /*let responseEfficiency = await Manager.getEfficiency(this.clientId.id,
                    500, 1,
                    this.rangeDateStartTimestamp, this.rangeDateEndTimestamp,
                    this.skillField ? this.skillField.id : null,
                    this.protocol ? this.protocol.protocolId : null);
                this.efficiencyList = responseEfficiency.data.data.items;
                 if (!this.skillField) {
                  let responseSkillField = await Manager.getSkillField();
                  this.allSkillFieldList = responseSkillField.data.data.items;
                  this.allSkillField = this.allSkillFieldList[0];
                }
                */

                if (response) {
                  _this6.showTable = true;
                  _this6.processing = false;
                  _this6.fromAchive = false;
                }

              case 17:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },

    onSearchSkillField: __WEBPACK_IMPORTED_MODULE_25_lodash_debounce___default()(function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(search) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getSkillField(this.clientId.id, 500, 1, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp, search);

              case 2:
                response = _context9.sent;

                this.skillFieldList = response.data.data.items;

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }(), 500),
    onChangeSkillFieldId: function onChangeSkillFieldId(val) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this7.skillField = val;

                if (val && !_this7.fromAchive) {
                  _this7.protocol = null;
                  _this7.protocolList = [];
                }

                if (!val) {
                  _this7.skillFieldList = [];
                }

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this7);
      }))();
    },
    onChangeProtocolId: function onChangeProtocolId(val) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this8.protocol = val;

                if (!val) {
                  _this8.skillFieldList = [];
                }

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this8);
      }))();
    },

    onSearchProtocol: __WEBPACK_IMPORTED_MODULE_25_lodash_debounce___default()(function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(search) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api_Manager__["a" /* default */].getProtocols(this.clientId.id, 500, 1, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp, this.skillField ? this.skillField.id : null, search);

              case 2:
                response = _context12.sent;

                this.protocolList = response.data.data.items;

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }(), 500),
    handleAfterChange: function handleAfterChange(event, slick, currentSlide) {
      var slide = __WEBPACK_IMPORTED_MODULE_16_lodash_parseInt___default()(slick.$slides.get(currentSlide).getElementsByClassName('item-slide')[0].dataset.slide);
      this.getCurrentSlideIndex(slide);
      this.allSkillField = this.allSkillFieldList[this.currentSlideIndex];
    },
    onChangeSkillField: function onChangeSkillField(val) {
      this.getCurrentSkillFieldIndex(val.id);
      if (this.currentSkillFieldIndex) {
        this.$refs.slick.goTo(this.currentSkillFieldIndex);
      }
    },


    nextBehaviorsPage: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var _this9 = this;

        var response, currentUB;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.isLastBehaviorsPage) {
                  _context13.next = 9;
                  break;
                }

                this.loading = true;
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_27__undesirableBehavior_api_undesirableBehavior__["a" /* default */].getBehaviors(this.clientId.id, this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : 'all', 'all', this.perPage, this.pageBehaviors, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 4:
                response = _context13.sent;


                response.data.data.items.forEach(function (item) {
                  _this9.behaviorsList.push(item);
                });

                if (response) {
                  this.loading = false;
                }
                this.lastBehaviorsId = this.behaviorsList[this.behaviorsList.length - 1].id;
                if (response.data.data.hasMorePages) {
                  this.pageBehaviors++;
                } else {
                  this.isLastBehaviorsPage = true;
                }

              case 9:

                if (this.isEdit && this.behaviorUBId) {
                  currentUB = __WEBPACK_IMPORTED_MODULE_26_lodash_filter___default()(this.behaviorsList, function (item) {
                    return item.id === _this9.behaviorUBId;
                  });


                  this.behaviorId = currentUB[0];
                }

              case 10:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function nextBehaviorsPage() {
        return _ref12.apply(this, arguments);
      }

      return nextBehaviorsPage;
    }(),

    getOptionBehaviorsTitle: function getOptionBehaviorsTitle(_ref13) {
      var option = _ref13.option;

      return option.text;
    },

    saveRequest: function saveRequest() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var comments, isSaved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                comments = _this10.getComments();

                _this10.pdfProcess = true;

                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this10.apiSaveUrl, {
                  'title': __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('user.client') + ' ' + _this10.client,
                  'clientId': _this10.clientId.id,
                  'startDate': _this10.rangeDateStartTimestamp,
                  'endDate': _this10.rangeDateEndTimestamp,
                  'clinicalCenterId': _this10.clinicalCenterId.id,
                  'skillFieldId': _this10.skillField ? _this10.skillField.id : null,
                  'protocolId': _this10.protocol ? _this10.protocol.protocolId : null,
                  'comments': comments,
                  'pdfReport': _this10.pdfReport,
                  'csvReport': _this10.csvReport,
                  'undesirableBehaviorGraphType': _this10.showGraphUndesirableBehaviors ? _this10.undesirableBehaviorGraphType : null,
                  'undesirableBehaviorBehaviorId': _this10.showGraphUndesirableBehaviors && _this10.undesirableBehaviorGraphType === '2' && _this10.behaviorId && _this10.behaviorId.id !== 'all' ? _this10.behaviorId.id : null,
                  'chartOptions': {
                    'showLevelLine': _this10.levelLineChecked,
                    'showTrendLine': _this10.trendLineChecked,
                    'showScatterLine': _this10.ScatterLineChecked,
                    'showGraphMoYesPercent': _this10.graphMoYesPercentChecked,
                    'showGraphTotalPercent': _this10.graphTotalPercentChecked,
                    'showGraphPromptLevels': _this10.graphPromptLevelsChecked,
                    'showGraphImprovedSPOU': _this10.graphImprovedSPOUChecked,
                    'showGraphMoYes': _this10.graphMoYesChecked,
                    'showGraphProbeFull': _this10.graphProbeFullChecked,
                    'showGraphMoGoal': _this10.graphMoGoalChecked,
                    'showGraphMandReact': _this10.graphMandReactChecked,
                    'showGraphGoal': _this10.graphGoalChecked,
                    'showGraphCumulativeImprove': _this10.graphCumulativeImproveChecked,
                    'showGraphImprovePrompt': _this10.graphImprovePromptChecked,
                    'showGraphImprove': _this10.graphImproveChecked,
                    'showGraphCumulitive': _this10.graphCumulitiveChecked,
                    'showAbsolute': _this10.chartType === 'absolute',
                    'showRelative': _this10.chartType === 'relative',
                    'showGraphUndesirableBehaviors': _this10.showGraphUndesirableBehaviors
                  }
                });

              case 4:
                isSaved = _context14.sent;


                if (isSaved) {
                  _this10.pdfProcess = false;
                  _this10.$router.push({ name: 'archive-reports' });
                }

              case 6:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this10);
      }))();
    },
    generatePdf: function generatePdf() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var response, hash, url, link, node;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this11.pdfProcess = true;
                _context15.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/users/clients/export/' + _this11.clientId.id, {
                  'startDate': _this11.rangeDateStartTimestamp,
                  'endDate': _this11.rangeDateEndTimestamp,
                  'clinicalCenterId': _this11.clinicalCenterId.id,
                  'skillFieldId': _this11.skillField ? _this11.skillField.id : null,
                  'protocolId': _this11.protocol ? _this11.protocol.protocolId : null,
                  'comments': _this11.getComments()
                });

              case 3:
                response = _context15.sent;
                hash = response.data.data.hash;
                url = "https://app.autismtech.online/api" + ('/users/reports/download?hash=' + hash);
                link = document.createElement('a');

                link.href = url;
                node = document.body.appendChild(link);

                link.click();
                setTimeout(function () {
                  node.remove();
                  _this11.pdfProcess = false;
                });

              case 11:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this11);
      }))();
    },


    trans: function trans(key) {
      return __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get(key);
    },

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
    },

    fetchDatasetForChart: function fetchDatasetForChart(item) {
      var _this12 = this;

      var data = [];
      var isMasteringChart = !!item.masteringEfficiency;
      item.scaleLabel = {
        labelString: '',
        display: true
      };
      item.scaleLabel.labelString = isMasteringChart ? __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('protocol.mastering_percent') : __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('protocol.average_percent');
      var daySessions = isMasteringChart ? item.masteringEfficiency.daySessions : item.daySessions;
      __WEBPACK_IMPORTED_MODULE_21_lodash_forEach___default()(daySessions, function (day) {
        data.push({
          x: _this12.toLocaleDate(day.day),
          y: day.percent
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_22__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isBCBA', 'user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_11__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_11__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    },
    rangeDateStart: function rangeDateStart(newValue, oldValue) {
      this.showTable = false;
      if (!newValue) {
        this.rangeDateStart = oldValue;
        return;
      }
      if (!this.fromAchive) {
        this.showGraphUndesirableBehaviors = false;
        this.skillField = null;
        this.skillFieldList = [];
        this.protocol = null;
        this.protocolList = [];
      }
    },
    rangeDateEnd: function rangeDateEnd(newValue, oldValue) {
      if (!this.fromAchive) {
        this.showGraphUndesirableBehaviors = false;
      }
      if (!newValue) {
        this.rangeDateEnd = oldValue;
        this.minDateStart = this.getMinDateStart(oldValue);
      } else {
        this.minDateStart = this.getMinDateStart(newValue);
        this.skillField = null;
        this.skillFieldList = [];
        this.protocol = null;
        this.protocolList = [];
      }
    },
    clientId: function clientId(id) {
      if (id) {
        this.disabledSelect = false;
        this.showTable = false;

        if (this.fromAchive) {
          if (this.skillFieldId || this.skillFieldName) {
            this.skillFieldList = [{ id: this.skillFieldId, name: this.skillFieldName }];
            console.log('this.skillFieldList', this.skillFieldList);
          }

          this.skillField = this.skillFieldList[0];

          if (this.protocolId || this.protocolTitle) {
            this.protocolList = [{ protocolId: this.protocolId, title: this.protocolTitle }];
          }
          this.protocol = this.protocolList[0];

          this.onSendRequest(true);
          //this.fromAchive = false;
        } else {
          this.showGraphUndesirableBehaviors = false;
          this.skillField = null;
          this.skillFieldList = [];
          this.protocol = null;
          this.protocolList = [];
        }
      }
    },
    skillField: function skillField(newValue) {
      if (!this.fromAchive) {
        this.showGraphUndesirableBehaviors = false;
      }
    },
    protocol: function protocol(newValue) {
      if (!this.fromAchive) {
        this.showGraphUndesirableBehaviors = false;
      }
    },
    showGraphUndesirableBehaviors: function showGraphUndesirableBehaviors(newValue) {
      if (newValue) {
        this.pageBehaviors = 1;
        this.behaviorId = { id: null, text: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.all_ub') };
        this.lastBehaviorsId = null;
        this.isLastBehaviorsPage = false;
        this.behaviorsList = [{ id: null, text: __WEBPACK_IMPORTED_MODULE_14__lang_translator__["a" /* default */].get('behavior.all_ub') }];
        this.nextBehaviorsPage();
      }
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__undesirableBehavior_api_undesirableBehavior__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_chart__ = __webpack_require__(17);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    },
    'changeData': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientTimezone': {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    'rangeDateStart': {
      type: [Date],
      default: function _default() {
        return new Date();
      }
    },
    'rangeDateEnd': {
      type: [Date],
      default: function _default() {
        return new Date();
      }
    }
  },
  data: function data() {
    return {
      activeBehaviorId: null,
      isModalVisible: false,
      isEditModalVisible: false,
      measurements: null,
      antecedentTypes: null,
      behaviorTypes: null,
      effectsTypes: null,
      antecedentLegend: null,
      behaviorLegend: null,
      effectsLegend: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      }
    };
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_13__common_chart__["c" /* LineChart */],
    Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_13__common_chart__["a" /* BarChart */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('behavior', ['behaviors', 'isLoaded']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateStart.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    lineChartDataset: function lineChartDataset() {
      return [this.fetchLineDatasetForChart()];
    },
    barChartAncedentDataset: function barChartAncedentDataset() {
      return this.fetchBarDatasetForChart(this.antecedentTypes, __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.ancedent'));
    },
    barChartBehaviorDataset: function barChartBehaviorDataset() {
      return this.fetchBarDatasetForChart(this.behaviorTypes, __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.unwanted_behavior'));
    },
    barChartEffectsDataset: function barChartEffectsDataset() {
      return this.fetchBarDatasetForChart(this.effectsTypes, __WEBPACK_IMPORTED_MODULE_10__lang_translator__["a" /* default */].get('behavior.aftermath'));
    }
  }),

  created: function created() {
    if (this.clientTimezone) {
      this.setDate();
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('behavior', ['setBehaviors', 'setCurrentPage']), {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
    },

    fetchLineDatasetForChart: function fetchLineDatasetForChart() {
      var _this = this;

      var data = [],
          i = 0;
      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: _this.toLocaleDate(item.dateRange.end),
          y: item.perHourCount
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_13__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      if (color == '#255255') return '#333333';
      return color;
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart(listTypes, name) {
      var _this2 = this;

      var data = [],
          i = 0,
          label = name,
          backgroundColor = void 0,
          datasets = [],
          legends = [];

      var types = __WEBPACK_IMPORTED_MODULE_12_lodash_orderBy___default()(listTypes, 'count', 'desc');

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(types, function (item) {
        data = [{
          x: ++i,
          y: item.count
        }];
        label = item.title;
        backgroundColor = _this2.getRandomColor();
        legends.push({
          label: label,
          background: backgroundColor
        });

        datasets.push(new __WEBPACK_IMPORTED_MODULE_13__common_chart__["b" /* BarChartDataset */]({
          data: data, label: label, labels: legends, backgroundColor: backgroundColor, borderColor: backgroundColor
        }));
      });

      return datasets;
    },
    setDate: function setDate() {
      this.fetchMeasurement();
    },
    openDescription: function openDescription(id) {
      if (this.activeBehaviorId !== id) {
        this.activeBehaviorId = id;
      } else {
        this.activeBehaviorId = null;
      }
    },
    getDateTimestamp: function getDateTimestamp(date) {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).unix() + Math.abs(date.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },


    fetchMeasurement: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, responseTypes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__undesirableBehavior_api_undesirableBehavior__["a" /* default */].getCountBehavior(this.clientId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 3:
                response = _context.sent;

                this.measurements = response.data.data;

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__undesirableBehavior_api_undesirableBehavior__["a" /* default */].getCountTypes(this.clientId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 7:
                responseTypes = _context.sent;

                this.antecedentTypes = responseTypes.data.data.antecedent;
                this.behaviorTypes = responseTypes.data.data.behavior;
                this.effectsTypes = responseTypes.data.data.effects;

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function fetchMeasurement() {
        return _ref.apply(this, arguments);
      }

      return fetchMeasurement;
    }()

  }),

  watch: {
    rangeDateStart: function rangeDateStart(oldValue, newValue) {
      var rangeDays = __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MILLISECONDS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MINUTES * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].HOURS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].COUNT_DAY;
      if (!oldValue) {
        this.rangeDateStart = newValue;
      }
      var myDate = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(this.rangeDateStart);
      var newDate = new Date(myDate.getTime() + rangeDays);

      if (newDate.getTime() / __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MILLISECONDS > __WEBPACK_IMPORTED_MODULE_9_moment___default.a.tz(new Date(), this.clientTimezone).utcOffset(0, true).unix()) {
        this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_9_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_9_moment___default()().utcOffset(), 'm')._d;
      } else {
        this.rangeDateEnd = newDate;
      }
    },
    changeData: function changeData() {
      this.setDate();
    },
    clientTimezone: function clientTimezone() {
      if (this.clientTimezone) {
        this.setDate();
      }
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appeals_api_appeals__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_mixins_pagination__ = __webpack_require__(28);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return Auth.getUserInfo().id || this.route.params.clientId;
      }
    },
    'changeData': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'clientTimezone': {
      type: [String],
      default: function _default() {
        return null;
      }
    },
    'rangeDateStart': {
      type: [Date],
      default: function _default() {
        return new Date();
      }
    },
    'rangeDateEnd': {
      type: [Date],
      default: function _default() {
        return new Date();
      }
    }
  },
  data: function data() {
    return {
      apiUrl: 'appeals/statistics/',
      isModalVisible: false,
      isEditModalVisible: false,
      measurements: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      appeals: null
    };
  },


  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_9__common_chart__["a" /* BarChart */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__common_mixins_pagination__["a" /* pagination */]],

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    isEmptyAppeals: function isEmptyAppeals() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(this.appeals);
    },
    lineChartDataset: function lineChartDataset() {
      return this.fetchDatasetForChart();
    },
    barChartDataset: function barChartDataset() {
      return this.fetchBarDatasetForChart();
    },
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  }),

  created: function created() {
    if (this.clientTimezone) {
      this.setDate();
    }
  },


  methods: {
    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
    },

    fetchMeasurement: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__appeals_api_appeals__["a" /* default */].getCountAppeals(this.clientId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);

              case 3:
                response = _context.sent;


                this.measurements = response.data.data;

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function fetchMeasurement() {
        return _ref.apply(this, arguments);
      }

      return fetchMeasurement;
    }(),

    fetchDatasetForChart: function fetchDatasetForChart() {
      var data = [];
      var i = 0;
      var label = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('appeals.avarage_appeals_perhour');
      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: i,
          y: item.perHourCount
        });
        i++;
      });

      return new __WEBPACK_IMPORTED_MODULE_9__common_chart__["d" /* LineChartDataset */]({
        data: data, label: label
      });
    },
    fetchBarDatasetForChart: function fetchBarDatasetForChart() {
      var _this = this;

      var data = [];
      var i = 0;
      var label = __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('appeals.total_appeals_perday');
      var labels = [];
      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.measurements, function (item) {
        data.push({
          x: i,
          y: item.totalCount
        });
        i++;
        labels.push(_this.toLocaleDate(item.dateRange.end));
      });

      return new __WEBPACK_IMPORTED_MODULE_9__common_chart__["b" /* BarChartDataset */]({ data: data, label: label, labels: labels });
    },
    setDate: function setDate() {
      this.getPageAppeals(this.clientId, this.rangeDateStartTimestamp, this.rangeDateEndTimestamp);
      this.fetchMeasurement();
    },


    getPageAppeals: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(clientId, startDate, endDate) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__appeals_api_appeals__["a" /* default */].getCountAllAppeals(clientId, startDate, endDate);

              case 2:
                response = _context2.sent;

                this.appeals = response.data.data;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPageAppeals(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return getPageAppeals;
    }(),

    getDateTimestamp: function getDateTimestamp(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).unix() + Math.abs(date.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE;
    }
  },

  watch: {
    rangeDateStart: function rangeDateStart(oldValue, newValue) {
      var rangeDays = __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MILLISECONDS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].SECONDS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MINUTES * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].HOURS * __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].COUNT_DAY;
      if (!oldValue) {
        this.rangeDateStart = newValue;
      }
      var myDate = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(this.rangeDateStart);
      var newDate = new Date(myDate.getTime() + rangeDays);

      if (newDate.getTime() / __WEBPACK_IMPORTED_MODULE_8__undesirableBehavior_Constants__["a" /* default */].MILLISECONDS > __WEBPACK_IMPORTED_MODULE_12_moment___default.a.tz(new Date(), this.clientTimezone).utcOffset(0, true).unix()) {
        this.rangeDateEnd = __WEBPACK_IMPORTED_MODULE_12_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_12_moment___default()().utcOffset(), 'm')._d;
      } else {
        this.rangeDateEnd = newDate;
      }
    },
    changeData: function changeData() {
      this.setDate();
    },
    clientTimezone: function clientTimezone() {
      if (this.clientTimezone) {
        this.setDate();
      }
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_chart__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'efficiencyGrid': {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      }
    };
  },

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_5__common_chart__["c" /* LineChart */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__loader_components_Loader__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), {
    lineChartDataset: function lineChartDataset() {
      return [this.fetchLineDatasetForChart()];
    }
  }),

  methods: {

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
    },

    fetchLineDatasetForChart: function fetchLineDatasetForChart() {
      var _this = this;

      var data = [],
          i = 0;
      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(this.efficiencyGrid, function (item) {
        data.push({
          x: _this.toLocaleDate(item.day),
          y: item.percent
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_5__common_chart__["d" /* LineChartDataset */]({
        data: data
      });
    }
  }

});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//




// Check if the request came from the browser and is not server rendered
if (typeof window !== 'undefined') {
  var slick = __webpack_require__(1401);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.create();
  },

  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
  },

  methods: {
    create: function create() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },

    destroy: function destroy() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
    },

    reSlick: function reSlick() {
      this.destroy();
      this.create();
    },

    next: function next() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickNext');
    },

    prev: function prev() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPrev');
    },

    pause: function pause() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPause');
    },

    play: function play() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPlay');
    },

    goTo: function goTo(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },

    currentSlide: function currentSlide() {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickCurrentSlide');
    },

    add: function add(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },

    remove: function remove(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },

    filter: function filter(filterData) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickFilter', filterData);
    },

    unfilter: function unfilter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickUnfilter');
    },

    getOption: function getOption(option) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGetOption', option);
    },

    setOption: function setOption(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },

    setPosition: function setPosition() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('setPosition');
    },

    // Events
    onAfterChange: function onAfterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },

    onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },

    onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },

    onDestroy: function onDestroy(event, slick) {
      this.$emit('destroy', event, slick);
    },

    onEdge: function onEdge(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },

    onInit: function onInit(event, slick) {
      this.$emit('init', event, slick);
    },

    onReInit: function onReInit(event, slick) {
      this.$emit('reInit', event, slick);
    },

    onSetPosition: function onSetPosition(event, slick) {
      this.$emit('setPosition', event, slick);
    },

    onSwipe: function onSwipe(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },

    onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },

    onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    }
  }

});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reports_pdfConstants__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'efficiencyList': {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    'client': {
      type: [String],
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {
    generate: function generate() {
      var _this = this;

      var that = this;
      var pdfName = __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('report.info_client');
      if (this.client) {
        pdfName = __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('report.info_client') + '_' + this.client;
      }

      //Filters
      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
        var filtersImg = canvas.toDataURL('image/png');

        //Client Table
        __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-client-table'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
          var clientsImg = canvas.toDataURL('image/png');

          //Ub - Appeals
          __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-ub'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
            var ubImg = canvas.toDataURL('image/png');

            //Ub - Appeals
            __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-appeals'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
              var appealsImg = canvas.toDataURL('image/png');

              __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
                var efficiencyList = [];
                var emptyEfficiencyList = [];

                var _loop = function _loop(i) {
                  if (_this.efficiencyList[i].daySessions.length > 0) {
                    var daySessions = _this.efficiencyList[i].daySessions.filter(function (item) {
                      return item.noData === false;
                    });
                    if (daySessions.length > 0) {
                      var domEfficiency = document.getElementById('slide_' + i);
                      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(domEfficiency, { allowTaint: true, useCORS: true, scale: 2 }).then(function (canvas) {
                        var efficiencyImg = canvas.toDataURL('image/png');
                        efficiencyList.push({
                          source: efficiencyImg,
                          title: _this.efficiencyList[i].skillFieldName
                        });
                      });
                    } else {
                      emptyEfficiencyList.push({
                        title: _this.efficiencyList[i].skillFieldName
                      });
                    }
                  } else {
                    emptyEfficiencyList.push({
                      title: _this.efficiencyList[i].skillFieldName
                    });
                  }
                };

                for (var i = 0; i < _this.efficiencyList.length; i++) {
                  _loop(i);
                }

                __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector('#pdf-filers'), { allowTaint: true, useCORS: true }).then(function (canvas) {
                  __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
                  var docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    pageMargins: [20, 30, 20, 20],
                    content: that.getContentPdf(filtersImg, clientsImg, ubImg, appealsImg, efficiencyList, emptyEfficiencyList),
                    footer: {
                      columns: [{
                        text: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('report.generated_by'),
                        fontSize: 8,
                        bold: true,
                        alignment: 'right',
                        margin: [0, 0, 20, 0]
                      }]
                    }
                  };
                  __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(pdfName + '.pdf');
                  _this.$emit('generated', true);
                });
              });
            });
          });
        });
      });
    },
    getContentPdf: function getContentPdf(filtersImg, clientsImg, ubImg, appealsImg, efficiencyList, emptyEfficiencyList) {
      var content = [];

      content.push({
        image: filtersImg,
        width: 550
      });

      content.push({
        image: clientsImg,
        width: 570,
        margin: [-10, 20, 0, 0]
      });

      content.push({
        image: ubImg,
        width: 570,
        margin: [-10, 20, 0, 0],
        pageBreak: 'before'
      });

      content.push({
        image: appealsImg,
        width: 570,
        margin: [-10, 20, 0, 0],
        pageBreak: 'before'
      });

      efficiencyList.forEach(function (efficiency) {
        content.push({
          pageBreak: 'before',
          text: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('report.data_protocol') + ': ' + efficiency.title,
          bold: true,
          margin: [-10, 20, 0, 0]
        });
        content.push({
          image: efficiency.source,
          width: 570,
          margin: [-10, 10, 0, 0]
        });
      });

      emptyEfficiencyList.forEach(function (efficiency) {
        content.push({
          pageBreak: 'before',
          text: __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('report.data_protocol') + ' ' + efficiency.title,
          bold: true,
          margin: [-10, 10, 0, 0]
        });
        content.push({
          image: __WEBPACK_IMPORTED_MODULE_3__reports_pdfConstants__["a" /* EMPTY_APPLYINGEFFICIENCY_IMG */].source,
          width: 570,
          margin: [-10, 20, 0, 0]
        });
      });

      return content;
    },
    pix2mm: function pix2mm(val, dpi) {
      return val / 0.0393701 / dpi;
    }
  }

});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_mixins_pagination__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArchiveList',
  data: function data() {
    return {
      apiUrl: '/statistics/reports',
      reports: {},
      clientId: __WEBPACK_IMPORTED_MODULE_5__common_auth_Manager__["a" /* default */].getUserInfo().id,
      paginateData: null,
      isModalVisible: false,
      reportId: null,
      isEdit: true,
      isLoaded: false,
      initialPage: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_mixins_pagination__["a" /* pagination */]],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__loader_components_Loader__["a" /* default */]
  },
  created: function created() {
    if (localStorage.currentPage) {
      this.onPaginationClick(localStorage.getItem("currentPage"));
      this.initialPage = +localStorage.getItem("currentPage") - 1;
    } else {
      this.getReports();
      this.initialPage = 1;
    }
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem('currentPage');
  },

  methods: {
    onPaginationClick: function onPaginationClick(pageNum) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage.setItem('currentPage', pageNum);
                _this.onPaginationBtnClick(pageNum);
                _context.next = 4;
                return _this.getReports();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    getReports: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                response = void 0;

                this.isLoaded = false;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrl + '/' + this.paginate.perPage + '/' + this.paginate.page);

              case 5:
                response = _context2.sent;

                this.reports = response.data.data.items;
                this.paginateData = response.data.data;
                this.isLoaded = true;

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](2);

                console.dir(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 11]]);
      }));

      function getReports() {
        return _ref.apply(this, arguments);
      }

      return getReports;
    }(),
    showDeletePopup: function showDeletePopup(id) {
      this.reportId = id;
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    toLocaleDateTimeTimezone: function toLocaleDateTimeTimezone(date) {
      var dateTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(date, 'YYYY-MM-DD HH:mm').toDate();
      //let dateTime = new Date(date);
      var dateWithTimezone = dateTime.getTime() + Math.abs(dateTime.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_9__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE * 1000;

      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(dateWithTimezone).format('DD.MM.YYYY HH:mm');
    },


    deleteReport: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isDeleted;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.isLoaded = false;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(this.apiUrl + '/' + this.reportId);

              case 4:
                isDeleted = _context3.sent;

                if (isDeleted) {
                  this.getReports(this.apiUrl + '/' + this.paginate.perPage + '/' + this.paginate.page);
                  this.isLoaded = true;
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function deleteReport() {
        return _ref2.apply(this, arguments);
      }

      return deleteReport;
    }(),

    generateCsv: function generateCsv(csv) {
      var _this2 = this;

      this.isLoaded = false;
      var id = csv.id;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: 'statistics/reports/clients/' + id + '/csv'
      }).then(function (response) {
        _this2.getReports();
      }).catch(function () {
        return console.log('error occured');
      });
    },
    downloadCsv: function downloadCsv(csv) {
      var file = csv.directory;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: 'statistics/reports/clients/csv/' + file,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', csv.alias + '.zip');
        document.body.appendChild(link);
        link.click();
      }).catch(function () {
        return console.log('error occured');
      });
    },
    generatePdf: function generatePdf(item) {
      var _this3 = this;

      this.isLoaded = false;
      var id = item.id;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: 'statistics/reports/clients/' + id + '/pdf'
      }).then(function (response) {
        _this3.getReports();
      }).catch(function () {
        return console.log('error occured');
      });
    },
    downloadPdf: function downloadPdf(item) {
      var id = item.id;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: 'statistics/reports/clients/pdf/' + id,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', item.pdf.alias + '.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(function () {
        return console.log('error occured');
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['user', 'isMensurationForbidden']), {
    isEmptyList: function isEmptyList() {
      return __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default()(this.reports);
    }
  }),
  watch: {
    paginateData: function paginateData() {
      this.setPaginate(this.paginateData);
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgB7ZRBDoIwEEX/GNx7hHIHTezSk3gUOYKcyJ0lkTvYI7B3UdumTRCG0hhMXPATaBPmv7T9Q4EMNap9uientkCeRGYdNlhYK/APgaO2if1m8DpJKTVnUkoJwvbm5ke5L5GxQm9wxgRMcMYR0K3MDpqDDmA61H6IkN6SiPDwSfdh3JGwQAbal06d7yRwApqEeWBMdZgWA00mHzkFZm6SACgxL+FeP/hTDDo34XouV9FLhI6UelQEumAJGdQ+5ebeXu1wtpnv8I3sLg2ZWspD9QYRnWU0IUp9OAAAAABJRU5ErkJggg=="

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardQuiz',
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isTherapist']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['route'])),
  data: function data() {
    return {
      apiUrl: '/quiz/',
      apiClientUrl: '/users/clients/',
      client: null
    };
  },
  created: function created() {
    if (!this.client) {
      this.getClient(this.clientId);
    }
  },


  methods: {

    getClient: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.apiClientUrl + clientId);

              case 3:
                response = _context.sent;

                this.client = response.data.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.dir(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getClient(_x) {
        return _ref.apply(this, arguments);
      }

      return getClient;
    }()

  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_join__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_max__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_autocompleteSearch_components_autocompleteSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_split__);






var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isChange: false,
      apiUrl: 'users/',
      quizUrl: '/quiz/assigned/',
      rangeDateStart: null,
      rangeDateEnd: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      minDateStart: this.getMinDateStart(new Date()),
      maxDateStart: this.getMaxDateStart(new Date()),
      quizList: [],
      autocomplete: [],
      visible: true,
      targetBehaviour: null,
      quiz: null,
      quizSelectedToDelete: null,
      isModalVisible: false,
      isModalErrorVisible: false,
      masList: null,
      fastList: null,
      results: null,
      maxFast: 0,
      maxMas: 0,
      dataMas: null,
      dataFast: null,
      messageError: null,
      options: {
        pageHeader: 'assignedQuiz',
        initialPage: null,
        filterable: false,
        sortable: [],
        skin: 'table table-sm',
        withSearch: false,
        columns: [{
          key: 'createdAt',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.create_date')
        }, {
          key: 'creator',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.created')
        }, {
          key: 'specialist',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('report.specialist')
        }, {
          key: 'quizAssignedUnits',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.assigned')
        }, {
          key: 'description',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.description')
        }, {
          key: 'quiz',
          changed: false,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.typeQuiz')
        }, {
          key: 'addToReport',
          changed: true,
          headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.addToReport')
        }, {
          key: 'action',
          changed: true,
          headings: ''
        }],
        requestFunction: this.requestFunction,
        responseAdapter: function responseAdapter(resp) {
          return {
            data: resp.data.data.items,
            count: resp.data.data.total
          };
        },
        texts: {
          filterPlaceholder: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.type_the_procol_name_to_search'),
          noResults: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('bids.no_data'),
          loading: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('home.labels.loading_message_table')
        },
        rowClassCallback: this.rowClassCallback,
        columnsClasses: {
          createdAt: this.isMobile ? '' : 'nowrap',
          creator: this.isMobile ? '' : 'nowrap',
          action: 'table-actions',
          quizAssignedUnits: 'not-break hide-row',
          addToReport: 'text-center  hide-row'
        },
        templates: {
          createdAt: this.createdAt,
          creator: this.getCreatorName,
          specialist: this.getSpecialistName,
          quiz: this.typeQuiz,
          quizAssignedUnits: this.getQuizAssignedUnits
        },
        listRow: {
          createdAt: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('protocol.create_date'),
            hasTemplate: true
          },
          creator: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.created'),
            hasTemplate: true
          },
          quizAssignedUnits: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.assigned'),
            hasTemplate: true
          },
          description: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.description'),
            hasTemplate: false
          },
          quiz: {
            headings: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.typeQuiz'),
            hasTemplate: true
          },
          childList: {
            headings: "",
            hasTemplate: false
          }

        },
        perPage: 10
      },
      therapist: true,
      isLoaded: false

    };
  },

  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_13_vuejs_paginate___default.a, Loader: __WEBPACK_IMPORTED_MODULE_14__loader_components_Loader__["a" /* default */], TableView: __WEBPACK_IMPORTED_MODULE_15__common_table_components_TableView__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_20__common_chart__["a" /* BarChart */], BarChartDataset: __WEBPACK_IMPORTED_MODULE_20__common_chart__["b" /* BarChartDataset */], autocompleteSearch: __WEBPACK_IMPORTED_MODULE_22__common_autocompleteSearch_components_autocompleteSearch__["a" /* default */]
  },

  provide: function provide() {
    return { parentValidator: this.$validator };
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])('auth', ['isTherapist', 'isCurator', 'isClient', 'isBCBA', 'user']), {
    rangeDateStartTimestamp: function rangeDateStartTimestamp() {
      return this.rangeDateStart ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.rangeDateStart).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE : null;
    },
    rangeDateEndTimestamp: function rangeDateEndTimestamp() {
      return this.rangeDateStart ? __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.rangeDateEnd).unix() + Math.abs(this.rangeDateEnd.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_19__undesirableBehavior_Constants__["a" /* default */].SECONDS_PER_MINUTE : null;
    },
    barChartDatasetMas: function barChartDatasetMas() {
      return this.fetchBarDatasetForChartMas();
    },
    barChartDatasetFast: function barChartDatasetFast() {
      return this.fetchBarDatasetForChartFast();
    }
  }),

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_18_vee_validate__["a" /* Validator */].extend('check-period', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('report.description_max_period', { attribute: attribute });
      },
      validate: function validate() {
        var date = new Date(_this.rangeDateStart.getFullYear(), _this.rangeDateStart.getMonth() + 4, _this.rangeDateStart.getDate(), _this.rangeDateEnd.getHours(), _this.rangeDateEnd.getMinutes(), _this.rangeDateEnd.getSeconds(), _this.rangeDateEnd.getMilliseconds());
        return _this.rangeDateEnd.getTime() <= date.getTime();
      }
    });
    this.getQuizList();
  },


  methods: {

    searchAutocomplete: __WEBPACK_IMPORTED_MODULE_21_lodash_debounce___default()(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(vm.apiUrl + vm.clientId + '/quiz/target-behavior/search' + '?search=' + search, { params: {
                    quizId: vm.quiz && vm.quiz.id ? vm.quiz.id : null
                  }
                });

              case 3:
                response = _context.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_23_lodash_uniqBy___default()(response.data.data, 'name');

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 250),

    setProblemBehaviourValue: function setProblemBehaviourValue(value) {
      this.targetBehaviour = value;
    },
    onChangeProblemBehaviour: function onChangeProblemBehaviour(search) {
      this.searchAutocomplete(search, this);
    },
    maxValue: function maxValue(answers) {
      var answerMax = __WEBPACK_IMPORTED_MODULE_11_lodash_max___default()(answers);
      return answerMax;
    },
    disabledCheckAnswer: function disabledCheckAnswer(row) {

      var disabled = false;

      disabled = row.quiz.id === 1 ? this.masList && row.id !== this.masList.quizId : this.fastList && row.id !== this.fastList.quizId;

      return disabled;
    },
    getDateStart: function getDateStart() {
      var today = new Date();
      var minDateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);

      return minDateStart;
    },
    choseSpecialists: function choseSpecialists(row, specialists) {

      if (row.quiz.id === 1) {

        if (specialists.addAnsweredToReport) {

          if (!this.masList) {
            this.masList = {
              quizType: row.quiz.id,
              quizId: row.id,
              unitIds: [specialists.id]
            };
          } else if (this.masList && row.id === this.masList.quizId) {
            this.masList.unitIds.push(specialists.id);
          }
        } else {

          var indexSpecialists = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.masList.unitIds, function (item) {
            return item === specialists.id;
          });

          this.masList.unitIds.splice(indexSpecialists, 1);
          if (!this.masList.unitIds.length) {
            this.masList = null;
          }
        }
      }

      if (row.quiz.id === 2) {
        if (specialists.addAnsweredToReport) {

          if (!this.fastList) {
            this.fastList = {
              quizType: row.quiz.id,
              quizId: row.id,
              unitIds: [specialists.id]
            };
          } else if (this.fastList && row.id === this.fastList.quizId) {
            this.fastList.unitIds.push(specialists.id);
          }
        } else {

          var _indexSpecialists = __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(this.fastList.unitIds, function (item) {
            return item === specialists.id;
          });
          this.fastList.unitIds.splice(_indexSpecialists, 1);

          if (!this.fastList.unitIds.length) {
            this.fastList = null;
          }
        }
      }
    },
    listReportLength: function listReportLength(list) {
      var answerCount = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(list, function (item) {
        return item.addAnsweredToReport;
      });

      return answerCount.length;
    },


    getMaxDateFinish: function getMaxDateFinish(date) {
      var clientDateEnd = __WEBPACK_IMPORTED_MODULE_17_moment___default()().tz(this.clientTimezone).add(-__WEBPACK_IMPORTED_MODULE_17_moment___default()().utcOffset(), 'm');
      var minDateEnd = clientDateEnd._d;
      return minDateEnd;
    },

    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    getMaxDateStart: function getMaxDateStart(date) {
      var maxDateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
      return maxDateStart;
    },

    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },

    toLocaleDateTime: function toLocaleDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_17_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
    },

    createdAt: function createdAt(h, row) {
      return this.toLocaleDate(row.createdAt.date);
    },
    rowClassCallback: function rowClassCallback(row) {
      return (this.isCurator && this.user.id === row.creator.id || this.isBCBA) && !this.isMobile && row.quizAnsweredUnits.length ? "" : "disable-child";
    },
    getCreatorName: function getCreatorName(h, row) {
      return row.creator.displayName;
    },
    getSpecialistName: function getSpecialistName(h, row) {
      return row.specialist.displayName;
    },
    getQuizAssignedUnits: function getQuizAssignedUnits(h, row) {
      var list = __WEBPACK_IMPORTED_MODULE_9_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_map___default()(row.quizAssignedUnits, 'name'), ', ');
      return list;
    },
    typeQuiz: function typeQuiz(h, row) {
      return row.quiz.title;
    },
    requestFunction: function requestFunction(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this3.getAssignedQiuz(_this3.options.perPage, data.page, _this3.clientId, data.query));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    getQuizList: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/');

              case 3:
                response = _context3.sent;


                this.quizList = response.data.data.items;

                this.quizList.unshift({
                  id: null,
                  title: __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('report.all')
                });

                this.isLoaded = true;

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.dir(_context3.t0);
                //this.$router.push({name: 'default'});

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function getQuizList() {
        return _ref2.apply(this, arguments);
      }

      return getQuizList;
    }(),

    onPaginationClick: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(pageNum) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.getAssignedQiuz(this.paginate.perPage, pageNum, this.clientId);
                this.onPaginationBtnClick(pageNum);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPaginationClick(_x3) {
        return _ref3.apply(this, arguments);
      }

      return onPaginationClick;
    }(),

    getAssignedQiuz: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(perPage, page, clientId) {
        var _this4 = this;

        var targetBehaviourId, params, response, assignedQuiz;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                targetBehaviourId = null;

                if (this.targetBehaviour) {
                  targetBehaviourId = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.autocomplete, function (item) {
                    return item.name === _this4.targetBehaviour;
                  })[0].id;
                }

                localStorage.setItem('currentPage', page);
                localStorage.setItem('currentPageHeader', 'assignedQuiz');

                params = {
                  perPage: perPage,
                  page: page,
                  startDate: this.rangeDateStartTimestamp,
                  endDate: this.rangeDateEndTimestamp,
                  quizId: this.quiz ? this.quiz.id : null,
                  targetBehaviorId: targetBehaviourId
                };
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + clientId + this.quizUrl, {
                  params: params
                });

              case 8:
                response = _context5.sent;
                assignedQuiz = response;

                assignedQuiz.data.data.items.forEach(function (item) {
                  item.isOpen = false;
                  item.addToReport = false;
                  item.quizAnsweredUnits.forEach(function (itemAnswered) {
                    if (_this4.addAnsweredInlist(item.id, item.quiz.id, itemAnswered.id)) {
                      _this4.$set(itemAnswered, 'addAnsweredToReport', true);
                    } else {
                      _this4.$set(itemAnswered, 'addAnsweredToReport', false);
                    }
                    itemAnswered.isOpen = false;
                  });
                });
                this.isChange = false;
                return _context5.abrupt('return', assignedQuiz);

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](0);

                console.dir(_context5.t0);
                //this.$router.push({name: 'default'});

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 15]]);
      }));

      function getAssignedQiuz(_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return getAssignedQiuz;
    }(),

    addAnsweredInlist: function addAnsweredInlist(quizId, type, specialistsId) {

      if (type === 1 && this.masList && this.masList.quizId === quizId) {

        var checked = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.masList.unitIds, function (item) {
          return item === specialistsId;
        });

        return checked.length;
      }

      if (type === 2 && this.fastList && this.fastList.quizId === quizId) {

        var _checked = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.fastList.unitIds, function (item) {
          return item === specialistsId;
        });

        return _checked.length;
      }

      return false;
    },
    applyFilter: function applyFilter() {
      this.isChange = true;
      this.masList = null;
      this.fastList = null;
      this.results = null;
    },
    showDeletePopup: function showDeletePopup(quiz) {
      this.quizSelectedToDelete = quiz;
      this.isModalVisible = true;
    },
    onModalClose: function onModalClose() {
      this.isModalVisible = false;
    },
    onModalErrorClose: function onModalErrorClose() {
      this.isChange = false;
      this.isModalErrorVisible = false;
    },


    deleteQuiz: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(quiz) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isChange = false;
                this.isLoaded = false;
                _context6.prev = 2;
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete('' + this.apiUrl + this.clientId + '/quiz/' + quiz.quiz.id + '/assign/' + quiz.id);

              case 5:
                this.isChange = true;
                this.isLoaded = true;

                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](2);


                if (_context6.t0 && _context6.t0.data.code === 403) {
                  this.isLoaded = true;
                  this.isChange = true;
                  this.isModalErrorVisible = true;
                }

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 9]]);
      }));

      function deleteQuiz(_x7) {
        return _ref5.apply(this, arguments);
      }

      return deleteQuiz;
    }(),

    getSpecialistIds: function getSpecialistIds() {
      var assignedQuiz = [];

      if (this.fastList) {
        assignedQuiz.push({
          id: this.fastList.quizId,
          unitIds: this.fastList.unitIds
        });
      }

      if (this.masList) {
        assignedQuiz.push({
          id: this.masList.quizId,
          unitIds: this.masList.unitIds
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(assignedQuiz);
    },


    showResult: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _this5 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.fastList && (this.fastList.unitIds.length < 2 || this.fastList.unitIds.length > 3) || this.masList && (this.masList.unitIds.length < 2 || this.masList.unitIds.length > 3))) {
                  _context7.next = 3;
                  break;
                }

                this.messageError = __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.errorResult');
                return _context7.abrupt('return');

              case 3:

                this.messageError = "";

                _context7.prev = 4;
                _context7.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + this.clientId + this.quizUrl + 'report/compare/', {
                  params: {
                    "assignedQuiz": this.getSpecialistIds()
                  }
                });

              case 7:
                response = _context7.sent;


                this.results = response.data.data;

                setTimeout(function () {
                  _this5.$refs.resultTable.scrollIntoView({ behavior: 'smooth' });
                }, 50);

                _context7.next = 16;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](4);

                this.isChange = false;
                this.messageError = _context7.t0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_context7.t0.data.errors)[0].message : null;

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 12]]);
      }));

      function showResult() {
        return _ref6.apply(this, arguments);
      }

      return showResult;
    }(),

    exportQuiz: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.fastList && (this.fastList.unitIds.length < 2 || this.fastList.unitIds.length > 3) || this.masList && (this.masList.unitIds.length < 2 || this.masList.unitIds.length > 3))) {
                  _context8.next = 3;
                  break;
                }

                this.messageError = __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.errorResult');
                return _context8.abrupt('return');

              case 3:

                this.messageError = "";

                _context8.prev = 4;
                _context8.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + this.clientId + this.quizUrl + 'pdf/compare/', {
                  responseType: 'blob',
                  params: {
                    "assignedQuiz": this.getSpecialistIds()
                  }
                }).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.quiz') + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 7:
                response = _context8.sent;
                _context8.next = 15;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8['catch'](4);

                console.dir(_context8.t0);
                this.isChange = false;
                this.messageError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_context8.t0.data.errors)[0].message;

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[4, 10]]);
      }));

      function exportQuiz() {
        return _ref7.apply(this, arguments);
      }

      return exportQuiz;
    }(),

    exportSpecialistQuiz: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(quizId, specialistsId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + this.clientId + this.quizUrl + quizId + '/assignedUnit/' + specialistsId + '/pdf/', {
                  responseType: 'blob'
                }).then(function (response) {
                  var url = window.URL.createObjectURL(new Blob([response.data]));
                  var link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', __WEBPACK_IMPORTED_MODULE_6__lang_translator__["a" /* default */].get('quiz.quiz') + '_' + quizId + '_' + specialistsId + '.pdf');
                  document.body.appendChild(link);
                  link.click();
                });

              case 3:
                response = _context9.sent;
                _context9.next = 11;
                break;

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9['catch'](0);

                console.dir(_context9.t0);
                this.isChange = false;
                this.messageError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_context9.t0.data.errors)[0].message;

              case 11:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 6]]);
      }));

      function exportSpecialistQuiz(_x8, _x9) {
        return _ref8.apply(this, arguments);
      }

      return exportSpecialistQuiz;
    }(),

    resultSpecialistQuiz: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(quizId, specialistsId) {
        var _this6 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('' + this.apiUrl + this.clientId + this.quizUrl + quizId + '/assignedUnit/' + specialistsId + '/report/');

              case 3:
                response = _context10.sent;

                this.isChange = true;
                this.masList = null;
                this.fastList = null;
                this.results = [response.data.data];
                setTimeout(function () {
                  _this6.$refs.resultTable.scrollIntoView({ behavior: 'smooth' });
                }, 50);

                _context10.next = 16;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10['catch'](0);

                console.dir(_context10.t0);
                this.isChange = false;
                this.messageError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_context10.t0.data.errors)[0].message;

              case 16:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 11]]);
      }));

      function resultSpecialistQuiz(_x10, _x11) {
        return _ref9.apply(this, arguments);
      }

      return resultSpecialistQuiz;
    }(),

    getRandomColor: function getRandomColor(i) {

      var letter = i * 80;
      var color = 'rgb(' + letter + ',' + letter + ',' + letter + ')';

      return color;
    },
    fetchBarDatasetForChartFast: function fetchBarDatasetForChartFast() {
      var _this7 = this;

      var dataFast = [],
          max = 0;

      var fastData = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.results, function (item) {
        return item.quiz.id === 2;
      });

      __WEBPACK_IMPORTED_MODULE_12_lodash_forEach___default()(fastData, function (result, index) {

        var data = [],
            backgroundColor = null;
        var label = result.assignedQuizUnit.name;
        var labels = [];

        __WEBPACK_IMPORTED_MODULE_12_lodash_forEach___default()(result.resultTable.title, function (title, index) {

          max = max < result.resultTable.totalScore[index] ? result.resultTable.totalScore[index] : max;

          data.push({
            x: title,
            y: result.resultTable.totalScore[index]
          });
          labels.push(__WEBPACK_IMPORTED_MODULE_24_lodash_split___default()(title, '   '));
        });
        backgroundColor = _this7.getRandomColor(index);

        dataFast.push(new __WEBPACK_IMPORTED_MODULE_20__common_chart__["b" /* BarChartDataset */]({ data: data, label: label, labels: labels, backgroundColor: backgroundColor }));
      });

      this.maxFast = max ? max * 1.2 : 0;

      this.dataFast = dataFast;

      return dataFast;
    },
    fetchBarDatasetForChartMas: function fetchBarDatasetForChartMas() {
      var _this8 = this;

      var dataMas = [],
          max = 0;

      var masData = __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(this.results, function (item) {
        return item.quiz.id === 1;
      });

      __WEBPACK_IMPORTED_MODULE_12_lodash_forEach___default()(masData, function (result, index) {

        var data = [],
            backgroundColor = null;
        var label = result.assignedQuizUnit.name;
        var labels = [];

        __WEBPACK_IMPORTED_MODULE_12_lodash_forEach___default()(result.resultTable.titles[0], function (title, index) {

          max = max < result.resultTable.totalScore[6][index] ? result.resultTable.totalScore[6][index] : max;

          data.push({
            x: title,
            y: result.resultTable.totalScore[6][index]
          });
          labels.push(title);
        });
        backgroundColor = _this8.getRandomColor(index);

        dataMas.push(new __WEBPACK_IMPORTED_MODULE_20__common_chart__["b" /* BarChartDataset */]({ data: data, label: label, labels: labels, backgroundColor: backgroundColor }));
      });

      this.maxMas = max ? max * 1.2 : 0;
      this.dataMas = dataMas;

      return dataMas;
    }
  },
  watch: {
    rangeDateEnd: function rangeDateEnd() {
      this.isChange = false;
    },
    rangeDateStart: function rangeDateStart() {
      this.isChange = false;
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_differenceBy__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_differenceBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_differenceBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_trim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_uniqBy__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_autocompleteSearch_components_autocompleteSearch__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vee_validate__ = __webpack_require__(16);




var _this3 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'client': null,
    'quizId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    return {
      apiUrl: 'users/',
      quizList: [],
      quizType: null,
      quizTemplate: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      minDateStart: this.getMinDateStart(new Date()),
      specialists: [],
      specialistsIds: [],
      specialist: null,
      rangeDateSheduled: null,
      quiz: null,
      show: true,
      isLoaded: false,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      rangeTimeStart: {
        HH: null,
        mm: null
      },
      autocomplete: [],
      visible: true,
      targetBehaviour: null,
      isModalVisible: false,
      disableAfterSubmit: false,
      assignToClientList: [{
        "id": null,
        "name": ""
      }],
      assignedToClient: null,
      motivation: null,
      checkFowOwn: false,
      settingDescription: null
    };
  },


  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_19_vue2_timepicker___default.a, autocompleteSearch: __WEBPACK_IMPORTED_MODULE_20__common_autocompleteSearch_components_autocompleteSearch__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('auth', ['user'])),

  mounted: function mounted() {},

  provide: function provide() {
    return { parentValidator: this.$validator };
  },
  created: function created() {
    var _this = this;

    this.show = this.$route.name === 'quiz-show';
    this.getQuizInfo();
    __WEBPACK_IMPORTED_MODULE_21_vee_validate__["a" /* Validator */].extend('unique_client', {
      getMessage: function getMessage(attribute) {
        return __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get('validation.unique_client', { attribute: attribute });
      },
      validate: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(client) {
          var valid, unique;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = void 0;
                  unique = 0;


                  __WEBPACK_IMPORTED_MODULE_14_lodash_forIn___default()(_this.assignToClientList, function (item) {
                    if (__WEBPACK_IMPORTED_MODULE_15_lodash_trim___default()(item.name) === __WEBPACK_IMPORTED_MODULE_15_lodash_trim___default()(client)) {
                      unique++;
                    }
                  });

                  if (unique > 1) {
                    valid = false;
                  } else {
                    valid = true;
                  }

                  return _context.abrupt('return', { valid: valid });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function validate(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    });
  },


  methods: {
    onChangeSpecialists: function onChangeSpecialists(val) {
      this.specialist = val;
    },
    addAssignToClient: function addAssignToClient(item) {

      this.assignedToClient = null;
      this.assignToClientList.push({
        "id": null,
        "name": ""
      });
    },
    removeAssignedToClient: function removeAssignedToClient(client) {
      var clientIndex = __WEBPACK_IMPORTED_MODULE_18_lodash_findIndex___default()(this.assignToClientList, function (item) {
        return item.name === client.name;
      });

      if (clientIndex !== -1) {
        this.assignToClientList.splice(clientIndex, 1);
      }
    },
    onModalClose: function onModalClose() {
      this.$router.push({ name: 'quiz', params: { clientId: this.clientId } });
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
    },

    onSearchSpecialists: function onSearchSpecialists(search, loading) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading(true);
                _context2.next = 3;
                return _this2.searchSpecialists(search, _this2);

              case 3:
                _this2.searchText = search;
                loading(false);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    searchSpecialists: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(search, vm) {
        var response, specialistList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + vm.apiUrl + vm.clientId + '/specialists/quiz/?search=' + search);

              case 3:
                response = _context3.sent;
                specialistList = response.data.data;

                specialistList.unshift(vm.user);

                vm.specialists = __WEBPACK_IMPORTED_MODULE_7_lodash_differenceBy___default()(specialistList, vm.specialist, 'id');

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.error('Unknown API error occurred.');

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(), 350),

    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    getQuizInfo: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getQuizList();

              case 2:
                if (!this.quizId) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 5;
                return this.getQuiz().then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(response) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:

                            _this4.quiz = response.data.data;

                            _this4.quizType = _this4.quiz.quiz;
                            _this4.specialist = _this4.quiz.specialist;
                            _this4.assignToClientList = _this4.quiz.assignedUnits;
                            _this4.targetBehaviour = _this4.quiz.description;
                            _this4.settingDescription = _this4.quiz.settingDescription;

                            _this4.rangeDateSheduled = __WEBPACK_IMPORTED_MODULE_12_moment___default()(_this4.quiz.utcScheduledAt.date, 'YYYY-MM-DD')._d;
                            _this4.rangeTimeStart = {
                              HH: __WEBPACK_IMPORTED_MODULE_12_moment___default()(_this4.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm:ss').format('HH'),
                              mm: __WEBPACK_IMPORTED_MODULE_12_moment___default()(_this4.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm:ss').format('mm')
                            };

                          case 8:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }()).finally(function () {
                  _this4.isLoaded = true;
                });

              case 5:
                _context5.next = 11;
                break;

              case 7:
                this.quizType = this.quizList[0];
                this.rangeDateSheduled = new Date();
                this.rangeTimeStart = {
                  HH: __WEBPACK_IMPORTED_MODULE_12_moment___default()(new Date()).format('HH'),
                  mm: __WEBPACK_IMPORTED_MODULE_12_moment___default()(new Date()).format('mm')
                };
                this.isLoaded = true;

              case 11:
                _context5.next = 13;
                return this.getQuizTemplate(this.quizType.id).finally(function () {
                  _this4.isLoaded = true;
                });

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getQuizInfo() {
        return _ref3.apply(this, arguments);
      }

      return getQuizInfo;
    }(),

    getQuizList: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/');

              case 3:
                response = _context6.sent;


                this.quizList = response.data.data.items;

                return _context6.abrupt('return', response);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);

                console.dir(_context6.t0);
                //this.$router.push({name: 'default'});

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function getQuizList() {
        return _ref5.apply(this, arguments);
      }

      return getQuizList;
    }(),

    getQuizTemplate: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
        var _this5 = this;

        var response, quizTemplate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/' + id);

              case 2:
                response = _context7.sent;
                quizTemplate = response.data.data;


                __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(quizTemplate.generalQuestions, function (question) {

                  __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(question.items, function (item) {

                    if (_this5.quizId) {
                      var detailAnswer = __WEBPACK_IMPORTED_MODULE_16_lodash_filter___default()(_this5.quiz.quizCreatorGeneralAnswers, function (quizQuestion) {
                        return quizQuestion.generalQuestion.id === item.id;
                      });

                      if (item.isDetailedAnswer) {
                        if (+item.id === 1 && +_this5.quizType.id === 1 || +item.id === 7 && +_this5.quizType.id === 2) {
                          _this5.targetBehaviour = detailAnswer[0].detailedAnswer.toString();
                        }

                        item.detailedAnswer = detailAnswer[0].detailedAnswer.toString();
                      } else {
                        item.answerId = detailAnswer[0].generalAnswer.id.toString();
                      }
                    } else {
                      item.detailedAnswer = null;
                      item.answerId = item.generalQuestionAnswers.length ? item.generalQuestionAnswers[0].id.toString() : null;
                    }

                    item.questionId = item.id;
                  });
                });

                this.quizTemplate = quizTemplate;

                return _context7.abrupt('return', response);

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getQuizTemplate(_x5) {
        return _ref6.apply(this, arguments);
      }

      return getQuizTemplate;
    }(),

    getQuiz: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:

                this.isLoaded = false;

                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/assigned/' + this.quizId);

              case 3:
                response = _context8.sent;
                return _context8.abrupt('return', response);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getQuiz() {
        return _ref7.apply(this, arguments);
      }

      return getQuiz;
    }(),

    editQuiz: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var result, quizDate, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                this.errors.clear();

                _context9.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context9.sent;


                if (!this.targetBehaviour) {
                  this.errors.items.push({
                    "field": "targetBehaviour",
                    "msg": __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get("quiz.errorTargetValue"),
                    "rule": "required",
                    "scope": null
                  });
                }

                if (!(result && this.targetBehaviour)) {
                  _context9.next = 18;
                  break;
                }

                _context9.prev = 6;


                this.disableAfterSubmit = true;

                quizDate = new Date(Date.UTC(this.rangeDateSheduled.getFullYear(), this.rangeDateSheduled.getMonth(), this.rangeDateSheduled.getDate(), this.rangeTimeStart.HH, this.rangeTimeStart.mm));
                _context9.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('' + this.apiUrl + this.clientId + '/quiz/' + this.quizType.id + '/assign/' + this.quizId, {
                  "assignedUnits": this.assignToClientList,
                  "assignedSpecialistId": this.specialist.id,
                  "utcScheduledAt": __WEBPACK_IMPORTED_MODULE_12_moment___default()(quizDate).unix(),
                  "targetBehavior": this.targetBehaviour,
                  "settingDescription": this.settingDescription
                });

              case 11:
                response = _context9.sent;


                if (response) {
                  this.$router.push({ name: 'quiz', params: { clientId: this.clientId } });
                }

                _context9.next = 18;
                break;

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9['catch'](6);


                if (_context9.t0 && _context9.t0.data.code === 403) {
                  this.isModalVisible = true;
                }

              case 18:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[6, 15]]);
      }));

      function editQuiz() {
        return _ref8.apply(this, arguments);
      }

      return editQuiz;
    }(),

    createQuiz: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var result, quizDate, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:

                this.errors.clear();

                _context10.next = 3;
                return this.$validator.validateAll();

              case 3:
                result = _context10.sent;


                if (!this.targetBehaviour) {
                  this.errors.items.push({
                    "field": "targetBehaviour",
                    "msg": __WEBPACK_IMPORTED_MODULE_4__lang_translator__["a" /* default */].get("quiz.errorTargetValue"),
                    "rule": "required",
                    "scope": null
                  });
                }

                if (!(result && this.targetBehaviour)) {
                  _context10.next = 17;
                  break;
                }

                _context10.prev = 6;


                this.disableAfterSubmit = true;

                quizDate = new Date(Date.UTC(this.rangeDateSheduled.getFullYear(), this.rangeDateSheduled.getMonth(), this.rangeDateSheduled.getDate(), this.rangeTimeStart.HH, this.rangeTimeStart.mm));
                _context10.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('' + this.apiUrl + this.clientId + '/quiz/' + this.quizType.id + '/assign', {
                  "assignedUnits": this.assignToClientList,
                  "assignedSpecialistId": this.specialist.id,
                  "utcScheduledAt": __WEBPACK_IMPORTED_MODULE_12_moment___default()(quizDate).unix(),
                  "targetBehavior": this.targetBehaviour,
                  "settingDescription": this.settingDescription
                });

              case 11:
                response = _context10.sent;


                if (response) {
                  this.$router.push({ name: 'quiz', params: { clientId: this.clientId } });
                }

                _context10.next = 17;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10['catch'](6);

              case 17:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[6, 15]]);
      }));

      function createQuiz() {
        return _ref9.apply(this, arguments);
      }

      return createQuiz;
    }(),

    searchAutocomplete: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(search, vm) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(vm.apiUrl + vm.clientId + '/quiz/target-behavior/search' + '?search=' + search, { params: {
                    quizId: vm.quiz && vm.quiz.id ? vm.quiz.id : null
                  }
                });

              case 3:
                response = _context11.sent;

                vm.autocomplete = __WEBPACK_IMPORTED_MODULE_17_lodash_uniqBy___default()(response.data.data, 'name');

                _context11.next = 10;
                break;

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11['catch'](0);

                console.error('Unknown API error occurred.');

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this3, [[0, 7]]);
      }));

      return function (_x6, _x7) {
        return _ref10.apply(this, arguments);
      };
    }(), 250),

    setProblemBehaviourValue: function setProblemBehaviourValue(value) {
      this.targetBehaviour = value;
    },
    onChangeProblemBehaviour: function onChangeProblemBehaviour(search) {
      this.searchAutocomplete(search, this);
    },
    setProblemBehaviourValidated: function setProblemBehaviourValidated(text) {
      console.info(text);
      this.targetBehaviour = text;
      this.autocomplete = [];
    },
    validatedProblemBehaviour: function validatedProblemBehaviour(error) {
      this.errors.items.push(error.items[0]);
    }
  },
  watch: {
    quizType: function quizType(newVlaue, oldValue) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!oldValue) {
                  _context12.next = 5;
                  break;
                }

                _this6.isLoaded = false;
                _context12.next = 4;
                return _this6.getQuizTemplate(newVlaue.id);

              case 4:
                _this6.isLoaded = true;

              case 5:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this6);
      }))();
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_join__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_paginate__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_table_components_TableView__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vee_validate__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'clientId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    },
    'client': null,
    'quizId': {
      type: [Number, String],
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    return {
      apiUrl: 'users/',
      quizList: [],
      quizType: null,
      quizTemplate: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      minDateStart: this.getMinDateStart(new Date()),
      specialists: [],
      specialistsIds: [],
      specialist: null,
      rangeDateSheduled: null,
      rangeTimeStart: null,
      quiz: null,
      show: true,
      isLoaded: false,
      isModalVisible: false,
      disableAfterSubmit: false,
      quizSpecialist: null,
      quizSpecialistList: [],
      errorSpecialist: false,
      count: 1,
      afterValidate: false
    };
  },


  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_9__loader_components_Loader__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('auth', ['user']), {
    answersSocialInfluencesLength: function answersSocialInfluencesLength() {
      var questionsList = [];
      var answersSocialInfluencesLength = 0;

      if (this.quizType.id == 2) {
        questionsList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.quizTemplate.questions, function (questionsList, key) {
          return key === 'social_influences_on_behavior';
        })[0].items;
        answersSocialInfluencesLength = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(questionsList, function (item) {
          return item.answerId === "8";
        }).length;
      }

      return answersSocialInfluencesLength === questionsList.length;
    },
    disabledSave: function disabledSave() {
      var _this = this;

      var disableSaveButton = false;
      var questionLength = 0;
      var questionAnsweredLength = 0;
      if (this.quizTemplate) {

        __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(this.quizTemplate.questions, function (questionsList, key) {

          var answ = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(questionsList.items, function (item) {
            var answersQuiz = 0;
            if (item.type == 5) {

              answersQuiz = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.answers, function (answer) {
                if (answer.answerId) {
                  return answer.id;
                }
              }).length;

              if (_this.errorAnswer(item)) {
                questionAnsweredLength--;
              }
            }

            if (item.type == 6) {

              answersQuiz = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.additionalAnswers, function (answer) {
                if (answer.answerId) {
                  return answer.id;
                }
              }).length;

              if (_this.errorAnswer(item)) {
                questionAnsweredLength--;
              }
            }

            if (key == 'evaluator_information' && item.type == 4) {
              if (!item.detailedAnswer) {
                questionAnsweredLength--;
              }
            }

            return item.answerId || item.detailedAnswer || answersQuiz;
          });

          if (!(_this.answersSocialInfluencesLength && key === 'social_reinforcement')) {
            questionAnsweredLength += answ.length;
            questionLength += questionsList.items.length;
          }
        });
      }

      disableSaveButton = questionAnsweredLength < questionLength;

      return disableSaveButton;
    }
  }),

  mounted: function mounted() {},

  created: function created() {
    this.show = this.$route.name === 'quiz-show';
    this.getQuizInfo();
  },


  methods: {
    errorAnswer: function errorAnswer(list) {
      var errorDetail = false;

      var checkboxCount = [];
      if (list.type == 5) {
        checkboxCount = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(list.answers, function (answ) {
          return answ.answerId;
        }).length;
      } else {
        checkboxCount = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(list.additionalAnswers, function (answ) {
          return answ.answerId;
        }).length;
      }

      errorDetail = list.type == 5 ? !(!!checkboxCount || !!list.detailedAnswer) : !checkboxCount && list.answerId == 9;

      return errorDetail;
    },
    onChangeSpecialists: function onChangeSpecialists(val) {
      this.quizSpecialist = val;
      this.errorSpecialist = false;
    },
    onModalClose: function onModalClose() {
      this.$router.push({ name: 'quiz', params: { clientId: this.clientId } });
    },


    toLocaleDate: function toLocaleDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
    },

    getMinDateStart: function getMinDateStart(date) {
      var minDateStart = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
      return minDateStart;
    },

    getQuizInfo: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getQuizList();

              case 2:
                if (!this.quizId) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return this.getQuiz();

              case 6:
                response = _context.sent;


                this.quiz = response.data.data;

                this.quizType = this.quiz.quiz;

                _context.next = 11;
                return this.getQuizTemplate(response.data.data.quiz.id);

              case 11:

                this.quizSpecialistList = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(this.quiz.assignedUnits, function (item) {
                  return !item.passedAt;
                });

                this.rangeDateSheduled = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD')._d;
                this.rangeTimeStart = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.quiz.utcScheduledAt.date, 'YYYY-MM-DD HH:mm').format("HH:mm");

                this.isLoaded = true;

                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](3);

                this.isLoaded = true;

              case 20:
                _context.next = 25;
                break;

              case 22:
                this.quizType = this.quizList[0];
                _context.next = 25;
                return this.getQuizTemplate(this.quizType.id).finally(function () {
                  _this2.isLoaded = true;
                });

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 17]]);
      }));

      function getQuizInfo() {
        return _ref.apply(this, arguments);
      }

      return getQuizInfo;
    }(),

    getQuizList: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/');

              case 3:
                response = _context2.sent;


                this.quizList = response.data.data.items;

                return _context2.abrupt('return', response);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.dir(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getQuizList() {
        return _ref2.apply(this, arguments);
      }

      return getQuizList;
    }(),

    getQuizTemplate: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var response, quizTemplate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/' + id);

              case 2:
                response = _context3.sent;
                quizTemplate = response.data.data;


                __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(quizTemplate.questions, function (question) {

                  __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(question.items, function (item) {

                    if (item.type == 3 || item.type == 4 || item.type == 5) {
                      item.detailedAnswer = null;
                    } else {
                      item.answerId = null;
                    }
                  });
                });

                this.quizTemplate = quizTemplate;

                return _context3.abrupt('return', response);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getQuizTemplate(_x) {
        return _ref3.apply(this, arguments);
      }

      return getQuizTemplate;
    }(),

    getQuiz: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                this.isLoaded = false;

                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('' + this.apiUrl + this.clientId + '/quiz/assigned/' + this.quizId);

              case 3:
                response = _context4.sent;
                return _context4.abrupt('return', response);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getQuiz() {
        return _ref4.apply(this, arguments);
      }

      return getQuiz;
    }(),

    saveQuiz: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this3 = this;

        var result, answers, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (this.quizSpecialist) {
                  _context5.next = 5;
                  break;
                }

                this.errorSpecialist = true;
                setTimeout(function () {
                  _this3.$refs.quizSpecialist.$el.scrollIntoView({ behavior: 'smooth' });
                }, 50);

                return _context5.abrupt('return');

              case 5:

                this.afterValidate = true;
                result = true;

                if (!this.disabledSave) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 10;
                return this.$validator.validateAll();

              case 10:
                result = _context5.sent;
                return _context5.abrupt('return');

              case 12:
                if (!result) {
                  _context5.next = 20;
                  break;
                }

                this.disableAfterSubmit = true;

                answers = [];


                __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(this.quizTemplate.questions, function (question, keyList) {

                  __WEBPACK_IMPORTED_MODULE_13_lodash_forEach___default()(question.items, function (item) {

                    if (keyList == 'evaluator_information' && item.type == 4) {

                      answers.push({
                        questionId: item.id,
                        answerId: item.answerId ? +item.answerId : item.answerId,
                        detailedAnswer: item.detailedAnswer
                      });
                    } else if (item.type == 6) {
                      if (item.answerId == 9) {
                        var answersQuiz = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.additionalAnswers, function (answer) {
                          if (answer.answerId) {
                            return answer;
                          }
                        });

                        var answerIdList = __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(answersQuiz, function (itemMap) {
                          return itemMap.id;
                        });
                        answers.push({
                          questionId: item.id,
                          answerId: answersQuiz.length ? answerIdList : null,
                          detailedAnswer: item.detailedAnswer
                        });
                      } else {
                        answers.push({
                          questionId: item.id,
                          answerId: item.answerId ? +item.answerId : item.answerId,
                          detailedAnswer: item.detailedAnswer
                        });
                      }
                    } else if (item.type == 5) {

                      var _answersQuiz = __WEBPACK_IMPORTED_MODULE_14_lodash_filter___default()(item.answers, function (answer) {
                        if (answer.answerId) {
                          return answer.id;
                        }
                      });
                      var _answerIdList = __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(_answersQuiz, function (itemMap) {
                        return itemMap.id;
                      });
                      answers.push({
                        questionId: item.id,
                        answerId: _answersQuiz.length ? _answerIdList : null,
                        detailedAnswer: item.detailedAnswer
                      });
                    } else {
                      answers.push({
                        questionId: item.id,
                        answerId: item.answerId ? +item.answerId : item.answerId,
                        detailedAnswer: item.detailedAnswer
                      });
                    }
                  });
                });

                _context5.next = 18;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('' + this.apiUrl + this.clientId + '/quiz/assigned/' + this.quizId, {
                  answers: answers,
                  assignedUnitId: this.quizSpecialist.id
                });

              case 18:
                response = _context5.sent;


                if (response) {
                  this.$router.push({ name: 'quiz', params: { clientId: this.clientId } });
                }

              case 20:
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5['catch'](0);


                this.disableAfterSubmit = false;

                if (_context5.t0 && _context5.t0.data && _context5.t0.data.code === 403) {
                  this.isModalVisible = true;
                }

              case 26:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 22]]);
      }));

      function saveQuiz() {
        return _ref5.apply(this, arguments);
      }

      return saveQuiz;
    }()

  },
  watch: {
    quizType: function quizType(newVlaue, oldValue) {
      if (oldValue) {
        this.isLoaded = false;
        this.getQuizTemplate(newVlaue.id);
      }
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_auth_Events__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_mixins_isMobile__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_page_components_StaticPage__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang_components_Selector__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_timepicker__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_timepicker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_5__modules_loader_components_Loader__["a" /* default */], LanguageSelector: __WEBPACK_IMPORTED_MODULE_10__lang_components_Selector__["a" /* default */], VueTimepicker: __WEBPACK_IMPORTED_MODULE_12_vue2_timepicker___default.a },
  data: function data() {
    return {
      loaded: false,
      menus: null,
      openDrawListMenu: false,
      scrolled: false,
      dashboard: false,
      scrollY: 0,
      expired: 5,
      rangeDateStart: null, //new Date(),
      duration: null,
      rangeTimeStart: {
        HH: "",
        mm: ""
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY']
      },
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: new Date(),
      previousDateSession: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('dro/session', ['startTimer', 'clearSession']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('auth', ['setIsPreviousDateSession', 'setPreviousDate', 'setPreviousTime', 'setPreviousDuration']), {
    logout: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.previousDateSession = false;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__common_auth_Manager__["a" /* default */].unauthorize();

              case 3:
                this.$router.push({ name: 'login' });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logout() {
        return _ref.apply(this, arguments);
      }

      return logout;
    }(),
    openDrawer: function openDrawer() {
      this.openDrawListMenu = true;
    },
    closeDrawer: function closeDrawer() {
      this.openDrawListMenu = false;
    },
    handleScroll: function handleScroll() {
      this.scrollY = window.scrollY < 60 ? 60 - window.scrollY : 0;
      if (document.querySelector('#dashboard')) {
        document.querySelector('#dashboard').style = 'top:' + this.scrollY + 'px;';
      }
      this.scrolled = window.scrollY > 60;
    },
    subscribeAuthEvents: function subscribeAuthEvents() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__common_auth_Manager__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__common_auth_Events__["a" /* default */].AFTER_UNAUTHORIZE, function () {
        _this.clearSession();
        return true;
      });
    },
    subscribeUIEvents: function subscribeUIEvents() {
      var _this2 = this;

      this.initIsMobile();
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
        _this2.initIsMobile();
      }, 100));
      if (this.isMobile) {
        window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
          _this2.handleScroll();
        }, 10));
      }
    },
    fetchMenu: function fetchMenu() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get('/menus');

              case 2:
                _ref2 = _context2.sent;
                response = _ref2.data;

                _this3.menus = response.data;
                _this3.menus.forEach(function (menu) {
                  var name = void 0;
                  if (menu.page_slug === '/') {
                    name = 'default';
                  } else {
                    var slug = menu.page_slug.split('/').pop();
                    name = 'page_' + slug;
                    _this3.$router.addRoutes([{
                      path: menu.page_slug,
                      name: name,
                      component: __WEBPACK_IMPORTED_MODULE_9__modules_page_components_StaticPage__["a" /* default */],
                      props: true,
                      meta: { slug: slug }
                    }]);
                  }
                  _this3.$set(menu, 'name', name);
                });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    resumeDroTimer: function resumeDroTimer() {
      if (this.isIntervalStarted) {
        this.startTimer();
      }
    },
    changeNumber: function changeNumber(event) {
      if (event.shiftKey || !(event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode == 46 || event.keyCode == 8 || event.keyCode >= 35 && event.keyCode <= 40)) {
        event.preventDefault();
      }
    },
    pageForPreviousDateSession: function pageForPreviousDateSession() {
      if (!(this.route.name === 'client' || this.route.name === 'current-stage' || this.route.name === 'stage-list' || this.route.name === 'mand-stage-current' || this.route.name === 'chain-stage-current' || this.route.name === 'shaping-stage-current' || this.route.name === 'choose-stage' || this.route.name === 'mastering-stage' || this.route.name === 'rotation-stage' || this.route.name === 'fluency-stage' || this.route.name === 'maintain-stage' || this.route.name === 'choose-usd' || this.route.name === 'mastering-stage-usd' || this.route.name === 'maintain-stage-usd' || this.route.name === 'pecs-stage' || this.route.name === 'pecs-stage-without-discrimination' || this.route.name === 'pecs-with-discrimination-stage' || this.route.name === 'pecs-with-items-stage' || this.route.name === 'protocol-item' || this.route.name === 'client-edit' || this.route.name === 'results')) {

        //this.$router.push({name: 'client'});

      }
    }
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_mixins_isMobile__["a" /* isMobile */]],

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['isGuest', 'isBCBA', 'isClient', 'isCurator', 'isTherapist', 'canViewCurators', 'canViewTherapists', 'canViewClients', 'user', 'isMensurationForbidden', 'subscriptionDaysLeft', 'isSubscriptionExpiredSoon', 'isPreviousDateSession']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('mobile', ['isMobile']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])('dro/session', ['isSessionStarted', 'assignee', 'uuid', 'isIntervalEnable']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('dro/session', ['isIntervalStarted']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['route']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])('protocol', ['protocolVersion']), {

    userIdentifier: function userIdentifier() {
      if (this.user) {
        return this.isClient ? this.user.displayName : this.user.username;
      } else {
        return null;
      }
    },
    isScrolled: function isScrolled() {
      return !this.scrolled && this.isSessionStarted && this.isIntervalEnable;
    }

  }),
  metaInfo: {
    title: 'AutismTech'
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4.subscribeAuthEvents();
              _this4.subscribeUIEvents();
              _context3.next = 4;
              return _this4.fetchMenu();

            case 4:
              _this4.resumeDroTimer();
              _this4.loaded = true;

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },
  mounted: function mounted() {

    if (localStorage.isPreviousDateSession) {
      this.previousDateSession = !!localStorage.getItem('isPreviousDateSession');
      this.setIsPreviousDateSession(!!localStorage.isPreviousDateSession);
    }
  },

  watch: {
    previousDateSession: function previousDateSession(newPreviousDateSession) {
      if (!!newPreviousDateSession) {
        localStorage.setItem('isPreviousDateSession', newPreviousDateSession);
        this.pageForPreviousDateSession();

        if (this.rangeDateStart) {
          this.setPreviousDate(this.rangeDateStart);
        }

        if (this.rangeTimeStart) {
          this.setPreviousTime(this.rangeTimeStart);
        }
      } else {
        localStorage.removeItem('isPreviousDateSession');
      }

      this.setIsPreviousDateSession(newPreviousDateSession);
    },
    rangeDateStart: function rangeDateStart(newValue) {
      this.setPreviousDate(newValue);
    },
    rangeTimeStart: function rangeTimeStart(newValue) {
      this.setPreviousTime(newValue);
    },
    duration: function duration(newValue) {
      this.$validator.validate('duration');
      if (newValue <= 120) {
        this.setPreviousDuration(newValue);
      }
    },
    isMobile: function isMobile() {
      this.subscribeUIEvents();
    }
  }

});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_5__loader_components_Loader__["a" /* default */] },
  data: function data() {
    return {
      content: null,
      title: 'AutismTech',
      meta_description: null,
      meta_keywords: null,
      loaded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['route'])),
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{ name: 'description', content: this.meta_description }, { name: 'keywords', content: this.meta_keywords }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response, page, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/page/' + _this.route.meta.slug);

            case 2:
              response = _context.sent;
              page = response.data.data;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 7;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(page)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                key = _step.value;

                _this[key] = page[key];
              }
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 15:
              _context.prev = 15;
              _context.prev = 16;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 18:
              _context.prev = 18;

              if (!_didIteratorError) {
                _context.next = 21;
                break;
              }

              throw _iteratorError;

            case 21:
              return _context.finish(18);

            case 22:
              return _context.finish(15);

            case 23:
              _this.loaded = true;

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 11, 15, 23], [16,, 18, 22]]);
    }))();
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //selectedLang: '',
    };
  },

  computed: {
    langList: function langList() {

      var langLists = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AVAILABLE_LANGUAGES */], function (item) {
        return item.toString() === 'uk' ? 'ua' : item;
      });

      return langLists;
    },
    selectedLang: function selectedLang() {

      var selected = __WEBPACK_IMPORTED_MODULE_1__locale__["a" /* default */].toString() === 'uk' ? 'ua' : __WEBPACK_IMPORTED_MODULE_1__locale__["a" /* default */].toString();

      return selected;
    }
  },
  methods: {
    onChange: function onChange(language) {
      var setLang = language;

      if (language.toString() === 'ua') {
        setLang = 'uk';
      }

      if (setLang !== __WEBPACK_IMPORTED_MODULE_1__locale__["a" /* default */].toString()) {

        location.href = location.href.replace('/' + __WEBPACK_IMPORTED_MODULE_1__locale__["a" /* default */] + '/', '/' + setLang + '/');
      }
    }
  }
});

/***/ }),
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_vendor_scss__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_vendor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_vendor_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_main_scss__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_axios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dro_filters__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_meta__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lib_vue_touch_events__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_vue__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_mdc_adapter__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_calendar__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_filters__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tables_2__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__bootstrap_validator__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_v_tooltip__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_smooth_scroll__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue2_smooth_scroll__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__bootstrap_validator__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_5_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__filters__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__modules_dro_filters__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_mdc_adapter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_calendar___default.a);
Object(__WEBPACK_IMPORTED_MODULE_15__lang_filters__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_lib_vue_touch_events__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_tables_2__["ServerTable"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_tables_2__["ClientTable"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue2_smooth_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_v_tooltip__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    render: function (h) { return h(__WEBPACK_IMPORTED_MODULE_10__App_vue__["a" /* default */]); },
});


/***/ }),
/* 715 */,
/* 716 */,
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */,
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Manager__ = __webpack_require__(22);





/* harmony default export */ __webpack_exports__["a"] = (function (axios) {
    var _this = this;

    axios.interceptors.request.use(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(config) {
            var token;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3__Manager__["a" /* default */].getToken();

                        case 2:
                            token = _context.sent;

                            if (token) {
                                config.headers['Authorization'] = "Bearer " + token;
                            }
                            return _context.abrupt("return", config);

                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }(), function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
});;

/***/ }),
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wolfy87_eventemitter__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wolfy87_eventemitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_wolfy87_eventemitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(144);












var DEFAULT_TOKEN_KEY = 'abaAccessToken';
var DEFAULT_TOKEN_EXPIRATION_TIME_KEY = 'abaAccessTokenExpiresIn';
var DEFAULT_REFRESH_TOKEN_KEY = 'abaRefreshTokenKey';
var DEFAULT_USER_INFO_KEY = 'abaUserInfoKey';
var DEFAULT_USER_INFO_EXPIRES_IN_KEY = 'abaUserInfoExpiresIn';
var DEFAULT_USER_INFO_TTL = 1000 * 60 * 60 * 12;

var Storage = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Storage, _EventEmitter);

    function Storage() {
        var tokenKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TOKEN_KEY;
        var expiresInKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TOKEN_EXPIRATION_TIME_KEY;
        var refreshTokenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_REFRESH_TOKEN_KEY;
        var userInfoKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_USER_INFO_KEY;
        var userInfoExpiresInKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_USER_INFO_EXPIRES_IN_KEY;
        var ttl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : DEFAULT_USER_INFO_TTL;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Storage);

        var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Storage.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Storage)).call(this));

        _this.$storage = Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* createStorageDriver */])();
        _this.$tokenKey = tokenKey;
        _this.$expiresInKey = expiresInKey;
        _this.$refreshTokenKey = refreshTokenKey;
        _this.$userInfoKey = userInfoKey;
        _this.$userInfoExpiresInKey = userInfoExpiresInKey;
        _this.$ttl = ttl;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Storage, [{
        key: 'setToken',
        value: function setToken(accessToken, expiresIn) {
            var refreshToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            this.removeToken();
            this.$storage.set(this.$tokenKey, accessToken);
            this.$storage.set(this.$expiresInKey, expiresIn);
            if (refreshToken) {
                this.$storage.set(this.$refreshTokenKey, refreshToken);
            }
        }
    }, {
        key: 'removeToken',
        value: function removeToken() {
            var onlyAccessToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.$storage.remove(this.$tokenKey);
            this.$storage.remove(this.$expiresInKey);
            this.$storage.remove(this.$userInfoKey);
            if (!onlyAccessToken) {
                this.$storage.remove(this.$refreshTokenKey);
            }
        }
    }, {
        key: 'isTokenExpired',
        value: function isTokenExpired() {
            var now = new Date().getTime();
            var expiresIn = parseInt(this.getExpiresIn());
            if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(expiresIn)) {
                return true;
            }
            return now >= expiresIn;
        }
    }, {
        key: 'getToken',
        value: function getToken() {
            return this.$storage.get(this.$tokenKey);
        }
    }, {
        key: 'getExpiresIn',
        value: function getExpiresIn() {
            return this.$storage.get(this.$expiresInKey);
        }
    }, {
        key: 'getRefreshToken',
        value: function getRefreshToken() {
            return this.$storage.get(this.$refreshTokenKey);
        }
    }, {
        key: 'getUserInfo',
        value: function getUserInfo() {
            if (this.ifUserInfoExpired()) {
                this.emit(__WEBPACK_IMPORTED_MODULE_9__Events__["a" /* default */].USER_INFO_EXPIRED);
            }

            var info = this.$storage.get(this.$userInfoKey) || null;
            if (info) {
                return JSON.parse(info);
            } else {
                return null;
            }
        }
    }, {
        key: 'setUserInfo',
        value: function setUserInfo(info) {
            this.setUserInfoExpiresIn();
            return this.$storage.set(this.$userInfoKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
        }
    }, {
        key: 'ifUserInfoExpired',
        value: function ifUserInfoExpired() {
            return this.getUserInfoExpiresIn() !== null && this.getUserInfoExpiresIn() < new Date().getTime();
        }
    }, {
        key: 'setUserInfoExpiresIn',
        value: function setUserInfoExpiresIn() {
            var expiresIn = new Date().getTime() + this.$ttl;
            return this.$storage.set(this.$userInfoExpiresInKey, expiresIn);
        }
    }, {
        key: 'getUserInfoExpiresIn',
        value: function getUserInfoExpiresIn() {
            return this.$storage.get(this.$userInfoExpiresInKey);
        }
    }, {
        key: 'clear',
        value: function clear() {
            return this.$storage.clear();
        }
    }]);

    return Storage;
}(__WEBPACK_IMPORTED_MODULE_8_wolfy87_eventemitter___default.a);

/* harmony default export */ __webpack_exports__["a"] = (Storage);

/***/ }),
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStorageDriver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drivers_LocalStorage__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers_PlainObject__ = __webpack_require__(788);
// In FF4, if disabled, window.localStorage should === null.

// Normally, we could not test that directly and need to do a
//   `('localStorage' in window) && ` test first because otherwise Firefox will
//   throw bugzil.la/365772 if cookies are disabled

// Also in iOS5 & Safari Private Browsing mode, attempting to use localStorage.setItem
// will throw the exception:
//   QUOTA_EXCEEDED_ERRROR DOM Exception 22.
// Peculiarly, getItem and removeItem calls do not throw.

// Because we are forced to try/catch this, we'll go aggressive.

// Just FWIW: IE8 Compat mode supports these features completely:
//   www.quirksmode.org/dom/html5.html
// But IE8 doesn't support either with local files
var isLocalStorageSupported = function isLocalStorageSupported() {
    var mod = 'modernizr';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch (e) {
        return false;
    }
};




var createStorageDriver = function createStorageDriver() {
    if (isLocalStorageSupported()) {
        return new __WEBPACK_IMPORTED_MODULE_0__drivers_LocalStorage__["a" /* default */]();
    } else {
        return new __WEBPACK_IMPORTED_MODULE_1__drivers_PlainObject__["a" /* default */]();
    }
};

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interface__ = __webpack_require__(277);







var LocalStorage = function (_Interface) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LocalStorage, _Interface);

    function LocalStorage() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LocalStorage);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LocalStorage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LocalStorage)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LocalStorage, [{
        key: 'get',
        value: function get(key) {
            return localStorage.getItem(key) || null;
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            return localStorage.setItem(key, value);
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            return localStorage.removeItem(key);
        }
    }, {
        key: 'clear',
        value: function clear() {
            return localStorage.clear();
        }
    }]);

    return LocalStorage;
}(__WEBPACK_IMPORTED_MODULE_5__Interface__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LocalStorage);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interface__ = __webpack_require__(277);







var PlainObject = function (_Interface) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PlainObject, _Interface);

    function PlainObject() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PlainObject);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlainObject.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PlainObject)).call(this));

        _this.storage = {};
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PlainObject, [{
        key: 'get',
        value: function get(key) {
            return this.storage[key] || null;
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.storage[key] = value;
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            delete this.storage[key];
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.storage = {};
        }
    }]);

    return PlainObject;
}(__WEBPACK_IMPORTED_MODULE_5__Interface__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PlainObject);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clone__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_interceptors_LanguageHeader__ = __webpack_require__(302);









var TOKEN_URL = 'oauth/token';
var SCOPE = '';
var APP_GRANT_TYPE = 'client_credentials';
var USER_GRANT_TYPE = 'password';
var REFRESH_GRANT_TYPE = 'refresh_token';
var CLIENT_ID = "2";
var DATAPICKER = "false";
var CLIENT_SECRET = "WJ1tRKlkDUGfaegntnqm64QeYNE0Ng3fK2Ol84yU";

var DEFAULT_DATA = {
  scope: SCOPE,
  client_id: CLIENT_ID,
  client_secret: CLIENT_SECRET,
  datapicker: DATAPICKER
};

var Manager = function () {
  function Manager() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
      baseURL: "https://app.autismtech.online/api"
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__lang_interceptors_LanguageHeader__["a" /* default */])(http);
    this.$http = http;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'makeRequest',
    value: function makeRequest() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.$http.post(TOKEN_URL, __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_clone___default()(DEFAULT_DATA), params));
    }
  }, {
    key: 'getAppToken',
    value: function getAppToken() {
      return this.makeRequest({ grant_type: APP_GRANT_TYPE });
    }
  }, {
    key: 'getUserToken',
    value: function getUserToken(_ref) {
      var username = _ref.username,
          password = _ref.password;

      return this.makeRequest({
        grant_type: USER_GRANT_TYPE,
        username: username,
        password: password
      });
    }
  }, {
    key: 'refresh',
    value: function refresh(refreshToken) {
      return this.makeRequest({
        grant_type: REFRESH_GRANT_TYPE,
        refresh_token: refreshToken
      });
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiClient__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(216);







var Manager = function () {
    function Manager() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Manager);

        this.$api = new __WEBPACK_IMPORTED_MODULE_4__ApiClient__["a" /* default */]();
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Manager, [{
        key: "setUser",
        value: function setUser(user) {
            __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('auth/setUser', user);
        }
    }, {
        key: "getUser",
        value: function getUser() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.user;
        }
    }, {
        key: "initUser",
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response, user;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this.$api.getUserInfo();

                            case 3:
                                response = _context.sent;
                                user = response.data.data;

                                this.setUser(user);
                                return _context.abrupt("return", user);

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                console.log(_context.t0);
                                throw _context.t0;

                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9]]);
            }));

            function initUser() {
                return _ref.apply(this, arguments);
            }

            return initUser;
        }()
    }, {
        key: "flush",
        value: function flush() {
            this.setUser(null);
        }
    }, {
        key: "isBCBA",
        value: function isBCBA() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isBCBA'];
        }
    }, {
        key: "isCurator",
        value: function isCurator() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isCurator'];
        }
    }, {
        key: "isTherapist",
        value: function isTherapist() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isTherapist'];
        }
    }, {
        key: "isClient",
        value: function isClient() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isClient'];
        }
    }, {
        key: "isMensurationForbidden",
        value: function isMensurationForbidden() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isMensurationForbidden'];
        }
    }, {
        key: "isSubscriptionExpiredSoon",
        value: function isSubscriptionExpiredSoon() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/isSubscriptionExpiredSoon'];
        }
    }, {
        key: "subscriptionDaysLeft",
        value: function subscriptionDaysLeft() {
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['auth/subscriptionDaysLeft'];
        }
    }, {
        key: "can",
        value: function can(name) {
            name = 'auth/can' + name.split('_').map(function (word) {
                var f = word.charAt(0).toUpperCase();
                return f + word.substr(1, word.length - 1);
            }).join('');

            // todo: maybe need to check, that it is function
            if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters[name] === undefined) {
                throw new Error("Getter " + name + " is not defined");
            }
            return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters[name];
        }
    }]);

    return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_axios__ = __webpack_require__(139);




var ApiClient = function () {
    function ApiClient() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ApiClient);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ApiClient, [{
        key: "getUserInfo",
        value: function getUserInfo() {
            return __WEBPACK_IMPORTED_MODULE_2__config_axios__["a" /* default */].get('auth/user-info');
        }
    }]);

    return ApiClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (ApiClient);

/***/ }),
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_Storage__ = __webpack_require__(861);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__["a" /* default */])({
    paths: [
        'dro.session',
    ],
    storage: __WEBPACK_IMPORTED_MODULE_1__storage_Storage__["a" /* default */]
}));


/***/ }),
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StorageItem__ = __webpack_require__(862);

var TTL = 3600 * 1000;
/* harmony default export */ __webpack_exports__["a"] = (new /** @class */ (function () {
    function TtlLocalStorage() {
        this.ttl = TTL;
        if (!this.isLocalStorageSupported()) {
            throw new Error('Your environment doesn\'t support local storage');
        }
        this.storage = localStorage;
    }
    TtlLocalStorage.prototype.getItem = function (key) {
        var data = this.storage.getItem(key);
        if (data !== null) {
            var item = __WEBPACK_IMPORTED_MODULE_0__StorageItem__["a" /* default */].fromString(data);
            if (!item.isExpired()) {
                return item.getValue();
            }
            this.removeItem(key);
        }
        return null;
    };
    TtlLocalStorage.prototype.setItem = function (key, value) {
        var item = new __WEBPACK_IMPORTED_MODULE_0__StorageItem__["a" /* default */](value, this.getExpiresAt());
        this.storage.setItem(key, item.serialize());
    };
    TtlLocalStorage.prototype.removeItem = function (key) {
        this.storage.removeItem(key);
    };
    TtlLocalStorage.prototype.clear = function () {
        this.storage.clear();
    };
    TtlLocalStorage.prototype.getExpiresAt = function () {
        return (new Date()).getTime() + this.ttl;
    };
    TtlLocalStorage.prototype.isLocalStorageSupported = function () {
        var mod = 'modernizr';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    return TtlLocalStorage;
}()));


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var StorageItem = /** @class */ (function () {
    function StorageItem(value, expiresAt) {
        this.value = value;
        this.expiresAt = expiresAt || null;
    }
    StorageItem.fromString = function (data) {
        var _a = JSON.parse(data), value = _a.value, expiresAt = _a.expiresAt;
        return new StorageItem(value, expiresAt);
    };
    StorageItem.prototype.serialize = function () {
        return JSON.stringify({
            value: this.value,
            expiresAt: this.expiresAt
        });
    };
    StorageItem.prototype.isExpired = function () {
        return this.expiresAt !== null && this.expiresAt < (new Date()).getTime();
    };
    StorageItem.prototype.getValue = function () {
        return this.value;
    };
    return StorageItem;
}());
/* harmony default export */ __webpack_exports__["a"] = (StorageItem);


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(893);





var module = {
    namespaced: true,
    state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    authorizationType: null,
    isPreviousDateSession: false,
    previousDate: null,
    previousTime: null,
    previousDuration: null,
    user: null,
    clientId: null
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_includes__);







var is = function is(state, role) {
  var user = state.user;
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default()(user) && __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(user.roles) && __WEBPACK_IMPORTED_MODULE_5_lodash_includes___default()(user.roles, role);
};

var can = function can(state, name) {
  var entityType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var onlyOwned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var user = state.user;
  var criteria = {
    name: name
  };
  if (entityType) {
    criteria['entityType'] = entityType;
  }
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean___default()(onlyOwned)) {
    criteria['onlyOwned'] = onlyOwned;
  }
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default()(user) && __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(user.abilities) && __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(user.abilities, criteria));
};
var _subscriptionDaysLeft = function _subscriptionDaysLeft(state) {
  if (!state.user) return null;

  var user = state.user;
  var subscriptionEndDate = user.subscriptionEndDate;
  if (subscriptionEndDate === null) {
    return null;
  }

  var now = new Date().getTime();
  var days = Math.floor((subscriptionEndDate * 1000 - now) / (1000 * 60 * 60 * 24));
  return days;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  isAuthorized: function isAuthorized(state) {
    return state.authorizationType !== __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UNAUTHORIZED */];
  },
  isGuest: function isGuest(state) {
    return state.authorizationType !== __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AUTHORIZED_AS_USER */];
  },
  isBCBA: function isBCBA(state) {
    return is(state, __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ROLE_BCBA */]) || is(state, __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* ROLE_INDEPENDENT_CURATOR */]);
  },
  isCurator: function isCurator(state) {
    return is(state, __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ROLE_CURATOR */]);
  },
  isTherapist: function isTherapist(state) {
    return is(state, __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* ROLE_THERAPIST */]);
  },
  isClient: function isClient(state) {
    return is(state, __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* ROLE_CLIENT */]);
  },
  isPreviousDateSession: function isPreviousDateSession(state) {
    return state.isPreviousDateSession;
  },
  previousDate: function previousDate(state) {
    return state.previousDate;
  },
  previousTime: function previousTime(state) {
    return state.previousTime;
  },
  previousDuration: function previousDuration(state) {
    return state.previousDuration;
  },
  isMensurationForbidden: function isMensurationForbidden(state) {
    return state.user ? state.user.isMensurationForbidden : false;
  },
  isSubscriptionExpiredSoon: function isSubscriptionExpiredSoon(state) {
    var daysLeft = _subscriptionDaysLeft(state);
    return daysLeft !== null && daysLeft <= __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SUBSCRIPTION_MIN_DAYS_LEFT_FOR_WARNING */];
  },
  subscriptionDaysLeft: function subscriptionDaysLeft(state) {
    return _subscriptionDaysLeft(state);
  },
  canViewCurators: function canViewCurators(state) {
    return can(state, 'view_curators');
  },
  canViewCurator: function canViewCurator(state) {
    return can(state, 'view_curator');
  },
  canViewTherapists: function canViewTherapists(state) {
    return can(state, 'view_therapists');
  },
  canViewTherapist: function canViewTherapist(state) {
    return can(state, 'view_therapist');
  },
  canViewClients: function canViewClients(state) {
    return can(state, 'view_clients');
  },
  canViewClient: function canViewClient(state) {
    return can(state, 'view_client');
  },
  canCreateCurator: function canCreateCurator(state) {
    return can(state, 'create_curator');
  },
  canUpdateCurator: function canUpdateCurator(state) {
    return can(state, 'update_curator');
  },
  canDeleteCurator: function canDeleteCurator(state) {
    return can(state, 'delete_curator');
  },
  canCreateTherapist: function canCreateTherapist(state) {
    return can(state, 'create_therapist');
  },
  canUpdateTherapist: function canUpdateTherapist(state) {
    return can(state, 'update_therapist');
  },
  canDeleteTherapist: function canDeleteTherapist(state) {
    return can(state, 'delete_therapist');
  },
  canCreateClient: function canCreateClient(state) {
    return can(state, 'create_client');
  },
  canUpdateClient: function canUpdateClient(state) {
    return can(state, 'update_client');
  },
  canDeleteClient: function canDeleteClient(state) {
    return can(state, 'delete_client');
  },
  canStatisticReportListView: function canStatisticReportListView(state) {
    return can(state, 'statistic_report_list_view');
  },
  user: function user(state) {
    return state.user;
  },
  clientId: function clientId(state) {
    return state;
  }
});

/***/ }),
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setAuthorizationType: function setAuthorizationType(_ref, type) {
    var commit = _ref.commit;

    commit('setAuthorizationType', type);
  },
  setIsPreviousDateSession: function setIsPreviousDateSession(_ref2, isPreviousDateSession) {
    var commit = _ref2.commit;

    commit('setIsPreviousDateSession', isPreviousDateSession);
  },
  setPreviousDate: function setPreviousDate(_ref3, previousDate) {
    var commit = _ref3.commit;

    console.info(previousDate);
    commit('setPreviousDate', previousDate);
  },
  setPreviousTime: function setPreviousTime(_ref4, previousTime) {
    var commit = _ref4.commit;

    commit('setPreviousTime', previousTime);
  },
  setPreviousDuration: function setPreviousDuration(_ref5, previousDuration) {
    var commit = _ref5.commit;

    commit('setPreviousDuration', previousDuration);
  },
  setUser: function setUser(_ref6, user) {
    var commit = _ref6.commit;

    commit('setUser', user);
  },
  setClientId: function setClientId(_ref7, clientId) {
    var commit = _ref7.commit;

    commit('setClientId', clientId);
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setAuthorizationType: function setAuthorizationType(state, type) {
    state.authorizationType = type;
  },
  setIsPreviousDateSession: function setIsPreviousDateSession(state, isPreviousDateSession) {
    state.isPreviousDateSession = isPreviousDateSession;
  },
  setPreviousDate: function setPreviousDate(state, previousDate) {
    state.previousDate = previousDate;
  },
  setPreviousTime: function setPreviousTime(state, previousTime) {
    state.previousTime = previousTime;
  },
  setPreviousDuration: function setPreviousDuration(state, previousDuration) {
    state.previousDuration = previousDuration;
  },
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setClientId: function setClientId(state, clientId) {
    state.clientId = clientId;
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(898);






var Mobile = function Mobile() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mobile);

  this.namespaced = true;
  this.state = Object(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */])();
  this.getters = __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */];
  this.actions = __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */];
  this.mutations = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */];
};

/* harmony default export */ __webpack_exports__["a"] = (Mobile);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    isMobile: false
  };
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  isMobile: function isMobile(state) {
    return state.isMobile;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var actions = {
  setIsMobile: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, isMobile) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('setIsMobile', isMobile);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function setIsMobile(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return setIsMobile;
  }()

};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
  setIsMobile: function setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_curator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_therapist__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_index__ = __webpack_require__(903);






var curator = new __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__api_curator__["a" /* default */]);
var therapist = new __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__api_therapist__["a" /* default */]);
var client = new __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  curator: {
    namespaced: true,
    modules: {
      repository: curator
    }
  },
  therapist: {
    namespaced: true,
    modules: {
      repository: therapist
    }
  },
  client: {
    namespaced: true,
    modules: {
      repository: client
    }
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseApiManager__ = __webpack_require__(102);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Curator API Manager.
 */
var CuratorApiManager = /** @class */ (function (_super) {
    __extends(CuratorApiManager, _super);
    function CuratorApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create entity.
     *
     * @param {String} username
     * @param {String} displayName
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    CuratorApiManager.prototype.create = function (_a) {
        var username = _a.username, displayName = _a.displayName, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axios.post("" + this.url, {
                            username: username,
                            displayName: displayName,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Update entity.
     *
     * @param {Number} id
     * @param {String} username
     * @param {String} displayName
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    CuratorApiManager.prototype.update = function (_a) {
        var id = _a.id, username = _a.username, displayName = _a.displayName, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axios.put(this.url + "/" + id, {
                            username: username,
                            displayName: displayName,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Check access to client.
     *
     * @param {Number} curatorId
     * @returns {Promise<AxiosPromise<any>>}
     */
    CuratorApiManager.prototype.hasAccess = function (curatorId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.axios.get(this.url + "/" + curatorId + "/access")];
            });
        });
    };
    return CuratorApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (CuratorApiManager);


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseApiManager__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_axios__ = __webpack_require__(139);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * Therapist API Manager.
 */
var TherapistApiManager = /** @class */ (function (_super) {
    __extends(TherapistApiManager, _super);
    function TherapistApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create entity.
     *
     * @param {String} username
     * @param {String} displayName
     * @param {Array<integer>} curatorIds
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    TherapistApiManager.prototype.create = function (_a) {
        var username = _a.username, displayName = _a.displayName, curatorIds = _a.curatorIds, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__config_axios__["a" /* default */].post("" + this.url, {
                            username: username,
                            displayName: displayName,
                            curatorIds: curatorIds,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Add clients to therapist.
     *
     * @param {Number} therapistId
     * @param {Array} clientIds
     * @returns {Promise<any>}
     */
    TherapistApiManager.prototype.addClients = function (_a) {
        var therapistId = _a.therapistId, clientIds = _a.clientIds;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__config_axios__["a" /* default */].post(this.url + "/" + therapistId + "/clients", {
                            clientIds: clientIds,
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Update entity.
     *
     * @param {Number} id
     * @param {String} username
     * @param {String} displayName
     * @param {Array<integer>} curatorIds
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    TherapistApiManager.prototype.update = function (_a) {
        var id = _a.id, username = _a.username, displayName = _a.displayName, curatorIds = _a.curatorIds, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__config_axios__["a" /* default */].put(this.url + "/" + id, {
                            username: username,
                            displayName: displayName,
                            curatorIds: curatorIds,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Paginate all entities.
     *
     * @param {Number} therapistId
     * @param {Number} perPage
     * @param {Number} page
     * @param {String} sort
     * @param {String} search
     * @param {Boolean} isOwn
     * @returns {Promise<any>}
     */
    TherapistApiManager.prototype.paginateAllClientsByTherapistId = function (_a) {
        var therapistId = _a.therapistId, _b = _a.perPage, perPage = _b === void 0 ? 5 : _b, _c = _a.page, page = _c === void 0 ? 1 : _c, sort = _a.sort, search = _a.search, isOwn = _a.isOwn;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__config_axios__["a" /* default */].get(this.url + "/" + therapistId + "/clients/" + perPage + "/" + page, {
                            params: {
                                sort: sort,
                                search: search,
                                isOwn: isOwn,
                            },
                        })];
                    case 1: return [2 /*return*/, _d.sent()];
                }
            });
        });
    };
    /**
     * Delete Client form Therapist.
     *
     * @param {Number} therapistId
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    TherapistApiManager.prototype.deleteClient = function (therapistId, clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__config_axios__["a" /* default */].delete(this.url + "/" + therapistId + "/clients/" + clientId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Check access to client.
     *
     * @param {Number} therapistId
     * @returns {Promise<AxiosPromise<any>>}
     */
    TherapistApiManager.prototype.hasAccess = function (therapistId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.axios.get(this.url + "/" + therapistId + "/access")];
            });
        });
    };
    return TherapistApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (TherapistApiManager);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseApiManager__ = __webpack_require__(102);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Client API Manager.
 */
var ClientApiManager = /** @class */ (function (_super) {
    __extends(ClientApiManager, _super);
    function ClientApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Crate entity.
     *
     * @param {String} code
     * @param {String} username
     * @param {String} displayName
     * @param {Number} clinicalCenterId
     * @param {Array<integer>} therapistIds
     * @param {String} timezone
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    ClientApiManager.prototype.create = function (_a) {
        var code = _a.code, username = _a.username, displayName = _a.displayName, clinicalCenterId = _a.clinicalCenterId, therapistIds = _a.therapistIds, timezone = _a.timezone, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axios.post("" + this.url, {
                            code: code,
                            username: username,
                            displayName: displayName,
                            clinicalCenterId: clinicalCenterId,
                            therapistIds: therapistIds,
                            timezone: timezone,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Update entity.
     *
     * @param {Number} id
     * @param {String} code
     * @param {String} username
     * @param {String} displayName
     * @param {Number} clinicalCenterId
     * @param {Array<integer>} therapistIds
     * @param {String} timezone
     * @param {String} password
     * @param {String} passwordConfirmation
     *
     * @returns {Promise<any>}
     */
    ClientApiManager.prototype.update = function (_a) {
        var id = _a.id, code = _a.code, username = _a.username, displayName = _a.displayName, clinicalCenterId = _a.clinicalCenterId, therapistIds = _a.therapistIds, timezone = _a.timezone, password = _a.password, passwordConfirmation = _a.passwordConfirmation;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axios.put(this.url + "/" + id, {
                            code: code,
                            username: username,
                            displayName: displayName,
                            clinicalCenterId: clinicalCenterId,
                            therapistIds: therapistIds,
                            timezone: timezone,
                            password: password,
                            passwordConfirmation: passwordConfirmation
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Check access to client.
     *
     * @param {Number} clientId
     * @returns {Promise<AxiosPromise<any>>}
     */
    ClientApiManager.prototype.hasAccess = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.axios.get(this.url + "/" + clientId + "/access")];
            });
        });
    };
    return ClientApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ClientApiManager);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(909);






var Repository = function Repository(apiManager) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Repository);

    this.namespaced = true;
    this.state = Object(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */])();
    this.getters = __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */];
    this.actions = __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */];
    this.mutations = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */];

    this.state.apiManager = apiManager;
};

/* harmony default export */ __webpack_exports__["a"] = (Repository);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    apiManager: {},

    items: [],
    page: 0,
    pageCount: 0,
    perPage: 0,
    total: 0,
    hasMorePages: false,
    isLoaded: false,
    isChanged: false,
    timezones: null,
    validationError: null
  };
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  items: function items(state) {
    return state.items;
  },
  page: function page(state) {
    return state.page;
  },
  pageCount: function pageCount(state) {
    return state.pageCount;
  },
  total: function total(state) {
    return state.total;
  },
  hasMorePages: function hasMorePages(state) {
    return state.hasMorePages;
  },
  isLoaded: function isLoaded(state) {
    return state.isLoaded;
  },
  isChanged: function isChanged(state) {
    return state.isChanged;
  },
  validationError: function validationError(state) {
    return state.validationError;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_timezone__ = __webpack_require__(907);




var actions = {
  getItems: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, _ref3) {
      var state = _ref2.state,
          commit = _ref2.commit;
      var perPage = _ref3.perPage,
          page = _ref3.page,
          sort = _ref3.sort,
          search = _ref3.search;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('setIsLoaded', false);

              _context.next = 4;
              return state.apiManager.paginateAll(perPage, page, sort, search);

            case 4:
              response = _context.sent;
              data = response.data.data;


              commit('setItems', data.items);
              commit('setPage', data.currentPage);
              commit('setPageCount', data.lastPage);
              commit('setPerPage', data.perPage);
              commit('setTotal', data.total);
              commit('setHasMorePages', data.hasMorePages);
              commit('setIsLoaded', true);
              return _context.abrupt('return', data);

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](0);
              response = _context.t0.response;

              console.error(response);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 16]]);
    }));

    function getItems(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return getItems;
  }(),
  deleteItemById: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6, _ref7) {
      var state = _ref6.state,
          commit = _ref6.commit;
      var id = _ref7.id;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit('setIsLoaded', false);

              _context2.next = 4;
              return state.apiManager.deleteById(id);

            case 4:
              response = _context2.sent;


              commit('deleteItemById', id);

              if (state.items.length === 0 && state.page - 1 > 0) {
                commit('setPage', state.page - 1);
                commit('setPageCount', state.pageCount - 1);
              }

              commit('setIsLoaded', true);

              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);
              response = _context2.t0.response;

              console.error(response.status);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    function deleteItemById(_x3, _x4) {
      return _ref5.apply(this, arguments);
    }

    return deleteItemById;
  }(),
  addItem: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref10, object) {
      var state = _ref10.state,
          commit = _ref10.commit,
          dispatch = _ref10.dispatch;
      var firstPage, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('setIsLoaded', false);
              commit('setIsChanged', false);
              commit('setValidationError', null);

              firstPage = 1;
              _context3.next = 7;
              return state.apiManager.create(object);

            case 7:
              response = _context3.sent;


              if (state.page === firstPage) {
                if (state.items.length + 1 > state.perPage) {
                  commit('removeLastItem');
                }

                commit('addItem', response.data.data);

                if ((state.total + 1) / state.perPage > state.pageCount) {
                  commit('setPageCount', state.pageCount + 1);
                }

                commit('setTotal', state.total + 1);
                commit('setIsLoaded', true);
              } else {
                dispatch('getItems', { perPage: state.perPage, page: firstPage });
              }
              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              commit('setValidationError', _context3.t0.data.errors);

            case 15:
              _context3.prev = 15;

              if (!state.validationError) {
                commit('setIsChanged', true);
              }
              return _context3.finish(15);

            case 18:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11, 15, 18]]);
    }));

    function addItem(_x5, _x6) {
      return _ref9.apply(this, arguments);
    }

    return addItem;
  }(),
  editItem: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref12, object) {
      var state = _ref12.state,
          commit = _ref12.commit;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commit('setIsLoaded', false);
              commit('setIsChanged', false);
              _context4.next = 5;
              return state.apiManager.update(object);

            case 5:
              response = _context4.sent;

              commit('editItem', response.data.data);
              commit('setIsLoaded', true);
              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);

              console.info(_context4.t0);
              console.error(_context4.t0.response.status);

            case 14:
              _context4.prev = 14;

              commit('setIsChanged', true);
              return _context4.finish(14);

            case 17:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 10, 14, 17]]);
    }));

    function editItem(_x7, _x8) {
      return _ref11.apply(this, arguments);
    }

    return editItem;
  }(),
  loadTimezones: function () {
    var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref14) {
      var commit = _ref14.commit;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__api_timezone__["a" /* default */].get();

            case 3:
              response = _context5.sent;

              commit('setTimezones', response.data.data);
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.info(_context5.t0);
              console.error(_context5.t0.response.status);

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 7]]);
    }));

    function loadTimezones(_x9) {
      return _ref13.apply(this, arguments);
    }

    return loadTimezones;
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managers_TimezoneApiManager__ = __webpack_require__(908);



var BASE_URL = "https://app.autismtech.online/api" + '/timezones';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__managers_TimezoneApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_axios___default.a, '' + BASE_URL));

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Timezone API Manager.
 */
var TimezoneApiManager = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param {String} url
     */
    function TimezoneApiManager(axios, url) {
        this.url = url;
        this.axios = axios;
    }
    /**
     * @returns {Promise<void>}
     */
    TimezoneApiManager.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("" + this.url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TimezoneApiManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (TimezoneApiManager);


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);


var mutations = {
  setItems: function setItems(state, clients) {
    state.items = clients;
  },
  setPage: function setPage(state, page) {
    state.page = page;
  },
  setPageCount: function setPageCount(state, count) {
    state.pageCount = count;
  },
  setPerPage: function setPerPage(state, count) {
    state.perPage = count;
  },
  setTotal: function setTotal(state, total) {
    state.total = total;
  },
  setHasMorePages: function setHasMorePages(state, hasMorePages) {
    state.hasMorePages = hasMorePages;
  },
  setIsLoaded: function setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
  setIsChanged: function setIsChanged(state, isChanged) {
    state.isChanged = isChanged;
  },
  setValidationError: function setValidationError(state, response) {
    console.info(response);
    state.validationError = response;
  },
  deleteItemById: function deleteItemById(state, id) {
    var index = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(state.items, { id: id });
    if (index >= 0) {
      state.items.splice(index, 1);
    }
  },
  editItem: function editItem(state, item) {
    var index = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(state.items, { id: item.id });
    if (index >= 0) {
      state.items.splice(index, 1, item);
    }
  },
  addItem: function addItem(state, item) {
    state.items.unshift(item);
  },
  removeLastItem: function removeLastItem(state) {
    state.items.splice(-1, 1);
  },
  setTimezones: function setTimezones(state, timezones) {
    state.timezones = timezones;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(915);





var module = {
  namespaced: true,
  modules: {
    session: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
      getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
      actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
      mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  settings: {
    behaviourTypeId: null,
    intervalDurationValue: null,
    intervalDurationUnitId: null,
    aimTypeId: null
  },
  auditor: {},
  assignee: {},
  uuid: null,
  currentInterval: {
    index: null,
    duration: null,
    current: 0,
    behaviourHappenedAt: null
  },
  isIntervalEnable: false,
  intervals: [],
  startedAt: null,
  finishedAt: null,
  isSessionStarted: false,
  shouldStartIntervalAutomatically: false
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(80);


/* harmony default export */ __webpack_exports__["a"] = ({
  intervalDuration: function intervalDuration(state) {
    var duration = state.settings.intervalDurationValue,
        unitId = state.settings.intervalDurationUnitId;
    if (!duration || !unitId) {
      return null;
    }
    duration = parseInt(duration);
    unitId = parseInt(unitId);
    if (unitId === __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* default */].INTERVAL_DURATION_UNIT_MINUTES) {
      return duration * 60;
    } else {
      return duration;
    }
  },
  shouldSessionBeSaved: function shouldSessionBeSaved(state) {
    return !!state.intervals.length;
  },
  saveSessionData: function saveSessionData(state, getters, rootState) {
    return {
      assigneeId: rootState.route.params.clientId,
      uuid: state.uuid,
      startedAt: state.startedAt,
      finishedAt: state.finishedAt,
      intervals: state.intervals,
      report: {
        behaviourTypeId: parseInt(state.settings.behaviourTypeId),
        aimTypeId: parseInt(state.settings.aimTypeId),
        intervalDurationValue: parseInt(state.settings.intervalDurationValue),
        intervalDurationUnitId: parseInt(state.settings.intervalDurationUnitId),
        behaviourDescription: state.settings.behaviourDescription || null
      }
    };
  },
  isIntervalStarted: function isIntervalStarted(state) {
    var interval = state.currentInterval;
    return interval.current < interval.duration && interval.behaviourHappenedAt === null;
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timer_Events__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_auth_Events__ = __webpack_require__(144);







/* harmony default export */ __webpack_exports__["a"] = ({
  setSettings: function setSettings(_ref, settings) {
    var commit = _ref.commit;

    commit('setSettings', settings);
  },
  setCurrentInterval: function setCurrentInterval(_ref2) {
    var commit = _ref2.commit;
    var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    commit('setCurrentInterval', interval);
  },
  setCurrentIntervalTime: function setCurrentIntervalTime(_ref3, time) {
    var commit = _ref3.commit;

    commit('setCurrentIntervalTime', time);
  },
  addInterval: function addInterval(_ref4) {
    var commit = _ref4.commit;

    commit('addInterval');
  },
  setIntervals: function setIntervals(_ref5, intervals) {
    var commit = _ref5.commit;

    commit('setIntervals', intervals);
  },
  setCurrentIntervalBehaviourHappenedAt: function setCurrentIntervalBehaviourHappenedAt(_ref6, value) {
    var commit = _ref6.commit;

    commit('setCurrentIntervalBehaviourHappenedAt', value);
  },
  setIntervalDuration: function setIntervalDuration(_ref7, params) {
    var commit = _ref7.commit;

    commit('setIntervalDuration', params);
  },
  setAuditor: function setAuditor(_ref8, object) {
    var commit = _ref8.commit;

    commit('setAuditor', object);
  },
  setAssignee: function setAssignee(_ref9, object) {
    var commit = _ref9.commit;

    commit('setAssignee', object);
  },
  setStartedAt: function setStartedAt(_ref10, value) {
    var commit = _ref10.commit;

    commit('setStartedAt', value);
  },
  setFinishedAt: function setFinishedAt(_ref11, value) {
    var commit = _ref11.commit;

    commit('setFinishedAt', value);
  },
  setUuid: function setUuid(_ref12, uuid) {
    var commit = _ref12.commit;

    commit('setUuid', uuid);
  },
  setIsSessionStarted: function setIsSessionStarted(_ref13, value) {
    var commit = _ref13.commit;

    commit('setIsSessionStarted', value);
  },
  setShouldStartIntervalAutomatically: function setShouldStartIntervalAutomatically(_ref14, value) {
    var commit = _ref14.commit;

    commit('setShouldStartIntervalAutomatically', value);
  },
  clearSession: function clearSession(_ref15) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    commit('setFinishedAt', null);
    commit('setStartedAt', null);
    commit('setIntervals', []);
    commit('setAuditor', {});
    commit('setAssignee', {});
    commit('setCurrentInterval', {
      index: null,
      duration: null,
      current: 0,
      behaviourHappenedAt: null
    });
    commit('setSettings', {
      behaviourTypeId: null,
      intervalDurationValue: null,
      intervalDurationUnitId: null,
      aimTypeId: null
    });
    commit('setUuid', null);
    commit('setIsSessionStarted', false);
    commit('setShouldStartIntervalAutomatically', false);
    dispatch('destroyTimer');
  },
  stopTimer: function stopTimer() {
    __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].stop();
  },
  resetTimer: function resetTimer() {
    __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].reset();
  },
  startTimer: function startTimer(_ref16) {
    var _this = this;

    var dispatch = _ref16.dispatch,
        commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch('initTimer');

            case 2:
              _context.next = 4;
              return commit('setTimerConfig');

            case 4:
              __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].start();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  destroyTimer: function destroyTimer(_ref17) {
    var _this2 = this;

    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch('resetTimer');

            case 2:
              __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].removeEvent();

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  initTimer: function initTimer(_ref18) {
    var _this3 = this;

    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch('destroyTimer');

            case 2:
              __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_3__timer_Events__["a" /* default */].TICK, function (_ref19) {
                var current = _ref19.current;

                dispatch('setCurrentIntervalTime', current);
              });
              __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_3__timer_Events__["a" /* default */].TO_TIME_REACHED, function () {
                dispatch('addInterval');
              });
              __WEBPACK_IMPORTED_MODULE_4__common_auth_Manager__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_5__common_auth_Events__["a" /* default */].BEFORE_UNAUTHORIZE, function () {
                dispatch('destroyTimer');
                return true;
              });

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  onBehaviourHappened: function onBehaviourHappened(_ref20) {
    var _this4 = this;

    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch('stopTimer');

            case 2:
              _context4.next = 4;
              return dispatch('setCurrentIntervalBehaviourHappenedAt', __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].getCurrentTime());

            case 4:
              _context4.next = 6;
              return dispatch('addInterval');

            case 6:
              _context4.next = 8;
              return dispatch('resetTimer');

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  setIntervalEnable: function setIntervalEnable(_ref21, value) {
    var commit = _ref21.commit;

    commit('setIntervalEnable', value);
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wolfy87_eventemitter__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wolfy87_eventemitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wolfy87_eventemitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Events__ = __webpack_require__(312);








var Timer = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Timer, _EventEmitter);

  function Timer() {
    var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Timer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Timer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Timer)).call(this));

    _this.setCurrentTime(0);
    _this.setTo(to);
    _this.interval = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Timer, [{
    key: 'getTo',
    value: function getTo() {
      return this.to;
    }
  }, {
    key: 'setTo',
    value: function setTo(to) {
      this.to = to;
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].TO_TIME_CHANGED, { to: to });
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.currentTime = time;
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].CURRENT_TIME_CHANGED, {
        current: time
      });
    }
  }, {
    key: 'isToTimeReached',
    value: function isToTimeReached() {
      return this.currentTime >= this.to;
    }
  }, {
    key: 'tick',
    value: function tick() {
      var previous = this.getCurrentTime();
      var current = previous + 1;
      this.setCurrentTime(current);
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].TICK, {
        previous: previous,
        current: current,
        to: this.getTo()
      });
    }
  }, {
    key: 'start',
    value: function start() {
      var _this2 = this;

      this.interval = setInterval(function () {
        _this2.tick();
        if (_this2.isToTimeReached()) {
          _this2.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].TO_TIME_REACHED, { to: _this2.getTo() });
          _this2.reset();
        }
      }, 1000);
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].START, {
        current: this.getCurrentTime(),
        to: this.getTo()
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].STOP, {
        current: this.getCurrentTime(),
        to: this.getTo()
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.stop();
      this.setCurrentTime(0);
      this.emit(__WEBPACK_IMPORTED_MODULE_6__Events__["a" /* default */].RESET, {
        current: this.getCurrentTime(),
        to: this.getTo()
      });
    }
  }]);

  return Timer;
}(__WEBPACK_IMPORTED_MODULE_5_wolfy87_eventemitter___default.a);

/* harmony default export */ __webpack_exports__["a"] = (Timer);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer__ = __webpack_require__(311);




/* harmony default export */ __webpack_exports__["a"] = ({
  setSettings: function setSettings(state, settings) {
    state.settings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, settings);
  },
  setCurrentInterval: function setCurrentInterval(state, _ref) {
    var _ref$index = _ref.index,
        index = _ref$index === undefined ? null : _ref$index,
        _ref$duration = _ref.duration,
        duration = _ref$duration === undefined ? null : _ref$duration;

    state.currentInterval = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
      index: index,
      duration: duration,
      behaviourHappenedAt: null,
      current: 0
    });
  },
  setCurrentIntervalTime: function setCurrentIntervalTime(state, time) {
    state.currentInterval.current = time;
  },
  addInterval: function addInterval(state) {
    var interval = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(state.currentInterval, ['current']));
    state.intervals = state.intervals.concat([interval]);
  },
  setIntervals: function setIntervals(state, intervals) {
    state.intervals = intervals;
  },
  setCurrentIntervalBehaviourHappenedAt: function setCurrentIntervalBehaviourHappenedAt(state, value) {
    state.currentInterval.behaviourHappenedAt = value;
  },
  setIntervalDuration: function setIntervalDuration(state, _ref2) {
    var value = _ref2.value,
        unitId = _ref2.unitId;

    state.settings.intervalDurationValue = value;
    state.settings.intervalDurationUnitId = unitId;
  },
  setAuditor: function setAuditor(state, object) {
    state.auditor = object;
  },
  setAssignee: function setAssignee(state, object) {
    state.assignee = object;
  },
  setStartedAt: function setStartedAt(state, value) {
    state.startedAt = value;
  },
  setFinishedAt: function setFinishedAt(state, value) {
    state.finishedAt = value;
  },
  setUuid: function setUuid(state, uuid) {
    state.uuid = uuid;
  },
  setIsSessionStarted: function setIsSessionStarted(state, value) {
    state.isSessionStarted = value;
  },
  setShouldStartIntervalAutomatically: function setShouldStartIntervalAutomatically(state, value) {
    state.shouldStartIntervalAutomatically = value;
  },
  setTimerConfig: function setTimerConfig(state) {
    __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].setCurrentTime(state.currentInterval.current);
    __WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */].setTo(state.currentInterval.duration);
  },
  setIntervalEnable: function setIntervalEnable(state, value) {
    state.isIntervalEnable = value;
  }
});

/***/ }),
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(925);





var module = {
  namespaced: true,
  modules: {
    session: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
      getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
      actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
      mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  auditor: null,
  assignee: null,
  uuid: null,
  stimuli: null,
  sessions: [],
  startedAt: null,
  finishedAt: null,
  isSaved: false
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setSettings: function setSettings(_ref, settings) {
    var commit = _ref.commit;

    commit('setSettings', settings);
  },
  setSessions: function setSessions(_ref2, sessions) {
    var commit = _ref2.commit;

    commit('setSessions', sessions);
  },
  setAuditor: function setAuditor(_ref3, object) {
    var commit = _ref3.commit;

    commit('setAuditor', object);
  },
  setAssignee: function setAssignee(_ref4, object) {
    var commit = _ref4.commit;

    commit('setAssignee', object);
  },
  setStartedAt: function setStartedAt(_ref5, value) {
    var commit = _ref5.commit;

    commit('setStartedAt', value);
  },
  setFinishedAt: function setFinishedAt(_ref6, value) {
    var commit = _ref6.commit;

    commit('setFinishedAt', value);
  },
  setIsSaved: function setIsSaved(_ref7, value) {
    var commit = _ref7.commit;

    commit('setIsSaved', value);
  },
  setUuid: function setUuid(_ref8, value) {
    var commit = _ref8.commit;

    commit('setUuid', value);
  },
  clearSession: function clearSession(_ref9) {
    var commit = _ref9.commit;

    commit('setSessions', {});
    commit('setUuid', null);
    //commit('setIsSaved', false);
    //commit('setFinishedAt', null);
    //commit('setStartedAt', null);
    //commit('setAssignee', null);
    //commit('setAuditor', null);
    //commit('setSettings', {});
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  setSettings: function setSettings(state, settings) {
    state.stimuli = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, settings);
  },
  setSessions: function setSessions(state, sessions) {
    state.sessions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, sessions);
  },
  setAuditor: function setAuditor(state, object) {
    state.auditor = object;
  },
  setAssignee: function setAssignee(state, object) {
    state.assignee = object;
  },
  setStartedAt: function setStartedAt(state, value) {
    state.startedAt = value;
  },
  setFinishedAt: function setFinishedAt(state, value) {
    state.finishedAt = value;
  },
  setIsSaved: function setIsSaved(state, value) {
    state.isSaved = value;
  },
  setUuid: function setUuid(state, uuid) {
    state.uuid = uuid;
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(930);





var module = {
  namespaced: true,
  modules: {
    list: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
      getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
      actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
      mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isSaved: false
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setIsSaved: function setIsSaved(_ref, value) {
    var commit = _ref.commit;

    commit('setIsSaved', value);
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setIsSaved: function setIsSaved(state, value) {
    state.isSaved = value;
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_index__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_undesirableBehavior__ = __webpack_require__(81);



var behavior = new __WEBPACK_IMPORTED_MODULE_0__vuex_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__api_undesirableBehavior__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (behavior);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(936);






var Behavior = function Behavior(apiUndesirableBehavior) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Behavior);

  this.namespaced = true;
  this.state = Object(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */])();
  this.getters = __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */];
  this.actions = __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */];
  this.mutations = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */];

  this.state.apiManager = apiUndesirableBehavior;
};

/* harmony default export */ __webpack_exports__["a"] = (Behavior);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    behaviors: [],
    typicalBehaviors: [],
    paginateData: null,
    isLoaded: false,
    isAdded: false,
    entity: {},
    currentPage: 1
  };
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var actions = {
  setBehaviors: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, _ref3) {
      var state = _ref2.state,
          commit = _ref2.commit;
      var clientId = _ref3.clientId,
          protocolId = _ref3.protocolId,
          antecedentId = _ref3.antecedentId,
          behaviorId = _ref3.behaviorId,
          perPage = _ref3.perPage,
          page = _ref3.page,
          startDate = _ref3.startDate,
          endDate = _ref3.endDate,
          sort = _ref3.sort,
          search = _ref3.search;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('setIsLoaded', false);

              _context.next = 4;
              return state.apiManager.findByClientId(clientId, protocolId, antecedentId, behaviorId, perPage, page, startDate, endDate, sort, search);

            case 4:
              response = _context.sent;
              data = response.data.data;


              commit('setBehaviors', data.items);
              commit('setPaginate', data);
              commit('setIsLoaded', true);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 11]]);
    }));

    function setBehaviors(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return setBehaviors;
  }(),

  setGroupedBehaviors: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit;
      var clientId = _ref6.clientId,
          perPage = _ref6.perPage,
          page = _ref6.page,
          startDate = _ref6.startDate,
          endDate = _ref6.endDate,
          frequencyType = _ref6.frequencyType;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit('setIsLoaded', false);

              _context2.next = 4;
              return state.apiManager.findByClientIdGroupedByFrequency(clientId, perPage, page, startDate, endDate, frequencyType);

            case 4:
              response = _context2.sent;
              data = response.data.data;


              commit('setBehaviors', data.items);
              commit('setPaginate', data);
              commit('setIsLoaded', true);
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 11]]);
    }));

    function setGroupedBehaviors(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return setGroupedBehaviors;
  }(),

  setTypesBehaviors: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, clientId) {
      var state = _ref8.state,
          commit = _ref8.commit;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return state.apiManager.getTypes(clientId);

            case 3:
              response = _context3.sent;
              data = response.data.data;


              commit('setTypesBehaviors', data);
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 8]]);
    }));

    function setTypesBehaviors(_x5, _x6) {
      return _ref7.apply(this, arguments);
    }

    return setTypesBehaviors;
  }(),
  setCurrentPage: function setCurrentPage(_ref9, page) {
    var commit = _ref9.commit;

    commit('setCurrentPage', page);
  },
  setIsAdded: function setIsAdded(_ref10, isAdded) {
    var commit = _ref10.commit;

    commit('setIsAdded', isAdded);
  },
  setEntity: function setEntity(_ref11, entity) {
    var commit = _ref11.commit;

    commit('setEntity', entity);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var mutations = {
  setBehaviors: function setBehaviors(state, behaviors) {
    state.behaviors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, behaviors);
  },
  setTypesBehaviors: function setTypesBehaviors(state, typicalBehaviors) {
    state.typicalBehaviors = typicalBehaviors;
  },
  setPaginate: function setPaginate(state, paginateData) {
    state.paginateData = paginateData;
  },
  setIsLoaded: function setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
  setCurrentPage: function setCurrentPage(state, page) {
    state.currentPage = page;
  },
  setIsAdded: function setIsAdded(state, isAdded) {
    state.isAdded = isAdded;
  },
  setEntity: function setEntity(state, entity) {
    state.entity = entity;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__ = __webpack_require__(102);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Undesirable Behavior API Manager.
 */
var UndesirableBehaviorApiManager = /** @class */ (function (_super) {
    __extends(UndesirableBehaviorApiManager, _super);
    function UndesirableBehaviorApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Finds undesirable behavior by Client ID.
     *
     * @param {Number} clientId
     * @param {Number} perPage
     * @param {Number} page
     * @param {String} sort
     * @param {String} search
     * @returns {Promise<any>}
     */
    UndesirableBehaviorApiManager.prototype.findByClientId = function (clientId, protocolId, antecedentId, behaviorId, perPage, page, startDate, endDate, sort, search) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/" + clientId + "/" + perPage + "/" + page;
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    antecedentId: antecedentId,
                                    behaviorId: behaviorId,
                                    protocolId: protocolId,
                                    startDate: startDate,
                                    endDate: endDate,
                                },
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     * @param clientId
     * @param perPage
     * @param page
     * @param startDate
     * @param endDate
     * @param frequencyType
     */
    UndesirableBehaviorApiManager.prototype.findByClientIdGroupedByFrequency = function (clientId, perPage, page, startDate, endDate, frequencyType) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/frequency/" + clientId + "/" + perPage + "/" + page + "/" + frequencyType;
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate,
                                },
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create new undesirable behavior.
     *
     * @param {Number} clientId
     * @param {String} antecedent
     * @param {String} behavior
     * @param {String} effects
     * @returns {Promise<any>}
     */
    UndesirableBehaviorApiManager.prototype.create = function (clientId, antecedentTypes, behaviorTypes, effectsTypes, consequenceInBehaviorTypes, entity, createdAt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(entity && Object.keys(entity).length !== 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.axios.post(this.url, {
                                clientId: clientId,
                                antecedentTypes: antecedentTypes,
                                behaviorTypes: behaviorTypes,
                                effectsTypes: effectsTypes,
                                consequenceInBehaviorTypes: consequenceInBehaviorTypes,
                                entity: entity,
                                createdAt: createdAt
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.axios.post(this.url, {
                            clientId: clientId,
                            antecedentTypes: antecedentTypes,
                            behaviorTypes: behaviorTypes,
                            effectsTypes: effectsTypes,
                            consequenceInBehaviorTypes: consequenceInBehaviorTypes,
                            createdAt: createdAt
                        })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get types by Client ID.
     *
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    UndesirableBehaviorApiManager.prototype.getTypes = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/units/types/" + clientId, {
                            clientId: clientId
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create new types.
     *
     * @param {Number} clientId
     * @param {Array} types
     * @returns {Promise<any>}
     */
    UndesirableBehaviorApiManager.prototype.saveTypes = function (clientId, antecedentTypes, behaviorTypes, effectsTypes, consequenceInBehaviorTypes) {
        return __awaiter(this, void 0, void 0, function () {
            var createdAt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createdAt = Math.round((new Date()).getTime() / 1000);
                        return [4 /*yield*/, this.axios.post(this.url + "/units/types", {
                                clientId: clientId,
                                antecedentTypes: antecedentTypes,
                                behaviorTypes: behaviorTypes,
                                effectsTypes: effectsTypes,
                                consequenceInBehaviorTypes: consequenceInBehaviorTypes,
                                createdAt: createdAt
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getCountBehavior = function (clientId, protocolId, antecedentId, behaviorId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/statistics/" + clientId, {
                            params: {
                                antecedentId: antecedentId,
                                behaviorId: behaviorId,
                                protocolId: protocolId,
                                startDate: startDate,
                                endDate: endDate
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getCountTypes = function (clientId, protocolId, antecedentId, behaviorId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/units/types/statistics/" + clientId, {
                            params: {
                                antecedentId: antecedentId,
                                behaviorId: behaviorId,
                                protocolId: protocolId,
                                startDate: startDate,
                                endDate: endDate
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getScatterplotData = function (clientId, protocolId, antecedentId, behaviorId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/scatterplot/" + clientId, {
                            params: {
                                antecedentId: antecedentId,
                                behaviorId: behaviorId,
                                protocolId: protocolId,
                                startDate: startDate,
                                endDate: endDate
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getAncedents = function (clientId, protocolId, skillFieldId, perPage, page, startDate, endDate) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/antecedents/" + clientId + "/" + perPage + "/" + page + "/";
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    protocolId: protocolId,
                                    skillFieldId: skillFieldId,
                                    startDate: startDate,
                                    endDate: endDate,
                                },
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getBehaviors = function (clientId, protocolId, skillFieldId, perPage, page, startDate, endDate) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/behaviors/" + clientId + "/" + perPage + "/" + page + "/";
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    protocolId: protocolId,
                                    skillFieldId: skillFieldId,
                                    startDate: startDate,
                                    endDate: endDate,
                                },
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UndesirableBehaviorApiManager.prototype.getUBsList = function (clientId, protocolId, skillFieldId, perPage, page, startDate, endDate) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/behaviors/" + clientId + "/" + perPage + "/" + page + "/";
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    protocolId: protocolId,
                                    skillFieldId: skillFieldId,
                                    startDate: startDate,
                                    endDate: endDate,
                                },
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UndesirableBehaviorApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (UndesirableBehaviorApiManager);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_index__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_appeals__ = __webpack_require__(128);



var appeals = new __WEBPACK_IMPORTED_MODULE_0__vuex_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__api_appeals__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (appeals);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(943);






var Appeals = function Appeals(apiAppeals) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Appeals);

  this.namespaced = true;
  this.state = Object(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */])();
  this.getters = __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */];
  this.actions = __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */];
  this.mutations = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */];

  this.state.apiManager = apiAppeals;
};

/* harmony default export */ __webpack_exports__["a"] = (Appeals);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    appeals: [],
    typicalAppeals: [],
    paginateData: null,
    isLoaded: false,
    isAdded: false,
    entity: {},
    currentPage: 1
  };
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var actions = {
  setAppeals: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, _ref3) {
      var state = _ref2.state,
          commit = _ref2.commit;
      var clientId = _ref3.clientId,
          perPage = _ref3.perPage,
          page = _ref3.page,
          startDate = _ref3.startDate,
          endDate = _ref3.endDate,
          sort = _ref3.sort,
          search = _ref3.search;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('setIsLoaded', false);

              _context.next = 4;
              return state.apiManager.findByClientId(clientId, perPage, page, startDate, endDate, sort, search);

            case 4:
              response = _context.sent;
              data = response.data.data;


              commit('setAppeals', data.items);
              commit('setPaginate', data);
              commit('setIsLoaded', true);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 11]]);
    }));

    function setAppeals(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return setAppeals;
  }(),
  setTypesAppeals: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, clientId) {
      var state = _ref5.state,
          commit = _ref5.commit;
      var response, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return state.apiManager.getTypes(clientId);

            case 3:
              response = _context2.sent;
              data = response.data.data;


              commit('setTypesAppeals', data);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 8]]);
    }));

    function setTypesAppeals(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return setTypesAppeals;
  }(),
  setCurrentPage: function setCurrentPage(_ref6, page) {
    var commit = _ref6.commit;

    commit('setCurrentPage', page);
  },
  setIsAdded: function setIsAdded(_ref7, isAdded) {
    var commit = _ref7.commit;

    commit('setIsAdded', isAdded);
  },
  setEntity: function setEntity(_ref8, entity) {
    var commit = _ref8.commit;

    console.info(entity);
    commit('setEntity', entity);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var mutations = {
  setAppeals: function setAppeals(state, appeals) {
    state.appeals = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, appeals);
  },
  setTypesAppeals: function setTypesAppeals(state, typicalAppeals) {
    state.typicalAppeals = typicalAppeals;
  },
  setPaginate: function setPaginate(state, paginateData) {
    state.paginateData = paginateData;
  },
  setIsLoaded: function setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
  setCurrentPage: function setCurrentPage(state, page) {
    state.currentPage = page;
  },
  setIsAdded: function setIsAdded(state, isAdded) {
    state.isAdded = isAdded;
  },
  setEntity: function setEntity(state, entity) {
    state.entity = entity;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__ = __webpack_require__(102);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Appeals API Manager.
 */
var AppealsApiManager = /** @class */ (function (_super) {
    __extends(AppealsApiManager, _super);
    function AppealsApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Finds appeals by Client ID.
     *
     * @param {Number} clientId
     * @param {Number} perPage
     * @param {Number} page
     * @param {Date} startDate
     * @param {Date} endDate
     * @param {String} search
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.findByClientId = function (clientId, perPage, page, startDate, endDate, search) {
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/" + clientId + "/" + perPage + "/" + page, {
                            params: {
                                startDate: startDate,
                                endDate: endDate,
                                search: search,
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create new Appeal.
     *
     * @param {Number} clientId
     * @param {Array} types
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.create = function (clientId, types, entity, createdAt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(entity && Object.keys(entity).length !== 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.axios.post("" + this.url, {
                                clientId: clientId,
                                types: types,
                                entity: entity,
                                createdAt: createdAt
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.axios.post("" + this.url, {
                            clientId: clientId,
                            types: types,
                            createdAt: createdAt
                        })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get types by Client ID.
     *
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.getTypes = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/types/" + clientId, {
                            clientId: clientId
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get types by Client ID.
     *
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.getCountAppeals = function (clientId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/statistics/" + clientId, {
                            params: {
                                startDate: startDate,
                                endDate: endDate
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get types by Client ID.
     *
     * @param {Number} clientId
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.getCountAllAppeals = function (clientId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get(this.url + "/statistics/types/" + clientId, {
                            params: {
                                startDate: startDate,
                                endDate: endDate
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create new types.
     *
     * @param {Number} clientId
     * @param {Array} types
     * @returns {Promise<any>}
     */
    AppealsApiManager.prototype.saveTypes = function (clientId, types) {
        return __awaiter(this, void 0, void 0, function () {
            var createdAt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createdAt = Math.round((new Date()).getTime() / 1000);
                        return [4 /*yield*/, this.axios.post(this.url + "/types", {
                                clientId: clientId,
                                types: types,
                                createdAt: createdAt
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AppealsApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (AppealsApiManager);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(949);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    protocolVuexData: null,
    protocolVersion: 0
  };
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
  setProtocol: function setProtocol(_ref, protocolData) {
    var commit = _ref.commit;

    commit('setProtocol', protocolData);
  },
  setProtocolVersion: function setProtocolVersion(_ref2, version) {
    var commit = _ref2.commit;

    commit('setProtocolVersion', version);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_translator__ = __webpack_require__(6);


var mutations = {
  setProtocol: function setProtocol(state, protocolData) {
    state.protocolVuexData = protocolData;
  },
  setProtocolVersion: function setProtocolVersion(state, version) {
    state.protocolVersion = version;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 950 */,
/* 951 */
/***/ (function(module, exports) {

module.exports = {"ar.admin":{"action":"الحدث","administrator":"مسئول","alert":"تحذير","all":"الكل","all_methods_if_empty":"كل الوسائل فارغة","avatar":"الصورة","back":"عودة","back_to_list":"العودة الى القائمة","batch_delete":"مسح بالجملة","browse":"تصفح","cancel":"إلغاء","captcha":"كود التحقق","choose":"اختر","choose_file":"اختر الملف","choose_image":"اختر الصورة","close":"اغلاق","collapse":"تصغير","confirm":"تأكيد","create":"انشاء","created_at":"تاريخ الانشاء","current_page":"الصفحة الحالية","delete":"مسح","delete_confirm":"هل انت متاكد من مسح هذا العنصر ","delete_failed":"فشل الحذف !","delete_succeeded":"تم الحذف بنجاح ! ","deny":"ليس لديك الاذن","description":"الوصف","edit":"تعديل","entries":"المدخلات","expand":"تكبير","export":"تصدير","failed":"فشل","filter":"تصنيف","http":{"method":"HTTP method","path":"HTTP path"},"icon":"الرمز","input":"المدخل","list":"القائمة","listbox":{"filter_clear":"عرض الكل","filter_placeholder":"تنقية","filtered":"{0} / {1}","text_empty":"قائمة فارغة","text_total":"عرض الكل {0}"},"login":"تسجيل الدخول","login_successful":"تم تسجيل الدخول بنجاح","logout":"تسجيل الخروج","menu":"القائمة","more":"المزيد","name":"الاسم","new":"جديد","new_folder":"مجلد جديد","online":"متصل","operation_log":"سجل التشغيل","order":"ترتيب","pagination":{"range":"عرض :first الى :last من :total المدخلات"},"parent_id":"الاصل","parent_select_error":"خطأ في تحديد الاصل","password":"الرقم السري","password_confirmation":"تأكيد الرقم السري","permission":"الصلاحية","permissions":"الصلاحيات","refresh":"تحديث","refresh_succeeded":"تم التحديث !","remember_me":"تذكرني","remove":"حذف","reset":"تفريغ","role":"القاعدة","roles":"القواعد","route":"المسار","save":"حفظ","save_succeeded":"تم الحفظ !","selected_rows":"الصفوف المختارة","setting":"الضبط","show":"عرض","size":"الحجم","slug":"المعرف","submit":"ارسال","succeeded":"تمت بنجاح","time":"الوقت","title":"العنوان","update_succeeded":"تم التعديل بنجاح !","updated_at":"تاريخ التعديل","upload":"رفع","uri":"URI","user_setting":"ضبط المستخدم","username":"اسم المستخدم","view":"عرض"},"en.admin":{"action":"Action","administrator":"Administrator","alert":"Alert","all":"All","all_methods_if_empty":"All methods if empty","avatar":"Avatar","back":"Back","back_to_list":"Back to List","batch_delete":"Batch delete","batch_enable_off":"Turn off skill domains","batch_enable_on":"Turn on skill domains","browse":"Browse","cancel":"Cancel","captcha":"Captcha","choose":"Choose","choose_file":"Select file","choose_image":"Select image","close":"Close","collapse":"Collapse","confirm":"Confirm","continue_creating":"Continue creating","continue_editing":"Continue editing","create":"Create","created_at":"Created At","current_page":"Current page","delete":"Delete","delete_confirm":"Are you sure to delete this item ?","delete_failed":"Delete failed !","delete_failed_skill_field":"You have not selected skill domains to delete","delete_succeeded":"Delete succeeded !","deny":"Permission denied","description":"Description","detail":"Detail","details":"Details","edit":"Edit","enable_off":"Turn off","enable_off_confirm_skill_fields":"Do you confirm the turning off selected skill domains?","enable_off_failed_skill_field":"You have not selected skill domains to enable off","enable_on":"Turn on","enable_on_confirm_skill_fields":"Do you confirm the turning on selected skill domains?","enable_on_failed_skill_field":"You have not selected skill domains to enable on","entries":"entries","expand":"Expand","export":"Export","failed":"Failed","filter":"Filter","http":{"method":"HTTP method","path":"HTTP path"},"icon":"Icon","input":"Input","list":"List","listbox":{"filter_clear":"Show all","filter_placeholder":"Filter","filtered":"{0} / {1}","text_empty":"Empty list","text_total":"Showing all {0}"},"login":"Login","login_successful":"Login successful","logout":"Logout","menu":"Menu","menu_titles":[],"more":"More","name":"Name","new":"New","new_folder":"New folder","online":"Online","operation_log":"Operation log","order":"Order","pagination":{"range":"Showing :first to :last of :total entries"},"parent_id":"Parent","parent_select_error":"Parent select error","password":"Password","password_confirmation":"Password confirmation","permission":"Permission","permissions":"Permissions","refresh":"Refresh","refresh_succeeded":"Refresh succeeded !","remember_me":"Remember me","remove":"Remove","reset":"Reset","role":"Role","roles":"Roles","route":"Route","save":"Save","save_succeeded":"Save succeeded !","search":"Search","sections":{"pages":{"description":" ","headers":{"index":"Pages"}},"settings":{"description":"System Settings","headers":{"index":"Settings"}},"subscriptions":{"description":" ","headers":{"index":"Subscriptions","region_discounts":"Fees"}},"users":{"chart":{"title":"Dynamics by the number of sessions held by clients of the analyst for the selected period"},"description":" ","headers":{"centers":"Centers","index":"Analysts","skillFields":"Skill domains","skillRatings":"Skill ratings","statistics":"Statistics","userCenters":"User centers"}}},"selected_rows":"Selected rows","setting":"Setting","show":"Show","size":"Size","slug":"Slug","submit":"Submit","succeeded":"Succeeded","time":"Time","title":"Title","update_succeeded":"Update succeeded !","updated_at":"Updated At","upload":"Upload","uri":"URI","user_setting":"User setting","username":"Username","view":"View"},"en.android":{"conflict_protocol":"Current protocol version on the device does not correspond to the latest protocol version on the server. You may save the session and update the protocol or continue without updating the protocol","language":"Language","no_connection":"No connection","no_data":"No data","settings":"Settings","subscription_has_expired":"Your system subscription expired. Please contact your system administrator","synchronization_in_progress":"Synchronization","synchronization_warning":"Warning! Unsaved session data will be lost during synchronization. Continue with unsaved data?","synchronize":"Synchronize","unable_to_save_date":"Unable to save data"},"en.appeals":{"R":"М","appeal":"Mand","appeals":"Mands","appeals_chart":"Graph of mands emitted during the period","appeals_count":"Number of mands","appeals_for_period":"Mands within period","avarage_appeals_perhour":"Avg. mands/hour","buttons":{"addAppeal":"Add","apply":"Apply","cancel":"Cancel","createAppeal":"Record","saveAppeal":"Save","write_appeal":"Record a mand"},"date_end":"Date till","date_start":"Date since","date_time":"Date/Time","edit_typical_appeals":"Edit typical mands","edit_typical_appeals_short":"Edit typ. mands","edit_typical_client_appeals":"Edit client typical mands","maxlength_appeals":"Max mand number: 50","need_choice_appeal":"Choose a mand","no_data":"No data","pagination":{"next":"Forward","previous":"Back"},"range":"Timeframe","recorded":"Recorded","total_appeals_perday":"Total number of different mands per day","type_new_appeal":"Enter a new mand","type_the_appeals_name_to_search":"Enter a mand to search","typical_appeals":"Typical mands","unique_appeals":"Mands must not duplicate","write_appeal":"Record a mand","write_client_appeal":"Record a mand"},"en.auth":{"failed":"These credentials do not match our records.","throttle":"Too many login attempts. Please try again in :seconds seconds."},"en.bcba":{"add_curator":"Add Curator","clients":"Clients","curators":"Curators","dashboard":"Dashboard","therapists":"Therapists"},"en.behavior":{"UB":"IB","add_ub_environment":"Enter new consequence in the environment","add_ub_to_report":"Add inappropriate behavior data to the report","aftermath":"Consequence","aftermath_short":"Consequence","all_ancedent":"All antecedent","all_option":"All option","all_protocol":"All protocol","all_ub":"All inappropriate behavior data","all_ub_for_day":"All inappropriate behavior within 24 hours","ancedent":"Antecedent","average_behavior":"Avg. number of IB per hour","behavior":"Behavior","buttons":{"add":"Add","apply":"Apply","cancel":"Cancel","create":"Record","create_behavior":"Record IB","save":"Save","show_by_frequency":"Show by frequency","show_by_time":"Show by date/time","typical_behavior":"Typical IB","write_unwanted_behavior":"Record Inappropriate Behavior"},"date_end":"Date till","date_start":"Date since","date_time":"Date/Time","describe_the_behavior":"Describe the behavior","edit_typical_appeals_short":"Edit typ. mands","edit_typical_behavior":"Edit typ. IB","edit_typical_client_behavior":"Edit typical IB of the client","enter_the_aftermath":"Enter the consequence","enter_the_ancedent":"Enter the antecedent","enter_the_new_aftermath":"Enter a new consequence","enter_the_new_ancedent":"Enter a new antecedent","enter_the_new_behavior":"Enter a new behavior","frequency_group_by":"Group by","frequency_group_types":{"aftermath":"Consequence","ancedent":"Antecedent","behavior":"Behavior","undefined":"By date/time"},"hours_24":"24 hours","maxlength_aftermath":"Max. consequence number: 50","maxlength_ancedent":"Max. antecedent number: 50","maxlength_behaviors":"Max. behavior number: 50","min":"min","need_choice_aftermath":"Choose antecedent","need_choice_ancedent":"Choose antecedent","need_choice_behavior":"Choose behavior","no_data":"No data","pagination":{"next":"Forward","previous":"Back"},"range":"Timeframe","scatter_plot":"Scatter-plot for inappropriate behavior data","sec":"sec","times":"times","ub_behavior":"Consequences in behavior","ub_environment":"Consequences in the environment","ub_for_day":"Inappropriate behavior within daily session","unique_aftermath":"Consequences must not duplicate","unique_ancedent":"Antecedents must not duplicate","unique_behaviors":"Behaviors must not duplicate","unwanted_behavior":"Inappropriate Behavior","unwanted_behavior_chart":"Graph of inappropriate behavior emitted during the period","unwanted_behavior_for_period":"Inappropriate Behavior within period","unwanted_behavior_title":"Edit typical IB","within":"Within","write_unwanted_behavior":"Record Inappropriate Behavior","write_unwanted_behavior_short":"Record IB","you_must_select_at_least_one_antecedent_behavior_and_consequence":"Please choose at least 1 antecedent, behavior and consequence"},"en.bids":{"Z":"R","add_comment":"Enter your comment","appoint_protocol":"Assign the protocol","bid":"Request","bids":"Requests","bids_for_new_protocols":"New protocol requests","bids_for_protocols":"Protocol requests","bids_for_protocols_and_modules":"Protocol and module requests","buttons":{"appointProtocol":"Assign a protocol","cancel":"Cancel","createProtocol":"Create a protocol","request_new_protocol_or_module":"Request a new protocol / interactivity module","sendRequest":"Send request","submit_bids_to_curator":"Send the request to the curator","submit_for_approval_to_bsba":"Send for analyst approval"},"change_date":"Date changed","choose_a_client":"Choose the client","client":"Client","clients":"Clients","comment":"Comment","comment_must_be_at_least_n_characters":"Your comment must contain min. :count characters","comments":"Comments","create_date":"Date created","edit_bid":"Edit protocol request","enter_client_code_to_search":"Enter client code to search","header":"Requests","initiator":"Initiator","no_data":"No data","overdue":"Outdated","pagination":{"next":"Forward","previous":"Back"},"parent":"Parent","protocol_goal":"Aims","request_new_protocol":"Request a new protocol","short_description":"Brief Description","start_protocol":"Start entering the protocol title","status":"Status","statuses":{"Assigned":"Assigned","Being processed by the BCBA":"Being processed by the Analyst","Being processed by the curator":"Being processed by the curator","Being processed by the therapist":"Being processed by the therapist","Cancelled":"Cancelled","New":"New"},"therapist":"Therapist","type_the_procol_name_to_search":"Enter protocol title to search","view_bid":"View protocol request","write_protocol_goal":"Describe protocol aims"},"en.buttons":{"back":"Back","back_to_client":"Back to the client profile","cancel":"Cancel","continue":"Continue","edit":"Edit","save":"Save","send":"Send"},"en.contact_us":{"buttons":{"send":"Send"},"congrats":"Thank you! We will contact you soon!","errors":{"save_failed":"Failed to save the message"},"header":"Feedback","labels":{"captcha":"Security code","email":"Your email","message":"Message","name":"Your name"}},"en.dashboard":{"functionalInDevelopment":"Sorry, this functionaity is being developed","library":"Library","requestHelp":"Request assistance","sendComment":"Leave a comment","writeRequest":"Record a mand","writeUnwantedBehavior":"Record Inappropriate Behavior"},"en.dro":{"aim_types":{"Absence of target behavior":"Absence of target behavior","Presence of target behavior":"Presence of target behavior"},"back_to_reports":"Back to reports","behaviour_absence":"Absence of target behavior","behaviour_absent":"No target behavior observed!","behaviour_description":"Description of target behavior","behaviour_presence":"Presence of target behavior","behaviour_type":"Type of target behavior","behaviour_type_long":"Long","behaviour_type_short":"Short","behaviour_types":{"Long":"Long","Short":"Short"},"cancel":"Cancel","continue_session":"Continue the session","description":"Procedure description: reinforces absence/presence of the target behavior during the preset interval.","dro_module":"DRO/DRI module","duration_units":{"Minutes":"Minutes","Seconds":"Seconds"},"finish_session":"Finish the session","forbidden":"You have no access to this module for this client","hold_session":"Run the session","instructions":{"collapse":"Collapse","expand":"Expand","header":"Instructions:","text":"Procedure description: reinforces absence/presence of the target behavior during the preset interval."},"interactive_module":"Interactivity module","interactive_module_one":"Interactivity module 1","interactive_modules":"Interactivity modules","interval_duration_units":"Interval measurement units","interval_time_range":"Interval time","interval_time_range_minutes":"Interval time (1-100 min)","interval_time_range_seconds":"Interval time (1-300 sec)","list":{"absent":"None","interval":"Interval","interval_suffix":"","target_behaviour":"Moment of target behavior","time":"Interval time"},"min":"min","no_data":"No data","pagination":{"next":"Forward","previous":"Back"},"parameters":"Parameters","report":{"auditor":"Specialist","average_successful_interval_duration":"Average time of successful interval","behaviour_description":"Target behavior","behaviour_type":"Behavior type","client":"Client","date":"Date","download_report":"Download the report","fail_rate":"% of cleared","failed_interval_count":"Number of cleared","header":"Report on the session","header_mobile":"DRO/DRI report","interval_count":"Number of intervals","started_at":"Date","success_rate":"% of successful","successful_interval_count":"Number of successful"},"reports":"Reports","restart_timer":"Restart the timer","sec":"sec","start_session":"Start the session","subtitle":"Interactivity module 1.","target_behaviour":"Target behavior","title":"DRO/DRI implementation.","type":"Type"},"en.email":{"after_registered":{"body":{"lines":{"first":"AutismTech is glad to greet you, :displayName!","second":"You have successfully registered a new intervention team member (:userType)","third":"To enter the system, the user must launch mobile app (or follow :loginUrl using Chrome, Safarim \n                     Firefox browsers) and enter username :username, and password :password. Please share this information to the\n                     user and keep user data safely."}},"subject":"AutismTech: intervention team member successfully added"},"after_registration":{"body":{"lines":{"fifth":"System support service does not have access to your account credentials. if you forget your password,\n                    you may recover it by choosing \"Password recovery\" on :loginUrl. New password will be generated and sent \n                    automatically to the email you used for account registration.","first":"AutismTech is glad to greet you, :displayName!","fourth":"2 - use your credentials to enter. Username :username and password :password","second":"Now you can enjoy the benefits of behavior measurement and analysis automation system. Just follow the \n                    link :appUrl using latest versions of  Chrome, Safari, or Firefox browsers to setup the intervention,\n                    or mobile applications for your platform to perform measurements.","sixth":"Enjoy your behavior measurement!","third":"1 - go to :loginUrl or launch your mobile app"}},"subject":":appName registration successful"},"bcba_account_activated":{"body":{"lines":{"first":"AutismTech is glad to greet you, :name!","second":"You have been granted full access to behavior measurement, creating and editing intervention protocols,\n                    measurement results and report generation. Also, you may opt to create accounts for the members of your\n                    intervention team and client representatives.","third":"Enjoy your behavior measurement!"}},"subject":"AutismTech: full access to the analyst account."},"bcba_account_deactivated":{"body":{"lines":{"first":"AutismTech is glad to greet you, :name!","second":"System algorithms have suspended the benefits of your account.","third":"If you suspect it's a mistake, please refer to our support service: https://autismtech.online/contacts"}},"subject":"AutismTech: analyst account suspended"},"bcba_account_mensuration_forbidden":{"body":{"lines":{"first":"AutismTech is glad to greet you, :name!","second":"System algorithms have suspended some functions of your account. You still can view measurement results\n                    and export intervention protocol descriptions.","third":"If you suspect it's a mistake, please refer to our support service: https://autismtech.online/contacts"}},"subject":"AutismTech: your account functions have been limited"},"csv_report_generated":{"body":{"lines":{"first":"Hello, :displayName!","second":"CSV report since  :startDate till :endDate for the client :clientCode has been ready.","third":"You may download it in section Reports > Report Archive."}},"subject":"CSV report has been ready"},"layout":{"greeting":{"error":"Oops!","success":"Hello!"},"regards":"Best regards,","subcopy":"If you have encountered a problem with pressing the :actionText button, please copy and paste the following URL into your browser: [ :actionUrl ]( :actionUrl ), press the Enter button afterwards"},"new_subscription":{"body":{"lines":{"first":"Hello, :name!","second":"A new subscription request has been created in the system.","third":"Details you can see on the link :url"}},"subject":"New subscription request"},"new_subscription_comment_for_admin":{"body":{"lines":{"first":"Hello, :name!","fourth":"Details you can see on the link :url","second":"To subscription :id was added a new comment:","third":"\":comment\""}},"subject":"To subscription :id was added a new comment"},"new_subscription_comment_for_user":{"body":{"lines":{"first":"Hello, :name!","fourth":"Details you can see on the link :url","second":"To subscription: id was added a new comment:","third":"\":comment\""}},"subject":"To subscription :id was added a new comment"},"pdf_report_generated":{"body":{"lines":{"first":"Hello, :displayName!","second":"PDF report since  :startDate till :endDate for the client :clientCode has been ready.","third":"You may download it in section Reports > Report Archive."}},"subject":"PDF report has been ready"},"recovery_password":{"body":{"lines":{"first":"Hello, :bcbaDisplayName","fourth":"Share the password you have set for the user in a convenient and safe way.","second":"Your team member :username :userDisplayName requested password recovery.","third":"You can change password of the user in the user profile."}},"subject":"Password recovery request"},"reset_password":{"body":{"lines":{"first":"Hello, you received this message because we received the request to change the password to your account.","second":"Change password","third":"If you have not requested to change the password, ignore this message."}},"subject":"Reset Password Notification"},"subscription_status_active":{"body":{"lines":{"first":"AutismTech is glad to greet you, :name!","second":"You have been granted full access to behavior measurement, visual analysis and intervention report \n                    generation.To begin, please enter the system from the page :loginUrl using your username :username","third":"Enjoy your behavior measurement!"}},"subject":"Autismtech: you have full access to behavior management functions"},"subscription_status_finished":{"body":{"lines":{"first":"Hello, :name!","second":"Your subscription :id expired","third":"Details you can see on the link :url"}},"subject":"Your subscription :id expired"},"subscription_status_inactive":{"body":{"lines":{"first":"AutismTech is glad to greet you, :name!","fourth":"If you think it is a mistake, please contact the support service via https://autismtech.online/contacts","second":"System algorithms have changed your subscription :id status. Now it is inactive.","third":"Why did it happen? Explore via :url"}},"subject":"AutismTech: subscription for :id deactivated","title":"Subscription deactivation"},"subscription_status_new":{"body":{"lines":{"first":"Hello, :name!","second":"Your subscription :id has been approved by the administrator and will be activated when the subscription begins","third":"Details you can see on the link :url"}},"subject":"Your subscription :id has been approved by admin"}},"en.errors":{"choose_curator_from_list":"Choose the curator from the list","choose_therapist_from_list":"Choose the therapist from the list","create_comment":"You may not create comments","delete_comment":"You may not delete this comment","edit_comment":"You may not edit this comment","reset_password":"Failed to change the password","save_comment":"Failed to save the comment","send_token":"User Not Found","session_expired":"Your session has been expired. Please, sign in.","something_wrong":"Something went wrong.","try_later":"Please try again or contact the administrator.","view_comments":"You may not view the comments","view_not_own_notifications":"You may not view notifications of other people"},"en.export":{"reports":{"dro":{"auditor":"Specialist who conducted the session","average_successful_interval_duration":"Average time of successful interval","behaviour_description":"Description of target behavior","behaviour_type":"Behavior type","client":"Client","fail_rate":"% of cleared","failed_interval_count":"Number of cleared","header":"Report on the session","interval_count":"Number of intervals","not_specified":"No data","started_at":"Date and time","success_rate":"% of successful","successful_interval_count":"Number of successful"},"random_rotation":{"auditor":"Specialist who conducted the session","block":"Block","block_count":"Overall number of trials","client":"Client","fail_rate":"% of incorrect responses","header":"Report on the session","incomplete_rate":"% of incomplete trials","prompt_rate":"% of prompts","result":"Result","session":"Session","started_at":"Date and time","stimulus":"Stimulus","success_rate":"% of correct responses"}}},"en.home":{"labels":{"home":"Home","loading_message":"Please wait a bit, loading is in process","loading_message_table":"Please wait a bit, the table is loading"}},"en.instruction":{"collapse":"Collapse","default_text":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis","expand":"Expand","header":"Instructions:"},"en.ios":{"creating_new_dro_session_confirmation":"Creating a new session will lead to unsaved DRO/DRI session data loss. Create new session?","download_appeals_for_client":"Download mands  for %client%","download_client_list":"Download client list","download_dro_sessions_for_client":"Download DRO/DRI  sessions for %client%","download_protocols_for_client":"Download protocols for %client%","download_random_rotation_sessions_for_client":"Download  random  rotation sessions for %client%","download_typical_undesirable_behaviors_and_appeal_for_client":"Download typical IB  and  M for  %client%","download_undesirable_behaviors_for_client":"Download IB for %client%","logout_impossible":"Quitting the system is impossible before sending all the data to the server. Please connect to the network and try again.","no_connection":"No Internet carrier.","synchronize":"Synchronize","synchronize_impossible":"Synchronizing is impossible without the Internet carrier.","synchronize_on":"Synchronized on","upload_appeals":"Upload mands","upload_bids":"Upload requests for protocols and interactivity modules","upload_data_to_server":"Upload data to the server","upload_dro_sessions":"Upload DRO/DRI sessions","upload_protocols":"Upload protocols","upload_random_rotation_sessions":"Upload random rotation sessions","upload_typical_undesirable_behaviors_and_appeals":"Upload typical IB and M","upload_undesirable_behaviors":"Upload IB"},"en.login":{"buttons":{"login":"Enter"},"i_consent_to_data_processing":"I agree with data processing","labels":{"forgot":"Password recovery","login":"Sign in","logout":"Sign out"},"unable_to_sign_in":"Unable to authorize"},"en.pagination":{"next":"Forward","previous":"Back"},"en.passwords":{"password":"Passwords must be at least six characters and match the confirmation.","password_subscription":"We recommend to have 8-16 characters in your password","reset":"Your password has been reset!","sent":"We have e-mailed your password reset link!","token":"This password reset token is invalid.","user":"We can't find a user with that e-mail address."},"en.profile":{"address":"Address","client_count":"Client count","clinic_center":"Clinical center","delete_logo":"Delete logo","displayName":"User","download_logo":"Load the logo","edit_clinic_center":"Edit clinical centre","firstName":"First name","lastName":"Last name","legalName":"Legal Name / Company number / Taxpayer number","name":"Name","name_clinic_center":"Clinical centre name","other_contact":"Other contacts","phone":"Phone","price":"Price","profile":"Profile","settings_task_type":"Checklist settings","status":"Status","subscriptions":"Subscriptions","subscriptionsSubtitle":"Data on current and previous subscriptions","username":"Identifier"},"en.protocol":{"OffPhaseModalTitle":"You intend to inactivate stage :phaseName.\n Stimuli of the :phaseName will be inaccessible within the current stage. \n If you intend to work with these stimuli, please move these stimuli to another phase.","absent":"No","active_protocols":"Active protocols","addCategory":"Add a category","addCheckList":"Attached data sheets","addEnvironment":"Add the environment","addProperty":"Add a attribute","addStep":"Add step","add_a_mand_reaction":"Add a mand reaction","add_a_stimulus":"Add a stimulus","add_interval":"Add interval","add_level":"Add new prompt level","add_minus_spo":"Use cold probe \"-\" results","add_new_protocol":"Assign a new protocol","add_new_stimulus":"Add new stimulus","add_plus_spo":"Use cold probe \"+\" results","add_to_set":"Add stimuli to set","after_one_lesson":"Each second session","after_three_classes":"Each fourth session","after_two_classes":"Each third session","all_attempts_past":"All trials for all stimuli completed.","all_field":"All field","all_intervals":"All intervals","all_phases":"All phases","all_stage":"All stages","answer_title":"Mand reaction ( chosen data recording sheet)","area":"Skill domain","assignDate":"Date assigned","assimilate_stimulus":"Stimuli mastered: :attribute","attempt":"Probe","attempt_count":"Number of probes (if applicable)","attempts":"Probes","audial":"Audial","auto_save_version":"Pre-saved version","available_protocols":"Available protocols","average_percent":"Average independent, %","back_to_list":"Back to the list of stages","baseLavel":"Basis level","base_level":"Basis level","bids":"Requests","bids_for_protocols":"Protocol requests","blocks":"blocks","body_parts":"Body parts","buttons":{"add":"Add","addMandReaction":"Add mand-reactions","addNewProtocol":"Assign a new protocol","addProtocol":"Assign the protocol","addStage":"Add a stage","addStimulus":"Add a stimulus","addСriterion":"Add a criterion","allow_mensuration":"Allow mensuration","apply_changes_to_protocol":"Apply protocol changes","back_to_protocol":"Back to the protocol","cancel":"Cancel","choose_stimulus":"Use the stimuli from the stage chosen","close_protocol":"Close protocol","collapse":"Collapse","conductTherapeuticSession":"Run therapeutic session","continueTherapeuticSession":"Continue therapeutic session","create":"Create a new protocol","createNotPublish":"Save as draft","delete":"Delete","duplicate":"Дублировать","duplicate_stage":"Duplicate the stage","edit":"Edit","editTasks":"Edit the data sheet","expand":"Expand","export":"Export","finishCurrentStage":"Finish current stage","finishEnvironment":"Finish the environment","finishStage":"Finish the stage","goToExercises":"Go to activities","hideAll":"Collapse all","leave_session":"Back","newTasks":"Fill the data sheet","no":"no","removeMandReaction":"Delete mand-reactions","removeStage":"Delete a stage","removeStimulus":"Delete the stimulus","removeСriterion":"Delete criterion","results":"Results","resultsMeasurementsCurrentDay":"Today measurement results","save":"Save protocol","saveTasks":"Save the data sheet","save_and_allow_mensuration":"Save and allow mensuration","save_session":"Save","sendRequest":"Send a request","showAll":"Expand all","start_new_session":"Start the new session","yes":"yes"},"category":"category","categoryTitle":"Category:","chain_mastered_chart":"Graph of the chain in the environment","chain_step_chart":"Graph of chain steps masterred in the environment","change_criteria":"Change current criterion","change_criteria_title":"Upon changing the current  criterion, all subsequent ones will be  marked as not mastered yet","change_criterion_position":"To change criterion order, please drag the criterion to the required position in the criterion list.","change_date":"Date edited","change_environment_position":"Tho change the order of environments not yet engaged, please drag the environment to the required position in the list.","change_mand_reaction_position":"To change mand target order, drag the target to the appropriate position in the mand target list","change_popup_title":"Save changes to protocol as","change_stage_position":"To change the stage order for inactive stages please drag the stage to the required position in the stage list.","change_step_position":"To change the order of steps, please drag the step to the required position in the list.","change_stimul_position":"To change the stimulus order please drag the stimulus to the required position in the stimulus list","changes":"Changes","changesSaved":"Session saved successfully","changes_date_text":"Attention: changes to the previous sessions are accepted only if these changes are after the date of the last change to the protocol.","changes_type":"Change type","chart_properties":"Wykres procentowy prawidłowego wykorzystania karty preferowanej właściwości","chart_properties_per_day":"Number of correctly used cards of preferred attributes in each block of the daily session","chart_properties_percent":"Graph: Share of correct usage of preferred item card usage","chart_properties_percent_per_day":"Share of corect usage of preferred attributes in each block of the daily session","check-list":"Data sheet","checkList":"Data sheet","chooseEnvironment":"Choose the environment","chooseLevel":"choose Level","choosePreferred":"Choose the preferred attribute","chooseStage":"Choose the stage","choose_chain_stage":"Please select the environment for training with the step.","choose_field":"Choose field","choose_interval":"Choose interval","choose_mand_stage":"Please select the stage for training with the simulus.","choose_phase":"Choose phase","choose_protocol":"Choose the protocol from the list","choose_shaping_stage":"Please select the environment for training with the criterion.","choose_stage":"Choose stage","choose_step":"Choose step","choose_stimul_chart":"Show charts","close_protocol":"Finish protocol","code1":"ABBLS","code2":"VB-MAPP","color":"Color","comment":"Specialist comment","completed_protocols":"Completed protocols","completionCriteria":"Completion criteria","compliance_check":"Correspondence check","condition_mastered":"reactions within","condition_mastered_prop":"Criterion of attribute mastering","condition_mastered_usd":"Condition of mastering the stimuli set","condition_next":"Condition of returning stimuli to the next prompt level","condition_procent":"% of independent reactions within session","condition_return":"Condition of returning stimuli to the previous prompt level","condition_session":"trials each","condition_tranfer":"Criterion of stimulus mastering for the phase","condition_tranfer_maintain":"Criterion of stimulus mastering for the extended trial","condition_tranfer_rotation":"Move stimuli to","condition_trial":"consequent daily sessions with min ","conductingTherapeuticSession":"Running therapeutic session","confirm_change":"Your previous data will be deleted","confirm_close":"Do you confirm closing the stage?","confirm_close_all":"Finalizing the last stage will finalize the whole protocol. Do you confirm finalizing the protocol?","confirm_close_all_env":"Finalizing the last environment will finalize the whole protocol. Do you confirm finalizing the protocol?","confirm_close_env":"Do you confirm closing the environment?","confirm_close_protocol":"Do you confirm closing the protocol?","confirm_delete":"Attention! All data for the stimulus within this protocol will be deleted. Please press \"Save\" if you agree","confirm_delete_category":"Attention! All trial data re. this category recorded in this protocol will be deleted. If you agree, please press Save button","confirm_delete_mand":"Attention! All data for the mand within this protocol will be deleted. Please press \"Save\" if you agree","confirm_delete_property":"Attention! All trial data re. this attribute recorded within this protocol will be deleted. If you agree, please press Save button","confirm_delete_stimulus":"Will stimulus for the current stage be replaced?","confirm_save_conflict_session":"The protocol was changed. Your data will be stored in conflict sessions.","conflict_sessions":"Сonflict sessions","continue_or_new":"Continue current session or start a new one","continue_previous":"Continue the curruent one","copy":"copy","countSamples":"Number of attempts to reach the criterion","countSamplesAxes":"number of attempts","count_properties":"Count attributes","count_properties1":"Count attributes 1","count_properties2":"Count attributes 2","count_properties3":"Count attributes 3","count_properties4":"Count attributes 4","count_reaction":"Independent stimuli per stage ","count_stimul":"Stimuli in rotation","create_date":"Date created","criteria":"Criteria","criteria_end_protocol":"Criterion for protocol completion","criteria_end_session":"Criterion of session finish on the current day","criteria_end_teaching":"Criterion of learning completion for one stimulus","criterion":"Criterion","criterionDirectionSession":"Session completion criterion","criterionLearningStimulus":"Stimulus teaching completion criterion","criterion_count":"Number of criteria in the environment","criterion_required":"Criterion field is obligatory to fill.","cumulative_category":"Number of correctly used cards of preferred attributes for category :CategoryName","cumulative_category_relative":"Share of corect usage of preferred attribute/item card :CategoryName","cumulitive_graph":"Cumulative graph of mastered stimuli","currentEnvironment":"Current environment","currentLevel":"Current level","currentStage":"Current stage","current_criterion":"Current criterion","date":"Date","date_first_session":"First session date","date_mastering":"Mastered date","day_session":"daily sessions at min.","delay":"delay  :sec sec","delay_none":"no delay","deleteCategory":"Delete the category","deleteProperty":"Delete the the attribute","delete_criteria_title":"This stimulus is a current one for  one of the stages. Continue removal?","delete_set":"This operation will break the stimulus set(s). Continue?","describeCategory":"Describe the category  :number","describeEnvironment":"Describe the environment :number","describeImplementation":"Describe the activity","describeMandReaction":"Describe mand target :number","describeProperty":"Describe the the attribute","describeStage":"Describe stage :number","describeStep":"Describe step :number","describeStimulus":"Describe the stimulus :number","describeСriterion":"Describe the criterion :number","descriptionPart":"Description part","description_on_delete":"После удаления должен остаться хотя бы один включенный критерий","detail_reaction_session":"Detailed workflow graph with reactions in the chosen session","detail_shaping_chart":"Detailed workflow graph with reactions in the chosen session","detailed_result":"Detailed result","directory_types":{"Teaching method":"Teaching method"},"disable":"Disabled","distinctive_properties":"Distinctive properties","dtt_phase_title":"Setup protocol phase stages","dtt_title":"DTT protocol stage settings","duration":"Session duration, min","editProtocol":"Edit the protocol","editor":"Changed by specialist","enable_recording":"Enable recording of Correct, Prompted and Errorneous response","endSession":"Save the session","end_protocol_date":"Protocol completion date","end_session_date":"Date of the latest session","enter_another_session_date":"Please enter another session date. The date of the session should be later than the latest session. Actual data was collected ","enter_session_date":"Enter the date of the session. Last data was collected on: ","entered_session_date":"Enter the date of the session.","environment":"Environment","environment_number":"Environment :count","environments":"Environments","errorCorrection":"Error correction","errorEnvironmentsCount":"Please setup at least one environment","errorPhaseCount":"Please activate at least one phase","errorResult":"Number of the stimul chosen must be 3","errorStages":"Please choose the checklist","errorStagesCount":"Please setup at least one stage","execution":"Intervention","executionSeconds":"Correct reaction within :time seconds","executionSecondsLimit":"Correct reaction within seconds ","exercise":"Activity","exercises":"Exercises","features":"Peculiarities","field":"Field","first_probe":"first probes in each of them","fluency":"Fluency","form":"Form","from":"из","full_physical":"Full physical","full_verbal":"Full verbal","gesture":"Gesture","goToSPO":"Proceed to СPE","goal":"Aim","graph_cumulative_improve":"Cumulative graph of С+, C and P","graph_goal":"Graph of C+, C and P with prompts","graph_improve":"Cumulative graph of Im+","graph_improve_prompt":"Graph Im+, relation between Im+ count and total trial count","graph_improved_spou":"Graph % improved reactions","graph_mand_react":"Graph of free mand frequency reaction","graph_mo_goal":"Graph of MO (MO - \"yes\")","graph_mo_yes":"Graph: % of probes with MO \"yes\"","graph_mo_yes_percent":"Graph: % of 1st probes with MO \"yes\"","graph_probe_full":"Graph of C+ + C and P with visible item to overall probe count within the session","graph_prompt_levels":"Graph of prompt levels","header":"Protocol","himself_percent":"Independent, %","hint_sub_title":"There are 10 prompt levels available. You may use the number of levels you require.","hint_type":"Prompt type","i_want_card":"I want card","important":"important","inessential":"inessential","instruction":"Instruction","interactivity_module":"Interactivity module","interval":"Interval","interval_count":"Repeat number ","interval_error":"Min. 1 interval must be selected","interval_name":"Interval title","introduced":"Introduced","item_card":"Item card","items":"Items","lastLesson":"Last session","last_measurement_results":"Last measurement results","last_session":"Last session","left":"left","level":"Level","levelLine":"Level line","levelTitle":"Level","levels":"Levels","listCategories":"Category list","list_of_mand_reaction":"Mand target list","list_of_stimulus":"List of stimulus","logEndCriteria":"Protocol completion criterion","make_criteria_current":"Make the criterion current","make_current":"Make a current one","make_first":"Make first","make_last":"Make last","mand_date":"Probe dated","mand_level":"Mand level (free mand or with visible object)","mand_required":"Mand-reaction is required.","master":"Master","master_criterion":"Master the criterion","mastered":"Transferred","mastered_criteretion":"Condition of mastering the criterion","mastered_criterion":"Criterion mastered","mastered_mand":"Mastered","mastered_stimuli":"Mastered stimuli","mastered_stimulus":"Mastered","mastering":"Learning","mastering vcd":"Learning","mastering_btn":"mastering","mastering_chart":"Schedule of protocol mastering","mastering_chart_phase":"Schedule of protocol mastering phase","mastering_chart_stage":"Schedule of protocol mastering stage","mastering_criteria":"Criteria of mastering","mastering_percent":"Protocol mastering, %","mastering_table":"Protocol mastering","materials":"Materials","max_count_for_session":"Total max count of probes within session must not exceed: 3000","max_field_count":"Max. number of fields","measured":"Measured","measurement_date":"Date run","min_field_count":"Min. number of fields","minor":"minor","motivation_condition":"Motivational Operation","moveFieldTitle":"Stimuli on fields :min to :max will be moved to closest available fields","n_sessions_with_n_blocks":":sessionCount sessions :sessionBlockCount blocks each","nameCategoryProperty":"Category/Attribute","name_criterion":"Criterion title","name_mand_reaction":"Target mand reaction","name_step":"Step title","newProtocol":"New protocol","next_block":"Next block","next_criterion":"Next criterion","next_session":"Next session","next_support":"Move to the support phase","noAvailableTeachingMethod":"No available teaching methods","no_available_protocols":"No available protocols","no_available_set_create":"No available stimuli for creating the set","no_data":"No data","no_list_category":"No categories available for training","no_list_property":"No attribute available for training","no_title":"Untitled","nodata":"No data","notPublish":"Draft","number_of_trials":"Trial number","of_protocol":"of the protocol","offButton":"Off","once_a_month":"Once a month","once_a_week":"Once a week","once_every_two_weeks":"Once a fortnight","one_trial":"One trial","pagination":{"next":"Forward","previous":"Back"},"partial_physical":"Partial physical","partial_verbal":"Partial verbal","pecs":{"control_of_achievements":"Achievement monitoring.","countSamples":"Number of attempts to match target criterion","go_to":"Go to","next_probe":"Next probe","step_one":"Step 1","step_three":"Step 3","step_two":"Step 2","table_mastered":"Table of step introduction and mastering","table_mastered_step":"Table of target sequence introduction and mastering","table_mastered_target_sequence":"Table of target sequence introduction and mastering","table_mastered_target_sequence_pwd":"Table of target sequence introduction and mastering","target_sequence":{"get_album":"Get Album","get_i_want_card":"Get the card \"I want\" from the album","get_reinforcement_item_card":"Get a card with a picture of a reinforcement item from the album","get_template":"Get a template for proposals from the album","give_template":"Give a template for suggestions to the Interlocutor","put_i_want_card":"Place “I want” card on the proposal template","put_reinforcement_item_card":"Place this card on the proposal template","read_sentence":"Reading a sentence on a template"},"target_sequence_title":"Target sequence","without_discrimination_target_sequence":{"get_album":"Get Album","get_card_desired_item":"Take the desired item card","get_i_want_card":"Get the card \"I want\"","get_target_property_item_card":"Take the card showing the target feature of an item","get_template":"Get a template for proposals from the album","give_template":"Give a template for suggestions to the Interlocutor","put_card_desired_item":"Place the desired item card onto the sentence template","put_i_want_card":"Place “I want” card on the proposal template","put_target_property_item_card":"Place the card displaying the target feature of an item onto the sentence template"}},"percent_block":"% of independent reactions and prompts within ","percent_next_block":" of independent reactions within ","percent_reaction":"of independent responses during","phase":"Phase","phase_fluency":"Fluency phase","phase_mastering":"Learning phase","phase_rotation":"Generalization phase","phase_stimuli":"Stimuli on phase","phase_support":"Maintenance phase","position":"Position","positional":"Positional","prev_block":"Previous block","probe_by_session":"Probes per session","promptType":"Prompt type","properties_without_discrimination":"Properties without discrimination","property":"attribute","propertyTitle":"Attribute","protocol":"Protocol","protocol_dtt":"DTT protocol ","protocol_goal":"Protocol aims","protocol_status":"Protocol status","protocols":"Protocols","providingHint":"Prompting","quantity":"Quantity","reactions":"Aims","reading_sentence":"Reading sentence","recommendation":"Recommendation","recordData":"Data record (type)","recording_method":"Data Recording Method","reducingPromp":"Prompt fading criterion","reducingTooltip":"Prompt fading method","reduction_hint_method":"Prompt fading method","removeEnvironment":"Remove environment","removeStage":"Delete a stage","removeStep":"Remove step","repeat":"Repeat ","requestNewProtocol":"New protocol requirement","requests":"Status","requiredCheckList":"Data sheet for all stages are required","requiredStepsList":"Steps-lists for all environments are required","requiredStimulList":"Stimul-lists for all stages are required","response":"Response","responses":"Responses","result":"Result","result_assigned_session":"Therapeutic session results","result_last_assigned_session":"Last therapeutic session results","result_of_protocol":"Protocol summary","result_of_stage":"Stage results","results":"Results","results_of_stages":"Protocol summary by stage","results_of_the_protocol":"Protocol results","results_protocol_title":"Stage efficiency chart","risingPrompt":"Prompt increase criterion","rotation":"Generalization","save_session_date":"Save session date","save_set":"Please save current changes for training with the current set","scatterLine":"Data spread line","selectTemplate":"Choose the template","select_attempt":"Record data for elements 4 and 5 of the target sequence","session":"Session","set":"Set","sets":"Sets","setup_distinctive_properties":"Phase Distinctive properties","setup_fluency":"Fluency settings","setup_i_want_card":"Phase I want card","setup_item_card":"Phase Item card","setup_mastering":"Mass trial settings","setup_properties_without_discrimination":"Phase Properties without discrimination","setup_reading_sentence":"Phase Reading sentence","setup_rotation":"Rotation settings","setup_stimuli":"Stimulus setup :title","setup_support":"Recurrent trial settings","shaping_chart":"Assessment and analysis of behavior change in the environment","shaping_last_session_chart":"Assessment and analysis of behavior change within the previous session","short_description":"Brief description","shortcut_enabled":"Add to the instant access menu","shortcut_menu_title":"Title in the instant access menu","showChangeDateSession":"Enter the data of previous periods","showGraphsTitle":"Show graphs in the report","show_on_environment":"Display for the environment","show_on_level":"Display at level","show_on_stage":"Display at stage","size":"Size","skillField_and_code":"Skill field name or code","speed":"Speed","spontaneous_level":"FM","stage":"Stage","stage_choose_from":"Level (choose from)","stage_count":"Stage number","stage_number":"Stage :count","stage_number_of_stage_count":"Stage :stageNumber of :stageCount","stages":"Stages","stages_stimuli":"Stimuli on stages","startTraining":"Learning started on","start_new":"Start a new one","start_session_date":"Start session date","started_at":"Started","status":"Status","statuses":{"Active":"In process","Completed":"Completed","Individualization":"Individualization","Maintaining":"Maintenance","New":"New","supporting":"Maintenance"},"step":"Step","step_count":"Number of steps per stage","step_required":"Step  is required.","steps":"Steps","stimul_count":"Total","stimul_settings":"To configure stimul-lists, select stimul and click the edit button","stimul_table_header":"Transfer history for stimuli with trials within the chosen timeframe","stimuls":"стимула","stimulus":"Stimulus","stimulus_count":"stimulus","stimulus_improved_chart":"Improved reaction chart for the stimulus:","stimulus_intervals":"Set stimulus repeat intervals","stimulus_list_empty":"No stimuli for СPE check-list.","stimulus_mastering_chart":"Independent chart:","stimulus_name":"Target stimulus","stimulus_prompt_chart":"Prompt fading chart for the stimulus:","stimulus_required":"Stimulus is required.","stimuluses":"Stimuli","subjects":"Item","support":"Maintenance","support_stimulus":"Stimuli in rotation","support_subtitle":"Switching intervals on or off as well as changing recurrency rate does not lead to automatic movement to new available intervals. Please move stimuli to available intervals manually.","synthesisStrategy":"Generalization strategy","table_mastered_category":"Table of starting and mastering catogories at levels","table_mastered_category_name":"Table of starting and mastering catogories:","table_subtitle":"To build a graph, please choose a stimulus from the table above","taskType":"Data record (view)","task_in_row":"sessions in a row","task_prompts":{"descriptions":{"L1":"hand on palm","L2":"hand on forearm","L3":"hand on elbow","L4":"hand shoulder","audio":"audial","full_physical":"full physical","full_verbal":"full verbal","gestural":"gesture","modeling":"modeling","partial_physical":"partial physical","partial_verbal":"partial verbal","positional":"positioning","textual":"textual","visual":"visual"},"main_description":"You may change contracted prompt titles to ones you actually use.","main_title":"Prompt setup","titles":{"L1":"PP1","L2":"PP2","L3":"PP3","L4":"PP4","audio":"А","full_physical":"FP","full_verbal":"FV","gestural":"G","modeling":"MD","partial_physical":"PP","partial_verbal":"PV","positional":"P","textual":"T","visual":"V"}},"task_type":"Data sheet type","task_types":{"answers":{"+":"+","-":"-","C":"C","C+":"C+","C1":"C","C6":"C","E":"E","E6":"N","FU":"FU","L1":"PP1","L2":"PP2","L3":"PP3","L4":"PP4","NM":"NM","NR":"NR","NR6":"O","P":"P","U":"Im","U+":"Im+","UG":"Sc","audio":"А","descriptions":{"+":"completed at once","-":"no reaction, error","C":" independent with verbal prompt of  \"do this way\" type","C+":"correct independent","C1":"independent","C6":"independent with visible tangible","E":"error","E6":"incorrect response","FU":"full Assistance","NM":"no motivation","NR":"no reaction","NR6":"no response","P":"prompt","U":"improved","U+":"improved","UG":"scrolling","no_data":"no data"},"full_physical":"FP","full_verbal":"FV","gestural":"G","modeling":"MD","no_data":"N/D","partial_physical":"PP","partial_verbal":"PV","positional":"P","textual":"T","titles":{"+":"+","-":"-","C":"C","C+":"C+","C1":"C","C6":"C","E":"E","E6":"N","FU":"FU","NM":"NM","NR":"NR","NR6":"O","P":"P","U":"Im","U+":"Im+","UG":"Sc","no_data":"N/D"},"visual":"V"},"descriptions":{"cold_probes":"Only the first reaction per day is recorded: mark \"+\" if completed at once, or \"-\" if no reaction, error or inappropriate behavior observed.","cold_probes_major":"Only the first reaction per day is recorded: mark \"+\" if completed at once, or \"-\" if no reaction, error or undesired behavior observed.","cold_probes_settings":"Only the first reaction per day is recorded and mark.","probe_analysis_c_plus_cpfueub":"C+ - correct independent, without verbal assistance, C - independent with verbal prompt of  \"do this way\" type, P - prompt, FU - Full Assistance, E - Error (another movement), NR - Undesired behavior, no reaction even after the prompt.","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"C+ - independent, w/o visible tangible, C - independent w/visible tangible, Im+ - improved response, Sc - Scrolling, NR- no response, P - prompt, I - Incorrect response, NM - no motvation","probe_analysis_cpe":"С - independent; P - prompt; E - error (another movement).","probe_analysis_cpenr":"С - independent; P - prompt; E - error; NR - UB, no reaction after prompting.","probe_analysis_cpeu":"С - independent; P - prompt; E - error (another movement), Im - improved response."},"titles":{"cold_probes":"Cold probes","cold_probes_major":"Cold probes - extended","probe_analysis_c_plus_cpfueub":"Probe analysis С+СPFuEUb","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"Probe analysis (СС+Im+ScNRPINM)","probe_analysis_cpe":"Probe analysis CPE","probe_analysis_cpenr":"Probe analysis CPENr","probe_analysis_cpeu":"Probe analysis CPEU"}},"teachingFormat":"Learning format","teachingMethod":"Teaching method","teaching_methods":{"Chain":"Chaining","DTT":"Discrete Trial Teaching Method (DTT)","Desensibilization":"Desensibilization","Features with items":"Alternative Communication: protocol for features with items","Mand Vocal":"Vocal Mand","NET":"NET","Pecs":"PECS","Pecs Properties Without Discrimination":"Alternative Commnuication: features without discrimination","Pecs Sentence Structure":"Alternative communication: sentence structure","Pecs With Discrimination":"Alternative Communication: protocol for features with discrimination","Random learning":"Incidental Teaching","Reaction forming":"Shaping","Shaping":"Shaping","Simple (Chain, Shaping)":"Simple","VCD":"Verbal Conditional Discrimination (VCD)","Десенсибилизация":"Desensibilization","Случайное обучение":"Incidental Teaching","Формирование реакций":"Shaping","Цепочка":"Chaining"},"temperature":"Temperature","textual":"Textual","texture":"Texture","therapeuticSession":"Therapeutic session","through_each_lesson":"Each session","title":"Protocol title","title_chain":"Chaining in the environment ","title_mand_reaction":"Mand training protocol","to_field":"to field","to_next_phase":"to next phase","to_prev_phase":"back to previous phase","to_rotation":"to rotation","to_support":"to support","today_support_stimulus":"Stimuli in rotation today","total_himself":"Overall, independent","total_percent":"independent, %","total_percent_graph":"Independent graph, %","track_change_level":"Track prompt change level","tracked_change_level":"Tracked prompt change level","tracked_reactions":"Reactions recorded","transfer_to_rotation":"Moved to rotation","transfer_to_support":"Moved to extended trial","trendLine":"Trend line","trendLineTitle":"Show graph lines","trial_count":"Trial count","trial_in_row":"trials in a row","trueReaction":"Correct reaction","unable_to_delete_protocol":"Unable to delete protocol","unique_criterion":"Criteria must not duplicate","unique_mand":"Mand-reaction must not repeat","unique_step":"Steps  must not repeat","unsaved_changes":"There are unsaved changes","unwanted_behavior":"Inappropriate behavior","view_auto_save":"view the pre-saved version","visual":"Visual","whole_period":"Whole period","withFields":"Show/hide field","with_subject":"VO","withoutProperties":"No exercises to train."},"en.quiz":{"addToReport":"Add to the report","answered":"Answered","answersDetail":"0=Never, 1=Almost Never, 2=Seldom, 3=Half the Time, 4=Usually, 5=Almost Always, 6=Always","answersDetailFast":"0=no, 1=yes, 2=do not know","assignToClient":"What is your relationship to the client?","assigned":"Assigned","assigned_specialist":"Evaluator","backToQuizList":"Return to the screening list","chooseQuiz":"Choose screening type","chooseSpecialist":"Choose the specialist","client":"Client","completePart2":"Complete Part II if you answered \"Yes\" to item 1,2, or 3.  Skip Part II if you answered \"No\" to all three items in Part I.","completeWith":"Done with","countYes":"Number of positive answers","createQuiz":"New screening","created":"Created","created_by":"Spent","dateAndTime":"Date and time","description":"Description","editQuiz":"Edit scoring tool","enterNameSpesialist":"Start entering the name of the specialist","errorDelete":"Scoring tool can not be deleted. This scoring is completed","errorEdit":"Scoring tool can not be edited. This scoring is completed.","errorResult":"Number of the specialists chosen must be between 2 and 3","errorTargetValue":"The target behavior field is required.","fast":{"answers":{"titles":["No","Yes","Self-care","Academic","Work","Other","Self-care routines","Academic Skills Training","Leisure Activities","Evenings","Meals","Vocational Training","When the student has nothing to do"]},"description":"The FAST identifies factors that may influence problem behaviors. Use it only for screening \n            as part of a comprehensive functional analysis of the behavior. Administer the FAST to several individuals \n            who interact with the client frequently. Then use the results to guide direct observation in several \n            different situations to verify suspected behavioral functions and to identify other factors that may \n            influence the problem behavior.","general_questions":{"informant_client_relationship":{"questions":{"1":"Indicate your relationship to the person:","2":"How long have you known the person?","3":"Do you interact with the person daily?","4":"In what situations do you usually interact with the person?"},"title":"Informant-Client Relationship"},"problem_behavior_information":{"answers":{"1":"Hourly","2":"Daily","3":"Weekly","4":"Less often","5":"Client's health is not at risk","6":"Behavior can harm the client's health at certain extent","7":"Behavior can severely harm the client's health"},"questions":{"1":"Label or briefly describe the inappropriate behavior","2":"How often do you observe inappropriate behavior? (hourly / daily / weekly / monthly)","3":"How long does the behavior last","4":"Behavior severety (choose the most matching option)","5":"Which situations the behavior is most likely to occur (persons present, activities, days/times, etc.)","6":"Which situations the behavior is least likely to occur (persons present, activities, days/times, etc.)","7":"What happens right before the behavior occurs (changing a tutor / instruction to complete a certain task, etc.)","8":"What happens right after the behavior occurs (changing a task / provides access to a toy, etc.)","9":"What do you usually undertake to correct the behavior?"},"title":"Answer the questions on inappropriate behavior"}},"questions":{"titles":{"1":"Does the problem behavior occur when the person is not receiving attention or when caregivers are \n                paying attention to some one else?","2":"Does the problem behavior occur when the person’s requests for preferred items or activities are \n                denied or when these are taken away?","3":"When the problem behavior occurs, do care-givers usually try to calm the person down or involve \n                the person in preferred activities?","4":"Is the person usually well behaved when(s) he is getting lots of attention or when preferred \n                activities are freely available?","5":"Does the person usually fuss or resist when(s) he is asked to perform a task or to participate in \n                activities?","6":"Does the problem behavior occur when the person is asked to perform a task or to participate in \n                activities?","7":"If the problem behavior occurs while tasks are being presented, is the person usually given a \n                “break” from tasks?","8":"Is the person usually well behaved when(s) he is not required to do any thing?","9":"Does the problem behavior occur even when no one is near by or watching?","10":"Does the person engage in the problem behavior even when leisure activities are available?","11":"Does the problem behavior appear to be a form of “self-stimulation?”","12":"Is the problem behavior less likely to occur when sensory stimulating activities are presented?","13":"Is the problem behavior cyclical, occurring for several days and then stopping?","14":"Does the person have recurring painful conditions such as ear infections or allergies?","15":"Is the problem behavior more likely to occur when the person is ill?","16":"If the person is experiencing physical problems, and these are treated, does the problem behavior \n                usually goaway?"}},"result_interpretation":"Circle the number of each question that was answered \"Yes\" and enter the number of \n            items that were circled in the “Total” column.","result_table":{"potential_source_of_reinforcement":{"automatic_pain":"Automatic   Reinforcement   (Pain Attenuation)","automatic_sensory":"Automatic   Reinforcement   (Sensory Stimulation)","social":"Social   Reinforcement   (Attention)","social_escape":"Social   Reinforcement   (Escape)","social_specific_activities":"Social Reinforcement   (access to Specific   Activities/Items)"},"titles":{"items":"Mark the question with the response \"Yes\"","potential_source_of_reinforcement":"Potential Source of Reinforcement","total":"Total"}},"title":"FAST"},"fastChart":"Multiple FAST diagram","fastTableTitle":"FAST scoring table","goToExercise":"Fill","goToQuiz":"Run screening","ifNoExplain":"If \"no\", how many hours per week?","ifOtherExplain":"If Other, please explain","ifYesExp":"If \"Yes\", please explain","ifYesExplain":"If \"yes\", how many hours per day","information":"Information about questionnaire","masChart":"Multiple MAS diagram","masTableTitle":"MAS scoring table","maxCountOfSpesialist":"Maximum number of specialists reached","meanScore":"Mean Score","meanScoreDescription":"(divide the total score by 4)","motivation_scale":{"answers":{"titles":["Never","Almost Never","Seldom","Half the Time","Usually","Almost Always","Always"]},"description":"Instructions:The Motivation Assessment Scale is a questionnaire designed to identify those \n            situations in which an individual is likely to behavior in certain ways. From this information, more informed\n             decision scan be made concerning the selection of appropriate reinforcers and treatments. To complete the MAS,\n             select one behavior that is of particular interest. It is important that you identify the behavior very \n             specifically. \"Aggressive\", for example, is not as good a description as \"hits his sister\". Once you have \n             specified the behavior to be rated, read each question carefully and circle the one number that best describes \n             your observations of this behavior.","general_questions":{"problem_behavior_information":{"questions":{"1":"Behavior Description","2":"Situations when inappropriate behavior is observed"},"title":"Behavior information"}},"information":"The MAS consists of 16 questions which describe situations in which the behaviour might \n            occur. All you have to do is circle how often (from never to always) the behaviour occurs in different \n            situations. When you have answered all 16 questions, you total the scores using a simple scoring sheet","questions":{"titles":{"1":"Would the behavior occur continuously, over and over, if this person were left alone for long periods of time? (For example, several hours)","2":"Does the behavior occur following a request to perform a difficult task?","3":"Does the behavior seem to occur in response to you talking to other persons in the room?","4":"Does the behavior ever occur to get a motivational item, food, or activity that this person has been told that he or she can'thave?","5":"Would the behavior occur repeatedly, in the same way, for very long periods of time, if no one were around? (For example, rocking back and forth for over an hour.)","6":"Does the behavior occur when any request is made of this person?","7":"Does the behavior occur whenever you stop attending to this person?","8":" Does the behavior occur when you take away a favorite motivational item,  food, or activity?","9":"Does it appear to you that this person enjoys performing the behavior? (It feels, tastes, looks, smells, and/or sounds pleasing.)","10":"Does this person seem to do the behavior to upset or annoy you when you are trying to get him or her to do what you ask?","11":"Does this person seem to do the behavior to upset or annoy you when you are not paying attention to him or her? (For example, if you are sitting in a separate room, interacting with another person.)","12":"Does the behavior stop occurring shortly after you give this person the motivational item, food, or activity he or she has requested?","13":"When the behavior is occurring, does this person seem calm and unaware of anything else going on around him or her?","14":"Does the behavior stop occurring shortly after (one to five minutes) you stop working or making demands of this person?","15":"Does this person seem to do the behavior to get you to spend some time with him or her?","16":"Does the behavior seem to occur when this person has been told that he or she can't do something he or she had wanted to do?"}},"result_interpretation":"If there is a tie for the highest score or if the means of the top two categories \n            are within .25 to .50points(and you have clearly specified the behaviour and setting),then both are considered \n            as influences that may be causing the problem behaviour to continue","result_table":{"results":{"mean_score":"Mean Score","relative_ranking":"Relative Ranking","total_score":"Total Score"},"titles":{"attention":"Attention","escape":"Escape","sensory":"Sensory","tangible":"Tangible"}},"title":"MAS"},"oneFastChart":"FAST diagram","oneMasChart":"MAS diagram","passed_at":"Finish date and time","pdfReport":"PDF report","pdfReportTitle":"Survey report","question_answers":"Question answers","question_titles":{"create_titles":{"fast":{"evaluator_information":{"questions":{"1":"How long have you known the client?","2":"Do you interact with the client on a daily basis?","3":"In what situations do you typically observe the person? (Mark all that apply)"},"title":"Evaluator Information"},"nonsocial_reinforcement":{"questions":{"19":"The behavior occurs frequently when the client is alone or unoccupied.","20":"The behavior occurs at relatively high rates regardless of what is going on in the \n                            client's immediate surrounding environment.","21":"The client seems to have few known reinforcers or rarely engages in appropriate object\n                            manipulation or \"play\" behavior.","22":"The client is generally unresponsive to social stimulation","23":"The client often engages in repetitive, stereotyped behaviors such as body rocking, \n                            hand or finger waving, object twirling, mouthing, etc.","24":"When the client engages in the behavior, you and others usually respond by doing nothing \n                            (e.g. you never or rarely attend to the behavior)","25":"The behavior seems to occur in cycles. During a \"high\" cycle, the behavior occurs \n                            frequently and is extremely difficult to interrupt. During a \"low\" cycle the behavior rarely occurs.","26":"The behavior seems to occur more often when the client is ill.","27":"The client  has a history of recurrent illness (e.g. ear or sinus infections, allergies, dermatitis, etc)."},"title":"Part III. Nonsocial (Automatic) Reinforcement"},"social_influences_on_behavior":{"questions":{"1":"The behavior usually occurs in your presence or in the presence of others.","2":"The behavior usually occurs soon after you or others interact with the client in some\n                            way, such as delivering an instruction or reprimand, walking way from (ignoring) the \n                            client, taking away a \"preferred\" item, requiring the client to change activities, \n                            talking to someone else in their presence, etc.","3":"The behavior often is accompanied by other \"emotional\" responses, such as yelling or crying."},"title":"Part I. Social Influences on Behavior"},"social_reinforcement":{"questions":{"4":"The behavior often occurs when the client has not received much attention.","5":"When the behavior occurs, you or others usually respond by interacting with the client \n                            in some way (e.g. comforting statements, verbal correction or reprimand, response blocking, redirection)","6":"The client often engages in other annoying behaviors that produce attention.","7":"The client frequently approaches you or others and/or initiates social interaction","8":"The behavior rarely occurs when you give the client lots of attention.","9":"The behavior often occurs when you take a particular item away from the client or when\n                            you terminate a preferred leisure activity.","10":"The behavior often occurs when you inform the client that they cannot have a certain \n                            item or cannot engage in a particular activity.","11":"When the behavior occurs, you often respond by giving the client a specific item, \n                            such a favorite motivational item, food, or some other item.","12":"The client often engages in other annoying behaviors that produce access to preferred items or activities.","13":"The behavior rarely occurs during training activities or when you place other types of\n                            demands on the client. If yes please identify the activities:","14":"The behavior often occurs during training activities or when asked to complete tasks.","15":"The client often is noncompliant during training activities or when asked to complete tasks.","16":"The behavior often occurs when the immediate environment is very noisy or crowded.","17":"When the behavior occurs, you often respond by giving the client a brief break from an ongoing task.","18":"The behavior rarely occurs when you place few demands on the client or when you leave them alone."},"title":"Part II. Social Reinforcement"}},"motivation_scale":{"main_questions":{"questions":{"1":"In case the client is alone, inappropriate behavior will be observed again and again?","2":"Inappropriate behavior will occur in case the client is instructed to complete a complex task","3":"Inappropriate behavior will occur in case an adult is talking to someone else","4":"Inappropriate behavior occurs after the client's demand to get a motivational item, food \n                        or access to a preferred activity  is declined","5":"The behavior will occur every time when the client is alone; the behavior will last for certain time","6":"Behavior will occur in case the client is instructed to complete a task","7":"The behavior will occur in case attention to the clinet is seized","8":"The behavior will occur in case access to the preferred item, food, or activitu of the client is seized","9":"The client displays signs of pleasure when engaged in inappropriate behavior","10":"When you instruct the client to complete a certain task, the client demonstrates inappropriate behavior to escape the task","11":"Does thу client seem to do the behavior to upset or annoy you when you are not paying \n                            attention to him or her? (For example, if you are sitting in a separate room, interacting \n                            with another person.)","12":"The behavior stops when you deliver preferred item, food, or propose a preferred activity to the client","13":"When the behavior occurs, it looks like the client does not pay attention to the environment","14":"The behavior stops right after you stop instructing the client to complete a certain task","15":"The behavior occurs to attract your attention","16":"The behavior occurs when you say the client can not access preferred item or activity"}},"problem_behavior_information":{"questions":{"1":"Behavior Description","2":"Situations when inappropriate behavior is observed"},"title":"Behavior information"}}},"show_titles":{"fast":{"evaluator_information":{"questions":{"1":"How long have you known the person?","2":"Do you interact with the client on a daily basis?","3":"In what situations do you typically observe the person? (Mark all that apply)"},"title":"Evaluator Information"},"nonsocial_reinforcement":{"questions":{"19":"The behavior occurs frequently when the client is alone or unoccupied.","20":"The behavior occurs at relatively high rates regardless of what is going on in the \n                            client's immediate surrounding environment.","21":"The client seems to have few known reinforcers or rarely engages in appropriate object\n                            manipulation or \"play\" behavior.","22":"The client is generally unresponsive to social stimulation","23":"The client often engages in repetitive, stereotyped behaviors such as body rocking, \n                            hand or finger waving, object twirling, mouthing, etc.","24":"When the client engages in the behavior, you and others usually respond by doing nothing \n                            (e.g. you never or rarely attend to the behavior)","25":"The behavior seems to occur in cycles. During a \"high\" cycle, the behavior occurs \n                            frequently and is extremely difficult to interrupt. During a \"low\" cycle the behavior rarely occurs.","26":"The behavior seems to occur more often when the client is ill.","27":"The client has a history of recurrent illness (e.g. ear or sinus infections, allergies, dermatitis, etc)."},"title":"Part III. Nonsocial (Automatic) Reinforcement"},"social_influences_on_behavior":{"questions":{"1":"The behavior usually occurs in your presence or in the presence of others.","2":" The behavior usually occurs soon after you or others interact with the client in some\n                            way, such as delivering an instruction or reprimand, walking way from (ignoring) the \n                            client, taking away a \"preferred\" item, requiring the client to change activities, \n                            talking to someone else in their presence, etc.","3":"The behavior often is accompanied by other \"emotional\" responses, such as yelling or crying."},"title":"Part I. Social Influences on Behavior"},"social_reinforcement":{"questions":{"4":"The behavior often occurs when the client has not received much attention.","5":"When the behavior occurs, you or others usually respond by interacting with the client\n                            in some way (e.g. comforting statements, verbal correction or reprimand, response blocking, redirection)","6":"The client often engages in other annoying behaviors that produce attention.","7":"The client frequently approaches you or others and/or initiates social interaction","8":"The behavior rarely occurs when you give the client lots of attention.","9":"The behavior often occurs when you take a particular item away from the client or when\n                            you terminate a preferred leisure activity.","10":"The behavior often occurs when you inform the client that they cannot have a certain \n                            item or cannot engage in a particular activity.","11":"When the behavior occurs, you often respond by giving the client a specific item, \n                            such a favorite motivational item, food, or some other item.","12":"The client often engages in other annoying behaviors that produce access to preferred items or activities.","13":"The behavior rarely occurs during training activities or when you place other types of\n                            demands on the client. If yes please identify the activities:","14":"The behavior often occurs during training activities or when asked to complete tasks.","15":"The client often is noncompliant during training activities or when asked to complete tasks.","16":"The behavior often occurs when the immediate environment is very noisy or crowded.","17":"When the behavior occurs, you often respond by giving the client a brief break from an ongoing task.","18":"The behavior rarely occurs when you place few demands on the client or when you leave them alone."},"title":"Part II. Social Reinforcement"}},"motivation_scale":{"main_questions":{"questions":{"1":"In case the client is alone, inappropriate behavior will be observed again and again?","2":"Inappropriate behavior will occur in case the client is instructed to complete a complex task","3":"Inappropriate behavior will occur in case an adult is talking to someone else","4":"Inappropriate behavior occurs after the client's demand to get a motivational item, food \n                        or access to a preferred activity  is declined","5":"The behavior will occur every time when the client is alone; the behavior will last for certain time","6":"Behavior will occur in case the client is instructed to complete a task","7":"The behavior will occur in case attention to the clinet is seized","8":"The behavior will occur in case access to the preferred item, food, or activitu of the client is seized","9":"The client displays signs of pleasure when engaged in inappropriate behavior","10":"When you instruct the client to complete a certain task, the client demonstrates inappropriate behavior to escape the task","11":"Does thу client seem to do the behavior to upset or annoy you when you are not paying \n                            attention to him or her? (For example, if you are sitting in a separate room, interacting \n                            with another person.)","12":"The behavior stops when you deliver preferred item, food, or propose a preferred activity to the client","13":"When the behavior occurs, it looks like the client does not pay attention to the environment","14":"The behavior stops right after you stop instructing the client to complete a certain task","15":"The behavior occurs to attract your attention","16":"The behavior occurs when you say the client can not access preferred item or activity"}}}}},"quiz":"Screening tools","quizComplete":"Done","quizTitle":"Структурированные собеседования и инструменты функциональной оценки","relativeRanking":"Relative Ranking of Maintaining Variable","relativeRankingDescription":"(high score to low score)","removedUser":"Specialist was deleted","reportTitle":"Структурированные собеседования и инструменты функциональной оценки","result_interpretation":"Result Interpretation","saveQuiz":"Save screening","scheduled_at":"Scheduled date","show":"Show","take":"Execute","targetBahaviour":"Target behavior","totalScore":"Total Score","typeQuiz":"Screening type"},"en.random_rotation":{"block_results":{"Correct":"Correct","Incorrect":"Incorrect","No data":"No data","Prompt":"Prompt"},"forbidden":"You have no access to this module for this client"},"en.registration":{"buttons":{"signup":"Register"},"congrats":{"first_line":"Registration completed successfully.","second_line":"You may enter the system using your email and password."},"header":"Registration","user_types":{"bcba":"Analyst","independent_curator":"Independent curator","supervisor":"To run supervision"}},"en.report":{"UB":"IB","add_skill":"Add the skill domain","address":"620075, Россия, г. Екатеринбург, ул. Малышева, 51, этаж 29, +7 (343) 384-84-81, info@company.com, ИНН 123456789, ОГРН 123456789","all":"All","all_centre":"All centres","all_protocol":"All protocols","all_skill":"All domains","archive_reports":"Report archive","author":"by","average_speed_bids":"Avg. request processing time, days","bids_all":"Total requests","bids_completed":"Processed requests","bids_created":"Created requests","bids_new":"New requests","bids_overdue":"Outdated requests","blocks":"Daily session blocks","changes_from":"Changes","changes_in_protocol":"Protocol change","changes_in_protocols":"Protocol change register","chart_for_category_daily_pecs":"Number of reactions for the category in each daily session block","chart_for_daily_pecs":"Number of mastered sequences in each block of the daily session","chart_for_perc_daily_pecs":"Share of mastered sequences in each block of the daily session","chart_for_percent_axes":"% of the chain steps","chart_for_percent_daily":"Share of chain steps mastered in each daily session block","chart_for_percent_daily_pecs":"share of mastered sequences at step","chart_for_percent_daily_pecs2":"share of mastered sequences","chart_for_properties_daily":"Number of preferred attributes in each daily session block.","chart_for_properties_percent_daily":"Share of preferred attributes in each daily session block.","chart_for_step_axes":"number of the chain steps","chart_for_step_daily":"Number of chain steps mastered in each daily session block","chart_for_step_daily_pecs":"number of mastered sequences at step","chart_for_step_daily_pecs2":"number of mastered sequences","chart_for_steps_daily":"Number of reactions per step in each block of the daily session","chart_for_steps_daily_pecs":"Number of reactions for the sequence in each block of the daily session","chart_for_stimul_daily":"Number of reactions per stimulus in each block of the daily session","chart_percent_axes":"% of the chain","choose_client":"Select the client from the list","choose_clinic_centre":"Select your centre","choose_curator":"Choose the curator","choose_period":"Choose the timeframe","choose_protocol":"Select the protocol","choose_skill":"Select the skill domain","choose_therapist":"Choose the therapist","client":"Client","clients":"Clients","clients_count":"Client number","clinic_centre":"Clinic centre","condition_mastered":"Condition to mastered stimul","condition_mastered_step":"Criterion of mastering the step","confidentially":"Confidential","conflict_sessions":"Conflict sessions","conflict_sessions_title":"Детальный экран конфликтной сессии","consolidated_efficiency":"Overall Efficiency %","count_stim":"count of mastered stimuli","cumulitive_graph":"Cumulative graph of mastered stimuli","cumulitive_graph_for_protocol":" Cumulative graph of stimuli mastered within the protocol","cumulitive_graph_pecs":"Graph of target sequence mastering at step","cumulitive_graph_pecs2":"Graph of target sequence mastering","curator":"Curator","daily_session":"Daily session","data_UB":"IB data","data_appeals":"Mand data","data_protocol":"Data on protocols","data_without_stimuli":"No sessions run","date_generation":"Generated on","day_session":"Day session","delete_report":"Delete","deleted_user":"deleted","description_choose_client":"Select the client to create this report","description_choose_curator":"If the curator is not specified, the report will include all records from the list","description_choose_period":"If the timeframe is not specified, the report will cover the whole available timeframe","description_choose_protocol":"If the protocol is not  specified, the report will cov all the records rom the list","description_choose_skill":"If the skill domain is not specified, the report will include all possible domains","description_choose_therapist":"If the therapist is not specified, the report wil include all the records from the list","description_max_period":"maximum available timeframe 4 month","download_pdf":"Download PDF","draw_report":"Create the report","duration":"Total session duration","filters":"Filters","footer_sub_title":"Any and all violations will be duly prosecuted by proper bodies under applied legislation","footer_title":"Usage of this service is allowed only under provisions of BACB Professional and Ethical Compliance Code for Behavior Analysts published on","for_all_protocol":"For all protocols","for_chain":"For chaining protocols","for_mand":"For mand protocol","from":"from","generate":"Generate","generate_by":"Generated by AutismTech www.autismtech.online","generate_csv_version":"Generate CSV version","generate_pdf_version":"Generate PDF version","generate_version":"Generate version","generated_by":"Generated by AutismTech www.autismtech.online","graph_cumulative_improve":"Cumulative graph of :first, :second и :third","graph_efficiency":"Efficiency chart","graph_goal":"Graph of of :first, :second и :third with prompts","graph_improve":"Cumulative graph of :improve","graph_improve_prompt":"Graph :improve, relation between :improve count and total trial count","graph_mand_react":"Graph of free mand frequency reaction","graph_mo_goal":"Graph of MO for target mand reaction  (CMO - \"yes\")","graph_mo_yes":"Graph: % of probes with MO \"yes\"","graph_mo_yes_percent":"Graph: % of 1st probes with MO \"yes\"","graph_probe":"Graph of :first + :second and :third with visible item to overall probe count within the session","graph_prompt_levels":"Graph of prompt levels","graph_relation_prompt":"Graph relation between probes :plus  with :second to correct free mand reactions","header":"Reports","himself":"Total unprompted mands (free and with the target visible)","himself_per_hour":"Unprompted mand reactions per hour","himself_per_minute":"Unprompted mand reactions per minute","hours":"Hours","hours_with_client":"Hours with clients","info_client":"Client data","info_curator":"Curator data","info_curators":"Curators data","info_therapist":"Entity data","info_therapists":"Therapists data","introduced":"Introduced","label_cumulative_improve":"Count of reactions :first, :second и :third","label_goal":"% :first, :second и :third","label_improve":"Reactions :improve","label_improve_prompt":"% improved reactions","label_mand_react":"Free mand reaction","label_mo_goal":"% MO \"yes\"","label_mo_yes":"% of probes with MO \"yes\"","label_mo_yes_percent":"% of 1st probes with MO \"yes\"","label_probe":"% :first + :second + :third","label_prompt_levels":"Prompt levels","label_relation_prompt":"Graph: relation between prompted probes trials with :second with visible item to correct free mand reactions","legend":"Legend:","mastered":"Transferred","min":"min","name_report":"Title","number_properties_pecs":"number of preferred attributes","number_step":"Number of the chain steps mastered","number_step_pecs":"number of mastered sequences","number_step_pecs_detail":"number of reactions ","percent_category":"Number of attributes mastered","percent_count":"Number of %","percent_efficiency":"Efficiency %","percent_properties_pecs":"share of preferred attributes","percent_step":"% of the chan steps mastered","percent_step_pecs":"share of mastered sequences","percent_step_pecs_detail":"share of reactions ","period":"Period","protocol":"Protocol","range_end":"Timeframe till","range_from":"Timeframe since","reaction_count":"Number of reactions","report":"Report","save_report":"Save the report","sec":"sec","sessions_client":"Sessions with parents","sessions_therapist":"Sessions with the therapist/curator","sessions_total":"Total sessions","show_graph":"Show graphs for the target","show_graph_btn":"Show graph","simple":"Simple CPEIm","skill_domain":"Skill domain","specialist":"Specialist","spontaneous":"Total free mand reactions","spontaneous_per_hour":"Free mand reactions per hour","spontaneous_per_minute":"Free mand reactions per minute","start_protocol":"Start entering the protocol","start_skill":"Start entering the skill domain","statistics_mand":"Total statistics of mand reactions","status":{"1":"Processing","2":"Generated","3":"Error"},"statusCSV":["Processing","Generated","Error","No data"],"step_count":"Number of steps","stimul":"Stimul","summary_table_requests":"Mand registry","table_prompts":"Mand reaction probe and frequency table","therapist":"Therapist","time_with_client":"Time with parents","time_with_therapist":"Time with the therapist/curator","title":{"about_clients":"Intervention report","about_curators":"Curator effectiveness report","about_therapists":"Therapist effectiveness report"},"to":"to","total":"Total","total_time":"Total time","with_prompts":"Total prompted mands","with_prompts_per_hour":"Prompted mand reactions per hour","with_prompts_per_minute":"Prompted mand reactions per minute","within_24_hours":"Within 24 hours","without_mand":"without mand protocol","write_protocols":"Protocols created"},"en.reset_password":{"forms":{"reset_password":{"bcba_new_pass":"Please address to your Analyst to get the new password.","buttons":{"reset":"Change password"},"congrats":{"first_line":"The password is successfully changed.","second_line":"You may enter the system using your email and password."},"congrats_email":"The request for password recover was sent to your analyst","congrats_email_bcba":"Autismtech system has already sent the link to your e-mail. Please follow the link to change your pasword to a more safe and easy to remember.","header":"Change password","sub_header":"Enter your identifier and your new password"},"send_token":{"buttons":{"send_password":"Recover"},"header":"Password recovery","sub_header":"Enter your registration username","success_alert":"The link to password reset is sent"}}},"en.rotation":{"L":"L","M":"M","P":"P","R":"R","block":"Block","build_table":"Create the table","cancel":"Cancel","description":"Items on the table are placed according to the certain scheme, and the target item (which is asked about) is always different.","destroy_table":"Reset the table","forbidden":"You have no access to this module for this client","instructions":{"collapse":"Collapse","expand":"Expand","header":"Instructions:","text":"Items on the table are placed according to the certain scheme, and the target item (which is asked about) is always different. The therapist needs a visual prompt on the location of the items now, which should be asked about  and the ability to make a record on the quality of the reaction. 1. The first screen: enter the titles of the 3 stimuli, i.e. cat (A), ball (B) and juice (C). The second and subsequent screens may look as attached. The table defines 27 lines, and then it restarts with block 1, so the procedure may rotate infinitely. As a result, when the set is over there is a table with per cent of correct reactions by stimulus and number of trials per stimulus. This table can be emailed"},"interactive_module":"Interactivity module","interactive_module_two":"Interactivity module 2","interactive_modules":"Interactivity modules","next_block":"Next block","no_data":"No data","p":"p","pagination":{"next":"Forward","previous":"Back"},"report":{"all_approaches_count":"Overall number of trials","auditor":"Specialist who conducted the session","client":"Client","date":"Date","download_report":"Download the report","fail_answer_rate":"% of incorrect responses","header":"Report on the session","hint_rate":"% of prompts","no_answer_rate":"% of incomplete trials","number_of_approaches_for_stimulus":"Number of trials per stimulus","report":"Report","started_at":"Date and time","stimulus_count":"Number of stimuli","success_rate":"Per cent of correct reacton per stimulus","successful_answer_rate":"% of correct responses","therapist":"Therapist"},"reports":"Reports","result":"Result","save":"Save","session":"Session","show_results":"Show the results","start_session":"Begin the session","stimulus":"Stimulus","stimulus_one":"Stimulus 1","stimulus_three":"Stimulus 3","stimulus_two":"Stimulus 2","title":"Automation of Random Rotation","unique_stimulus":"Stimuli must not repeat","write_names_for_stimulus":"Enter stimulus titles"},"en.settings":{"client_price":"Customer cost in the system","currency_unit":"Conventional currency unit","maintenance":"Maintenance mode","maintenance_in":"Only on/off values","page_not_found":"Page not found","page_not_found_subscription":"The page you requested does not exist. You might like going to the home page or refer to the support service from the contact page."},"en.subscription":{"add_comment":"Add comment","choose_region":"Choose region from list","comment":"Comment","comment_title":"Comment","cost":"Cost","create_date":"Create date","discount":{"value":{"type":{"percent":"%"}}},"duration":"Duration","duration_days":":value d","end_date":"End Date","start_date":"Start Date","status":{"active":"Active","finished":"Finished","inactive":"Inactive","new":"New","under_consideration":"Under consideration"},"sub_title":"При оплате подписки сроком на 3 месяца вы получаете скидку 10%, при оплате сроком на 6 месяцев - 20%","subscription_continue":"To continue your measurement recording, please extend the subscription in your profile, or refer to the support team.","subscription_expired":"You subscription has expired.","subscription_expired_today":"Your subscription expires today.","subscription_limited":"You subscription has expired and resulted in suspended measurement recording. To enable behaviour measurement recording, please extend the subscription in your profile, or refer to the support team.","subscription_period":"Subscription Period","subscription_soon_expired":"Your subscription expires in :attribute days.","title":"Request new subscription"},"en.upload":{"accept_file_types":"File type not supported","add_file":"Load the file","cancel":"Cancel","delete":"Delete","failed":"File load failed","max_file_size":"File is too big","max_number_of_files":"Max file number reached","min_file_size":"File is too small"},"en.user":{"C":"C","P":"P","T":"T","active_protocol":"Active protocols","add":"Add","add_client":"Add a client","add_client_no_data":"No available clients","add_curator":"Add a curator","add_therapist":"Add a therapist","add_therapist_no_data":"No available therapists for this curator","attached_therapist_list":"Assigned therapist lists","bcba":"Analyst","bcba_languages":{"en":"English","pl":"Polish","ru":"Russian","uk":"Ukrainian"},"bcba_statuses":{"Active":"Active","Deactivated":"Deactivated","Mensuration forbidden":"Mensuration forbidden"},"bcba_types":{"BCBA":"Analyst","Independent curator":"Independent curator"},"cancel":"Cancel","choose_client_from_list":"Choose the client from the list","choose_therapist_from_list":"Choose the therapist from the list","client":"Client","clientHash":"Client hash","client_code":"Client code","clients":"Clients","clinical_center":"Clinical centre","clinical_center_no_data":"No data","close":"Close","confirm_delete":"Do you confirm the removal?","confirm_delete_client_form_therapist":"Are you sure you want to delete the assigned client?","confirm_delete_text":"Are you sure you want to delete the assigned therapist?","confirm_delete_title":"Delete confirm","contacts":"Parent contacts","curator":"Curator","curator_profile":"Curator profile","curators":"Curators","dashboard":"Dashboard","delete":"Delete","display_name":"Display Name","edit":"Edit","edit_client":"Edit the client record","edit_curator":"Edit the curator record","edit_therapist":"Edit the therapist record","hours_parent":"Hours with parents","hours_therapist":"Hours with the therapist","list_attached_clients":"Assigned client list","no_data":"No data","number":"Number","parent_email":"Parent email","parent_first_name":"Parent name","parent_last_name":"Parent Last Name","password":"Password","profile_therapist":"Therapist profile","request_for_work":"Requests in process","request_for_work_overdue":"Requests in process / outdated","save":"Save","start_curator":"Start entering the name of curator","start_therapist":"Start entering the name of therapist","supervisor":"Supervisor","therapist":"Therapist","therapists":"Therapists","type_the_client_code_to_search":"Enter the client code to search ...","type_the_client_name_to_search":"Enter the client name to search ...","type_the_clinical_center_name_to_search":"Enter the clinical centre name to search ...","type_the_curator_name_to_search":"Enter the curator name to search ...","type_the_therapist_name_to_search":"Enter the therapist name to search ...","type_the_timezone_to_search":"Choose your timezone to search ...","update":"Refresh","user":"User","username":"Username","users":"Users"},"en.validation":{"accepted":"The :attribute must be accepted.","active_url":"The :attribute is not a valid URL.","after":"The :attribute must be a date after :date.","after_or_equal":"The :attribute must be a date after or equal to :date.","alpha":"The :attribute must only contain characters within the same alphabet.","alpha_dash":"The :attribute must only contain characters within the same alphabet, incl. numbers, and dashes.","alpha_num":"The :attribute must contain characters only within the same alphabet and numbers","alpha_spaces":"The :attribute must contain characters only within the same alphabet and spaces","array":"The :attribute must be an array.","attributes":{"address":"Address","analystEmail":"Analyst E-mail","antecedentTypes":"Typical Antecedents","assigneeId":"Client ID","auditorId":"Auditor ID","bcbaId":"Analyst ID","bcba_id":"Analyst","behaviorTypes":"Typical behaviors","captcha":"Security code","captcha_key":"Secret key","center":"Center","centerEmail":"Center E-mail","centerName":"Center name","centerPhone":"Center phone","centers":"Centers","certificate":"Certificate","certificateActionType":"Certificate action type","certificateFileName":"Certificate file","client_count":"Number Of Clients","comment":"Comment","contacts":"Contacts","content":"Content","created_at":"Date created","currentPassword":"Current password","displayName":"Display Name","display_name":"Display Name","effectsTypes":"Typical consequences","email":"E-mail","enable":"Status","enableFalse":"Off","enableTrue":"On","file":"File","finishedAt":"Completion time","finished_at":"to","firstName":"First Name","first_name":"First Name","full_name":"Full Name","goal":"Aim","hash":"Hash","id":"ID","intervals":"Intervals","intervals.*.behaviourHappenedAt":"Aimed behavior occurred on","intervals.*.duration":"Interval duration","intervals.*.index":"Interval index","key":"Key","language":"Language","lastName":"Last Name","last_name":"Last Name","legalName":"Legal name","logo":"Logo","menu":"Menu","menu_id":"Menu ID","message":"Message","meta_description":"Meta Description","meta_keywords":"Meta Keywords","meta_title":"Meta Title","name":"Name","newPassword":"New password","newPasswordConfirmation":"Password confirmation","new_password":"New password","old_password":"Current password","owner":"Owner","page_slug":"Page","password":"Password","password_confirmation":"Password confirmation","period":"Timeframe","phone":"Phone","position":"Position","protocol":{"applying":"Skill domain","baseLevel":"Basis Level","code1":"ABBLS","code2":"VB-MAPP","describe_stage":"Describe stage","errorCorrection":"Error correction","execution":"Intervention","features":"Peculiarities","goal":"Aim","hintType":"Prompt type","instruction":"Instruction","max_field_count":"Max field count","min_field_count":"Min field count","provideHint":"Prompting","reductionHint":"Prompt fading criterion","reductionHintMethod":"Prompt fading method","rightReaction":"Correct reaction","risingPrompt":"Prompt increase criterion","stage":"Stage","title":"Protocol title"},"published":"Published","ratingId":"Skill rating","region_discount_id":"Tariff","remember_me":"Remember me","report":{"behaviourDescription":"Description of target behavior","behaviourTypeId":"Behavior type","failedIntervalCount":"Number of cleared","intervalCount":"Number of intervals","intervalDurationUnitId":"Interval measurement units","intervalDurationValue":"Interval time","rightCount":"Number of correct responses","sessionDuration":"Session duration","successfulIntervalCount":"Number of successful","suggestedCount":"Number of prompts","totalCount":"Overall number of trials","uncompletedCount":"Number of incomplete trials","wrongCount":"Number of incorrect responses"},"role":"Role","sessions":"Sessions","sessions.*.blocks":"Block","sessions.*.blocks.*.index":"Block index","sessions.*.blocks.*.resultId":"Block results","sessions.*.blocks.*.stimuli":"Stimuli","sessions.*.blocks.*.stimuli.*.correct":"Correct stimulus","sessions.*.blocks.*.stimuli.*.name":"Stimulus title","sessions.*.blocks.*.stimuli.*.position":"Stimulus position","sessions.*.index":"Session index","skillField":"Skill field","skillFieldName":"Skill field name","skillRating":"Skill rating","skillRatingName":"Skill rating name","slug":"Slug","socialNetwork":"Social networks","stage":"Stage","startedAt":"Start time","started_at":"from","status_id":"Status","stimuli":"Stimuli","stimuli.*":"Stimulus title","subscription_auto_cost":"Recommended price","subscription_cost":"Calculated Subscription Cost","subscription_discount_value":"Discount Amount","subscription_discount_value_type":"Unit of Discount Values","subscription_period":"Subscription Period","task":"Stimulus","timezone":"Timezone","title":"Title","updated_at":"Date changed","user_counts":"Number of clients\\Clients with sessions\\Curators\\Therapists","user_type":"Register as a","username":"Username","usersCenters":"Users centers","uuid":"UUID","value":"Value","viewed":"Viewed","year":"Year"},"before":"The :attribute must be a date before :date.","before_or_equal":"The :attribute must be a date before or equal to :date.","between":{"array":"The :attribute must have between :min and :max items.","file":"The :attribute must be between :min and :max kilobytes.","numeric":"The :attribute must be between :min and :max.","string":"The :attribute must be between :min and :max characters."},"boolean":"The :attribute field must be true or false.","confirmed":"The :attribute confirmation does not match.","custom":{"assign_curator_can_analytic":"Only analyst may assign curators","attribute-name":{"rule-name":"custom-message"},"count_assigned_specialists":"The number of specialists assigned must be between 2 and 3","curator_not_have_client":"The curator assigned must manage a therapist assigned for the client","curator_not_have_therapist":"The curator may assign only subordinate therapists","different_problem_behavior":"Choose screening tools with the same target inappropriate behaviors","incorrect_count_answered_specialists":"Choose specialists who completed the screening tool","incorrect_count_answers":"Incorrect number of responses in this screening tool","incorrect_count_general_detailed_answers":"Incorrect number of responses with text fields for the current screening tool","incorrect_count_passed_quiz":"Choose only completed screening tools you created for the client","incorrect_general_question_answer":"Incorrect response to the general question","incorrect_quiz_answers":"Incorrect responses for the screening tool","incorrect_quiz_general_answers":"Incorrect total responses for the screening tool","missing_quiz_answers":"One or more questions of the screening tool lack responses ","not_user_or_curator":"You may chose only a therapist, or curator","select_different_quiz_types":"Choose different types of screening tools","therapist_not_have_client":"The therapist assigned must be assigned to the client"},"date":"The :attribute is not a valid date.","date_format":"The :attribute does not match the format :format.","different":"The :attribute and :other must be different.","digits":"The :attribute must be :digits digits.","digits_between":"The :attribute must be between :min and :max digits.","dimensions":"The :attribute has invalid image dimensions.","distinct":"The :attribute field has a duplicate value.","email":"The :attribute must be a valid email address.","exists":"The selected :attribute is invalid.","file":"The :attribute must be a file.","filled":"The :attribute field must have a value.","has_access_to_client":"This user has no access to this client","has_active_bcba":"The user account is deactivated","has_selected_item":":attribute must contain the selected item.","image":"The :attribute must be an image.","in":"The selected :attribute is invalid.","in_array":"The :attribute field does not exist in :other.","incorrect_value":"Incorrect value","integer":"The :attribute must be an integer.","interval":{"max":"The interval can not exceed :max :unit"},"invalid_credentials":"User account data is incorrect","ip":"The :attribute must be a valid IP address.","ipv4":"The :attribute must be a valid IPv4 address.","ipv6":"The :attribute must be a valid IPv6 address.","isEmptyError":"Choose  the mand","is_not_equal_to_actual_db_value":"The :attribute must match to actual value in the database.","json":"The :attribute must be a valid JSON string.","max":{"array":"The :attribute may not have more than :max items.","file":"The :attribute may not be greater than :max kilobytes.","numeric":"The :attribute may not be greater than :max.","string":"The :attribute may not be greater than :max characters."},"mimes":"The :attribute must be a file of type: :values.","mimetypes":"The :attribute must be a file of type: :values.","min":{"array":"The :attribute must have at least :min items.","file":"The :attribute must be at least :min kilobytes.","numeric":"The :attribute must be at least :min.","string":"The :attribute must be at least :min characters."},"not_in":"The selected :attribute is invalid.","not_regex":"The :attribute format is invalid.","number_of_client_exceeded":"You reached your subscription client limit. Please contact the system administrator.","numeric":"The :attribute must be a number.","present":"The :attribute field must be present.","regex":"The :attribute must contain latin characters, numbers and signs.","required":"The :attribute field is required.","required_field":"field is required.","required_if":"The :attribute field is required when :other is :value.","required_unless":"The :attribute field is required unless :other is in :values.","required_with":"The :attribute field is required when :values is present.","required_with_all":"The :attribute field is required when :values is present.","required_without":"The :attribute field is required when :values is not present.","required_without_all":"The :attribute field is required when none of :values are present.","same":"The :attribute and :other must match.","size":{"array":"The :attribute must contain :size items.","file":"The :attribute must be :size kilobytes.","numeric":"The :attribute must be :size.","string":"The :attribute must be :size characters."},"string":"The :attribute must be a string.","timezone":"The :attribute must be a valid zone.","unable_activate_expired_subscription":"Unable to activate expired subscription","unable_activate_future_subscription":"You can not activate subscription starting in future","unique":"The :attribute has already been taken.","unique_categories":"Category with this title is already added. Please choose another title","unique_client":"This client is already added","unique_email":"User with such :attribute is already registered","unique_properties":"Attribute with this title is already added. Please choose another title","unique_skill_field":"This skill domain is already added","unique_stage":"This stage title is already added","unique_task":"This stimulus is already added","uploaded":"The :attribute failed to upload.","url":"The :attribute format is invalid."},"es.admin":{"action":"Acción","administrator":"Administrador","alert":"Alerta","all":"Todas","avatar":"Avatar","back":"Volver","back_to_list":"Volver a la lista","batch_delete":"Eliminar por lotes","browse":"vistazo","cancel":"Cancelar","captcha":"Captcha","choose":"Elegir","choose_file":"Elegir archivo","choose_image":"Elegir imagen","close":"Cerrar","collapse":"Colapsar","confirm":"Confirmar","create":"Crear","created_at":"Creado el","current_page":"Página actual","delete":"Eliminar","delete_confirm":"¿ Esta seguro de eliminar este elemento ?","delete_failed":"¡ Eliminación fallida !","delete_succeeded":"¡ Eliminación exitosa !","deny":"Permiso denegado","description":"Descripción","edit":"Editar","entries":"Entradas","expand":"Expandir","export":"Exportar","failed":"Fallido","filter":"Filtrar","http":{"method":"HTTP method","path":"HTTP path"},"icon":"Icono","input":"Entrada","list":"Lista","login":"Iniciar sesión","login_successful":"Inicio de sesión correcto","logout":"Cerrar sesión","menu":"Menú","more":"Más","name":"Nombre","new":"Nuevo","online":"en línea","operation_log":"Registro","order":"Ordenar","pagination":{"range":"Mostrando :first a :last de :total elementos"},"parent_id":"Padre","parent_select_error":"Error al seleccionar el elemento padre","password":"Contraseña","password_confirmation":"Confirmación de contraseña","permission":"Permiso","permissions":"Permisos","refresh":"Refrescar","refresh_succeeded":"¡ Actualizar correctamente !","remember_me":"Recordarme","remove":"Retirar","reset":"Restablecer","role":"Rol","roles":"Roles","route":"Route","save":"Guardar","save_succeeded":"¡ Guardar con éxito !","selected_rows":"Filas seleccionadas","setting":"Ajustes","show":"Mostrar","slug":"Slug","submit":"Enviar","succeeded":"Exitoso","title":"Título","update_succeeded":"¡ Actualización correcta !","updated_at":"Actualizado el","uri":"URI","user_setting":"Configuración del usuario","username":"Nombre de usuario","view":"Ver"},"fr.admin":{"action":"Action","administrator":"Administrateur","alert":"Alerte","all":"Tous","all_methods_if_empty":"Toutes méthodes si vide","avatar":"Avatar","back":"Retourner","back_to_list":"Retourne à la liste","batch_delete":"Supprimer en masse","browse":"Naviguer","cancel":"Annuler","captcha":"Captcha","choose":"Choisissez","choose_file":"Choisissez un fichier","choose_image":"Choisissez une image","close":"Fermer","collapse":"Replier","confirm":"Confirmer","create":"Créer","created_at":"Créé à","current_page":"La page actuelle","delete":"Supprimer","delete_confirm":"Êtes vous bien certain de vouloir supprimer cet élement ?","delete_failed":"L'effacement a échoué !","delete_succeeded":"L'élement a bien été supprimé !","deny":"Permission refusée","description":"Description","edit":"Editer","entries":"lignes","expand":"Déplier","export":"Exporter","failed":"Failli","filter":"Filtre","http":{"method":"HTTP méthode","path":"HTTP chemin"},"icon":"Icône","input":"Entrée","list":"Liste","listbox":{"filter_clear":"Affichez tous","filter_placeholder":"Filtre","filtered":"{0} / {1}","text_empty":"Liste vide","text_total":"Affichant toutes {0}"},"login":"Connexion","login_successful":"Connexion réussie","logout":"Déconnexion","menu":"Menu","more":"Plus","name":"Nom","new":"Nouveau","new_folder":"Nouveau dossier","online":"En ligne","operation_log":"Journal des opérations","order":"Sorter","pagination":{"range":":first à :last de :total lignes"},"parent_id":"Parent","parent_select_error":"Parent select erreur","password":"Mot de passe","password_confirmation":"Confirmez votre mot de passe","permission":"Permission","permissions":"Droits","refresh":"Rafraîchir","refresh_succeeded":"Rafraîchissement réussi !","remember_me":"Rester connecté","remove":"Enlèver","reset":"Reset","role":"Rôle","roles":"Rôles","route":"Route","save":"Sauvegarder","save_succeeded":"Changements sauvés !","selected_rows":"Les lignes sélectionnées","setting":"Paramètres","show":"Affiche","size":"Taille","slug":"Slug","submit":"Soumettre","succeeded":"Succédé","time":"Temps","title":"Titre","update_succeeded":"Changements sont bien mis à jour !","updated_at":"Mis à jour à","upload":"Télécharger","uri":"URI","user_setting":"Paramètres","username":"Nom d'utilisateur","view":"Voir"},"he.admin":{"action":"פעולה","administrator":"מנהל מערכת","alert":"אזהרה","avatar":"תמונה","back":"חזרה","back_to_list":"חזרה לרשימה","batch_delete":"מחק מסומנים","browse":"דפדוף","captcha":"קאפצ'ה","choose":"בחר","choose_file":"בחר קובץ","choose_image":"בחר תמונה","close":"סגור","collapse":"פתח","create":"יצירה","created_at":"נוצר ב","delete":"מחיקה","delete_confirm":"אתה בטוח שאתה רוצה למחוק?","delete_failed":"מחיקה נכשלה","delete_succeeded":"מחיקה הצליחה","deny":"אין הרשאות","description":"תאור","edit":"עריכה","entries":"רשומות","expand":"הרחב","export":"ייצוא","failed":"כשלון","filter":"חיפוש","icon":"אייקון","input":"קלט","list":"רשימה","login":"כניסה","login_successful":"כניסה הצליחה","logout":"יציאה","menu":"תפריט","more":"עוד","name":"שם","new":"חדש","online":"און ליין","operation_log":"לוג מערכת","order":"סדר","pagination":{"range":":last מ :total תוצאות"},"parent_id":"אב","parent_select_error":"בעייה בבחירת האב","password":"סיסמא","password_confirmation":"שוב סיסמא","permissions":"הרשאות","refresh":"רענן","refresh_succeeded":"רענון הצליחה","remember_me":"זכור אותי","remove":"הסרה","reset":"אתחול","roles":"תפקידים","save":"שמור","save_succeeded":"נשמר בהצלחה","setting":"הגדרות","show":"צפה","slug":"טקסט","submit":"שלח","succeeded":"הצלחה","title":"כותרת","update_succeeded":"עודכן בהצלחה","updated_at":"עודכן ב","uri":"כתובת","user_setting":"הגדרות משתמש","username":"שם משתמש","view":"צפייה"},"ja.admin":{"action":"操作","administrator":"管理者","alert":"注意","all":"全て","all_methods_if_empty":"空欄の場合は全て","avatar":"アバター","back":"戻る","back_to_list":"一覧へ戻る","batch_delete":"一括削除","browse":"参照","cancel":"取消","captcha":"Captcha","choose":"選択","choose_file":"ファイルを選択","choose_image":"画像を選択","close":"閉じる","collapse":"縮小","confirm":"確認","create":"作成","created_at":"作成日時","current_page":"現在のページ","delete":"削除","delete_confirm":"本当に削除しますか？","delete_failed":"削除に失敗しました！","delete_succeeded":"削除しました！","deny":"権限がありません。","description":"概要","edit":"編集","entries":"件","expand":"展開","export":"出力","failed":"失敗","filter":"フィルタ","http":{"method":"HTTP method","path":"HTTP path"},"icon":"アイコン","input":"入力","list":"一覧","listbox":{"filter_clear":"全て表示","filter_placeholder":"フィルタ","filtered":"{0} / {1}","text_empty":"空のリスト","text_total":"計 {0} 個のアイテム"},"login":"ログイン","login_successful":"ログインしました！","logout":"ログアウト","menu":"メニュー","more":"続き","name":"名称","new":"新規","new_folder":"新規フォルダ","online":"オンライン","operation_log":"操作ログ","order":"順序","pagination":{"range":"全 :total 件中 :first - :last 件目"},"parent_id":"親ID","parent_select_error":"親ID選択エラー","password":"パスワード","password_confirmation":"確認用パスワード","permission":"権限","permissions":"権限","refresh":"再読込","refresh_succeeded":"更新しました！","remember_me":"ログイン状態を記憶","remove":"消去","reset":"リセット","role":"役割","roles":"役割","route":"Route","save":"保存","save_succeeded":"保存しました！","selected_rows":"選択行のみ","setting":"設定","show":"表示","size":"サイズ","slug":"スラッグ","submit":"送信","succeeded":"成功","time":"日時","title":"タイトル","update_succeeded":"更新しました！","updated_at":"更新日時","upload":"アップロード","uri":"URI","user_setting":"ユーザー設定","username":"ユーザーID","view":"表示"},"nl.admin":{"action":"Actie","administrator":"Beheerder","alert":"Alert","all":"Alle","all_methods_if_empty":"Alle methodes indien geen geselecteerd","avatar":"Profielfoto","back":"Terug","back_to_list":"Terug naar lijst","batch_delete":"Verwijder meerdere","browse":"Selecteer","cancel":"Annuleer","captcha":"captcha","choose":"Kies","choose_file":"Kies een bestand","choose_image":"Kies een afbeelding","close":"Sluit","collapse":"Dichtklappen","confirm":"Bevestig","create":"Maak","created_at":"Gemaakt op","current_page":"Huidige pagina","delete":"Wissen","delete_confirm":"Bent u zeker dat u dit item wilt verwijderen ?","delete_failed":"Kon niet verwijderen !","delete_succeeded":"Verwijderd !","deny":"Toegang geweigerd","description":"Omschrijving","edit":"Wijzigen","entries":"rijen","expand":"Openklappen","export":"Exporteer","failed":"Mislukt","filter":"Filter","http":{"method":"HTTP methode","path":"HTTP pad"},"icon":"Icoon","input":"Input","list":"Lijst","listbox":{"filter_clear":"Toon alle","filter_placeholder":"Filter","filtered":"{0} / {1}","text_empty":"Lege lijst","text_total":"Alle {0} getoond"},"login":"Aanmelden","login_successful":"Ingelogd","logout":"Afmelden","menu":"Menu","more":"Meer","name":"Naam","new":"Nieuw","new_folder":"Nieuwe map","online":"Online","operation_log":"Bewerkingslog","order":"Sorteer","pagination":{"range":":first tot :last van :total rijen"},"parent_id":"Parent","parent_select_error":"'Parent select' fout","password":"Wachtwoord","password_confirmation":"Wachtwoord bevestigen","permission":"Permissie","permissions":"Rechten","refresh":"Vernieuw","refresh_succeeded":"Vernieuwd !","remember_me":"Ingelogd blijven","remove":"Verwijder","reset":"Reset","role":"Rol","roles":"Rollen","route":"Route","save":"Opslaan","save_succeeded":"Opgeslaan !","selected_rows":"Geselecteerde rijen","setting":"Instellingen","show":"Toon","size":"Grootte","slug":"Slug","submit":"Bevestig","succeeded":"Gelukt","time":"Tijd","title":"Titel","update_succeeded":"Bijgewerkt !","updated_at":"Gewijzigd op","upload":"Uploaden","uri":"URI","user_setting":"Instellingen","username":"Gebruikersnaam","view":"Toon"},"pl.admin":{"action":"Опции","administrator":"Администратор","alert":"Ошибка","all":"Все","all_methods_if_empty":"Все методы, если не указано","avatar":"Аватар","back":"Назад","back_to_list":"Вернуться к списку","batch_delete":"Пакетное удаление","batch_enable_off":"Выключить области навыков","batch_enable_on":"Включить области навыков","browse":"Выбор файла","cancel":"Отмена","captcha":"Защитный код","choose":"Выбрать","choose_file":"Выбор файла","choose_image":"Выбор изображения","close":"Закрыть","collapse":"Свернуть","confirm":"Подтвердить","continue_creating":"Продолжить создание","continue_editing":"Продолжить редактировать","create":"Новая запись","created_at":"Дата создания","current_page":"Текущая страница","delete":"Удалить","delete_confirm":"Вы уверены, что хотите удалить эту запись?","delete_failed":"Ошибка при удалении!","delete_failed_skill_field":"Вы не выбрали области для удаления","delete_succeeded":"Успешно удалено!","deny":"Доступ запрещен","description":"Описание","detail":"Подробно","details":"Детали","edit":"Редактировать","enable_off":"Выключить","enable_off_confirm_skill_fields":"Вы подтверждаете выключение выбранных областей?","enable_off_failed_skill_field":"Вы не выбрали области для отключения","enable_on":"Включить","enable_on_confirm_skill_fields":"Вы подтверждаете включение выбранных областей?","enable_on_failed_skill_field":"Вы не выбрали области для включения","entries":"записей","expand":"Развернуть","export":"Экспорт","failed":"Ошибка","filter":"Фильтр","http":{"method":"HTTP метод","path":"HTTP путь"},"icon":"Иконка","input":"Ввод","list":"Список","listbox":{"filter_clear":"Показать все","filter_placeholder":"Фильтр","filtered":"{0} / {1}","text_empty":"Пустой список","text_total":"Все: {0}"},"login":"Войти","login_successful":"Авторизация успешна","logout":"Выйти","main":{"header":"Панель управления :appName"},"menu":"Меню","menu_titles":[],"more":"Еще","name":"Имя","new":"Добавить","new_folder":"Новая папка","no":"Нет","online":"Онлайн","operation_log":"Журнал событий","order":"Сортировка","pagination":{"range":"Записи с :first по :last из :total"},"parent_id":"Родитель","parent_select_error":"Ошибка при выборе родителя","password":"Пароль","password_confirmation":"Подтверждение пароля","permission":"Доступ","permissions":"Доступ","refresh":"Обновить","refresh_succeeded":"Успешно обновлено!","remember_me":"Запомнить","remove":"Удалить","reset":"Сбросить","role":"Роль","roles":"Роли","route":"Путь","save":"Сохранить","save_succeeded":"Успешно сохранено!","search":"Поиск","sections":{"contact_us":{"headers":{"index":"Обратная связь"}},"menu_items":{"headers":{"create":"Страницы","edit":"Элементы меню","index":"Меню"}},"menus":{"headers":{"create":"Страницы","index":"Меню"}},"pages":{"description":" ","headers":{"index":"Страницы"}},"settings":{"description":"Настройки системы","headers":{"index":"Настройки"}},"subscriptions":{"description":" ","headers":{"index":"Подписки","region_discounts":"Тарифы"}},"users":{"chart":{"title":"Динамика по количеству проведённых сессий по клиентам данного аналитика за выбранный период"},"description":" ","headers":{"centers":"Центры","index":"Аналитики","skillFields":"Область навыков","skillRatings":"Модуль оценки","statistics":"Статистика","userCenters":"Центры аналитиков"}}},"selected_rows":"Выбранные строки","setting":"Настройка","show":"Показать","size":"Размер","slug":"Слаг","submit":"Отправить","succeeded":"Завершена","time":"Время","title":"Название","update_succeeded":"Успешно изменено!","updated_at":"Дата обновления","upload":"Загрузить","uri":"URI","user_setting":"Настройки пользователя","username":"Логин","view":"Посмотреть","yes":"Да"},"pl.android":{"conflict_protocol":"Aktualna wersja protokołu na urządzeniu nie odpowiada najnowszej wersji protokołu na serwerze. Możesz zapisać sesję i zaktualizować protokół lub kontynuować bez aktualizacji protokołu.","language":"Język","no_connection":"Brak połączenia","no_data":"Brak danych","settings":"Ustawienia","subscription_has_expired":"Your system subscription expired. Please contact your system administrator","synchronization_in_progress":"Synchronizacja w trakcie","synchronization_warning":"Warning! Unsaved session data will be lost during synchronization. Continue with unsaved data?","synchronize":"Synchronizować","unable_to_save_date":"Nie można zapisać danych"},"pl.appeals":{"R":"P","appeal":"Prośba","appeals":"Prośby","appeals_chart":"Tabela prośby w wybranym okresie","appeals_count":"Liczba prośb","appeals_for_period":"Prośby  w wybranym okresie","avarage_appeals_perhour":"Średnia ilość prośb na godzinę","buttons":{"addAppeal":"Dodać","apply":"Zastosować","cancel":"Anuluj","createAppeal":"Zapisz","saveAppeal":"Zapisz","write_appeal":"Zapisz prośbę"},"date_end":"Data do","date_start":"Data z","date_time":"Data/Godzina","edit_typical_appeals":"Edytuj typowe prośby","edit_typical_appeals_short":"Edytuj typowe prośby","edit_typical_client_appeals":"Edytuj typowe prośby klienta","maxlength_appeals":"Maksymalna liczba prośb: 50","need_choice_appeal":"Wybierz prośbę","no_data":"Brak danych","pagination":{"next":"Dalej","previous":"Wstecz"},"range":"Period","recorded":"Zapisano","total_appeals_perday":"Całkowita ilość różnych prośb  dziennie","type_new_appeal":"Wpisz nową prośbę","type_the_appeals_name_to_search":"Wpisz nazwę prośby do wyszukiwania","typical_appeals":"Typowe prośby","unique_appeals":"Prośby  nie mogą się powtarzać","write_appeal":"Zapisz prośbę","write_client_appeal":"Zapisz prośbę klienta"},"pl.auth":{"failed":"Nazwa użytkownika i hasło nie zgadzają się.","throttle":"Zbyt wiele prób logowania.  Spróbuj ponownie za :seconds sekund."},"pl.behavior":{"UB":"NZ","add_ub_environment":"Wprowadź nowe konsekwencje w środowisku","add_ub_to_report":"Dodaj informacje NZ do raportu","aftermath":"Konsekwencja","aftermath_short":"Konsekwencja","all_ancedent":"Wszystkie zmienną poprzedzającą","all_option":"Wszystkie opcje","all_protocol":"Wszystkie protokołu","all_ub":"Wszystkie NZ","all_ub_for_day":"Wszystkie NZ w ciągu 24 godzin","ancedent":"Zmienna poprzedzająca","average_behavior":"Średnia ilość NZ na godzinę ","behavior":"Zachowanie","buttons":{"add":"Dodać","apply":"Zastosować ","cancel":"Anuluj","create":"Zapisz","create_behavior":"Zapisz NZ","save":"Zapisz","show_by_frequency":"Pokaż według częstotliwości","show_by_time":"Pokaż według daty / godziny","typical_behavior":"Typowe NZ","write_unwanted_behavior":"Zapisz niepożądane zachowanie"},"date_end":"Data do","date_start":"Data z","date_time":"Data/Godzina","describe_the_behavior":"Opisz zachowanie","edit_typical_appeals_short":"Edytuj typowe zapytania","edit_typical_behavior":"Edytuj typowe NZ","edit_typical_client_behavior":"Edytuj typowe NZ","enter_the_aftermath":"Wpisz konsekwencję","enter_the_ancedent":"Wpisz zmienną poprzedzającą","enter_the_new_aftermath":"Wpisz nową konsekwencję","enter_the_new_ancedent":"Wpisz nową zmienną poprzedzającą ","enter_the_new_behavior":"Wpisz nowe zachowanie","frequency_group_by":"Grupuj według","frequency_group_types":{"aftermath":"Konsekwencji","ancedent":"Zmiennej poprzedzającej","behavior":"Zachowania","undefined":"według daty / godziny"},"hours_24":"24 godziny","maxlength_aftermath":"Maksymalna liczba konsekwencji: 200","maxlength_ancedent":"Maksymalna ilość zmiennych poprzedzających: 200","maxlength_behaviors":"Maksymalna liczba zachowań: 200","min":"min","need_choice_aftermath":"Wybierz konsekwencję","need_choice_ancedent":"Wybierz zmienną poprzedzającą","need_choice_behavior":"Wybierz zachowanie","no_data":"Brak danych","pagination":{"next":"Dalej","previous":"Wstecz"},"range":"Period","scatter_plot":"Scatter-plot niepożądanego zachowania","sec":"sec","times":" czasu","ub_behavior":"Konsekwencje w zachowaniu","ub_environment":"Konsekwencje dla środowiska","ub_for_day":"NZ na sesję dzienną","unique_aftermath":"Konsekwencje nie mogą się powtarzać","unique_ancedent":"Zmienne poprzedzające nie mogą się powtarzać","unique_behaviors":"Zachowania nie mogą się powtarzać","unwanted_behavior":"Niepożądane zachowanie","unwanted_behavior_chart":"Tabela niepożądane zachowanie w wybranym okresie","unwanted_behavior_for_period":"Niepożądane zachowanie w wybranym okresie","unwanted_behavior_title":"Edytuj typowe NZ","within":"W ciągu","write_unwanted_behavior":"Zapisz niepożądane zachowanie","write_unwanted_behavior_short":"Zapisz NZ","you_must_select_at_least_one_antecedent_behavior_and_consequence":"Musisz wybrać co najmniej jedną zamienną poprzedzającą, zachowanie i konsekwencję"},"pl.bids":{"Z":"Z","add_comment":"Wpisz swój komentarz","appoint_protocol":"Zaznacz protokół","bid":"Zgłoszenie","bids":"Zgłoszenia","bids_for_new_protocols":"Zgłoszenie nowego protokółu","bids_for_protocols":"Zgłoszenia protokołów","bids_for_protocols_and_modules":"Zgłoszenie protokołu i modułu","buttons":{"appointProtocol":"Przyznaczyć protokół","cancel":"Anuluj","createProtocol":"Stworzyć protokół","request_new_protocol_or_module":"Wniosek o nowy protokół/moduł interaktywności","sendRequest":"Wysłać zgłoszenie","submit_bids_to_curator":"Wysłać zgłoszenie do kuratora","submit_for_approval_to_bsba":"W pracy Analityk"},"change_date":"Data zmiany","client":"Klient","clients":"Klienci","comment":"Komentarze","comments":"Komentarze","create_date":"Data stworzenia","edit_bid":"Edytuj żądanie protokołu","header":"Zgłoszenia","initiator":"Inicjator","no_data":"Brak danych","overdue":"Przeterminowane","pagination":{"next":"Dalej","previous":"Wstecz"},"parent":"Rodzic","protocol_goal":"Cele protokołu","request_new_protocol":"Wniosek o nowy protokół","short_description":"Opis krótki","start_protocol":"Zacznij wpisywać tytuł protokołu","status":"Status","statuses":{"Assigned":"Przyznaczony","Being processed by the BCBA":"W pracy analityka","Being processed by the curator":"W pracy kuratora","Being processed by the therapist":"W pracy terapeuty","Cancelled":"Anulowany","New":"Nowy"},"therapist":"Terapeuta","type_the_procol_name_to_search":"Wpisz nazwę protokołu dla wyszukiwania","view_bid":"Przegląd zgłoszenia protokołu","write_protocol_goal":"Opisz cele protokołu"},"pl.buttons":{"back":"Wstecz","back_to_client":"Powrót do profilu klienta","cancel":"Anuluj","continue":"Kontynuuj","edit":"Edytuj","save":"Zapisz","send":"Wysłać"},"pl.contact_us":{"buttons":{"send":"Wysłać"},"congrats":"Dziękuję Ci! Skontaktujemy się z Tobą wkrótce!","errors":{"save_failed":"Nie udało się zapisać wiadomości"},"header":"Informacje zwrotne","labels":{"captcha":"Kod bezpieczeństwa","email":"Twój email","message":"Wiadomość","name":"Imię"}},"pl.dashboard":{"functionalInDevelopment":"Przepraszamy, ta funkcja jest w trakcie opracowywana","labels":{"dashboard":"Panel sterowania","welcome":"Jesteś zalogowany!"},"library":"Biblioteka","requestHelp":"Prośba o pomoc","sendComment":"Zostaw komentarz","writeRequest":"Zapisz prośbę","writeUnwantedBehavior":"Zapisz NZ"},"pl.dro":{"aim_types":{"Absence of target behavior":"Brak zachowania docelowego","Presence of target behavior":"Obecność  zachowania docelowego"},"back_to_reports":"Powrót do raportów","behaviour_absence":"Brak zachowania docelowego","behaviour_absent":"Nie było zachowania docelowego!","behaviour_description":"Opis zachowania docelowego","behaviour_presence":"Obecność  zachowania docelowego","behaviour_type":"Typ zachowania docelowego","behaviour_type_long":"Długie","behaviour_type_short":"Krótkie","behaviour_types":{"Long":"Długie","Short":"Krótkie"},"cancel":"Anuluj","continue_session":"Kontynuuj sesję","description":"Opis procedury: zachęcanie przez brak/obecność zachowania docelowego podczas ustalonego interwału","dro_module":"Moduł DRO/DRI","duration_units":{"Minutes":"Minuty","Seconds":"Sekundy"},"finish_session":"Zakończ sesję","forbidden":"Nie masz dostępu do tego modułu dla tego klienta","hold_session":"Uruchom sesję","instructions":{"collapse":"Zwiń","expand":"Czytać w całości","header":"Instrukcje:","text":"Opis procedury: zachęcanie przez brak/obecność zachowania docelowego podczas ustalonego interwału"},"interactive_module":"Moduł interaktywności","interactive_module_one":"Moduł interaktywności 1","interactive_modules":"Moduły interaktywności","interval_duration_units":"Jednostki miary interwałowej","interval_time_range":"Czas interwału","interval_time_range_minutes":"Czas interwału (1-100 min)","interval_time_range_seconds":"Czas interwału (1-300 sec)","list":{"absent":"Nie było","interval":"Interwał","interval_suffix":"","target_behaviour":"Moment docelowego zachowania","time":"Czas interwału"},"min":"min.","no_data":"Brak danych","pagination":{"next":"Dalej","previous":"Wstecz"},"parameters":"Parametry","report":{"auditor":"Specjalista","average_successful_interval_duration":"Średni czas udanego interwału","behaviour_description":"Zachowanie docelowe","behaviour_type":"Typ zachowania ","client":"Klient","date":"Data","download_report":"Pobierz raport","fail_rate":"% Odrzuconych","failed_interval_count":"Liczba odrzuconych","header":"Raport z sesji","header_mobile":"Raport DRO/DRI","interval_count":"Liczba intewałów","started_at":"Data","success_rate":"% Udanych","successful_interval_count":"Liczba udanych"},"reports":"Raporty","restart_timer":"Uruchom ponownie minutnik","sec":"sec.","start_session":"Rozpocznij sesję","subtitle":"Moduł interaktywności 1","target_behaviour":"Zachowanie docelowe","title":"Realizacja DRO/DRI.","type":"Typ"},"pl.email":{"after_registered":{"body":{"lines":{"first":"System AutismTech wita Państwao, :displayName!","second":"Nowy użytkownik został poprawnie zarejestrowany (:userType)","third":"W celu wejścia, użytkownik musi zalogować się do aplikacji mobilnej (lub w Chrome, Safari \n                    lub przeglądarce Firefox, aby przejść do strony logowania :loginUrl) i wpisać Identifikator - :username,\n                     Hasło - :password. Podziel się tą informacją z użytkownikiem i przechowuj dane w bezpiecznym miejscu."}},"subject":"AutismTech: Udane dodanie do zespołu interwencyjnego"},"after_registration":{"body":{"lines":{"fifth":"Dział obsługi technicznej nie ma dostępu do danych konta, więc jeśli zapomnicie swojego hasła,\n                     możecie ją odzyskać wybierając \"Przywróć hasło\" na stronie logowania :loginUrl. Nowe hasło zostanie \n                     wygenerowane i wysłane automatycznie na adres e-mail podany podczas rejestracji.","first":"System AutismTech wita Państwo, :displayName!","fourth":"2 - Aby się zalogować, należy użyć Identifikatora :username i hasło :password","second":"Teraz możecie skorzystać z automatyzacji pomiarów i analizy danych behawioralnych klikając \n                    na link :appUrl w przeglądarce Chrome, Safari lub Firefox aktualnej wersji, aby skonfigurować system.\n                    Można to również zrobić w aplikacji mobilnej.","sixth":"udanych Pomiarów!","third":"1 - Przejście do strony logowania za linkiem :loginUrl lub uruchomcie swoją aplikację mobilną."}},"subject":"Potwierdzenie rejestracji :appName"},"bcba_account_activated":{"body":{"lines":{"first":"Witamy :name!","second":"Macie całkowity dostęp do pomiarów behawioralnych, tworzenia i redagowania protokołów \n                    interwencji, wyników pomiarów i raportów. Obecnie możliwe jest również tworzenie kont dla członków \n                    zespołu interwencyjnego i przedstawicieli klientów.","third":"udanych Pomiarów!"}},"subject":"AutismTech: całkowity dostęp do pomiarów behawioralnych"},"bcba_account_deactivated":{"body":{"lines":{"first":"Witamy :name!","second":"Algorytmy systemowe wyłączyły funkcje konta.","third":"Jeśli uważacie, że to jest to błąd, prosimy o kontakt z obsługą techniczną: https://autismtech.online/contacts."}},"subject":"AutismTech: konto analityka jest zdeaktywowane."},"bcba_account_mensuration_forbidden":{"body":{"lines":{"first":"Witamy :name!","second":"Algorytmy systemowe wyłączyły funkcje konta. Możliwość przeglądania wyników pomiarów i \n                    zachowania opisów protokołów interwencji została zapisana.","third":"Jeśli uważacie, że to jest to błąd, prosimy o kontakt z obsługą techniczną: https://autismtech.online/contacts."}},"subject":"AutismTech:  możliwości konta są ograniczone"},"csv_report_generated":{"body":{"lines":{"first":"Witaj, :displayName!","second":"Raport CSV za :startDate - :endDate według klienta :clientCode wygenerowano.","third":"Możesz go pobrać w sekcji Raporty > Archiwum raportów."}},"subject":"Wygenerowano raport CSV"},"layout":{"greeting":{"error":"Ups!","success":"Witamy!"},"regards":"Z poważaniem,","subcopy":"Jeśli masz problem z naciśnięciem przycisku :actionText, skopiuj i wklej następujący adres URL do przeglądarki: [ :actionUrl ]( :actionUrl )"},"new_subscription":{"body":{"lines":{"first":"Witaj, :name!","second":"W systemie utworzono nowe zapytanie o subskrypcję","third":"Szczegóły, które możesz obejrzeć pod adresem :url"}},"subject":"Nowe zapytanie o subskrypcję"},"new_subscription_comment_for_admin":{"body":{"lines":{"first":"Witaj, :name!","fourth":"Szczegóły, które możesz obejrzeć pod adresem :url","second":"Do subskrypcji :id dodano nowy komentarz:","third":"\":comment\""}},"subject":"Do subskrypcji :id dodano nowy komentarz"},"new_subscription_comment_for_user":{"body":{"lines":{"first":"Witaj, :name!","fourth":"Szczegóły, które możesz obejrzeć pod adresem :url","second":"Do subskrypcji :id dodano nowy komentarz:","third":"\":comment\""}},"subject":"Do subskrypcji :id dodano nowy komentarz"},"pdf_report_generated":{"body":{"lines":{"first":"Witaj, :displayName!","second":"Raport PDF za :startDate - :endDate według klienta :clientCode wygenerowano.","third":"Możesz go pobrać w sekcji Raporty > Archiwum raportów."}},"subject":"Wygenerowano raport PDF"},"recovery_password":{"body":{"lines":{"first":"Dzień dobry, :bcbaDisplayName","fourth":"Udostępnij hasło ustawione dla użytkownika w dogodny dla Ciebie sposób.","second":"Twój członek zespołu :username :userDisplayName poprosił o odzyskanie hasła.","third":"Możesz zmienić hasło użytkownika w jego profilu."}},"subject":"Żądanie odzyskania hasła"},"reset_password":{"body":{"lines":{"first":"Witaj, otrzymałeś tę wiadomość, ponieważ otrzymaliśmy prośbę o zmianę hasła do twojego konta","second":"Zmień hasło","third":"Jeśli nie poprosiłeś o zmianę hasła, zignoruj​ten komunikat."}},"subject":"Zmiana hasła"},"subscription_status_active":{"body":{"lines":{"first":"System AutismTech wita Państwo, :name!","second":"Macie całkowity dostęp do pomiarów behawioralnych, graficznej analizy zebranych danych i \n                    raportowania interwencji. Aby rozpocząć, zaloguj się z :loginUrl używając swojego identyfikatora :username","third":"udanych Pomiarów!"}},"subject":"AutismTech: całkowity dostęp do pomiarów behawioralnych"},"subscription_status_finished":{"body":{"lines":{"first":"Witaj, :name!","second":"Twoja subskrypcja wygasła :id wygasł","third":"Szczegóły, które możesz obejrzeć pod adresem :url"}},"subject":"Twoja subskrypcja wygasła :id wygasł"},"subscription_status_inactive":{"body":{"lines":{"first":"System AutismTech wita Państwa, :name!","fourth":"Jeśli uważacie, że to jest to błąd, prosimy o kontakt z obsługą techniczną: https://autismtech.online/contacts.","second":"Algorytmy systemowe przypisały abonamentowi :id status nieaktywny.","third":"Dlaczego to się stało? Kliknij na link :url"}},"subject":"AutismTech: Abonament dla :id jest zdeaktywowany.","title":"Dezaktywacja abonamentu"},"subscription_status_new":{"body":{"lines":{"first":"Witaj, :name!","second":"Twoja subskrypcja :id została zatwierdzona przez administratora i zostanie aktywowana po rozpoczęciu subskrypcji.","third":"Szczegóły, które możesz obejrzeć pod adresem :url"}},"subject":"Twoja subskrypcja :id została zatwierdzona przez administratora"}},"pl.errors":{"choose_curator_from_list":"Wybierz kuratora z listy","choose_therapist_from_list":"Wybierz terapeutę z listy","create_comment":"Nie możesz tworzyć komentarzy","delete_comment":"Nie możesz usunąć tego komentarza","edit_comment":"Nie możesz edytować tego komentarza","reset_password":"Nie udało się zmienić hasła","save_comment":"Nie udało się zapisać komentarza","send_token":"Nie znaleziono użytkownika","session_expired":"Twoja sesja wygasła. Proszę się zalogować.","something_wrong":"Coś poszło nie tak.","try_later":"Spróbuj ponownie lub skontaktuj się z administratorem.","view_comments":"Nie możesz przeglądać komentarzy","view_not_own_notifications":"Nie możesz wyświetlać powiadomień innych osób"},"pl.export":{"reports":{"dro":{"auditor":"Specjalista, który przeprowadził sesję","average_successful_interval_duration":"Średni czas udanego interwału","behaviour_description":"Opis zachowania docelowego","behaviour_type":"Typ zachowania ","client":"Klient","fail_rate":"% Odrzuconych","failed_interval_count":"Liczba odrzuconych","header":"Raport z sesji","interval_count":"Liczba interwałów","not_specified":"Brak danych","started_at":"Data i godzina","success_rate":"% Udanych","successful_interval_count":"Liczba udanych"},"random_rotation":{"auditor":"Specjalista, który przeprowadził sesję","block":"Blok","block_count":"Ogólna liczba prób","client":"Klient","fail_rate":"% Błędnych odpowiedzi","header":"Raport z sesji","incomplete_rate":"% Niewypełnionych prób","prompt_rate":"% Podpowiedzi","result":"Wynik","session":"Sesja","started_at":"Data i godzina","stimulus":"Bodziec","success_rate":"% Poprawnych odpowiedzi"}}},"pl.home":{"labels":{"documentation":"Dokumentacja","forge":"Forge","github":"Github","home":"Strona główna","laracasts":"Laracasts","loading_message":"Poczekaj chwilę, trwa ładowanie","loading_message_table":"Proszę poczekać chwilę, trwa ładowanie tabeli","news":"Wiadomości"}},"pl.instruction":{"collapse":"Zwiń","default_text":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis","expand":"Czytać w całości","header":"Instrukcje:"},"pl.ios":{"creating_new_dro_session_confirmation":"Utworzenie nowej sesji spowoduje utratę niezapisanych danych sesji DRO/DRI. Utworzyć nową sesję?","download_appeals_for_client":"Pobierz prośby dla %client%","download_client_list":"Pobierz listę klientów","download_dro_sessions_for_client":"Pobierz sesje DRO/DRI dla %client%","download_protocols_for_client":"Pobierz protokoły dla %client%","download_random_rotation_sessions_for_client":"Pobierz losowe sesje rotacyjne dla %client%","download_typical_undesirable_behaviors_and_appeal_for_client":"Pobierz typowe NZ i M dla %client%","download_undesirable_behaviors_for_client":"Pobierz NZ dla %client%","logout_impossible":"Nie można się wylogować przed wysłaniem wszystkich danych do serwera. Połącz się z Internetem i spróbuj ponownie.","no_connection":"Brak połączenia z Internetem.","synchronize":"Synchronizować","synchronize_impossible":"Synchronizacja nie jest możliwa. Brak połączenia z Internetem.","synchronize_on":"Zsynchronizowano na","upload_appeals":"Wyślij dane prośb","upload_bids":"Prześlij prośby o protokoły/moduły interaktywne","upload_data_to_server":"Wyślij dane na serwer","upload_dro_sessions":"Wyślij sesje DRO/DRI","upload_protocols":"Wyślij protokoły","upload_random_rotation_sessions":"Wyślij dane sesji losowej rotacji","upload_typical_undesirable_behaviors_and_appeals":"Wyślij typowe NZ i P","upload_undesirable_behaviors":"Wyślij NZ"},"pl.login":{"buttons":{"login":"Zaloguj się"},"i_consent_to_data_processing":"Wyrażam zgodę na przetwarzanie danych","labels":{"forgot":"Odzyskiwanie hasła","login":"Zaloguj się","logout":"Wyloguj się"},"unable_to_sign_in":"Nie możesz autoryzować się "},"pl.pagination":{"next":"Dalej","previous":"Wstecz"},"pl.passwords":{"password":"Hasła muszą mieć co najmniej sześć znaków i muszą odpowiadać potwierdzeniu.","password_subscription":"Polecamy, aby hasło zawierało 8–16 znaków","reset":"Twoje hasło zostało zresetowane!","sent":"Prześlemy Ci e-mailem link do resetowania hasła!","token":"Nieprawidłowy kod resetowania hasła.","user":"Nie możemy znaleźć użytkownika pod tym adresem e-mail."},"pl.placeholders":{"enter_new_message":"Rejestracja"},"pl.profile":{"address":"Adres","client_count":"Liczba klientów","clinic_center":"Centra kliniczne","delete_logo":"Usuń logo","displayName":"Użytkownik","download_logo":"Pobierz logo Centrum","edit_clinic_center":"Edycja Centrum klinicznego","firstName":"Imię","lastName":"Nazwisko","legalName":"Nazwa prawna/numer firmy/numer podatnika","name":"Tytuł","name_clinic_center":"Nazwa Centrum klinicznego","other_contact":"Inne kontakty","phone":"Telefon","price":"Koszt","profile":"Profil Analityka","settings_task_type":"Ustawienia listy kontrolnej reakcji","status":"Status","subscriptions":"Subskrypcje","subscriptionsSubtitle":"Dane dotyczące bieżących i poprzednich subskrypcji","username":"Identyfikator"},"pl.protocol":{"OffPhaseModalTitle":"Zamierzasz dezaktywować fazę :phaseName. \n Bodźce :phaseName będą niedostępne w bieżącym etapie. \n Jeśli zamierzasz pracować z tymi bodźcami, przenieś je do innej fazy.","absent":"Nie","active_protocols":"Aktywne protokoły","addCategory":"Dodać kategorię","addCheckList":"Załączone listy kontrolne reakcji","addEnvironment":"Dodać środowisko","addProperty":"Dodać właściwość","addStep":"Dodać krok","add_a_mand_reaction":"Dodaj bodziec","add_a_stimulus":"Dodaj bodziec","add_interval":"Dodaj interwał","add_level":"Dodać nowy poziom podpowiedzi","add_minus_spo":"Użyj - zimne wyniki próby","add_new_protocol":"Przeznaczenie nowego protokołu","add_new_stimulus":"Dodaj nowy bodźiec","add_plus_spo":"Użyj + zimne wyniki próby","add_to_set":"Dodaj bodźce do zestawu","after_one_lesson":"Po jednym zajęciu","after_three_classes":"Po trzech zajęciach","after_two_classes":"Po dwóch zajęciach","all_attempts_past":"Wszystkie próby dla wszystkich bodźców zakończone.","all_field":"Wszystkie pola","all_intervals":"Wszystkie interwały","all_phases":"Wszystkie fazy","all_stage":"Wszystkie etapy","answer_title":"Reakcja Mand (wybrany list kontrolny)","area":"Obszar","assignDate":"Data przyznaczenia","assimilate_stimulus":"opanowano bodźców: :attribute","attempt":"Próba","attempt_count":"Liczba próbek (jeśli dotyczy)","attempts":"Próby","audial":"Audial","auto_save_version":"Wersja automatycznie zapisana","available_protocols":"Dostępne protokoły","average_percent":"Średni % niezal. reakcji","back_to_list":"Powrót do listy etapów","baseLavel":"Poziom podstawowy","base_level":"Poziom podstawowy","bids":"Zgłoszenia","bids_for_protocols":"Zgłoszenia protokołów","blocks":"blokach","body_parts":"Części ciała","buttons":{"add":"Dodaj","addMandReaction":"Dodaj bodziec","addNewProtocol":"Przypisz nowy protokół","addProtocol":"Przypisz  protokół","addStage":"Dodaj etap","addStimulus":"Dodaj bodziec","addСriterion":"Dodaj kryterium","allow_mensuration":"Allow mensuration","apply_changes_to_protocol":"Zastosuj zmiany protokołu","back_to_protocol":"Powrót do protokołu","cancel":"Anulować ","choose_stimulus":"Użyj bodźców z wybranego etapu","close_protocol":"Zakończ protokół","collapse":"Zwiń","conductTherapeuticSession":"Przeprowadź sesję terapeutyczną","continueTherapeuticSession":"Kontynuuj sesję terapeutyczną","create":"Utwórz nowy protokół","createNotPublish":"Przenieś na wersję roboczą","delete":"Usuń","duplicate":"Zduplikować","duplicate_stage":"Zduplikować etap","edit":"Edytuj","editTasks":"Edytuj listę kontrolną  reakcji","expand":"Rozwiń","export":"Eksport","finishCurrentStage":"Zamknij bieżący etap","finishEnvironment":"Zakończ gromadzenie danych w środowisku","finishStage":"Zakończ gromadzenie danych w etap","goToExercises":"Przejdź do ćwiczeń","hideAll":"Zwin wszystkie","leave_session":"Wstecz","newTasks":"Wypełnij listę kontrolną reakcji","no":"nie","removeMandReaction":"Usuń bodziec","removeStage":"Usuń etap","removeStimulus":"Usuń bodziec","removeСriterion":"Usuń kryterium","results":"Wyniki","resultsMeasurementsCurrentDay":"Wyniki pomiarów dnia bieżącego","save":"Zapisz protokół","saveTasks":"Zapisz listę kontrolną reakcji","save_and_allow_mensuration":"Save and allow mensuration","save_session":"Zapisz","sendRequest":"Wyślij zapytanie","showAll":"Rozwiń wszystkie","start_new_session":"Rozpocznij sesję","yes":"tak"},"category":"Kategorię","categoryTitle":"Категория","chain_mastered_chart":"Wykres łańcucha w środowisku","chain_step_chart":"Wykres kroków łańcucha opanowanych w środowisku","change_criteria":"Zmień aktualne kryterium","change_criteria_title":"Po zmianie obecnego kryterium wszystkie kolejne zostaną oznaczone jako jeszcze nie opanowane","change_criterion_position":"Aby zmienić kolejność kryteriów, przeciągnij kryterium do wymaganej pozycji na liście kryteriów.","change_date":"Data edycji","change_environment_position":"Aby zmienić kolejność środowisk, które nie są jeszcze zaangażowane, przeciągnij środowisko do wymaganej pozycji na liście.","change_mand_reaction_position":"Aby zmienić kolejność bodźców, przeciągnij bodziec do odpowiedniej pozycji na liście celów mand.","change_popup_title":"Zapisz zmiany w protokole jako","change_stage_position":"Aby zmienić kolejność etapów dla nieaktywnych etapów, przeciągnij etap do wymaganej pozycji na liście etapów.","change_step_position":"Aby zmienić kolejność kroków, przeciągnij krok do wymaganej pozycji na liście.","change_stimul_position":"Aby zmienić kolejność bodźców, przeciągnij bodziec do wymaganej pozycji na liście bodźców.","changes":"Zmiany","changesSaved":"Сессия успешно сохранена","changes_date_text":"Uwaga: zmiany w poprzednich sesjach są akceptowane tylko wtedy, gdy zmiany te nastąpią po dacie ostatniej zmiany w protokole","changes_type":"Typ zmian","chart_properties":"Wykres procentowy prawidłowego wykorzystania karty preferowanej właściwości","chart_properties_per_day":"Liczba poprawnie użytych preferowanych kart właściwości w każdym bloku codziennej sesji","chart_properties_percent":"Wykres procentowy prawidłowego wykorzystania karty preferowanej właściwości","chart_properties_percent_per_day":"Część poprawnie wykorzystanych preferowanych kart właściwości w każdym bloku codziennej sesji","check-list":"Tabela reakcji","checkList":"Tabela reakcji","chooseEnvironment":"Wybierz  środowisko","chooseLevel":"Proszę wybrać poziom","choosePreferred":"Выбор предпочитаемого свойства","chooseStage":"Wybierz etap","choose_chain_stage":"Wybierz środowisko do trenowania kroku.","choose_field":"Wybierz pole","choose_interval":"Wybierz interwał","choose_mand_stage":"Wybierz środowisko pracy z bodźcem:","choose_phase":"Wybierz fazę","choose_protocol":"Wybierz protokół z listy","choose_shaping_stage":"Выберите среду для работы с критерием.","choose_stage":"Wybierz etap","choose_step":"Wybierz krok","choose_stimul_chart":"Wykres","close_protocol":"Zakończ protokół","code1":"ABBLS","code2":"VB-MAPP","color":"Kolor","comment":"Komentarze","completed_protocols":"Zakończone protokoły","completionCriteria":"Kryteria zakończenia","compliance_check":"Sprawdzenie zgodności","condition_mastered":"reakcje podczas","condition_mastered_prop":"Warunek opanowania własności","condition_mastered_usd":"Warunek opanowania zestawu bodźców","condition_next":"Warunek przeniesienia zestawu bodźców na następny poziom podpowiedzi","condition_procent":"% niezależnych reakcji podczas sesji ","condition_return":"Warunek powrotu bodźca do poprzedniego poziomu podpowiedzi","condition_session":"prób w każdym z nich","condition_tranfer":"Kryterium rozwoju bodźca w polu/fazie","condition_tranfer_maintain":"Kryterium rozwoju bodźca na polu/podtrzymywanie","condition_tranfer_rotation":"Przeniesienie bodźca na pole","condition_trial":"kolejnych sesji popołudniowych, minimum","conductingTherapeuticSession":"Prowadzenie sesji terapeutycznej","confirm_change":"Twoje poprzednie dane zostaną usunięte","confirm_close":"Czy potwierdzasz zamknięcie etapu? ","confirm_close_all":"Wykonanie ostatniego kroku zakończy cały protokół. Uzupełnić protokół?","confirm_close_all_env":"Wykonanie ostatniego środowisku zakończy cały protokół. Uzupełnić protokół?","confirm_close_env":"Czy potwierdzasz zamknięcie wykonanie środowisku?","confirm_close_protocol":"Czy potwierdzasz zamknięcie protokół?","confirm_delete":"Uwaga! Wszystkie dane dotyczące bodźca w ramach tego protokołu zostaną usunięte. Naciśnij „Zapisz”, jeśli się zgadzasz.","confirm_delete_category":"Uwaga! Wszystkie dane dotyczące kategorię, zebranych zgodnie z niniejszym protokołem zostaną usunięte. Jeśli się zgadzasz, kliknij Zapisz.","confirm_delete_mand":"Uwaga! Wszystkie dane dotyczące bodźca, zebranych zgodnie z niniejszym protokołem zostaną usunięte. Jeśli się zgadzasz, kliknij Zapisz.","confirm_delete_property":"Uwaga! Wszystkie dane dotyczące właściwość, zebranych zgodnie z niniejszym protokołem zostaną usunięte. Jeśli się zgadzasz, kliknij Zapisz.","confirm_delete_stimulus":"Czy bodźcy na obecnym etapie zostaną zastąpione?","confirm_save_conflict_session":"Protokół został zmieniony. Twoje dane będą przechowywane w sesjach konfliktów.","conflict_sessions":"Sesje konfliktowe","continue_or_new":"Czy chcesz kontynuować bieżącą sesję, czy rozpocząć nową?","continue_previous":"Kontynuować aktualną","copy":"kopia","countSamples":"Liczba prób osiągnięcia kryterium","countSamplesAxes":"Liczba prób","count_properties":"Liczba właściwość","count_properties1":"Liczba właściwość 1","count_properties2":"Liczba właściwość 2","count_properties3":"Liczba właściwość 3","count_properties4":"Liczba właściwość 4","count_reaction":"Niezależnych bodźców na etapie","count_stimul":"Bodźców na utrzymywaniu","create_date":"Data utworzenia","criteria":"Kryteria","criteria_end_protocol":"Kryterium zakończenia protokołu","criteria_end_session":"Kryterium zakończenia sesji w bieżącym dniu","criteria_end_teaching":"Kryterium ukończenia nauki dla jednego bodźca","criterion":"Kryterium","criterionDirectionSession":"Kryterium zakończenia sesji","criterionLearningStimulus":"Kryterium ukończenia nauczania bodźca","criterion_count":"liczba kryteriów w środowisku","criterion_required":"Pole kryterium jest obowiązkowe do wypełnienia.","cumulative_category":"Liczba poprawnie użytych preferowanych kart właściwości dla kategorii :CategoryName przy wyborze","cumulative_category_relative":"Część poprawnie wykorzystanych preferowanych kart właściwości dla kategorii :CategoryName","cumulitive_graph":"Kumulatywny wykres opanowanych bodźców","currentEnvironment":"Obecne środowiska","currentLevel":"Aktualny poziom","currentStage":"Obecny etap","current_criterion":"Obecne kryterium","date":"Data","date_first_session":"Data pierwszej sesji","date_mastering":"Data opanowania","day_session":"codziennych sesji o min","delay":"opóźnienie :sec sekund","delay_none":"opóźnienie 0 sekund","deleteCategory":"Usunąć kategorię","deleteProperty":"Usunąć właściwość","delete_criteria_title":"Ten bodziec jest aktualny dla jednego z etapów.  Kontynuować usuwanie??","delete_set":"Ta operacja zniszczy zestaw(y). Kontynuować?","describeCategory":"Opisać kategorię :number","describeEnvironment":"Opisz środowisko :number","describeImplementation":"Opisz aktywność","describeMandReaction":"Opisz cel mand :number","describeProperty":"Opisać nieruchomość","describeStage":"Opisz etap :number","describeStep":"Opisz  krok :number","describeStimulus":"Opisz bodziec :number","describeСriterion":"Opisz kryterium :number","descriptionPart":"Część opisowa","description_on_delete":"Po usunięciu musi pozostać co najmniej jedno uwzględnione kryterium","detail_reaction_session":"Szczegółowy wykres przepływu pracy z reakcjami w wybranej sesji","detail_shaping_chart":"Szczegółowy wykres przepływu pracy z reakcjami w wybranej sesji","detailed_result":"Szczegółowy wynik","directory_types":{"Teaching method":"Technika uczenia"},"disable":"Wyłaczony","distinctive_properties":"Свойства с различением","dtt_phase_title":"Konfiguracja fazy protokołu","dtt_title":"Ustawienia etapów protokołu DTT","duration":"Czas trwania sesji","editProtocol":"Edytuj protokół","editor":"Specjalista","enable_recording":"Skonfiguruj naprawę poprawną, z podpowiedzią i złą odpowiedzią","endSession":"Zapisz sesję","end_protocol_date":"Data zakończenia protokołu","end_session_date":"Data ostatniej sesji dziennej","enter_another_session_date":"Wprowadź inną datę sesji dziennej. Data sesji dziennej musi być późniejsza niż data ostatniej dziennej sesji. Najnowsze dane zostały zebrane.","enter_session_date":"Wprowadź datę sesji. Ostatnie dane zostały zebrane w dniu:","entered_session_date":"Wprowadź datę sesji.","environment":"środowiska","environment_number":"środowisku :count","environments":"środowiska","errorCorrection":"Korekcja błędów","errorEnvironmentsCount":"Proszę skonfigurować przynajmniej jeden środowisko","errorPhaseCount":"Aktywuj przynajmniej jedną fazę","errorResult":"Liczba wybranych bodźców musi wynosić 3","errorStages":"Obowiązkowo wybrać listę kontrolną reakcji","errorStagesCount":"Proszę skonfigurować przynajmniej jeden etap","execution":"Realizacja","executionSeconds":"Prawidłowe wykonanie za :time sek","executionSecondsLimit":"Prawidłowa reakcja w ciągu kilku sekund","exercise":"Ćwiczenie","exercises":"Cwiczeń","features":"Właściwości","field":"Pole","first_probe":"pierwsze próby w każdym z nich","fluency":"Biegłość","form":"Formularz","from":"z","full_physical":"Pełna Fizyczna","full_verbal":"Pełna Werbalna","gesture":"Gestowa","goToSPO":"Przejdź do СPE","goal":"Cel","graph_cumulative_improve":"Skumulowany wykres N+, N i P","graph_goal":"Wykres N+, N и P","graph_improve":"Skumulowany wykres U+","graph_improve_prompt":"Wykres U+, stosunek próbek z U+ do całkowitej liczby próbek","graph_improved_spou":"Wykres % poprawiona reakcji","graph_mand_react":"Wykres częstotliwości spontanicznych reakcji mand, na godzinę","graph_mo_goal":"Wykres warunków motywacyjnych (OM - TAK)","graph_mo_yes":"Wykres -%  próbek z OM - TAK","graph_mo_yes_percent":"Wykres -% pierwszych próbek z OM - TAK","graph_probe_full":"Wykres N+ wraz z N i P w odniesieniu do całkowitej liczby próbek na sesję","graph_prompt_levels":"Wykres zmniejszenia poziomu podpowiedzi","header":"Protokół","himself_percent":"Niezależny, %","hint_sub_title":"Dostępnych jest 10 poziomów. Możesz użyć wymaganej liczby poziomów.","hint_type":"Rodzaj podpowiedzi","i_want_card":"Перемещение карточки “Я хочу”","important":"znaczący","inessential":"nieważny","instruction":"Instrukcja","interactivity_module":"Moduł interaktywności","interval":"Interwał","interval_count":"Liczba powtórzeń","interval_error":"Należy zaznaczyć co najmniej 1 interwał","interval_name":"Tytuł interwału","introduced":"Wprowadzono","item_card":"Добавление карточки с изображением желаемого предмета на шаблон для предложений","items":"Przedmioty","lastLesson":"Ostatnie zajęcie ","last_measurement_results":"Wyniki ostatniego pomiaru","last_session":"Ostatnia sesja","left":"lewo","level":"Poziom","levelLine":"Linia poziomu","levelTitle":"Poziom","levels":"Poziomy","listCategories":"Lista kategorii","list_of_mand_reaction":"Lista bodźców","list_of_stimulus":"Lista bodźców","logEndCriteria":"Kryterium zakończenia protokołu","make_criteria_current":"Zrób to kryterium aktualnym","make_current":"Zrobić aktualny","make_first":"Zrób pierwszym","make_last":"Zrób ostatnim","mand_date":"Data próby","mand_level":"Poziom mand (wolny mand lub z widocznym przedmiotem)","mand_required":"Pole bodźcy jest wymagane.","master":"Master","master_criterion":"Opanuj kryterium","mastered":"Przeniesiono ","mastered_criteretion":"Warunek do opanowania kryterium","mastered_criterion":"Kryterium opanowan","mastered_mand":"Opanowano","mastered_stimuli":"Opanowane bodźce","mastered_stimulus":"Opanowano","mastering":"Opanowanie","mastering vcd":"Opanowanie","mastering_btn":"opanowany","mastering_chart":"Tabela opanowania protokołu","mastering_chart_phase":"Wykres rozwoju w fazie","mastering_chart_stage":"Wykres rozwoju fazy protokołu","mastering_criteria":"Kryteria opanowania","mastering_percent":"Opanowanie protokołu, %","mastering_table":"Opanowanie protokołu","materials":"Materiały","max_count_for_session":"Całkowita maksymalna liczba prób w sesji nie może przekraczać 3000","max_field_count":"Maksymalna liczba pól","measured":"Zmierzony","measurement_date":"Data uruchomienia","min_field_count":"Minimalna liczba pól","minor":"nieistotny","motivation_condition":"Warunek motywacyjny","moveFieldTitle":"Bodźce które znajdują się nie w polach od :min do :max zostaną przeniesione do najbliższych dostępnych pól","n_sessions_with_n_blocks":":sessionCount sesji po :sessionBlockCount bloków","nameCategoryProperty":"Kategorię/Właściwość","name_criterion":"Tytuł kryterium","name_mand_reaction":"Tytuł bodźca","name_step":"Tytuł kroku","newProtocol":"Nowy protokół","next_block":"Przenieść na poziom","next_criterion":"Następny kryterium","next_session":"Następna sesja","next_support":"Przenieść do Wsparcie","noAvailableTeachingMethod":"Brak dostępnych metod nauczania","no_available_protocols":"Brak dostępnych protokołów","no_available_set_create":"Brak dostępnych bodźców do stworzenia zestawu.","no_data":"Brak danych","no_list_category":"Brak kategorii dostępnych dla szkoleń","no_list_property":"Brak właściwości dostępnych do nauki","no_title":"Bez tytułu","nodata":"Brak danych","notPublish":"Wersja robocza","number_of_trials":"Numer próby","of_protocol":"protokołu","offButton":"Wyłączyć","once_a_month":"Raz na miesiąc","once_a_week":"Raz w tygodniu","once_every_two_weeks":"Raz na dwa tygodnie","one_trial":"Jedna próba","pagination":{"next":"Dalej","previous":"Wstecz"},"partial_physical":"Częściowa Fizyczna","partial_verbal":"Częściowa Werbalna","pecs":{"control_of_achievements":"Kontrola osiągnięć.","countSamples":"Liczba prób przed osiągnięciem kryterium docelowego","go_to":"Przejść do","next_probe":"Następna próba","step_one":"Krok 1","step_three":"Krok 3","step_two":"Krok 2","table_mastered":"Tabela wejścia i opanowania kroku","table_mastered_step":"Tabela wejścia i opanowania docelowej sekwencji","table_mastered_target_sequence":"Tabela wejścia i opanowania docelowej sekwencji kroku","table_mastered_target_sequence_pwd":"Tabela wejścia i opanowania docelowej sekwencji","target_sequence":{"get_album":"Pobierzeć album","get_i_want_card":"Wyjmij kartę \"Chcę\" z albumu.","get_reinforcement_item_card":"Wyjmij kartę z elementem wzmacniającym z albumu","get_template":"Wyjmij szablon dla zdań z albumu.","give_template":"Oddać interlokutorowi szablon dla zdań.","put_i_want_card":"Umieść kartę \"Chcę\" na szablonie dla propozycji.","put_reinforcement_item_card":"Umieść tę kartę na szablonie zdań","read_sentence":"Czytanie zdania na szablonie."},"target_sequence_title":"Docelowa kolejność","without_discrimination_target_sequence":{"get_album":"Pobierzeć album","get_card_desired_item":"Wyjmij kartę żądanego przedmiotu.","get_i_want_card":"Wyjmij kartę \"Chcę\" z albumu.","get_target_property_item_card":"Wyjąć kartę ze zdjęciem docelowej właściwości obiektu","get_template":"Wyjmij szablon dla propozycji z albumu.","give_template":"Oddać interlokutorowi szablon dla propozycji.","put_card_desired_item":"Umieść żądaną kartę przedmiotu na szablonie dla zdań.","put_i_want_card":"Umieść kartę \"Chcę\" na szablonie dla propozycji.","put_target_property_item_card":"Umieścić kartę z docelową właściwością przedmiotu na szablonie dla zdań."}},"percent_block":"% niezależnych reakcji i podpowiedzi w ","percent_next_block":" % niezależnych reakcji  w ","percent_reaction":"niezależnych odpowiedzi podczas","phase":"Faza","phase_fluency":"Faza płynności","phase_mastering":"Faza opanowania","phase_rotation":"Faza rotacji","phase_stimuli":"Bodźcy w fazach","phase_support":"Faza podtrzymywania","position":"Lokalizacja","positional":"Pozycjonowana","prev_block":"Wrócić na poziom","probe_by_session":"Próby na sesję","promptType":"Widok podpowiedzi","properties_without_discrimination":"Свойства без различения","property":"właściwość","propertyTitle":"właściwość","protocol":"Protokół","protocol_dtt":"DTT protokół","protocol_goal":"Cel protokołu","protocol_status":"Status protokołu","protocols":"Protokoły","providingHint":"Podpowiedź","quantity":"Ilość","reactions":"Cele","reading_sentence":"Czytanie zdania na szablonie.","recommendation":"Rekomendacje","recordData":"Zapisywanie danych (widok)","recording_method":"Metoda zapisywania danych","reducingPromp":"Kryterium upuszczania podpowiedzi","reducingTooltip":"Metoda upuszczania podpowiedzi","reduction_hint_method":"Metoda upuszczania podpowiedzi","removeEnvironment":"Usuń środowisko","removeStep":"Usuń krok","repeat":"Powtórzenie","requestNewProtocol":"Poproś o nowy protokół","requests":"Prośby","requiredCheckList":"Lista kontrolna reakcji jest wymagana dla wszystkich etapów","requiredStepsList":"Список шагов для всех сред обязателен для заполнения","requiredStimulList":"Lista bodźców  jest wymagana  dla wszystkich etapów","response":"Reakcja","responses":"Reakcje","result":"Wynik","result_assigned_session":"Wyniki sesji terapeutycznej","result_last_assigned_session":"Wyniki ostatniej sesji terapeutycznej","result_of_protocol":"Podsumowanie protokołu","result_of_stage":"Wyniki etapu","results":"Wyniki","results_of_stages":"Podsumowanie protokołu według etapów","results_of_the_protocol":"Wyniki protokołu","results_protocol_title":"Tabela efektywności etapu","risingPrompt":"Kryteria wzrostu podpowiedzi","rotation":"Rotacja","save_session_date":"Data zapisania sesji","save_set":"Musisz zapisać bieżące zmiany, aby pracować z zestawem","scatterLine":"Linia rozprzestrzeniania danych","selectTemplate":"Wybierz szablon","select_attempt":"Zbierz dane dotyczące 4 i 5 elementów sekwencji docelowej","session":"Sesja","set":"Zestaw","sets":"Zestawy","setup_distinctive_properties":"Faza Свойства с различением","setup_fluency":"Ustawienia biegłości","setup_i_want_card":"Faza Перемещение карточки “Я хочу”","setup_item_card":"Faza Добавление карточки с изображением желаемого предмета на шаблон для предложений","setup_mastering":"Ustawienia opanowania","setup_properties_without_discrimination":"Faza Свойства без различения","setup_reading_sentence":"Faza Czytanie zdania na szablonie.","setup_rotation":"Ustawienia rotacji","setup_stimuli":"Ustawienia bodźca :title","setup_support":"Ustawienia utrzymywania","shaping_chart":"Ocena i analiza zmian zachowań w środowisku","shaping_last_session_chart":"Ocena i analiza zmian zachowania w poprzedniej sesji","short_description":"Krótki opis","shortcut_enabled":"Dodaj do szybkiego menu","shortcut_menu_title":"Tytuł do szybkiego menu","showChangeDateSession":"Wprowadź dane z poprzednich sesji","showGraphsTitle":"Pokaż wykresy w raporcie","show_on_environment":"Pokazywać w  środowisku","show_on_level":"Pokazywanie się na poziomie","show_on_stage":"Pokaż na etapie","size":"Rozmiar","skillField_and_code":"Obszar lub kod umiejętności","speed":"Szybkość","spontaneous_level":"FM","stage":"Etap","stage_choose_from":"Poziom (wybrać spośród)","stage_count":"Numer etapu","stage_number":"Etap :count","stage_number_of_stage_count":"Etap :stageNumber z :stageCount","stages":"Etapy","stages_stimuli":"Bodźcy na etapie","startTraining":"Rozpoczęcie nauczania","start_new":"Rozpocząć nową","start_session_date":"Data rozpoczęcia sesji","started_at":"Rozpoczęty","status":"Status","statuses":{"Active":"W trakcie","Completed":"Zakończony","Individualization":"Individualization","Maintaining":"Utrzymywanie","New":"Nowy ","supporting":"Utrzymywanie"},"step":"Krok","step_count":"liczba kroków na etap","step_required":"Pole krok jest wymagane.","steps":"Kroki","stimul_count":"Razem","stimul_settings":"Aby wyregulować wiele bodźców, wybierz bodźce i naciśnij przycisk zmiany","stimul_table_header":"Historia ruchu bodźca z próbami dla wybranego okresu","stimuls":"bodźca","stimulus":"Bodziec","stimulus_count":"bodźców","stimulus_improved_chart":"Wykres ulepszonych reakcji dla:","stimulus_intervals":"Ustaw interwały powtarzania bodźca","stimulus_list_empty":"Brak bodźców, aby przejść listę kontrolną reakcji CPE.","stimulus_mastering_chart":"Wykres niezależnych reakcji dla:","stimulus_name":"Tytuł bodźca","stimulus_prompt_chart":"Tabela  zmniejszenia poziomu podpowiedzi bodźca:","stimulus_required":"Pole bodźca jest wymagane.","stimuluses":"Bodziec","subjects":"Przedmioty","support":"Utrzymywanie","support_stimulus":"Bodźcy do utrzymywania","support_subtitle":"Włączanie lub wyłączanie interwałów, a także zmiana współczynnika cykliczności nie powodują automatycznego przejścia do nowych dostępnych interwałów.  Proszę ręcznie przenieść bodźce do dostępnych przedziałów.","synthesisStrategy":"Strategia uogólnienia","table_mastered_category":"Tabela wprowadzania i wykorzystania kategorii na poziomach","table_mastered_category_name":"Tabela wprowadzania i wykorzystania kategorii:","table_subtitle":"Aby zrobić wykres, wybierz bodziec z powyższej tabeli","taskType":"Zapisywanie danych (widok)","task_in_row":"sesje z rzędu","task_prompts":{"descriptions":{"L1":"ręka na dłoni","L2":"ręka na przedramieniu","L3":"ręka na łokciu","L4":"ręka na ramieniu","audio":"audial","full_physical":"pełna fizyczna","full_verbal":"pełna werbalna","gestural":"gestowa","modeling":"modeling","partial_physical":"częściowa fizyczna","partial_verbal":"częściowa werbalna","positional":"pozycjonowana","textual":"tekstowa","visual":"wizualna"},"main_description":"Możesz zastąpić skrócone nazwy wskazówek nazwami, których używasz w pracy.","main_title":"Konfiguruj podpowiedzi","titles":{"L1":"PP1","L2":"PP2","L3":"PP3","L4":"PP4","audio":"А","full_physical":"FP","full_verbal":"FV","gestural":"G","modeling":"MD","partial_physical":"PP","partial_verbal":"PV","positional":"P","textual":"T","visual":"V"}},"task_type":"Tabela reakcji","task_types":{"answers":{"+":"+","-":"-","C":"C","C+":"C+","C1":"C","C6":"C","E":"E","E6":"N","FU":"FU","L1":"PP1","L2":"PP2","L3":"PP3","L4":"PP4","NM":"NM","NR":"NR","NR6":"O","P":"P","U":"Im","U+":"Im+","UG":"Sc","audio":"А","descriptions":{"+":"zrobiłem od razu","-":"brak reakcji, NZ, błąd","C":"niezależny, zdanie \"zrób tak\"","C+":"niezależny, bez widocznej namacalnej","C1":"niezależny","C6":"niezależny, z przedmiotem","E":"błąd","E6":"nieprawidłowa reakcja","FU":"pełna pomoc","NM":"brak motywacji","NR":"brak reakcji","NR6":"Brak reakcji","P":"podpowiedź","U":"poprawiona reakcja","U+":"poprawiona reakcja","UG":"przewijanie","no_data":"no data"},"full_physical":"FP","full_verbal":"FV","gestural":"G","modeling":"MD","no_data":"N/D","partial_physical":"PP","partial_verbal":"PV","positional":"P","textual":"T","titles":{"+":"+","-":"-","C":"C","C+":"C+","C1":"C","C6":"C","E":"E","E6":"N","FU":"FU","NM":"NM","NR":"NR","NR6":"O","P":"P","U":"Im","U+":"Im+","UG":"Sc","no_data":"N/D"},"visual":"V"},"descriptions":{"cold_probes":"Rejestrowana jest tylko pierwsza reakcja dziennie: zaznacz „+”, jeśli zakończy się od razu, lub „-”, jeśli nie zaobserwowano żadnej reakcji, błędu lub niepożądanego zachowania.","cold_probes_major":"Rejestrowana jest tylko pierwsza reakcja dziennie: zaznacz „+”, jeśli zakończy się od razu, lub „-”, jeśli nie zaobserwowano żadnej reakcji, błędu lub niepożądanego zachowania.","cold_probes_settings":"Pod uwagę brana jest tylko pierwsza reakcja dnia.","probe_analysis_c_plus_cpfueub":"C + - niezależny, bez pomocy werbalnej, C - niezależny z podpowiedziami typu „zrób to w ten sposób”, P - podpowiedzi, FU - pełna pomoc, E - błąd (inny ruch), UB - niewłaściwe zachowanie, brak reakcji nawet po podpowiedzi.","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"C + - niezależny, bez widocznej namacalnej, C - niezależny, z przedmiotem, Im + - poprawiona reakcja, Sc - przewijanie, NR - brak odpowiedzi, P - podpowiedź, I - nieprawidłowa odpowiedź, NM - brak motywacji","probe_analysis_cpe":"С - niezależny;  P - podpowiedź;  E - błąd.","probe_analysis_cpenr":"С - niezależny;  P - podpowiedź;  E - błąd;  NR - UB, brak reakcji po podpowiedzi.","probe_analysis_cpeu":"С - niezależny; P - podpowiedź; E - błąd (inny ruch), Im - poprawiona reakcja."},"titles":{"cold_probes":"Zimne próby","cold_probes_major":"Zimne próby - zaawansowany","probe_analysis_c_plus_cpfueub":"Analiza prób С+СPFuEUb","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"Analiza prób","probe_analysis_cpe":"Analiza prób CPE","probe_analysis_cpenr":"Analiza prób CPENr","probe_analysis_cpeu":"Analiza prób CPEU"}},"teachingFormat":"Format uczenia ","teachingMethod":"Technika uczenia","teaching_methods":{"Chain":"Łańcuch","DTT":"Zaawansowany (DTT)","Desensibilization":"Odwrażliwianie","Features with items":"Komunikacja alternatywna: свойства и предметы","Mand Vocal":"Vocal Mand","NET":"NET","Pecs":"Процедура PECS","Pecs Properties Without Discrimination":"Komunikacja alternatywna: właściwości bez rozróżnienia","Pecs Sentence Structure":"Komunikacja alternatywna: struktura zdania","Pecs With Discrimination":"Komunikacja alternatywna: właściwości z wyróżnieniem","Random learning":"Przypadkowe uczenie","Reaction forming":"Formowanie reakcji","Shaping":"Kształtowanie","Simple (Chain, Shaping)":"Prosty (łańcuch, kształtowanie)","VCD":"Różnicowanie bodźców werbalnych (RBW)","Десенсибилизация":"Odwrażliwianie","Случайное обучение":"Przypadkowe uczenie","Формирование реакций":"Formowanie reakcji","Цепочка":"Łańcuch"},"temperature":"Temperatura","textual":"Tekstowa","texture":"Tekstura","therapeuticSession":"Sesja terapeutyczna","through_each_lesson":"Każde zajęcie","title":"Tytuł protokołu","title_chain":"Łańcuch w środowisku ","title_mand_reaction":"Protokół tworzenia mand","to_field":"do pola ","to_next_phase":"do następnej fazy","to_prev_phase":"powrócić do poprzedniej fazy","to_rotation":"do obrotu","to_support":"na utrzymywanie","today_support_stimulus":"Bodźcy dzisiaj do utrzymywania","total_himself":"W sumie, niezależny","total_percent":"% niezależnych reakcji","total_percent_graph":"Wykres % niezależnych reakcji","track_change_level":"Śledź poziom zmiany podpowiedzi","tracked_change_level":"Śledzony poziom zmiany podpowiedzi","tracked_reactions":"Śledzone reakcje","transfer_to_rotation":"Przeniesiono do rotacji","transfer_to_support":"Przeniesiono na utrzymywanie","trendLine":"Linia trendu","trendLineTitle":"Pokaż linie wykresu","trial_count":"Liczba próbek","trial_in_row":"próby z rzędu","trueReaction":"Prawidłowa reakcja","unable_to_delete_protocol":"Протокол невозможно удалить","unique_criterion":"Kryteria nie mogą się powtarzać","unique_mand":"Bodźcy nie powinny się powtarzać","unique_step":"Kroki nie mogą się powtarzać.","unsaved_changes":"Są niezapisane zmiany","unwanted_behavior":"Niepożądane zachowanie","view_auto_save":"Wyświetl zapisaną wersję","visual":"Wizualna","whole_period":"Cały okres","withFields":"Pokaż/ukryj pola","with_subject":"VO","withoutProperties":"Нет упражнений для прохождения"},"pl.quiz":{"addToReport":"Dodać do raportu","answered":"Ответивший","answersDetail":"0 = nigdy 1 = prawie nigdy 2 = rzadko 3 = w połowie przypadków 4 = zazwyczaj 5 = prawie zawsze 6 = zawsze","answersDetailFast":"0 = Nie 1 = Tak 2 = Nie wiem","assignToClient":"Kim jesteście dla pacjenta?","assigned":"Jest przypisane","assigned_specialist":"Przyznaczony specjalista","backToQuizList":"Powrót do listy badań","chooseQuiz":"Wybierz typ badania","chooseSpecialist":"Wybrać specjalistę","completePart2":"Complete Part II if you answered \"Yes\" to item 1,2, or 3.  Skip Part II if you answered \"No\" to all three items in Part I.","completeWith":"Done with","countYes":"liczba odpowiedzi \"Tak\"","createQuiz":"Nowe badanie","created":"Created","created_by":"Przyznaczony","dateAndTime":"Data i godzina","description":"Opis","editQuiz":"Redagować badanie","enterNameSpesialist":"Zacznij wpisywać imię specjalisty","errorDelete":"Badanie nie jest dostępne do usunięcia. Badanie zostało zaliczone.","errorEdit":"Badanie nie jest dostępne do redagowania. Badanie zostało zaliczone.","errorResult":"Liczba wybranych specjalistów powinna mieścić się w przedziale od 2 do 3","errorTargetValue":"Docelowe pole zachowania jest obowiązkowe do wypełnienia.","fast":{"answers":{"titles":["Nie","Tak","Self-care","Academic","Work","Other","Self-care routines","Academic Skills Training","Leisure Activities","Evenings","Meals","Vocational Training","When the student has nothing to do"]},"description":"Функциональное сканирование определяет факторы, которые влияют на проблемное поведение. \n            Проводящий собеседование специалист предъявляет опросник нескольким людям, которые работают с пациентом. \n            Результаты используются, чтобы помочь специалисту определитьситуации, провоцирующие проблемное поведение и \n            определить функцию поведения. Если у пациента наблюдается больше одного вида проблемного поведения, \n            заполните несколько опросников, один для каждого поведения","general_questions":{"informant_client_relationship":{"questions":{"1":"Kim jesteście dla klienta?","2":"Od jak dawna utrzymujecie kontakt z klientem?","3":"Czy kontaktujecie się z klientem сodziennie?","4":"W jakich sytuacjach obserwujecie klienta? Proszę zapisać wszystkie stosowne sytuacje.?"},"title":"Należy wypełnić informacje dotyczące interakcji z klientem."},"problem_behavior_information":{"answers":{"1":"co godzinę","2":"co dzień","3":"co tydzień","4":"co miesiąc","5":"Zdrowie klienta nie jest zagrożone","6":"Zachowanie może być w pewnym stopniu szkodliwe dla zdrowia klienta.","7":"Zachowanie może spowodować znaczną szkodę dla zdrowia klienta."},"questions":{"1":"Proszę podać nazwę lub krótko opisać niepożądane zachowanie","2":"Jak często pojawiają się problematyczne zachowania? (co godzinę / co dzień / co tydzień / co miesiąc)","3":"Jak długo trwa zachowanie?","4":"Jak intensywne jest to zachowanie? (proszę wybrać najbardziej odpowiednią opcję)","5":"Opisz sytuacje, w których najczęściej występują problematyczne zachowania (z pewnymi osobami, podczas określonych czynności, w określonych porach dnia, itp.)","6":"Opisz sytuacje, w których istnieje najmniejsze  wystąpienia problematycznych zachowań (u niektórych osób, podczas niektórych zajęć, o określonych porach dnia, itd.)","7":"Proszę opisać, co dzieje się bezpośrednio przed wystąpieniem tego zachowania? (zmiana nauczyciela, przedstawienie konkretnego zadania, nauczyciel zabrał zabawkę, itp.","8":"Co się dzieje od razu po rozpoczęciu problematycznego zachowania? (nauczyciel zmienia zajencie na zajencie gry, daje zabawkę, prosi nie robić czegoś, itp).","9":"Co obecnie robicie, aby skorygować zachowanie?"},"title":"Proszę odpowiedzieć na pytania dotyczące problematycznych zachowań."}},"questions":{"titles":{"1":"Problematyczne zachowanie pojawia się, gdy klient nie otrzymuje wystarczającej uwagi lub osoba, która z nim pracuje, zwraca uwagę na kogoś innego.","2":"Problematyczne zachowanie pojawia się, gdy klient prosi o coś, co uwielbia, ale nie otrzymuje tego?","3":"Kiedy pojawiają się problematyczne zachowania, osoba pracująca z podopiecznym zazwyczaj stara się go uspokoić, dając mu to, co lubi.","4":"Klient wykazuje dopuszczalne zachowanie, gdy robi to, co uwielbia.","5":"Klient zazwyczaj zaczyna stawiać opór, gdy zostaje poproszony/wymagany do wykonania jakiegoś zadania.","6":"Klient wykazuje problematyczne zachowanie, gdy jest proszony/wymagany do wykonania zadania.","7":"Jeśli klient wykaże problematyczne zachowanie podczas wykonywania zadania, otrzymuje przerwę od wykonania zadania.","8":"Klient demonstruje dopuszczalne zachowanie, gdy nikt niczego od niego nie żąda.","9":"Niepożądane zachowanie występuje nawet wtedy, gdy klient jest sam.","10":"Problematyczne zachowanie występuje nawet wtedy, gdy klient robi coś, co mu się podoba.","11":"ПNiepożądane zachowanie jest formą samo-multymulacji.","12":"Problematyczne zachowania są mniej prawdopodobne, gdy pacjent ma możliwość zaangażowania się w działania","13":"Niepożądane zachowania są cykliczne: pojawiają się w ciągu kilku dni, a następnie znikają.","14":"Klient jest podatny na choroby i reakcje alergiczne","15":"Niepożądane zachowanie występuje najczęściej, gdy klient jest chory.","16":"Problematyczne zachowania znikają, gdy klient zaczyna się czuć lepiej (po chorobie)."}},"result_interpretation":"Та функция, которая получила максимальное количество баллов, потенциально может \n            являться причиной возникновения поведения.Результаты функционального сканирования должны быть дополнены \n            наблюдением и заполнением АВС таблицы. Интерпретация результатов должнабыть основана на анализе данных, \n            полученных в процессе наблюдения","result_table":{"potential_source_of_reinforcement":{"automatic_pain":"Automatyczne   wzmocnienie   (unikanie bólu)","automatic_sensory":"Automatyczne   wzmocnienie   (stymulacja dotykowa)","social":"Wzmocnienie   społeczne   (Uwaga)","social_escape":"Wzmocnienie   społeczne   (unikanie)","social_specific_activities":"Wzmocnienie społeczne   (dostęp do preferowanych   tematów/działań)"},"titles":{"items":"Należy zaznaczyć numer pytania z odpowiedzią \"Tak\".","potential_source_of_reinforcement":"Funkcja","total":"Liczba pytań z odpowiedzią \"tak\" w każdym wierszu"}},"title":"FAST"},"fastChart":"Wykres podsumowujący FAST","fastTableTitle":"Tabela podsumowująca FAST","goToExercise":"Rozpocząć proces wypełnienia","goToQuiz":"Wykonać","ifNoExplain":"Jeśli \"nie\", to ile godzin tygodniowo?","ifOtherExplain":"If Other, please explain","ifYesExp":"If \"Yes\", please explain","ifYesExplain":"Jeśli \"tak\", to ile godzin na dobę?","information":"Informacje o badaniu","masChart":"Wykres podsumowujący MAS","masTableTitle":"Tabela podsumowująca sesję MAS","maxCountOfSpesialist":"Wybrano maksymalną liczbę specjalistów","meanScore":"średnia ocena punktowa","meanScoreDescription":"(podzielić ogólną ocenę na 4)","motivation_scale":{"answers":{"titles":["Nigdy","Prawie nigdy","Rzadko","W połowie przypadków","Zazwyczaj","Prawie zawsze","Zawsze"]},"description":"Skala motywacyjna to ankieta, która pozwala na szybkie określenie funkcji problematycznych zachowań. Za pomocą\n         skali możliwe jest określenie wcześniejszych uwarunkowań, które wpływają na znaczenie następstw zachowań problemowych \n         (Operacje motywacyjne) i w których takie niepożądane zachowanie zwykle ma miejsce.","general_questions":{"problem_behavior_information":{"questions":{"1":"Zidentyfikowanie docelowego zachowania","2":"Należy krótko opisać sytuacje, w których dochodzi do niepożądanych zachowań."},"title":"Informacje o zachowaniu"}},"information":"Skala motywacyjna zawiera 16 pytań, które opisują różne sytuacje, w których mogą wystąpić niepożądane zachowania. \n        Należy podać jasną i konkretną definicję zamierzonego zachowania (nie \"zachowuje się agresywnie\", ale \"ciosy w twarz\") oraz wypełnić \n        kwestionariusz dotyczący tej definicji. Jeśli dziecko ma kilka rodzajów niepożądanych zachowań, należy wypełnić osobny kwestionariusz \n        dla każdego rodzaju zachowania. Pożądane jest, aby co najmniej dwie osoby z najbliższego otoczenia dziecka wypełniły kwestionariusz.","questions":{"titles":{"1":"Jeśli dziecko zostanie bez opieki, problematyczne zachowanie będzie się powtarzać.","2":"Niepożądane zachowanie wystąpi, jeśli klient zostanie poproszony o wykonanie trudnego zadania.","3":"Niechciane zachowanie ma miejsce, gdy dorosły rozmawia z kimś innym.","4":"Niechciane zachowanie ma miejsce, gdy klient żąda rzeczy motywacyjnej, jedzenia lub ulubionego zajęcia, ale został odrzucony.","5":"Zachowania będą się powtarzać, gdy nikogo nie będzie w pobliżu, a także trwać przez jakiś czas.","6":"Zachowanie pojawi się, jeśli poprosić klienta o zrobienie czegoś.","7":"Zachowanie pojawi się, jeśli przestaną zwracać uwagę na klienta.","8":"Zachowanie pojawi się, gdy zabierzecie jego ulubioną zabawkę, jedzenie, lub przerwiecie ulubioną działalność dziecka.","9":"Klientowi sprawia przyjemność angażowanie się w niepożądane zachowania","10":"Kiedy zlecacie wykonanie zadania, pacient pokazuje niepożądane zachowanie, aby uniknąć zadania.","11":"Pacjent wykazuje niechciane zachowanie, gdy przestają zwracać na niego uwagę.","12":"Zachowanie kończy się, gdy dajecie pacientowi dostęp do preferowanego przedmiotu, jedzenia lub aktywności.","13":"Kiedy pojawia się zachowanie, wydaje się, że klient nie zauważa, gdzie jest i co się wokół niego dzieje.","14":"Zachowanie kończy się, gdy tylko przestaniecie zmuszać dziecko do wykonania określonego zadania.","15":"Zachowanie ma na celu zwrócenie Państwa uwagi.","16":"Zachowanie zdarza się, gdy mówicie, że dziecko nie może czegoś zrobić lub dostać (np. zabawki)."}},"result_interpretation":"Funkcja, która uzyskuje maksymalną liczbę punktów może potencjalnie spowodować zachowanie. Wyniki skali \n        motywacyjnej powinny być uzupełnione uwagami i wypełnieniem tablicy ABC. Interpretacja wyników powinna opierać się na analizie danych \n        uzyskanych podczas monitoringu oraz na ostatecznych wynikach kwestionariusza.","result_table":{"results":{"mean_score":"średnia ocena punktowa","relative_ranking":"Względnе rozpowszechnianie","total_score":"Ogólny wynik"},"titles":{"attention":"Uwaga","escape":"Unikanie","sensory":"Dotykowa","tangible":"Dostęp"}},"title":"MAS"},"oneFastChart":"Wykres FAST","oneMasChart":"Wykres MAS","passed_at":"Data i godzina badania","pdfReport":"Raport w formacie PDF","question_answers":"Odpowiedzi na pytania","question_titles":{"create_titles":{"fast":{"evaluator_information":{"questions":{"1":"Od jak dawna utrzymujecie kontakt z klientom?","2":"Czy kontaktujecie się z klientem сodziennie?","3":"W jakich sytuacjach obserwujecie klienta? Proszę zapisać wszystkie stosowne sytuacje."},"title":"Evaluator Information"},"nonsocial_reinforcement":{"questions":{"19":"The behavior occurs frequently when the student is alone or unoccupied.","20":"The behavior occurs at relatively high rates regardless of what is going on in the \n                            student's immediate surrounding environment.","21":"The student seems to have few known reinforcers or rarely engages in appropriate object\n                            manipulation or \"play\" behavior.","22":"The student is generally unresponsive to social stimulation","23":"The student often engages in repetitive, stereotyped behaviors such as body rocking, \n                            hand or finger waving, object twirling, mouthing, etc.","24":"When the student engages in the behavior, you and others usually respond by doing nothing \n                            (e.g. you never or rarely attend to the behavior)","25":"The behavior seems to occur in cycles. During a \"high\" cycle, the behavior occurs \n                            frequently and is extremely difficult to interrupt. During a \"low\" cycle the behavior rarely occurs.","26":"The behavior seems to occur more often when the student is ill.","27":"The student has a history of recurrent illness (e.g. ear or sinus infections, allergies, dermatitis, etc)."},"title":"Part III. Nonsocial (Automatic) Reinforcement"},"social_influences_on_behavior":{"questions":{"1":"Zachowanie zazwyczaj ma miejsce w Państwa obecności lub w obecności innych osób.","2":"Zachowanie zazwyczaj następuje po interakcji z klientem. Na przykład po udzieleniu mu instrukcji \n                        lub dezaprobaty, pozostawieniu go (zignorowaniu), zakończeniu dostępu do preferowanego tematu, zażądaniu \n                        zmiany działalności, rozmowie z kimś innym w obecności klienta, itp.","3":"Zachowaniom często towarzyszą reakcje \"emocjonalne\", takie jak krzyki czy łazy."},"title":"Part I. Social Influences on Behavior"},"social_reinforcement":{"questions":{"4":"Zachowanie jest często obserwowane, gdy klient nie otrzymał uwagi.","5":"Kiedy pojawia się zachowanie, Pan(i) lub inne osoby reagują w jakikolwiek sposób \n                        (używają fraz pocieszających, blokują lub przekierowują reakcję, używają fraz osądzających, itp. ","6":"Klient często wykazuje inne niepożądane zachowania, które przyciągają uwagę.","7":"Klient często zbliża się do Pana( i) lub innych osób i inicjuje interakcje społeczne.","8":"Zachowanie jest rzadko obserwowane, jeśli klient otrzymuje dużo uwagi..","9":"Zachowanie jest często obserwowane w przypadku zakończenia dostępu klienta do określonego tematu \n                        lub preferowanego działania..","10":"Zachowanie jest często obserwowane, gdy informujecie się klienta, że nie jest on w stanie uzyskać \n                        dostępu do konkretnego tematu lub czynności..","11":"Obserwując zachowanie, często reagujecie, dając klientowi dostęp do konkretnej rzeczy, \n                        preferowanego jedzenia lub innego przedmiotu..","12":"Klient często wykazuje inne niepożądane zachowania. W wyniku takiego zachowania klient ma dostęp do preferowanych mu tematów lub czynności..","13":"Zachowanie jest rzadko obserwowane podczas zajęć szkoleniowych lub gdy stawia się klientowi inne wymagania. Jeśli tak, proszę określić rodzaje działań:","14":"The behavior often occurs during training activities or when asked to complete tasks.","15":"The student often is noncompliant during training activities or when asked to complete tasks.","16":"The behavior often occurs when the immediate environment is very noisy or crowded.","17":"When the behavior occurs, you often respond by giving the student a brief break from an ongoing task.","18":"The behavior rarely occurs when you place few demands on the student or when you leave them alone."},"title":"Part II. Social Reinforcement"}},"motivation_scale":{"main_questions":{"questions":{"1":"Jeśli dziecko zostanie bez opieki, problematyczne zachowanie będzie się powtarzać.","2":"Niepożądane zachowanie wystąpi, jeśli klient zostanie poproszony o wykonanie trudnego zadania.","3":"Niechciane zachowanie ma miejsce, gdy dorosły rozmawia z kimś innym.","4":"Niechciane zachowanie ma miejsce, gdy klient żąda rzeczy motywacyjnej, jedzenia lub ulubionego zajęcia, ale został odrzucony.","5":"Zachowania będą się powtarzać, gdy nikogo nie będzie w pobliżu, a także trwać przez jakiś czas.","6":"Zachowanie pojawi się, jeśli poprosić klienta o zrobienie czegoś.","7":"Zachowanie pojawi się, jeśli przestaną zwracać uwagę na klienta.","8":"Zachowanie pojawi się, gdy zabierzecie jego ulubioną zabawkę, jedzenie, lub przerwiecie ulubioną działalność dziecka.","9":"Klientowi sprawia przyjemność angażowanie się w niepożądane zachowania","10":"Kiedy zlecacie wykonanie zadania, pacient pokazuje niepożądane zachowanie, aby uniknąć zadania.","11":"Pacjent wykazuje niechciane zachowanie, gdy przestają zwracać na niego uwagę.","12":"Zachowanie kończy się, gdy dajecie pacientowi dostęp do preferowanego przedmiotu, jedzenia lub aktywności.","13":"Kiedy pojawia się zachowanie, wydaje się, że klient nie zauważa, gdzie jest i co się wokół niego dzieje.","14":"Zachowanie kończy się, gdy tylko przestaniecie zmuszać dziecko do wykonania określonego zadania.","15":"Zachowanie ma na celu zwrócenie Państwa uwagi.","16":"Zachowanie zdarza się, gdy mówicie, że dziecko nie może czegoś zrobić lub dostać (np. zabawki)."}},"problem_behavior_information":{"questions":{"1":"Zidentyfikowanie docelowego zachowania","2":"Należy krótko opisać sytuacje, w których dochodzi do niepożądanych zachowań."},"title":"Informacje o zachowaniu"}}},"show_titles":{"fast":{"evaluator_information":{"questions":{"1":"Od jak dawna utrzymujecie kontakt z klientom?","2":"Czy kontaktujecie się z klientem сodziennie?","3":"W jakich sytuacjach obserwujecie klienta? Proszę zapisać wszystkie stosowne sytuacje."},"title":"Evaluator Information"},"nonsocial_reinforcement":{"questions":{"19":"The behavior occurs frequently when the student is alone or unoccupied.","20":"The behavior occurs at relatively high rates regardless of what is going on in the \n                            student's immediate surrounding environment.","21":"The student seems to have few known reinforcers or rarely engages in appropriate object\n                            manipulation or \"play\" behavior.","22":"The student is generally unresponsive to social stimulation","23":"The student often engages in repetitive, stereotyped behaviors such as body rocking, \n                            hand or finger waving, object twirling, mouthing, etc.","24":"When the student engages in the behavior, you and others usually respond by doing nothing \n                            (e.g. you never or rarely attend to the behavior)","25":"The behavior seems to occur in cycles. During a \"high\" cycle, the behavior occurs \n                            frequently and is extremely difficult to interrupt. During a \"low\" cycle the behavior rarely occurs.","26":"The behavior seems to occur more often when the student is ill.","27":"The student has a history of recurrent illness (e.g. ear or sinus infections, allergies, dermatitis, etc)."},"title":"Part III. Nonsocial (Automatic) Reinforcement"},"social_influences_on_behavior":{"questions":{"1":"Zachowanie zazwyczaj ma miejsce w Państwa obecności lub w obecności innych osób.","2":"Zachowanie zazwyczaj następuje po interakcji z klientem. Na przykład po udzieleniu mu instrukcji \n                        lub dezaprobaty, pozostawieniu go (zignorowaniu), zakończeniu dostępu do preferowanego tematu, zażądaniu \n                        zmiany działalności, rozmowie z kimś innym w obecności klienta, itp.","3":"Zachowaniom często towarzyszą reakcje \"emocjonalne\", takie jak krzyki czy łazy."},"title":"Part I. Social Influences on Behavior"},"social_reinforcement":{"questions":{"4":"Zachowanie jest często obserwowane, gdy klient nie otrzymał uwagi.","5":"Kiedy pojawia się zachowanie, Pan(i) lub inne osoby reagują w jakikolwiek sposób \n                        (używają fraz pocieszających, blokują lub przekierowują reakcję, używają fraz osądzających, itp. ","6":"Klient często wykazuje inne niepożądane zachowania, które przyciągają uwagę.","7":"Klient często zbliża się do Pana( i) lub innych osób i inicjuje interakcje społeczne.","8":"Zachowanie jest rzadko obserwowane, jeśli klient otrzymuje dużo uwagi..","9":"Zachowanie jest często obserwowane w przypadku zakończenia dostępu klienta do określonego tematu \n                        lub preferowanego działania..","10":"Zachowanie jest często obserwowane, gdy informujecie się klienta, że nie jest on w stanie uzyskać \n                        dostępu do konkretnego tematu lub czynności..","11":"Obserwując zachowanie, często reagujecie, dając klientowi dostęp do konkretnej rzeczy, \n                        preferowanego jedzenia lub innego przedmiotu..","12":"Klient często wykazuje inne niepożądane zachowania. W wyniku takiego zachowania klient ma dostęp do preferowanych mu tematów lub czynności..","13":"Zachowanie jest rzadko obserwowane podczas zajęć szkoleniowych lub gdy stawia się klientowi inne wymagania. Jeśli tak, proszę określić rodzaje działań:","14":"The behavior often occurs during training activities or when asked to complete tasks.","15":"The student often is noncompliant during training activities or when asked to complete tasks.","16":"The behavior often occurs when the immediate environment is very noisy or crowded.","17":"When the behavior occurs, you often respond by giving the student a brief break from an ongoing task.","18":"The behavior rarely occurs when you place few demands on the student or when you leave them alone."},"title":"Part II. Social Reinforcement"}},"motivation_scale":{"main_questions":{"questions":{"1":"Jeśli dziecko zostanie bez opieki, problematyczne zachowanie będzie się powtarzać.","2":"Niepożądane zachowanie wystąpi, jeśli klient zostanie poproszony o wykonanie trudnego zadania.","3":"Niechciane zachowanie ma miejsce, gdy dorosły rozmawia z kimś innym.","4":"Niechciane zachowanie ma miejsce, gdy klient żąda rzeczy motywacyjnej, jedzenia lub ulubionego zajęcia, ale został odrzucony.","5":"Zachowania będą się powtarzać, gdy nikogo nie będzie w pobliżu, a także trwać przez jakiś czas.","6":"Zachowanie pojawi się, jeśli poprosić klienta o zrobienie czegoś.","7":"Zachowanie pojawi się, jeśli przestaną zwracać uwagę na klienta.","8":"Zachowanie pojawi się, gdy zabierzecie jego ulubioną zabawkę, jedzenie, lub przerwiecie ulubioną działalność dziecka.","9":"Klientowi sprawia przyjemność angażowanie się w niepożądane zachowania","10":"Kiedy zlecacie wykonanie zadania, pacient pokazuje niepożądane zachowanie, aby uniknąć zadania.","11":"Pacjent wykazuje niechciane zachowanie, gdy przestają zwracać na niego uwagę.","12":"Zachowanie kończy się, gdy dajecie pacientowi dostęp do preferowanego przedmiotu, jedzenia lub aktywności.","13":"Kiedy pojawia się zachowanie, wydaje się, że klient nie zauważa, gdzie jest i co się wokół niego dzieje.","14":"Zachowanie kończy się, gdy tylko przestaniecie zmuszać dziecko do wykonania określonego zadania.","15":"Zachowanie ma na celu zwrócenie Państwa uwagi.","16":"Zachowanie zdarza się, gdy mówicie, że dziecko nie może czegoś zrobić lub dostać (np. zabawki)."}}}}},"quiz":"Ankiety i badania","quizComplete":"Badanie ankietowe zakończone","quizTitle":"Wywiady ustrukturyzowane i narzędzia oceny funkcjonalnej","relativeRanking":"Względnе rozpowszechnianie","relativeRankingDescription":"(od więcej do mniej)","removedUser":"Specjalista jest usunięty","reportTitle":"Wywiady ustrukturyzowane i narzędzia oceny funkcjonalnej","result_interpretation":"Interpretacja wyniku","saveQuiz":"Save quiz","scheduled_at":"Data przeznaczenia","show":"Pokazać","take":"Wykonać","targetBahaviour":"Zachowanie docelowe","totalScore":"Ogólny wynik","typeQuiz":"Typ badania"},"pl.random_rotation":{"block_results":{"Correct":"Poprawny","Incorrect":"Błąd","No data":"Brak danych","Prompt":"Podpowiedź"},"forbidden":"Nie masz dostępu do tego modułu dla tego klienta"},"pl.registration":{"buttons":{"signup":"Zarejestrować się"},"congrats":{"first_line":"Jesteś zarejestrowany.","second_line":"Możesz wejść do systemu za pomocą adresu e-mail i hasła."},"header":"Rejestracja","user_types":{"bcba":"Analityk","independent_curator":"Niezależny kurator","supervisor":"Aby prowadzić nadzór"}},"pl.report":{"UB":"NZ","add_skill":"Dodaj obszar umiejętności","address":"620075, Rosja, Jekaterynburg, ul. Malysheva, 51, piętro 29, +7 (343) 384-84-81, info@company.com, NIP 123456789, REGON 123456789","all":"Wszystko","all_centre":"Wszystkie centrum","all_protocol":"Wszystkie protokoły","all_skill":"Wszystkie obszary","archive_reports":"Archiwum raportów","author":"Autor","average_speed_bids":"Średnia prędkość przetwarzania i zgłoszeń, w dniach","bids_all":"Całkowita liczba zgłoszeń","bids_completed":"Zgłoszenia opracowane","bids_created":"Utworzono aplikacji","bids_new":"Zgłoszenia nowe","bids_overdue":"Zgłoszenia przeterminowane","blocks":"Bloki  dziennej sesji","changes_from":"Zmiany z","changes_in_protocol":"Zmiany protokołu","changes_in_protocols":"Rejestr zmian protokołu","chart_for_category_daily_pecs":"Liczba preferowanych właściwości w każdym bloku sesji dziennej.","chart_for_daily_pecs":"Liczba opanowanych sekwencji w każdym bloku sesji dziennej","chart_for_perc_daily_pecs":"Procent sekwencji opanowanych w każdym bloku sesji dziennej","chart_for_percent_axes":" % kroków podjętych w środowisku","chart_for_percent_daily":"Udział kroków łańcucha opanowanych w każdym dziennym bloku sesji","chart_for_percent_daily_pecs":"części opanowywanych sekwencji na kroku","chart_for_percent_daily_pecs2":"części opanowanych sekwencji","chart_for_properties_daily":"Liczba preferowanych właściwości w każdym bloku sesji dziennej.","chart_for_properties_percent_daily":"Częśći preferowanych właściwości w każdym bloku sesji dziennej.","chart_for_step_axes":"liczba kroków na etap","chart_for_step_daily":"Liczba kroków łańcucha opanowanych w każdym dziennym bloku sesji","chart_for_step_daily_pecs":"liczba opanowanych sekwencji na etapie","chart_for_step_daily_pecs2":"liczba opanowanych sekwencji","chart_for_steps_daily":"Liczba reakcji na krok n każdego bloku codziennej sesji.","chart_for_steps_daily_pecs":"Liczba reakcji dla danej sekwencji w każdym bloku sesji dziennej.","chart_for_stimul_daily":"Liczba reakcji na bodziec w każdym bloku codziennej sesji.","chart_percent_axes":" % kroków podjętych","choose_client":"Wybierz klienta z listy","choose_clinic_centre":"Wybierz swoje centrum kliniczne","choose_curator":"Wybierz kuratora","choose_period":"Wybierz period","choose_protocol":"Wybierz protokół","choose_skill":"Wybierz obszar umiejętności","choose_therapist":"Wybierz terapeute","client":"Klient","clients":"Klienci","clients_count":"Liczba klientów","clinic_centre":"Centrum kliniczne","condition_mastered":"Warunek opanowania bodźca","condition_mastered_step":"Kryterium opanowania kroku","confidentially":"Konfidencjonalnie","conflict_sessions":"Sesje konfliktowe","conflict_sessions_title":"Szczegółowy ekran sesji konfliktowej","consolidated_efficiency":"Ogólny % efektywności ","count_stim":"liczba opanowanych bodźców","cumulitive_graph":"Kumulatywny wykres opanowanych bodźców","cumulitive_graph_for_protocol":"Kumulatywny wykres opanowanych bodźców dla protokołu","cumulitive_graph_pecs":"Schemat śledzenia w celu opanowania sekwencji docelowej w danym kroku","cumulitive_graph_pecs2":"Schemat śledzenia w celu opanowania sekwencji docelowej ","curator":"Kurator","daily_session":"Sesja dzienna","data_UB":"Dane o NZ","data_appeals":"Dane o prośbach","data_protocol":"Dane o protokołach","data_without_stimuli":"Nie przeprowadzono żadnych zajęć","date_generation":"Wygenerowano w dniu","day_session":"Sesje popołudniowe","delete_report":"Usuń","deleted_user":"usunięty","description_choose_client":"wybierz klienta, aby utworzyć ten raport","description_choose_curator":"jeśli kurator nie zostanie określony, raport będzie zawierać wszystkie zapisy z listy","description_choose_period":"jeśli przedział czasowy nie jest określony, raport obejmie cały dostępny przedział czasowy","description_choose_protocol":"jeśli protokół nie zostanie określony, raport przejdzie do wszystkich zapisów z listy","description_choose_skill":"jeśli obszar umiejętności nie zostanie określony, ​​raport obejmie wszystkie możliwe obszary","description_choose_therapist":"jeśli terapeuta nie zostanie określony, raport będzie zawierać wszystkie zapisy z listy","description_max_period":"maksymalny dostępny okres 4 miesiące","download_pdf":"Załadować PDF","draw_report":"Utwórz raport","duration":"Czas trwania sesji","filters":"Filtry","footer_sub_title":"Wszelkie naruszenia będą należycie ścigane przez właściwe organy zgodnie z obowiązującymi przepisami.","footer_title":"Korzystanie z tej usługi jest dozwolone wyłącznie na podstawie przepisów BACB Professional and Ethical Compliance Code for Behavior Analysts opublikowanych na","for_all_protocol":"Dla wszystkich protokołów","for_chain":"W przypadku protokołów dotyczących łańcucha dowodowego","for_mand":"Dla protokołu Mand","from":"z","generate":"Sformować","generate_by":"Wygenerowane przez AutismTech www.autismtech.online","generate_csv_version":"Wygeneruj wersję CSV","generate_pdf_version":"Wygeneruj wersję PDF","generate_version":"Wygeneruj wersję","generated_by":"Wygenerowane przez AutismTech www.autismtech.online","graph_cumulative_improve":"Wykres kumulatywny :first, :second i :third","graph_efficiency":"Tabela efektywności ","graph_goal":"Wykres :first, :second i :third","graph_improve":"Wykres kumulatywny :improve","graph_improve_prompt":"Wykres :improve, stosunek próbek z :improve do całkowitej liczby próbek","graph_mand_react":"Wykres częstotliwości spontanicznych reakcji mand, na godzinę ","graph_mo_goal":"Wykres warunków motywacyjnych (OM - TAK)","graph_mo_yes":"Wykres -%  próbek z MOM - TAK","graph_mo_yes_percent":"Wykres % pierwszych próbek z OM - TAK","graph_probe":"Wykres :first wraz z :second i :third w odniesieniu do całkowitej liczby próbek na sesję","graph_prompt_levels":"Wykres zmniejszenia poziomu podpowiedzi","graph_relation_prompt":"Wykres zależności próbek z podpowiedzią + próbki z :second z podmiotem do spontanicznych poprawnych reakcji","header":"Raporty","himself":"Całkowita liczba reakcji mand bez podpowiedzi (N,N+)","himself_per_hour":"Liczba reakcji mand na godzinę bez podpowiedzi","himself_per_minute":"Liczba reakcji mand na minutę bez podpowiedzi","hours":"Godziny","hours_with_client":"Godziny z klientami","info_client":"Dane klienta","info_curator":"Dane kuratora","info_curators":"Dane kuratorów","info_therapist":"Dane terapeuty","info_therapists":"Dane terapeutów","introduced":"Wprowadzono","label_cumulative_improve":"Liczba reakcji :first, :second i :third","label_goal":"% :first, :second i :third","label_improve":"Liczba reakcji :improve","label_improve_prompt":"% :improve","label_mand_react":"Częstotliwość spontanicznych reakcji","label_mo_goal":"% OM - TAK","label_mo_yes":"% próbek z MOM - TAK","label_mo_yes_percent":"% pierwszych próbek z OM - TAK","label_probe":"% :first + :second + :third","label_prompt_levels":"Poziomy podpowiedzi","label_relation_prompt":"zależność próbek z podpowiedzią + próbki z :second z podmiotem do spontanicznych poprawnych reakcji","legend":"Symbole oznaczające:","mastered":"Opanowany","min":"min","name_report":"Tytuł","number_properties_pecs":"liczba preferowanych właściwości","number_step":"liczba opanowanych kroków łańcucha","number_step_pecs":"liczba sekwencji","number_step_pecs_detail":"liczba of reactions ","percent_category":"liczba opanowanych funkcji","percent_count":"Liczba %","percent_efficiency":"% efektywności","percent_properties_pecs":"częśći preferowanych właściwości","percent_step":" % kroków podjętych w łańcuchu","percent_step_pecs":"części sekwencji","percent_step_pecs_detail":"części of reactions ","period":"Period","protocol":"Protokół","range_end":"Period do","range_from":"Period z","reaction_count":"Liczba reakcji","report":"Raport","save_report":"Zapisz raport","sec":"sec","sessions_client":"Sesje z rodzicami","sessions_therapist":"Sesje z terapeutą (kuratorem)","sessions_total":"Sesje razem","show_graph":"Pokaż wykresy dla celu","show_graph_btn":"Pokaż wykresy","simple":"Prosty","skill_domain":"Obszar umiejętności","specialist":"Specjalista","spontaneous":"Tylko spontaniczne reakcje mand","spontaneous_per_hour":"Liczba spontanicznych reakcji mand na godzinę","spontaneous_per_minute":"Liczba reakcji mand na minutę","start_protocol":"Zacznij wprowadzać protokół","start_skill":"Zacznij wprowadzać obszar umiejętności","statistics_mand":"Ogólna statystyka reakcji mand","status":{"1":"Tworzy się ","2":"Stworzony","3":"Coś poszło nie tak"},"statusCSV":["Tworzy się","Stworzony","Coś poszło nie tak","Brak danych"],"step_count":"Liczba kroków","stimul":"Bodziec","summary_table_requests":"Rejestr prośb","table_prompts":"Tabela wprowadzania i opanowania bodźca","therapist":"Terapeuta","time_with_client":"Czas z rodzicami","time_with_therapist":"Czas z terapeutą (kuratorem)","title":{"about_clients":"Raport z interwencji","about_curators":"Raport o kuratorach","about_therapists":"Raport o terapeutach"},"to":"do","total":"Razem","total_time":"Całkowity czas, godz","with_prompts":"Suma podpowiedzi mands","with_prompts_per_hour":"Liczba reakcji mand na godzinę z podpowiedzią","with_prompts_per_minute":"Liczba reakcji mand na minutę z podpowiedzią","within_24_hours":"W 24 godziny","without_mand":"za wyjątkiem protokołu Mand","write_protocols":"Utworzono protokoły"},"pl.reset_password":{"forms":{"reset_password":{"bcba_new_pass":"Zwróć się do swojego analityka, aby uzyskać nowe hasło.","buttons":{"reset":"Zmień hasło"},"congrats":{"first_line":"Hasło zostało zmienione.","second_line":"Możesz zalogować się przy użyciu swojego ID i hasła."},"congrats_email":"Żądanie odzyskania hasła wysłane do analityka","congrats_email_bcba":"System Autismtech już wysłał link na Twój e-mail. Kliknij link, aby zmienić hasło na bezpieczniejsze i łatwiejsze do zapamiętania.","header":"Zmień hasło","sub_header":"Wpisz swój ID i nowe hasło"},"send_token":{"buttons":{"send_password":"Odzyskać"},"header":"Odzyskiwanie hasła","sub_header":"Wpisz swój ID, którego używasz do logowania","success_alert":"Link do resetowania hasła jest wysyłany!"}}},"pl.rotation":{"L":"L","M":"M","P":"P","R":"R","block":"Blok","build_table":"Utwórz tabelę","cancel":"Anuluj","description":"Przedmioty na stole są umieszczane zgodnie z określonym schematem, a przedmiot docelowy (o który pytamy) jest zawsze inny.","destroy_table":"Zresetuj tabelę","forbidden":"Nie masz dostępu do tego modułu dla tego klienta","instructions":{"collapse":"Zwiń","expand":"Czytać w całości","header":"Instrukcje:","text":"Przedmioty na stole są umieszczane zgodnie z określonym schematem, a przedmiot docelowy (o który pytamy) jest zawsze inny. Terapeuta potrzebuje teraz wizualnej podpowiedzi na temat położenia przedmiotów, o które należy zapytać i możliwości zarejestrowania jakości reakcji.  1. Pierwszy ekran: wprowadź tytuły 3 bodźców, tj. Kota (A), piłki (B) i soku (C). Drugi i kolejne ekrany mogą wyglądać na załączone. Tabela definiuje 27 linii, a następnie uruchamia się ponownie od bloku 1, więc procedura może się obracać w nieskończoność. W rezultacie, gdy zestaw jest skończony, pojawia się tabela z procentem prawidłowych reakcji według bodźca i liczbą prób na bodziec. Ta tabela może zostać wysłana pocztą e-mail."},"interactive_module":"Moduł interaktywności","interactive_module_two":"Moduł interaktywności 2","interactive_modules":"Moduły interaktywności","next_block":"Następny blok","no_data":"Brak danych","p":"p","pagination":{"next":"Dalej","previous":"Wstecz"},"report":{"all_approaches_count":"Ogólna liczba prób","auditor":"Specjalista, który przeprowadził sesję","client":"Klient","date":"Data","download_report":"Pobierz raport","fail_answer_rate":"% Błędnych odpowiedzi","header":"Raport z sesji","hint_rate":"% Podpowiedzi","no_answer_rate":"% Niewypełnionych prób","number_of_approaches_for_stimulus":"Liczba prób na bodziec","report":"Raport","started_at":"Data i godzina","stimulus_count":"Liczba bodźców","success_rate":"Procent prawidłowych reakcji na bodziec","successful_answer_rate":"% Poprawnych odpowiedzi","therapist":"Terapeuta"},"reports":"Raporty","result":"Wynik","save":"Zapisz","session":"Sesja","show_results":"Pokaż wyniki","start_session":"Rozpocznij sesję","stimulus":"Bodziec","stimulus_one":"Bodziec 1","stimulus_three":"Bodziec 3","stimulus_two":"Bodziec 2","title":"Automatyzacja za pomocą losowej rotacji","unique_stimulus":"Bodźce nie mogą się powtarzać","write_names_for_stimulus":"Wprowadź tytuły bodźców"},"pl.settings":{"client_price":"Koszt klienta w systemie","currency_unit":"Konwencjonalna jednostka walutowa","maintenance":"Tryb konserwacji","maintenance_in":"Dozwolone znaczenia: 'on', 'off'","page_not_found":"Strona nie znaleziona","page_not_found_subscription":"Żądana strona nie istnieje. Możesz przejść na stronę główną lub skorzystać z pomocy technicznej na stronie kontaktowej."},"pl.subscription":{"add_comment":"Dodaj komentarz","choose_region":"Wybierz region z listy","comment":"Komentarz do prośby o nową subskrypcję","comment_title":"Komentarz","cost":"Koszt","create_date":"Data stworzenia","discount":{"value":{"type":{"percent":"%"}}},"duration":"Czas trwania","duration_days":":value d.","end_date":"Data zakończenia","start_date":"Data rozpoczęcia","status":{"active":"Aktywny","finished":"Zakończone","inactive":"Nieaktywny","new":"Nowy","under_consideration":"W opracowaniu"},"sub_title":"При оплате подписки сроком на 3 месяца вы получаете скидку 10%, при оплате сроком на 6 месяцев - 20%","subscription_continue":"Przedłuż subskrypcję lub skontaktuj się z pomocą techniczną, aby kontynuować pomiary.","subscription_expired":"Twoja subskrypcja wygasła.","subscription_expired_today":"Twoja subskrypcja wygasa dzisiaj.","subscription_limited":"Możliwość zapisania pomiarów jest ograniczona. Aby kontynuować pomiary, przedłuż  subskrypcję na swoim profilu lub skontaktuj się z pomocą techniczną.","subscription_period":"Okres subskrypcji","subscription_soon_expired":"Twoja subskrypcja wygasa za :attribute dni.","title":"Poproś o nową subskrypcję"},"pl.upload":{"accept_file_types":"Typ pliku nie jest obsługiwany","add_file":"Załaduj plik","cancel":"Anulować","delete":"Usuń","failed":"Nie udało się załadować plik","max_file_size":"Plik jest za duży","max_number_of_files":"Osiągnięto maksymalną liczbę plików","min_file_size":"Plik jest za mały"},"pl.user":{"C":"K","P":"P","T":"T","active_protocol":"Aktywne protokoły","add":"Dodaj","add_client":"Dodaj Klienta","add_client_no_data":"Brak dostępnych klientów","add_curator":"Dodaj Kyratora","add_therapist":"Dodaj Terapeutę","add_therapist_no_data":"Brak dostępnych terapeutów dla tego kuratora","attached_therapist_list":"Lista przypisanych terapeutów","bcba":"Analityk","bcba_languages":{"en":"Angielski","pl":"Polski","ru":"Rosyjski"},"bcba_statuses":{"Active":"Aktywny","Deactivated":"Zdezaktywowany","Mensuration forbidden":"Pomiary zabronione"},"bcba_types":{"BCBA":"Analityk","Independent curator":"Niezależny kurator"},"cancel":"Anuluj","choose_client_from_list":"Wybierz klienta z listy","choose_therapist_from_list":"Wybierz terapeutę z listy","client":"Klient","clientHash":"Skrót klienta","client_code":"Kod klienta","clients":"Klienci","clinical_center":"Centrum kliniczne","clinical_center_no_data":"Brak danych","close":"Zamknij","confirm_delete":"Czy potwierdzasz usunięcie?","confirm_delete_client_form_therapist":"Czy na pewno chcesz usunąć przypisanego klienta?","confirm_delete_text":"Czy na pewno chcesz usunąć przypisanego terapeutę?","confirm_delete_title":"Potwierdź usunięcie","contacts":"Rodzic","curator":"Kurator","curator_profile":"Profil kuratora","curators":"Kuratorzy","dashboard":"Panel sterowania","delete":"Usuń","display_name":"Użytkownik","edit":"Edytuj","edit_client":"Edytuj zapis Klienta","edit_curator":"Edytuj zapis Kuratora","edit_therapist":"Edytuj zapis Terapeuty","hours_parent":"Godziny z rodzicami","hours_therapist":"Godziny z terapeutą","list_attached_clients":"Lista przypisanych klientów","no_data":"Brak danych","number":"Numer","parent_email":"E-mail Rodzica","parent_first_name":"Imię Rodzica","parent_last_name":"Nazwisko Rodzica","password":"Hasło","profile_therapist":"Profil terapeuty","request_for_work":"Zgłoszenia w opracowaniu","request_for_work_overdue":"Zgłoszenia w opracowaniu/przeterminowane","save":"Zapisz","start_curator":"Zacznij wpisywać imię kuratora","start_therapist":"Zacznij wpisywać imię terapeuty","supervisor":"Superwizor","therapist":"Terapeuta","therapists":"Terapeuci","type_the_client_code_to_search":"Wprowadź kod klienta do wyszukania ...","type_the_client_name_to_search":"Wprowadź nazwę klienta do wyszukania ...","type_the_clinical_center_name_to_search":"Wprowadź nazwę centrum klinicznego, aby wyszukać ...","type_the_curator_name_to_search":"Wprowadź imię kuratora do wyszukania ...","type_the_therapist_name_to_search":"Wprowadź imię terapeuty do wyszukania ...","type_the_timezone_to_search":"Wybierz strefę czasową do wyszukiwania ...","update":"Odśwież","user":"Użytkownik","username":"Identyfikator","users":"Użytkownicy"},"pl.validation":{"accepted":"Musisz zaakceptować :attribute.","active_url":"Pole :attribute zawiera nieprawidłowy adres URL.","after":"Pole :attribute musi mieć datę po :date.","after_or_equal":"Pole :attribute musi być data po lub równą :date.","alpha":"Pole :attribute musi zawierać tylko znaki w tym samym alfabecie.","alpha_dash":"Pole :attribute musi zawierać tylko znaki w tym samym alfabecie, w tym. cyfry i myślniki.","alpha_num":"Pole :attribute musi zawierać znaki tylko w obrębie tego samego alfabetu i cyfr.","alpha_spaces":"Pole :attribute musi zawierać znaki tylko w obrębie tego samego alfabetu i spacji.","array":"Pole :attribute musi być tablicą.","attributes":{"address":"Adres","analystEmail":"E-mail аnalityka","antecedentTypes":"Typowe zmienne poprzedzające","assigneeId":"ID Klienta","auditorId":"Audytor ID","bcbaId":"ID analityka","bcba_id":"Analityk","behaviorTypes":"Typowe zachowania","captcha":"Kod bezpieczeństwa","captcha_key":"Sekretny klucz","center":"Centrum","centerEmail":"E-mail centrum","centerName":"Nazwa centrum","centerPhone":"Telefon centrum","centers":"Centrum","certificate":"Certyfikat","certificateActionType":"Typ działania z certyfikatem","certificateFileName":"Plik certyfikatu","client_count":"Liczba klientów ","comment":"Komentarz","contacts":"Kontakty","content":"Treść","created_at":"Data stworzenia","currentPassword":"Aktualne hasło","displayName":"Użytkownik","display_name":"Użytkownik","effectsTypes":"Typowe konsekwencje ","email":"E-mail","enable":"Status","enableFalse":"Wyłączyć","enableTrue":"Włączyć","file":"Plik","finishedAt":"Czas realizacji","finished_at":"do","firstName":"Imię","first_name":"Imię","full_name":"Imię i nazwisko","goal":"Cel","hash":"Hash","id":"ID","intervals":"Interwały","intervals.*.behaviourHappenedAt":"Zachowanie docelowe nastąpiło w","intervals.*.duration":"Czas trwania interwału","intervals.*.index":"Indeks interwałów","key":"Klucz","language":"Język","lastName":"Nazwisko","last_name":"Nazwisko","legalName":"Nazwa prawna","logo":"Logo","menu":"Menu","menu_id":"ID Menu","message":"Wiadomość","meta_description":"Opis meta","meta_keywords":"Meta słowa kluczowe","meta_title":"Tytuł meta","name":"Imię ","newPassword":"Nowe hasło","newPasswordConfirmation":"Potwierdzenie hasła","new_password":"Nowe hasło","old_password":"Aktualne hasło","owner":"Właściciel","page_slug":"Strona","password":"Hasło","password_confirmation":"Potwierdzenie hasła","period":"Period","phone":"Telefon","position":"Pozycja","protocol":{"applying":"Obszar","baseLevel":"Poziom podstawowy","code1":"ABBLS","code2":"VB-MAPP","describe_stage":"Opisz etap","errorCorrection":"Korekcja błędów","execution":"Realizacja","features":"Właściwości","goal":"Cel","hintType":"Rodzaj podpowiedzi","instruction":"Instrukcja","max_field_count":"Maksymalna liczba pól","min_field_count":"Minimalna liczba pól","provideHint":"Podpowiedź","reductionHint":"Kryterium upuszczania podpowiedzi","reductionHintMethod":"Metoda upuszczania podpowiedzi","rightReaction":"Prawidłowa reakcja","risingPrompt":"Kryterium wzrostu podpowiedzi","stage":"Etap","title":"Tytuł protokołu"},"published":"Opublikowano","ratingId":"Moduł oceny","region_discount_id":"Taryfa","remember_me":"Zapamiętaj mnie","report":{"behaviourDescription":"Opis zachowania docelowego","behaviourTypeId":"Typ zachowania","failedIntervalCount":"Liczba nieudanych interwałów","intervalCount":"Liczba interwałów","intervalDurationUnitId":"Jednostki miary interwałowej","intervalDurationValue":"Czas przerwy","rightCount":"Liczba poprawnych odpowiedzi","sessionDuration":"Czas trwania sesji","successfulIntervalCount":"Liczba udanych interwałów","suggestedCount":"Liczba podpowiedzi","totalCount":"Ogólna liczba prób","uncompletedCount":"Liczba niepełnych prób","wrongCount":"Liczba niepoprawnych odpowiedzi"},"role":"Rola","sessions":"Sesje","sessions.*.blocks":"Blok","sessions.*.blocks.*.index":"Indeks bloku","sessions.*.blocks.*.resultId":"Wyniki bloku","sessions.*.blocks.*.stimuli":"Bodźcy","sessions.*.blocks.*.stimuli.*.correct":"Prawidłowy bodziec","sessions.*.blocks.*.stimuli.*.name":"Tytuł bodźca","sessions.*.blocks.*.stimuli.*.position":"Pozycja bodźca","sessions.*.index":"Indeks sesji","skillField":"Obszar umiejętności","skillFieldName":"Nazwa obszaru umiejętności","skillRating":"Moduł oceny","skillRatingName":"Nazwa modułu oceny","slug":"Slug","socialNetwork":"Sieci społecznościowe","stage":"Etap","startedAt":"Czas rozpoczęcia","started_at":"z","status_id":"Status","stimuli":"Bodźcy","stimuli.*":"Tytuł bodźca","subscription_auto_cost":"Cena zalecana","subscription_cost":"Koszt subskrypcji","subscription_discount_value":"Kwota rabatu","subscription_discount_value_type":"Jednostka miary rabatu","subscription_period":"Okres subskrypcji","task":"Bodziec","timezone":"Strefa czasowa","title":"Tytuł","updated_at":"Data zmiany","user_counts":"Liczba klientów\\Klienci z sesjami\\Kuratorzy\\Terapeuci","user_type":"Zarejestrować się jako","username":"Identyfikator","usersCenters":"Centra użytkownika","uuid":"UUID","value":"Wartość","viewed":"Obejrzano","year":"Rok"},"before":"Pole :attribute musi mieć datę przed :date.","before_or_equal":"Pole :attribute musi być datą wcześniejszą lub równą :data.","between":{"array":"Liczba elementów w polu :attribute musi być pomiędzy :min i :max.","file":"Rozmiar pliku w polu :attribute musi być między :min a :max. Kilobajtów (a).","numeric":"Pole :attribute musi znajdować się między :min a :max.","string":"Liczba znaków w polu :attribute musi być pomiędzy :min i :max."},"boolean":"Pole :attribute musi być znaczeniem logicznym.","confirmed":"Pole :attribute nie pasuje do potwierdzenia.","custom":{"assign_curator_can_analytic":"Tylko analityk może wyznaczyć kuratorów","attribute-name":{"rule-name":"custom-message"},"count_assigned_specialists":"Liczba przydzielonych specjalistów musi wynosić od 2 do 3","curator_not_have_client":"Wyznaczony kurator musi mieć terapeutę związanego z klientem","curator_not_have_therapist":"Kurator może wyznaczyć tylko swoich własnych terapeutów","different_problem_behavior":"Wybierz kwestionariusze z tymi samymi zachowaniami problemowymi","incorrect_count_answered_specialists":"Wybierz specjalistów, którzy wypełnili kwestionariusz","incorrect_count_answers":"Błędna liczba odpowiedzi na ten kwestionariusz","incorrect_count_general_detailed_answers":"Nieprawidłowa liczba odpowiedzi z polami tekstowymi w tym kwestionariuszu","incorrect_count_passed_quiz":"Wybierz tylko te kwestionariusze klientów, które zdałeś, a które stworzyłeś.","incorrect_general_question_answer":"Błędna odpowiedź na wspólne pytanie","incorrect_quiz_answers":"Błędne odpowiedzi dla kwestionariusza.","incorrect_quiz_general_answers":"Błędne odpowiedzi ogólne na kwestionariusz","missing_quiz_answers":"Brakujące odpowiedzi na pytania zawarte w kwestionariuszu","not_user_or_curator":"Można wybrać tylko terapeutę lub kuratora","select_different_quiz_types":"Wybierz różne rodzaje kwestionariuszy","therapist_not_have_client":"Przypisany terapeuta musi być przypisany do klienta"},"date":"Pole :attribute nie jest datą.","date_format":"Pole :attribute nie pasuje do formatu :format.","different":"Pole :attribute i :other muszą być różne.","digits":"Długość pola cyfrowego :attribute musi wynosić :digits.","digits_between":"Długość pola cyfrowego :attribute musi być pomiędzy :min a :max.","dimensions":"Pole :attribute ma nieprawidłowe rozmiary obrazku.","distinct":"Pole :attribute zawiera zduplikowane znaczenie.","email":"Pole :attribute musi być prawidłowym adresem e-mail.","exists":"Wybrane znaczenie dla :attribute jest niepoprawne.","file":"Pole :attribute musi być plikiem.","filled":"Pole :attribute jest wymagane.","has_access_to_client":"Ten użytkownik nie ma dostępu do tego klienta","has_active_bcba":"Konto użytkownika jest dezaktywowane","has_selected_item":":attribute musi zawierać wybrany element.","image":"Pole :attribute musi być obrazkiem.","in":"Wybrane znaczenie dla :attribute jest niepoprawne.","in_array":"Pole :attribute nie istnieje w :other.","incorrect_value":"Nieprawidłowe znaczenie","integer":"Pole :attribute musi być liczbą całkowitą.","interval":{"max":"Przedział nie może przekroczyć :max :unit"},"invalid_credentials":"Dane konta użytkownika są nieprawidłowe","ip":"Pole :attribute musi być prawidłowym adresem IP.","ipv4":"Pole :attribute  musi być prawidłowym adresem IPv4.","ipv6":"Pole :attribute  musi być prawidłowym adresem IPv6.","isEmptyError":"Wybierz mand","is_not_equal_to_actual_db_value":"Znaczenie :attribute musi być zgodne z bieżącym znaczeniem w bazie","json":"Pole :attribute musi być JSON ciągiem.","max":{"array":"Liczba elementów w polu :attribute nie może przekraczać :max.","file":"Rozmiar pliku w polu :attribute nie może przekraczać :max Kilobajtów (a).","numeric":"Pole :attribute nie może być większy niż :max.","string":"Liczba znaków w polu :attribute nie może przekraczać :max."},"mimes":"Pole :attribute musi być plikiem jednego z następujących typów: :values.","mimetypes":"Pole :attribute musi być plikiem jednego z następujących typów: :values.","min":{"array":"Liczba elementów w polu :attribute musi wynosić co najmniej :min.","file":"Rozmiar pliku w polu :attribute musi wynosić co najmniej :min Kilobajty (a).","numeric":"Pole :attribute musi wynosić co najmniej :min.","string":"Liczba znaków w polu :attribute  musi wynosić co najmniej :min."},"not_in":"Wybrane znaczenie dla :attribute jest niepoprawne.","not_regex":"Format wybrany dla :attribute jest nieprawidłowy.","number_of_client_exceeded":"Osiągnięto limit klientów w ramach subskrypcji. Proszę zwrócić się do administratora.","numeric":"Pole :attribute musi być liczbą.","present":"Pole :attribute musi być obecne.","regex":":attribute musi zawierać znaki łacińskie, cyfry i znaki","required":"Pole :attribute jest wymagane.","required_field":"jest wymagane.","required_if":"Pole :attribute jest wymagane, gdy :other równa się :value.","required_unless":"Pole :attribute jest wymagane, gdy :other nie równa się :values.","required_with":"Pole :attribute jest wymagane, gdy podano :values.","required_with_all":"Pole :attribute jest wymagane, gdy podano :values.","required_without":"Pole :attribute jest wymagane, gdy :values nie są określone.","required_without_all":"Pole :attribute jest wymagane, jeśli nie podano żadnej z :value.","same":"Znaczenie :attribute musi być zgodny :other.","size":{"array":"Liczba elementów w polu :attribute musi być równa :size.","file":"Rozmiar pliku w polu :attribute musi być równy :size Kilobajty (a).","numeric":"Pole :attribute musi być równe :size.","string":"Liczba znaków w polu :attribute musi być równa :size."},"string":"Pole :attribute musi być ciągiem.","timezone":"Pole :attribute musi być prawidłową strefą czasową.","unable_activate_expired_subscription":"Nie można aktywować wygasłej subskrypcji","unable_activate_future_subscription":"Nie można aktywować subskrypcji z datą rozpoczęcia późniejszą niż dzisiaj","unique":"Takie znaczenie pola :attribute już istnieje.","unique_categories":"Kategorię o tej samej nazwie został już dodany","unique_client":"Taki klient już dodany","unique_email":"Użytkownik z tym :attribute jest już zarejestrowany","unique_properties":"Właściwość o tej samej nazwie został już dodany","unique_skill_field":"Ten obszar został już dodany","unique_stage":"Etap o tej samej nazwie został już dodany","unique_task":"Taki bodziec już dodany","uploaded":"Ładowanie pola :attribute nie powiódło się.","url":"Pole :attribute ma niepoprawny format."},"pt.admin":{"action":"Acção","administrator":"Administrador","alert":"Alerta","all":"Tudo","all_methods_if_empty":"Todos os métodos por defeito caso vazio.","avatar":"Avatar","back":"Voltar","back_to_list":"Voltar para Listagem","batch_delete":"Apagar vários","browse":"Escolher","cancel":"Cancelar","captcha":"Captcha","choose":"Escolher","choose_file":"Selecionar ficheiro","choose_image":"Selecionar imagem","close":"Fechar","collapse":"Diminuir","confirm":"Confirmar","create":"Criar","created_at":"Criado em","current_page":"Página Actual","delete":"Apagar","delete_confirm":"Tem a certeza que deseja apagar este item?","delete_failed":"Remoção falhou!","delete_succeeded":"Remoção completada com sucesso!","deny":"Permissão Negada","description":"Descrição","edit":"Editar","entries":"Entradas","expand":"Expandir","export":"Exportar","failed":"Falhou","filter":"Filtrar","http":{"method":"Método HTTP","path":"Caminho HTTP"},"icon":"Icone","input":"Entrada","list":"Lista","listbox":{"filter_clear":"Mostrar tudo","filter_placeholder":"Filtrar","filtered":"{0} / {1}","text_empty":"Listagem Vazia","text_total":"Mostrando todos {0}"},"login":"Login","login_successful":"Login com sucesso","logout":"Logout","menu":"Menu","more":"Mais","name":"Nome","new":"Novo","new_folder":"Nova Pasta","online":"Online","operation_log":"Registo de Operações","order":"Ordenar","pagination":{"range":"Mostrando :first até :last de :total entradas"},"parent_id":"Pai","parent_select_error":"Erro ao selecionar o pai","password":"Palavra-Passe","password_confirmation":"Confirmação de Palavra-Passe","permission":"Permissão","permissions":"Permissões","refresh":"Actualizar","refresh_succeeded":"Actualizado com sucesso!","remember_me":"Lembrar","remove":"Remover","reset":"Reset","role":"Papel","roles":"Papéis","route":"Rota","save":"Guardar","save_succeeded":"Gravação completada com sucesso!","selected_rows":"Linhas Selecionadas","setting":"Configurações","show":"Mostrar","size":"Tamanho","slug":"Slug","submit":"Submeter","succeeded":"Completado com Êxito","time":"Tempo","title":"Título","update_succeeded":"Actualização completada com sucesso!","updated_at":"Actualizado em","upload":"Upload","uri":"URI","user_setting":"Configurações de Utilizador","username":"Nome de Utilizador","view":"Visualizar"},"ru.admin":{"action":"Опции","administrator":"Администратор","alert":"Ошибка","all":"Все","all_methods_if_empty":"Все методы, если не указано","avatar":"Аватар","back":"Назад","back_to_list":"Вернуться к списку","batch_delete":"Пакетное удаление","batch_enable_off":"Выключить области навыков","batch_enable_on":"Включить области навыков","browse":"Выбор файла","cancel":"Отмена","captcha":"Защитный код","choose":"Выбрать","choose_file":"Выбор файла","choose_image":"Выбор изображения","close":"Закрыть","collapse":"Свернуть","confirm":"Подтвердить","continue_creating":"Продолжить создание","continue_editing":"Продолжить редактировать","create":"Новая запись","created_at":"Дата создания","current_page":"Текущая страница","delete":"Удалить","delete_confirm":"Вы уверены, что хотите удалить эту запись?","delete_failed":"Ошибка при удалении!","delete_failed_skill_field":"Вы не выбрали области для удаления","delete_succeeded":"Успешно удалено!","deny":"Доступ запрещен","description":"Описание","detail":"Подробно","details":"Детали","edit":"Редактировать","enable_off":"Выключить","enable_off_confirm_skill_fields":"Вы подтверждаете выключение выбранных областей?","enable_off_failed_skill_field":"Вы не выбрали области для отключения","enable_on":"Включить","enable_on_confirm_skill_fields":"Вы подтверждаете включение выбранных областей?","enable_on_failed_skill_field":"Вы не выбрали области для включения","entries":"записей","expand":"Развернуть","export":"Экспорт","failed":"Ошибка","filter":"Фильтр","http":{"method":"HTTP метод","path":"HTTP путь"},"icon":"Иконка","input":"Ввод","list":"Список","listbox":{"filter_clear":"Показать все","filter_placeholder":"Фильтр","filtered":"{0} / {1}","text_empty":"Пустой список","text_total":"Все: {0}"},"login":"Войти","login_successful":"Авторизация успешна","logout":"Выйти","main":{"header":"Панель управления :appName"},"menu":"Меню","menu_titles":[],"more":"Еще","name":"Имя","new":"Добавить","new_folder":"Новая папка","no":"Нет","online":"Онлайн","operation_log":"Журнал событий","order":"Сортировка","pagination":{"range":"Записи с :first по :last из :total"},"parent_id":"Родитель","parent_select_error":"Ошибка при выборе родителя","password":"Пароль","password_confirmation":"Подтверждение пароля","permission":"Доступ","permissions":"Доступ","refresh":"Обновить","refresh_succeeded":"Успешно обновлено!","remember_me":"Запомнить","remove":"Удалить","reset":"Сбросить","role":"Роль","roles":"Роли","route":"Путь","save":"Сохранить","save_succeeded":"Успешно сохранено!","search":"Поиск","sections":{"contact_us":{"headers":{"index":"Обратная связь"}},"menu_items":{"headers":{"create":"Страницы","edit":"Элементы меню","index":"Меню"}},"menus":{"headers":{"create":"Страницы","index":"Меню"}},"pages":{"description":" ","headers":{"index":"Страницы"}},"settings":{"description":"Настройки системы","headers":{"index":"Настройки"}},"subscriptions":{"description":" ","headers":{"index":"Подписки","region_discounts":"Тарифы"}},"users":{"chart":{"title":"Динамика по количеству проведённых сессий по клиентам данного аналитика за выбранный период"},"description":" ","headers":{"centers":"Центры","index":"Аналитики","skillFields":"Область навыков","skillRatings":"Модуль оценки","statistics":"Статистика","userCenters":"Центры аналитиков"}}},"selected_rows":"Выбранные строки","setting":"Настройка","show":"Показать","size":"Размер","slug":"Слаг","submit":"Отправить","succeeded":"Завершена","time":"Время","title":"Название","update_succeeded":"Успешно изменено!","updated_at":"Дата обновления","upload":"Загрузить","uri":"URI","user_setting":"Настройки пользователя","username":"Логин","view":"Посмотреть","yes":"Да"},"ru.android":{"conflict_protocol":"Текущая версия протокола на устройстве не соответствует последней версии протокола на сервере. Вы можете сохранить сессию и обновить протокол или продолжить не обновляя протокол.","language":"Язык","no_connection":"Нет соединения","no_data":"Нет данных","settings":"Настройки","subscription_has_expired":"Срок действия подписки истек. Обратитесь к администратору.","synchronization_in_progress":"Выполняется синхронизация","synchronization_warning":"Внимание! При синхронизации результаты сессий которые не были сохранены будут утеряны. Продолжить?","synchronize":"Синхронизировать","unable_to_save_date":"Невозможно сохранить данные"},"ru.appeals":{"R":"П","appeal":"Просьба","appeals":"Просьбы","appeals_chart":"График просьб за период","appeals_count":"Количество просьб","appeals_for_period":"Просьбы за период","avarage_appeals_perhour":"Среднее количество просьб в час","buttons":{"addAppeal":"Добавить","apply":"Применить","cancel":"Отмена","createAppeal":"Записать","saveAppeal":"Сохранить","write_appeal":"Записать просьбу"},"date_end":"Дата по","date_start":"Дата с","date_time":"Дата/Время","edit_typical_appeals":"Редактировать типовые просьбы","edit_typical_appeals_short":"Ред. типовые просьбы","edit_typical_client_appeals":"Редактировать типовые просьбы клиента","maxlength_appeals":"Максимальное количество просьб: 50","need_choice_appeal":"Выберите просьбу","no_data":"Нет данных","pagination":{"next":"Вперёд","previous":"Назад"},"range":"Период","recorded":"Записал","total_appeals_perday":"Суммарное количество различных просьб за день","type_new_appeal":"Введите новую просьбу","type_the_appeals_name_to_search":"Введите название просьбы для поиска","typical_appeals":"Типовые просьбы","unique_appeals":"Просьбы не должны повторяться","write_appeal":"Записать просьбу","write_client_appeal":"Записать просьбу клиента"},"ru.auth":{"failed":"Имя пользователя и пароль не совпадают.","throttle":"Слишком много попыток входа. Пожалуйста, попробуйте еще раз через :seconds секунд."},"ru.behavior":{"UB":"НП","add_ub_environment":"Введите новое последствие  в среде","add_ub_to_report":"Добавить в отчет информацию по НП","aftermath":"Последствия","aftermath_short":"Последствие","all_ancedent":"Все антецеденты","all_option":"Все опции","all_protocol":"Все протоколы","all_ub":"Все НП","all_ub_for_day":"Все НП за 24 часа","ancedent":"Антецедент","average_behavior":"Среднее количество НП в час","behavior":"Поведение","buttons":{"add":"Добавить","apply":"Применить","cancel":"Отмена","create":"Записать","create_behavior":"Записать НП","save":"Сохранить","show_by_frequency":"Вывести по частоте","show_by_time":"Вывести по дате/времени","typical_behavior":"Типовые НП","write_unwanted_behavior":"Записать нежелательное поведение"},"date_end":"Дата по","date_start":"Дата с","date_time":"Дата/время","describe_the_behavior":"Опишите поведение","edit_typical_appeals_short":"Ред. типовые просьбы","edit_typical_behavior":"Ред. типовые НП","edit_typical_client_behavior":"Редактировать типовые НП клиента","enter_the_aftermath":"Введите последствие","enter_the_ancedent":"Введите антецедент","enter_the_new_aftermath":"Введите новое последствие","enter_the_new_ancedent":"Введите новый антецедент","enter_the_new_behavior":"Введите новое поведение","frequency_group_by":"Группировать по","frequency_group_types":{"aftermath":"Последствиям","ancedent":"Антецеденту","behavior":"Поведению","undefined":"По дате/времени"},"hours_24":"24 часов","maxlength_aftermath":"Максимальное количество последствий: 200","maxlength_ancedent":"Максимальное количество антецедентов: 200","maxlength_behaviors":"Максимальное количество поведений: 200","min":"мин","need_choice_aftermath":"Выберите последствие","need_choice_ancedent":"Выберите антецедент","need_choice_behavior":"Выберите поведение","no_data":"Нет данных","pagination":{"next":"Вперёд","previous":"Назад"},"range":"Период","scatter_plot":"Диаграмма повременной регистрации  НП","sec":"сек","times":"разы","ub_behavior":"Последствия в поведении","ub_environment":"Последствия в среде","ub_for_day":"НП за дневную сессию","unique_aftermath":"Последствия не должны повторяться","unique_ancedent":"Антецеденты не должны повторяться","unique_behaviors":"Поведения не должны повторяться","unwanted_behavior":"Нежелательное поведение","unwanted_behavior_chart":"График нежелательного поведения за период","unwanted_behavior_for_period":"Нежелательное поведение за период","unwanted_behavior_title":"Редактировать типовые НП","within":"В рамках","write_unwanted_behavior":"Записать нежелательное поведение","write_unwanted_behavior_short":"Записать НП","you_must_select_at_least_one_antecedent_behavior_and_consequence":"Вы должны выбрать хотя бы один антецедент, поведение и последствие"},"ru.bids":{"Z":"З","add_comment":"Введите свой комментарий","appoint_protocol":"Назначить протокол","bid":"Заявка","bids":"Заявки","bids_for_new_protocols":"Заявки на новые протоколы","bids_for_protocols":"Заявки на протоколы","bids_for_protocols_and_modules":"Заявки на протоколы и модули","buttons":{"appointProtocol":"Назначить протокол","cancel":"Отмена","createProtocol":"Создать протокол","request_new_protocol_or_module":"Заявка на новый протокол/модуль интерактивности","sendRequest":"Отправить заявку","submit_bids_to_curator":"Отправить заявку куратору","submit_for_approval_to_bsba":"Отправить на утверждение аналитика"},"change_date":"Дата изменения","choose_a_client":"Выберите клиента","client":"Клиент","clients":"Клиенты","comment":"Комментарий","comment_must_be_at_least_n_characters":"Должен содержать не менее :count символов","comments":"Комментарии","create_date":"Дата создания","edit_bid":"Редактирование заявки на протокол","enter_client_code_to_search":"Введите код клиента для поиска","header":"Заявки","initiator":"Инициатор","no_data":"Нет данных","overdue":"Просрочена","pagination":{"next":"Вперёд","previous":"Назад"},"parent":"Родитель","protocol_goal":"Цели протокола","request_new_protocol":"Заявка на новый протокол","short_description":"Короткое описание","start_protocol":"Начните вводить название протокола","status":"Статус","statuses":{"Assigned":"Назначен","Being processed by the BCBA":"В работе у аналитика","Being processed by the curator":"В работе у куратора","Being processed by the therapist":"В работе у тераписта","Cancelled":"Отменена","New":"Новая"},"therapist":"Терапист","type_the_procol_name_to_search":"Введите название протокола для поиска","view_bid":"Просмотр заявки на протокол","write_protocol_goal":"Опишите цели протокола"},"ru.buttons":{"back":"Назад","back_to_client":"Назад в профиль клиента","cancel":"Отмена","continue":"Продолжить","edit":"Редактировать","save":"Сохранить","send":"Отправить"},"ru.contact_us":{"buttons":{"send":"Отправить"},"congrats":"Спасибо, мы с Вами свяжемся!","errors":{"save_failed":"Не удалось сохранить сообщение"},"header":"Обратная связь","labels":{"captcha":"Защитный код","email":"Адрес электронной почты","message":"Сообщение","name":"Ваше Имя"}},"ru.dashboard":{"functionalInDevelopment":"Функционал находится в разработке","labels":{"dashboard":"Панель управления","welcome":"Вы залогинены!"},"library":"Библиотека","requestHelp":"Запрос помощи","sendComment":"Оставить комментарий","writeRequest":"Записать просьбу","writeUnwantedBehavior":"Записать НП"},"ru.dro":{"aim_types":{"Absence of target behavior":"Отсутствие целевого поведения","Presence of target behavior":"Наличие целевого поведения"},"back_to_reports":"Вернуться к отчетам","behaviour_absence":"Отсутствие целевого поведения","behaviour_absent":"Целевого поведения не было!","behaviour_description":"Описание целевого поведения","behaviour_presence":"Наличие целевого поведения","behaviour_type":"Тип целевого поведения","behaviour_type_long":"Длинное","behaviour_type_short":"Короткое","behaviour_types":{"Long":"Длинное","Short":"Короткое"},"cancel":"Отмена","continue_session":"Продолжить сессию","description":"Суть процедуры - поощряется отсутствие/наличие целевого поведения в течение предустановленного интервала.","dro_module":"Модуль DRO/DRI","duration_units":{"Minutes":"Минуты","Seconds":"Секунды"},"finish_session":"Закончить сессию","forbidden":"У вас нет доступа к данному модулю для данного клиента","hold_session":"Провести сессию","instructions":{"collapse":"Свернуть","expand":"Читать полностью","header":"Инструкции:","text":"Суть процедуры - поощряется отсутствие/наличие целевого поведения в течение предустановленного интервала."},"interactive_module":"Модуль интерактивности","interactive_module_one":"Модуль интерактивности 1","interactive_modules":"Модули интерактивности","interval_duration_units":"Единицы измерения интервала","interval_time_range":"Время интервала","interval_time_range_minutes":"Время интервала (1-100 мин)","interval_time_range_seconds":"Время интервала (1-300 сек)","list":{"absent":"Не было","interval":"Интервал","interval_suffix":"й","target_behaviour":"Момент целевого поведения","time":"Время интервала"},"min":"мин.","no_data":"Нет данных","pagination":{"next":"Вперёд","previous":"Назад"},"parameters":"Параметры","report":{"auditor":"Специалист","average_successful_interval_duration":"Среднее время успешного интервала","behaviour_description":"Целевое поведение","behaviour_type":"Тип поведения","client":"Клиент","date":"Дата","download_report":"Скачать отчет","fail_rate":"% Сброшенных","failed_interval_count":"Количество сброшенных","header":"Отчет о проведенном занятии","header_mobile":"Отчет DRO/DRI","interval_count":"Количество интервалов","started_at":"Дата","success_rate":"% Успешных","successful_interval_count":"Количество успешных"},"reports":"Отчёты","restart_timer":"Перезапустить таймер","sec":"сек.","start_session":"Начать сессию","subtitle":"Модуль интерактивности 1.","target_behaviour":"Целевое поведение","title":"Реализация процедуры DRO/DRI.","type":"Тип"},"ru.email":{"after_registered":{"body":{"lines":{"first":"Система AutismTech (АутизмТек) приветствует вас, :displayName!","second":"Вы успешно зарегистрировали нового пользователя (:userType)","third":"Для входа, пользователь должен зайти в мобильном приложении (или браузере Chrome, Safari или\n                    Firefox на страницу входа :loginUrl) и ввести  Идентификатор - :username, Пароль - :password. Поделитесь этой\n                    информацией с пользователем и храните учётные данные пользователей в надёжном месте."}},"subject":"AutismTech: Успешное пополнение команды вмешательства"},"after_registration":{"body":{"lines":{"fifth":"Служба поддержки системы не имеет доступа к данным вашей учётной записи, поэтому если вы забудете \n                    свой пароль, вы сможете восстановить его, выбрав «Восстановление пароля» на странице входа :loginUrl. \n                    Новый пароль будет сгенерирован и отправлен автоматически на указанный при регистрации адрес электронной почты.","first":"Система AutismTech (АутизмТек) приветствует вас, :displayName!","fourth":"2 - Для входа используйте Идентификатор :username и пароль :password","second":"Теперь вы можете воспользоваться преимуществами системы автоматизации измерений и анализа данных \n                    поведения, пройдя по ссылке :appUrl в браузере Chrome, Safari или Firefox актуальной версии для настройки\n                    системы или в приложении для вашей мобильной платформы для измерений.","sixth":"Успешных измерений!","third":"1 - Перейдите на страницу входа по ссылке :loginUrl или запустите ваше мобильное приложение"}},"subject":"Подтверждение регистрации :appName"},"bcba_account_activated":{"body":{"lines":{"first":"Система AutismTech (АутизмТек) приветствует вас, :name!","second":"Вам предоставлен полный доступ к измерениям поведения, созданию и редактированию протоколов \n                    вмешательства, результатам измерений и отчётам. Также, теперь возможно создавать учётные записи для членов\n                    команды вмешательства и представителей клиентов.","third":"Успешных измерений!"}},"subject":"AutismTech: полный доступ к учётной записи аналитика"},"bcba_account_deactivated":{"body":{"lines":{"first":"Приветствуем :name!","second":"Алгоритмы системы отключили возможности вашей учётной записи.","third":"Если вы считаете, что это ошибка, пожалуйста, обратитесь в службу поддержки: https://autismtech.online/contacts"}},"subject":"AutismTech: учётная запись аналитика деактивирована"},"bcba_account_mensuration_forbidden":{"body":{"lines":{"first":"Приветствуем :name!","second":"Алгоритмы системы отключили возможности вашей учётной записи. Возможность просматривать результаты\n                    измерений и сохранить описания протоколов вмешательства сохранена.","third":"Если вы считаете, что это ошибка, пожалуйста, обратитесь в службу поддержки."}},"subject":"AutismTech: возможности вашей учётной записи ограничены"},"csv_report_generated":{"body":{"lines":{"first":"Здравствуйте, :displayName!","second":"Отчет в CSV за :startDate - :endDate по клиенту :clientCode сформирован.","third":"Вы можете скачать его в секции Отчеты > Архив отчетов."}},"subject":"CSV отчет сформирован"},"layout":{"greeting":{"error":"Ой!","success":"Здравствуйте!"},"regards":"С уважением,","subcopy":"Если у вас возникли проблемы с нажатием :actionText кнопки, скопируйте и вставьте URL-адрес ниже в свой веб-браузер: [ :actionUrl ]( :actionUrl )"},"new_subscription":{"body":{"lines":{"first":"Здравствуйте, :name!","second":"В системе был создан новый запрос на подписку","third":"Детали Вы можете посмотреть по ссылке :url"}},"subject":"Новый запрос на подписку"},"new_subscription_comment_for_admin":{"body":{"lines":{"first":"Здравствуйте, :name!","fourth":"Детали Вы можете посмотреть по ссылке :url","second":"К подписке :id был добавлен новый комментарий:","third":"\":comment\""}},"subject":"К подписке :id был добавлен новый комментарий"},"new_subscription_comment_for_user":{"body":{"lines":{"first":"Здравствуйте, :name!","fourth":"Детали Вы можете посмотреть по ссылке :url","second":"К подписке :id был добавлен новый комментарий:","third":"\":comment\""}},"subject":"К подписке :id был добавлен новый комментарий"},"pdf_report_generated":{"body":{"lines":{"first":"Здравствуйте, :displayName!","second":"Отчет в PDF за :startDate - :endDate по клиенту :clientCode сформирован.","third":"Вы можете скачать его в секции Отчеты > Архив отчетов."}},"subject":"PDF отчет сформирован"},"recovery_password":{"body":{"lines":{"first":"Добрый день, :bcbaDisplayName","fourth":"Поделитесь паролем, который Вы установили для пользователя любым удобным для Вас способом.","second":"Член вашей команды :username :userDisplayName запросил восстановление пароля.","third":"Вы можете изменить пароль пользователя в его профиле."}},"subject":"Запрос на восстановление пароля"},"reset_password":{"body":{"lines":{"first":"Вы получили это сообщение потому что мы получили запрос на изменение пароля для вашего аккаунта","second":"Изменить пароль","third":"Если вы не посылали запрос на смену пароля, просто проигнорируйте это письмо."}},"subject":"Изменение пароля"},"subscription_status_active":{"body":{"lines":{"first":"Система AutismTech (АутизмТек) приветствует вас, :name!","second":"Вам предоставлен полный доступ к измерениям поведения, функциям графического анализа собранных\n                    данных и создания отчётов о вмешательстве. Для начала, войдите в систему со страницы :loginUrl,\n                    используя ваш идентификатор :username","third":"Успешных измерений!"}},"subject":"AutismTech: полный доступ к измерениям поведения"},"subscription_status_finished":{"body":{"lines":{"first":"Здравствуйте, :name!","second":"Срок действия Вашей подписки :id истек","third":"Детали Вы можете посмотреть по ссылке :url"}},"subject":"Срок действия Вашей подписки :id истек"},"subscription_status_inactive":{"body":{"lines":{"first":"Система AutismTech (АутизмТек) приветствует вас, :name!","fourth":"Если это ошибка, пожалуйста, обратитесь в службу поддержки: https://autismtech.online/contacts","second":"Алгоритмы системы присвоили вашей подписке :id статус неактивной.","third":"Почему это произошло? Посмотрите по ссылке :url"}},"subject":"AutismTech: Подписка для :id деактивирована","title":"Деактивация подписки"},"subscription_status_new":{"body":{"lines":{"first":"Здравствуйте, :name!","second":"Ваша подписка :id была одобрена администратором и будет активирована при наступлении даты начала действия подписки","third":"Детали Вы можете посмотреть по ссылке :url"}},"subject":"Ваша подписка :id была одобрена администратором"}},"ru.errors":{"choose_curator_from_list":"Выберите куратора из списка","choose_therapist_from_list":"Выберите тераписта из списка","create_comment":"Вы не можете создавать комментарии","delete_comment":"Вы не можете удалить этот комментарий","edit_comment":"Вы не можете редактировать этот комментарий","reset_password":"Не удалось сменить пароль","save_comment":"Не удалось сохранить комментарий","send_token":"Пользователь не найден","session_expired":"Время вашей сессии истекло. Пожалуйста авторизуйтесь.","something_wrong":"Что-то пошло не так.","try_later":"Пожалуйста, попробуйте еще раз или свяжитесь с администратором.","view_comments":"Вы не можете просматривать комментарии","view_not_own_notifications":"Вы не можете просматривать чужие нотификации"},"ru.export":{"reports":{"dro":{"auditor":"Специалист проводивший занятие","average_successful_interval_duration":"Среднее время успешного интервала","behaviour_description":"Описание целевого поведения","behaviour_type":"Тип поведения","client":"Клиент","fail_rate":"% Сброшенных","failed_interval_count":"Кол-во сброшенных","header":"Отчет о проведенном занятии","interval_count":"Количество интервалов","not_specified":"Не указано","started_at":"Дата и время проведения","success_rate":"% Успешных","successful_interval_count":"Кол-во успешных"},"random_rotation":{"auditor":"Специалист проводивший занятие","block":"Блок","block_count":"Общее кол-во подходов","client":"Клиент","fail_rate":"% неправильных ответов","header":"Отчет о проведенном занятии","incomplete_rate":"% невыполненных подходов","prompt_rate":"% подсказок","result":"Результат","session":"Сессия","started_at":"Дата и время проведения","stimulus":"Стимул","success_rate":"% правильных ответов"}}},"ru.home":{"labels":{"documentation":"Документация","forge":"Forge","github":"Github","home":"Главная","laracasts":"Laracasts","loading_message":"Пожалуйста подождите, выполняется загрузка","loading_message_table":"Пожалуйста подождите, таблица загружается","news":"Новости"}},"ru.instruction":{"collapse":"Свернуть","default_text":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis","expand":"Читать полностью","header":"Инструкции:"},"ru.ios":{"creating_new_dro_session_confirmation":"При создании новой сессии несохраненные даные DRO/DRI будут утеряны. Создать новую сессию?","download_appeals_for_client":"Загрузить просбы для %client%","download_client_list":"Загрузить список клиентов","download_dro_sessions_for_client":"Загрузить сессии DRO/DRI для %client%","download_protocols_for_client":"Загрузить протоколы для %client%","download_random_rotation_sessions_for_client":"Загрузить сессии случайной ротации для %client%","download_typical_undesirable_behaviors_and_appeal_for_client":"Загрузить типовые НП и П для %client%","download_undesirable_behaviors_for_client":"Загрузить НП для %client%","logout_impossible":"Вы не можете выйти из системы до отправки всех данных на сервер. Пожалуйста, подключитесь к сети интернет и попробуйте ещё раз.","no_connection":"Отсутствует подключение к интернету.","synchronize":"Синхронизировать","synchronize_impossible":"Синхронизация невозможна. Нет подключения к сети Интернет.","synchronize_on":"Актуально на","upload_appeals":"Отправить данные просьб","upload_bids":"Отправить заявку на протоколы/модули интерактивности","upload_data_to_server":"Отправить данные на сервер","upload_dro_sessions":"Отправить даные сессий DRO/DRI","upload_protocols":"Отправить протоколы","upload_random_rotation_sessions":"Отправить данные сессий случайной ротации","upload_typical_undesirable_behaviors_and_appeals":"Отправить типовые НП и П","upload_undesirable_behaviors":"Отправить НП"},"ru.login":{"buttons":{"login":"Войти"},"i_consent_to_data_processing":"Я даю согласие на обработку данных","labels":{"forgot":"Восстановление пароля","login":"Вход","logout":"Выход"},"unable_to_sign_in":"Невозможно выполнить авторизацию"},"ru.pagination":{"next":"Вперёд","previous":"Назад"},"ru.passwords":{"password":"Пароль должен быть не менее шести символов и совпадать с подтверждением.","password_subscription":"Пароль должен содержать 8-16 символов","reset":"Ваш пароль был сброшен!","sent":"Ссылка на сброс пароля была отправлена!","token":"Ошибочный код сброса пароля.","user":"Не удалось найти пользователя с указанным электронным адресом."},"ru.placeholders":{"enter_new_message":"Введите новое сообщение"},"ru.profile":{"address":"Адрес","client_count":"Количество клиентов","clinic_center":"Клинические центры","delete_logo":"Удалить логотип","displayName":"Пользователь","download_logo":"Загрузить логотип центра","edit_clinic_center":"Редактирование клинического центра","firstName":"Имя","lastName":"Фамилия","legalName":"Юридическое наименование/ИНН/ОГРН","name":"Название","name_clinic_center":"Название клинического центра","other_contact":"Другие контакты","phone":"Телефон","price":"Стоимость","profile":"Профиль Аналитика","settings_task_type":"Настройки листов записи реакций","status":"Статус","subscriptions":"Подписки","subscriptionsSubtitle":"Данные о текущих и прошлых подписках","username":"Идентификатор"},"ru.protocol":{"OffPhaseModalTitle":"Вы хотите выключить фазу :phaseName.\n Стимулы фазы :phaseName не будут доступны для работы в рамках данного этапа.\n Если вы хотите работать с данными стимулами - перенесите стимулы на другую фазу.","absent":"Отсутствует","active_protocols":"Активные протоколы","addCategory":"Добавить категорию","addCheckList":"Прикрепленные листы записи реакций","addEnvironment":"Добавить среду","addProperty":"Добавить свойство","addStep":"Добавить шаг","add_a_mand_reaction":"Добавить стимул","add_a_stimulus":"Добавить стимул","add_interval":"Добавить Интервал","add_level":"Добавить новый уровень подсказки","add_minus_spo":"Отправить “минусы” в СПО","add_new_protocol":"Назначение нового протокола","add_new_stimulus":"Добавить новый стимул","add_plus_spo":"Отправить “плюсы” в СПО","add_to_set":"Добавить стимулы в набор","after_one_lesson":"Через одно занятие","after_three_classes":"Через три занятия","after_two_classes":"Через два занятия","all_attempts_past":"Все пробы пройдены для всех стимулов.","all_field":"Все поля","all_intervals":"Все интервалы","all_phases":"Все фазы","all_stage":"Все этапы","answer_title":"Манд-реакция (выбранный лист записи реакций)","area":"Область","assignDate":"Дата назначения","assimilate_stimulus":"освоено стимулов: :attribute","attempt":"Проба","attempt_count":"Количество проб(если применимо)","attempts":"Пробы","audial":"Аудиальная","auto_save_version":"Автосохранённая версия","available_protocols":"Доступные протоколы","average_percent":"Средний % сам. реакций","back_to_list":"Вернуться к списку этапов","baseLavel":"Базовый уровень","base_level":"Базовый уровень","bids":"Заявки","bids_for_protocols":"Заявки на протоколы","blocks":"блоках","body_parts":"Части тела","buttons":{"add":"Добавить","addMandReaction":"Добавить стимул","addNewProtocol":"Назначить новый протокол","addProtocol":"Назначить протокол","addStage":"Добавить этап","addStimulus":"Добавить стимул","addСriterion":"Добавить критерий","allow_mensuration":"Разрешить измерения","apply_changes_to_protocol":"Применить изменения к протоколу","back_to_protocol":"Назад к протоколу","cancel":"Отменить","choose_stimulus":"Заполнить стимулами из выбранного этапа","close_protocol":"Завершить протокол","collapse":"Свернуть","conductTherapeuticSession":"Провести терапевтическую сессию","continueTherapeuticSession":"Продолжить терапевтическую сессию","create":"Создать новый протокол","createNotPublish":"Перевести в черновик","delete":"Удалить","duplicate":"Дублировать","duplicate_stage":"Дублировать этап","edit":"Изменить","editTasks":"Редактировать лист записи реакций","expand":"Развернуть","export":"Экспорт","finishCurrentStage":"Закрыть текущий этап","finishEnvironment":"Закончить сбор данных в среде","finishStage":"Закончить сбор данных в этапе","goToExercises":"Перейти к упражнениям","hideAll":"Свернуть все","leave_session":"Назад","newTasks":"Заполнить лист записи реакций","no":"нет","removeMandReaction":"Удалить стимул","removeStage":"Удалить этап","removeStimulus":"Удалить стимул","removeСriterion":"Удалить критерий","results":"Результаты","resultsMeasurementsCurrentDay":"Результаты измерений текущего дня","save":"Сохранить протокол","saveTasks":"Сохранить лист записи реакций","save_and_allow_mensuration":"Сохранить и разрешить измерения","save_session":"Сохранить","sendRequest":"Отправить запрос","showAll":"Развернуть все","start_new_session":"Начать новую сессию","yes":"да"},"category":"категория","categoryTitle":"Категория","chain_mastered_chart":"График отслеживания освоения цепочки в среде","chain_step_chart":"График отслеживания количества освоенных шагов цепочки в среде","change_criteria":"Сменить текущий критерий","change_criteria_title":"При смене текущего критерия, критерии которые идут после текущего будут отмечены как неосвоенные","change_criterion_position":"Для того чтобы поменять порядок критериев перетащите критерий на необходимую позицию в списке критерий.","change_date":"Дата изменения","change_environment_position":"Для того чтобы поменять порядок сред, которые не были в работе, перетащите среду на необходимую позицию в списке сред.","change_mand_reaction_position":"Для того чтобы поменять порядок стимулов перетащите стимул на необходимую позицию в списке стимулов.","change_popup_title":"Сохранить изменения в протоколе как","change_stage_position":"Для того чтобы поменять порядок этапов, которые не были в работе, перетащите этап  на необходимую позицию в списке этапов.","change_step_position":"Для того чтобы поменять порядок шагов перетащите шаг на необходимую позицию в списке шагов.","change_stimul_position":"Для того чтобы поменять порядок стимулов перетащите стимул на необходимую позицию в списке стимулов.","changes":"Изменения","changesSaved":"Сессия успешно сохранена","changes_date_text":"Внимание! Вносить изменения за предыдущие сессии можно будет только от даты последнего изменения в протоколе.","changes_type":"Тип изменения","chart_properties":"График доли правильного использования карточки предпочитаемого свойства/предмета","chart_properties_per_day":"Количество правильно используемых карточек предпочитаемых свойств в каждом блоке дневной сессии","chart_properties_percent":"График процент правильного использования карточки предпочитаемого  свойства","chart_properties_percent_per_day":"Доли правильно используемых карточек предпочитаемых свойств в каждом блоке дневной сессии","check-list":"Лист записи реакций","checkList":"Лист записи реакций","chooseEnvironment":"Выберите среду","chooseLevel":"Выберите уровень","choosePreferred":"Выбор предпочитаемого свойства","chooseStage":"Выберите этап","choose_chain_stage":"Выберите среду для работы с шагом.","choose_field":"Выберите поле","choose_interval":"Выберите интервал","choose_mand_stage":"Выберите этап для работы со стимулом.","choose_phase":"Выберите фазу","choose_protocol":"Выберите протокол из списка","choose_shaping_stage":"Выберите среду для работы с критерием.","choose_stage":"Выберите этап","choose_step":"Выберите шаг","choose_stimul_chart":"График","close_protocol":"Закрыть протокол","code1":"ABBLS","code2":"VB-MAPP","color":"Цвет","comment":"Комментарий","completed_protocols":"Завершенные протоколы","completionCriteria":"Критерии завершения","compliance_check":"Проверка соответствия","condition_mastered":"реакций  в течение","condition_mastered_prop":"Условие освоения свойства","condition_mastered_usd":"Условие освоения набора стимулов","condition_next":"Условие перевода набора стимулов на следующий уровень подсказки","condition_procent":"% самостоятельных реакций  в течение сессии ","condition_return":"Условие возврата набора стимулов на предыдущий уровень подсказки","condition_session":"проб в каждой из них","condition_tranfer":"Критерий освоения стимула на поле/фазе","condition_tranfer_maintain":"Критерий освоения стимула на поле/поддержание","condition_tranfer_rotation":"Перевод стимула на поле","condition_trial":"последовательных дневных сессий, при минимуме","conductingTherapeuticSession":"Проведение терапевтической сессии","confirm_change":"Ваши предыдущие данные будут удалены","confirm_close":"Вы подтверждаете закрытие этапа?","confirm_close_all":"Завершение последнего этапа завершит весь протокол. Завершить протокол?","confirm_close_all_env":"Завершение сбора данных в последней среде завершит весь протокол. Завершить протокол?","confirm_close_env":"Вы подтверждаете завершение сбора данных в среде?","confirm_close_protocol":"Вы подтверждаете завершение протокола?","confirm_delete":"Внимание! Все пробы по стимулу, собранные в рамках данного протокола будут удалены. Если вы согласны нажмите Сохранить.","confirm_delete_category":"Внимание! Все данные проб по категории, записанные в рамках данного протокола будут удалены. Если вы согласны нажмите Сохранить.","confirm_delete_mand":"Внимание! Все пробы по стимулу, собранные в рамках данного протокола будут удалены. Если вы согласны нажмите Сохранить.","confirm_delete_property":"Внимание! Все данные проб по свойству, записанные в рамках данного протокола будут удалены. Если вы согласны нажмите Сохранить.","confirm_delete_stimulus":"Стимулы для текущего этапа будут заменены?","confirm_save_conflict_session":"Протокол был изменен. Ваши данные будут записаны в конфликтную сессию.","conflict_sessions":"Конфликтные сессии","continue_or_new":"Хотите ли вы продолжить текущею сессию или начать новую","continue_previous":"Продолжить текущую","copy":"копия","countSamples":"Кол-во попыток до достижения критерия","countSamplesAxes":"кол-во попыток","count_properties":"Количество свойств","count_properties1":"Количество свойств 1","count_properties2":"Количество свойств 2","count_properties3":"Количество свойств 3","count_properties4":"Количество свойств 4","count_reaction":"Самостоятельных реакций на этапе ","count_stimul":"Стимулов на поддержании ","create_date":"Дата создания","criteria":"Критерии","criteria_end_protocol":"Критерий завершения протокола","criteria_end_session":"Критерий завершения сессии в текущий день","criteria_end_teaching":"Критерий завершения обучения для одного стимула","criterion":"Критерий","criterionDirectionSession":"Критерий завершения сессии","criterionLearningStimulus":"Критерий завершения обучения стимула","criterion_count":"кол-во критериев в среде","criterion_required":"Поле Критерий обязательно для заполнения.","cumulative_category":"Количество правильно используемых карточек предпочитаемых свойств для категории","cumulative_category_relative":"Доли правильно используемых карточек предпочитаемых свойств для категории","cumulitive_graph":"Кумулятивные графики освоения","currentEnvironment":"Текущая среда","currentLevel":"Текущий уровень","currentStage":"Текущий этап","current_criterion":"Текущий критерий","date":"Дата","date_first_session":"Дата первой сессии","date_mastering":"Дата освоения","day_session":"дневных сессий при минимуме","delay":"задержка  :sec сек","delay_none":"задержка 0 сек","deleteCategory":"Удалить категорию","deleteProperty":"Удалить свойство","delete_criteria_title":"Этот стимул является текущим на одном из этапов. Продолжить удаление?","delete_set":"Данная операция приведет к разрушению набора(ов). Продолжить?","describeCategory":"Опишите категорию  :number","describeEnvironment":"Опишите среду :number","describeImplementation":"Опишите выполнение","describeMandReaction":"Опишите стимул :number","describeProperty":"Опишите свойство","describeStage":"Опишите этап :number","describeStep":"Опишите шаг :number","describeStimulus":"Опишите стимул :number","describeСriterion":"Опишите критерий :number","descriptionPart":"Описательная часть","description_on_delete":"После удаления должен остаться хотя бы один включенный критерий","detail_reaction_session":"Детальный график работы с реакциями за выбранную сессию","detail_shaping_chart":"Детальный график работы с реакциями за выбранную сессию","detailed_result":"Детальный результат","directory_types":{"Teaching method":"Метод обучения"},"disable":"Отключен","distinctive_properties":"Свойства с различением","dtt_phase_title":"Настройка фаз этапа протокола","dtt_title":"Настройка этапов протокола DTT","duration":"Продолжительность сессии, мин","editProtocol":"Редактировать протокол","editor":"Специалист","enable_recording":"Настроить фиксацию правильного, с подсказкой и ошибочного ответа","endSession":"Сохранить сессию","end_protocol_date":"Дата окончания протокола","end_session_date":"Дата последней дневной сессии","enter_another_session_date":"Введите другую дату дневной сессии.  Дата дневной сессии должна быть позже даты последней дневной сессии. Последние данные были собраны ","enter_session_date":"Введите другую дату дневной сессии.  Дата дневной сессии должна быть позже даты последней дневной сессии. Последние данные были собраны ","entered_session_date":"Введите дату дневной сессии.","environment":"Среда","environment_number":"Среда :count","environments":"Среды","errorCorrection":"Коррекция ошибки","errorEnvironmentsCount":"Обязательно нужна хотя бы одна среда","errorPhaseCount":"Обязательно включить хотя бы одну фазу","errorResult":"Количество выбранных стимулов должно быть равно 3","errorStages":"Обязательно выбрать лист записи реакций","errorStagesCount":"Обязательно нужен хотя бы один этап","execution":"Выполнение","executionSeconds":"Правильное выполнение за :time сек","executionSecondsLimit":"Правильное выполнение за, сек ","exercise":"Упражнение","exercises":"Упражнения","features":"Особенности","field":"Поле","first_probe":"первых проб в каждой из них","fluency":"Беглость","form":"Форма","from":"из","full_physical":"Полная физическая","full_verbal":"Полная вербальная","gesture":"Жестовая","goToSPO":"Перейти к СПО","goal":"Цель","graph_cumulative_improve":"График кумулятивный С+, C и П","graph_goal":"График С+, C и П","graph_improve":"График кумулятивный У+","graph_improve_prompt":"График У+, отношение проб с У+ к общему кол-ву проб","graph_improved_spou":"График % улучшенных реакций","graph_mand_react":"График частоты спонтанных манд-реакций, в час","graph_mo_goal":"График мотивационного условия для цели манд реакции (CМО - ДА)","graph_mo_yes":"График % проб с МО - Да","graph_mo_yes_percent":"График % первых проб с МО - ДА","graph_probe_full":"График С+ с С и П относительно общего кол-ва проб за сессию","graph_prompt_levels":"График уменьшения уровня подсказок","header":"Протокол","himself_percent":"Сам, %","hint_sub_title":"Всего доступно 10 уровней подсказки. Вы можете использовать то кол-во уровней, которое вам необходимо.","hint_type":"Вид подсказки","i_want_card":"Перемещение карточки “Я хочу”","important":"значительные","inessential":"несущественные","instruction":"Инструкция","interactivity_module":"Модуль интерактивности","interval":"Интервал","interval_count":"Количество повторений ","interval_error":"Минимум 1 интервал должен быть отмечен","interval_name":"Название интервала","introduced":"Введен","item_card":"Добавление карточки с изображением желаемого предмета на шаблон для предложений","items":"Предметы","lastLesson":"Последнее занятие","last_measurement_results":"Результаты последних проведённых измерений","last_session":"Последняя сессия","left":"осталось","level":"Уровень","levelLine":"Линия уровня","levelTitle":"Уровень","levels":"Уровни","listCategories":"Список категорий","list_of_mand_reaction":"Cписок стимулов","list_of_stimulus":"Cписок стимулов","logEndCriteria":"Критерий завершения протокола","make_criteria_current":"Вернуться к критерию","make_current":"Сделать текущим","make_first":"Cделать первым","make_last":"Cделать последним","mand_date":"Дата пробы","mand_level":"Уровень просьбы (Предметно или Спонтанно)","mand_required":"Поле стимул обязательно для заполнения.","master":"Освоить","master_criterion":"Освоить критерий","mastered":"Переведен","mastered_criteretion":"Условие освоения критерия","mastered_criterion":"Критерий освоен","mastered_mand":"Освоено","mastered_stimuli":"Освоенные стимулы","mastered_stimulus":"Освоено","mastering":"Освоение","mastering vcd":"Освоение","mastering_btn":"освоен","mastering_chart":"График освоения протокола","mastering_chart_phase":"График освоения на фазе","mastering_chart_stage":"График освоения этапа протокола","mastering_criteria":"Критерии освоения","mastering_percent":"Освоение протокола, %","mastering_table":"Освоение протокола","materials":"Материалы","max_count_for_session":"Общее максимальное количество проб по сессии не должно превышать 3000","max_field_count":"Максимальное кол-во полей","measured":"Измерил","measurement_date":"Дата проведения","min_field_count":"Минимальное кол-во полей","minor":"незначительные","motivation_condition":"Мотивационное условие","moveFieldTitle":"Стимулы, которые находятся не на полях от :min по :max  будут перенесены на ближайшие доступные поля","n_sessions_with_n_blocks":":sessionCount сессий по :sessionBlockCount блоков","nameCategoryProperty":"Категория/Свойство","name_criterion":"Название критерия","name_mand_reaction":"Название стимула","name_step":"Название шага","newProtocol":"Новый протокол","next_block":"На уровень","next_criterion":"Перейти к следующему критерию","next_session":"Следующая сессия","next_support":"Перевести на Поддержание","noAvailableTeachingMethod":"Нет доступных методов обучения","no_available_protocols":"Нет доступных протоколов","no_available_set_create":"Нет доступных стимулов для создания набора","no_data":"Нет данных","no_list_category":"Нет категорий доступных для обучения","no_list_property":"Нет свойств доступных для обучения","no_title":"Без названия","nodata":"Нет данных","notPublish":"Черновик","number_of_trials":"Номер пробы","of_protocol":"протокола","offButton":"Выключить","once_a_month":"Один раз в месяц","once_a_week":"Один раз в неделю","once_every_two_weeks":"Один раз в две недели","one_trial":"Одна проба","pagination":{"next":"Вперёд","previous":"Назад"},"partial_physical":"Частичная физическая","partial_verbal":"Частичная вербальная","pecs":{"control_of_achievements":"Контроль достижений.","countSamples":"Количество попыток до достижения целевого критерия","go_to":"Перейти на","next_probe":"Следующая проба","step_one":"Шаг 1","step_three":"Шаг 3","step_two":"Шаг 2","table_mastered":"Таблица ввода и освоения шага","table_mastered_step":"Таблица ввода и освоения целевой последовательности","table_mastered_target_sequence":"Таблица ввода и освоения целевой последовательности на шаге","table_mastered_target_sequence_pwd":"Таблица ввода и освоения целевой последовательности","target_sequence":{"get_album":"Взять альбом","get_i_want_card":"Достать из альбома карточку “Я хочу”","get_reinforcement_item_card":"Достать из альбома карточку с изображением предмета-подкрепления","get_template":"Достать из альбома шаблон для предложений","give_template":"Отдать шаблон для предложений Собеседнику","put_i_want_card":"Поместить карточку “Я хочу” на шаблон для предложений","put_reinforcement_item_card":"Поместить эту карточку на шаблон для предложений","read_sentence":"Чтение предложения на шаблоне"},"target_sequence_title":"Целевая последовательность","without_discrimination_target_sequence":{"get_album":"Взять альбом","get_card_desired_item":"Достать карточку желаемого предмета","get_i_want_card":"Достать карточку “Я хочу”","get_target_property_item_card":"Достать карточку с изображением целевого свойства предмета","get_template":"Достать из альбома шаблон для предложений","give_template":"Отдать шаблон для предложений Собеседнику","put_card_desired_item":"Поместить карточку желаемого предмета на шаблон для предложений","put_i_want_card":"Поместить карточку “Я хочу” на шаблон для предложений","put_target_property_item_card":"Поместить  карточку с изображением целевого свойства предмета на шаблон для предложений"}},"percent_block":"% самостоятельных реакций  и подсказок на ","percent_next_block":"% самостоятельных реакций на ","percent_reaction":"самостоятельных реакций в течение","phase":"Фаза","phase_fluency":"Фаза беглости","phase_mastering":"Фаза освоения","phase_rotation":"Фаза ротации","phase_stimuli":"Стимулы на фазах","phase_support":"Фаза поддержания","position":"Местоположение","positional":"Позиционная","prev_block":"Вернуть на уровень","probe_by_session":"Пробы за сессию","promptType":"Вид подсказки","properties_without_discrimination":"Свойства без различения","property":"свойство","propertyTitle":"Свойство","protocol":"Протокол","protocol_dtt":"Протокол DTT ","protocol_goal":"Цели протокола","protocol_status":"Статус протокола","protocols":"Протоколы","providingHint":"Предоставление подсказки","quantity":"Количество","reactions":"Цели","reading_sentence":"Чтение предложения на шаблоне","recommendation":"Рекомендация","recordData":"Запись данных (вид)","recording_method":"Способ записи данных","reducingPromp":"Критерий снижения подсказки","reducingTooltip":"Метод снижения подсказки","reduction_hint_method":"Метод снижения подсказки","removeEnvironment":"Удалить среду","removeStep":"Удалить шаг","repeat":"Повторение","requestNewProtocol":"Запрос нового протокола","requests":"Просьбы","requiredCheckList":"Лист записи реакций для всех этапов обязателен для заполнения","requiredStepsList":"Список шагов для всех сред обязателен для заполнения","requiredStimulList":"Список стимулов для всех этапов обязателен для заполнения","response":"Реакция","responses":"Реакции","result":"Результат","result_assigned_session":"Результаты терапевтической сессии","result_last_assigned_session":"Результаты последней терапевтической сессии","result_of_protocol":"Сводные данные протокола","result_of_stage":"Результаты этапа","results":"Результаты","results_of_stages":"Сводные данные по этапам протокола","results_of_the_protocol":"Результаты протокола","results_protocol_title":"График эффективности этапа","risingPrompt":"Критерий повышения подсказки","rotation":"Ротация","save_session_date":"Дата сохранения сессии","save_set":"Необходимо сохранить текущие изменения, чтобы работать с набором","scatterLine":"Линия разброса данных","selectTemplate":"Выберите шаблон","select_attempt":"Cобирать данные на 4 и 5 элементах целевой последовательности","session":"Сессия","set":"Набор","sets":"Наборы","setup_distinctive_properties":"Фаза Свойства с различением","setup_fluency":"Настройка беглости","setup_i_want_card":"Фаза Перемещение карточки “Я хочу”","setup_item_card":"Фаза Добавление карточки с изображением желаемого предмета на шаблон для предложений","setup_mastering":"Настройка освоения","setup_properties_without_discrimination":"Фаза Свойства без различения","setup_reading_sentence":"Фаза Чтение предложения на шаблоне","setup_rotation":"Настройка ротации","setup_stimuli":"Настройки стимула :title","setup_support":"Настройка поддержания","shaping_chart":"Оценка и анализ изменений поведения в среде","shaping_last_session_chart":"Оценка и анализ изменений поведения за последнюю сессию","short_description":"Короткое описание","shortcut_enabled":"Добавить в меню быстрого доступа","shortcut_menu_title":"Название для меню быстрого доступа","showChangeDateSession":"Внести данные предыдущих сессий","showGraphsTitle":"Показывать графики в отчете","show_on_environment":"Показывать в среде","show_on_level":"Показывать на уровне","show_on_stage":"Показывать на этапе","size":"Размер","skillField_and_code":"Область или код навыков","speed":"Скорость","spontaneous_level":"C","stage":"Этап","stage_choose_from":"Уровень (выбор из)","stage_count":"Номер этапа","stage_number":"Этап :count","stage_number_of_stage_count":"Этап :stageNumber из :stageCount","stages":"Этапы","stages_stimuli":"Стимулы на этапах","startTraining":"Начало обучения","start_new":"Начать новую","start_session_date":"Дата начала сессии","started_at":"Введено","status":"Статус","statuses":{"Active":"В работе","Completed":"Пройден","Individualization":"Индивидуализация","Maintaining":"Поддержание","New":"Новый","supporting":"Поддержание"},"step":"Шаг","step_count":"кол-во шагов на этапе","step_required":"Поле Шаг обязательно для заполнения.","steps":"Шаги","stimul_count":"Всего","stimul_settings":"Для настройки нескольких стимулов, выберите стимулы и нажмите кнопку изменить","stimul_table_header":"История движения стимулов с пробами за выбранный период","stimuls":"стимула","stimulus":"Стимул","stimulus_count":"стимулов","stimulus_improved_chart":"График улучшенных реакций для:","stimulus_intervals":"Задать интервалы повторения стимула","stimulus_list_empty":"Нет стимулов для прохождения листа записи реакций СПО.","stimulus_mastering_chart":"График самостоятельных реакций для:","stimulus_name":"Название стимула","stimulus_prompt_chart":"График уменьшения уровня подсказки стимула:","stimulus_required":"Поле Стимул обязательно для заполнения.","stimuluses":"Стимулы","subjects":"Предмет","support":"Поддержание","support_stimulus":"Стимулы на поддержании","support_subtitle":"При включении или выключении интервалов и изменения кол-ва повторений стимулы не будут автоматически переходить на новые доступные интервалы. Переносить стимулы на доступные интервалы необходимо вручную.","synthesisStrategy":"Стратегия обобщения","table_mastered_category":"Таблица ввода и освоения категорий на уровнях","table_mastered_category_name":"Таблица ввода и освоения категории:","table_subtitle":"Для построения графика выберите стимул из таблицы","taskType":"Запись данных (вид)","task_in_row":"занятия подряд","task_prompts":{"descriptions":{"L1":"рука на кисти","L2":"рука на предплечье","L3":"рука на локте","L4":"рука на плече","audio":"аудиальная","full_physical":"полная физическая","full_verbal":"полная вербальная","gestural":"жестовая","modeling":"моделинг","partial_physical":"частичная физическая","partial_verbal":"частичная вербальная","positional":"позиционная","textual":"текстовая","visual":"визуальная"},"main_description":"Вы можете заменить сокращенные названия подсказок на названия, которые Вы используете в работе.","main_title":"Настроить подсказки","titles":{"L1":"ЧФ1","L2":"ЧФ2","L3":"ЧФ3","L4":"ЧФ4","audio":"АП","full_physical":"ПФ","full_verbal":"ПВ","gestural":"ЖП","modeling":"МД","partial_physical":"ЧФ","partial_verbal":"ЧВ","positional":"ПП","textual":"ТП","visual":"ВП"}},"task_type":"Тип листа записи реакции","task_types":{"answers":{"+":"+","-":"-","C":"С","C+":"С+","C1":"С","C6":"С","E":"О","E6":"Н","FU":"ПП","L1":"ЧФ1","L2":"ЧФ2","L3":"ЧФ3","L4":"ЧФ4","NM":"НМ","NR":"Н","NR6":"O","P":"П","U":"У","U+":"У+","UG":"УГ","audio":"АП","descriptions":{"+":"сделал сразу","-":"нет реакции, НП, ошибка","C":"сам, фраза \"сделай так\"","C+":"сам, без предмета","C1":"сам","C6":"сам, с предметом","E":"ошибка","E6":"неправильная реакция","FU":"полная помощь","NM":"нет мотивации","NR":"нет реакции","NR6":"отсутствие реакции","P":"подсказка","U":"улучшенная реакция","U+":"улучшенная реакция","UG":"угадывание","no_data":"нет данных"},"full_physical":"ПФ","full_verbal":"ПВ","gestural":"ЖП","modeling":"МД","no_data":"Н/Д","partial_physical":"ЧФ","partial_verbal":"ЧВ","positional":"ПП","textual":"ТП","titles":{"+":"+","-":"-","C":"С","C+":"С+","C1":"C","C6":"C","E":"О","E6":"Н","FU":"ПП","NM":"НМ","NR":"Н","NR6":"O","P":"П","U":"У","U+":"У+","UG":"УГ","no_data":"Н/Д"},"visual":"ВП"},"descriptions":{"cold_probes":"Учитывается только первая реакция за день; ставится отметка вида «+» (сделал сразу) или «-» (нет реакции, НП, ошибка).","cold_probes_major":"Учитывается только первая реакция за день; ставится отметка вида «+» (сделал сразу) или «-» (нет реакции, НП, ошибка).","cold_probes_settings":"Учитывается только первая реакция за день и ставится отметка.","probe_analysis_c_plus_cpfueub":"С+ - сам, без вербальной помощи; С – сам, фраза «сделай так»; П - подсказка; ПП – полная помощь; О – ошибка (другое движение); Н – НП, отсутствие реакции даже после подсказки.","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"С+ - сам, без предмета; С - сам, с предметом; У+ - улучшенная реакция; УГ - угадывание; О - отсутствие реакции; П - подсказка; Н - неправильная реакция; НМ - нет мотивации","probe_analysis_cpe":"С – сам; П - подсказка; О – ошибка (другое движение).","probe_analysis_cpenr":"С – сам; П - подсказка; О – ошибка (другое движение); Н – НП, отсутствие реакции даже после подсказки.","probe_analysis_cpeu":"С – сам; П - подсказка; О – ошибка (другое движение); У - улучшенная реакция."},"titles":{"cold_probes":"Холодные пробы","cold_probes_major":"Холодные пробы - расширенный","probe_analysis_c_plus_cpfueub":"Анализ проб (С+СПНОПП)","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"Анализ проб (СС+У+УГОПН)","probe_analysis_cpe":"Анализ проб (СПО)","probe_analysis_cpenr":"Анализ проб (СПНО)","probe_analysis_cpeu":"Анализ проб (СПОУ)"}},"teachingFormat":"Формат обучения","teachingMethod":"Метод обучения","teaching_methods":{"Chain":"Цепочка","DTT":"Метод отдельных блоков (DTT)","Desensibilization":"Десенсибилизация","Features with items":"Альтернативная коммуникация: свойства и предметы","Mand Vocal":"Манд Вокальный","NET":"NET","Pecs":"Процедура PECS","Pecs Properties Without Discrimination":"Альтернативная коммуникация: cвойства без различения","Pecs Sentence Structure":"Альтернативная коммуникация: cтруктура предложения","Pecs With Discrimination":"Альтернативная коммуникация: свойства с различением","Random learning":"Случайное обучение","Reaction forming":"Формирование реакций","Shaping":"Шейпинг","Simple (Chain, Shaping)":"Простой","VCD":"Условная дискриминация (УСД)","Десенсибилизация":"Десенсибилизация","Случайное обучение":"Случайное обучение","Формирование реакций":"Формирование реакций","Цепочка":"Цепочка"},"temperature":"Температура","textual":"Текстовая","texture":"Текстура","therapeuticSession":"Терапевтическая сессия","through_each_lesson":"На каждом занятии","title":"Название протокола","title_chain":"Цепочка в среде ","title_mand_reaction":"Протокол формирование манд-реакций","to_field":"на поле","to_next_phase":"на следующую фазу","to_prev_phase":"вернуть на предыдущую фазу","to_rotation":"в ротацию","to_support":"на поддержание","today_support_stimulus":"Стимулы сегодня на поддержании","total_himself":"Итого, сам","total_percent":"% самостоятельных реакций","total_percent_graph":"График % самостоятельных реакций","track_change_level":"Отслеживать уровень изменения подсказки","tracked_change_level":"Отслеживаемый уровень изменения подсказки","tracked_reactions":"Отслеживаемые реакции","transfer_to_rotation":"Переведено в ротацию","transfer_to_support":"Переведено на поддержание","trendLine":"Линия тренда","trendLineTitle":"Отображать линии на графике","trial_count":"Кол-во проб","trial_in_row":"пробы подряд","trueReaction":"Верная реакция","unable_to_delete_protocol":"Протокол невозможно удалить","unique_criterion":"Критерии не должны повторяться","unique_mand":"Стимулы не должны повторяться","unique_step":"Шаги не должны повторяться","unsaved_changes":"Есть несохранённые изменения","unwanted_behavior":"Нежелательное поведение","view_auto_save":"посмотреть автосохранённую версию","visual":"Визуальная","whole_period":"Весь период","withFields":"Показать/скрыть поля","with_subject":"П","withoutProperties":"Нет упражнений для прохождения"},"ru.quiz":{"addToReport":"Добавить в отчет","answered":"Ответивший","answersDetail":"0=никогда, 1=почти никогда, 2=редко, 3=в половине случаев, 4=обычно, 5=почти всегда, 6=всегда","answersDetailFast":"0=нет, 1=да, 2=не знаю","assignToClient":"Кем вы приходитесь клиенту?","assigned":"Назначено","assigned_specialist":"Назначенный специалист","backToQuizList":"Вернуться к списку опросов","chooseQuiz":"Выберите тип опроса","chooseSpecialist":"Выбрать специалиста","client":"Клиент","completePart2":"Заполните Часть II,  если вы ответили «да» 1,2, или 3.  Пропустите Часть II  если вы ответили «нет» на все вопросы Части I.","completeWith":"Проведен с","countYes":"кол-во ответов «Да»","createQuiz":"Новый опрос","created":"Создал","created_by":"Назначил","dateAndTime":"Запланированная дата и время проведения","description":"Описание","editQuiz":"Редактировать опрос","enterNameSpesialist":"Начните вводить имя специалиста","errorDelete":"Опрос не доступен для удаления. Данный опрос пройден.","errorEdit":"Опрос не доступен для редактирования. Данный опрос пройден.","errorResult":"Количество выбранных специалистов должно быть в диапазоне от 2 до 3","errorTargetValue":"Поле целевое поведение обязательно для заполнения.","fast":{"answers":{"titles":["Нет","Да","Уход за собой","Обучение","Работа","Прочее","Уход за собой","Обучение навыкам","Досуг","Вечером","Приём пищи","Формирование профессиональных навыков","Когда клиент ничем не занят"]},"description":"Функциональное сканирование определяет факторы, которые влияют на нежелательное поведение. \n            Проводящий собеседование специалист предъявляет опросник нескольким людям, которые работают с клиентом. \n            Результаты используются, чтобы помочь специалисту определитьситуации, провоцирующие нежелательное поведение и \n            определить функцию поведения. Если у клиента наблюдается больше одного вида нежелательного поведения, \n            заполните несколько опросников, один для каждого поведения","general_questions":{"informant_client_relationship":{"questions":{"1":"Кем вы приходитесь клиенту?","2":"Как давно вы знаете клиента?","3":"Как часто вы взаимодействуете с клиентом?","4":"В каких ситуациях вы взаимодействуете с клиентом?"},"title":"Заполните информацию о взаимодействии с клиентом"},"problem_behavior_information":{"answers":{"1":"каждый час","2":"каждый день","3":"каждую неделю","4":"каждый месяц","5":"Здоровье клиента не подвергается риску","6":"Поведение может нанести ущерб здоровью клиента в определенной степени","7":"Поведение может нанести ущерб здоровью клиента в значительной степени"},"questions":{"1":"Дайте название или кратко опишите нежелательное поведение","2":"Как часто возникает нежелательное поведение? (каждый час / каждый день / каждую неделю / каждый месяц)","3":"Как долго поведение длится?","4":"Насколько поведение интенсивно? (выберите наиболее подходящий вариант)","5":"Опишите, в каких ситуациях нежелательное поведение возникает чаще всего (с определенными людьми, \n                    во время определенных занятий, в определенное время дня, и т. д.):","6":"Опишите, в каких ситуациях нежелательное поведение возникает реже всего (с определенными людьми, \n                    во время определенных занятий, в определенное время дня, и т. д.):","7":"Опишите, что происходит непосредственно перед тем как поведение возникает? (смена инструктора, \n                    предъявление определенного задания, инструктор забрал мотивационный предмет, и т.д.):","8":"Что происходит сразу же после того, как нежелательное поведение началось? (инструктор меняет занятие \n                    на мотивационное деятельность, отдает мотивационный предмет, просит не делать этого и т.д.):","9":"Что вы делаете на данный момент, чтобы скорректировать поведение?"},"title":"Ответьте на вопросы о нежелательном поведении"}},"questions":{"titles":{"1":"Нежелательное поведение возникает когда клиент не получает достаточно внимания или тот человек, \n                который с ним работает, уделяет внимание кому-то другому","2":"Нежелательное поведение возникает, когда клиент просит что-то, что он любит, но ему это не дают?","3":"Когда возникает нежелательное поведение, тот человек, который работает с клиентом, обычно пытается \n                его успокоить, давая то, что клиент любит","4":"Клиент демонстрирует приемлемое поведение, когда он или она занимается тем, что любит","5":"Клиент обычно начинает сопротивляться, когда его просят/требуют сделать какое-либо задание","6":"Клиент демонстрирует нежелательное поведение, когда его просят/требуют сделать какое-либо задание","7":"Если клиент демонстрирует нежелательное поведение во время какого-либо задания, ему предоставляется \n                перерыв от задания","8":"Клиент обычно ведет себя хорошо, когда от него никто ничего не требует","9":"Нежелательное поведение возникает даже тогда, когда клиент находится один","10":"Нежелательное поведение возникает даже тогда, когда клиент занимается любимым занятием","11":"Нежелательное поведение является формой самостимуляции","12":"Вероятность возникновения нежелательного поведения меньше, когда у клиента есть возможность \n                заниматься сенсорно-стимулирующими занятиями или предметами","13":"Нежелательное поведение имеет циклический характер: оно возникает в течение нескольких дней, а потом \n                исчезает","14":"Клиент подвержен заболеваниям и аллергическим реакциям","15":"Нежелательное поведение возникает чаще всего, когда клиент болен","16":"Нежелательное поведение исчезает, когда после заболевания он начинает чувствовать себя лучше"}},"result_interpretation":"Та функция, которая получила максимальное количество баллов, потенциально может \n            являться причиной возникновения поведения.Результаты функционального сканирования должны быть дополнены \n            наблюдением и заполнением АВС таблицы. Интерпретация результатов должнабыть основана на анализе данных, \n            полученных в процессе наблюдения","result_table":{"potential_source_of_reinforcement":{"automatic_pain":"Автоматическое   подкрепление   (Избегание боли)","automatic_sensory":"Автоматическое   подкрепление   (Сенсорная стимуляция)","social":"Социальное   подкрепление   (Внимание)","social_escape":"Социальное   подкрепление   (Избегание)","social_specific_activities":"Социальное подкрепление   (доступ к предпочитаемым   предметам/деятельности)"},"titles":{"items":"Отметьте номер вопроса с ответом «Да»","potential_source_of_reinforcement":"Функция","total":"Количество вопросов с ответом «Да» в каждой строке"}},"title":"FAST"},"fastChart":"Сводная диаграмма нескольких FAST","fastTableTitle":"Таблица результатов FAST","goToExercise":"Пройти","goToQuiz":"Выполнить","ifNoExplain":"Если «нет», то сколько часов в неделю?","ifOtherExplain":"Если другое, опишите","ifYesExp":"Если «да», опишите","ifYesExplain":"Если «да», то сколько часов в день?","information":"Информация об опросе","masChart":"Сводная диаграмма нескольких MAS","masTableTitle":"Таблица результатов MAS","maxCountOfSpesialist":"Выбрано максимальное количество специалистов","meanScore":"Средний балл","meanScoreDescription":"(общий балл разделить на 4)","motivation_scale":{"answers":{"titles":["Никогда","Почти никогда","Редко","В половине случаев","Обычно","Почти всегда","Всегда"]},"description":"Мотивационная шкала-это опросник, который позволяет быстро определить функцию проблематичного \n            поведения. С помощью данной шкалы можно определить предшествующие условия, которые воздействуют на \n            значимость последствий проблематичного поведения (Мотивационные операции), и в которых обычно возникает \n            это нежелательное поведение.","general_questions":{"problem_behavior_information":{"questions":{"1":"Определение целевого поведения","2":"Кратко опишите ситуации, в которых возникает целевое поведение"},"title":"Информация о поведении"}},"information":"Мотивационная шкала содержит 16 вопросов, которые описывают различные ситуации, \n            в которых может возникнуть нежелательное поведение. Необходимо дать четкое и конкретное определение \n            целевому поведению (не \"ведет себя агрессивно\", а \"бьет кулаком в лицо\"), и заполнить опросник в \n            отношении этого определения. Если у клиента наблюдается несколько видов нежелательного поведения, следует \n            заполнять по каждому виду поведения отдельный опросник. Желательно, чтобы опросник заполнили, по меньшей \n            мере, два человека, из близкого окружения клиента.","questions":{"titles":{"1":"Если клиента оставить одного, нежелательное поведение будет возникать снова и снова","2":"Нежелательное поведение возникнет, если от клиента потребовать выполнить трудное задание","3":"Нежелательное поведение возникает, когда взрослый разговаривает с кем-нибудь другим","4":"Нежелательное поведение возникает, когда клиент требует получить мотивационный предмет, еду или любимое занятие, но ему было отказано в его просьбе.","5":"Поведение будет возникать раз за разом, когда никого нет рядом, а также продолжаться в течение какого-то времени","6":"Поведение возникнет, если клиента попросить что-то сделать","7":"Поведение возникнет, если прекратят уделять внимание клиенту","8":"Поведение возникнет, когда вы заберете предпочитаемый предмет, еду, или прервете любимое занятие клиента","9":"Клиент получает удовольствие, когда занимается нежелательным поведением","10":"Когда вы предоставляете клиенту инструкцию выполнить задание, он демонстрирует свое нежелательное поведение, чтобы избежать задания","11":"Клиент демонстрирует свое нежелательное поведение, когда ему перестают уделять внимание","12":"Поведение заканчивается, когда вы предоставляете клинету доступ к предпочитаемому предмету, еде или виду деятельности","13":"Когда поведение происходит, создается впечатление, что клиент не замечает, где он находится и что происходит вокруг него","14":"Поведение заканчивается, как только вы прекращаете предоставлять клиенту инструкцию выполнять определенное задание","15":"Поведение происходит, чтобы привлечь ваше внимание","16":"Поведение происходит, когда вы сказали, что клиент не может чего-то сделать или получить (например, мотивационный предмет)"}},"result_interpretation":"Та функция, которая получила максимальное количество баллов, потенциально может \n            являться причиной возникновения поведения.Результаты мотивационной шкалы должны быть дополнены наблюдением \n            и заполнением таблицы АВС. Интерпретация результатов должна быть основана на анализе данных, полученных в \n            ходе наблюдения и итоговых результатов опросника","result_table":{"results":{"mean_score":"Средний балл","relative_ranking":"Относительное распределение","total_score":"Общий балл"},"titles":{"attention":"Внимание","escape":"Избегание","sensory":"Сенсорная","tangible":"Доступ"}},"title":"MAS"},"oneFastChart":"Диаграмма FAST","oneMasChart":"Диаграмма MAS","passed_at":"Дата и время проведения","pdfReport":"PDF отчет","pdfReportTitle":"Отчет об опросе","question_answers":"Ответы на вопросы","question_titles":{"create_titles":{"fast":{"evaluator_information":{"questions":{"1":"Как давно вы знаете клиента?","2":"Вы взаимодействуете с клиентом ежедневно?","3":"В каких ситуациях вы наблюдаете за клиентом? Отметьте все применимые ситуации"},"title":"Данные об источнике информации о клиенте"},"nonsocial_reinforcement":{"questions":{"19":"Целевое поведение наблюдается часто, если клиент находится в одиночестве или не занят продуктивной деятельностью.","20":"Поведение наблюдается с относительно высокой частотой независимо от текущей деятельности или происходящего в среде.","21":"Кажется, что у клиента мало известных подкреплений или редко демонстрирует приемлемые реакции манипуляции предметами.","22":"Клиент обычно не реагирует на социальное взаимодействие","23":"Клиент часто демонстрирует повторяющееся, стереотипное поведение, такое как раскачивание тела, взмахи руками или движения пальцами, кручение предметов, их разгрызание и т.д.","24":"Когда клиент демонстрирует целевое поведение, вы и другие люди обычно никак не реагируете (например, вы никогда или редко обращаете внимание на целевое поведение)","25":"Целевое поведение наблюдается в циклах. Во время цикла высокой вероятности поведения, оно наблюдается часто и его сложно прервать. Во время цикла с \n                        низкой вероятностью, целевое поведение демонстрируется редко","26":"Целевое поведение проявляется более часто при болезни клиента.","27":"У клиента есть история повторяющихся болезней (например, инфекции носоглотки, аллергии, дерматиты и т.д.)."},"title":"Часть III. Автоматическое подкрепление"},"social_influences_on_behavior":{"questions":{"1":"Поведение обычно происходит в вашем присутствии или в присутстви других лиц.","2":" Поведение обычно происходит после взаимодействия с клиентом, например, после предоставления \n                        инструкции или неодобрения, отхода от клиента (игнорирования), прекращения доступа к предпочитаемому \n                        предмету, требования смены вида деятельности, разговора с кем-то ещё в присутствии клиента и т.д.","3":"Поведение часто сопровождается «эмоциональными» реакциями, такими как крики или слёзы."},"title":"Часть I. Социальные последствия поведения"},"social_reinforcement":{"questions":{"4":"Поведение часто наблюдается, когда клиент не получил внимания.","5":"При возникновении поведения, вы или другие люди реагируете взаимодействием с клиентом каким-либо образом \n                        (используете утешающие фразы,  блокируете или перенаправляете реакцию, используеете осуждающие фразы и т.д.) ","6":"Клиент часто демонстрирует прочие раздражающие виды поведения, которые вызывают привлечение внимания.","7":"Клиент часто приближается к вам или другим людям и инициирует социальное взаимодействие","8":"Поведение редко наблюдается, если клиент получает много внимания.","9":"Поведение часто наблюдается, если вы прекращаете доступ клиента к какому-либо предмету или предпочитаемому виду деятельности.","10":"Поведение часто наблюдается, когда вы сообщаете клиенту о невозможности получить доступ к определённому предмету или виду деятельности.","11":"При наблюдении поведения, вы часто реагируете тем, что предоставляете клиенту доступ к определённому предмету, предпочитаемой еде или другому предмету.","12":"Клиент часто демонстрирует прочее раздражающее поведение, в результате которого получает доступ к предпочитаемым предметам или видам деятельности.","13":"Поведение редко наблюдается во время учебной деятельности или когда вы предъявляете иные требования к клиенту. Если да, укажите виды деятельности:","14":"Поведение часто наблюдается во время учебной деятельности или при предоставлении инструкции выполнить какое-либо задание.","15":"Часто клиент не демонстрирует поведение, совместимое с учебной деятельностью или выполнением инструкций.","16":"Целевое поведение часто наблюдается в шумной среде или в присутствии множества людей.","17":"Когда вы наблюдаете целевое поведение, вы часто реагируете предоставлением клиенту короткого перерыва в выполнении текущей инструкции.","18":"Целевое поведение часто наблюдается в ситуациях, когда вы предъявляете клиенту мало требований или оставляете его в одиночестве."},"title":"Часть II. Социальные подкрепления"}},"motivation_scale":{"main_questions":{"questions":{"1":"Если клиента оставить одного, нежелательное поведение будет возникать снова и снова","2":"Нежелательное поведение возникнет, если от клиента потребовать выполнить трудное задание","3":"Нежелательное поведение возникает, когда взрослый разговаривает с кем-нибудь другим","4":"Нежелательное поведение возникает, когда клиент требует получить мотивационный предмет, еду или любимое \n                            занятие, но ему было отказано в его просьбе.","5":"Поведение будет возникать раз за разом, когда никого нет рядом, а также продолжаться в \n                            течение какого-то времени","6":"Поведение возникнет, если клиента попросить что-то сделать","7":"Поведение возникнет, если прекратят уделять внимание клиенту","8":"Поведение возникнет, когда вы заберете мотивационный предмет, еду, или прервете любимое занятие клиента","9":"Клиент получает удовольствие, когда занимается нежелательным поведением","10":"Когда вы предоставляете клиенту инструкцию выполнить задание, он демонстрирует свое нежелательное поведение, чтобы избежать задания","11":"Клиент демонстрирует свое нежелательное поведение, когда ему перестают уделять внимание","12":"Поведение заканчивается, когда вы предоставляете клинету доступ к предпочитаемому предмету, еде или виду деятельности","13":"Когда поведение происходит, создается впечатление, что клиент не замечает, где он \n                            находится и что происходит вокруг него","14":"Поведение заканчивается, как только вы прекращаете предоставлять клиенту инструкцию выполнять определенное задание","15":"Поведение происходит, чтобы привлечь ваше внимание","16":"Поведение происходит, когда вы сказали, что клиент не может чего-то сделать или получить (например, мотивационный предмет)"}},"problem_behavior_information":{"questions":{"1":"Определение целевого поведения","2":"Кратко опишите ситуации, в которых возникает целевое поведение"},"title":"Информация о поведении"}}},"show_titles":{"fast":{"evaluator_information":{"questions":{"1":"Как давно вы знаете клиента?","2":"Вы взаимодействуете с клиентом ежедневно?","3":"В каких ситуациях вы наблюдаете за клиентом? Отметьте все применимые ситуации"},"title":"Часть I. Данные об источнике информации о клиенте"},"nonsocial_reinforcement":{"questions":{"19":"Целевое поведение наблюдается часто, если клиент находится в одиночестве или не занят продуктивной деятельностью.","20":"Поведение наблюдается с относительно высокой частотой независимо от текущей деятельности или происходящего в среде.","21":"Кажется, что у клиента мало известных подкреплений или редко демонстрирует приемлемые реакции манипуляции предметами.","22":"Клиент обычно не реагирует на социальное взаимодействие","23":"Клиент часто демонстрирует повторяющееся, стереотипное поведение, такое как раскачивание тела, взмахи руками или движения пальцами, кручение предметов, их разгрызание и т.д.","24":"Когда клиент демонстрирует целевое поведение, вы и другие люди обычно никак не реагируете (например, вы никогда или редко обращаете внимание на целевое поведение)","25":"Целевое поведение наблюдается в циклах. Во время цикла высокой вероятности целевого поведения поведения, оно наблюдается часто и его сложно прервать. Во время цикла с \n                        низкой вероятностью, целевое поведение демонстрируется редко","26":"Целевое поведение проявляется более часто при болезни клиента.","27":"У клиента есть история повторяющихся болезней (например, инфекции носоглотки, аллергии, дерматиты и т.д.)."},"title":"Часть III. Автоматическое подкрепление"},"social_influences_on_behavior":{"questions":{"1":"Поведение обычно происходит в вашем присутствии или в присутствии других лиц.","2":"Поведение обычно происходит после взаимодействия с клиентом, например, после предоставления \n                        инструкции или неодобрения, отхода от клиента (игнорирования), прекращения доступа к предпочитаемому \n                        предмету, требования смены вида деятельности, разговора с кем-то ещё в присутствии клиента и т.д.","3":"Поведение часто сопровождается \"эмоциональными\" реакциями, такими как крики или слёзы."},"title":"Социальные последствия поведения"},"social_reinforcement":{"questions":{"4":"Поведение часто наблюдается, когда клиент не получил внимания.","5":"При возникновении поведения, вы или другие люди реагируете взаимодействием с клиентом каким-либо образом \n                        (используете утешающие фразы,  блокируете или перенаправляете реакцию, используеете осуждающие фразы и т.д.) ","6":"Клиент часто демонстрирует прочие раздражающие виды поведения, которые вызывают привлечение внимания.","7":"Клиент часто приближается к вам или другим людям и инициирует социальное взаимодействие","8":"Поведение редко наблюдается, если клиент получает много внимания.","9":"Поведение часто наблюдается, если вы прекращаете доступ клиента к какому-либо предмету или предпочитаемому виду деятельности.","10":"Поведение часто наблюдается, когда вы сообщаете клиенту о невозможности получить доступ к определённому предмету или виду деятельности.","11":"При наблюдении поведения, вы часто реагируете тем, что предоставляете клиенту доступ к определённому предмету, предпочитаемой еде или другому предмету.","12":"Клиент часто демонстрирует прочее раздражающее поведение, в результате которого получает доступ к предпочитаемым предметам или видам деятельности.","13":"Поведение редко наблюдается во время учебной деятельности или когда вы предъявляете иные требования к клиенту. Если да, укажите виды деятельности:","14":"Поведение часто наблюдается во время учебной деятельности или при предоставлении инструкции выполнить какое-либо задание.","15":"Часто клиент не демонстрирует поведение, совместимое с учебной деятельностью или выполнением инструкций.","16":"Целевое поведение часто наблюдается в шумной среде или в присутствии множества людей.","17":"Когда вы наблюдаете целевое поведение, вы часто реагируете предоставлением клиенту короткого перерыва в выполнении текущей инструкции.","18":"Целевое поведение часто наблюдается в ситуациях, когда вы предъявляете клиенту мало требований или оставляете его в одиночестве."},"title":"Часть II. Социальные подкрепления"}},"motivation_scale":{"main_questions":{"questions":{"1":"Если клиента оставить одного, нежелательное поведение будет возникать снова и снова","2":"Нежелательное поведение возникнет, если от клиента потребовать выполнить трудное задание","3":"Нежелательное поведение возникает, когда взрослый разговаривает с кем-нибудь другим","4":"Нежелательное поведение возникает, когда клиент требует получить мотивационный предмет, еду или любимое \n                            занятие, но ему было отказано в его просьбе.","5":"Поведение будет возникать раз за разом, когда никого нет рядом, а также продолжаться в \n                            течение какого-то времени","6":"Поведение возникнет, если клиента попросить что-то сделать","7":"Поведение возникнет, если прекратят уделять внимание клиенту","8":"Поведение возникнет, когда вы заберете мотивационный предмет, еду, или прервете любимое занятие клиента","9":"Клиент получает удовольствие, когда занимается нежелательным поведением","10":"Когда вы предоставляете клиенту инструкцию выполнить задание, он демонстрирует свое нежелательное поведение, чтобы избежать задания","11":"Клиент демонстрирует свое нежелательное поведение, когда ему перестают уделять внимание","12":"Поведение заканчивается, когда вы предоставляете клинету доступ к предпочитаемому предмету, еде или виду деятельности","13":"Когда поведение происходит, создается впечатление, что клиент не замечает, где он \n                            находится и что происходит вокруг него","14":"Поведение заканчивается, как только вы прекращаете предоставлять клиенту инструкцию выполнять определенное задание","15":"Поведение происходит, чтобы привлечь ваше внимание","16":"Поведение происходит, когда вы сказали, что клиент не может чего-то сделать или получить (например, мотивационный предмет)"}}}}},"quiz":"Скрининг НП","quizComplete":"Проведен","quizTitle":"Структурированные собеседования и инструменты функциональной оценки","relativeRanking":"Относительное распределение вероятности переменной","relativeRankingDescription":"(от большего к меньшему)","removedUser":"Специалист удален","reportTitle":"Структурированные собеседования и инструменты функциональной оценки","result_interpretation":"Трактовка результата","saveQuiz":"Создать опрос","scheduled_at":"Дата назначения","show":"Показать","take":"Выполнить","targetBahaviour":"Целевое поведение","totalScore":"Общий балл","typeQuiz":"Тип опроса"},"ru.random_rotation":{"block_results":{"Correct":"Правильно","Incorrect":"Неправильно","No data":"Немає данних","Prompt":"Підказка"},"forbidden":"У вас немає доступу до даного модулю для даного клієнта"},"ru.registration":{"buttons":{"signup":"Зарегистрироваться"},"congrats":{"first_line":"Регистрация прошла успешно.","second_line":"Вы можете войти используя email и пароль."},"header":"Регистрация","user_types":{"bcba":"Аналитик","independent_curator":"Независимый куратор","supervisor":"Для проведения супервизии"}},"ru.report":{"UB":"НП","add_skill":"Добавить область навыков","address":"620075, Россия, г. Екатеринбург, ул. Малышева, 51, этаж 29, +7 (343) 384-84-81, info@company.com, ИНН 123456789, ОГРН 123456789","all":"Все","all_centre":"Все центры","all_protocol":"Все протоколы","all_skill":"Все области","archive_reports":"Архив отчетов","author":"Автор","average_speed_bids":"Средняя скорость обработки заявок, в днях","bids_all":"Заявки всего","bids_completed":"Заявки обработанные","bids_created":"Заявок создано","bids_new":"Заявки новые","bids_overdue":"Заявки просрочены","blocks":"Блоки дневной сессии","changes_from":"Изменения от","changes_in_protocol":"Изменения в протоколе","changes_in_protocols":"Изменения в протоколах","chart_for_category_daily_pecs":"Количество реакций для категории в каждом блоке дневной сессии","chart_for_daily_pecs":"Количество освоенных последовательностей в каждом блоке дневной сессии","chart_for_perc_daily_pecs":"Доля освоенных последовательностей в каждом блоке дневной сессии","chart_for_percent_axes":"доля освоенных шагов в среде","chart_for_percent_daily":"Доля освоенных шагов в каждом блоке дневной сессии","chart_for_percent_daily_pecs":"доли освоенных последовательностей на шаге","chart_for_percent_daily_pecs2":"доли освоенных последовательностей","chart_for_properties_daily":"Количество предпочитаемых свойств в каждом блоке дневной сессии.","chart_for_properties_percent_daily":"Доля предпочитаемых свойств в каждом блоке дневной сессии.","chart_for_step_axes":"количество шагов на этапе","chart_for_step_daily":"Кол-во освоенных шагов в каждом блоке дневной сессии","chart_for_step_daily_pecs":"количество освоенных последовательностей на шаге","chart_for_step_daily_pecs2":"количество освоенных последовательностей","chart_for_steps_daily":"Количество реакций для шага в каждом блоке дневной сессии.","chart_for_steps_daily_pecs":"Количество реакций для последовательности в каждом блоке дневной сессии","chart_for_stimul_daily":"Количество реакций для стимула в каждом блоке дневной сессии.","chart_percent_axes":"доля освоенных шагов","choose_client":"Выберите клиента из списка","choose_clinic_centre":"Выберите клинический центр","choose_curator":"Выберите куратора","choose_period":"Выберите период","choose_protocol":"Выберите протокол","choose_skill":"Выберите область навыков","choose_therapist":"Выберите тераписта","client":"Клиент","clients":"Клиенты","clients_count":"Количество клиентов","clinic_centre":"Клинический центр","condition_mastered":"Условие освоения стимула","condition_mastered_step":"Условие освоения шага","confidentially":"Конфиденциально","conflict_sessions":"Конфликтные сессии","conflict_sessions_title":"Детальный экран конфликтной сессии","consolidated_efficiency":"Сводный % эффективности","count_stim":"кол-во освоенных стимулов","cumulitive_graph":"Кумулятивный график освоенных стимулов","cumulitive_graph_for_protocol":"Кумулятивный график освоенных стимулов для протокола","cumulitive_graph_pecs":"График отслеживания освоения целевой последовательности на шаге","cumulitive_graph_pecs2":"График отслеживания освоения целевой последовательности","curator":"Куратор","daily_session":"Дневная сессия","data_UB":"Данные о НП","data_appeals":"Данные о просьбах","data_protocol":"Данные о протоколах","data_without_stimuli":"Занятия не проводились","date_generation":"Дата генерации","day_session":"Дневные сессии","delete_report":"Удалить","deleted_user":"удален","description_choose_client":"необходимо выбрать конкретного клиента для построения данного отчёта","description_choose_curator":"если не выбран куратор, отчет будет включать все записи из списка","description_choose_period":"если период не указан, отчет будет включать весь доступный период","description_choose_protocol":"если протокол не выбран, отчет будет построен по всем записям в списке","description_choose_skill":"если область не указана, отчет будет включать все возможные области","description_choose_therapist":"если не выбран терапист, отчет будет включать все записи из списка","description_max_period":"максимальный доступный период 4 месяца","download_pdf":"Скачать в PDF","draw_report":"Построить отчёт","duration":"Общая продолжительность сессий","filters":"Фильтры","footer_sub_title":"Любые и все нарушения преследуются в рамках применяемого законодательства соответствующими инстанциями.","footer_title":"Использование данного документа допускается исключительно при соблюдении Кодекса этики специалиста ПАП доступного по адресу","for_all_protocol":"Для всех протоколов","for_chain":"Для протоколов Цепочка","for_mand":"Для Манд протокола","from":"с","generate":"Сформировать","generate_by":"Сгенерировано с помощью AutismTech www.autismtech.online","generate_csv_version":"Сформировать CSV версию","generate_pdf_version":"Сформировать PDF версию","generate_version":"Сформировать версию","generated_by":"Сгенерировано с помощью AutismTech www.autismtech.online","graph_cumulative_improve":"График кумулятивный :first, :second и :third","graph_efficiency":"График эффективности","graph_goal":"График :first, :second и :third","graph_improve":"График кумулятивный :improve","graph_improve_prompt":"График :improve, отношение проб с :improve к общему кол-ву проб","graph_mand_react":"График частоты спонтанных манд-реакций, в час","graph_mo_goal":"График мотивационного условия для цели манд реакции (CМО - ДА)","graph_mo_yes":"График % проб с МО - Да","graph_mo_yes_percent":"График % первых проб с МО - ДА","graph_probe":"График :first вместе с :second и :third относительно общего кол-ва проб за сессию","graph_prompt_levels":"График уменьшения уровня подсказок","graph_relation_prompt":"График отношения проб с подсказкой + проб с :second с предметом к спонтанным правильным реакциям","header":"Отчеты","himself":"Всего манд-реакций без подсказок (С, С+)","himself_per_hour":"Кол-во манд-реакций в час без подсказки","himself_per_minute":"Кол-во манд-реакций в минуту без подсказки","hours":"Часы","hours_with_client":"Часы с клиентами","info_client":"Данные по клиенту","info_curator":"Данные по куратору","info_curators":"Данные по кураторам","info_therapist":"Данные по тераписту","info_therapists":"Данные по терапистам","introduced":"Введен","label_cumulative_improve":"Кол-во реакций :first, :second и :third","label_goal":"% :first, :second и :third","label_improve":"Кол-во реакций :improve","label_improve_prompt":"%  улучшенных реакций","label_mand_react":"Частота спонтанных реакций","label_mo_goal":"% МО - ДА","label_mo_yes":"% проб с МО - Да","label_mo_yes_percent":"% первых проб с МО - ДА","label_probe":"% :first + :second + :third","label_prompt_levels":"Уровни подсказок","label_relation_prompt":"отношение проб с подсказкой + проб с :second с предметом к спонтанным правильным реакциям","legend":"Условные обозначения:","mastered":"Освоен","min":"мин","name_report":"Название","number_properties_pecs":"количество предпочитаемых свойств","number_step":"количество освоенных шагов цепочки","number_step_pecs":"кол-во последовательностей","number_step_pecs_detail":"кол-во реакций","percent_category":"количество освоенных св-в","percent_count":"Кол-во %","percent_efficiency":"% эффективности","percent_properties_pecs":"доли предпочитаемых свойств","percent_step":"доли освоенных шагов цепочки","percent_step_pecs":"доли последовательностей","percent_step_pecs_detail":"доли реакций","period":"Период","protocol":"Протокол","range_end":"Период по","range_from":"Период с","reaction_count":"Кол-во реакций","report":"Отчет","save_report":"Сохранить отчёт","sec":"сек","sessions_client":"Сессий с родителями","sessions_therapist":"Сессий с терапистом (куратором)","sessions_total":"Сессий всего","show_graph":"Показать графики для цели","show_graph_btn":"Отобразить графики","simple":"Простой СПОУ","skill_domain":"Область навыков","specialist":"Специалист","spontaneous":"Всего спонтанных  манд-реакций (С+)","spontaneous_per_hour":"Кол-во спонтанных манд-реакций в час","spontaneous_per_minute":"Кол-во спонтанных манд-реакций в минуту","start_protocol":"Начните вводить протокол","start_skill":"Начните вводить область навыков","statistics_mand":"Общая статистика манд-реакций","status":{"1":"Формируется","2":"Сформировался","3":"Что-то пошло не так"},"statusCSV":["Формируется","Сформировался","Что-то пошло не так","Нет данных"],"step_count":"Кол-во шагов","stimul":"Стимул","summary_table_requests":"Сводная таблица просьб","table_prompts":"Таблица ввода и освоения стимула","therapist":"Терапист","time_with_client":"Время с родителями","time_with_therapist":"Время с терапистом (куратором)","title":{"about_clients":"Отчёт о вмешательстве","about_curators":"Отчёт о кураторах","about_therapists":"Отчёт о терапистах"},"to":"по","total":"Всего","total_time":"Время всего","with_prompts":"Всего манд-реакций с подсказкой (П)","with_prompts_per_hour":"Кол-во манд-реакций в час с подсказкой","with_prompts_per_minute":"Кол-во манд-реакций в минуту с подсказкой","within_24_hours":"За 24 часа","without_mand":"кроме Манд протокола","write_protocols":"Написано протоколов"},"ru.reset_password":{"forms":{"reset_password":{"bcba_new_pass":"Обратитесь к аналитику за обновленным паролем.","buttons":{"reset":"Изменить пароль"},"congrats":{"first_line":"Пароль успешно изменен.","second_line":"Вы можете войти используя идентификатор и пароль."},"congrats_email":"Запрос на восстановление пароля отправлен Вашему аналитику","congrats_email_bcba":"Система Аутизмтек отправила ссылку на вашу электронную почту. Воспользуйтесь ей для изменения пароля на более запоминающийся и безопасный.","header":"Изменить пароль","sub_header":"Введите ваш идентификатор и новый пароль"},"send_token":{"buttons":{"send_password":"Восстановить"},"header":"Восстановление пароля","sub_header":"Введите ваш идентификатор, который вы используете для входа в систему","success_alert":"Ссылка на сброс пароля была отправлена!"}}},"ru.rotation":{"L":"L","M":"M","P":"P","R":"R","block":"Блок","build_table":"Построить таблицу","cancel":"Отмена","description":"Предметы на столе размещаются по определенной схеме и целевой предмет (тот, о котором спрашивают) - всегда разный.","destroy_table":"Сбросить таблицу","forbidden":"У вас нет доступа к данному модулю для данного клиента","instructions":{"collapse":"Свернуть","expand":"Читать полностью","header":"Инструкции:","text":"Предметы на столе размещаются по определенной схеме и целевой предмет (тот, о котором спрашивают) - всегда разный. Педагогу нужна визуальная подсказка, как сейчас располагаются предметы, о каком нужно спросить и возможность сделать пометку о качестве реакции. 1. Первый экран: введите названия трех стимулов: допустим, кошка (А), мяч(В) и сок (С). 2. Второй и последующий экраны могут выглядеть так (см приложение) В таблице определено 27 строк, дальше просто идет блок 1, то есть это может крутиться по кругу бесконечно. В результате по окончании сета получается таблица процент правильных реакций по стимулам и количество подходов по стимулу, которую (таблицу) можно отправить по почте куда то."},"interactive_module":"Модуль интерактивности","interactive_module_two":"Модуль интерактивности 2","interactive_modules":"Модули интерактивности","next_block":"Следующий блок","no_data":"Нет данных","p":"p","pagination":{"next":"Вперёд","previous":"Назад"},"report":{"all_approaches_count":"Общее количество подходов","auditor":"Специалист проводивший занятие","client":"Клиент","date":"Дата","download_report":"Скачать отчет","fail_answer_rate":"% Неправильных ответов","header":"Отчет о проведенном занятии","hint_rate":"% Подсказок","no_answer_rate":"% Невыполненных подходов","number_of_approaches_for_stimulus":"Количество подходов по стимулу","report":"Отчет","started_at":"Дата и время проведения","stimulus_count":"Количество стимулов","success_rate":"Процент правильных реакций по стимулам","successful_answer_rate":"% Правильных ответов","therapist":"Терапист"},"reports":"Отчёты","result":"Результат","save":"Сохранить","session":"Сессия","show_results":"Показать результаты","start_session":"Начать сессию","stimulus":"Стимул","stimulus_one":"Стимул 1","stimulus_three":"Стимул 3","stimulus_two":"Стимул 2","title":"Автоматизация работы с использованием случайной ротации","unique_stimulus":"Стимулы не должны повторяться","write_names_for_stimulus":"Введите названия для стимулов"},"ru.settings":{"client_price":"Стоимость клиента в системе","currency_unit":"Условная единица измерения валюты","maintenance":"Режим тех обслуживания","maintenance_in":"Допустимые значения: 'on', 'off'","page_not_found":"Страница не нашлась","page_not_found_subscription":"Этой страницы не существует. Возможно, вы захотите вернуться на главную или обратиться в службу поддержки со страницы контактов"},"ru.subscription":{"add_comment":"Добавить комментарий","choose_region":"Выберите ваш регион из списка","comment":"Комментарий к запросу новой подписки","comment_title":"Комментарий","cost":"Стоимость","create_date":"Дата создания","discount":{"value":{"type":{"percent":"%"}}},"duration":"Длительность","duration_days":":value д.","end_date":"Дата окончания","start_date":"Дата начала","status":{"active":"Активная","finished":"Оконченная","inactive":"Неактивная","new":"Новая","under_consideration":"На рассмотрении"},"sub_title":"При оплате подписки сроком на 3 месяца вы получаете скидку 10%, при оплате сроком на 6 месяцев - 20%","subscription_continue":"Продлите подписку или обратитесь в службу поддержки для продолжения измерений.","subscription_expired":"Срок вашей подписки истёк.","subscription_expired_today":"Срок вашей подписки истекает сегодня.","subscription_limited":"Возможность измерений ограничена. Для продолжения измерений продлите подписку в своем профиле или обратитесь в службу поддержки.","subscription_period":"Период подписки","subscription_soon_expired":"Срок вашей подписки истекает через :attribute дней.","title":"Запрос новой подписки"},"ru.upload":{"accept_file_types":"Тип файла не поддерживается","add_file":"Загрузить файл","cancel":"Отменить","delete":"Удалить","failed":"Не удалось загрузить файл","max_file_size":"Файл слишком большой","max_number_of_files":"Достигнуто максимальное количество файлов","min_file_size":"Файл слишком маленький"},"ru.user":{"C":"К","P":"П","T":"Т","active_protocol":"Активные протоколы","add":"Добавить","add_client":"Добавить Клиента","add_client_no_data":"Нет доступных клиентов","add_curator":"Добавить Куратора","add_therapist":"Добавить Тераписта","add_therapist_no_data":"Нет доступных терапистов для этого куратора","attached_therapist_list":"Список закрепленных терапистов","bcba":"Аналитик","bcba_languages":{"en":"Английский","pl":"Польский","ru":"Русский","uk":"Украинский"},"bcba_statuses":{"Active":"Активен","Deactivated":"Деактивирован","Mensuration forbidden":"Возможность измерений ограничена"},"bcba_types":{"BCBA":"Аналитик","Independent curator":"Независимый куратор"},"cancel":"Отмена","choose_client_from_list":"Выберите клиента из списка","choose_therapist_from_list":"Выберите тераписта из списка","client":"Клиент","clientHash":"Хеш клиента","client_code":"Код Клиента","clients":"Клиенты","clinical_center":"Клинический Центр","clinical_center_no_data":"Нет данных","close":"Закрыть","confirm_delete":"Вы подтверждаете удаление?","confirm_delete_client_form_therapist":"Вы уверены, что хотите удалить закрепленного клиента?","confirm_delete_text":"Вы уверены, что хотите удалить закрепленного тераписта?","confirm_delete_title":"Подтвердите удаление","contacts":"Родитель","curator":"Куратор","curator_profile":"Профиль куратора","curators":"Кураторы","dashboard":"Панель Управления","delete":"Удалить","display_name":"Пользователь","edit":"Редактировать","edit_client":"Редактировать Запись Клиента","edit_curator":"Редактировать Запись Куратора","edit_therapist":"Редактировать Запись Тераписта","hours_parent":"Часы с родителями","hours_therapist":"Часы с терапистом","list_attached_clients":"Список прикрепленных Клиентов","no_data":"Нет данных","number":"Номер","parent_email":"Адрес Электронной Почты Родителя","parent_first_name":"Имя Родителя","parent_last_name":"Фамилия Родителя","password":"Пароль","profile_therapist":"Профиль тераписта","request_for_work":"Заявки в работе","request_for_work_overdue":"Заявки в работе/просрочены","save":"Сохранить","start_curator":"Начните вводить имя куратора","start_therapist":"Начните вводить имя тераписта","supervisor":"Супервизор","therapist":"Терапист","therapists":"Тераписты","type_the_client_code_to_search":"Введите код клиента для поиска ...","type_the_client_name_to_search":"Введите имя клиента для поиска ...","type_the_clinical_center_name_to_search":"Введите имя клинического центра для поиска ...","type_the_curator_name_to_search":"Введите имя куратора для поиска ...","type_the_therapist_name_to_search":"Введите имя тераписта для поиска ...","type_the_timezone_to_search":"Введите часовой пояс для поиска ...","update":"Обновить","user":"Пользователь","username":"Идентификатор","users":"Пользователи"},"ru.validation":{"accepted":"Вы должны принять :attribute.","active_url":"Поле :attribute содержит недействительный URL.","after":"В поле :attribute должна быть дата после :date.","after_or_equal":"В поле :attribute должна быть дата после или равняться :date.","alpha":"Поле :attribute может содержать только буквы одного алфавита.","alpha_dash":"Поле :attribute может содержать только буквы одного алфавита, цифры и дефис.","alpha_num":"Поле :attribute может содержать только буквы одного алфавита и цифры.","alpha_spaces":"Поле :attribute может содержать только буквы одного алфавита и пробелы.","array":"Поле :attribute должно быть массивом.","attributes":{"address":"Адрес","analystEmail":"E-mail аналитика","antecedentTypes":"Типовые Антецеденты","assigneeId":"ID Клиента","auditorId":"Аудитор ID","bcbaId":"Идентификатор аналитика","bcba_id":"Аналитик","behaviorTypes":"Типовые Поведения","captcha":"Защитный код","captcha_key":"Ключ для защитного кода","center":"Центр","centerEmail":"E-mail центра","centerName":"Название центра","centerPhone":"Телефон центра","centers":"Центры","certificate":"Сертификат","certificateActionType":"Тип действия с сертификатом","certificateFileName":"Файл сертификата","client_count":"Количество клиентов","comment":"Комментарий","contacts":"Контакты","content":"Контент","created_at":"Дата создания","currentPassword":"Текущий пароль","displayName":"Пользователь","display_name":"Пользователь","effectsTypes":"Типовые Последствия","email":"E-mail","enable":"Статус","enableFalse":"Выкл","enableTrue":"Вкл","file":"Файл","finishedAt":"Время окончания","finished_at":"по","firstName":"Имя","first_name":"Имя","full_name":"Имя и фамилия","goal":"Цель","hash":"Хеш","id":"ID","intervals":"Интервалы","intervals.*.behaviourHappenedAt":"Целевое поведение случилось в","intervals.*.duration":"Длина интервала","intervals.*.index":"Индекс интервала","key":"Ключ","language":"Язык","lastName":"Фамилия","last_name":"Фамилия","legalName":"Юридическое наименование","logo":"Логотип","menu":"Меню","menu_id":"ID Меню","message":"Сообщение","meta_description":"Мета описание","meta_keywords":"Мета ключевые слова","meta_title":"Мета заголовок","name":"Имя","newPassword":"Новый пароль","newPasswordConfirmation":"Подтверждение пароля","new_password":"Новый пароль","old_password":"Текущий пароль","owner":"Владелец","page_slug":"Страница","password":"Пароль","password_confirmation":"Подтверждение пароля","period":"Период","phone":"Телефон","position":"Позиция","protocol":{"applying":"Область","baseLevel":"Базовый уровень","code1":"ABBLS","code2":"VB-MAPP","describe_stage":"Опишите этап","errorCorrection":"Коррекция ошибки","execution":"Выполнение","features":"Особенности","goal":"Цель","hintType":"Вид подсказки","instruction":"Инструкция","max_field_count":"Максимальное кол-во полей","min_field_count":"Минимальное кол-во полей","provideHint":"Предоставление подсказки","reductionHint":"Критерий снижения подсказки","reductionHintMethod":"Метод понижения подсказки","rightReaction":"Верная реакция","risingPrompt":"Критерий повышения подсказки","stage":"Этап","title":"Название протокола"},"published":"Опубликовано","ratingId":"Модуль оценки","region_discount_id":"Тариф","remember_me":"Запомнить меня","report":{"behaviourDescription":"Описание целевого поведения","behaviourTypeId":"Тип поведения","failedIntervalCount":"Количество неудачных интервалов","intervalCount":"Количество интервалов","intervalDurationUnitId":"Единицы измерения интервала","intervalDurationValue":"Время интервала","rightCount":"Количество правильных ответов","sessionDuration":"Длительность сессии","successfulIntervalCount":"Количество успешных интервалов","suggestedCount":"Количество подсказок","totalCount":"Общее количество подходов","uncompletedCount":"Количество незаконченных подходов","wrongCount":"Количество неправильных ответов"},"role":"Роль","sessions":"Сессии","sessions.*.blocks":"Блок","sessions.*.blocks.*.index":"Индекс блока","sessions.*.blocks.*.resultId":"Результат блока","sessions.*.blocks.*.stimuli":"Стимулы","sessions.*.blocks.*.stimuli.*.correct":"Правильный стимул","sessions.*.blocks.*.stimuli.*.name":"Название стимула","sessions.*.blocks.*.stimuli.*.position":"Позиция стимула","sessions.*.index":"Индекс сессии","skillField":"Область навыков","skillFieldName":"Название области навыков","skillRating":"Модуль оценки","skillRatingName":"Название модуля оценки","slug":"Слаг","socialNetwork":"Социальные сети","stage":"Этап","startedAt":"Время начала","started_at":"с","status_id":"Статус","stimuli":"Стимулы","stimuli.*":"Название стимула","subscription_auto_cost":"Рекомендуемая цена","subscription_cost":"Cтоимость подписки","subscription_discount_value":"Величина скидки","subscription_discount_value_type":"Ед. изм. величины скидки","subscription_period":"Период подписки","task":"Стимул","timezone":"Таймзона","title":"Заголовок","updated_at":"Дата обновления","user_counts":"Всего клиентов\\Клиентов с измерениями\\Кураторов\\Терапистов","user_type":"Зарегистрироваться как","username":"Идентификатор","usersCenters":"Центры пользователя","uuid":"UUID","value":"Значение","viewed":"Просмотрено","year":"Год"},"before":"В поле :attribute должна быть дата до :date.","before_or_equal":"В поле :attribute должна быть дата до или равняться :date.","between":{"array":"Количество элементов в поле :attribute должно быть между :min и :max.","file":"Размер файла в поле :attribute должен быть между :min и :max Килобайт(а).","numeric":"Поле :attribute должно быть между :min и :max.","string":"Количество символов в поле :attribute должно быть между :min и :max."},"boolean":"Поле :attribute должно иметь значение логического типа.","confirmed":"Поле :attribute не совпадает с подтверждением.","custom":{"assign_curator_can_analytic":"Назначать кураторов может только аналитик","attribute-name":{"rule-name":"custom-message"},"count_assigned_specialists":"Количество назначенных специалистов должно быть между 2 и 3 элементами","curator_not_have_client":"Назначеный куратор должен иметь тераписта связанного с клиентом","curator_not_have_therapist":"Куратор может назначать только своих терапистов","different_problem_behavior":"Выберите опросники с одинаковыми проблемными поведениями","incorrect_count_answered_specialists":"Выберите специалистов которые прошли опросник","incorrect_count_answers":"Неверное количество ответов на данный опросник","incorrect_count_general_detailed_answers":"Неверное количество общих ответов с пользовательским вводом на данный опросник","incorrect_count_passed_quiz":"Выберите только пройденные опросники клиента авторами которых вы являетесь","incorrect_general_question_answer":"Неверный ответ на общий вопрос","incorrect_quiz_answers":"Неверные ответы для опросника","incorrect_quiz_general_answers":"Неверные общие ответы для опросника","missing_quiz_answers":"Пропущены ответы на вопросы для опросника","not_user_or_curator":"Выбрать можно только тераписта или куратора","select_different_quiz_types":"Выберите различные типы опросников","therapist_not_have_client":"Назначеный терапист должен быть назначен клиенту"},"date":"Поле :attribute не является датой.","date_format":"Поле :attribute не соответствует формату :format.","different":"Поля :attribute и :other должны различаться.","digits":"Длина цифрового поля :attribute должна быть :digits.","digits_between":"Длина цифрового поля :attribute должна быть между :min и :max.","dimensions":"Поле :attribute имеет недопустимые размеры изображения.","distinct":"Поле :attribute содержит повторяющееся значение.","email":"Поле :attribute должно быть действительным электронным адресом.","exists":"Выбранное значение для :attribute некорректно.","file":"Поле :attribute должно быть файлом.","filled":"Поле :attribute обязательно для заполнения.","has_access_to_client":"Этот пользователь не имеет доступа к данному клиенту","has_active_bcba":"Данный пользователь деактивирован","has_selected_item":":attribute должен содержать выбранный элемент.","image":"Поле :attribute должно быть изображением.","in":"Выбранное значение для :attribute ошибочно.","in_array":"Поле :attribute не существует в :other.","incorrect_value":"Некорректное значение","integer":"Поле :attribute должно быть целым числом.","interval":{"max":"Интервал не может превышать :max :unit"},"invalid_credentials":"Учетные данные пользователя некорректны","ip":"Поле :attribute должно быть действительным IP-адресом.","ipv4":"Поле :attribute должно быть действительным IPv4-адресом.","ipv6":"Поле :attribute должно быть действительным IPv6-адресом.","isEmptyError":"Выберите просьбу","is_not_equal_to_actual_db_value":"Значение :attribute должно совпадать с текущим значением в базе данных","json":"Поле :attribute должно быть JSON строкой.","max":{"array":"Количество элементов в поле :attribute не может превышать :max.","file":"Размер файла в поле :attribute не может быть более :max Килобайт(а).","numeric":"Поле :attribute не может быть более :max.","string":"Количество символов в поле :attribute не может превышать :max."},"mimes":"Поле :attribute должно быть файлом одного из следующих типов: :values.","mimetypes":"Поле :attribute должно быть файлом одного из следующих типов: :values.","min":{"array":"Количество элементов в поле :attribute должно быть не менее :min.","file":"Размер файла в поле :attribute должен быть не менее :min Килобайт(а).","numeric":"Поле :attribute должно быть не менее :min.","string":"Количество символов в поле :attribute должно быть не менее :min."},"not_in":"Выбранное значение для :attribute ошибочно.","not_regex":"Выбранный формат для :attribute ошибочный.","number_of_client_exceeded":"Вы достигли лимита клиентов в рамках подписки. Обратитесь к администратору.","numeric":"Поле :attribute должно быть числом.","present":"Поле :attribute должно присутствовать.","regex":":attribute должен содержать символы латинского алфавита, цифры и знаки","required":"Поле :attribute обязательно для заполнения.","required_field":"обязательно для заполнения.","required_if":"Поле :attribute обязательно для заполнения, когда :other равно :value.","required_unless":"Поле :attribute обязательно для заполнения, когда :other не равно :values.","required_with":"Поле :attribute обязательно для заполнения, когда :values указано.","required_with_all":"Поле :attribute обязательно для заполнения, когда :values указано.","required_without":"Поле :attribute обязательно для заполнения, когда :values не указано.","required_without_all":"Поле :attribute обязательно для заполнения, когда ни одно из :values не указано.","same":"Значение :attribute должно совпадать с :other.","size":{"array":"Количество элементов в поле :attribute должно быть равным :size.","file":"Размер файла в поле :attribute должен быть равен :size Килобайт(а).","numeric":"Поле :attribute должно быть равным :size.","string":"Количество символов в поле :attribute должно быть равным :size."},"string":"Поле :attribute должно быть строкой.","timezone":"Поле :attribute должно быть действительным часовым поясом.","unable_activate_expired_subscription":"Невозможно активировать подписку с истекшей датой окончания","unable_activate_future_subscription":"Невозможно активировать подписку с датой начала позже сегодняшнего дня","unique":"Такое значение поля :attribute уже существует.","unique_categories":"Категория с таким именем уже добавлена. Пожалуйста, выберите иное название","unique_client":"Такой клиент уже добавлен","unique_email":"Пользователь с таким :attribute уже зарегистрирован","unique_properties":"Свойство с таким именем уже добавлено.  Пожалуйста, выберите иное название","unique_skill_field":"Такая область уже добавлена","unique_stage":"Этап с таким именем уже добавлен","unique_task":"Такой стимул уже добавлен","uploaded":"Загрузка поля :attribute не удалась.","url":"Поле :attribute имеет ошибочный формат."},"tr.admin":{"action":"İşlem","administrator":"Yönetici","alert":"Uyarı","all":"Tümü","all_methods_if_empty":"tüm metodlar boş ise","avatar":"Profil resmi","back":"Geri","back_to_list":"Listeye dön","batch_delete":"Toplu sil","browse":"Gözat","cancel":"İptal","captcha":"Doğrulama","choose":"Seçin","choose_file":"Dosya seçin","choose_image":"Resim seçin","close":"Kapat","collapse":"Daralt","confirm":"Onayla","create":"Oluştur","created_at":"Oluşturulma tarihi","current_page":"Mevcut sayfa","delete":"Sil","delete_confirm":"Silmek istediğinize emin misiniz?","delete_failed":"Silme hatalı!","delete_succeeded":"Silme başarılı!","deny":"İzin yok","description":"Açıklama","edit":"Düzenle","entries":"kayıtlar","expand":"Genişlet","export":"Dışarı aktar","failed":"Hatalı","filter":"Filtrele","http":{"method":"HTTP metodu","path":"HTTP dizini"},"icon":"İkon","input":"Giriş","list":"Liste","listbox":{"filter_clear":"Tümümnü göster","filter_placeholder":"Filtrele","filtered":"{0} / {1}","text_empty":"Boş liste","text_total":"Toplam {0} kayıt"},"login":"Giriş","login_successful":"Giriş başarılı","logout":"Çıkış","menu":"Menü","more":"Daha","name":"İsim","new":"Yeni","new_folder":"Yeni dizin","online":"Aktif","operation_log":"İşlem kayıtları","order":"Sırala","pagination":{"range":":total kayıt içinden :first den :last e kadar"},"parent_id":"Ebeveyn","parent_select_error":"Üst hata","password":"Parola","password_confirmation":"Parola tekrar","permission":"İzin","permissions":"İzinler","refresh":"Yenile","refresh_succeeded":"Yenileme başarılı!","remember_me":"Beni hatırla","remove":"Kaldır","reset":"Temizle","role":"Rol","roles":"Roller","route":"Rota","save":"Kaydet","save_succeeded":"Kaydetme başarılı!","selected_rows":"Seçilen kayıtlar","setting":"Ayarlar","show":"Göster","size":"Boyut","slug":"Kalıcı link","submit":"Gönder","succeeded":"Başarılı","time":"Zaman","title":"Başlık","update_succeeded":"Güncellemen başarılı!","updated_at":"Güncellenme tarihi","upload":"Yükle","uri":"URL","user_setting":"Kullanıcı ayarları","username":"Kullanıcı adı","view":"Gör"},"uk.admin":{"action":"Опції","administrator":"Адміністратор","alert":"Помилка","all":"Всі","all_methods_if_empty":"Всі методи, якщо не вказано","avatar":"Аватар","back":"Повернутись","back_to_list":"Повернутися до списку","batch_delete":"Пакетне видалення","batch_enable_off":"Вимкнути область навичок","batch_enable_on":"Включіть область навичок","browse":"Выбір файлу","cancel":"Відміна","captcha":"Захисний код (captcha)","choose":"Обрати","choose_file":"Вибір файла","choose_image":"Вибір зображення","close":"Закрити","collapse":"Згорнути","confirm":"Підтвердіть","continue_creating":"Продовжити створення","continue_editing":"Продовжити редагувати","create":"Новий запис","created_at":"Дата створення","current_page":"Поточна сторінка","delete":"Видалити","delete_confirm":"Ви впевнені, що хочете видалити цей запис?","delete_failed":"Помилка при видаленні!","delete_failed_skill_field":"Вы не обрали області для видалення","delete_succeeded":"Успішно видалено!","deny":"Доступ заборонено","description":"Опис","detail":"Детально","details":"Деталі","edit":"Редагувати","enable_off":"Вимкнути","enable_off_confirm_skill_fields":"Ви підтверджуєте вимкнення обраних областей?","enable_off_failed_skill_field":"Вы не обрали області для відключения","enable_on":"Включіть","enable_on_confirm_skill_fields":"Ви підтверджуєте включення обраних областей?","enable_on_failed_skill_field":"Вы не обрали області для включения","entries":"запис","expand":"Розгорнути","export":"Експорт","failed":"Помилка","filter":"Фільтр","http":{"method":"HTTP метод","path":"HTTP шлях"},"icon":"Іконка","input":"Ввід","list":"Список","listbox":{"filter_clear":"Показати все","filter_placeholder":"Фільтр","filtered":"{0} / {1}","text_empty":"Пустий список","text_total":"Всі: {0}"},"login":"Увійти","login_successful":"Авторизація успішна","logout":"Вийти","main":{"header":"Панель управління :appName"},"menu":"Меню","menu_titles":[],"more":"Ще","name":"Им'я","new":"Додати","new_folder":"Нова папка","no":"Нет","online":"Онлайн","operation_log":"Журнал подій","order":"Сортування","pagination":{"range":"Запис с :first до :last з :total"},"parent_id":"Один із батьків","parent_select_error":"Помилка при виборі одного з батьків","password":"Пароль","password_confirmation":"Підтверждення пароля","permission":"Доступ","permissions":"Доступ","refresh":"Поновити","refresh_succeeded":"Успішно оновлено!","remember_me":"Запом'ятати","remove":"Видалити","reset":"Скинути","role":"Роль","roles":"Роль","route":"Шлях","save":"Зберегти","save_succeeded":"Успішно збережено!","search":"Пошук","sections":{"contact_us":{"headers":{"index":"Зворотній зв'язок"}},"menu_items":{"headers":{"create":"Сторінки","edit":"Елементи меню","index":"Меню"}},"menus":{"headers":{"create":"Сторінки","index":"Меню"}},"pages":{"description":" ","headers":{"index":"Сторінки"}},"settings":{"description":"Налаштування системи","headers":{"index":"Налаштування"}},"subscriptions":{"description":" ","headers":{"index":"Підписки","region_discounts":"Тарифи"}},"users":{"chart":{"title":"Динаміка за кількістю проведених сесій по клієнтам даного аналітика за обраний період"},"description":" ","headers":{"centers":"Центри","index":"Аналітики","skillFields":"Область навичок","skillRatings":"Модуль оцінки","statistics":"Статистика","userCenters":"Центри аналітиків"}}},"selected_rows":"Обрані строки","setting":"Налаштування","show":"Показати","size":"Розмір","slug":"Слаг","submit":"Відправити","succeeded":"Завершена","time":"Час","title":"Назва","update_succeeded":"Успішно змінено!","updated_at":"Дата оновлення","upload":"Завантажити","uri":"URI","user_setting":"Налаштування користувача","username":"Логін","view":"Подивитися","yes":"Да"},"uk.android":{"conflict_protocol":"Поточна версія протоколу на пристрої не відповідає останній версії протоколу на сервері. Ви можете зберегти сесію і оновити протокол або продовжити без оновлення протоколу.","language":"Мова","no_connection":"Немає з'єднання","no_data":"Немає даних","settings":"Налаштування","subscription_has_expired":"Термін дії підписки закінчився. Зверніться до адміністратора.","synchronization_in_progress":"Виконується синхронізація","synchronization_warning":"Увага! При синхронізації результати сесій які не були збережені будуть загублені. Продовжити?","synchronize":"Cинхронізувати","unable_to_save_date":"Неможливо зберегти дані"},"uk.appeals":{"R":"П","appeal":"Прохання","appeals":"Прохання","appeals_chart":"Графік прохань за період","appeals_count":"Кількість прохань","appeals_for_period":"Прохання за період","avarage_appeals_perhour":"Середня кількість прохань за годину","buttons":{"addAppeal":"Додати","apply":"Застосувати","cancel":"Відміна","createAppeal":"Записати","saveAppeal":"Зберегти","write_appeal":"Записати прохання"},"date_end":"Дата до","date_start":"Дата від","date_time":"Дата/Час","edit_typical_appeals":"Редагувати типові прохання","edit_typical_appeals_short":"Ред. типові прохання","edit_typical_client_appeals":"Редагувати типові прохання клієнта","maxlength_appeals":"Максимальна кількість прохань: 50","need_choice_appeal":"Оберіть прохання","no_data":"Немає данних","pagination":{"next":"Вперед","previous":"Повернутись"},"range":"Період","recorded":"Записано","total_appeals_perday":"Сумарна кількість різних (різнообразних) прохань за день","type_new_appeal":"Впишіть нове прохання","type_the_appeals_name_to_search":"Введіть назву прохання для пошуку","typical_appeals":"Типові прохання","unique_appeals":"Прохання не повинні повторюватись","write_appeal":"Записати прохання","write_client_appeal":"Записати прохання клієнта"},"uk.auth":{"failed":"Ім'я користувача і пароль не збігаються.","throttle":"Занадто багато спроб входу. Будь ласка, спробуйте ще раз через: seconds секунд."},"uk.behavior":{"UB":"НП","add_ub_environment":"Введіть новий наслідок у середовищі","add_ub_to_report":"Додати до звіту інформацію про НП","aftermath":"Наслідки","aftermath_short":"Наслідок","all_ancedent":"Всі антецеденти","all_option":"Всі опції","all_protocol":"Всі протоколи","all_ub":"Усі НП","all_ub_for_day":"Всі НП за 24 години","ancedent":"Антецедент","average_behavior":"Середня кількість НП за годину","behavior":"Поведінка","buttons":{"add":"Додати","apply":"Застосувати","cancel":"Відмінити","create":"Записати","create_behavior":"Записати НП","save":"Зберегти","show_by_frequency":"Вивести по частоті","show_by_time":"Вивести за датою / часом","typical_behavior":"Типові НП","write_unwanted_behavior":"Записати небажану поведінку"},"date_end":"Дата до","date_start":"Дата від","date_time":"Дата/Час","describe_the_behavior":"Опишіть поведінку","edit_typical_appeals_short":"Ред. типові прохання","edit_typical_behavior":"Ред. типову НП","edit_typical_client_behavior":"Редагувати типову НП клієнта","enter_the_aftermath":"Запишіть наслідки","enter_the_ancedent":"Запишіть антецедент","enter_the_new_aftermath":"Запишіть нові наслідки","enter_the_new_ancedent":"Запишіть новий антецедент","enter_the_new_behavior":"Запишіть нову поведінку","frequency_group_by":"Групувати по","frequency_group_types":{"aftermath":"Наслідкам","ancedent":"Антецеденту","behavior":"Поведінці","undefined":"За датою/часом"},"hours_24":"24 годин","maxlength_aftermath":"Максимальна кількість наслідків: 200","maxlength_ancedent":"Максимальна кількість антецедентів: 200","maxlength_behaviors":"Максимальна кількість поведінок: 200","min":"хв","need_choice_aftermath":"Оберіть наслідки","need_choice_ancedent":"Оберіть антецедент","need_choice_behavior":"Оберіть поведінку","no_data":"Немає данних","pagination":{"next":"Вперед","previous":"Повернутися"},"range":"Період","scatter_plot":"Почасова діаграма запису даних НП","sec":"сек","times":"разы","ub_behavior":"Наслідки в поведінці","ub_environment":"Наслідки в середовищі","ub_for_day":"НП за денну сесію","unique_aftermath":"Наслідки не повинні повторюватись","unique_ancedent":"Антецеденти не повинні повторюватись","unique_behaviors":"Поведінка не повинна повторюватись","unwanted_behavior":"Неприйнятлива поведінка","unwanted_behavior_chart":"Графік неприйнятливої поведінки за період","unwanted_behavior_for_period":"Неприйнятлива поведінка за період","unwanted_behavior_title":"Редагувати типову НП","within":"В рамках","write_unwanted_behavior":"Записати неприйнятливу поведінку","write_unwanted_behavior_short":"Записати НП","you_must_select_at_least_one_antecedent_behavior_and_consequence":"Ви повинні обрати хоча б один антецедент, поведінку і наслідок"},"uk.bids":{"Z":"З","add_comment":"Напишіть свій коментар","appoint_protocol":"Назначити протокол","bid":"Заявка","bids":"Заявки","bids_for_new_protocols":"Заявки на нові протоколи","bids_for_protocols":"Заявки на протоколи","bids_for_protocols_and_modules":"Заявки на протоколи і модулі","buttons":{"appointProtocol":"Призначити протокол","cancel":"Відміна","createProtocol":"Створити протокол","request_new_protocol_or_module":"Запит нового протоколу/модуля інтерактивності","sendRequest":"Відправити заявку","submit_bids_to_curator":"Відправити заявку куратору","submit_for_approval_to_bsba":"Відправити на затвердження аналітику"},"change_date":"Дата внесення змін","choose_a_client":"Оберіть клієнта","client":"Клієнт","clients":"Клієнти","comment":"Коментар","comment_must_be_at_least_n_characters":"Повинен містити не менше ніж :count символів","comments":"Коментарі","create_date":"Дата створення","edit_bid":"Редагування запиту на протокол","enter_client_code_to_search":"Напишіть код клієнта для пошуку","header":"Заявки","initiator":"Ініціатор","no_data":"Немає даних","overdue":"Прострочена","pagination":{"next":"Вперед","previous":"Повернутися"},"parent":"Один із батьків","protocol_goal":"Цілі протоколу","request_new_protocol":"Запит нового протоколу","short_description":"Короткий опис","start_protocol":"Напишіть назву протоколу для пошуку","status":"Статус","statuses":{"Assigned":"Призначено","Being processed by the BCBA":"В роботі у аналітика","Being processed by the curator":"В роботі у куратора","Being processed by the therapist":"В роботі у терапіста","Cancelled":"Відмінена","New":"Нова"},"therapist":"Терапіст","type_the_procol_name_to_search":"Напишіть назву протоколу для пошуку","view_bid":"Перегляд заявки на протокол","write_protocol_goal":"Опишіть цілі протоколу"},"uk.buttons":{"back":"Повернутися","back_to_client":"Повернутися до профілю клієнта","cancel":"Відміна","continue":"Продовжити","edit":"Редагувати","save":"Зберегти","send":"Надіслати"},"uk.contact_us":{"buttons":{"send":"Надіслати"},"congrats":"Дякуємо, ми з Вами зв'яжемось!","errors":{"save_failed":"Не вдалось зберегти повідомлення"},"header":"Зворотній зв'язок","labels":{"captcha":"Захисниий код","email":"Адреса електронної пошти","message":"Повідомлення","name":"Ваше ім'я"}},"uk.dashboard":{"functionalInDevelopment":"Функціонал знаходиться в розробці","labels":{"dashboard":"Панель управління","welcome":"Ви залоговані!"},"library":"Бібліотека","requestHelp":"Запит допомоги","sendComment":"Залишити коментар","writeRequest":"Записати прохання","writeUnwantedBehavior":"Записати НП"},"uk.dro":{"aim_types":{"Absence of target behavior":"Відсутність цільової поведінки","Presence of target behavior":"Наявність цільової поведінки"},"back_to_reports":"Повернутися до звітів","behaviour_absence":"Відсутність цільової поведінки","behaviour_absent":"Цільової поведінки не було!","behaviour_description":"Опис цільової поведінки","behaviour_presence":"Наявність цільової поведінки","behaviour_type":"Тип цільової поведінки","behaviour_type_long":"Довга","behaviour_type_short":"Коротка","behaviour_types":{"Long":"Довга","Short":"Коротка"},"cancel":"Відміна","continue_session":"Продовжити сесію","description":"Суть процедури - заохочується відсутність / наявність цільового поведінки протягом встановленого інтервалу.","dro_module":"Модуль DRO/DRI","duration_units":{"Minutes":"Хвилини","Seconds":"Секунди"},"finish_session":"Завершити сесію","forbidden":"У вас немає доступу до даного модулю для даного клієнта","hold_session":"Провести сесію","instructions":{"collapse":"Згорнути","expand":"Читати повністю","header":"Інструкції:","text":"Суть процедури - заохочується відсутність / наявність цільового поведінки протягом встановленого інтервалу."},"interactive_module":"Модуль інтерактивності","interactive_module_one":"Модуль інтерактивності 1","interactive_modules":"Модулі інтерактивності","interval_duration_units":"Одиниці виміру інтервалу","interval_time_range":"Час інтервалу","interval_time_range_minutes":"Час інтервалу (1-100 хв)","interval_time_range_seconds":"Час інтервалу (1-300 сек)","list":{"absent":"Не було","interval":"Інтервал","interval_suffix":"й","target_behaviour":"Момент цільової поведінки","time":"Час інтервалу"},"min":"хв.","no_data":"Немає даних","pagination":{"next":"Вперед","previous":"Повернутися"},"parameters":"Параметри","report":{"auditor":"Спеціаліст","average_successful_interval_duration":"Середній час успішного інтервала","behaviour_description":"Цільова поведінка","behaviour_type":"Тип поведінки","client":"Клієнт","date":"Дата","download_report":"Скачати звіт","fail_rate":"% Скинутих","failed_interval_count":"Кількість скинутих","header":"Звіт про проведене заняття","header_mobile":"Звіт DRO/DRI","interval_count":"Кількість інтервалів","started_at":"Дата","success_rate":"% Успішних","successful_interval_count":"Кількість успішних"},"reports":"Звіти","restart_timer":"Перезапустити таймер","sec":"сек.","start_session":"Розпочати сесію","subtitle":"Модуль інтерактивності 1.","target_behaviour":"Цільова поведінка","title":"Реаілізація процедури DRO/DRI.","type":"Тип"},"uk.email":{"after_registered":{"body":{"lines":{"first":"Система AutismTech (АутізмТех) вітає вас, :displayName!","second":"Ви успішно зареєстрували нового користувача (:userType)","third":"Для входу, користувач повинен зайти в мобільному додатку (або браузері Chrome, Safari або Firefox на сторінку входу :loginUrl) \n                і ввести Ідентифікатор - :username, Пароль - :password. Поділіться цією інформацією з користувачем і зберігайте облікові дані користувачів в надійному місці."}},"subject":"AutismTech: Успішне поповнення команди втручання"},"after_registration":{"body":{"lines":{"fifth":"Служба підтримки системи не має доступу до даних Вашого облікового запису, тому якщо ви забудете свій пароль, ви зможете відновити його, вибравши \n                «Відновлення пароля» на сторінці входу :loginUrl. Новий пароль буде створений і відправлений автоматично на вказану при реєстрації адресу електронної пошти.","first":"Система AutismTech (АутізмТех) вітає вас, :displayName!","fourth":"2 - Для входу використовуйте Ідентифікатор :username і пароль :password","second":"Тепер ви можете скористатися перевагами системи автоматизації вимірювань і аналізу даних поведінки, пройшовши за посиланням :appUrl \n                в браузері Chrome, Safari або Firefox актуальної версії для налаштування системи. Так само можете це зробити в додатку для вашої мобільної платформи для вимірювань.","sixth":"Вдалих вимірювань!","third":"1 - Перейдіть на сторінку входу за посиланням :loginUrl или запустите ваше мобильное приложение"}},"subject":"Підтвердження реєстрації :appName"},"bcba_account_activated":{"body":{"lines":{"first":"Система AutismTech (АутізмТек) вітає вас, :name!","second":"Вам надано повний доступ до вимірювань поведінки, створення і редагування протоколів втручання, \n                результатів вимірювань і звітів. Також, тепер можливо створення облікових записів для членів команди втручання і представників клієнтів.","third":"Вдалих вимірювань!"}},"subject":"AutismTech: повний доступ до облікового запису аналітика"},"bcba_account_deactivated":{"body":{"lines":{"first":"Вітаємо, :name!","second":"Алгоритми системи відключили можливості вашого облікового запису.","third":"Якщо ви вважаєте, що це помилка, будь ласка, зверніться в службу підтримки: https://autismtech.online/contacts"}},"subject":"AutismTech: обліковий запис аналітика деактивовано"},"bcba_account_mensuration_forbidden":{"body":{"lines":{"first":"Вітаємо, :name!","second":"Алгоритми системи відключили можливості вашого облікового запису. Можливість перегляду результатів вимірів і збереження опису протоколів втручання збережена.","third":"Якщо ви вважаєте, що це помилка, будь ласка, зверніться в службу підтримки: https://autismtech.online/contacts"}},"subject":"AutismTech: можливості вашого облікового запису обмежені"},"csv_report_generated":{"body":{"lines":{"first":"Вітаю, :displayName!","second":"Звіт в CSV за :startDate - :endDate по клієнту :clientCode сформований.","third":"Ви можете завантажити його в секції Звіти > Архів звітів."}},"subject":"CSV звіт сформований"},"layout":{"greeting":{"error":"Упс!","success":"Вітаю!"},"regards":"З повагою,","subcopy":"Якщо у вас виникли проблеми з натисканням  :actionText кнопки, скопіюйте та вставте URL-адресу нижче в свій веб-браузер: [ :actionUrl ]( :actionUrl )"},"new_subscription":{"body":{"lines":{"first":"Вітаю, :name!","second":"В системі був створений новий запит на підписку","third":"Деталі Ви можете переглянути за посиланням :url"}},"subject":"Новий запит на підписку"},"new_subscription_comment_for_admin":{"body":{"lines":{"first":"Вітаю, :name!","fourth":"Деталі Ви можете переглянути за посиланням :url","second":"До підписки :id був доданий новий коментар:","third":"\":comment\""}},"subject":"До підписки  :id був доданий новий коментар"},"new_subscription_comment_for_user":{"body":{"lines":{"first":"Вітаю, :name!","fourth":"Деталі Ви можете переглянути за посиланням :url","second":"До підписки :id був доданий новий коментар:","third":"\":comment\""}},"subject":"До підписки :id був доданий новий коментар"},"pdf_report_generated":{"body":{"lines":{"first":"Вітаю, :displayName!","second":"Звіт в PDF за :startDate - :endDate по клієнту :clientCode сформований.","third":"Ви можете завантажити його в секції Звіти > Архів звітів."}},"subject":"PDF звіт сформований"},"recovery_password":{"body":{"lines":{"first":"Вітаємо, :bcbaDisplayName","fourth":"Поділіться паролем, який Ви встановили для користувача будь-яким зручним для Вас і безпечним способом.","second":"Член вашої команди: username: userDisplayName запросив відновлення пароля.","third":"Ви можете змінити пароль користувача в його профілі."}},"subject":"Запит на відновлення пароля"},"reset_password":{"body":{"lines":{"first":"Ви отримали це повідомлення тому що ми отримали запит на зміну пароля для вашого облікового запису","second":"Зміна пароля","third":"Якщо ви не посилали запит на зміну пароля, просто ігноруйте цей лист."}},"subject":"Зміна пароля"},"subscription_status_active":{"body":{"lines":{"first":"Система AutismTech (АутізмТех) вітає вас, :name!","second":"Вам надано повний доступ до вимірювань поведінки, функцій графічного аналізу зібраних даних і створення звітів про втручання. \n                Для початку, увійдіть в систему зі сторінки: loginUrl, використовуючи ваш ідентифікатор: username і пароль :password","third":"Вдалих вимірювань!"}},"subject":"AutismTech: повний доступ до вимірювань поведінки"},"subscription_status_finished":{"body":{"lines":{"first":"Вітаю, :name!","second":"Термін дії Вашої підписки :id закінчився","third":"Деталі Ви можете переглянути за посиланням :url"}},"subject":"Срок действия Вашей подписки :id истек"},"subscription_status_inactive":{"body":{"lines":{"first":"Система AutismTech (АутізмТек) вітає вас, :name!","fourth":"Якщо це помилка, будь ласка, зверніться в службу підтримки: https://autismtech.online/contacts","second":"Алгоритми системи присвоїли вашії підписці :id статус неактивної.","third":"Чому це сталось? Подивіться за посиланням :url"}},"subject":"AutismTech: Підписка для :id деактивована","title":"Деактивация підписки"},"subscription_status_new":{"body":{"lines":{"first":"Вітаю, :name!","second":"Ваша підписка :id була схвалена адміністратором і буде активована при настанні дати початку дії підписки","third":"Деталі Ви можете переглянути за посиланням :url"}},"subject":"Ваша підписка :id була схвалена адміністратором"}},"uk.errors":{"choose_curator_from_list":"Виберіть  куратора зі списку","choose_therapist_from_list":"Виберіть  терапіста зі списку","create_comment":"Ви не можете створювати коментарі","delete_comment":"Ви не можете видалити цей коментар","edit_comment":"Ви не можете редагувати цей коментар","reset_password":"Не вдалося змінити пароль","save_comment":"Неможливо зберегти коментар","send_token":"Користувач не знайдений","session_expired":"Час вашої сесії минув. Будь ласка авторизуйтесь.","something_wrong":"Щось трапилося.","try_later":"Будь ласка, спробуйте ще раз або зв'яжіться з адміністратором.","view_comments":"Ви не можете переглядати коментарі","view_not_own_notifications":"Ви не можете переглядати чужі нотифікації"},"uk.export":{"reports":{"dro":{"auditor":"Спеціаліст який проводив заняття","average_successful_interval_duration":"Середній час успішного інтервала, хв.","behaviour_description":"Опис цільової поведінки","behaviour_type":"Тип поведінки","client":"Клієнт","fail_rate":"% Скинутих","failed_interval_count":"Кількість скинутих","header":"Звіт про проведене заняття","interval_count":"Кількість інтервалів","not_specified":"Не вказано","started_at":"Дата і час проведення","success_rate":"% Успішних","successful_interval_count":"Кількість успішних"},"random_rotation":{"auditor":"Спеціаліст який проводив заняття","block":"Блок","block_count":"Загальна кількість підходів","client":"Клієнт","fail_rate":"% неправильних відповідей","header":"Звіт про проведене заняття","incomplete_rate":"% невиконаних підходів","prompt_rate":"% підказок","result":"Результат","session":"Сесія","started_at":"Дата і час проведення","stimulus":"Стимул","success_rate":"% правильних відповідей"}}},"uk.home":{"labels":{"documentation":"Документація","forge":"Forge","github":"Github","home":"Головна","laracasts":"Laracasts","loading_message":"Зачекайте, будь ласка, виконується завантаження","loading_message_table":"Зачекайте, будь ласка, таблиця завантажується","news":"Новини"}},"uk.instruction":{"collapse":"Згорнути","default_text":"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu. Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis, ipsum. Sed aliquam ultrices mauris. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Praesent adipiscing. Phasellus ullamcorper ipsum rutrum nunc. Nunc nonummy metus. Vestibulum volutpat pretium libero. Cras id dui. Aenean ut eros et nisl sagittis vestibulum. Nullam nulla eros, ultricies sit amet, nonummy id, imperdiet feugiat, pede. Sed lectus. Donec mollis hendrerit risus. Phasellus nec sem in justo pellentesque facilisis. Etiam imperdiet imperdiet orci. Nunc nec neque. Phasellus leo dolor, tempus non, auctor et, hendrerit quis, nisi. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Maecenas malesuada. Praesent congue erat at massa. Sed cursus turpis vitae tortor. Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Nullam sagittis. Suspendisse pulvinar, augue ac venenatis condimentum, sem libero volutpat nibh, nec pellentesque velit pede quis nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Ut varius tincidunt libero. Phasellus dolor. Maecenas vestibulum mollis","expand":"Читати повністю","header":"Інструкції:"},"uk.ios":{"creating_new_dro_session_confirmation":"При створенні нової сесії не збережені дані DRO / DRI будуть загублені. Створити нову сесію?","download_appeals_for_client":"Завантажити прохання для %client%","download_client_list":"Завантажити список клієнтів","download_dro_sessions_for_client":"Завантажити сесії DRO / DRI для %client%","download_protocols_for_client":"Завантажити протоколи для %client%","download_random_rotation_sessions_for_client":"Завантажити сесії випадкової ротації для %client%","download_typical_undesirable_behaviors_and_appeal_for_client":"Завантажити типові НП і П для %client%","download_undesirable_behaviors_for_client":"Завантажити НП для  %client%","logout_impossible":"Ви не можете вийти з системи до відправки всіх даних на сервер. Будь ласка, встановіть з'єднання з мережі інтернет і спробуйте ще раз.","no_connection":"Відсутнє підключення до інтернету.","synchronize":"Cинхронізувати","synchronize_impossible":"Синхронізація неможлива: немає підключення до мережі Інтернет.","synchronize_on":"Актуально на","upload_appeals":"Надіслати дані прохань","upload_bids":"Надіслати запити на протоколи / модулі інтерактивності","upload_data_to_server":"Надіслати дані на сервер","upload_dro_sessions":"Надіслати дані сесій DRO / DRI","upload_protocols":"Надіслати протоколи","upload_random_rotation_sessions":"Надіслати дані сесій випадкової ротаціїи","upload_typical_undesirable_behaviors_and_appeals":"Надіслати типові НП і П","upload_undesirable_behaviors":"Надіслати НП"},"uk.login":{"buttons":{"login":"Увійти"},"i_consent_to_data_processing":"Я даю згоду на обробку даних","labels":{"forgot":"Відновлення паролю","login":"Вхід","logout":"Вихід"},"unable_to_sign_in":"Неможливо виконати авторизацію"},"uk.pagination":{"next":"Вперед","previous":"Повернутися"},"uk.passwords":{"password":"Пароль повинен бути не менше шести символів і збігатися з підтвердженням.","password_subscription":"Пароль повинен містити 8-16 символів","reset":"Ваш пароль був скинутий!","sent":"Ссилка на скидання пароля была віправлена!","token":"Ошибочный код сброса пароля.","user":"Не вдалося знайти користувача з зазначеним електронною адресою."},"uk.placeholders":{"enter_new_message":"Введіть нове повідомлення"},"uk.profile":{"address":"Адреса","client_count":"Кількість клієнтів","clinic_center":"Клінічні Центри","delete_logo":"Видалити логотип","displayName":"Користувач","download_logo":"Завантажити  логотип центра","edit_clinic_center":"Редагування  клінічного центра","firstName":"Им'я","lastName":"Прізвище","legalName":"Юридична назва / Номер компанії / Номер платника податків","name":"Назва","name_clinic_center":"Назва клінічного центра","other_contact":"Інші контакти","phone":"Телефон","price":"Вартість","profile":"Профіль  Аналітика","settings_task_type":"Налаштування аркуша запису реакцій","status":"Статус","subscriptions":"Підписки","subscriptionsSubtitle":"Дані про поточні та минулі підписки","username":"Ідентифікатор"},"uk.protocol":{"OffPhaseModalTitle":"Ви хочете вимкнути фазу :phaseName.\n Стимули фази :phaseName  не будуть доступні для роботи в рамках цього етапу. \\ n Якщо ви хочете працювати з цими стимулами - перенесіть стимули до іншої фази.","absent":"Відсутнє","active_protocols":"Активні протоколи","addCategory":"Додати категорію","addCheckList":"Прикріплені аркуші запису реакцій","addEnvironment":"Додати середовище","addProperty":"Додати властивость","addStep":"Додати крок","add_a_mand_reaction":"Додати стимул","add_a_stimulus":"Додати стимул","add_interval":"Додати Інтервал","add_level":"Додайте новий рівень підказки","add_minus_spo":"Надіслати “мінуси” в СПН","add_new_protocol":"Призначення нового протоколу","add_new_stimulus":"Додати новий стимул","add_plus_spo":"Надіслати “плюси” в СПН","add_to_set":"Додати стимули до набору","after_one_lesson":"Через одне заняття","after_three_classes":"Через три заняття","after_two_classes":"Через два заняття","all_attempts_past":"Всі проби пройдені для всіх стимулів.","all_field":"Всі поля","all_intervals":"Всі інтервали","all_phases":"Всі фази","all_stage":"Всі етапи","answer_title":"Манд-реакція (обраний  аркуш запису реакцій)","area":"Область","assignDate":"Дата призначення","assimilate_stimulus":"освоєно стимулів: :attribute","attempt":"Проба","attempt_count":"Кількість проб (якщо є)","attempts":"Проби","audial":"Аудіальна","auto_save_version":"Автозбережена версія","available_protocols":"Доступні протоколи","average_percent":"Средний % сам. реакцій","back_to_list":"Повернутися до списку етапів","baseLavel":"Базовий рівень","base_level":"Базовий рівень","bids":"Заявки","bids_for_protocols":"Заявки на протоколи","blocks":"блоках","body_parts":"Частини тіла","buttons":{"add":"Додати","addMandReaction":"Додати стимул","addNewProtocol":"Призначити новий протокол","addProtocol":"Призначити протокол","addStage":"Додати етап","addStimulus":"Додати стимул","addСriterion":"Додати критерій","allow_mensuration":"Дозволити вимірювання","apply_changes_to_protocol":"Застосувати зміни до протоколу","back_to_protocol":"Повернутися до протоколу","cancel":"Скасувати","choose_stimulus":"Заповнити стимулами з обраного етапу","close_protocol":"Завершити протокол","collapse":"Згорнути","conductTherapeuticSession":"Провести терапевтичну сесію","continueTherapeuticSession":"Продовжити терапевтичну сесію","create":"Створити новий протокол","createNotPublish":"Перевести в чернетку","delete":"Видалити","duplicate":"Дублювати","duplicate_stage":"Дублювати етап","edit":"Змінити","editTasks":"Редагувати аркуш запису реакцій","expand":"Читати повністю","export":"Експорт","finishCurrentStage":"Закрити поточний етап","finishEnvironment":"Завершити збір даних у середовищі","finishStage":"Завершити збір даних на етапі","goToExercises":"Перейти до вправ","hideAll":"Згорнути все","leave_session":"Повернутися","newTasks":"Заповнити аркуш запису реакцій","no":"ні","removeMandReaction":"Видалити стимул","removeStage":"Видалити етап","removeStimulus":"Видалити стимул","removeСriterion":"Видалити критерій","results":"Результати","resultsMeasurementsCurrentDay":"Результати вимірювань поточного дня","save":"Зберегти протокол","saveTasks":"Зберегти аркуш запису реакцій","save_and_allow_mensuration":"Зберегти та дозволити вимірювання","save_session":"Зберегти","sendRequest":"Відправити запит","showAll":"Розгорнути все","start_new_session":"Почніть нову сесію","yes":"так"},"category":"категорі","categoryTitle":"Категория:","chain_mastered_chart":"Графік відстеження освоєння ланцюгів в середовищі","chain_step_chart":"Графік відстеження кількості освоєних ланцюгових кроків у середовищі","change_criteria":"Змінити поточний критерій","change_criteria_title":"При зміні поточного критерію, критерії, що відповідають поточному, будуть позначені як неосвоєні","change_criterion_position":"Щоб змінити порядок критеріїв, перемістіть критерії на необхідну позицію у списку критеріїв.","change_date":"Дата внесення змін","change_environment_position":"Щоб змінити порядок середовищ, які не були в роботі, перемістіть середовище у необхідне положення у списку середовищ.","change_mand_reaction_position":"Щоб змінити порядок стимулів, перетягніть стимул на потрібну позицію в списку стимулів.","change_popup_title":"Зберегти зміни в протоколі як","change_stage_position":"Щоб змінити порядок етапів, над якими не працювали, перетягніть етап на необхідну  позицію у списку етапів .","change_step_position":"Щоб змінити порядок кроків, перемістіть крок у необхідне положення у списку кроків","change_stimul_position":"Щоб змінити порядок стимулів, перетягніть стимул на потрібну позицію в списку стимулів .","changes":"Зміни","changesSaved":"Сессия успешно сохранена","changes_date_text":"Увага! Вносити зміни для попередніх сесій можна буде лише з дати останньої зміни в протоколі.","changes_type":"Тип зміни","chart_properties":"Графік долі правильного використання карточок бажаної властивості / предметуу","chart_properties_per_day":"Кількість правильно вікористовуваних властивостей  у кожному блоці денного сеансу.","chart_properties_percent":"Графік відсотку правильного використання карточок бажаних властивостей","chart_properties_percent_per_day":"Долі правильно використовуваних карточок бажаних властивостей у кожному блоці денного сеансу.","check-list":"Аркуш запису реакцій","checkList":"Аркуш запису реакцій","chooseEnvironment":"Выберіть середовище","chooseLevel":"Виберіть рівень","choosePreferred":"Вибір бажаної властивості","chooseStage":"Виберіть етап","choose_chain_stage":"Виберіть середовище для роботи з кроком.","choose_field":"Виберіть поле","choose_interval":"Виберіть інтервал","choose_mand_stage":"Виберіть етап для роботы зі стимулом.","choose_phase":"Виберіть фазу","choose_protocol":"Виберіть протокол зі списку","choose_shaping_stage":"Оберіть середовище для роботы з крітерієм.","choose_stage":"Виберіть етап","choose_step":"Виберіть крок","choose_stimul_chart":"Графік","close_protocol":"Закрити протокол","code1":"ABBLS","code2":"VB-MAPP","color":"Колір","comment":"Коментар","completed_protocols":"Завершені протоколи","completionCriteria":"Критерії завершення","compliance_check":"Перевірка відповідності","condition_mastered":"реакцій протягом","condition_mastered_prop":"Критерій освоєння властивості","condition_mastered_usd":"Умова оволодіння набором стимулів","condition_next":"Умова перенесення набору стимулів на наступний рівень підказки","condition_procent":"% самостійних реакцій протягом  сесії ","condition_return":"Умова повернення набору стимулів на попередній рівень підказки","condition_session":"проб в кожній з них","condition_tranfer":"Критерій освоєння стимулу на полi / фазі","condition_tranfer_maintain":"Критерій освоєння стимулу на полі / підтримці ","condition_tranfer_rotation":"Перевод стимулу на поле","condition_trial":"послідовних  денних сесій, за мінімумом","conductingTherapeuticSession":"Проведення терапевтичної сесії","confirm_change":"Ваші попередні дані будуть видалені ","confirm_close":"Ви підтверджуєте закриття етапу?","confirm_close_all":"Завершення останнього етапу завершить весь протокол. Завершити протокол?","confirm_close_all_env":"Завершення збір даних у останньому середовищі завершить весь протокол. Завершити протокол?","confirm_close_env":"Ви підтверджуєте завершення збору даних у середовищі?","confirm_close_protocol":"Ви підтверджуєте завершення протокола?","confirm_delete":"Увага! Всі проби по стимулу, зібрані в рамках цього протоколу будуть видалені. Якщо ви згодні, натисніть Зберегти.","confirm_delete_category":"Увага! Всі дані проб для категорії, зібрані в межах даного протоколу будуть видалені. Якщо згодні - натисніть Зберегти","confirm_delete_mand":"Увага! Всі проби по стимулу, зібрані в рамках цього протоколу будуть видалені. Якщо ви згодні, натисніть Зберегти.","confirm_delete_property":"Увага! Всі дані проб для властивості, зібрані в межах даного протоколу будуть видалені. Якщо згодні - натисніть Зберегти","confirm_delete_stimulus":"Стимули для поточного етапу будуть замінені?","confirm_save_conflict_session":"Протокол був змінений. Ваші дані будуть записані в конфліктну сесію.","conflict_sessions":"Конфліктні сесії","continue_or_new":"Чи хочете ви продовжити поточну сесію або почати нову?","continue_previous":"Продовжити поточну","copy":"копія","countSamples":"Кількість спроб до досягнення критерію","countSamplesAxes":"кількість проб","count_properties":"Кількість властивостей","count_properties1":"Кількість властивостей 1","count_properties2":"Кількість властивостей 2","count_properties3":"Кількість властивостей 3","count_properties4":"Кількість властивостей 4","count_reaction":"Самостійних реакцій на етапі ","count_stimul":"Стимулів на підтримці ","create_date":"Дата створення","criteria":"Критерії","criteria_end_protocol":"Критерій завершення протоколу","criteria_end_session":"Критерій завершення сесії в поточний день","criteria_end_teaching":"Критерій завершення навчання для одного стимулу","criterion":"Критерій","criterionDirectionSession":"Критерій завершення сесії","criterionLearningStimulus":"Критерій завершення навчання стимулу","criterion_count":"кіл-ть критеріїв у середовищі","criterion_required":"Поле Критерій є обов’язковим для заповнення.","cumulative_category":"Кількість правильно вікористовуваних властивостей для категорії :CategoryName","cumulative_category_relative":"Долі правильно використовуваних карточок бажаних властивостей для категорії :CategoryName","cumulitive_graph":"Кумулятивні графики освоєння","currentEnvironment":"Поточне середовище","currentLevel":"Поточний рівень","currentStage":"Поточний етап","current_criterion":"Поточний критерій","date":"Дата","date_first_session":"Дата першої сесії","date_mastering":"Дата освоєння","day_session":"денних сеансів з мінімум","delay":"затримка  :sec сек","delay_none":"затримка 0 сек","deleteCategory":"Видалити категорію","deleteProperty":"Видалити властивость","delete_criteria_title":"Цей стимул є поточним на одній із стадій. Продовжити видалення?","delete_set":"Ця операція знищить набори. Продовжити?","describeCategory":"Опишіть категорію:number","describeEnvironment":"Опишіть середовище :number","describeImplementation":"Опишіть виконання","describeMandReaction":"Опишіть стимул :number","describeProperty":"Опишіть властивость","describeStage":"Опишіть етап :number","describeStep":"Опишіть крок :number","describeStimulus":"Опишіть стимул :number","describeСriterion":"Опишіть критерій :number","descriptionPart":"Описова частина","description_on_delete":"Після видалення повинен залишатися принаймні один включений критерій","detail_reaction_session":"Детальний графік роботи з реакціями за обрану сесію","detail_shaping_chart":"Детальний графік роботи з реакціями за обрану сесію","detailed_result":"Детальний результат","directory_types":{"Teaching method":"Метод навчання"},"disable":"Відключений","distinctive_properties":"Свойства с различением","dtt_phase_title":"Налаштування фаз етапу протоколу","dtt_title":"Налаштування етапів протоколу DTT","duration":"Тривалість сесії, хв","editProtocol":"Редагувати протокол","editor":"Спеціаліст","enable_recording":"Налаштувати фіксацію правильної, з підказкою і помилкової відповіді","endSession":"Зберегти сесію","end_protocol_date":"Дата закінчення протоколу","end_session_date":"Дата останньої денної сесії","enter_another_session_date":"Введіть іншу дату денного сеансу. Дата денної сесії повинна бути пізніше дати останньої денної сесії. Зібрано останні дані ","enter_session_date":"Введіть іншу дату денного сеансу. Дата денної сесії повинна бути пізніше дати останньої денної сесії. Зібрано останні дані ","entered_session_date":"Введіть дату денного сеансу.","environment":"Середовище","environment_number":"Середовище :count","environments":"Середовище","errorCorrection":"Корекція помилки","errorEnvironmentsCount":"обов’язково потрібне хоча б одне середовище","errorPhaseCount":"Обов’язково включіть хоча б одну фазу","errorResult":"Кількість відібраних стимулів має дорівнювати 3","errorStages":"Обов’язково виберіть  аркуш запису реакцій","errorStagesCount":"Безумовно потрібен хоча б один етап","execution":"Виконання","executionSeconds":"Правильне виконання протягом :time сек","executionSecondsLimit":"Правильне виконання протягом, сек ","exercise":"Вправа","exercises":"Вправи","features":"Особливості","field":"Поле","first_probe":"перших випробувань у кожному з них","fluency":"Побіжність","form":"Форма","from":"з","full_physical":"Повна фізична","full_verbal":"Повна вербальна","gesture":"Жестова","goToSPO":"Перейти до СПН","goal":"Мета","graph_cumulative_improve":"Графік кумулятивний С+, C і П","graph_goal":"Графік С+, C и П","graph_improve":"Графік кумулятивний У+","graph_improve_prompt":"Графік У + для цілі, ставлення проб з У + до загальної кількості проб","graph_improved_spou":"Графік % покращених реакцій","graph_mand_react":"Графік частоти спонтанних манд реакцій, в годину","graph_mo_goal":"Графік МУ для цілі манд реакції (CМО - ТАК)","graph_mo_yes":"Графік % проб з МО - ТАК","graph_mo_yes_percent":"Графік % перших проб з МО - ТАК","graph_probe_full":"Графік C + разом з С і П щодо загальної кількості проб за сесію","graph_prompt_levels":"Графік зменшення рівня підказок","header":"Протокол","himself_percent":"Сам, %","hint_sub_title":"Усього доступно 10 рівнів підказки. Ви можете використовувати ту к-ть рівнів, яка вам необхідна.","hint_type":"Вид підказки","i_want_card":"Переміщення картки “Я хочу”","important":"значні","inessential":"несуттєві","instruction":"Інструкція","interactivity_module":"Модуль інтерактивності","interval":"Інтервал","interval_count":"Кількість повторень ","interval_error":"Мінімум 1 інтервал повинен бути відзначений ","interval_name":"Назва інтервалу","introduced":"Введено","item_card":"Ддавання картки із зображенням  бажаного предмету  на шаблон для речень","items":"Предмети","lastLesson":"Останнє заняття","last_measurement_results":"Результати останніх проведених вимірювань","last_session":"Остання сесія","left":"залишилось","level":"Рівень","levelLine":"Лінія рівня","levelTitle":"Рівень","levels":"Cписок стимулів","listCategories":"Список категорій","list_of_mand_reaction":"Cписок стимулів","list_of_stimulus":"Cписок стимулів","logEndCriteria":"Критерій завершення протоколу","make_criteria_current":"Повернутися до критерія","make_current":"Зробити актуальним","make_first":"Зробити першим","make_last":"Зробити останнім","mand_date":"Дата проби","mand_level":"Рівень прохання (Предметно або Спонтанно)","mand_required":"Поле Стимул обов'язкове для заповнення.","master":"Опанувати","master_criterion":"Опанувати критерій","mastered":"Переведено","mastered_criteretion":"Умова освоєння критерію","mastered_criterion":"Критерій освоєн","mastered_mand":"Освоєно","mastered_stimuli":"Освоєні стимули","mastered_stimulus":"Освоєно","mastering":"Освоєння","mastering vcd":"Освоєння","mastering_btn":"освоєн","mastering_chart":"Графік освоєння протоколу","mastering_chart_phase":"Графік освоєння на фазі","mastering_chart_stage":"Графік освоєння етапу протоколу","mastering_criteria":"Критерії освоєння","mastering_percent":"Освоєння протоколу, %","mastering_table":"Освоєння протоколу","materials":"Матеріали","max_count_for_session":"Загальна максимальна кількість проб по сесії не повинно перевищувати 3000","max_field_count":"Максимальна кількість полів","measured":"Виміряв","measurement_date":"Дата проведення","min_field_count":"Мінімальна кількість полів","minor":"незначні","motivation_condition":"Мотиваційна умова","moveFieldTitle":"Стимули, які знаходяться не на полях від: min до: max будуть переміщені до найближчих доступних полів ","n_sessions_with_n_blocks":":sessionCount сесій з :sessionBlockCount блоков","nameCategoryProperty":"Категорія/Властивость","name_criterion":"Назва критерію","name_mand_reaction":"Назва стимулу","name_step":"Назва кроку","newProtocol":"Новий протокол","next_block":"На рівень","next_criterion":"Перейти до наступного критерію","next_session":"Наступна сесія","next_support":"Перевести на Підтримку","noAvailableTeachingMethod":"Немає доступних методів навчання","no_available_protocols":"Немає доступних протоколів","no_available_set_create":"Немає доступних стимулів для створення набору","no_data":"Немає даних","no_list_category":"Нема категорій, доступних для вивчення","no_list_property":"Нема властивостей, доступних дя вивчення","no_title":"Без назви","nodata":"Немає даних","notPublish":"Чернетка","number_of_trials":"Номер проби","of_protocol":"протокола","offButton":"Вимкнути","once_a_month":"Один раз на місяць","once_a_week":"Один раз на тиждень","once_every_two_weeks":"Один раз на два тижні","one_trial":"Одна проба","pagination":{"next":"Вперед","previous":"Повернутися"},"partial_physical":"Часткова фізична","partial_verbal":"Часткова вербальна","pecs":{"control_of_achievements":"Контроль досягнень.","countSamples":"Кількість проб до досягнення критерию","go_to":"Перейти на","next_probe":"Наступна проба","step_one":"Крок 1","step_three":"Крок 3","step_two":"Крок 2","table_mastered":"Таблиця вводу та освоєння кроку","table_mastered_step":"Таблиця вводу та освоєння цільової послідовності","table_mastered_target_sequence":"Таблиця вводу та освоєння цільової послідовності для кроку","table_mastered_target_sequence_pwd":"Таблиця вводу та освоєння цільової послідовності","target_sequence":{"get_album":"Взяти альбом","get_i_want_card":"Дістати з альбому картку “Я хочу”","get_reinforcement_item_card":"Дістати з альбому картку із зображенням предмета-підкріплення","get_template":"Дістати з альбому шаблон для речень","give_template":"Віддати шаблон для речень Співрозмовнику","put_i_want_card":"Помістити картку “Я хочу” на шаблон для речень","put_reinforcement_item_card":"Помістити цю картку на шаблон для речень","read_sentence":"Читання речення на шаблоні"},"target_sequence_title":"Цільова послідовність","without_discrimination_target_sequence":{"get_album":"Взяти альбом","get_card_desired_item":"Дістати картку бажаного предмета","get_i_want_card":"Дістати з альбому картку “Я хочу”","get_reinforcement_item_card":"Дістати з альбому картку із зображенням предмета-підкріплення","get_target_property_item_card":"Дістати картку із зображенням цільової властивості предмета","get_template":"Дістати з альбому шаблон для речень","give_template":"Віддати шаблон для речень Співрозмовнику","put_card_desired_item":"Помістити картку бажаного предмета на шаблон для речень","put_i_want_card":"Помістити картку “Я хочу” на шаблон для речень","put_reinforcement_item_card":"Помістити цю картку на шаблон для речень","put_target_property_item_card":"Помістити картку із зображенням цільового властивості предмета на шаблон для речень"}},"percent_block":"% самостійних реакцій та натяків на ","percent_next_block":"% самостійних реакцій на ","percent_reaction":"незалежних реакцій протягом","phase":"Фаза","phase_fluency":"Фаза біглості","phase_mastering":"Фаза освоєння","phase_rotation":"Фаза ротації","phase_stimuli":"Стимули на фазах","phase_support":"Фаза підтримки","position":"Місцезнаходження","positional":"Позиційна","prev_block":"Повернути на рівень","probe_by_session":"Проби за сесію","promptType":"Вид підказки","properties_without_discrimination":"Свойства без различения","property":"властивость","propertyTitle":"Властивость","protocol":"Протокол","protocol_dtt":"Протокол DTT ","protocol_goal":"Цілі протоколу","protocol_status":"Статус протоколу","protocols":"Протоколи","providingHint":"Надання підказки","quantity":"Кількість","reactions":"Цілі","reading_sentence":"Читання речення на шаблоні","recommendation":"Рекомендація","recordData":"Запис даних (вид)","recording_method":"Спосіб запису даних","reducingPromp":"Критерій зниження підказки","reducingTooltip":"Метод зниження підказки","reduction_hint_method":"Метод зниження підказки","removeEnvironment":"Видалити середовище","removeStep":"Видалити крок","repeat":"Повторення","requestNewProtocol":"Запит нового протоколу","requests":"Прохання","requiredCheckList":"Аркуш запису реакцій для всіх етапів обов'язковий для заповнення","requiredStepsList":"Список кроків для всіх середовищ  є обов’язковим для заповнення.","requiredStimulList":"Список стимулів для всіх етапів обов'язковий для заповнення","response":"Реакція","responses":"Реакції","result":"Результат","result_assigned_session":"Результати терапевтичної сесії","result_last_assigned_session":"Результати останньої терапевтичної сесії","result_of_protocol":"Зведені дані протоколу","result_of_stage":"Результати етапу","results":"Результати","results_of_stages":"Зведені дані по етапах протоколу","results_of_the_protocol":"Результати протоколу","results_protocol_title":"Графік ефективності етапу","risingPrompt":"Критерій підвищення підказки","rotation":"Ротація","save_session_date":"Дата збереження сесії","save_set":"Вам потрібно зберегти поточні зміни, щоб працювати з набором","scatterLine":"Лінія варіабельності","selectTemplate":"Виберіть шаблон","select_attempt":"Збирати дані на 4 та 5 елементах цільової послідовності","session":"Сесія","set":"Набір","sets":"Набори","setup_distinctive_properties":"Фаза Свойства с различением","setup_fluency":"Налаштування побіжністі","setup_i_want_card":"Фаза Переміщення картки “Я хочу”","setup_item_card":"Фаза Додавання картки із зображенням  бажаного предмету  на шаблон для речень","setup_mastering":"Налаштування освоєння","setup_properties_without_discrimination":"Фаза Свойства без различения","setup_reading_sentence":"Фаза Читання речення на шаблоні","setup_rotation":"Налаштування ротації","setup_stimuli":"Налаштування стимула :title","setup_support":"Налаштування підтримки","shaping_chart":"Оцінка та аналіз змін поведінки у середовищі","shaping_last_session_chart":"Оцінка та аналіз змін поведінки протягом останньої сесії","short_description":"Короткий опис","shortcut_enabled":"Додати в меню швидкого доступу","shortcut_menu_title":"Назва для меню швидкого доступу","showChangeDateSession":"Внести дані попередніх сесій","showGraphsTitle":"Показати графіки у звіті","show_on_environment":"Показувати в середовищі","show_on_level":"Відображати на рівні","show_on_stage":"Показувати на етапі","size":"Розмір","skillField_and_code":"Область або код навичок","speed":"Швидкість","spontaneous_level":"C","stage":"Етап","stage_choose_from":"Рівень (вибір з)","stage_count":"Номер етапу","stage_number":"Этап :count","stage_number_of_stage_count":"Етап :stageNumber з :stageCount","stages":"Етапи","stages_stimuli":"Стимули на етапах","startTraining":"Початок навчання","start_new":"Розпочати нову","start_session_date":"Дата початку сесії","started_at":"Введено","status":"Статус","statuses":{"Active":"В роботі","Completed":"Пройдений","Individualization":"Індивідуалізація","Maintaining":"Підтримка","New":"Новий","supporting":"Підтримка"},"step":"Крок","step_count":"кіл-ть кроків на етапі","step_required":"Поле Крок є обов’язковим для заповнення.","steps":"Кроки","stimul_count":"Всього","stimul_settings":"Для налаштування декількох стимулів, виберіть стимули і натисніть кнопку змінити","stimul_table_header":"Історія руху стимулів з пробами за обраний період","stimuls":"стимула","stimulus":"Стимул","stimulus_count":"стимулів","stimulus_improved_chart":"Графік покращених реакцій для:","stimulus_intervals":"Поставити інтервали повторення стимулу ","stimulus_list_empty":"Немає стимулів для запису в аркуш запису реакцій СПН.","stimulus_mastering_chart":"Графік самостійних реакцій для:","stimulus_name":"Назва стимулу","stimulus_prompt_chart":"Графік зменшення рівня підказок стимулу:","stimulus_required":"Поле Стимул обов'язкове для заповнення.","stimuluses":"Стимули","subjects":"Предмет","support":"Підтримка","support_stimulus":"Стимули на підтримці","support_subtitle":"При увімкненні або вимкненні інтервалів та зміни кількості повторів стимули не будуть автоматично переходити на нові доступні інтервали. Переносити стимули на доступні проміжки часу потрібно вручну.","synthesisStrategy":"Стратегія узагальнення","table_mastered_category":"Таблиця вводу та освоєння категорій на рівнях","table_mastered_category_name":"Таблиця вводу та освоєння категорій:","table_subtitle":"Щоб створити графік, виберіть стимул із таблиці ","taskType":"Запис даних (вид)","task_in_row":"занять поспіль","task_prompts":{"descriptions":{"L1":"рука на кисті","L2":"рука на передпліччі","L3":"рука на локті","L4":"рука на плечі","audio":"аудіальна","full_physical":"повна фізична","full_verbal":"повна вербальна","gestural":"жестова","modeling":"моделінг","partial_physical":"часткова фізична","partial_verbal":"часткова вербальна","positional":"позиційна","textual":"текстова","visual":"візуальна"},"main_description":"Ви можете замінити скорочені назви підказок на назви, які ви використовуєте в роботі.","main_title":"Налаштувати підказки","titles":{"L1":"ЧФ1","L2":"ЧФ2","L3":"ЧФ3","L4":"ЧФ4","audio":"АП","full_physical":"ПФ","full_verbal":"ПВ","gestural":"ЖП","modeling":"МД","partial_physical":"ЧФ","partial_verbal":"ЧВ","positional":"ПП","textual":"ТП","visual":"ВП"}},"task_type":"Тип аркушу запису реакцій","task_types":{"answers":{"+":"+","-":"-","C":"С","C+":"С+","C1":"С","C6":"С","E":"ПМ","E6":"Н","FU":"ПД","L1":"ЧФ1","L2":"ЧФ2","L3":"ЧФ3","L4":"ЧФ4","NM":"НМ","NR":"Н","NR6":"O","P":"П","U":"У","U+":"У+","UG":"ВГ","audio":"АП","descriptions":{"+":"зробив відразу","-":"немає реакції, НП, помилка","C":"сам, фраза «зроби так»","C+":"сам, без предмету","C1":"сам","C6":"сам, з предметом","E":"помилка","E6":"негативна реакція","FU":"повна допомога;","NM":"без мотивації","NR":"немає реакції","NR6":"реакція відсутня","P":"підказка","U":"удосканалена реакція","U+":"удосканалена реакція","UG":"вгадування","no_data":"немає даних"},"full_physical":"ПФ","full_verbal":"ПВ","gestural":"ЖП","modeling":"МД","no_data":"Н/Д","partial_physical":"ЧФ","partial_verbal":"ЧВ","positional":"ПП","textual":"ТП","titles":{"+":"+","-":"-","C":"С","C+":"С+","C1":"C","C6":"C","E":"ПМ","E6":"Н","FU":"ПД","NM":"НМ","NR":"Н","NR6":"Р","P":"П","U":"У","U+":"У+","UG":"ВГ","no_data":"Н/Д"},"visual":"ВП"},"descriptions":{"cold_probes":"Записується тільки перша реакція за день; ставиться відмітка виду «+» (зробив відразу) або «-» (немає реакції, НП, помилка).","cold_probes_major":"Записується тільки перша реакція за день; ставиться відмітка виду «+» (зробив відразу) або «-» (немає реакції, НП, помилка).","cold_probes_settings":"Записується тільки перша реакція за день та ставиться відмітка.","probe_analysis_c_plus_cpfueub":"С + - сам, без вербальної допомоги; С - сам, фраза «зроби так»; П - підказка; ПД - повна допомога; ПМ - помилка (інший рух); Н - НП, відсутність реакції навіть після підказки.","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"С + - самостійна реакція без предмету в полі зору; С - самостійна реакція з предметом в полі зору; У+ - удосканалена реакція, П  - підказка; ВГ - вгадування (scrolling); Р - реакція відсутня; П - підказка; Н - негативна реакція; НМ - без мотивації","probe_analysis_cpe":"С - сам; П - підказка; Н - негативна реакція.","probe_analysis_cpenr":"С - сам; П - підказка; Н - негативна реакція; Б -  без реакції","probe_analysis_cpeu":"С - сам; П - підказка; Н - негативна реакція; У - удосканалена реакція."},"titles":{"cold_probes":"Холодні проби","cold_probes_major":"Холодні проби - розширений","probe_analysis_c_plus_cpfueub":"Аналіз проб (С + СПНБПП)","probe_analysis_c_plus_cu_plus_u_ugnpeno_mo":"Аналіз проб (СС + У + ВгПРНБ)","probe_analysis_cpe":"Аналіз проб (СПН)","probe_analysis_cpenr":"Аналіз проб (СПНБ)","probe_analysis_cpeu":"Аналіз проб (СПОУ)"}},"teachingFormat":"Формат навчання","teachingMethod":"Метод навчання","teaching_methods":{"Chain":"Ланцюжок","DTT":"Метод окремих блоків (DTT)","Desensibilization":"Десенсибілізація","Features with items":"Альтернативна комунікація: властивості з предметами","Mand Vocal":"Манд Вокальний","NET":"NET","Pecs":"Процедура PECS","Pecs Properties Without Discrimination":"Альтернативна комунікація: властивості без розрізнення","Pecs Sentence Structure":"Альтернативна комунікація: структура речення","Pecs With Discrimination":"Альтернативна комунікація: властивості з розрізненням","Random learning":"Випадкове навчання","Reaction forming":"Формування реакцій","Shaping":"Шейпінг","Simple (Chain, Shaping)":"Простий","VCD":"Умовна Дискримінація (УСД)","Десенсибилизация":"Десенсибілізація","Случайное обучение":"Випадкове навчання","Формирование реакцій":"Формування реакцій","Цепочка":"Ланцюжок"},"temperature":"Температура","textual":"Текстова","texture":"Текстура","therapeuticSession":"Терапевтична сесія","through_each_lesson":"На кожному занятті","title":"Назва  протоколу","title_chain":"Ланцюг в середовищі ","title_mand_reaction":"Протокол формування манд-реакцій","to_field":"на поле","to_next_phase":"на наступну фазу","to_prev_phase":"повернутися на попередню фазу","to_rotation":"в ротацію","to_support":"на підтримку","today_support_stimulus":"Стимули сьогодні на підтримці","total_himself":"Разом, сам","total_percent":"% самостійних реакцій","total_percent_graph":"Графік % самостійних реакцій","track_change_level":"Відстежувати рівень зміни підказки ","tracked_change_level":"Відстежувати рівень зміни підказки","tracked_reactions":"Відслідковують реакції","transfer_to_rotation":"Переведено в ротацію","transfer_to_support":"Переведено на підтримку","trendLine":"Лінія тренду","trendLineTitle":"Відображати лінії на графіку","trial_count":"Кіл-ть проб","trial_in_row":"проб поспіль","trueReaction":"Вірна реакція","unable_to_delete_protocol":"Протокол неможливо видалити","unique_criterion":"Критерії не повинні повторюватися","unique_mand":"Стимулы не повинні повторюватися","unique_step":"Кроки не повинні повторюватися","unsaved_changes":"Є незбережені зміни","unwanted_behavior":"Неприйнятлива поведінка","view_auto_save":"подивитися автозбережену версію","visual":"Візуальна","whole_period":"Весь період","withFields":"Показати / приховати поля","with_subject":"П","withoutProperties":"Нема вправ для виконання"},"uk.quiz":{"addToReport":"Додати до звіту","answered":"Відповівший","answersDetail":"0 = ніколи 4 = зазвичай 1 = майже ніколи 5 = майже завжди 2 = рідко 6 = завжди 3 = у половині випадків","answersDetailFast":"0 = ні, 1 = так, 2 = не знаю","assignToClient":"Ким Ви є для клієнта?","assigned":"Призначено","assigned_specialist":"Призначений спеціаліст","backToQuizList":"Повернутися до списку опитувань","chooseQuiz":"Виберіть тип опитування","chooseSpecialist":"Виберіть спеціаліста","client":"Клієнт","completePart2":"Заповніть  Частину II, якщо Ви відповіли «так» 1,2, або 3.  Пропустіть  Частину II, якщо Ви відповіли «ні» на всі три пункти в  Частині I.","completeWith":"Проведено з","countYes":"кількість відповідей «Так»","createQuiz":"Нове опитування","created":"Створено","created_by":"Призначен","dateAndTime":"Запланована дата і час проведення","description":"Опис","editQuiz":"Редагувати опитування","enterNameSpesialist":"Почніть вводити ім’я спеціаліста","errorDelete":"Опитування недоступне для видалення. Це опитування пройдено.","errorEdit":"Опитування недоступне для редагування. Це опитування пройдено.","errorResult":"Кількість відібраних спеціалістів має бути в межах від 2 до 3","errorTargetValue":"Поле цільової поведінки є обов’язковим для заповнення.","fast":{"answers":{"titles":["Ні","Так","Догляд за собою","Навчання","Робота","Інше","Догляд за собою","Навчання навичкам","Дозвілля","Увечері","Приймання їжі","Формування професійних навичок","Коли клієнт нічим не зайнятий"]},"description":"Функціональне сканування визначає фактори, що впливають на проблемну поведінку. \n        Спеціаліст, який проводить опитування, представляє анкету кільком людям, які працюють з пацієнтом. \n        Результати використовуються, щоб допомогти спеціалісту визначити ситуації, що провокують проблемну поведінку \n        та визначити функцію поведінки. Якщо пацієнт має більше ніж один тип проблемної поведінки, заповнити кілька анкет, по одному для кожної поведінки.","general_questions":{"informant_client_relationship":{"questions":{"1":"Ким Ви є для клієнта?","2":"Як давно ви знаєте клієнта?","3":"Як часто ви взаємодієте з клієнтом?","4":"У яких ситуаціях ви взаємодієте з клієнтом?"},"title":"Заповніть інформацію про взаємодію з клієнтом"},"problem_behavior_information":{"answers":{"1":"кожну годину","2":"кожен день","3":"щотижня","4":"кожен місяць","5":"Здоров'я клієнта не наражається на ризик","6":"Поведінка може завдати шкоди здоров'ю клієнта певною мірою","7":"Поведінка може завдати шкоди здоров'ю клієнта в значній мірі"},"questions":{"1":"Дайте назву або коротко опишіть неприйнятливу поведінку","2":"Як часто виникає неприйнятлива поведінка? (щогодини / щодня / щотижня / щомісяця)","3":"Як довго триває така поведінка?","4":"Наскільки поведінка інтенсивна? (виберіть найбільш підходящий варіант)","5":"Опишіть, у яких ситуаціях найчастіше виникає неприйнятлива поведінка (з певними людьми, під час певних занять, у певний час доби тощо):","6":"Опишіть, у яких ситуаціях найменш часто виникає неприйнятлива поведінка (з певними людьми, під час певних занять, у певний час доби тощо):","7":"Опишіть, що відбувається безпосередньо перед тим, як відбувається поведінка? (зміна вчителя, презентація конкретного завдання, вчитель забрав іграшку тощо):","8":"Що відбувається відразу після початку проблемної поведінки? (Учитель змінює урок на гру, дає іграшку, просить не робити щось, тощо):","9":"Що ви робите зараз, щоб виправити свою поведінку?"},"title":"Дайте відповіді на запитання щодо неприйнятливої поведінки"}},"questions":{"titles":{"1":"Неприйнятлива поведінка виникає коли клієнт не отримує достатньо уваги або та людина,\n                    яка з ним працює, приділяє увагу комусь іншому ","2":"Неприйнятлива поведінка виникає, коли клієнт просить щось, що він любить, але йому це не дають","3":"Коли виникає неприйнятлива поведінка, та людина, яка працює з клієнтом, зазвичай намагається\n                    його заспокоїти, даючи те, що пацієнт любить ","4":"Клієнт демоснтрує прийнятну поведінку коли займається улюбленою справою","5":"Клиент зазвичай начинает сопротивляться, когда его просят/требуют сделать какое-либо задание","6":"Клієнт зазвичай починає чинити опір, коли його просять / вимагають зробити якесь завдання","7":"Якщо клієнт демонструє неприйнятливу поведінку під час виконання будь-якої інструкції, йому надається перерва від завдання ","8":"Клієнт демоснтрує прийнятну поведінку коли від нього ніхто нічого не вимагає","9":"Неприйнятлива поведінка виникає навіть тоді, коли клієнт знаходиться один","10":"Неприйнятлива поведінка виникає навіть тоді, коли клієнт займається улюбленою справою","11":"Неприйнятлива поведінка є формою самостімуляції","12":"Імовірність виникнення неприйнятливої поведінки менше, коли у клієнта є можливість займатися сенсорно-стимулюючими заняттями або предметами ","13":"Неприйнятлива поведінка має циклічний характер: вона виникає протягом декількох днів, а потім зникає ","14":"Клієнт схильний до захворювань і алергічних реакцій","15":"Неприйнятлива поведінку виникає найчастіше, коли клієнт хворий","16":"Неприйнятлива поведінка зникає, коли після захворювання клієнт починає відчувати себе краще"}},"result_interpretation":"Та функція, яка отримує максимальну кількість балів, потенційно може становитимуться причиною зворотного сповіщення. \n        Результати функціонального сканування повинні бути доповнені спостереженням і заповненням АВС таблиці. Інтерпретація результатів повинна бути \n        основана на аналізі даних, отриманих у процесі спостереження ","result_table":{"potential_source_of_reinforcement":{"automatic_pain":"Автоматичне підкріплення (Уникнення болі)","automatic_sensory":"Автоматичне підкріплення (Сенсорна стимуляція)","social":"Соціальне підкріплення   (Увага)","social_escape":"Соціальне підкріплення   (Уникнення)","social_specific_activities":"Соціальне підкріплення (доступ до обраних предметів / діяльності)"},"titles":{"items":"Відзначте номер питання з відповіддю «Так»","potential_source_of_reinforcement":"Функція","total":"Кількість питань з відповіддю «Так» в кожному рядку"}},"title":"FAST"},"fastChart":"Зведена діаграма декількох FAST","fastTableTitle":"Таблиця результатів FAST","goToExercise":"Пройти","goToQuiz":"Виконати","ifNoExplain":"Якщо «ні», скільки годин на тижденью?","ifOtherExplain":"Якщо інше, будь-ласка поясніть","ifYesExp":"Якщо «так», будь-ласка поясніть","ifYesExplain":"Якщо «так», скільки годин за день?","information":"Інформація про опитування","masChart":"Зведена діаграма декількох MAS","masTableTitle":"Таблиця результатів MAS","maxCountOfSpesialist":"Обрано максимальну кількість спеціалістів","meanScore":"Середній бал","meanScoreDescription":"(загальний бал ділиться на 4)","motivation_scale":{"answers":{"titles":["Ніколи","Майже ніколи","Рідко","У половині випадків","Зазвичай","Майже завжди","Завжди"]},"description":"Мотиваційна шкала - це опитувальник, який дозволяє швидко визначити функцію проблемної поведінки. \n        За допомогою цієї шкали можна визначити попередні умови, які впливають на значимість наслідків проблемної поведінки (мотиваційні операції), \n        і в яких ця небажана поведінка зазвичай має місце.","general_questions":{"problem_behavior_information":{"questions":{"1":"Визначення цільової поведінки","2":"Коротко опишіть ситуації, в яких виникає небажана поведінка"},"title":"Інформація про поведінку"}},"information":"Шкала мотивації містить 16 запитань, які описують різні ситуації, в яких може виникнути небажана поведінка. \n        Необхідно дати чітке і конкретне визначення цільова поведінка (на приклад, не \" поводиться агресивно \", а \" б'є кулакам по обличчю \") \n        та заповніть анкету по відношенні цього визначення. Якщо у дитини кілька типів небажаної поведінки, дотримуйтесь заповнити окрему анкету для кожного типу поведінки. \n        Бажано, щоб анкета була заповнена принаймні дві людини з найближчого оточення дитини.","questions":{"titles":{"1":"Якщо клієнт залишиться сам, неприйнятлива поведінка буде виникати знову і знову","2":"Неприйнятлива поведінка відбуватиметься, якщо клієнт повинен виконати складне завдання","3":"Неприйнятлива поведінка виникає, коли дорослий розмовляє з кимось іншим","4":"Несприйнятлива поведінка виникає, коли клієнт вимагає мотиваційного предмета, освіти або улюбленої діяльності, але йому відмовляють у його проханні.","5":"Поведінка буде повторюватися раз за разом, коли поруч нікого немає, а також продовжуватиметься деякий час","6":"Поведінка відбуватиметься, якщо клієнта попросять щось зробити","7":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","8":"Поведінка відбуватиметься, коли ви відберете улюблений предмет, їжу або перервете улюблене заняття клієнта","9":"Клієнт отримує задоволення від неприйнятливої поведінки","10":"Коли ви доручаєте клієнту виконати завдання, він демонструє свою неприйнятливу поведінку, щоб уникнути завдання.","11":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","12":"Поведінка закінчується, коли ви надаєте клієнту доступ до улюбленого предмета, їжі чи заняття","13":"Коли поведінка виникає, створюється враження, що клієнт не помічає, де він знаходиться і що відбувається навколо нього.","14":"Поведінка закінчується, як тільки ви перестаєте доручати клієнту виконати певне завдання.","15":"Поведінка виникає, щоб привернути вашу увагу","16":"Поведінка виникає, коли ви говорите, що клієнт не може щось зробити або отримати (наприклад, мотиваційний предмет)"}},"result_interpretation":"Функція, яка отримала максимальну кількість балів,  потенційно може бути причиною появи поведінки. \n        Результати мотиваційної шкали повинні доповнюватися спостереженням та заповненням таблиці AVS. \n        Інтерпретація результатів повинна базуватися на аналізі даних, отриманих у ході спостереження та остаточних результатів анкетування.","result_table":{"results":{"mean_score":"Середній бал","relative_ranking":"Відносний розподіл","total_score":"Загальний бал"},"titles":{"attention":"Увага","escape":"Уникнення","sensory":"Сенсорна","tangible":"Доступ"}},"title":"MAS"},"oneFastChart":"Діаграма FAST","oneMasChart":"Діаграма MAS","passed_at":"Дата та час проходження","pdfReport":"Звіт у форматі PDF","pdfReportTitle":"Звіт про опитування","question_answers":"Відповіді на запитання","question_titles":{"create_titles":{"fast":{"evaluator_information":{"questions":{"1":"Як давно ви знаєте клієнта?","2":"Ви взаємодієте з клієнтом щодня?","3":"В яких ситуаціях ви спостерігаєте за клієнтом? Відзначте всі відповідні ситуації"},"title":"Дані про джерело інформації про клієнта"},"nonsocial_reinforcement":{"questions":{"19":"Цільова поведінка спостерігається часто, якщо клієнт знаходиться на самоті або не зайнятий продуктивною діяльністю.","20":"Поведінка спостерігається з відносно високою частотою незалежно від поточної діяльності або того, що відбувається в середовищі.","21":"Здається, що у клієнта мало відомих підкріплень або рідко демонструє прийнятні реакції маніпуляції предметами.","22":"Клієнт зазвичай не реагує на соціальну взаємодію","23":"Клієнт часто демонструє повторювану, стереотипну поведінку, таку як: розгойдування тіла, помахи руками або рухи пальцями, кручення предметів, їх розгризання і т.д.","24":"Коли клієнт демонструє цільову поведінку, Ви і інші люди зазвичай ніяк не реагуєте (наприклад, Ви ніколи або рідко звертаєте увагу на цільову поведінку)","25":"Цільова поведінка спостерігається в циклах. Під час циклу високої ймовірності цільового поведінки, вона спостерігається часто і її складно перервати. Під час циклу з низькою ймовірністю, цільова поведінка демонструється рідко","26":"Цільова поведінка проявляється частіше при хворобі клієнта.","27":"У клієнта є історія повторюваних хвороб (наприклад, інфекції носоглотки, алергії, дерматити і т.д.)."},"title":"Частина III. Автоматичне підкріплення"},"social_influences_on_behavior":{"questions":{"1":"Поведінка зазвичай відбувається у вашій присутності або в присутності інших осіб","2":" Поведінка зазвичай відбувається після взаємодії з клієнтом, наприклад, після надання інструкції або несхвалення, відходу від клієнта (ігнорування), припинення доступу до улюбленого предмету, вимоги зміни виду діяльності, розмови з кимось ще в присутності клієнта і т.д.","3":"Поведінка часто супроводжується \"емоційними\" реакціями, такими як крики або сльози"},"title":"Частина I. Соціальні наслідки поведінки"},"social_reinforcement":{"questions":{"4":"Поведінка часто спостерігається, коли клієнт не отримав уваги.","5":"При виникненні поведінки, ви або інші люди реагуєте взаємодією з клієнтом будь-яким чином (використовуєте фрази які тішать, блокуєте або перенаправляє реакцію, використовуєте засуджуючі фрази і т.д.) ","6":"Клієнт часто демонструє інші дратівливі види поведінки, які викликають привернення уваги.","7":"Клієнт часто наближається до Вас або інших людей і ініціює соціальну взаємодію.","8":"Поведінка рідко спостерігається, якщо клієнт отримує багато уваги.","9":"Поведінка часто спостерігається, якщо ви припиняєте доступ клієнта до якого-небудь предмету або улюбленого виду діяльності.","10":"Поведінка часто спостерігається, коли Ви повідомляєте клієнту про неможливість отримати доступ до певного предмету або виду діяльності.","11":"При спостереженні поведінки, Ви часто реагуєте тим, що надаєте клієнту доступ до певного предмету, улюбленої їжі або іншого предмету.","12":"Клієнт часто демонструє іншу небажану поведінку, в результаті якої отримує доступ до обраних предметів або видам діяльності.","13":"Поведінка рідко спостерігається під час навчальної діяльності або коли ви пред'являєте інші вимоги до клієнта. Якщо так, вкажіть види діяльності:","14":"Поведінка часто спостерігається під час навчальної діяльності або при наданні інструкції виконати якесь завдання.","15":"Часто клієнт не демонструє поведінку, сумісну з навчальною діяльністю або виконанням інструкцій.","16":"Цільова поведінка часто спостерігається в шумному середовищі або в присутності великої кількості людей.","17":"Коли ви спостерігаєте цільову поведінкау, Ви часто реагуєте наданням клієнтові короткої перерви у виконанні поточної інструкції.","18":"Цільова поведінка часто спостерігається в ситуаціях, коли ви пред'являєте клієнту мало вимог або залишаєте його на самоті."},"title":"Частина II. Соціальні підкріплення"}},"motivation_scale":{"main_questions":{"questions":{"1":"Якщо клієнт залишиться сам, неприйнятлива поведінка буде виникати знову і знову","2":"Неприйнятлива поведінка відбуватиметься, якщо клієнт повинен виконати складне завдання","3":"Неприйнятлива поведінка виникає, коли дорослий розмовляє з кимось іншим","4":"Несприйнятлива поведінка виникає, коли клієнт вимагає мотиваційного предмета, освіти або улюбленої діяльності, але йому відмовляють у його проханні.","5":"Поведінка буде повторюватися раз за разом, коли поруч нікого немає, а також продовжуватиметься деякий час","6":"Поведінка відбуватиметься, якщо клієнта попросять щось зробити","7":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","8":"Поведінка відбуватиметься, коли ви відберете улюблений предмет, їжу або перервете улюблене заняття клієнта","9":"Клієнт отримує задоволення від неприйнятливої поведінки","10":"Коли ви доручаєте клієнту виконати завдання, він демонструє свою неприйнятливу поведінку, щоб уникнути завдання.","11":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","12":"Поведінка закінчується, коли ви надаєте клієнту доступ до улюбленого предмета, їжі чи заняття","13":"Коли поведінка виникає, створюється враження, що клієнт не помічає, де він знаходиться і що відбувається навколо нього.","14":"Поведінка закінчується, як тільки ви перестаєте доручати клієнту виконати певне завдання.","15":"Поведінка виникає, щоб привернути вашу увагу","16":"Поведінка виникає, коли ви говорите, що клієнт не може щось зробити або отримати (наприклад, мотиваційний предмет)"}},"problem_behavior_information":{"questions":{"1":"Визначення цільової поведінки","2":"Коротко опишіть ситуації, в яких виникає небажана поведінка"},"title":"Інформація про поведінку"}}},"show_titles":{"fast":{"evaluator_information":{"questions":{"1":"Як давно ви знаєте клієнта?","2":"Ви взаємодієте з клієнтом щодня?","3":"В яких ситуаціях ви спостерігаєте за клієнтом? Відзначте всі відповідні ситуації"},"title":"Частина I. Дані про джерело інформації про клієнта"},"nonsocial_reinforcement":{"questions":{"19":"Цільова поведінка спостерігається часто, якщо клієнт знаходиться на самоті або не зайнятий продуктивною діяльністю.","20":"Поведінка спостерігається з відносно високою частотою незалежно від поточної діяльності або того, що відбувається в середовищі.","21":"Здається, що у клієнта мало відомих підкріплень або рідко демонструє прийнятні реакції маніпуляції предметами.","22":"Клієнт зазвичай не реагує на соціальну взаємодію","23":"Клієнт часто демонструє повторювану, стереотипну поведінку, таку як: розгойдування тіла, помахи руками або рухи пальцями, кручення предметів, їх розгризання і т.д.","24":"Коли клієнт демонструє цільову поведінку, Ви і інші люди зазвичай ніяк не реагуєте (наприклад, Ви ніколи або рідко звертаєте увагу на цільову поведінку)","25":"Цільова поведінка спостерігається в циклах. Під час циклу високої ймовірності цільового поведінки, вона спостерігається часто і її складно перервати. \n                        Під час циклу з низькою ймовірністю, цільова поведінка демонструється рідко","26":"Цільова поведінка проявляється частіше при хворобі клієнта","27":"У клієнта є історія повторюваних хвороб (наприклад, інфекції носоглотки, алергії, дерматити і т.д.)"},"title":"Частина III. Автоматичне підкріплення"},"social_influences_on_behavior":{"questions":{"1":"Поведінка зазвичай відбувається у вашій присутності або в присутності інших осіб.","2":"Поведінка зазвичай відбувається після взаємодії з клієнтом, наприклад, після надання інструкції або несхвалення, відходу від клієнта (ігнорування), припинення доступу до улюбленого предмету, вимоги зміни виду діяльності, розмови з кимось ще в присутності клієнта і т.д.","3":"Поведінка часто супроводжується \"емоційними\" реакціями, такими як крики або сльози"},"title":"Соціальні наслідки поведінки"},"social_reinforcement":{"questions":{"4":"Поведінка часто спостерігається, коли клієнт не отримав уваги.","5":"При виникненні поведінки, ви або інші люди реагуєте взаємодією з клієнтом будь-яким чином (використовуєте фрази які тішать, блокуєте або перенаправляє реакцію, використовуєте засуджуючі фрази і т.д.) ","6":"Клієнт часто демонструє інші дратівливі види поведінки, які викликають привернення уваги.","7":"Клієнт часто наближається до Вас або інших людей і ініціює соціальну взаємодію.","8":"Поведінка рідко спостерігається, якщо клієнт отримує багато уваги.","9":"Поведінка часто спостерігається, якщо ви припиняєте доступ клієнта до якого-небудь предмету або улюбленого виду діяльності.","10":"Поведінка часто спостерігається, коли Ви повідомляєте клієнту про неможливість отримати доступ до певного предмету або виду діяльності.","11":"При спостереженні поведінки, Ви часто реагуєте тим, що надаєте клієнту доступ до певного предмету, улюбленої їжі або іншого предмету.","12":"Клієнт часто демонструє іншу небажану поведінку, в результаті якої отримує доступ до обраних предметів або видам діяльності.","13":"Поведінка рідко спостерігається під час навчальної діяльності або коли ви пред'являєте інші вимоги до клієнта. Якщо так, вкажіть види діяльності:","14":"Поведінка часто спостерігається під час навчальної діяльності або при наданні інструкції виконати якесь завдання.","15":"Часто клієнт не демонструє поведінку, сумісну з навчальною діяльністю або виконанням інструкцій.","16":"Цільова поведінка часто спостерігається в шумному середовищі або в присутності великої кількості людей.","17":"Коли ви спостерігаєте цільову поведінкау, Ви часто реагуєте наданням клієнтові короткої перерви у виконанні поточної інструкції.","18":"Цільова поведінка часто спостерігається в ситуаціях, коли ви пред'являєте клієнту мало вимог або залишаєте його на самоті."},"title":"Частина II. Соціальні підкріплення"}},"motivation_scale":{"main_questions":{"questions":{"1":"Якщо клієнт залишиться сам, неприйнятлива поведінка буде виникати знову і знову","2":"Неприйнятлива поведінка відбуватиметься, якщо клієнт повинен виконати складне завдання","3":"Неприйнятлива поведінка виникає, коли дорослий розмовляє з кимось іншим","4":"Несприйнятлива поведінка виникає, коли клієнт вимагає мотиваційного предмета, освіти або улюбленої діяльності, але йому відмовляють у його проханні.","5":"Поведінка буде повторюватися раз за разом, коли поруч нікого немає, а також продовжуватиметься деякий час","6":"Поведінка відбуватиметься, якщо клієнта попросять щось зробити","7":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","8":"Поведінка відбуватиметься, коли ви відберете улюблений предмет, їжу або перервете улюблене заняття клієнта","9":"Клієнт отримує задоволення від неприйнятливої поведінки","10":"Коли ви доручаєте клієнту виконати завдання, він демонструє свою неприйнятливу поведінку, щоб уникнути завдання.","11":"Поведінка відбуватиметься, якщо перестати звертати увагу на клієнта","12":"Поведінка закінчується, коли ви надаєте клієнту доступ до улюбленого предмета, їжі чи заняття","13":"Коли поведінка виникає, створюється враження, що клієнт не помічає, де він знаходиться і що відбувається навколо нього.","14":"Поведінка закінчується, як тільки ви перестаєте доручати клієнту виконати певне завдання.","15":"Поведінка виникає, щоб привернути вашу увагу","16":"Поведінка виникає, коли ви говорите, що клієнт не може щось зробити або отримати (наприклад, мотиваційний предмет)"}}}}},"quiz":"Скринінг НП","quizComplete":"Проведено","quizTitle":"Структуровані співбесіди і інструменти функціональної оцінки","relativeRanking":"Відносний розподіл ймовірності змінної","relativeRankingDescription":"(від більшої до меншої)","removedUser":"Спеціаліст видалений","reportTitle":"Структуровані співбесіди і інструменти функціональної оцінки","result_interpretation":"Інтерпретація результату","saveQuiz":"Створити опитування","scheduled_at":"Дата призначення","show":"Показати","take":"Виконати","targetBahaviour":"Цільова поведінка","totalScore":"Загальний бал","typeQuiz":"Тип опитування"},"uk.random_rotation":{"block_results":{"Correct":"Правильно","Incorrect":"Неправильно","No data":"Немає даних","Prompt":"Підказка"},"forbidden":"У вас нет доступа к данному модулю для данного клиента"},"uk.registration":{"buttons":{"signup":"Зареєструватись"},"congrats":{"first_line":"Реєстрація пройшла успішно.","second_line":"Ви можете увійти використовуючи електронну пошту і пароль."},"header":"Реєстрація","user_types":{"bcba":"Аналітик","independent_curator":"Незалежний куратор","supervisor":"Для проведення супервізії"}},"uk.report":{"UB":"НП","add_skill":"Додайте область навичок","address":"620075, Росія, Єкатеринбург, вул. Малишева, 51, поверх 29, +7 (343) 384-84-81, info@company.com, ІНН 123456789, OGRN 123456789","all":"Всі","all_centre":"Всі центри","all_protocol":"Всі протоколи","all_skill":"Всі області","archive_reports":"Архів звітів","author":"Автор","average_speed_bids":"Середня швидкість обробки заявок, в днях","bids_all":"Заявки всього","bids_completed":"Заявки оброблені","bids_created":"Заявок створено","bids_new":"Заявки нові","bids_overdue":"Заявки прострочені","blocks":"Блоки денної сесії","changes_from":"Зміни від","changes_in_protocol":"Зміни в протоколі","changes_in_protocols":"Зміни в протоколах","chart_for_category_daily_pecs":"Кількість реакцій для категорії в кожнобу блоці денної сесії","chart_for_daily_pecs":"Кількість опанованих послідовностей в кожному блоці денної сесії","chart_for_perc_daily_pecs":"Доля опанованих послідовностей в кожному блоці денної сесії","chart_for_percent_axes":"частки освоєних кроків  в середовищі","chart_for_percent_daily":"Частка освоєних кроків у кожному блоці денної сесії","chart_for_percent_daily_pecs":"долі опанованих послідовностей для кроку","chart_for_percent_daily_pecs2":"долі опанованих послідовностей","chart_for_properties_daily":"Кількість бажаних властивостей у кожному блоці денної сесії.","chart_for_properties_percent_daily":"Долі бажаних властивостей у кожному блоці денної сесії.","chart_for_step_axes":"кількість кроків на етапі","chart_for_step_daily":"Кількість освоєних кроків у кожному блоці денної сесії","chart_for_step_daily_pecs":"кількість опанованих послідовностей для кроку","chart_for_step_daily_pecs2":"кількість опанованих послідовностей","chart_for_steps_daily":"Кількість реакцій для кроку у кожному блоці денної сесії.","chart_for_steps_daily_pecs":"Кількість реакцій для послідовності в кожному блоці денної сесії","chart_for_stimul_daily":"Кількість реакцій для стимулу у кожному блоці денного сеансу.","chart_percent_axes":"частки освоєних кроків","choose_client":"Виберіть клієнта зі списку","choose_clinic_centre":"Виберіть  клінічний Центр","choose_curator":"Виберіть куратора","choose_period":"Оберіть період","choose_protocol":"Виберіть протокол","choose_skill":"Виберіть область навичок","choose_therapist":"Виберіть терапіста","client":"Клієнт","clients":"Клієнти","clients_count":"Кількість клієнтів","clinic_centre":"Клінічний Центр","condition_mastered":"Умова оволодіння стимулом","condition_mastered_step":"Умова освоєння кроку","confidentially":"Конфіденційно","conflict_sessions":"Конфліктні сесії","conflict_sessions_title":"Детальный екран конфліктної сесії","consolidated_efficiency":"Зведений % ефективності","count_stim":"кількість освоєних стимулів","cumulitive_graph":"Кумулятивний графік освоєних стимулів","cumulitive_graph_for_protocol":"Кумулятивний графік освоєних стимулів для протоколу","cumulitive_graph_pecs":"Графік відстеження опанування цільової послідовності для кроку","cumulitive_graph_pecs2":"Графік відстеження опанування цільової послідовності","curator":"Куратор","daily_session":"Денна сессія","data_UB":"Дані про НП","data_appeals":"Дані про прохання","data_protocol":"Дані про протоколи","data_without_stimuli":"Заняття не проводились","date_generation":"Дата генерації","day_session":"Денні сесії","delete_report":"Видалити","deleted_user":"видален","description_choose_client":"необхідно вибрати конкретного клієнта для побудови даного звіту","description_choose_curator":"якщо куратор не обраний, звіт буде включати всі записи зі списку","description_choose_period":"якщо період не вказано, звіт буде включати весь доступний період","description_choose_protocol":"якщо протокол не обраний, звіт буде включати всі записи зі списку","description_choose_skill":"якщо область не вказано, звіт буде включати всі доступні області","description_choose_therapist":"якщо терапіст не обраний, звіт буде включати всі записи зі списку","description_max_period":"максимальний доступний період 4 місяці","download_pdf":"Скачати в PDF","draw_report":"Побудувати звіт","duration":"Загальна тривалість сесій","filters":"Фільтри","footer_sub_title":"Будь-які та всі порушення або злочинні діяння переслідуються чинним законодавством.","footer_title":"Використання даного документу допускається лише при дотриманні Кодексу етики Фахівеця з ПАП, яикй доступний за адресою ","for_all_protocol":"Для всіх протоколів","for_chain":"Для протоколів Ланцюжок","for_mand":"Для протоколу Манд","from":"з","generate":"Сформувати","generate_by":"Згенеровано за допомогою AutismTech www.autismtech.online","generate_csv_version":"Сформувати версію CSV","generate_pdf_version":"Сформувати версію PDF","generate_version":"Сформувати версію","generated_by":"Згенеровано за допомогою AutismTech www.autismtech.online","graph_cumulative_improve":"Кумулятивний графік :first, :second і :third","graph_efficiency":"Графік ефективності","graph_goal":"Графік :first, :second і :third","graph_improve":"Кумулятивний графік :improve","graph_improve_prompt":"Графік :improve, відносини проб з :improve до загальної кількості проб","graph_mand_react":"Графік частоти спонтанних манд реакцій, в год","graph_mo_goal":"Графік МУ для цілі манд реакції (CМО - ТАК)","graph_mo_yes":"Графік % проб з МО - ТАК","graph_mo_yes_percent":"Графік % перших проб з МО - ТАК","graph_probe":"Графік :first разом з  :second і :third щодо загальної кількості проб за сесію","graph_prompt_levels":"Графік зменшення рівня підказок","graph_relation_prompt":"Графік відносини проб з підказкою + проб з :second з предметом до спонтанних правильних реакцій","header":"Звіти","himself":"Всього манд-реакцій без підказок (С, С +)","himself_per_hour":"Кількість манд-реакцій без підказки в годину","himself_per_minute":"Кількість манд-реакцій в хвилину без підказки","hours":"Години","hours_with_client":"Годин з клієнтами, год","info_client":"Дані по клієнту","info_curator":"Дані по куратору","info_curators":"Дані по кураторам","info_therapist":"Дані по терапісту","info_therapists":"Дані по терапістам","introduced":"Введено","label_cumulative_improve":"Кількість реакцій :first, :second и :third","label_goal":"% :first, :second и :third","label_improve":"Кількість реакцій :improve","label_improve_prompt":"% покращених реакцій","label_mand_react":"Частота спонтанних реакцій","label_mo_goal":"% МО - ТАК","label_mo_yes":"% проб з МО - ТАК","label_mo_yes_percent":"% перших проб з МО - ТАК","label_probe":"% :first + :second + :third","label_prompt_levels":"Рівні підказок","label_relation_prompt":"відносини проб з підказкою + проб з :second з предметом до спонтанних правильних реакцій","legend":"Умовні позначки:","mastered":"освоєно","min":"хв","name_report":"Назва","number_properties_pecs":"кількість бажаних властивостей","number_step":"кількість освоєних ланцюгових кроків","number_step_pecs":"кількість послідовностей","number_step_pecs_detail":"кількість реакцій","percent_category":"кількість засвоєних властивостей","percent_count":"Кількість %","percent_efficiency":"% ефективності","percent_properties_pecs":"долі бажаних властивостей","percent_step":"частки освоєних кроків ланцюга","percent_step_pecs":"долі послідовностей","percent_step_pecs_detail":"долі реакцій","period":"Період ","protocol":"Протокол","range_end":"Період до","range_from":"Період з","reaction_count":"Кількість реакцій","report":"Звіт","save_report":"Зберегти звіт","sec":"сек","sessions_client":"Сесій з батьками","sessions_therapist":"Сесій з терапістом (куратором)","sessions_total":"Сесій всього","show_graph":"Показати графіки для цілей","show_graph_btn":"Відобразити графіки","simple":"Простий СПНУ","skill_domain":"Область навичок","specialist":"Спеціаліст","spontaneous":"Всього спонтанних манд-реакції (С +)","spontaneous_per_hour":"Кількість спонтанних манд-реакцій в годину","spontaneous_per_minute":"Кількість спонтанних манд-реакцій в хвилину","start_protocol":"Почніть вводити протокол","start_skill":"Почніть вводити область навичок","statistics_mand":"Загальна статистика манд-реакцій","status":{"1":"Формується","2":"Сформировался","3":"Что-то пошло не так"},"statusCSV":["Формується","Сформировался","Что-то пошло не так","Немає даних"],"step_count":"Кількість кроків","stimul":"Стимул","summary_table_requests":"Зведена таблиця прохань","table_prompts":"Таблиця вводу та освоєння стимулу","therapist":"Терапіст","time_with_client":"Час з батьками, год","time_with_therapist":"Час з терапістом (куратором), год","title":{"about_clients":"Звіт про втручання","about_curators":"Звіт про кураторів","about_therapists":"Звіт про терапістів"},"to":"до","total":"Всього","total_time":"Всього часу, год","with_prompts":"Всього манд-реакцій з підказкою (П)","with_prompts_per_hour":"Кількість спонтанних манд-реакцій з підказкою в годину","with_prompts_per_minute":"Кількість манд-реакцій в хвилину з підказкою","within_24_hours":"За 24 години","without_mand":"окрім Манд протокола","write_protocols":"Написано протоколів"},"uk.reset_password":{"forms":{"reset_password":{"bcba_new_pass":"Зверніться до аналітика за оновленим паролем.","buttons":{"reset":"Змінити пароль"},"congrats":{"first_line":"Пароль успішно змінений.","second_line":"Ви можете увійти використовуючи ідентифікатор і пароль."},"congrats_email":"Запит на  відновлення паролю відправлено Вашому аналітику","congrats_email_bcba":"Система Аутізмтек відправила посилання на вашу електронну пошту. Скористайтеся ним для зміни пароля на той, який буде більш запам'ятовуватися і яикй буде більш безпечний.","header":"Змінити пароль","sub_header":"Введіть ваш ідентифікатор який вказали при реєстрації і новий пароль"},"send_token":{"buttons":{"send_password":"Відновити"},"header":"Відновлення паролю","sub_header":"Введіть ідентифікатор який вказали при реєстрації","success_alert":"Посилання на скидання паролю було відправлено!!"}}},"uk.rotation":{"L":"L","M":"M","P":"P","R":"R","block":"Блок","build_table":"Побудувати таблицю","cancel":"Відміна","description":"Предмети на столі розміщуються за певною схемою і цільовий предмет (той, про який запитують) - завжди різний.","destroy_table":"Скинути таблицю","forbidden":"У вас немає доступу до даного модулю для даного клієнта","instructions":{"collapse":"Згорнути","expand":"Читати повністю","header":"Інструкції:","text":"Предмети на столі розміщуються за певною схемою і цільовий предмет (той, про який запитують) - завжди різний. Педагогу потрібна візуальна підказка, як зараз розташовуються предмети, про які потрібно запитати і можливість зробити позначку про якість реакції. 1. Перший екран: введіть назви трьох стимулів: припустимо, кішка (А), м'яч (В) і сік (С). 2. Другий і наступний екрани можуть виглядати так (див додаток) У таблиці визначено 27 рядків, далі просто йде блок 1, тобто це може крутитися по колу нескінченно. В результаті після закінчення сету виходить таблиця відсоток правильних реакцій за стимулами і кількість підходів по стимулу, яку (таблицю) можна відправити поштою."},"interactive_module":"Модуль інтерактивності","interactive_module_two":"Модуль інтерактивності 2","interactive_modules":"Модулі інтерактивності","next_block":"Наступний блок","no_data":"Немає даних","p":"p","pagination":{"next":"Вперед","previous":"Повернутися"},"report":{"all_approaches_count":"Загальна кількість підходів","auditor":"Спеціаліст який проводив заняття","client":"Клієнт","date":"Дата","download_report":"Скачати звіт","fail_answer_rate":"% Неправильних відповідей","header":"Звіт про проведене заняття","hint_rate":"% Підказок","no_answer_rate":"% Невиконаних підходів","number_of_approaches_for_stimulus":"Кількість підходів за стимулом","report":"Звіт","started_at":"Дата і час проведення","stimulus_count":"Кількість стимулів","success_rate":"Процент правильних реакцій за стимулами","successful_answer_rate":"% Правильних відповідей","therapist":"Терапіст"},"reports":"Звіти","result":"Результат","save":"Зберегти","session":"Сесія","show_results":"Показати результати","start_session":"Розпочати сесію","stimulus":"Стимул","stimulus_one":"Стимул 1","stimulus_three":"Стимул 3","stimulus_two":"Стимул 2","title":"Автоматизація роботи з використанням випадкової ротації","unique_stimulus":"Стимули не повинні повторюватись","write_names_for_stimulus":"Введіть назви для стимулів"},"uk.settings":{"client_price":"Вартість клієнта в системі","currency_unit":"Умовна одиниця виміру валюти","maintenance":"Режим тех обслуживания","maintenance_in":"Допустимые значения: 'on', 'off'","page_not_found":"Сторінку не знайдено","page_not_found_subscription":"Ця сторінка не існує. Можливо, ви захочете повернутися на головну сторінку або зв’яжіться зі службою підтримки зі сторінки контактів "},"uk.subscription":{"add_comment":"Додати коментар","choose_region":"Выберите ваш регион из списка","comment":"Комментарий к запросу новой подписки","comment_title":"Коментар","cost":"Вартість","create_date":"Дата створення","discount":{"value":{"type":{"percent":"%"}}},"duration":"Тривалість","duration_days":":value д.","end_date":"Дата закінчення","start_date":"Дата початку","status":{"active":"Активна","finished":"Закінчена","inactive":"Неактивна","new":"Нова","under_consideration":"На рассмотрении"},"sub_title":"При оплате подписки сроком на 3 месяца вы получаете скидку 10%, при оплате сроком на 6 месяцев - 20%","subscription_continue":"Продлите подписку или обратитесь в службу поддержки для продолжения измерений.","subscription_expired":"Термін дії підписки закінчився. Зверніться до адміністратора.","subscription_expired_today":"Термін дії підписки закінчується сьогодні.","subscription_limited":"Можливість вимірювань обмежена. Для продолжения измерений продлите подписку в своем профиле или обратитесь в службу поддержки.","subscription_period":"Період підписки","subscription_soon_expired":"Термін дії підписки закінчується через :attribute днів.","title":"Запит нової передплати"},"uk.upload":{"accept_file_types":"Тип файлу не підтримується","add_file":"Завантажити файл","cancel":"Скасувати","delete":"Вилучити","failed":"Не вдалося завантажити файл","max_file_size":"Файл занадто великий","max_number_of_files":"Досягнуто максимальну кількість файлів","min_file_size":"Файл занадто маленький"},"uk.user":{"C":"К","P":"П","T":"Т","active_protocol":"Активні протоколи","add":"Додати","add_client":"Додати Клієнта","add_client_no_data":"Немає доступних клієнтів","add_curator":"Додати Куратора","add_therapist":"Додати Терапіста","add_therapist_no_data":"Немає доступних терапістів для цього куратора","attached_therapist_list":"Список закріплених терапістів","bcba":"Аналітик","bcba_languages":{"en":"Англійська","pl":"Польська","ru":"Російська","uk":"Українська"},"bcba_statuses":{"Active":"Активний","Deactivated":"Деактивовано","Mensuration forbidden":"Можливість вимірювань обмежена"},"bcba_types":{"BCBA":"Аналітик","Independent curator":"Независимый куратор"},"cancel":"Відміна","choose_client_from_list":"Оберіть клієнта зі списку","choose_therapist_from_list":"Оберіть терапіста зі списку","client":"Клієнт","clientHash":"Хеш клієнта","client_code":"Код Клієнта","clients":"Клієнти","clinical_center":"Клінічний Центр","clinical_center_no_data":"Немає даних","close":"Закрити","confirm_delete":"Ви підтверджуєте видалення?","confirm_delete_client_form_therapist":"Ви впевнені, що хочете видалити закріпленого клієнта?","confirm_delete_text":"Ви впевнені, що хочете видалити закріпленого терапіста?","confirm_delete_title":"Підтвердіть видалення","contacts":"Один із батьків","curator":"Куратор","curator_profile":"Профіль куратора","curators":"Куратори","dashboard":"Панель управління","delete":"Видалити","display_name":"Користувач","edit":"Редагувати","edit_client":"Редагувати Запис Клієнта","edit_curator":"Редагувати Запис Куратора","edit_therapist":"Редагувати Запис Терапіста","hours_parent":"Години з батьками","hours_therapist":"Години з терапістом","list_attached_clients":"Список прикріплених Клієнтів","no_data":"Немає даних","number":"Номер","parent_email":"Адреса Електронної Пошти одного із батьків","parent_first_name":"Ім'я одного із батьків","parent_last_name":"Прізвище одного із батьків","password":"Пароль","profile_therapist":"Профіль тераписта","request_for_work":"Заявки в роботі","request_for_work_overdue":"Заявки в роботі / прострочені","save":"Зберегти","start_curator":"Почніть вводити ім'я куратора","start_therapist":"Почніть вводити ім'я терапіста","supervisor":"Супервізор","therapist":"Терапіст","therapists":"Терапісти","type_the_client_code_to_search":"Введіть код клієнта для пошуку ...","type_the_client_name_to_search":"Введіть ім'я клієнта для пошуку ...","type_the_clinical_center_name_to_search":"Введіть ім'я клінічного центру для пошуку ...","type_the_curator_name_to_search":"Введіть ім'я куратора для пошуку ...","type_the_therapist_name_to_search":"Введіть ім'я терапіста для пошуку ...","type_the_timezone_to_search":"Введіть часовий пояс для пошуку ...","update":"Поновити","user":"Користувач","username":"Ідентифікатор","users":"Користувачі"},"uk.validation":{"accepted":"Ви повинні прийняти  :attribute.","active_url":"Поле :attribute містить недійсний  URL.","after":"В поле :attribute повинна бути дата після :date.","after_or_equal":"В поле :attribute повинна бути дата після або дорівнювати :date.","alpha":"Поле :attribute може містити тільки літери одного алфавіту.","alpha_dash":"Поле :attribute може містити тільки літери одного алфавіту, цифри і дефіс.","alpha_num":"Поле :attribute може містити тільки літери одного алфавіту і цифри.","alpha_spaces":"Поле :attribute може містити тільки літери одного алфавіту і пробіли.","array":"Поле :attribute має бути масивом.","attributes":{"address":"Адреса","analystEmail":"E-mail аналітика","antecedentTypes":"Типові Антецеденти","assigneeId":"ID Клієнта","auditorId":"Аудитор ID","bcbaId":"Ідентифікатор аналітика","bcba_id":"Аналітик","behaviorTypes":"Типові Поведінки","captcha":"Захисний код (captcha)","captcha_key":"Ключ для захисного коду","center":"Центр","centerEmail":"E-mail центру","centerName":"Назва центру","centerPhone":"Телефон центру","centers":"Центри","certificate":"Сертифікат","certificateActionType":"Тип дії з сертифікатом","certificateFileName":"Файл сертифіката","client_count":"Кількість клієнтів","comment":"Коментар","contacts":"Контакти","content":"Контент","created_at":"Дата створення","currentPassword":"Поточний пароль","displayName":"Користувач","display_name":"Користувач","effectsTypes":"Типові Наслідки","email":"E-mail","enable":"Статус","enableFalse":"Викл","enableTrue":"Вкл","file":"Файл","finishedAt":"Час закінчення","finished_at":"до","firstName":"Им'я","first_name":"Им'я","full_name":"Им'я и прізвище","goal":"Мета","hash":"Хеш","id":"ID","intervals":"Інтервали","intervals.*.behaviourHappenedAt":"Цільова поведінка сталася в","intervals.*.duration":"Довжина інтервалу","intervals.*.index":"Індекс інтервалу","key":"Ключ","language":"Мова","lastName":"Прізвище","last_name":"Прізвище","legalName":"Юридична назва","logo":"Логотип","menu":"Меню","menu_id":"ID Меню","message":"Повідомлення","meta_description":"Мета опис","meta_keywords":"Мета ключові слова","meta_title":"Мета заголовок","name":"Им'я","newPassword":"Новий пароль","newPasswordConfirmation":"Підтвердження пароля","new_password":"Новий пароль","old_password":"Поточний пароль","owner":"Власник","page_slug":"Сторінка","password":"Пароль","password_confirmation":"Підтвердження пароля","period":"Період","phone":"Телефон","position":"Позиція","protocol":{"applying":"Область","baseLevel":"Базовий рівень","code1":"ABBLS","code2":"VB-MAPP","describe_stage":"Опишіть етап","errorCorrection":"Корекція помилки","execution":"Виконання","features":"Особливості","goal":"Мета","hintType":"Вид підказки","instruction":"Інструкція","max_field_count":"Максимальна кількість полів","min_field_count":"Мінімальна кількість полів","provideHint":"Надання підказки","reductionHint":"Критерій зниження підказки","reductionHintMethod":"Метод зниження підказки","rightReaction":"Вірна реакція","risingPrompt":"Критерій підвищення підказки","stage":"Етап","title":"Назва протоколу"},"published":"Опубліковано","ratingId":"Модуль оцінки","region_discount_id":"Тариф","remember_me":"Запам'ятати мене","report":{"behaviourDescription":"Опис цільової поведінки","behaviourTypeId":"Тип поведінки","failedIntervalCount":"Кількість невдалих інтервалів","intervalCount":"Кількість інтервалів","intervalDurationUnitId":"Одиниці виміру інтервалу","intervalDurationValue":"Час інтервалу","rightCount":"Кількість правильних відповідей","sessionDuration":"Тривалість сесії","successfulIntervalCount":"Кількість успішних інтервалів","suggestedCount":"Кількість підказок","totalCount":"Загальна кількість підходів","uncompletedCount":"Кількість незавершених підходів","wrongCount":"Кількість неправильних відповідей"},"role":"Роль","sessions":"Сесії","sessions.*.blocks":"Блок","sessions.*.blocks.*.index":"Індекс блоку","sessions.*.blocks.*.resultId":"Результат блоку","sessions.*.blocks.*.stimuli":"Стимули","sessions.*.blocks.*.stimuli.*.correct":"Правильний стимул","sessions.*.blocks.*.stimuli.*.name":"Назва стимулу","sessions.*.blocks.*.stimuli.*.position":"Позиція стимулу","sessions.*.index":"Індекс сесії","skillField":"Область навичок","skillFieldName":"Назва області навичок","skillRating":"Модуль оценки","skillRatingName":"Назва модуля оцінки","slug":"Слаг","socialNetwork":"Соціальні мережі","stage":"Етап","startedAt":"Час початку","started_at":"з","status_id":"Статус","stimuli":"Стимули","stimuli.*":"Назва стимулу","subscription_auto_cost":"Рекомендована ціна","subscription_cost":"Вартість підписки","subscription_discount_value":"Величина знижки","subscription_discount_value_type":"Од. вим. величини знижки","subscription_period":"Період підписки","task":"Стимул","timezone":"Часовий пояс","title":"Заголовок","updated_at":"Дата оновлення","user_counts":"Всього клієнтів \\ Клієнтів з вимірами \\ Кураторів \\ терапістів","user_type":"Зареєструватися як","username":"Ідентифікатор","usersCenters":"Центри користувачая","uuid":"UUID","value":"Значення","viewed":"Переглянуто","year":"Рік"},"before":"В поле :attribute повинна бути дата до :date.","before_or_equal":"В поле :attribute повинна бути дата до або дорівнювати :date.","between":{"array":"Кількість елементів в поле :attribute має бути між :min і :max.","file":"Розмір файлу в поле :attribute повинен бути між :min і :max Кілобайтів (а).","numeric":"Поле :attribute має бути між :min и :max.","string":"Кількість символів в поле :attribute має бути між :min і :max."},"boolean":"Поле :attribute повинно мати значення логічного типу.","confirmed":"Поле :attribute не збігається з підтвердженням.","custom":{"assign_curator_can_analytic":"Призначати кураторів може тільки аналітик","attribute-name":{"rule-name":"custom-message"},"count_assigned_specialists":"Кількість призначених фахівців має бути між 2 і 3 елементами","curator_not_have_client":"Призначенний куратор повинен мати терапіста пов'язаного з клієнтом","curator_not_have_therapist":"Куратор може призначати тільки своїх терапистів","different_problem_behavior":"Вибиріть інструменти скринінгу з однаковою цільовою невідповідною поведінкою","incorrect_count_answered_specialists":"Виберіть фахівців, які завершили скринінговий інструмент","incorrect_count_answers":"Неправильна кількість відповідей у цьому інструменті скринінгу","incorrect_count_general_detailed_answers":"Неправильна кількість відповідей із текстовими полями для поточного інструменту перевірки","incorrect_count_passed_quiz":"Вибирайте лише завершені інструменти скринінгу, які ви створили для клієнта","incorrect_general_question_answer":"Неправильна відповідь на загальне питання","incorrect_quiz_answers":"Неправильні відповіді для інструменту скринінгу","incorrect_quiz_general_answers":"Неправильні загальні відповіді для інструменту скринінгу","missing_quiz_answers":"На одне або кілька запитань скринінгового інструменту відсутні відповіді","not_user_or_curator":"Вибрати можна тільки терапіста або куратора","select_different_quiz_types":"Вибиріть різні типи скринінгових інструментів","therapist_not_have_client":"Призначенний терапіст повинен бути призначений клієнту"},"date":"Поле :attribute не є датою.","date_format":"Поле :attribute не відповідає формату :format.","different":"Поля :attribute і :other повинні відрізнятися.","digits":"Довжина цифрового поля :attribute повинна бути :digits.","digits_between":"Довжина цифрового поля :attribute повинна бути між :min і :max.","dimensions":"Поле :attribute має неприпустимі розміри зображення.","distinct":"Поле :attribute містить повторюване значення.","email":"Поле: attribute має бути дійсною електронною адресою.","exists":"Вибране значення для :attribute некоректне.","file":"Поле: attribute має бути файлом.","filled":"Поле :attribute є обов’язковим для заповнення","has_access_to_client":"Цей користувач не має доступу до даного клієнта","has_active_bcba":"Даного користувача деактивовано","has_selected_item":":аttribute повинен містити обраний елемент.","image":"Поле :attribute має бути зображенням.","in":"Вибране значення для :attribute помилкове.","in_array":"Поле :attribute не існує в :other.","incorrect_value":"Некоректне значення","integer":"Поле :attribute має бути цілим числом.","interval":{"max":"Інтервал не може перевищувати :max :unit"},"invalid_credentials":"Облікові дані користувача некоректні","ip":"Поле :attribute має бути дійсною IP-адресою.","ipv4":"Поле :attribute має бути дійсною IPv4-адресою.","ipv6":"Поле :attribute має бути дійсною IPv6-адресою.","isEmptyError":"Виберіть прохання","is_not_equal_to_actual_db_value":"Значення :attribute має збігатися з поточним значенням в базі даних","json":"Поле :attribute має бути JSON рядком.","max":{"array":"Кількість елементів в полі :attribute не може перевищувати :max.","file":"Розмір файлу в полі :attribute не може бути більше :max Кілобайтів (а).","numeric":"Поле :attribute не може бути більше :max.","string":"Кількість символів в полі :attribute не може перевищувати :max."},"mimes":"Поле :attribute має бути файлом одного з наступних типів: :values.","mimetypes":"Поле :attribute має бути файлом одного з наступних типів: :values.","min":{"array":"Кількість елементів в полі :attribute має бути не менше :min.","file":"Розмір файлу в полі :attribute повинен бути не менше :min Кілобайтів (а).","numeric":"Поле :attribute має бути не менше :min.","string":"Кількість символів в полі :attribute має бути не менше :min."},"not_in":"Вибране значення для :attribute помилкове.","not_regex":"Обраний формат для :attribute помилковий.","number_of_client_exceeded":"Ви досягли ліміту клієнтів в рамках підписки. Зверніться до адміністратору.","numeric":"Поле :attribute має бути числом.","present":"Поле :attribute має бути присутнім.","regex":":аttribute повинен містити символи латинського алфавіту, цифри і знаки","required":"Поле :attribute  обов'язково для заповнення.","required_field":" обов'язково для заповнення.","required_if":"Поле :attribute обов'язково для заповнення, коли :other дорівнює :value.","required_unless":"Поле :attribute обов'язково для заповнення, коли :other не дорівнює :values.","required_with":"Поле :attribute обов'язково для заповнення, коли :values вказано.","required_with_all":"Поле :attribute обов'язково для заповнення, коли :values вказано.","required_without":"Поле :attribute обов'язково для заповнення, коли :values не вказано.","required_without_all":"Поле :attribute обов'язково для заповнення, коли жоден з :values не вказано.","same":"Значення :attribute має збігатися з :other.","size":{"array":"Кількість елементів в полі :attribute має бути рівним :size.","file":"Розмір файлу в полі :attribute має дорівнювати :size Кілобайтів (а).","numeric":"Поле :attribute має бути рівним :size.","string":"Кількість символів в полі :attribute має бути рівним :size."},"string":"Поле :attribute має бути рядком.","timezone":"Поле :attribute має бути дійсним часовим поясом.","unable_activate_expired_subscription":"Неможливо активувати підписку з вичерпаною датою закінчення","unable_activate_future_subscription":"Неможливо активувати підписку з датою початку пізніше сьогоднішнього дня","unique":"Таке значення поля :attribute вже існує.","unique_categories":"Категорія з такою назвою вже існує. Будь ласка, оберіть іншу назву","unique_client":"Такий клієнт вже доданий","unique_email":"Користувач з таким: attribute вже зареєстрований.","unique_properties":"Властивість з такою назвою вже додана. Будь ласка, оберіть іншу назву","unique_skill_field":"Така область вже додана","unique_stage":"Етап з таким ім'ям вже доданий.","unique_task":"Такий стимул вже доданий.","uploaded":"Завантаження поля :attribute не вдалася.","url":"Поле :attribute має хибний формат."},"zh-CN.admin":{"action":"操作","administrator":"管理员","alert":"注意","all":"全部","all_methods_if_empty":"为空默认为所有方法","avatar":"头像","back":"返回","back_to_list":"返回列表","batch_delete":"批量删除","browse":"浏览","cancel":"取消","captcha":"验证码","choose":"选择","choose_file":"选择文件","choose_image":"选择图片","close":"关闭","collapse":"收起","confirm":"确认","create":"创建","created_at":"创建时间","current_page":"当前页","delete":"删除","delete_confirm":"确认删除?","delete_failed":"删除失败 !","delete_succeeded":"删除成功 !","deny":"无权访问","description":"简介","edit":"编辑","entries":"条","expand":"展开","export":"导出","failed":"失败","filter":"筛选","http":{"method":"HTTP方法","path":"HTTP路径"},"icon":"图标","input":"输入","list":"列表","listbox":{"filter_clear":"显示全部","filter_placeholder":"过滤","filtered":"{0} / {1}","text_empty":"空列表","text_total":"总共 {0} 项"},"login":"登录","login_successful":"登录成功 !","logout":"登出","menu":"菜单","more":"更多","name":"名称","new":"新增","new_folder":"新建文件夹","online":"在线","operation_log":"操作日志","order":"排序","pagination":{"range":"从 :first 到 :last ，总共 :total 条"},"parent_id":"父级菜单","parent_select_error":"父级选择错误","password":"密码","password_confirmation":"确认密码","permission":"权限","permissions":"权限","refresh":"刷新","refresh_succeeded":"刷新成功 !","remember_me":"记住我","remove":"移除","reset":"撤销","role":"角色","roles":"角色","route":"路由","save":"保存","save_succeeded":"保存成功 !","selected_rows":"选择的行","setting":"设置","show":"显示","size":"大小","slug":"标识","submit":"提交","succeeded":"成功","time":"时间","title":"标题","update_succeeded":"更新成功 !","updated_at":"更新时间","upload":"上传","uri":"路径","user_setting":"用户设置","username":"用户名","view":"查看"},"zh-TW.admin":{"action":"操作","administrator":"管理員","alert":"警告","all":"全部","all_methods_if_empty":"為空默認為所有方法","avatar":"頭像","back":"返回","back_to_list":"返回列表","batch_delete":"批次刪除","browse":"瀏覽","cancel":"取消","captcha":"驗證碼","choose":"選擇","choose_file":"選擇檔案","choose_image":"選擇圖片","close":"關閉","collapse":"收起","confirm":"確認","create":"創建","created_at":"建立時間","current_page":"現在頁面","delete":"刪除","delete_confirm":"確認刪除？","delete_failed":"刪除失敗！","delete_succeeded":"刪除成功！","deny":"權限不足","description":"簡介","edit":"編輯","entries":"條","expand":"展開","export":"匯出","failed":"失敗","filter":"篩選","http":{"method":"HTTP方法","path":"HTTP路徑"},"icon":"圖示","input":"輸入","list":"列表","listbox":{"filter_clear":"顯示全部","filter_placeholder":"過濾","filtered":"{0} / {1}","text_empty":"空列表","text_total":"總共 {0} 項"},"login":"登錄","login_successful":"成功登入！","logout":"登出","menu":"目錄","more":"更多","name":"名稱","new":"新增","new_folder":"新建資料夾","online":"在線","operation_log":"操作記錄","order":"排序","pagination":{"range":"從 :first 到 :last ，總共 :total 條"},"parent_id":"父目錄","parent_select_error":"父級選擇錯誤","password":"密碼","password_confirmation":"確認密碼","permission":"權限","permissions":"權限","refresh":"重新整理","refresh_succeeded":"成功重新整理！","remember_me":"記住我","remove":"移除","reset":"重置","role":"角色","roles":"角色","route":"路由","save":"儲存","save_succeeded":"儲存成功！","selected_rows":"選擇的行","setting":"設置","show":"顯示","size":"大小","slug":"標誌","submit":"送出","succeeded":"成功","time":"時間","title":"標題","update_succeeded":"更新成功！","updated_at":"更新時間","upload":"上傳","uri":"路徑","user_setting":"用戶設置","username":"用戶名","view":"查看"}}

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(315);




/* harmony default export */ __webpack_exports__["a"] = (function (axios) {
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_1__Manager__["a" /* default */].unauthorize();
      __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ name: 'login' });
    } else if (error.response.status === 404) {
      __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].push({ name: 'error' });
    } else {
      //router.push({name: 'error'});
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
  });
});;

/***/ }),
/* 953 */,
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupForm_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c08caf9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupForm_vue__ = __webpack_require__(967);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c08caf9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseUploader_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb87b13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseUploader_vue__ = __webpack_require__(965);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bb87b13_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseUploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 963 */,
/* 964 */,
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","name":"files[]","multiple":_vm.options.maxNumberOfFiles > 1,"accept":_vm.options.accept}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled || _vm.afterSubmitForm),expression:"!disabled || afterSubmitForm"}],staticClass:"btn btn-info fileinput-button"},[_c('span',[_vm._v(_vm._s(_vm.getTranslation('upload.add_file')))]),_vm._v(" "),_c('base-uploader',{attrs:{"options":_vm.options},on:{"fileuploadadd":_vm.onFileUploadAdd,"fileuploadprogressall":_vm.onFileUploadProgressAll,"fileuploaddone":_vm.onFileUploadDone,"fileuploadfail":_vm.onFileUploadFail,"fileuploadprocessfail":_vm.onFileUploadProcessFail}})],1)]),_vm._v(" "),(_vm.progress)?_c('div',{staticClass:"progress position-relative mt-1"},[_c('div',{staticClass:"progress-bar bg-info",style:({'width': (_vm.progress + "%")})},[_c('span',[_vm._v(_vm._s((_vm.progress + "%")))])]),_vm._v(" "),(_vm.files.length)?_c('span',[_vm._v(_vm._s(_vm.files[0].name))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.files.length && !_vm.afterSubmitForm )?_c('div',{staticClass:"form-group"},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.files),function(file){return _c('li',{staticClass:"list-group-item list-group-item-sm"},[_vm._v("\n                "+_vm._s(file.name)+"\n                "),(file.error)?_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(file.error))])]):_vm._e(),_vm._v(" "),(!file.deleteUrl)?_c('button',{staticClass:"btn btn-link info-link pl-0",on:{"click":function($event){$event.preventDefault();_vm.cancel(file)}}},[_vm._v(_vm._s(_vm.getTranslation('upload.cancel')))]):_vm._e(),_vm._v(" "),(file.deleteUrl)?_c('button',{staticClass:"btn btn-link info-link pl-0",on:{"click":function($event){$event.preventDefault();_vm.remove(file)}}},[_vm._v(_vm._s(_vm.getTranslation('upload.delete')))]):_vm._e()])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[(_vm.submitted)?_c('div',{staticClass:"col-md-12 text-center"},[_c('p',{staticClass:"congrats_message"},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('registration.congrats.first_line'))+"\n                            "),_c('br'),_vm._v("\n                            "+_vm._s(_vm._f("trans")('registration.congrats.second_line'))+"\n                        ")])]):_vm._e(),_vm._v(" "),(!_vm.submitted)?_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm._f("trans")('registration.header')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.errors.has('server'))?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.errors.first('server'))+"\n                                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('user_type')},attrs:{"label":_vm._f("trans")('validation.attributes.user_type'),"name":"user_type","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.user_type')},model:{value:(_vm.user.type),callback:function ($$v) {_vm.$set(_vm.user, "type", $$v)},expression:"user.type"}},_vm._l((_vm.types),function(type){return _c('option',{key:type.id,domProps:{"value":type.value}},[_vm._v("\n                                                "+_vm._s(type.label)+"\n                                            ")])})),_vm._v(" "),(_vm.errors.has('user_type'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                           "+_vm._s(_vm.errors.first('user_type'))+"\n                                        ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:255'),expression:"'required|alpha_spaces|max:255'"}],class:{'is-invalid': _vm.errors.has('first_name')},attrs:{"label":_vm._f("trans")('validation.attributes.first_name'),"type":"text","name":"first_name","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.first_name')},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}}),_vm._v(" "),(_vm.errors.has('first_name'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                           "+_vm._s(_vm.errors.first('first_name'))+"\n                                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:255'),expression:"'required|alpha_spaces|max:255'"}],class:{'is-invalid': _vm.errors.has('last_name')},attrs:{"label":_vm._f("trans")('validation.attributes.last_name'),"type":"text","name":"last_name","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.last_name')},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}}),_vm._v(" "),(_vm.errors.has('last_name'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('last_name'))+"\n                                    ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|email|max:255|unique_email'),expression:"'required|email|max:255|unique_email'"}],class:{'is-invalid': _vm.errors.has('email')},attrs:{"label":_vm._f("trans")('validation.attributes.email'),"type":"text","name":"email","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.email')},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),(_vm.errors.has('email'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                        "+_vm._s(_vm.errors.first('email'))+"\n                                    ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16|confirmed'),expression:"'required|min:8|max:16|confirmed'"}],class:{'is-invalid': _vm.errors.has('password')},attrs:{"label":_vm._f("trans")('validation.attributes.password'),"type":"password","name":"password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password')},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm._f("trans")('passwords.password_subscription')))]),_vm._v(" "),(_vm.errors.has('password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                        "+_vm._s(_vm.errors.first('password'))+"\n                                    ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password_confirmation')},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                        "+_vm._s(_vm.errors.first('password_confirmation'))+"\n                                    ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('uploader',{class:{'is-invalid': _vm.errors.has('file')},on:{"fileuploadadd":_vm.onFileUploadAdd,"fileuploaddone":_vm.onFileUploadDone,"fileuploadfail":_vm.onFileUploadFail,"fileuploadprocessfail":_vm.onFileUploadProcessFail,"fileuploadremove":_vm.onFileUploadRemove}}),_vm._v(" "),(_vm.errors.has('file'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                        "+_vm._s(_vm.errors.first('file'))+"\n                                    ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success active text-uppercase btn-register",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.register()}}},[_vm._v("\n                                    "+_vm._s(_vm._f("trans")('registration.header'))+"\n                                ")])])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e884c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(970);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e884c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog mdc-dialog--open mdc-dialog--loader"},[_c('div',{attrs:{"id":"loaderContainer"}},[_c('img',{attrs:{"src":__webpack_require__(181),"alt":"loader"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")(_vm.messages)))])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__wrappdrop"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened modal-login",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm._f("trans")('login.labels.login')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.errors.has('server'))?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.errors.first('server'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255|min:5'),expression:"'required|max:255|min:5'"}],class:{'is-invalid': _vm.errors.has('username')},attrs:{"label":_vm._f("trans")('validation.attributes.username'),"type":"text","name":"username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.errors.has('username'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.errors.first('username')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('password')},attrs:{"label":_vm._f("trans")('validation.attributes.password'),"type":"password","name":"password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password')},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm._f("trans")('passwords.password_subscription')))]),_vm._v(" "),(_vm.errors.has('password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                          "+_vm._s(_vm.errors.first('password'))+"\n                      ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success active text-uppercase btn-signup float-right",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.login()}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('login.buttons.login'))+"\n                  ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link success-link mr-2",attrs:{"to":{name: 'password-recovery-send-token'}}},[_vm._v(_vm._s(_vm._f("trans")('login.labels.forgot'))+"\n                  ")])],1)])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendResetTokenForm_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b413f7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendResetTokenForm_vue__ = __webpack_require__(972);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendResetTokenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b413f7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendResetTokenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[(_vm.submittedForBcba)?_c('div',{staticClass:"col-md-12 text-center"},[_c('p',{staticClass:"congrats_message"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.congrats_email_bcba')))])]):_vm._e(),_vm._v(" "),(_vm.submittedForUser)?_c('div',{staticClass:"col-md-12 text-center"},[_c('p',{staticClass:"congrats_message"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.congrats_email')))])]):_vm._e(),_vm._v(" "),(!_vm.submittedForBcba && !_vm.submittedForUser)?_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"col-md-12 pt-2"},[_c('h2',{staticClass:"modal-title"},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('reset_password.forms.send_token.header'))+"\n                ")]),_vm._v(" "),_c('h3',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('reset_password.forms.reset_password.bcba_new_pass')))]),_vm._v(" "),_c('h2',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('reset_password.forms.send_token.sub_header')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255|min:5'),expression:"'required|max:255|min:5'"}],class:{'is-invalid': _vm.errors.has('username') || _vm.responseHashError},attrs:{"label":_vm._f("trans")('validation.attributes.username'),"type":"text","name":"username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.errors.has('username'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.errors.first('username'))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.responseHashError && !_vm.errors.has('username'))?_c('span',{staticClass:"invalid-feedback",class:{'d-block': _vm.responseHashError}},[_c('strong',[_vm._v(_vm._s(_vm.responseHashError))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success active btn-full-width",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.send()}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('reset_password.forms.send_token.buttons.send_password'))+"\n                ")])])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordForm_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d86aa8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordForm_vue__ = __webpack_require__(974);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d86aa8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[(_vm.submitted)?_c('div',{staticClass:"col-md-12 text-center"},[_c('p',{staticClass:"congrats_message"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.congrats.first_line'))+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.congrats.second_line'))+"\n            ")])]):_vm._e(),_vm._v(" "),(!_vm.submitted)?_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm._f("trans")('reset_password.forms.reset_password.header'))+"\n                  "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('reset_password.forms.reset_password.sub_header')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.errors.has('server'))?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                  "+_vm._s(_vm.errors.first('server'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5|max:255'),expression:"'required|min:5|max:255'"}],class:{'is-invalid': _vm.errors.has('username')  || _vm.responseHashError},attrs:{"label":_vm._f("trans")('validation.attributes.username'),"type":"text","name":"username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.errors.has('username'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.errors.first('username'))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.responseHashError && !_vm.errors.has('username'))?_c('span',{staticClass:"invalid-feedback",class:{'d-block': _vm.responseHashError}},[_c('strong',[_vm._v(_vm._s(_vm.responseHashError))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16|confirmed'),expression:"'required|min:8|max:16|confirmed'"}],class:{'is-invalid': _vm.errors.has('password')},attrs:{"label":_vm._f("trans")('validation.attributes.password'),"type":"password","name":"password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password')},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm._f("trans")('passwords.password_subscription')))]),_vm._v(" "),(_vm.errors.has('password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                          "+_vm._s(_vm.errors.first('password'))+"\n                                      ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password_confirmation')},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.errors.first('password'))+"\n                    ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success active",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.register()}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.buttons.reset'))+"\n                ")])])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766a7758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUsForm_vue__ = __webpack_require__(976);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766a7758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[(_vm.submitted)?_c('div',{staticClass:"col-md-12 text-center centered-content"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('contact_us.congrats')))])]):_vm._e(),_vm._v(" "),(!_vm.submitted)?_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm._f("trans")('contact_us.header')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.errors.has('server'))?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.errors.first('server'))+"\n                                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm._f("trans")('contact_us.labels.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:255'),expression:"'required|alpha_spaces|max:255'"},{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('name')},attrs:{"id":"name","type":"text","name":"name","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('contact_us.labels.name')},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                           "+_vm._s(_vm.errors.first('name'))+"\n                                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm._f("trans")('validation.attributes.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:255'),expression:"'required|email|max:255'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('email')},attrs:{"id":"email","type":"text","name":"email","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.email')},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('email'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('email'))+"\n                                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"message"}},[_vm._v(_vm._s(_vm._f("trans")('contact_us.labels.message')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('message')},attrs:{"name":"message","id":"message","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('contact_us.labels.message')},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('message'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('message'))+"\n                                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"col-form-label text-md-right",attrs:{"for":"captcha"}},[_vm._v("\n                                            "+_vm._s(_vm._f("trans")('contact_us.labels.captcha'))+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 capcha-cell"},[_c('img',{attrs:{"src":_vm.image,"alt":"Captcha"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"captcha"}},[_vm._v(_vm._s(_vm._f("trans")('contact_us.labels.captcha')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_num|max:255'),expression:"'required|alpha_num|max:255'"},{name:"model",rawName:"v-model",value:(_vm.form.captcha),expression:"form.captcha"}],staticClass:"form-control",class:{'is-invalid': _vm.errors.has('captcha')},attrs:{"id":"captcha","type":"text","name":"captcha","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('contact_us.labels.captcha')},domProps:{"value":(_vm.form.captcha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "captcha", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('captcha'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                           "+_vm._s(_vm.errors.first('captcha'))+"\n                                        ")]):_vm._e()])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success active",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.send()}}},[_vm._v("\n                                    "+_vm._s(_vm._f("trans")('contact_us.buttons.send'))+"\n                                ")])])])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3c9873_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__ = __webpack_require__(978);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3c9873_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('h2',{staticClass:"page-subtitle-error text-center"},[_vm._v(_vm._s(_vm._f("trans")('settings.page_not_found')))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('settings.page_not_found_subscription')))]),_vm._v(" "),_c('div',{staticClass:"buttons text-center"},[_c('router-link',{staticClass:"btn btn-outline-light mr-2 mb-md-0 mb-3",attrs:{"to":{name: 'default'}}},[_vm._v(_vm._s(_vm._f("trans")('home.labels.home')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-outline-light",attrs:{"href":"https://autismtech.online/contacts"}},[_vm._v(_vm._s(_vm._f("trans")('validation.attributes.contacts')))])],1)]),_vm._v(" "),_vm._m(1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-title-error text-center"},[_c('span',[_vm._v("404")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 text-center mt-3"},[_c('img',{attrs:{"src":__webpack_require__(181),"width":"50px","alt":"loader"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dashboardParent_components_DefaultDashboardLayout__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dashboardParent_components_AvailableProtocolList__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboardParent_components_AvailableProtocolLayout__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dashboardParent_components_AppealsLayout__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dashboardParent_components_UndesirableBehaviorLayout__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dashboardParent_components_ActiveProtocolView__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dashboardParent_components_CurrentStage__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dashboardParent_components_MandReactionStage__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dashboardParent_components_ChainReactionStage__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dashboardParent_components_ShapingCurrentStage__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_dashboardParent_components_ReactionStagesList__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_dashboardParent_components_MasteringStage__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_dashboardParent_components_MaintainStage__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_dashboardParent_components_RotationStage__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_dashboardParent_components_FluencyStage__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_dashboardParent_components_ChooseStage__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_dashboardParent_components_ChooseUSDStage__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dashboardParent_components_CurrentStageResults__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router_hooks_isMensurationForbidden__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__routes_hooks_canViewAssignedProtocol__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_dashboardParent_components_ConflictLayout__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_dashboardParent_components_MasteringStageUSD__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_dashboardParent_components_MaintainStageUSD__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_dashboardParent_components_CurrentStageLayout__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_dashboardParent_components_PecsReactionStage__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_dashboardParent_components_PecsWithoutDiscriminationReactionStage__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_dashboardParent_components_PecsWithDiscriminationStage__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_dashboardParent_components_PecsWithItemsStage__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__dro_routes_hooks_hasAccess__ = __webpack_require__(559);

































/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__modules_dashboardParent_components_DefaultDashboardLayout__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */],
  children: [{
    path: '/available-protocols/',
    name: 'available-protocols',
    component: __WEBPACK_IMPORTED_MODULE_1__modules_dashboardParent_components_AvailableProtocolList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: '/appeals',
    name: 'appeals',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_dashboardParent_components_AppealsLayout__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: '/undesirable-behavior',
    name: 'undesirable-behavior',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_dashboardParent_components_UndesirableBehaviorLayout__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */]
  }]
}, {
  path: '/available-protocols/',
  component: __WEBPACK_IMPORTED_MODULE_2__modules_dashboardParent_components_AvailableProtocolLayout__["a" /* default */],
  beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */],
  key: 'available-protocol:protocolId',
  props: true,
  children: [{
    path: ':protocolId/protocol',
    name: 'protocol-item',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_5__modules_dashboardParent_components_ActiveProtocolView__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */],
    key: 'available-protocol:protocolId'
  }, {
    path: '/current-stage',
    name: 'current-stage-layout',
    component: __WEBPACK_IMPORTED_MODULE_24__modules_dashboardParent_components_CurrentStageLayout__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__router_hooks_isMensurationForbidden__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__routes_hooks_canViewAssignedProtocol__["a" /* default */]]),
    key: 'available-protocol:protocolId',
    children: [{
      path: '/available-protocols/:protocolId/current-stage/:stageId',
      name: 'current-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_6__modules_dashboardParent_components_CurrentStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/stages',
      name: 'stage-list',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_10__modules_dashboardParent_components_ReactionStagesList__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/mand-stage/:stageId',
      name: 'mand-stage-current',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_7__modules_dashboardParent_components_MandReactionStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/chain-stage/:stageId',
      name: 'chain-stage-current',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_8__modules_dashboardParent_components_ChainReactionStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/shaping-stage/:stageId',
      name: 'shaping-stage-current',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_9__modules_dashboardParent_components_ShapingCurrentStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/choose-stage/:stageId',
      name: 'choose-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_15__modules_dashboardParent_components_ChooseStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/:stageId/mastering-stage/:phaseId',
      name: 'mastering-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_11__modules_dashboardParent_components_MasteringStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/:stageId/rotation-stage/:phaseId',
      name: 'rotation-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_13__modules_dashboardParent_components_RotationStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/:stageId/fluency-stage/:phaseId',
      name: 'fluency-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_14__modules_dashboardParent_components_FluencyStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/:stageId/maintain-stage/:phaseId',
      name: 'maintain-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_12__modules_dashboardParent_components_MaintainStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/stage',
      name: 'pecs-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_25__modules_dashboardParent_components_PecsReactionStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/stage-pecs-with-discrimination/:stageId',
      name: 'pecs-with-discrimination-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_27__modules_dashboardParent_components_PecsWithDiscriminationStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/stage-pecs-with-items/',
      name: 'pecs-with-items-stage',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_28__modules_dashboardParent_components_PecsWithItemsStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/stage-pecs/',
      name: 'pecs-stage-without-discrimination',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_26__modules_dashboardParent_components_PecsWithoutDiscriminationReactionStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/choose-usd/:stageId',
      name: 'choose-usd',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_16__modules_dashboardParent_components_ChooseUSDStage__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/mastering-stage-usd/:stageId',
      name: 'mastering-stage-usd',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_22__modules_dashboardParent_components_MasteringStageUSD__["a" /* default */],
      key: 'available-protocol:protocolId'
    }, {
      path: '/available-protocols/:protocolId/maintain-stage-usd/:stageId',
      name: 'maintain-stage-usd',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_23__modules_dashboardParent_components_MaintainStageUSD__["a" /* default */],
      key: 'available-protocol:protocolId'
    }]
  }, {
    path: ':protocolId/results',
    name: 'results',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_17__modules_dashboardParent_components_CurrentStageResults__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__routes_hooks_canViewAssignedProtocol__["a" /* default */]]),
    key: 'available-protocol:protocolId'
  }]
}, {
  path: '/clients/:clientId/conflict-list/:sessionId',
  name: 'conflict-list',
  component: __WEBPACK_IMPORTED_MODULE_21__modules_dashboardParent_components_ConflictLayout__["a" /* default */],
  props: true,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_29_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_18__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__router_hooks_isMensurationForbidden__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__dro_routes_hooks_hasAccess__["a" /* default */]])
}]);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultDashboardLayout_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a70781dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultDashboardLayout_vue__ = __webpack_require__(1021);
function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DefaultDashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a70781dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DefaultDashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestHelpModal_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0730b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestHelpModal_vue__ = __webpack_require__(983);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_requestHelpModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0730b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_requestHelpModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"bids-modal",attrs:{"title":_vm._f("trans")('dashboard.requestHelp')},on:{"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('dashboard.functionalInDevelopment')))])])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onSendRequestButtonClick()}}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.sendRequest')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 334,
	"./af.js": 334,
	"./ar": 335,
	"./ar-dz": 336,
	"./ar-dz.js": 336,
	"./ar-kw": 337,
	"./ar-kw.js": 337,
	"./ar-ly": 338,
	"./ar-ly.js": 338,
	"./ar-ma": 339,
	"./ar-ma.js": 339,
	"./ar-sa": 340,
	"./ar-sa.js": 340,
	"./ar-tn": 341,
	"./ar-tn.js": 341,
	"./ar.js": 335,
	"./az": 342,
	"./az.js": 342,
	"./be": 343,
	"./be.js": 343,
	"./bg": 344,
	"./bg.js": 344,
	"./bm": 345,
	"./bm.js": 345,
	"./bn": 346,
	"./bn.js": 346,
	"./bo": 347,
	"./bo.js": 347,
	"./br": 348,
	"./br.js": 348,
	"./bs": 349,
	"./bs.js": 349,
	"./ca": 350,
	"./ca.js": 350,
	"./cs": 351,
	"./cs.js": 351,
	"./cv": 352,
	"./cv.js": 352,
	"./cy": 353,
	"./cy.js": 353,
	"./da": 354,
	"./da.js": 354,
	"./de": 355,
	"./de-at": 356,
	"./de-at.js": 356,
	"./de-ch": 357,
	"./de-ch.js": 357,
	"./de.js": 355,
	"./dv": 358,
	"./dv.js": 358,
	"./el": 359,
	"./el.js": 359,
	"./en-au": 360,
	"./en-au.js": 360,
	"./en-ca": 361,
	"./en-ca.js": 361,
	"./en-gb": 362,
	"./en-gb.js": 362,
	"./en-ie": 363,
	"./en-ie.js": 363,
	"./en-il": 364,
	"./en-il.js": 364,
	"./en-nz": 365,
	"./en-nz.js": 365,
	"./eo": 366,
	"./eo.js": 366,
	"./es": 367,
	"./es-do": 368,
	"./es-do.js": 368,
	"./es-us": 369,
	"./es-us.js": 369,
	"./es.js": 367,
	"./et": 370,
	"./et.js": 370,
	"./eu": 371,
	"./eu.js": 371,
	"./fa": 372,
	"./fa.js": 372,
	"./fi": 373,
	"./fi.js": 373,
	"./fo": 374,
	"./fo.js": 374,
	"./fr": 375,
	"./fr-ca": 376,
	"./fr-ca.js": 376,
	"./fr-ch": 377,
	"./fr-ch.js": 377,
	"./fr.js": 375,
	"./fy": 378,
	"./fy.js": 378,
	"./gd": 379,
	"./gd.js": 379,
	"./gl": 380,
	"./gl.js": 380,
	"./gom-latn": 381,
	"./gom-latn.js": 381,
	"./gu": 382,
	"./gu.js": 382,
	"./he": 383,
	"./he.js": 383,
	"./hi": 384,
	"./hi.js": 384,
	"./hr": 385,
	"./hr.js": 385,
	"./hu": 386,
	"./hu.js": 386,
	"./hy-am": 387,
	"./hy-am.js": 387,
	"./id": 388,
	"./id.js": 388,
	"./is": 389,
	"./is.js": 389,
	"./it": 390,
	"./it.js": 390,
	"./ja": 391,
	"./ja.js": 391,
	"./jv": 392,
	"./jv.js": 392,
	"./ka": 393,
	"./ka.js": 393,
	"./kk": 394,
	"./kk.js": 394,
	"./km": 395,
	"./km.js": 395,
	"./kn": 396,
	"./kn.js": 396,
	"./ko": 397,
	"./ko.js": 397,
	"./ky": 398,
	"./ky.js": 398,
	"./lb": 399,
	"./lb.js": 399,
	"./lo": 400,
	"./lo.js": 400,
	"./lt": 401,
	"./lt.js": 401,
	"./lv": 402,
	"./lv.js": 402,
	"./me": 403,
	"./me.js": 403,
	"./mi": 404,
	"./mi.js": 404,
	"./mk": 405,
	"./mk.js": 405,
	"./ml": 406,
	"./ml.js": 406,
	"./mn": 407,
	"./mn.js": 407,
	"./mr": 408,
	"./mr.js": 408,
	"./ms": 409,
	"./ms-my": 410,
	"./ms-my.js": 410,
	"./ms.js": 409,
	"./mt": 411,
	"./mt.js": 411,
	"./my": 412,
	"./my.js": 412,
	"./nb": 413,
	"./nb.js": 413,
	"./ne": 414,
	"./ne.js": 414,
	"./nl": 415,
	"./nl-be": 416,
	"./nl-be.js": 416,
	"./nl.js": 415,
	"./nn": 417,
	"./nn.js": 417,
	"./pa-in": 418,
	"./pa-in.js": 418,
	"./pl": 419,
	"./pl.js": 419,
	"./pt": 420,
	"./pt-br": 421,
	"./pt-br.js": 421,
	"./pt.js": 420,
	"./ro": 422,
	"./ro.js": 422,
	"./ru": 423,
	"./ru.js": 423,
	"./sd": 424,
	"./sd.js": 424,
	"./se": 425,
	"./se.js": 425,
	"./si": 426,
	"./si.js": 426,
	"./sk": 427,
	"./sk.js": 427,
	"./sl": 428,
	"./sl.js": 428,
	"./sq": 429,
	"./sq.js": 429,
	"./sr": 430,
	"./sr-cyrl": 431,
	"./sr-cyrl.js": 431,
	"./sr.js": 430,
	"./ss": 432,
	"./ss.js": 432,
	"./sv": 433,
	"./sv.js": 433,
	"./sw": 434,
	"./sw.js": 434,
	"./ta": 435,
	"./ta.js": 435,
	"./te": 436,
	"./te.js": 436,
	"./tet": 437,
	"./tet.js": 437,
	"./tg": 438,
	"./tg.js": 438,
	"./th": 439,
	"./th.js": 439,
	"./tl-ph": 440,
	"./tl-ph.js": 440,
	"./tlh": 441,
	"./tlh.js": 441,
	"./tr": 442,
	"./tr.js": 442,
	"./tzl": 443,
	"./tzl.js": 443,
	"./tzm": 444,
	"./tzm-latn": 445,
	"./tzm-latn.js": 445,
	"./tzm.js": 444,
	"./ug-cn": 446,
	"./ug-cn.js": 446,
	"./uk": 447,
	"./uk.js": 447,
	"./ur": 448,
	"./ur.js": 448,
	"./uz": 449,
	"./uz-latn": 450,
	"./uz-latn.js": 450,
	"./uz.js": 449,
	"./vi": 451,
	"./vi.js": 451,
	"./x-pseudo": 452,
	"./x-pseudo.js": 452,
	"./yo": 453,
	"./yo.js": 453,
	"./zh-cn": 454,
	"./zh-cn.js": 454,
	"./zh-hk": 455,
	"./zh-hk.js": 455,
	"./zh-tw": 456,
	"./zh-tw.js": 456
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;

/***/ }),
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"behavior-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('behavior.write_unwanted_behavior'),"accept":_vm._f("trans")('behavior.buttons.create'),"accept-disabled":(_vm.isPreviousDateSession && !_vm.currentDate()) || _vm.disabled},on:{"cancel":_vm.cancel,"close":_vm.close,"validate":function($event){_vm.validate()}},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('behavior.write_unwanted_behavior_short')))])]),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.validate()}}},[_c('mdc-icon',{attrs:{"icon":"done"}})],1)])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalAncedent),function(ancedent,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : ancedent.selected},on:{"click":function($event){_vm.setActiveAncedent(ancedent)}}},[_vm._v("\n                "+_vm._s(ancedent.text)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isMaxLengthAncedent') || _vm.errors.has('isEmptyErrorAncedent') || _vm.errors.has('newTypicalAncedent')},attrs:{"name":"newTypicalAncedent","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_ancedent'),"label":_vm._f("trans")('behavior.enter_the_new_ancedent')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addAncedent($event)}},model:{value:(_vm.newTypicalAncedent.text),callback:function ($$v) {_vm.$set(_vm.newTypicalAncedent, "text", $$v)},expression:"newTypicalAncedent.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalAncedent'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalAncedent')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addAncedent()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isMaxLengthAncedent') || _vm.errors.has('isEmptyErrorAncedent'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isMaxLengthAncedent') || _vm.errors.first('isEmptyErrorAncedent')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.behavior')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalBehavior),function(behavior,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : behavior.selected},on:{"click":function($event){_vm.setActiveBehavior(behavior)}}},[_vm._v("\n                "+_vm._s(behavior.text)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isMaxLengthBehavior') || _vm.errors.has('isEmptyErrorBehavior') || _vm.errors.has('newTypicalBehavior')},attrs:{"name":"newTypicalBehavior","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_behavior'),"label":_vm._f("trans")('behavior.enter_the_new_behavior')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addBehavior($event)}},model:{value:(_vm.newTypicalBehavior.text),callback:function ($$v) {_vm.$set(_vm.newTypicalBehavior, "text", $$v)},expression:"newTypicalBehavior.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalBehavior'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalBehavior')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button","disabled":_vm.selectedBehaviorLenght > 0},on:{"click":function($event){_vm.addBehavior()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isMaxLengthBehavior') || _vm.errors.has('isEmptyErrorBehavior'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isMaxLengthBehavior') || _vm.errors.first('isEmptyErrorBehavior')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_environment')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalEffect),function(aftermath,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : aftermath.selected},on:{"click":function($event){_vm.setActiveEffect(aftermath)}}},[_vm._v("\n        "+_vm._s(aftermath.text)+"\n      ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isMaxLengthEffect') || _vm.errors.has('isEmptyErrorEffect') || _vm.errors.has('newTypicalEffect')},attrs:{"name":"newTypicalEffect","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_aftermath'),"label":_vm._f("trans")('behavior.enter_the_new_aftermath')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addEffect($event)}},model:{value:(_vm.newTypicalEffect.text),callback:function ($$v) {_vm.$set(_vm.newTypicalEffect, "text", $$v)},expression:"newTypicalEffect.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalEffect'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalEffect')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addEffect()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isMaxLengthEffect') || _vm.errors.has('isEmptyErrorEffect'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isMaxLengthEffect') || _vm.errors.first('isEmptyErrorEffect')))])]):_vm._e()])]),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_behavior')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalConsequenceInBehavior),function(consequence,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : consequence.selected},on:{"click":function($event){_vm.setActiveConsequenceInBehavior(consequence)}}},[_vm._v("\n                "+_vm._s(consequence.text)+"\n            ")])}))]):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isMaxLengthConsequenceInBehavior') || _vm.errors.has('isEmptyErrorConsequenceInBehavior') || _vm.errors.has('newTypicalConsequenceInBehavior')},attrs:{"name":"newTypicalConsequenceInBehavior","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_aftermath'),"label":_vm._f("trans")('behavior.enter_the_new_aftermath')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addConsequenceInBehavior($event)}},model:{value:(_vm.newTypicalConsequenceInBehavior.text),callback:function ($$v) {_vm.$set(_vm.newTypicalConsequenceInBehavior, "text", $$v)},expression:"newTypicalConsequenceInBehavior.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalConsequenceInBehavior'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalConsequenceInBehavior')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addConsequenceInBehavior()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isMaxLengthConsequenceInBehavior') || _vm.errors.has('isEmptyErrorConsequenceInBehavior'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isMaxLengthConsequenceInBehavior') || _vm.errors.first('isEmptyErrorConsequenceInBehavior')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('footer',{staticClass:"col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button","disabled":(_vm.isPreviousDateSession && !_vm.currentDate()) || _vm.disabled},on:{"click":function($event){_vm.validate()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('behavior.buttons.create')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"appeals-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('appeals.write_client_appeal'),"accept":_vm._f("trans")('appeals.buttons.createAppeal'),"accept-disabled":_vm.disabled || (_vm.isPreviousDateSession && !_vm.currentDate())},on:{"cancel":_vm.cancel,"close":_vm.close,"validate":_vm.validate},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('appeals.write_appeal')))])]),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.validate()}}},[_c('mdc-icon',{staticClass:"done",attrs:{"icon":"done"}})],1)])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalAppealsTemp),function(appeal,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : appeal.selected},on:{"click":function($event){_vm.setActiveAppeal(appeal)}}},[_vm._v("\n                "+_vm._s(appeal.text)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:100'),expression:"'min:1|max:100'"}],class:{'is-invalid': _vm.errors.has('newAppeal || isEmptyError || isMaxLengthAppeals')},attrs:{"name":"newAppeal","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('appeals.appeals'),"label":_vm._f("trans")('appeals.type_new_appeal')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addAppeal($event)}},model:{value:(_vm.newAppeal.text),callback:function ($$v) {_vm.$set(_vm.newAppeal, "text", $$v)},expression:"newAppeal.text"}})],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addAppeal()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('newAppeal') || _vm.errors.has('isEmptyError') || _vm.errors.has('isMaxLengthAppeals'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newAppeal') || _vm.errors.first('isEmptyError') || _vm.errors.first('isMaxLengthAppeals')))])]):_vm._e()])]),_vm._v(" "),(_vm.isMobile)?_c('footer',{staticClass:"col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button","disabled":_vm.disabled || (_vm.isPreviousDateSession && !_vm.currentDate())},on:{"click":function($event){_vm.validate()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.createAppeal')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendCommentModal_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac667b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendCommentModal_vue__ = __webpack_require__(996);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendCommentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac667b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendCommentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"bids-modal",attrs:{"title":_vm._f("trans")('dashboard.sendComment')},on:{"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('dashboard.functionalInDevelopment')))])])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onSendRequestButtonClick()}}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.sendRequest')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_droModal_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008addc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_droModal_vue__ = __webpack_require__(1004);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_droModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008addc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_droModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"novalidate":""}},[(_vm.isMobile && _vm.modalView)?_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("DRO/DRI")])]),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('button',{staticClass:"btn btn-link",on:{"click":function($event){$event.preventDefault();return _vm.startSession($event)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('dro.start_session'))+"\n                        ")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"dro-settings d-flex flex-wrap"},[_c('div',{staticClass:"form-group col-md-12 ",class:{'col-lg-5': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.target_behaviour'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"aimTypeId","label":_vm._f("trans")('dro.behaviour_absence'),"value":"1"},model:{value:(_vm.form.aimTypeId),callback:function ($$v) {_vm.$set(_vm.form, "aimTypeId", $$v)},expression:"form.aimTypeId"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"aimTypeId","label":_vm._f("trans")('dro.behaviour_presence'),"value":"2"},model:{value:(_vm.form.aimTypeId),callback:function ($$v) {_vm.$set(_vm.form, "aimTypeId", $$v)},expression:"form.aimTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12",class:{'col-lg-7': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_duration_units'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.min'),"value":"1"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.sec'),"value":"2"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12",class:{'col-lg-5': !_vm.modalView}},[(_vm.form.intervalDurationUnitId == 1)?_c('h5',{staticClass:"title"},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('dro.interval_time_range_minutes'))+":")]):(_vm.form.intervalDurationUnitId == 2)?_c('h5',{staticClass:"title"},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('dro.interval_time_range_seconds'))+":")]):_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_time_range'))+":")]),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:100'),expression:"'required|numeric|min_value:1|max_value:100'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"100","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 2)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:300'),expression:"'required|numeric|min_value:1|max_value:300'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"300","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.errors.has('intervalDurationValue'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('intervalDurationValue'))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.min')))]):(_vm.form.intervalDurationUnitId == 2)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.sec')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-md-12",class:{'col-lg-7': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.behaviour_description'))+":")]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:255'),expression:"'max:255'"}],class:{'is-invalid': _vm.errors.has('behaviourDescription')},attrs:{"name":"behaviourDescription","type":"text","max":"255","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.behaviourDescription')},model:{value:(_vm.form.behaviourDescription),callback:function ($$v) {_vm.$set(_vm.form, "behaviourDescription", $$v)},expression:"form.behaviourDescription"}}),_vm._v(" "),(_vm.errors.has('behaviourDescription'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('behaviourDescription'))+"\n                                        ")]):_vm._e()],1)])])],1):_c('div',[_c('div',{class:{'rounded border shadow py-3': !_vm.modalView}},[_c('div',{staticClass:"dro-settings d-flex flex-wrap"},[_c('div',{staticClass:"form-group col-md-12 ",class:{'col-lg-5': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.target_behaviour'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"aimTypeId","label":_vm._f("trans")('dro.behaviour_absence'),"value":"1"},model:{value:(_vm.form.aimTypeId),callback:function ($$v) {_vm.$set(_vm.form, "aimTypeId", $$v)},expression:"form.aimTypeId"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"aimTypeId","label":_vm._f("trans")('dro.behaviour_presence'),"value":"2"},model:{value:(_vm.form.aimTypeId),callback:function ($$v) {_vm.$set(_vm.form, "aimTypeId", $$v)},expression:"form.aimTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12",class:{'col-lg-7': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_duration_units'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.min'),"value":"1"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.sec'),"value":"2"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12",class:{'col-lg-5': !_vm.modalView}},[(_vm.form.intervalDurationUnitId == 1)?_c('h5',{staticClass:"title"},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('dro.interval_time_range_minutes'))+":")]):(_vm.form.intervalDurationUnitId == 2)?_c('h5',{staticClass:"title"},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('dro.interval_time_range_seconds'))+":")]):_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_time_range'))+":")]),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:100'),expression:"'required|numeric|min_value:1|max_value:100'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"100","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 2)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:300'),expression:"'required|numeric|min_value:1|max_value:300'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"300","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.errors.has('intervalDurationValue'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('intervalDurationValue'))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.min')))]):(_vm.form.intervalDurationUnitId == 2)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.sec')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group  col-md-12",class:{'col-lg-7': !_vm.modalView}},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.behaviour_description'))+":")]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:255'),expression:"'max:255'"}],class:{'is-invalid': _vm.errors.has('behaviourDescription')},attrs:{"name":"behaviourDescription","type":"text","max":"255","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.behaviourDescription')},model:{value:(_vm.form.behaviourDescription),callback:function ($$v) {_vm.$set(_vm.form, "behaviourDescription", $$v)},expression:"form.behaviourDescription"}}),_vm._v(" "),(_vm.errors.has('behaviourDescription'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                            "+_vm._s(_vm.errors.first('behaviourDescription'))+"\n                                        ")]):_vm._e()],1)])]),_vm._v(" "),(_vm.modalView)?_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-button--raised button-success text-uppercase col-md-12",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.startSession()}}},[_vm._v(" "+_vm._s(_vm._f("trans")('dro.start_session'))+"\n            ")])]):_vm._e(),_vm._v(" "),(!_vm.modalView)?_c('div',{staticClass:"dro-settings form group-row"},[_c('div',{staticClass:"text-center"},[_c('mdc-button',{staticClass:"button-success text-uppercase col-sm-6 mt-4",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.startSession()}}},[_vm._v(_vm._s(_vm._f("trans")('dro.start_session'))+"\n                ")])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('mdc-dialog',{staticClass:"dro-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('dro.title')},on:{"cancel":_vm.close,"close":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e(),_vm._v(" "),_c('settings-form',{attrs:{"modalView":_vm.modalView,"settings":_vm.form},on:{"session-settings-set":_vm.onSessionSettingsSet,"close":_vm.close}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentIntervalFormMenu_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9015c868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentIntervalFormMenu_vue__ = __webpack_require__(1009);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentIntervalFormMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9015c868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentIntervalFormMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */,
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalProgressBar_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6e1f41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalProgressBar_vue__ = __webpack_require__(1008);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6e1f41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('span',{staticClass:"progress__current",class:{'progress__current__complete' : _vm.showCompleteMessage},style:({'left': ((_vm.progress - 2) + "%")})},[_vm._v(_vm._s(_vm._f("minutes")(_vm.current)))]),_vm._v(" "),_c('div',{staticClass:"progress-bar",class:{'complete': _vm.showCompleteMessage},style:({'width': (_vm.progress + "%")}),attrs:{"role":"progressbar","aria-valuenow":_vm.progress,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.showCompleteMessage)?_c('span',{staticClass:"progress-bar__message text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('dro.behaviour_absent'))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"progress__times"},[_vm._v(_vm._s(_vm._f("trans")('dro.list.time'))+" "+_vm._s(_vm._f("minutes")(_vm.max)))]),_vm._v(" "),(!_vm.showCompleteMessage)?_c('span',{staticClass:"progress__times__modal"},[_vm._v(_vm._s(_vm._f("minutes")(_vm.current)))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interval-form-menu",attrs:{"id":"dashboard"}},[_c('p',[_vm._v("DRO/DRI")]),_vm._v(" "),_c('div',{class:{'bg-info' : _vm.isIntervalStarted, 'bg-warning' : !_vm.isIntervalStarted && !_vm.isIntervalCompleted, 'bg-success': _vm.isIntervalCompleted}},[(_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-transparent text-uppercase left-button",attrs:{"type":"submit"},on:{"click":function($event){_vm.finishSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_c('img',{attrs:{"src":__webpack_require__(471),"alt":_vm._f("trans")('dro.finish_session')}})]):_vm._e(),_vm._v(" "),(!_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-transparent text-uppercase left-button",attrs:{"type":"submit"},on:{"click":function($event){_vm.saveSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_c('img',{attrs:{"src":__webpack_require__(471),"alt":_vm._f("trans")('dro.finish_session')}})]):_vm._e(),_vm._v(" "),_c('interval-progress-bar'),_vm._v(" "),(_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-transparent text-uppercase right-button",attrs:{"type":"submit"},on:{"click":function($event){_vm.onBehaviourHappened()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_c('img',{attrs:{"src":__webpack_require__(1010),"alt":_vm._f("trans")('dro.target_behaviour')}})]):_vm._e(),_vm._v(" "),(!_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-transparent text-uppercase right-button",attrs:{"type":"submit"},on:{"click":function($event){_vm.startSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_c('img',{attrs:{"src":__webpack_require__(1011),"alt":_vm._f("trans")('dro.continue_session')}})]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCA0SDE2VjBMMTMuMDQzIDIuOTU2OTdMMTEuNTI5MyA0LjQ3MDgzTDEwIDZWNi4xMDAwNFY4LjE3MDIzVjguNTg1ODhMOC4yOTI5NyAxMC4yOTI5QzcuOTAyMzQgMTAuNjgzNCA3LjkwMjM0IDExLjMxNjYgOC4yOTI5NyAxMS43MDcxQzguNjgzNTkgMTIuMDk3NyA5LjMxNjQxIDEyLjA5NzcgOS43MDcwMyAxMS43MDcxTDExLjQxNDEgMTBIMTEuODMwMUgxMy44OTk5SDE0TDE1LjUyOTMgOC40NzA4M0wxNy4wNDMgNi45NTcwM0wyMCA0Wk0xNC41MDEgNi42NzA0N0wxNS4xNzE0IDZIMTRWNC44Mjg0M0wxMy4zMjk2IDUuNDk5MDhMMTIgNi44Mjg0M1Y2Ljk5OTU3VjhIMTMuMDAwNUgxMy4xNzE0TDE0LjUwMSA2LjY3MDQ3Wk04IDYuMTAwMDRDNS43MTc3NyA2LjU2MzM1IDQgOC41ODEwNSA0IDExQzQgMTMuNzYxNCA2LjIzODc3IDE2IDkgMTZDMTEuNDE4OSAxNiAxMy40MzY1IDE0LjI4MjIgMTMuODk5OSAxMkgxMi4yNDI3TDExLjE0MzEgMTMuMDk5NEwxMS4xMjExIDEzLjEyMTNDMTAuNTM1MiAxMy43MDcgOS43Njc1OCAxNCA5IDE0TDguOTk1NjEgMTMuOTk5OUM4LjIyOTQ5IDEzLjk5ODggNy40NjM4NyAxMy43MDYxIDYuODc4OTEgMTMuMTIxNUM2LjMzNTk0IDEyLjU3ODYgNiAxMS44Mjg2IDYgMTFDNiA5LjcyOTA2IDYuNzkwNTMgOC42NDI3NiA3LjkwNjI1IDguMjA1NjNMOCA3Ljc1NzQ1VjYuMTAwMDRaTTkgNEw5LjE2OTQzIDQuMDAyMDFMMTAuOTU3NSAyLjIxMzVDMTAuMzI3MSAyLjA3MzczIDkuNjcyMzYgMiA5IDJDNC4wMjkzIDIgMCA2LjAyOTQyIDAgMTFDMCAxNS45NzA2IDQuMDI5MyAyMCA5IDIwQzEzLjk3MDcgMjAgMTggMTUuOTcwNiAxOCAxMUMxOCAxMC4zMjc1IDE3LjkyNjMgOS42NzIyNCAxNy43ODY2IDkuMDQxODdMMTUuOTk4IDEwLjgzMDNMMTYgMTFDMTYgMTQuODY2IDEyLjg2NjIgMTggOSAxOEM1LjEzMzc5IDE4IDIgMTQuODY2IDIgMTFDMiA3LjEzNDAzIDUuMTMzNzkgNCA5IDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDEpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjU1MTUgMC4wMDM0OTgzNEM2LjQ2MTUzIC0wLjEzNjUwMiAyLjI5MTUzIDMuOTQzNSAyLjI5MTUzIDkuMDAzNUgwLjUwMTUzNEMwLjA1MTUzNDQgOS4wMDM1IC0wLjE2ODQ2NiA5LjU0MzUgMC4xNTE1MzQgOS44NTM1TDIuOTQxNTMgMTIuNjUzNUMzLjE0MTUzIDEyLjg1MzUgMy40NTE1MyAxMi44NTM1IDMuNjUxNTMgMTIuNjUzNUw2LjQ0MTUzIDkuODUzNUM2Ljc2MTUzIDkuNTQzNSA2LjUzMTUzIDkuMDAzNSA2LjA5MTUzIDkuMDAzNUg0LjI5MTUzQzQuMjkxNTMgNS4xMDM1IDcuNDcxNTMgMS45NTM1IDExLjM5MTUgMi4wMDM1QzE1LjExMTUgMi4wNTM1IDE4LjI0MTUgNS4xODM1IDE4LjI5MTUgOC45MDM1QzE4LjM0MTUgMTIuODEzNSAxNS4xOTE1IDE2LjAwMzUgMTEuMjkxNSAxNi4wMDM1QzkuNjgxNTMgMTYuMDAzNSA4LjE5MTUzIDE1LjQ1MzUgNy4wMTE1MyAxNC41MjM1QzYuNjExNTMgMTQuMjEzNSA2LjA1MTUzIDE0LjI0MzUgNS42OTE1MyAxNC42MDM1QzUuMjcxNTMgMTUuMDMzNSA1LjMwMTUzIDE1LjczMzUgNS43NzE1MyAxNi4xMDM1QzcuMjkxNTMgMTcuMjkzNSA5LjIxMTUzIDE4LjAwMzUgMTEuMjkxNSAxOC4wMDM1QzE2LjM0MTUgMTguMDAzNSAyMC40MzE1IDEzLjgzMzUgMjAuMjkxNSA4Ljc0MzVDMjAuMTYxNSA0LjA1MzUgMTYuMjQxNSAwLjEzMzQ5OCAxMS41NTE1IDAuMDAzNDk4MzRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjY5ODQ3IDIuOTk2NTgpIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMC43NSAwQzAuMzQgMCAwIDAuMzQgMCAwLjc1VjQuNDNDMCA0Ljc4IDAuMTkgNS4xMSAwLjQ5IDUuMjlMMy42MSA3LjE0QzMuOTcgNy4zNSA0LjQzIDcuMjMgNC42NCA2Ljg4QzQuODUgNi41MiA0LjczIDYuMDYgNC4zOCA1Ljg1TDEuNSA0LjE0VjAuNzRDMS41IDAuMzQgMS4xNyAwIDAuNzUgMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjk5IDgpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"dro-report-dialog",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('dro.report.header_mobile'),"accept":_vm._f("trans")('user.close'),"cancel":_vm._f("trans")('dro.cancel')},on:{"cancel":_vm.close,"accept":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',[_c('div',{staticClass:"close-cross",on:{"click":_vm.close}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.date'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.date))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.client'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.assignee.code))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm.auditor.role))]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.auditor.name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('dro.parameters'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm._f("aimType")(_vm.settings.aimTypeId)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('dro.behaviour_description'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.behaviourDescription))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.interval_count')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.successful_interval_count')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.success_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.failed_interval_count')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.fail_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.report.average_successful_interval_duration')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.intervalCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.successfulIntervalCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.successRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.failedIntervalCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.failRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("minutes")((_vm.averageSuccessfulIntervalDuration || '-'))))])])])])])]):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.header_mobile')))])]),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('button',{staticClass:"btn btn-link",on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[_vm._v(_vm._s(_vm._f("trans")('user.close'))+"\n                        ")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},[_c('div',{staticClass:"mobile-table__row mx-0"},[_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.interval_count')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm.intervalCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.successful_interval_count')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm.successfulIntervalCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.success_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.successRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.failed_interval_count')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm.failedIntervalCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.fail_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.failRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.average_successful_interval_duration')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("minutes")((_vm.averageSuccessfulIntervalDuration || '-'))))])])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protocolModal_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2cea32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_protocolModal_vue__ = __webpack_require__(1019);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_protocolModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2cea32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_protocolModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdc-dialog',{staticClass:"wide-modal",attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.save_session'),"cancel":_vm._f("trans")('dro.cancel'),"accept-disabled":_vm.isPreviousDateSession && _vm.showDatePrevious},on:{"cancel":_vm.close,"close":_vm.close,"validate":_vm.saveSession},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e(),_vm._v(" "),(!_vm.showMands)?_c('div',{staticClass:"row"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_vm._l((_vm.stagesList),function(stage){return (!stage.isClosed)?_c('div',{staticClass:"mt-3 col-lg-3 col-md-4 link-stage"},[_c('mdc-button',{staticClass:"link-stage__button",class:{'disabled': stage.isClosed},attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();_vm.chooseStage(stage.id)}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])])],1):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.showMands)?_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"wizard-tab-container"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.addMandReaction')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addMandReactionsItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addMandReaction'),"name":"addMandReactionsItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addMandReaction')},model:{value:(_vm.addMandReactionsItem),callback:function ($$v) {_vm.addMandReactionsItem=$$v},expression:"addMandReactionsItem"}}),_vm._v(" "),(_vm.errors.has('addMandReactionsItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addMandReactionsItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addMands(_vm.addMandReactionsItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.showDatePrevious)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])])])]):_vm._e(),_vm._v(" "),(!_vm.isMobile && _vm.loaded)?_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.mands),function(mand,index){return _c('tr',{key:mand.globalUuid},[_c('td',[_vm._v(_vm._s(mand.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(mand.attempt))]),_vm._v(" "),_c('td',[_vm._l((mand.recordedReactions),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(mand.answer),expression:"mand.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + mand.globalUuid +key,"type":"radio","name":'radios'+index + mand.globalUuid},domProps:{"value":label.title,"checked":_vm._q(mand.answer,label.title)},on:{"change":[function($event){_vm.$set(mand, "answer", label.title)},function($event){_vm.attemptChange(label.id, mand, label.title)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + mand.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!mand.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(mand.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])}))]):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.loaded)?_c('div',{staticClass:"mobile-table position-relative mt-3"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.mands),function(mand,index){return _c('div',{key:mand.globalUuid,staticClass:"mobile-table__row"},[(mand.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': mand.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(mand.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(mand.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.mands.length/3) == 0}},[_vm._l((mand.recordedReactions),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(mand.answer),expression:"mand.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + mand.globalUuid +key,"type":"radio","name":'radios'+index + mand.globalUuid},domProps:{"value":label.title,"checked":_vm._q(mand.answer,label.title)},on:{"change":[function($event){_vm.$set(mand, "answer", label.title)},function($event){_vm.attemptChange(label.id, mand, label.title)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + mand.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(mand.lastAnswers ? mand.lastAnswers.length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(mand.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])}))]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n        ")]):_vm._e()],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMensurationForbidden && !_vm.isPreviousDateSession)?_c('div',[(_vm.isCurrentIntervalShow)?_c('div',[_c('current-interval-form-menu',{on:{"save-session":_vm.onSaveSession}})],1):_vm._e(),_vm._v(" "),(_vm.isOpenMDCMenu)?_c('div',{staticClass:"mdc-menu__backdrop",on:{"click":function($event){$event.preventDefault();return _vm.hideMdcMenu($event)}}}):_vm._e(),_vm._v(" "),_c('mdc-menu-anchor',{staticClass:"fixed-menu"},[_c('mdc-button',{attrs:{"raised":""},on:{"click":function($event){_vm.isOpenMDCMenu=true}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("more_horiz")])]),_vm._v(" "),_c('mdc-menu',{model:{value:(_vm.isOpenMDCMenu),callback:function ($$v) {_vm.isOpenMDCMenu=$$v},expression:"isOpenMDCMenu"}},[(!_vm.isPreviousDateSession)?_c('mdc-menu-item',[_c('mdc-button',{directives:[{name:"touch",rawName:"v-touch.preventDefault.longtap",modifiers:{"preventDefault":true,"longtap":true}}],attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onHelpModalBtnClick($event)},"longtap":_vm.onHelpModalBtnClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("format_align_left")]),_vm._v(_vm._s(_vm._f("trans")('dashboard.writeRequest'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('mdc-menu-item',[_c('mdc-button',{directives:[{name:"touch",rawName:"v-touch.preventDefault.longtap",modifiers:{"preventDefault":true,"longtap":true}}],attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onBehaviorModalBtnClick($event)},"longtap":_vm.onBehaviorModalBtnClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("warning")]),_vm._v(_vm._s(_vm._f("trans")('dashboard.writeUnwantedBehavior'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(!_vm.hideDroModal && _vm.hasAccess && !_vm.isPreviousDateSession)?_c('mdc-menu-item',{class:{'started' :_vm.isCurrentIntervalShow}},[_c('mdc-button',{directives:[{name:"touch",rawName:"v-touch.preventDefault.longtap",modifiers:{"preventDefault":true,"longtap":true}}],attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onDROModalBtnClick($event)},"longtap":_vm.onDROModalBtnClick}},[_c('span',{staticClass:"dro-icon"}),_vm._v(_vm._s(_vm._f("trans")('dro.dro_module'))+"\n        ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.dashboardProtocolList),function(dashboardProtocol){return _c('mdc-menu-item',{key:dashboardProtocol.id},[_c('mdc-button',{directives:[{name:"touch",rawName:"v-touch.preventDefault.longtap",modifiers:{"preventDefault":true,"longtap":true}}],attrs:{"raised":"","disabled":_vm.currentProtocolId == dashboardProtocol.id},on:{"click":function($event){$event.preventDefault();_vm.dashboardProtocolClick(dashboardProtocol.id)},"longtap":function($event){_vm.dashboardProtocolClick(dashboardProtocol.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("format_align_left")]),_vm._v(_vm._s(dashboardProtocol.shortcutMenuTitle)+"\n        ")])],1)})],2)],1),_vm._v(" "),(_vm.isRequestModalVisible)?_c('div',[_c('request-help-modal',{attrs:{"visible":_vm.isRequestModalVisible,"clientId":_vm.modal.clientId},on:{"close":_vm.onRequestModalClose}})],1):_vm._e(),_vm._v(" "),(_vm.isBehaviorModalVisible)?_c('div',[_c('undesirable-behavior-modal',{attrs:{"visible":_vm.isBehaviorModalVisible,"clientId":_vm.modal.clientId,"clientData":_vm.client},on:{"close":_vm.onBehaviorModalClose,"cancel":_vm.onBehaviorModalCancel}})],1):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('write-appeals-modal',{attrs:{"visible":_vm.isModalVisible,"clientId":_vm.modal.clientId,"clientData":_vm.client},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}})],1):_vm._e(),_vm._v(" "),(_vm.isCommentModalVisible)?_c('div',[_c('send-comment-modal',{attrs:{"visible":_vm.isCommentModalVisible,"clientId":_vm.modal.clientId},on:{"close":_vm.onCommentModalClose}})],1):_vm._e(),_vm._v(" "),(_vm.isModalReportVisible)?_c('div',[_c('report-modal',{attrs:{"visible":_vm.isModalReportVisible},on:{"close":_vm.onReportModalClose}})],1):_vm._e(),_vm._v(" "),(_vm.isDroModalVisible)?_c('div',[_c('dro-modal',{attrs:{"visible":_vm.isDroModalVisible  && !_vm.hideDroModal,"clientId":_vm.modal.clientId},on:{"close":_vm.onDroModalClose}})],1):_vm._e(),_vm._v(" "),(_vm.isProtocolModalVisible)?_c('div',[_c('protocol-modal',{attrs:{"visible":_vm.isProtocolModalVisible,"protocolId":_vm.protocolId,"clientData":_vm.client,"clientId":_vm.modal.clientId},on:{"close":_vm.onProtocolModalClose}})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view')],1)]),_vm._v(" "),(_vm.isClient)?_c('dashboard-menu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableProtocolList_vue__ = __webpack_require__(478);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203a764a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableProtocolList_vue__ = __webpack_require__(1041);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableProtocolList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203a764a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableProtocolList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolModal_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09351f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolModal_vue__ = __webpack_require__(1027);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09351f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{class:{'is-clear': !_vm.options, 'is-loading': _vm.loading},attrs:{"disabled":_vm.disabled,"label":_vm.label,"options":_vm.options,"on-change":_vm.onSetSelected,"closeOnSelect":_vm.closeOnSelect,"onSearch":_vm.onChange,"filterable":_vm.filterable,"searchable":_vm.searchable,"v-validate":_vm.validated.validate,"data-vv-validate-on":_vm.validated.on,"data-vv-name":_vm.validated.name,"data-vv-as":_vm.validated.as},scopedSlots:_vm._u([{key:"selected-option",fn:function(option){return [_vm._v("\n    "+_vm._s(_vm.getTitle(option))+"\n  ")]}},{key:"option",fn:function(option){return [_vm._v("\n\n    "+_vm._s(_vm.getTitle(option))+"\n\n    "),(_vm.isLastItem(option) && !_vm.isLastPage)?_c('span',{directives:[{name:"touch",rawName:"v-touch.preventDefault",modifiers:{"preventDefault":true}},{name:"touch",rawName:"v-touch.preventDefault.tap",value:(_vm.nextPage),expression:"nextPage",modifiers:{"preventDefault":true,"tap":true}}],staticClass:"load_more__button",attrs:{"id":"load_more"},on:{"mouseover":function($event){_vm.nextPage()},"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('img',{attrs:{"height":"24","src":__webpack_require__(181),"alt":"loader"}})]):_vm._e()]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n      "+_vm._s(_vm.noOptions)+"\n    ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"protocol-modal",attrs:{"title":_vm._f("trans")('protocol.add_new_protocol'),"cancel":_vm._f("trans")('user.cancel')},on:{"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(this.assignList)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('select-with-pager',{staticClass:"load_more__select aut-dropdown",attrs:{"id":"protocol","selected":_vm.selected,"label":'title',"options":_vm.assignList,"loading":_vm.loading,"isLastPage":_vm.isLastPage,"validated":_vm.validated,"noOptions":_vm._f("trans")('protocol.choose_protocol'),"getOptionTitle":_vm.getOptionTitle,"isLast":_vm.isLast},on:{"set-selected":_vm.onSetSelected,"next-page":_vm.nextPage,"set-search":_vm.searchProtocol}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.choose_protocol'))+"\n          ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('protocol') }},[_vm._v(_vm._s(_vm._f("trans")('protocol.header')))]),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('bids.start_protocol')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('protocol'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('protocol')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel",attrs:{"type":"button"},on:{"click":function($event){_vm.cancel()}}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.cancel')))]),_vm._v(" "),(this.assignList.length)?_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":"","disabled":_vm.disabled},on:{"click":function($event){_vm.onSendRequestButtonClick()}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('protocol.buttons.addProtocol'))+"\n    ")]):_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":"","disabled":_vm.disabled,"to":{ name: 'protocol-create'}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('protocol.buttons.create'))+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-textfield',{ref:"input_search",staticClass:"list-search",attrs:{"type":"text","name":_vm.name,"id":"input_search","disabled":_vm.disabled,"label":_vm.placeholder,"value":_vm.value},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter($event)},"blur":_vm.onEnter}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.initialPage)?_c('div',{class:{'loading':!_vm.isLoaded}},[(_vm.isTwoSearch)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(_vm.options.withSearch)?_c('search',{attrs:{"placeholder":_vm.options.texts.filterPlaceholder},on:{"enter":_vm.onSearchEnter},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.options.withSearch)?_c('search',{attrs:{"name":"searchSkillField","placeholder":_vm._f("trans")('protocol.skillField_and_code')},on:{"enter":_vm.onSearchSkillField},model:{value:(_vm.searchSkillField),callback:function ($$v) {_vm.searchSkillField=$$v},expression:"searchSkillField"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(!_vm.isTwoSearch)?_c('div',[(_vm.options.withSearch)?_c('search',{attrs:{"placeholder":"Search","placeholder":_vm.options.texts.filterPlaceholder},on:{"enter":_vm.onSearchEnter},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isList)?_c('v-server-table',{ref:"protocolTable",attrs:{"columns":[_vm.tableColumns[_vm.indexColumn]],"options":_vm.options,"skin":"table table-sm"},scopedSlots:_vm._u([{key:_vm.tableColumns[_vm.indexColumn],fn:function(props){return [_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"title d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"d-flex align-items-center"},[_vm._t("id",null,{row:props.row}),_vm._v(" "),_vm._t("logo",null,{row:props.row}),_vm._v(" "),(props.row.title)?_c('strong',[_vm._v(_vm._s(props.row.title))]):_vm._e()],2),_vm._v(" "),_c('div',[_vm._t("action",null,{row:props.row})],2)])])]),_vm._v(" "),_vm._l((_vm.options.listRow),function(column,key,index){return (!_vm.listWithHeaderView && !_vm.listHide)?_c('div',{staticClass:"description",class:{'pt-2' : (index == 0)}},[(props.row[key])?_c('p',{staticClass:"gray-dark"},[(column.headings)?_c('b',[_vm._v(_vm._s(column.headings)+":")]):_vm._e(),_vm._v(" "),(!props.row[key].date)?_c('span',[_vm._v(_vm._s(column.hasTemplate ? _vm.options.templates[key](null, props.row) :  props.row[key]))]):_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row[key].date)))])]):_c('div',[(column.headings && props.row[key])?_c('b',[_vm._v(_vm._s(column.headings)+":")]):_vm._e(),_vm._v(" "),_vm._t(key,null,{row:props.row})],2)]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options.listRow),function(column,key){return (_vm.listWithHeaderView && !_vm.listHide)?_c('div',{staticClass:"description"},[(props.row[key])?_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(column.headings))]),_vm._v(" "),_c('p',[(!props.row[key].date)?_c('span',[_vm._v(_vm._s(column.hasTemplate ? _vm.options.templates[key](null, props.row) :  props.row[key]))]):_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row[key].date)))])])]):_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(column.headings))]),_vm._v(" "),_vm._t(key,null,{row:props.row})],2)]):_vm._e()}),_vm._v(" "),_vm._t("descriptionList",null,{row:props.row})]}}])}):_vm._e(),_vm._v(" "),(!_vm.isList && _vm.withChild)?_c('v-server-table',{ref:"protocolTable",attrs:{"columns":_vm.tableColumns,"options":_vm.options,"skin":"table table-sm"},scopedSlots:_vm._u([{key:"child_row",fn:function(props){return _c('div',{},[_vm._t("childRow",null,{row:props.row})],2)}},_vm._l((_vm.slotColumns),function(column){return {key:column,fn:function(props){return [_c('div',{key:column},[_vm._t(column,null,{row:props.row})],2)]}}})])}):_vm._e(),_vm._v(" "),(!_vm.isList && !_vm.withChild)?_c('v-server-table',{ref:"protocolTable",attrs:{"columns":_vm.tableColumns,"options":_vm.options,"skin":"table table-sm"},scopedSlots:_vm._u([_vm._l((_vm.slotColumns),function(column){return {key:column,fn:function(props){return [_c('div',{key:column},[_vm._t(column,null,{row:props.row})],2)]}}})])}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typeProtocol; });

var typeProtocol = {

  methods: {
    isDTTProtocol: function isDTTProtocol(teachingMethod) {
      return teachingMethod == 1;
    },

    isSimpleProtocol: function isSimpleProtocol(teachingMethod) {
      return teachingMethod == 2;
    },

    isMandProtocol: function isMandProtocol(teachingMethod) {
      return teachingMethod == 3;
    },

    isUSDProtocol: function isUSDProtocol(teachingMethod) {
      return teachingMethod == 4;
    },

    isChainProtocol: function isChainProtocol(teachingMethod) {
      return teachingMethod == 5;
    },

    isShapingProtocol: function isShapingProtocol(teachingMethod) {
      return teachingMethod == 6;
    },
    isPecsProtocol: function isPecsProtocol(teachingMethod) {
      return teachingMethod == 7;
    },
    isPecsWithoutDiscriminationProtocol: function isPecsWithoutDiscriminationProtocol(teachingMethod) {
      return teachingMethod == 8;
    },
    isPecsWithDiscriminationProtocol: function isPecsWithDiscriminationProtocol(teachingMethod) {
      return teachingMethod == 9;
    },
    isPecsWithItemsProtocol: function isPecsWithItemsProtocol(teachingMethod) {
      return teachingMethod == 10;
    }
  }
};

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assigned-list",class:{'without_btn': !(!_vm.isTherapist && !_vm.onlyList && !_vm.isMensurationForbidden && !_vm.isPreviousDateSession)}},[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errorDeleteMessage))]),_vm._v(" "),_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange,"isTwoSearch":true},on:{"on-search":_vm.onSearchEnter,"on-search-skill-field":_vm.onSearchSkillField},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('div',{},[_c('router-link',{attrs:{"to":{ name: 'protocol-item', params: {clientId: _vm.clientId, protocolId: props.row.id }}}},[_c('div',{staticClass:"icon-circle icon-blue"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.P')))]):_vm._e()])])],1)}},{key:"protocols",fn:function(props){return _c('div',{},[(_vm.activeProtocolList(props.row.protocol.stages).length !== 1 &&
                !_vm.isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                !_vm.isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                !_vm.isPecsProtocol(props.row.protocol.teachingMethod.id) &&
                !_vm.isCompleted(props.row) &&
                !_vm.isNew(props.row) &&
                !_vm.isMensurationForbidden  &&
                !_vm.isClient &&
                !_vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
          !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
          !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 &&
                !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
                !_vm.isMensurationForbidden  &&
                !_vm.isClient &&
                !_vm.isOnIndividualization(props.row) &&
                (_vm.isChainProtocol(props.row.protocol.teachingMethod.id) || _vm.isShapingProtocol(props.row.protocol.teachingMethod.id) || _vm.isMandProtocol(props.row.protocol.teachingMethod.id)))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: _vm.isChainProtocol(props.row.protocol.teachingMethod.id) ? 'chain-stage-current' : _vm.isShapingProtocol(props.row.protocol.teachingMethod.id) ? 'shaping-stage-current' : 'mand-stage-current',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 &&
                   !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
                   !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) && _vm.isUSDProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'choose-usd',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsProtocol(props.row.protocol.teachingMethod.id) &&
                    !_vm.isCompleted(props.row) && !_vm.isNew(props.row) && !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'pecs-stage',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                    !_vm.isCompleted(props.row) && !_vm.isNew(props.row) && !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'pecs-stage-without-discrimination',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithItemsProtocol(props.row.protocol.teachingMethod.id) && !_vm.isCompleted(props.row) &&
                    !_vm.isNew(props.row) && !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'pecs-with-items-stage',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        _vm.isDTTProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'choose-stage',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        _vm.isSimpleProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'current-stage',
                   params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isNew(props.row) || (!_vm.isCompleted(props.row) && !_vm.isNew(props.row) && _vm.isMensurationForbidden)  ||
                  (!_vm.isCompleted(props.row) && !_vm.isNew(props.row) && _vm.isClient) || _vm.isOnIndividualization(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'protocol-item', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isCompleted(props.row))?_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'results', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),_c('div',[_c('dl',{staticClass:"term_with_descr"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol_goal'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(props.row.protocol.goal))])])]),_vm._v(" "),_c('div',[_c('dl',{staticClass:"term_with_descr"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.area'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(props.row.protocol.skillField.name))])])])],1)}},{key:"title",fn:function(props){return _c('div',{},[(_vm.activeProtocolList(props.row.protocol.stages).length !== 1 &&
                !_vm.isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                !_vm.isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                !_vm.isPecsProtocol(props.row.protocol.teachingMethod.id) && !_vm.isCompleted(props.row) &&
                !_vm.isNew(props.row) &&
                !_vm.isMensurationForbidden  &&
                !_vm.isClient &&
                !_vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
          !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
          !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        (_vm.isChainProtocol(props.row.protocol.teachingMethod.id) || _vm.isShapingProtocol(props.row.protocol.teachingMethod.id) || _vm.isMandProtocol(props.row.protocol.teachingMethod.id)))?_c('router-link',{attrs:{"to":{ name: _vm.isChainProtocol(props.row.protocol.teachingMethod.id) ? 'chain-stage-current' : _vm.isShapingProtocol(props.row.protocol.teachingMethod.id) ? 'shaping-stage-current' : 'mand-stage-current',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
                   !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) && _vm.isUSDProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{attrs:{"to":{ name: 'choose-usd',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsProtocol(props.row.protocol.teachingMethod.id) && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'pecs-stage',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'pecs-stage-without-discrimination',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithItemsProtocol(props.row.protocol.teachingMethod.id) && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'pecs-stage-items',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(props.row.protocol.stages.length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        _vm.isUSDProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{attrs:{"to":{ name: 'choose-usd',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        _vm.isDTTProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{attrs:{"to":{ name: 'choose-stage',
                    params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList(props.row.protocol.stages).length === 1 && !_vm.isCompleted(props.row) && !_vm.isNew(props.row) &&
        !_vm.isMensurationForbidden  && !_vm.isClient && !_vm.isOnIndividualization(props.row) &&
        _vm.isSimpleProtocol(props.row.protocol.teachingMethod.id))?_c('router-link',{attrs:{"to":{ name: 'current-stage',
                   params: {clientId: _vm.clientId, protocolId: props.row.id, stageId:_vm.activeProtocolList(props.row.protocol.stages)[0].id}}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isNew(props.row) || (!_vm.isCompleted(props.row) && !_vm.isNew(props.row) && _vm.isMensurationForbidden)  ||
                    (!_vm.isCompleted(props.row) && !_vm.isNew(props.row) && _vm.isClient) || _vm.isOnIndividualization(props.row))?_c('router-link',{attrs:{"to":{ name: 'protocol-item', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e(),_vm._v(" "),(_vm.isCompleted(props.row))?_c('router-link',{attrs:{"to":{ name: 'results', params: {clientId: _vm.clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.protocol.title))])]):_vm._e()],1)}},{key:"status",fn:function(props){return _c('div',{},[_c('span',{staticClass:"status-badge",class:{'new-status' : _vm.isNew(props.row),
                        'individualize-status' : _vm.isIndividualize(props.row),
                        'active-status' : _vm.isActive(props.row),
                        'maintaining-status' : _vm.isMaintaining(props.row),
                        'completed-status' : _vm.isCompleted(props.row)}}),_vm._v("\n      "+_vm._s(_vm._f("trans")('protocol.statuses.' + props.row.status.name))+"\n    ")])}},{key:"action",fn:function(props){return (!_vm.isTherapist && !_vm.isClient)?_c('div',{},[_c('div',[_c('mdc-menu-anchor',[_c('mdc-button',{attrs:{"raised":""},on:{"click":function($event){props.row.isOpen = true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('mdc-menu',{model:{value:(props.row.isOpen),callback:function ($$v) {_vm.$set(props.row, "isOpen", $$v)},expression:"props.row.isOpen"}},[(!_vm.isCompleted(props.row) && !_vm.isMensurationForbidden && !_vm.isPreviousDateSession)?_c('mdc-menu-item',[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'protocol-edit', params: {clientId: _vm.clientId, protocolId: props.row.protocol.id, clientProtocol: true, isActiveProtocol: _vm.isNew(props.row)}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.edit'))+"\n              ")])],1):_vm._e(),_vm._v(" "),((_vm.isNew(props.row) || _vm.isOnIndividualization(props.row))&& !_vm.isMensurationForbidden)?_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showDeletePopup(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.delete')))])]):_vm._e(),_vm._v(" "),_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.exportProtocol(props.row.protocol.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.export')))])]),_vm._v(" "),_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.makeFirst(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.make_first')))])]),_vm._v(" "),_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.makeLast(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.make_last')))])]),_vm._v(" "),(_vm.isOnIndividualization(props.row))?_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.allowMensuration(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.allow_mensuration')))])]):_vm._e()],1)],1)],1)]):_vm._e()}}])}),_vm._v(" "),(!_vm.isTherapist && !_vm.onlyList && !_vm.isMensurationForbidden && !_vm.isPreviousDateSession)?_c('div',{staticClass:"row mt-2 mt-md-3"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onShowModalBtnClick($event)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.addNewProtocol'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[(_vm.isCurator || _vm.isBCBA)?_c('new-protocol-modal',{attrs:{"visible":_vm.isModalVisible,"clientId":this.clientId},on:{"close":_vm.onProtocolModalClose,"cancel":_vm.onModalCancel}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.onRemoveActiveProtocol(_vm.assignedProtocolId)},"cancel":_vm.onModalClose},model:{value:(_vm.isDeleteModalVisible),callback:function ($$v) {_vm.isDeleteModalVisible=$$v},expression:"isDeleteModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__ = __webpack_require__(102);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Bids API Manager.
 */
var BidsApiManager = /** @class */ (function (_super) {
    __extends(BidsApiManager, _super);
    function BidsApiManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create entity.
     *
     * @param {String} description
     * @param {String} comment
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.create = function (clientId, description) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!clientId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.axios.post(this.url, {
                                clientId: clientId,
                                description: description,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.axios.post(this.url, {
                            description: description,
                        })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list bids.
     *
     * @param {Number} userId
     * @param {Number} perPage
     * @param {Number} page
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.list = function (userId, perPage, page) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (userId) {
                            url = this.url + "/users/" + userId + "/" + perPage + "/" + page;
                        }
                        else {
                            url = this.url + "/" + perPage + "/" + page;
                        }
                        return [4 /*yield*/, this.axios.get(url, {
                                perPage: perPage,
                                page: page,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update entity.
     *
     * @param {Number} id
     * @param {String} description
     * @param {String} comment
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.update = function (id, description, comment) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/" + id;
                        return [4 /*yield*/, this.axios.put(url, {
                                description: description,
                                comment: comment,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get assign-entities.
     *
     * @param id
     * @param {String} search
     * @param {Number} perPage
     * @param {Number} page
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.searchId = function (id, search, perPage, page) {
        if (search === void 0) { search = ''; }
        if (perPage === void 0) { perPage = 1000; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/" + id + "/assign-entities";
                        return [4 /*yield*/, this.axios.get(url, {
                                params: {
                                    search: search,
                                    perPage: perPage,
                                    page: page
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create assign.
     *
     * @param {Number} bidId
     * @param {Number} assignedId
     * @param {String} assignedType
     * @param {String} comment
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.assign = function (bidId, assignedId, assignedType, comment, description) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/assign/";
                        return [4 /*yield*/, this.axios.post(url, {
                                bidId: bidId,
                                assignedId: assignedId,
                                assignedType: assignedType,
                                comment: comment,
                                description: description,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set viewed.
     *
     * @param {Number} bidId
     * @param {Number} assignedId
     *
     * @returns {Promise<any>}
     */
    BidsApiManager.prototype.viewed = function (bidId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url + "/" + bidId + "/viewed/";
                        return [4 /*yield*/, this.axios.put(url, {
                                bidId: bidId
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BidsApiManager;
}(__WEBPACK_IMPORTED_MODULE_0__user_api_managers_BaseApiManager__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (BidsApiManager);


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a65543c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1035);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a65543c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"bids-modal",attrs:{"title":_vm._f("trans")('bids.edit_bid')},on:{"accept":_vm.close,"close":_vm.close,"cancel":_vm.cancel,"validate":_vm.validate},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:10|max:1000'),expression:"'required|min:10|max:1000'"}],class:{'is-invalid': _vm.errors.has('goal')},attrs:{"id":"goal","label":_vm._f("trans")('bids.protocol_goal'),"type":"text","name":"goal","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('bids.protocol_goal')},model:{value:(_vm.bid.description),callback:function ($$v) {_vm.$set(_vm.bid, "description", $$v)},expression:"bid.description"}}),_vm._v(" "),(_vm.errors.has('goal'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('goal')))])]):_vm._e()],1)]),_vm._v(" "),(!_vm.isTherapist)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('select-with-pager',{staticClass:"load_more__select aut-dropdown",attrs:{"id":"entities","name":"entities","label":'name',"selected":_vm.protocol,"options":_vm.entities,"searchable":true,"loading":_vm.loading,"isLastPage":_vm.isLastPage,"getOptionTitle":_vm.getOptionTitle,"isLast":_vm.isLast,"validated":_vm.validated,"noOptions":_vm._f("trans")('bids.type_the_procol_name_to_search')},on:{"next-page":_vm.nextPage,"set-selected":_vm.onChangeProcol,"set-search":_vm.onSearchProcol}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('protocol') }},[_vm._v(_vm._s(_vm._f("trans")('bids.appoint_protocol')))]),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('bids.start_protocol')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('protocol'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('protocol')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:255'),expression:"'max:255'"}],class:{'is-invalid': _vm.errors.has('comment')},attrs:{"id":"comment","label":_vm._f("trans")('bids.add_comment'),"type":"text","name":"comment","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('bids.add_comment')},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),(_vm.errors.has('comment'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('comment')))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[(_vm.bid.comments != null && _vm.bid.comments.count > 0)?_c('div',{staticClass:"text-block"},[_c('p',{staticClass:"text-block__title"},[_vm._v(_vm._s(_vm._f("trans")('bids.comments')))]),_vm._v(" "),_vm._l((_vm.bid.comments.data),function(commentary){return _c('div',[_c('p',{staticClass:"text-block__subtitle"},[_vm._v("\n            "+_vm._s(commentary.user.name)+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"text-block__text"},[_vm._v("\n            "+_vm._s(commentary.text)+"\n          ")])])})],2):_vm._e()])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.cancel')))]),_vm._v(" "),(!_vm.isTherapist)?_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{ name: 'protocol-create'}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('bids.buttons.createProtocol'))+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.isTherapist)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onAppointProtocolButtonClick()}}},[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.appointProtocol')))]):_vm._e(),_vm._v(" "),(_vm.isCurator || _vm.isTherapist)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onApprovalButtonClick()}}},[(_vm.isTherapist)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.sendRequest')))]):_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.submit_for_approval_to_bsba')))])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewModal_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2c3b10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewModal_vue__ = __webpack_require__(1037);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2c3b10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"bids-modal",attrs:{"title":_vm._f("trans")('bids.view_bid')},on:{"cancel":_vm.cancel,"close":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":_vm.cancel}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"text-block"},[_c('p',{staticClass:"text-block__subtitle"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('bids.protocol_goal'))+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"text-block__text"},[_vm._v("\n          "+_vm._s(_vm.bid.description)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[(_vm.bid.comments != null)?_c('div',{staticClass:"text-block"},[_c('hr'),_vm._v(" "),_c('p',{staticClass:"text-block__title"},[_vm._v(_vm._s(_vm._f("trans")('bids.comments')))]),_vm._v(" "),(_vm.bid.comments.count > 0)?_c('div',_vm._l((_vm.bid.comments.data),function(commentary){return _c('div',[_c('p',{staticClass:"text-block__subtitle"},[_vm._v("\n              "+_vm._s(commentary.user.name)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-block__text"},[_vm._v("\n              "+_vm._s(commentary.text)+"\n            ")])])})):_c('p',{staticClass:"text-block__text"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('bids.no_data'))+"\n        ")])]):_vm._e()])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.cancel')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e9672a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__ = __webpack_require__(1039);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e9672a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"bids-modal",attrs:{"title":_vm._f("trans")('bids.request_new_protocol')},on:{"cancel":_vm.cancel,"close":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":_vm.cancel}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:10|max:1000'),expression:"'required|min:10|max:1000'"}],class:{'is-invalid': _vm.errors.has('description')},attrs:{"id":"description","label":_vm._f("trans")('bids.write_protocol_goal'),"type":"text","name":"description","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('bids.comment'),"multiline":"","rows":"8","cols":"40"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),(_vm.errors.has('description'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('description')))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.description.length)+"/1000")])],1)]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm._f("trans")('bids.buttons.cancel')))]),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onSendRequestButtonClick()}}},[(_vm.isTherapist)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.sendRequest')))]):_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.sendRequest')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bids"},[(_vm.isTherapist)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('bids.bids')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.state.created)?_c('div',{staticClass:"col-md-12",class:{'without-btn': !_vm.addBidBlockShouldBeVisible}},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('div',{},[_c('div',{staticClass:"icon-circle icon-orange"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm._f("trans")('bids.bid'))+" #"+_vm._s(props.row.index))])])}},{key:"icon",fn:function(props){return _c('div',{},[_c('div',{staticClass:"icon-circle icon-orange"},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.Z')))])])])}},{key:"description",fn:function(props){return _c('div',{},[_c('div',{staticClass:"d-flex row"},[_c('div',{staticClass:"col-md-5"},[_c('b',[_vm._v(_vm._s(_vm._f("trans")('bids.bid'))+" #"+_vm._s(props.row.index))])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('span',{staticClass:"comments-btn"},[_vm._v(_vm._s(_vm._f("trans")('bids.comments'))+": "+_vm._s(props.row.comments.count))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex row"},[_c('div',{staticClass:"col-md-5"},[_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm._f("trans")('bids.short_description'))+":")])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('span',{staticClass:"bids-description__text"},[_vm._v(_vm._s(_vm._f("shortText")(props.row.description,_vm.shortTextLength)))])])])])}},{key:"client",fn:function(props){return (!_vm.isClient)?_c('div',{},[_c('router-link',{attrs:{"to":{ name: 'client-edit', params: { clientId: props.row.client.id }}}},[_vm._v("\n            "+_vm._s(props.row.client.code)+"\n          ")])],1):_vm._e()}},{key:"initiator",fn:function(props){return _c('div',{},[(props.row.initiator && props.row.initiator.isTherapist)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.therapist')))]):_c('span',[_vm._v(_vm._s(_vm._f("trans")('bids.parent')))]),_vm._v(":\n          "),_c('p',[_vm._v(_vm._s(props.row.initiator ? props.row.initiator.fullName : props.row.client.fullName))])])}},{key:"status",fn:function(props){return _c('div',{},[(props.row.isOverdue)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm._f("trans")('bids.overdue'))+"!")]):_vm._e(),_vm._v("\n          "+_vm._s(_vm._f("trans")(("bids.statuses." + (props.row.status.name))))+"\n        ")])}},{key:"therapist",fn:function(props){return (!_vm.isClient)?_c('div',{},_vm._l((props.row.therapists),function(therapist){return _c('span',{key:therapist.id},[(!_vm.isTherapist)?_c('router-link',{attrs:{"to":{ name: 'therapist-edit', params: { therapistId: therapist.id }}}},[_c('div',[_vm._v(_vm._s(therapist.fullName))])]):_vm._e(),_vm._v(" "),(_vm.isTherapist)?_c('div',[_vm._v(_vm._s(therapist.fullName))]):_vm._e()],1)})):_vm._e()}},{key:"change_date",fn:function(props){return _c('div',{},[(props.row.updatedAt)?_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row.updatedAt.date)))]):_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row.createdAt.date)))])])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.isEditable && !_vm.isClient  && !_vm.isMensurationForbidden)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onEditBtnClick(props.row)}}},[_c('mdc-icon',{attrs:{"icon":"edit"}})],1):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onViewBtnClick(props.row)}}},[_c('mdc-icon',{attrs:{"icon":"info"}})],1)])}},{key:"descriptionList",fn:function(props){return _c('div',{},[_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")(("bids.statuses." + (props.row.status.name)))))]),_vm._v(" "),(props.row.isOverdue)?_c('p',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('bids.overdue'))+"!")]):_vm._e()]),_vm._v(" "),(_vm.isClient)?_c('div',{staticClass:"pt-2"},[_c('span',{staticClass:"comments-btn"},[_vm._v(_vm._s(_vm._f("trans")('bids.comments'))+": "+_vm._s(props.row.comments.count))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pt-2"},[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('bids.short_description'))+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("shortText")(props.row.description,_vm.shortTextLength)))])]),_vm._v(" "),_c('div',{staticClass:"pt-2"},[_c('p',[_c('span',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('bids.initiator'))+":")]),_vm._v("\n                "+_vm._s(props.row.initiator ? props.row.initiator.fullName : ''))])]),_vm._v(" "),(!_vm.isClient)?_c('p',{staticClass:"pt-2"},[_c('span',{staticClass:"gray-dark"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('bids.therapist'))+":\n              ")]),_vm._v(" "),_vm._l((props.row.therapists),function(therapist){return _c('span',{key:therapist.id},[_c('div',[_vm._v(_vm._s(therapist.fullName))])])})],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pt-2"},[_c('span',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('bids.create_date'))+":")]),_vm._v(" "),(props.row.updatedAt)?_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row.updatedAt.date)))]):_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(props.row.createdAt.date)))])])])])}}])})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[(_vm.addBidBlockShouldBeVisible)?_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onAddBtnClick($event)}}},[_vm._v(_vm._s(_vm._f("trans")('bids.buttons.request_new_protocol_or_module'))+"\n      ")])],1):_vm._e()]),_vm._v(" "),_c('bids-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}}),_vm._v(" "),_c('bids-view-modal',{attrs:{"visible":_vm.isViewModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}}),_vm._v(" "),_c('bids-add-modal',{attrs:{"visible":_vm.isAddModalVisible,"clientId":_vm.modal.clientId},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.active_protocols')))]),_vm._v(" "),_c('assigned-protocol-list',{attrs:{"clientId":_vm.clientId,"onlyList":_vm.onlyList}}),_vm._v(" "),_c('h2',{staticClass:"title mt-4"},[_vm._v(_vm._s(_vm._f("trans")('bids.bids_for_protocols')))]),_vm._v(" "),_c('bids-list',{attrs:{"userId":_vm.clientId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableProtocolLayout_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef9c1170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableProtocolLayout_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableProtocolLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef9c1170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableProtocolLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('div',{staticClass:"mdc-tab-bar-wrapp"},[(_vm.loaded)?_c('nav',{staticClass:"mdc-tab-bar mdc-tab-bar-upgraded"},[_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active': 'protocol-item' === _vm.route.name},attrs:{"to":{name: 'protocol-item'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.header')))])]),_vm._v(" "),(_vm.activeProtocolList.length != 1 &&
                                !_vm.isPecsWithItems() &&
                                !_vm.isPecs() &&
                                !_vm.isPecsWithoutDiscrimination() &&
                                !_vm.isCompleted() &&
                                !_vm.isMensurationForbidden &&
                                !_vm.isClient &&
                                !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'current-stage' === _vm.route.name ||
                                'choose-stage' === _vm.route.name ||
                                'mastering-stage' === _vm.route.name ||
                                'rotation-stage' === _vm.route.name ||
                                'fluency-stage' === _vm.route.name ||
                                'maintain-stage' === _vm.route.name ||
                                'stage-list' === _vm.route.name ||
                                'mand-stage-current' === _vm.route.name ||
                                'choose-usd' === _vm.route.name ||
                                'pecs-with-discrimination-stage' === _vm.route.name ||
                                'shaping-stage-current' === _vm.route.name ||
                                'chain-stage-current' === _vm.route.name ||
                                'mastering-stage-usd' === _vm.route.name ||
                                'maintain-stage-usd' === _vm.route.name},attrs:{"to":{name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length === 1 &&
                           !_vm.isPecsWithItems() &&
                           !_vm.isPecsWithDiscrimination() &&
                           !_vm.isPecs() &&
                           !_vm.isPecsWithoutDiscrimination() &&
                           !_vm.isUSD() &&
                           !_vm.isDtt()  &&
                           !_vm.isSimple() &&
                           !_vm.isCompleted() &&
                           !_vm.isMensurationForbidden &&
                           !_vm.isClient &&
                           !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'mand-stage-current' === _vm.route.name ||
                                'shaping-stage-current' === _vm.route.name ||
                                'chain-stage-current' === _vm.route.name ||
                                'shaping-stage-current' === _vm.route.name ||
                                'chain-stage-current' === _vm.route.name ||
                                'pecs-with-discrimination-stage' === _vm.route.name ||
                                'mand-stage-current' === _vm.route.name},attrs:{"to":{ name: _vm.isChain() ? 'chain-stage-current' : _vm.isShaping() ? 'shaping-stage-current' : 'mand-stage-current',
                            params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.activeProtocolList[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length === 1 &&
                           _vm.isUSD() &&
                           !_vm.isCompleted() &&
                           !_vm.isMensurationForbidden &&
                           !_vm.isClient &&
                           !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'choose-usd' === _vm.route.name ||
                                'mastering-stage-usd' === _vm.route.name ||
                                'maintain-stage-usd' === _vm.route.name},attrs:{"to":{ name: 'choose-usd',
                  params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.activeProtocolList[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length === 1 &&
                           _vm.isDtt() &&
                           !_vm.isCompleted() &&
                           !_vm.isMensurationForbidden &&
                           !_vm.isClient &&
                           !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'mastering-stage' === _vm.route.name ||
                                'rotation-stage' === _vm.route.name ||
                                'fluency-stage' === _vm.route.name ||
                                'maintain-stage' === _vm.route.name ||
                                'choose-stage' === _vm.route.name},attrs:{"to":{ name: 'choose-stage',
                  params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.activeProtocolList[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.isPecs() && !_vm.isCompleted() && !_vm.isMensurationForbidden && !_vm.isClient && !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'pecs-stage' === _vm.route.name},attrs:{"to":{ name: 'pecs-stage',
                  params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.protocol.protocol.stages[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscrimination() && !_vm.isCompleted() && !_vm.isMensurationForbidden && !_vm.isClient && !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'pecs-stage-without-discrimination' === _vm.route.name},attrs:{"to":{ name: 'pecs-stage-without-discrimination',
                  params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.protocol.protocol.stages[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length === 1 && _vm.isPecsWithDiscrimination() && !_vm.isCompleted() && !_vm.isMensurationForbidden && !_vm.isClient && !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'pecs-with-discrimination-stage' === _vm.route.name},attrs:{"to":{ name: 'pecs-with-discrimination-stage',
                  params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.protocol.protocol.stages[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.isPecsWithItems() &&
                           !_vm.isCompleted() &&
                           !_vm.isMensurationForbidden &&
                           !_vm.isClient &&
                           !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                           'pecs-with-items-stage' === _vm.route.name},attrs:{"to":{ name: 'pecs-with-items-stage',
                           params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.protocol.protocol.stages[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length === 1 &&
                           _vm.isSimple() &&
                           !_vm.isCompleted() &&
                           !_vm.isMensurationForbidden &&
                           !_vm.isClient &&
                           !_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active':
                                'current-stage' === _vm.route.name},attrs:{"to":{ name: 'current-stage',
                 params: {clientId: _vm.clientId, protocolId: _vm.protocolId, stageId:_vm.activeProtocolList[0].id}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.exercises')))])]):_vm._e(),_vm._v(" "),(!_vm.isOnIndividualization())?_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active': 'results' === _vm.route.name},attrs:{"to":{name: 'results'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.results')))])]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-light back btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client')))]),_vm._v(" "),(_vm.loaded && (_vm.clientId || _vm.assignedProtocolId))?_c('span',[_vm._v(_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded && _vm.protocol)?_c('router-view',{key:_vm.route.key,attrs:{"protocolData":_vm.protocol,"clientData":_vm.client,"teachingMethod":_vm.teachingMethodId,"client":_vm.client,"clientId":_vm.clientId || _vm.assignedProtocolId}}):_vm._e()],1)]),_vm._v(" "),(_vm.assignedProtocolId && _vm.client)?_c('dashboard-menu',{attrs:{"clientId":_vm.assignedProtocolId,"clientData":_vm.client,"hideDroModal":_vm.hideDroModal,"checkHasAccess":_vm.checkHasAccess,"checkedHasAccess":_vm.hasAccess}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppealsList_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c72e8b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppealsList_vue__ = __webpack_require__(1071);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppealsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c72e8b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppealsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTypicalAppealsModal_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395a742d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTypicalAppealsModal_vue__ = __webpack_require__(1047);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTypicalAppealsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395a742d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTypicalAppealsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"appeals-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('appeals.edit_typical_client_appeals'),"accept":_vm._f("trans")('appeals.buttons.saveAppeal'),"accept-disabled":_vm.isMensurationForbidden},on:{"cancel":_vm.cancel,"close":_vm.close,"validate":_vm.validate},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('appeals.edit_typical_appeals_short')))])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.validate()}}},[_c('mdc-icon',{staticClass:"done",attrs:{"icon":"done"}})],1)]):_vm._e()],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalAppealsTemp),function(appeal,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n        "+_vm._s(appeal.text)+"\n\n\n        "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.removeAppeal(index,appeal)}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:100'),expression:"'min:1|max:100'"}],class:{'is-invalid': _vm.errors.has('newTypicalAppeal'  || 'isNotUnique' || 'isMaxLengthAppeals' || 'isEmptyError')},attrs:{"name":"newTypicalAppeal","disabled":_vm.isMensurationForbidden,"type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('appeals.type_new_appeal'),"label":_vm._f("trans")('appeals.type_new_appeal')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addAppeal($event)}},model:{value:(_vm.newTypicalAppeal.text),callback:function ($$v) {_vm.$set(_vm.newTypicalAppeal, "text", $$v)},expression:"newTypicalAppeal.text"}})],1),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addAppeal()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('newTypicalAppeal') || _vm.errors.has('isNotUnique') || _vm.errors.has('isMaxLengthAppeals') || _vm.errors.has('server') || _vm.errors.has('isEmptyError'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalAppeal') || _vm.errors.first('isNotUnique') || _vm.errors.first('isMaxLengthAppeals') || _vm.errors.first('isEmptyError')  || _vm.errors.first('server')))])]):_vm._e()])]),_vm._v(" "),(_vm.isMobile)?_c('footer',{staticClass:"col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button","disabled":_vm.isMensurationForbidden},on:{"click":function($event){_vm.validate()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.saveAppeal')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_round__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lang_translator__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChart',
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: {
    withLegend: {
      required: false,
      type: [Boolean],
      default: false
    },
    datasets: {
      required: true,
      type: [Array, Object]
    },
    linedatasets: {
      required: false,
      type: [Array, Object]
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function _default() {
        return {
          display: false
        };
      }
    },
    listChartDate: {
      required: false,
      type: [Array, Object]
    },
    manyChart: {
      required: false,
      type: [Boolean],
      default: false
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    isMobile: {
      required: false,
      type: [Boolean],
      default: false
    },
    labelText: {
      required: false,
      type: [String],
      default: ""
    },
    withoutMax: {
      required: false,
      type: [Boolean],
      default: false
    },
    persentMax: {
      required: false,
      type: [Boolean, String],
      default: false
    },
    valueMax: {
      required: false,
      type: [Number, String],
      default: null
    },
    isXAxis: {
      required: false,
      type: [Boolean],
      default: true
    },
    isValueType: {
      required: false,
      type: [Boolean],
      default: false
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true
    },
    chartId: '',
    stageInfo: null,
    categoryInfo: null
  },
  mounted: function mounted() {
    this.render();
  },

  plugins: [__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default.a, __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default.a],
  methods: {
    render: function render() {
      var _this = this;

      var withLegend = this.withLegend;
      var lastHoveredIndex = 0;

      var max = 0;
      if (this.datasets && !this.manyChart && !this.persentMax) {
        var maxLineDatasets = __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(this.datasets[0].data, function (item) {
          return item.y;
        });
        if (maxLineDatasets) {
          if (this.withoutMax) {
            if (maxLineDatasets.y < 1) {
              max = maxLineDatasets.y * 1.3;
            } else {
              max = __WEBPACK_IMPORTED_MODULE_9_lodash_round___default()(maxLineDatasets.y * 1.3 / 5, 1) * 5;
            }
          } else {
            max = maxLineDatasets.y * 1.3 < 100 ? __WEBPACK_IMPORTED_MODULE_9_lodash_round___default()(maxLineDatasets.y * 1.3 / 5, 2) * 5 : 105;
          }
        }
      }

      if (this.datasets && this.manyChart && !this.persentMax) {
        var maxLineDatasetsList = [];
        var _maxLineDatasets = 0;

        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.datasets, function (chart) {
          var max = __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(chart.data, function (item) {
            return item.y;
          });
          maxLineDatasetsList.push(max.y);
        });

        _maxLineDatasets = __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default()(maxLineDatasetsList);
        if (_maxLineDatasets) {
          if (this.withoutMax) {
            if (_maxLineDatasets < 1) {
              max = _maxLineDatasets * 1.3;
            } else {
              max = __WEBPACK_IMPORTED_MODULE_9_lodash_round___default()(_maxLineDatasets * 1.3 / 5, 1) * 5;
            }
          } else {
            max = _maxLineDatasets * 1.3 < 100 ? __WEBPACK_IMPORTED_MODULE_9_lodash_round___default()(_maxLineDatasets * 1.3 / 5, 1) * 5 : 105;
          }
        }
      }

      if (this.persentMax) {
        max = 110;
      }

      var pointArray = [];

      var manyChart = this.manyChart;

      if (this.isValueType) {

        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.verticalLinePoint, function (point, index) {
          pointArray.push({
            id: point.id,
            type: point.type,
            mode: point.mode,
            scaleID: point.scaleID,
            value: point.value,
            borderColor: point.borderColor,
            borderDash: point.borderDash,
            borderWidth: point.borderWidth,
            onMouseover: function onMouseover(e) {
              var element = this;
              //element.options.label.content = '';
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }

              tooltipEl.innerHTML = '<div>' + point.label.contentLong + '</div>';

              element.chartInstance.update();
            },
            onMouseout: function onMouseout(e) {
              var element = this;
              element.options.label.content = point.label.content;
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              if (tooltipEl) {
                tooltipEl.parentNode.removeChild(tooltipEl);
              }
              element.chartInstance.update();
            },
            label: {
              content: point.label.content,
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: 10,
              xAdjust: index == 0 ? -30 : 0
            }
          });
        });
      } else {

        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.verticalLinePoint, function (point, index) {

          pointArray.push({
            id: "vertLine" + index,
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: point.x,
            borderColor: "black",
            borderDash: point.isImportant ? 0 : [5, 5],
            borderWidth: 2,
            onMouseover: function onMouseover(e) {
              var element = this;
              //element.options.label.content = '';
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }

              tooltipEl.innerHTML = '<div>' + point.comment + '</div>';
              element.chartInstance.update();
            },
            onMouseout: function onMouseout(e) {
              var element = this;
              element.options.label.content = point.comment.substr(0, 5);
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              if (tooltipEl) {
                tooltipEl.parentNode.removeChild(tooltipEl);
              }
              element.chartInstance.update();
            },
            label: {
              content: point.comment.substr(0, 5),
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: index % 3 === 1 ? 10 : index % 3 === 2 ? 50 : 80,
              xAdjust: index === 0 ? -40 : 0
            }
          });
        });
      }

      var labels = [];

      if (this.datasets && this.listChartDate) {
        labels = this.listChartDate;
      } else {

        labels = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.datasets, function (dataset) {
          return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(dataset.data, function (item) {
            return item.x;
          });
        })));
      }

      var dataset = [];

      if (this.linedatasets) {
        __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.linedatasets, function (item) {
          dataset.push(item);
        });
        dataset.push(this.datasets[0]);
      }

      var _label2 = this.labelText;
      var chartId = this.chartId;
      var valueMax = this.valueMax;

      this.renderChart({
        labels: labels,
        datasets: this.linedatasets ? dataset : this.datasets
      }, {
        animation: {
          duration: this.animationDuration
        },
        layout: {
          padding: {
            left: 30,
            right: 50,
            top: 0,
            bottom: 0
          }
        },
        'onClick': function onClick(evt, item) {
          if (item[0]) {
            var tooltipEl = document.getElementById('chartjs-tooltip' + chartId);
            if (tooltipEl) {
              tooltipEl.parentNode.removeChild(tooltipEl);
            }
            var index = item[0]['_index'];
            var datasetIndex = lastHoveredIndex ? lastHoveredIndex : item[0]['_datasetIndex'];
            var point = _this.datasets[0].data[index];
            var _label = _this.datasets[0].label;
            _this.$emit('popup-show', point, _this.stageInfo, datasetIndex, _this.categoryInfo);
          }
        },
        responsive: true,
        tooltips: {
          enabled: false,
          title: '',
          titleFontColor: 'transparent',
          titleFontSize: 0,
          titleMarginBottom: 0,
          custom: function custom(tooltip) {

            // Tooltip Element
            var tooltipEl = document.getElementById('chartjs-tooltip' + chartId);

            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip' + chartId;
              tooltipEl.innerHTML = '<table></table>';
              this._chart.canvas.parentNode.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltip.yAlign) {
              tooltipEl.classList.add(tooltip.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            function getDataPoints(bodyItem) {
              return bodyItem.datasetIndex;
            }

            // Set Text
            if (tooltip.body) {
              var titleLines = [];
              var bodyLines = tooltip.body.map(getBody);
              var valuePoint = tooltip.dataPoints.map(getDataPoints);

              var innerHtml = '<tbody>';

              if (manyChart) {
                bodyLines.forEach(function (body, i) {
                  var colors = tooltip.labelColors[i];
                  var style = 'background:' + colors.backgroundColor;
                  var datasetPoint = valuePoint[i];

                  var span = '<span class="chartjs-tooltip-key chartjs-tooltip-key-' + datasetPoint + '"></span>';
                  innerHtml += '<tr><td>' + span + body + '</td></tr>';
                });
              } else {
                var colors = tooltip.labelColors[0];
                var style = 'background:' + colors.backgroundColor;
                var datasetPoint = valuePoint[valuePoint.length - 1];

                var span = '<span class="chartjs-tooltip-key chartjs-tooltip-key-' + datasetPoint + '"></span>';
                innerHtml += '<tr><td>' + span + bodyLines[bodyLines.length - 1] + '</td></tr>';
              }

              innerHtml += '</tbody>';

              var tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }

            var positionY = this._chart.canvas.offsetTop;
            var positionX = this._chart.canvas.offsetLeft;

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = positionX + tooltip.caretX + 'px';
            tooltipEl.style.top = positionY + tooltip.caretY + 'px';
            tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
            tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
            tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
          },
          callbacks: {
            // Use the footer callback to display the sum of the items showing in the tooltip
            label: function label(tooltipItem, data) {

              lastHoveredIndex = tooltipItem.datasetIndex;

              return __WEBPACK_IMPORTED_MODULE_9_lodash_round___default()(tooltipItem.yLabel, 2) + _label2;
            }
          }
        },
        maintainAspectRatio: this.aspectRatio,
        aspectRatio: this.aspectRatio ? 1.6 : false,
        //showAllTooltips: true,
        legend: {
          display: this.showLegend,
          position: this.isMobile ? 'bottom' : 'right',
          labels: {
            usePointStyle: true,
            padding: 20
          },
          fullWidth: false,
          onHover: function onHover(e) {
            e.target.style.cursor = 'pointer';
          }
        },
        legendCallback: function legendCallback(chart) {
          if (withLegend) {
            var text = [];
            text.push('<ul class="' + chart.id + '-legend">');
            for (var i = 0; i < chart.data.datasets.length; i++) {
              text.push('<li><span class="chart-legend ' + chart.data.datasets[i].pointStyle + '"></span>');
              if (chart.data.datasets[i].label) {
                text.push(chart.data.datasets[i].label);
              }
              text.push('</li>');
            }
            text.push('</ul>');
            return text.join("");
          }
        },

        annotation: {
          events: ['dblclick', 'mouseover', 'mouseout'],
          annotations: pointArray
        },
        scales: {
          yAxes: [{
            afterTickToLabelConversion: function afterTickToLabelConversion(scaleInstance) {

              if (!valueMax) {
                scaleInstance.ticks[0] = null;
                scaleInstance.ticksAsNumbers[0] = null;
              }

              scaleInstance.ticks[scaleInstance.zeroLineIndex + 1] = null;
            },

            ticks: {
              beginAtZero: this.yAxesBeginAtZero,
              min: valueMax ? -valueMax / 30 : this.persentMax ? -5 : max > 0 ? -max / 30 : -0.05,
              max: valueMax ? valueMax : max ? max : 1,
              display: true
              //stepSize: max < 100 ? toInteger(max/5) : null
            },
            //stacked: true,
            scaleLabel: {
              display: true,
              labelString: this.scaleLabel
            },
            gridLines: {
              zeroLineColor: 'rgba(0,0,0,0)',
              //display: false,
              zeroLineBorderDashOffset: 0.5
              //offsetGridLines: true
            }
          }],
          xAxes: [{
            gridLines: {
              //zeroLineWidth: 2,
              //offsetGridLines: true,
              //display: false,
              zeroLineBorderDashOffset: 0.5
            },
            ticks: {
              display: !this.isMobile,
              maxRotation: 20,
              callback: function callback(dataLabel, index) {

                var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(dataLabel, '_');
                // Hide the text after _
                return value[0];
              }
            },
            scaleLabel: {
              display: true,
              labelString: __WEBPACK_IMPORTED_MODULE_11__lang_translator__["a" /* default */].get('report.day_session')
            }
          }]
        },
        plugins: {
          datalabels: {
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 4,
            color: 'white',
            align: 'end',
            offset: 8,
            display: false, /*function(context) {
                            let index = context.dataIndex;
                            let value = context.dataset.data[index];
                            return value.y > 0;
                            },*/
            formatter: function formatter(value, context) {
              return value.x + ": " + value.y;
            }
          }
        }

      });
      var HTML = this.$data._chart.generateLegend();
      this.$emit('generated', HTML);
    }
  },
  watch: {
    datasets: function datasets() {
      this.render();
    },
    linedatasets: function linedatasets() {
      this.render();
    }
  }

});

/***/ }),
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_split__);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChart',
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: {
    datasets: {
      required: true,
      type: [Array, Object]
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function _default() {
        return {
          display: false
        };
      }
    },
    yLabels: {
      required: true,
      type: [Array, Object]
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true
    },
    stageInfo: null

  },
  mounted: function mounted() {
    this.render();
  },

  plugins: [__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default.a, __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default.a],
  methods: {
    render: function render() {
      var _this = this;

      var lastHoveredIndex = 0;

      var xLabels = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.datasets, function (dataset) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(dataset.data, function (item) {
          return item.x;
        });
      })));

      var dataset = [];

      this.renderChart({
        xLabels: xLabels,
        yLabels: this.yLabels,
        datasets: this.datasets
      }, {
        animation: {
          duration: this.animationDuration
        },
        layout: {
          padding: {
            left: 30,
            right: 40,
            top: 0,
            bottom: 0
          }
        },
        'onClick': function onClick(evt, item) {
          if (item[0]) {
            var index = item[0]['_index'];
            var datasetIndex = item[0]['_datasetIndex'];
            var point = _this.datasets[0].data[index];
            var label = _this.datasets[0].label;
            _this.$emit('popup-show', point, _this.stageInfo, lastHoveredIndex);
          }
        },
        responsive: true,
        tooltips: {
          callbacks: {
            // Use the footer callback to display the sum of the items showing in the tooltip
            label: function label(tooltipItem, data) {
              lastHoveredIndex = tooltipItem.datasetIndex;

              return tooltipItem.yLabel;
            }
          }
        },
        maintainAspectRatio: this.aspectRatio,
        aspectRatio: this.aspectRatio ? 1.6 : false,
        showAllTooltips: true,
        legend: {
          display: this.showLegend,
          position: 'bottom'
        },
        scales: {
          yAxes: [{
            type: 'category',
            position: 'left',
            display: true,
            ticks: {
              reverse: true
            },
            scaleLabel: {
              display: true,
              labelString: this.scaleLabel
            }
          }],
          xAxes: [{
            ticks: {
              display: !this.isMobile,
              callback: function callback(dataLabel, index) {

                var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(dataLabel, '_');
                // Hide the text after _
                return value[0];
              }
            },
            scaleLabel: {
              display: true,
              labelString: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.day_session')
            }
          }]
        },
        plugins: {
          datalabels: {
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 4,
            color: 'white',
            align: 'end',
            offset: 8,
            display: false, /*function(context) {
                            let index = context.dataIndex;
                            let value = context.dataset.data[index];
                            return value.y > 0;
                            },*/
            formatter: function formatter(value, context) {
              return value.x + ": " + value.y;
            }
          }
        }
      });
    }
  },
  watch: {
    datasets: function datasets() {
      this.render();
    }
  }

});

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pick__);



var _class = function _class(_ref) {
  var data = _ref.data,
      label = _ref.label,
      _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? false : _ref$fill,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === undefined ? '#000' : _ref$borderColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? '#000' : _ref$backgroundColor,
      _ref$borderCapStyle = _ref.borderCapStyle,
      borderCapStyle = _ref$borderCapStyle === undefined ? 'butt' : _ref$borderCapStyle,
      _ref$borderJoinStyle = _ref.borderJoinStyle,
      borderJoinStyle = _ref$borderJoinStyle === undefined ? 'miter' : _ref$borderJoinStyle,
      _ref$lineTension = _ref.lineTension,
      lineTension = _ref$lineTension === undefined ? 0 : _ref$lineTension,
      _ref$pointRadius = _ref.pointRadius,
      pointRadius = _ref$pointRadius === undefined ? 2 : _ref$pointRadius,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === undefined ? 2 : _ref$borderWidth,
      _ref$pointBorderWidth = _ref.pointBorderWidth,
      pointBorderWidth = _ref$pointBorderWidth === undefined ? 5 : _ref$pointBorderWidth,
      _ref$pointHoverRadius = _ref.pointHoverRadius,
      pointHoverRadius = _ref$pointHoverRadius === undefined ? 3 : _ref$pointHoverRadius,
      _ref$pointBackgroundC = _ref.pointBackgroundColor,
      pointBackgroundColor = _ref$pointBackgroundC === undefined ? '#000' : _ref$pointBackgroundC,
      _ref$pointBorderColor = _ref.pointBorderColor,
      pointBorderColor = _ref$pointBorderColor === undefined ? '#000' : _ref$pointBorderColor,
      _ref$pointStyle = _ref.pointStyle,
      pointStyle = _ref$pointStyle === undefined ? 'rect' : _ref$pointStyle,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'line' : _ref$type,
      _ref$borderDash = _ref.borderDash,
      borderDash = _ref$borderDash === undefined ? [] : _ref$borderDash;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

  this.data = data;
  this.label = label;
  this.fill = fill;
  this.borderColor = borderColor;
  this.backgroundColor = backgroundColor;
  this.borderCapStyle = borderCapStyle;
  this.borderJoinStyle = borderJoinStyle;
  this.lineTension = lineTension;
  this.pointRadius = pointRadius;
  this.borderWidth = borderWidth;
  this.pointBorderWidth = pointBorderWidth;
  this.pointHoverRadius = pointHoverRadius;
  this.pointBackgroundColor = pointBackgroundColor;
  this.pointBorderColor = pointBorderColor;
  this.pointStyle = pointStyle;
  this.type = type;
  this.borderDash = borderDash;
};

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_toInteger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_toInteger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lang_translator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_split__);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChart',
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: {
    datasets: {
      required: true,
      type: [Array, Object]
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true
    },
    yAxesBeginAtZero: {
      required: false,
      type: [Boolean],
      default: false
    },
    animationDuration: {
      required: false,
      type: [Number],
      default: 0
    },
    scaleLabel: {
      required: false,
      type: [Array, Object, String],
      default: function _default() {
        return {
          display: false
        };
      }
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    yLabels: {
      required: true,
      type: [Array, Object]
    },
    listChartDate: {
      required: false,
      type: [Array, Object],
      default: null
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true
    },
    stageInfo: null,
    allAxisShow: {
      required: false,
      type: [Boolean],
      default: false
    },
    xAxisLabel: {
      required: false,
      type: [String],
      default: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('report.day_session')
    }

  },
  mounted: function mounted() {
    this.render();
  },

  plugins: [__WEBPACK_IMPORTED_MODULE_4_chartjs_plugin_datalabels___default.a, __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default.a],
  methods: {
    render: function render() {
      var lastHoveredIndex = 0;
      var xLabels = [];
      if (this.listChartDate) {
        xLabels = this.listChartDate;
      } else {
        xLabels = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_flattenDeep___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.datasets, function (dataset) {
          return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(dataset.data, function (item) {
            return item.x;
          });
        })));
      }

      var dataset = [];
      var allAxisShow = this.allAxisShow;

      var pointArray = [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.verticalLinePoint, function (point, index) {

        pointArray.push({
          id: "vertLine" + index,
          type: "line",
          mode: "vertical",
          scaleID: "x-axis-0",
          value: point.x,
          borderColor: "black",
          borderDash: point.isImportant ? 0 : [5, 5],
          borderWidth: 2,
          onMouseover: function onMouseover(e) {
            var element = this;
            //element.options.label.content = '';
            var tooltipEl = document.getElementById('chartjs-tooltip-vertical');

            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip-vertical';
              element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
            }

            tooltipEl.innerHTML = '<div>' + point.comment + '</div>';
            element.chartInstance.update();
          },
          onMouseout: function onMouseout(e) {
            var element = this;
            element.options.label.content = point.comment.substr(0, 5);
            var tooltipEl = document.getElementById('chartjs-tooltip-vertical');
            if (tooltipEl) {
              tooltipEl.parentNode.removeChild(tooltipEl);
            }
            element.chartInstance.update();
          },
          label: {
            content: point.comment.substr(0, 5),
            enabled: true,
            position: "top",
            xPadding: 16,
            yPadding: 10,
            yAdjust: index % 3 === 1 ? 10 : index % 3 === 2 ? 50 : 80,
            xAdjust: index === 0 ? -40 : 0
          }
        });
      });

      var chart = this;

      var colorY = [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.yLabels, function (item) {
        var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(item, '_');
        if (!value[1]) {
          colorY.push('rgba(0,0,0,0.1)');
        } else {
          colorY.push('rgba(0,0,0,0)');
        }
      });

      var colorX = [];

      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(xLabels, function (item) {
        var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(item, '_');
        if (!value[1]) {
          colorX.push('rgba(0,0,0,0.1)');
        } else {
          colorX.push('rgba(0,0,0,0)');
        }
      });

      this.renderChart({
        xLabels: xLabels,
        yLabels: this.yLabels,
        datasets: this.datasets
      }, {
        animation: {
          duration: this.animationDuration
        },
        tooltips: {
          enabled: false
        },
        layout: {
          padding: {
            left: 30,
            right: 40,
            top: 0,
            bottom: 0
          }
        },
        'onClick': function onClick(evt, item) {
          if (item[0]) {

            var activePoints = this.getElementAtEvent(evt);
            var point = this.data.datasets[activePoints[0]._datasetIndex].data[activePoints[0]._index];
            chart.$emit('popup-show', point, chart.stageInfo);
          }
        },
        responsive: true,
        maintainAspectRatio: this.aspectRatio,
        aspectRatio: this.aspectRatio ? 1.6 : false,
        showAllTooltips: false,
        annotation: {
          events: ['dblclick', 'mouseover', 'mouseout'],
          annotations: pointArray
        },
        legend: {
          display: this.showLegend,
          position: 'bottom'
        },
        scales: {
          yAxes: [{
            type: 'category',
            position: 'left',
            display: true,
            afterTickToLabelConversion: function afterTickToLabelConversion(scaleInstance) {
              /*forEach(scaleInstance.ticks, (tick, index) => {
                if (index % 4 !== 0){
                  scaleInstance.ticks[index] = '';
                }
              });*/

            },
            gridLines: {
              color: colorY
            },
            ticks: {
              stepSize: 4,
              autoSkip: false,
              callback: function callback(dataLabel, index) {
                var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(dataLabel, '_');
                // Hide the text after _

                return (index + 2) % 4 === 0 ? value[0] + ' П' : '';
              }
            },
            scaleLabel: {
              display: true,
              labelString: __WEBPACK_IMPORTED_MODULE_9__lang_translator__["a" /* default */].get('protocol.mastering_criteria')
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.xAxisLabel
            },
            gridLines: {
              color: colorX
            },

            afterTickToLabelConversion: function afterTickToLabelConversion(scaleInstance) {
              if (!allAxisShow) {

                /*forEach(xLabels, (tick, index) => {
                  let value = split(tick, '_');
                   if (value.length > 1){
                    scaleInstance.ticks[index] = null;
                  }
                });*/
              }
            },
            ticks: {
              display: true,
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback: function callback(dataLabel, index) {

                var value = __WEBPACK_IMPORTED_MODULE_10_lodash_split___default()(dataLabel, '_');
                // Hide the text after _
                return value[1] !== '3' && !allAxisShow ? '' : value[0];
              }
            }
          }]
        },
        plugins: {
          datalabels: {
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 4,
            color: 'white',
            align: 'end',
            offset: 8,
            display: false, /*function(context) {
                            let index = context.dataIndex;
                            let value = context.dataset.data[index];
                            return value.y > 0;
                            },*/
            formatter: function formatter(value, context) {
              return value.x + ": " + value.y;
            }
          }
        }
      });
    }
  },
  watch: {
    datasets: function datasets() {
      this.render();
    }
  }

});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_join__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BarChart',
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["a" /* Bar */],
  props: {
    linedatasets: {
      required: false,
      type: [Object, Array]
    },
    withLabels: {
      required: false,
      type: [Boolean],
      default: false
    },
    showLegend: {
      required: false,
      type: [Boolean],
      default: true
    },
    bardatasets: {
      required: true,
      type: [Object, Array]
    },
    scaleLabelY: {
      required: false,
      type: [String],
      default: ""
    },
    scaleLabelX: {
      required: false,
      type: [String],
      default: ""
    },
    aspectRatio: {
      required: false,
      type: [Boolean],
      default: true
    },
    verticalLinePoint: {
      required: false,
      type: [Array, Object],
      default: null
    },
    valueMax: {
      required: false,
      type: [Number, String],
      default: null
    }

  },
  mounted: function mounted() {
    this.render();
  },

  plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels___default.a, __WEBPACK_IMPORTED_MODULE_5_chartjs_plugin_annotation___default.a],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('mobile', ['isMobile'])),
  methods: {
    render: function render() {

      var maxBarDatasets = 0;
      var maxLineDatasets = 0;
      if (this.bardatasets) {
        var maxB = 0;
        if (this.bardatasets.data) {
          maxB = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(this.bardatasets.data, function (item) {
            return item.y;
          });
        } else if (this.bardatasets[0]) {
          maxB = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(this.bardatasets[0].data, function (item) {
            return item.y;
          });
        }
        if (maxB) {
          maxBarDatasets = maxB.y * 1.1 < 100 ? maxB.y * 1.1 : maxB.y;
        }
      }
      if (this.linedatasets) {
        var maxL = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(this.linedatasets.data ? this.linedatasets.data : this.linedatasets[0].data, function (item) {
          return item.y;
        });
        if (maxL) {
          maxLineDatasets = maxL.y * 1.1 < 100 ? maxL.y * 1.1 : maxL.y;
        }
      }
      var max = maxBarDatasets - maxLineDatasets > 0 ? maxBarDatasets : maxLineDatasets;
      var valueMax = this.valueMax;

      var pointArray = [];

      if (this.verticalLinePoint) {
        __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(this.verticalLinePoint, function (point, index) {
          pointArray.push({
            id: "vertLine" + index,
            type: "line",
            mode: "vertical",
            scaleID: "x-axis-0",
            value: point.x,
            borderColor: "black",
            borderDash: point.isImportant ? 0 : [5, 5],
            borderWidth: 2,
            onMouseover: function onMouseover(e) {
              var element = this;
              //element.options.label.content = '';
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-vertical';
                element.chartInstance.canvas.parentNode.appendChild(tooltipEl);
              }

              tooltipEl.innerHTML = '<div>' + point.comment + '</div>';
              element.chartInstance.update();
            },
            onMouseout: function onMouseout(e) {
              var element = this;
              element.options.label.content = point.comment.substr(0, 5);
              var tooltipEl = document.getElementById('chartjs-tooltip-vertical');
              tooltipEl.parentNode.removeChild(tooltipEl);
              element.chartInstance.update();
            },
            label: {
              content: point.comment.substr(0, 5),
              enabled: true,
              position: "top",
              xPadding: 16,
              yPadding: 10,
              yAdjust: 10
            }
          });
        });
      }

      this.renderChart(this.linedatasets ? {
        labels: this.bardatasets.labels,
        datasets: [this.bardatasets, this.linedatasets]
      } : this.withLabels ? {
        labels: this.bardatasets[0].labels,
        datasets: this.bardatasets
      } : {
        //labels: this.bardatasets[0].labels,
        datasets: this.bardatasets
      }, {
        responsive: true,
        borderSkipped: "bottom",
        maintainAspectRatio: this.aspectRatio,
        aspectRatio: this.aspectRatio ? 1.6 : false,
        tooltips: {
          enabled: this.linedatasets || this.withLabels ? true : false,
          callbacks: {
            title: function title(tooltipItem, data) {
              var label = Array.isArray(tooltipItem[0].xLabel) ? __WEBPACK_IMPORTED_MODULE_4_lodash_join___default()(tooltipItem[0].xLabel, ' ') : tooltipItem[0].xLabel || '';
              return label;
            }
          }
        },
        legend: {
          display: this.showLegend,
          position: this.isMobile ? 'bottom' : 'right',
          labels: {
            boxWidth: 14,
            padding: 20
          }
        },
        annotation: {
          events: ['click', 'dblclick', 'mouseover', 'mouseout'],
          annotations: pointArray
        },
        scales: {
          yAxes: [{
            afterTickToLabelConversion: function afterTickToLabelConversion(scaleInstance) {

              if (valueMax) {
                scaleInstance.ticks[0] = null;
              }
            },
            ticks: {
              beginAtZero: true,
              max: valueMax ? valueMax : max ? max : 1
              //min: 0,
              //suggestedMax: max
            },
            offset: true,
            scaleLabel: {
              display: true,
              labelString: this.scaleLabelY
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true
              //suggestedMax: 50
            },
            offset: true,
            scaleLabel: {
              display: true,
              labelString: this.scaleLabelX
            },
            maxBarThickness: 50
          }]
        },
        animation: false,
        plugins: {
          datalabels: {
            backgroundColor: function backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderRadius: 4,
            color: 'white',
            align: 'end',
            offset: 8,
            display: function display(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              return value.y > 0 && context.dataset.type != 'bar';
            },
            formatter: function formatter(value) {
              return value.y;
            }
          }
        }
      });
    }
  },
  watch: {
    linedatasets: function linedatasets() {
      this.render();
    },
    bardatasets: function bardatasets() {
      this.render();
    }
  }
});

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var _class = function _class(_ref) {
  var data = _ref.data,
      label = _ref.label,
      labels = _ref.labels,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'rgba(0,0,0,0.3)' : _ref$backgroundColor,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === undefined ? 'rgba(0,0,0,0.3)' : _ref$borderColor,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'bar' : _ref$type;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

  this.data = data, this.borderColor = borderColor;
  this.type = type, this.backgroundColor = backgroundColor, this.label = label, this.labels = labels;
};

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 1069 */,
/* 1070 */
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.clientTimezone)?_c('div',{staticClass:"appeals col-12"},[_c('div',{staticClass:"row mt-2 mb-3 mt-md-0"},[_c('div',{staticClass:"col-12 col-lg-7"},[_c('div',{staticClass:"d-flex h-100  flex-wrap flex-sm-nowrap align-items-end justify-content-between justify-content-sm-start"},[_c('div',{staticClass:"datepicker"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                             "+_vm._s(_vm._f("trans")('appeals.date_start'))+"\n                        ")]),_vm._v(" "),_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-period'),expression:"'required|check-period'"}],attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":new Date(),"name":"rangeDateStart","data-vv-validate-on":"none"},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                             "+_vm._s(_vm._f("trans")('appeals.date_end'))+"\n                        ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":new Date(),"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-lightblue mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.onSendRequest()}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('appeals.buttons.apply'))+"\n\n                    ")])])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"col-12 col-lg-5 d-md-none d-lg-block"},[_c('div',{staticClass:"d-flex h-100  align-items-end justify-content-end"},[_c('button',{staticClass:"btn btn-light mr-2",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onEditBtnClick($event)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('appeals.typical_appeals'))+"\n                    ")]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onShowModalBtnClick($event)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('appeals.buttons.write_appeal'))+"\n\n                    ")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row",class:{'invalid-feedback': _vm.errors.has('rangeDateStart')}},[_vm._v(_vm._s(_vm._f("trans")('report.description_max_period')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.isLoaded)?_c('div',{staticClass:"col-12"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},_vm._l((_vm.appeals),function(appeal){return (!_vm.isEmptyAppeals && _vm.isLoaded)?_c('div',{key:_vm.appeals.id,staticClass:"appeals-item"},[_c('div',{staticClass:"appeals-item__header"},[_c('span',[_vm._v(_vm._s(_vm.toLocaleDateYear(Object.keys(appeal)[0])))])]),_vm._v(" "),_c('div',{staticClass:"appeals-list"},_vm._l((appeal),function(items){return _c('div',_vm._l((items),function(typicalAppeal,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n                                "+_vm._s(typicalAppeal.text)+" ("+_vm._s(typicalAppeal.count)+")\n                            ")])}))}))]):_vm._e()}))]),_vm._v(" "),(_vm.isEmptyAppeals && _vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('appeals.no_data')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2 mt-md-0"},[_c('div',{staticClass:"col-sm-12 col-md-5"},[(!_vm.isEmptyAppeals && _vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-7 text-right d-lg-none"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('button',{staticClass:"btn btn-light mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onEditBtnClick($event)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('appeals.typical_appeals'))+"\n\n                        ")])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-12 col-sm-6"},[_c('mdc-button',{staticClass:"col-12 button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onShowModalBtnClick($event)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('appeals.buttons.write_appeal'))+"\n\n\n                        ")])],1):_vm._e()])])]),_vm._v(" "),_c('appeals-add-modal',{attrs:{"visible":_vm.isModalVisible,"clientId":_vm.clientId},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}}),_vm._v(" "),_c('edit-typical-appeals-modal',{attrs:{"visible":_vm.isEditModalVisible,"clientId":_vm.clientId},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.measurements)?_c('div',{staticClass:"col-12 mb-4 mt-4"},[_c('bar-chart',{attrs:{"linedatasets":_vm.lineChartDataset,"bardatasets":_vm.barChartDataset,"scale-label-x":_vm._f("trans")('report.day_session'),"scale-label-y":_vm._f("trans")('appeals.appeals_count'),"height":null,"width":null,"show-legend":true}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('appeals.appeals_chart')))])],1):_vm._e()])],1):_c('div',{staticClass:"col-12"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appeals-layout"},[((_vm.isTherapist || _vm.isBCBA || _vm.isCurator) && _vm.client)?_c('button',{staticClass:"btn btn-light btn-sm mt-2 mt-md-0",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),(_vm.clientId)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")]):_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e(),_vm._v(" "),(_vm.client || (_vm.isClient && _vm.clientTimezone))?_c('div',{staticClass:"pt"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('appeals.appeals_for_period')))]),_vm._v(" "),_c('appeals-list',{attrs:{"clientId":_vm.clientId,"clientTimezone":_vm.clientTimezone}})],1):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('dashboard-menu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorList_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1f1c636_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorList_vue__ = __webpack_require__(1077);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UndesirableBehaviorList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1f1c636_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UndesirableBehaviorList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */,
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"behavior-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('behavior.edit_typical_client_behavior'),"accept":_vm._f("trans")('behavior.buttons.save'),"accept-disabled":_vm.isMensurationForbidden},on:{"cancel":_vm.cancel,"close":_vm.close,"validate":_vm.validate},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('behavior.edit_typical_behavior')))])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('span',{on:{"click":function($event){$event.preventDefault();_vm.validate()}}},[_c('mdc-icon',{attrs:{"icon":"done"}})],1)]):_vm._e()],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalAncedent),function(ancedent,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n        "+_vm._s(ancedent.text)+"\n        "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.removeAncedent(index, ancedent)}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isNotUniqueAncedent') || _vm.errors.has('isEmptyErrorAncedent') || _vm.errors.has('isMaxLengthAncedent') || _vm.errors.has('newTypicalAncedent')},attrs:{"name":"newTypicalAncedent","disabled":_vm.isMensurationForbidden,"type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_ancedent'),"label":_vm._f("trans")('behavior.enter_the_new_ancedent')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addAncedent($event)}},model:{value:(_vm.newTypicalAncedent.text),callback:function ($$v) {_vm.$set(_vm.newTypicalAncedent, "text", $$v)},expression:"newTypicalAncedent.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalAncedent'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalAncedent')))])]):_vm._e()],1),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addAncedent()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isNotUniqueAncedent') || _vm.errors.has('isEmptyErrorAncedent') || _vm.errors.has('isMaxLengthAncedent'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isNotUniqueAncedent') || _vm.errors.first('isEmptyErrorAncedent') || _vm.errors.first('isMaxLengthAncedent')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.behavior')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalBehavior),function(behavior,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n        "+_vm._s(behavior.text)+"\n        "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.removeBehavior(index, behavior)}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isNotUniqueBehavior') || _vm.errors.has('isEmptyErrorBehavior') || _vm.errors.has('isMaxLengthBehavior') || _vm.errors.has('newTypicalBehavior')},attrs:{"name":"newTypicalBehavior","disabled":_vm.isMensurationForbidden,"type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_behavior'),"label":_vm._f("trans")('behavior.enter_the_new_behavior')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addBehavior($event)}},model:{value:(_vm.newTypicalBehavior.text),callback:function ($$v) {_vm.$set(_vm.newTypicalBehavior, "text", $$v)},expression:"newTypicalBehavior.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalBehavior'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalBehavior')))])]):_vm._e()],1),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addBehavior()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isNotUniqueBehavior') || _vm.errors.has('isEmptyErrorBehavior') || _vm.errors.has('isMaxLengthBehavior'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isNotUniqueBehavior') || _vm.errors.first('isEmptyErrorBehavior') || _vm.errors.first('isMaxLengthBehavior')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_environment')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalEffects),function(aftermath,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n        "+_vm._s(aftermath.text)+"\n        "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.removeEffect(index, aftermath)}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isNotUniqueEffect') || _vm.errors.has('isEmptyErrorEffect') || _vm.errors.has('isMaxLengthEffect') || _vm.errors.has('newTypicalEffect')},attrs:{"name":"newTypicalEffect","type":"text","disabled":_vm.isMensurationForbidden,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_aftermath'),"label":_vm._f("trans")('behavior.enter_the_new_aftermath')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addEffect($event)}},model:{value:(_vm.newTypicalEffect.text),callback:function ($$v) {_vm.$set(_vm.newTypicalEffect, "text", $$v)},expression:"newTypicalEffect.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalEffect'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalEffect')))])]):_vm._e()],1),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addEffect()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isNotUniqueEffect') || _vm.errors.has('isEmptyErrorEffect') || _vm.errors.has('isMaxLengthEffect'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isNotUniqueEffect') || _vm.errors.first('isEmptyErrorEffect') || _vm.errors.first('isMaxLengthEffect')))])]):_vm._e()])]),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('b',{staticClass:"behavior-modal__subtitle mt30"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_behavior')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.typicalConsequenceInBehavior),function(consequence,index){return _c('div',{key:index,staticClass:"radio-btn"},[_vm._v("\n        "+_vm._s(consequence.text)+"\n        "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.removeConsequenceInBehavior(index, consequence)}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1):_vm._e()])}))]):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row align-items-center"},[_c('div',{staticClass:"col-8 col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:1|max:200'),expression:"'min:1|max:200'"}],class:{'is-invalid': _vm.errors.has('isNotUniqueConsequenceInBehavior') || _vm.errors.has('isEmptyErrorConsequenceInBehavior') || _vm.errors.has('isMaxLengthConsequenceInBehavior') || _vm.errors.has('newTypicalConsequenceInBehavior')},attrs:{"name":"newTypicalConsequenceInBehavior","type":"text","disabled":_vm.isMensurationForbidden,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('behavior.enter_the_new_aftermath'),"label":_vm._f("trans")('behavior.enter_the_new_aftermath')},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addConsequenceInBehavior($event)}},model:{value:(_vm.newTypicalConsequenceInBehavior.text),callback:function ($$v) {_vm.$set(_vm.newTypicalConsequenceInBehavior, "text", $$v)},expression:"newTypicalConsequenceInBehavior.text"}}),_vm._v(" "),(_vm.errors.has('newTypicalConsequenceInBehavior'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('newTypicalConsequenceInBehavior')))])]):_vm._e()],1),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-4 col-md-3"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addConsequenceInBehavior()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('appeals.buttons.addAppeal')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('isNotUniqueConsequenceInBehavior') || _vm.errors.has('isEmptyErrorConsequenceInBehavior') || _vm.errors.has('isMaxLengthEffect'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isNotUniqueConsequenceInBehavior') || _vm.errors.first('isEmptyErrorConsequenceInBehavior') || _vm.errors.first('isMaxLengthConsequenceInBehavior')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('footer',{staticClass:"col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button","disabled":_vm.isMensurationForbidden},on:{"click":function($event){_vm.validate()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('behavior.buttons.save')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.measurements.length)?_c('div',{staticClass:"col-12 mt-3"},[(_vm.lineChartDataset)?_c('line-chart',{attrs:{"datasets":_vm.lineChartDataset,"show-legend":false,"withoutMax":true,"animation-duration":0,"aspect-ratio":false,"height":360,"width":null,"chartId":"averageBehavior","scale-label":_vm._f("trans")('behavior.average_behavior'),"y-axes-begin-at-zero":true}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('behavior.unwanted_behavior_chart')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row mt-5"},[(_vm.antecedentTypes)?_c('div',{staticClass:"col-md-6 col-sm-12",class:{'col-lg-4': _vm.isClient}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartAncedentDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartAncedentDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.behaviorTypes)?_c('div',{staticClass:"col-md-6 col-sm-12",class:{'col-lg-4': _vm.isClient}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.unwanted_behavior')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartBehaviorDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartBehaviorDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.effectsTypes)?_c('div',{staticClass:"col-md-6 col-sm-12 pt-md-2",class:{'col-lg-4': _vm.isClient}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_environment')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartEffectsDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartEffectsDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.consequenceInBehavior && !_vm.isClient)?_c('div',{staticClass:"col-md-6 col-sm-12 pt-md-2"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_behavior')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartConsequenceInBehaviorDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartConsequenceInBehaviorDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n        ")])})],2):_vm._e()])]),_vm._v(" "),(_vm.scatterplotData && _vm.scatterplotXLabels.length)?_c('div',{staticClass:"col-12 mt-3"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('behavior.scatter_plot')))]),_vm._v(" "),_c('div',{staticClass:"fixed-table-wrapp"},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"time-cell"}),_vm._v(" "),_vm._l((_vm.scatterplotXLabels),function(data){return _c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("toLocaleDate")(data)))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.scatterplotYLabels),function(time){return _c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(time.text)+"\n          ")]),_vm._v(" "),_vm._l((_vm.scatterplotXLabels),function(data){return _c('td',{staticClass:"text-center",class:{'checked-cell': _vm.currentScatterplotValue(data, _vm.scatterplotData[time.id])}},[_vm._v("\n            "+_vm._s(_vm.currentScatterplotValue(data, _vm.scatterplotData[time.id]))+"\n          ")])})],2)}))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.clientTimezone)?_c('div',{staticClass:"undesirable col-12"},[_c('div',{staticClass:"row mt-2 mb-3 mt-md-0"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"filter-row d-flex h-100  flex-wrap align-items-end justify-content-between justify-content-sm-start"},[_c('div',{staticClass:"datepicker"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                 "+_vm._s(_vm._f("trans")('behavior.date_start'))+"\n            ")]),_vm._v(" "),_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-period'),expression:"'required|check-period'"}],class:{'is-invalid': _vm.errors.has('rangeDateStart')},attrs:{"name":"rangeDateStart","formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.rangeDateFinish,"data-vv-validate-on":"none","min-date":_vm.minDateStart},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                 "+_vm._s(_vm._f("trans")('appeals.date_end'))+"\n            ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.rangeDateFinish,"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('div',{staticClass:"item-filter mr-md-4"},[_c('span',{staticClass:"datepicker__label"},[_vm._v(" "+_vm._s(_vm._f("trans")('behavior.within')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.protocolList,"disabled":_vm.disabledSelect,"label":"protocolId","name":"protocol","filterable":false,"placeholder":" ","onSearch":_vm.onSearchProtocol,"data-vv-validate-on":"none"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n                "+_vm._s(option.title)+"\n              ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n                "+_vm._s(option.title)+"\n              ")]}}]),model:{value:(_vm.protocol),callback:function ($$v) {_vm.protocol=$$v},expression:"protocol"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('report.choose_protocol'))+"\n                ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"item-filter mr-md-4"},[_c('span',{staticClass:"datepicker__label"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('ancedent'), 'is-clear': !_vm.ancedentId},attrs:{"id":"ancedentId","name":"ancedent","label":'text',"selected":_vm.ancedentId,"options":_vm.ancedents,"loading":_vm.loading,"lastId":_vm.lastAncedentId,"searchable":false,"isLastPage":_vm.isLastAncedentPage,"optionTitle":'text',"isLast":_vm.isLastAncedent,"getOptionTitle":_vm.getOptionAncedentTitle},on:{"next-page":_vm.nextAncedentPage,"set-selected":_vm.onSetAncedentSelected}})],1),_vm._v(" "),_c('div',{staticClass:"item-filter"},[_c('span',{staticClass:"datepicker__label"},[_vm._v(_vm._s(_vm._f("trans")('behavior.behavior')))]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('behavior'), 'is-clear': !_vm.behaviorId},attrs:{"id":"behaviorId","name":"behavior","label":'text',"selected":_vm.behaviorId,"options":_vm.behaviorsList,"loading":_vm.loading,"lastId":_vm.lastBehaviorsId,"searchable":false,"isLastPage":_vm.isLastBehaviorsPage,"optionTitle":'text',"isLast":_vm.isLastBehavior,"getOptionTitle":_vm.getOptionBehaviorsTitle},on:{"next-page":_vm.nextBehaviorsPage,"set-selected":_vm.onSetBehaviorsSelected}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row",class:{'invalid-feedback': _vm.errors.has('rangeDateStart')}},[_vm._v(_vm._s(_vm._f("trans")('report.description_max_period')))])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-0  d-lg-block"},[_c('div',{class:{'d-flex h-100  align-items-end justify-content-end': !_vm.isMobile}},[_c('button',{staticClass:"btn btn-lightblue mt-3 mt-sm-0 mb-2 mr-2",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.applyFilter()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('behavior.buttons.apply'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light mb-2 mr-2",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onEditBtnClick($event)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('behavior.buttons.typical_behavior'))+"\n          ")]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-button',{staticClass:"btn button-primary mb-2 ",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onShowModalBtnClick($event)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('behavior.buttons.create_behavior'))+"\n          ")]):_vm._e()],1)])]),_vm._v(" "),(!_vm.isMobile && !_vm.isEmptyBehavior)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('behavior.behavior')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_environment')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_behavior')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"},[_vm._v(_vm._s(_vm._f("trans")('behavior.date_time')))])])]),_vm._v(" "),_c('tbody',[(!_vm.isLoaded)?_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.behaviors),function(behavior){return (!_vm.isEmptyBehavior && _vm.isLoaded)?_c('tr',{key:_vm.behaviors.id},[_c('td',_vm._l((behavior.antecedents),function(antecedent,index){return _c('span',[_vm._v(_vm._s(antecedent.text)),(index != behavior.antecedents.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])})),_vm._v(" "),_c('td',_vm._l((behavior.behaviors),function(behaviorName,index){return _c('span',[_vm._v(_vm._s(behaviorName.text)),(index != behavior.behaviors.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])})),_vm._v(" "),_c('td',_vm._l((behavior.effects),function(effect,index){return _c('span',[_vm._v(_vm._s(effect.text)),(index != behavior.effects.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])})),_vm._v(" "),_c('td',_vm._l((behavior.consequenceInBehaviors),function(consequenceInBehavior,index){return _c('span',[_vm._v(_vm._s(consequenceInBehavior.text)),(index != behavior.consequenceInBehaviors.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])})),_vm._v(" "),_c('td',{staticClass:"action-cell"},[(behavior.updatedAt)?_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(behavior.updatedAt.date)))]):_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(behavior.createdAt.date)))])])]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('behavior.ancedent'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},[(!_vm.isLoaded)?_c('div',{staticClass:"d-flex"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.behaviors),function(behavior){return (_vm.isLoaded)?_c('div',{key:behavior.id,staticClass:"mobile-table__row"},[_c('div',{staticClass:"title align-items-center d-flex justify-content-between",class:{hidden : _vm.activeBehaviorId != behavior.id}},[_c('b',_vm._l((behavior.antecedents),function(antecedent,index){return _c('span',[_vm._v(_vm._s(antecedent.text)),(index != behavior.antecedents.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])})),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.openDescription(behavior.id)}}},[(_vm.activeBehaviorId != behavior.id)?_c('mdc-icon',{attrs:{"icon":"keyboard_arrow_right"}}):_c('mdc-icon',{attrs:{"icon":"keyboard_arrow_down"}})],1)]),_vm._v(" "),_c('div',{staticClass:"gray-dark"},[(behavior.updatedAt)?_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(behavior.updatedAt.date)))]):_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(behavior.createdAt.date)))])]),_vm._v(" "),_c('div',{staticClass:"description pt-2",class:{hidden : _vm.activeBehaviorId != behavior.id}},[_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('behavior.behavior')))]),_vm._v(" "),_c('p',_vm._l((behavior.behaviors),function(behaviorName,index){return _c('span',[_vm._v(_vm._s(behaviorName.text)),(index != behavior.behaviors.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"pt-2"},[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_environment')))]),_vm._v(" "),_c('p',_vm._l((behavior.effects),function(effect,index){return _c('span',[_vm._v(_vm._s(effect.text)),(index != behavior.effects.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"pt-2"},[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ub_behavior')))]),_vm._v(" "),_c('p',_vm._l((behavior.consequenceInBehaviors),function(consequenceInBehavior,index){return _c('span',[_vm._v(_vm._s(consequenceInBehavior.text)),(index != behavior.consequenceInBehaviors.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}))])])]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.isEmptyBehavior && _vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.no_data')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2 mt-md-0"},[_c('div',{staticClass:"col-sm-12 col-md-5"},[(!_vm.isEmptyBehavior && _vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-7 text-right d-lg-none"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('button',{staticClass:"btn btn-light mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onEditBtnClick($event)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('behavior.buttons.typical_behavior'))+"\n            ")])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-12 col-sm-6"},[_c('mdc-button',{staticClass:"col-12 button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.onShowModalBtnClick($event)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('behavior.buttons.create_behavior'))+"\n            ")])],1):_vm._e()])])]),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('undesirable-behavior-add-modal',{attrs:{"visible":_vm.isModalVisible,"clientId":_vm.clientId},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}})],1):_vm._e(),_vm._v(" "),(_vm.isEditModalVisible)?_c('div',[_c('edit-typical-behaviors-modal',{attrs:{"visible":_vm.isEditModalVisible,"clientId":_vm.clientId},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}})],1):_vm._e()]):_c('div',{staticClass:"col-12"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1),_vm._v(" "),(_vm.clientId)?_c('div',{staticClass:"col-12"},[(_vm.clientId)?_c('undesirable-behavior-chart',{attrs:{"client-id":_vm.clientId,"rangeDateStart":_vm.rangeDateStart,"rangeDateEnd":_vm.rangeDateEnd,"protocol-id":_vm.protocol && _vm.protocol.protocolId !== 'time' ? _vm.protocol.id : null,"ancedent-id":_vm.ancedentId && _vm.ancedentId.id !== 'all'  ? _vm.ancedentId.id : null,"behavior-id":_vm.behaviorId && _vm.behaviorId.id !== 'all' ? _vm.behaviorId.id : null,"is-apply-changes":_vm.changedShow},on:{"changedView":_vm.changedView}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"undesirable-layout"},[((_vm.isTherapist || _vm.isBCBA || _vm.isCurator) && _vm.client)?_c('button',{staticClass:"btn btn-light btn-sm mt-2 mt-md-0",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),(_vm.clientId)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")]):_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e(),_vm._v(" "),(_vm.client || (_vm.isClient && _vm.clientTimezone))?_c('div',{staticClass:"pt"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('behavior.unwanted_behavior_for_period')))]),_vm._v(" "),_c('undesirable-behavior-list',{attrs:{"clientId":_vm.clientId,"clientTimezone":_vm.clientTimezone}})],1):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('dashboard-menu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveProtocolView_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2229ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveProtocolView_vue__ = __webpack_require__(1082);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveProtocolView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2229ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveProtocolView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleView_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaa391ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleView_vue__ = __webpack_require__(1081);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaa391ba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile)?_c('div',{staticClass:"toggle-btn-container",class:{'is-hide-info': !_vm.isShowAll}},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.toggleShow($event)}}},[(!_vm.isShowAll)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.showAll')))]):_vm._e(),_vm._v(" "),(_vm.isShowAll)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.hideAll')))]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"protocol"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"alert alert-light",attrs:{"role":"alert"}},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title))]),_vm._v(" "),_c('dl',{staticClass:"sidebar-list"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.area')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.protocol.skillField.name))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.goal')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.goal))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('dl',{staticClass:"half-list"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.assignDate')))]),_vm._v(" "),(_vm.assignedProtocol.createdAt)?_c('dd',[_vm._v("\n                "+_vm._s(_vm._f("toLocaleDate")(_vm.assignedProtocol.createdAt.date))+"\n              ")]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.startTraining')))]),_vm._v(" "),(_vm.assignedProtocol.beginDate)?_c('dd',[_vm._v("\n                "+_vm._s(_vm._f("toLocaleDate")(_vm.assignedProtocol.beginDate.date))+"\n              ")]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.lastLesson')))]),_vm._v(" "),(_vm.assignedProtocol.endDate)?_c('dd',[_vm._v("\n                "+_vm._s(_vm._f("toLocaleDate")(_vm.assignedProtocol.endDate.date))+"\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('toogle-view',[_c('dl',{staticClass:"list"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.instruction')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.instruction))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.trueReaction')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.rightReaction))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.providingHint')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.provideHint))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.reducingPromp')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.reductionHint))])])]),_vm._v(" "),_vm._l((_vm.protocol.stages),function(value){return (_vm.isPecs() || _vm.isPecsWithoutDiscrimination())?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12 mt-3"},[(_vm.isPecs())?_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title'))+". "+_vm._s(_vm._f("trans")(value.description)))]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscrimination())?_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[_c('tbody',_vm._l((value.tasks),function(task,index){return _c('tr',{key:task.id},[_c('td',[_vm._v("\n                    "+_vm._s(index + 1)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"name-field"},[_vm._v("\n                    "+_vm._s(task.description)+"\n                  ")])])}))])])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary"},[(('execution' in this.protocol))?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.execution')))]),_vm._v(" "),_c('p',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.execution))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"alert alert-primary"},[(_vm.protocol.dataFields.features)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('dl',{staticClass:"list"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.features')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.features))])])])]):_vm._e()]),_vm._v(" "),_c('toogle-view',[_c('dl',{staticClass:"list"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.errorCorrection')))]),_vm._v(" "),_c('dd',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm.protocol.dataFields.errorCorrection))])])]),_vm._v(" "),(!_vm.isMensurationForbidden && !_vm.isClient && !_vm.isOnIndividualization())?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[(_vm.activeProtocolList.length != 1 && !_vm.isCompleted() && !_vm.isPecs() && !_vm.isPecsWithoutDiscrimination() && !_vm.isPecsWithDiscrimination())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'stage-list', params: { clientId: _vm.assignedProtocol.assigneeId, protocolData: _vm.protocolData}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length == 1 && !_vm.isCompleted() && (_vm.isChain() || _vm.isShaping() || _vm.isMand()))?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: _vm.isChain() ? 'chain-stage-current' : _vm.isShaping() ? 'shaping-stage-current' : 'mand-stage-current',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.activeProtocolList[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscrimination())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'stage-list', params: { clientId: _vm.assignedProtocol.assigneeId, protocolData: _vm.protocolData}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length == 1 && !_vm.isCompleted() && _vm.isUSD())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'choose-usd',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.activeProtocolList[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(!_vm.isCompleted() && _vm.isPecs())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'pecs-stage',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.protocolData.protocol.stages[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(!_vm.isCompleted() && _vm.isPecsWithoutDiscrimination())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'pecs-stage-without-discrimination',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.protocol.stages[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(!_vm.isCompleted() && _vm.isPecsWithItems())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'pecs-with-items-stage',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.protocol.stages[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length == 1 && !_vm.isCompleted() && _vm.isDtt())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'choose-stage',
                    params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId: _vm.activeProtocolList[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.activeProtocolList.length == 1 && !_vm.isCompleted() && _vm.isSimple())?_c('router-link',{staticClass:"btn btn-primary mr-2",attrs:{"to":{ name: 'current-stage',
                   params: {clientId: _vm.assignedProtocol.assigneeId, protocolId: _vm.assignedProtocol.id, stageId:_vm.activeProtocolList[0].id}}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.goToExercises'))+"\n              ")]):_vm._e()],1)]):_vm._e()],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStage_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59bd1ee9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStage_vue__ = __webpack_require__(1086);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59bd1ee9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1084 */,
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction alert alert-secondary"},[_c('h5',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.isExpanded && _vm.text ? _vm.text : _vm.shortText))]),_vm._v(" "),(_vm.isCanExpanded)?_c('a',{staticClass:"link",class:{expanded : _vm.isExpanded},on:{"click":function($event){_vm.toggle()}}},[_vm._v(_vm._s(_vm._f("trans")((_vm.isExpanded ? 'instruction.collapse' : 'instruction.expand'))))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.isLoaded && _vm.protocols)?_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[(_vm.protocols)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocols.protocol.title))]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stage'))+":\n              "+_vm._s(_vm.activeStep.description))]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.conductingTherapeuticSession')))]),_vm._v(" "),(_vm.activeStep.type && _vm.showSessionView)?_c('h3',{staticClass:"step-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n              "+_vm._s(_vm.activeStep.type.title))]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('h3',{staticClass:"step-title text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.max_count_for_session')))]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isClient && ((!_vm.isVirtualStage && _vm.activeStep.type.id == 5 && !_vm.activeStep.daySessionClosed) || (_vm.activeStep.type.id != 5)))?_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.add_new_stimulus')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStimulus(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty || (!_vm.isVirtualStage && _vm.activeStep.type.id == 5 && _vm.activeStep.daySessionClosed))?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.btnDisabled && !(!_vm.isVirtualStage && _vm.activeStep.type.id == 5 && _vm.activeStep.daySessionClosed))?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.all_attempts_past'))+"\n            ")]):_vm._e(),_vm._v(" "),((_vm.showSessionView || _vm.close) && !_vm.isMobile && !_vm.stimulusListEmpty && !_vm.btnDisabled)?_c('div',{staticClass:"position-relative wrapper-loader"},[(((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)  && !_vm.showSpoSession)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),((_vm.isBCBA || _vm.isCurator) && ((_vm.isVirtualStage && _vm.activeStep.type.id == 5) || (_vm.activeStep.type.id != 5)))?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"results-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.stimulusList),function(stimul,index){return _c('tr',{key:stimul.globalUuid},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),((_vm.isBCBA || _vm.isCurator) && ((_vm.isVirtualStage && _vm.activeStep.type.id == 5) || (_vm.activeStep.type.id != 5)))?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:'+_vm.attemptsCount+'|numeric'),expression:"'min_value:1|max_value:'+attemptsCount+'|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":1000,"name":"attepmtsCount","data-vv-validate-on":"none"},on:{"keydown":_vm.changeNumber},model:{value:(stimul.attepmtsCount),callback:function ($$v) {_vm.$set(stimul, "attepmtsCount", $$v)},expression:"stimul.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',[_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((_vm.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.globalUuid + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.globalUuid +key + label.id,"type":"radio","disabled":stimul.attempt >= _vm.attemptsCount,"name":'radios'+index + stimul.globalUuid + key + label.id},domProps:{"value":label.title+index + stimul.globalUuid + key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.globalUuid + key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.globalUuid + key + label.id)},function($event){_vm.attemptChange(label.id, stimul.globalUuid, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.attempt >= _vm.attemptsCount},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])}))])],1):_vm._e(),_vm._v(" "),(_vm.showSessionView && _vm.isMobile && !_vm.stimulusListEmpty)?_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),(_vm.stimulusList)?_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.stimulusList),function(stimul,index){return _c('div',{key:stimul.globalUuid,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.stimulusList.length/3) == 0}},[_vm._l((_vm.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.globalUuid +key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.globalUuid +key + label.id,"type":"radio","disabled":stimul.attempt >= _vm.attemptsCount,"name":'radios'+index + stimul.globalUuid +key + label.id},domProps:{"value":label.title+index + stimul.globalUuid +key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.globalUuid +key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.globalUuid +key + label.id)},function($event){_vm.attemptChange(label.id, stimul.globalUuid, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.attempt >= _vm.attemptsCount},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid +key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])})):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isLoaded && !_vm.close && !_vm.isClient)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[(!_vm.showSessionView)?_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.btnDisabled},on:{"click":function($event){$event.preventDefault();_vm.showSession()}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.endSession'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.showSessionView)?_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)  && !_vm.showSpoSession)},on:{"click":function($event){$event.preventDefault();_vm.hideSession(false, !_vm.isVirtualStage && _vm.activeStep.type.id == 5)}}},[_vm._v("\n                   "+_vm._s(_vm._f("trans")(!_vm.isVirtualStage && _vm.activeStep.type.id == 5 ? 'protocol.goToSPO' : 'protocol.endSession'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit","disabled":((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)  && !_vm.showSpoSession},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.buttons.finishStage'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 mt-5 mt-lg-0"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-info mt-2",attrs:{"to":{ name: 'results', params: { clientId: _vm.protocols.assigneeId, protocolId: _vm.protocols.id}}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.results'))+"\n            ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[(!_vm.isClient)?_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishStage'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.hideSession(true, false);},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSessionStage,"cancel":_vm.cancelSession},model:{value:(_vm.isModalSessionVisible),callback:function ($$v) {_vm.isModalSessionVisible=$$v},expression:"isModalSessionVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MandReactionStage_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdaab2a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MandReactionStage_vue__ = __webpack_require__(1088);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MandReactionStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdaab2a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MandReactionStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title)+": "+_vm._s(_vm.currentStage.description))]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.addMandReaction')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addMandReactionsItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addMandReaction'),"name":"addMandReactionsItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addMandReaction')},model:{value:(_vm.addMandReactionsItem),callback:function ($$v) {_vm.addMandReactionsItem=$$v},expression:"addMandReactionsItem"}}),_vm._v(" "),(_vm.errors.has('addMandReactionsItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addMandReactionsItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addMands(_vm.addMandReactionsItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"wrapper-loader position-relative"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.reactions')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.mands),function(mand,index){return _c('tr',{key:mand.globalUuid},[_c('td',[_vm._v(_vm._s(mand.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(mand.attempt))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"attepmtsCount"},on:{"keydown":_vm.changeNumber},model:{value:(mand.attepmtsCount),callback:function ($$v) {_vm.$set(mand, "attepmtsCount", $$v)},expression:"mand.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((mand.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': mand.lastAnswers.length > 5 && index < (mand.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(mand.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((mand.recordedReactions),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(mand.answer),expression:"mand.answer"}],key:label.title+index + mand.globalUuid + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + mand.globalUuid +key + label.id,"type":"radio","name":'radios'+index + mand.globalUuid + key + label.id},domProps:{"value":label.title+index + mand.globalUuid + key + label.id,"checked":_vm._q(mand.answer,label.title+index + mand.globalUuid + key + label.id)},on:{"change":[function($event){_vm.$set(mand, "answer", label.title+index + mand.globalUuid + key + label.id)},function($event){_vm.attemptChange(label.id, mand, label.title, mand.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + mand.globalUuid + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!mand.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(mand.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])}))]),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('buttons.save'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.finishStage'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.reactions')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.mands),function(mand,index){return _c('div',{key:mand.globalUuid,staticClass:"mobile-table__row"},[(mand.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': mand.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(mand.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(mand.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((mand.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': mand.lastAnswers.length > 5 && index < (mand.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(mand.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.mands.length/3) == 0}},[_vm._l((mand.recordedReactions),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(mand.answer),expression:"mand.answer"}],key:label.title+index + mand.globalUuid + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + mand.globalUuid +key + label.id,"type":"radio","name":'radios'+index + mand.globalUuid +key + label.id},domProps:{"value":label.title+index + mand.globalUuid + key + label.id,"checked":_vm._q(mand.answer,label.title+index + mand.globalUuid + key + label.id)},on:{"change":[function($event){_vm.$set(mand, "answer", label.title+index + mand.globalUuid + key + label.id)},function($event){_vm.attemptChange(label.id, mand, label.title, mand.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + mand.globalUuid + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!mand.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(mand.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])})),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.rangeDateStart && _vm.rangeTimeStart.HH && _vm.rangeTimeStart.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.showChangeDateSession)},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('buttons.save'))+"\n            ")]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.finishStage'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishCurrentStage'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeStage,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainReactionStage_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbbdfa14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainReactionStage_vue__ = __webpack_require__(1090);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainReactionStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbbdfa14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainReactionStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title)+": "+_vm._s(_vm.currentStage.description))]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"wrapper-loader position-relative"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.steps')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(task.attempt))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"attepmtsCount"},on:{"keydown":_vm.changeNumber},model:{value:(task.attepmtsCount),callback:function ($$v) {_vm.$set(task, "attepmtsCount", $$v)},expression:"task.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!task.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])}))]),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('buttons.save'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.finishEnvironment'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.reactions')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.tasks),function(task,index){return _c('div',{key:task.globalUuid,staticClass:"mobile-table__row"},[(task.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': task.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.tasks.length/3) == 0}},[_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!task.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])})),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.rangeDateStart && _vm.rangeTimeStart.HH && _vm.rangeTimeStart.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.showChangeDateSession)},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('buttons.save'))+"\n            ")]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.finishEnvironment'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishEnvironment'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeStage,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShapingCurrentStage_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed19cc5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShapingCurrentStage_vue__ = __webpack_require__(1092);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShapingCurrentStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed19cc5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShapingCurrentStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title)+": "+_vm._s(_vm.currentStage.description))]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper-loader position-relative"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"prev-list",class:{'is-open': _vm.isOpenPrev, 'is-list': _vm.prevTasks.length > 1},on:{"click":function($event){$event.preventDefault();_vm.toggleViewPrev()}}},_vm._l((_vm.prevTasks),function(task,index){return _c('div',{key:task.globalUuid,staticClass:"list-item"},[_c('span',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('div',[(!(task.selected || task.disabled))?_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.selectAsCurrent(task.globalUuid)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.make_criteria_current'))+"\n                ")]):_vm._e()])])})),_vm._v(" "),(_vm.selectedTasks && !_vm.isMobile)?_c('div',[_c('table',{staticClass:"table table-sm table-fixed border-primary mt-2 mb-2"},[_c('tbody',{staticClass:"gray-700"},[_c('tr',{staticClass:"selected"},[_c('td',{staticClass:"item mw120"},[_vm._v(_vm._s(_vm.selectedTasks.description))]),_vm._v(" "),(_vm.selectedTasks.selected)?_c('td',{staticClass:"item show-on-active nowrap"},[_vm._v(_vm._s(_vm.selectedTasks.attempt))]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('td',{staticClass:"table-count item  show-on-active"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"attepmtsCount"},on:{"keydown":_vm.changeNumber},model:{value:(_vm.selectedTasks.attepmtsCount),callback:function ($$v) {_vm.$set(_vm.selectedTasks, "attepmtsCount", $$v)},expression:"selectedTasks.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell item"},[_c('div',{staticClass:"mt-2"},[_vm._l((_vm.selectedTasks.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': _vm.selectedTasks.lastAnswers.length > 5 && index < (_vm.selectedTasks.lastAnswers.length -5)}},[_vm._v("\n                          "+_vm._s(answer)+"\n                        ")])}),_vm._l((_vm.emptyLength(_vm.selectedTasks.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((_vm.selectedTasks.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTasks.answer),expression:"selectedTasks.answer"}],key:label.title + _vm.selectedTasks.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id' + _vm.selectedTasks.globalUuid + label.id +key,"type":"radio","name":'radios'+ _vm.selectedTasks.globalUuid + label.id +key},domProps:{"value":label.title + _vm.selectedTasks.globalUuid + label.id +key,"checked":_vm._q(_vm.selectedTasks.answer,label.title + _vm.selectedTasks.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(_vm.selectedTasks, "answer", label.title + _vm.selectedTasks.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, _vm.selectedTasks, label.title, _vm.selectedTasks.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id' + _vm.selectedTasks.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!_vm.selectedTasks.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(_vm.selectedTasks.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right text-cell"},[(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask !== _vm.tasks.length - 1))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(_vm.selectedTasks.globalUuid, _vm.selectedTasks, _vm.selectedIndexTask)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.next_criterion'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask === _vm.tasks.length - 1) && !_vm.selectedTasks.mastered && !_vm.selectedTasks.lastSessions.isMastered)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(_vm.selectedTasks.globalUuid, _vm.selectedTasks, _vm.selectedIndexTask)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.master_criterion'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask === _vm.tasks.length - 1) && (_vm.selectedTasks.mastered || _vm.selectedTasks.lastSessions.isMastered))?_c('span',{staticClass:"nowrap"},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.mastered_criterion'))+"\n                    ")]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedTasks && _vm.isMobile)?_c('div',[_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__body"},[_c('div',{staticClass:"mobile-table__row"},[(_vm.selectedTasks.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': _vm.selectedTasks.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.selectedTasks.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask !== _vm.tasks.length - 1))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(_vm.selectedTasks.globalUuid, _vm.selectedTasks, _vm.selectedIndexTask)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.next_criterion'))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask === _vm.tasks.length - 1) && !_vm.selectedTasks.mastered && !_vm.selectedTasks.lastSessions.isMastered)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(_vm.selectedTasks.globalUuid, _vm.selectedTasks, _vm.selectedIndexTask)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.master_criterion'))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.selectedTasks.toNextLevel && _vm.selectedTasks.selected && (_vm.selectedIndexTask === _vm.tasks.length - 1) && (_vm.selectedTasks.mastered || _vm.selectedTasks.lastSessions.isMastered))?_c('span',[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.mastered_criterion'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.selectedTasks.attempt))])]),_vm._v(" "),(_vm.selectedTasks.selected)?_c('div',{staticClass:"mt-2 not-show"},[_vm._l((_vm.selectedTasks.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': _vm.selectedTasks.lastAnswers.length > 5 && index < (_vm.selectedTasks.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(_vm.selectedTasks.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row not-show",class:{'stimul-row-3' : (_vm.tasks.length/3) == 0}},[_vm._l((_vm.selectedTasks.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTasks.answer),expression:"selectedTasks.answer"}],key:label.title+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key,"type":"radio","name":'radios'+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key},domProps:{"value":label.title+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key,"checked":_vm._q(_vm.selectedTasks.answer,label.title+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(_vm.selectedTasks, "answer", label.title+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, _vm.selectedTasks, label.title, _vm.selectedTasks.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+_vm.selectedIndexTask + _vm.selectedTasks.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn not-show",attrs:{"type":"button","disabled":!_vm.selectedTasks.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(_vm.selectedTasks.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"disabled-list mb-4",class:{'is-open': _vm.isOpenDisabled, 'is-list': _vm.nextTasks.length > 1},on:{"click":function($event){$event.preventDefault();_vm.toggleViewDisabled()}}},_vm._l((_vm.nextTasks),function(task){return _c('div',{key:task.globalUuid,staticClass:"list-item"},[_c('span',[_vm._v(_vm._s(task.description))])])})),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('buttons.save'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.finishEnvironment'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e()],1)]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishEnvironment'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeStage,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.change_criteria'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.changeCurrentTask,"cancel":_vm.onModalClose},model:{value:(_vm.isChangeCurrent),callback:function ($$v) {_vm.isChangeCurrent=$$v},expression:"isChangeCurrent"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactionStagesList_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d8c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReactionStagesList_vue__ = __webpack_require__(1094);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactionStagesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d8c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReactionStagesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol'))+": "+_vm._s(_vm.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.protocol && _vm.protocol.teachingMethod.id !== 5 && _vm.protocol.teachingMethod.id !== 6 && _vm.protocol.teachingMethod.id !== 9)?_c('h2',{staticClass:"second-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.choose_stage')))]):_vm._e(),_vm._v(" "),(_vm.protocol && (_vm.protocol.teachingMethod.id === 5 || _vm.protocol.teachingMethod.id === 6))?_c('h2',{staticClass:"second-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.chooseEnvironment')))]):_vm._e(),_vm._v(" "),(_vm.protocol && (_vm.protocol.teachingMethod.id === 9))?_c('h2',{staticClass:"second-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.chooseLevel')))]):_vm._e(),_vm._v(" "),(_vm.protocolsData && _vm.stagesList.length)?_c('div',{staticClass:"row"},_vm._l((_vm.stagesList),function(stage){return (!stage.isClosed)?_c('div',{staticClass:"mt-3 col-lg-3 col-md-4 link-stage"},[(_vm.protocol && _vm.protocol.teachingMethod.id !== 4 && _vm.protocol.teachingMethod.id !== 1  && _vm.protocol && _vm.protocol.teachingMethod.id !== 2 && _vm.protocol.teachingMethod.id !== 9 && _vm.protocol.teachingMethod.id !== 10)?_c('router-link',{staticClass:"link-stage__button",attrs:{"to":{ name: _vm.protocol.teachingMethod.id === 5 ? 'chain-stage-current' : _vm.protocol.teachingMethod.id === 6 ? 'shaping-stage-current' : 'mand-stage-current', params: {protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol && _vm.protocol.teachingMethod.id === 4)?_c('router-link',{staticClass:"link-stage__button",attrs:{"to":{ name: 'choose-usd', params: {protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol && _vm.protocol.teachingMethod.id === 1)?_c('router-link',{staticClass:"link-stage__button",attrs:{"to":{ name: 'choose-stage', params: {protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol.teachingMethod.id === 2)?_c('router-link',{staticClass:"link-stage__button",attrs:{"to":{ name: 'current-stage', params: { clientId: _vm.clientId, protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol.teachingMethod.id === 9 && stage.isAvailable && !stage.isDisabled)?_c('router-link',{staticClass:"link-stage__button",attrs:{"to":{ name: 'pecs-with-discrimination-stage', params: { clientId: _vm.clientId, protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol.teachingMethod.id === 9 && !stage.isAvailable && !stage.isDisabled)?_c('span',{staticClass:"link-stage__button disabled"},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e(),_vm._v(" "),(_vm.protocol.teachingMethod.id === 10)?_c('router-link',{staticClass:"link-stage__button ",attrs:{"to":{ name: 'pecs-with-items-stage', params: { clientId: _vm.clientId, protocolData: _vm.protocolsData, stageId:stage.id}}}},[_c('h4',{staticClass:"link-stage__title"},[_vm._v(_vm._s(stage.description))])]):_vm._e()],1):_vm._e()})):_vm._e(),_vm._v(" "),(!_vm.stagesList.length)?_c('div',{staticClass:"col-12"},[_vm._v("\n\n        "+_vm._s(_vm._f("trans")('protocol.withoutProperties'))+"\n\n      ")]):_vm._e()]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasteringStage_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b33413c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasteringStage_vue__ = __webpack_require__(1105);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasteringStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b33413c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasteringStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering'))+": "),(_vm.protocols)?_c('span',[_vm._v(_vm._s(_vm.protocols.title))]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+": "+_vm._s(_vm.conditionTransfer)+"\n        ")]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.add_new_stimulus')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStimulus(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),(_vm.activeStep.taskType)?_c('h3',{staticClass:"row-title mt-5"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n          "+_vm._s(_vm.activeStep.taskType.title))]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',{staticClass:"position-relative wrapper-loader"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2",class:{'box-shadow': _vm.activeStep.withFields}},[(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title",on:{"click":function($event){phaseItem.visible = !phaseItem.visible}}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+": "+_vm._s(phaseItem.items.length)+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),(phaseItem.visible)?_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('tr',{key:stimul.id},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.attempt))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"attepmtsCount"},on:{"keydown":_vm.changeNumber},model:{value:(stimul.attepmtsCount),callback:function ($$v) {_vm.$set(stimul, "attepmtsCount", $$v)},expression:"stimul.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+label.title+index + stimul.id + label.id,"type":"radio","name":'radios'+index + stimul.id + label.id},domProps:{"value":label.title+index + stimul.id + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + label.id)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+label.title+index + stimul.id + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount + 1)+"\n                  ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == _vm.activeStep.maxFieldCount)) || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                  ")]):_vm._e()])]):_vm._e()}))]):_vm._e()]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',{staticClass:"mobile-table position-relative"},_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2"},[(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title",on:{"click":function($event){phaseItem.visible = !phaseItem.visible}}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(phaseItem.items.length)+" "+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),(phaseItem.visible)?_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]):_vm._e(),_vm._v(" "),(phaseItem.visible)?_c('div',{staticClass:"mobile-table__body"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('div',{key:stimul.id,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount +1)+"\n                    ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == _vm.activeStep.maxFieldCount)) || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (phaseItem.length/3) == 0}},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id + label.id +key,"type":"radio","name":'radios'+index + stimul.id + label.id +key},domProps:{"value":label.title+index + stimul.id + label.id +key,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + label.id +key)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + label.id +key)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.id + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()})):_vm._e()]):_vm._e()})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.save'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-stage'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSession,"cancel":_vm.cancelSession},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaintainStage_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97381596_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaintainStage_vue__ = __webpack_require__(1107);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaintainStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97381596_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaintainStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support'))+": "),(_vm.protocols)?_c('span',[_vm._v(_vm._s(_vm.protocols.title))]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.conductingTherapeuticSession')))]),_vm._v(" "),(_vm.activeStep.taskType)?_c('h3',{staticClass:"step-title mt-4"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n          "+_vm._s(_vm.activeStep.taskType.title))]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"step-title"},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.today_support_stimulus')))]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolData && _vm.protocolData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isMobile && _vm.todayStimulList)?_c('div',{staticClass:"position-relative wrapper-loader"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.todayStimulList),function(stimul,index){return (!stimul.moveToPrevPhase)?_c('tr',{key:stimul.globalUuid},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('td',{staticClass:"wide-cell"},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key,"type":"radio","disabled":stimul.disabled,"name":'radios'+index + stimul.globalUuid},domProps:{"value":label.title,"checked":_vm._q(stimul.answer,label.title)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title)},function($event){_vm.attemptChange(label.id, stimul)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(stimul.toRotation && _vm.stageInfo && _vm.stageInfo.phases.length > 1)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToPrevPhase(stimul.globalUuid)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.to_prev_phase'))+"\n                ")]):_vm._e()])]):_vm._e()}))]),_vm._v(" "),(_vm.allStimulList)?_c('div',{staticClass:"box-shadow mt-2 mb-4"},[_c('h3',{staticClass:"step-title",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.support_stimulus'))+"\n              "),(_vm.allStimulList.length)?_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[_c('span',{class:{'arrow-down': _vm.visible, 'arrow-up':!_vm.visible}})]):_vm._e()]),_vm._v(" "),(_vm.visible)?_c('table',{staticClass:"table table-sm mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.list.interval')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.allStimulList),function(stimul,index){return _c('tr',{key:stimul.globalUuid},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.getInterval(stimul.intervalType))+"\n                ")])])}))]):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.todayStimulList)?_c('div',[_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.todayStimulList),function(stimul,index){return (!stimul.moveToPrevPhase)?_c('div',{key:stimul.globalUuid,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(stimul.toRotation && _vm.stageInfo && _vm.stageInfo.phases.length > 1)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToPrevPhase(stimul.globalUuid)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_prev_phase'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))])]),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row"},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key,"type":"radio","disabled":stimul.disabled,"name":'radios'+index + stimul.globalUuid},domProps:{"value":label.title,"checked":_vm._q(stimul.answer,label.title)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title)},function($event){_vm.attemptChange(label.id, stimul)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]),_vm._v(" "),(_vm.allStimulList)?_c('div',{staticClass:"box-shadow mt-2 mb-4"},[_c('h3',{staticClass:"step-title",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.support_stimulus'))+"\n              "),(_vm.allStimulList.length)?_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[_c('span',{class:{'arrow-down': _vm.visible, 'arrow-up':!_vm.visible}})]):_vm._e()]),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.allStimulList),function(stimul,index){return _c('div',{key:stimul.globalUuid,staticClass:"mobile-table__row"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n                    "+_vm._s(stimul.description)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"description mt-2"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat'))+":\n                      "+_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")('dro.list.interval'))+":\n                      "+_vm._s(_vm.getInterval(stimul.intervalType)))])])])}))]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('buttons.save'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-stage'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSession,"cancel":_vm.cancelSession},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationStage_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90b547fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationStage_vue__ = __webpack_require__(1109);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90b547fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.rotation'))+": "),(_vm.protocols)?_c('span',[_vm._v(_vm._s(_vm.protocols.title))]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+": "+_vm._s(_vm.conditionTransfer)+"\n        ")]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!(_vm.isClient || _vm.isTherapist))?_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.add_new_stimulus')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStimulus(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),(_vm.activeStep.taskType)?_c('h3',{staticClass:"row-title mt-5"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n          "+_vm._s(_vm.activeStep.taskType.title))]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2 position-relative wrapper-loader",class:{'box-shadow': _vm.activeStep.withFields}},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title",on:{"click":function($event){phaseItem.visible = !phaseItem.visible}}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(phaseItem.items.length)+" "+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),(phaseItem.visible)?_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('tr',{key:stimul.id},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.attempt))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"code1"},on:{"keydown":_vm.changeNumber},model:{value:(stimul.attepmtsCount),callback:function ($$v) {_vm.$set(stimul, "attepmtsCount", $$v)},expression:"stimul.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key + label.id,"type":"radio","name":'radios'+index + stimul.id + key + label.id,"disabled":_vm.isDisabled},domProps:{"value":label.title+index + stimul.id + key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + key + label.id)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : _vm.isDisabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.id + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount +1)+"\n                  ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == (_vm.activeStep.maxFieldCount))) || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                  ")]):_vm._e()])]):_vm._e()}))]):_vm._e()],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',{staticClass:"mobile-table"},_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2"},[(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(phaseItem.items.length)+" "+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('div',{key:stimul.id,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount +1)+"\n                    ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == (_vm.activeStep.maxFieldCount))) || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (phaseItem.length/3) == 0}},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key + label.id,"type":"radio","name":'radios'+index + stimul.id + key + label.id},domProps:{"value":label.title+index + stimul.id + key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + key + label.id)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.id + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]):_vm._e()})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.save'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link  btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-stage'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSession,"cancel":_vm.cancelSession},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FluencyStage_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2013401d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FluencyStage_vue__ = __webpack_require__(1111);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FluencyStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2013401d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FluencyStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.fluency'))+": "),(_vm.protocols)?_c('span',[_vm._v(_vm._s(_vm.protocols.title))]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+": "+_vm._s(_vm.conditionTransfer)+"\n          "),_c('br'),_vm._v(" "),(_vm.activeStep.executionSecondsLimit)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.executionSeconds', {time: _vm.activeStep.executionSecondsLimit })))]):_vm._e()]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!(_vm.isClient || _vm.isTherapist))?_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.add_new_stimulus')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStimulus(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),(_vm.activeStep.taskType)?_c('h3',{staticClass:"row-title mt-5"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n          "+_vm._s(_vm.activeStep.taskType.title))]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2 position-relative wrapper-loader",class:{'box-shadow': _vm.activeStep.withFields}},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title",on:{"click":function($event){phaseItem.visible = !phaseItem.visible}}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(phaseItem.items.length)+" "+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),(phaseItem.visible)?_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))]),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trial_count')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('tr',{key:stimul.id},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.attempt))]),_vm._v(" "),((_vm.isBCBA || _vm.isCurator))?_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],ref:"attepmtsCount",refInFor:true,attrs:{"id":"attepmtsCount","type":"number","min":"1","max":"1000","name":"code1"},on:{"keydown":_vm.changeNumber},model:{value:(stimul.attepmtsCount),callback:function ($$v) {_vm.$set(stimul, "attepmtsCount", $$v)},expression:"stimul.attepmtsCount"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key + label.id,"type":"radio","name":'radios'+index + stimul.id + key + label.id,"disabled":_vm.isDisabled},domProps:{"value":label.title+index + stimul.id + key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + key + label.id)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : _vm.isDisabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.id + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount +1)+"\n                  ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == (_vm.activeStep.maxFieldCount)))  || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                  ")]):_vm._e()])]):_vm._e()}))]):_vm._e()],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.isMobile && !_vm.stimulusListEmpty && _vm.phases)?_c('div',{staticClass:"mobile-table"},_vm._l((_vm.phases),function(phaseItem,indexPhase){return (_vm.visibleList(phaseItem.items))?_c('div',{staticClass:"mb-2"},[(_vm.activeStep.withFields)?_c('h3',{staticClass:"step-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.field'))+"\n              "),_c('span',[_vm._v(_vm._s(indexPhase + +_vm.activeStep.minFieldCount))]),_vm._v("\n              ("+_vm._s(phaseItem.items.length)+" "+_vm._s(_vm._f("trans")('protocol.stimulus_count'))+")\n              "),_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[(phaseItem.countToNextLevel)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.assimilate_stimulus', {attribute: phaseItem.countToNextLevel})))]):_vm._e(),_vm._v(" "),_c('span',{class:{'arrow-down': phaseItem.visible, 'arrow-up':!phaseItem.visible}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((phaseItem.items),function(stimul,index){return (!stimul.moveToNextPhase)?_c('div',{key:stimul.id,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(stimul.toNextLevel && (stimul.fieldIndex != _vm.activeStep.maxFieldCount) && _vm.activeStep.withFields)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_field'))+" "+_vm._s(indexPhase + +_vm.activeStep.minFieldCount +1)+"\n                    ")]):_vm._e(),_vm._v(" "),((stimul.toNextLevel && (stimul.fieldIndex == (_vm.activeStep.maxFieldCount)))  || (stimul.toNextLevel && !_vm.activeStep.withFields))?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToNextLevel(stimul.id, stimul, indexPhase, true)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_next_phase'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((stimul.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': stimul.lastAnswers.length > 5 && index < (stimul.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(stimul.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (phaseItem.length/3) == 0}},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title+index + stimul.id + key + label.id,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key + label.id,"type":"radio","name":'radios'+index + stimul.id + key + label.id},domProps:{"value":label.title+index + stimul.id + key + label.id,"checked":_vm._q(stimul.answer,label.title+index + stimul.id + key + label.id)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title+index + stimul.id + key + label.id)},function($event){_vm.attemptChange(label.id, stimul,indexPhase, label.title, stimul.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.id + key + label.id}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!(stimul.sessionAnswers[stimul.fieldIndex] ? stimul.sessionAnswers[stimul.fieldIndex].length : false)},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.id,indexPhase, stimul, stimul.toNextLevel)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]):_vm._e()})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.save'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link  btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-stage'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSession,"cancel":_vm.cancelSession},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseStage_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd917374_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseStage_vue__ = __webpack_require__(1115);
function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd917374_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[(_vm.protocolVuexData)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol'))+": "+_vm._s(_vm.protocolVuexData.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolVuexData && _vm.protocolVuexData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.stage)?_c('h2',{staticClass:"second-title"},[_vm._v("\n    "+_vm._s(_vm._f("trans")('protocol.stage'))+": "+_vm._s(_vm.stage.description)+"\n\n    "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-primary float-md-right",on:{"click":function($event){_vm.closeSession()}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('protocol.buttons.finishStage'))+"\n    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title mt-3 mt-md-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.choose_phase')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.protocolVuexData)?_c('stage-header',{attrs:{"stage":_vm.stage,"protocolsData":_vm.protocolVuexData,"stageCount":_vm.stageCount},on:{"close-session":_vm.closeSession,"fetch-protocol":_vm.fetchProtocolData}}):_vm._e(),_vm._v(" "),(_vm.mastering)?_c('div',{staticClass:"mb-4",class:{
    'col-md-3': _vm.phasesCount == 4,
    'col-md-4': _vm.phasesCount == 3,
    'col-md-6': _vm.phasesCount == 2 || _vm.phasesCount == 1,
  }},[_c('router-link',{staticClass:"link-box link-box_red",attrs:{"to":{ name: 'mastering-stage', params: {stageId: this.stageId, phaseId: 1, protocolData:_vm.protocolVuexData, client:_vm.client, stage: _vm.stage}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering')))])])],1):_vm._e(),_vm._v(" "),(_vm.rotation)?_c('div',{staticClass:"mb-4",class:{
    'col-md-3': _vm.phasesCount == 4,
    'col-md-4': _vm.phasesCount == 3,
    'col-md-6': _vm.phasesCount == 2 || _vm.phasesCount == 1,
  }},[(_vm.rotationCount)?_c('router-link',{staticClass:"link-box link-box_orange",attrs:{"to":{ name: 'rotation-stage', params: {stageId: this.stageId, phaseId: 2, protocolData:_vm.protocolVuexData, client:_vm.client, stage: _vm.stage}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.rotation')))])]):_vm._e(),_vm._v(" "),(!_vm.rotationCount)?_c('div',{staticClass:"link-box link-box_orange disabled"},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.rotation')))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.fluency)?_c('div',{staticClass:"mb-4",class:{
    'col-md-3': _vm.phasesCount == 4,
    'col-md-4': _vm.phasesCount == 3,
    'col-md-6': _vm.phasesCount == 2 || _vm.phasesCount == 1,
  }},[(_vm.fluencyCount)?_c('router-link',{staticClass:"link-box link-box_light-green",attrs:{"to":{ name: 'fluency-stage', params: {stageId: this.stageId, phaseId: 4, protocolData:_vm.protocolVuexData, client:_vm.client, stage: _vm.stage}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.fluency')))])]):_vm._e(),_vm._v(" "),(!_vm.fluencyCount)?_c('div',{staticClass:"link-box link-box_orange disabled"},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.fluency')))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.support)?_c('div',{staticClass:"mb-4",class:{
    'col-md-3': _vm.phasesCount == 4,
    'col-md-4': _vm.phasesCount == 3,
    'col-md-6': _vm.phasesCount == 2 || _vm.phasesCount == 1,
  }},[(_vm.supportCount)?_c('router-link',{staticClass:"link-box link-box_green",attrs:{"to":{ name: 'maintain-stage', params: {stageId: this.stageId, phaseId: 3, client:_vm.client, stage: _vm.stage, teachingMethod: 1}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support')))])]):_vm._e(),_vm._v(" "),(!_vm.supportCount)?_c('div',{staticClass:"link-box link-box_orange disabled"},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support')))])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('router-view')],1),_vm._v(" "),(_vm.stageCount > 1)?_c('div',{staticClass:"col-md-12 form-group-button stage-button"},[_c('router-link',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolData: _vm.protocolVuexData, teachingMethod: 1, stage: _vm.stage }}}},[_c('span',[_vm._v("Вернуться к списку этапов")])])],1):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishCurrentStage'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeStage,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseUSDStage_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477360ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseUSDStage_vue__ = __webpack_require__(1118);
function injectStyle (ssrContext) {
  __webpack_require__(1117)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseUSDStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477360ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseUSDStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('stage-header',{attrs:{"stage":_vm.stage,"stageCount":_vm.stageCount},on:{"close-session":_vm.closeSession,"fetch-protocol":_vm.fetchProtocol}}),_vm._v(" "),(_vm.mastering)?_c('div',{staticClass:"mb-4 col-md-6"},[(_vm.masteringCount)?_c('router-link',{staticClass:"link-box link-box_red",attrs:{"to":{ name: 'mastering-stage-usd', params: {protocolData:_vm.protocolsData, phaseId: _vm.mastering.id, client:_vm.clientData, stageId:_vm.stageId, stage: _vm.stage}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering')))])]):_vm._e(),_vm._v(" "),(!_vm.masteringCount)?_c('div',{staticClass:"link-box link-box_red disabled"},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering')))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.support)?_c('div',{staticClass:"mb-4 col-md-6"},[(_vm.supportCount)?_c('router-link',{staticClass:"link-box link-box_green",attrs:{"to":{ name: 'maintain-stage-usd', params: {phaseId: _vm.support.id, client:_vm.clientData, stageId:_vm.stageId, stage: _vm.stage}}}},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support')))])]):_vm._e(),_vm._v(" "),(!_vm.supportCount)?_c('div',{staticClass:"link-box link-box_orange disabled"},[_c('h4',{staticClass:"link-box__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support')))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.activeStageCount > 1)?_c('div',{staticClass:"col-md-12 form-group-button stage-button"},[_c('router-link',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"to":{ name: 'stage-list', params: {clientId: _vm.clientId, protocolData: _vm.protocolsData, teachingMethod: 4, stage: _vm.stage }}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.back_to_list')))])])],1):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.title,"accept":_vm._f("trans")('protocol.buttons.finishCurrentStage'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeStage,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageResults_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54ddc6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageResults_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54ddc6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1120 */,
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_axios__ = __webpack_require__(139);






/**
 * Protocol API manager.
 */

var ProtocolApiManager = function () {

  /**
   * Constructor.
   *
   * @param {String} url
   */
  function ProtocolApiManager(url) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ProtocolApiManager);

    this.url = url;
  }

  /**
   * Paginate last sessions.
   *
   * @param {Number} userId
   * @param {Number} perPage
   * @param {Number} page
   * @returns {Promise<any>}
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProtocolApiManager, [{
    key: 'paginateLastSessions',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var userId = _ref2.userId,
            _ref2$perPage = _ref2.perPage,
            perPage = _ref2$perPage === undefined ? 5 : _ref2$perPage,
            _ref2$page = _ref2.page,
            page = _ref2$page === undefined ? 1 : _ref2$page;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__config_axios__["a" /* default */].get(this.url + '/users/' + userId + '/last-sessions/' + perPage + '/' + page, {});

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function paginateLastSessions(_x) {
        return _ref.apply(this, arguments);
      }

      return paginateLastSessions;
    }()
  }]);

  return ProtocolApiManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtocolApiManager);

/***/ }),
/* 1122 */,
/* 1123 */,
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageChain_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77606b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageChain_vue__ = __webpack_require__(1126);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageChain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77606b00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageChain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"mdc_dialog_wider",attrs:{"title":_vm.title,"accept":_vm._f("trans")('user.close')},on:{"cancel":_vm.close,"accept":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.dataSet)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.dataSet)?_c('bar-chart',{attrs:{"bardatasets":_vm.fetchBarDatasetForChart(),"withLabels":true,"scaleLabelY":_vm.scaleY,"scaleLabelX":_vm._f("trans")('report.blocks'),"aspectRatio":false,"valueMax":_vm.valueMax,"vertical-line-point":_vm.verticalLinePoint,"show-legend":!(_vm.isChain || _vm.isPecs|| _vm.isPecsWithoutDiscrimination|| _vm.isPecsWithDiscrimination || _vm.isPecsWithItems) || _vm.isStageChain ? !!_vm.dataSet.data.length : false,"height":360}}):_vm._e(),_vm._v(" "),(!_vm.isChain && !_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm.graphTitle)+" "+_vm._s(_vm.stimulName)+" ("+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+").\n  ")]):_vm._e(),_vm._v(" "),((_vm.isChain || _vm.isPecs || _vm.isPecsWithoutDiscrimination) && _vm.chartType === 1)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm._f("trans")(_vm.isChain ? 'report.chart_for_step_daily' : _vm.isStageChain ? 'report.chart_for_steps_daily_pecs' : 'report.chart_for_step_daily_pecs'))+": "+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+".\n  ")]):_vm._e(),_vm._v(" "),((_vm.isChain || _vm.isPecs || _vm.isPecsWithoutDiscrimination) && _vm.chartType !== 1)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm._f("trans")(_vm.isChain ? 'report.chart_for_percent_daily' : _vm.isStageChain ? 'report.chart_for_steps_daily_pecs' : 'report.chart_for_percent_daily_pecs'))+": "+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+".\n  ")]):_vm._e(),_vm._v(" "),((_vm.isPecsWithDiscrimination || _vm.isPecsWithItems) && !!this.isStageChain)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm.graphTitle)+" "+_vm._s(_vm._f("trans")('protocol.category'))+" "+_vm._s(_vm.categoryInfo.title)+" ("+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+").\n  ")]):_vm._e(),_vm._v(" "),((_vm.isPecsWithDiscrimination || _vm.isPecsWithItems) && !this.isStageChain)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm._f("trans")(_vm.chartType === 1 ? 'protocol.chart_properties_per_day' : 'protocol.chart_properties_percent_per_day'))+". "+_vm._s(_vm._f("trans")('protocol.categoryTitle'))+" "+_vm._s(_vm.categoryInfo.title)+" ("+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+").\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-5"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.title_chain'))+" "+_vm._s(_vm.stage.description))]),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.options,"isChange":_vm.isChange,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"name",fn:function(props){return _c('div',{},[_vm._v("\n      "+_vm._s(props.row.name)+"\n      "),(!props.row.active)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('protocol.disable')))]):_vm._e()])}},{key:"motivationCondition",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.yes')))]):_vm._e(),_vm._v(" "),(!props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.no')))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.name)?_c('div',[_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.id),"disabled":_vm.chosenStimul.length == 4 && !_vm.checkedStimulus(props.row.id)},on:{"change":function($event){_vm.choseStimulus(props.row, $event)}}})],1):_vm._e()])}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.chartShow()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[(_vm.chartDatasetsForStimul && _vm.chartDatasetsForStimul.chartData && _vm.chartDatasetsForStimul.chartData.length && _vm.chartDatasetsForStimulDataset)?_c('div',{staticClass:"col-12",class:{'mb-1': _vm.isChangeStimuli}},[_c('div',{staticClass:"row position-relative"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{class:{'col-md-9' : (_vm.chartDatasetsForStimul.chartData.length === 1), 'col-md-12' : _vm.chartDatasetsForStimul.chartData.length !== 1  }},[_c('line-chart',{staticClass:"row",attrs:{"datasets":_vm.chartDatasetsForStimulDataset,"scale-label":_vm._f("trans")('protocol.total_percent'),"stage-info":_vm.stage.id,"list-chart-date":_vm.chartDatasetsForStimul.labels,"many-chart":_vm.chartDatasetsForStimul.chartData.length > 1,"show-legend":_vm.chartDatasetsForStimul.chartData.length > 1,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changesLine,"linedatasets":_vm.trendLinePoint,"persentMax":_vm.persentMax,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":340,"width":null},on:{"popup-show":_vm.popupShow}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.stimulus_mastering_chart'))+"\n            "),_vm._l((_vm.chartDatasetsForStimulDataset),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.label)),(index < _vm.chartDatasetsForStimulDataset.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(".\n          ")],2)],1),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length === 1)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.chosenStimul.length && _vm.withoutData)?_c('div',{staticClass:"col-md-12 text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_data'))+" "),_vm._l((_vm.chosenStimul),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.name)),(index < _vm.chosenStimul.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(".")],2)]):_vm._e()]),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isChain":true,"isStageChain":true,"chartType":"1","stimulId":_vm.chosenStimul[0].id,"stage-id":_vm.selectedStageId,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageShaping_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ef3da2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageShaping_vue__ = __webpack_require__(1130);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageShaping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ef3da2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageShaping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopupShaping_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb4894f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopupShaping_vue__ = __webpack_require__(1129);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopupShaping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb4894f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopupShaping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"mdc_dialog_wider",attrs:{"title":_vm._f("trans")('protocol.detail_reaction_session'),"accept":_vm._f("trans")('user.close')},on:{"cancel":_vm.close,"accept":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.dataSet)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.dataSet && _vm.dataSet.yLabels)?_c('line-shaping-chart',{key:"shapingChart",staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForShapingChart(_vm.dataSet.data),"chart-id":"shapingChart","xAxisLabel":_vm._f("trans")('protocol.probe_by_session'),"y-labels":_vm.dataSet.yLabels,"list-chart-date":_vm.dataSet.xLabels,"show-legend":false,"y-axes-begin-at-zero":true,"height":380,"all-axis-show":true,"width":null,"aspect-ratio":false}}):_vm._e(),_vm._v(" "),(_vm.dataSet && _vm.dataSet.yLabels)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.shaping_chart'))+" \""+_vm._s(_vm.dataSet.stage.description)+"\"")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row mt-3"},[(_vm.measurementsShaping && _vm.yLabelsShaping)?_c('div',{staticClass:"col-12"},[_c('line-shaping-chart',{key:"shapingChart",staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForShapingChart(_vm.measurementsShaping),"stageId":_vm.stage.id,"y-labels":_vm.yLabelsShaping,"list-chart-date":_vm.xLabelsShaping,"vertical-line-point":_vm.changes,"show-legend":false,"y-axes-begin-at-zero":true,"height":680,"width":null,"aspect-ratio":false},on:{"popup-show":_vm.popupShow}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.shaping_chart'))+" \""+_vm._s(_vm.stage.description)+"\"")])],1):_vm._e()]),_vm._v(" "),(_vm.isShapingModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isShapingModalVisible,"stage-id":_vm.stage.id,"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSimple_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeea5a1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSimple_vue__ = __webpack_require__(1135);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSimple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeea5a1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSimple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.fetchDatasetForPromptsChart(_vm.promtChartValues).length)?_c('div',{staticClass:"col-12"},[_c('line-non-numeric-y-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForPromptsChart(_vm.promtChartValues),"chart-id":'promtChart' + _vm.stageId + _vm.index,"stage-info":_vm.stageId,"y-labels":_vm.promtChartLevels,"scale-label":_vm._f("trans")('report.label_prompt_levels'),"show-legend":false,"y-axes-begin-at-zero":true,"height":280,"width":null,"aspect-ratio":false},on:{"popup-show":_vm.popupPromptShow}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n      "+_vm._s(_vm._f("trans")('report.graph_prompt_levels'))+" "+_vm._s(_vm.description)+".\n    ")]),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isSimple":_vm.isSimple,"isDtt":_vm.isDtt,"chartType":"2","stimulId":_vm.isDtt ? _vm.chosenStimul[0].globalTaskId : _vm.chosenStimul[0].id,"stage-id":_vm.selectedStageId,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageSimple_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc67ac4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageSimple_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageSimple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc67ac4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageSimple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row mt-3"},[(_vm.measurements && _vm.xLabels)?_c('div',{class:{'col-9': _vm.xLabels.length >= 3 && _vm.measurements.tasksChart.length === 1, 'col-12': _vm.xLabels.length < 3 || _vm.measurements.tasksChart.length !== 1 }},[(_vm.xLabels.length)?_c('line-chart',{staticClass:"row",attrs:{"datasets":_vm.dataset,"chart-id":'stageChart_' + _vm.stage.id,"scale-label":_vm._f("trans")('protocol.total_percent'),"stage-info":_vm.stage.id,"persentMax":true,"show-legend":_vm.dataset.length > 1,"list-chart-date":_vm.measurements.labels,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changes,"linedatasets":_vm.trendLinePoint,"labelText":'%',"aspect-ratio":false,"height":340,"width":null},on:{"popup-show":_vm.popupShow}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_mastering_chart'))+" \""+_vm._s(_vm.stage.description)+"\"")])],1):_vm._e(),_vm._v(" "),(_vm.measurements && _vm.xLabels && _vm.xLabels.length >= 3 && _vm.measurements.tasksChart.length === 1)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.measurements && _vm.xLabels && _vm.datasetImproved && _vm.datasetImproved[0].data.length)?_c('div',{staticClass:"col-12"},[(_vm.xLabels.length)?_c('line-chart',{staticClass:"row mt-5",attrs:{"datasets":_vm.datasetImproved,"chart-id":'stageChartImproved_' + _vm.stage.id,"scale-label":_vm._f("trans")('report.label_improve_prompt'),"stage-info":_vm.stage.id,"persentMax":true,"list-chart-date":_vm.measurements.labels,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changes,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":340,"width":null}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_improved_chart'))+" \""+_vm._s(_vm.stage.description)+"\"")])],1):_vm._e()]),_vm._v(" "),(_vm.measurements && _vm.measurements.tasksChart)?_c('div',{staticClass:"row"},_vm._l((_vm.measurements.tasksChart),function(taskChart){return (taskChart.promptChartData.values && taskChart.promptChartData.values.length)?_c('div',{staticClass:"col-12"},[_c('prompt-chart',{attrs:{"promt-chart-values":taskChart.promptChartData.hintResultsData,"promt-chart-levels":_vm.hintRezultsLevels,"stage-id":_vm.stage.id,"chosen-stimul":_vm.chosenStimul,"protocol-id":_vm.protocolId,"description":taskChart.description + '. ' + _vm.stage.description,"index":0,"isSimple":true}})],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isSimple":true,"stimulName":_vm.chosenStimul[0].stimulusName,"chartType":_vm.type,"stage-id":_vm.stage.id,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"stimulId":_vm.chosenStimul[0].id,"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('report.table_prompts')))]),_vm._v(" "),(_vm.showReport)?_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.optionsStatisticList,"isChange":_vm.isChangeStatic,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"motivationCondition",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.yes')))]):_vm._e(),_vm._v(" "),(!props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.no')))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.name)?_c('div',[_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.id),"disabled":_vm.chosenStimul.length == 4 && !_vm.checkedStimulus(props.row.id),"name":"mandReaction"},on:{"change":function($event){_vm.choseSimpleStimulus(props.row, $event)}}})],1):_vm._e()])}}])}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.chartSimpleShow()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n      ")])]),_vm._v(" "),_vm._l((_vm.stagesList),function(stage){return ((!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id)) && _vm.chosenStimul.length && _vm.showReport)?_c('div',{staticClass:"row"},[_c('current-stage-simple',{attrs:{"protocol-id":_vm.protocolId,"chosenStimul":_vm.chosenStimul,"is-apply-filter":_vm.showSimpleReport,"stage":stage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentMand_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6fb6266_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentMand_vue__ = __webpack_require__(1144);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentMand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6fb6266_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentMand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MandPopup_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db28b22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MandPopup_vue__ = __webpack_require__(1142);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MandPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db28b22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MandPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"mdc_dialog_wider",attrs:{"title":_vm._f("trans")('report.chart_for_stimul_daily'),"accept":_vm._f("trans")('user.close')},on:{"cancel":_vm.close,"accept":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.mandDataSet)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.mandDataSet)?_c('bar-chart',{attrs:{"bardatasets":_vm.fetchBarDatasetForChart(),"withLabels":true,"scaleLabelY":_vm._f("trans")('report.reaction_count'),"scaleLabelX":_vm._f("trans")('report.blocks'),"aspectRatio":false,"vertical-line-point":_vm.verticalLinePoint,"show-legend":!!_vm.mandDataSet.data.length,"height":360}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n    "+_vm._s(_vm.graphTitle)+": "+_vm._s(_vm.stimulName)+". "+_vm._s(_vm.typeTitle)+". ("+_vm._s(_vm.toLocaleDate(_vm.dataPoint))+")\n    "),_c('br'),_vm._v(" "),(_vm.mandType == 3  || _vm.mandType == 7 || _vm.mandType == 8)?_c('span',[_vm._v("\n      "+_vm._s(_vm._f("trans")('report.legend'))+"\n      "+_vm._s(_vm.mandAnswers[0].title)+" - "+_vm._s(_vm.mandAnswers[0].description)+",\n      "+_vm._s(_vm.mandAnswers[1].title)+" - "+_vm._s(_vm.mandAnswers[1].description)+",\n      "+_vm._s(_vm.mandAnswers[4].title)+" - "+_vm._s(_vm.mandAnswers[4].description)+".\n    ")]):_vm._e(),_vm._v(" "),(_vm.mandType == 9  || _vm.mandType == 10)?_c('span',[_vm._v("\n      "+_vm._s(_vm._f("trans")('report.legend'))+"\n      "+_vm._s(_vm.mandAnswers[2].title)+" - "+_vm._s(_vm.mandAnswers[2].description)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-5"},[_vm._l((_vm.mandDataset),function(mandData,index){return _c('div',{staticClass:"row"},[_c('div',{class:{
        'col-md-9' : (_vm.mandType != 6 && _vm.mandType != 10 && _vm.mandType != 8 && _vm.mandType != 7 && _vm.mandType != 11),
        'col-md-12' : !(_vm.mandType != 6 && _vm.mandType != 10 && _vm.mandType != 8 && _vm.mandType != 7 && _vm.mandType != 11)}},[_c('div',{staticClass:"position-relative"},[(_vm.isChangeStimuli)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.mandType != 6 && _vm.mandType != 11)?_c('line-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForMandChart(mandData),"chart-id":'mandChart' + _vm.mandType + index,"stageInfo":mandData.stageInfo,"withoutMax":_vm.mandType == 5  || _vm.mandType == 8 || _vm.mandType == 10 || _vm.mandType == 11,"persentMax":_vm.mandType != 5  && _vm.mandType != 6 && _vm.mandType != 8 && _vm.mandType != 11 && _vm.mandType != 10,"is-value-type":true,"show-legend":_vm.mandType == 7 || _vm.mandType == 8,"linedatasets":_vm.trendLinePoint[index],"y-axes-begin-at-zero":true,"list-chart-date":mandData.days,"vertical-line-point":mandData.pointArray,"many-chart":_vm.mandType == 8 || _vm.mandType == 7,"scale-label":_vm.scaleLabelTitle(_vm.mandType),"aspect-ratio":false,"height":280,"width":null},on:{"popup-show":_vm.popupShow}}):_vm._e(),_vm._v(" "),(_vm.mandType == 6 && _vm.mandLevels.length && _vm.fetchDatasetForMandChart(mandData).length)?_c('line-non-numeric-y-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForMandChart(mandData),"chart-id":'mandChart' + _vm.mandType + index,"stageInfo":mandData.stageInfo,"y-labels":_vm.hintRezultsLevels,"show-legend":false,"y-axes-begin-at-zero":true,"scale-label":_vm.scaleLabelTitle(_vm.mandType),"height":280,"width":null,"aspect-ratio":false},on:{"popup-show":_vm.popupShow}}):_vm._e(),_vm._v(" "),((_vm.mandType != 11 && _vm.mandType != 6) || (_vm.mandType == 6 && _vm.mandLevels.length && _vm.fetchDatasetForMandChart(mandData).length))?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n          "+_vm._s(_vm.mandGraphReactionTitle(_vm.mandType))+": "),_c('span',[_vm._v(_vm._s(_vm.mandTitle))]),_vm._v(". "+_vm._s(mandData.stageInfo.description)+".\n          "),_c('br'),_vm._v(" "),(_vm.mandType == 3  || _vm.mandType == 7 || _vm.mandType == 8)?_c('span',[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.legend'))+"\n          "+_vm._s(_vm.mandAnswers[0].title)+" - "+_vm._s(_vm.mandAnswers[0].description)+",\n          "+_vm._s(_vm.mandAnswers[1].title)+" - "+_vm._s(_vm.mandAnswers[1].description)+",\n          "+_vm._s(_vm.mandAnswers[4].title)+" - "+_vm._s(_vm.mandAnswers[4].description)+".\n        ")]):_vm._e(),_vm._v(" "),(_vm.mandType == 9  || _vm.mandType == 10)?_c('span',[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.legend'))+"\n          "+_vm._s(_vm.mandAnswers[2].title)+" - "+_vm._s(_vm.mandAnswers[2].description)+"\n        ")]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),(_vm.mandType != 6 && _vm.mandType != 10 && _vm.mandType != 8 && _vm.mandType != 7 && _vm.mandType != 11  && index == 0)?_c('div',{staticClass:"mt-3",class:{
        'col-md-3' : (_vm.mandType != 6 && _vm.mandType != 10 && _vm.mandType != 8 && _vm.mandType != 7 && _vm.mandType != 11)}},[_c('mdc-switch',{model:{value:(_vm.levelMandLineChecked),callback:function ($$v) {_vm.levelMandLineChecked=$$v},expression:"levelMandLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendMandLineChecked),callback:function ($$v) {_vm.trendMandLineChecked=$$v},expression:"trendMandLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.scatterMandLineChecked),callback:function ($$v) {_vm.scatterMandLineChecked=$$v},expression:"scatterMandLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e()])}),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('mand-popup',{attrs:{"visible":_vm.isModalVisible,"stimulName":_vm.mandTitle,"mandType":_vm.mandType,"mandId":_vm.mandId,"typeTitle":_vm.stageInfo.description,"graphTitle":_vm.mandGraphReactionTitle(_vm.mandType),"protocolId":_vm.protocolId,"mandAnswers":_vm.mandAnswers,"stageId":_vm.stageInfo.id,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.showReport)?_c('div',{staticClass:"mt-4 position-relative options-mand-list without-btn"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('report.table_prompts')))]),_vm._v(" "),(_vm.showReport)?_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.optionsStatisticList,"isChange":_vm.isChangeStatic,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"motivationCondition",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.yes')))]):_vm._e(),_vm._v(" "),(!props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.no')))]):_vm._e()])}},{key:"mandLevel",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.mandLevel == 'spontaneous_level')?_c('div',[_vm._v(_vm._s(_vm._f("trans")('protocol.spontaneous_level')))]):_vm._e(),_vm._v(" "),(props.row.mandLevel == 'with_subject')?_c('div',[_vm._v(_vm._s(_vm._f("trans")('protocol.with_subject')))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.name)?_c('div',[_c('mdc-radio',{attrs:{"checked":props.row.id == _vm.selectedId,"name":"mandReaction"},on:{"change":function($event){_vm.choseSessionStimulus(props.row.id)}}})],1):_vm._e()])}}])}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.selectedId)?_c('div',{staticClass:"mt-2 position-relative"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('report.statistics_mand')))]),_vm._v(" "),(_vm.selectedId)?_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.optionsStimulReactionList,"isList":_vm.isMobile,"isChange":_vm.isChangeStimul}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showReport && _vm.taskTypesMand.length && !_vm.isEmptyMand && _vm.selectedId)?_c('div',{staticClass:"mt-3 mb-5"},[_c('div',{staticClass:"alert alert-secondary"},[_c('h4',{staticClass:"stage-results__subtitle mb-3"},[_vm._v(_vm._s(_vm._f("trans")('report.show_graph')))]),_vm._v(" "),_c('mdc-switch',{staticClass:"switch--disabled",attrs:{"checked":true,"disabled":""}},[_vm._v(_vm._s(_vm.graphReactionTitle(7))+": "+_vm._s(_vm.titleMandReaction)+"  "),_c('span',{staticClass:"anchor_graph",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToGraph(7)}}})]),_vm._v(" "),_c('mdc-switch',{staticClass:"switch--disabled",attrs:{"checked":true,"disabled":""}},[_vm._v(_vm._s(_vm.graphReactionTitle(6))+": "+_vm._s(_vm.titleMandReaction)+" "),_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(6)}}})]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType1),callback:function ($$v) {_vm.showMandType1=$$v},expression:"showMandType1"}},[_vm._v(_vm._s(_vm.graphReactionTitle(1))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType1 && _vm.inListOfSelectedType('1'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(1)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType2),callback:function ($$v) {_vm.showMandType2=$$v},expression:"showMandType2"}},[_vm._v(_vm._s(_vm.graphReactionTitle(2))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType2 && _vm.inListOfSelectedType('2'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(2)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType3),callback:function ($$v) {_vm.showMandType3=$$v},expression:"showMandType3"}},[_vm._v(_vm._s(_vm.graphReactionTitle(3))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType3 && _vm.inListOfSelectedType('3'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(3)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType4),callback:function ($$v) {_vm.showMandType4=$$v},expression:"showMandType4"}},[_vm._v(_vm._s(_vm.graphReactionTitle(4))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType4 && _vm.inListOfSelectedType('4'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(4)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType5),callback:function ($$v) {_vm.showMandType5=$$v},expression:"showMandType5"}},[_vm._v(_vm._s(_vm.graphReactionTitle(5))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType5 && _vm.inListOfSelectedType('5'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(5)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType8),callback:function ($$v) {_vm.showMandType8=$$v},expression:"showMandType8"}},[_vm._v(_vm._s(_vm.graphReactionTitle(8))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType8 && _vm.inListOfSelectedType('8'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(8)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType9),callback:function ($$v) {_vm.showMandType9=$$v},expression:"showMandType9"}},[_vm._v(_vm._s(_vm.graphReactionTitle(9))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType9 && _vm.inListOfSelectedType('9'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(9)}}}):_vm._e()]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.showMandType10),callback:function ($$v) {_vm.showMandType10=$$v},expression:"showMandType10"}},[_vm._v(_vm._s(_vm.graphReactionTitle(10))+": "+_vm._s(_vm.titleMandReaction)+" "),(_vm.showMandType10 && _vm.inListOfSelectedType('10'))?_c('span',{staticClass:"anchor_graph",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.goToGraph(10)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.graphReactionShow()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n            ")])])])],1)]):_vm._e(),_vm._v(" "),(_vm.graphReaction  && _vm.selectedId && !_vm.isEmptyMand)?_c('div',_vm._l((_vm.graphReaction.chartData),function(mandGraph,index){return _c('div',{ref:'mandGraphWrapp' + mandGraph.type,refInFor:true,attrs:{"id":'mandGraphWrapp' + mandGraph.type}},[_c('current-stage-mand',{attrs:{"mand-dataset":mandGraph.data,"mand-type":mandGraph.type,"mand-changes":_vm.graphReaction.changes,"mand-levels":_vm.graphReaction.levels,"mand-answers":_vm.graphReaction.answers,"mand-title":_vm.titleMandReaction,"mand-id":_vm.selectedId,"clientData":_vm.clientData,"protocolId":_vm.protocolId}})],1)})):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageDTT_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9e133c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageDTT_vue__ = __webpack_require__(1146);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageDTT_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9e133c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageDTT_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimul_table_header'))+": "+_vm._s(_vm.stage.description))]),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.options,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"value",fn:function(props){return _c('div',{},[(props.row.type == 'phase' && props.row.value == 1)?_c('p',{staticClass:"ml-2 mb-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_mastering')))]):_vm._e(),_vm._v(" "),(props.row.type == 'phase' && props.row.value == 2)?_c('p',{staticClass:"ml-2 mb-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_rotation')))]):_vm._e(),_vm._v(" "),(props.row.type == 'phase' && props.row.value == 3)?_c('p',{staticClass:"ml-2 mb-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_support')))]):_vm._e(),_vm._v(" "),(props.row.type == 'phase' && props.row.value == 4)?_c('p',{staticClass:"ml-2 mb-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_fluency')))]):_vm._e(),_vm._v(" "),(props.row.type == 'field')?_c('p',{staticClass:"ml-4 mb-0"},[_vm._v(_vm._s(_vm._f("trans")('protocol.field'))+" "+_vm._s(props.row.value))]):_vm._e(),_vm._v(" "),(props.row.type != 'phase' && props.row.type != 'field' && props.row.type != 'interval')?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(props.row.value)+" ")]):_vm._e(),_vm._v(" "),(props.row.type == 'interval')?_c('p',{staticClass:"mb-0 ml-4"},[_vm._v(_vm._s(_vm._f("intervalNameByTypeId")(props.row.value)))]):_vm._e()])}},{key:"masteredAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.masteredAt)?_c('div',[_vm._v(_vm._s(_vm.toLocaleDate(props.row.masteredAt.date)))]):_vm._e()])}},{key:"startedAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n      "+_vm._s(_vm.toLocaleDate(props.row.startedAt.date))+"\n    ")])}},{key:"countSamples",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.countSamples)?_c('div',[_vm._v(_vm._s(props.row.countSamples))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.stimulusName)?_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.globalTaskId),"disabled":_vm.chosenStimul.length ==4 && !_vm.checkedStimulus(props.row.globalTaskId)},on:{"change":function($event){_vm.choseStimulus(props.row, $event)}}}):_vm._e()],1)}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[(_vm.list.length)?_c('button',{staticClass:"btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.chartShow()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.chosenStimul.length)?_c('div',{staticClass:"row mt-3"},[(_vm.chartDatasetsForStimul && _vm.chartDatasetsForStimul.chartData && _vm.chartDatasetsForStimul.chartData.length && _vm.dataset)?_c('div',{staticClass:"col-12",class:{'mb-1': _vm.isChangeStimuli}},[_c('div',{staticClass:"row position-relative"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{class:{'col-md-9' : (_vm.chartDatasetsForStimul.chartData.length === 1 && _vm.chartDatasetsForStimul.labels.length > 2), 'col-md-12' : (_vm.chartDatasetsForStimul.chartData.length !== 1 || _vm.chartDatasetsForStimul.labels.length  <= 2)  }},[_c('line-chart',{staticClass:"row",attrs:{"datasets":_vm.dataset,"scale-label":_vm._f("trans")('protocol.total_percent'),"stage-info":_vm.stage.id,"list-chart-date":_vm.chartDatasetsForStimul.labels,"many-chart":_vm.chartDatasetsForStimul.chartData.length > 1,"show-legend":_vm.chartDatasetsForStimul.chartData.length > 1,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changesLine,"linedatasets":_vm.trendLinePoint,"persentMax":_vm.persentMax,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":340,"width":null},on:{"popup-show":_vm.popupShow}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.stimulus_mastering_chart'))+"\n            "),_vm._l((_vm.dataset),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.label)),(index < _vm.dataset.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(".\n          ")],2)],1),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length === 1 && _vm.chartDatasetsForStimul.labels.length > 2)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.chosenStimul.length && _vm.withoutData)?_c('div',{staticClass:"col-md-12 text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_data')))])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.promptsChartList),function(promtChart,index){return (_vm.chosenStimul.length)?_c('div',{staticClass:"row"},[(promtChart.levels.length)?_c('div',{staticClass:"col-12 mt-5"},[_c('prompt-chart',{attrs:{"promt-chart-values":promtChart.values,"promt-chart-levels":promtChart.levels,"stage-id":_vm.stage.id,"chosen-stimul":_vm.chosenStimul,"protocol-id":_vm.protocolId,"description":_vm.chosenStimul[index] ? _vm.chosenStimul[index].stimulusName : '',"index":index,"isDtt":true}})],1):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.isDTTModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isDTTModalVisible,"isDtt":true,"isStageChain":true,"chartType":_vm.type,"stimulId":_vm.chosenStimul[0].globalTaskId,"stage-id":_vm.selectedStageId,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecs_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2675290_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecs_vue__ = __webpack_require__(1148);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2675290_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[(!_vm.isPecsWithoutDiscrimination)?_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.table_mastered_target_sequence'))+": "+_vm._s(_vm.stage.description))]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscrimination)?_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.table_mastered_step')))]):_vm._e(),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.options,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"name",fn:function(props){return _c('div',{},[(props.row.name)?_c('div',[_vm._v(_vm._s(_vm._f("trans")(props.row.name)))]):_vm._e()])}},{key:"masteredAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.masteredAt)?_c('div',[_vm._v(_vm._s(_vm.toLocaleDate(props.row.masteredAt.date)))]):_vm._e()])}},{key:"startedAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n      "+_vm._s(_vm.toLocaleDate(props.row.startedAt.date))+"\n    ")])}},{key:"countSamples",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.countSamples)?_c('div',[_vm._v(_vm._s(props.row.countSamples))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.id),"disabled":_vm.chosenStimul.length == 4 && !_vm.checkedStimulus(props.row.id)},on:{"change":function($event){_vm.choseStimulus(props.row, $event)}}})],1)}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.chartShow()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[(_vm.chartDatasetsForStimul && _vm.chartDatasetsForStimul.chartData && _vm.chartDatasetsForStimul.chartData.length && _vm.chartDatasetsForStimulDataset)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row position-relative"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('line-chart',{staticClass:"row",attrs:{"datasets":_vm.chartDatasetsForStimulDataset,"withLegend":true,"showLegend":false,"scale-label":_vm._f("trans")('protocol.total_percent'),"stage-info":_vm.stage.id,"list-chart-date":_vm.chartDatasetsForStimul.labels,"many-chart":_vm.chartDatasetsForStimul.chartData.length > 1,"show-legend":_vm.chartDatasetsForStimul.chartData.length > 1,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changesLine,"linedatasets":_vm.trendLinePoint,"persentMax":_vm.persentMax,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":340,"width":null},on:{"generated":_vm.setLegend,"popup-show":_vm.popupShow}})],1),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length === 1 && _vm.labelsActiveLength > 2)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e(),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length !== 1)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('div',{staticClass:"legend-con",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.stimulus_mastering_chart'))+"\n            "),_vm._l((_vm.chartDatasetsForStimulDataset),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.label)),(index < _vm.chartDatasetsForStimulDataset.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(".\n          ")],2)])],1)]):_vm._e(),_vm._v(" "),(_vm.chosenStimul.length && _vm.withoutData)?_c('div',{staticClass:"col-md-12 text-center"},[_c('h5',[_vm._l((_vm.chosenStimul),function(stimul,index){return _c('span',[_vm._v(_vm._s(_vm._f("trans")(stimul.name))),(index < _vm.chosenStimul.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(" -  "+_vm._s(_vm._f("trans")('protocol.no_data'))+".")],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.chartDatasetsHintForStimulDataset),function(hintData){return _c('div',{staticClass:"col-12"},[_c('line-non-numeric-y-chart',{staticClass:"row mt-5",attrs:{"datasets":hintData.chart,"chart-id":'hintChart' + _vm.stage.id + hintData.label,"stage-info":_vm.stage.id,"y-labels":hintData.levels,"show-legend":false,"y-axes-begin-at-zero":true,"scale-label":_vm._f("trans")('report.label_prompt_levels'),"height":280,"width":null,"aspect-ratio":false},on:{"popup-show":_vm.popupShow}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.graph_prompt_levels'))+" "+_vm._s(hintData.label)+".\n      ")])],1)})),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isPecsWithoutDiscrimination":_vm.isPecsWithoutDiscrimination,"isPecs":_vm.isPecs,"isStageChain":true,"chartType":"1","stimulId":_vm.chosenStimul[0].id,"stage-id":_vm.selectedStageId,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CumulutiveChart_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf86539a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CumulutiveChart_vue__ = __webpack_require__(1150);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CumulutiveChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf86539a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CumulutiveChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[((_vm.isChain || _vm.isPecs ||  _vm.isPecsWithoutDiscrimination || _vm.isPecsWithDiscrimination || _vm.isPecsWithItems) && _vm.cumulutiveData && _vm.cumulutiveData.length)?_c('div',{staticClass:"mt-3 col-12"},[(_vm.isPecs)?_c('div',{staticClass:"mb-3 pl-1"},[_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.chart_for_step_daily_pecs'),"name":"cumulutiveKind","value":"absolute","checked":""},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.chart_for_percent_daily_pecs'),"name":"cumulutiveKind","value":"relative"},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}})],1):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscrimination && _vm.cumulutiveData)?_c('div',{staticClass:"mb-3 pl-1"},[_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.chart_for_step_daily_pecs2'),"name":"cumulutiveKind","value":"absolute","checked":""},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.chart_for_percent_daily_pecs2'),"name":"cumulutiveKind","value":"relative"},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}})],1):_vm._e(),_vm._v(" "),((_vm.isPecsWithDiscrimination || _vm.isPecsWithItems) && _vm.cumulutiveData[0].categoryInfo)?_c('div',{staticClass:"mb-3 pl-1"},[_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.number_properties_pecs'),"name":'cumulutiveKind'+_vm.cumulutiveData[0].categoryInfo.id,"value":"absolute","checked":""},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.percent_properties_pecs'),"name":'cumulutiveKind'+_vm.cumulutiveData[0].categoryInfo.id,"value":"relative"},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}})],1):_vm._e(),_vm._v(" "),(!_vm.isPecsWithoutDiscrimination && !_vm.isPecs && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('div',{staticClass:"mb-3 pl-1"},[_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.number_step'),"name":"cumulutiveKind","value":"absolute","checked":""},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"label":_vm._f("trans")('report.percent_step'),"name":"cumulutiveKind","value":"relative"},model:{value:(_vm.cumulutiveKind),callback:function ($$v) {_vm.cumulutiveKind=$$v},expression:"cumulutiveKind"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.cumulutiveData),function(cumulutiveChart,key){return (_vm.isPecsWithDiscrimination || _vm.isPecsWithItems || !_vm.selectedStage || (_vm.selectedStage && (_vm.selectedStage.id == cumulutiveChart.stageInfo.id)))?_c('div',[_vm._l((cumulutiveChart.absoluteData),function(absoluteChart,chartKey){return ((_vm.cumulutiveKind === 'absolute' && absoluteChart.values))?_c('div',[(absoluteChart.values.length)?_c('line-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForCumulutiveChart(absoluteChart.values),"chart-id":'cumulutiveChart_'+key+'_absolute_'+chartKey,"stage-info":cumulutiveChart.stageInfo.id,"category-info":cumulutiveChart.categoryInfo,"persentMax":true,"list-chart-date":absoluteChart.xLabels,"y-axes-begin-at-zero":true,"valueMax":absoluteChart.maxY,"aspect-ratio":false,"height":280,"width":null,"show-legend":false,"scale-label":_vm._f("trans")((_vm.isPecsWithItems || _vm.isPecsWithDiscrimination) ? 'report.number_properties_pecs' : _vm.isPecs || _vm.isPecsWithoutDiscrimination || _vm.isPecsWithDiscrimination ? 'report.number_step_pecs' : 'report.number_step')},on:{"popup-show":_vm.popupAbsoluteDataShow}}):_vm._e(),_vm._v(" "),(absoluteChart.values.length && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")(_vm.isPecs  ? 'report.cumulitive_graph_pecs' : 'protocol.chain_step_chart'))+": "+_vm._s(cumulutiveChart.stageInfo.description))]):_vm._e(),_vm._v(" "),(absoluteChart.values.length && _vm.isPecsWithoutDiscrimination)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('report.cumulitive_graph_pecs2')))]):_vm._e(),_vm._v(" "),(absoluteChart.values.length && (_vm.isPecsWithItems || _vm.isPecsWithDiscrimination))?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.cumulative_category'))+" "+_vm._s(cumulutiveChart.categoryInfo.title)+". "),(_vm.isPecsWithDiscrimination)?_c('span',[_vm._v(_vm._s(_vm.stageInfo.description))]):_vm._e()]):_vm._e()],1):_vm._e()}),_vm._v(" "),((_vm.cumulutiveKind === 'relative' && cumulutiveChart.relativeData.values.length))?_c('div',[((_vm.cumulutiveKind === 'relative'))?_c('line-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForCumulutiveChart(cumulutiveChart.relativeData.values),"chart-id":'cumulutiveChart_relativeData'+key,"stage-info":cumulutiveChart.stageInfo.id,"category-info":cumulutiveChart.categoryInfo,"persentMax":true,"list-chart-date":cumulutiveChart.relativeData.xLabels,"y-axes-begin-at-zero":true,"aspect-ratio":false,"height":280,"width":null,"show-legend":false,"scale-label":_vm._f("trans")((_vm.isPecsWithItems || _vm.isPecsWithDiscrimination) ? 'report.percent_properties_pecs' : _vm.isPecs || _vm.isPecsWithoutDiscrimination || _vm.isPecsWithDiscrimination ? 'report.percent_step_pecs' : 'report.chart_for_percent_axes')},on:{"popup-show":_vm.popupRelativeDataShow}}):_vm._e(),_vm._v(" "),((_vm.cumulutiveKind === 'relative') && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")(_vm.isPecs  ? 'report.cumulitive_graph_pecs' : 'protocol.chain_mastered_chart'))+": "+_vm._s(cumulutiveChart.stageInfo.description))]):_vm._e(),_vm._v(" "),((_vm.cumulutiveKind === 'relative') && _vm.isPecsWithoutDiscrimination)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('report.cumulitive_graph_pecs2')))]):_vm._e(),_vm._v(" "),((_vm.cumulutiveKind === 'relative') && (_vm.isPecsWithItems || _vm.isPecsWithDiscrimination))?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.cumulative_category_relative'))+" "+_vm._s(cumulutiveChart.categoryInfo.title)+". "),(_vm.isPecsWithDiscrimination)?_c('span',[_vm._v(_vm._s(_vm.stageInfo.description))]):_vm._e()]):_vm._e()],1):_vm._e()],2):_vm._e()}),_vm._v(" "),(_vm.cumulutiveData && _vm.cumulutiveData[0].relativeData && !_vm.cumulutiveData[0].relativeData.values.length)?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('protocol.no_data'))+".")]):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.isChain && !_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems && _vm.cumulutiveData && _vm.cumulutiveData.cumulativeData.values.length)?_c('div',{staticClass:"mt-5 col-12"},[(!_vm.selectedStage)?_c('line-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForCumulutiveChart(_vm.cumulutiveData.cumulativeData.values),"chart-id":"mandCumulutiveChart","persentMax":false,"list-chart-date":_vm.cumulutiveData.cumulativeData.xLabels,"y-axes-begin-at-zero":true,"aspect-ratio":false,"height":260,"width":null,"show-legend":false,"scale-label":_vm._f("trans")('report.count_stim')}}):_vm._e(),_vm._v(" "),(!_vm.selectedStage)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('report.cumulitive_graph_for_protocol')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.cumulutiveData.byStageData),function(cumulutiveChart,key){return (!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == cumulutiveChart.stageInfo.id))?_c('div',[_c('line-chart',{staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForCumulutiveChart(cumulutiveChart.values),"chart-id":'mandCumulutiveChart_'+key,"persentMax":false,"list-chart-date":cumulutiveChart.xLabels,"y-axes-begin-at-zero":true,"aspect-ratio":false,"height":260,"width":null,"show-legend":false,"scale-label":_vm._f("trans")('report.count_stim')}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('report.cumulitive_graph'))+": "+_vm._s(cumulutiveChart.stageInfo.description))])],1):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isChain":_vm.isChain,"isPecs":_vm.isPecs,"isPecsWithoutDiscrimination":_vm.isPecsWithoutDiscrimination,"isPecsWithDiscrimination":_vm.isPecsWithDiscrimination,"isPecsWithItems":_vm.isPecsWithItems,"chartType":_vm.type,"version":_vm.version,"stage-id":_vm.selectedStageId,"graphTitle":_vm._f("trans")(_vm.isPecsWithItems || _vm.isPecsWithDiscrimination ? 'report.chart_properties_per_day' : 'protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"categoryInfo":_vm.cumulutiveData[0].categoryInfo,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionResults_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f24420a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionResults_vue__ = __webpack_require__(1152);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f24420a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12  mt-4"},[_c('h4',{staticClass:"stage-results__subtitle"},[_vm._v(_vm._s(_vm.session.stage.description)+": "),_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.toLocaleDate(_vm.session.day)))])]),_vm._v(" "),_vm._l((_vm.rowStimuli),function(row){return _c('div',{staticClass:"row"},[(row.stimuli)?_c('div',{staticClass:"col-12 stage-results-wrapper"},[(row.phaseType)?_c('p',{staticClass:"stage-results__subtitle"},[_vm._v("\n        "+_vm._s(_vm._f("phaseNameByTypeId")(row.phaseType))+".\n        "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.check-list'))+" \""+_vm._s(row.taskType.title)+"\"")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"stage-results-table table table-sm"},[(row.stimuli.length)?_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th'),_vm._v(" "),_vm._l((row.answers),function(item,index){return _c('th',{key:'count' + index,staticClass:"narrow-width text-center"},[_vm._v("\n            "+_vm._s(item.title)+"\n          ")])}),_vm._v(" "),_vm._l((row.answers),function(item,index){return _c('th',{key:'persent' + index,staticClass:"narrow-width text-center"},[_vm._v("\n            "+_vm._s(item.title)+", %\n          ")])})],2)]):_vm._e(),_vm._v(" "),_c('tbody',[_vm._l((row.stimuli),function(stimulus){return _c('tr',[_c('td',[_c('span',[_vm._v(_vm._s(stimulus.description))])]),_vm._v(" "),_vm._l((stimulus.answers),function(item){return _c('td',{staticClass:"text-center"},[_c('span',[_vm._v(_vm._s(item.count ? item.count : _vm.trans('protocol.task_types.answers.no_data')))])])}),_vm._v(" "),_vm._l((stimulus.answers),function(item){return _c('td',{staticClass:"text-center"},[_c('span',[_vm._v(_vm._s(item.percent ? item.percent : _vm.trans('protocol.task_types.answers.no_data')))])])})],2)}),_vm._v(" "),(!row.stimuli.length)?_c('tr',{staticClass:"text-center",attrs:{"colspan":"3"}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))])]):_vm._e()],2)]):_c('div',{staticClass:"mobile-table"},[(row.stimuli.length)?_c('div',{staticClass:"mobile-table__body"},_vm._l((row.stimuli),function(stimulus,index){return _c('div',{key:index,staticClass:"mobile-table__row"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n              "+_vm._s(stimulus.description)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._l((stimulus.answers),function(answer){return _c('p',[_vm._v("\n                "+_vm._s(_vm.answerTitle(answer.answer, row))+": "+_vm._s(answer.count ? answer.count :
                _vm.trans('protocol.task_types.answers.no_data')))])}),_vm._v(" "),_vm._l((stimulus.answers),function(answer){return _c('p',[_vm._v("\n                "+_vm._s(_vm.answerTitle(answer.answer, row))+",%: "+_vm._s(answer.percent ?
                (answer.percent + '%') :
                _vm.trans('protocol.task_types.answers.no_data')))])})],2)])})):_vm._e(),_vm._v(" "),(!row.stimuli.length)?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))]):_vm._e()])]):_vm._e()])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionPecsResults_vue__ = __webpack_require__(542);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0127dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionPecsResults_vue__ = __webpack_require__(1154);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionPecsResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da0127dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionPecsResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12  mt-4"},[_c('h4',{staticClass:"stage-results__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.control_of_achievements'))+" "),(_vm.teachingMethod == 7)?_c('span',[_vm._v(_vm._s(_vm.session.stage.description)+":")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.toLocaleDate(_vm.session.day)))])]),_vm._v(" "),(_vm.isRowData)?_c('div',{staticClass:"row"},_vm._l((_vm.session.rowData),function(dataProp){return _c('div',{staticClass:"col-12 mt-3"},[_c('h4',{staticClass:"stage-results__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.categoryTitle'))+": "+_vm._s(dataProp.title)+".")]),_vm._v(" "),_vm._l((dataProp.stimuli),function(stimul){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__subtitle"},[_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")(dataProp.typeId == 2 ? 'protocol.subjects' : 'protocol.property')))]),_vm._v(": "+_vm._s(stimul.description))]),_vm._v(" "),(stimul.result.length)?_c('table',{staticClass:"stage-results-table table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"pl-3"},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.number_of_trials'))+"\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.compliance_check'))+"\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property'))+" "),(_vm.teachingMethod == 10 && dataProp.typeId != 2)?_c('span',[_vm._v(" / "+_vm._s(_vm._f("trans")('protocol.subjects')))]):_vm._e()])])]),_vm._v(" "),_c('tbody',_vm._l((stimul.result),function(taskData,index){return _c('tr',[_c('td',{staticClass:"pl-3"},[(_vm.teachingMethod != 10)?_c('span',[_vm._v(_vm._s(index + 1))]):_vm._e(),_vm._v(" "),(_vm.teachingMethod == 10)?_c('span',[_vm._v(_vm._s(taskData.sessionIndex)+"."+_vm._s(taskData.iterationIndex))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("trans")(taskData.title))+"\n                  ")]),_vm._v(" "),_c('td',_vm._l((taskData.stimuli),function(task){return _c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(task))])}))])}))]):_vm._e()])])}),_vm._v(" "),(!dataProp.stimuli.length)?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))]):_vm._e()],2)})):_vm._e(),_vm._v(" "),(!_vm.isRowData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.isMobile)?_c('table',{staticClass:"stage-results-table table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.attempt'))+"\n          ")]),_vm._v(" "),_vm._l((_vm.session.stimuli),function(stimul){return _c('th',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(stimul)+"\n          ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.session.data),function(row,index){return _c('tr',{staticClass:"text-center"},[_c('td',[_vm._v("\n            "+_vm._s(index + 1)+"\n          ")]),_vm._v(" "),_vm._l((row),function(cell){return _c('td',[(cell.isCustomized)?_c('span',[_vm._v("\n              "+_vm._s(cell.title)+"\n            ")]):_vm._e(),_vm._v(" "),(!cell.isCustomized)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("trans")(cell.title))+"\n            ")]):_vm._e()])})],2)}))]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table"},[(_vm.session.data.length)?_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.session.data),function(row,index){return _c('div',{key:index,staticClass:"mobile-table__row"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.attempt'))+" "+_vm._s(index + 1)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"description"},_vm._l((row),function(cell,index){return _c('p',{staticClass:"mt-2"},[_vm._v("\n                "+_vm._s(_vm.session.stimuli[index])+" -\n                "),(cell.isCustomized)?_c('span',[_vm._v("\n                "+_vm._s(cell.title)+"\n              ")]):_vm._e(),_vm._v(" "),(!cell.isCustomized)?_c('span',[_vm._v("\n                "+_vm._s(_vm._f("trans")(cell.title))+"\n              ")]):_vm._e()])}))])})):_vm._e(),_vm._v(" "),(!_vm.session.data.length)?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))]):_vm._e()]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionPecsWithDiscrimination_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6149ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionPecsWithDiscrimination_vue__ = __webpack_require__(1156);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionPecsWithDiscrimination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6149ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionPecsWithDiscrimination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12  mt-4"},[_vm._l((_vm.session.tableData),function(row){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__subtitle"},[_vm._v(_vm._s(_vm.session.stage.description)+": "),_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.toLocaleDate(_vm.session.day)))]),_vm._v("."),_c('br'),_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.categoryTitle'))+": "+_vm._s(row.categoryTitle))]),_vm._v(" "),_vm._l((row.globalTasks),function(task){return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__subtitle"},[_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(": "+_vm._s(task.title))]),_vm._v(" "),(task.data.length)?_c('table',{staticClass:"stage-results-table table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"pl-3"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.number_of_trials'))+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.compliance_check'))+"\n              ")])])]),_vm._v(" "),_c('tbody',_vm._l((task.data),function(taskData,indexTaskData){return _c('tr',[_c('td',{staticClass:"pl-3"},[_vm._v("\n                "+_vm._s(indexTaskData + 1)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(_vm._f("trans")(taskData.title))+"\n              ")])])}))]):_vm._e()])])})],2)])}),_vm._v(" "),(!_vm.session.tableData.length)?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsWithDescrimination_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d295e7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsWithDescrimination_vue__ = __webpack_require__(1158);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsWithDescrimination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d295e7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsWithDescrimination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.stagesList)?_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.table_mastered_category')))]),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.options,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"stageId",fn:function(props){return _c('div',{staticClass:"nowrap"},[_c('div',[_vm._v(_vm._s(_vm.stageName(props.row.stageId)))])])}},{key:"masteredAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.masteredAt)?_c('div',[_vm._v(_vm._s(_vm.toLocaleDate(props.row.masteredAt)))]):_vm._e()])}},{key:"startedAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n        "+_vm._s(_vm.toLocaleDate(props.row.startedAt))+"\n      ")])}},{key:"countSamples",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.countSamples)?_c('div',[_vm._v(_vm._s(props.row.countSamples))]):_vm._e()])}}])})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsCategory_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d7eea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsCategory_vue__ = __webpack_require__(1164);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d7eea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartForStimul_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acac23bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartForStimul_vue__ = __webpack_require__(1163);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartForStimul_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acac23bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartForStimul_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopupTable_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1496a47b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopupTable_vue__ = __webpack_require__(1162);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPopupTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1496a47b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPopupTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"mdc_dialog_wider",attrs:{"title":_vm.title,"accept":_vm._f("trans")('user.close')},on:{"cancel":_vm.close,"accept":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.dataSet)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.dataSet && _vm.dataSet.length)?_c('table',{staticClass:"stage-results-table table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"pl-3"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.number_of_trials'))+"\n      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.compliance_check'))+"\n      ")]),_vm._v(" "),_c('th',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataSet),function(taskData,indexTaskData){return _c('tr',[_c('td',{staticClass:"pl-3"},[_vm._v("\n        "+_vm._s(taskData.sessionIndex)+"."+_vm._s(taskData.iterationIndex)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm._f("trans")(taskData.title))+"\n      ")]),_vm._v(" "),_c('td',_vm._l((taskData.stimuli),function(task){return _c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(task))])}))])}))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('line-chart',{staticClass:"row",attrs:{"datasets":_vm.chartData,"chart-id":'chartForStimulChart' + _vm.stageId + _vm.category && _vm.category.id ? _vm.category.id : '',"withLegend":true,"showLegend":false,"scale-label":_vm._f("trans")('protocol.countSamplesAxes'),"stage-info":_vm.stageId,"category-info":_vm.category,"list-chart-date":_vm.chartDatasetsForStimul.labels,"many-chart":_vm.chartDatasetsForStimul.chartData.length > 1,"show-legend":_vm.chartDatasetsForStimul.chartData.length > 1,"y-axes-begin-at-zero":true,"vertical-line-point":_vm.changesLine,"linedatasets":_vm.trendLinePoint,"persentMax":_vm.persentMax,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":340,"width":null},on:{"generated":_vm.setLegend,"popup-show":_vm.popupShow}})],1),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length === 1 && _vm.labelsActiveLength > 2)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e(),_vm._v(" "),(_vm.chartDatasetsForStimul.chartData.length !== 1)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('div',{staticClass:"legend-con",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.chart_properties_percent'))+"\n        "),_vm._l((_vm.chartData),function(stimul,indexStim){return _c('span',[_vm._v(_vm._s(stimul.label)),(indexStim < _vm.chartData.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(". "),(_vm.teachingMethod == 9)?_c('span',[_vm._v(_vm._s(_vm.stage.description))]):_vm._e()],2)]),_vm._v(" "),(_vm.isModalVisible && !_vm.isPecsWithItems)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isPecsWithoutDiscrimination":false,"isPecs":false,"isPecsWithDiscrimination":_vm.isPecsWithDiscrimination,"isPecsWithItems":_vm.isPecsWithItems,"isStageChain":true,"chartType":"1","stimulId":_vm.chosenStimul[0].id,"stage-id":_vm.selectedStageId,"category-info":_vm.categoryInfo,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e(),_vm._v(" "),(_vm.isModalVisible && _vm.isPecsWithItems)?_c('div',[_c('chart-popup-table',{attrs:{"visible":_vm.isModalVisible,"isPecsWithItems":_vm.isPecsWithItems,"chartType":"1","stimulId":_vm.chosenStimul[0].id,"category-info":_vm.categoryInfo,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.table_mastered_category_name'))+" "+_vm._s(_vm.category.title))]),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.teachingMethod == 10 ? _vm.optionsItems : _vm.options,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"masteredAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.masteredAt)?_c('div',[_vm._v(_vm._s(_vm.toLocaleDate(props.row.masteredAt.date)))]):_vm._e()])}},{key:"startedAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n      "+_vm._s(_vm.toLocaleDate(props.row.startedAt.date))+"\n    ")])}},{key:"countSamples",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.countSamples)?_c('div',[_vm._v(_vm._s(props.row.countSamples))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.name)?_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.id),"disabled":_vm.chosenStimul.length == 4 && !_vm.checkedStimulus(props.row.id)},on:{"change":function($event){_vm.choseStimulus(props.row, $event)}}}):_vm._e()],1)}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-5 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.chartShow()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.show_graph_btn'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[(_vm.chartDatasetsForStimul && _vm.chartDatasetsForStimulDataset)?_c('div',{staticClass:"col-12"},[(_vm.isPecsWithItems)?_c('div',{staticClass:"row position-relative"},[_c('div',{staticClass:"col-12"},[_c('chart-for-stimul',{attrs:{"chartData":_vm.chartDatasetsForStimulDataset,"chartDatasetsForStimul":_vm.chartDatasetsForStimul,"changesLine":_vm.changesLine,"category":_vm.category,"loaded":_vm.loaded,"chosenStimul":_vm.chosenStimul,"protocolId":_vm.protocolId,"teachingMethod":_vm.teachingMethod,"stage":_vm.stage}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.chartDatasetsForStimulDataset),function(chartData,index){return (!_vm.isPecsWithItems)?_c('div',{staticClass:"row position-relative"},[((_vm.stage && _vm.chartDatasetsForStimul[index].stageInfo.id === _vm.stage.id) || !_vm.stage)?_c('div',{staticClass:"col-12"},[_c('chart-for-stimul',{attrs:{"chartData":chartData,"chartDatasetsForStimul":_vm.chartDatasetsForStimul[index],"changesLine":_vm.changesLine[index],"category":_vm.category,"loaded":_vm.loaded,"chosenStimul":_vm.chosenStimul,"protocolId":_vm.protocolId,"stage":_vm.chartDatasetsForStimul[index].stageInfo,"teachingMethod":_vm.teachingMethod}})],1):_vm._e()]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.chosenStimul.length && _vm.withoutData)?_c('div',{staticClass:"col-md-12 text-center"},[_c('h5',[_vm._l((_vm.chosenStimul),function(stimul,index){return _c('span',[_vm._v(_vm._s(_vm._f("trans")(stimul.name))),(index < _vm.chosenStimul.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(" -  "+_vm._s(_vm._f("trans")('protocol.no_data'))+".")],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionCategoryResults_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322bc373_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionCategoryResults_vue__ = __webpack_require__(1166);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastSessionCategoryResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322bc373_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastSessionCategoryResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-3"},[(!_vm.lastSession)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.lastSession)?_c('div',{staticClass:"col-12"},[_vm._l((_vm.lastSession.answers),function(row){return _c('div',{staticClass:"row mb-3"},_vm._l((row.rowData),function(dataProp){return _c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.categoryTitle'))+": "+_vm._s(_vm.lastSession.categories[row.categoryId])+". "),_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.toLocaleDate(_vm.lastSession.day)))]),_vm._v(".")]),_vm._v(" "),_c('p',{staticClass:"stage-results__subtitle"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.propertyTitle'))+": "+_vm._s(_vm.lastSession.stimuli[dataProp.global_id])+".\n        ")]),_vm._v(" "),(dataProp.answers.length)?_c('table',{staticClass:"stage-results-table table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"pl-3"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.number_of_trials'))+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.compliance_check'))+"\n              ")])])]),_vm._v(" "),_c('tbody',_vm._l((dataProp.answers),function(taskData,indexTaskData){return _c('tr',[_c('td',{staticClass:"pl-3"},[_vm._v("\n                "+_vm._s(indexTaskData + 1)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(_vm._f("trans")(taskData.title))+"\n              ")])])}))]):_vm._e()])}))}),_vm._v(" "),(!_vm.lastSession.answers || (_vm.lastSession.answers && !_vm.lastSession.answers.length))?_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))]):_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"toggle-btn-container cursor-pointer",on:{"click":function($event){$event.preventDefault();return _vm.toggleShow($event)}}},[_c('h3',{staticClass:"page-sub-title mt-3 mb-0"},[_vm._v("\n        "+_vm._s(_vm.nameTitle)+" "+_vm._s(_vm.title)+"\n        "),(!_vm.isShowAll)?_c('span',{staticClass:"float-right"},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.showAll')))]):_vm._e(),_vm._v(" "),(_vm.isShowAll)?_c('span',{staticClass:"float-right"},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.hideAll')))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.isShowAll)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsWithItems_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77865b29_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsWithItems_vue__ = __webpack_require__(1169);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentPecsWithItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77865b29_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentPecsWithItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stagesList)?_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title mt-5"},[_vm._v(_vm._s(_vm._f("trans")('protocol.table_mastered_category')))]),_vm._v(" "),_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.options,"isList":_vm.isMobile,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"stageId",fn:function(props){return _c('div',{staticClass:"nowrap"},[_c('div',[_vm._v(_vm._s(_vm.stageName(props.row.stageId)))])])}},{key:"masteredAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.masteredAt)?_c('div',[_vm._v(_vm._s(_vm.toLocaleDate(props.row.masteredAt)))]):_vm._e()])}},{key:"startedAt",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n      "+_vm._s(_vm.toLocaleDate(props.row.startedAt))+"\n    ")])}},{key:"countSamples",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.countSamples)?_c('div',[_vm._v(_vm._s(props.row.countSamples))]):_vm._e()])}}])})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-results"},[(_vm.isApplyFilter)?_c('loader'):_vm._e(),_vm._v(" "),(!_vm.isLoaded && !_vm.isApplyFilter)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[((_vm.lastSession.length  && _vm.isLoaded && (_vm.isBCBA || _vm.isCurator)) || _vm.teachingMethod == 9)?_c('div',{staticClass:"col-12 pl-1"},[_c('mdc-radio',{attrs:{"label":_vm._f("trans")('protocol.last_session'),"name":"mode","value":"session"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"label":_vm._f("trans")('protocol.detailed_result'),"name":"mode","value":"detail"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1):_vm._e()]),_vm._v(" "),(!_vm.lastSession.length && _vm.teachingMethod != 9)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[((_vm.isEmptyMeasurements || _vm.isEmptyMeasurementsList || (_vm.protocol.isDtt && _vm.measurements.length < 2 && _vm.mode == 'session')) && _vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_data')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.mode == 'session' && _vm.lastSession.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.result_last_assigned_session'))+"\n        "+_vm._s(_vm._f("trans")('protocol.of_protocol'))+" \""+_vm._s(_vm.protocolData.protocol.title)+"\"")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(!_vm.lastSession.length && _vm.isLoaded)?_c('div',{staticClass:"text-center mt-4"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_data')))])]):_vm._e()]),_vm._v(" "),(_vm.teachingMethod != 7 && _vm.teachingMethod != 8 && _vm.teachingMethod != 9 && _vm.teachingMethod != 10)?_c('div',{staticClass:"col-12"},_vm._l((_vm.lastSession),function(session,index){return _c('div',{staticClass:"row"},[_c('last-session-results',{attrs:{"session":session,"rowStimuli":_vm.isUSD || _vm.isDTT ? session.phases : [session]}}),_vm._v(" "),(_vm.isShaping && _vm.lastSessionChart[index].data && _vm.lastSessionChart[index].yLabels)?_c('div',{staticClass:"col-12"},[_c('line-shaping-chart',{key:"shapingChart",staticClass:"row mt-2",attrs:{"datasets":_vm.fetchDatasetForShapingChart(_vm.lastSessionChart[index].data),"chart-id":"shapingChart","xAxisLabel":_vm._f("trans")('protocol.probe_by_session'),"y-labels":_vm.lastSessionChart[index].yLabels,"list-chart-date":_vm.lastSessionChart[index].xLabels,"show-legend":false,"all-axis-show":true,"y-axes-begin-at-zero":true,"height":680,"width":null,"aspect-ratio":false}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.shaping_last_session_chart')))])],1):_vm._e()],1)})):_vm._e(),_vm._v(" "),(_vm.teachingMethod == 7 || _vm.teachingMethod == 8 || _vm.teachingMethod == 10)?_c('div',{staticClass:"col-12"},_vm._l((_vm.lastSession),function(session){return _c('div',{staticClass:"row"},[_c('last-session-pecs-results',{attrs:{"session":session,"isRowData":_vm.teachingMethod == 10,"teachingMethod":_vm.teachingMethod}})],1)})):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mode == 'session' && _vm.teachingMethod == 9 && _vm.stagesList.length),expression:"mode == 'session' && teachingMethod == 9 && stagesList.length"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.result_last_assigned_session'))+"\n        "+_vm._s(_vm._f("trans")('protocol.of_protocol'))+" \""+_vm._s(_vm.protocolData.protocol.title)+"\"")])]),_vm._v(" "),_vm._l((_vm.stagesList),function(stage){return (!stage.isDisabled)?_c('div',{staticClass:"col-12 without-btn"},[_c('toogle-view',{attrs:{"title":stage.description}},[_c('last-session-category-results',{attrs:{"protocol-id":_vm.protocolId,"stage":stage}})],1)],1):_vm._e()})],2),_vm._v(" "),(_vm.isLoaded && (_vm.isBCBA || _vm.isCurator))?_c('div',{staticClass:"row mb-3",class:{'visibility-hidden': _vm.mode !== 'detail'}},[_c('div',{staticClass:"col-12 mt-4"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.protocol'))+":\""+_vm._s(_vm.protocolData.protocol.title)+"\"")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.teachingMethod != 8 && _vm.teachingMethod != 10),expression:"teachingMethod != 8 && teachingMethod != 10"}],staticClass:"col-md-4 col-12"},[_c('v-select',{class:{'is-invalid': _vm.errors.has('selectedStage'), 'is-clear': !_vm.selectedStage},attrs:{"options":_vm.stagesList,"on-change":_vm.onChangeSelectedStage,"label":"id","name":"applying","filterable":false,"data-vv-validate-on":"none"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n          "+_vm._s(option.description)+"\n        ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n          "+_vm._s(option.description)+"\n        ")]}}]),model:{value:(_vm.selectedStage),callback:function ($$v) {_vm.selectedStage=$$v},expression:"selectedStage"}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")(_vm.isPecsWithDiscrimination ? 'protocol.chooseLevel' : _vm.isPecs ? 'protocol.choose_step' :  'protocol.chooseStage')))])],1)]):_vm._e(),_vm._v(" "),(_vm.isLoaded && (_vm.isBCBA || _vm.isCurator))?_c('div',{staticClass:"row mb-3",class:{'visibility-hidden': _vm.mode !== 'detail'}},[_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n             "+_vm._s(_vm._f("trans")('report.range_from'))+"\n        ")]),_vm._v(" "),_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-period'),expression:"'required|check-period'"}],class:{'is-invalid': _vm.errors.has('rangeDateStart')},attrs:{"name":"rangeDateStart","formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.minDateStart,"data-vv-validate-on":"none","label":_vm._f("trans")('rotation.stimulus_one')},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-4"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n             "+_vm._s(_vm._f("trans")('report.range_end'))+"\n        ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row",class:{'invalid-feedback': _vm.errors.has('rangeDateStart')}},[_vm._v(_vm._s(_vm._f("trans")('report.description_max_period')))])])]):_vm._e(),_vm._v(" "),(_vm.isLoaded && (_vm.isBCBA || _vm.isCurator))?_c('div',{staticClass:"row mb-3",class:{'visibility-hidden': _vm.mode !== 'detail'}},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.applyFilter(true)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.draw_report'))+"\n      ")])])]):_vm._e(),_vm._v(" "),_c('div',{class:{'visibility-hidden': _vm.mode !== 'detail'}},[(_vm.isChain)?_c('div',{staticClass:"mt-4 position-relative"},_vm._l((_vm.stagesList),function(stage){return ((!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id)) && _vm.showReport)?_c('div',{staticClass:"row"},[_c('current-stage-chain',{attrs:{"protocol-id":_vm.protocolId,"stage":stage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.isShaping)?_c('div',_vm._l((_vm.stagesList),function(stage){return ((!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id)) && _vm.showReport)?_c('div',{staticClass:"row"},[_c('current-stage-shaping',{attrs:{"protocol-id":_vm.protocolId,"is-apply-filter":_vm.showReport,"stage":stage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.isSimple)?_c('div',{staticClass:"mt-4 position-relative  without-btn"},[_c('current-simple',{attrs:{"selectedStage":_vm.selectedStage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp,"protocolId":_vm.protocolId,"stagesList":_vm.stagesList,"showReport":_vm.showReport}})],1):_vm._e(),_vm._v(" "),(_vm.isUSD && _vm.isLoaded)?_c('div',[(_vm.showReport)?_c('div',{staticClass:"mt-4 position-relative options-mand-list without-btn"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('report.table_prompts')))]),_vm._v(" "),(_vm.showReport && (_vm.mode == 'detail'))?_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.optionsStatisticList,"isChange":_vm.isChangeStatic,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"motivationCondition",fn:function(props){return _c('div',{staticClass:"nowrap"},[(props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.yes')))]):_vm._e(),_vm._v(" "),(!props.row.motivationCondition)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('admin.no')))]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[(props.row.name)?_c('div',[_c('mdc-checkbox',{attrs:{"checked":_vm.checkedStimulus(props.row.id),"disabled":_vm.chosenStimul.length == 4 && !_vm.checkedStimulus(props.row.id)},on:{"change":function($event){_vm.choseStimulus(props.row, $event)}}})],1):_vm._e()])}}])}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.chosenStimul.length && _vm.chartDatasetsForStages)?_c('div',{staticClass:"col-12",class:{'mb-1': _vm.isChangeStimuli}},_vm._l((_vm.chartDatasetsForStages),function(stage,index){return _c('div',{staticClass:"row"},[_c('div',{class:{'col-md-9' : (_vm.chosenStimul.length === 1), 'col-md-12' : _vm.chosenStimul.length !== 1  }},[(stage.graphReactionxLabels.length)?_c('line-chart',{staticClass:"row",attrs:{"datasets":stage.dataForChart,"scale-label":_vm.scaleLabel,"linedatasets":_vm.trendLineArrayPoint[index],"list-chart-date":stage.graphReactionDays,"many-chart":_vm.chosenStimul.length > 1,"show-legend":_vm.chosenStimul.length > 1,"y-axes-begin-at-zero":true,"vertical-line-point":stage.graphReactionPointArray,"persentMax":_vm.persentMax,"labelText":'%',"is-mobile":_vm.isMobile,"aspect-ratio":false,"height":280,"width":null},on:{"popup-show":_vm.popupShow}}):_vm._e(),_vm._v(" "),(stage.graphReactionxLabels.length)?_c('h4',{staticClass:"chart__title mb-3"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.stimulus_mastering_chart'))+"\n              "),_vm._l((_vm.chosenStimul),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.name)),(index < _vm.chosenStimul.length -1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(".\n              "+_vm._s(stage.description)+"\n            ")],2):_vm._e()],1),_vm._v(" "),( _vm.chosenStimul.length === 1 && index === 0)?_c('div',{staticClass:"mt-3 col-md-3"},[_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine')))])],1):_vm._e()])})):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isMand && _vm.isLoaded)?_c('div',[_c('current-mand',{attrs:{"selectedStage":_vm.selectedStage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp,"protocolId":_vm.protocolId,"stagesList":_vm.stagesList,"showReport":_vm.showReport,"taskTypesMand":_vm.taskTypesMand,"clientData":_vm.clientData}})],1):_vm._e(),_vm._v(" "),(_vm.isDTT)?_c('div',[((_vm.isBCBA || _vm.isCurator) && _vm.isLoaded && _vm.showReport)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 without-btn"},_vm._l((_vm.stagesList),function(stage){return (!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id))?_c('div',{staticClass:"row"},[_c('current-stage-d-t-t',{attrs:{"protocol-id":_vm.protocolId,"is-apply-filter":_vm.showReport,"stage":stage,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isPecs)?_c('div',[(_vm.showReport)?_c('div',{staticClass:"mt-4 position-relative options-mand-list without-btn"},[_c('h4',{staticClass:"stage-results__title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.table_mastered')))]),_vm._v(" "),(_vm.showReport && (_vm.mode == 'detail'))?_c('table-view',{staticClass:"stimulus_table",attrs:{"options":_vm.optionsPecsList,"isChange":_vm.isChangeStatic,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"position",fn:function(props){return _c('div',{staticClass:"nowrap"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.step'))+" "+_vm._s(props.row.position)+"\n          ")])}}])}):_vm._e()],1):_vm._e(),_vm._v(" "),((_vm.isBCBA || _vm.isCurator) && _vm.isLoaded && _vm.showReport)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 without-btn"},_vm._l((_vm.stagesList),function(stage){return (!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id))?_c('div',{staticClass:"row"},[_c('current-pecs',{attrs:{"protocol-id":_vm.protocolId,"is-apply-filter":_vm.showReport,"stage":stage,"teachingMethod":_vm.teachingMethod,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isPecsWithoutDiscrimination)?_c('div',[((_vm.isBCBA || _vm.isCurator) && _vm.isLoaded && _vm.showReport)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 without-btn"},_vm._l((_vm.stagesList),function(stage){return (!_vm.selectedStage || (_vm.selectedStage && _vm.selectedStage.id == stage.id))?_c('div',{staticClass:"row"},[_c('current-pecs',{attrs:{"apiChartUrl":"/protocols/assigned/pecs-without-discrimination/","protocol-id":_vm.protocolId,"teachingMethod":_vm.teachingMethod,"stage":stage,"is-apply-filter":_vm.showReport,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e()}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscrimination)?_c('div',[((_vm.isBCBA || _vm.isCurator) && _vm.isLoaded && _vm.showReport)?_c('div',{staticClass:"row"},[(_vm.stagesList.length)?_c('div',{staticClass:"col-12 without-btn"},[_c('current-pecs-with-descrimination',{attrs:{"apiChartUrl":"/protocols/assigned/pecs-with-discrimination/","protocol-id":_vm.protocolId,"teachingMethod":_vm.teachingMethod,"stage":_vm.selectedStage,"stages-list":_vm.stagesList,"is-apply-filter":_vm.showReport,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 without-btn"},_vm._l((_vm.protocolData.protocol.categories),function(category){return _c('div',{staticClass:"row"},[_c('current-pecs-category',{attrs:{"apiChartUrl":"/protocols/assigned/pecs-with-discrimination/","protocol-id":_vm.protocolId,"teachingMethod":_vm.teachingMethod,"stage":_vm.selectedStage,"category":category,"is-apply-filter":_vm.showReport,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1)}))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isPecsWithItems)?_c('div',[((_vm.isBCBA || _vm.isCurator) && _vm.isLoaded && _vm.showReport)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 without-btn"},_vm._l((_vm.protocolData.categories),function(category){return _c('div',{staticClass:"row"},[_c('current-pecs-category',{attrs:{"apiChartUrl":"/protocols/assigned/pecs-features-with-items/","protocol-id":_vm.protocolId,"teachingMethod":_vm.teachingMethod,"stage":_vm.selectedStage,"category":category,"is-apply-filter":_vm.showReport,"rangeDateStartTimestamp":_vm.rangeDateStartTimestamp,"rangeDateEndTimestamp":_vm.rangeDateEndTimestamp}})],1)}))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('cumulutive-chart',{class:{'visibility-hidden': _vm.mode !== 'detail'},attrs:{"teaching-method":_vm.teachingMethod,"cumulutiveData":_vm.cumulutiveData,"selectedStage":_vm.selectedStage,"protocolId":_vm.protocolId}}),_vm._v(" "),(_vm.cumulutiveData && _vm.showReport && (_vm.isPecsWithDiscrimination || _vm.isPecsWithItems))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.cumulutiveData),function(chart){return ((_vm.selectedStage && chart.stageInfo.id === _vm.selectedStage.id) || !_vm.selectedStage)?_c('div',{staticClass:"row"},_vm._l((chart.categories),function(categoryCumulutiveData,key){return _c('div',{staticClass:"col-12"},[_c('cumulutive-chart',{class:{'visibility-hidden': _vm.mode !== 'detail'},attrs:{"teaching-method":_vm.teachingMethod,"cumulutiveData":_vm.getData(categoryCumulutiveData),"selectedStage":_vm.selectedStage,"stageInfo":chart.stageInfo,"protocolId":_vm.protocolId}})],1)})):_vm._e()}))]):_vm._e(),_vm._v(" "),(_vm.clientData)?_c('undesirable-behavior-chart',{class:{'visibility-hidden': _vm.mode !== 'detail'},attrs:{"client-id":_vm.clientData.id,"rangeDateStart":_vm.rangeDateStart,"rangeDateEnd":_vm.rangeDateEnd,"protocol-id":_vm.protocolId,"ancedent-id":null,"behavior-id":null,"is-apply-changes":_vm.changedShow},on:{"changedView":_vm.changedView}}):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isModalVisible,"isVCD":_vm.isUSD,"isSimple":_vm.isSimple,"stimulName":!_vm.isUSD ? _vm.chosenStimul[0].stimulusName : _vm.chosenStimul[0].name,"chartType":"1","stage-id":_vm.isSimple ? _vm.selectedStageId : _vm.selectedStage ? _vm.selectedStage.id : null,"graphTitle":_vm._f("trans")('protocol.stimulus_mastering_chart'),"stimulId":!_vm.isUSD && !_vm.isSimple ? _vm.chosenStimul[0].stimulusId : _vm.chosenStimul[0].id,"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onClose}})],1):_vm._e(),_vm._v(" "),(_vm.isPromptModalVisible)?_c('div',[_c('chart-popup',{attrs:{"visible":_vm.isPromptModalVisible,"stimulName":_vm.chosenStimul[0].stimulusName,"chartType":"2","graphTitle":_vm._f("trans")('protocol.stimulus_prompt_chart'),"stimulId":_vm.chosenStimul[0].stimulusId,"protocolId":_vm.protocolId,"dataPoint":_vm.dataPoint},on:{"close":_vm.onPromptClose}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var isAuthorized = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var id, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            id = to && to.params && to.params.protocolId ? parseInt(to.params.protocolId) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/protocols/assigned/' + id + '/access');

          case 4:
            response = _context.sent;
            result = response.data.data;


            if (!__WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].isGuest() && result && result.access) {
              next();
            } else {
              next({ name: 'login' });
            }
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);

            next({ name: 'client' });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9]]);
  }));

  return function isAuthorized(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConflictLayout_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605366a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConflictLayout_vue__ = __webpack_require__(1173);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConflictLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605366a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConflictLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-wrap align-items-center justify-content-between"},[_c('div',{staticClass:"dro col-lg-9 pl-0"},[_c('button',{staticClass:"btn btn-light btn-sm  mb-1",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])]),_vm._v(" "),_c('h4',{staticClass:"dro__title"},[_vm._v(_vm._s(_vm._f("trans")('report.conflict_sessions_title'))+" #"+_vm._s(_vm.sessionId))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('div',{class:{'without_btn': _vm.hasPager}},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded}})],1)]),_vm._v(" "),_c('dashboard-menu',{attrs:{"hideDroModal":_vm.hideDroModal}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasteringStageUSD_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a117747_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasteringStageUSD_vue__ = __webpack_require__(1175);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasteringStageUSD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a117747_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasteringStageUSD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[(_vm.protocols)?_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering'))+": "),(_vm.protocolData)?_c('span',[_vm._v(_vm._s(_vm.protocolData.protocol.title))]):_vm._e()]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolData && _vm.protocolData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-4",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.protocols && !_vm.sessionView)?_c('div',{staticClass:"col-md-12 col-md-12 position-relative wrapper-loader"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.protocols.levels),function(level,index){return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.level'))+" \""+_vm._s(level.description)+"\"")]),_vm._v(" "),(level.groups.length)?_c('div',{staticClass:"row"},_vm._l((level.groups),function(group,indexGroup){return _c('div',{staticClass:"col-md-6 mt-2"},[_c('div',{staticClass:"alert cursor-pointer",on:{"click":function($event){$event.preventDefault();_vm.goToGroup(index, indexGroup)}}},[_c('h4',{staticClass:"set-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.set'))+" "+_vm._s(indexGroup+1))]),_vm._v(" "),_c('p',{staticClass:"set-subtitle text-block__slash"},_vm._l((group.stimuli),function(stimul){return _c('span',[_vm._v(_vm._s(stimul.description))])})),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 pr-0 col-12 pt-2"},_vm._l((group.sessions.slice().reverse()),function(session){return _c('div',{staticClass:"mastering-block",class:session.masteringRatio >= _vm.protocols.masteringConditions.nextPhase.ratio ? 'green' : 'red'},[_c('span',{staticClass:"line"}),_vm._v("\n                            "+_vm._s(session.masteringRatio)+"%\n                          ")])})),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-12 pr-sm-0 pt-2 pt-sm-0"},[(index + 1 !== _vm.protocols.levels.length && group.canBeMovedForward  && !group.canBeMovedBack)?_c('button',{staticClass:"btn btn-light float-right btn-xs",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.goToNextLevel(index, indexGroup)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('protocol.next_block'))+" \""+_vm._s(_vm.protocols.levels[index + 1].description)+"\"\n                          ")]):_vm._e(),_vm._v(" "),(index + 1 === _vm.protocols.levels.length && group.canBeMovedForward  && !group.canBeMovedBack)?_c('button',{staticClass:"btn btn-light float-right btn-xs",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.goToMaintain(index, indexGroup)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('protocol.to_support'))+"\n                          ")]):_vm._e(),_vm._v(" "),(index  !== 0 && group.canBeMovedBack)?_c('button',{staticClass:"btn btn-light float-right btn-xs",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.goToPrevLevel(index, indexGroup)}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('protocol.prev_block'))+" \""+_vm._s(_vm.protocols.levels[index - 1].description)+"\"\n                          ")]):_vm._e()])])])])})):_vm._e()])])})],2):_vm._e()]),_vm._v(" "),(_vm.sessionView)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12"},[_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.level'))+": "+_vm._s(_vm.protocols.levels[_vm.selectedIndex].description))]),_vm._v(" "),(_vm.selectedGroup)?_c('h4',{staticClass:"row-title text-block__slash mb-3"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.set'))+": "),_vm._l((_vm.selectedGroup.stimuli),function(stimul,index){return _c('span',[_vm._v(_vm._s(stimul.description)+" "+_vm._s(_vm.shortDescripton ?  ' - ' + _vm.shortDescripton[index] : '')+" ")])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 position-relative wrapper-loader"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.tempSessions.blocks),function(block,blockIndex){return _c('div',{key:block.uuid,staticClass:"session-block row"},[_c('div',{staticClass:"col-md-12",class:{'is-changed': block.isChanged}},[_vm._l((block.stimuli),function(stimul,index){return _c('div',{key:index,staticClass:"mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper",class:{'row_with_answer': !block.isChanged && ((_vm.selectedGroup.lastSession && _vm.selectedGroup.lastSession.blocks[blockIndex]) || block.answer), 'w33p': _vm.protocols.taskType.id !== 4}},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{staticClass:"mdc-radio__native-control",class:{'mdc-radio-checked__native-control': _vm.currentAnswer(stimul, blockIndex, block.answer)},attrs:{"id":'id[' + blockIndex + '][' + index + ']',"type":"radio","name":'radios[' + blockIndex + ']',"disabled":_vm.disabledRow(blockIndex) || (_vm.disableC(stimul) && _vm.protocols.taskType.id === 4)},on:{"click":function($event){_vm.attemptChange(stimul,blockIndex, stimul.correct ? _vm.himselfAnswer : _vm.otherAnswer.id)}}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background list-cell",class:{'active-cell': stimul.correct}},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id[' + blockIndex + '][' + index + ']'}},[_vm._v(_vm._s(stimul.name))])])])])}),(_vm.protocols.taskType.id === 4 && _vm.selectedIndex !== (_vm.protocols.levels.length - 1))?_c('div',{staticClass:"mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper",class:{'row_with_answer': (_vm.selectedGroup.lastSession && _vm.selectedGroup.lastSession.blocks[blockIndex]) || block.answer}},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{staticClass:"mdc-radio__native-control",class:{'mdc-radio-checked__native-control': _vm.currentAnswerPrompt(blockIndex)},attrs:{"id":'id[' + blockIndex + '][4]',"type":"radio","name":'radios[' + blockIndex + ']',"disabled":_vm.disabledRow(blockIndex)},on:{"click":function($event){_vm.attemptChange('p',blockIndex, _vm.promptAnswer)}}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background list-cell prompt-cell"},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id[' + blockIndex + '][4]'}},[_vm._v("P")])])])]):_vm._e(),(_vm.protocols.taskType.id === 4  && _vm.selectedIndex === (_vm.protocols.levels.length - 1))?_c('div',{staticClass:"mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper",class:{'row_with_answer': (_vm.selectedGroup.lastSession && _vm.selectedGroup.lastSession.blocks[blockIndex]) || block.answer}},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{staticClass:"mdc-radio__native-control",class:{'mdc-radio-checked__native-control': _vm.currentAnswerError(blockIndex)},attrs:{"id":'id[' + blockIndex + '][4]',"type":"radio","name":'radios[' + blockIndex + ']',"disabled":_vm.disabledRow(blockIndex)},on:{"click":function($event){_vm.attemptChange(_vm.otherAnswer.title,blockIndex, _vm.otherAnswer.id, true)}}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background list-cell error-cell",class:{'error-active-cell': (block.answer && block.answer !== _vm.himselfAnswer) || _vm.currentAnswerError(blockIndex)}},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id[' + blockIndex + '][4]'}},[_vm._v(_vm._s(_vm.otherAnswer.title))])])])]):_vm._e()],2)])})],2)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.protocolData)?_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.protocolData.protocol.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row form-group-button stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient && _vm.sessionView)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.answersLenght<9 || (_vm.isPreviousDateSession && _vm.protocolData && _vm.protocolData.endDate && _vm.showDatePrevious)},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false, true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.next_session'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2  mt-2 mt-md-0",attrs:{"type":"submit","disabled":(_vm.isPreviousDateSession && _vm.protocolData && _vm.protocolData.endDate && _vm.showDatePrevious) || (!_vm.currentAnswersLenght && _vm.sessionView)},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.save'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.sessionView)?_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-usd', params: {protocolData: _vm.protocolData, stageId:_vm.stageId}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]):_vm._e(),_vm._v(" "),(_vm.sessionView)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.sessionView = !_vm.sessionView}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.back'))+"\n        ")]):_vm._e()],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.continue_or_new'),"accept":_vm._f("trans")('protocol.start_new'),"cancel":_vm._f("trans")('protocol.continue_previous')},on:{"accept":function($event){_vm.closePopup(true)},"cancel":function($event){_vm.closePopup(false)}},model:{value:(_vm.chooseNextSessionModal),callback:function ($$v) {_vm.chooseNextSessionModal=$$v},expression:"chooseNextSessionModal"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.save_set'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.closeChangesPopup(true)},"cancel":function($event){_vm.closeChangesPopup(false)}},model:{value:(_vm.saveChangesPopup),callback:function ($$v) {_vm.saveChangesPopup=$$v},expression:"saveChangesPopup"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaintainStageUSD_vue__ = __webpack_require__(553);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b19816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaintainStageUSD_vue__ = __webpack_require__(1177);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaintainStageUSD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b19816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaintainStageUSD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"novalidate":""}},[_c('div',{staticClass:"row wizard-tab-container"},[_c('div',{staticClass:"col-lg-8"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.support'))+": "),(_vm.protocols)?_c('span',[_vm._v(_vm._s(_vm.protocols.title))]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.conductingTherapeuticSession')))]),_vm._v(" "),(_vm.activeStep.taskType)?_c('h3',{staticClass:"step-title mt-4"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.checkList'))+":\n          "+_vm._s(_vm.activeStep.taskType.title))]):_vm._e(),_vm._v(" "),(_vm.stimulusListEmpty)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.stimulus_list_empty'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"step-title"},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.today_support_stimulus')))]),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolData && _vm.protocolData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isMobile && _vm.todayStimulList)?_c('div',{staticClass:"position-relative wrapper-loader"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.todayStimulList),function(stimul,index){return (!stimul.moveToPrevPhase)?_c('tr',{key:stimul.globalUuid},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('td',{staticClass:"wide-cell"},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key,"type":"radio","disabled":stimul.disabled,"name":'radios'+index + stimul.globalUuid},domProps:{"value":label.title,"checked":_vm._q(stimul.answer,label.title)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title)},function($event){_vm.attemptChange(label.id, stimul)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(stimul.toRotation)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToPrevPhase(stimul.globalUuid)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.to_prev_phase'))+"\n                ")]):_vm._e()])]):_vm._e()}))]),_vm._v(" "),(_vm.allStimulList)?_c('div',{staticClass:"box-shadow mt-2 mb-4"},[_c('h3',{staticClass:"step-title",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.support_stimulus'))+"\n              "),(_vm.allStimulList.length)?_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[_c('span',{class:{'arrow-down': _vm.visible, 'arrow-up':!_vm.visible}})]):_vm._e()]),_vm._v(" "),(_vm.visible)?_c('table',{staticClass:"table table-sm mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.list.interval')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.allStimulList),function(stimul,index){return _c('tr',{key:stimul.globalUuid},[_c('td',[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.getInterval(stimul.intervalType))+"\n                ")])])}))]):_vm._e()]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.todayStimulList)?_c('div',[_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.todayStimulList),function(stimul,index){return (!stimul.moveToPrevPhase)?_c('div',{key:stimul.globalUuid,staticClass:"mobile-table__row"},[(stimul.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': stimul.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[(stimul.toRotation)?_c('button',{staticClass:"btn btn-link btn-link__table-text",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.goToPrevPhase(stimul.globalUuid)}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.to_prev_phase'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))])]),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row"},[_vm._l((stimul.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(stimul.answer),expression:"stimul.answer"}],key:label.title,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + stimul.id +key,"type":"radio","disabled":stimul.disabled,"name":'radios'+index + stimul.globalUuid},domProps:{"value":label.title,"checked":_vm._q(stimul.answer,label.title)},on:{"change":[function($event){_vm.$set(stimul, "answer", label.title)},function($event){_vm.attemptChange(label.id, stimul)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : stimul.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + stimul.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!stimul.disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(stimul.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]),_vm._v(" "),(_vm.allStimulList)?_c('div',{staticClass:"box-shadow mt-2 mb-4"},[_c('h3',{staticClass:"step-title",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.support_stimulus'))+"\n              "),(_vm.allStimulList.length)?_c('button',{staticClass:"btn btn-link btn-link__text float-right",attrs:{"type":"button"}},[_c('span',{class:{'arrow-down': _vm.visible, 'arrow-up':!_vm.visible}})]):_vm._e()]),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.allStimulList),function(stimul,index){return _c('div',{key:stimul.globalUuid,staticClass:"mobile-table__row"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n                    "+_vm._s(stimul.description)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"description mt-2"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.repeat'))+":\n                      "+_vm._s(stimul.iterationIndex)+" / "+_vm._s(stimul.iterationCount))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")('dro.list.interval'))+":\n                      "+_vm._s(_vm.getInterval(stimul.intervalType)))])])])}))]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row stage-button"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit","disabled":_vm.disabledSave || (!(_vm.previousDate && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveStage()}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('buttons.save'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'choose-usd'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.saveSession,"cancel":_vm.cancelSession},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageLayout_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7baec82c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageLayout_vue__ = __webpack_require__(1179);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentStageLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7baec82c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentStageLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{attrs:{"protocolData":_vm.protocolData,"clientData":_vm.clientData,"client":_vm.clientData,"clientId":_vm.clientId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsReactionStage_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032489af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsReactionStage_vue__ = __webpack_require__(1181);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsReactionStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_032489af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsReactionStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.currentStage)?_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm.conditionTransfer)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.protocol)?_c('div',{staticClass:"row"},_vm._l((_vm.protocol.stages),function(stage,index){return _c('div',{key:stage.uuid,staticClass:"col-12"},[(stage.uuid === _vm.currentStage.uuid )?_c('div',[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mt-float float-md-right",attrs:{"type":"submit","disabled":(!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();_vm.saveCurrentStep()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.pecs.next_probe'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title mt-3"},[_vm._v(_vm._s(stage.description))]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"wrapper-loader position-relative"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.tasks),function(task,index){return (!task.newStageUuid)?_c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":task.disabledBack},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',[(task.toNextLevel)?_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering_btn')))]):_vm._e()])]):_vm._e()}))])],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.tasks),function(task,index){return (!task.newStageUuid)?_c('div',{key:task.globalUuid,staticClass:"mobile-table__row"},[(task.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': task.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.description)+" "),(task.toNextLevel)?_c('span',[_vm._v("("+_vm._s(_vm._f("trans")('protocol.mastering_btn'))+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.tasks.length/3) == 0}},[_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":task.disabledBack},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]):_vm._e()]):_c('div',[_c('div',{staticClass:"disabled-list is-list mb-4",class:{'is-open': stage.isOpenDisabled},on:{"click":function($event){$event.preventDefault();_vm.toggleViewDisabled(index)}}},[_c('div',{staticClass:"active-item"},[_c('span',[_vm._v(_vm._s(stage.description))]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-link__table-text float-right",attrs:{"type":"button","disabled":(!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.saveStage(false, stage.uuid)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.pecs.go_to'))+" "+_vm._s(stage.description)+"\n                ")])]),_vm._v(" "),_vm._l((stage.tasks),function(task){return _c('div',{key:task.globalUuid,staticClass:"list-item"},[_c('span',[_vm._v(_vm._s(task.description))])])})],2)])])})):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button mt-3"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.close_protocol'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{name: 'client-edit', params: { clientId: this.clientId }}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_close_protocol'),"accept":_vm._f("trans")('protocol.buttons.close_protocol'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveStage(true)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithoutDiscriminationReactionStage_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231ea73d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithoutDiscriminationReactionStage_vue__ = __webpack_require__(1183);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithoutDiscriminationReactionStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231ea73d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithoutDiscriminationReactionStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.currentStage)?_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm.conditionTransfer)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.protocol)?_c('div',{staticClass:"row"},_vm._l((_vm.protocol.stages),function(stage,index){return _c('div',{key:stage.uuid,staticClass:"col-12"},[(stage.uuid === _vm.currentStage.uuid )?_c('div',[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mt-float float-md-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.saveCurrentStep()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.pecs.next_probe'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"wrapper-loader position-relative mt-4"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.tasks),function(task,index){return (!task.newStageUuid)?_c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',{staticClass:"results-cell"},[_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":task.disabledBack},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',[(task.toNextLevel)?_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering_btn')))]):_vm._e()])]):_vm._e()}))])],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.tasks),function(task,index){return (!task.newStageUuid)?_c('div',{key:task.globalUuid,staticClass:"mobile-table__row"},[(task.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': task.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.description)+" "),(task.toNextLevel)?_c('span',[_vm._v("("+_vm._s(_vm._f("trans")('protocol.mastering_btn'))+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.attempt))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.tasks.length/3) == 0}},[_vm._l((task.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":task.disabledBack},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]):_vm._e()]):_c('div',[_c('div',{staticClass:"disabled-list is-list mb-4",class:{'is-open': stage.isOpenDisabled},on:{"click":function($event){$event.preventDefault();_vm.toggleViewDisabled(index)}}},[_c('div',{staticClass:"active-item"},[_c('span',[_vm._v(_vm._s(stage.description))]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-link__table-text float-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.saveStage(false, stage.uuid)}}},[_vm._v("\n                  Перейти на "+_vm._s(stage.description)+"\n                ")])]),_vm._v(" "),_vm._l((stage.tasks),function(task){return _c('div',{key:task.globalUuid,staticClass:"list-item"},[_c('span',[_vm._v(_vm._s(task.description))])])})],2)])])})):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button mt-3"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.close_protocol'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{name: 'client-edit', params: { clientId: this.clientId }}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_close_protocol'),"accept":_vm._f("trans")('protocol.buttons.close_protocol'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveStage(true)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithDiscriminationStage_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f4bac9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithDiscriminationStage_vue__ = __webpack_require__(1185);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithDiscriminationStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f4bac9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithDiscriminationStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.currentStage)?_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.levelTitle'))+": "+_vm._s(_vm.currentStage.description)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.currentStage)?_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm.conditionTransfer)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.currentStage && !_vm.currentStage.selectedTasks)?_c('div',{staticClass:"row"},_vm._l((_vm.categories),function(category,index){return _c('div',{key:category.globalUuid,staticClass:"col-12"},[(category.tasks.length > 1)?_c('toogle-view',{attrs:{"title":category.title,"nameTitle":_vm.nameTitle}},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveCategory(category)}},model:{value:(category.active),callback:function ($$v) {_vm.$set(category, "active", $$v)},expression:"category.active"}})],1)])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((category.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])]):_vm._e(),_vm._v(" "),(category.tasks.length === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3 mb-0"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.categoryTitle'))+": "+_vm._s(category.title)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((category.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])])]):_vm._e()],1)})):_vm._e(),_vm._v(" "),(_vm.currentStage && _vm.currentStage.selectedTasks )?_c('div',{staticClass:"row"},_vm._l((_vm.categories),function(category,index){return (_vm.activeTaskLength(category.tasks).length)?_c('div',{key:category.globalUuid,staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.categoryTitle'))+": "+_vm._s(category.title))]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"wrapper-loader position-relative"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.result')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((category.tasks),function(task,index){return (task.active)?_c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',{staticClass:"results-cell"},[(task.lastAnswers)?_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                        "+_vm._s(answer)+"\n                      ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2):_vm._e(),_vm._v(" "),_vm._l((_vm.currentStage.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(category.uuid, label.id, task, label.title, 1)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!task.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid, category.uuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2),_vm._v(" "),_c('td',[(task.toNextLevel || (task.isMastered && category.currentStageUuid != _vm.currentStage.uuid))?_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastering_btn'))+" ")]):_vm._e()])]):_vm._e()}))]),_vm._v(" "),(!_vm.activeTaskLength(category.tasks).length)?_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_list_property')))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table position-relative"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.attempts')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((category.tasks),function(task,index){return (task.active)?_c('div',{key:task.globalUuid,staticClass:"mobile-table__row"},[(task.answer)?_c('div',{staticClass:"container-load"},[_c('svg',{class:{'animate': task.answer},attrs:{"viewbox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z","stroke":"#3da35a","fill":"transparent"}})])]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.description)+" "),(task.toNextLevel || (task.isMastered && category.currentStageUuid != _vm.currentStage.uuid))?_c('span',[_vm._v("("+_vm._s(_vm._f("trans")('protocol.mastering_btn'))+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.attempt))])]),_vm._v(" "),(task.lastAnswers)?_c('div',{staticClass:"mt-2"},[_vm._l((task.lastAnswers),function(answer,index){return _c('span',{staticClass:"item-box",class:{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}},[_vm._v("\n                      "+_vm._s(answer)+"\n                    ")])}),_vm._l((_vm.emptyLength(task.lastAnswers.length)),function(n){return _c('span',{staticClass:"item-box-light"})})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-2 stimul-row",class:{'stimul-row-3' : (_vm.tasks.length/3) == 0}},[_vm._l((_vm.currentStage.type.answers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid + label.id +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + label.id +key,"type":"radio","name":'radios'+index + task.globalUuid + label.id +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid + label.id +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid + label.id +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid + label.id +key)},function($event){_vm.attemptChange(category.uuid, label.id, task, label.title, task.attepmtsCount)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + label.id + key}},[_vm._v(_vm._s(label.title))])])])])}),_vm._v(" "),_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!task.attempt},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(task.globalUuid, category.uuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])],2)]):_vm._e()}))]):_vm._e()]):_vm._e()})):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button mt-3"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient && _vm.currentStage && !_vm.currentStage.selectedTasks)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"disabled":_vm.disabledSelected},on:{"click":function($event){$event.preventDefault();_vm.selectTaskList()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.choosePreferred'))+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.isClient && _vm.currentStage && _vm.currentStage.selectedTasks)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":_vm.disabledSave},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.close_protocol'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{ name: 'stage-list'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_close_protocol'),"accept":_vm._f("trans")('protocol.buttons.close_protocol'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveStage(true)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithItemsStage_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_504cd578_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithItemsStage_vue__ = __webpack_require__(1187);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PecsWithItemsStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_504cd578_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PecsWithItemsStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"row  wizard-tab-container"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-12"},[(_vm.protocol)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.protocol.title))]):_vm._e(),_vm._v(" "),(_vm.currentStage)?_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm.conditionTransfer)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isPreviousDateSession && _vm.protocolsData && _vm.protocolsData.endDate)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"row mt-2 mb-3",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"col-12"},[(_vm.showDatePrevious)?_c('div',{staticClass:"alert-danger text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.enter_another_session_date'))+" "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e(),_vm._v(" "),(!_vm.showDatePrevious)?_c('div',{staticClass:"alert-secondary text-center"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.end_session_date'))+": "),_c('strong',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(_vm.minDate)))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.maxTotalAtemptsCountError)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.max_count_for_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.currentStage && !_vm.currentStage.selectedTasks && _vm.itemsCategory)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.itemsCategory.tasks.length > 1)?_c('toogle-view',{attrs:{"title":_vm.itemsCategory.title,"nameTitle":""}},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.subjects')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveCategory(_vm.itemsCategory)}},model:{value:(_vm.itemsCategory.active),callback:function ($$v) {_vm.$set(_vm.itemsCategory, "active", $$v)},expression:"itemsCategory.active"}})],1)])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.itemsCategory.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])]):_vm._e(),_vm._v(" "),(_vm.itemsCategory.tasks.length === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3 mb-0"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.categoryTitle'))+" "+_vm._s(_vm.itemsCategory.title)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.itemsCategory.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.currentStage && !_vm.currentStage.selectedTasks && _vm.propsCategory.length)?_c('div',{staticClass:"row"},_vm._l((_vm.propsCategory),function(category,index){return _c('div',{key:category.globalUuid,staticClass:"col-12"},[(category.tasks.length > 1)?_c('toogle-view',{attrs:{"title":category.title,"nameTitle":_vm._f("trans")(category.typeId == 2 ? '' : 'protocol.categoryTitle')}},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")(category.typeId == 2 ? 'protocol.subjects' : 'protocol.property')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveCategory(category)}},model:{value:(category.active),callback:function ($$v) {_vm.$set(category, "active", $$v)},expression:"category.active"}})],1)])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((category.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])]):_vm._e(),_vm._v(" "),(category.tasks.length === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3 mb-0"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.categoryTitle'))+" "+_vm._s(category.title)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-sm table-fixed mt-2"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"title-cell text-capitalize"},[_vm._v(_vm._s(_vm._f("trans")('protocol.property')))]),_vm._v(" "),_c('th',{staticClass:"action-cell"})])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((category.tasks),function(task,index){return _c('tr',{key:task.globalUuid},[_c('td',[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)])}))])])]):_vm._e()],1)})):_vm._e(),_vm._v(" "),(_vm.currentStage && _vm.currentStage.selectedTasks)?_c('div',{staticClass:"row"},[((!(_vm.previousDate && _vm.previousTime && _vm.previousTime.HH && _vm.previousTime.mm) && (_vm.isBCBA || _vm.isCurator) && _vm.isPreviousDateSession) || _vm.showDatePrevious)?_c('loader',{staticClass:"table-loader position-absolute without-img",attrs:{"messages":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[(!_vm.isClient)?_c('button',{staticClass:"btn btn-primary btn-sm mt-float float-md-right",attrs:{"type":"submit","disabled":!_vm.selectItem || !_vm.selectProperty},on:{"click":function($event){$event.preventDefault();_vm.saveCurrentStep()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.pecs.next_probe'))+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.categories.length)?_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3"},[_vm._v(_vm._s(_vm.itemsCategory.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._l((_vm.itemsCategory.tasks),function(task){return _c('div',{staticClass:"d-inline-block mr-2"},_vm._l((task.typeAnswers),function(label,key){return (task.active)?_c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper",class:{'props-radio-wrapper': label.answer == '+'}},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title + 'items' + task.globalUuid +key,staticClass:"mdc-radio__native-control",attrs:{"id":'idItems' + task.globalUuid + key,"type":"radio","name":'radiosItems' + task.globalUuid +key,"disabled":task.disabled},domProps:{"value":label.title + 'items' + task.globalUuid +key,"checked":_vm._q(task.answer,label.title + 'items' + task.globalUuid +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title + 'items' + task.globalUuid +key)},function($event){_vm.attemptChange(_vm.itemsCategory, label, task)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'idItems' + task.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])]):_vm._e()}))}),_vm._v(" "),_c('div',{staticClass:"d-inline-block align-top"},[_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!_vm.itemsCategory.tasks[0].disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(_vm.itemsCategory.uuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])])],2)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.propsCategory),function(category,index){return (_vm.activeTaskLength(category.tasks).length)?_c('div',{key:category.globalUuid,staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title mt-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.categoryTitle'))+" "+_vm._s(category.title))]),_vm._v(" "),_vm._l((category.tasks),function(task){return (task.active)?_c('div',{staticClass:"d-inline-block mr-2"},_vm._l((task.typeAnswers),function(label,key){return _c('div',{staticClass:"mdc-radio-wrapper mdc-form-field stimul-radio-wrapper",class:{'props-radio-wrapper': label.answer == '+'}},[_c('div',{staticClass:"mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(task.answer),expression:"task.answer"}],key:label.title+index + task.globalUuid +key,staticClass:"mdc-radio__native-control",attrs:{"id":'id'+index + task.globalUuid + key,"type":"radio","name":'radios'+index + task.globalUuid +key,"disabled":task.disabled},domProps:{"value":label.title+index + task.globalUuid +key,"checked":_vm._q(task.answer,label.title+index + task.globalUuid +key)},on:{"change":[function($event){_vm.$set(task, "answer", label.title+index + task.globalUuid +key)},function($event){_vm.attemptChange(category, label, task)}]}}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__background",class:{'disabled' : task.disabled},style:({background: label.color})},[_c('div',{staticClass:"mdc-radio__outer-circle"}),_vm._v(" "),_c('div',{staticClass:"mdc-radio__inner-circle"}),_vm._v(" "),_c('label',{attrs:{"for":'id'+index + task.globalUuid + key}},[_vm._v(_vm._s(label.title))])])])])})):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"d-inline-block align-top"},[_c('button',{staticClass:"btn return-btn",attrs:{"type":"button","disabled":!category.tasks[0].disabled},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousAttempt(category.uuid)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("undo")])])])],2):_vm._e()})],2):_vm._e(),_vm._v(" "),(!_vm.isClient)?_c('div',{staticClass:"form-group row form-group-button stage-button mt-3"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isClient && _vm.currentStage && !_vm.currentStage.selectedTasks)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"disabled":!_vm.selectTaskAndItem},on:{"click":function($event){$event.preventDefault();_vm.selectTaskList()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.choosePreferred'))+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.isClient && _vm.currentStage && _vm.currentStage.selectedTasks)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":!_vm.selectItem || !_vm.selectProperty},on:{"click":function($event){$event.preventDefault();_vm.saveStage(false)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.closeSession()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.close_protocol'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-link btn-sm mr-2 mt-2 mt-md-0",attrs:{"to":{name: 'client-edit', params: { clientId: this.clientId }}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('instruction',{attrs:{"text":_vm.execution,"header":_vm._f("trans")('protocol.execution'),"short-text-length":180}})],1)],1)]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_save_conflict_session'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveSession(false)},"cancel":_vm.onModalClose},model:{value:(_vm.isConflictModalVisible),callback:function ($$v) {_vm.isConflictModalVisible=$$v},expression:"isConflictModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_close_protocol'),"accept":_vm._f("trans")('protocol.buttons.close_protocol'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.saveStage(true)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_protocols_components_ProtocolList__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_protocols_components_Protocol__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_protocols_components_ProtocolDashboardLayout__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_bids_components_BidsList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__ = __webpack_require__(132);










/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/protocols',
  component: __WEBPACK_IMPORTED_MODULE_3__modules_protocols_components_ProtocolDashboardLayout__["a" /* default */],
  children: [{
    path: 'index',
    name: 'protocols',
    component: __WEBPACK_IMPORTED_MODULE_1__modules_protocols_components_ProtocolList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: 'bids',
    name: 'bids',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_bids_components_BidsList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: 'applications',
    name: 'applications',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: '/protocols/:protocolId/edit',
    name: 'protocol-edit',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_protocols_components_Protocol__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }, {
    path: '/protocols/create',
    name: 'protocol-create',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_protocols_components_Protocol__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }]
}]);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolList_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae99864_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolList_vue__ = __webpack_require__(1190);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae99864_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"protocols"},[(!_vm.isMensurationForbidden)?_c('div',{staticClass:"row pager-btn-row mb-5 mb-md-2"},[_c('div',{staticClass:"col-md-12 col-lg-12 text-right"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'protocol-create'},"disabled":_vm.disabled}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.buttons.create'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isList":_vm.isMobile,"isChange":_vm.isChange,"isTwoSearch":true},on:{"on-search":_vm.onSearchEnter,"on-search-skill-field":_vm.onSearchSkillField},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('div',{},[_c('div',{staticClass:"icon-circle icon-blue"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.P')))]):_vm._e()])])}},{key:"title",fn:function(props){return _c('div',{},[_c('strong',[_vm._v(_vm._s(props.row.title))]),_c('br'),_vm._v(" "),_c('div',[_c('dl',{staticClass:"term_with_descr"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol_goal'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(props.row.goal))])])]),_vm._v(" "),_c('div',[_c('dl',{staticClass:"term_with_descr"},[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('protocol.area'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(props.row.skillField.name))])])]),_vm._v(" "),(props.row.draft && !_vm.isMensurationForbidden)?_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.unsaved_changes'))+":")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'protocol-edit', params: { protocolId: props.row.draft.id}}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.view_auto_save'))+"\n          ")])],1):_vm._e()])}},{key:"createdAt",fn:function(props){return _c('div',{},[_vm._v("\n        "+_vm._s(_vm._f("toLocaleDate")(props.row.createdAt.date))+"\n      ")])}},{key:"published",fn:function(props){return (!props.row.published)?_c('span',{},[_vm._v(_vm._s(_vm._f("trans")('protocol.notPublish')))]):_vm._e()}},{key:"action",fn:function(props){return _c('mdc-menu-anchor',{},[_c('mdc-button',{attrs:{"raised":""},on:{"click":function($event){props.row.isOpen=true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('mdc-menu',{model:{value:(props.row.isOpen),callback:function ($$v) {_vm.$set(props.row, "isOpen", $$v)},expression:"props.row.isOpen"}},[(!_vm.isMensurationForbidden)?_c('mdc-menu-item',[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'protocol-edit', params: { protocolId: props.row.id }}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.edit'))+"\n            ")])],1):_vm._e(),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.duplicateProtocol(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.duplicate')))])]):_vm._e(),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showDeletePopup(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.delete')))])]):_vm._e(),_vm._v(" "),_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.exportProtocol(props.row.id)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.export')))])])],1)],1)}},{key:"mobileHeader",fn:function(props){return _c('div',{},[_c('div',{staticClass:"icon-circle icon-blue"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(props.row.title))])])}}])},[_c('div',{attrs:{"slot":"mobileTitle"},slot:"mobileTitle"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.protocols'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 col-lg-12 text-right"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'protocol-create'},"disabled":_vm.disabled}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.buttons.create'))+"\n      ")])],1):_vm._e()]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.deleteProtocol(_vm.protocolId)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocol_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae5002e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocol_vue__ = __webpack_require__(1236);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae5002e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocol_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1192 */,
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validateRule),expression:"validateRule"}],ref:_vm.id,staticClass:"autocomplete__input",class:{'is-invalid': _vm.errors.has(_vm.id)},attrs:{"id":_vm.id,"autocomplete":"off","name":_vm.id,"type":"text","multiline":_vm.multiline,"rows":_vm.rowsCount,"label":_vm.label,"disabled":_vm.disabled,"data-vv-validate-on":"none","data-vv-as":_vm.validateLable},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.down($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.right($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.up($event)}],"input":_vm.change,"blur":_vm.hideDropdown,"validate":_vm.validate},model:{value:(_vm.inputText),callback:function ($$v) {_vm.inputText=$$v},expression:"inputText"}}),_vm._v(" "),(_vm.errors.has(_vm.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(_vm.id)))])]):_vm._e()],1)]),_vm._v(" "),_c('ul',{ref:"scrollContainer",staticClass:"autocomplete-dropdown",class:{'open':_vm.openSuggestion}},_vm._l((_vm.suggestions),function(item,index){return _c('li',{ref:"options",refInFor:true,staticClass:"autocomplete-dropdown__item",class:{'active': _vm.isActive(index)},on:{"click":function($event){_vm.suggestionClick(index, item[_vm.field])},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.suggestionClick(index, item[_vm.field])}}},[_vm._v("\n      "+_vm._s(item[_vm.field])+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1194 */,
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41012a0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__(1199);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41012a0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete_title'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.accept,"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_vm._v("\n  "+_vm._s(_vm._f("trans")('user.confirm_delete_client_form_therapist'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hintVisible)?_c('div',{staticClass:"col-md-12 switch-right-list"},[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.hint_sub_title')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 hint-wrapp"},_vm._l((_vm.sortedHintList),function(hint){return _c('mdc-switch',{key:hint.id,class:{'pl-4' : hint.subLevel},model:{value:(hint.active),callback:function ($$v) {_vm.$set(hint, "active", $$v)},expression:"hint.active"}},[_c('span',{staticClass:"color-block",style:({background: hint.color})},[_vm._v(_vm._s(hint.title))]),_vm._v("\n        "+_vm._s(hint.description)+"\n      ")])}))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1198 */,
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.checkList'))+"\n          "+_vm._s(_vm.currentStage.title)+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),(_vm.tasks)?_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))])]),_vm._v(" "),_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_stage')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_mand')))]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.tasks,"ghost-class":"ghost","tag":"tbody","handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.tasks),function(task){return _c('tr',{key:task.globalUuid},[_c('td',{staticClass:"name-field"},[_vm._v("\n                  "+_vm._s(task.description)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{attrs:{"disabled":task.mastered},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{attrs:{"disabled":!task.active},on:{"change":function($event){_vm.masteredTask(task)}},model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(task.active && !task.mastered)?_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")]):_vm._e()])])}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],class:{'is-invalid': _vm.errors.has('addTaskReactionItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addTaskReactionItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addTaskReactionItem),callback:function ($$v) {_vm.addTaskReactionItem=$$v},expression:"addTaskReactionItem"}}),_vm._v(" "),(_vm.errors.has('addTaskReactionItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addTaskReactionItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addTask(_vm.addTaskReactionItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"form-group row"},[(_vm.taskType)?_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"taskTypes",attrs:{"id":"taskTypes"}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-clear is-invalid': !_vm.taskType.title},attrs:{"name":"taskType","options":_vm.taskTypesNew,"label":"title","filterable":false,"clearable":true,"data-vv-validate-on":"none","disabled":_vm.disabledChange || _vm.disabledTaskType,"on-change":_vm.changeTaskType},model:{value:(_vm.taskType),callback:function ($$v) {_vm.taskType=$$v},expression:"taskType"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                    ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'is-invalid': !_vm.taskType.title}},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "),_c('sup',[_c('mdc-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.msg),expression:"msg",modifiers:{"top-center":true}}],staticClass:"help_icon",attrs:{"icon":"help"}})],1)]),_vm._v(" "),(!_vm.taskType.title)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "+_vm._s(_vm._f("trans")('validation.required_field')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.isBaseColdSample && _vm.taskType)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"taskTypes",attrs:{"id":"spoTaskTypes"}},[_c('v-select',{class:{'is-clear': !_vm.currentStage.generate.type.title},attrs:{"name":"spoTaskType","options":_vm.spoTaskTypesNew,"label":"title","disabled":_vm.disabledChange,"on-change":_vm.changeSpoTaskType},model:{value:(_vm.currentStage.generate.type),callback:function ($$v) {_vm.$set(_vm.currentStage.generate, "type", $$v)},expression:"currentStage.generate.type"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                    ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type')))])],1)]):_vm._e()]),_vm._v(" "),(_vm.taskType)?_c('div',{staticClass:"form-group row"},[(_vm.isBaseColdSample)?_c('div',{staticClass:"col-md-4"},[_c('mdc-radio',{attrs:{"name":"radios","disabled":_vm.disabledChange,"value":"4","label":_vm._f("trans")('protocol.add_minus_spo'),"checked":""},model:{value:(_vm.currentStage.generate.answer),callback:function ($$v) {_vm.$set(_vm.currentStage.generate, "answer", $$v)},expression:"currentStage.generate.answer"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"radios","disabled":_vm.disabledChange,"value":"3","label":_vm._f("trans")('protocol.add_plus_spo')},model:{value:(_vm.currentStage.generate.answer),callback:function ($$v) {_vm.$set(_vm.currentStage.generate, "answer", $$v)},expression:"currentStage.generate.answer"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.taskType)?_c('div',{staticClass:"row mb-4"},[(_vm.taskType.id !== 1)?_c('div',{staticClass:"col-md-12"},[_c('mdc-switch',{model:{value:(_vm.currentStage.isPromptEnabled),callback:function ($$v) {_vm.$set(_vm.currentStage, "isPromptEnabled", $$v)},expression:"currentStage.isPromptEnabled"}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.track_change_level'))+"\n                ")]),_vm._v(" "),_c('hints',{attrs:{"hint-list":_vm.currentStage.taskPrompts,"hintVisible":_vm.currentStage.isPromptEnabled}})],1):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.hideTasks()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksDTT_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d028e6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksDTT_vue__ = __webpack_require__(1205);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksDTT_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d028e6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksDTT_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDTTModal_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fa1128_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDTTModal_vue__ = __webpack_require__(1202);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDTTModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fa1128_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDTTModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"auto_height_modal",attrs:{"title":_vm._f("trans")('protocol.setup_stimuli', {title: _vm.stimul.description}),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.save,"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('phaseTask'), 'is-clear': !_vm.phaseTask},attrs:{"options":_vm.phases,"name":"phases","label":"title","filterable":false,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_phase')},model:{value:(_vm.phaseTask),callback:function ($$v) {_vm.phaseTask=$$v},expression:"phaseTask"}}),_vm._v(" "),(_vm.currentPhase)?_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm.currentPhase))]):_vm._e()],1)]),_vm._v(" "),(_vm.fieldList && _vm.phaseTask)?_c('div',{staticClass:"form-group row"},[(_vm.phaseTask.typeId != 3)?_c('div',{staticClass:"col-12"},[_c('mdc-select',{class:{'is-invalid': _vm.errors.has('field'), 'is-full': _vm.field},attrs:{"label":_vm._f("trans")('protocol.choose_field'),"name":"field","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_field')},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}},_vm._l((_vm.fieldList),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.field'))+" "+_vm._s(item)+"\n          ")])}))],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.intervalList && _vm.phaseTask)?_c('div',{staticClass:"form-group row"},[(_vm.phaseTask.typeId == 3)?_c('div',{staticClass:"col-12"},[_c('mdc-select',{class:{'is-invalid': _vm.errors.has('interval'), 'is-full': _vm.interval},attrs:{"label":_vm._f("trans")('protocol.choose_interval'),"name":"interval","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_interval')},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}},_vm._l((_vm.intervalList),function(item){return _c('option',{domProps:{"value":item.typeId}},[_vm._v("\n             "+_vm._s(item.name)+"\n          ")])}))],1):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDttPhaseModal_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702dc5be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDttPhaseModal_vue__ = __webpack_require__(1204);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDttPhaseModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702dc5be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDttPhaseModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"auto_height_modal",attrs:{"title":"Настройка стимулов","accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.save,"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('phaseTask'), 'is-clear': !_vm.phaseTask},attrs:{"options":_vm.phases,"name":"phases","label":"title","filterable":false,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_phase')},model:{value:(_vm.phaseTask),callback:function ($$v) {_vm.phaseTask=$$v},expression:"phaseTask"}})],1)]),_vm._v(" "),(_vm.fieldList && _vm.phaseTask)?_c('div',{staticClass:"form-group row"},[(_vm.phaseTask.typeId != 3)?_c('div',{staticClass:"col-12"},[_c('mdc-select',{class:{'is-invalid': _vm.errors.has('field'), 'is-full': _vm.field},attrs:{"label":_vm._f("trans")('protocol.choose_field'),"name":"field","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_field')},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}},_vm._l((_vm.fieldList),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.field'))+" "+_vm._s(item)+"\n          ")])}))],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.intervalList && _vm.phaseTask)?_c('div',{staticClass:"form-group row"},[(_vm.phaseTask.typeId == 3)?_c('div',{staticClass:"col-12"},[_c('mdc-select',{class:{'is-invalid': _vm.errors.has('interval'), 'is-full': _vm.interval},attrs:{"label":_vm._f("trans")('protocol.choose_interval'),"name":"interval","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_interval')},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}},_vm._l((_vm.intervalList),function(item){return _c('option',{domProps:{"value":item.typeId}},[_vm._v("\n             "+_vm._s(item.name)+"\n          ")])}))],1):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm.currentStage.title)+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle mb-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_stimul_position')))])]),_vm._v(" "),(_vm.tasks)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('div',[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.stimul_settings'))+"\n              "),_c('button',{staticClass:"btn btn-link secondary-link btn-sm float-right",attrs:{"type":"button","disabled":!_vm.stimulListToChangeAndActive},on:{"click":function($event){$event.preventDefault();_vm.onEditSomeBtnClick()}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.edit'))+"\n              ")])]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_name')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_stage')))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('user.edit')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.tasks,"ghost-class":"ghost","tag":"tbody","handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.tasks),function(task){return _c('tr',{key:task.id},[_c('td',{staticClass:"name-field"},[_vm._v("\n                    "+_vm._s(task.description)+"\n                  ")]),_vm._v(" "),_c('td',[(task.fieldIndex && task.phaseType != 3)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.field'))+" "+_vm._s(task.fieldIndex)+" / ")]):_vm._e(),_vm._v(" "),(task.phaseType == 3 && _vm.currentIntervalType(task.intervalType))?_c('span',[_vm._v(_vm._s(_vm.currentIntervalType(task.intervalType))+" / ")]):_vm._e(),_vm._v(" "),(!task.phaseType || task.phaseType == 1)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_mastering')))]):_vm._e(),_vm._v(" "),(task.phaseType == 2)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_rotation')))]):_vm._e(),_vm._v(" "),(task.phaseType == 3)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_support')))]):_vm._e(),_vm._v(" "),(task.phaseType == 4)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_fluency')))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.acivatedTask(task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-rounded",attrs:{"type":"button","disabled":!task.active},on:{"click":function($event){$event.preventDefault();_vm.onEditBtnClick(task)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("edit")])])]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{attrs:{"disabled":!task.active},model:{value:(task.changed),callback:function ($$v) {_vm.$set(task, "changed", $$v)},expression:"task.changed"}})],1),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(task.active)?_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")]):_vm._e()])])}))],1):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-table mt-3 mb-3"},[_c('div',{staticClass:"mobile-table__head"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_name')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_stage')))])]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},_vm._l((_vm.tasks),function(task){return _c('div',{key:task.id,staticClass:"mobile-table__row"},[_c('div',[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.acivatedTask(task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1)]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('p',{staticClass:"gray-700"},[(task.fieldIndex && task.phaseType != 3)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.field'))+" "+_vm._s(task.fieldIndex)+" / ")]):_vm._e(),_vm._v(" "),(task.phaseType == 3 && _vm.currentIntervalType(task.intervalType))?_c('span',[_vm._v(_vm._s(_vm.currentIntervalType(task.intervalType))+" / ")]):_vm._e(),_vm._v(" "),(!task.phaseType || task.phaseType == 1)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_mastering')))]):_vm._e(),_vm._v(" "),(task.phaseType == 2)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_rotation')))]):_vm._e(),_vm._v(" "),(task.phaseType == 3)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_support')))]):_vm._e(),_vm._v(" "),(task.phaseType == 4)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_fluency')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm._f("trans")('user.edit')))]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('mdc-checkbox',{staticClass:"d-inline-block",attrs:{"disabled":!task.active},model:{value:(task.changed),callback:function ($$v) {_vm.$set(task, "changed", $$v)},expression:"task.changed"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm btn-rounded d-inline-block",staticStyle:{"margin-top":"-16px"},attrs:{"type":"button","disabled":!task.active},on:{"click":function($event){$event.preventDefault();_vm.onEditBtnClick(task)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("edit")])])],1)])])}))]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.stimul_settings'))+"\n            "),_c('button',{staticClass:"btn btn-link secondary-link btn-sm float-right",attrs:{"type":"button","disabled":!_vm.stimulListToChangeAndActive},on:{"click":function($event){$event.preventDefault();_vm.onEditSomeBtnClick()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.edit'))+"\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addTask(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 mt-4"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.dtt_phase_title'))+"\n        ")]),_vm._v(" "),(_vm.errorPhaseCount)?_c('strong',{ref:"errorPhase",staticClass:"invalid-feedback invalid",attrs:{"id":"errorPhase"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.errorPhaseCount')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.protocol.stages[_vm.currentStageIndex])?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.setup_mastering'))+": "),_c('mdc-switch',{model:{value:(_vm.masteringActive),callback:function ($$v) {_vm.masteringActive=$$v},expression:"masteringActive"}}),_vm._v(" "),(_vm.masteringActive)?_c('mdc-checkbox',{staticClass:"float-right",attrs:{"label":_vm._f("trans")('protocol.withFields')},model:{value:(_vm.mastering.withFields),callback:function ($$v) {_vm.$set(_vm.mastering, "withFields", $$v)},expression:"mastering.withFields"}}):_vm._e()],1)]),_vm._v(" "),(_vm.masteringActive)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 required"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"taskType",class:{'is-clear': !_vm.masteringTaskType, 'is-invalid': _vm.errors.has('taskTypes')},attrs:{"name":"taskType","id":"taskType","options":_vm.taskTypesList,"label":"title","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_type')},model:{value:(_vm.masteringTaskType),callback:function ($$v) {_vm.masteringTaskType=$$v},expression:"masteringTaskType"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                      ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'is-invalid': _vm.errors.has('taskType')}},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "),_c('sup',[_c('mdc-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.msg),expression:"msg",modifiers:{"top-center":true}}],staticClass:"help_icon",attrs:{"icon":"help"}})],1)]),_vm._v(" "),(_vm.errors.has('taskType'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('taskType')))])]):_vm._e()],1),_vm._v(" "),(_vm.mastering.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.min_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:15|numeric'),expression:"'min_value:1|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.masteringMinFieldCount),expression:"masteringMinFieldCount",modifiers:{"number":true}}],ref:"minFieldCount_mastering",class:{'is-invalid': _vm.errors.has('minFieldCount_mastering')},attrs:{"id":"minFieldCount_mastering","min":"1","max":"15","label":_vm._f("trans")('protocol.min_field_count'),"type":"number","name":"minFieldCount_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.min_field_count')},domProps:{"value":(_vm.masteringMinFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 1)},"change":function($event){_vm.changeMinFieldCount(_vm.masteringMinFieldCount,1)},"input":function($event){if($event.target.composing){ return; }_vm.masteringMinFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('minFieldCount_mastering'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('minFieldCount_mastering')))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.mastering.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.max_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:'+_vm.masteringMinFieldCount+'|max_value:15|numeric'),expression:"'min_value:'+masteringMinFieldCount+'|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.masteringMaxFieldCount),expression:"masteringMaxFieldCount",modifiers:{"number":true}}],ref:"maxFieldCount_mastering",class:{'is-invalid': _vm.errors.has('maxFieldCount_mastering')},attrs:{"id":"maxFieldCount_mastering","label":_vm._f("trans")('protocol.max_field_count'),"type":"number","min":"1","max":"15","name":"maxFieldCount_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.max_field_count')},domProps:{"value":(_vm.masteringMaxFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 1)},"change":function($event){_vm.changeMaxFieldCount(_vm.masteringMaxFieldCount,1)},"input":function($event){if($event.target.composing){ return; }_vm.masteringMaxFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('maxFieldCount_mastering'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('maxFieldCount_mastering')))])]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.masteringActive)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferCondition","value":_vm.transferConditionValue.first,"checked":_vm.masteringTransferCondition == _vm.transferConditionValue.first},model:{value:(_vm.masteringTransferCondition),callback:function ($$v) {_vm.masteringTransferCondition=$$v},expression:"masteringTransferCondition"}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.one_trial'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferCondition","value":_vm.transferConditionValue.second,"id":"transferCondition2","checked":_vm.masteringTransferCondition == _vm.transferConditionValue.second},model:{value:(_vm.masteringTransferCondition),callback:function ($$v) {_vm.masteringTransferCondition=$$v},expression:"masteringTransferCondition"}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"},{name:"model",rawName:"v-model",value:(_vm.masteringConditionTransfer.trialCount),expression:"masteringConditionTransfer.trialCount"}],ref:"trial_in_row_mastering",attrs:{"id":"trial_in_row","min":"1","type":"number","name":"trial_in_row","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.trial_in_row')},domProps:{"value":(_vm.masteringConditionTransfer.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.masteringConditionTransfer, "trialCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.trial_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferCondition","value":_vm.transferConditionValue.third,"id":"transferCondition3","checked":_vm.masteringTransferCondition == _vm.transferConditionValue.third},model:{value:(_vm.masteringTransferCondition),callback:function ($$v) {_vm.masteringTransferCondition=$$v},expression:"masteringTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.masteringConditionTransfer.sessionCount),expression:"masteringConditionTransfer.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"task_count_mastering",attrs:{"id":"task_count","min":"1","type":"number","name":"task_count","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_in_row')},domProps:{"value":(_vm.masteringConditionTransfer.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.masteringConditionTransfer, "sessionCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.task_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferCondition","value":_vm.transferConditionValue.fourth,"id":"transferCondition4","checked":_vm.masteringTransferCondition == _vm.transferConditionValue.fourth},model:{value:(_vm.masteringTransferCondition),callback:function ($$v) {_vm.masteringTransferCondition=$$v},expression:"masteringTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.masteringConditionTransfer.ratio),expression:"masteringConditionTransfer.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent_mastering",class:{'is-invalid': _vm.errors.has('condition_procent_mastering')},attrs:{"id":"condition_procent_mastering","min":"80","type":"number","name":"condition_procent_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.masteringConditionTransfer.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.masteringConditionTransfer, "ratio", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_procent'))+"\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.masteringConditionTransfer.conditionSession),expression:"masteringConditionTransfer.conditionSession"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session_mastering",staticClass:"ml-2",attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.masteringConditionTransfer.conditionSession)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.masteringConditionTransfer, "conditionSession", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.masteringConditionTransfer.conditionTrial),expression:"masteringConditionTransfer.conditionTrial"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial_mastering",staticClass:"ml-2",attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.masteringConditionTransfer.conditionTrial)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.masteringConditionTransfer, "conditionTrial", $event.target.value)}}}),_vm._v("\n\n                    "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n                  ")]),_vm._v(" "),(_vm.errors.has('trial_in_row'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('trial_in_row'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('task_count'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_count'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_procent_mastering'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_mastering'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+" ")])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(_vm.masteringActive && _vm.masteringTaskType)?_c('div',{staticClass:"col-md-12"},[(_vm.masteringTaskType.id != 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('mdc-switch',{model:{value:(_vm.masteringVisible),callback:function ($$v) {_vm.masteringVisible=$$v},expression:"masteringVisible"}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.track_change_level'))+"\n                  ")])],1),_vm._v(" "),_c('hints',{attrs:{"hint-list":_vm.hintListMastering,"hintVisible":_vm.masteringVisible}})],1):_vm._e()]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.protocol.stages[_vm.currentStageIndex])?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.setup_rotation'))+": "),_c('mdc-switch',{model:{value:(_vm.rotationActive),callback:function ($$v) {_vm.rotationActive=$$v},expression:"rotationActive"}}),_vm._v(" "),(_vm.rotationActive)?_c('mdc-checkbox',{staticClass:"float-right",attrs:{"label":_vm._f("trans")('protocol.withFields')},model:{value:(_vm.rotation.withFields),callback:function ($$v) {_vm.$set(_vm.rotation, "withFields", $$v)},expression:"rotation.withFields"}}):_vm._e()],1)]),_vm._v(" "),(_vm.rotationActive)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 required"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"taskTypeRotation",class:{'is-clear': !_vm.rotationTaskType, 'is-invalid': _vm.errors.has('taskTypeRotation')},attrs:{"name":"taskTypeRotation","id":"taskTypeRotation","options":_vm.taskTypesList,"label":"title","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_type')},model:{value:(_vm.rotationTaskType),callback:function ($$v) {_vm.rotationTaskType=$$v},expression:"rotationTaskType"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                      ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'is-invalid': _vm.errors.has('taskTypeRotation')}},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "),_c('sup',[_c('mdc-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.msg),expression:"msg",modifiers:{"top-center":true}}],staticClass:"help_icon",attrs:{"icon":"help"}})],1)]),_vm._v(" "),(_vm.errors.has('taskTypeRotation'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('taskTypeRotation')))])]):_vm._e()],1),_vm._v(" "),(_vm.rotation.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.min_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:15|numeric'),expression:"'min_value:1|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.rotationMinFieldCount),expression:"rotationMinFieldCount",modifiers:{"number":true}}],ref:"minFieldCount_rotation",class:{'is-invalid': _vm.errors.has('minFieldCount_rotation')},attrs:{"id":"minFieldCount_rotation","min":"1","max":"15","label":_vm._f("trans")('protocol.min_field_count'),"type":"number","name":"minFieldCount_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.min_field_count')},domProps:{"value":(_vm.rotationMinFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 2)},"change":function($event){_vm.changeMinFieldCount(_vm.rotationMinFieldCount,2)},"input":function($event){if($event.target.composing){ return; }_vm.rotationMinFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('minFieldCount_rotation'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('minFieldCount_rotation')))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.rotation.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.max_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:'+_vm.rotationMinFieldCount+'|max_value:15|numeric'),expression:"'min_value:'+rotationMinFieldCount+'|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.rotationMaxFieldCount),expression:"rotationMaxFieldCount",modifiers:{"number":true}}],ref:"maxFieldCount_rotation",class:{'is-invalid': _vm.errors.has('maxFieldCount_rotation')},attrs:{"id":"maxFieldCount_rotation","min":"1","max":"15","label":_vm._f("trans")('protocol.max_field_count'),"type":"number","name":"maxFieldCount_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.max_field_count')},domProps:{"value":(_vm.rotationMaxFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 2)},"change":function($event){_vm.changeMaxFieldCount(_vm.rotationMaxFieldCount,2)},"input":function($event){if($event.target.composing){ return; }_vm.rotationMaxFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('maxFieldCount_rotation'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('maxFieldCount_rotation')))])]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.rotationActive)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionRotation","value":_vm.transferConditionValue.first,"checked":_vm.rotationTransferCondition == _vm.transferConditionValue.first},model:{value:(_vm.rotationTransferCondition),callback:function ($$v) {_vm.rotationTransferCondition=$$v},expression:"rotationTransferCondition"}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.one_trial'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionRotation","value":_vm.transferConditionValue.second,"id":"transferCondition2","checked":_vm.rotationTransferCondition == _vm.transferConditionValue.second},model:{value:(_vm.rotationTransferCondition),callback:function ($$v) {_vm.rotationTransferCondition=$$v},expression:"rotationTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotationConditionTransfer.trialCount),expression:"rotationConditionTransfer.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],attrs:{"id":"trial_count","min":"1","type":"number","name":"trial_count_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.trial_in_row')},domProps:{"value":(_vm.rotationConditionTransfer.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rotationConditionTransfer, "trialCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.trial_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionRotation","value":_vm.transferConditionValue.third,"id":"transferCondition3","checked":_vm.rotationTransferCondition == _vm.transferConditionValue.third},model:{value:(_vm.rotationTransferCondition),callback:function ($$v) {_vm.rotationTransferCondition=$$v},expression:"rotationTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotationConditionTransfer.sessionCount),expression:"rotationConditionTransfer.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10'),expression:"'min_value:1|max_value:10'"}],ref:"task_count_rotation",attrs:{"id":"task_count_rotation","min":"1","type":"number","name":"task_count_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_in_row')},domProps:{"value":(_vm.rotationConditionTransfer.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rotationConditionTransfer, "sessionCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.task_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionRotation","value":_vm.transferConditionValue.fourth,"id":"transferCondition4","checked":_vm.rotationTransferCondition == _vm.transferConditionValue.fourth},model:{value:(_vm.rotationTransferCondition),callback:function ($$v) {_vm.rotationTransferCondition=$$v},expression:"rotationTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotationConditionTransfer.ratio),expression:"rotationConditionTransfer.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent_rotation",class:{'is-invalid': _vm.errors.has('condition_procent_rotation')},attrs:{"id":"condition_procent_rotation","min":"80","type":"number","name":"condition_procent_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.rotationConditionTransfer.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rotationConditionTransfer, "ratio", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_procent'))+"\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotationConditionTransfer.conditionSession),expression:"rotationConditionTransfer.conditionSession"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session_rotation",staticClass:"ml-2",attrs:{"id":"condition_session_rotation","min":"1","type":"number","name":"condition_session_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.rotationConditionTransfer.conditionSession)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rotationConditionTransfer, "conditionSession", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rotationConditionTransfer.conditionTrial),expression:"rotationConditionTransfer.conditionTrial"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial_rotation",staticClass:"ml-2",attrs:{"id":"condition_trial_rotation","min":"1","type":"number","name":"condition_trial_rotation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.rotationConditionTransfer.conditionTrial)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rotationConditionTransfer, "conditionTrial", $event.target.value)}}}),_vm._v("\n\n                    "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n                  ")]),_vm._v(" "),(_vm.errors.has('trial_count_rotation'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('trial_count_rotation'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('task_count_rotation') )?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_count_rotation'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_procent_rotation') )?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_rotation'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial_rotation'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial_rotation'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session_rotation'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session_rotation'))+" ")])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(_vm.rotationActive && _vm.rotationTaskType)?_c('div',{staticClass:"col-md-12"},[(_vm.rotationTaskType.id != 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('mdc-switch',{model:{value:(_vm.rotationVisible),callback:function ($$v) {_vm.rotationVisible=$$v},expression:"rotationVisible"}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.track_change_level'))+"\n                  ")])],1),_vm._v(" "),_c('hints',{attrs:{"hint-list":_vm.hintListRotation,"hintVisible":_vm.rotationVisible}})],1):_vm._e()]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.protocol.stages[_vm.currentStageIndex])?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.setup_fluency'))+": "),_c('mdc-switch',{model:{value:(_vm.fluencyActive),callback:function ($$v) {_vm.fluencyActive=$$v},expression:"fluencyActive"}}),_vm._v(" "),(_vm.fluencyActive)?_c('mdc-checkbox',{staticClass:"float-right",attrs:{"label":_vm._f("trans")('protocol.withFields')},model:{value:(_vm.fluency.withFields),callback:function ($$v) {_vm.$set(_vm.fluency, "withFields", $$v)},expression:"fluency.withFields"}}):_vm._e()],1)]),_vm._v(" "),(_vm.fluencyActive)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4  required"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.executionSecondsLimit')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:3|required|numeric'),expression:"'min_value:3|required|numeric'"},{name:"model",rawName:"v-model",value:(_vm.fluency.executionSecondsLimit),expression:"fluency.executionSecondsLimit"}],ref:"executionSecondsLimit",class:{'is-invalid': _vm.errors.has('executionSecondsLimit')},attrs:{"id":"executionSecondsLimit","min":"3","label":_vm._f("trans")('protocol.executionSecondsLimit'),"type":"number","name":"executionSecondsLimit","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.executionSecondsLimit')},domProps:{"value":(_vm.fluency.executionSecondsLimit)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluency, "executionSecondsLimit", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('executionSecondsLimit'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('executionSecondsLimit')))])]):_vm._e()]),_vm._v(" "),(_vm.fluency.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.min_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:15|numeric'),expression:"'min_value:1|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.fluencyMinFieldCount),expression:"fluencyMinFieldCount",modifiers:{"number":true}}],ref:"minFieldCount_fluency",class:{'is-invalid': _vm.errors.has('minFieldCount_fluency')},attrs:{"id":"minFieldCount_fluency","min":"1","max":"15","label":_vm._f("trans")('protocol.min_field_count'),"type":"number","name":"minFieldCount_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.min_field_count')},domProps:{"value":(_vm.fluencyMinFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 4)},"change":function($event){_vm.changeMinFieldCount(_vm.fluencyMinFieldCount,4)},"input":function($event){if($event.target.composing){ return; }_vm.fluencyMinFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('minFieldCount_fluency'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('minFieldCount_fluency')))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.fluency.withFields)?_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"mdc-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.max_field_count')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:'+_vm.fluencyMinFieldCount+'|max_value:15|numeric'),expression:"'min_value:'+fluencyMinFieldCount+'|max_value:15|numeric'"},{name:"model",rawName:"v-model.number",value:(_vm.fluencyMaxFieldCount),expression:"fluencyMaxFieldCount",modifiers:{"number":true}}],ref:"maxFieldCount_fluency",class:{'is-invalid': _vm.errors.has('maxFieldCount_fluency')},attrs:{"id":"maxFieldCount_fluency","min":"1","max":"15","label":_vm._f("trans")('protocol.max_field_count'),"type":"number","name":"maxFieldCount_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.max_field_count')},domProps:{"value":(_vm.fluencyMaxFieldCount)},on:{"keydown":function($event){_vm.changeNumberMax($event, 4)},"change":function($event){_vm.changeMaxFieldCount(_vm.fluencyMaxFieldCount,4)},"input":function($event){if($event.target.composing){ return; }_vm.fluencyMaxFieldCount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.has('maxFieldCount_fluency'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('maxFieldCount_fluency')))])]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.fluencyActive)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_tranfer'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionFluency","value":_vm.transferConditionValue.first,"checked":_vm.fluencyTransferCondition == _vm.transferConditionValue.first},model:{value:(_vm.fluencyTransferCondition),callback:function ($$v) {_vm.fluencyTransferCondition=$$v},expression:"fluencyTransferCondition"}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.one_trial'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionFluency","value":_vm.transferConditionValue.second,"id":"transferCondition2","checked":_vm.fluencyTransferCondition == _vm.transferConditionValue.second},model:{value:(_vm.fluencyTransferCondition),callback:function ($$v) {_vm.fluencyTransferCondition=$$v},expression:"fluencyTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fluencyConditionTransfer.trialCount),expression:"fluencyConditionTransfer.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],attrs:{"id":"trial_count","min":"1","type":"number","name":"trial_count_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.trial_in_row')},domProps:{"value":(_vm.fluencyConditionTransfer.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluencyConditionTransfer, "trialCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.trial_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionFluency","value":_vm.transferConditionValue.third,"id":"transferCondition3","checked":_vm.fluencyTransferCondition == _vm.transferConditionValue.third},model:{value:(_vm.fluencyTransferCondition),callback:function ($$v) {_vm.fluencyTransferCondition=$$v},expression:"fluencyTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fluencyConditionTransfer.sessionCount),expression:"fluencyConditionTransfer.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"task_count_fluency",attrs:{"id":"task_count_fluency","min":"1","type":"number","name":"task_count_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_in_row')},domProps:{"value":(_vm.fluencyConditionTransfer.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluencyConditionTransfer, "sessionCount", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.task_in_row'))+"\n                  ")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"transferConditionFluency","value":_vm.transferConditionValue.fourth,"id":"transferCondition4","checked":_vm.fluencyTransferCondition == _vm.transferConditionValue.fourth},model:{value:(_vm.fluencyTransferCondition),callback:function ($$v) {_vm.fluencyTransferCondition=$$v},expression:"fluencyTransferCondition"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fluencyConditionTransfer.ratio),expression:"fluencyConditionTransfer.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent_fluency",class:{'is-invalid': _vm.errors.has('condition_procent_fluency')},attrs:{"id":"condition_procent_fluency","min":"80","type":"number","name":"condition_procent_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.fluencyConditionTransfer.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluencyConditionTransfer, "ratio", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_procent'))+"\n\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fluencyConditionTransfer.conditionSession),expression:"fluencyConditionTransfer.conditionSession"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session_fluency",staticClass:"ml-2",attrs:{"id":"condition_session_fluency","min":"1","type":"number","name":"condition_session_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.fluencyConditionTransfer.conditionSession)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluencyConditionTransfer, "conditionSession", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fluencyConditionTransfer.conditionTrial),expression:"fluencyConditionTransfer.conditionTrial"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial_fluency",staticClass:"ml-2",attrs:{"id":"condition_trial_fluency","min":"1","type":"number","name":"condition_trial_fluency","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.fluencyConditionTransfer.conditionTrial)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fluencyConditionTransfer, "conditionTrial", $event.target.value)}}}),_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n                  ")]),_vm._v(" "),(_vm.errors.has('trial_count_fluency'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('trial_count_fluency'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('task_count_fluency') )?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_count_fluency'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_procent_fluency') )?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_fluency'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial_fluency'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial_fluency'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session_fluency'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session_fluency'))+" ")])]):_vm._e()],1)])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.protocol.stages[_vm.currentStageIndex])?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.setup_support'))+" : "),_c('mdc-switch',{model:{value:(_vm.intervalsActive),callback:function ($$v) {_vm.intervalsActive=$$v},expression:"intervalsActive"}})],1),_vm._v(" "),_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_intervals')))]),_vm._v(" "),(_vm.protocol.assigneeId)?_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.support_subtitle')))]):_vm._e(),_vm._v(" "),(_vm.intervalError)?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_error')))])]):_vm._e(),_vm._v(" "),(_vm.intervalsActive)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_name')))]),_vm._v(" "),_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_count')))]),_vm._v(" "),_c('th',{staticClass:"table-actions"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.intervals),function(interval){return _c('tr',{key:interval.index},[_c('td',[_vm._v("\n                    "+_vm._s(interval.name)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"table-count"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(interval.count),expression:"interval.count"},{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],attrs:{"type":"number","min":"1","name":"interval_count","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.interval_count')},domProps:{"value":(interval.count)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(interval, "count", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(interval.checked),callback:function ($$v) {_vm.$set(interval, "checked", $$v)},expression:"interval.checked"}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.errors.has('interval_count'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('interval_count')))])]):_vm._e()])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])]),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('task-d-t-t-modal',{attrs:{"visible":_vm.isModalVisible,"stimul":_vm.stimul,"intervals":_vm.intervals,"data":_vm.currentStage.phases},on:{"close":_vm.onModalClose,"save":_vm.onModalSave}})],1):_vm._e(),_vm._v(" "),(_vm.isModalChangePhaseVisible)?_c('div',[_c('task-dtt-phase-modal',{attrs:{"visible":_vm.isModalChangePhaseVisible,"stimulList":_vm.stimulListToChange,"intervals":_vm.intervals,"data":_vm.currentStage.phases},on:{"close":_vm.onModalClose,"save":_vm.onModalSaveChanges}})],1):_vm._e(),_vm._v(" "),(_vm.modalView)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.OffPhaseModalTitle', {phaseName: _vm.phaseName}),"accept":_vm._f("trans")('protocol.offButton'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.onModalSavePhase,"cancel":_vm.onModalClosePhase},model:{value:(_vm.modalView),callback:function ($$v) {_vm.modalView=$$v},expression:"modalView"}})],1):_vm._e(),_vm._v(" "),(_vm.modalViewField)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.moveFieldTitle', {min: _vm.minValue, max: _vm.maxValue}),"accept":_vm._f("trans")('behavior.buttons.apply'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.onModalSaveField,"cancel":_vm.onModalCloseField},model:{value:(_vm.modalViewField),callback:function ($$v) {_vm.modalViewField=$$v},expression:"modalViewField"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksMand_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb158c34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksMand_vue__ = __webpack_require__(1207);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksMand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb158c34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksMand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideMands(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm.currentStage.title)+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle mb-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_stimul_position')))])]),_vm._v(" "),(_vm.mands)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"mands"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.name_mand_reaction')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_stage')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_mand')))]):_vm._e(),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.recommendation')))]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.mands,"ghost-class":"ghost","tag":"tbody","handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.mands),function(mand){return _c('tr',{key:mand.globalUuid},[_c('td',{staticClass:"name-field"},[_vm._v("\n                  "+_vm._s(mand.description)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{model:{value:(mand.active),callback:function ($$v) {_vm.$set(mand, "active", $$v)},expression:"mand.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.masteredMand(mand)}},model:{value:(mand.mastered),callback:function ($$v) {_vm.$set(mand, "mastered", $$v)},expression:"mand.mastered"}})],1):_vm._e(),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions text-center"},[(mand.canBeMarkedAsMastered)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('report.mastered')))]):_vm._e(),_vm._v(" "),(!mand.canBeMarkedAsMastered)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.no')))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(mand.active)?_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")]):_vm._e()])])}))],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],class:{'is-invalid': _vm.errors.has('addMandReactionItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addMandReaction'),"name":"addMandReactionItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addMandReaction')},model:{value:(_vm.addMandReactionItem),callback:function ($$v) {_vm.addMandReactionItem=$$v},expression:"addMandReactionItem"}}),_vm._v(" "),(_vm.errors.has('addMandReactionItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addMandReactionItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addMand(_vm.addMandReactionItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"half_box-block mb-4"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('protocol.tracked_reactions')))]),_vm._v(" "),(_vm.errorRecordedReactionsList)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.tracked_reactions'))+" обязательны")]):_vm._e(),_vm._v(" "),_vm._l((_vm.recordedReactionsList),function(type){return _c('div',{staticClass:"mb-2"},[_c('mdc-checkbox',{attrs:{"label":_vm.labelMand(type.placeholder, type.description )},on:{"change":_vm.changeRecordedReactions},model:{value:(type.checked),callback:function ($$v) {_vm.$set(type, "checked", $$v)},expression:"type.checked"}})],1)}),_vm._v(" "),_c('div',{staticClass:"choose-input-block"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('report.condition_mastered')))]),_vm._v(" "),(_vm.masteringConditionAnswer)?_c('div',{staticClass:"select-wrapp"},[_c('v-select',{attrs:{"name":"teachingMethod","options":_vm.masteringCondition,"filterable":false,"label":"id"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n                         "+_vm._s(option.title)+"\n                       ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n                         "+_vm._s(option.title)+"\n                       ")]}}]),model:{value:(_vm.masteringConditionAnswer),callback:function ($$v) {_vm.masteringConditionAnswer=$$v},expression:"masteringConditionAnswer"}})],1):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.ratio),expression:"currentStage.masteringCondition.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent",class:{'is-invalid': _vm.errors.has('condition_procent')},attrs:{"id":"condition_procent","min":"80","type":"number","name":"condition_procent","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.currentStage.masteringCondition.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "ratio", $event.target.value)}}}),_vm._v("\n                   % "+_vm._s(_vm._f("trans")('protocol.condition_mastered'))+"\n\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.sessionCount),expression:"currentStage.masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_session')},attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.currentStage.masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.trialCount),expression:"currentStage.masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_trial')},attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.currentStage.masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n                 ")]),_vm._v(" "),(_vm.errors.has('condition_procent'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+"  ")])]):_vm._e()],2)]),_vm._v(" "),(_vm.isPromptEnableList)?_c('div',{staticClass:"col-md-5"},[_c('mdc-switch',{model:{value:(_vm.currentStage.isPromptEnabled),callback:function ($$v) {_vm.$set(_vm.currentStage, "isPromptEnabled", $$v)},expression:"currentStage.isPromptEnabled"}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.track_change_level'))+"\n              ")]),_vm._v(" "),_c('hints',{attrs:{"hint-list":_vm.currentStage.taskPrompts,"hintVisible":_vm.currentStage.isPromptEnabled}})],1):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.hideMands(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksUSD_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b17fe1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksUSD_vue__ = __webpack_require__(1213);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksUSD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b17fe1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksUSD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHintModal_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f962f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddHintModal_vue__ = __webpack_require__(1210);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddHintModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f962f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddHintModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"fullscreen-modal",class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('protocol.add_to_set'),"accept":_vm._f("trans")('behavior.buttons.create'),"cancel":_vm._f("trans")('behavior.buttons.cancel')},on:{"cancel":_vm.cancel,"validate":function($event){_vm.validate()},"close":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(_vm.isMobile)?_c('div',[_c('div',{staticClass:"close-cross",on:{"click":_vm.close}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('header',{staticClass:"mdc-dialog__header  mdc-dialog__header--visible"},[_c('h2',{staticClass:"mdc-dialog__header__title"},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.add_to_set')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.stimulusList.length)?_c('div',{staticClass:"col-md-12"},[(_vm.errorsStimulLenght)?_c('div',{staticClass:"alert-danger text-center mb-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.errorResult')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.stimulusList),function(stimul,index){return _c('div',{key:index,staticClass:"radio-btn selectable",class:{'active' : stimul.selected},on:{"click":function($event){_vm.setActiveStimul(stimul)}}},[_vm._v("\n                "+_vm._s(stimul.description)+"\n            ")])})],2):_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.no_available_set_create')))])])]),_vm._v(" "),(_vm.isMobile)?_c('footer',{staticClass:"col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"},[_c('button',{staticClass:"col-12 mdc-button mdc-button--raised button-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.validate()}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('behavior.buttons.create')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskUSDModal_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7936262e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskUSDModal_vue__ = __webpack_require__(1212);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskUSDModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7936262e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskUSDModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"auto_height_modal",attrs:{"title":_vm._f("trans")('protocol.setup_stimuli', {title: _vm.stimul.description}),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.save,"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('phaseTask'), 'is-clear': !_vm.phaseTask},attrs:{"options":_vm.phases,"name":"phases","label":"title","filterable":false,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_phase')},model:{value:(_vm.phaseTask),callback:function ($$v) {_vm.phaseTask=$$v},expression:"phaseTask"}}),_vm._v(" "),(_vm.currentPhase)?_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm.currentPhase))]):_vm._e()],1)]),_vm._v(" "),(_vm.intervalList && _vm.phaseTask)?_c('div',{staticClass:"form-group row"},[(_vm.phaseTask.typeId == 3)?_c('div',{staticClass:"col-12"},[_c('mdc-select',{class:{'is-invalid': _vm.errors.has('interval'), 'is-full': _vm.interval},attrs:{"label":_vm._f("trans")('protocol.choose_interval'),"name":"interval","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.choose_interval')},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}},_vm._l((_vm.intervalList),function(item){return _c('option',{domProps:{"value":item.typeId}},[_vm._v("\n             "+_vm._s(item.name)+"\n          ")])}))],1):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm.currentStage.title)+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimuluses')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle mb-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_stimul_position')))])]),_vm._v(" "),(_vm.tasks)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('table',{staticClass:"table table-sm"},[_c('draggable',{attrs:{"list":_vm.tasks,"ghost-class":"ghost","tag":"tbody","handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.tasks),function(task){return _c('tr',{key:task.id,class:{'table-secondary': task.levelUuid}},[_c('td',{staticClass:"name-field"},[_vm._v("\n                    "+_vm._s(task.description)+"\n                  ")]),_vm._v(" "),_c('td',[(task.phaseTypeId === 5)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_mastering')))]):_vm._e(),_vm._v(" "),(task.phaseTypeId === 3)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.phase_support')))]):_vm._e(),_vm._v(" "),(task.phaseTypeId == 3 && _vm.currentIntervalType(task.intervalTypeId))?_c('span',[_vm._v(" / "+_vm._s(_vm.currentIntervalType(task.intervalTypeId))+" ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActive(task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),(task.active)?_c('td',{staticClass:"text-right action-cell"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-rounded",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.onEditBtnClick(task)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(task.active)?_c('td',{staticClass:"text-right action-cell"},[_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")])]):_vm._e()])}))],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],class:{'is-invalid': _vm.errors.has('addStimulusItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addStimulus'),"name":"addStimulusItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addStimulus')},model:{value:(_vm.addStimulusItem),callback:function ($$v) {_vm.addStimulusItem=$$v},expression:"addStimulusItem"}}),_vm._v(" "),(_vm.errors.has('addStimulusItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addStimulusItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addTask(_vm.addStimulusItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]),_vm._v(" "),(_vm.mastering)?_c('div',{staticClass:"row form-group"},[_vm._l((_vm.mastering.levels),function(level,index){return _c('div',{staticClass:"col-md-12 mt-3"},[_c('div',{staticClass:"alert alert-secondary"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],ref:'level_' + index,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('level_' + index)},attrs:{"type":"text","name":'level_' + index,"label":_vm.levelTitle(index),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeMandReaction', {number: index + 1})},model:{value:(level.description),callback:function ($$v) {_vm.$set(level, "description", $$v)},expression:"level.description"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right"},[(index > 2)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeLevel(index)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.buttons.delete'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-rounded copy-btn ml-1",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.addGroup(index)}}})]),_vm._v(" "),_vm._l((level.groups),function(group,groupIndex){return _c('div',{staticClass:"col-md-4 mt-2"},[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item list-group-item-light"},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.set'))+"  "+_vm._s(groupIndex + 1)+"\n                      "),_c('button',{staticClass:"btn btn-primary btn-sm btn-rounded float-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.protocol.assigneeId ? _vm.acceptDeleteSet(index, groupIndex) : _vm.deleteGroup(index, groupIndex)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("close")])]),_vm._v(" "),(group.sessions)?_c('div',{staticClass:"float-right text-block__slash mr-2"},_vm._l((group.sessions.slice().reverse()),function(session){return _c('span',[_vm._v(_vm._s(session.masteringRatio)+"%")])})):_vm._e()]),_vm._v(" "),_vm._l((group.stimuli),function(stimul){return _c('li',{staticClass:"list-group-item"},[_vm._v("\n                      "+_vm._s(_vm.stimulDescrition(stimul.globalUuid))+"\n                    ")])})],2)])})],2)])])}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addLevel(_vm.hintLevel)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.add_level'))+"\n          ")])])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 mt-4"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.dtt_phase_title'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.currentStage)?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.setup_mastering'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 required"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"taskType",class:{'is-clear': !_vm.mastering.taskType, 'is-invalid': _vm.errors.has('taskTypes')},attrs:{"name":"taskType","id":"taskType","options":_vm.taskTypesList,"label":"title","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_type')},model:{value:(_vm.mastering.taskType),callback:function ($$v) {_vm.$set(_vm.mastering, "taskType", $$v)},expression:"mastering.taskType"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                      "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                    ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'is-invalid': _vm.errors.has('taskType')}},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "),_c('sup',[_c('mdc-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.msg),expression:"msg",modifiers:{"top-center":true}}],staticClass:"help_icon",attrs:{"icon":"help"}})],1)]),_vm._v(" "),(_vm.errors.has('taskType'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('taskType')))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_next'))+":")]),_vm._v(" "),_c('div',{staticClass:"mdc-wrapper",class:{'is-invalid': _vm.errors.has('condition_procent_nextLevel')}},[_vm._v("\n                  ≥ "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mastering.masteringConditions.nextLevel.ratio),expression:"mastering.masteringConditions.nextLevel.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:89|max_value:100|numeric'),expression:"'min_value:89|max_value:100|numeric'"}],ref:"condition_procent_nextLevel",class:{'is-invalid': _vm.errors.has('condition_procent_nextLevel')},attrs:{"id":"condition_procent_nextLevel","min":"89","max":"100","type":"number","name":"condition_procent_nextLevel","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.mastering.masteringConditions.nextLevel.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mastering.masteringConditions.nextLevel, "ratio", $event.target.value)}}}),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.percent_block'))+"\n                  "),_c('div',{staticClass:"mdc-select-wrapper"},[_c('v-select',{ref:"condition_session_nextLevel",attrs:{"name":"condition_session","id":"condition_session","options":_vm.condition_list,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},model:{value:(_vm.mastering.masteringConditions.nextLevel.blockCount),callback:function ($$v) {_vm.$set(_vm.mastering.masteringConditions.nextLevel, "blockCount", $$v)},expression:"mastering.masteringConditions.nextLevel.blockCount"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                          "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                        ")])])],2)],1),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.blocks'))+"\n                ")]),_vm._v(" "),(_vm.errors.has('condition_procent_nextLevel'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_nextLevel')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_return'))+":")]),_vm._v(" "),_c('div',{staticClass:"mdc-wrapper",class:{'is-invalid': _vm.errors.has('condition_procent_prevLevel')}},[_vm._v("\n                  < "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mastering.masteringConditions.previousLevel.ratio),expression:"mastering.masteringConditions.previousLevel.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:0|max_value:' + _vm.mastering.masteringConditions.nextLevel.ratio  + '|numeric'),expression:"'min_value:0|max_value:' + mastering.masteringConditions.nextLevel.ratio  + '|numeric'"}],ref:"condition_procent_prevLevel",class:{'is-invalid': _vm.errors.has('condition_procent_prevLevel')},attrs:{"id":"condition_procent_prevLevel","min":"0","max":"100","type":"number","name":"condition_procent_prevLevel","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.mastering.masteringConditions.previousLevel.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mastering.masteringConditions.previousLevel, "ratio", $event.target.value)}}}),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.percent_block'))+"\n                  "),_c('div',{staticClass:"mdc-select-wrapper"},[_c('v-select',{ref:"condition_session_prevLevel",attrs:{"name":"condition_session","id":"condition_session_prevLevel","options":_vm.condition_list,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},model:{value:(_vm.mastering.masteringConditions.previousLevel.blockCount),callback:function ($$v) {_vm.$set(_vm.mastering.masteringConditions.previousLevel, "blockCount", $$v)},expression:"mastering.masteringConditions.previousLevel.blockCount"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                          "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                        ")])])],2)],1),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.blocks'))+"\n                ")]),_vm._v(" "),(_vm.errors.has('condition_procent_prevLevel'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_prevLevel')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 choose-block mt-4"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_mastered_usd'))+":")]),_vm._v(" "),_c('div',{staticClass:"mdc-wrapper",class:{'is-invalid': _vm.errors.has('condition_procent_nextPhase')}},[_vm._v("\n                  ≥ "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mastering.masteringConditions.nextPhase.ratio),expression:"mastering.masteringConditions.nextPhase.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:89|max_value:100|numeric'),expression:"'min_value:89|max_value:100|numeric'"}],ref:"condition_procent_nextPhase",class:{'is-invalid': _vm.errors.has('condition_procent_nextPhase')},attrs:{"id":"condition_procent_nextPhase","min":"89","max":"100","type":"number","name":"condition_procent_nextPhase","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.mastering.masteringConditions.nextPhase.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mastering.masteringConditions.nextPhase, "ratio", $event.target.value)}}}),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.percent_next_block'))+"\n                  "),_c('div',{staticClass:"mdc-select-wrapper"},[_c('v-select',{ref:"condition_session_nextPhase",attrs:{"name":"condition_session","id":"condition_session_nextPhase","options":_vm.condition_list,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},model:{value:(_vm.mastering.masteringConditions.nextPhase.blockCount),callback:function ($$v) {_vm.$set(_vm.mastering.masteringConditions.nextPhase, "blockCount", $$v)},expression:"mastering.masteringConditions.nextPhase.blockCount"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                          "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                        ")])])],2)],1),_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.blocks'))+"\n                ")]),_vm._v(" "),(_vm.errors.has('condition_procent_nextPhase'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_nextPhase')))])]):_vm._e()])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3"},[(_vm.currentStage)?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.setup_support'))+":\n            ")]),_vm._v(" "),_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stimulus_intervals')))]),_vm._v(" "),(_vm.intervalError)?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_error')))])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_name')))]),_vm._v(" "),_c('th',{staticClass:"table-count"},[_vm._v(_vm._s(_vm._f("trans")('protocol.interval_count')))]),_vm._v(" "),_c('th',{staticClass:"table-actions"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.intervals),function(interval){return _c('tr',{key:interval.index},[_c('td',[_vm._v("\n                    "+_vm._s(interval.name)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"table-count"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|numeric'),expression:"'min_value:1|numeric'"}],attrs:{"type":"number","min":"1","name":"interval_count","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.interval_count')},on:{"keydown":_vm.changeNumber},model:{value:(interval.count),callback:function ($$v) {_vm.$set(interval, "count", $$v)},expression:"interval.count"}})],1),_vm._v(" "),_c('td',[_c('mdc-checkbox',{model:{value:(interval.checked),callback:function ($$v) {_vm.$set(interval, "checked", $$v)},expression:"interval.checked"}})],1)])}))]),_vm._v(" "),(_vm.errors.has('interval_count'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('interval_count')))])]):_vm._e()])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n      ")])])]),_vm._v(" "),(_vm.isModalHintVisible)?_c('add-hint-modal',{attrs:{"visible":_vm.isModalHintVisible,"stimulList":_vm.activeStimulList},on:{"close":_vm.onModalClose,"cancel":_vm.onModalCancel}}):_vm._e(),_vm._v(" "),(_vm.isModalVisible)?_c('task-usd-modal',{attrs:{"visible":_vm.isModalVisible,"stimul":_vm.stimul,"intervals":_vm.intervals,"data":_vm.currentStage.phases},on:{"close":_vm.onModalUSDClose,"save":_vm.onModalSave}}):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.deletedSetItem,"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.changeStimul,"cancel":_vm.closeStimul},model:{value:(_vm.isModalAcceptPopup),callback:function ($$v) {_vm.isModalAcceptPopup=$$v},expression:"isModalAcceptPopup"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm.deletedSetItem,"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.disableStimul,"cancel":_vm.closeDisableStimul},model:{value:(_vm.isModalDisablePopup),callback:function ($$v) {_vm.isModalDisablePopup=$$v},expression:"isModalDisablePopup"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.delete_set'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.closeAcceptDeleteSetPopup,"cancel":_vm.cancelAcceptDeleteSetPopup},model:{value:(_vm.acceptDeleteSetPopup),callback:function ($$v) {_vm.acceptDeleteSetPopup=$$v},expression:"acceptDeleteSetPopup"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksChain_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5a27c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksChain_vue__ = __webpack_require__(1215);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksChain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5a27c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksChain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.environment'))+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.steps')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle mb-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_step_position')))])]),_vm._v(" "),(_vm.tasks)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.name_step')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_environment')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_mand')))]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.tasks,"ghost-class":"ghost","tag":"tbody","handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.tasks),function(task){return _c('tr',{key:task.globalUuid},[_c('td',{staticClass:"name-field"},[_vm._v("\n                  "+_vm._s(task.description)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.masteredTask(task)}},model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(task.active)?_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")]):_vm._e()])])}))],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[(_vm.currentStage && _vm.currentStage.masteringCondition)?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"half_box-block mb-4"},[_c('div',{staticClass:"choose-input-block"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('report.condition_mastered_step')))]),_vm._v("\n\n                   100% "+_vm._s(_vm._f("trans")('protocol.condition_mastered'))+"\n\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.sessionCount),expression:"currentStage.masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_session')},attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.currentStage.masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.trialCount),expression:"currentStage.masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_trial')},attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.currentStage.masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n                 ")]),_vm._v(" "),(_vm.errors.has('condition_procent'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+"  ")])]):_vm._e()])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksShaping_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b29c86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksShaping_vue__ = __webpack_require__(1217);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksShaping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b29c86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksShaping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.environment'))+": "+_vm._s(_vm.currentStage.description))])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.criterion')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle mb-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_criterion_position')))])]),_vm._v(" "),(_vm.tasks)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('table',{staticClass:"table table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.name_criterion')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_environment')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.current_criterion')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_mand')))]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.tasks,"ghost-class":"ghost","tag":"tbody","move":_vm.onMoveTasks,"handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.tasks),function(task){return _c('tr',{key:task.globalUuid},[_c('td',{staticClass:"name-field"},[_vm._v("\n                  "+_vm._s(task.description)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{attrs:{"disabled":_vm.currentStage.targetStimulus.globalUuid === task.globalUuid},on:{"change":function($event){_vm.changeVisibleTask(task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-radio',{attrs:{"name":"target_stimul","checked":_vm.currentStage.targetStimulus.globalUuid == task.globalUuid,"value":task.globalUuid,"disabled":!task.active},on:{"change":function($event){_vm.targetTask(task)}},model:{value:(_vm.currentStage.targetStimulus.globalUuid),callback:function ($$v) {_vm.$set(_vm.currentStage.targetStimulus, "globalUuid", $$v)},expression:"currentStage.targetStimulus.globalUuid"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{attrs:{"disabled":""},model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-right action-cell"},[(task.active && !task.mastered && _vm.currentStage.targetStimulus.globalUuid !== task.globalUuid)?_c('span',{staticClass:"drag-btn align-top"},[_vm._v("draggable")]):_vm._e()])])}))],1),_vm._v(" "),(_vm.errorStimuli || _vm.errorTarget)?_c('div',[_c('strong',{staticClass:"invalid-feedback invalid"},[_vm._v("Должен быть выбран хотя бы 1 критерий ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],class:{'is-invalid': _vm.errors.has('addTaskReactionItem')},attrs:{"type":"text","label":_vm._f("trans")('protocol.buttons.addСriterion'),"name":"addTaskReactionItem","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.buttons.addСriterion')},model:{value:(_vm.addTaskReactionItem),callback:function ($$v) {_vm.addTaskReactionItem=$$v},expression:"addTaskReactionItem"}}),_vm._v(" "),(_vm.errors.has('addTaskReactionItem'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('addTaskReactionItem')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1"},[_c('button',{staticClass:"btn btn-sm btn-rounded btn-add-grey",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addTask(_vm.addTaskReactionItem)}}},[_c('i',{staticClass:"material-icons button-primary btn-fixed"},[_vm._v("add")])])])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_criteretion')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 mb-3 required"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"taskType",class:{'is-clear': !_vm.taskType, 'is-invalid': _vm.errors.has('taskTypes')},attrs:{"name":"taskType","id":"taskType","options":_vm.taskTypesList,"label":"title","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.task_type')},model:{value:(_vm.taskType),callback:function ($$v) {_vm.taskType=$$v},expression:"taskType"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.no_data'))+"\n                  ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'is-invalid': _vm.errors.has('taskType')}},[_vm._v(_vm._s(_vm._f("trans")('protocol.task_type'))+" "),_c('sup',[_c('mdc-icon',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.msg),expression:"msg",modifiers:{"top-center":true}}],staticClass:"help_icon",attrs:{"icon":"help"}})],1)]),_vm._v(" "),(_vm.errors.has('taskType'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('taskType')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"half_box-block mb-4"},[_c('div',{staticClass:"choose-input-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.ratio),expression:"currentStage.masteringCondition.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:50|max_value:100|numeric'),expression:"'min_value:50|max_value:100|numeric'"}],ref:"condition_procent",class:{'is-invalid': _vm.errors.has('condition_procent')},attrs:{"id":"condition_procent","min":"50","max":"100","type":"number","name":"condition_procent","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.percent_reaction')},domProps:{"value":(_vm.currentStage.masteringCondition.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "ratio", $event.target.value)}}}),_vm._v("\n                   % "+_vm._s(_vm._f("trans")('protocol.percent_reaction'))+"\n\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.sessionCount),expression:"currentStage.masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_session')},attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.day_session')},domProps:{"value":(_vm.currentStage.masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.day_session'))+"\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStage.masteringCondition.trialCount),expression:"currentStage.masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_trial')},attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.first_probe')},domProps:{"value":(_vm.currentStage.masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentStage.masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n                   "+_vm._s(_vm._f("trans")('protocol.first_probe'))+"\n                 ")]),_vm._v(" "),(_vm.errors.has('condition_procent'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+"  ")])]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.hideTasks(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.change_criteria_title'),"accept":_vm._f("trans")('protocol.buttons.yes'),"cancel":_vm._f("trans")('protocol.buttons.no')},on:{"accept":_vm.onAcceptChangeStimulus,"cancel":_vm.onCancelChangeStimulus},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmChangeModal_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34c3c644_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmChangeModal_vue__ = __webpack_require__(1219);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmChangeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34c3c644_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmChangeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_change'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.accept,"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeFixingModal_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f63d65_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeFixingModal_vue__ = __webpack_require__(1221);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeFixingModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24f63d65_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeFixingModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"short-modal",attrs:{"title":_vm._f("trans")('protocol.change_popup_title'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"validate":_vm.validate,"accept":_vm.accept,"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('mdc-radio',{attrs:{"name":"fixingChange","disabled":_vm.disabledNotImportantChanges,"label":_vm._f("trans")('protocol.inessential'),"value":"1"},model:{value:(_vm.fixingChange),callback:function ($$v) {_vm.fixingChange=$$v},expression:"fixingChange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('mdc-radio',{attrs:{"name":"fixingChange","disabled":_vm.disabledNotImportantChanges,"label":_vm._f("trans")('protocol.minor'),"value":"2"},model:{value:(_vm.fixingChange),callback:function ($$v) {_vm.fixingChange=$$v},expression:"fixingChange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('mdc-radio',{attrs:{"name":"fixingChange","label":_vm._f("trans")('protocol.important'),"value":"3"},model:{value:(_vm.fixingChange),callback:function ($$v) {_vm.fixingChange=$$v},expression:"fixingChange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.changes_date_text')))]),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.entered_session_date'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"rangeDateStart","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.entered_session_date'),"formats":_vm.formats,"pickTime":true,"format":'YYYY-MM-DD HH:mm',"min-date":_vm.minDateStart,"max-date":_vm.maxDateStart,"title-position":"left"},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}}),_vm._v(" "),(_vm.errors.has('rangeDateStart'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('rangeDateStart')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-12 time-picker-wrapp"},[_c('vue-timepicker',{attrs:{"format":"HH:mm","hour-range":[_vm.hourRange],"minute-range":[_vm.minuteRange],"hide-clear-button":""},model:{value:(_vm.rangeTimeStart),callback:function ($$v) {_vm.rangeTimeStart=$$v},expression:"rangeTimeStart"}}),_vm._v(" "),(_vm.errorTime)?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('protocol.entered_session_date')))])]):_vm._e()],1)]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:500'),expression:"'required|max:500'"}],class:{'is-invalid': _vm.errors.has('comment')},attrs:{"name":"comment","max":"500","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('bids.comment'),"multiline":"","rows":"4","cols":"40","disabled":_vm.fixingChange == 1,"type":"text"},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),(_vm.errors.has('comment'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('comment')))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1222 */,
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocollnfo_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adcde98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocollnfo_vue__ = __webpack_require__(1224);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocollnfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adcde98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocollnfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(('teachingMethodDescription' in _vm.protocol)),expression:"('teachingMethodDescription' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-8"},[_c('autocomplete-search',{ref:"teachingMethodDescription",attrs:{"id":"teachingMethodDescription","visible":_vm.visible,"suggestions":_vm.autocomplete,"field":'title',"label":_vm._f("trans")('protocol.teachingMethod'),"validateRule":'max:1000',"validateLable":_vm._f("trans")('protocol.teachingMethod')},on:{"input":_vm.setTeachingMethodNewValue,"inputChange":_vm.onChangeTeachingMethodNew,"save":_vm.setTeachingMethodNewValidated,"validate":_vm.validatedTeachingMethodNew},model:{value:(_vm.protocol.teachingMethodDescription),callback:function ($$v) {_vm.$set(_vm.protocol, "teachingMethodDescription", $$v)},expression:"protocol.teachingMethodDescription"}}),_vm._v(" "),(_vm.errors.has('teachingMethodDescription'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('teachingMethodDescription')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('title' in _vm.protocol)),expression:"('title' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],ref:"title",staticClass:"required",class:{'is-invalid': _vm.errors.has('title')},attrs:{"id":"title","label":_vm._f("trans")('protocol.title'),"type":"text","name":"title","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.title')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.title),callback:function ($$v) {_vm.$set(_vm.protocol, "title", $$v)},expression:"protocol.title"}}),_vm._v(" "),(_vm.errors.has('title'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('title')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('skillField' in this.protocol)),expression:"('skillField' in this.protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-8 required"},[_c('autocomplete-search',{ref:"searchSkillField",attrs:{"id":"searchSkillField","visible":_vm.visible,"suggestions":_vm.autocomplete,"field":'name',"label":_vm._f("trans")('protocol.area'),"validateRule":'required|max:1000',"validateLable":_vm._f("trans")('protocol.area')},on:{"focus":function($event){_vm.setIsChanged(false)},"input":_vm.setSkillFieldValue,"inputChange":_vm.onChangeSkillField,"save":_vm.setSkillFieldValidated,"validate":_vm.validatedSkillField},model:{value:(_vm.protocol.skillField),callback:function ($$v) {_vm.$set(_vm.protocol, "skillField", $$v)},expression:"protocol.skillField"}}),_vm._v(" "),(_vm.errors.has('searchSkillField'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('searchSkillField')))])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('code1' in _vm.protocol.dataFields)),expression:"('code1' in protocol.dataFields)"}],staticClass:"col-md-2"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:5'),expression:"'max:5'"}],ref:"code1",class:{'is-invalid': _vm.errors.has('code1')},attrs:{"id":"code1","label":_vm._f("trans")('protocol.code1'),"type":"text","name":"code1","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.code1')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.code1),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "code1", $$v)},expression:"protocol.dataFields.code1"}}),_vm._v(" "),(_vm.errors.has('code1'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('code1')))])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('code2' in _vm.protocol.dataFields)),expression:"('code2' in protocol.dataFields)"}],staticClass:"col-md-2"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:5'),expression:"'max:5'"}],ref:"code2",class:{'is-invalid': _vm.errors.has('code2')},attrs:{"id":"code2","label":_vm._f("trans")('protocol.code2'),"type":"text","name":"code2","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.code2')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.code2),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "code2", $$v)},expression:"protocol.dataFields.code2"}}),_vm._v(" "),(_vm.errors.has('code2'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('code2')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('goal' in _vm.protocol)),expression:"('goal' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:3000'),expression:"'required|max:3000'"}],ref:"goal",staticClass:"required",class:{'is-invalid': _vm.errors.has('goal')},attrs:{"id":"goal","label":_vm._f("trans")('protocol.goal'),"type":"text","multiline":"","rows":"3","name":"goal","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.goal')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.goal),callback:function ($$v) {_vm.$set(_vm.protocol, "goal", $$v)},expression:"protocol.goal"}}),_vm._v(" "),(_vm.errors.has('goal'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('goal')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.protocol.assigneeId && _vm.isMand),expression:"protocol.assigneeId && isMand"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"ml12"},[_c('mdc-checkbox',{attrs:{"label":_vm._f("trans")('protocol.shortcut_enabled')},model:{value:(_vm.protocol.isShortcutEnabled),callback:function ($$v) {_vm.$set(_vm.protocol, "isShortcutEnabled", $$v)},expression:"protocol.isShortcutEnabled"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:16'),expression:"'required|max:16'"}],ref:"shortcutMenuTitle",staticClass:"required",class:{'is-invalid': _vm.errors.has('shortcutMenuTitle')},attrs:{"id":"shortcutMenuTitle","label":_vm._f("trans")('protocol.shortcut_menu_title'),"type":"text","name":"shortcutMenuTitle","disabled":!_vm.protocol.isShortcutEnabled,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.shortcut_menu_title')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.shortcutMenuTitle),callback:function ($$v) {_vm.$set(_vm.protocol, "shortcutMenuTitle", $$v)},expression:"protocol.shortcutMenuTitle"}}),_vm._v(" "),(_vm.errors.has('shortcutMenuTitle'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('shortcutMenuTitle')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('teachingFormat' in _vm.protocol)),expression:"('teachingFormat' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchTeachingFormat",class:{'is-invalid': _vm.errors.has('teachingFormat')},attrs:{"type":"text","name":"teachingFormat","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.teachingFormat'),"data-vv-as":_vm._f("trans")('protocol.teachingFormat')},model:{value:(_vm.protocol.teachingFormat),callback:function ($$v) {_vm.$set(_vm.protocol, "teachingFormat", $$v)},expression:"protocol.teachingFormat"}}),_vm._v(" "),(_vm.errors.has('teachingFormat'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('teachingFormat')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('baseLevel' in _vm.protocol.dataFields) && _vm.selectedTeachingMethodID !== 7 && _vm.selectedTeachingMethodID !== 8),expression:"('baseLevel' in protocol.dataFields) && selectedTeachingMethodID !== 7 && selectedTeachingMethodID !== 8"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{ref:"baseLevel",staticClass:"mdc-textfield-wrapper",attrs:{"id":"baseLevel","aria-required":"false","aria-invalid":"false"}},[_c('div',{staticClass:"mdc-textfield mdc-text-field mdc-text-field--upgraded mdc-text-field--textarea",class:{'is-invalid': _vm.errors.has('baseLevel')}},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('max:500'),expression:"'max:500'"},{name:"model",rawName:"v-model",value:(_vm.protocol.dataFields.baseLevel),expression:"protocol.dataFields.baseLevel"}],staticClass:"mdc-text-field__input",attrs:{"rows":"2","cols":"40","name":"baseLevel","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.baseLevel')},domProps:{"value":(_vm.protocol.dataFields.baseLevel)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.dataFields, "baseLevel", $event.target.value)},function($event){_vm.setIsChanged(true)}]}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label mdc-floating-label--float-above",attrs:{"for":"baseLevel"}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.base_level'))+" ")])]),_vm._v(" "),(_vm.errors.has('baseLevel'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('baseLevel')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('instruction' in _vm.protocol.dataFields) && _vm.selectedTeachingMethodID !== 7 && _vm.selectedTeachingMethodID !== 8),expression:"('instruction' in protocol.dataFields) && selectedTeachingMethodID !== 7 && selectedTeachingMethodID !== 8"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"instruction",class:{'is-invalid': _vm.errors.has('instruction')},attrs:{"id":"instruction","label":_vm._f("trans")('protocol.instruction'),"type":"text","multiline":"","rows":"2","name":"instruction","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.instruction')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.instruction),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "instruction", $$v)},expression:"protocol.dataFields.instruction"}}),_vm._v(" "),(_vm.errors.has('instruction'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('instruction')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('rightReaction' in _vm.protocol.dataFields)),expression:"('rightReaction' in protocol.dataFields)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"rightReaction",class:{'is-invalid': _vm.errors.has('rightReaction')},attrs:{"id":"rightReaction","label":_vm._f("trans")('protocol.trueReaction'),"type":"text","multiline":"","rows":"2","name":"rightReaction","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.rightReaction')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.rightReaction),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "rightReaction", $$v)},expression:"protocol.dataFields.rightReaction"}}),_vm._v(" "),(_vm.errors.has('rightReaction'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('rightReaction')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('materials' in _vm.protocol)),expression:"('materials' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchMaterials",class:{'is-invalid': _vm.errors.has('materials')},attrs:{"type":"text","name":"materials","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.materials'),"data-vv-as":_vm._f("trans")('protocol.materials')},model:{value:(_vm.protocol.materials),callback:function ($$v) {_vm.$set(_vm.protocol, "materials", $$v)},expression:"protocol.materials"}}),_vm._v(" "),(_vm.errors.has('materials'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('materials')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('hintType' in _vm.protocol.dataFields)),expression:"('hintType' in protocol.dataFields)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"hintType",class:{'is-invalid': _vm.errors.has('hintType')},attrs:{"id":"hintType","label":_vm._f("trans")('protocol.hint_type'),"type":"text","name":"hintType","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.hintType')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.hintType),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "hintType", $$v)},expression:"protocol.dataFields.hintType"}}),_vm._v(" "),(_vm.errors.has('hintType'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('hintType')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('provideHint' in _vm.protocol.dataFields) && _vm.selectedTeachingMethodID !== 7),expression:"('provideHint' in protocol.dataFields) && selectedTeachingMethodID !== 7"}],staticClass:"form-group row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(('provideHint' in _vm.protocol.dataFields)),expression:"('provideHint' in protocol.dataFields)"}],staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:3000'),expression:"'max:3000'"}],ref:"provideHint",class:{'is-invalid': _vm.errors.has('provideHint')},attrs:{"id":"provideHint","label":_vm._f("trans")('protocol.providingHint'),"type":"text","multiline":"","rows":"2","name":"provideHint","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.provideHint')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.provideHint),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "provideHint", $$v)},expression:"protocol.dataFields.provideHint"}}),_vm._v(" "),(_vm.errors.has('provideHint'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('provideHint')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('reductionHint' in _vm.protocol.dataFields)),expression:"('reductionHint' in protocol.dataFields)"}],staticClass:"form-group row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(('reductionHint' in _vm.protocol.dataFields)),expression:"('reductionHint' in protocol.dataFields)"}],staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"reductionHint",class:{'is-invalid': _vm.errors.has('reductionHint')},attrs:{"id":"reductionHint","label":_vm._f("trans")('protocol.reducingPromp'),"type":"text","multiline":"","rows":"2","name":"reductionHint","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.reductionHint')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.reductionHint),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "reductionHint", $$v)},expression:"protocol.dataFields.reductionHint"}}),_vm._v(" "),(_vm.errors.has('reductionHint'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('reductionHint')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('reductionHintMethod' in _vm.protocol.dataFields)),expression:"('reductionHintMethod' in protocol.dataFields)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"reductionHintMethod",class:{'is-invalid': _vm.errors.has('reductionHintMethod')},attrs:{"id":"reductionHintMethod","label":_vm._f("trans")('protocol.reduction_hint_method'),"type":"text","multiline":"","rows":"2","name":"reductionHintMethod","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.reductionHintMethod')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.reductionHintMethod),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "reductionHintMethod", $$v)},expression:"protocol.dataFields.reductionHintMethod"}}),_vm._v(" "),(_vm.errors.has('reductionHintMethod'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('reductionHintMethod')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(('risingPrompt' in _vm.protocol)),expression:"('risingPrompt' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{ref:"risingPrompt",staticClass:"mdc-textfield-wrapper",attrs:{"id":"risingPrompt","aria-required":"false","aria-invalid":"false"}},[_c('div',{staticClass:"mdc-textfield mdc-text-field mdc-text-field--upgraded mdc-text-field--textarea",class:{'is-invalid': _vm.errors.has('risingPrompt')}},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"},{name:"model",rawName:"v-model",value:(_vm.protocol.risingPrompt),expression:"protocol.risingPrompt"}],staticClass:"mdc-text-field__input",attrs:{"rows":"2","cols":"40","name":"risingPrompt","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.risingPrompt')},domProps:{"value":(_vm.protocol.risingPrompt)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "risingPrompt", $event.target.value)},function($event){_vm.setIsChanged(true)}]}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label mdc-floating-label--float-above",attrs:{"for":"risingPrompt"}},[_vm._v(" "+_vm._s(_vm._f("trans")('protocol.risingPrompt'))+" ")])]),_vm._v(" "),(_vm.errors.has('risingPrompt'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('risingPrompt')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(('execution' in _vm.protocol)),expression:"('execution' in protocol)"}],staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.execution')))]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:"execution",staticClass:"required",class:{'is-invalid': _vm.errors.has('execution')},attrs:{"id":"execution","type":"text","name":"execution","label":_vm._f("trans")('protocol.describeImplementation'),"multiline":"","rows":"6","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.execution')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.execution),callback:function ($$v) {_vm.$set(_vm.protocol, "execution", $$v)},expression:"protocol.execution"}}),_vm._v(" "),(_vm.errors.has('execution'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('execution')))])]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolCriteration_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1a6df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolCriteration_vue__ = __webpack_require__(1226);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolCriteration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1a6df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolCriteration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(('features' in _vm.protocol.dataFields))?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:2500'),expression:"'max:2500'"}],ref:"features",class:{'is-invalid': _vm.errors.has('features')},attrs:{"id":"features","label":_vm._f("trans")('protocol.features'),"type":"text","multiline":"","rows":"2","name":"features","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.features')},model:{value:(_vm.protocol.dataFields.features),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "features", $$v)},expression:"protocol.dataFields.features"}}),_vm._v(" "),(_vm.errors.has('features'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('features')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(('errorCorrection' in _vm.protocol.dataFields))?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:2500'),expression:"'max:2500'"}],ref:"errorCorrection",class:{'is-invalid': _vm.errors.has('errorCorrection')},attrs:{"id":"errorCorrection","label":_vm._f("trans")('protocol.errorCorrection'),"type":"text","multiline":"","rows":"2","name":"errorCorrection","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.protocol.errorCorrection')},on:{"input":function($event){_vm.setIsChanged(true)}},model:{value:(_vm.protocol.dataFields.errorCorrection),callback:function ($$v) {_vm.$set(_vm.protocol.dataFields, "errorCorrection", $$v)},expression:"protocol.dataFields.errorCorrection"}}),_vm._v(" "),(_vm.errors.has('errorCorrection'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('errorCorrection')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(('criteriaEndSession' in _vm.protocol) && _vm.selectedTeachingMethodID !== 7)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchCriteriaEndSession",class:{'is-invalid': _vm.errors.has('criteriaEndSession')},attrs:{"type":"text","name":"criteriaEndSession","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.criteria_end_session'),"data-vv-as":_vm._f("trans")('protocol.criteria_end_session')},model:{value:(_vm.protocol.criteriaEndSession),callback:function ($$v) {_vm.$set(_vm.protocol, "criteriaEndSession", $$v)},expression:"protocol.criteriaEndSession"}}),_vm._v(" "),(_vm.errors.has('criteriaEndSession'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('criteriaEndSession')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(('criteriaEndTeaching' in _vm.protocol) && _vm.selectedTeachingMethodID !== 7)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchCriteriaEndTeaching",class:{'is-invalid': _vm.errors.has('criteriaEndTeaching')},attrs:{"type":"text","name":"criteriaEndTeaching","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.criteria_end_teaching'),"data-vv-as":_vm._f("trans")('protocol.criteria_end_teaching')},model:{value:(_vm.protocol.criteriaEndTeaching),callback:function ($$v) {_vm.$set(_vm.protocol, "criteriaEndTeaching", $$v)},expression:"protocol.criteriaEndTeaching"}}),_vm._v(" "),(_vm.errors.has('criteriaEndTeaching'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('criteriaEndTeaching')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(('criteriaEndProtocol' in _vm.protocol) && _vm.selectedTeachingMethodID !== 7)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchCriteriaEndProtocol",class:{'is-invalid': _vm.errors.has('criteriaEndProtocol')},attrs:{"type":"text","name":"criteriaEndProtocol","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.criteria_end_protocol'),"data-vv-as":_vm._f("trans")('protocol.criteria_end_protocol')},model:{value:(_vm.protocol.criteriaEndProtocol),callback:function ($$v) {_vm.$set(_vm.protocol, "criteriaEndProtocol", $$v)},expression:"protocol.criteriaEndProtocol"}}),_vm._v(" "),(_vm.errors.has('criteriaEndProtocol'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('criteriaEndProtocol')))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(('synthesisStrategy' in _vm.protocol))?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('max:1000'),expression:"'max:1000'"}],ref:"searchSynthesisStrategy",class:{'is-invalid': _vm.errors.has('synthesisStrategy')},attrs:{"type":"text","name":"synthesisStrategy","visible":_vm.visible,"data-vv-validate-on":"none","label":_vm._f("trans")('protocol.synthesisStrategy'),"data-vv-as":_vm._f("trans")('protocol.synthesisStrategy')},model:{value:(_vm.protocol.synthesisStrategy),callback:function ($$v) {_vm.$set(_vm.protocol, "synthesisStrategy", $$v)},expression:"protocol.synthesisStrategy"}}),_vm._v(" "),(_vm.errors.has('synthesisStrategy'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('synthesisStrategy')))])]):_vm._e()],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksPecs_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7561226c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksPecs_vue__ = __webpack_require__(1228);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksPecs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7561226c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksPecs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_vm._l((_vm.protocol.stages),function(value){return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12 mt-3"},[(_vm.teachingMethod.id == 7)?_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")(value.description)))]):_vm._e(),_vm._v(" "),(_vm.teachingMethod.id == 8)?_c('h4',{staticClass:"row-title"},[_vm._v("\n        \n        "+_vm._s(_vm._f("trans")('protocol.select_attempt'))+"\n        \n        "),_c('mdc-checkbox',{model:{value:(_vm.isAllTasksEnabled),callback:function ($$v) {_vm.isAllTasksEnabled=$$v},expression:"isAllTasksEnabled"}})],1):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.pecs.target_sequence_title')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.mastered_mand')))])])]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((value.tasks),function(task,index){return ((_vm.teachingMethod.id == 8 && _vm.isAllTasksEnabled && (task.position == 3 || task.position == 4)) || _vm.teachingMethod.id == 7 || (_vm.teachingMethod.id == 8 && !_vm.isAllTasksEnabled))?_c('tr',{key:task.id},[_c('td',[_vm._v("\n              "+_vm._s(index + 1)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"name-field"},[_vm._v("\n              "+_vm._s(task.description)+"\n            ")]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e()]):_vm._e()}))])])])}),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"choose-block"},[_c('div',{staticClass:"mdc-radio-wrapper"},[_vm._v("\n                "+_vm._s(_vm.protocol.stages[0].masteringCondition.ratio)+_vm._s(_vm._f("trans")('protocol.condition_procent'))+"\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.stages[0].masteringCondition.sessionCount),expression:"protocol.stages[0].masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('required|min_value:1|max_value:10|numeric'),expression:"'required|min_value:1|max_value:10|numeric'"}],ref:"condition_session_mastering",staticClass:"ml-2",attrs:{"id":"condition_session_mastering","min":"1","type":"number","name":"condition_session_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.protocol.stages[0].masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.stages[0].masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.stages[0].masteringCondition.trialCount),expression:"protocol.stages[0].masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('required|min_value:1|max_value:10|numeric'),expression:"'required|min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.protocol.stages[0].masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.stages[0].masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n\n                "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n\n              ")]),_vm._v(" "),(_vm.errors.has('condition_session_mastering'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session_mastering'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+" ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-switch',{model:{value:(_vm.protocol.stages[0].isPromptEnabled),callback:function ($$v) {_vm.$set(_vm.protocol.stages[0], "isPromptEnabled", $$v)},expression:"protocol.stages[0].isPromptEnabled"}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.track_change_level'))+"\n            ")]),_vm._v(" "),_c('hints',{attrs:{"hint-list":_vm.protocol.stages[0].taskPrompts,"hintVisible":_vm.protocol.stages[0].isPromptEnabled}})],1)])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriteriaPecs_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38733da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriteriaPecs_vue__ = __webpack_require__(1231);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriteriaPecs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38733da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriteriaPecs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1230 */,
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row mt-4"},[_c('div',{staticClass:"col-12 mb-4"},[(_vm.protocol.masteringCondition)?_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"choose-input-block"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_mastered_prop')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.ratio),expression:"protocol.masteringCondition.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent_mastering",class:{'is-invalid': _vm.errors.has('condition_procent_mastering')},attrs:{"id":"condition_procent_mastering","min":"80","max":"100","type":"number","name":"condition_procent_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.protocol.masteringCondition.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "ratio", $event.target.value)}}}),_vm._v("% "+_vm._s(_vm._f("trans")('protocol.percent_reaction'))+"\n\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.sessionCount),expression:"protocol.masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_session')},attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.protocol.masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.trialCount),expression:"protocol.masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_trial')},attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.protocol.masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n            ")]),_vm._v(" "),(_vm.errors.has('condition_procent_mastering'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_mastering'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+"  ")])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.listCategories')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._l((_vm.protocol.categories),function(category,key){return _c('div',{staticClass:"alert-secondary dragging-block"},[_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-5 col-10 mb-4"},[_c('v-select',{attrs:{"options":_vm.levels,"label":"uuid","name":"categoryStage","placeholder":_vm._f("trans")('protocol.currentLevel'),"data-vv-validate-on":"none"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.' + option.title))+"\n            ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.' + option.title))+"\n            ")]}}]),model:{value:(category.currentStage),callback:function ($$v) {_vm.$set(category, "currentStage", $$v)},expression:"category.currentStage"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.currentLevel'))+"\n              ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.currentLevel')))])],1),_vm._v(" "),(category.masteringPercent)?_c('div',{staticClass:"col-md-5 col-2 pt-4 text-right"},[_c('span',{staticClass:"mr-md-2"},[_vm._v(_vm._s(category.masteringPercent)+"%")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row dragging mb-4"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_category'),expression:"'required|max:1000|unique_category'"}],ref:'category_' + key,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('category_' + key)},attrs:{"type":"text","name":'category_' + key,"label":_vm._f("trans")('protocol.describeCategory', {number: key + 1}),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeCategory', {number: key + 1})},model:{value:(category.title),callback:function ($$v) {_vm.$set(category, "title", $$v)},expression:"category.title"}}),_vm._v(" "),(_vm.errors.has('category_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('category_' + key)))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button","disabled":_vm.protocol.categories.length === 1 || _vm.protocol.categories.length > 10},on:{"click":function($event){$event.preventDefault();_vm.removeCategoryPopup(category.uuid)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.deleteCategory'))+"\n          ")])])]),_vm._v(" "),_vm._l((category.tasks),function(task,taskKey){return _c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-7 col-11 offset-1"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_properties'),expression:"'required|max:1000|unique_properties'"}],ref:'task_' + key + '_' + taskKey,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('task_' + key + '_' + taskKey)},attrs:{"type":"text","name":'task_' + key + '_' + taskKey,"label":_vm._f("trans")('protocol.describeProperty'),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeProperty')},model:{value:(task.description),callback:function ($$v) {_vm.$set(task, "description", $$v)},expression:"task.description"}}),_vm._v(" "),(_vm.errors.has('task_' + key + '_' + taskKey))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_' + key + '_' + taskKey)))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-11 offset-1 offset-md-0"},[_c('button',{staticClass:"btn btn-link secondary-link btn-sm mt-2",attrs:{"type":"button","disabled":category.tasks.length === 1 || category.tasks.length > 20},on:{"click":function($event){$event.preventDefault();_vm.removePropertyPopup(category.uuid, task.uuid)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.deleteProperty'))+"\n            ")])])])}),_vm._v(" "),_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":category.tasks.length >= 20},on:{"click":function($event){$event.preventDefault();_vm.addProperty(category.uuid, category.id)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.addProperty'))+"\n          ")])])])],2)}),_vm._v(" "),_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-12 mt-4"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":!_vm.protocol.stages.length || _vm.protocol.categories.length > 9},on:{"click":function($event){$event.preventDefault();_vm.addCategory()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.addCategory'))+"\n        ")])])])],2),_vm._v(" "),(_vm.isModalAcceptPopup)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete_property'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.removeProperty(_vm.currentCategoryUuid, _vm.currentTaskUuid)},"cancel":_vm.cancel},model:{value:(_vm.isModalAcceptPopup),callback:function ($$v) {_vm.isModalAcceptPopup=$$v},expression:"isModalAcceptPopup"}})],1):_vm._e(),_vm._v(" "),(_vm.isModalAcceptPopupCategory)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete_category'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.removeCategory(_vm.currentCategoryUuid)},"cancel":_vm.cancel},model:{value:(_vm.isModalAcceptPopupCategory),callback:function ($$v) {_vm.isModalAcceptPopupCategory=$$v},expression:"isModalAcceptPopupCategory"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriteriaPecsItems_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e887440e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriteriaPecsItems_vue__ = __webpack_require__(1233);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CriteriaPecsItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e887440e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CriteriaPecsItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row mt-4"},[_c('div',{staticClass:"col-12 mb-4"},[_c('div',{staticClass:"box-shadow"},[(_vm.protocol.masteringCondition)?_c('div',{staticClass:"choose-input-block"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm._f("trans")('protocol.condition_mastered_prop')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.ratio),expression:"protocol.masteringCondition.ratio"},{name:"validate",rawName:"v-validate",value:('min_value:80|max_value:100|numeric'),expression:"'min_value:80|max_value:100|numeric'"}],ref:"condition_procent_mastering",class:{'is-invalid': _vm.errors.has('condition_procent_mastering')},attrs:{"id":"condition_procent_mastering","min":"80","max":"1000","type":"number","name":"condition_procent_mastering","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_procent')},domProps:{"value":(_vm.protocol.masteringCondition.ratio)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "ratio", $event.target.value)}}}),_vm._v("% "+_vm._s(_vm._f("trans")('protocol.percent_reaction'))+"\n\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.sessionCount),expression:"protocol.masteringCondition.sessionCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_session",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_session')},attrs:{"id":"condition_session","min":"1","type":"number","name":"condition_session","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_trial')},domProps:{"value":(_vm.protocol.masteringCondition.sessionCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "sessionCount", $event.target.value)}}}),_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.condition_trial'))+"\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.masteringCondition.trialCount),expression:"protocol.masteringCondition.trialCount"},{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:10|numeric'),expression:"'min_value:1|max_value:10|numeric'"}],ref:"condition_trial",staticClass:"ml-2",class:{'is-invalid': _vm.errors.has('condition_trial')},attrs:{"id":"condition_trial","min":"1","type":"number","name":"condition_trial","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.condition_session')},domProps:{"value":(_vm.protocol.masteringCondition.trialCount)},on:{"keydown":_vm.changeNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.masteringCondition, "trialCount", $event.target.value)}}}),_vm._v("\n        "+_vm._s(_vm._f("trans")('protocol.condition_session'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_procent_mastering'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_procent_mastering'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_session'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_session'))+"  ")])]):_vm._e(),_vm._v(" "),(_vm.errors.has('condition_trial'))?_c('span',{staticClass:"invalid-feedback invalid"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('condition_trial'))+"  ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.listCategories')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_vm._l((_vm.protocol.categories),function(category,key){return _c('div',{staticClass:"alert-secondary dragging-block"},[_c('div',{staticClass:"form-group row dragging"},[(category.masteringPercent)?_c('div',{staticClass:"col-md-12 text-right"},[_c('span',{staticClass:"mr-md-2"},[_vm._v(_vm._s(category.masteringPercent)+"%")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row dragging mb-4"},[_c('div',{staticClass:"col-md-8 col-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_category'),expression:"'required|max:1000|unique_category'"}],ref:'category_' + key,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('category_' + key)},attrs:{"type":"text","name":'category_' + key,"label":_vm._f("trans")('protocol.describeCategory', {number: key + 1}),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeCategory', {number: key + 1})},model:{value:(category.title),callback:function ($$v) {_vm.$set(category, "title", $$v)},expression:"category.title"}}),_vm._v(" "),(_vm.errors.has('category_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('category_' + key)))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[(category.typeId == 1)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button","disabled":_vm.protocol.categories.length === 2 || _vm.protocol.categories.length > 10},on:{"click":function($event){$event.preventDefault();_vm.removeCategory(category.uuid)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.deleteCategory'))+"\n          ")]):_vm._e()])]),_vm._v(" "),_vm._l((category.tasks),function(task,taskKey){return _c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-7 col-11 offset-1"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_properties'),expression:"'required|max:1000|unique_properties'"}],ref:'task_' + key + '_' + taskKey,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('task_' + key + '_' + taskKey)},attrs:{"type":"text","name":'task_' + key + '_' + taskKey,"label":_vm._f("trans")('protocol.describeProperty'),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeProperty')},model:{value:(task.description),callback:function ($$v) {_vm.$set(task, "description", $$v)},expression:"task.description"}}),_vm._v(" "),(_vm.errors.has('task_' + key + '_' + taskKey))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_' + key + '_' + taskKey)))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-11 offset-1 offset-md-0"},[_c('button',{staticClass:"btn btn-link secondary-link btn-sm mt-2",attrs:{"type":"button","disabled":category.tasks.length === 1 || category.tasks.length > 20},on:{"click":function($event){$event.preventDefault();_vm.removePropertyPopup(category.uuid, task.uuid)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.deleteProperty'))+"\n          ")])])])}),_vm._v(" "),_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":category.tasks.length >= 20},on:{"click":function($event){$event.preventDefault();_vm.addProperty(category.uuid, category.id)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.addProperty'))+"\n          ")])])])],2)}),_vm._v(" "),_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-12 mt-4"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":!_vm.protocol.stages.length || _vm.protocol.categories.length > 9},on:{"click":function($event){$event.preventDefault();_vm.addCategory()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.addCategory'))+"\n        ")])])])],2),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.listCategories')))])]),_vm._v(" "),(_vm.protocol.categories)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},_vm._l((_vm.protocol.categories),function(category,index){return _c('table',{key:category.globalUuid,staticClass:"table table-sm mb-0"},[_c('thead',{class:{'visibility-collapse' : index !== 0}},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.nameCategoryProperty')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_level')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.master')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary"},[_c('td',{staticClass:"name-field"},[_c('strong',[_vm._v(_vm._s(category.title))])]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveCategory(category)}},model:{value:(category.active),callback:function ($$v) {_vm.$set(category, "active", $$v)},expression:"category.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"}):_vm._e()]),_vm._v(" "),_vm._l((category.tasks),function(task){return _c('tr',{key:task.uuid},[_c('td',{staticClass:"pl-4"},[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveTask(category, task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',[_c('mdc-checkbox',{attrs:{"disabled":!task.active},on:{"change":function($event){_vm.masteredTask(task)}},model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e()])})],2)])})):_vm._e(),_vm._v(" "),(_vm.protocol.categories && !_vm.protocol.categories.length)?_c('div',{staticClass:"col-12"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.no_list_category'))+"\n        ")]):_vm._e()])])]),_vm._v(" "),(_vm.isModalAcceptPopup)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete_property'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.removeProperty(_vm.currentCategoryUuid, _vm.currentTaskUuid)},"cancel":_vm.cancel},model:{value:(_vm.isModalAcceptPopup),callback:function ($$v) {_vm.isModalAcceptPopup=$$v},expression:"isModalAcceptPopup"}})],1):_vm._e(),_vm._v(" "),(_vm.isModalAcceptPopupCategory)?_c('div',[_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete_category'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.removeCategory(_vm.currentCategoryUuid)},"cancel":_vm.cancel},model:{value:(_vm.isModalAcceptPopupCategory),callback:function ($$v) {_vm.isModalAcceptPopupCategory=$$v},expression:"isModalAcceptPopupCategory"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksPecs3_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3f97fae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksPecs3_vue__ = __webpack_require__(1235);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksPecs3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3f97fae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksPecs3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-light btn-sm back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hidePecsWithDiscrimination(true)}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!this.isNew && !this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(this.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm._f("toLocaleDateTime")(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n          "+_vm._s(_vm.currentStage.description)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-secondary mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.listCategories')))])]),_vm._v(" "),(_vm.categories)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},_vm._l((_vm.categories),function(category,index){return _c('table',{key:category.globalUuid,staticClass:"table table-sm mb-0"},[_c('thead',{class:{'visibility-collapse' : index !== 0}},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.nameCategoryProperty')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.show_on_level')))]),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.master')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary"},[_c('td',{staticClass:"name-field"},[_c('strong',[_vm._v(_vm._s(category.title))])]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveCategory(category)}},model:{value:(category.active),callback:function ($$v) {_vm.$set(category, "active", $$v)},expression:"category.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',{staticClass:"table-actions"}):_vm._e()]),_vm._v(" "),_vm._l((category.tasks),function(task){return _c('tr',{key:task.uuid},[_c('td',{staticClass:"pl-4"},[_vm._v(_vm._s(task.description))]),_vm._v(" "),_c('td',{staticClass:"table-actions"},[_c('mdc-checkbox',{on:{"change":function($event){_vm.changeActiveTask(category, task)}},model:{value:(task.active),callback:function ($$v) {_vm.$set(task, "active", $$v)},expression:"task.active"}})],1),_vm._v(" "),((_vm.isCurator || _vm.isBCBA) && _vm.protocol.assigneeId)?_c('td',[_c('mdc-checkbox',{attrs:{"disabled":!task.active},on:{"change":function($event){_vm.masteredTask(task)}},model:{value:(task.mastered),callback:function ($$v) {_vm.$set(task, "mastered", $$v)},expression:"task.mastered"}})],1):_vm._e()])})],2)])})):_vm._e(),_vm._v(" "),(_vm.categories && !_vm.categories.length)?_c('div',{staticClass:"col-12"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.no_list_category'))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.hidePecsWithDiscrimination(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.back_to_protocol'))+"\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!(_vm.listTasks || _vm.listTasksDTT || _vm.listTasksMand || _vm.listTasksUSD || _vm.listTasksChain || _vm.listTasksShaping || _vm.listTasksPecsWithDiscrimination))?_c('div',{staticClass:"protocol"},[_c('div',{staticClass:"row top-button form-group-button"},[_c('div',{staticClass:"col-md-12"},[(_vm.clientId || _vm.protocol.assigneeId)?_c('router-link',{staticClass:"btn btn-light btn-sm back",attrs:{"to":{ name: 'client-edit', params: { clientId: _vm.clientId || _vm.protocol.assigneeId}}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])]):_c('router-link',{staticClass:"btn btn-light btn-sm back",attrs:{"to":{ name: 'protocols'}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back')))])]),_vm._v(" "),(_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(_vm.isMand ? true : _vm.protocol.published)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.apply_changes_to_protocol'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isNew && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit","disabled":!_vm.protocol.stages.length},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.save'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isNew && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit","disabled":!_vm.canPublish},on:{"click":function($event){$event.preventDefault();_vm.createProtocol(true)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.create'))+"\n        ")]):_vm._e(),_vm._v(" "),(!(_vm.isNew) && !(_vm.clientId || _vm.protocol.assigneeId) && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-link btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(false)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.createNotPublish'))+"\n        ")]):_vm._e(),_vm._v(" "),((_vm.isNew) && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-link btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.createProtocol(false)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.createNotPublish'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.protocol.isOnIndividualization)?_c('button',{staticClass:"btn btn-primary btn-sm ml-0 ml-md-2 mb-2",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.saveAndAllowMensuration()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.buttons.save_and_allow_mensuration'))+"\n        ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.newProtocol')))]):_vm._e(),_vm._v(" "),(!_vm.isNew && !_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editProtocol')))]):_vm._e(),_vm._v(" "),(_vm.protocol.isDraft)?_c('h1',{staticClass:"page-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.auto_save_version'))+" "+_vm._s(_vm.toLocaleDateTimeTimezone(_vm.protocol.updatedAt.date)))]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.descriptionPart')))])])]),_vm._v(" "),(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('v-select',{class:{'is-clear': !_vm.teachingMethod},attrs:{"name":"teachingMethod","options":_vm.directories,"label":"name","disabled":_vm.disabledTeachingMethod},model:{value:(_vm.teachingMethod),callback:function ($$v) {_vm.teachingMethod=$$v},expression:"teachingMethod"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(_vm._s(_vm._f("trans")('protocol.noAvailableTeachingMethod')))])]),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")('protocol.recording_method')))])],1)])])]),_vm._v(" "),(_vm.teachingMethod)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('protocol-info',{attrs:{"protocol":_vm.protocol,"setIsChanged":_vm.setIsChanged,"visible":_vm.visible,"errors":_vm.errors,"selectedTeachingMethodID":_vm.selectedTeachingMethodID}}),_vm._v(" "),(!_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('div',{staticClass:"form-group row"},[(!_vm.isChain && !_vm.isShaping)?_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title mt-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stages')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_stage_position')))])]):_vm._e(),_vm._v(" "),(_vm.isChain || _vm.isShaping)?_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title mt-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.environments')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_environment_position')))])]):_vm._e()]):_vm._e(),_vm._v(" "),(('stages' in _vm.protocol) && !_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithItems)?_c('div',{ref:"stages",staticClass:"stages",attrs:{"id":"stages"}},[(!_vm.isPecsWithDiscrimination)?_c('draggable',{attrs:{"list":_vm.protocol.stages,"ghost-class":"ghost","move":_vm.onMoveStages,"handle":".drag-btn"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},_vm._l((_vm.protocol.stages),function(value,key){return _c('div',[_c('div',{staticClass:"form-group row dragging"},[(!_vm.isMobile)?_c('div',{staticClass:"col-md-2 text-center stages-col"},[_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(key + 1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")(_vm.isChain  || _vm.isShaping ? 'protocol.environment' : 'protocol.stage'))+" "+_vm._s(key + 1))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-10"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_stage'),expression:"'required|max:1000|unique_stage'"}],ref:'stage_' + key,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('stage_' + key)},attrs:{"type":"text","id":'stage_' + key,"label":_vm._f("trans")(_vm.isChain || _vm.isShaping ? 'protocol.describeEnvironment' : 'protocol.describeStage', {number: key + 1}),"name":'stage_' + key,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")(_vm.isChain || _vm.isShaping ? 'protocol.environment' : 'protocol.stage'),"disabled":value.isClosed},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.addStage()},"change":function($event){_vm.setStageDescription(value,$event)}},model:{value:(_vm.protocol.stages[key].description),callback:function ($$v) {_vm.$set(_vm.protocol.stages[key], "description", $$v)},expression:"protocol.stages[key].description"}}),_vm._v(" "),(_vm.errors.has('stage_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('stage_' + key)))])]):_vm._e(),_vm._v(" "),(!_vm.errorStages && value.notValid)?_c('strong',{staticClass:"invalid-feedback invalid"},[_vm._v(_vm._s(_vm._f("trans")('protocol.errorStages')))]):_vm._e(),_vm._v(" "),(!value.hasAssignedStage && _vm.isMobile  && _vm.protocol.stages.length>1)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeStage(key)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")(_vm.isChain || _vm.isShaping ? 'protocol.removeEnvironment': 'protocol.buttons.removeStage'))+"\n                  ")]):_vm._e(),_vm._v(" "),(((value.tasks && value.tasks.length) || (value.stimuli && value.stimuli.length) || (_vm.isChain && _vm.protocol.globalTasks && _vm.protocol.globalTasks.length)) && !_vm.isMand && _vm.isMobile)?_c('button',{staticClass:"btn btn-primary btn-rounded copy-btn ml-1 float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.duplicateStage(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(value.mands && value.mands.length && _vm.isMand && _vm.isMobile)?_c('button',{staticClass:"btn btn-primary btn-rounded copy-btn ml-1 float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.duplicateStage(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(_vm.isMobile && !_vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded edit-btn ml-1 float-right",attrs:{"type":"submit","disabled":value.isClosed},on:{"click":function($event){$event.preventDefault();_vm.showTasks(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded edit-btn ml-1 float-right",attrs:{"type":"submit","disabled":value.isClosed},on:{"click":function($event){$event.preventDefault();_vm.showMands(_vm.protocol.stages[key])}}}):_vm._e()],1),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"col-2 text-center"},[(!value.isClosed && _vm.isMobile )?_c('span',{staticClass:"drag-btn"},[_vm._v("draggable")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"col-md-5"},[(!value.hasAssignedStage && _vm.protocol.stages.length>1)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeStage(key)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")(_vm.isChain || _vm.isShaping ? 'protocol.removeEnvironment': 'protocol.buttons.removeStage'))+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded edit-btn ml-1",attrs:{"type":"submit","disabled":value.isClosed},on:{"click":function($event){$event.preventDefault();_vm.showTasks(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(_vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded edit-btn ml-1",attrs:{"type":"submit","disabled":value.isClosed},on:{"click":function($event){$event.preventDefault();_vm.showMands(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(((value.tasks && value.tasks.length) || (value.stimuli && value.stimuli.length) || (_vm.isChain && _vm.protocol.globalTasks && _vm.protocol.globalTasks.length))  && !_vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded copy-btn ml-1",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.duplicateStage(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(value.mands && value.mands.length && _vm.isMand)?_c('button',{staticClass:"btn btn-primary btn-rounded copy-btn ml-1",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.duplicateStage(_vm.protocol.stages[key])}}}):_vm._e(),_vm._v(" "),(!value.isClosed && !_vm.isMobile)?_c('span',{staticClass:"drag-btn align-top ml-1"},[_vm._v("draggable")]):_vm._e()]):_vm._e()])])})):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscrimination)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title mt-3"},[_vm._v(_vm._s(_vm._f("trans")('protocol.count_properties')))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.protocol.stages),function(value,key){return (_vm.isPecsWithDiscrimination)?_c('div',[_c('div',{staticClass:"form-group row without-line"},[(!_vm.isMobile)?_c('div',{staticClass:"col-2 text-center stages-col"},[_c('span',{staticClass:"badge badge-info mt-2"},[_vm._v(_vm._s(key + 1))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 pt-2 pb-2"},[_c('button',{staticClass:"btn btn-primary btn-rounded edit-btn ml-1 float-right",attrs:{"type":"submit","disabled":!value.isActive},on:{"click":function($event){$event.preventDefault();_vm.showTasks(_vm.protocol.stages[key])}}}),_vm._v(" "),_c('mdc-checkbox',{staticClass:"float-right",attrs:{"disabled":_vm.activeStages.length == 1 && value.isActive},model:{value:(value.isActive),callback:function ($$v) {_vm.$set(value, "isActive", $$v)},expression:"value.isActive"}}),_vm._v(" "),_c('p',{staticClass:"mb-0 mt-1"},[_vm._v(_vm._s(_vm._f("trans")('protocol.count_properties'))+" "+_vm._s(key + 1))]),_vm._v(" "),(_vm.errors.has('stage_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('stage_' + key)))])]):_vm._e()],1)])]):_vm._e()}),_vm._v(" "),(!_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination)?_c('div',{staticClass:"form-group row"},[(!_vm.isMobile)?_c('div',{staticClass:"col-md-2 text-center stages-col"},[_c('span',{staticClass:"badge badge-secondary"},[_vm._v(_vm._s(_vm.protocol.stages.length + 1))]),_vm._v(" "),(!_vm.isChain && !_vm.isShaping)?_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.stage'))+"\n                "+_vm._s(_vm.protocol.stages.length + 1))]):_vm._e(),_vm._v(" "),(_vm.isChain || _vm.isShaping)?_c('p',[_vm._v(_vm._s(_vm._f("trans")('protocol.environment'))+"\n                "+_vm._s(_vm.protocol.stages.length + 1))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[(!_vm.isChain && !_vm.isShaping)?_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStage()}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.addStage'))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.isChain || _vm.isShaping)?_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addStage()}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.addEnvironment'))+"\n              ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.validateStimuls && _vm.isChain)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.requiredStepsList')))])])]):_vm._e(),_vm._v(" "),(!_vm.validateStimuls && !_vm.isChain)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.requiredStimulList')))])])]):_vm._e(),_vm._v(" "),(!_vm.validateCheckList)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm._f("trans")('protocol.requiredCheckList')))])])]):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(!_vm.errorStagesCount && !_vm.isChain)?_c('strong',{staticClass:"invalid-feedback invalid"},[_vm._v("\n              "+_vm._s(_vm._f("trans")(!_vm.isChain ? 'protocol.errorStagesCount' :  'protocol.errorEnvironmentsCount'))+"\n            ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(('stages' in _vm.protocol) && (_vm.isPecs || _vm.isPecsWithoutDiscrimination))?_c('div',{staticClass:"stages row"},[_c('tasks-pecs',{attrs:{"protocol":_vm.protocol,"teaching-method":_vm.teachingMethod}})],1):_vm._e(),_vm._v(" "),(_vm.isPecsWithDiscrimination)?_c('criteria-pecs',{attrs:{"protocol":_vm.protocol},on:{"removed":_vm.onChangeRemovedCategoryCount}}):_vm._e(),_vm._v(" "),(_vm.isPecsWithItems && _vm.protocol.categories && _vm.protocol.categories.length)?_c('criteria-pecs-items',{attrs:{"protocol":_vm.protocol},on:{"removed":_vm.onChangeRemovedCategoryCount}}):_vm._e(),_vm._v(" "),(!_vm.isMand && !_vm.isPecs && !_vm.isPecsWithoutDiscrimination && !_vm.isPecsWithDiscrimination && !_vm.isPecsWithItems)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")(!_vm.isChain ? !_vm.isShaping ? 'protocol.stimuluses' : 'protocol.criterion' : 'protocol.steps')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle"},[_vm._v(_vm._s(_vm._f("trans")(!_vm.isChain ? !_vm.isShaping ? 'protocol.change_stimul_position' : 'protocol.change_criterion_position' : 'protocol.change_step_position')))])]),_vm._v(" "),(_vm.protocol.globalTasks)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},[_c('draggable',{attrs:{"list":_vm.protocol.globalTasks,"ghost-class":"ghost","handle":".drag-btn"},on:{"start":function($event){_vm.draggingGlobalTasks = true},"end":function($event){_vm.draggingGlobalTasks = false}}},_vm._l((_vm.protocol.globalTasks),function(value,key){return _c('div',{staticClass:"alert-secondary dragging-block"},[_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-9 col-10"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_task'),expression:"'required|max:1000|unique_task'"}],ref:'task_' + key,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('task_' + key)},attrs:{"type":"text","name":'task_' + key,"label":_vm._f("trans")(_vm.isChain ? 'protocol.describeStep' : _vm.isShaping ? 'protocol.describeСriterion' : 'protocol.describeStimulus', {number: key + 1}),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")(_vm.isChain ? 'protocol.step' : _vm.isShaping ? 'protocol.criterion' : 'validation.attributes.task')},on:{"focus":function($event){_vm.focusStageTaskDescription(value)},"change":function($event){_vm.setStageTaskDescription(value,$event)},"input":function($event){_vm.setIsChanged(false)}},model:{value:(value.description),callback:function ($$v) {_vm.$set(value, "description", $$v)},expression:"value.description"}}),_vm._v(" "),(_vm.errors.has('task_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_' + key)))])]):_vm._e(),_vm._v(" "),((_vm.showDeleteButton || value.isNew || _vm.isCurator || _vm.isBCBA) && key && _vm.isMobile)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeTaskModal(_vm.protocol.globalTasks[key].uuid)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")(_vm.isChain ? 'protocol.removeStep' : _vm.isShaping ? 'protocol.buttons.removeСriterion' : 'protocol.buttons.removeStimulus'))+"\n                      ")]):_vm._e()],1),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"col-2 text-center"},[_c('span',{staticClass:"drag-btn"},[_vm._v("draggable")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"col-md-3 pr-2"},[((_vm.showDeleteButton || value.isNew || _vm.isCurator || _vm.isBCBA) && key)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeTaskModal(_vm.protocol.globalTasks[key].uuid)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")(_vm.isChain ? 'protocol.removeStep' : _vm.isShaping ? 'protocol.buttons.removeСriterion' : 'protocol.buttons.removeStimulus'))+"\n                      ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"drag-btn float-right"},[_vm._v("draggable")])]):_vm._e()])])}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addTask()}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")(_vm.isChain ? 'protocol.addStep' : _vm.isShaping ? 'protocol.buttons.addСriterion' : 'protocol.buttons.addStimulus'))+"\n              ")])])])]):_vm._e(),_vm._v(" "),(_vm.isMand)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.list_of_mand_reaction')))]),_vm._v(" "),_c('h5',{staticClass:"row-title_subsitle"},[_vm._v(_vm._s(_vm._f("trans")('protocol.change_mand_reaction_position')))])]),_vm._v(" "),(_vm.protocol.globalMandReactions)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"mandGoal"}},[_c('draggable',{attrs:{"list":_vm.protocol.globalMandReactions,"ghost-class":"ghost","handle":".drag-btn"},on:{"start":function($event){_vm.draggingGlobalTasks = true},"end":function($event){_vm.draggingGlobalTasks = false}}},_vm._l((_vm.protocol.globalMandReactions),function(value,key){return _c('div',{staticClass:"alert-secondary dragging-block"},[_c('div',{staticClass:"form-group row dragging"},[_c('div',{staticClass:"col-md-9 col-10"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_task'),expression:"'required|max:1000|unique_task'"}],ref:'task_' + key,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has('task_' + key)},attrs:{"type":"text","name":'task_' + key,"label":_vm._f("trans")('protocol.describeMandReaction', {number: key + 1}),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.describeMandReaction', {number: key + 1})},on:{"change":function($event){_vm.setStageMandDescription(value,$event)}},model:{value:(value.description),callback:function ($$v) {_vm.$set(value, "description", $$v)},expression:"value.description"}}),_vm._v(" "),(_vm.errors.has('task_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('task_' + key)))])]):_vm._e(),_vm._v(" "),((_vm.showDeleteButton || _vm.isCurator || _vm.isBCBA) && key && _vm.isMobile)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeMandModal(_vm.protocol.globalMandReactions[key].uuid)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('protocol.buttons.removeStimulus'))+"\n                      ")]):_vm._e()],1),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"col-2 text-center"},[_c('span',{staticClass:"drag-btn"},[_vm._v("draggable")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"col-md-3"},[((_vm.showDeleteButton || _vm.isCurator || _vm.isBCBA) && key)?_c('button',{staticClass:"btn btn-link secondary-link btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeMandModal(_vm.protocol.globalMandReactions[key].uuid)}}},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('protocol.buttons.removeStimulus'))+"\n                      ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"drag-btn float-right ml-1"},[_vm._v("draggable")])]):_vm._e()])])}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addMand()}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('protocol.buttons.addMandReaction'))+"\n              ")])])])]):_vm._e(),_vm._v(" "),_c('protocol-criteration',{attrs:{"protocol":_vm.protocol,"setIsChanged":_vm.setIsChanged,"visible":_vm.visible,"errors":_vm.errors,"selectedTeachingMethodID":_vm.selectedTeachingMethodID}}),_vm._v(" "),_c('div',{staticClass:"form-group row form-group-button"},[_c('div',{staticClass:"col-md-12"},[(_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2 mb-2 mb-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(_vm.protocol.published)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.apply_changes_to_protocol'))+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.isNew && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2 mb-2 mb-md-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(true)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.save'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isNew && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"type":"submit","disabled":!_vm.canPublish},on:{"click":function($event){$event.preventDefault();_vm.createProtocol(true)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.create'))+"\n            ")]):_vm._e(),_vm._v(" "),(!(_vm.isNew) && !(_vm.clientId || _vm.protocol.assigneeId) && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mb-2 mb-md-0",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.editProtocol(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.createNotPublish'))+"\n            ")]):_vm._e(),_vm._v(" "),((_vm.isNew) && !_vm.protocol.isDraft)?_c('button',{staticClass:"btn btn-link btn-sm mr-2 mb-2 mb-md-0",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.createProtocol(false)}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.createNotPublish'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.protocol.isOnIndividualization)?_c('button',{staticClass:"btn btn-primary btn-sm mr-2 mb-2 mb-md-0",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.saveAndAllowMensuration()}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.buttons.save_and_allow_mensuration'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.clientId || _vm.protocol.assigneeId)?_c('router-link',{staticClass:"btn btn-primary btn-sm mr-2 mb-2 mb-md-0",attrs:{"to":{ name: 'client-edit', params: { clientId: _vm.clientId || _vm.protocol.assigneeId}}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.cancel')))])]):_c('router-link',{staticClass:"btn btn-primary btn-sm mr-2",attrs:{"to":{ name: 'protocols'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.cancel')))])])],1)])],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.listTasks)?_c('tasks',{attrs:{"protocol":_vm.protocol,"protocol":_vm.protocol,"taskTypes":_vm.taskNotDttTypes,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideTasks":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksDTT)?_c('tasks-d-t-t',{attrs:{"protocol":_vm.protocol,"protocol":_vm.protocol,"showDeleteButton":_vm.showDeleteButton,"transferConditionValue":_vm.transferConditionValue,"taskTypes":_vm.taskTypes,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideTasks":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksUSD)?_c('tasks-usd',{attrs:{"protocol":_vm.protocol,"taskTypes":_vm.taskTypes,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideTasks":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksMand)?_c('tasks-mand',{attrs:{"protocol":_vm.protocol,"protocol":_vm.protocol,"showDeleteButton":_vm.showDeleteButton,"transferConditionValue":_vm.transferConditionValue,"taskTypes":_vm.taskTypesMand,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideMands":_vm.hideMands,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksShaping)?_c('tasks-shaping',{attrs:{"protocol":_vm.protocol,"taskTypes":_vm.taskTypes,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideTasks":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksChain)?_c('tasks-chain',{attrs:{"protocol":_vm.protocol,"taskTypes":_vm.taskNotDttTypes,"selectedTaskTypeTitle":_vm.selectedTaskTypeTitle,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hideTasks":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),(_vm.listTasksPecsWithDiscrimination)?_c('tasks-pecs3',{attrs:{"protocol":_vm.protocol,"protocol":_vm.protocol,"showDeleteButton":_vm.showDeleteButton,"transferConditionValue":_vm.transferConditionValue,"selectedStagesTitle":_vm.selectedStagesTitle,"is-new":_vm.isNew,"change-from-client":!_vm.showDeleteButton},on:{"editProtocol":function($event){_vm.editProtocol(true)},"createProtocol":function($event){_vm.createProtocol(true)},"hidePecsWithDiscrimination":_vm.hideTasks,"changeCanPublish":_vm.changeCanPublish,"protocolChanged":function($event){_vm.setIsChanged(true)}}}):_vm._e(),_vm._v(" "),_c('confirm-change-modal',{attrs:{"visible":_vm.isOpen},on:{"close":_vm.cancel,"accept":_vm.accept}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.acceptDelete,"cancel":_vm.cancelDelete},model:{value:(_vm.isTaskDeleteOpen),callback:function ($$v) {_vm.isTaskDeleteOpen=$$v},expression:"isTaskDeleteOpen"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.confirm_delete_mand'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.acceptDeleteMand,"cancel":_vm.cancelDeleteMand},model:{value:(_vm.isMandDeleteOpen),callback:function ($$v) {_vm.isMandDeleteOpen=$$v},expression:"isMandDeleteOpen"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")(_vm.isShaping ? 'protocol.delete_criteria_title' : 'protocol.delete_set'),"accept":_vm._f("trans")('buttons.continue'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.changeStimul,"cancel":_vm.closeStimul},model:{value:(_vm.isModalAcceptPopup),callback:function ($$v) {_vm.isModalAcceptPopup=$$v},expression:"isModalAcceptPopup"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('protocol.description_on_delete'),"accept":_vm._f("trans")('buttons.continue')},on:{"accept":_vm.closeStimul},model:{value:(_vm.isModalCantDelete),callback:function ($$v) {_vm.isModalCantDelete=$$v},expression:"isModalCantDelete"}}),_vm._v(" "),(_vm.changedSavePopup)?_c('div',[_c('change-fixing-modal',{attrs:{"visible":_vm.changedSavePopup,"protocol":_vm.protocol,"client":_vm.client,"disabledNotImportantChanges":_vm.disabledNotImportantChanges},on:{"accept":_vm.acceptSave,"cancel":_vm.cancelSave}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolDashboardLayout_vue__ = __webpack_require__(585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3416d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolDashboardLayout_vue__ = __webpack_require__(1239);
function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolDashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3416d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolDashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[(!_vm.isTherapist)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('nav',{staticClass:"mdc-tab-bar mdc-tab-bar-upgraded"},[_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active': 'protocols' === _vm.route.name},attrs:{"to":{name: 'protocols'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocols')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'mdc-tab--active': 'bids' === _vm.route.name},attrs:{"to":{name: 'bids'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('protocol.bids')))])])],1),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_user_client_components_List__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_user_curator_components_List__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user_client_components_Profile__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dashboardParent_components_AppealsLayout__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dashboardParent_components_UndesirableBehaviorLayout__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_user_client_components_UserDashboardLayout__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user_curator_profile_components_Profile__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_hooks_canViewCleint__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_hooks_canViewClients__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_hooks_canViewCurators__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_hooks_canViewCurator__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dro_routes__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__randomRotation_routes__ = __webpack_require__(1298);

















/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/users',
  component: __WEBPACK_IMPORTED_MODULE_5__modules_user_client_components_UserDashboardLayout__["a" /* default */],
  children: [{
    path: 'clients',
    name: 'client',
    component: __WEBPACK_IMPORTED_MODULE_0__modules_user_client_components_List__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_8__router_hooks_canViewClients__["a" /* default */]
  }, {
    path: 'clients/:clientId/edit',
    name: 'client-edit',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_user_client_components_Profile__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_7__router_hooks_canViewCleint__["a" /* default */]
  }, {
    path: 'clients/:clientId/appeals',
    name: 'client-appeals',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_dashboardParent_components_AppealsLayout__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_7__router_hooks_canViewCleint__["a" /* default */]
  }, {
    path: 'clients/:clientId/undesirable-behavior',
    name: 'client-undesirable-behavior',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_dashboardParent_components_UndesirableBehaviorLayout__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_7__router_hooks_canViewCleint__["a" /* default */]
  }, {
    path: 'curators',
    name: 'curator',
    component: __WEBPACK_IMPORTED_MODULE_1__modules_user_curator_components_List__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_9__router_hooks_canViewCurators__["a" /* default */]
  }, {
    path: 'curators/:id/edit',
    name: 'curator-edit',
    component: __WEBPACK_IMPORTED_MODULE_6__modules_user_curator_profile_components_Profile__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_10__router_hooks_canViewCurator__["a" /* default */],
    props: true
  }].concat(__WEBPACK_IMPORTED_MODULE_11__dro_routes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__randomRotation_routes__["a" /* default */])
}]);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a3427e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1248);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7a3427e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8994f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1246);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8994f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managers_ClinicalCenterApiManager__ = __webpack_require__(1244);



var BASE_URL = "https://app.autismtech.online/api" + '/users';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__managers_ClinicalCenterApiManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_axios___default.a, BASE_URL + '/centers'));

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Clinical Center API Manager.
 */
var ClinicalCenterApiManager = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param {String} url
     */
    function ClinicalCenterApiManager(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    /**
     * Search all entities.
     *
     * @param {String} search
     * @param {Number} perPage
     * @param {Number} page
     *
     * @returns {Promise<any>}
     */
    ClinicalCenterApiManager.prototype.search = function (search, perPage, page) {
        if (search === void 0) { search = ''; }
        if (perPage === void 0) { perPage = 10; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("" + this.url, {
                            search: search,
                            perPage: perPage,
                            page: page
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ClinicalCenterApiManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (ClinicalCenterApiManager);


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  PER_PAGE: 10,
  PAGE: 1,
  FIRST_TIMES_CHARACTERS_LENGTH: 12,
  MIN_CHARACTERS_LENGTH: 1
});

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{staticClass:"client-modal",attrs:{"title":_vm._f("trans")(!_vm.isEdit ? 'user.add_client' : 'user.edit_client'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.close,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[(_vm.errors.has('isValidationError'))?_c('div',{staticClass:"form-group row mb-2"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('isValidationError')))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('clinicalCenter'), 'is-clear': !_vm.user.clinicalCenter},attrs:{"id":"clinicalCenter","name":"clinicalCenter","label":"name","options":_vm.clinicalCentersNew,"on-change":_vm.onChangeClinicalCenter,"data-vv-validate-on":"none","data-vv-name":"clinicalCenter","data-vv-as":_vm._f("trans")('user.clinical_center')},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n                        "+_vm._s(option.name)+"\n                    ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n                        "+_vm._s(option.name)+"\n                    ")]}}]),model:{value:(_vm.user.clinicalCenter),callback:function ($$v) {_vm.$set(_vm.user, "clinicalCenter", $$v)},expression:"user.clinicalCenter"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                            "+_vm._s(_vm._f("trans")('user.clinical_center_no_data'))+"\n                        ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('clinicalCenter') }},[_vm._v(_vm._s(_vm._f("trans")('user.clinical_center')))]),_vm._v(" "),(_vm.errors.has('clinicalCenter'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('clinicalCenter')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 timezone-list"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('timezone'), 'is-clear': !_vm.userTimezone},attrs:{"options":_vm.timezonesListNew,"name":"timezone","filterable":false,"onSearch":_vm.onSearchTimezone,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.timezone')},model:{value:(_vm.userTimezone),callback:function ($$v) {_vm.userTimezone=$$v},expression:"userTimezone"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('user.type_the_timezone_to_search'))+"\n                  ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('timezone') }},[_vm._v(_vm._s(_vm._f("trans")('validation.attributes.timezone')))]),_vm._v(" "),(_vm.errors.has('timezone'))?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('timezone')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_dash|max:8'),expression:"'required|alpha_dash|max:8'"}],class:{'is-invalid': _vm.errors.has('code')},attrs:{"id":"code","label":_vm._f("trans")('user.client_code'),"type":"text","name":"code","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('user.client_code')},model:{value:(_vm.user.code),callback:function ($$v) {_vm.$set(_vm.user, "code", $$v)},expression:"user.code"}}),_vm._v(" "),(_vm.errors.has('code'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('code')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"therapistsSelect",staticClass:"aut-dropdown",class:{'is-invalid': _vm.errors.has('therapists'), 'is-clear': !_vm.therapists.length &&  !_vm.searchText},attrs:{"id":"therapists","name":"therapists","label":"id","options":_vm.therapistsNew,"filterable":false,"onSearch":_vm.onSearchTherapist,"on-change":_vm.onChangeTherapist,"data-vv-validate-on":"none","data-vv-name":"therapists","data-vv-as":_vm._f("trans")('user.therapists'),"multiple":""},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n                  "+_vm._s(option.displayName)+"\n                ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n                  "+_vm._s(option.displayName)+"\n\n                ")]}}]),model:{value:(_vm.user.therapists),callback:function ($$v) {_vm.$set(_vm.user, "therapists", $$v)},expression:"user.therapists"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('user.type_the_therapist_name_to_search'))+"\n                  ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('therapists') }},[_vm._v(_vm._s(_vm._f("trans")('user.therapists')))]),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('user.start_therapist')))]),_vm._v(" "),(_vm.errors.has('therapists') && _vm.searchText)?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('errors.choose_therapist_from_list')))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('therapists') && !_vm.searchText)?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('therapists')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}),expression:"{required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}"}],class:{'is-invalid': _vm.errors.has('username') || (_vm.validationError && _vm.validationError.username)},attrs:{"id":"username","label":_vm._f("trans")('user.username'),"type":"text","name":"username","autocomplete":"new-username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('user.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.validationError && _vm.validationError.username)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.validationError.username.message))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('username') && _vm.errors.firstRule('username') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('username')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('username') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.userName})))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],class:{'is-invalid': _vm.errors.has('displayName')},attrs:{"id":"displayName","label":_vm._f("trans")('user.display_name'),"type":"text","name":"displayName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('user.display_name')},model:{value:(_vm.user.displayName),callback:function ($$v) {_vm.$set(_vm.user, "displayName", $$v)},expression:"user.displayName"}}),_vm._v(" "),(_vm.errors.has('displayName'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('displayName')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16'),expression:"'min:8|max:16'"}],ref:"password",class:{'is-invalid': _vm.errors.has('password')},attrs:{"id":"password","type":"password","label":_vm._f("trans")(_vm.isEdit ? 'validation.attributes.new_password' : 'validation.attributes.password'),"name":"password","value":_vm.user.password,"autocomplete":"new-password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),(_vm.errors.has('password') || _vm.errors.has('form-pass.password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.errors.first('password')  || _vm.errors.first('form-pass.password'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('passwords.password_subscription'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16|confirmed:password'),expression:"'min:8|max:16|confirmed:password'"}],class:{'is-invalid': _vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"value":_vm.user.passwordConfirmation,"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password_confirmation')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.passwordConfirmation),callback:function ($$v) {_vm.$set(_vm.user, "passwordConfirmation", $$v)},expression:"user.passwordConfirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('validation.confirmed', {attribute: _vm.passwordLabel}))+"\n                ")]):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdc-menu-anchor',[_c('mdc-button',{attrs:{"raised":""},on:{"click":function($event){_vm.isOpen=true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('mdc-menu',{model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(_vm.showEdit)?_c('mdc-menu-item',[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.editItem(_vm.item)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('user.edit'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.showDelete)?_c('mdc-menu-item',[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.showDeletePopup($event)}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('user.delete'))+"\n                ")])]):_vm._e()],1)],1),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.deleteItem,"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center"},[(_vm.isTherapist && !_vm.isMensurationForbidden)?_c('div',{staticClass:"row pt-2 pt-md-0"},[_c('div',{staticClass:"col-sm-4 col-lg-6"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('user.clients')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-lg-6 text-right",class:{'hash-invalid': _vm.errors.has('code') || _vm.responseHashError}},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_dash|max:8'),expression:"'required|alpha_dash|max:8'"}],staticClass:"header-btn client-hash",class:{'is-invalid': _vm.errors.has('code') || _vm.responseHashError},attrs:{"id":"code","label":_vm._f("trans")('user.clientHash'),"type":"text","name":"code","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('user.clientHash')},model:{value:(_vm.user.code),callback:function ($$v) {_vm.$set(_vm.user, "code", $$v)},expression:"user.code"}}),_vm._v(" "),(_vm.errors.has('code'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('code')))])]):_vm._e(),_vm._v(" "),(_vm.responseHashError && !_vm.errors.has('code'))?_c('span',{staticClass:"invalid-feedback",class:{'d-block': _vm.responseHashError}},[_c('strong',[_vm._v(_vm._s(_vm.responseHashError))])]):_vm._e(),_vm._v(" "),_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":function($event){$event.preventDefault();return _vm.addHashBtnClick($event)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.add'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange},on:{"on-search":_vm.onSearchEnter},scopedSlots:_vm._u([{key:"client",fn:function(props){return _c('div',{},[_c('router-link',{staticClass:"name-link",attrs:{"to":{ name: 'client-edit', params: { clientId: props.row.id }}}},[_c('div',{staticClass:"icon-circle icon-purple"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.C')))]):_vm._e()]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(props.row.code))])])],1)}},{key:"action",fn:function(props){return _c('div',{},[(_vm.canUpdateClient || _vm.canDeleteClient)?_c('client-btn',{attrs:{"item":props.row,"showEdit":_vm.canUpdateClient,"showDelete":_vm.canDeleteClient},on:{"editItem":_vm.onEditBtnClick,"deleteItem":_vm.onDeleteBtnClick}}):_vm._e()],1)}}])}),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[(_vm.canCreateClient && !_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.onAddCuratorModalBtnClick}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.add_client'))+"\n      ")])],1):_vm._e()]),_vm._v(" "),_c('client-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3156e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1252);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da3156e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fdf54b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1251);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fdf54b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")(!_vm.isEdit ? 'user.add_curator' : 'user.edit_curator'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.close,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}),expression:"{required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}"}],class:{'is-invalid': _vm.errors.has('username') || (_vm.validationError && _vm.validationError.username)},attrs:{"id":"username","type":"text","label":_vm._f("trans")('validation.attributes.username'),"name":"username","autocomplete":"new-username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.validationError && _vm.validationError.username)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.validationError.username.message))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('username') && _vm.errors.firstRule('username') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('username')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('username') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.userName})))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],class:{'is-invalid': _vm.errors.has('displayName')},attrs:{"id":"displayName","type":"text","label":_vm._f("trans")('validation.attributes.displayName'),"name":"displayName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.displayName')},model:{value:(_vm.user.displayName),callback:function ($$v) {_vm.$set(_vm.user, "displayName", $$v)},expression:"user.displayName"}}),_vm._v(" "),(_vm.errors.has('displayName'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('displayName')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16'),expression:"'min:8|max:16'"}],ref:"password",class:{'is-invalid': _vm.errors.has('password')},attrs:{"id":"password","type":"password","label":_vm._f("trans")(_vm.isEdit ? 'validation.attributes.new_password' : 'validation.attributes.password'),"name":"password","value":_vm.user.password,"data-vv-validate-on":"none","autocomplete":"new-password","data-vv-as":_vm._f("trans")('validation.attributes.password')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),(_vm.errors.has('password') || _vm.errors.has('form-pass.password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                          "+_vm._s(_vm.errors.first('password')  || _vm.errors.first('form-pass.password'))+"\n                      ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('passwords.password_subscription'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16|confirmed:password'),expression:"'min:8|max:16|confirmed:password'"}],class:{'is-invalid': _vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"value":_vm.user.passwordConfirmation,"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password_confirmation')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.passwordConfirmation),callback:function ($$v) {_vm.$set(_vm.user, "passwordConfirmation", $$v)},expression:"user.passwordConfirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('validation.confirmed', {attribute: _vm.passwordLabel}))+"\n        ")]):_vm._e()],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curator-table justify-content-center"},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange},on:{"on-search":_vm.onSearchEnter},scopedSlots:_vm._u([{key:"curators",fn:function(props){return _c('div',{},[_c('router-link',{staticClass:"name-link",attrs:{"to":{ name: 'curator-edit', params: { id: props.row.id }}}},[_c('div',{staticClass:"icon-circle icon-indigo"},[(!_vm.isMobile)?_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm._f("toFirstLetter")(props.row.displayName)))]):_vm._e()]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(props.row.displayName))])])],1)}},{key:"curator-edit",fn:function(props){return (_vm.isMobile)?_c('div',{},[_c('router-link',{attrs:{"to":{ name: 'curator-edit', params: { id: props.row.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.displayName)),_c('br'),_vm._v("\n                    "+_vm._s(props.row.lastName)+"\n                ")])])],1):_vm._e()}},{key:"action",fn:function(props){return (!_vm.isMensurationForbidden)?_c('div',{},[(_vm.canUpdateCurator || _vm.canDeleteCurator)?_c('client-btn',{attrs:{"item":props.row,"showEdit":_vm.canUpdateCurator,"showDelete":_vm.canDeleteCurator},on:{"editItem":_vm.onEditBtnClick,"deleteItem":_vm.onDeleteBtnClick}}):_vm._e()],1):_vm._e()}},{key:"therapistsCount",fn:function(props){return _c('div',{},[_vm._v("\n            "+_vm._s(props.row.therapistsCount)+"/"+_vm._s(props.row.clientsCount)+"\n        ")])}},{key:"bidsOnWorkCount",fn:function(props){return _c('div',{},[_vm._v("\n            "+_vm._s(props.row.bidsOnWorkCount)+"/"+_vm._s(props.row.overdueBidsCount)+"\n        ")])}}])}),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[(_vm.canCreateCurator && !_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.onAddCuratorModalBtnClick}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('user.add_curator'))+"\n            ")])],1):_vm._e()]),_vm._v(" "),_c('curator-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13948c0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1266);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13948c0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientInfo_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010ede86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientInfo_vue__ = __webpack_require__(1255);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010ede86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"page-title col-md-8 col-sm-12"},[_vm._v(_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")]),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('div',{staticClass:"col-md-4 col-sm-12 btn-row"},[(_vm.isBCBA || _vm.isCurator || (_vm.isTherapist && _vm.hasAssignedQuiz))?_c('mdc-button',{staticClass:"btn btn-link btn-info",attrs:{"raised":"","to":{name: 'quiz', params: {clientId: _vm.clientId }}}},[_c('img',{attrs:{"src":__webpack_require__(593),"alt":"","height":"16"}}),_vm._v("\n                "+_vm._s(_vm._f("trans")('quiz.quiz'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.isTherapist && !_vm.hasAssignedQuiz)?_c('span',{staticClass:"btn btn-link btn-info mdc-button mdc-button--raised mdc-ripple-upgraded disabled"},[_c('img',{attrs:{"src":__webpack_require__(593),"alt":"","height":"16"}}),_vm._v("\n                "+_vm._s(_vm._f("trans")('quiz.quiz'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('mdc-button',{staticClass:"btn btn-link btn-info",attrs:{"raised":"","to":{name: 'client-undesirable-behavior', params: {clientId: _vm.clientId } }}},[_c('img',{attrs:{"src":__webpack_require__(1256),"alt":""}}),_vm._v("\n                "+_vm._s(_vm._f("trans")('behavior.UB'))+"\n            ")]),_vm._v(" "),_c('mdc-button',{staticClass:"btn btn-link btn-info",attrs:{"raised":"","to":{name: 'client-appeals', params: {clientId: _vm.clientId }}}},[_c('img',{attrs:{"src":__webpack_require__(1257),"alt":""}}),_vm._v("\n                "+_vm._s(_vm._f("trans")('appeals.appeals'))+"\n            ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-block mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.clinical_center'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.client.clinicalCenter ? _vm.client.clinicalCenter.name : ''))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.contacts'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.client.displayName)+", "+_vm._s(_vm.client.username))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.curator'))+":")]),_vm._v(" "),_vm._l((_vm.client.curators),function(curator){return _c('dd',[_vm._v("\n                        "+_vm._s(curator.displayName)+"\n                    ")])}),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.therapist'))+":")]),_vm._v(" "),_vm._l((_vm.client.therapists),function(therapist){return _c('dd',[_vm._v("\n                        "+_vm._s(therapist.displayName)+"\n                    ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.hours_therapist'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("asHours")(_vm.client.hoursWithTherapists ? _vm.client.hoursWithTherapists : 0)))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('user.hours_parent'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("asHours")(_vm.client.hoursWithParents ? _vm.client.hoursWithParents : 0)))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDggMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjI1IDEuMjY0MTFWOC4xNDExMkMwLjI1IDguNTYxMzggMC42MTQ1MjkgOC45MDUyMyAxLjA2MDA2IDguOTA1MjNIMi42ODAxOVYxNC4zNjg2QzIuNjgwMTkgMTQuNzU4MyAzLjIyMjk0IDE0Ljg5NTkgMy40MzM1NiAxNC41NTk3TDcuNjM3NzkgNy43NTkwNkM3Ljk1MzcyIDcuMjQ3MTEgNy41NjQ4OSA2LjYxMjkgNi45NDExNCA2LjYxMjlINS4xMTAzOUw3LjEyNzQ1IDEuNTMxNTVDNy4zMjk5NyAxLjAzNDg4IDYuOTQxMTQgMC41IDYuMzc0MDkgMC41SDEuMDYwMDZDMC42MTQ1MjkgMC41IDAuMjUgMC44NDM4NSAwLjI1IDEuMjY0MTFaIiBmaWxsPSIjNkE5N0ZDIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjI1IDJIOS4xMTVDOC44IDEuMTMgNy45NzUgMC41IDcgMC41QzYuMDI1IDAuNSA1LjIgMS4xMyA0Ljg4NSAySDEuNzVDMC45MjUgMiAwLjI1IDIuNjc1IDAuMjUgMy41VjE0QzAuMjUgMTQuODI1IDAuOTI1IDE1LjUgMS43NSAxNS41SDEyLjI1QzEzLjA3NSAxNS41IDEzLjc1IDE0LjgyNSAxMy43NSAxNFYzLjVDMTMuNzUgMi42NzUgMTMuMDc1IDIgMTIuMjUgMlpNNyAyQzcuNDEyNSAyIDcuNzUgMi4zMzc1IDcuNzUgMi43NUM3Ljc1IDMuMTYyNSA3LjQxMjUgMy41IDcgMy41QzYuNTg3NSAzLjUgNi4yNSAzLjE2MjUgNi4yNSAyLjc1QzYuMjUgMi4zMzc1IDYuNTg3NSAyIDcgMlpNNy43NSAxMi41SDRDMy41ODc1IDEyLjUgMy4yNSAxMi4xNjI1IDMuMjUgMTEuNzVDMy4yNSAxMS4zMzc1IDMuNTg3NSAxMSA0IDExSDcuNzVDOC4xNjI1IDExIDguNSAxMS4zMzc1IDguNSAxMS43NUM4LjUgMTIuMTYyNSA4LjE2MjUgMTIuNSA3Ljc1IDEyLjVaTTEwIDkuNUg0QzMuNTg3NSA5LjUgMy4yNSA5LjE2MjUgMy4yNSA4Ljc1QzMuMjUgOC4zMzc1IDMuNTg3NSA4IDQgOEgxMEMxMC40MTI1IDggMTAuNzUgOC4zMzc1IDEwLjc1IDguNzVDMTAuNzUgOS4xNjI1IDEwLjQxMjUgOS41IDEwIDkuNVpNMTAgNi41SDRDMy41ODc1IDYuNSAzLjI1IDYuMTYyNSAzLjI1IDUuNzVDMy4yNSA1LjMzNzUgMy41ODc1IDUgNCA1SDEwQzEwLjQxMjUgNSAxMC43NSA1LjMzNzUgMTAuNzUgNS43NUMxMC43NSA2LjE2MjUgMTAuNDEyNSA2LjUgMTAgNi41WiIgZmlsbD0iIzZBOTdGQyIvPgo8L3N2Zz4K"

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConflictProtocolList_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cf81f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConflictProtocolList_vue__ = __webpack_require__(1259);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConflictProtocolList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cf81f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConflictProtocolList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conflict-list",class:{'without_btn': !(!_vm.isTherapist && !_vm.onlyList && !_vm.isMensurationForbidden)}},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange},on:{"on-search":_vm.onSearchEnter},scopedSlots:_vm._u([{key:"id",fn:function(props){return _c('div',{},[_c('router-link',{attrs:{"to":{ name: 'conflict-list', params: {clientId: _vm.clientId, sessionId: props.row.id }}}},[_c('div',{staticClass:"icon-circle icon-blue"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(props.row.id))]):_vm._e()])])],1)}},{key:"protocols",fn:function(props){return _c('div',{},[_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'conflict-list', params: {clientId: _vm.clientId, sessionId: props.row.id }}}},[_c('strong',[_vm._v(_vm._s(props.row.title))])])],1)}},{key:"stageIndex",fn:function(props){return _c('div',{},[_vm._v("\n      "+_vm._s(props.row.stageIndex + 1)+"\n    ")])}},{key:"action",fn:function(props){return (!_vm.isTherapist && !_vm.isClient)?_c('div',{},[_c('a',{staticClass:"delete-icon",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showDeletePopup(props.row.id)}}},[_c('mdc-icon',{attrs:{"icon":"delete"}})],1)]):_vm._e()}}])}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.onRemoveActiveProtocol(_vm.assignedSessionId)},"cancel":_vm.onModalClose},model:{value:(_vm.isDeleteModalVisible),callback:function ($$v) {_vm.isDeleteModalVisible=$$v},expression:"isDeleteModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModulesList_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5053373e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModulesList_vue__ = __webpack_require__(1265);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModulesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5053373e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModulesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleItem_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ea554f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleItem_vue__ = __webpack_require__(1262);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ea554f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasAccess)?_c('div',{staticClass:"modules-item dro",on:{"click":function($event){_vm.openDetail()}}},[_c('h3',{staticClass:"modules-item__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.title')))]),_vm._v(" "),_c('p',{staticClass:"modules-item__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('dro.description')))]),_vm._v(" "),_c('p',{staticClass:"modules-item__number"},[_vm._v("#1")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleItem_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b9f742_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleItem_vue__ = __webpack_require__(1264);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b9f742_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasAccess)?_c('div',{staticClass:"modules-item rotation",on:{"click":function($event){_vm.openDetail()}}},[_c('h3',{staticClass:"modules-item__title"},[_vm._v(_vm._s(_vm._f("trans")('rotation.title')))]),_vm._v(" "),_c('p',{staticClass:"modules-item__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('rotation.description')))]),_vm._v(" "),_c('p',{staticClass:"modules-item__number"},[_vm._v("#2")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modules"},[(!_vm.isLoadedRotation && _vm.isLoadedDro)?_c('div',[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modules-list"},[_c('dro-module-item',{attrs:{"clientId":_vm.clientId},on:{"isLoaded":_vm.setLoadedDro,"hasAccess":_vm.setHasAccessDro}}),_vm._v(" "),_c('rotation-module-item',{attrs:{"clientId":_vm.clientId},on:{"isLoaded":_vm.setLoadedRotation,"hasAccess":_vm.setHasAccessRotation}})],1),_vm._v(" "),(!_vm.hasAccessDro && !_vm.hasAccessRotation && _vm.isLoadedRotation && _vm.isLoadedDro)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('dro.no_data')))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('client-info',{attrs:{"clientId":_vm.clientId}}),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interactive_modules')))]):_vm._e(),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('modules-list',{attrs:{"clientId":_vm.clientId}}):_vm._e(),_vm._v(" "),((_vm.isBCBA || _vm.isCurator) && !_vm.isPreviousDateSession)?_c('h4',{staticClass:"row-title pt-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.conflict_sessions')))]):_vm._e(),_vm._v(" "),((_vm.isBCBA || _vm.isCurator) && !_vm.isPreviousDateSession)?_c('conflict-protocol-list',{attrs:{"clientId":_vm.clientId,"reload":_vm.reloadBids}}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"row-title pt-4",attrs:{"id":"protocol"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.active_protocols')))]),_vm._v(" "),_c('assigned-protocol-list',{attrs:{"clientId":_vm.clientId,"reload":_vm.reloadBids}}),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('h4',{staticClass:"row-title pt-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.bids_for_protocols')))]):_vm._e(),_vm._v(" "),(!_vm.isPreviousDateSession)?_c('bids-list',{attrs:{"userId":_vm.clientId},on:{"list-reload":_vm.reloadList}}):_vm._e()],1),_vm._v(" "),_c('dashboard-menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[(!_vm.isTherapist && !_vm.isPreviousDateSession)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('nav',{staticClass:"mdc-tab-bar dashboard-menu mdc-tab-bar-upgraded"},[_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.canViewTherapists, 'mdc-tab--active': 'client' === _vm.route.name || 'client-edit' === _vm.route.name},attrs:{"to":{name: 'client'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.clients')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.canViewCurators, 'mdc-tab--active': 'curator' === _vm.route.name || 'curator-edit' === _vm.route.name},attrs:{"to":{name: 'curator'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.curators')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.canViewTherapists, 'mdc-tab--active': 'therapist' === _vm.route.name || 'therapist-edit' === _vm.route.name},attrs:{"to":{name: 'therapist'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.therapists')))])])],1),_vm._v(" "),_c('hr')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view')],1)]),_vm._v(" "),(_vm.isClient)?_c('dashboard-menu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55163940_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1280);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55163940_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CuratorInfo_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ba581c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CuratorInfo_vue__ = __webpack_require__(1271);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CuratorInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ba581c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CuratorInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.curator.id)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.curator.displayName))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachedTherapistList_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b7f73a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachedTherapistList_vue__ = __webpack_require__(1279);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachedTherapistList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b7f73a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachedTherapistList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TherapistItem_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3dd82b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TherapistItem_vue__ = __webpack_require__(1274);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TherapistItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3dd82b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TherapistItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{class:{'action-cell' : _vm.isMobile}},[_c('router-link',{attrs:{"to":{ name: 'therapist-edit', params: { therapistId: _vm.item.id }}}},[_c('div',{staticClass:"icon-circle icon-indigo"},[(!_vm.isMobile)?_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm._f("toFirstLetter")(_vm.item.displayName)))]):_vm._e()]),_vm._v(" "),(!_vm.isMobile)?_c('strong',[_vm._v(_vm._s(_vm.item.displayName))]):_vm._e()])],1),_vm._v(" "),(_vm.isMobile)?_c('td',[_c('router-link',{attrs:{"to":{ name: 'therapist-edit', params: { therapistId: _vm.item.id }}}},[_c('strong',[_vm._v(_vm._s(_vm.item.displayName)+"\n        ")])])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.item.clientsCount)+"\n    ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.item.bidsOnWorkCount)+"\n    ")]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('td',{staticClass:"table-actions"},[_c('a',{staticClass:"delete-icon",on:{"click":function($event){$event.preventDefault();return _vm.deleteItem($event)}}},[_c('mdc-icon',{attrs:{"icon":"delete"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteTherapistModal_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00bfc3ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteTherapistModal_vue__ = __webpack_require__(1276);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteTherapistModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00bfc3ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteTherapistModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete_title'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.confirm,"cancel":_vm.close},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_vm._v("\n    "+_vm._s(_vm._f("trans")('user.confirm_delete_text'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTherapistModal_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f56d8c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTherapistModal_vue__ = __webpack_require__(1278);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTherapistModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f56d8c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTherapistModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.add_therapist'),"accept":_vm._f("trans")('user.add'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.isAcceptDisabled},on:{"accept":_vm.accept,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isLoaded)?_c('div',{staticClass:"container"},[_c('loader',{staticClass:"table-loader"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(_vm.isLoaded)?_c('div',{staticClass:"container"},[(_vm.isListEmpty)?_c('div',[_vm._v(_vm._s(_vm._f("trans")('user.add_therapist_no_data')))]):_vm._e(),_vm._v(" "),(!_vm.isListEmpty)?_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('therapist'), 'is-clear': !_vm.therapistId},attrs:{"id":"mdc-therapist","name":"therapist","label":'displayName',"selected":_vm.therapistId,"options":_vm.therapists,"filterable":false,"searchable":false,"loading":_vm.loading,"isLastPage":_vm.isLastPage,"getOptionTitle":_vm.getOptionTitle,"isLast":_vm.isLast},on:{"next-page":_vm.nextPage,"set-selected":_vm.onSetSelected}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('therapist') }},[_vm._v(_vm._s(_vm._f("trans")('user.choose_therapist_from_list')))]),_vm._v(" "),(_vm.errors.has('therapist_id'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                       "+_vm._s(_vm.errors.first('therapist_id'))+"\n                    ")]):_vm._e()],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"therapist-table justify-content-center"},[_c('search',{attrs:{"placeholder":"Search","placeholder":_vm._f("trans")('user.type_the_therapist_name_to_search'),"disabled":!_vm.isLoaded},on:{"enter":_vm.onSearchEnter},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[(_vm.isMobile)?_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm._f("trans")('user.therapists')))]):_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.therapists')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('user.clients')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('user.request_for_work')))]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('th',{staticClass:"action-cell"}):_vm._e()])]),_vm._v(" "),_c('tbody',[(!_vm.isLoaded)?_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return (_vm.isLoaded)?_c("item",{key:item.id,tag:"tr",attrs:{"item":item},on:{"deleteItem":_vm.onDeleteTherapist}}):_vm._e()})],2)]),_vm._v(" "),(_vm.isEmptyList && _vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('bids.no_data')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2 mt-md-0"},[_c('div',{staticClass:"col-md-12 col-lg-5"},[(_vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[(_vm.paginate.lastPage > 1)?_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"initial-page":_vm.paginate.page,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.canCreateCurator && !_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 col-lg-7 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.toggleAddTherapistModal}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('user.add_therapist'))+"\n            ")])],1):_vm._e()]),_vm._v(" "),_c('add-therapist-modal',{attrs:{"visible":_vm.isAddTherapistModalOpen},on:{"close":_vm.toggleAddTherapistModal,"accept":_vm.onAddTherapist}}),_vm._v(" "),_c('delete-therapist-modal',{attrs:{"visible":_vm.deleteModal.isOpen},on:{"close":_vm.toggleDeleteModal,"confirm":_vm.deleteTherapist}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('curator-info',{attrs:{"id":_vm.id}}),_vm._v(" "),_c('h4',{staticClass:"row-title pt-2"},[_vm._v(_vm._s(_vm._f("trans")('user.attached_therapist_list')))]),_vm._v(" "),_c('therapist-list'),_vm._v(" "),_c('h4',{staticClass:"row-title pt-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.bids_for_protocols')))]),_vm._v(" "),_c('bids-list',{attrs:{"userId":_vm.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user_api_client__ = __webpack_require__(224);



var _this = this;




var isAuthorized = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var clientId, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            clientId = to && to.params && to.params.clientId ? parseInt(to.params.clientId) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__modules_user_api_client__["a" /* default */].hasAccess(clientId);

          case 4:
            response = _context.sent;
            result = response.data.data;


            if (!__WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].can('view_client') && result && result.access) {
              next();
            } else {
              next({ name: 'login' });
            }
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            next({ name: 'client' });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9]]);
  }));

  return function isAuthorized(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].can('view_clients')) {
    next();
  } else {
    next({ name: 'login' });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].can('view_curators')) {
    next();
  } else {
    next({ name: 'login' });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user_api_curator__ = __webpack_require__(159);



var _this = this;




var isAuthorized = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var id, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            id = to && to.params && to.params.id ? parseInt(to.params.id) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__modules_user_api_curator__["a" /* default */].hasAccess(id);

          case 4:
            response = _context.sent;
            result = response.data.data;

            if (!__WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].can('view_curator') && result && result.access) {
              next();
            } else {
              next({ name: 'login' });
            }
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            console.info(_context.t0);
            next({ name: 'login' });

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9]]);
  }));

  return function isAuthorized(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionLayout__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DroLayout__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_hooks_isMensurationForbidden__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__ = __webpack_require__(559);








/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'clients/:clientId/dro',
  name: 'dro',
  component: __WEBPACK_IMPORTED_MODULE_1__components_DroLayout__["a" /* default */],
  props: true,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__["a" /* default */]])
}, {
  path: 'clients/:clientId/dro/session',
  name: 'dro-session',
  component: __WEBPACK_IMPORTED_MODULE_0__components_SessionLayout__["a" /* default */],
  props: true,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router_hooks_isMensurationForbidden__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__["a" /* default */]])
}]);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLayout_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a35091_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLayout_vue__ = __webpack_require__(1293);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a35091_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsTable_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec9446ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsTable_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec9446ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row border settings-table"},[_c('div',{staticClass:"col-md-4"},[_c('dl',{staticClass:"settings-table-item"},[_c('dt',{staticClass:"settings-table-item__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.target_behaviour'))+":")]),_vm._v(" "),_c('dd',{staticClass:"settings-table-item__subtitle"},[_vm._v(_vm._s(_vm._f("aimType")(_vm.settings.aimTypeId)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('dl',{staticClass:"settings-table-item"},[_c('dt',{staticClass:"settings-table-item__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.list.time'))+":")]),_vm._v(" "),_c('dd',{staticClass:"settings-table-item__subtitle"},[_vm._v(_vm._s(_vm._f("minutes")(_vm.intervalDuration)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('dl',{staticClass:"settings-table-item"},[_c('dt',{staticClass:"settings-table-item__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.behaviour_description'))+":")]),_vm._v(" "),_c('dd',{staticClass:"settings-table-item__subtitle"},[_vm._v(_vm._s(_vm.settings.behaviourDescription))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentIntervalForm_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c87c72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentIntervalForm_vue__ = __webpack_require__(1290);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentIntervalForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c87c72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentIntervalForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isIntervalStarted && _vm.isLoaded)?_c('div',{staticClass:"dro-settings row  mt-3"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_duration_units'))+":")]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.min'),"value":"1"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"intervalDurationUnitId","label":_vm._f("trans")('dro.sec'),"value":"2"},model:{value:(_vm.form.intervalDurationUnitId),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationUnitId", $$v)},expression:"form.intervalDurationUnitId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[(_vm.form.intervalDurationUnitId == 1)?_c('h5',{staticClass:"title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('dro.interval_time_range_minutes'))+":")]):(_vm.form.intervalDurationUnitId == 2)?_c('h5',{staticClass:"title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('dro.interval_time_range_seconds'))+":")]):_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('dro.interval_time_range'))+":")]),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:100'),expression:"'required|numeric|min_value:1|max_value:100'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"100","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 2)?_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1|max_value:300'),expression:"'required|numeric|min_value:1|max_value:300'"}],class:{'is-invalid': _vm.errors.has('intervalDurationValue')},attrs:{"name":"intervalDurationValue","type":"number","min":"1","max":"300","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.report.intervalDurationValue')},model:{value:(_vm.form.intervalDurationValue),callback:function ($$v) {_vm.$set(_vm.form, "intervalDurationValue", $$v)},expression:"form.intervalDurationValue"}}):_vm._e(),_vm._v(" "),(_vm.errors.has('intervalDurationValue'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                                          "+_vm._s(_vm.errors.first('intervalDurationValue'))+"\n                                      ")]):_vm._e(),_vm._v(" "),(_vm.form.intervalDurationUnitId == 1)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.min')))]):(_vm.form.intervalDurationUnitId == 2)?_c('label',[_vm._v(_vm._s(_vm._f("trans")('dro.sec')))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('interval-progress-bar')],1)]),_vm._v(" "),_c('div',{staticClass:"dro-settings row mt-5"},[(_vm.isIntervalStarted)?_c('div',{staticClass:"col-md-12 text-center"},[(_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-success text-uppercase col-sm-6 mb-3",attrs:{"type":"submit"},on:{"click":function($event){_vm.onBehaviourHappened()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_vm._v(_vm._s(_vm._f("trans")('dro.target_behaviour'))+"\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isIntervalStarted)?_c('div',{staticClass:"col-md-12 text-center"},[(_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-warning text-uppercase col-sm-6 mt-2",attrs:{"type":"submit"},on:{"click":function($event){_vm.finishSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_vm._v(_vm._s(_vm._f("trans")('dro.finish_session'))+"\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isIntervalStarted)?_c('div',{staticClass:"col-md-12 text-center"},[(!_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-success text-uppercase col-sm-6 text-uppercase mb-3",attrs:{"type":"submit"},on:{"click":function($event){_vm.startSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_vm._v(_vm._s(_vm._f("trans")('dro.continue_session'))+"\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isIntervalStarted)?_c('div',{staticClass:"col-md-12 text-center"},[(!_vm.isIntervalStarted)?_c('mdc-button',{staticClass:"button-warning text-uppercase col-sm-6 mt-2",attrs:{"type":"submit"},on:{"click":function($event){_vm.saveSession()},"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==32){ return null; }return _vm.clickPrevent($event)}}},[_vm._v(_vm._s(_vm._f("trans")('dro.finish_session'))+"\n        ")]):_vm._e()],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalList_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dbd43b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalList_vue__ = __webpack_require__(1292);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntervalList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dbd43b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntervalList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('table',{staticClass:"table table-sm text-center interval-table"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.list.interval')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.list.time')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('dro.list.target_behaviour')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.intervals),function(interval){return _c('tr',{key:interval.index},[_c('td',[_vm._v(_vm._s(interval.index)+_vm._s(_vm._f("trans")('dro.list.interval_suffix')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("minutes")(interval.duration)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("minutes")((interval.behaviourHappenedAt === null ? '-' : interval.behaviourHappenedAt))))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'visibility-hidden' : (_vm.isModalVisible && _vm.isMobile)}},[(!_vm.loaded || _vm.processing)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"dro"},[_c('button',{staticClass:"btn btn-light btn-sm  mb-1",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])]),_vm._v(" "),_c('h4',{staticClass:"dro__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.title')))]),_vm._v(" "),_c('p',{staticClass:"dro__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('dro.interactive_module_one')))]),_vm._v(" "),_c('p',{staticClass:"dro__description"},[_vm._v(_vm._s(_vm._f("trans")('dro.description')))])]),_vm._v(" "),(!_vm.isCurrentUserStartedSessionBlock)?_c('settings-form',{attrs:{"settings":_vm.form},on:{"session-settings-set":_vm.onSessionSettingsSet}}):_vm._e(),_vm._v(" "),(_vm.isCurrentUserStartedSessionBlock)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('settings-table'),_vm._v(" "),_c('current-interval-form',{on:{"save-session":_vm.onSaveSession}}),_vm._v(" "),(_vm.isIntervalsNotEmpty)?_c('interval-list'):_vm._e()],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 mt-4 mt-md-0"},[_c('instruction',{attrs:{"text":_vm._f("trans")('dro.instructions.text'),"header":_vm._f("trans")('dro.instructions.header'),"short-text-length":300}})],1)]):_vm._e(),_vm._v(" "),_c('dashboard-menu',{attrs:{"hideDroModal":_vm.hideDroModal}})],1),_vm._v(" "),(_vm.isModalVisible)?_c('div',[_c('report-modal',{attrs:{"visible":_vm.isModalVisible},on:{"close":_vm.onClose}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DroLayout_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fbff99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DroLayout_vue__ = __webpack_require__(1297);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DroLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fbff99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DroLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DroReport_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5d7d46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DroReport_vue__ = __webpack_require__(1296);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DroReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad5d7d46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DroReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'without_btn': _vm.hasPager}},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"listWithHeaderView":true,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"exportReport",fn:function(props){return _c('div',{},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.exportReport(props.row.id)}}},[_c('mdc-icon',{attrs:{"icon":"save_alt"}})],1)])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-wrap align-items-center justify-content-between"},[_c('div',{staticClass:"dro col-lg-9 pl-0"},[_c('button',{staticClass:"btn btn-light btn-sm  mb-1",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])]),_vm._v(" "),_c('h4',{staticClass:"dro__title"},[_vm._v(_vm._s(_vm._f("trans")('dro.title')))]),_vm._v(" "),_c('p',{staticClass:"dro__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('dro.interactive_module_one')))]),_vm._v(" "),_c('p',{staticClass:"dro__description"},[_vm._v(_vm._s(_vm._f("trans")('dro.description')))])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":"","to":{name: 'dro-session'}}},[_vm._v(_vm._s(_vm._f("trans")('dro.hold_session'))+"\n            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-4"},[_c('dro-report')],1),_vm._v(" "),_c('dashboard-menu',{attrs:{"hideDroModal":_vm.hideDroModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SessionLayout__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RotationLayout__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_hooks_isMensurationForbidden__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__ = __webpack_require__(1311);








/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'clients/:clientId/rotation',
  name: 'rotation',
  component: __WEBPACK_IMPORTED_MODULE_1__components_RotationLayout__["a" /* default */],
  props: true,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__["a" /* default */]])
}, {
  path: 'clients/:clientId/rotation/session',
  name: 'rotation-session',
  component: __WEBPACK_IMPORTED_MODULE_0__components_SessionLayout__["a" /* default */],
  props: true,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_2_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_3__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router_hooks_isMensurationForbidden__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__hooks_hasAccess__["a" /* default */]])
}]);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLayout_vue__ = __webpack_require__(613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da753a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLayout_vue__ = __webpack_require__(1306);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da753a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsForm_vue__ = __webpack_require__(614);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91200568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsForm_vue__ = __webpack_require__(1301);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91200568_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"rounded border shadow py-3"},[_c('div',{staticClass:"rotation-settings d-flex flex-wrap",attrs:{"id":"rotation-settings"}},[_c('p',{staticClass:"rotation-settings__title col-md-12"},[_vm._v(_vm._s(_vm._f("trans")('rotation.write_names_for_stimulus')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 col-lg-4"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-unique'),expression:"'required|check-unique'"}],class:{'is-invalid': _vm.errors.has('firstStimul')},attrs:{"name":"firstStimul","type":"text","disabled":_vm.tableWasBuild,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('rotation.stimulus_one'),"label":_vm._f("trans")('rotation.stimulus_one')},model:{value:(_vm.form[0]),callback:function ($$v) {_vm.$set(_vm.form, 0, $$v)},expression:"form[0]"}}),_vm._v(" "),(_vm.errors.has('firstStimul'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n            "+_vm._s(_vm.errors.first('firstStimul'))+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 col-lg-4"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-unique'),expression:"'required|check-unique'"}],class:{'is-invalid': _vm.errors.has('secondStimul')},attrs:{"name":"secondStimul","type":"text","disabled":_vm.tableWasBuild,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('rotation.stimulus_two'),"label":_vm._f("trans")('rotation.stimulus_two')},model:{value:(_vm.form[1]),callback:function ($$v) {_vm.$set(_vm.form, 1, $$v)},expression:"form[1]"}}),_vm._v(" "),(_vm.errors.has('secondStimul'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n            "+_vm._s(_vm.errors.first('secondStimul'))+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 col-lg-4"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-unique'),expression:"'required|check-unique'"}],class:{'is-invalid': _vm.errors.has('thirdStimul')},attrs:{"name":"thirdStimul","type":"text","disabled":_vm.tableWasBuild,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('rotation.stimulus_three'),"label":_vm._f("trans")('rotation.stimulus_three')},model:{value:(_vm.form[2]),callback:function ($$v) {_vm.$set(_vm.form, 2, $$v)},expression:"form[2]"}}),_vm._v(" "),(_vm.errors.has('thirdStimul'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n            "+_vm._s(_vm.errors.first('thirdStimul'))+"\n          ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"form group-row"},[_c('div',{staticClass:"text-left"},[(_vm.tableWasBuild)?_c('mdc-button',{staticClass:"button-primary col-sm-6 col-lg-4 mt-4",attrs:{"type":"submit","id":"rotation-setting__button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.destroyTable()}}},[_vm._v(_vm._s(_vm._f("trans")('rotation.destroy_table'))+"\n      ")]):_c('mdc-button',{staticClass:"button-primary col-sm-6 col-lg-4 mt-4",attrs:{"type":"submit","id":"rotation-setting__button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.buildTable()}}},[_vm._v(_vm._s(_vm._f("trans")('rotation.build_table'))+"\n      ")])],1)]),_vm._v(" "),(_vm.loaded)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportModal_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1f69a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportModal_vue__ = __webpack_require__(1303);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1f69a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{class:{'fullscreen-dialog' : _vm.isMobile},attrs:{"title":_vm._f("trans")('rotation.report.header'),"accept":_vm._f("trans")('rotation.save'),"cancel":_vm._f("trans")('rotation.cancel'),"accept-disabled":_vm.disabled},on:{"validate":_vm.save,"accept":_vm.close,"close":_vm.close,"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(!_vm.isMobile)?_c('div',[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.date'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.date))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.client'))+":")]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.assignee.code))])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"gray-dark-sm"},[_vm._v(_vm._s(_vm.auditor.role))]),_vm._v(" "),_c('p',{staticClass:"gray-700"},[_vm._v(_vm._s(_vm.auditor.name))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.successful_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.hint_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.fail_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.no_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.all_approaches_count')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700 text-center"},[_c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.successfulAnswerRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.hintRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.failAnswerRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percent")(_vm.noAnswerRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.allApproachesCount))])])])]):_vm._e()])]):_c('div',[_c('mdc-toolbar',{staticClass:"navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-0 mb-md-4",attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[_c('span',{on:{"click":_vm.cancel}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.report')))])]),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[_c('button',{staticClass:"btn btn-link",on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_vm._v(_vm._s(_vm._f("trans")('dro.back_to_reports')))])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},[_c('div',{staticClass:"mobile-table__row mx-0"},[_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.successful_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.successfulAnswerRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.hint_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.hintRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.fail_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.failAnswerRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.no_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("percent")(_vm.noAnswerRate)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.all_approaches_count')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm.allApproachesCount))])])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionsList_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ce0246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionsList_vue__ = __webpack_require__(1305);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ce0246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmptySessions && !_vm.isEmptyTempChosenResult)?_c('div',{staticClass:"sessions"},[(!_vm.isMobile)?_c('div',_vm._l((_vm.sessions),function(session,key,sessionIndex){return _c('div',{staticClass:"session"},[_c('div',{staticClass:"session-info d-flex"},[_c('div',{staticClass:"col-md-2 px-0 text-left"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.session'))+" "+_vm._s((sessionIndex + 1)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"}),_vm._v(" "),_c('div',{staticClass:"col-md-2  px-0 text-center"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.result')))])])]),_vm._v(" "),_c('div',{staticClass:"session-head d-flex text-center"},[_c('div',{staticClass:"col-md-1  px-0"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.block')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.L')))])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.M')))])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.R')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2  px-0"},[_c('p',[_vm._v("'+' '-' '"+_vm._s(_vm._f("trans")('rotation.p'))+"'")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((session.blocks),function(block,blockIndex){return _c('div',{key:blockIndex,staticClass:"session-block row"},[_c('div',{staticClass:"col-md-1"},[_vm._v("\n            "+_vm._s((block.index))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"row"},_vm._l((block.stimuli),function(blockCell,index){return _c('div',{key:index,staticClass:"col-4 px-0"},[_c('div',{staticClass:"session-block__cell",class:{'session-block__cell--active' : blockCell.correct}},[_c('p',[_vm._v(_vm._s(blockCell.name))])])])}))]),_vm._v(" "),_c('div',{staticClass:"session-block__radios col-md-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 px-0"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[sessionIndex][blockIndex].value),expression:"tempChosenResult[sessionIndex][blockIndex].value"}],attrs:{"type":"radio","name":'radios[' + sessionIndex + '][' + blockIndex + ']',"disabled":_vm.tempChosenResult[sessionIndex][blockIndex].isChecked},domProps:{"value":_vm.successfulAnswer,"checked":_vm._q(_vm.tempChosenResult[sessionIndex][blockIndex].value,_vm.successfulAnswer)},on:{"click":function($event){_vm.setChecked(sessionIndex, blockIndex)},"change":function($event){_vm.$set(_vm.tempChosenResult[sessionIndex][blockIndex], "value", _vm.successfulAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text big"},[_vm._v("\n                    +\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 px-0"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[sessionIndex][blockIndex].value),expression:"tempChosenResult[sessionIndex][blockIndex].value"}],attrs:{"type":"radio","name":'radios[' + sessionIndex + '][' + blockIndex + ']',"disabled":_vm.tempChosenResult[sessionIndex][blockIndex].isChecked},domProps:{"value":_vm.failAnswer,"checked":_vm._q(_vm.tempChosenResult[sessionIndex][blockIndex].value,_vm.failAnswer)},on:{"click":function($event){_vm.setChecked(sessionIndex, blockIndex)},"change":function($event){_vm.$set(_vm.tempChosenResult[sessionIndex][blockIndex], "value", _vm.failAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text big"},[_vm._v("\n                  —\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 px-0"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[sessionIndex][blockIndex].value),expression:"tempChosenResult[sessionIndex][blockIndex].value"}],attrs:{"type":"radio","name":'radios[' + sessionIndex + '][' + blockIndex + ']',"disabled":_vm.tempChosenResult[sessionIndex][blockIndex].isChecked},domProps:{"value":_vm.hintAnswer,"checked":_vm._q(_vm.tempChosenResult[sessionIndex][blockIndex].value,_vm.hintAnswer)},on:{"click":function($event){_vm.setChecked(sessionIndex, blockIndex)},"change":function($event){_vm.$set(_vm.tempChosenResult[sessionIndex][blockIndex], "value", _vm.hintAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("\n                  P\n                ")])])])])])])}))])})):_c('div',[_c('div',{staticClass:"session-head d-flex text-center"},[_c('div',{staticClass:"col-6 text-left px-0"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.session'))+" "+_vm._s((_vm.indexCurrentSession + 1))+"/"+_vm._s(_vm.sessionsLength))])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right  px-0"},[_c('p',[_vm._v(_vm._s(_vm._f("trans")('rotation.block'))+" "+_vm._s((_vm.indexCurrentBlock + 1))+"/"+_vm._s(_vm.blocksLength))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.visibleBlock.stimuli),function(blockCell){return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"session-block__cell",class:{'session-block__cell--active' : blockCell.correct}},[_c('p',[_vm._v(_vm._s(_vm._f("shortText")(blockCell.name,_vm.shortTextLength)))])])])}),_vm._v(" "),_c('div',{staticClass:"session-block__radios col-12"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 px-0"},[_c('label',{class:{'is-checked': _vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value == _vm.successfulAnswer}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value),expression:"tempChosenResult[indexCurrentSession][indexCurrentBlock].value"}],attrs:{"type":"radio","id":_vm.successfulAnswer,"name":'radios[' + _vm.indexCurrentSession + '][' + _vm.indexCurrentBlock + ']',"disabled":_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].isChecked},domProps:{"value":_vm.successfulAnswer,"checked":_vm._q(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value,_vm.successfulAnswer)},on:{"click":function($event){_vm.setChecked(_vm.indexCurrentSession, _vm.indexCurrentBlock)},"change":function($event){_vm.$set(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock], "value", _vm.successfulAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text big"},[_vm._v("\n                  +\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 px-0"},[_c('label',{class:{'is-checked': _vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value == _vm.hintAnswer}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value),expression:"tempChosenResult[indexCurrentSession][indexCurrentBlock].value"}],attrs:{"type":"radio","id":_vm.hintAnswer,"name":'radios[' + _vm.indexCurrentSession + '][' + _vm.indexCurrentBlock + ']',"disabled":_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].isChecked},domProps:{"value":_vm.hintAnswer,"checked":_vm._q(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value,_vm.hintAnswer)},on:{"click":function($event){_vm.setChecked(_vm.indexCurrentSession, _vm.indexCurrentBlock)},"change":function($event){_vm.$set(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock], "value", _vm.hintAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("\n                  P\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 px-0"},[_c('label',{class:{'is-checked': _vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value == _vm.failAnswer}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value),expression:"tempChosenResult[indexCurrentSession][indexCurrentBlock].value"}],attrs:{"type":"radio","id":_vm.failAnswer,"name":'radios[' + _vm.indexCurrentSession + '][' + _vm.indexCurrentBlock + ']',"disabled":_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].isChecked},domProps:{"value":_vm.failAnswer,"checked":_vm._q(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock].value,_vm.failAnswer)},on:{"click":function($event){_vm.setChecked(_vm.indexCurrentSession, _vm.indexCurrentBlock)},"change":function($event){_vm.$set(_vm.tempChosenResult[_vm.indexCurrentSession][_vm.indexCurrentBlock], "value", _vm.failAnswer)}}}),_vm._v(" "),_c('span',{staticClass:"text big"},[_vm._v("\n                  —\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"session-block__pagination d-flex justify-content-between"},[_c('mdc-button',{staticClass:"button-primary col-2 px-0 mt-2",attrs:{"type":"submit","disabled":_vm.isPrevButtonDisabled},on:{"click":function($event){_vm.changeBlock('prev')}}},[_c('mdc-icon',{attrs:{"icon":"arrow_back_ios"}})],1),_vm._v(" "),_c('mdc-button',{staticClass:"button-primary col-9 px-0 mt-2",attrs:{"type":"submit","disabled":_vm.isNextButtonDisabled},on:{"click":function($event){_vm.changeBlock('next')}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('rotation.next_block'))+"\n            "),_c('mdc-icon',{attrs:{"icon":"arrow_forward_ios"}})],1)],1)])],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 px-0 text-left"},[_c('mdc-button',{staticClass:"button-primary col-sm-6 col-md-7 col-lg-6 col-xl-4 mt-2",attrs:{"type":"submit"},on:{"click":function($event){_vm.showReport()}}},[_vm._v(_vm._s(_vm._f("trans")('rotation.show_results'))+"\n    ")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'visibility-hidden' : (_vm.isModalVisible && _vm.isMobile)}},[(!_vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"rotation"},[_c('h4',{staticClass:"rotation__title"},[_vm._v(_vm._s(_vm._f("trans")('rotation.title')))]),_vm._v(" "),_c('p',{staticClass:"rotation__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('rotation.interactive_module_two')))]),_vm._v(" "),_c('p',{staticClass:"rotation__description"},[_vm._v(_vm._s(_vm._f("trans")('rotation.description')))])]),_vm._v(" "),_c('settings-form',{on:{"session-settings-set":_vm.onSessionSettingsSet}}),_vm._v(" "),(_vm.isSettingsSet)?_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-12"},[_c('sessions-list',{attrs:{"sessions":_vm.sessions},on:{"show-report":_vm.onShowModalBtnClick}})],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 mt-4 mt-lg-0"},[_c('instruction',{attrs:{"text":_vm._f("trans")('rotation.instructions.text'),"header":_vm._f("trans")('rotation.instructions.header'),"short-text-length":300}})],1)]):_vm._e(),_vm._v(" "),_c('dashboard-menu')],1),_vm._v(" "),(_vm.isSettingsSet)?_c('report-modal',{attrs:{"visible":_vm.isModalVisible},on:{"close":_vm.onClose,"cancel":_vm.onModalCancel}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationLayout_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c468c5d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationLayout_vue__ = __webpack_require__(1310);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c468c5d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationReport_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2595226_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationReport_vue__ = __webpack_require__(1309);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RotationReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2595226_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RotationReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light text-center"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.started_at')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.auditor')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.successful_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.hint_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.fail_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.no_answer_rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('rotation.report.all_approaches_count')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700 text-center"},[(!_vm.isLoaded)?_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.reports),function(report){return (!_vm.isEmptyReports && _vm.isLoaded)?_c('tr',{key:_vm.reports.id},[_c('td',[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(report.startedAt.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.auditor.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.successRate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.promptRate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.failRate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.incompleteRate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.totalCount))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.exportReport(report.id)}}},[_c('mdc-icon',{attrs:{"icon":"save_alt"}})],1)])]):_vm._e()})],2)]):_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__head"},[_vm._v("\n      "+_vm._s(_vm._f("trans")('rotation.reports'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"mobile-table__body"},[(!_vm.isLoaded)?_c('div',{staticClass:"d-flex"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.reports),function(report){return (!_vm.isEmptyReports && _vm.isLoaded)?_c('div',{key:_vm.reports.id,staticClass:"mobile-table__row mx-0"},[_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.started_at')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(_vm._f("toLocaleDateTime")(report.startedAt.date)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.auditor')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.auditor.name))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.successful_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.successRate))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.hint_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.promptRate))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.fail_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.failRate))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.no_answer_rate')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.incompleteRate))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('rotation.report.all_approaches_count')))]),_vm._v(" "),_c('p',{staticClass:"p-2 gray-700"},[_vm._v(_vm._s(report.totalCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark head"},[_vm._v(_vm._s(_vm._f("trans")('dro.report.download_report')))]),_vm._v(" "),_c('p',{staticClass:"p-2"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.exportReport(report.id)}}},[_c('mdc-icon',{attrs:{"icon":"save_alt"}})],1)])])])]):_vm._e()})],2)]),_vm._v(" "),(_vm.isEmptyReports && _vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('rotation.no_data')))])]):_vm._e(),_vm._v(" "),(!_vm.isEmptyReports)?_c('div',[(_vm.paginate.lastPage > 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex flex-wrap align-items-center justify-content-between"},[_c('div',{staticClass:"dro col-lg-9 pl-0"},[_c('button',{staticClass:"btn btn-light btn-sm  mb-1",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.backToPreviousPage()}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])]),_vm._v(" "),_c('h4',{staticClass:"dro__title"},[_vm._v(_vm._s(_vm._f("trans")('rotation.title')))]),_vm._v(" "),_c('p',{staticClass:"dro__subtitle"},[_vm._v(_vm._s(_vm._f("trans")('rotation.interactive_module_two')))]),_vm._v(" "),_c('p',{staticClass:"dro__description"},[_vm._v(_vm._s(_vm._f("trans")('rotation.description')))])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":"","to":{name: 'rotation-session'}}},[_vm._v(_vm._s(_vm._f("trans")('rotation.start_session'))+"\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-4"},[_c('rotation-report')],1),_vm._v(" "),_c('dashboard-menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_Manager__ = __webpack_require__(136);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var clientId, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            clientId = to && to.params && to.params.clientId ? parseInt(to.params.clientId) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2__api_Manager__["a" /* default */].hasAccess(clientId);

          case 4:
            response = _context.sent;
            result = response.data.data;

            if (!(result && result.hasAccess)) {
              _context.next = 10;
              break;
            }

            next();
            _context.next = 11;
            break;

          case 10:
            throw new Error('Forbidden');

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](0);

            next({ name: 'default' });

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 13]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Subscriptions__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ClinicalCenter__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Subscription__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TaskTypes__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SkillDomain__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProfileLayout__ = __webpack_require__(1329);








/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/profile',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ProfileLayout__["a" /* default */],
  children: [{
    path: 'edit',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Profile__["a" /* default */]
  }, {
    path: 'subscriptions',
    name: 'subscriptions',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_0__components_Subscriptions__["a" /* default */]
  }, {
    path: 'subscriptions/:id',
    name: 'subscription',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subscription__["a" /* default */]
  }, {
    path: 'clinic-center',
    name: 'clinic-center',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_1__components_ClinicalCenter__["a" /* default */]
  }, {
    path: 'task-types',
    name: 'task-types',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_3__components_TaskTypes__["a" /* default */]
  }, {
    path: 'skill-domain',
    name: 'skill-domain',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_5__components_SkillDomain__["a" /* default */]
  }]
}]);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8c5be92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__ = __webpack_require__(1314);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8c5be92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row without_btn"},[_c('div',{staticClass:"col-12"},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"action",fn:function(props){return _c('div',{},[(props.row.hasUnreadComments)?_c('mdc-icon',{staticClass:"mr-2 text-warning",attrs:{"icon":"mail"}}):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'subscription', params: { id: props.row.id }}}},[_c('mdc-icon',{attrs:{"icon":"edit"}})],1)],1)}}])})],1)]),_vm._v(" "),_c('form',{staticClass:"mt-4",attrs:{"novalidate":""}},[_c('h4',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('subscription.title')))]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-2"},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('subscription.start_date'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"min-date":new Date()},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 mt-2 mt-md-0"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('subscription.end_date'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 mt-4 mt-md-0"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],staticClass:"mt-0",class:{'is-invalid': _vm.errors.has('client_count')},attrs:{"id":"client_count","label":_vm._f("trans")('profile.client_count'),"type":"text","name":"client_count","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.client_count')},model:{value:(_vm.client_count),callback:function ($$v) {_vm.client_count=$$v},expression:"client_count"}}),_vm._v(" "),(_vm.errors.has('client_count'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('client_count')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('mdc-textfield',{ref:"comment",attrs:{"id":"comment","label":_vm._f("trans")('subscription.add_comment'),"type":"text","multiline":"","rows":"2","name":"comment","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.comment')},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),(_vm.errors.has('comment'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('comment')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.sendRequest($event)}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.sendRequest'))+"\n          ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicalCenter_vue__ = __webpack_require__(620);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4d444e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicalCenter_vue__ = __webpack_require__(1318);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicalCenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4d444e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicalCenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicalModal_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e335868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicalModal_vue__ = __webpack_require__(1317);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicalModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e335868_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicalModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('profile.edit_clinic_center'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.close,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min: 5}),expression:"{required: true, min: 5}"}],class:{'is-invalid': _vm.errors.has('clinicName')},attrs:{"id":"clinicName","type":"text","label":_vm._f("trans")('profile.name_clinic_center'),"name":"clinicName","autocomplete":"new-clinicName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('profile.name_clinic_center')},model:{value:(_vm.clinicName.name),callback:function ($$v) {_vm.$set(_vm.clinicName, "name", $$v)},expression:"clinicName.name"}}),_vm._v(" "),(_vm.errors.has('clinicName') && _vm.errors.firstRule('clinicName') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('clinicName')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('clinicName') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.clinicalName})))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: false, max: 255}),expression:"{required: false, max: 255}"}],class:{'is-invalid': _vm.errors.has('legalName')},attrs:{"id":"clinicName","type":"text","label":_vm._f("trans")('profile.legalName'),"name":"legalName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('profile.legalName')},model:{value:(_vm.clinicName.legalName),callback:function ($$v) {_vm.$set(_vm.clinicName, "legalName", $$v)},expression:"clinicName.legalName"}}),_vm._v(" "),(_vm.errors.has('legalName') && _vm.errors.firstRule('legalName') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('legalName')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('clinicName') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.clinicalName})))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min:5|max:13'),expression:"'required|numeric|min:5|max:13'"}],class:{'is-invalid': _vm.errors.has('phone')},attrs:{"id":"phone","type":"tel","label":_vm._f("trans")('profile.phone'),"name":"phone","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('profile.phone')},model:{value:(_vm.clinicName.phone),callback:function ($$v) {_vm.$set(_vm.clinicName, "phone", $$v)},expression:"clinicName.phone"}}),_vm._v(" "),(_vm.errors.has('phone'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('phone')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate"}],class:{'is-invalid': _vm.errors.has('address')},attrs:{"id":"address","type":"text","label":_vm._f("trans")('profile.address'),"name":"address","value":_vm.clinicName.address,"data-vv-validate-on":"none","autocomplete":"new-address","data-vv-as":_vm._f("trans")('profile.address')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.clinicName.address),callback:function ($$v) {_vm.$set(_vm.clinicName, "address", $$v)},expression:"clinicName.address"}}),_vm._v(" "),(_vm.errors.has('address'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('address')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:{'is-invalid': _vm.errors.has('email')},attrs:{"id":"email","type":"text","label":_vm._f("trans")('contact_us.labels.email'),"name":"email","value":_vm.clinicName.email,"data-vv-validate-on":"none","autocomplete":"new-address","data-vv-as":_vm._f("trans")('validation.attributes.email')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.clinicName.email),callback:function ($$v) {_vm.$set(_vm.clinicName, "email", $$v)},expression:"clinicName.email"}}),_vm._v(" "),(_vm.errors.has('email'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('email')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"mdc-textfield mdc-text-field mdc-text-field--upgraded mdc-text-field--textarea",class:{'is-invalid': _vm.errors.has('other_contact')}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.clinicName.socialNetwork),expression:"clinicName.socialNetwork"}],staticClass:"mdc-text-field__input",attrs:{"rows":"4","cols":"40","id":"other_contact","name":"other_contact","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('profile.other_contact')},domProps:{"value":(_vm.clinicName.socialNetwork)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.clinicName, "socialNetwork", $event.target.value)},function($event){_vm.$emit('input', $event.target.value)}]}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label mdc-floating-label--float-above",attrs:{"for":"other_contact"}},[_vm._v(" "+_vm._s(_vm._f("trans")('profile.other_contact'))+" ")])]),_vm._v(" "),(_vm.errors.has('other_contact'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('other_contact')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[(_vm.logoUrl)?_c('div',{staticClass:"float-left mr-2 mb-2 wrapp-logo"},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":""}})]):_vm._e(),_vm._v(" "),_c('uploader',{class:{'is-invalid': _vm.errors.has('file')},attrs:{"options":_vm.options},on:{"fileuploadadd":_vm.onFileUploadAdd,"fileuploaddone":_vm.onFileUploadDone,"fileuploadfail":_vm.onFileUploadFail,"fileuploadprocessfail":_vm.onFileUploadProcessFail,"fileuploadremove":_vm.onFileUploadRemove}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row without_btn"},[_c('div',{staticClass:"col-12"},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange,"isList":_vm.isMobile},scopedSlots:_vm._u([{key:"name",fn:function(props){return _c('div',{},[(props.row.logo)?_c('div',{staticClass:"icon-circle"},[_c('img',{attrs:{"src":props.row.logo,"alt":""}})]):_vm._e(),_vm._v(" "),_c('strong',[_vm._v(_vm._s(props.row.name))])])}},{key:"logo",fn:function(props){return _c('div',{},[(props.row.logo)?_c('div',{staticClass:"icon-circle"},[_c('img',{attrs:{"src":props.row.logo,"alt":""}})]):_vm._e()])}},{key:"action",fn:function(props){return _c('div',{},[_c('button',{staticClass:"btn btn-link",on:{"click":function($event){$event.preventDefault();_vm.onModalBtnClick(props.row)}}},[_c('mdc-icon',{attrs:{"icon":"edit"}})],1)])}}])})],1)])],1),_vm._v(" "),(_vm.isModalVisible)?_c('clinical-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49892d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__ = __webpack_require__(1320);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49892d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-title"},[_vm._v("#"+_vm._s(_vm.subscription.id))]),_vm._v(" "),_c('div',{staticClass:"info-block"},[(_vm.subscription)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('subscription.start_date'))+":")]),_vm._v(" "),(_vm.subscription.startedAt)?_c('dd',[_vm._v(_vm._s(_vm._f("toLocaleDate")(_vm.subscription.startedAt.date)))]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('subscription.end_date'))+":")]),_vm._v(" "),(_vm.subscription.finishedAt)?_c('dd',[_vm._v(_vm._s(_vm._f("toLocaleDate")(_vm.subscription.finishedAt.date)))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm._f("trans")('profile.client_count'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.subscription.clientCount))]),_vm._v(" "),(_vm.subscription.cost)?_c('dt',[_vm._v(_vm._s(_vm._f("trans")('profile.price'))+":")]):_vm._e(),_vm._v(" "),(_vm.subscription.cost)?_c('dd',[_vm._v(_vm._s(_vm.subscription.cost))]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm._f("trans")('profile.status'))+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.subscription.status))])])])]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"mt-4",attrs:{"novalidate":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"comment",class:{'is-invalid': _vm.errors.has('comment')},attrs:{"id":"comment","label":_vm._f("trans")('subscription.add_comment'),"type":"text","multiline":"","rows":"2","name":"comment","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.comment')},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),(_vm.errors.has('comment'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('comment')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.leaveComment($event)}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('buttons.send'))+"\n        ")])])])]),_vm._v(" "),_c('table-view',{attrs:{"options":_vm.commentListOptions,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange,"isList":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskTypes_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f74f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskTypes_vue__ = __webpack_require__(1322);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f74f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row description-wrapp"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"page-title"},[_vm._v(_vm._s(_vm._f("trans")('profile.settings_task_type')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 mb-3"},[_c('div',{staticClass:"box-shadow"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 half_box-container"},_vm._l((_vm.taskTypes),function(types,taskTypesIndex){return (types.type.id != 2)?_c('div',{staticClass:"half_box-block mb-4"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(types.type.title))]),_vm._v(" "),(types.type.description)?_c('p',{staticClass:"description"},[_vm._v(_vm._s(types.type.description))]):_vm._e(),_vm._v(" "),_vm._l((types.answers),function(type,index){return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"color-block",style:({background: type.color})},[_vm._v(_vm._s(_vm._f("trans")(type.placeholder)))]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:2'),expression:"'required|max:2'"}],class:{'is-invalid': _vm.errors.has('title_'+index+taskTypesIndex)},attrs:{"name":'title_'+index+taskTypesIndex,"maxlength":"2","type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")(type.placeholder)},model:{value:(type.title),callback:function ($$v) {_vm.$set(type, "title", $$v)},expression:"type.title"}}),_vm._v(" "),_c('span',{class:{'is-invalid': _vm.errors.has('title_'+index+taskTypesIndex)}},[_vm._v(_vm._s(_vm._f("trans")(type.descriptionPlaceholder)))]),_vm._v(" "),(_vm.errors.has('title_'+index+taskTypesIndex))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('title_'+index+taskTypesIndex)))])]):_vm._e()],1)})],2):_vm._e()}))])])]),_vm._v(" "),(_vm.hintListRotation)?_c('div',{staticClass:"col-md-4"},[_c('h3',{staticClass:"title-block"},[_vm._v(_vm._s(_vm.hintListRotation.type.title))]),_vm._v(" "),(_vm.hintListRotation.type.description)?_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.hintListRotation.type.description))]):_vm._e(),_vm._v(" "),_vm._l((_vm.hintListRotation.prompts),function(hint,index){return _c('div',{staticClass:"mb-2",class:{'pl-4' : (index === 2 || index === 3 || index === 4 || index === 5)}},[_c('span',{staticClass:"color-block",style:({background: hint.color})},[_vm._v(_vm._s(_vm._f("trans")(hint.placeholder)))]),_vm._v(" "),_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:3'),expression:"'required|max:3'"}],class:{'is-invalid': _vm.errors.has('hint_title_'+index)},attrs:{"maxlength":"3","name":'hint_title_'+index,"type":"text","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")(hint.placeholder)},model:{value:(hint.title),callback:function ($$v) {_vm.$set(hint, "title", $$v)},expression:"hint.title"}}),_vm._v(" "),_c('span',{class:{'is-invalid': _vm.errors.has('hint_title_'+index)}},[_vm._v(_vm._s(_vm._f("trans")(hint.descriptionPlaceholder)))]),_vm._v(" "),(_vm.errors.has('hint_title_'+index))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('hint_title_'+index)))])]):_vm._e()],1)})],2):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-3 text-right"},[_c('button',{staticClass:"btn btn-primary col-md-2",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.setTaskTypesInfo()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('behavior.buttons.apply'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b31a8b72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1324);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b31a8b72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('form',{staticClass:"position-relative",attrs:{"data-vv-scope":"form-profile","novalidate":""}},[(!_vm.loaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, min: 5, regex: /^[a-zA-Z0-9._@-]+$/}),expression:"{required: true, max: 255, min: 5, regex: /^[a-zA-Z0-9._@-]+$/}"}],class:{'is-invalid': _vm.errors.has('username') || _vm.errors.has('form-profile.username')},attrs:{"id":"username","label":_vm._f("trans")('profile.username'),"type":"text","name":"username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.errors.has('username') || _vm.errors.has('form-profile.username'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('username') || _vm.errors.first('form-profile.username')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],class:{'is-invalid': _vm.errors.has('displayName') || _vm.errors.has('form-profile.displayName')},attrs:{"id":"displayName","label":_vm._f("trans")('profile.displayName'),"type":"text","name":"displayName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.displayName')},model:{value:(_vm.user.displayName),callback:function ($$v) {_vm.$set(_vm.user, "displayName", $$v)},expression:"user.displayName"}}),_vm._v(" "),(_vm.errors.has('displayName') || _vm.errors.has('form-profile.displayName'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('displayName') || _vm.errors.first('form-profile.displayName')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|email|max:255'),expression:"'required|email|max:255'"}],class:{'is-invalid': _vm.errors.has('email')  || _vm.responseHashError || _vm.errors.has('form-profile.email')},attrs:{"id":"email","label":_vm._f("trans")('validation.attributes.email'),"type":"email","name":"email","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.email')},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),(_vm.errors.has('email') || _vm.errors.has('form-profile.email'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errors.first('email') || _vm.errors.first('form-profile.email'))+"\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6"},[(_vm.password_changed)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"alert alert-success"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('reset_password.forms.reset_password.congrats.first_line'))+"\n        ")])])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"form-pass","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('currentPassword') || _vm.errors.has('form-pass.current_password') },attrs:{"label":_vm._f("trans")('validation.attributes.old_password'),"type":"password","name":"current_password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.old_password')},model:{value:(_vm.current_password),callback:function ($$v) {_vm.current_password=$$v},expression:"current_password"}}),_vm._v(" "),(_vm.errors.has('currentPassword')  || _vm.errors.has('form-pass.current_password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n              "+_vm._s(_vm.errors.first('currentPassword') || _vm.errors.first('form-pass.current_password'))+"\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('new_password') || _vm.errors.has('form-pass.new_password')},attrs:{"label":_vm._f("trans")('validation.attributes.new_password'),"type":"password","name":"new_password","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.new_password')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.errors.has('new_password') || _vm.errors.has('form-pass.new_password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n             "+_vm._s(_vm.errors.first('new_password') || _vm.errors.first('currentPassword') || _vm.errors.first('form-pass.new_password'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n            "+_vm._s(_vm._f("trans")('passwords.password_subscription'))+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:16'),expression:"'required|min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password_confirmation')},model:{value:(_vm.password_confirmation),callback:function ($$v) {_vm.password_confirmation=$$v},expression:"password_confirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                   "+_vm._s(_vm.errors.first('password_confirmation')  || _vm.errors.first('newPasswordConfirmation') || _vm.errors.first('form-pass.password_confirmation'))+"\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.savePassword()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('buttons.save'))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillDomain_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe1437e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillDomain_vue__ = __webpack_require__(1328);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillDomain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe1437e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillDomain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillModal_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4869806b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillModal_vue__ = __webpack_require__(1327);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4869806b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('report.skill_domain'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.close,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:{'is-invalid': _vm.errors.has('name')},attrs:{"id":"name","type":"text","label":_vm._f("trans")('report.skill_domain'),"name":"name","autocomplete":"new-clinicName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('report.skill_domain')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.errors.has('name') && _vm.errors.firstRule('name') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('name')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('name') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.name})))])]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"action",fn:function(props){return _c('div',{},[_c('client-btn',{attrs:{"item":props.row,"showEdit":true,"showDelete":true},on:{"editItem":function($event){_vm.onModalBtnClick(props.row)},"deleteItem":function($event){_vm.onDeleteBtnClick(props.row.id)}}})],1)}}])}),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.onAddModalBtnClick}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('report.add_skill'))+"\n            ")])],1)])],1)])],1),_vm._v(" "),(_vm.isModalVisible)?_c('skill-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileLayout_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24db37e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileLayout_vue__ = __webpack_require__(1331);
function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24db37e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('div',{staticClass:"dashboard-menu-wrapper"},[_c('nav',{staticClass:"mdc-tab-bar mdc-tab-bar-upgraded dashboard-menu"},[_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded can-view",class:{'mdc-tab--active': 'profile' === _vm.route.name},attrs:{"to":{name: 'profile'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('profile.profile')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded can-view",class:{'mdc-tab--active': 'subscriptions' === _vm.route.name || 'subscription' === _vm.route.name},attrs:{"to":{name: 'subscriptions'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('profile.subscriptions')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded can-view",class:{'mdc-tab--active': 'clinic-center' === _vm.route.name},attrs:{"to":{name: 'clinic-center'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('profile.clinic_center')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded can-view",class:{'mdc-tab--active': 'task-types' === _vm.route.name},attrs:{"to":{name: 'task-types'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('profile.settings_task_type')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded can-view",class:{'mdc-tab--active': 'skill-domain' === _vm.route.name},attrs:{"to":{name: 'skill-domain'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('report.skill_domain')))])])],1),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_user_therapist_components_List__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_user_client_components_UserDashboardLayout__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks_canViewTherapists__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_canViewTherapist__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_user_therapist_profile_Profile__ = __webpack_require__(1339);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/users',
  component: __WEBPACK_IMPORTED_MODULE_1__modules_user_client_components_UserDashboardLayout__["a" /* default */],
  children: [{
    path: 'therapists',
    name: 'therapist',
    component: __WEBPACK_IMPORTED_MODULE_0__modules_user_therapist_components_List__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__hooks_canViewTherapists__["a" /* default */]
  }, {
    path: 'therapists/:therapistId/edit',
    name: 'therapist-edit',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_user_therapist_profile_Profile__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_3__hooks_canViewTherapist__["a" /* default */]
  }]
}]);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6841f7d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6841f7d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d47aaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1335);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d47aaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")(!_vm.isEdit ? 'user.add_therapist' : 'user.edit_therapist'),"accept":_vm._f("trans")('user.save'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.disabled},on:{"accept":_vm.close,"cancel":_vm.close,"validate":_vm.save},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.close()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),(!_vm.isLoaded)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}),expression:"{required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}"}],class:{'is-invalid': _vm.errors.has('username') || (_vm.validationError && _vm.validationError.username)},attrs:{"id":"username","type":"text","label":_vm._f("trans")('validation.attributes.username'),"name":"username","autocomplete":"new-username","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.username')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}}),_vm._v(" "),(_vm.validationError && _vm.validationError.username)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.validationError.username.message))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('username') && _vm.errors.firstRule('username') != 'regex')?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('username')))])]):_vm._e(),_vm._v(" "),(_vm.errors.firstRule('username') === 'regex' )?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('validation.regex', {attribute: _vm.userName})))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],class:{'is-invalid': _vm.errors.has('displayName')},attrs:{"id":"displayName","type":"text","label":_vm._f("trans")('validation.attributes.displayName'),"name":"displayName","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.displayName')},model:{value:(_vm.user.displayName),callback:function ($$v) {_vm.$set(_vm.user, "displayName", $$v)},expression:"user.displayName"}}),_vm._v(" "),(_vm.errors.has('displayName'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('displayName')))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"curatorsSelect",staticClass:"aut-dropdown",class:{'is-invalid': _vm.errors.has('curators'), 'is-clear': !(_vm.user.curators ? _vm.user.curators.length : _vm.user.curators) &&  !_vm.searchText},attrs:{"id":"curators","name":"curators","label":"id","options":_vm.curatorsNew,"filterable":false,"onSearch":_vm.onSearch,"on-change":_vm.onChange,"data-vv-validate-on":"none","data-vv-name":"curators","data-vv-as":_vm._f("trans")('user.curators'),"multiple":""},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n                            "+_vm._s(option.displayName)+"\n                        ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n                            "+_vm._s(option.displayName)+"\n                        ")]}}]),model:{value:(_vm.user.curators),callback:function ($$v) {_vm.$set(_vm.user, "curators", $$v)},expression:"user.curators"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                                "+_vm._s(_vm._f("trans")('user.type_the_curator_name_to_search'))+"\n                            ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('curators') }},[_vm._v(_vm._s(_vm._f("trans")('user.curators')))]),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('user.start_curator')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.errors.has('curators') && _vm.searchText)?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('errors.choose_curator_from_list')))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('curators') && !_vm.searchText)?_c('span',{staticClass:"invalid-feedback-label"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('curators')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16'),expression:"'min:8|max:16'"}],class:{'is-invalid': _vm.errors.has('password')},attrs:{"id":"password","type":"password","label":_vm._f("trans")(_vm.isEdit ? 'validation.attributes.new_password' : 'validation.attributes.password'),"name":"password","value":_vm.user.password,"data-vv-validate-on":"none","autocomplete":"new-password","data-vv-as":_vm._f("trans")('validation.attributes.password')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),(_vm.errors.has('password') || _vm.errors.has('form-pass.password'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.errors.first('password')  || _vm.errors.first('form-pass.password'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('passwords.password_subscription'))+"\n                    ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min:8|max:16|confirmed:password'),expression:"'min:8|max:16|confirmed:password'"}],class:{'is-invalid': _vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation')},attrs:{"label":_vm._f("trans")('validation.attributes.password_confirmation'),"value":_vm.user.passwordConfirmation,"type":"password","name":"password_confirmation","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('validation.attributes.password')},on:{"input":function($event){_vm.$emit('input', $event.target.value)}},model:{value:(_vm.user.passwordConfirmation),callback:function ($$v) {_vm.$set(_vm.user, "passwordConfirmation", $$v)},expression:"user.passwordConfirmation"}}),_vm._v(" "),(_vm.errors.has('password_confirmation') || _vm.errors.has('newPasswordConfirmation') || _vm.errors.has('form-pass.password_confirmation'))?_c('span',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm._f("trans")('validation.confirmed', {attribute: _vm.passwordLabel}))+"\n                    ")]):_vm._e()],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"therapist-table justify-content-center"},[_c('table-view',{attrs:{"options":_vm.options,"isLoaded":_vm.isLoaded,"isChange":_vm.isChange},on:{"on-search":_vm.onSearchEnter},scopedSlots:_vm._u([{key:"therapists",fn:function(props){return _c('div',{},[_c('router-link',{staticClass:"name-link",attrs:{"to":{ name: 'therapist-edit', params: { therapistId: props.row.id }}}},[_c('div',{staticClass:"icon-circle icon-indigo"},[(!_vm.isMobile)?_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm._f("toFirstLetter")(props.row.displayName)))]):_vm._e()]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(props.row.displayName))])])],1)}},{key:"curator-edit",fn:function(props){return (_vm.isMobile)?_c('div',{},[_c('router-link',{attrs:{"to":{ name: 'curator-edit', params: { id: props.row.id }}}},[_vm._v("\n        "+_vm._s(props.row.displayName)+"\n      ")])],1):_vm._e()}},{key:"action",fn:function(props){return (!_vm.isMensurationForbidden)?_c('div',{},[(_vm.canUpdateTherapist || _vm.canDeleteTherapist)?_c('client-btn',{attrs:{"item":props.row,"showEdit":_vm.canUpdateTherapist,"showDelete":_vm.canDeleteTherapist},on:{"editItem":_vm.onEditBtnClick,"deleteItem":_vm.onDeleteBtnClick}}):_vm._e()],1):_vm._e()}}])}),_vm._v(" "),_c('div',{staticClass:"row pager-btn-row"},[(_vm.canCreateTherapist && !_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 text-right"},[_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.onAddCuratorModalBtnClick}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.add_therapist'))+"\n      ")])],1):_vm._e()]),_vm._v(" "),_c('therapist-modal',{attrs:{"visible":_vm.isModalVisible,"data":_vm.modal.data},on:{"close":_vm.onModalClose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].can('view_therapists')) {
    next();
  } else {
    next({ name: 'login' });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_therapist__ = __webpack_require__(79);



var _this = this;




var isAuthorized = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var id, response, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            id = to && to.params && to.params.therapistId ? parseInt(to.params.therapistId) : null;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__api_therapist__["a" /* default */].hasAccess(id);

          case 4:
            response = _context.sent;
            result = response.data.data;

            if (!__WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_2__common_auth_Manager__["a" /* default */].can('view_therapist') && result && result.access) {
              next();
            } else {
              next({ name: 'login' });
            }
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            next({ name: 'login' });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9]]);
  }));

  return function isAuthorized(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cf3c5a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1348);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cf3c5a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4084a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__(1345);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4084a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDeleteModal_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1583130_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDeleteModal_vue__ = __webpack_require__(1342);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1583130_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete_title'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":_vm.accept,"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_vm._v("\n  "+_vm._s(_vm._f("trans")('user.confirm_delete_client_form_therapist'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachClientModal_vue__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c952a71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachClientModal_vue__ = __webpack_require__(1344);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachClientModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c952a71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachClientModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.add_client'),"accept":_vm._f("trans")('user.add'),"cancel":_vm._f("trans")('user.cancel'),"accept-disabled":_vm.isAcceptDisabled},on:{"accept":_vm.accept,"cancel":_vm.cancel},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(_vm.loading)?_c('div',[_c('loader',{staticClass:"table-loader"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"close-cross",on:{"click":function($event){_vm.cancel()}}},[_c('mdc-icon',{attrs:{"icon":"close"}})],1),_vm._v(" "),_c('div',[(!_vm.isItemsExists)?_c('div',[_vm._v("\n      "+_vm._s(_vm._f("trans")('user.add_client_no_data'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isItemsExists)?_c('form',{attrs:{"novalidate":""}},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-12"},[_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('therapist_id'), 'is-clear': !_vm.item},attrs:{"id":"mdc-client","name":"client_id","label":'code',"selected":_vm.item,"options":_vm.itemsNew,"searchable":false,"filterable":false,"loading":_vm.loading,"lastId":_vm.lastClientId,"isLastPage":_vm.isLastPageClient,"isLast":_vm.isLastClient,"getOptionTitle":_vm.getOptionClientTitle},on:{"next-page":_vm.nextClientPage,"set-selected":_vm.onChangeClinicId}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'mdc-floating-label-error': _vm.errors.has('therapist_id') }},[_vm._v(_vm._s(_vm._f("trans")('user.choose_client_from_list')))])],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('search',{attrs:{"placeholder":_vm._f("trans")('user.type_the_client_code_to_search')},on:{"enter":_vm.onSearchEnter},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.clients')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.number')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.completed_protocols')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.active_protocols')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('bids.bids_for_new_protocols')))]),_vm._v(" "),(_vm.canUpdateClient && _vm.canUpdateTherapist && !_vm.isMensurationForbidden)?_c('th',{staticClass:"action-cell"}):_vm._e()])]),_vm._v(" "),_c('tbody',[(_vm.loading)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return (!_vm.loading)?_c('tr',{key:item.id},[_c('td',{staticClass:"wide-col"},[_c('router-link',{attrs:{"to":{ name: 'client-edit', params: { clientId: item.id }}}},[_c('div',{staticClass:"icon-circle icon-purple"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.C')))]):_vm._e()]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.code))])])],1),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_vm._v(_vm._s(item.hash))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.completedAssignedProtocolsCount))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.activeAssignedProtocolsCount))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.newBidsCount))]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('td',[(_vm.canUpdateClient && _vm.canUpdateTherapist)?_c('a',{staticClass:"delete-icon",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onDeleteItemIconClick(item)}}},[_c('mdc-icon',{attrs:{"icon":"delete"}})],1):_vm._e()]):_vm._e()]):_vm._e()})],2)]):_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},[(_vm.loading)?_c('div',{staticClass:"d-flex"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return (!_vm.loading)?_c('div',{key:item.id,staticClass:"mobile-table__row"},[_c('div',{staticClass:"title d-flex align-items-center justify-content-between"},[_c('router-link',{staticClass:"d-flex align-items-center",attrs:{"to":{ name: 'client-edit', params: { clientId: item.id }}}},[_c('div',{staticClass:"icon-circle icon-purple"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.code))])]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',[(_vm.canUpdateClient && _vm.canUpdateTherapist)?_c('a',{staticClass:"delete-icon",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onDeleteItemIconClick(item)}}},[_c('mdc-icon',{attrs:{"icon":"delete"}})],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('user.number')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.hash))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.completed_protocols')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.completedAssignedProtocolsCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.active_protocols')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.activeAssignedProtocolsCount))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('bids.bids_for_new_protocols')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.newBidsCount))])])])]):_vm._e()})],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-2 mt-md-0"},[_c('div',{staticClass:"col-md-12 col-lg-5"},[_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.paginate.lastPage > 1),expression:"paginate.lastPage > 1"}],staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"initial-page":_vm.paginate.page,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1)]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('div',{staticClass:"col-md-12 col-lg-7 text-right"},[(_vm.canUpdateClient && _vm.canUpdateTherapist)?_c('mdc-button',{staticClass:"button-primary",attrs:{"raised":""},on:{"click":_vm.onAttachClientButtonClick}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.add_client'))+"\n      ")]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('confirm-delete-modal',{attrs:{"visible":_vm.modals.confirmDelete.isVisible,"item":_vm.modals.confirmDelete.client},on:{"accept":_vm.onAcceptDeleteClient,"cancel":_vm.onCancelDeleteClient}}),_vm._v(" "),_c('attach-client-modal',{attrs:{"visible":_vm.modals.attachClient.isVisible,"therapist-id":_vm.therapistId},on:{"accept":_vm.onAcceptAttachClient,"cancel":_vm.onCancelAttachClient}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Measurements_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018b2022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Measurements_vue__ = __webpack_require__(1347);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Measurements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018b2022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Measurements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.client')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.stage')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.measured')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.measurement_date')))])])]),_vm._v(" "),_c('tbody',[(_vm.loading)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return (!_vm.loading && !_vm.isEmptyMeasurements)?_c('tr',{key:item.id},[_c('td',{staticClass:"wide-col"},[_c('router-link',{attrs:{"to":{ name: 'results', params: { protocolId: item.assignedProtocolId }}}},[_c('div',{staticClass:"icon-circle icon-purple"},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.P')))]):_vm._e()]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.protocolTitle))])])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'client-edit', params: { clientId: item.clientId }}}},[_vm._v("\n            "+_vm._s(item.clientCode)+"\n          ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stageTitle))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("trans")(("user." + (item.auditorTypeName)))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toLocaleDate")(item.updatedAt)))])]):_vm._e()})],2)]):_c('div',{staticClass:"mobile-table"},[_c('div',{staticClass:"mobile-table__body"},[(_vm.loading)?_c('div',{staticClass:"d-flex"},[_c('loader',{staticClass:"table-loader",attrs:{"messages":"home.labels.loading_message_table"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return (!_vm.loading && !_vm.isEmptyMeasurements)?_c('div',{key:item.id,staticClass:"mobile-table__row"},[_c('div',{staticClass:"title d-flex align-items-center justify-content-between"},[_c('router-link',{attrs:{"to":{ name: 'results', params: { protocolId: item.assignedProtocolId }}}},[_c('div',{staticClass:"icon-circle icon-purple"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(item.protocolTitle))])])],1),_vm._v(" "),_c('div',{staticClass:"description pt-2"},[_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.stage')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.stageTitle))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.measured')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")(("user." + (item.auditorTypeName)))))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"gray-dark"},[_vm._v(_vm._s(_vm._f("trans")('protocol.measurement_date')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("toLocaleDate")(item.updatedAt)))])])])]):_vm._e()})],2)])])]),_vm._v(" "),(_vm.isEmptyMeasurements && !_vm.loading)?_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('user.no_data')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2 mt-md-0"},[_c('div',{staticClass:"col-md-12 col-lg-5"},[_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.paginate.lastPage > 1),expression:"paginate.lastPage > 1"}],staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"initial-page":_vm.paginate.page,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center"},[(_vm.loading)?_c('div',{staticClass:"col-lg-12"},[_c('loader',{staticClass:"table-loader"})],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.model.displayName))])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"row"},[_c('h4',{staticClass:"col-12 row-title pt-2"},[_vm._v(_vm._s(_vm._f("trans")('user.list_attached_clients')))]),_vm._v(" "),_c('clients',{staticClass:"col-md-12",attrs:{"therapist-id":_vm.therapistId},on:{"loading":_vm.onLoading}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"row"},[_c('h4',{staticClass:"col-12 row-title pt-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.bids_for_protocols')))]),_vm._v(" "),_c('bids-list',{staticClass:"col-md-12",attrs:{"userId":_vm.therapistId}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"row"},[_c('h4',{staticClass:"col-12 row-title pt-4"},[_vm._v(_vm._s(_vm._f("trans")('protocol.last_measurement_results')))]),_vm._v(" "),_c('measurements',{staticClass:"col-md-12",attrs:{"user-id":_vm.therapistId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsLayout__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CuratorList__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TherapistList__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ClientsList__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArchiveList__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_hooks_canViewReports__ = __webpack_require__(1410);







/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/reports',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ReportsLayout__["a" /* default */],
  children: [{
    path: 'curators',
    name: 'curator-reports',
    component: __WEBPACK_IMPORTED_MODULE_1__components_CuratorList__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_canViewReports__["a" /* default */]
  }, {
    path: 'therapists',
    name: 'therapist-reports',
    component: __WEBPACK_IMPORTED_MODULE_2__components_TherapistList__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_canViewReports__["a" /* default */]
  }, {
    path: 'clients',
    name: 'client-reports',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ClientsList__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_canViewReports__["a" /* default */]
  }, {
    path: 'archive',
    name: 'archive-reports',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ArchiveList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_canViewReports__["a" /* default */]
  }]
}]);

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsLayout_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c95fdc90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsLayout_vue__ = __webpack_require__(1352);
function injectStyle (ssrContext) {
  __webpack_require__(1351)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c95fdc90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-2"},[_c('nav',{staticClass:"mdc-tab-bar mdc-tab-bar-upgraded dashboard-menu report-menu"},[_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.isBCBA || _vm.isCurator, 'mdc-tab--active': 'client-reports' === _vm.route.name},attrs:{"to":{name: 'client-reports'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.clients')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.isBCBA, 'mdc-tab--active': 'curator-reports' === _vm.route.name},attrs:{"to":{name: 'curator-reports'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.curators')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.isBCBA || _vm.isCurator, 'mdc-tab--active': 'therapist-reports' === _vm.route.name},attrs:{"to":{name: 'therapist-reports'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('user.therapists')))])]),_vm._v(" "),_c('router-link',{staticClass:"mdc-tab mdc-ripple-upgraded",class:{'can-view': _vm.isBCBA || _vm.isCurator, 'mdc-tab--active': 'archive-reports' === _vm.route.name},attrs:{"to":{name: 'archive-reports'}}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('report.archive_reports')))])])],1),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CuratorList_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008f2412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CuratorList_vue__ = __webpack_require__(1386);
function injectStyle (ssrContext) {
  __webpack_require__(1354)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CuratorList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008f2412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CuratorList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportCurator_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74126e6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportCurator_vue__ = __webpack_require__(1385);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportCurator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74126e6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportCurator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"hidden":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center"},[_c('div',{attrs:{"id":"pdf-filers"}},[_c('div',{staticClass:"row row-filter mt-2 mb-3 mt-md-0"},[_c('div',{staticClass:"col-12 col-lg-4",attrs:{"id":"div-curator"}},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_curator'))+"\n        ")]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",attrs:{"id":"mdc-curator","name":"clinicalCenter","label":'id',"selected":_vm.curatorId,"options":_vm.curators,"filterable":false,"searchable":false,"loading":_vm.loading,"isLastPage":_vm.isLastPage,"getOptionTitle":_vm.getOptionTitle,"isLast":_vm.isLast},on:{"next-page":_vm.nextPage,"set-selected":_vm.onSetSelected}}),_vm._v(" "),_c('span',{staticClass:"description-row",attrs:{"id":"span-b"}},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_curator')))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 mt-lg-0 col-lg-8"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_period'))+" "),_c('sup',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('report.range_from'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.minDateStart},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12  mt-2 mt-lg-0 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width right"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('report.range_end'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_period')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","disabled":_vm.isLoading,"raised":""},on:{"click":function($event){$event.preventDefault();_vm.onSendRequest()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.draw_report'))+"\n      ")])])]),_vm._v(" "),(_vm.pdfProcess)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.showTable && !_vm.isLoading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"id":"pdf-client-table"}},[(_vm.curator)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.info_curator'))+": "+_vm._s(_vm.curator))]):_vm._e(),_vm._v(" "),(!_vm.curator)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.info_curators')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.curator')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_new')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_completed')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_overdue')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.average_speed_bids')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.write_protocols')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.clients_count')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},[_vm._l((_vm.curatorsStatistics),function(item){return (_vm.curatorsStatistics.length > 0)?_c('tr',[_c('td',[_vm._v(_vm._s(item.displayName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.newBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.processedBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.overdueBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.avgBidProcessingSpeed))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdProtocolCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalClientCount))])]):_vm._e()}),_vm._v(" "),(_vm.curatorsStatistics.length === 0)?_c('tr',{staticClass:"text-center"},[_c('td',{attrs:{"colspan":"8"}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('user.no_data')))])])]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 text-right"},[(!_vm.isMobile)?_c('button',{staticClass:"btn btn-blue mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.generatePdf()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.download_pdf'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","disabled":_vm.isSaveDisable,"raised":""},on:{"click":function($event){$event.preventDefault();_vm.saveRequest()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.save_report'))+"\n      ")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TherapistList_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ab9625a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TherapistList_vue__ = __webpack_require__(1391);
function injectStyle (ssrContext) {
  __webpack_require__(1388)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TherapistList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ab9625a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TherapistList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportTherapist_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c41df314_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportTherapist_vue__ = __webpack_require__(1390);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportTherapist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c41df314_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportTherapist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"hidden":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center"},[_c('div',{attrs:{"id":"pdf-filers"}},[_c('div',{staticClass:"row row-filter mt-2 mb-3 mt-md-0"},[_c('div',{staticClass:"col-12 col-lg-4",attrs:{"id":"div-therapist"}},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_therapist'))+"\n        ")]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('therapist')},attrs:{"id":"mdc-therapist","name":"therapist","label":'displayName',"selected":_vm.therapistId,"options":_vm.therapists,"filterable":false,"searchable":false,"loading":_vm.loading,"isLastPage":_vm.isLastPage,"getOptionTitle":_vm.getOptionTitle,"isLast":_vm.isLast},on:{"next-page":_vm.nextPage,"set-selected":_vm.onSetSelected}}),_vm._v(" "),_c('span',{staticClass:"description-row",attrs:{"id":"span-b"}},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_therapist')))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 mt-lg-0 col-lg-8"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_period'))+" "),_c('sup',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('report.range_from'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.minDateStart},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2 mt-lg-0 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width right"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('report.range_end'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_period')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","disabled":_vm.isLoading,"raised":""},on:{"click":function($event){$event.preventDefault();_vm.onSendRequest()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.draw_report'))+"\n      ")])])]),_vm._v(" "),(_vm.pdfProcess)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.showTable && !_vm.isLoading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"id":"pdf-client-table"}},[(_vm.therapistId)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.info_therapist'))+": "+_vm._s(_vm.therapist))]):_vm._e(),_vm._v(" "),(!_vm.therapistId)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.info_therapists')))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.therapist')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_new')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_created')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_completed')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.bids_overdue')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.clients_count')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.total_time')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},[_vm._l((_vm.therapistStatistics),function(item){return (_vm.therapistStatistics.length > 0)?_c('tr',[_c('td',[_vm._v(_vm._s(item.displayName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.newBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.processedBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.overdueBidCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalClientCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.timeDuration(item.hoursWithClients)))])]):_vm._e()}),_vm._v(" "),(_vm.therapistStatistics.length === 0)?_c('tr',{staticClass:"text-center"},[_c('td',{attrs:{"colspan":"7"}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('user.no_data')))])])]):_vm._e()],2)]),_vm._v(" "),(_vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e(),_vm._v(" "),(_vm.therapist)?_c('h3',{staticClass:"table-title mt-2"},[_vm._v(_vm._s(_vm._f("trans")('user.clients')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[(_vm.therapist)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('user.clients')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.total_time')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},_vm._l((_vm.clientStatistics),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.timeDuration(item.hours)))])])}))]):_vm._e()]),_vm._v(" "),(_vm.paginateClient.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginateClient.lastPage,"page-range":_vm.paginateClient.pageRange,"margin-pages":_vm.paginateClient.marginPages,"force-page":_vm.paginateClient.forcePage,"click-handler":_vm.onPaginationClientClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 text-right"},[(!_vm.isMobile)?_c('button',{staticClass:"btn btn-blue mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.generatePdf()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.download_pdf'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","disabled":_vm.isSaveDisable,"raised":""},on:{"click":function($event){$event.preventDefault();_vm.saveRequest()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.save_report'))+"\n      ")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientsList_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7d9c7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientsList_vue__ = __webpack_require__(1406);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7d9c7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataUB_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_821e11b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataUB_vue__ = __webpack_require__(1395);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataUB_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_821e11b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataUB_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-shadow",attrs:{"id":"ub"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.data_UB')))]),_vm._v(" "),_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.average_behavior')))]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[(_vm.measurements)?_c('div',{staticClass:"col-12"},[_c('line-chart',{attrs:{"datasets":_vm.lineChartDataset,"show-legend":false,"animation-duration":0,"height":null,"width":null,"y-axes-begin-at-zero":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[(_vm.antecedentTypes)?_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.ancedent')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartAncedentDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartAncedentDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n          ")])})],2):_vm._e(),_vm._v(" "),(_vm.behaviorTypes)?_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.unwanted_behavior')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartBehaviorDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartBehaviorDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n          ")])})],2):_vm._e(),_vm._v(" "),(_vm.effectsTypes)?_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('behavior.aftermath')))]),_vm._v(" "),_c('bar-chart',{attrs:{"bardatasets":_vm.barChartEffectsDataset,"show-legend":false,"height":260}}),_vm._v(" "),_vm._l((_vm.barChartEffectsDataset),function(label){return _c('div',{staticClass:"legend-item"},[_c('span',{style:({background:label.backgroundColor})}),_vm._v(_vm._s(label.label)+"\n          ")])})],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataAppeals_vue__ = __webpack_require__(654);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d2ccb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataAppeals_vue__ = __webpack_require__(1397);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataAppeals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d2ccb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataAppeals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 block-shadow mt-4",attrs:{"id":"appeals"}},[_c('div',{staticClass:"row"},[(_vm.measurements)?_c('div',{staticClass:"col-12 mb-4"},[_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.data_appeals')))]),_vm._v(" "),_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('report.summary_table_requests')))]),_vm._v(" "),_c('div',{staticClass:"appeals-list"},_vm._l((_vm.appeals),function(appeal){return _c('div',{staticClass:"radio-btn"},[_vm._v("\n          "+_vm._s(appeal.text)+" ("+_vm._s(appeal.count)+")\n        ")])})),_vm._v(" "),_c('p',{staticClass:"table-subtitle"},[_vm._v(_vm._s(_vm._f("trans")('appeals.appeals_count')))]),_vm._v(" "),_c('bar-chart',{attrs:{"linedatasets":_vm.lineChartDataset,"bardatasets":_vm.barChartDataset,"height":null,"width":null,"show-legend":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataEfficiency_vue__ = __webpack_require__(655);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eaabfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataEfficiency_vue__ = __webpack_require__(1399);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataEfficiency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eaabfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataEfficiency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.efficiencyGrid)?_c('div',{staticClass:"col-12"},[_c('line-chart',{attrs:{"datasets":_vm.lineChartDataset,"show-legend":false,"animation-duration":0,"height":null,"width":null,"y-axes-begin-at-zero":true}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slickCarousel_vue__ = __webpack_require__(656);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f6f7688_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slickCarousel_vue__ = __webpack_require__(1402);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slickCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f6f7688_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slickCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */,
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportClient_vue__ = __webpack_require__(657);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd154b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportClient_vue__ = __webpack_require__(1405);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfReportClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bd154b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfReportClient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY_APPLYINGEFFICIENCY_IMG; });
var EMPTY_APPLYINGEFFICIENCY_IMG = {
  source: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB/wAAAOQCAYAAAA0TglYAAAgAElEQVR4XuzdB5QTVfvH8UcpKr2D9CYCKggKgtJ77x3pvYqi0jtI77036b1L71VAQJTepTcRQQXx/Z/n7j9Dks1ukt0sS5bvPYfzwmYyufOZyb7O/O597mv/+9///ic0BBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEPArgdcI/P3qfNFZBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEjACBPxcCAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACfihA4O+HJ40uI4AAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgggQODPNYAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggIAfChD4++FJo8sIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggQ+HMNIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggg4IcCBP5+eNLoMgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgT+XAMIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgj4oQCBvx+eNLqMAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAgT/XAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAn4oQODvhyeNLiOAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIEDgzzWAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIICAHwoQ+PvhSaPLCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIEPhzDSCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIOCHAgT+fnjS6DICCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIE/lwDCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAII+KEAgb8fnjS6jAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAIE/1wACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAJ+KEDg74cnjS4jgAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCBA4M81gAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAgB8KEPj74UmjywgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCBD4cw0ggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCDghwIE/n540ugyAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACBP5cAwgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCPihAIG/H540uowAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggACBP9cAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACfihA4O+HJ40uI4AAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgggQODPNYAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggIAfChD4++FJo8sIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggQ+HMNIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggg4IcCBP5+eNLoMgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgT+XAMIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgj4oQCBvx+eNLqMAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAgT/XAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAn4oQODvhyeNLiOAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIEDgzzWAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIICAHwoQ+PvhSaPLCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIEPhzDSCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIOCHAgT+fnjS6DICCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIE/lwDCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAII+KEAgb8fnjS6jAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAgBX4z5o9R3r26ee1SJo0qWXz+rVev+9FvuHcufNStGQZ6yMbN6wvnTt++yK7EKE+q0279rJm7TrrmH7+6aBEjx7NJ8fIufIJIztBAAEEEEAAAQQQQAABBF5qgf/++0/2H/hRNm/ZKj8ePCS3bt+We/fum3vLBPETyHuZM0mRwgWlUMEC8tZbb73Ux/Iqd+7J06eSJ39huXPnjmE4/esxiRw5skWSLUduefDggcSIHl22bl4v8ePFCxHXjZs3ZfyESbJl63ZzrcSJE1vyfPaptGzWVNKlS+t2n3qttWv/jdy8ects27tnN/m8Vk2373tRG/Cc5UVJ8zkIIIAAAggggAACCERMAQL/iHlew/SouBENU152jgACCCCAAAIIIIAAAghEaIFt23fIwMFD5dTpM26PM0GCBPJFm5ZSs3o1ef31191uzwYvVuDqtWuSt0AR60N3bNkoyZMnM/9+9OixZP0op+jgDm2LF8yV7Nk+9LqDPx//Reo1bCy///4g0HujRo0qY0ePkMIFCwS539u370ipshXk7r17ZpvixYrI+DGjvO5HWL6B5yxhqcu+EUAAAQQQQAABBBCI+AIE/hH/HPv8CLkR9TkpO0QAAQQQQAABBBBAAAEEIrzAs2fPpM93A0QrDHrb8ufLK6OGD5GYMWN6+1a2D0MBDfNz5y0gGqprq1SxvHTp2EEiRXpdRo8dL1OnzzQ/f/PNN+XA3p1mpr837cmTJ1K4eCm5evWaedvbSZLIh1mzyMnTp+XChYvmZ1oVYvP6dZIoUcJAu9b+1W3QWPbs3WdeS5Y0qaxZuVRixYrlTTfCfFues4Q5MR+AAAIIIIAAAggggECEFggy8Nebn66dO7g9+JgxYprR0S9zo0y8b88ON6K+9WRvCCCAAAIIIIAAAggggEBEF/jf//4nrdt+KevWb3B5qClTpJD48ePJn38+Ep01/vjxY4fttEz80kXz5f33Mkd0Kr87Pj2nbb74yprJ7+oAenbvKnU/r+X1sS1dtkK+7tDJvC9VypSyasUSM2jg6dOnUr9RU9m7b795rXXL5vJVu7aB9j9m3AQZNiJgNn+kSJFkwdzZIaoy4HXHvXwDz1m8BGNzBBBAAAEEEEAAAQQQcBAIMvBPnDiR7N25LUJwEfj79jRyI+pbT/aGAAIIIIAAAggggAACCER0gXETJsmQYSMcDjNatGjSvGljqValssPs7H///VcO/HjQzBDXtde1fdP+S2nRrElEZ/Lb4zt46HDA+dp/QJ48fWqOQwP2j7Jnk2ZNGkvBAvlCdGztv+0oy5avNO/t9O3X0qRxQ2s/m7dukybNWpp/f5g1qyxdNM/hM7RPNWrXtQYivMzXEM9ZQnR58CYEEEAAAQQQQAABBBD4fwECfy4FrwW4EfWajDcggAACCCCAAAIIIIAAAq+swMVLl6RI8dIOM8C1NPus6VMkXbq0wbqsWbtOfrt6TZo0aiCvv/76K2voLweuM+/v3L0rWtEhQfz4EjVq1FB1/fN6Da1y/OPHjHKoMHnh4iUpXKyk2X+SxIllz86t1mc9ePBASperJNeuXzc/y/NZbpk5bYq89tproepPWL2Z5yxhJct+EUAAAQQQQAABBBB4NQQI/F+N8+zTo+RG1Kec7AwBBBBAAAEEEEAAAQQQiNAC33bsIouXLrOOUcvzL1u8QN7LnClCHzcHF3qBeg2byM5du82OxowcJqVKlrB2evrMWSlRupz5d4oUyWX75ufLRTRr2UY2btpsXtOBB2tXLZMECRKEvkNhtAees4QRLLtFAAEEEEAAAQQQQOAVEQhV4G9fPk1H5a9cukjeeustOXP2rMycNUd27d4jN27eNOurZc+eTRo3rC85c3wcJO2zZ89k/YaNovs9cuSo3L59x5SCS/r221Igfz5p3Ki++bu7pmv9LVuxUrZu2y4nT56WO3cC9mNrOqI7bpw4kixZUsnz2adSoXxZeSd9+iB3+92AQTJl2gzr9T69ukvtmjVcbv/TkaPStHkruXvvnnl9+ZKFkuWD961ty1WsIsd/+dX698Z1q13OaJg3f6EMGDxUHj58aLYtV6a0jBg22N2hW6//9ddfMn/hItmwcbPokgYP/vhDYsWMKSlSpJBCBfNL9apVJGFCz252jx49JitXr5W9+/bJ9Rs3RUfK27c333zTrLWY5f33pXChglKmTCmJGiWKR3319bmy/1Ad7b9w0WLZvmOnXL12Xf75+29zg589+4dSpVJFyZc3j8s+enq+jxw9Km2//Fp+++2q2Y8+YNiwdpUUL1VOLl+54tHxO2+UNWsWWbZofsA59/Ba0W2/nztP+vYbYK5z/Q7+cvSQtetHjx7LB9lcf+/0uxAjRgxJmya15M3zmXxeq6ZDKU3difP79WHJgb07XR5fo6bNZeu2HdZrc2fPkFyf5HS57fUbN0Sv852798iVy1fkj4cPJXasWJImTWrJny+v1KheVeLHi+fW8fffH8jCxYtl85Ztoudcr0+91nU/RQoXlJo1qkvMGDHMfjp27iYLFy9xu8+gNjjx80/yxhtviKfXiO7H3e+EEHeGNyKAAAIIIIAAAggg4AcCfz56JNlz5BYt029rdWrXlF49uoWq9873S/Y706UC3n47ieT4+CNz7+5uYIGv7k1OnjotpcpW8Oi4tFrB2ZPHA23r6b3GsZ+PS4XK1az367OW+XNmWf+2f16jP/S2nP2s2XOkZ59+1v6aNWkkHb5pb/3b036G9p6oV9/vZOas783nNqxfV7p27mj1Ye78BdK1ey/zb33OMWXiePN3575rJQl99hPaxnMWMffcPGcJ/JzE/triOYt33zSes3jnxdYIIIAAAggggEBQAj4L/PUD5syabsJsXZdPy7i5as5rrtm22bFzl/Tq08/cPATVNFgePXKYFC5YIMhtNMwbOHio3L//u8dnXf9jvHzZMtKrR1eJGTNmoPd5eiOrwWPx0mXNQAVbC0ngr+vMVav5ubUPHTCxaf3aQEFsUAe4a/deaf9tB4d+OG+rD0A6ftveBLxBtVu3bkunrt0cAlxPULU0o1oWKVwo2M3D4lzpB2rpwGEjRsnEyVMdHio5d0YHJwwbMtAKg22ve3K+dSBGwSIl5N79+9Zup06aYNYlLFC4+AsN/A8d/slcL3rc2rwJ/J1N9FobN2aUKXdoa74O/LWfY8dPlDFjxzsMxAnJNbpi1Wrp0auv/PHHH0Fea3HjxpEB/fpI0SKFX3jg78nvBE++U2yDAAIIIIAAAggggIC/CmzeslWaNG/l0P0f1qyUDO8EPejek2MNLvC3f7/e73/9VTtp0axJoN368t5Ed37gx4NmzXhP2qsS+If2nmj/gR+l5uf1rHvdUcOHyKe5c5lnT22/bC83b94yr40cNkTKliklJ06clIpVqlv3ms2bNpZvv/7Kk1MS7DY8Z+E5i6cTK3jO4t3XzdvAP7S/U7zrHVsjgAACCCCAAAL+I+DTwD99unRy9tw5t0evo6519LWtLVi0RDp37W4FlsHtQEP/VcsWu5wVr6PPdSS3c9MZuf/884/1Y+d/215IkzqVzPt+VqBg3ZMAWPfhXIJNf+Zt4K8PHHSU/s/Hf7H6261LR2lQz7OHBnqceQsUMWvmedL0wUfL5k0Dbaql8XStPK2O4Nx0Db4nT56YH+vDkyiRI7sMboMa3KHvC6tzpftu/21HWbZ8pUO39WFK7NixAg0E+ezT3DJj6iSJFCmStb0n57tf/4EydfpM6z0aJk8cN9r8u3DxUnLp0uVAbv/991+gPjlvlO3DrLJofsA17MkMf62QUKpsRYcBBu4C/0SJElqzG579+0yO//qrqQJhaxqQ79iySaJHj2Z+5OvAv1PX7rJg4WJPLk+zTbu2raVt65aBttfqAF269/RoP2qye/sWGTR0mCxcFHiGvyfnRj/o12OHzRqUnlwjnv5O8OgA2AgBBBBAAAEEEEAAAT8V6D9oiEyeMs3qfXAVw7w5RPv7Jb0vrVghoLT7//77n1y9ds2E7/ZtycJ5ovdb9s1X9ya2fTrPqg/ueF6VwN+T5yTuzrt9eX5X2+oAAJ3F//fff0vZilXkwoWLZjM93wvmzhZdQiI0jecsPGfhOUvgbxDPWULzW4X3IoAAAggggAACvhfwaeBv617VypWkdKkSEjduXDlx8qQMHznaGnWt26ROlUo2b1hrwmJtOgK7fOVqZja2hvE62754saKm5Py1a9dk3IRJouXqbM1VeftpM2ZJ3+8GOAhpP+rVrS1p06SRzFmyW6/17NZFSpcuKatXr5XRY8c7zNJ+/73Mog8CotiVpPck3Fu9Zp0ZXe7cvA38Fy1ZKh06dbV2kzHju2aAg30g7e4y0JLqTZq3lHRp00r9up/Lxx9nN+dCQ+jpM2bJ2h/WW7vQc6A3wB9/9NxHZ0uXLl9Jrl69Zm2XLGlSE7wWK1ZExo2faGbPa4sTJ7b8uHeXHDl6TCZNmWatkWd749jRI6Rk8WIOXQ7LczV/wSLp3K2H9XlaZr9X967y6ae5zTIDOvq/Z5++sn7DJmubfr17Ss0az0shujvf+vCgeOlyVvUAHYSiSzPoEhFBNX1AkOmDbNbL6nb4wN5gT6Ungb+WL9QyhvbN3Y2olu6fOW2y9RYNu3v27meWBbC1yRPGmuUZtPky8NelNtp/87wEoz7k0rKM5cqWkYQJEsiNGzdk4ZKlptS/fdPqIblzfWL9SJcNKVu+ssNAE61K0KxJY8nwzjtmgM+2HTtkwsQpcu36dQluGQ7dacWqNUSXrrC1datXyLsZ3gny/Li7RvSNnv5OcPd95nUEEEAAAQQQQAABBPxZoN1X38jK1WusQ9D/bp81PeB+MjTN/n5J7/VO/nLUYXfO/z3eqEE96dKpg7WNr+5N7D9Uq9jpMmK2tmPLRon2/wOp9Wc6uN+2JNyrEPj76p5I70m/7tDR4T7eZqyVBYcOHmAq933doZMsXbbCvKTVG9euXBbsfbo31x/PWXjOEtwMf56zBP428ZzFm98wbIsAAggggAACCIRewKeBv4bk40aPsIJCW/fOn78gJctWcCjzr2vL6Rpztnb4pyNy8tQpKVq4cKC15TWAzl+4uLV2vAaaRw7us0J5nc2uZdR1trOtDR7wnVSuFLB2nnPYqoF/3Tq1zWs68r9Grbrmf22tR9fOUq/u85L67sI9LX2vAbDz2va6P28Cf72JLVi0hMOsep3t/VH250Gxp6dc+xI7dmyXm3/bsYssXrrMes35gUv/gYNl8tTp1uuZM2WSObOmWfvTJRPsA3/74Hrk6LGif2wtceJEsnXjD6KhuLawPFdadSBfoaKi50ObDh7RG3xdy92+aRUFLfFnG0SSNm0a2fTD8wdQ7s638zr1QVVJsP/MsAj8d+7aLfUaBi5L6W3gr/28dPmyWaLA1ffHV4H/s2fPpHCxUg7VCOy/i/Zeg4cOl/ETnw9K0AEpC+cFrNuo7auvO8jylausf+tDngljR4k+NHN2P3f+vOg1HFzz9Y2oN78TPP1Osx0CCCCAAAIIIIAAAv4oULdBI9Fy6LZWulRJGT1iaKgPxV3grx/wad6CcuPmTfNZ+nxAnxNo8+W9if2BjBk3wSwvp00rg508fsThOO2Xf4vogX9Y3BP9dOSo6HKQd+7clXjx4kqB/Pmsqg3OAzhcTT4I7UXHcxaes9iuIefnJM6Bv27HcxbfTqwIi98pof2dwPsRQAABBBBAAIGXScCngX+pEsVlzKjhLo+v9Rdfydp1P1ivfdGmlegfT1uDxs1k+46d1uY6ozpdurTm3xoMakBoa7pum67fZmvBBf66za7de6Rug8bW9jorfPvmDda/vQmAtRz6/fu/W+/1JvAfNGSYTJg0xXqvVigY2L+vp0Qeb6c3Jrny5DMzt21t/+4dZqDF06dPJXvO3NZrWgFgw9pVDksoBBf46/6q1qgtuq68rQ0dNMAqrxiW52rL1u3SuFkL63MrVSwvQwb2d+miy0h06vJ85sWu7Zsl6dtvm22DO9/OIbsOFli7armpHhBc83Xgr4NgdJCJVizQB0laAeKvv/4yXQhJ4P/riRNSpnxl6xDsB5r4KvB3Xs8yefJksm3T+kAhvXZCjyVH7rwOg3h2bt1kZmfowI4s2XNay0ro9ts2r5eUKVJ4/B1w3tDXgb/9oBB3vxNC3GneiAACCCCAAAIIIICAHwjUqd9Idu8Jn8A/60efyMOHD41S+y+/kFYtmpm/++rexJm/W4/eMmfefPNj5+cK+rNXKfB/kfdEFy5ekrIVKlv3j7Vr1jBV3rSdPHVaNm/Zau6dY8WKKZ/kzGGWuLNVnPTVV4jnLCI8Z3k+aUGvK56z+Dbwf5G/U3z1e4H9IIAAAggggAACL1LAp4F/cCP1p8+cJX36PS+5X6xoETMj19NmX5pN37N4wVzJnu1D8/Yates6rM/nXD3AXeCv+8hfuJhcufKb1Z3N69daM8ODC4B1LXJd90+bzkLWWeX2DzM8CfxTp04l6zduki++/NrMNNCmM+PXrFwm8eLG9ZTIq+1atWkn69Y/H9SgMyz0/O3bf0Bq1alv7SvXJzll7uwZDvt2F/hrCT09X7ZmPwAjLM+V84AJHYCSPYjqCBcvXnIoYa/HqMeqzdX5rlWjupw6fUbqN2piVRDQkF3fl+Pjj9za+zrw/7L9t7Ji1WrzufrQSisu6JIY2rwN/LXiwdffdhKdEaEt47sZzCAGW/NV4G8/20X3bf8QxhVgwybNZdv2HdZLtqodBw8dlmo1n1fgSJNalwhZ5/YcBLeBLwN/b38nhKrjvBkBBBBAAAEEEEAAgZdcQJe+09LutqbrrX8/c1qoe+1uhr99+Kj36Vs2rpO3kyQxn+urexPng6jfqKmZga5NlyTTpcnsW3gG/lriPlbMmKY7ei8bO3YseTdDBilevKgUKpA/UAA+a/Yc6dmnn9X9Zk0aSYdvni9j6MvnJKG5GJ48fSqVq9aQX349YXajS7PpcxitoNCjd1/RZf+cW9asWWTCmFHmuYsvG89ZeM5iu554zuLbpRN5zuLL31TsCwEEEEAAAQQiqsALC/x/WL9RWrb5wnLUcv4azDs3XW97w8ZNcuTIMTl95owp1fbo8WNr9rJte1133ha02pfp09ePHzko0aJFs3btSeDvXIFg2uQJpjyctqBuZHXtvZJly5vZ8Bqyrl21TDp06uow+MBd4O/qwtIAc9SIYfJe5uDLkLu7KCdPmSb9Bz2vdBDc9p2+/VqaNG4YaER2k0YNpFOHbxze6i7wP3vunBQrWdZ6T9YsH8iyxQHrzIfluXIu8+7Ox/71ieNGS9EihV2eb1f70fUBe/fqLuXLlvHoY3wZ+Nt/lzScX750kWR8L6vVD3eBv15fVSpXMtvrTHodoKKlEbVplYN53880s1FszTnw9+iA/38j+4EUnbv1cHjYoutn6jqaQTV9uKQPmWztq3ZtpXXL5maggw54sLXPPs0ts2eEbg1QXwX+Ifmd4I0n2yKAAAIIIIAAAggg4G8Cfb8bINNmPL/310HtB/fvDvVh2Af+GmDr/YI2HUSvM2v1vkmbhv1aibBwwQLWZ/rq3sT5IHSZNC3jra1mjWrSr3dPh01CEvh7CuX8jGXz1m3SpFlLj96u7x03ZqTDhIOQBv4v+p6oV9/vZOasgOXfdCnBlcsWSfp06aR7zz4Og/ydIWwDA/T68KbxnMVzLZ6z8Jzl6NFj1gWzbvUKMyAnqObLZ6+eX6VsiQACCCCAAAIIRByBFxb4O5db/+D992TF0ucjrS9cuCgDBg+VjZs2e6RrH/h/kO1jqwS9q3XwPAn8nW/4hw8dZIW5rv6js2b1amYmvJYC1Kbl4nTGsvMM9pAE/okSJZTuXTuLzlAPTfPmRlSDVH1AMmXaDDPAwdZsIat9P9wF/rquVq48+a23pE6Vysym0BaW56pNu/ayZq33M731Bl+vxQzvpDd9dD7frs6BPkho3LC+fPlFG49KAfoq8NdZGFrKX5eNiBIliixfvEAyZcooaTNktrrpLvAP6prS5QlGDB0s77/3fF+6ra8Cf+eZPX179xCtnBBUc67YoANSdGDK3PkLpGv3XtbbdNCFfl9D03wR+If0d0Jo+s17EUAAAQQQQAABBBB42QV0aT8dYG/fVi1fEuoB7vaBf1AGOqtdQ/fSpUo43Lf56t7E/nMfP34sH2TLITqzV1v3rp2kft06Dl17WQN/7aRzRYKQBP4v+p5IS/U3af58qcgB3/WRalUqy/nzF6RoyTLmXOgzokH9+0mxYkXk1KnTprKiTjTR1rNbF6lbp7ZXXyGes3jGxXOWACees4Qu8H/Rv1M8u7rZCgEEEEAAAQQQeDkFXljgryX89Kba1uzL+O3dt1+atmjlsKa83phn+zCrKasfO1Yss+aarcKvVtsAACAASURBVESb7sM+8P8sXyG5fuOGtW9fzPCfPmWi5M+X1+zTOQDWoFJD0P4DB5vX8+b5TGZOC1iry9vAX2eVx4geXU6cOiUnT56yjkFvSnV2tI60D2lT8+/nznP5dh11b7vJ1Q10Fr/O5l+4eIl07Px8bXufzPDPmkWWLQpYxzAsz5X9eon6WZMnjJXChQp6zed8vj/MmlXSpk0tN27clD179znsz9WACFcf6KvAv/+gwaKDZ7R90/5LadGsifm7LwJ/W791Joo++NABBdpcBf56fbpq//33n8OP7Wf4d+neU+bNX2i9HtIZ/qtWr5Uvvvra2k+RwoVk0vgxXp9n+zeENvAPze+EUHWcNyOAAAIIIIAAAggg8JIL3Ll7V3LmDri3trVKFcvLkIH9Q9VzTwJ/2wfofbUOEraV9PfVvYn9ATgvj7do/hz5yGmJuZAE/rrWfFDrzdvff7mb4W9///jkyRPzfKVrj15y4sRJ6zAWzvveLFWozdvA/0XfE+kzoNLlKsrvvz8w/S1XprSMGBbwjGbs+IkydPhI83fnpSftlyDUqpH6bMmbxnMWnrPo9eLtxAies4h4O8P/Rf9O8eb3ANsigAACCCCAAAIvo8ALC/yd18jTUdc6+lpHwecvVEzu3rtnfHTmdK8eXaVCubJW4Kg/1zXh9cbM1uwD/5qf15P9B360XtOlAuyDck9m+OcvXEyuXPnN2oeuCa6lz7U5B8AtmzeVKVOni64VFytWLFm/ZqW19pu3gf/GdaslXbq0ZuT5t526yJKlz9dO1xnnupZ6UOFqaC6opi1ay6bNW6xdjB4x1NwIq6N62pqua6+hrX1zN8Pf/gZa32d/4x2W52ry1OnWIAz93C/atDJ/vG3BrUW4aMlSs2yDrUWNGlU2b1gryZImDfZjfBH4azWB4SNHm8/Jnu1D82BCS1dq8ybwtx+gou/VBySLly5zqOzQtnVLade2tdm3841sgvjx5cDenS6Pt1HT5rJ12w7rNfvAf9yESTJk2AjrNa2IoZUxgmoNmzSXbduf72vooAFSsUI5+fHgIale6/lMGf2e6vc1NC20gX9ofieEpt+8FwEEEEAAAQQQQAABfxDQWdg6iN/W9B5XlxKzLdMXkmOwD/yjRokiJ38JKJ+tzbZ0WYfOXU11NG32gbiv7k3s+633OrpfbTq7+ejhA6L9sm8hCfxt1QSdjY79fFwqVK5m/dibwN/2Jp0JX6REaWsf9gPavQ38X+Q9kS7bULtuA6viYqqUKWXViiVmMoW2dl99IytXrzF/d57Ff/XaNclboIh5LU6c2HL4wN6QXH4u38NzlqApec4iwnMW70r6v8jfKT77JcCOEEAAAQQQQACBcBR4YYF/leq15PBPR6xDtZVa0xLsWord1r79+itp3rRxIJLgAv/xEyfL4KHDrffYB8z6Q3eB/67de6Vug0bW+1OmSCHbNq+3/u18Y6JrDt67f9+8PnLYEClbppS1bUgDf92B7jNfwaJmEISt2Zx8eY08/PNP+SxvQfnz0SNrt/t375CECRPI06dPJXvO3Fa1BZ1JsGHtKjMowdbcBf7Van4uBw8dtrYfOniAVCxfzvw7LM/V8V9+FX3oY2taOk377u2AieBuRHXflarWlCNHnz9M0mPTYwyu+SLwt113WrJ/zcqlokslWMfqRUl/58Dftg9dokJnpWjTZSX27QqoJOCrwF+vCb02bC158mSyffMGl7NV9AFdzk/zOlT92LltkxlYobNRsmTPaf7X1tavXSnvpA9YkiEkLbSBf2h+J4Skv7wHAQQQQAABBBBAAAF/Ejh0+CepWsOxdHqCBAlk5tRJZomy4JoOAp40ZZp079JJMmZ819o0uMDfttGoMeNkxKjn1cBsA/t9dW9i+xydaV+gSHHRSnraChbIJ1MnTQh0WC9b4K8dzPRBNvPMRFvD+nWla+eO5u/eBv4v8p5o2IhRopNKtGllusUL5oouG2lrLVq3lfUbNpl/9u/bW6pXe/6cQCeb5MiVx7zmvBxeaL5TPGcJXo/nLDxn8XaG/4v8nRKa7z7vRQABBBBAAAEEXhYBnwb+WT54X7Rsna0UuO0gnddV09Hu+3Ztk9ixY8vU6TOlX/+BloeW9dPyfvZNA3Cd0RtUSf87d+5I/sLFzSh+W7PNBtZ/Bxf4axk4DSGvXr1mvdd5rb2g1nQvVaK4jBn1fKCB7iA0gb++335WgP47ceJEsnXjD6bygadNvTZv2SYF8ucVXRrBuX3TsbNDJQHnWfy6VIHOlrc1vXGePWOqqWagLbjA37mSgwbH2zatt/ofludKqySULl/JYWmE9l9+Ia1aNHNJp9flmbPnpHHD+hI5cmRrG3c3ort275G6DZ4PStFBEauWL5bMmTIFeYp8Efjbdt6rRzepU7umw2eFZoa/bUd16jeS3XsCZjdEjx5Nfv7poPm7rwJ/fQhWtERpuXDxktX3oNZM1AE8OjjE1j7JmcPMALI15zU3dRDDtMkTrIoHtu30+61VM6pWrmRV4XB1kkIb+Nv2GZLfCZ5+r9kOAQQQQAABBBBAAAF/FnAuo6/Hove5zZo0ktq1aohWErNvly5fNkG/bVkwHaC+ZME80YHD2jwJ/J3vT1cuWyzvv5dZfHlvon3RimnfduxidV+XDyhftkyg0/WyBf5a5VCrHdqa/f2zt4H/i7on0kHqOrtf7/+1uVoqrkevPjJ7TsDyhq1bNhetXGBrR48eE73/0+ZNtTieszxfgpLnLIGfkwQ1sYLnLMes7563gf+L+p3iz/+/St8RQAABBBBAAAF7AZ8G/rpjXe9NA9Z3380gfz3+S9Zv3CQ6qv7vv/+2PrdBvbrSrUvAqHHn9bg1fJ4ycZxEixbNvK5l6rp06+EQ9uvP7Uv667+dy7nrzzTkq1e3tqRNk0YyZwlYh06bhoylSpWQNWvWyeix463Z+vqazi5YtniBQ+k9V4G/zkbQUv5x48ZxuKJCG/g/ePDAzPLX0eG2FtzNlPPlrA8umjRvacqqax9bNGsseuMRK2YsuXzlikybMVN+WL/R4W32Zdf1Be1D6XKV5Nr169Z2yZIllXZtWkuxooVNmcKJk6ea17QE3o97d8lPR46ac7Bx02aHfduWCrD/YVieKz1uLStv33SpgmpVKkny5Mnln7//Nn2dM2+B/HrihNnM/nrUf7sL/HUb5/Oc57PcMmt6gImr5qvAXz9n5rQpgWbFhzbwX/vDemnbrr158KUta9YssmzRfPN3XwX+ui/nih5afaHO57XMsg/6gO/mrVuyeMkyWbh4icWoAyp0mQ77cp8nT52WshUqi5ZytDUdFNCqRXN5J306UyVDl6wYO2GS/PHHH6KDkXQ9Sl2CwVXzReAf0t8JQV40vIAAAggggAACCCCAQAQS0HsiHWz/8/FfAh2V/jd/urRpJUGC+Kbq3PXrNxzuR21vaNOqhehSZ9rcBf5nzp6V2nUbig4616YTEw7u22UNivfFvYned2zbsdOE/bZKfUnfflu2bPohUDl/7cPLFPjfuHnTlL4/8GPAQG9tOlNel4/TFpLAP6zvibQqYqmyFeTWrdumj1pJYcrE8YHujzds3CTNWwWE/EkSJxatCKeTIXSQQNsvvzb3pdrq160jOuHDXeM5C89ZnKtBOD8ncRX485ylhugAG1sLSeAf1r9T3H33eR0BBBBAAAEEEPAnAZ8H/u4OXkvDr1iy0Ar09YYtT/7CDgMCdN21FClTyP1790VvQrXFjBHDIQR3Dvx1m05du8uChYsDdUErCthK1OmLzv+2vUFnCuh+306SxGEfrgL/yRPHSeGCBQJ9VmgDf92hc9lB9di2ZYNoOSt3Tb0qVqkuN2/ecrepeV2XT9BlFJzbiRMn5fP6Da31Du1f19DUVk5dH8xEiRxZnjx9Gmgf9uv/Ob8YVudKP2fQkGEyYdIUj45fN8qa5QNZoGHw/6+v6Engrw9F9Fzbt5nTJpvBFa6aLwJ/fUDxw5oVga5P/TxvAn+t1JDx3QxWN3Vgh630pO2Ho4YPlTKlS5p/+jLw1/317N1XZn0/1+PzE9QyH64GjgS1Ux2Ysnj+XNFlHlw1XwT+If2d4DEEGyKAAAIIIIAAAggg4OcCuqxcqzbtZOeu3V4fiZZl/65PLyvctQ/8dWe6hr2t3b//u5w7f94a0Kw/r1WjuvTt3cPhc0Nzb6KD4LX6nasW1LJytgHWtvfYb3f25HHzY0/uR3U7nRxRoXI16+P1+HWgtK1t3rpNmjRraf1bnytEjxGwxv3TJ08dJj7ozz7NnUu+nznN2j4kgX9Y3hNpWN+4WQszuUGbVkNcs3KZy+ckOjC8ZJkKcvbcOWtbHUB+7vwF0Wcd2nSSyYZ1q0QHaLhrPGfhOYu7wJ/nLIG/RTxncfebhdcRQAABBBBAAAHfCvg08Nc1tG/dvm1miLtqGqxOGj/WrBVv3+bOXyBdu/cK8sgKFypo1uvTNfFsZdtcBf66gznz5suQYSOD7ENQH6KzwPv26m6WGXBuzjfc1apUlgHf9XG5K18E/voQpFCREnLn7l3rM+rWqW0qE3jSdHmCNu3aO6wz7/w+fbCglRhssyNc7VeD4I6du4mWsPemaRn/Ht26SMniz0sDunp/WJwr2+dMmTbDLI9gv867cx90sEKF8mWlb68eZu0+W/P0AUvDJs1F15O0Na0OsWrZYnH1cMcXgf/QwQOkYvlyLk+FN4F/cOdS+67XhP0yCL4O/PXztVz/yNFjgz0/uqxA104dHdZbdO779JmzZMCgoWYWUFBN1/kcNXyIpE+XLshtQnsjGprfCd58t9gWAQQQQAABBBBAAAF/F9Awdt6ChTJi5JhAobOrY9P7S70vsA1Itm3jHPgH51KsaBEZMXSQy6XyQnpvou/Tpch81c6f/tXsytP7UW8D/+D6qRXRpk2Z6BCeexv4h/U9kd7jq402vZfXSoVa5S2odvrMWfm83vMKD/bb6SQQXZ7R1SSOoPbHcxYRnrMcsi4P5+ckwX2/eM4SoOPtDP+w/p3iq9/d7AcBBBBAAAEEEHhZBHwa+Gto3rVTBxk/cZJs2bbdzDLX0O7dDBmkYoVyUrlihUBrbNsgdO1wvXnQcutaCi9evLiS7cOsUrVyZSlUML/ZrEOnrrJsxUr5999/A5X0twfVcvjLlq0wpfVOnjwl9+7dc5iBrjeHsWPHkmRJk5pR7BqiaigYVLO/4dYbSl0r3D4gtn+fLwJ/3Z+WvercvaecOXPWHK+uMb/xh9WSKmVKj68dLa+/dt16OfTTT3Lnzl0zWEKrF+gx6wCCDO+k92hfhw7/JKvWrJX9+w/I9Rs3TYl055tlLcf+3nuZzbnStQr1BtqT5utzZf+ZOgp/7rwFsmPnLrl0+Yr8+eefEiNGDEmVMoV88klOqVq5ossQ2NMHLDogQ0s37t2336ogMWRgf6lUsXygQw9N4K83hw3r15XOHb8NkjQ0gb9eyylTJJdcuT6RWjWqiQ7csW9hEfjr/q/fuGHW49y5e49cvnxZHj78U2LFjClp0qSW/PnySq2a1T2qaqFLVcycNUd27Nol165dN7N44seLJx9+mFVKFCsqpUoWdzkIw/4YQxP4h/Z3giffE7ZBAAEEEEAAAQQQQCCiCeh9xtZt22Xzlq3y64mTcufuHXNPECdOHEkQP55kzpxJihYuLPnz5XEZ1AcX+Gv1tsRJEku2rFmlcqUKQVZis5mG5N7EnwN/fSaiVdDey5xJypYpLRXKlTVLHtg3bwL/sL4n0mUgqlSvZQZ66/3rN+3bmXL87pou5zBuwmTZtGWLeT6lEzzy5vlUWjVvFmT1N3f75DkLz1n0GnEX+POcRYTnLO5+m/A6AggggAACCCDgWwEr8A/Jbp1LxGngr2u2v2zt3LnzUrRkGatbjRvWDzY8fdn6/7L1R6sH2Na80779/NNBM7DDF41z5QtF9oEAAggggAACCCCAAAIIIBCWAs6B/44tG0WXCfS0dene0wyAtjXbDH9P3892EUuA5ywR63xyNAgggAACCCCAAAIIvGgBAv8XLR4BPo8b0QhwEjkEBBBAAAEEEEAAAQQQQACBEAsQ+IeYjje6EOA5C5cFAggggAACCCCAAAIIhEaAwD80eq/oe7kRfUVPPIeNAAIIIIAAAggggAACCCBgBAj8uRB8KcBzFl9qsi8EEEAAAQQQQAABBF49AQL/V++ch/qIuRENNSE7QAABBBBAAAEEEEAAAQQQ8GMB58B/59ZNkixZUo+PiJL+HlO9EhvynOWVOM0cJAIIIIAAAggggAACYSZA4B9mtBF3x9yIRtxzy5EhgAACCCCAAAIIIIAAAgi4F7AP/FOnSiXrVi+XN954w/0b/38L+8D/09y55PuZ0zx+LxtGPAGes0S8c8oRIYAAAggggAACCCDwIgVCFfi/yI7yWQgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCDwXIDAn6sBAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABPxQg8PfDk0aXEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQIPDnGkAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMAPBQj8/fCk0WUEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQI/LkGEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQ8EMBAn8/PGl0GQEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQJ/rgEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQT8UIDA3w9PGl1GAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECAwJ9rAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAT8UIPD3w5NGlxFAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEECDw5xpAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDADwUI/P3wpNFlBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEECPy5BhBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEPBDAQJ/PzxpdBkBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAECf64BBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEE/FCAwN8PTxpdRgABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAgMCfawABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAE/FCDw98OTRpcRQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBAg8OcaQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAwA8FCPz98KTRZQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBAj8uQYQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBDwQwECfz88aXQZAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABAn+uAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBPxQgMDfD08aXUYAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQIDAn2sAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABPxQg8PfDk0aXEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQIPDnGkAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMAPBQj8/fCk0WUEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQI/LkGEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQ8EMBAn8/PGl0GQEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQJ/rgEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQT8UIDA3w9PGl1GAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECAwJ9rAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAT8UIPD3w5NGlxFAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEECDw5xpAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEDADwUI/P3wpNFlBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEECPy5BhBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEPBDAQJ/PzxpdBkBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAECf64BBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEE/FCAwN8PTxpdRgABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAgMCfawABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAE/FPDLwP/Jkyfy+PFj+euvv8yfKFGiSNy4cSVatGjy2muvmT+etGfPnsnTp0/l77//lkePHonu93//+595f6RIkeTNN9+UGDFiyBtvvCGvv/66x/v15LPZBgEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgdAI+F3gr4H877//LpcvX5bffvtNrl27JjFjxpQcOXJI8uTJTfiv4bwnTYN+3deNGzfk4sWLcu/ePTMAQMN+DfoTJ04s6dOnl4QJE5r96s9pCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIvAwCfhX4//PPP/LHH3/I7du3TdCvIf25c+ckXrx4UqxYMcmQIYNEjRrVo2BeBw5owK/7uH79uty9e9dUDbDN8NdBA1o1IE2aNJI0aVLzGW+99dbLcM7oAwIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAuJXgf+dO3fk5MmTov+rZfc1sD9z5owJ5r0J/DXU//fff02VgAMHDsjDhw8lZcqUkiBBArMsgA4s0EEAWuZfZ/UnSpRIMmbMaF6nIYAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggg8DII+FXgf+vWLTl+/LiZ5R87dmy5f/++HDt2TKJHj+5V4K9l+3U2v87u37t3r/z333+SM2dOM5tfS/n/9ddfZjDAlStXTCUB/azcuXObJQN0oAENAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACB8Bbwq8BfZ+LfuHHDzM6PFSuWCeO3bNkiWn7fmxn+GvZrlQAN9E+dOiVvvPGG5MqVS1KkSGFm9Ov+9bPOnz8v+/btM68XKlRI0qVLZwJ/Qv/wvmz5fAQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABvwr8nzx5Ysrsa9NZ/TpDf/Xq1fLs2TOvAn+tEPDbb7/J1atXzQACncH/8ccfS9KkSc2+bSX/dbmAjRs3mn8XKVJE3nnnHYkSJYoZYEBDAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAgPAX8KvDX0vs6+15b5MiR5ezZsyEK/HUpgHPnzsnNmzfNTP548eJJ1qxZJXHixNa50JBf96+Bvy4BkC9fPkmfPr289dZb5rNpCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIhKeAXwX+zlCnT58OUeB/9+5d0ffeunXLhPnx48eX999/XxImTOjwEVrSXwN/rSyQO3duSZs2rcSIEUOiRo0anueMz0YAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQEBe2cD/1KlTJvDX5QASJEggmTNndhn4b9682QT+OXLkkDRp0kisWLHkjTfe4NJBAAEEEEAAAQQQQAABBBBAAAEPBbSK3tZtO2Tz1q1y6NBhuXX7tjx8+KdZri9ZsqTycfZsUqlCecmaNYuHe2QzBBBAAAEEEEAAAQQQQAABBBBQgVc68L99+7ZD4K/Bv33TGf4a+P/999+SPXt2E/jHjBnTJ4G/Puyw/dHPfP311+W1117jqkQAAQQQQAABBBBAAAEEwkVA70dsf7g/CZdTEGE/9MCPB6Vbj95y5uxZt8dYrGgR6d+3t8SNG8fttmyAAAIIIIAAAggggAACCCCAAAKvcOB/5swZ0cD/n3/+MSX933vvPUmUKJHDNaGB/4YNG+Tx48eSLVs2SZkypUSLFi3UJf016NfKArY/+lBNlwmIFCkS1yQCCCCAAAIIIIAAAgggEC4CGvLrPUmUKFG4PwmXMxAxP/TYz8elUtUa8t9//1kHmDBhAnk3QwaJESO6meV//Jdf5cGDB9brGd/NIIsXzDX33zQEEEAAAQQQQAABBBBAAAEEEAhe4JWc4X///n3RMP/mzZvmoULcuHHlww8/lCRJkhgtDeT1YcTZs2dl48aNZlDAJ598YgJ/LecfOXLkUF1Xum8N+58+fSr//vuvmd3/5ptvhnq/oeoUb0YAAQQQQAABBBBAAIFXWoDA/5U+/WF28HrvW6xkGblw8ZIUyJ9PkGiaBgAAIABJREFUWrVoJh9lz+bweXpfvHrtOunRs488/PNP81qzJo2kwzftw6xf7BgBBBBAAAEEEEAAAQQQQACBiCLwSgb+f/zxh/z2229y9epV8ydWrFgm0E+WLJk5r/pA4smTJybw15L+2goXLixp06Y1M170QVhomgb++kBD/2jor/t76623CPxDg8p7EUAAAQQQQAABBBBAIFQClPQPFR9vDkbg9JmzcuvWLcnz2afBOm3fsVMaNG5mtokXN64c2Lsz1PffnBgEEEAAAQQQQAABBBBAAAEEIrpAhA/8dba+Bus6S18fYOkMfQ3z7969K5cuXZITJ06Yn+XKlUtSpUplylfqtrYqAIcPHzZhfKFChUzgr/sIbSPwD60g70cAAQQQQAABBBBAAAEEEIiIAvkKFZXffrtqDm3fru2SKFHCiHiYHBMCCCCAAAIIIIAAAggggAACPhOI0IG/Lex/9OiR3Lt3z6AlTpzYBPx//fWXKeu/Z88eM6P/448/NoG+zvbX7c+dO2dm/+vAgHjx4knOnDklefLkPoEn8PcJIztBAAEEEEAAAQQQQAABBBCIYAIVq9aQo0ePmaM6sGeHJEiQIIIdIYeDAAIIIIAAAggggAACCCCAgG8F/CLw1+Be/zx+/Fh+//1387/atCz/3r17RQP0HDlymEBeZ+hHjx5d4sSJI1GjRjUl8zW013BfS+dnypRJ4sePb0J+ff/+/ftFS/wnTZrUPEiIGTOmGQygr+nnRIsWzQwSyJAhg3mfLxqBvy8U2QcCCCCAAAIIIIAAAggggEBEEtBqfDly5ZGHf/4p0aNHk59/Oujy8K5dvy6LFi+VbTt2ypXLV8z28eLFlU9z55LmTRvLO+nTu3xfjdp15cCPAfvcsWWjJE8esKyfc7t+44Z8lq+Q+fFH2bPJovlzXG535OhRmf39PPnx0CG5ffuOqRbo3Nq2bint2rY2Py5VrqKcPHkqRKfsq3ZtpXXL5ua9nh6Hbrt85Srp3LWH/P3337Jx3WpJly5toM9/9OixzJ2/QDZs3CRnz503z0j0GYxzO3/6V6/67mk/PfXWDz90+CdZvGSp7N13QG7euiWRI0eSFMmTS768eaV+vc8lSeLEXvXRfmP7/nq6E1fXh20/devUlp7duphd7dt/QGZ9P0eOHv3ZPKPS509583wqzZs1kVQpU7r9uF9+PSELFy2W3Xv3yc2bN+XZs/8kYcIEkuPjj6RShfLm2g+qBXVcumRl7FixJGPGd6VE8aJSrWoViRolSrB9CU0/7HfcpXtPmTd/odvjLlK4kEwaPybQdiNGjZFRY8aZnw8a0E+qVKoY5L50SZG6DRrJrVu3pU+v7lK7Zo0gtz177pwUK1nWbb90gyUL50m2D7Na2+o5rlWnvvl3pYrlZcjA/kHuR5831mvYxFzPpUuVlNEjhrrcVr+Hq9esk1Vr1srx47/I3Xv3zHPK1KlSitrUqV3TTFxydR3rM9CzJ497dCxshAACCCCAAAIIIOD/An4R+NsCcg3hDx48KNeuXTPy+h/It2/fNn/XMF7/o1dL7idLlkyyZ89ugnoN/K9cuSIHDhwwgwEKFCggqVOnNoMEdPDAxYsXzf7u3Llj9qf/Ma370P8w1n2mS5fODAbQAQRvvvmmT844gb9PGNkJAggggAACCCCAAAIIIIBABBLoP3CwTJ463RzR57VqSu+e3RyOTu+lR48dLxMmTXEZruvGkSNHlmGDB0qZ0iUDyfgygB46fKSMHT/R4TP0OYKtaV+1hWfgf/78BSlTobIJ+7W5CvwvXLgo9Rs3lStXfrP6rs9EbMsZ2o5DXwzPwF8Hg3Tq2l2WLV8Z5BWv1Ry/69tLKpYvF6Jvha8D/8yZMsmyxfOlZ59+QYbb2udxo0dKwQL5XPZZl6js1ec7mTNvfrDHpOHvsCEDJUb06MFe966uUdsbMmXKKPNmzwgUIOvrvuiHfcfaftneBNnuWmgDfx2EU65iVTlz9qz5KHeB/+GfjkiV6rXcdcu8HprAv0OnrrJoyVKzn6ACfx0I06JVWzn2c9ChfZw4sWX4kEGSP19eq8+265jA36PTyEYIIIAAAggggECEEfDrwN8281/Phv0NqQb0GvgnSZLE3JRooH/kyBET+OfKlUtSpEhhTqD+h7+G/jdu3DDBv4b+OkBAHxDoTP+3335b0qdPb0Ze68/sb4xCcwUQ+IdGj/cigAACCCCAAAIIIIAAAghEBAG9p9dZ2jrrXYP+vfv2m8NKnDiRLF+80Pyvffu6QydZumyF+VHMGDGkbJnS8u67GUTD4B8PHjIz1LVptb91q5ZLmjSpHd7vq8B/xarV8mX7b82+Y8eOLb16dJWihQvJW2+9ZX7205GjUrlaTfN3+8BfgztbxUL7jk2dNkM2b91mftS1c0fJnCljoNOrs9iTJUtqfu7JceizDe3D8V+ez8p3Dvy18mGJMuXl3LnzZr8lixeTb7/5SlKmSGEF/joLeeeu3eb18Ar89RlK/UZNZdfuPaYfefN8JpUrVZDUqVLJf/89kyNHj8m4CZPNMx1tkyeOk8IFC3j9FbF3HTlsiJlB76rpkpGtv/jKvBTcDP+4ceNIrpw5Zd36DabqhM6i12v6xo2bsnLVGrl85YrZh4b+G9aukhQpAi8j2aJ1W1m/IeC61udUlStWkPffyyyRIkcy523J0uWiwbC2D95/z1Sj0OvfvgUVAOv5P3P2nIwcPcb6jCaNGkinDt8EOmxf9MN+pw0aN5PtO3Yal/ZftnX4PK040f7bjuZnoQ38dbDFrNnPK3S4C/y3bd8hDZsEVNLo8E17SZM6lUPfps2YZVUJCWng/8P6jdKyzRfWfl0F/vfu35fyFavK1f+f8KTffT3376RPJ1p8QwcmLFm2XB4+fBjoGiTw9/qrzxsQQAABBBBAAIEIIeAXgX9QJf2DOgM60982I1/fqyX6NdjXQQEa3ttuwvXmRgcE6OuPHj0yDwlsM/w14NftYsSIYW6W7AcUhPbME/iHVpD3I4AAAggggAACCCCAAAII+KOABttNmrUMsusaAI4aMVTezfBOoG3WrF0nvfr2l4oVypny9hr627cp02bIdwMGmR/VqlFd+vbu4fC6J0G5vsFdifnylarKz8d/MfuePWOqfPZpbofPCSrwD+qg7cubz509Q3J9kjPYU+vJcQwaMsxUQrBvzoH/lq3bpXGzFmYTLQ2/YO7sQJ/7MgT+OhhEqz9oa9WimbT/8nlYauuwLkNQt0FjMxtaw9EtG9aZSR/eNE9cPbk+7Pejz5I6ftNemjRu6NAVnYDSpHlL2bV7r/l5+bJlZPjQgGvX1nSZha7de5l/6vdh1vSpgQYh6ACS5q3aWPtp3LC+dO4YMBjF1twFwPpsrHjpcqIVIbS8/9qVy8KkH/Y7tX2HXAX6GnZ//MlnZvPQBP46oEAHFtg3d4G/VpCwDTbYvH5toEFDOtBHB/xoC0ngf/PmLSlZtrz8/vsDq1uuAn8dULJ23Q9mGx0oolVLnKuO3r//u3w/d55Z0sE2GEi3d3e+vflOsC0CCCCAAAIIIICA/wj4ReDvP5ye9ZTA3zMntkIAAQQQQAABBBBAAAEEEIhYAu4C/149ukntmtVDVGFPB/Tn+iy/aGCoAdjOrQEzo23NF4GuThLIkDmLaEiaIH58ObB3Z6ATFN6B/4EfD0rNz+uZiQtaLcA2y9858NflEYaPHG36H1QQGt6Bvwbjn+UrZM5plg/el6WL5gd5bdi7T58y0aHMuSffIl9cH/o59vvRig0N69d1+fHXrl+X/IWKmWtJZ/kf3LdbokePZrbVa7lA4eKi20SKFEnWr1kpadOmcbkftSlYpISZ7a372b1ji8SLGzfQdR9ciXcdhKPfzQ+zZpWli+ZZ7/VlP+w7nztvAdHwu3rVytK/Xx+H4/JF4K/7KFG6vKn6kDVrFjl69Fiw17mtA+MnTpbBQ4ebfx45uC/Q8gahCfz1d0e9ho3N4Az7PjkH/rrMRuHipUwfkr79tmxav8arJUYJ/D35trMNAggggAACCCAQ8QQI/MPhnBL4hwM6H4kAAggggAACCCCAAAIIIBDuAidOnJSpM2Za/dAZyufOXbDW2NYXcub4WKZOmmCFn950ulrNz+XgocPmLad+Oeowy9tXgW7W7Dnl4Z9/mgqCB/bsCNS98Az8NfQtWaaCCYp1VvmlS5etpQ6cA/+p02dKv/4DTf+1GoJWRXBu4R3421chCC48135roPpBthxm2YQWzZrIN+2/9ObS8WipBN2huwoQnl5nuq/adRtYS1nMmTVdcuf6xPR5/4EfzaANbQUL5DPfh+Ba9559zGxvbQO+6yPVqlS2NncXAGsJ/YJFisudu3elTasW8uUXbaz3+rIftp3qAIeM739oBjrYL3lhe90XgX/TFq1l0+Ytku3DrFKyRHGr8oe7Gf62JQC00ufJ40cCkYcm8Ld932LFiiXDhwySRk0Dlg5wDvxHjRknI0aNMa/pNazXsjfN3fn2Zl9siwACCCCAAAIIIOA/AgT+4XCuCPzDAZ2PRAABBBBAAAEEEEAAAQQQeGkFzpw9KxpaasCoTYNPDUC9bRqibd0WEMIf2r9HdB11W/M0iHUX6Nap30h27wkoxb58yUIz89y+hWfgbwsktTS79q112y9N8KnNOfDXgRE6QEJbUKFyeAf+Q4aNkHETJpk+atWGaG8FzIAPqp2/cMEEyVUqVZRBA/p5dfn46vrwdD/auQGDhsqkKVNNP7t16SgN6gVUAxg7fqIMHT7S/L3Tt18HWhLA+cC0/LuWgddWtXIlGdi/b6Dr3tUM/wsXL0mPXr3NrPM0aVLLkgXzJE6c2NZ7fdkP205/++2q5CtU1PxT+6n9tW+hDfwXLFwsnbp2F13uc/WKJaKDRvp+N8B8hLvAX5cA0KUA0qVLa74vzi2kgf+p02ekfMUq8uTpUxk1fKikTZtaypQPGJThHPjbf+dWLF0kH7z/XoiuYz3fWh3A1iK9HklixYopsWM/P79e7ZiNEUAAAQQQQAABBF5qAQL/cDg9BP7hgM5HIoAAAggggAACCCCAAAIIvNQCT548kao1asvPx38x/Zw0foxZw9tV0zXbt+/YJb/8ekLOnTtnSr7rzO7LV36Tv/76y7zl4P7dLkube4PwUfZssmj+HIe3HDl6VKrXqitPnz6VZEmTii5DkD9fHlN6XVt4Bf5r1q6TNu3ai85OXrlssWR4J73YZjprv5wDf/2Z/eu1a9YwM7wTJUpoHa+vAn9PzZ29v+nYWZYsXe7p263tGjWoJ106dfDqfZ4G9e4GhHi6H+3ctBmzrDC6dcvm8lW7tqbP3Xr0ljnz5pu/jxs90qzjHlzTZRvKVaxiNsnz2acya/oUa3P7/uj1amtapUK/R3q9NKhXR1o2byoxY8Z0+Bhf9sO2Yx0so4NmtC2YO1tyfPyRw2eGJvC/dPmylC5XyfwusFU6sDd2F/jrMgqXr1yRQgXzy5SJ4wORhyTw15C/QuVqcvLkKalYvpwMHTxAfj1xIsjAv2jJMnLu3Hnz2UcP7Q90Ttxd1Pbn29W2CRMmML9XWzZragbR0BBAAAEEEEAAAQQihgCBfzicRwL/cEDnIxFAAAEEEEAAAQQQQAABBF56gQ0bN0nzVgGhp4acGnbaN60EMGrMeFm/YaNZ5zy4FlaBv36mViLo3K2H6Hrb2jTsT5QwoVlf/p8nT8za4dpclSx37nOX7j1l3vyF5sdzZ8+QXJ/kDPa4XAXKN27eNKX8Hzx4ID27dZG6dWqbfbgL/P/55x/p13+QzF+4yPLUkuMxY8Qw7799547oQAxt50//6tX14y54dLUz58D/i6++llWr15pN161eIe9meMerPnizsadBvS8D/7nzF0jX7r1MN5s0aiCdOnxj/v7V1x1k+cpV5u8zpk6SfHnzBHso589fkCIlSpttPsyaVZYuCijvr82T86DLU9SsXlV00EGUKFGs9/qyH7ad2gfwzlU4dJuQBv5a2aF6rTpy+KcjUrxYERk/ZpT5SE8Dfx0Aoct1aGvetLF8+3VAxQT7FpLAf+DgoTJx8lRJnjyZrFm5zHy3ggv8P81bUPT7rO3MiZ+tgUSeXsuenG/dlw7u0IEhWbN84Omu2Q4BBBBAAAEEEEDgJRYg8A+Hk0PgHw7ofCQCCCCAAAIIIIAAAggggMBLL2Bf7ltL5WtZeltbtmKldOrczZTF1lCyaOFCkjdvHsmU8V0TpkWPFk1atvnCKukfXOA/ZtRwSZgggUuPe/fuS4vWAYMOXM3wt71J14zX5QO+6dhJ7t//3eW+XkTgr7N06zZobJYZ0NndM6dNltdee830x13gb+u0hqx9+vaXFasClzG3bROawD+k3j169ZHZcwLC6+9nTpNPc+cKs2s4PAL/yVOnS/+Bg80xfflFG1NhQZv9zHoNrjXADq5ppYuyFQJKxAc1w9+5pL8+m7p7955s3rJV+g0YKI8ePTa+GgLrtr7uh63/7b/pKPpd1moDO7dtCnRYIQ38R48dL8NHjhadwf7D6pXWch6eBv579u6Tz+s1NP0ZPWKoKbXv3LwN/HVgUK069c1u5s+ZZVUz8HiG/+ED1uAbTy9823Xs6nzrQAIdXDRh0hSz9EXqVKlM2X/b+fb0M9gOAQQQQAABBBBA4OUTIPAPh3NC4B8O6HwkAggggAACCCCAAAIIIIDASy+gM/iLlypn+vnZp7ll9oyA9c1PnjptSpbrrP6M72aQiePGSIoUyQMdT6OmzT0K/Hds2WgGCbhq7mZw296jM4IrV60pZ8+dE50hPXHcaNFBCsd+Pi6Vq9U0m72IwH/Dps2mLLyuzf3D6hWSOHEi67A8Dfxt657rG+vV/VzatWll9uerkv4h9bYPxHX2u86CD6sWHoG/fbA/ZGB/qVSxvDm8MeMmyLARATPUO3f8Vho3DAiNg2rr1m+QVm3amZerVKoogwb0szYNKgC235cuH6B90Wa/lIYv+2H7vM/yFRL9jpUpXdKsZ+/cQhL4Z3jnHfOd0xB72uQJUiB/Pmu3ngb+tpn4+sa9O7c5fI9sO/Mm8O/RrYuULF1erl2/Ls2aNJIO37S3+hRc4K+DDnTwgTZdmuP99zJ7dcl7cr6HDBsh4yZMMvtdvGCuZM/2oVefwcYIIIAAAggggAACL58AgX84nBMC/3BA5yMRQAABBBBAAAEEEEAAAQReeoHv586T7j37mH42qFdXunXpaP6ugbYGd9p01r8G667aiwz8W3/xlaxd94OZTa+zonWAgrafjhx9YYG/hpu6BIKW3R8zcpiUKlnCgcWTwF9nh1euWsNUTvgkZw6ZM2u6NeM3vAP/o8d+lopVqptjCq7agi8u7PAI/IuVLGsGjGjbvGGdpEmdyvx97779UrtuwOCGwgULyOSJ44I9xJ59+sms2XPMNv379pbq1apY23sSANtX1mjZvKl8/VXA4AFf9kP39/PxX6R8papm3wP795WqlSsFOi5vA/8+vbqb3w26vMbntWpK757dHPbpSeCv1ToKFyslFy9dkgzvpJcf1qx06e1p4K+DLnTwgVYyyJQpoyxbvECi2i2VEFzgrwM9dKCFNh0koIMFvGmenG/775UODtH+0hBAAAEEEEAAAQT8W4DAPxzOH4F/OKDzkQgggAACCCCAAAIIIIAAAi9cQMO2ceMnSpfOHaRi+YCZ+0E1DfrKlq9sZv9qWzjve/n4o+zm71pif/2GgPLfzqX6bfvT0K5StZpy9Ogxl9v5KtDVnWuZeS03r815ve8XGfhnzpTJrAeutkMHDwhE6y7w1yoF5SpUkUuXL0ucOLFl7arlkiRxYms/4R346znVtek1zNWmAyu0ZH1wTd9jW9LAmwveV9eH/X7sQ3znvugSDHXqB4S5eh5Xr1hibfL06VPJV6io3Lx5SyJHjiwb1q0y5dddtQcPHkiBIiVE/zdq1Kiya/tmSRA/vrWpJwHwyZOnpFS5gNBXlxXQ5QW0+bIfur9OXbrJgkVLTPi9f88OU0XCuXkb+Nu+A2nSpJbVy5fIW2+95bBLTwJ/XZpDBwtpa//lF9KqRTOX1p4G/hrynzhx0pwPnaWvgwjsW3CBv76vdPmAgRC67MHGH1bLm2++6fGl7Mn5tl++YOSwIVK2TCmP98+GCCCAAAIIIIAAAi+nAIF/OJwXAv9wQOcjEUAAAQQQQAABBBBAAAEEXqiABvc6a/bvv/82n5svbx4TpOX4+KNA/dAAqlvP3lawmz9fXpk+ZaK1XZfuPc3a09p0trPOerZv//zzj3Tu1kOWLX8+M9d5YICvAl0N6ypVCZgRnzXLB2ZgQhS72bsvMvBXAw0F165e7nKtb3eBf5t27WXN2nWGUpckKFqksINreAf+2pnlK1fJV193MP2KHy+ezJw+2QTkzk2XUujavadEixZN5s6e4fW65L66Puz3kzvXJzJx/BiJET26Q3d1Rr1up+XetblaM37W93OlZ+++5nUt6z5r+lQzKMO+6XerVdt21jIW9evWke5dOzls40kAbF9BY8LYUVKsaBFrH77qh34vqtX83Mx815n9OsPfVfM28Nd9RIoUSZYsnOey8oe7wP/Ro8dSrlIV87tHg/XtmzdIwoQJXPbN08Df9matUKKVSpxbcIG/blu/UVPZsXOXeVvpUiXNYB77CgH686tXr5nfeVr5QpcOsTVPzvcXX30tq1avNW/ZuukHSZUypcvj5YcIIIAAAggggAAC/iNA4B8O54rAPxzQ+UgEEEAAAQQQQAABBBBAAIEXKqCzg7v37G1m9No3Xe8+47vvSIwYMUTDtlOnT8utW7etTXQm8+KFcyVe3LjWzzZv3SZNmgWEWm8nSSK9enSVLB98II8ePZIDBw/JlGnT5fz5C5IpY0Yz411bWAT+fz56ZKoQ6Ix4DXFXr1wqKVOkcDi+Fxn460z2ed/PlJw5PnZ5boML/O2XT6hTu6b06uFYCl13+DIE/toP+6BVZ7yXLV1KcubMITFjxpBbt27Jxk1bTPl5bTr4YvniBaaUujctLAJ//XytmKAl9t/NkEGePftXjhw9JvMXLjLXvraSxYvJ2NEjAnVVKxU0ad5Stmzdbl7T70OVypUkc+aMEjlSJDl77rwsXrpMdPCAtowZ35WlC+cFmg1uHwAfPrDH+px/nz2TK1d+k0WLl8rc+QvMz9OlSytrVy5zGMASmn7oUhOHDv8kx4//ImMnTJI//vjDVF8YMXSwJEnyvJKE/cE/fPinNG7WwvxIBwfZlhfQwR5p06YxPx8xaoyMGvN8mYOv2rWV1i0DZug7N1eBvw7WuXv3rpw5c1a0hL4OFjHX2RdtTIWDoJo3gX+ez3LLzGlTXFabcBf4X712TcqUr2yqNmjT6gXVq1aWNKlTm+U7Dvx4UBYuXio60EmrJOzYskFixoxptrU/35vWr7EO5dm/z+Tyld9kwaLFsmFjQLWUIoULyaTxY4I8Xl5AAAEEEEAAAQQQ8B8BAv9wOFcE/uGAzkcigAACCCCAAAIIIIAAAgiEi4DOIB88dIRcvnLF7efrzOIB/foEmsmsb9S16m1BlfOONAwd8F0fefbsP1P+X1tYBP72M+KHDx0k5cuWCXRMLzLw1/W9dZ3voFpQgb99lYJ3M7wjy5cslDfeeCPQbl6WwF9nhfftP9CsU68BdFAtefJkMvC7vqIz671tYRH4a0WL8RMniz4HctVKlSwhw3T2dtSoLl/XYLpb916yaMnSYA9Hq2eMGj5EYsWKFWg7++MKbifJkiWVWdOmmHDZuYW0HzoYQZcm8EXTme5aCUGbfeCvM9znz5llZvm7aq4C/337D0itOvUdNtfqFuNGjwhyP7qxp4G/hvA/rF4hiRMnctknd4G/vunU6TNm4IPO5A+q6eCoMaOGOVS88PR8Z/ngfZkxdbLL37W+OF/sAwEEEEAAAQQQQODFChD4v1hv82kE/uGAzkcigAACCCCAAAIIIIAAAgiEm4DO9t++Y6ds3rLVzHC+ffuOPPjjDzPL/+23k5gZ6pUqlHdZktvW6X///Vemz5wtS5Yuk4sXL8kbb74pKVMkl+LFisrntWqa4OrOnTtSqmxFuXP3rs8D/znz5ku3Hr1NOFu7Zg3Rct2u2osK/DXknTxhrMNsbOf+uAr8tUpBuQpV5OKlS6aU94Rxo0VDf1ftZQn8bX3T9c3nLVgke/btkxs3bpry8Fp+Pcv770uhggXMWuT2yyt4c8GHReC/Y8tG+ePhHzJx8lTRkPn33x+Y61SrU9SoXjXQ0hRB9ffo0WOycMlSs4+bN2+Z406QIL7k+OgjqVC+rFkuI6gWXACsAwT03GvYXatGNbMcQnDN236EdeCvAzzmzZ4pOlghqOYq8P/l1xNmeQGtNpAmdSqpXKmC1KldK9iwX/fvSeAfPXo0GTlsqBQqmD/IPnkS+OubdcmG7+fOlx/Wb/g/9u68t+orzRP4Abyy23gBgwnGBhGS6qSqCTGVKoqQ0P3HjHqWVzAazWsYjUbzPkYjzevoboVOpK5OBUKiFFWVjX03ZjeLsdma0XNmLuMkJIFwyeEef36SBfjeex7781z+sL/nPL880WFmZib19KxMr2x9Of3Nnj3pP/77v/vO+/37+h3f64oVy/MUlL/7t/8m/cf/8O9+8v+Vp/l/5bkECBAgQIAAAQI/j4DA/+dx/kYVgX8BdCUJECBAgAABAgQIECBAgAABAs9Z4Ek3DjznL+OFWH5u4P8//vt/S//5P333fvY/9oX+avuOvFFi7gn/H3uNxwkQIECAAAECBAjMNwGBf4GOC/wLoCtJgAABAgQIECBAgAABAgQIEHjOAgL//w8s8H/ObzbLEyBAgAABAgQIEPh/AgL/Am8FgX8BdCUJECBAgAABAgQIECBAgAABAs9ZQOAv8H/ObzHLEyBAgAABAgQIEPiOgMC/wJtC4F8AXUk5+f7zAAAgAElEQVQCBAgQIECAAAECBAgQIECAwHMWEPgL/J/zW8zyBAgQIECAAAECBAT+L8J7QOD/InTB10CAAAECBAgQIECAAAECBAgQaK6AwF/g39x3lNUIECBAgAABAgQI/LiAE/4/btT0Zwj8m05qQQIECBAgQIAAAQIECBAgQIBAcQGB//9vwdmz59LO3XvSggUL0v/+X/8zvb1r51P351fbd6Spqevpv/+3/5r+y3/+T0/9ei8gQIAAAQIECBAgMB8EBP4FuizwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDKBlgr8Hzx4kO7du5dmZ2fT9PR0unv3bnr48GFasGBBWrRoUerq6kpLly5NnZ2daeHChfnzP3TFerFGrHf79u389wjj43Xt7e15vWXLluX1fmytp3lfCPyfRstzCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQOBxAi0V+EcwPzU1lSYnJ9PJkyfT1atX8waACPsj6B8cHExjY2Opv78/B/bx+R+6ZmZm0pUrV/J6p0+fzutF6N/W1pZWrlyZ1qxZk9fr6+vLn2tW6C/w95+RAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBJ5VoGUC/zjJH4F8BP3nz5/PQX2cym+c8I8T/T09PWlkZCQNDQ2l3t7e1N3d/VifeE2E7rHG8ePH83rXr19PsQEgTv3HFevFxoFNmzbl9ZYvX55P/DfjEvg3Q9EaBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmN8CLRH4R0B///79fAr/wIED6ebNm2n9+vX55P3ixYvTnTt3cmgfY/7jVP/AwEDasmVLfvxxV4T6MS0g1vvkk0/yxoHYKBABf4T6sX48Fs9ZsWJFPuk/OjqaNxE04xL4N0PRGgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJjfAi0R+MfY/gjl43T/vn378un87du355A+RvnHyfwI6M+cOZMmJiZySL9jx460bt26x47hjw0CN27cyKf7I/CP0/zj4+N5vZgKEI99/fXXedT/rVu38kaAbdu25eC/GZfAvxmK1iBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMD8FmiJwD/C/suXL+dA/9ChQ6mzszMH9MPDw/lEf5z+j1P5EeDv378/P7579+58Kn/BggXfCf0jxL9w4UJe79ixYznkj/Vig0CsFxsILl26lDcYfPHFF3lTwa5du9KGDRua8m4R+DeF0SIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCY1wItEfjHifuzZ8+mc+fO5VP3cYI/TtwPDQ3l5jVG/h85ciTt3bs3//vdd99NmzZtSu3t7fkE/9xr7noxEWD58uV5YsDatWvz0+7evZtvD3D06NH0+9//PnV0dKS//du/TWNjY4/dQPC07yCB/9OKeT4BAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIfFugJQL/a9eu5ZP4cSo/TvL39vam1157LQ0ODj76fiLkj4A+Av+4BcDOnTtzQB+n99va2r7xff9Y4B+vj1P+hw8fTh988EF+fQT+sYEg/v7tDQRP+7YS+D+tmOcTIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwLcFWiLwv3LlSg7fL168mMP8VatWpVdffTX19/d/4/uJkf4R+McJ/R07dqSNGzfmcfxxQn/uFSP9Y63Tp08/Gun/5ptvPrpFQLx+amoq1/zwww/z6/fs2ZM2b96cJwbE2P9nuR48eJC/j7gVQXzEeo/bmPAsNbyWAAECBAgQIECAAAECP0XgcbdF+ynreA0BAgQIECBAgAABAgQIECBAgMDzF2iZwP/QoUM5pI+wvK+vL23duvWxgf/777+fA/833ngjjYyM5HH9nZ2d35C8c+dOilP+J06cSAcOHMiPxQaBeP6SJUvyOP94LAL/L7/8Mm8aeOedd9Lo6Ghe61kD/wj542uIP2MygcD/+b/RVSBAgAABAgQIECBA4MkEYqJZTDaL4N9FgAABAgQIECBAgAABAgQIECDwYgu0VOB/6dKlbwT+EfzPveKEfwT+EaZH4B8B/bJly74T+MemgXjOqVOncuB/+/btHPYPDAzkwD82DMTtA2ICQNwmIDYNvP322/kWAc044R9B/+zs7KPAP36Z5oT/i/0fxVdHgAABAgQIECBAYL4IxIbkmHL2rLcymy9evk8CBAgQIECAAAECBAgQIECAQEmBlgn8jxw5kiLwj6A+Rvq/8sorOaD/duD/3nvvPRrpH4H/40b6x6n6f/3Xf01xq4Bjx46lycnJdP369fy6xmn7CPljCsBXX32V19i9e3e+RUA8/qy/+BL4l3zLq02AAAECBAgQIECAwA8JxIbkZkw2o0yAAAECBAgQIECAAAECBAgQIPD8BVoi8L927VqK0/tx6j6C+Z6envT666+n1atXZ6FGgB+n8ffu3ZvD/J07d+YT/l1dXflU/uOumZmZHPqfP38+nT17Nq8dV5y2j+kBMdr/L3/5S/53I/Bvxv0sGxMGIviPrzV+oRZfZ/zpIkCAAAECBAgQIECAQEmBxgn/Z72VWcnvQW0CBAgQIECAAAECBAgQIECAwHwRaInAP07aRyB/7ty5/BGn79988820du3a3KcI0ON0fgT+MdI/TuDv2bMnB/4Ron/fifzG6yL4j4979+49Wi8em5iYSH/6059y4B8j/Tds2NCU+1hGyB+1IvCPj/j6jPSfL//lfJ8ECBAgQIAAAQIEXmyB2OQcP6PEny4CBAgQIECAAAECBAgQIECAAIEXW6AlAv/bt2/nk/inTp3KI/ZjvOT4+Hh66aWX8un9GPPfmALw2WefPTqRPzIy8ijAj+fEL6waoykjdJ+dnc1j+2NCQGwiiFP28Zw42d849R81Y6T/r3/967Ru3bqmdDNqN8L+CP4F/k1htQgBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTmlUBLBP4RjscJ/Bjr/9FHH+UT/du2bUsbN27MQX0E9MeOHcun/2NjQG9vb9q+fXsaGhrKz43Hr169mhs7ODiYg/0I2icnJ9Pnn3+ex+pv3bo13yIgJgLEGl988UX+M8L4eM0rr7yS+vv7m/LmEPg3hdEiBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmNcCLRH4R0AewX2M9f/444/zqfwI8/v6+tKyZcvyZoB4LCYBLF68OAf0mzdvTitXrsyj/i9dupQ3C0R4//LLL+cNARH4nzlzJn366af5dTENID4fEwNi/RMnTuSNAFEnPuL2AVGrGZfAvxmK1iBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMD8FmiJwD9aFCH51NRUOnnyZJqYmEiXL1/OQX2M42/cY3LVqlVpdHQ0B/QR9i9atCg/J15z4MCBHObv2rUr3wog1ouNAIcOHcqTASLkj80BccXzOjo6Hm0ciJP/3d3d+fPNuAT+zVC0BgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBOa3QMsE/tGmO3fu5NA/RvFHiB+hf5zUjzH8cfp+zZo1aWxsLJ/8j89FsB6n/+Mk/8GDB3NgPz4+noaHh3PXb968mc6fP58D/0boH5+Pkf+xRpzqj5P/PT09eVNBsy6Bf7MkrUOAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIH5K9BSgX+M9b9//34O8aenp/OJ/MYJ/wj44xT+0qVL8+n8RkAfr4lT/rFRID4XQX48L67YLDA7O5s/4jmxdqwXkwE6Ozvz85YsWZLXa+Yl8G+mprUIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAwPwVaKvCvpUUC/1o66fsgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAOQGBfwF7gX8BdCUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQmYDAv0BDBf4F0JUkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAZQIC/wINFfgXQFeSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClQkI/As0VOBfAF1JAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVCYg8C/QUIF/AXQlCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUJmAwL9AQwX+BdCVJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQGUCAv8CDRX4F0BXkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABApUJCPwLNFTgXwBdSQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFQmIPAv0FCBfwF0JQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFCZgMC/QEMF/gXQlSRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBlAgL/Ag0V+BdAV5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQKVCQj8CzRU4F8AXUkCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUJiDwL9BQgX8BdCUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQmYDAv0BDBf4F0JUkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAZQIC/wINFfgXQFeSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClQkI/As0VOBfAF1JAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVCYg8C/QUIF/AXQlCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUJmAwL9AQwX+BdCVJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQGUCAv8CDRX4F0BXkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABApUJCPwLNFTgXwBdSQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFQmIPAv0FCBfwF0JQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFCZgMC/QEMF/gXQlSRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBlAgL/Ag0V+BdAV5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQKVCQj8CzRU4F8AXUkCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUJiDwL9BQgX8BdCUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQmYDAv0BDBf4F0JUkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAZQIC/wINFfgXQFeSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClQkI/As0VOBfAF1JAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVCYg8C/QUIF/AXQlCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUJmAwL9AQwX+BdCVJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQGUCAv8CDRX4F0BXkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABApUJCPwLNFTgXwBdSQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFQmIPAv0FCBfwF0JQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFCZgMC/QEMF/gXQlSRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBlAgL/Ag0V+BdAV5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQKVCQj8CzRU4F8AXUkCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUJiDwL9BQgX8BdCUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQmYDAv0BDBf4F0JUkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAZQIC/wINFfgXQFeSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClQkI/As0VOBfAF1JAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVCYg8C/QUIF/AXQlCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUJmAwL9AQwX+BdCVJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQGUCAv8CDRX4F0BXkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABApUJCPwLNFTgXwBdSQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFQmIPAv0FCBfwF0JQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFCZgMC/QEMF/gXQlSRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBlAgL/Ag0V+BdAV5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQKVCQj8CzRU4F8AXUkCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUJiDwL9BQgX8BdCUJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQmYDAv0BDBf4F0JUkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAZQIC/wINFfgXQFeSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEClQm0VOD/4MGDdO/evTQ7O5ump6fT3bt308OHD9OCBQvSokWLUldXV1q6dGnq7OxMCxcuzJ//oSvWu3PnTl5vZmYmrx3rxWvjo6Oj4xvrxeeacQn8m6FoDQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECMxvgZYK/COYn5qaSpOTk+nkyZPp6tWrOaSPsD+C/sHBwTQ2Npb6+/tTe3t7/vwPXbdv305XrlzJ6509ezavHYF/vC42DcQ6GzduzH/GZoK2tramvFsE/k1htAgBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTmtUDLBP4RxEfAH0H/+fPnc1AfgX3jhH+cvu/p6UkjIyNpaGgo9fb2pu7u7sc2N14ToXuscezYsbzezZs388SAxin+eM7y5cvTunXr0po1a9LAwEBasmRJU94sAv+mMFqEAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC81qgJQL/CN/v37+fTp8+nQ4cOJDD+fXr16e+vr60ePHiPJY/QvsY8x+n8yOc37JlS378cVeM8o9wv7FejPPftGnTo5P88e+LFy+m69ev5wkCq1atSr/4xS/yBIFmXAL/ZihagwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAvNboCUC/wjd4zR/nO7ft29fPp2/ffv2fJo/RvlHQB/h/ZkzZ9LExERasWJF2rFjRz6dv2DBgu90ONaLzQHHjx9Pf/jDH/Jzdu7cmUZHR/Mo/3gsRvzHmqdOncon/X/zm9/kTQbNuAT+zVC0BgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBOa3QEsE/hH2X758OQf6hw4dyqH8+Ph4Gh4ezif64/R/nPqPAH///v358d27d+cAP8L8b4f+s7Oz+fR+PP+Pf/xjfv7vfve7tGHDhjzSPyYGxLj/EydOpIMHD+YpArFebDBoxiXwb4aiNQgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDC/BVoi8L9x40Y+cX/u3Lk0OTmZT/Bv27YtDQ0N5e41Rv4fOXIk7d27N//73XffzWP629vbc4g/94pAPwL/CPQ/++yz/Jw44R+Bf1tbW4oNARH4x+n+P//5z6m7uzu9/fbb+fFmXAL/ZihagwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAvNboCUC/2vXrqVjx46lCxcu5JP8vb296bXXXkuDg4OPuhch/9GjR3PgHyP7I8AfGxvLYX2E+HOvmAgQoX6c8P/www/zLQLiFgAbN25MS5YsybcPiLA/NhhEzZUrV+ZbCKxdu7Yp7xaBf1MYLUKAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIF5LdASgX+ctj98+HC6ePFiDvNXrVqVXn311dTf3/+N5kWAH4H/3bt3HwX4S5cuTR0dHd94XmMiQNwiIG4BEJsI1q1bl/r6+lI8PyYATExMpOnp6fzagYGBtGXLlly3GZfAvxmK1iBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMD8FmiZwP/QoUM58H/w4EEO5rdu3frYwP/999/Pgf8bb7yRRkZG0vLly1NnZ+d3uhyh/+XLl/NUgNOnT+eT/HHqv/HcWKOnpycH/S+99FIO+xcvXtyUd4vAvymMFiFAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMC8FmipwP/SpUvfCPwj+J97xQn/CPzjhH4E/qOjo2nZsmXfCfwbJ/xjcsCJEydSnPSPzQTxuvb29rRgwYIUY/9XrFiRx/zHKP+YJhDj/ptxReAfkwqiRnwsXLjwsbceaEYtaxAgQIAAAQIECBAgQOBJBeJnofiIn1HiTxcBAgQIECBAgAABAgQIECBAgMCLLdAygf+RI0dSBP4Rysdp+1deeSWP2p97ReD/3nvvPRrpH4H/40b6R9h++/btdPbs2fSnP/0pzczM5FP8sYGgq6srh/HXrl3LH1NTU3lKwNx6z/qLr5hSEBMEIuyP8F/g/2L/J/HVESBAgAABAgQIEJgvAvGzSVtbW7612aJFi+bLt+37JECAAAECBAgQIECAAAECBAi0rEBLBP4RvEeYH2P3r1+/nkftv/7662n16vom1AgAACAASURBVNUZPk7sR3Ae4/n37t2b/75z5858wj8C/Di1P/eKgD9O9586dSp9/vnn+fHx8fEc+sfzI4yPx6PmH//4x/wLrx07dqTh4eEczsfHs1zfDvzjF2lRN+q4CBAgQIAAAQIECBAgUEKgcbI/fi6JW50J/Et0QU0CBAgQIECAAAECBAgQIECAwNMJtETgf+PGjXwa/9y5c/kjTty/+eabedR+XI0APQL/GOkfgfyePXty4B+/rPp2QB/rxRj/WOv8+fN57P+2bdvyevHc2DAQoX9MFfjggw8ebSCI8f7NOOki8H+6N6lnEyBAgAABAgQIECDw/AUak8wap/yfdaPz8/+KVSBAgAABAgQIECBAgAABAgQIEGiJwD/G7zdO5H/11Vf5tEnjRH6czo8x/40pAJ999lnq7u5Ou3fvTiMjI7nDEbDHc+IXWPHa6enpdPr06Rz4x9SA2EDQCPzjORH4x7j9w4cPp3/6p3/KEwTefvvtNDY2lgP/Zz2JPzfwj783Tvh/exKBtycBAgQIECBAgAABAgR+boHGSf+fu656BAgQIECAAAECBAgQIECAAAECTy/QEoF/hO8xhj9G7H/00Uc5wI+APk7cR1gfAf6xY8dygB8bA3p7e9P27dvT0NBQfm48fvXq1awzODiY/5ycnMwj/b/++uu0ePHi9NZbb+WR/hHm37t3L01NTeVbBOzbty+H/DExIAL/COcbJ1+envv/viI2FESN+L7iI07OxCaFZ91I8FO/Hq8jQIAAAQIECBAgQIBAQ+BZf94hSYAAAQIECBAgQIAAAQIECBAg8PMJtETgHwF5BPcx1v/jjz9OMZI/wvy+vr48jj82A8RjMQkgwvsI9Tdv3pxWrlyZR/NfunQpbxaIYP3ll1/OmwQi0I9T/p9//nkO4OP5AwMDjwL/qBGvi3VXrFiRfv3rX6fh4eFnDvujtY0JAhH2R/Av8P/53vAqESBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoBaBlgj8GyF5hPQnT55MExMT6fLlyzngj3H7jZGTq1atSqOjo3kzQIT9cRo/nhOvOXDgQIqR+bt27crBfYTtFy9eTIcOHcpj/WPkfwTxjdMs8fc4dR9rrlmzJp/+7+npaUrfBf5NYbQIAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE5rVAywT+0aUI5SP0j3H8EeJH6B8n5GMUfpz0j2A+xu7Hyf/4XATrcfr/zJkz6eDBgznwHx8fz4F/XDdv3swn+GO9CP1jc0BcEfrH6+PWABs2bMgTA2L9zs7OprxZBP5NYbQIAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE5rVASwX+MdY/TuZHiD89PZ3H9TdO+EdAHyfyly5dmjo6Oh6d1I/XRJAfGwUiyI/NAPG8uBprxXqxmSCe27jiubFO3CKgq6srbxaI0fvNuAT+zVC0BgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBOa3QEsF/rW0SuBfSyd9HwQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECgnIPAvYC/wL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqE2ipwP/Bgwfp3r17aXZ2Nk1PT6e7d++mhw8fpgULFqRFixalrq6utHTp0tTZ2ZkWLlyYP/+46/79++nOnTtpZmYm3bp1K6/zQ1es29vbmxYvXpzX/L51n/S9IfB/UinPI0CAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHvE2ipwD+C/qmpqTQ5OZlOnjyZrl69mjcARNgfQf/g4GAaGxtL/f39qb29PX/+cVdsFrh48WI6e/ZsOn78eLp27dpjnxebCeJjzZo1afv27Wl4eDi1tbXlzQTPcgn8n0XPawkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEAgBFom8I/gPQL+CPrPnz+frly5km7fvv3ohH+E8D09PWlkZCQNDQ3lE/nd3d2P7fKPBf4xSSCmADQmCUTQ/8477+TNBAJ//3EIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBA4EUQaInAP8L+COBPnz6dDhw4kG7evJnWr1+f+vr68pj9GM8fmwAiyI9T/QMDA2nLli358cddPzbSP9aLSQKXLl1K586dSytXrky//e1vc00j/V+Et62vgQABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgRaIvCPsf1xmj9O9+/bty/FSPwYsR+n+WOU/8zMTN4McObMmTQxMZFWrFiRduzYkdatW5cD+qe9IuyP9S5cuJCuX7+eA/9f/OIX+ZYBzbiM9G+GojUIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECAwvwVaIvCPsP/y5cs50D906FDq7OxM4+PjKUbtx4n+OLEfp/6PHz+e9u/fnx/fvXt3Gh0dfeoT+TFNIDYNfPrpp+nWrVt508DatWvT6tWr8+aCZlwC/2YoWoMAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLzW6AlAv8bN26ks2fP5vH6k5OT+QT/tm3b0tDQUO5eY+T/kSNH0t69e/O/33333bRp06bU3t6eFi5c+ERdjo0Ds7OzeWPBJ598kl/zy1/+Mo/yj1sHxFrNuAT+zVC0BgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBOa3QEsE/teuXUvHjh3LI/bjJH9vb2967bXXvjFiP0L+o0eP5sA/bgGwc+fONDY2lrq7u1NbW9sTdXl6ejpdvHgxn/CP2wfEa//6r/86byyINX7K7QEeV1jg/0Tt8CQCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQ+AGBlgj8r1y5kg4fPpzD+AjzV61alV599dXU39//jW8tRvpH4H/37t20Y8eOtHHjxjyGv6Oj44neBFEnpgTE7QMadbZs2fKdOk+02A88KQL/WD8mCsRHTCB4mo0Jz1rf6wkQIECAAAECBAgQIPB9As3a6EyYAAECBAgQIECAAAECBAgQIEDg+Qu0TOB/6NChHPg/ePAg9fX1pa1btz428H///fdz4P/GG2+kkZGRtHz58tTZ2flEknHLgP3796dbt27l18bJ/thUEJsGmnnF9xBfY4T98fdFixalrq6upt0yoJlfq7UIECBAgAABAgQIEJhfAhH4P+lt0eaXjO+WAAECBAgQIECAAAECBAgQIPDiCbRU4H/p0qVvBP4R/M+94oR/BP537tzJgf/o6GhatmzZjwb+jRH7Mcb/ww8/zEH89u3b0/r163MQH+P84zlx24BmXHMD/1i3Efg/6a0HmvE1WIMAAQIECBAgQIAAAQJzBRon+yPsj59NhP7eHwQIECBAgAABAgQIECBAgACBF1+gZQL/GLUfgX+E+THS/5VXXkkDAwPfEI7A/7333ns00j8C/ycZ6R+n7eNU/6lTp9Inn3ySf7n129/+Ng0PD6f4pVdjBH8E9c24BP7NULQGAQIECBAgQIAAAQLNFGic7I+fh2JKWmxMdhEgQIAAAQIECBAgQIAAAQIECLzYAi0R+F+7di1FmH/hwoV0/fr11NPTk15//fW0evXqrBsn7yOUP3r0aNq7d2/++86dO/MJ/ycZlX/79u18u4AzZ86kw4cPpyVLlqS33norrVu3Lk8UiBP/9+7dy+s24/p24B8nZ7q7u/NGAxcBAgQIECBAgAABAgRKCTRO93d0dAj8SzVBXQIECBAgQIAAAQIECBAgQIDAUwi0ROB/48aNdPbs2XTu3Ln8sXz58vTmm2+mtWvX5m+1EaBH4B8j/eOXVHv27MmB/5OMopyamkonTpxIk5OTKWrFhoK/+qu/yhsKYjNBY0NBs0b6NyYGxEaC+BD4P8U71lMJECBAgAABAgQIEHhuAnHKv3HSvzHi/7kVszABAgQIECBAgAABAgQIECBAgMAzC7RE4B8n8K9cuZJH7n/11Vd5vOT4+Hh66aWXUnt7ex7z35gC8Nlnn+XT8rt3704jIyMZKDYExHPiF1bx2m+fpI9bBXz55Ze5RjzW39+fNm/enG8d8DyuCPwbYX9MDhD4Pw9laxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBugZYI/CMcn5mZyWP9P/rooxzgb9u2LW3cuDGf9p+enk7Hjh3Lp/8jtO/t7U3bt29PQ0ND+bnx+NWrV3MnBwcH88j+udf58+dTbBRo3C5gzZo1acOGDWnlypXPpfsC/+fCalECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjMK4GWCPwjII/gPsb6f/zxx3nsfoT5fX19admyZXkzQDwWkwAWL16cQ/04oR+B/d27d1Oc4I/NAnGS/uWXX84n+Odec9cdHh7OtwqIj9hM8Dwugf/zULUmAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE5pdASwT+0ZIIyaemptLJkyfTxMREunz5cg74Hz58+OgekzGCf3R0NG8GiLB/0aJF+TnxmgMHDuTx/7t27cqn9+dep0+fTh9++GGeBDA2NpbWr1+fNw0sXbr0ubwbBP7PhdWiBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmFcCLRP4R1fu3LmTQ//Jyckc4kfof+/evdTW1pZP+sco/gjs4+R/fC6C9Tj9f+bMmXTw4MEc+I+Pj6c4xT/3unDhQvrzn/+cnxth/+rVq/OGga6urufyZhD4PxdWixIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGBeCbRU4B9j/e/fv5+D+TiNH+P6Gyf8I+Dv7u7Op/I7Ojryqf+44jVxyj82CsTnYjNAPG/u1dhIEM+NWwJE0B+bA2JCwPO4BP7PQ9WaBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmF8CLRX419IagX8tnfR9ECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoJyAwL+AvcC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEWirwf/DgQbp3716anZ1N09PT6e7du+nhw4dpwYIFadGiRamrqystXbo0dXZ2poULF+bP/9AV2YiFHgAAIABJREFUr43w/c6dO+nWrVtpZmYmRY34fLw+1on1Yt22trb8uWZcAv9mKFqDAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC81ugpQL/CPqnpqbS5ORkOnnyZLp69WreABBhfwTzg4ODaWxsLPX396f29vb8+R+6ItyPsP/SpUvpyJEjed0I/iOQj5B/YGAgrxfrLlmyJHV0dDTl3SLwbwqjRQgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIDCvBVom8I9T9xHwR9B//vz5dOXKlXT79u1HJ/zj9H1PT08aGRlJQ0NDqbe3N3V3d/9gc+P1Fy9eTBMTE+n06dN5/cYJ/5gOsHLlyvTSSy+ltWvX5tA/NhU04xL4N0PRGgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJjfAi0R+EfYf//+/RzKHzhwIN28eTOtX78+9fX1pcWLF+dT+rEJIMb8x6n+OJm/ZcuW/PgPXRcuXEh/+ctf8gn/mAiwbNmyPB0gNg9E+B8bAmIDwKpVq55ovSd9Kwn8n1TK8wgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEDg+wRaIvCPsf0Rvsfp/n379uWR+9u3b8+n+ePU/czMTN4McObMmXxaf8WKFWnHjh1p3bp1KU7qf/uK18dHvOajjz7KY/w3btyYNxGsWbMmbxqITQAR+t+4cSOP84/R/jE1oBmXwL8ZitYgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDA/BZoicA/wv7Lly/nQP/QoUOps7MzjY+Pp+Hh4RzOx+n/OPV//PjxtH///vz47t270+joaA78vx36x/NjKsCJEydy4B8TBGKDwIYNG/JtAOL58fjdu3dTbDZoa2vLGws6Ojqa8m4R+DeF0SIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCY1wItEfjHKfuzZ8+mc+fOpcnJyXyCf9u2bWloaCg3rzHy/8iRI2nv3r353++++27atGlTHtUfI/rnXhHmxwaBCPw//fTTHPDHxIDBwcEc8McVr+nq6sq3DIg/Y2PB46YF/JR3j8D/p6h5DQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjMFWiJwP/atWvp2LFj6cKFCzmoj9H6r732Wg7oG1eE/EePHs2Bf4T2O3fuzGP448R+nNCfe01PT+eJATHSPyYGxAaAGOUfz7t+/XqeGBAhf39/fx71H38+bp2f+lYS+P9UOa8jQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYZASwT+V65cSYcPH04XL17MYf6qVavSq6++moP4uVeM9I/AP0bxx4j+COsfN4o/Ng2cP38+nTp1Km8SiMB/YGAgTwOIzQCNU/7x2pgiEB+xISD+3YxL4N8MRWsQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEBgfgu0TOAfJ/Ej8H/w4EHq6+tLW7dufWzg//777+fA/4033kgjIyNp+fLlqbOz8xtdbtwiIKYGfPnll3lU/yuvvJKD/RjhH6+PaQIxWeD27du53q9+9asc+jfjEvg3Q9EaBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmN8CLRX4X7p06RuBfwTxc6844R+Bf5zYj8B/dHQ0LVu27HsD/zjd/8UXX+THx8fH8/NXrFiRA//Jycl04sSJ9NVXX+WT/XGLgA0bNuTNAfHxLFcE/jFFIG4dEB8LFy5s6i0DnuVr81oCBAgQIECAAAECBOa3QPy8Ez+jPOvPPfNb0XdPgAABAgQIECBAgAABAgQIEPh5BFom8D9y5EiKwD/C/BjpHyfyYwz/3CsC//fee+/RSP8I8H9opH8E+jE5IE71/+Y3v8mBfoz1f/jwYT7ZHxMA/vmf/zmXaAT+bW1t+Zdfz3LFlIL4PiLsj/A/1uzq6sp/uggQIECAAAECBAgQIFBSYNGiRamjoyPFny4CBAgQIECAAAECBAgQIECAAIEXW6AlAv8YrR9hfozZv379eurp6Umvv/56Wr16ddaNgD6C8zixv3fv3vz3COgj8I8gPUL8udf09HS+PcDJkyfzCf4lS5akXbt2pZdeeunR02KN2GTwD//wD3kDwe9+97t8i4BY61l/8RVB/+zsbA7842uPoL+7u1vg/2L/X/HVESBAgAABAgQIEJgXAvHzSUxBe9afe+YFlm+SAAECBAgQIECAAAECBAgQIFBYoCUC/xs3bqSzZ8+mc+fO5Y/ly5enN998M61duzbzxYn5COUj8I+R/nECf8+ePTnwf9yJ/JmZmRSbCOKE/8GDB3PYvnv37nzCv3E1Av+///u/z8F8bAhorPesv/gS+Bd+1ytPgAABAgQIECBAgMD3CjRO+D/rZDPEBAgQIECAAAECBAgQIECAAAECz1+gJQL/GK9/5cqVdOrUqXwiP06bjI+P5xP5ceI+xuM3pgB89tlnjwL8OJEfV2OEftyDMl4bYX6c8o/A/+OPP84bBN566618gj8ej1P3sSkgNhD8/ve/z/eufPvtt9PGjRvzKZdn/cVXBP6Nkf5RK9Z0wv/5v9lVIECAAAECBAgQIEDgxwXi553YOB0/B7kIECBAgAABAgQIECBAgAABAgRebIGWCPwjII8APsb6f/TRRznA37ZtWw7g47R/hPfHjh3Lp/9jY0Bvb2/avn17Ghoays+Nx69evZo7MTg4mMP1WDNG+v/hD3/Ia2/dujVvIBgYGMgbAiYmJvIGg6+//jotXbo03yIgJgDEL72e9Rdf8TXdu3cvfw3xIfB/sf+T+OoIECBAgAABAgQIzCeBZvzMM5+8fK8ECBAgQIAAAQIECBAgQIAAgZICLRH4RwAfIXmM9Y8T+THiP8L8vr6+tGzZshzYx2MxCWDx4sU51N+8eXNauXJlHvV/6dKlvFkgTqq8/PLLqb+/P5ufP38+xUSA2AwQoX48f9WqVfmE/8WLF9P169fz2lHnl7/8ZVq9enVTehXfTyPsj+A/vi4n/JtCaxECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjMG4GWCPyjGxGST01N5VP5cfr+8uXLOeCPcD5OoERoHmH96Oho3gwQ4X2cnI/nxGsOHDiQx//v2rUrn9SP69atW+nChQt5MsDp06dzwD93vZgeMDw8nNeLsD82BTTjEvg3Q9EaBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQmN8CLRP4R5vivvcR+k9OTuYQP0L/OCEf95eMk/5r1qxJY2Nj+UR+fC6C9Tihf+bMmXTw4MEc+I+Pj+cQP644ZT87O5tD/8OHD+c/o0ZcceI+JgXEevFnV1dXXrMZl8C/GYrWIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwPwWaKnAP8b6R0gfIf709HQe1984kR9hfIT0cQq/o6Mjn/qPK14Tp/xjo0B8LjYDxPPiiuA9PiL0j9P+8Wf8O9aM9To7O/N6EfbHtIDGms/6lhH4P6ug1xMgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBASwX+tbRL4F9LJ30fBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQKCcg8C9gL/AvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTEPgXaKjAvwC6kgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKhMQOBfoKEC/wLoShIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKAyAYF/gYYK/AugK0mAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKBAT+BRoq8C+AriQBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqExD4F2iowL8AupIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCoTEDgX6ChAv8C6EoSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgMgGBf4GGCvwLoCtJgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygQE/gUaKvAvgK4kAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKhMQ+BdoqMC/ALqSBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqExA4F+goQL/AuhKEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoDIBgX+Bhgr8C6ArSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoEBP4FGirwL4CuJAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCoTaKnA/8GDB+nevXtpdnY2TU9Pp7t376aHDx+mBQsWpEWLFqWurq60dOnS1NnZmRYuXJg//31XvO727dvp6tWraWZm5rFPizU7OjrS4sWL07Jly/Lfm3EJ/JuhaA0CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjMb4GWCvwj6J+amkqTk5Pp5MmTOayPDQARzEfQPzg4mMbGxlJ/f39qb2/Pn3/cFWF/fJw5cybt378/nTt3Lm8O+PYGge7u7tTT05OGh4fT5s2b06pVq5rybhH4N4XRIgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEJjXAi0T+EdAHwF/BP3nz59PV65cySf0Gyf840R/hPMjIyNpaGgo9fb2pgjsH3fFa+7fv5+OHDmS/vEf/zEH/hHmx0n+uZfAf17/3/DNEyBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBA4IUWaInAvxHQnz59Oh04cCDdvHkzrV+/PvX19eWQ/s6dO3kTQIz5j1P9AwMDacuWLfnxx11xwj5uB3D06NH0wQcf5Ne/8cYbeaPA3MtI/xf6veuLI0CAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwLwWaInAP8b2x2n+ON2/b9++FIH99u3b82n+GOU/MzOTYjNAjOifmJhIK1asSDt27Ejr1q37zpj+6Hac7o/bAxw7diz9y7/8S2pra0t/8zd/kzZu3PizvBmM9P9ZmBUhQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBA1QItEfhH2H/58uUc6B86dCh1dnam8fHxNDw8nE/0R4Afp/6PHz+e9u/fnx/fvXt3Gh0dzYF/fMy9YgNBTAM4ceJE3kDQ0dGR3nnnnbyB4Oe4BP4/h7IaBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqFugJQL/GzdupLNnz6Zz586lycnJfIJ/27Ztj0bwN0b+HzlyJO3duzfFv9999920adOm1N7env4Pe/f+VOWRJ368VZSLgIggiqJy0dHEGZ2sGqxMUY6T7F+8tVsVK1MzNVu5OJPEzUzK8UIWRREFBDXIRV2/9en6Hss4xph4kuY8vJ4qSoVzuuHV+AO8n+6zcePG76xiHOcfNwhE8I+XCIjHx3i7d+9OT548yY+NGwlaWlrS1q1b8w0B8e8Xx/mp3xqC/0+V8zwCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqAk0RPCfn5/Px+/fvn07h/ru7u507Nix1NfX92wlI9pfvXo1B//YwT82NpZGRkZSa2trPrL/+WtlZSUtLCzkEwH++te/prihoL+/Pwf+OE0grra2tjx+7Prv7e3NH4ubB+pxCf71UDQGAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE1rdAQwT/ubm5dPny5XTnzp0c83fs2JGOHj2aQ/zzVwT8CP6xg//06dNpaGgotbe35x36z1+14D8xMZEuXLiQ7t27l7Zv354ft7y8nHf5x27+zs7OtGfPnvy2a9euPFY9LsG/HorGIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwPoWaJjgf+nSpRz8I8b39PSkt95666XB/6OPPsrB/+TJk3l3fkT75ubm76xyBP84KSBeIiBeBiBuIti7d2/q6urKu/gXFxfT1NRU3vkfj42d/u+8804+8r8el+BfD0VjECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAYH0LNFTwn5mZ+U7wj/D//BU7/CP4R6SP4D88PJw6Ojr+Jfg/fvw4H90fLxVw69atPETE/Aj+cXNABP8bN26kOAEgXkogxvjd736XDhw4kHf+b9iw4Y2+awT/N+LzZAIECBAgQIAAAQIEfgaB+Dmn9laPn3t+hk/RkAQIECBAgAABAgQIECBAgAABAi8INEzwj534Efwj5seR/m+//XbauXPnd76cCP4ffvjhsyP9I/i/7Ej/p0+f5hsH4iSApaWlPEZLS0s+0j9+sRUfi+gfsf8vf/lLikAfLxGwf//+fALApk2b3ugbKcaLOeJkgbj5IOaM+Zuamt5oXE8mQIAAAQIECBAgQIDATxWIn0viZ534mSd+NnrTn3t+6ufheQQIECBAgAABAgQIECBAgAABAq8v0BDBP3biR8y/fft2unfvXtq+fXs6fvx42rVrV/5KI+BHRL969Wo6d+5c/vvY2Fje4R8hPX5h9fxVe3w8Lv5e+8VWbed+7eNxk8F//dd/5ZsM3nvvvbzDP37x9aZhXvB//W9QjyRAgAABAgQIECBA4JcREPx/GWezECBAgAABAgQIECBAgAABAgTqKdAQwf/+/fv5iP2bN2/mt87OzvTuu++mPXv2ZIvabv0I/nGkf/yi6oMPPsjBP+J8/Pv5q/b42F0fb7Fzpa2t7VnIj+Afb5cvX07/+Z//mR9z9uzZNDIyko/8f9OdLo70r+e3sLEIECBAgAABAgQIEKiHgCP966FoDAIECBAgQIAAAQIECBAgQIDALyvQEMH/4cOHaW5uLl27di1dvHgxR/fR0dFnR+zHDvzaKQBffPFFam1tzYF+cHAwa0bgj8fEL7DiuRHcY8y4kSBODIgTAOK0gDj+P2J+HLUfR/rHDQT//d//nd/3hz/8IQf/eOyLNxD82CUT/H+smMcTIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwIsCDRH8Y4f90tJSPtb/448/zgH/xIkTaWhoKO/2jzg/Pj6ed//HjQHd3d3p1KlTqb+/Pz82Pn737t38tff19eVgH/+Ox0fUj2P6jx07lh8fNwR8++23aXJyMk1MTOQ5Y454iYC4gaC26+VNvpUE/zfR81wCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQCIGGCP6117yPY/0/++yzvDM/4nxPT0/q6OjINwPEx2LXfhzNH1H/0KFDqaurK62urqaZmZkc7iP0HzlyJD8nTgSIqP/111/nHf2xez/Gi/gf40xPT+fd/3Gzwc6dO/MNAXEKQD0uwb8eisYgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDA+hZoiOAfSxSRfGFhIe+6n5qaSrOzsznMP336NO+6j5i/Y8eONDw8nG8GiNgfR/HHY+I558+fz8fxnzlzJg0MDOTIf+fOnXTp0qUc9+OmgXhfjBdjxXO3bduWHxvjRfTfunVrXb5bBP+6MBqEAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC61qgYYJ/rNLKykqO/hHoI+JH9I9I39TUlHft7969+9lO/XhfhPUI+bGT/8KFCzn4j46O5ogf14MHD/Kx/nEDQYwZJwfEc+JxMV6cFBAvGxA7/+Oo/xizHpfgXw9FYxAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGB9CzRU8H/y5Ek+Yj8i/uLiYj6uv7bDP2J8a2tram9vz8fyx67/uOI5scs/bhSI90W8j8fFVRsrxlteXs43D8RV2+Hf0tLybLx4X7zV4xL866FoDAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECKxvgYYK/lVZKsG/Kivp6yBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEA5AcG/gL3gXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgADkmbKVAAAgAElEQVQBAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigk0VPB/8uRJevToUVpeXk6Li4tpdXU1PX36NG3YsCFt2rQptbS0pPb29tTc3Jw2btyY3/9jrufHv3fvXn5+V1dXamtry+P/2PG+b27B/8esiscSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwMsEGir4R+hfWFhI09PTaWJiIt29ezffABAxPkJ/X19fGhkZSb29vWnz5s35/T/mivHv37+fbty4kb7++uv8/OPHj6eBgYHU2tqampqafsxw3/tYwb8ujAYhQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAuhZomOAfO/kj8Efov3XrVpqbm0sPHz58tsM/dvRv3749DQ4Opv7+/tTd3Z0j/eteMX7s6p+cnExXrlxJf//73/Pzx8bG0qFDh/INBVu2bHnd4V75OMG/LowGIUCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwLoWaIjgHzH+8ePH6fr16+n8+fPpwYMHad++famnpycft7+yspJvAohj/mNX/s6dO9Phw4fzx1/nivHjbWpqKn355ZdpfHw8zczM5Oe/9957+dQAwf91JD2GAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBH4pgYYI/nFsf+zmj939n3zySYod8qdOncq7+SPELy0t5ZsBYnd+RPtt27al06dPp71796YNGzb8oOXq6moeP47yj539Mc63336bbxwYHR1NQ0NDgv8PKnoAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECPySAg0R/CPGz87O5hB/6dKl1NzcnEP8wMBA3tEfu/9j1/8333yTPv300/zxs2fPpuHh4Rz8fyj6147yv3PnTj7WP146IObr6upKJ06ceHZjgSP9f8lvTXMRIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwKsEGiL4379/P+++v3nzZpqens47+CPE9/f356+tduT/lStX0rlz5/K/33///XTw4MG0efPmtHHjxpcaxEkBT548SRH6L168mGKeGDtODIibB1paWvI8Bw4csMPf/yMCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQWFMCDRH85+fn0/j4eLp9+3beyd/d3Z2OHTuW+vr6nmFG5L969WoO/vESAGNjY2lkZCS1trampqaml6LH45aXl/PNBF9++WV+qYDf/OY3+SaAv/3tb/nGAcF/TX2/+mQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBA4P8LNETwn5ubS5cvX8478SPS79ixIx09ejT19vZ+ZyFjV34E/9XV1XT69Ok0NDT0yp35i4uL+SaCqampdO3atbR169b0b//2b/n5f/nLX/Kf8e/Y4R8fq9eR/nFDQXwd8VIE8RYvS/CqGxN8txIgQIAAAQIECBAgQOCXEnidl0X7pT4X8xAgQIAAAQIECBAgQIAAAQIECLxaoGGC/6VLl3Lwj1je09OT3nrrrZcG/48++iiH+pMnT6bBwcHU2dmZmpubX6oQ43311VdpYWEhH+W/c+fOtG/fvvzvP//5z2llZSW98847+X0R/OPlAepxReSPsePPOEVA8K+HqjEIECBAgAABAgQIEKiHQLwkWpySFuHfRYAAAQIECBAgQIAAAQIECBAgsLYFGir4z8zMfCf4R/h//ood/hH8I6ZH8B8eHk4dHR3/EvzjpoF4TBzlf+HChTzmr371q7Rnz57U1dWVbt26lf70pz/lxxw/fjwNDAyktra2ugb/eCmBWvCPX6bZ4b+2/6P47AgQIECAAAECBAisF4G4ITlON4vw7yJAgAABAgQIECBAgAABAgQIEFjbAg0T/K9cuZIi+EeEjyP933777bwj//krgv+HH3747Ej/CP7t7e3/chT/w4cP82kBcZT/5ORkju2//vWvU39/f97JEu97Mfi3tLTkj9XjitAv+NdD0hgECBAgQIAAAQIECNRbIH7uiVPSIvy7CBAgQIAAAQIECBAgQIAAAQIE1rZAQwT/+fn5FDH/9u3b6d69e2n79u155/2uXbuybhyL/3//93/p6tWr6dy5c/nvY2NjeYd/hPoXj+KP8cbHx9PNmzfT7OxsDv4HDx5M3d3debzp6en05Zdf5hsH4v2x8z8+Fsf6x06XN/3FV+2EgQj/8bnGL9TqeUPB2v6W89kRIECAAAECBAgQILCWBWo7/N/05561/DX63AgQIECAAAECBAgQIECAAAECVRFoiOB///79fPx+BPp46+zsTO+++24O8XFFQI84H8E/jvSPoyc/+OCDHPwjpr94FGXcOPA///M/aWJiIs3NzeXnx5i1GwOWlpbyaQIR47dt25bnOXToUP4zbjaIGwTe5IpxHz16lI/0j7f4/Bzp/yainkuAAAECBAgQIECAQL0ENmzYkH9GiT9dBAgQIECAAAECBAgQIECAAAECa1ugIYJ/HMEfYf7atWvp4sWL+XjJ0dHRtH///hzp45j/2ikAX3zxRY7nZ8+eTYODg1m/tqM+fmEVz41TAv75z3/mI/3jZoK4WeD56/ng39XVlQYGBnLw37t3b92Cfy32R/gX/Nf2fxKfHQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBNaiQEME/4jjEeHjWP+PP/44B/wTJ06koaGhvDN/cXHx2RH9cWNAHL9/6tSp1N/fnx8bH79792727+vryzcJPHjwII8ZwT123D9/1Y70j4/96le/yjcW9Pb2po6Ojroc6R/zCf5r8b+Dz4kAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQKNI9AQwT8CeYT7ONb/s88+y7vyI+b39PTkCB/hPj4WJwG0tbXlqB878mN3fuzej+P542aB2El/5MiRHO9fdcVR/3/605/yc+PGggMHDqT29vYc++txCf71UDQGAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIE1rdAQwT/WKKI5AsLCylifBzFPzs7mwP/06dP82tLRszfsWNHGh4ezjcDROzftGlTfkw85/z583ln/5kzZ3LAf9Ul+K/v/xS+egIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECDSCQMME/8BcWVnJ0T+O3I8oH9E/jt1vamrKO/13796dRkZG8s7/eF/cJBC7/ycnJ9OFCxdy8B8dHU0DAwOvXJsYPx4fx+7HSQExbmtrax6zHpcd/vVQNAYBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTWt0BDBf841j8ifET8xcXFfOR+bYd/xPiI8rWj92PXf1zxnNjlHzcKxPviZoB43Kuu5eXl/PgI852dnamlpSWfFlAb802/ZQT/NxX0fAIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBoqOBfleUS/Kuykr4OAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlBMQ/AvYC/4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICgn+BBRX8C6CbkgABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAhUTEPwLLKjgXwDdlAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEKiYgOBfYEEF/wLopiRAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEDFBAT/Agsq+BdANyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQqJiD4F1hQwb8AuikJECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBQMQHBv8CCCv4F0E1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBigkI/gUWVPAvgG5KAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIVExA8C+woIJ/AXRTEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGICDRX8nzx5kh49epSWl5fT4uJiWl1dTU+fPk0bNmxImzZtSi0tLam9vT01NzenjRs35ve/6orxVlZW8ngPHz7MY0eMj+c1NTXl8bZu3fpsvBizHpfgXw9FYxAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGB9CzRU8I8wv7CwkKanp9PExES6e/dujvQR+yP09/X1pZGRkdTb25s2b96c3/+qKyL/7OxsHu/69etpfn4+PX78OD8vQn+MNzw8nHp6elJra2u+CaAel+BfD0VjECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAYH0LNEzwj538Efgj9N+6dSvNzc3lXfm1Hf6x+3779u1pcHAw9ff3p+7u7hzpX3ZFcI/d/THe+Ph4Hu/evXt5p398LK4Yb9u2bWn//v15vIj/cRNAPS7Bvx6KxiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMD6FmiI4B9RP3bexy788+fPpwcPHqR9+/blnfdtbW35WP6I9nHMf+zO37lzZzp8+HD++Muu2ssCxHiff/55WlpaSkNDQ/nxcYx/3EgwNTWV7t+/n4/3j9h/9OjR/Gc9LsG/HorGIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwPoWaIjgH4E+Inzs7v/kk0/yLvxTp07l3fxxlH8E+4j3k5OTOdTHzvzTp0+nvXv35mD/4rW6uppvDojHX7hwIT/m+PHj+SaCCP7ffvtt+uabb/KYt2/fzqcFvPfee2lgYKAu3y2Cf10YDUKAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIF1LdAQwT9i/+zsbA70ly5dSs3NzWl0dDQH+NjRH7v/Y9d/RPpPP/00f/zs2bNpeHg4x/wXo3/tBoL5+fk0PT2dmpqacuyPlwSI8WK+CP1xg8HFixfzUf6///3v04EDB+ryzSL414XRIAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEFjXAg0R/ONo/Rs3bqSbN2/mQB87+E+cOJH6+/vz4tWO/L9y5Uo6d+5c/vf777+fDh48mDZv3pw2btz4nUWOGwTiZQCWl5fz6QAR/Lu6uvLu/nhu3DwQ88QO/xgzThEYGxtL+/fvr8s3i+BfF0aDECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAYF0LNETwj5344+Pjedd9xPg4Yv/YsWOpr6/v2eJFqL969WoO/rGDPwL9yMhIam1tzUH/+SuCe+3tyZMn+QSA2o0B8e+ZmZk8VkT/2O3f29ubfvvb36bdu3fX5ZtF8K8Lo0EIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwrgUaIvjPzc2ly5cvpzt37uSYv2PHjnT06NEc4p+/4kj/CP6rq6vp9OnTaWhoKO/O37JlyysXOcZcXFzMcf/bb7/NLx8QJwrEOHGaQIT+eHmAOPK/HpfgXw9FYxAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGB9CzRM8L906VIO/rEDv6enJ7311lsvDf4fffRRDvUnT55Mg4ODqbOzMzU3N79ylRcWFtK1a9dy5I+3iP6bNm3K4x8+fDgNDAzk8P9D47zut5Lg/7pSHkeAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC3yfQUME/jtp/PvhH+H/+ih3+EfxXVlZy8I9d+R0dHT8Y6mvBf3JyMt28eTPv9I8j/mP8AwcO5B3+sbs/Xh6gHlcE/zhV4PHjx/lt48aNL33pgXrMZQwCBAgQIECAAAECBAi8rkC83Fm8xc8o8aeLAAECBAgQIECAAAECBAgQIEBgbQs0TPC/cuVKiuAfMT+O9H/77bfTzp07v6Mbwf/DDz98dqR/BP+fcqT/vXv30t27d9P9+/fT8vJy6urqSkeOHMk3ANTjl15x00KcQhCxP+K/4L+2/5P47AgQIECAAAECBAisF4H42aSpqSm/LFqceuYiQIAAAQIECBAgQIAAAQIECBBY2wINEfzn5+dTxPzbt2+niPGx2/748eNp165dWffp06c5nF+9ejWdO3cu/31sbCzv8G9pacm79Z+/4vG12B6PjYgfj4lfbsW/Hzx4kBrV5VwAACAASURBVKanp9PExES6ePFiHuPdd9/NR/vHL73eNPq/GPxjzJgjfrHmIkCAAAECBAgQIECAQAmB2s7++LkkXs5M8C+xCuYkQIAAAQIECBAgQIAAAQIECPw4gYYI/rHT/saNG/m4/Xjr7OzMAX7Pnj35q60F9Aj+caR/hPsPPvggB//4ZVX8+/krjtNfXFzMpwVE+I/HbNu2LUf32s0AS0tLKU4V+POf/5yfWruBIG4MeNNffAn+P+6b1KMJECBAgAABAgQIEPj5BWo3Ntd2+b/4c9TP/xmYgQABAgQIECBAgAABAgQIECBA4McKNETwf/jwYZqbm0vXrl3LO+5jt8no6Gjav39/3pkf4b52CsAXX3yRWltb09mzZ9Pg4GD2iMAej4lfYMVzI/LHSQHxnIWFhXxc5b59+/LR/bVd/nGUfwT/P/7xj3mMP/zhD2lkZCTP96Y78Z8P/vH32g7/F08i+LGL6fEECBAgQIAAAQIECBB4U4HaTv83HcfzCRAgQIAAAQIECBAgQIAAAQIEfn6Bhgj+Eehjx30c6//xxx/ngH/ixIk0NDSUd/vHbv3x8fG8+z9uDOju7k6nTp1K/f39+bHx8bt372bNvr6+HP5nZ2fzqQER9SP4//a3v0179+7Nu/zj5oA7d+7kMeMGgra2tvT+++/nEwPqcaR/vGxAnDIQX1e8xU0GcZPCm95I8PN/u5iBAAECBAgQIECAAIGqC7zpS5hV3cfXR4AAAQIECBAgQIAAAQIECBBYSwINEfwjkEe4j0D/2WefpTjiP2J+T09P6ujoyDcDxMfiJICI8xH1Dx06lHfsr66uppmZmXyzQIT1I0eO5OfEzv7r16+nf/zjHzm6R8zv7e3NJwDEc+LGgbgpoHYDwenTp/MNAfW44uupxf4I/4J/PVSNQYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgfUl0BDBP5YkInlE+omJiTQ1NZVjfAT+p0+f5h37Ec137NiRw33cDBCxP3bjx2PiOefPn8/H8Z85cyYNDAzkHfaxi//y5cvp9u3b+XHxvhgvrhizdvNAjBcvHxBj1uMS/OuhaAwCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAisb4GGCf6xTHHUfkT/6enpHPEj+kekj6PwY9f+7t2708jISN75H++LsB67/ycnJ9OFCxdy8B8dHc3BP64HDx7kmwdu3bqVx4yTA2LnfdwoEDv9Y5wDBw6kXbt25fHjffW4BP96KBqDAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC61ugoYJ/HOsfQT4i/uLiYj56v7bDPwJ/a2tram9vT1u2bMk79OOK58Tu/bhRIN4XET8eF1fcLLC8vJzfYswY+/kTA2KcrVu3ppaWlnyzQJwiUI9L8K+HojEIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwvgUaKvhXZakE/6qspK+DAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC5QQE/wL2gn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBComIPgXWFDBvwC6KQkQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIFAxAcG/wIIK/gXQTUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGKCQj+BRZU8C+AbkoCBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhUTEDwL7Cggn8BdFMSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYgKCf4EFFfwLoJuSAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFRMQ/AssqOBfAN2UBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQqJiA4F9gQQX/AuimJECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQMUEBP8CCyr4F0A3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBCom0FDB/8mTJ+nRo0dpeXk5LS4uptXV1fT06dO0YcOGtGnTptTS0pLa29tTc3Nz2rhxY37/q64YL8aI8R4+fJj/HjE+rqampjze1q1b83gxfoxZj0vwr4eiMQgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQILC+BRoq+EeYX1hYSNPT02liYiLdvXs33wAQMT5Cf19fXxoZGUm9vb1p8+bN+f2vupaWltL8/Hy6detWun79eh4von+E/Qj9Md7Q0FDauXNnjv8xZj0uwb8eisYgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDA+hZomOAfO/kjyEfoj0A/NzeXd+XXdvhHpN++fXsaHBxM/f39qbu7O7W2tr50deM5Ed1jvP/93//N48Xfa+PFk2K8bdu2pX379uXxIv7HTQX1uAT/eigagwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAutboCGCfwT6x48f513458+fTw8ePMghvqenJ7W1taWVlZUc7eOY/9jVHzvyDx8+nD/+sqt2lH9tvG+//Tbt378/nwwQO/tjvKmpqXT//v18Q0G8/ze/+U2O/vW4BP96KBqDAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC61ugIYJ/HNsfu+9jd/8nn3ySd+efOnUq7+aPXfdxNH/E+8nJyRzqY2f+6dOn0969e9OGDRv+ZYVjvHh5gHjO559/nm8mOH78eL6JoKOjI88VO//j4zFeV1dX+t3vfpc/Xo9L8K+HojEIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwvgUaIvhHgJ+dnc1B/9KlS6m5uTmNjo6mgYGBvKM/gn3s+v/mm2/Sp59+mj9+9uzZNDw8nIP/i9G/FvzjGP8YM47vP3DgQNqxY0dqamrKO/xnZmbyDQZfffVV3vX/+9//Pt9gUI9L8K+HojEIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwvgUaIvjH0fo3btxIN2/eTNPT03kH/4kTJ1J/f39evdqR/1euXEnnzp3L/37//ffTwYMH0+bNm3PQf/6qHekfNxLEjQIR+SP2t7a25ofF++fm5nLw//vf/55fNuDMmTP5poB6XIJ/PRSNQYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgfUt0BDBf35+Po2Pj6fbt2/nQN/d3Z2OHTuW+vr6nq1eRP6rV6/m4B87+MfGxtLIyEiO+BH0n7/isRHdI/zH6QBxAsCWLVvyaQFx3bt3Lx/nHzcZ3Lp1K99gECcK7Nmzpy7fLYJ/XRgNQoAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgXUt0BDBP3bbX758Od25cyfH/NiNf/To0dTb2/udxYsj/SP4r66uptOnT6ehoaHU3t6eY/7rXHEDQIwf88R8caNB3AQQ8xw+fDj19PS8zjA/+JgI/jFP3GwQb3ECwctuTPjBgTyAAAECBAgQIECAAAECdRZ48SXR6jy84QgQIECAAAECBAgQIECAAAECBOoo0DDB/9KlSznER5SP8P7WW2+9NPh/9NFHOfifPHkyDQ4Ops7OztTc3PxaZMvLy2lhYSFNTk6mr7/+Op8CcOjQobR37958k0Ec7V+Pq/aSAhH74+9xU0FLS0t++QEXAQIECBAgQIAAAQIESgpE8H/xZdFKfj7mJkCAAAECBAgQIECAAAECBAgQ+H6Bhgr+MzMz3wn+L+64jx3+EfxXVlZy8B8eHk4dHR0/GPwjusdzIvZPTU3llw6YnZ1NW7duzScJ7N69O78sQL1+6fV88I+bCmrB/8WXHvCNS4AAAQIECBAgQIAAgV9KoLazP37uqefPP7/U528eAgQIECBAgAABAgQIECBAgMB6FGiY4H/lypUUwT/CfOy2f/vtt9POnTu/s2YR/D/88MNnR/pH8H+dI/0fPnyYA//NmzdTjBFBft++fWnXrl15rjhuP3bjP336tC7fI4J/XRgNQoAAAQIECBAgQIBAHQVqO/sj9scpaXFjsosAAQIECBAgQIAAAQIECBAgQGBtCzRE8J+fn88hPnbe37t3L23fvj0dP348B/m4IsTHTvmrV6+mc+fO5b+PjY3lHf6vOio/HhfH/9+9ezddv349TU9Pp/v37+eXAYiXDIjx45j9+MXXo0eP8rj1uF4M/rGDJm4qsMO/HrrGIECAAAECBAgQIEDgpwrUdvdv2bJF8P+piJ5HgAABAgQIECBAgAABAgQIEPgFBRoi+EeEv3HjRt6BH28R5N999920Z8+eTFUL6BH840j/+CXVBx98kIP/q46iXF5ezrE/xoznxjgHDhxI/f39eWd/W1tbHiuCf8T+eu3wj7HiBoI4NSDeBP9f8DveVAQIECBAgAABAgQIfK9A/OxT2+lfO+IfFwECBAgQIECAAAECBAgQIECAwNoVaIjgH0fuz83NpWvXrqWLFy/m4yVHR0fT/v378w78OOa/dgrAF198kXfLnz17Ng0ODmb5CPnxmPiFVe1oyoj3tefEzv44OWDbtm3p17/+9bOd/T/XEZYR/GuxP8K/4L92/4P4zAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQILBWBRoi+EccX1paysf6f/zxxzngnzhxIg0NDeXd/ouLi2l8fDzv1I8bA7q7u9OpU6fyTv14bHw8dvLH1dfXl28IiDHj1IC//vWvKW4oiNMA4sSA3t7etHXr1mc7+3+OhRP8fw5VYxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQGB9CTRE8I9AHuE+Av1nn32W4oj/iPk9PT2po6Mj3wwQH4twH8fwR9Q/dOhQ6urqSqurq2lmZibfLBA76Y8cOZJ38sdj4xj/uIEgjvaPnf27d+9+dgLA898GMWaMFX/Wjrh8k28Twf9N9DyXAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBEKgIYJ/fKIRyRcWFtLExESamppKs7OzOdrH0fy115jcsWNH3qkfNwNEoI8j+eMx8Zzz58/n4//PnDmTbxS4c+dOunLlSvr888/z7v+4CSB2/sdzXnytyhgvThTYu3dvampqyjcOvMkl+L+JnucSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQAg0TPCPT3ZlZSVH/+np6RzxI/o/evQoR/jY6R879EdGRnLQj/dFWI/d/5OTk+nChQs5+I+OjuYj/yP4x6kAsct/fn7+lTv3BX//WQgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEBgrQk0VPCPY/0fP36cI/7i4mI+rr+2wz8Cf+zQb29vT1u2bHm2Sz+eE7v840aB2LkfNwNE+I+bB+L9tXFetTCO9F9r37Y+HwIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBoqOBfleVypH9VVtLXQYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgXICgn8Be8G/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMlMqHKQAAIABJREFUoKGC/5MnT9KjR4/S8vJyWlxcTKurq+np06dpw4YNadOmTamlpSW1t7en5ubmtHHjxvz+17linIcPH6alpaX8tnnz5rR9+/bU1taWx3jdcV5nrniM4P+6Uh5HgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAt8n0FDBP0L/wsJCmp6eThMTE+nu3bv5BoCI/RH6+/r60sjISOrt7c3RPt7/Q1fcMBBjXr9+Pd24cSNNTU2ljo6OdPLkybR37948Ttw8UM9L8K+nprEIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwPgUaJvhHmI/AH6H/1q1baW5uLu/Kr+3wjygfu/IHBwdTf39/6u7uTq2tra9c1ZWVlXT//v00MzOTQ3+MPT4+np/77//+7+nQoUNpy5Ytr3XjwI/59hH8f4yWxxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIDAywQaIvhH1H/8+HHehX/+/Pn04MGDtG/fvtTT05OP3Y9wHzcBxDH/sat/586d6fDhw/njr7pmZ2fTP//5zxR/xrH9cUPBlStX8o0Dgr//MAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECCwlgUaIvjHsf2xmz924H/yyScpdsifOnUq7+aPo/yXlpbyzQCTk5N5p/62bdvS6dOn85H8EfK/77pz5076xz/+kXf5x3Pm5+fTV199lbZu3Sr4r+XvWp8bAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECKSGCP4R+2MXfgT9S5cupebm5jQ6OpoGBgbyjv7Y/R+7/r/55pv06aef5o+fPXs2DQ8P5+D/fdE/njM9PZ2f39nZmW8W+OMf/5ji5QHs8Pe/gwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTWskBDBP/YgX/jxo108+bNHOhjN/6JEydSf39/tq0d+R/H8Z87dy7/+/33308HDx5MmzdvzgH/Zdfq6mp+GYC4Yld/nCDwH//xH+nJkyeC/1r+rvW5ESBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEBj7PCPo/bHx8fT7du3807+7u7udOzYsdTX1/dsCSPyX716NQf/eAmAsbGxNDIyklpbW1NTU9NLlzpeGiB298cVj4nnC/7+VxAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAIwg0xA7/ubm5dPny5XTnzp0c83fs2JGOHj2aent7v2McR/pH8I+d+6dPn05DQ0Opvb09bdmy5bXWIuYQ/F+LyoMIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoLBAwwT/S5cu5eAfx+339PSkt95666XB/6OPPsrB/+TJk2lwcDB1dnam5ubm12IW/F+LyYMIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAYA0INFTwn5mZ+U7wj/D//BU7/CP4r6ys5OA/PDycOjo63ij4b968OW3cuDHFSwbEWz2ueCmBOKkgXk4g3mL8V730QD3mNAYBAgQIECBAgAABAgReR2DDhg35Z5T400WAAAECBAgQIECAAAECBAgQILC2BRom+F+5ciVF8I+YH0f6v/3222nnzp3f0Y3g/+GHHz470j+C/5sc6X/w4MG0adOmPEecLBChvh5XjBVfR8T+GLOpqSm1tLTkP10ECBAgQIAAAQIECBAoKRA/A8XLotV+Fir5uZibAAECBAgQIECAAAECBAgQIEDg1QINEfzn5+dTxPzbt2+ne/fupe3bt6fjx4+nXbt25a8udt5HOL969Wo6d+5c/vvY2Fje4R8hPXbpv8714pH+IyMjeWdLXPUM/hH6l5eXc/CPzz1Cvx3+r7NCHkOAAAECBAgQIECAwM8tED+fxMuiCf4/t7TxCRAgQIAAAQIECBAgQIAAAQJvLtAQwf/+/fvpxo0b6ebNm/mts7Mzvfvuu2nPnj1ZIGL86upqDv5xpH9E+g8++CAH//hlVS3a/xDX9wX/OMoybiKo15H+gv8PrYSPEyBAgAABAgQIECBQSqC2w/91f44q9XmalwABAgQIECBAgAABAgQIECBAIKWGCP4PHz5Mc3Nz6dq1a+nixYt5t8no6Gjav39/3r0fx+PXTgH44osv8m75s2fPpsHBwbzGtSP0I9zHc7/v6PwXg3/tSP94Xr1if3w+EfxrR/rHuPELNTv8/XckQIAAAQIECBAgQGAtCEToj5+Z4ucgFwECBAgQIECAAAECBAgQIECAwNoWaIjgH4F8aWkpH+v/8ccf54B/4sSJNDQ0lHf7Ly4upvHx8bz7P24M6O7uTqdOnUr9/f35sfHxu3fv5pXo6+tLW7dufemqvBj8Dx06lG8oqPfOlvicHj16lMN/vAn+a/s/ic+OAAECBAgQIECAwHoSiNAv9q+nFfe1EiBAgAABAgQIECBAgAABAo0s0BDBP47Tj0gex/p/9tlnKY74j5jf09OTOjo68s0A8bE4CaCtrS1H/Yj1XV1d+aj/mZmZfLNAhPsjR47k58XO+nj8wsJC/jOuGOOTTz7Jx/efPHky7d27Nwf/uEEgxopd+DHGm/7yK8avxf4I/zGmHf6N/N/I506AAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIFfXqAhgn+wRCSPOD8xMZGmpqbS7OxsDvUR7iPARzTfsWNHGh4ezjcDRKCPnfPxmHjO+fPnc7w/c+ZM2rdvXw7uEfj/9re/5fHiisfGzQFxxVhx80CMvWfPnvTOO++kgYGBfLRljPsml+D/JnqeS4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIh0DDBPz7ZeN37iP7T09M54kf0jx3yEeFjp//u3bvTyMhI3sEf74uwHrv/Jycn04ULF3LwHx0dzQH/ZcE/bh6Itwzz3DGWcQOB4O8/DAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAisJYGGCv5xrH+E+oj4i4uL+bj+2g7/CPxxLH57e3vasmXLs2P34zm1o/sj4sfNAC0tLS890v/7FiZ2+jvSfy192/pcCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKChgn9VlsuR/lVZSV8HAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEygkI/gXsBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYoJCP4FFlTwL4BuSgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFRMQPAvsKCCfwF0UxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBiAoJ/gQUV/Augm5IAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIVExD8Cyyo4F8A3ZQECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBComIDgX2BBBf8C6KYkQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAxQQE/wILKvgXQDclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEKiYg+BdYUMG/ALopCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgUDEBwb/Aggr+BdBNSYAAAQIECBAg8P/au5OeKpM2AMMPIDKIioiiOCsao0ZdOG5cGH+1w9Zp4dagYJwFFUENIojSqUo0n0mv6tBf6fteJzFRSJ2C6zm9aO5TBQECBAgQIECAAAECBAgQIECAAAECBBomIPhXGKjgXwHdlgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEGiYgOBfYaCCfwV0WxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBhAoJ/hYEK/hXQbUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGGCQj+FQYq+FdAtyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQaJiD4Vxio4F8B3ZYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBomIDgX2Gggn8FdFsSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYQKCf4WBCv4V0G1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBhgkI/hUGKvhXQLclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEGiYg+FcYqOBfAd2WBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQaJiA4F9hoIJ/BXRbEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGECgn+FgQr+FdBtSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYYJCP4VBir4V0C3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBBomIPhXGKjgXwHdlgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEGiYgOBfYaCCfwV0WxIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBhAoJ/hYEK/hXQbUmAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIGGCQj+FQYq+FdAtyUBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQaJiD4Vxio4F8B3ZYECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBomIDgX2Gggn8FdFsSIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECgYQKCf4WBCv4V0G1JgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBhgkI/hUGKvhXQLclAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEGiYg+FcYqOBfAd2WBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQaJiA4F9hoIJ/BXRbEiBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAoGECgn+FgQr+FdBtSYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgYYJCP4VBir4V0C3JQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBBomIPhXGKjgXwHdlgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEGiYQKuD//fv3+Pbt2/x9evXWFxcjJWVlVhbW4uurq7o6emJ/v7+GBoair6+vuju7s4fX4+H4L8eip6DAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC7RZodfBPoX9hYSFmZmbi6dOn8eHDh/wGgBT7U+gfGxuLiYmJ2LFjR/T29uaPr8dD8F8PRc9BgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBdgu0Nvink/wp8KfQ/+bNm5ibm4svX778OuGfTvRv27YtDh06FOPj4zEyMhIDAwPr8moR/NeF0ZMQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECg1QKtDP4p9q+ursbz58/j/v378fnz59i/f3+Mjo7G4OBgLC8v5zcBpGv+06n+nTt3xvHjx/Pn1+Mh+K+HoucgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIBAuwVaGfzTtf3pNH863X/nzp1IAf7ChQv5NH+6yn9paSm/GeDFixfx+vXr2Lp1a1y+fDn27t0bXV1dHb9iBP+OCT0BAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIEWi/QyuCfYv/79+9z0J+cnIy+vr64dOlS7Nu3L5/oT6f/06n/J0+exN27d/Pnr169GkeOHMnBv9PoL/i3/r87AAQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIEOhYoJXB/9OnT/Hy5ct49epVzMzM5BP8586di/Hx8Qz688r/x48fx40bN/K/r127FkePHo3e3t7o7u7uCF7w74jPYgIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCIiFYG//n5+Zieno7Z2dl8kn9kZCTOnDkTY2Njv14UKfJPTU3l4J9+BcCVK1diYmIiBgYGYsOGDR29eAT/jvgsJkCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIG2Bv+5ubl49OhRvH37Nsf87du3x6lTp2LHjh2/vSjSlf4p+K+srMTly5fj8OHDMTQ0FBs3buzoxSP4d8RnMQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAi0OfhPTk7m4P/9+/cYHR2NEydO/Gvwv3XrVg7+58+fj0OHDsWWLVuir6+voxeP4N8Rn8UECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg0Pbg/+7du9+Cfwr///tIJ/xv3rwZS0tLcfr06di/f39s3rx53U74p9sF0psJ0mM9flWAVzQBAgQIECBAgAABAgRKBbq6uvKvL+vt7c1vcu7p6Sl9KusIECBAgAABAgQIECBAgAABAgT+TwJda+mX1bfska70f/z4caTgv7y8nK/0P3nyZOzcufM3ienp6bh+/XosLCzE0aNHY2xsLPr7+/MPwDp5/Dzhn2L/ly9fIv3bD9Q6EbWWAAECBAgQIECAAIFOBdL/52zatCmGh4fzLWiDg4OdPqX1BAgQIECAAAECBAgQIECAAAEC/7FAK4P//Px8pNP7s7Oz8fHjx9i2bVucPXs2du3albnTeyBShJ+amsrB//Pnz/kNAenz6cRLpydd0vOnXyWQgv/Xr1/z39MP17q7u//jcXt6AgQIECBAgAABAgQI/LuA4O+VQYAAAQIECBAgQIAAAQIECBD4+wRaGfw/ffoUL1++jFevXuU/W7ZsiYsXL8aePXvyBH/G+BT805X+KdBfuXIlDh48mGN/uuqy08fPNxWkvdLfU+xfj+ft9OuyngABAgQIECBAgACBdgq40r+dc/ddEyBAgAABAgQIECBAgAABAn+3QCuDf7pGP13r/+zZs3j48GG+Tv/SpUtx4MCBfNI+XfP/8xaABw8exMDAQFy9ejUOHz4syv/dr3dfPQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBBoj0Mrgv7q6GktLS/la/9u3b+cT/efOnctBP532X1xcjOnp6Xz6P70xYGRkJC5cuBB79+5tzOB9IwQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDwdwu0Mvj/+PEjR/50rf+9e/ciXfE/Pj4eo6OjsXnz5vxmgPS5dBPA4OBgjI2NxbFjx2L79u1/97R99QQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDQGIFWBv80vRT9FxYW4unTp/H69et4//59Dvxra2v52v7u7u4c+I8cOZLfDDA8PBz9/f2NGbxvhAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgT+boHWBv80tuXl5Rz9Z2ZmcvhP0f/bt2+xYcOGfNJ/9+7dMTExkU/+p4+lNwF4ECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBP0Gg1cE/Xeu/urqar/BfXFyMlZWVXyf8U+AfGBiIoaGh2LhxYz71n/54ECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBP0Gg1cH/TxiAr4EAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAQumDoAAABIklEQVQAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCAj+JWrWECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBygKCf+UB2J4AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECJQICP4latYQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIHKAoJ/5QHYngABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIlAgI/iVq1hAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgcoCgn/lAdieAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAiUCPwDrUM8WJGDCx4AAAAASUVORK5CYII=',
  marginX: 5,
  marginY: 15,
  width: 200,
  height: 80.43,
  format: 'JPEG',
  compression: 'MEDIUM'
};

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"hidden":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center row-filter"},[(_vm.pdfProcess)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.processingFilter)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"pdf-filers"}},[(!_vm.processingFilter)?_c('div',{staticClass:"row mt-2 mb-lg-3 mt-md-0"},[_c('div',{staticClass:"col-12  col-lg-4"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_clinic_centre'))+" "),_c('sup',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('clinicalCenter'), 'is-clear': !_vm.clinicalCenterId},attrs:{"id":"clinicalCenterId","name":"clinicalCenter","label":'name',"selected":_vm.clinicalCenterId,"options":_vm.clinics,"loading":_vm.loading,"lastId":_vm.lastId,"searchable":false,"isLastPage":_vm.isLastPage,"optionTitle":'name',"isLast":_vm.isLast,"getOptionTitle":_vm.getOptionTitle},on:{"next-page":_vm.nextClinicalPage,"set-selected":_vm.onChangeClinicalCenter}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 mt-lg-0 col-lg-8"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_period'))+" "),_c('sup',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n               "+_vm._s(_vm._f("trans")('report.range_from'))+"\n          ")]),_vm._v(" "),_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-period'),expression:"'required|check-period'"}],attrs:{"name":"rangeDateStart","formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":new Date(),"data-vv-validate-on":"none","min-date":_vm.minDateStart},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12  mt-2 mt-lg-0 col-lg-6"},[_c('div',{staticClass:"datepicker datepicker__width right"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                   "+_vm._s(_vm._f("trans")('report.range_end'))+"\n              ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.rangeDateFinish,"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description-row",class:{'invalid-feedback': _vm.errors.has('rangeDateStart')}},[_vm._v(_vm._s(_vm._f("trans")('report.description_max_period')))])])])])]):_vm._e(),_vm._v(" "),(!_vm.processingFilter)?_c('div',{staticClass:"row mt-3 mb-3 mt-md-0"},[_c('div',{staticClass:"col-12 col-lg-4",attrs:{"id":"div-client"}},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_client'))+" "),_c('sup',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('client')},attrs:{"id":"mdc-client","disabled":_vm.disabledClient,"name":"client_id","label":'code',"selected":_vm.clientId,"options":_vm.clients,"searchable":false,"filterable":false,"loading":_vm.loading,"lastId":_vm.lastClinicId,"isLastPage":_vm.isLastPageClient,"isLast":_vm.isLastClient,"getOptionTitle":_vm.getOptionClientTitle},on:{"next-page":_vm.nextClientPage,"set-selected":_vm.onChangeClinicId}}),_vm._v(" "),_c('span',{staticClass:"description-row",attrs:{"id":"span-b"}},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_client')))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 mt-lg-0 col-lg-4"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_skill'))+"\n        ")]),_vm._v(" "),_c('h4',{staticClass:"row-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('report.start_skill')))]),_vm._v(" "),_c('v-select',{staticClass:"aut-dropdown",attrs:{"options":_vm.skillFieldList,"disabled":_vm.disabledSelect,"label":"id","name":"skillField","filterable":false,"onSearch":_vm.onSearchSkillField,"on-change":_vm.onChangeSkillFieldId,"placeholder":_vm._f("trans")('report.all_skill'),"data-vv-validate-on":"none"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n            "+_vm._s(option.name)+"\n          ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n            "+_vm._s(option.name)+"\n          ")]}}]),model:{value:(_vm.skillField),callback:function ($$v) {_vm.skillField=$$v},expression:"skillField"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('report.choose_skill'))+"\n            ")])])],2),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_skill')))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3 mt-lg-0 col-lg-4"},[_c('h3',{staticClass:"row-title"},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.choose_protocol'))+"\n        ")]),_vm._v(" "),_c('h4',{staticClass:"row-sub-title"},[_vm._v(_vm._s(_vm._f("trans")('report.start_protocol')))]),_vm._v(" "),_c('v-select',{staticClass:"aut-dropdown",attrs:{"options":_vm.protocolList,"disabled":_vm.disabledSelect,"label":"protocolId","name":"protocol","filterable":false,"placeholder":_vm._f("trans")('report.all_protocol'),"onSearch":_vm.onSearchProtocol,"on-change":_vm.onChangeProtocolId,"data-vv-validate-on":"none"},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n            "+_vm._s(option.title)+"\n          ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n            "+_vm._s(option.title)+"\n          ")]}}]),model:{value:(_vm.protocol),callback:function ($$v) {_vm.protocol=$$v},expression:"protocol"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('report.choose_protocol'))+"\n            ")])])],2),_vm._v(" "),_c('span',{staticClass:"description-row"},[_vm._v(_vm._s(_vm._f("trans")('report.description_choose_protocol')))])],1)]):_vm._e()]),_vm._v(" "),(!_vm.processingFilter)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLineTitle')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.levelLineChecked),callback:function ($$v) {_vm.levelLineChecked=$$v},expression:"levelLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.levelLine'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.trendLineChecked),callback:function ($$v) {_vm.trendLineChecked=$$v},expression:"trendLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.trendLine'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.ScatterLineChecked),callback:function ($$v) {_vm.ScatterLineChecked=$$v},expression:"ScatterLineChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.scatterLine'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('protocol.showGraphsTitle')))]),_vm._v(" "),_c('h4',{staticClass:"row-sub-title mt-2 mb-2"},[_vm._v(_vm._s(_vm._f("trans")('report.for_all_protocol')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphTotalPercentChecked),callback:function ($$v) {_vm.graphTotalPercentChecked=$$v},expression:"graphTotalPercentChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.total_percent_graph'))+" ("+_vm._s(_vm._f("trans")('report.without_mand'))+")\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphPromptLevelsChecked),callback:function ($$v) {_vm.graphPromptLevelsChecked=$$v},expression:"graphPromptLevelsChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_prompt_levels'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphCumulitiveChecked),callback:function ($$v) {_vm.graphCumulitiveChecked=$$v},expression:"graphCumulitiveChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.cumulitive_graph'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphImprovedSPOUChecked),callback:function ($$v) {_vm.graphImprovedSPOUChecked=$$v},expression:"graphImprovedSPOUChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_improved_spou'))+" ("+_vm._s(_vm._f("trans")('report.simple'))+")\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},[_c('h4',{staticClass:"row-sub-title mt-2 mb-2"},[_vm._v(_vm._s(_vm._f("trans")('report.for_chain')))]),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"radios","value":"absolute","label":_vm._f("trans")('protocol.chain_step_chart')},model:{value:(_vm.chartType),callback:function ($$v) {_vm.chartType=$$v},expression:"chartType"}}),_vm._v(" "),_c('mdc-radio',{attrs:{"name":"radios","value":"relative","label":_vm._f("trans")('protocol.chain_mastered_chart')},model:{value:(_vm.chartType),callback:function ($$v) {_vm.chartType=$$v},expression:"chartType"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-sub-title mt-4 mb-2"},[_vm._v(_vm._s(_vm._f("trans")('report.for_mand')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphMoYesPercentChecked),callback:function ($$v) {_vm.graphMoYesPercentChecked=$$v},expression:"graphMoYesPercentChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_mo_yes_percent'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphMoYesChecked),callback:function ($$v) {_vm.graphMoYesChecked=$$v},expression:"graphMoYesChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_mo_yes'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphProbeFullChecked),callback:function ($$v) {_vm.graphProbeFullChecked=$$v},expression:"graphProbeFullChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_probe_full'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphMoGoalChecked),callback:function ($$v) {_vm.graphMoGoalChecked=$$v},expression:"graphMoGoalChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_mo_goal'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphMandReactChecked),callback:function ($$v) {_vm.graphMandReactChecked=$$v},expression:"graphMandReactChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_mand_react'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphGoalChecked),callback:function ($$v) {_vm.graphGoalChecked=$$v},expression:"graphGoalChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_goal'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphCumulativeImproveChecked),callback:function ($$v) {_vm.graphCumulativeImproveChecked=$$v},expression:"graphCumulativeImproveChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_cumulative_improve'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphImprovePromptChecked),callback:function ($$v) {_vm.graphImprovePromptChecked=$$v},expression:"graphImprovePromptChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_improve_prompt'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.graphImproveChecked),callback:function ($$v) {_vm.graphImproveChecked=$$v},expression:"graphImproveChecked"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.graph_improve'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('report.generate_version')))]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.pdfReport),callback:function ($$v) {_vm.pdfReport=$$v},expression:"pdfReport"}},[_vm._v(_vm._s(_vm._f("trans")('report.generate_pdf_version'))+"\n          ")]),_vm._v(" "),_c('mdc-switch',{model:{value:(_vm.csvReport),callback:function ($$v) {_vm.csvReport=$$v},expression:"csvReport"}},[_vm._v(_vm._s(_vm._f("trans")('report.generate_csv_version'))+"\n          ")])],1),_vm._v(" "),(_vm.clientId)?_c('div',{staticClass:"col-12 mt-4"},[_c('mdc-switch',{model:{value:(_vm.showGraphUndesirableBehaviors ),callback:function ($$v) {_vm.showGraphUndesirableBehaviors =$$v},expression:"showGraphUndesirableBehaviors "}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('behavior.add_ub_to_report'))+"\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.showGraphUndesirableBehaviors)?_c('div',{staticClass:"col-12 mt-2"},[_c('mdc-radio',{attrs:{"name":"radiosUB","value":"1","label":_vm._f("trans")('behavior.all_ub_for_day')},model:{value:(_vm.undesirableBehaviorGraphType),callback:function ($$v) {_vm.undesirableBehaviorGraphType=$$v},expression:"undesirableBehaviorGraphType"}})],1):_vm._e(),_vm._v(" "),(_vm.showGraphUndesirableBehaviors)?_c('div',{staticClass:"col-12"},[_c('mdc-radio',{attrs:{"name":"radiosUB","value":"2","label":_vm._f("trans")('behavior.ub_for_day')},model:{value:(_vm.undesirableBehaviorGraphType),callback:function ($$v) {_vm.undesirableBehaviorGraphType=$$v},expression:"undesirableBehaviorGraphType"}})],1):_vm._e(),_vm._v(" "),(_vm.showGraphUndesirableBehaviors && _vm.undesirableBehaviorGraphType === '2')?_c('div',{staticClass:"col-12"},[_c('select-with-pager',{staticClass:"load_more__select",class:{'is-invalid': _vm.errors.has('behavior'), 'is-clear': !_vm.behaviorId},attrs:{"id":"behaviorId","name":"behavior","label":'text',"selected":_vm.behaviorId,"options":_vm.behaviorsList,"loading":_vm.loading,"lastId":_vm.lastBehaviorsId,"searchable":false,"isLastPage":_vm.isLastBehaviorsPage,"optionTitle":'text',"isLast":_vm.isLastBehavior,"getOptionTitle":_vm.getOptionBehaviorsTitle},on:{"next-page":_vm.nextBehaviorsPage,"set-selected":_vm.onSetBehaviorsSelected}})],1):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-3 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","raised":"","disabled":!_vm.clientId},on:{"click":function($event){$event.preventDefault();_vm.onSendRequest()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('report.draw_report'))+"\n      ")])])]),_vm._v(" "),(_vm.processing)?_c('loader',{staticClass:"table-loader"}):_vm._e(),_vm._v(" "),(_vm.showTable && !_vm.processing)?_c('div',[_c('div',{staticClass:"col-12",attrs:{"id":"pdf-client-table"}},[(_vm.client)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm._f("trans")('report.info_client'))+":\n        "+_vm._s(_vm.client))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.introduced')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.mastered')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.total_time')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.sessions_total')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('protocol.protocol_status')))])])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},[_vm._l((_vm.statisticsList),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[(item.createdAt)?_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(item.createdAt)))]):_vm._e()]),_vm._v(" "),_c('td',[(item.finishedAt)?_c('span',[_vm._v(_vm._s(_vm._f("toLocaleDate")(item.finishedAt)))]):_c('span',[_vm._v("—")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.timeDuration(item.totalTimes)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalSessions))]),_vm._v(" "),_c('td',{attrs:{"nowrap":""}},[_c('span',{staticClass:"status-badge",class:{'new-status' : _vm.isNew(item.statusId),
                  'individualize-status' : _vm.isIndividualize(item.statusId),
               'active-status' : _vm.isActive(item.statusId),
               'maintaining-status' : _vm.isMaintaining(item.statusId),
               'completed-status' : _vm.isCompleted(item.statusId)}}),_vm._v(_vm._s(_vm._f("trans")('protocol.statuses.' + item.statusName))+"\n            ")])])}),_vm._v(" "),_c('tr',{staticClass:"total"},[_c('td',[_vm._v(_vm._s(_vm._f("trans")('report.total'))+": "+_vm._s(_vm.totalStatisticsList.count))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.timeDuration(_vm.totalStatisticsList.totalTimes)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.totalStatisticsList.totalSessions))]),_vm._v(" "),_c('td')])],2)])]),_vm._v(" "),(_vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showTable && !_vm.processing)?_c('div',{staticClass:"col-12 mt-3 text-right"},[_c('button',{staticClass:"btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0",attrs:{"type":"button","disabled":_vm.isSaveDisable,"raised":""},on:{"click":function($event){$event.preventDefault();_vm.saveRequest()}}},[_vm._v("\n      "+_vm._s(_vm._f("trans")('report.save_report'))+"\n    ")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveList_vue__ = __webpack_require__(658);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be4511f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveList_vue__ = __webpack_require__(1409);
function injectStyle (ssrContext) {
  __webpack_require__(1408)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be4511f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.name_report')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.author')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("CSV")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("PDF")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm._f("trans")('report.date_generation')))]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('th',{staticClass:"action-cell"}):_vm._e()])]),_vm._v(" "),_c('tbody',{staticClass:"gray-700"},[(!_vm.isLoaded)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('loader',{staticClass:"table-loader"})],1)]):_vm._e(),_vm._v(" "),(_vm.isEmptyList && _vm.isLoaded)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"6"}},[_c('h5',[_vm._v(_vm._s(_vm._f("trans")('behavior.no_data')))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.reports),function(item){return (_vm.isLoaded && !_vm.isEmptyList)?_c('tr',[_c('td',[(item.type == 1 && !item.isUserDeleted)?_c('router-link',{attrs:{"to":{ name: 'client-reports',
                      params: {
                        isEdit: _vm.isEdit,
                        id: item.clientId,
                        skillFieldId: item.skillFieldId,
                        skillFieldName: item.skillFieldName,
                        clinicId: item.clinicalCenterId,
                        protocolId: item.protocolId,
                        protocolTitle: item.protocolTitle,
                        startDate: item.startDate,
                        endDate: item.endDate,
                        csvShow: typeof item.csv !== 'undefined',
                        pdfShow: typeof item.pdf !== 'undefined',
                        behaviorGraphType: item.undesirableBehaviorGraphType,
                        behaviorUBId: item.undesirableBehaviorBehaviorId,
                        levelLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showLevelLine : false) : false,
                        trendLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showTrendLine : false) : false,
                        scatterLineShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showScatterLine : false) : false,
                        graphMoYesPercentShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoYesPercent : false) : false,
                        graphTotalPercentShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphTotalPercent : false) : false,
                        graphPromptLevelsShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphPromptLevels : false) : false,
                        graphImprovedSPOUShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprovedSPOU : false) : false,
                        graphMoYesShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoYes : false) : false,
                        graphProbeFullShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphProbeFull : false) : false,
                        graphMoGoalShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMoGoal : false) : false,
                        graphMandReactShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphMandReact : false) : false,
                        graphGoalShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphGoal : false) : false,
                        graphCumulativeImproveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphCumulativeImprove : false) : false,
                        graphImprovePromptShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprovePrompt : false) : false,
                        graphImproveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphImprove : false) : false,
                        graphCumulitiveShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphCumulitive : false) : false,
                        graphAboluteShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showAbsolute : false) : false,
                        graphRelativeShow: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showRelative : false) : false,
                        graphUndesirableBehaviors: item.settings ? (item.settings.chartOptions ? item.settings.chartOptions.showGraphUndesirableBehaviors : false) : false,
                        }}}},[_vm._v("\n                "+_vm._s(item.title)+"\n              ")]):_vm._e(),_vm._v(" "),(item.type == 2 && !item.isUserDeleted)?_c('router-link',{attrs:{"to":{ name: 'curator-reports',
                      params: {
                        isEdit: _vm.isEdit,
                        id: item.curatorId,
                        startDate: item.startDate,
                        endDate: item.endDate
                        }}}},[_vm._v("\n                "+_vm._s(item.title)+"\n              ")]):_vm._e(),_vm._v(" "),(item.type == 3 && !item.isUserDeleted)?_c('router-link',{attrs:{"to":{ name: 'therapist-reports',
                      params: {
                        isEdit: _vm.isEdit,
                        id: item.therapistId,
                        startDate: item.startDate,
                        endDate: item.endDate
                        }}}},[_vm._v("\n                "+_vm._s(item.title)+"\n              ")]):_vm._e(),_vm._v(" "),(item.isUserDeleted)?_c('span',[_vm._v(_vm._s(item.title)+" - "),_c('i',[_vm._v(_vm._s(_vm._f("trans")('report.deleted_user')))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"description mb-0"},[_vm._v("\n                "+_vm._s(_vm._f("trans")('report.range_from'))+" "+_vm._s(_vm._f("toLocaleDate")(item.startDate.date))),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("trans")('report.range_end'))+" "+_vm._s(_vm._f("toLocaleDate")(item.endDate.date))+"\n                "),(item.skillFieldName)?_c('span',[_c('br'),_vm._v(_vm._s(_vm._f("trans")('protocol.area'))+": "+_vm._s(item.skillFieldName))]):_vm._e()])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.owner.fullName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(typeof item.csv !== 'undefined' && item.csv.status == 1 && item.clientId)?_c('a',{staticClass:"text-center name-link",attrs:{"href":"#"},on:{"click":function($event){_vm.downloadCsv(item.csv)}}},[_c('img',{attrs:{"src":__webpack_require__(659),"alt":""}})]):_vm._e(),_vm._v(" "),(typeof item.csv !== 'undefined' && item.csv.status != 1 && item.clientId)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('report.statusCSV.' + item.csv.status)))]):_vm._e(),_vm._v(" "),(typeof item.csv == 'undefined' && !item.isUserDeleted && item.clientId)?_c('a',{staticClass:"text-center name-link",attrs:{"href":"#"},on:{"click":function($event){_vm.generateCsv(item)}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('report.generate'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(typeof item.pdf !== 'undefined' && item.pdf.status == 2 && item.clientId)?_c('a',{staticClass:"text-center name-link",attrs:{"href":"#"},on:{"click":function($event){_vm.downloadPdf(item)}}},[_c('img',{attrs:{"src":__webpack_require__(659),"alt":""}})]):_vm._e(),_vm._v(" "),(typeof item.pdf !== 'undefined' && item.pdf.status != 2 && item.clientId)?_c('span',[_vm._v(_vm._s(_vm._f("trans")('report.status.' + item.pdf.status)))]):_vm._e(),_vm._v(" "),(typeof item.pdf == 'undefined' && !item.isUserDeleted && item.clientId)?_c('a',{staticClass:"text-center name-link",attrs:{"href":"#"},on:{"click":function($event){_vm.generatePdf(item)}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('report.generate'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.toLocaleDateTimeTimezone(item.createdAt.date)))]),_vm._v(" "),(!_vm.isMensurationForbidden)?_c('td',{staticClass:"text-right"},[_c('a',{staticClass:"delete-icon",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showDeletePopup(item.id)}}},[_c('mdc-icon',{attrs:{"icon":"delete"}})],1)]):_vm._e()]):_vm._e()})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.paginate.lastPage > 1)?_c('nav',{staticClass:"nav justify-content-center justify-content-md-start"},[_c('paginate',{attrs:{"page-count":_vm.paginate.lastPage,"initial-page":_vm.initialPage,"page-range":_vm.paginate.pageRange,"margin-pages":_vm.paginate.marginPages,"force-page":_vm.paginate.forcePage,"click-handler":_vm.onPaginationClick,"container-class":'pagination pagination-sm',"page-class":'page-item',"page-link-class":'page-link'}},[_c('span',{staticClass:"page-link",attrs:{"slot":"prevContent"},slot:"prevContent"},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"page-link",attrs:{"slot":"nextContent"},slot:"nextContent"},[_vm._v("»")])])],1):_vm._e()])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.deleteReport()},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest() && __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].can('statistic_report_list_view')) {
    next();
  } else {
    next({ name: 'login' });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_quiz_components_QuizDashboardLayout__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_quiz_components_QuizList__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_quiz_components_Quiz__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_quiz_components_QuizTaking__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__ = __webpack_require__(132);









/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/quiz/:clientId',
  component: __WEBPACK_IMPORTED_MODULE_1__modules_quiz_components_QuizDashboardLayout__["a" /* default */],
  props: true,
  children: [{
    path: 'index',
    name: 'quiz',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_quiz_components_QuizList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */]
  }, {
    path: ':quizId/edit',
    name: 'quiz-edit',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_quiz_components_Quiz__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }, {
    path: ':quizId/show',
    name: 'quiz-show',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_quiz_components_Quiz__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }, {
    path: ':quizId/take',
    name: 'quiz-take',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_quiz_components_QuizTaking__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }, {
    path: 'create',
    name: 'quiz-create',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_quiz_components_Quiz__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_0_vue_router_multiguard___default()([__WEBPACK_IMPORTED_MODULE_5__router_hooks_isAuthorized__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router_hooks_isMensurationForbidden__["a" /* default */]])
  }]
}]);

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizDashboardLayout_vue__ = __webpack_require__(660);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af4cd604_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizDashboardLayout_vue__ = __webpack_require__(1414);
function injectStyle (ssrContext) {
  __webpack_require__(1413)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizDashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af4cd604_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizDashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded shadow  container-box"},[_c('div',{staticClass:"row mt-2 top-button form-group-button"},[(_vm.client)?_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-light btn-sm back",attrs:{"to":{ name: 'client-edit', params: { clientId: _vm.clientId}}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('buttons.back_to_client'))+" "+_vm._s(_vm.client.code)+" ("+_vm._s(_vm.client.hash)+")")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-view',{attrs:{"clientId":_vm.clientId,"client":_vm.client}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizList_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c7ca80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizList_vue__ = __webpack_require__(1419);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c7ca80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(_vm.isBCBA || _vm.isCurator)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"filter-row d-flex h-100  flex-wrap align-items-end justify-content-between justify-content-sm-start"},[_c('div',{staticClass:"datepicker"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                 "+_vm._s(_vm._f("trans")('behavior.date_start'))+"\n            ")]),_vm._v(" "),_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|check-period'),expression:"'required|check-period'"}],class:{'is-invalid': _vm.errors.has('rangeDateStart')},attrs:{"name":"rangeDateStart","formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"max-date":_vm.maxDateStart,"data-vv-validate-on":"none","min-date":_vm.minDateStart},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('div',{staticClass:"datepicker right"},[_c('span',{staticClass:"datepicker__label"},[_vm._v("\n                 "+_vm._s(_vm._f("trans")('appeals.date_end'))+"\n            ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"min-date":_vm.rangeDateStart},model:{value:(_vm.rangeDateEnd),callback:function ($$v) {_vm.rangeDateEnd=$$v},expression:"rangeDateEnd"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1),_vm._v(" "),_c('div',{staticClass:"item-filter mr-md-4"},[_c('v-select',{class:{'is-invalid': _vm.errors.has('field'), 'is-clear': !_vm.quiz},attrs:{"options":_vm.quizList,"label":"title","name":"quiz","filterable":false,"data-vv-validate-on":"none"},model:{value:(_vm.quiz),callback:function ($$v) {_vm.quiz=$$v},expression:"quiz"}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")('quiz.quiz')))])],1),_vm._v(" "),_c('div',{staticClass:"item-filter mr-md-4 mb-0"},[_c('autocomplete-search',{ref:"targetBehaviour",class:{'is-invalid': _vm.errors.has('targetBehaviour')},attrs:{"id":"targetBehaviour","suggestions":_vm.autocomplete,"visible":_vm.visible,"field":'name',"label":_vm._f("trans")('quiz.targetBahaviour'),"validateRule":"","validateLable":""},on:{"input":_vm.setProblemBehaviourValue,"inputChange":_vm.onChangeProblemBehaviour},model:{value:(_vm.targetBehaviour),callback:function ($$v) {_vm.targetBehaviour=$$v},expression:"targetBehaviour"}}),_vm._v(" "),(_vm.errors.has('targetBehaviour'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('targetBehaviour')))])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(_vm.isBCBA || _vm.isCurator)?_c('div',{staticClass:"col-12 mt-0  d-lg-block"},[_c('div',{class:{'d-flex h-100  align-items-end justify-content-end': !_vm.isMobile}},[_c('button',{staticClass:"btn btn-lightblue mt-3 mt-sm-0 mb-2 mr-2",attrs:{"type":"button","raised":""},on:{"click":function($event){$event.preventDefault();_vm.applyFilter()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('behavior.buttons.apply'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light mb-2 mr-2",attrs:{"type":"button","disabled":(!_vm.fastList || (_vm.fastList && _vm.fastList.unitIds.length < 2)) && (!_vm.masList || (_vm.masList && _vm.masList.unitIds.length < 2)),"raised":""},on:{"click":function($event){$event.preventDefault();_vm.showResult()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.report'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light mb-2 mr-2",attrs:{"type":"button","disabled":(!_vm.fastList || (_vm.fastList && _vm.fastList.unitIds.length < 2)) && (!_vm.masList || (_vm.masList && _vm.masList.unitIds.length < 2)),"raised":""},on:{"click":function($event){$event.preventDefault();_vm.exportQuiz()}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('quiz.pdfReport'))+"\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary mb-2",attrs:{"to":{ name: 'quiz-create', params: {clientId: _vm.clientId}}}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('quiz.createQuiz'))+"\n        ")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3 mt-2",class:{'table-without-header':_vm.isMobile, 'table-hide-head':_vm.isTherapist}},[(_vm.messageError)?_c('div',{staticClass:"text-danger mb-2"},[_vm._v(_vm._s(_vm.messageError))]):_vm._e(),_vm._v(" "),_c('table-view',{attrs:{"options":_vm.options,"withChild":_vm.isBCBA || _vm.isCurator,"isList":_vm.isMobile,"indexColumn":"4","isLoaded":_vm.isLoaded,"isChange":_vm.isChange},scopedSlots:_vm._u([{key:"childRow",fn:function(props){return _c('div',{},[((_vm.isCurator && _vm.user.id === props.row.creator.id) || _vm.isBCBA)?_c('div',{staticClass:"p-3"},[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('quiz.quizComplete')))]),_vm._v(" "),_c('th',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("trans")('quiz.passed_at')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('quiz.addToReport')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((props.row.quizAnsweredUnits),function(specialists){return _c('tr',{key:specialists.id},[_c('td',[_vm._v(_vm._s(specialists.name))]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_vm._v(_vm._s(specialists.passedAt ? _vm.toLocaleDateTime(specialists.passedAt.date) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('mdc-checkbox',{attrs:{"disabled":!specialists.addAnsweredToReport && ((_vm.listReportLength(props.row.quizAnsweredSpecialists) > 2) || _vm.disabledCheckAnswer(props.row))},on:{"change":function($event){_vm.choseSpecialists(props.row,specialists)}},model:{value:(specialists.addAnsweredToReport),callback:function ($$v) {_vm.$set(specialists, "addAnsweredToReport", $$v)},expression:"specialists.addAnsweredToReport"}})],1),_vm._v(" "),_c('td',[_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.exportSpecialistQuiz(props.row.id, specialists.id)}}},[_vm._v(_vm._s(_vm._f("trans")('quiz.pdfReport')))])])]),_vm._v(" "),_c('td',[_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.resultSpecialistQuiz(props.row.id, specialists.id)}}},[_vm._v(_vm._s(_vm._f("trans")('report.report')))])])])])}))])]):_vm._e()])}},{key:"quizAssignedUnits",fn:function(props){return _c('div',{},[(_vm.isMobile)?_c('b',[_vm._v(_vm._s(_vm._f("trans")('quiz.assigned'))+":")]):_vm._e(),_vm._v(" "),_vm._l((props.row.quizAssignedUnits),function(specialist){return _c('div',{staticClass:"d-flex"},[_vm._v("\n            "+_vm._s(specialist.name)+"\n            "),(specialist.isAnswered)?_c('i',{staticClass:"material-icons text-success align-middle fz16"},[_vm._v("done")]):_vm._e()])})],2)}},{key:"childList",fn:function(props){return _c('div',{},[_c('div',[_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm._f("trans")('quiz.quizComplete')))]),_vm._v(" "),_c('th',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm._f("trans")('quiz.passed_at')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("trans")('quiz.addToReport')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((props.row.quizAnsweredUnits),function(specialists){return _c('tr',{key:specialists.id},[_c('td',[_vm._v(_vm._s(specialists ? specialists.name: ''))]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_vm._v(_vm._s(specialists.passedAt ? _vm.toLocaleDate(specialists.passedAt.date) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('mdc-checkbox',{attrs:{"disabled":!specialists.addAnsweredToReport && ((_vm.listReportLength(props.row.quizAnsweredSpecialists) > 2) || _vm.disabledCheckAnswer(props.row))},on:{"change":function($event){_vm.choseSpecialists(props.row,specialists)}},model:{value:(specialists.addAnsweredToReport),callback:function ($$v) {_vm.$set(specialists, "addAnsweredToReport", $$v)},expression:"specialists.addAnsweredToReport"}})],1),_vm._v(" "),_c('td',[_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.exportSpecialistQuiz(props.row.id, specialists.id)}}},[_vm._v(_vm._s(_vm._f("trans")('quiz.pdfReport')))])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.resultSpecialistQuiz(props.row.id, specialists.id)}}},[_vm._v(_vm._s(_vm._f("trans")('report.report')))])])])])}))])])])}},{key:"action",fn:function(props){return _c('div',{},[(_vm.isBCBA || _vm.isCurator)?_c('div',{staticClass:"actions"},[_c('mdc-menu-anchor',[_c('mdc-button',{attrs:{"raised":""},on:{"click":function($event){props.row.isOpen = true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('mdc-menu',{model:{value:(props.row.isOpen),callback:function ($$v) {_vm.$set(props.row, "isOpen", $$v)},expression:"props.row.isOpen"}},[_c('mdc-menu-item',[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'quiz-show', params: {clientId: _vm.clientId, quizId: props.row.id }}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('quiz.show'))+"\n                  ")])],1),_vm._v(" "),((!props.row.quizAnsweredUnits.length || props.row.specialist.isDeleted) && ((_vm.isCurator && _vm.user.id === props.row.creator.id) || _vm.isBCBA))?_c('mdc-menu-item',[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'quiz-edit', params: {clientId: _vm.clientId, quizId: props.row.id }}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('protocol.buttons.edit'))+"\n                  ")])],1):_vm._e(),_vm._v(" "),_c('mdc-menu-item',[(props.row.specialist && _vm.user.id === props.row.specialist.id  && (props.row.quizAssignedUnits.length !== props.row.quizAnsweredUnits.length))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'quiz-take', params: {clientId: _vm.clientId, quizId: props.row.id }}}},[_vm._v("\n                    "+_vm._s(_vm._f("trans")('quiz.take'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),(!props.row.quizAnsweredUnits.length && ((_vm.isCurator && _vm.user.id === props.row.creator.id) || _vm.isBCBA))?_c('mdc-menu-item',[_c('a',{staticClass:"nav-link",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.showDeletePopup(props.row)}}},[_vm._v(_vm._s(_vm._f("trans")('protocol.buttons.delete')))])]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isTherapist)?_c('div',{staticClass:"nowrap"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'quiz-take', params: {clientId: _vm.clientId, quizId: props.row.id }}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('quiz.goToQuiz'))+"\n            ")])],1):_vm._e()])}},{key:"addToReport",fn:function(props){return (_vm.isBCBA || _vm.isCurator)?_c('div',{},[_c('mdc-checkbox',{attrs:{"disabled":"","checked":!!_vm.listReportLength(props.row.quizAnsweredUnits)}})],1):_vm._e()}}])})],1)]),_vm._v(" "),_c('div',{ref:"resultTable",staticClass:"col-12 mt-4 position-relative",attrs:{"id":"resultTable"}},_vm._l((_vm.results),function(result){return _c('div',{staticClass:"row"},[(result.quiz.id === 1)?_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('quiz.masTableTitle'))+" ("+_vm._s(result.assignedQuizUnit.name)+")")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th'),_vm._v(" "),_vm._l((result.resultTable.titles[0]),function(title,index){return _c('th',{staticClass:"text-center"},[_vm._v(_vm._s(title))])})],2)]),_vm._v(" "),_c('tbody',[_vm._l((result.resultTable.questionAnswers),function(answers){return _c('tr',[_c('td'),_vm._v(" "),_vm._l((answers),function(answer){return _c('td',{staticClass:"text-center"},[_c('strong',{staticClass:"float-left mw20"},[_vm._v(_vm._s(answer.questionId)+".")]),_vm._v(" "+_vm._s(answer.value)+"\n              ")])})],2)}),_vm._v(" "),_vm._l((result.resultTable.totalScore),function(answersTotal,indexTotal){return _c('tr',[(indexTotal == 5)?_c('td',[_vm._v(_vm._s(_vm._f("trans")('quiz.totalScore')))]):_vm._e(),_vm._v(" "),(indexTotal == 6)?_c('td',[_vm._v(_vm._s(_vm._f("trans")('quiz.meanScore'))+" "),_c('i',[_vm._v(_vm._s(_vm._f("trans")('quiz.meanScoreDescription')))])]):_vm._e(),_vm._v(" "),(indexTotal == 7)?_c('td',[_vm._v(_vm._s(_vm._f("trans")('quiz.relativeRanking'))+" "),_c('i',[_vm._v(_vm._s(_vm._f("trans")('quiz.relativeRankingDescription')))])]):_vm._e(),_vm._v(" "),_vm._l((answersTotal),function(answer){return _c('td',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(answer)+"\n              ")])})],2)})],2)])]):_vm._e(),_vm._v(" "),(result.quiz.id === 2)?_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('quiz.fastTableTitle'))+" ("+_vm._s(result.assignedQuizUnit.name)+")")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',_vm._l((result.resultTable.titles),function(title,index){return _c('th',{class:{'text-center': (index===1)},attrs:{"colspan":index===0 ? result.resultTable.questionAnswers[0].length : 1}},[_vm._v(_vm._s(title))])}))]),_vm._v(" "),_c('tbody',_vm._l((result.resultTable.questionAnswers),function(answers,index){return _c('tr',[_vm._l((answers),function(answer,answIndex){return _c('td',{staticClass:"text-center",class:{'bg-secondary': answer.value === 1}},[_vm._v("\n              "+_vm._s(answer.questionId - 22)+"\n            ")])}),_vm._v(" "),(index === 4 || index === 3)?_c('td'):_vm._e(),_vm._v(" "),(index === 4 || index === 3)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n              "+_vm._s(result.resultTable.totalScore[index])+"\n            ")]),_vm._v(" "),_c('td',{class:{'bg-secondary': result.resultTable.totalScore[index] === _vm.maxValue(result.resultTable.totalScore)}},[_vm._v("\n              "+_vm._s(result.resultTable.title[index])+"\n            ")])],2)}))])]):_vm._e()])})),_vm._v(" "),(_vm.barChartDatasetMas.length && _vm.maxMas)?_c('div',{staticClass:"col-12 mt-3"},[_c('bar-chart',{attrs:{"bardatasets":_vm.dataMas,"scaleLabelX":"","scaleLabelY":_vm._f("trans")('quiz.meanScore'),"withLabels":true,"showLegend":_vm.results.length>1,"aspectRatio":false,"height":360,"valueMax":_vm.maxMas,"show-legend":true}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")(_vm.results.length>1 ? 'quiz.masChart' : 'quiz.oneMasChart')))])],1):_vm._e(),_vm._v(" "),(_vm.barChartDatasetFast.length && _vm.maxFast)?_c('div',{staticClass:"col-12 mt-3"},[_c('bar-chart',{attrs:{"bardatasets":_vm.dataFast,"scaleLabelX":"","scaleLabelY":_vm._f("trans")('quiz.countYes'),"withLabels":true,"aspectRatio":false,"height":360,"showLegend":_vm.results.length>1,"valueMax":_vm.maxFast,"show-legend":true}}),_vm._v(" "),_c('h4',{staticClass:"chart__title mb-3"},[_vm._v(_vm._s(_vm._f("trans")(_vm.results.length>1 ? 'quiz.fastChart' : 'quiz.oneFastChart')))])],1):_vm._e(),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('user.confirm_delete'),"accept":_vm._f("trans")('user.delete'),"cancel":_vm._f("trans")('user.cancel')},on:{"accept":function($event){_vm.deleteQuiz(_vm.quizSelectedToDelete)},"cancel":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}}),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('quiz.errorDelete'),"accept":_vm._f("trans")('user.close')},on:{"accept":_vm.onModalErrorClose},model:{value:(_vm.isModalErrorVisible),callback:function ($$v) {_vm.isModalErrorVisible=$$v},expression:"isModalErrorVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cfbe246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__ = __webpack_require__(1421);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cfbe246_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row top-button form-group-button"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('router-link',{staticClass:"btn btn-light btn-sm back mr-2",attrs:{"to":{name: 'quiz', params: {clientId: _vm.clientId }}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('quiz.backToQuizList')))])]),_vm._v(" "),(_vm.quizId && !_vm.show)?_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.editQuiz(false)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('buttons.save'))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.quizId && !_vm.show)?_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.createQuiz(false)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('quiz.saveQuiz'))+"\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('v-select',{class:{'is-invalid': _vm.errors.has('field'), 'is-clear': !_vm.quizType},attrs:{"options":_vm.quizList,"label":"title","name":"quizType","filterable":false,"disabled":!!_vm.quizId || _vm.show,"data-vv-validate-on":"none"},model:{value:(_vm.quizType),callback:function ($$v) {_vm.quizType=$$v},expression:"quizType"}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label"},[_vm._v(_vm._s(_vm._f("trans")(_vm.show ? 'quiz.typeQuiz' : 'quiz.chooseQuiz')))])],1)])])]),_vm._v(" "),(_vm.client)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],ref:"client",staticClass:"required",class:{'is-invalid': _vm.errors.has('client')},attrs:{"id":"client","label":_vm._f("trans")('user.client'),"type":"text","name":"client","disabled":""},model:{value:(_vm.client.code),callback:function ($$v) {_vm.$set(_vm.client, "code", $$v)},expression:"client.code"}}),_vm._v(" "),(_vm.errors.has('client'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('client')))])]):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[(!_vm.show)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-12"},[_c('label',{},[_vm._v("\n                 "+_vm._s(_vm._f("trans")('quiz.dateAndTime'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"datepicker"},[_c('v-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'is-invalid': _vm.errors.has('rangeDateSheduled')},attrs:{"name":"rangeDateSheduled","formats":_vm.formats,"title-position":"left","input-props":{ readonly: true },"data-vv-validate-on":"none","min-date":_vm.minDateStart},model:{value:(_vm.rangeDateSheduled),callback:function ($$v) {_vm.rangeDateSheduled=$$v},expression:"rangeDateSheduled"}}),_vm._v(" "),(_vm.errors.has('rangeDateSheduled'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('rangeDateSheduled')))])]):_vm._e(),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 time-picker-wrapp"},[_c('vue-timepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"format":"HH:mm","hour-range":[_vm.hourRange],"minute-range":[_vm.minuteRange],"hide-clear-button":""},model:{value:(_vm.rangeTimeStart),callback:function ($$v) {_vm.rangeTimeStart=$$v},expression:"rangeTimeStart"}})],1)]):_vm._e(),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dl',{staticClass:"text-secondary"},[_c('dt',[_vm._v("\n              "+_vm._s(_vm._f("trans")('quiz.dateAndTime'))+"\n            ")]),_vm._v(" "),(_vm.rangeDateSheduled)?_c('dd',[_vm._v("\n              "+_vm._s(_vm._f("toLocaleDate")(_vm.rangeDateSheduled))+" "+_vm._s(_vm.rangeTimeStart.HH)+":"+_vm._s(_vm.rangeTimeStart.mm)+"\n            ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6 multiselect-wrapp required"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"aut-dropdown",class:{'is-invalid': _vm.errors.has('specialists'), 'is-clear': !_vm.specialist},attrs:{"id":"specialists","name":"specialists","label":"id","options":_vm.specialists,"filterable":false,"onSearch":_vm.onSearchSpecialists,"on-change":_vm.onChangeSpecialists,"data-vv-validate-on":"none","data-vv-name":"specialists","data-vv-as":_vm._f("trans")('quiz.chooseSpecialist'),"disabled":_vm.show},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n              "+_vm._s(option.displayName)+"\n            ")]}},{key:"selected-option",fn:function(option){return [_vm._v("\n              "+_vm._s(option.displayName)+"\n            ")]}}]),model:{value:(_vm.specialist),callback:function ($$v) {_vm.specialist=$$v},expression:"specialist"}},[_c('template',{slot:"no-options"},[_c('div',{on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._v("\n                "+_vm._s(_vm._f("trans")('quiz.enterNameSpesialist'))+"\n              ")])])],2),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{ 'invalid-feedback-label': _vm.errors.has('specialists') }},[_vm._v("\n            "+_vm._s(_vm._f("trans")((_vm.quizId && !_vm.show) ? 'quiz.chooseSpecialist' : 'protocol.editor')))]),_vm._v(" "),(!_vm.show)?_c('span',{staticClass:"description-row",class:{'invalid-feedback-label' : _vm.errors.has('specialists')}},[_vm._v(_vm._s(_vm._f("trans")('quiz.enterNameSpesialist')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.assignToClientList)?_c('div',{staticClass:"tasks col-md-12",attrs:{"id":"tasks"}},_vm._l((_vm.assignToClientList),function(client,key){return _c('div',{key:key,staticClass:"alert-secondary dragging-block"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-9  pt-3 pt-md-0"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000|unique_client'),expression:"'required|max:1000|unique_client'"}],ref:'client_' + key,refInFor:true,staticClass:"required m-0",class:{'is-invalid': _vm.errors.has('client_' + key)},attrs:{"type":"text","name":'client_' + key,"label":_vm._f("trans")('quiz.assignToClient'),"disabled":_vm.show,"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('quiz.assignToClient')},model:{value:(client.name),callback:function ($$v) {_vm.$set(client, "name", $$v)},expression:"client.name"}}),_vm._v(" "),(_vm.errors.has('client_' + key))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('client_' + key)))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-link secondary-link btn-sm float-right",attrs:{"type":"button","disabled":_vm.assignToClientList.length<2 || _vm.show},on:{"click":function($event){$event.preventDefault();_vm.removeAssignedToClient(client)}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.buttons.delete'))+"\n                ")])])])])})):_vm._e(),_vm._v(" "),(!_vm.show && _vm.assignToClientList.length < 5)?_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addAssignToClient()}}},[_vm._v("\n            "+_vm._s(_vm._f("trans")('protocol.buttons.add'))+"\n          ")])]):_vm._e()]),_vm._v(" "),(_vm.quizType && _vm.quizType.id == 1)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',{staticClass:"row-title mt-4"},[_vm._v(_vm._s(_vm._f("trans")('quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.title')))])])]):_vm._e(),_vm._v(" "),(_vm.quizType)?_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-12"},[_c('autocomplete-search',{ref:"targetBehaviour",staticClass:"required",class:{'is-invalid': _vm.errors.has('targetBehaviour')},attrs:{"id":"targetBehaviour","suggestions":_vm.autocomplete,"visible":_vm.visible,"field":'name',"label":_vm._f("trans")('quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.1'),"validateRule":"","validateLable":"","multiline":true,"disabled":_vm.show,"rowsCount":"3"},on:{"input":_vm.setProblemBehaviourValue,"inputChange":_vm.onChangeProblemBehaviour},model:{value:(_vm.targetBehaviour),callback:function ($$v) {_vm.targetBehaviour=$$v},expression:"targetBehaviour"}})],1)]):_vm._e(),_vm._v(" "),(_vm.quizType && _vm.quizType.id == 1)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-11 mt-4 mt-md-0"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:1000'),expression:"'required|max:1000'"}],staticClass:"required",class:{'is-invalid': _vm.errors.has('settingDescription')},attrs:{"type":"text","label":_vm._f("trans")('quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.2'),"name":"settingDescription","data-vv-validate-on":"none","disabled":_vm.show,"data-vv-as":_vm._f("trans")('quiz.question_titles.create_titles.motivation_scale.problem_behavior_information.questions.2')},model:{value:(_vm.settingDescription),callback:function ($$v) {_vm.settingDescription=$$v},expression:"settingDescription"}}),_vm._v(" "),(_vm.errors.has('settingDescription'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('settingDescription')))])]):_vm._e()],1)]):_vm._e()]),_vm._v(" "),(_vm.quizTemplate)?_c('div',{staticClass:"col-md-12 mt-4"},[_c('div',{staticClass:"row"},_vm._l((_vm.quizTemplate.generalQuestions),function(questionsRow){return _c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"row-title mt-4"},[_vm._v(_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (questionsRow.title)))))]),_vm._v(" "),_vm._l((questionsRow.items),function(question){return _c('div',{key:question.id,staticClass:"row mt-3"},[(question.isDetailedAnswer && !((question.id === 1 && _vm.quizTemplate.id === 1) || (question.id === 7 && _vm.quizTemplate.id === 2)))?_c('div',{staticClass:"col-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:question.group + question.id,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","name":question.group + question.id,"label":_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title))),"multiline":"","rows":"3","data-vv-validate-on":"none","data-vv-as":_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title))),"disabled":_vm.show},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(!question.isDetailedAnswer)?_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"row-title_subsitle"},[_vm._v(_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title)))))]),_vm._v(" "),_vm._l((question.generalQuestionAnswers),function(answer){return _c('mdc-radio',{key:answer.id,attrs:{"disabled":_vm.show,"name":question.group + question.id,"label":answer.title,"value":answer.id+'',"data-vv-validate-on":"none"},model:{value:(question.answerId),callback:function ($$v) {_vm.$set(question, "answerId", $$v)},expression:"question.answerId"}})})],2):_vm._e()])})],2)}))]):_vm._e(),_vm._v(" "),(_vm.quizTemplate)?_c('div',{staticClass:"col-md-12 mt-4"},[_c('div',{staticClass:"row mt-2"},_vm._l((_vm.quizTemplate.questions),function(questionList,keyList){return _c('div',{key:questionList.title,staticClass:"col-12"},[(_vm.quizType.id === 2)?_c('h5',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (questionList.title)))))]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('tbody',_vm._l((questionList.items),function(question){return _c('tr',{key:question.id},[_c('td',[(keyList !== 'evaluator_information')?_c('span',[_vm._v(_vm._s(_vm.quizType.id === 1 ? question.id : question.id-22)+".")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title)))))])])}))]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',_vm._l((questionList.items),function(question){return _c('div',{key:question.id,staticClass:"row"},[_c('div',{staticClass:"col-12"},[(keyList !== 'evaluator_information')?_c('span',[_vm._v(_vm._s(_vm.quizType.id === 1 ? question.id : question.id-22)+".")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title))))+"\n              ")])])})):_vm._e()])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row top-button form-group-button"},[_c('div',{staticClass:"col-md-12 mt-2"},[(_vm.quizId && !_vm.show)?_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.editQuiz(false)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('buttons.save'))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.quizId && !_vm.show)?_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.createQuiz(false)}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('quiz.saveQuiz'))+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('quiz.errorEdit'),"accept":_vm._f("trans")('user.close')},on:{"accept":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizTaking_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c32b72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizTaking_vue__ = __webpack_require__(1423);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizTaking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c32b72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizTaking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row top-button form-group-button"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('router-link',{staticClass:"btn btn-light btn-sm back mr-2",attrs:{"to":{name: 'quiz', params: {clientId: _vm.clientId }}}},[_c('i',{staticClass:"material-icons mdc-button__icon"},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("trans")('quiz.backToQuizList')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.saveQuiz()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.save'))+"\n      ")])],1)]),_vm._v(" "),(_vm.quizType)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h1',{staticClass:"page-title"},[_vm._v("\n        "+_vm._s(_vm.quizType.title)+"\n      ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('dl',[_c('dt',[_vm._v("\n          "+_vm._s(_vm._f("trans")('user.client'))+"\n        ")]),_vm._v(" "),(_vm.client)?_c('dd',[_vm._v("\n          "+_vm._s(_vm.client.code)+"\n        ")]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v("\n          "+_vm._s(_vm._f("trans")('quiz.dateAndTime'))+"\n        ")]),_vm._v(" "),_c('dd',[_vm._v("\n          "+_vm._s(_vm._f("toLocaleDate")(_vm.rangeDateSheduled))+" "+_vm._s(_vm.rangeTimeStart)+"\n        ")]),_vm._v(" "),_c('dt',[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.editor'))+"\n        ")]),_vm._v(" "),(_vm.quiz)?_c('dd',[_vm._v("\n          "+_vm._s(_vm.quiz.creator.displayName)+"\n        ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 required"},[_c('v-select',{ref:"quizSpecialist",class:{'is-invalid': _vm.errors.has('field'), 'is-clear': !_vm.quizSpecialist},attrs:{"options":_vm.quizSpecialistList,"on-change":_vm.onChangeSpecialists,"label":"name","name":"quizSpecialist","filterable":false,"data-vv-validate-on":"none"},model:{value:(_vm.quizSpecialist),callback:function ($$v) {_vm.quizSpecialist=$$v},expression:"quizSpecialist"}}),_vm._v(" "),_c('label',{staticClass:"mdc-floating-label",class:{'text-danger' : _vm.errorSpecialist}},[_vm._v(_vm._s(_vm._f("trans")('quiz.assignToClient')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.quizTemplate)?_c('div',{staticClass:"col-md-12 mt-4"},[(_vm.quiz.quiz.id === 1)?_c('h5',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")('quiz.answersDetail')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2"},_vm._l((_vm.quizTemplate.questions),function(questionList,keyList){return _c('div',{key:questionList.title,staticClass:"col-12"},[(_vm.quizType.id === 2)?_c('h5',{staticClass:"row-title"},[_vm._v(_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (questionList.title)))))]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table table-sm"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.quizTemplate.answers),function(answer){return _c('th',{key:answer.id,staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.quizType.id === 2 ? answer.title : answer.value)+" ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((questionList.items),function(question){return _c('tr',{key:question.id},[_c('td',{attrs:{"colspan":question.type==1 || question.type==4 || question.type==6 ? 1 : _vm.quizTemplate.answers.length+1}},[_c('div',{class:{'text-danger': ((question.type==5 && _vm.errorAnswer(question)) || (question.type==6 && _vm.errorAnswer(question))) && _vm.afterValidate}},[(keyList !== 'evaluator_information')?_c('span',[_vm._v(_vm._s(_vm.quiz.quiz.id === 1 ? question.id : question.id-22)+".")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title))))+"\n                ")]),_vm._v(" "),(question.type==3)?_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:question.group + question.id,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","name":question.group + question.id,"label":"","data-vv-validate-on":"none","disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"data-vv-as":_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title)))},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._l((question.answers),function(answer){return (question.type==5)?_c('div',{key:answer.id},[_c('mdc-checkbox',{attrs:{"name":'quizTemplate' + question.group + question.id + answer.id,"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"label":answer.title},model:{value:(answer.answerId),callback:function ($$v) {_vm.$set(answer, "answerId", $$v)},expression:"answer.answerId"}})],1):_vm._e()}),_vm._v(" "),_vm._l((question.additionalAnswers),function(answer){return (question.type==6)?_c('div',{key:answer.id},[_c('mdc-checkbox',{attrs:{"name":'quizTemplate' + question.group + question.id + answer.id,"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"label":answer.title},model:{value:(answer.answerId),callback:function ($$v) {_vm.$set(answer, "answerId", $$v)},expression:"answer.answerId"}})],1):_vm._e()}),_vm._v(" "),(question.type==5 || question.type==4)?_c('div',[(keyList=='evaluator_information' && question.type==4)?_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:question.group + question.id,refInFor:true,class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","data-vv-as":_vm._f("trans")(question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain'),"name":question.group + question.id,"label":_vm._f("trans")(question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain'),"disabled":!question.answerId || (keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength)},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1):_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:(question.type==5 ? 'max:5000' : 'required|max:5000'),expression:"question.type==5 ? 'max:5000' : 'required|max:5000'"}],ref:question.group + question.id,refInFor:true,class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","name":question.group + question.id,"label":_vm._f("trans")(question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp'),"disabled":question.type==4 && (!question.answerId || (question.answerId == 8)) || (keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength),"data-vv-as":_vm._f("trans")(question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp')},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1)]):_vm._e()],2),_vm._v(" "),_vm._l((_vm.quizTemplate.answers),function(answer){return (question.type==1 || question.type==4 || question.type==6)?_c('td',{key:answer.id,staticClass:"text-center",class:{'error-cell': !(keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength) && _vm.afterValidate && !question.answerId}},[_c('mdc-radio',{staticClass:"without-label-checkbox",attrs:{"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"name":'quizTemplate' + question.group + question.id,"value":answer.id+''},model:{value:(question.answerId),callback:function ($$v) {_vm.$set(question, "answerId", $$v)},expression:"question.answerId"}}),_vm._v(" "),(_vm.errors.has('quizTemplate' + question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('quizTemplate' + question.group + question.id)))])]):_vm._e()],1):_vm._e()})],2)}))]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',_vm._l((_vm.quizTemplate.questions),function(question){return _c('div',{key:question.id,staticClass:"row"},_vm._l((questionList.items),function(question){return _c('div',{key:question.id,staticClass:"col-12"},[_c('div',{class:{'text-danger': ((question.type==5 && _vm.errorAnswer(question)) || (question.type==6 && _vm.errorAnswer(question))) && _vm.afterValidate}},[(keyList !== 'evaluator_information')?_c('span',[_vm._v(_vm._s(_vm.quiz.quiz.id === 1 ? question.id : question.id-22)+".")]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title))))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.quizTemplate.answers),function(answer){return _c('div',{key:answer.id,staticClass:"col-3"},[_c('mdc-radio',{attrs:{"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"name":'quizTemplate' + question.group + question.id,"value":answer.id+'',"label":_vm.quiz.quiz.id === 1 ? answer.id : answer.title},model:{value:(question.answerId),callback:function ($$v) {_vm.$set(question, "answerId", $$v)},expression:"question.answerId"}}),_vm._v(" "),(_vm.errors.has('quizTemplate' + question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('quizTemplate' + question.group + question.id)))])]):_vm._e()],1)})),_vm._v(" "),_c('div',{attrs:{"colspan":question.type==1 || question.type==4  ? 1 : _vm.quizTemplate.answers.length+1}},[(question.type==3)?_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:question.group + question.id,refInFor:true,staticClass:"required",class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","name":question.group + question.id,"label":"","data-vv-validate-on":"none","disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"data-vv-as":_vm._f("trans")(("quiz.question_titles.create_titles." + (question.title)))},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._l((question.answers),function(answer){return (question.type==5)?_c('div',{key:answer.id},[_c('mdc-checkbox',{attrs:{"name":'quizTemplate' + question.group + question.id + answer.id,"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"label":answer.title},model:{value:(answer.answerId),callback:function ($$v) {_vm.$set(answer, "answerId", $$v)},expression:"answer.answerId"}})],1):_vm._e()}),_vm._v(" "),_vm._l((question.additionalAnswers),function(answer){return (question.type==6)?_c('div',{key:answer.id},[_c('mdc-checkbox',{attrs:{"name":'quizTemplate' + question.group + question.id + answer.id,"disabled":keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength,"label":answer.title},model:{value:(answer.answerId),callback:function ($$v) {_vm.$set(answer, "answerId", $$v)},expression:"answer.answerId"}})],1):_vm._e()}),_vm._v(" "),(question.type==5 || question.type==4)?_c('div',[(keyList=='evaluator_information' && question.type==4)?_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:5000'),expression:"'required|max:5000'"}],ref:question.group + question.id,refInFor:true,class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","data-vv-as":_vm._f("trans")(question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain'),"name":question.group + question.id,"label":_vm._f("trans")(question.answerId == 9 ? 'quiz.ifYesExplain' : 'quiz.ifNoExplain'),"disabled":!question.answerId || (keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength)},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1):_c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:(question.type==5 ? 'max:5000' : 'required|max:5000'),expression:"question.type==5 ? 'max:5000' : 'required|max:5000'"}],ref:question.group + question.id,refInFor:true,class:{'is-invalid': _vm.errors.has(question.group + question.id)},attrs:{"id":question.group + question.id,"type":"text","name":question.group + question.id,"label":_vm._f("trans")(question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp'),"disabled":question.type==4 && (!question.answerId || (question.answerId == 8)) || (keyList === 'social_reinforcement' && _vm.answersSocialInfluencesLength),"data-vv-as":_vm._f("trans")(question.type==5 ? 'quiz.ifOtherExplain' : 'quiz.ifYesExp')},model:{value:(question.detailedAnswer),callback:function ($$v) {_vm.$set(question, "detailedAnswer", $$v)},expression:"question.detailedAnswer"}}),_vm._v(" "),(_vm.errors.has(question.group + question.id))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first(question.group + question.id)))])]):_vm._e()],1)]):_vm._e()],2)])}))})):_vm._e(),_vm._v(" "),(keyList === 'social_influences_on_behavior')?_c('h5',{staticClass:"row-title mb-4"},[_vm._v(_vm._s(_vm._f("trans")('quiz.completePart2')))]):_vm._e()])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row top-button form-group-button"},[_c('div',{staticClass:"col-md-12 mt-2"},[_c('button',{staticClass:"btn btn-primary btn-sm mb-2",attrs:{"type":"submit","disabled":_vm.disableAfterSubmit},on:{"click":function($event){$event.preventDefault();_vm.saveQuiz()}}},[_vm._v("\n        "+_vm._s(_vm._f("trans")('user.save'))+"\n      ")])])]),_vm._v(" "),_c('mdc-dialog',{attrs:{"title":_vm._f("trans")('quiz.errorEdit'),"accept":_vm._f("trans")('user.close')},on:{"accept":_vm.onModalClose},model:{value:(_vm.isModalVisible),callback:function ($$v) {_vm.isModalVisible=$$v},expression:"isModalVisible"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest()) {
        next();
    } else {
        next({ name: 'default' });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__ = __webpack_require__(22);


var isAuthorized = function isAuthorized(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isGuest()) {
        next({ name: 'login' });
    } else {
        __WEBPACK_IMPORTED_MODULE_0__common_auth_Manager__["a" /* default */].isClient() ? next({ name: 'available-protocols' }) : next({ name: 'client' });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (isAuthorized);

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["a"] = (function (axios) {
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.status === 403 && error.data && error.data.errors && error.data.errors.code == 1) {
      __WEBPACK_IMPORTED_MODULE_1__Manager__["a" /* default */].reinitUser().then(function () {
        location.reload(true);
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }
  });
});;

/***/ }),
/* 1427 */,
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hours__ = __webpack_require__(1429);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.filter('toLocaleDate', __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].toLocaleDate);
    Vue.filter('toLocaleDateTime', __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].toLocaleDateTime);
    Vue.filter('toFirstLetter', __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].toFirstLetter);
    Vue.filter('phaseNameByTypeId', __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].phaseNameByTypeId);
    Vue.filter('asHours', __WEBPACK_IMPORTED_MODULE_1__hours__["a" /* default */]);
    Vue.filter('intervalNameByTypeId', __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].intervalNameByTypeId);
  }
});

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

function hours(value) {
  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
    return value;
  }

  value = value | 0;

  var hours = Math.floor(value / 3600);
  var minutes = Math.floor((value - hours * 3600) / 60);
  var seconds = value - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  return hours + ':' + minutes + ':' + seconds;
}

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__minutes__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aimType__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__behaviourType__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__percent__ = __webpack_require__(1434);





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.filter('minutes', __WEBPACK_IMPORTED_MODULE_0__minutes__["a" /* default */]);
    Vue.filter('aimType', __WEBPACK_IMPORTED_MODULE_1__aimType__["a" /* default */]);
    Vue.filter('behaviourType', __WEBPACK_IMPORTED_MODULE_2__behaviourType__["a" /* default */]);
    Vue.filter('percent', __WEBPACK_IMPORTED_MODULE_3__percent__["a" /* default */]);
  }
});

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

function minutes(value) {
  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
    return value;
  }

  var hours = Math.floor(value / 3600);
  var minutes = Math.floor((value - hours * 3600) / 60);
  var seconds = value - hours * 3600 - minutes * 60;

  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  var time = minutes + ':' + seconds;

  if (hours) {
    if (hours < 10) {
      hours = '0' + hours;
    }
    time = hours + ':' + time;
  }

  return time;
}

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_translator__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  switch (parseInt(value)) {
    case __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* default */].AIM_TYPE_ABSENCE:
      return __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('dro.behaviour_absence');
    case __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* default */].AIM_TYPE_PRESENCE:
      return __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('dro.behaviour_presence');
    default:
      return value;
  }
});

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_translator__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  switch (parseInt(value)) {
    case __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* default */].BEHAVIOUR_TYPE_SHORT:
      return __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('dro.behaviour_type_short');
    case __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* default */].BEHAVIOUR_TYPE_LONG:
      return __WEBPACK_IMPORTED_MODULE_1__lang_translator__["a" /* default */].get('dro.behaviour_type_long');
    default:
      return value;
  }
});

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value === 'number') {
    return value + '%';
  } else {
    return '' + value;
  }
});

/***/ }),
/* 1435 */,
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TouchEvents = [
  'tap',
  'longtap',
  'swipeup',
  'swipedown',
  'swipeleft',
  'swiperight',
  'swipe',
  'drag'];
//注册触摸事件
//register the touch event
TouchEvents = TouchEvents.map(function(evt) {
  return {
    name: evt,
    evt: new Event(evt),
  };
});

var touch = {
  install: function(Vue) {
    Vue.directive('touch', {
      inserted: function(dom, conf) { touchRegist(dom, conf.modifiers); },
    });
    //触摸开始时间
    //start time when touch the screen
    var startTime, touches = {},
        ismoved = !1;
    //原生触摸事件监听
    //touch events listener
    var touchRegist = function(dom, cfg) {
      //禁止浏览器事件 默认关闭
      //prohibit browser swipe events ,default is allow
      //当前对象是否能拖拽 默认关闭
      //this dom can be dragged ,default is can't
      var pD = cfg.preventdefault || !1,
          _dg = cfg.drag || !1;
      dom.addEventListener('touchstart', function(e) {
        e.stopPropagation();
        pD && e.preventDefault();
        startTime = (new Date()).getTime();
        touches.start = e.changedTouches[0];
      }, false);

      dom.addEventListener('touchmove', function(e) {
        e.stopPropagation();
        touches.move = e.changedTouches[0];
        moveCheck(_dg, dom);
      }, false);

      dom.addEventListener('touchend', function(e) {
        e.stopPropagation();
        var endTime = (new Date()).getTime();
        touches.end = e.changedTouches[0];
        var n = _dg ? 7 : typeCheck(endTime - startTime);
        dom.dispatchEvent(TouchEvents[n].evt);
        ismoved = !1;
      }, false);
    };

    var typeCheck = function(d) {
      switch (touchCheck()) {
        case -2:
          /*右滑  swipe right*/
          return (d > 5e2) ? 6 : 5;
        case -1:
          /*下滑 swipe down*/
          return (d > 5e2) ? 6 : 3;
        case 0:
          /*轻触 tap *长按 long tap*/
          var n = (d < 5e2) ? 0 : 1;
          return ismoved ? 6 : n;
        case 1:
          /*上滑 swipe up*/
          return (d > 5e2) ? 6 : 2;
        case 2:
          /*左滑 swipe left*/
          return (d > 5e2) ? 6 : 4;
        default:
          /*触摸 swipe*/
          return 6;
      }
    };

    var touchCheck = function() {
      var s = touches.start,
          e = touches.end,
          x = s.clientX - e.clientX,
          y = s.clientY - e.clientY,
          X = Math.abs(x),
          Y = Math.abs(y);
      //0 tap  1 上 -1下  2 左 -2 右  3 触摸
      //0 tap  1 up -1 down  2 left -2 right  3 swipe
      if (X < 10 && Y < 10) return 0;
      else {
        if (X > Y) {
          if (Y > 50) return 3;
          else return x > 0 ? 2 : -2;
        } else {
          if (X > 50) return 3;
          else return y > 0 ? 1 : -1;
        }
      }
    };

    //判断用户是否仅仅是滑动屏幕
    //check user just swipe screen
    var moveCheck = function(_dg, dom) {
      var s = touches.start,
          m = touches.move,
          x = s.clientX - m.clientX,
          y = s.clientY - m.clientY;
      if (_dg) {
        var h = m.clientY - dom.offsetHeight * 0.5,
            w = m.clientX - dom.offsetWidth * 0.5;
        dom.style.top = h + 'px';
        dom.style.left = w + 'px';
      } else {
        if (Math.abs(x) > 50 || Math.abs(y) > 50) ismoved = !0;
      }
    };
  },
};

/* harmony default export */ __webpack_exports__["a"] = (touch);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6f6640e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1443);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6f6640e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobile_index__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(4);






var isMobile = {
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('mobile', ['setIsMobile']), {
    initIsMobile: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var win, isMobile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                win = window.innerWidth;
                isMobile = win < 768;


                this.setIsMobile(isMobile);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initIsMobile() {
        return _ref.apply(this, arguments);
      }

      return initIsMobile;
    }()
  })
};

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPage_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2cb5a3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPage_vue__ = __webpack_require__(1440);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StaticPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2cb5a3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StaticPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal modal-opened",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"false"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content modal-rounded"},[_c('div',{staticClass:"row"},[(_vm.loaded)?_c('div',{staticClass:"col-md-12",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_vm._v(" "),(!_vm.loaded)?_c('loader'):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selector_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5dee1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selector_vue__ = __webpack_require__(1442);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca5dee1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"header-select",attrs:{"options":_vm.langList,"on-change":_vm.onChange,"searchable":false},model:{value:(_vm.selectedLang),callback:function ($$v) {_vm.selectedLang=$$v},expression:"selectedLang"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'scrolled' : _vm.isScrolled, 'error_wrapp': '404' === _vm.route.name || 'error' === _vm.route.name, 'previous-wrapp': _vm.previousDateSession},attrs:{"id":"app"}},[(!_vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('mdc-layout-app',[_c('mdc-toolbar',{staticClass:"navbar-expand-md navbar-custom  navbar-dark bg-primary mb-0 mb-md-4",class:{ 'wider-header': !_vm.isGuest },attrs:{"slot":"toolbar"},slot:"toolbar"},[_c('div',{staticClass:"container"},[_c('mdc-toolbar-row',[_c('mdc-toolbar-section',{attrs:{"shrink-to-fit":""}},[(!_vm.isGuest)?_c('mdc-toolbar-menu-icon',{on:{"click":function($event){$event.preventDefault();return _vm.openDrawer($event)}}}):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{name: _vm.isClient ? 'available-protocols' : 'client'}}},[_c('img',{staticClass:"desktop",attrs:{"src":__webpack_require__(1444),"alt":"AutismTech"}}),_vm._v(" "),_c('img',{staticClass:"mobile",attrs:{"src":__webpack_require__(1445),"alt":"AutismTech"}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav navbar-top mr-auto"},[_vm._l((_vm.menus),function(item,index){return (_vm.menus)?_c('li',{staticClass:"nav-item",class:{'active': item.name === _vm.route.name}},[(item.page_slug)?_c('router-link',{staticClass:"nav-link",attrs:{"to":item.page_slug}},[_vm._v("\n                  "+_vm._s(item.title)+"\n                ")]):_vm._e(),_vm._v(" "),(!item.page_slug)?_c('a',{staticClass:"nav-link",attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))]):_vm._e()],1):_vm._e()}),_vm._v(" "),(!_vm.isGuest && !_vm.isTherapist && (_vm.canViewCurators || _vm.canViewTherapists || _vm.canViewClients) )?_c('li',{staticClass:"nav-item",class:{'active': ('client' === _vm.route.name || 'curator' === _vm.route.name || 'therapist' === _vm.route.name)}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'client'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('user.users'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isTherapist && (_vm.canViewCurators || _vm.canViewTherapists || _vm.canViewClients) && !_vm.previousDateSession)?_c('li',{staticClass:"nav-item",class:{'active': ('client' === _vm.route.name || 'curator' === _vm.route.name || 'therapist' === _vm.route.name)}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'client'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('user.clients'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && (_vm.isBCBA || _vm.isCurator) && !_vm.previousDateSession)?_c('li',{staticClass:"nav-item",class:{'active': 'protocols' === _vm.route.name || 'bids' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'protocols'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.protocols'))+" / "+_vm._s(_vm._f("trans")('protocol.bids'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && (_vm.isBCBA || _vm.isCurator) && !_vm.previousDateSession)?_c('li',{staticClass:"nav-item",class:{'active': 'curator-reports' === _vm.route.name || 'therapist-reports' === _vm.route.name || 'client-reports' === _vm.route.name  || 'archive-reports' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'client-reports'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('report.header'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('li',{staticClass:"nav-item",class:{'active': 'available-protocols' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'available-protocols'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.available_protocols'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('li',{staticClass:"nav-item",class:{'active': 'appeals' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'appeals'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.requests'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('li',{staticClass:"nav-item",class:{'active': 'undesirable-behavior' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'undesirable-behavior'}}},[_vm._v("\n                  "+_vm._s(_vm._f("trans")('protocol.unwanted_behavior'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isTherapist && !_vm.previousDateSession)?_c('li',{staticClass:"nav-item",class:{'active': 'bids' === _vm.route.name}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'bids'}}},[_vm._v(_vm._s(_vm._f("trans")('bids.bids'))+"\n                ")])],1):_vm._e()],2)],1),_vm._v(" "),_c('mdc-toolbar-section',{attrs:{"align-end":""}},[((_vm.isBCBA || _vm.isCurator) && !_vm.isMobile)?_c('mdc-switch',{staticClass:"without-wrapp",class:{'without-wrapp-checked': _vm.previousDateSession},model:{value:(_vm.previousDateSession),callback:function ($$v) {_vm.previousDateSession=$$v},expression:"previousDateSession"}},[_vm._v(_vm._s(_vm._f("trans")('protocol.showChangeDateSession')))]):_vm._e(),_vm._v(" "),_c('language-selector'),_vm._v(" "),(!_vm.isGuest && _vm.userIdentifier && !_vm.isMobile && _vm.isBCBA)?_c('router-link',{staticClass:"btn btn-outline-light mr-2 nik_name",attrs:{"title":_vm.userIdentifier,"to":{name: 'profile'}}},[_vm._v("\n              "+_vm._s(_vm.userIdentifier)+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.userIdentifier && !_vm.isMobile && !_vm.isBCBA)?_c('span',{staticClass:"btn btn-outline-light mr-2 nik_name",attrs:{"title":_vm.userIdentifier}},[_vm._v("\n              "+_vm._s(_vm.userIdentifier))]):_vm._e(),_vm._v(" "),(!_vm.isGuest)?_c('a',{staticClass:"btn btn-outline-light",on:{"click":_vm.logout}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")])]):_vm._e(),_vm._v(" "),(_vm.isGuest)?_c('router-link',{staticClass:"btn btn-outline-light mr-2",attrs:{"to":{name: 'login'}}},[_vm._v("\n              "+_vm._s(_vm._f("trans")('login.buttons.login'))+"\n            ")]):_vm._e()],1)],1)],1)]),_vm._v(" "),_c('mdc-drawer',{staticClass:"slide-menu",attrs:{"slot":"drawer"},slot:"drawer",model:{value:(_vm.openDrawListMenu),callback:function ($$v) {_vm.openDrawListMenu=$$v},expression:"openDrawListMenu"}},[_c('mdc-drawer-list',[_vm._l((_vm.menus),function(item,index){return (_vm.menus)?_c('mdc-drawer-item',{key:item.id,staticClass:"nav-item",class:{'active': item.name === _vm.route.name},attrs:{"to":item.page_slug ? item.page_slug : item.url}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")]):_vm._e()}),_vm._v(" "),(!_vm.isGuest && !_vm.isTherapist && (_vm.canViewCurators || _vm.canViewTherapists || _vm.canViewClients))?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': ('client' === _vm.route.name || 'curator' === _vm.route.name || 'therapist' === _vm.route.name)},attrs:{"to":{name: 'client'}},on:{"click":_vm.closeDrawer}},[_vm._v(_vm._s(_vm._f("trans")('user.users'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isTherapist && (_vm.canViewCurators || _vm.canViewTherapists || _vm.canViewClients))?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': ('client' === _vm.route.name || 'curator' === _vm.route.name || 'therapist' === _vm.route.name)},attrs:{"to":{name: 'client'}},on:{"click":_vm.closeDrawer}},[_vm._v(_vm._s(_vm._f("trans")('user.clients'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && (_vm.isBCBA || _vm.isCurator))?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'protocols' === _vm.route.name || 'bids' === _vm.route.name},attrs:{"to":{name: 'protocols'}},on:{"click":_vm.closeDrawer}},[_vm._v(_vm._s(_vm._f("trans")('protocol.protocols'))+" / "+_vm._s(_vm._f("trans")('protocol.bids'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'available-protocols' === _vm.route.name},attrs:{"to":{name: 'available-protocols'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.available_protocols'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && (_vm.isBCBA || _vm.isCurator))?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'curator-reports' === _vm.route.name || 'therapist-reports' === _vm.route.name || 'client-reports' === _vm.route.name  || 'archive-reports' === _vm.route.name},attrs:{"to":{name: 'client-reports'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('report.header'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'appeals' === _vm.route.name},attrs:{"to":{name: 'appeals'}},on:{"click":_vm.closeDrawer}},[_vm._v(_vm._s(_vm._f("trans")('protocol.requests'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isClient)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'undesirable-behavior' === _vm.route.name},attrs:{"to":{name: 'undesirable-behavior'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('protocol.unwanted_behavior'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.isTherapist)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'bids' === _vm.route.name},attrs:{"to":{name: 'bids'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('bids.bids'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.userIdentifier && _vm.isBCBA)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'profile' === _vm.route.name || 'profile' === _vm.route.name},attrs:{"to":{name: 'profile'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('profile.profile'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isGuest && _vm.userIdentifier && _vm.isBCBA)?_c('mdc-drawer-item',{staticClass:"nav-item",class:{'active': 'subscriptions' === _vm.route.name || 'subscription' === _vm.route.name},attrs:{"to":{name: 'subscriptions'}},on:{"click":_vm.closeDrawer}},[_vm._v("\n          "+_vm._s(_vm._f("trans")('profile.subscriptions'))+"\n        ")]):_vm._e()],2)],1),_vm._v(" "),_c('main',{staticClass:"container mb-0 mb-md-4"},[(_vm.isSubscriptionExpiredSoon && !_vm.isMensurationForbidden)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('div',{staticClass:"d-flex align-content-center flex-wrap"},[_c('mdc-icon',{staticClass:"align-self-center mr-md-3 md-32",attrs:{"mdc-icon":"","icon":"warning"}}),_vm._v(" "),_c('div',[(_vm.subscriptionDaysLeft > 1)?_c('strong',[_vm._v(_vm._s(_vm._f("trans")('subscription.subscription_soon_expired',  {attribute: _vm.subscriptionDaysLeft})))]):_c('strong',[_vm._v(_vm._s(_vm._f("trans")('subscription.subscription_expired_today')))]),_vm._v(" "),_c('br'),_vm._v("\n            "+_vm._s(_vm._f("trans")('subscription.subscription_continue'))+"\n          ")])],1)]):_vm._e(),_vm._v(" "),(_vm.isMensurationForbidden)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('div',{staticClass:"d-flex align-content-center flex-wrap"},[_c('mdc-icon',{staticClass:"align-self-center mr-md-3 md-32 mr-2",attrs:{"mdc-icon":"","icon":"warning"}}),_vm._v(" "),_c('div',{staticClass:"mw-90"},[_c('strong',[_vm._v(_vm._s(_vm._f("trans")('subscription.subscription_expired')))]),_vm._v(" "),_c('br'),_vm._v("\n            "+_vm._s(_vm._f("trans")('subscription.subscription_limited'))+"\n          ")])],1)]):_vm._e(),_vm._v(" "),(_vm.previousDateSession)?_c('div',{ref:"maxTotalAtemptsCountError",staticClass:"wrapp-form",attrs:{"id":"maxTotalAtemptsCountError"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"page-sub-title"},[_vm._v("\n              "+_vm._s(_vm._f("trans")('protocol.entered_session_date'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('div',{staticClass:"datepicker datepicker__width"},[_c('v-date-picker',{attrs:{"formats":_vm.formats,"pickTime":true,"format":'YYYY-MM-DD HH:mm',"max-date":_vm.maxDateStart,"title-position":"left"},model:{value:(_vm.rangeDateStart),callback:function ($$v) {_vm.rangeDateStart=$$v},expression:"rangeDateStart"}}),_vm._v(" "),_c('mdc-icon',{attrs:{"icon":"date_range"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12 time-picker-wrapp"},[_c('vue-timepicker',{attrs:{"format":"HH:mm","hour-range":[_vm.hourRange],"minute-range":[_vm.minuteRange],"hide-clear-button":""},model:{value:(_vm.rangeTimeStart),callback:function ($$v) {_vm.rangeTimeStart=$$v},expression:"rangeTimeStart"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:('min_value:1|max_value:120|numeric'),expression:"'min_value:1|max_value:120|numeric'"}],staticClass:"mt-0",class:{'is-invalid': _vm.errors.has('duration')},attrs:{"id":"duration","type":"number","min":"1","max":"120","name":"duration","label":_vm._f("trans")('protocol.duration'),"data-vv-validate-on":"none","data-vv-as":_vm._f("trans")('protocol.duration')},on:{"keydown":_vm.changeNumber},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}}),_vm._v(" "),(_vm.errors.has('duration'))?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.errors.first('duration')))])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapp-relative"},[(_vm.previousDateSession && !(_vm.rangeDateStart && _vm.rangeTimeStart.HH && _vm.rangeTimeStart.mm) || _vm.duration > 120)?_c('loader',{staticClass:"table-loader position-absolute",attrs:{"messages":_vm._f("trans")('protocol.entered_session_date')}}):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.route.key})],1)])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7fc1c25.svg";

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translator__ = __webpack_require__(6);





var map = {
	'trans': 'get',
	'trans_choice': 'choice'
};

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	var _loop = function _loop(filterName, methodName) {
		Vue.filter(filterName, function () {
			return __WEBPACK_IMPORTED_MODULE_3__translator__["a" /* default */][methodName].apply(__WEBPACK_IMPORTED_MODULE_3__translator__["a" /* default */], arguments);
		});
	};

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(map)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

			var filterName = _ref2[0];
			var methodName = _ref2[1];

			_loop(filterName, methodName);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
});

/***/ }),
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_ru__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_en__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_uk__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_uk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_uk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_pl__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_pl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_pl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_locale__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_constants__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_translator__ = __webpack_require__(6);









__WEBPACK_IMPORTED_MODULE_0_vee_validate__["b" /* default */].Validator.localize(__WEBPACK_IMPORTED_MODULE_5__lang_locale__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__lang_locale__["a" /* default */].toString() === __WEBPACK_IMPORTED_MODULE_6__lang_constants__["d" /* RU_LANGUAGE */] ? __WEBPACK_IMPORTED_MODULE_1_vee_validate_dist_locale_ru___default.a : __WEBPACK_IMPORTED_MODULE_5__lang_locale__["a" /* default */].toString() === __WEBPACK_IMPORTED_MODULE_6__lang_constants__["e" /* UA_LANGUAGE */] ? __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_uk___default.a : __WEBPACK_IMPORTED_MODULE_5__lang_locale__["a" /* default */].toString() === __WEBPACK_IMPORTED_MODULE_6__lang_constants__["c" /* PL_LANGUAGE */] ? __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_pl___default.a : __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_en___default.a);

function getMessage(key, attr, locale, min, max) {
  console.info(key);
  console.info(attr);
  return __WEBPACK_IMPORTED_MODULE_7__lang_translator__["a" /* default */].get("validation." + key, { attribute: attr, min: min, max: max }, locale);
};

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["b" /* default */].Validator.localize({
  ru: {
    messages: {
      alpha: function alpha(attr) {
        return getMessage('alpha', attr, 'ru');
      },
      alpha_spaces: function alpha_spaces(attr) {
        return getMessage('alpha_spaces', attr, 'ru');
      },
      alpha_dash: function alpha_dash(attr) {
        return getMessage('alpha_dash', attr, 'ru');
      },
      alpha_num: function alpha_num(attr) {
        return getMessage('alpha_num', attr, 'ru');
      }
    }
  },
  en: {
    messages: {
      alpha: function alpha(attr) {
        return getMessage('alpha', attr, 'en');
      },
      alpha_spaces: function alpha_spaces(attr) {
        return getMessage('alpha_spaces', attr, 'en');
      },
      alpha_dash: function alpha_dash(attr) {
        return getMessage('alpha_dash', attr, 'en');
      },
      alpha_num: function alpha_num(attr) {
        return getMessage('alpha_num', attr, 'en');
      }
    }
  },
  pl: {
    messages: {
      alpha: function alpha(attr) {
        return getMessage('alpha', attr, 'pl');
      },
      alpha_spaces: function alpha_spaces(attr) {
        return getMessage('alpha_spaces', attr, 'pl');
      },
      alpha_dash: function alpha_dash(attr) {
        return getMessage('alpha_dash', attr, 'pl');
      },
      alpha_num: function alpha_num(attr) {
        return getMessage('alpha_num', attr, 'pl');
      },
      min_value: function min_value(attr, min) {
        return getMessage('min.numeric', attr, 'pl', min);
      },
      max_value: function max_value(attr, max) {
        return getMessage('min.numeric', attr, 'pl', 0, max);
      }
    }
  },
  uk: {
    messages: {
      alpha: function alpha(attr) {
        return getMessage('alpha', attr, 'uk');
      },
      alpha_spaces: function alpha_spaces(attr) {
        return getMessage('alpha_spaces', attr, 'uk');
      },
      alpha_dash: function alpha_dash(attr) {
        return getMessage('alpha_dash', attr, 'uk');
      },
      alpha_num: function alpha_num(attr) {
        return getMessage('alpha_num', attr, 'uk');
      }
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vee_validate__["b" /* default */]);

/***/ })
],[714]);


// WEBPACK FOOTER //
// static/js/app.132763874da8edfd16bd.js